/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 422);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(427)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(431);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(489)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button[not:disabled]:hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel[not:disabled]:hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger[not:disabled]:hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22).setImmediate, __webpack_require__(22).clearImmediate))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a09f94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31a09f94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31a09f94_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preDatatableComponent_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d87483d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preDatatableComponent_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d87483d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preDatatableComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d87483d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preDatatableComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd11ee8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__ = __webpack_require__(494);
function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfd11ee8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd11ee8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileDatatable_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a222c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobileDatatable_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52a222c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileDatatable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52a222c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobileDatatable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderDetails_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e108764_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderDetails_vue__ = __webpack_require__(497);
function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e108764_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(39);
var isBuffer = __webpack_require__(432);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "black_shipzone.png?fa87ecbeb83a0239f44009b089a17c80";

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6332d68b_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_datepicker_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6332d68b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_datepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6332d68b_hasScoped_true_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewExportOrderDetails_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dafe31c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewExportOrderDetails_vue__ = __webpack_require__(1164);
function injectStyle (ssrContext) {
  __webpack_require__(1162)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewExportOrderDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dafe31c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewExportOrderDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewLogDetails_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2d31b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewLogDetails_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewLogDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2d31b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewLogDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelExportOrder_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01672a0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancelExportOrder_vue__ = __webpack_require__(1161);
function injectStyle (ssrContext) {
  __webpack_require__(1159)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01672a0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancelExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminCancelOrder_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4eb6b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminCancelOrder_vue__ = __webpack_require__(569);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminCancelOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4eb6b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminCancelOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditOrderCase_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0aed4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditOrderCase_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditOrderCase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee0aed4c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditOrderCase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createQrCode_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb700b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createQrCode_vue__ = __webpack_require__(620);
function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createQrCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb700b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createQrCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "whatsapp.png?cc7ed84031a39e69a28d9a007c06d56f";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(423);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* unused harmony export use */
/* unused harmony export directive */
/* unused harmony export mixin */
/* unused harmony export mapFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validator; });
/* unused harmony export ErrorBag */
/* unused harmony export Rules */
/* unused harmony export ErrorComponent */
/* unused harmony export version */
/**
  * vee-validate v2.0.8
  * (c) 2018 Abdelrahman Awad
  * @license MIT
  */
var supportsPassive = true;
var detectPassiveSupport = function () {
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener('testPassive', null, opts);
        window.removeEventListener('testPassive', null, opts);
    } catch (e) {
        supportsPassive = false;
    }
    return supportsPassive;
};
var addEventListener = function (el, eventName, cb) {
    el.addEventListener(eventName, cb, supportsPassive ? {
        passive: true
    } : false);
};
var isTextInput = function (el) { return ['text','number','password','search','email','tel',
    'url','textarea'].indexOf(el.type) !== -1; };
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };
var isNullOrUndefined = function (value) { return value === null || value === undefined; };
var setDataAttribute = function (el, name, value) { return el.setAttribute(("data-vv-" + name), value); };
var createFlags = function () { return ({
    untouched: true,
    touched: false,
    dirty: false,
    pristine: true,
    valid: null,
    invalid: null,
    validated: false,
    pending: false,
    required: false,
    changed: false
}); };
var isEqual = function (lhs, rhs) {
    if (lhs instanceof RegExp && rhs instanceof RegExp) {
        return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
    }
    if (Array.isArray(lhs) && Array.isArray(rhs)) {
        if (lhs.length !== rhs.length) 
            { return false; }
        for (var i = 0;i < lhs.length; i++) {
            if (!isEqual(lhs[i], rhs[i])) {
                return false;
            }
        }
        return true;
    }
    if (isObject(lhs) && isObject(rhs)) {
        return Object.keys(lhs).every(function (key) { return isEqual(lhs[key], rhs[key]); }) && Object.keys(rhs).every(function (key) { return isEqual(lhs[key], rhs[key]); });
    }
    return lhs === rhs;
};
var getScope = function (el) {
    var scope = getDataAttribute(el, 'scope');
    if (isNullOrUndefined(scope) && el.form) {
        scope = getDataAttribute(el.form, 'scope');
    }
    return !isNullOrUndefined(scope) ? scope : null;
};
var getPath = function (path, target, def) {
    if ( def === void 0 ) def = undefined;

    if (!path || !target) 
        { return def; }
    var value = target;
    path.split('.').every(function (prop) {
        if (!Object.prototype.hasOwnProperty.call(value, prop) && value[prop] === undefined) {
            value = def;
            return false;
        }
        value = value[prop];
        return true;
    });
    return value;
};
var hasPath = function (path, target) {
    var obj = target;
    return path.split('.').every(function (prop) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
        obj = obj[prop];
        return true;
    });
};
var parseRule = function (rule) {
    var params = [];
    var name = rule.split(':')[0];
    if (~rule.indexOf(':')) {
        params = rule.split(':').slice(1).join(':').split(',');
    }
    return {
        name: name,
        params: params
    };
};
var debounce = function (fn, wait, immediate) {
    if ( wait === void 0 ) wait = 0;
    if ( immediate === void 0 ) immediate = false;

    if (wait === 0) {
        return fn;
    }
    var timeout;
    return function () {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

        var later = function () {
            timeout = null;
            if (!immediate) 
                { fn.apply(void 0, args); }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) 
            { fn.apply(void 0, args); }
    };
};
var normalizeRules = function (rules) {
    if (!rules) {
        return {};
    }
    if (isObject(rules)) {
        return Object.keys(rules).reduce(function (prev, curr) {
            var params = [];
            if (rules[curr] === true) {
                params = [];
            } else if (Array.isArray(rules[curr])) {
                params = rules[curr];
            } else {
                params = [rules[curr]];
            }
            if (rules[curr] !== false) {
                prev[curr] = params;
            }
            return prev;
        }, {});
    }
    if (typeof rules !== 'string') {
        warn('rules must be either a string or an object.');
        return {};
    }
    return rules.split('|').reduce(function (prev, rule) {
        var parsedRule = parseRule(rule);
        if (!parsedRule.name) {
            return prev;
        }
        prev[parsedRule.name] = parsedRule.params;
        return prev;
    }, {});
};
var warn = function (message) {
    console.warn(("[vee-validate] " + message));
};
var createError = function (message) { return new Error(("[vee-validate] " + message)); };
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj); };
var isCallable = function (func) { return typeof func === 'function'; };
var hasClass = function (el, className) {
    if (el.classList) {
        return el.classList.contains(className);
    }
    return !(!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)"))));
};
var addClass = function (el, className) {
    if (el.classList) {
        el.classList.add(className);
        return;
    }
    if (!hasClass(el, className)) {
        el.className += " " + className;
    }
};
var removeClass = function (el, className) {
    if (el.classList) {
        el.classList.remove(className);
        return;
    }
    if (hasClass(el, className)) {
        var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
        el.className = el.className.replace(reg, ' ');
    }
};
var toggleClass = function (el, className, status) {
    if (!el || !className) 
        { return; }
    if (Array.isArray(className)) {
        className.forEach(function (item) { return toggleClass(el, item, status); });
        return;
    }
    if (status) {
        return addClass(el, className);
    }
    removeClass(el, className);
};
var toArray = function (arrayLike) {
    if (isCallable(Array.from)) {
        return Array.from(arrayLike);
    }
    var array = [];
    var length = arrayLike.length;
    for (var i = 0;i < length; i++) {
        array.push(arrayLike[i]);
    }
    return array;
};
var assign = function (target) {
    var others = [], len = arguments.length - 1;
    while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

    if (isCallable(Object.assign)) {
        return Object.assign.apply(Object, [ target ].concat( others ));
    }
    if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object');
    }
    var to = Object(target);
    others.forEach(function (arg) {
        if (arg != null) {
            Object.keys(arg).forEach(function (key) {
                to[key] = arg[key];
            });
        }
    });
    return to;
};
var id = 0;
var idTemplate = '{id}';
var uniqId = function () {
    if (id >= 9999) {
        id = 0;
        idTemplate = idTemplate.replace('{id}', '_{id}');
    }
    id++;
    var newId = idTemplate.replace('{id}', String(id));
    return newId;
};
var find = function (arrayLike, predicate) {
    var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
    for (var i = 0;i < array.length; i++) {
        if (predicate(array[i])) {
            return array[i];
        }
    }
    return undefined;
};
var isBuiltInComponent = function (vnode) {
    if (!vnode) {
        return false;
    }
    var tag = vnode.componentOptions.tag;
    return /keep-alive|transition|transition-group/.test(tag);
};
var makeEventsArray = function (events) { return typeof events === 'string' && events.length ? events.split('|') : []; };
var makeDelayObject = function (events, delay, delayConfig) {
    if (typeof delay === 'number') {
        return events.reduce(function (prev, e) {
            prev[e] = delay;
            return prev;
        }, {});
    }
    return events.reduce(function (prev, e) {
        if (typeof delay === 'object' && e in delay) {
            prev[e] = delay[e];
            return prev;
        }
        if (typeof delayConfig === 'number') {
            prev[e] = delayConfig;
            return prev;
        }
        prev[e] = delayConfig && delayConfig[e] || 0;
        return prev;
    }, {});
};
var deepParseInt = function (input) {
    if (typeof input === 'number') 
        { return input; }
    if (typeof input === 'string') 
        { return parseInt(input); }
    var map = {};
    for (var element in input) {
        map[element] = parseInt(input[element]);
    }
    return map;
};
var merge = function (target, source) {
    if (!(isObject(target) && isObject(source))) {
        return target;
    }
    Object.keys(source).forEach(function (key) {
        var obj, obj$1;

        if (isObject(source[key])) {
            if (!target[key]) {
                assign(target, ( obj = {}, obj[key] = {}, obj ));
            }
            merge(target[key], source[key]);
            return;
        }
        assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
    });
    return target;
};

var ErrorBag = function ErrorBag() {
    this.items = [];
};
ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
        var this$1 = this;

    var index = 0;
    return {
        next: function () { return ({
            value: this$1.items[index++],
            done: index > this$1.items.length
        }); }
    };
};
ErrorBag.prototype.add = function add (error) {
        var ref;

    if (arguments.length > 1) {
        error = {
            field: arguments[0],
            msg: arguments[1],
            rule: arguments[2],
            scope: !isNullOrUndefined(arguments[3]) ? arguments[3] : null,
            regenerate: null
        };
    }
    (ref = this.items).push.apply(ref, this._normalizeError(error));
};
ErrorBag.prototype._normalizeError = function _normalizeError (error) {
    if (Array.isArray(error)) {
        return error.map(function (e) {
            e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
            return e;
        });
    }
    error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
    return [error];
};
ErrorBag.prototype.regenerate = function regenerate () {
    this.items.forEach(function (i) {
        i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
    });
};
ErrorBag.prototype.update = function update (id, error) {
    var item = find(this.items, function (i) { return i.id === id; });
    if (!item) {
        return;
    }
    var idx = this.items.indexOf(item);
    this.items.splice(idx, 1);
    item.scope = error.scope;
    this.items.push(item);
};
ErrorBag.prototype.all = function all (scope) {
    if (isNullOrUndefined(scope)) {
        return this.items.map(function (e) { return e.msg; });
    }
    return this.items.filter(function (e) { return e.scope === scope; }).map(function (e) { return e.msg; });
};
ErrorBag.prototype.any = function any (scope) {
    if (isNullOrUndefined(scope)) {
        return !(!this.items.length);
    }
    return !(!this.items.filter(function (e) { return e.scope === scope; }).length);
};
ErrorBag.prototype.clear = function clear (scope) {
        var this$1 = this;

    if (isNullOrUndefined(scope)) {
        scope = null;
    }
    for (var i = 0;i < this.items.length; ++i) {
        if (this$1.items[i].scope === scope) {
            this$1.items.splice(i, 1);
            --i;
        }
    }
};
ErrorBag.prototype.collect = function collect (field, scope, map) {
        if ( map === void 0 ) map = true;

    if (!field) {
        var collection = {};
        this.items.forEach(function (e) {
            if (!collection[e.field]) {
                collection[e.field] = [];
            }
            collection[e.field].push(map ? e.msg : e);
        });
        return collection;
    }
    field = !isNullOrUndefined(field) ? String(field) : field;
    if (isNullOrUndefined(scope)) {
        return this.items.filter(function (e) { return e.field === field; }).map(function (e) { return map ? e.msg : e; });
    }
    return this.items.filter(function (e) { return e.field === field && e.scope === scope; }).map(function (e) { return map ? e.msg : e; });
};
ErrorBag.prototype.count = function count () {
    return this.items.length;
};
ErrorBag.prototype.firstById = function firstById (id) {
    var error = find(this.items, function (i) { return i.id === id; });
    return error ? error.msg : null;
};
ErrorBag.prototype.first = function first (field, scope) {
        var this$1 = this;
        if ( scope === void 0 ) scope = null;

    if (isNullOrUndefined(field)) {
        return null;
    }
    field = String(field);
    var selector = this._selector(field);
    var scoped = this._scope(field);
    if (scoped) {
        var result = this.first(scoped.name, scoped.scope);
        if (result) {
            return result;
        }
    }
    if (selector) {
        return this.firstByRule(selector.name, selector.rule, scope);
    }
    for (var i = 0;i < this.items.length; ++i) {
        if (this$1.items[i].field === field && this$1.items[i].scope === scope) {
            return this$1.items[i].msg;
        }
    }
    return null;
};
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
    var errors = this.collect(field, scope, false);
    return errors.length && errors[0].rule || null;
};
ErrorBag.prototype.has = function has (field, scope) {
        if ( scope === void 0 ) scope = null;

    return !(!this.first(field, scope));
};
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
        if ( scope === void 0 ) scope = null;

    var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];
    return error && error.msg || null;
};
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
        if ( rule === void 0 ) rule = 'required';
        if ( scope === void 0 ) scope = null;

    var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];
    return error && error.msg || null;
};
ErrorBag.prototype.removeById = function removeById (id) {
        var this$1 = this;

    if (Array.isArray(id)) {
        this.items = this.items.filter(function (i) { return id.indexOf(i.id) === -1; });
        return;
    }
    for (var i = 0;i < this.items.length; ++i) {
        if (this$1.items[i].id === id) {
            this$1.items.splice(i, 1);
            --i;
        }
    }
};
ErrorBag.prototype.remove = function remove (field, scope) {
        var this$1 = this;

    field = !isNullOrUndefined(field) ? String(field) : field;
    var removeCondition = function (e) {
        if (!isNullOrUndefined(scope)) {
            return e.field === field && e.scope === scope;
        }
        return e.field === field && e.scope === null;
    };
    for (var i = 0;i < this.items.length; ++i) {
        if (removeCondition(this$1.items[i])) {
            this$1.items.splice(i, 1);
            --i;
        }
    }
};
ErrorBag.prototype._selector = function _selector (field) {
    if (field.indexOf(':') > -1) {
        var ref = field.split(':');
            var name = ref[0];
            var rule = ref[1];
        return {
            name: name,
            rule: rule
        };
    }
    return null;
};
ErrorBag.prototype._scope = function _scope (field) {
    if (field.indexOf('.') > -1) {
        var ref = field.split('.');
            var scope = ref[0];
            var name = ref.slice(1);
        return {
            name: name.join('.'),
            scope: scope
        };
    }
    return null;
};

var LOCALE = 'en';
var Dictionary = function Dictionary(dictionary) {
    if ( dictionary === void 0 ) dictionary = {};

    this.container = {};
    this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };
prototypeAccessors.locale.get = function () {
    return LOCALE;
};
prototypeAccessors.locale.set = function (value) {
    LOCALE = value || 'en';
};
Dictionary.prototype.hasLocale = function hasLocale (locale) {
    return !(!this.container[locale]);
};
Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
    if (!this.container[locale]) {
        this.container[locale] = {};
    }
    this.container[locale].dateFormat = format;
};
Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
    if (!this.container[locale] || !this.container[locale].dateFormat) {
        return null;
    }
    return this.container[locale].dateFormat;
};
Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
    var message = null;
    if (!this.hasMessage(locale, key)) {
        message = this._getDefaultMessage(locale);
    } else {
        message = this.container[locale].messages[key];
    }
    return isCallable(message) ? message.apply(void 0, data) : message;
};
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
    if (!this.hasLocale(locale)) {
        return this.getMessage(locale, key, data);
    }
    var dict = this.container[locale].custom && this.container[locale].custom[field];
    if (!dict || !dict[key]) {
        return this.getMessage(locale, key, data);
    }
    var message = dict[key];
    return isCallable(message) ? message.apply(void 0, data) : message;
};
Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
    if (this.hasMessage(locale, '_default')) {
        return this.container[locale].messages._default;
    }
    return this.container.en.messages._default;
};
Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
        if ( fallback === void 0 ) fallback = '';

    if (!this.hasAttribute(locale, key)) {
        return fallback;
    }
    return this.container[locale].attributes[key];
};
Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
    return !(!(this.hasLocale(locale) && this.container[locale].messages && this.container[locale].messages[key]));
};
Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
    return !(!(this.hasLocale(locale) && this.container[locale].attributes && this.container[locale].attributes[key]));
};
Dictionary.prototype.merge = function merge$1 (dictionary) {
    merge(this.container, dictionary);
};
Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
    if (!this.hasLocale(locale)) {
        this.container[locale] = {
            messages: {},
            attributes: {}
        };
    }
    this.container[locale].messages[key] = message;
};
Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
    if (!this.hasLocale(locale)) {
        this.container[locale] = {
            messages: {},
            attributes: {}
        };
    }
    this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors );

var normalizeValue = function (value) {
    if (isObject(value)) {
        return Object.keys(value).reduce(function (prev, key) {
            prev[key] = normalizeValue(value[key]);
            return prev;
        }, {});
    }
    if (isCallable(value)) {
        return value('{0}', ['{1}','{2}','{3}']);
    }
    return value;
};
var normalizeFormat = function (locale) {
    var messages = normalizeValue(locale.messages);
    var custom = normalizeValue(locale.custom);
    return {
        messages: messages,
        custom: custom,
        attributes: locale.attributes,
        dateFormat: locale.dateFormat
    };
};
var I18nDictionary = function I18nDictionary(i18n, rootKey) {
    this.i18n = i18n;
    this.rootKey = rootKey;
};

var prototypeAccessors$1 = { locale: { configurable: true } };
prototypeAccessors$1.locale.get = function () {
    return this.i18n.locale;
};
prototypeAccessors$1.locale.set = function (value) {
    warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};
I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
    return this.i18n.getDateTimeFormat(locale || this.locale);
};
I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
    this.i18n.setDateTimeFormat(locale || this.locale, value);
};
I18nDictionary.prototype.getMessage = function getMessage (locale, key, data) {
    var path = (this.rootKey) + ".messages." + key;
    if (!this.i18n.te(path)) {
        return this.i18n.t(((this.rootKey) + ".messages._default"), locale, data);
    }
    return this.i18n.t(path, locale, data);
};
I18nDictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
        if ( fallback === void 0 ) fallback = '';

    var path = (this.rootKey) + ".attributes." + key;
    if (!this.i18n.te(path)) {
        return fallback;
    }
    return this.i18n.t(path, locale);
};
I18nDictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
    var path = (this.rootKey) + ".custom." + field + "." + key;
    if (this.i18n.te(path)) {
        return this.i18n.t(path);
    }
    return this.getMessage(locale, key, data);
};
I18nDictionary.prototype.merge = function merge$1 (dictionary) {
        var this$1 = this;

    Object.keys(dictionary).forEach(function (localeKey) {
            var obj;

        var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
        var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
        this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
        if (locale.dateFormat) {
            this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
        }
    });
};
I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
        var obj, obj$1;

    this.merge(( obj$1 = {}, obj$1[locale] = {
            messages: ( obj = {}, obj[key] = value, obj )
        }, obj$1 ));
};
I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
        var obj, obj$1;

    this.merge(( obj$1 = {}, obj$1[locale] = {
            attributes: ( obj = {}, obj[key] = value, obj )
        }, obj$1 ));
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$1 );

var defaultConfig = {
    locale: 'en',
    delay: 0,
    errorBagName: 'errors',
    dictionary: null,
    strict: true,
    fieldsBagName: 'fields',
    classes: false,
    classNames: null,
    events: 'input|blur',
    inject: true,
    fastExit: true,
    aria: true,
    validity: false,
    i18n: null,
    i18nRootKey: 'validation'
};
var currentConfig = assign({}, defaultConfig);
var dependencies = {
    dictionary: new Dictionary({
        en: {
            messages: {},
            attributes: {},
            custom: {}
        }
    })
};
var Config = function Config () {};

var staticAccessors = { default: { configurable: true },current: { configurable: true } };

staticAccessors.default.get = function () {
    return defaultConfig;
};
staticAccessors.current.get = function () {
    return currentConfig;
};
Config.dependency = function dependency (key) {
    return dependencies[key];
};
Config.merge = function merge$$1 (config) {
    currentConfig = assign({}, currentConfig, config);
    if (currentConfig.i18n) {
        Config.register('dictionary', new I18nDictionary(currentConfig.i18n, currentConfig.i18nRootKey));
    }
};
Config.register = function register (key, value) {
    dependencies[key] = value;
};
Config.resolve = function resolve (context) {
    var selfConfig = getPath('$options.$_veeValidate', context, {});
    return assign({}, Config.current, selfConfig);
};

Object.defineProperties( Config, staticAccessors );

var Generator = function Generator () {};

Generator.generate = function generate (el, binding, vnode) {
    var model = Generator.resolveModel(binding, vnode);
    var options = Config.resolve(vnode.context);
    return {
        name: Generator.resolveName(el, vnode),
        el: el,
        listen: !binding.modifiers.disable,
        scope: Generator.resolveScope(el, binding, vnode),
        vm: Generator.makeVM(vnode.context),
        expression: binding.value,
        component: vnode.child,
        classes: options.classes,
        classNames: options.classNames,
        getter: Generator.resolveGetter(el, vnode, model),
        events: Generator.resolveEvents(el, vnode) || options.events,
        model: model,
        delay: Generator.resolveDelay(el, vnode, options),
        rules: Generator.resolveRules(el, binding),
        initial: !(!binding.modifiers.initial),
        validity: options.validity,
        aria: options.aria,
        initialValue: Generator.resolveInitialValue(vnode)
    };
};
Generator.getCtorConfig = function getCtorConfig (vnode) {
    if (!vnode.child) 
        { return null; }
    var config = getPath('child.$options.$_veeValidate', vnode);
    return config;
};
Generator.resolveRules = function resolveRules (el, binding) {
    if (!binding.value && (!binding || !binding.expression)) {
        return getDataAttribute(el, 'rules');
    }
    if (binding.value && ~['string','object'].indexOf(typeof binding.value.rules)) {
        return binding.value.rules;
    }
    return binding.value;
};
Generator.resolveInitialValue = function resolveInitialValue (vnode) {
    var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
    return model && model.value;
};
Generator.makeVM = function makeVM (vm) {
    return {
        get $el() {
            return vm.$el;
        },
        get $refs() {
            return vm.$refs;
        },
        $watch: vm.$watch ? vm.$watch.bind(vm) : function () {},
        $validator: vm.$validator ? {
            errors: vm.$validator.errors,
            validate: vm.$validator.validate.bind(vm.$validator),
            update: vm.$validator.update.bind(vm.$validator)
        } : null
    };
};
Generator.resolveDelay = function resolveDelay (el, vnode, options) {
    var delay = getDataAttribute(el, 'delay');
    var globalDelay = options && 'delay' in options ? options.delay : 0;
    if (!delay && vnode.child && vnode.child.$attrs) {
        delay = vnode.child.$attrs['data-vv-delay'];
    }
    if (!isObject(globalDelay)) {
        return deepParseInt(delay || globalDelay);
    }
    globalDelay.input = delay || 0;
    return deepParseInt(globalDelay);
};
Generator.resolveEvents = function resolveEvents (el, vnode) {
    var events = getDataAttribute(el, 'validate-on');
    if (!events && vnode.child && vnode.child.$attrs) {
        events = vnode.child.$attrs['data-vv-validate-on'];
    }
    if (!events && vnode.child) {
        var config = Generator.getCtorConfig(vnode);
        events = config && config.events;
    }
    return events;
};
Generator.resolveScope = function resolveScope (el, binding, vnode) {
        if ( vnode === void 0 ) vnode = {};

    var scope = null;
    if (vnode.child && isNullOrUndefined(scope)) {
        scope = vnode.child.$attrs && vnode.child.$attrs['data-vv-scope'];
    }
    return !isNullOrUndefined(scope) ? scope : getScope(el);
};
Generator.resolveModel = function resolveModel (binding, vnode) {
    if (binding.arg) {
        return {
            expression: binding.arg
        };
    }
    var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
    if (!model) {
        return null;
    }
    var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
    var lazy = !(!(model.modifiers && model.modifiers.lazy));
    if (!watchable) {
        return {
            expression: null,
            lazy: lazy
        };
    }
    return {
        expression: model.expression,
        lazy: lazy
    };
};
Generator.resolveName = function resolveName (el, vnode) {
    var name = getDataAttribute(el, 'name');
    if (!name && !vnode.child) {
        return el.name;
    }
    if (!name && vnode.child && vnode.child.$attrs) {
        name = vnode.child.$attrs['data-vv-name'] || vnode.child.$attrs['name'];
    }
    if (!name && vnode.child) {
        var config = Generator.getCtorConfig(vnode);
        if (config && isCallable(config.name)) {
            var boundGetter = config.name.bind(vnode.child);
            return boundGetter();
        }
        return vnode.child.name;
    }
    return name;
};
Generator.resolveGetter = function resolveGetter (el, vnode, model) {
    if (model && model.expression) {
        return function () { return getPath(model.expression, vnode.context); };
    }
    if (vnode.child) {
        var path = getDataAttribute(el, 'value-path') || vnode.child.$attrs && vnode.child.$attrs['data-vv-value-path'];
        if (path) {
            return function () { return getPath(path, vnode.child); };
        }
        var config = Generator.getCtorConfig(vnode);
        if (config && isCallable(config.value)) {
            var boundGetter = config.value.bind(vnode.child);
            return function () { return boundGetter(); };
        }
        return function () { return vnode.child.value; };
    }
    switch (el.type) {
        case 'checkbox':
            return function () {
                var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
                els = toArray(els).filter(function (el) { return el.checked; });
                if (!els.length) 
                    { return undefined; }
                return els.map(function (checkbox) { return checkbox.value; });
            };
        case 'radio':
            return function () {
                var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
                var elm = find(els, function (el) { return el.checked; });
                return elm && elm.value;
            };
        case 'file':
            return function (context) { return toArray(el.files); };
        case 'select-multiple':
            return function () { return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; }); };
        default:
            return function () { return el && el.value; };
    }
};

var DEFAULT_OPTIONS = {
    targetOf: null,
    initial: false,
    scope: null,
    listen: true,
    name: null,
    rules: {},
    vm: null,
    classes: false,
    validity: true,
    aria: true,
    events: 'input|blur',
    delay: 0,
    classNames: {
        touched: 'touched',
        untouched: 'untouched',
        valid: 'valid',
        invalid: 'invalid',
        pristine: 'pristine',
        dirty: 'dirty'
    }
};
var Field = function Field(options) {
    if ( options === void 0 ) options = {};

    this.id = uniqId();
    this.el = options.el;
    this.updated = false;
    this.dependencies = [];
    this.watchers = [];
    this.events = [];
    this.delay = 0;
    this.rules = {};
    this._cacheId(options);
    this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
    options = assign({}, DEFAULT_OPTIONS, options);
    this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0;
    this.validity = options.validity;
    this.aria = options.aria;
    this.flags = createFlags();
    this.vm = options.vm;
    this.component = options.component;
    this.ctorConfig = this.component ? getPath('$options.$_veeValidate', this.component) : undefined;
    this.update(options);
    this.initialValue = this.value;
    this.updated = false;
};

var prototypeAccessors$2 = { validator: { configurable: true },isRequired: { configurable: true },isDisabled: { configurable: true },alias: { configurable: true },value: { configurable: true },rejectsFalse: { configurable: true } };
prototypeAccessors$2.validator.get = function () {
    if (!this.vm || !this.vm.$validator) {
        warn('No validator instance detected.');
        return {
            validate: function () {}
        };
    }
    return this.vm.$validator;
};
prototypeAccessors$2.isRequired.get = function () {
    return !(!this.rules.required);
};
prototypeAccessors$2.isDisabled.get = function () {
    return !(!(this.component && this.component.disabled)) || !(!(this.el && this.el.disabled));
};
prototypeAccessors$2.alias.get = function () {
    if (this._alias) {
        return this._alias;
    }
    var alias = null;
    if (this.el) {
        alias = getDataAttribute(this.el, 'as');
    }
    if (!alias && this.component) {
        return this.component.$attrs && this.component.$attrs['data-vv-as'];
    }
    return alias;
};
prototypeAccessors$2.value.get = function () {
    if (!isCallable(this.getter)) {
        return undefined;
    }
    return this.getter();
};
prototypeAccessors$2.rejectsFalse.get = function () {
    if (this.component && this.ctorConfig) {
        return !(!this.ctorConfig.rejectsFalse);
    }
    if (!this.el) {
        return false;
    }
    return this.el.type === 'checkbox';
};
Field.prototype.matches = function matches (options) {
    if (!options) {
        return true;
    }
    if (options.id) {
        return this.id === options.id;
    }
    if (options.name === undefined && options.scope === undefined) {
        return true;
    }
    if (options.scope === undefined) {
        return this.name === options.name;
    }
    if (options.name === undefined) {
        return this.scope === options.scope;
    }
    return options.name === this.name && options.scope === this.scope;
};
Field.prototype._cacheId = function _cacheId (options) {
    if (this.el && !options.targetOf) {
        setDataAttribute(this.el, 'id', this.id);
    }
};
Field.prototype.update = function update (options) {
    this.targetOf = options.targetOf || null;
    this.initial = options.initial || this.initial || false;
    if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
        this.validator.update(this.id, {
            scope: options.scope
        });
    }
    this.scope = !isNullOrUndefined(options.scope) ? options.scope : !isNullOrUndefined(this.scope) ? this.scope : null;
    this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
    this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
    this.model = options.model || this.model;
    this.listen = options.listen !== undefined ? options.listen : this.listen;
    this.classes = (options.classes || this.classes || false) && !this.component;
    this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
    this.getter = isCallable(options.getter) ? options.getter : this.getter;
    this._alias = options.alias || this._alias;
    this.events = options.events ? makeEventsArray(options.events) : this.events;
    this.delay = options.delay ? makeDelayObject(this.events, options.delay, this._delay) : makeDelayObject(this.events, this.delay, this._delay);
    this.updateDependencies();
    this.addActionListeners();
    if (!this.name) {
        warn('A field is missing a "name" or "data-vv-name" attribute');
    }
    if (options.rules !== undefined) {
        this.flags.required = this.isRequired;
    }
    if (this.flags.validated && options.rules !== undefined && this.updated) {
        this.validator.validate(("#" + (this.id)));
    }
    this.updated = true;
    this.addValueListeners();
    if (!this.el) {
        return;
    }
    this.updateClasses();
    this.updateAriaAttrs();
};
Field.prototype.reset = function reset () {
        var this$1 = this;

    var defaults = createFlags();
    Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
        this$1.flags[flag] = defaults[flag];
    });
    this.addActionListeners();
    this.updateClasses();
    this.updateAriaAttrs();
    this.updateCustomValidity();
};
Field.prototype.setFlags = function setFlags (flags) {
        var this$1 = this;

    var negated = {
        pristine: 'dirty',
        dirty: 'pristine',
        valid: 'invalid',
        invalid: 'valid',
        touched: 'untouched',
        untouched: 'touched'
    };
    Object.keys(flags).forEach(function (flag) {
        this$1.flags[flag] = flags[flag];
        if (negated[flag] && flags[negated[flag]] === undefined) {
            this$1.flags[negated[flag]] = !flags[flag];
        }
    });
    if (flags.untouched !== undefined || flags.touched !== undefined || flags.dirty !== undefined || flags.pristine !== undefined) {
        this.addActionListeners();
    }
    this.updateClasses();
    this.updateAriaAttrs();
    this.updateCustomValidity();
};
Field.prototype.updateDependencies = function updateDependencies () {
        var this$1 = this;

    this.dependencies.forEach(function (d) { return d.field.destroy(); });
    this.dependencies = [];
    var fields = Object.keys(this.rules).reduce(function (prev, r) {
        if (Validator.isTargetRule(r)) {
            var selector = this$1.rules[r][0];
            if (r === 'confirmed' && !selector) {
                selector = (this$1.name) + "_confirmation";
            }
            prev.push({
                selector: selector,
                name: r
            });
        }
        return prev;
    }, []);
    if (!fields.length || !this.vm || !this.vm.$el) 
        { return; }
    fields.forEach(function (ref) {
            var selector = ref.selector;
            var name = ref.name;

        var el = null;
        if (selector[0] === '$') {
            var ref$1 = this$1.vm.$refs[selector.slice(1)];
            el = Array.isArray(ref$1) ? ref$1[0] : ref$1;
        } else {
            try {
                el = this$1.vm.$el.querySelector(selector);
            } catch (err) {
                el = null;
            }
        }
        if (!el) {
            try {
                el = this$1.vm.$el.querySelector(("input[name=\"" + selector + "\"]"));
            } catch (err) {
                el = null;
            }
        }
        if (!el) {
            return;
        }
        var options = {
            vm: this$1.vm,
            classes: this$1.classes,
            classNames: this$1.classNames,
            delay: this$1.delay,
            scope: this$1.scope,
            events: this$1.events.join('|'),
            initial: this$1.initial,
            targetOf: this$1.id
        };
        if (isCallable(el.$watch)) {
            options.component = el;
            options.el = el.$el;
            options.getter = Generator.resolveGetter(el.$el, {
                child: el
            });
        } else {
            options.el = el;
            options.getter = Generator.resolveGetter(el, {});
        }
        this$1.dependencies.push({
            name: name,
            field: new Field(options)
        });
    });
};
Field.prototype.unwatch = function unwatch (tag) {
        if ( tag === void 0 ) tag = null;

    if (!tag) {
        this.watchers.forEach(function (w) { return w.unwatch(); });
        this.watchers = [];
        return;
    }
    this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
    this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};
Field.prototype.updateClasses = function updateClasses () {
    if (!this.classes || this.isDisabled) 
        { return; }
    toggleClass(this.el, this.classNames.dirty, this.flags.dirty);
    toggleClass(this.el, this.classNames.pristine, this.flags.pristine);
    toggleClass(this.el, this.classNames.touched, this.flags.touched);
    toggleClass(this.el, this.classNames.untouched, this.flags.untouched);
    if (!isNullOrUndefined(this.flags.valid) && this.flags.validated) {
        toggleClass(this.el, this.classNames.valid, this.flags.valid);
    }
    if (!isNullOrUndefined(this.flags.invalid) && this.flags.validated) {
        toggleClass(this.el, this.classNames.invalid, this.flags.invalid);
    }
};
Field.prototype.addActionListeners = function addActionListeners () {
        var this$1 = this;

    this.unwatch(/class/);
    if (!this.el) 
        { return; }
    var onBlur = function () {
        this$1.flags.touched = true;
        this$1.flags.untouched = false;
        if (this$1.classes) {
            toggleClass(this$1.el, this$1.classNames.touched, true);
            toggleClass(this$1.el, this$1.classNames.untouched, false);
        }
        this$1.unwatch(/^class_blur$/);
    };
    var inputEvent = isTextInput(this.el) ? 'input' : 'change';
    var onInput = function () {
        this$1.flags.dirty = true;
        this$1.flags.pristine = false;
        if (this$1.classes) {
            toggleClass(this$1.el, this$1.classNames.pristine, false);
            toggleClass(this$1.el, this$1.classNames.dirty, true);
        }
        this$1.unwatch(/^class_input$/);
    };
    if (this.component && isCallable(this.component.$once)) {
        this.component.$once('input', onInput);
        this.component.$once('blur', onBlur);
        this.watchers.push({
            tag: 'class_input',
            unwatch: function () {
                this$1.component.$off('input', onInput);
            }
        });
        this.watchers.push({
            tag: 'class_blur',
            unwatch: function () {
                this$1.component.$off('blur', onBlur);
            }
        });
        return;
    }
    if (!this.el) 
        { return; }
    addEventListener(this.el, inputEvent, onInput);
    var blurEvent = ['radio','checkbox'].indexOf(this.el.type) === -1 ? 'blur' : 'click';
    addEventListener(this.el, blurEvent, onBlur);
    this.watchers.push({
        tag: 'class_input',
        unwatch: function () {
            this$1.el.removeEventListener(inputEvent, onInput);
        }
    });
    this.watchers.push({
        tag: 'class_blur',
        unwatch: function () {
            this$1.el.removeEventListener(blurEvent, onBlur);
        }
    });
};
Field.prototype.checkValueChanged = function checkValueChanged () {
    if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
        return false;
    }
    return this.value !== this.initialValue;
};
Field.prototype.addValueListeners = function addValueListeners () {
        var this$1 = this;

    this.unwatch(/^input_.+/);
    if (!this.listen || !this.el) 
        { return; }
    var fn = this.targetOf ? function () {
        this$1.flags.changed = this$1.checkValueChanged();
        this$1.validator.validate(("#" + (this$1.targetOf)));
    } : function () {
            var args = [], len = arguments.length;
            while ( len-- ) args[ len ] = arguments[ len ];

        if (args.length === 0 || isCallable(Event) && args[0] instanceof Event || args[0] && args[0].srcElement) {
            args[0] = this$1.value;
        }
        this$1.flags.changed = this$1.checkValueChanged();
        this$1.validator.validate(("#" + (this$1.id)), args[0]);
    };
    var inputEvent = isTextInput(this.el) ? 'input' : 'change';
    inputEvent = this.model && this.model.lazy ? 'change' : inputEvent;
    var events = !this.events.length || isTextInput(this.el) ? this.events : ['change'];
    if (this.model && this.model.expression && events.indexOf(inputEvent) !== -1) {
        var debouncedFn = debounce(fn, this.delay[inputEvent]);
        var unwatch = this.vm.$watch(this.model.expression, function () {
                var args = [], len = arguments.length;
                while ( len-- ) args[ len ] = arguments[ len ];

            this$1.flags.pending = true;
            debouncedFn.apply(void 0, args);
        });
        this.watchers.push({
            tag: 'input_model',
            unwatch: unwatch
        });
        events = events.filter(function (e) { return e !== inputEvent; });
    }
    events.forEach(function (e) {
        var debouncedFn = debounce(fn, this$1.delay[e]);
        var validate = function () {
                var args = [], len = arguments.length;
                while ( len-- ) args[ len ] = arguments[ len ];

            this$1.flags.pending = true;
            debouncedFn.apply(void 0, args);
        };
        this$1._addComponentEventListener(e, validate);
        this$1._addHTMLEventListener(e, validate);
    });
};
Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
        var this$1 = this;

    if (!this.component) 
        { return; }
    this.component.$on(evt, validate);
    this.watchers.push({
        tag: 'input_vue',
        unwatch: function () {
            this$1.component.$off(evt, validate);
        }
    });
};
Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
        var this$1 = this;

    if (!this.el || this.component) 
        { return; }
    addEventListener(this.el, evt, validate);
    this.watchers.push({
        tag: 'input_native',
        unwatch: function () {
            this$1.el.removeEventListener(evt, validate);
        }
    });
    if (~['radio','checkbox'].indexOf(this.el.type)) {
        var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
        toArray(els).forEach(function (el) {
            if (getDataAttribute(el, 'id') && el !== this$1.el) {
                return;
            }
            addEventListener(el, evt, validate);
            this$1.watchers.push({
                tag: 'input_native',
                unwatch: function () {
                    el.removeEventListener(evt, validate);
                }
            });
        });
    }
};
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
    if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) 
        { return; }
    this.el.setAttribute('aria-required', this.isRequired ? 'true' : 'false');
    this.el.setAttribute('aria-invalid', this.flags.invalid ? 'true' : 'false');
};
Field.prototype.updateCustomValidity = function updateCustomValidity () {
    if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity)) 
        { return; }
    this.el.setCustomValidity(this.flags.valid ? '' : this.validator.errors.firstById(this.id) || '');
};
Field.prototype.destroy = function destroy () {
    this.unwatch();
    this.dependencies.forEach(function (d) { return d.field.destroy(); });
    this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$2 );

var FieldBag = function FieldBag() {
    this.items = [];
};

var prototypeAccessors$3 = { length: { configurable: true } };
FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
        var this$1 = this;

    var index = 0;
    return {
        next: function () { return ({
            value: this$1.items[index++],
            done: index > this$1.items.length
        }); }
    };
};
prototypeAccessors$3.length.get = function () {
    return this.items.length;
};
FieldBag.prototype.find = function find$1 (matcher) {
    return find(this.items, function (item) { return item.matches(matcher); });
};
FieldBag.prototype.filter = function filter (matcher) {
    if (Array.isArray(matcher)) {
        return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
    }
    return this.items.filter(function (item) { return item.matches(matcher); });
};
FieldBag.prototype.map = function map (mapper) {
    return this.items.map(mapper);
};
FieldBag.prototype.remove = function remove (matcher) {
    var item = null;
    if (matcher instanceof Field) {
        item = matcher;
    } else {
        item = this.find(matcher);
    }
    if (!item) 
        { return null; }
    var index = this.items.indexOf(item);
    this.items.splice(index, 1);
    return item;
};
FieldBag.prototype.push = function push (item) {
    if (!(item instanceof Field)) {
        throw createError('FieldBag only accepts instances of Field that has an id defined.');
    }
    if (!item.id) {
        throw createError('Field id must be defined.');
    }
    if (this.find({
        id: item.id
    })) {
        throw createError(("Field with id " + (item.id) + " is already added."));
    }
    this.items.push(item);
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$3 );

var RULES = {};
var STRICT_MODE = true;
var TARGET_RULES = ['confirmed','after','before'];
var Validator = function Validator(validations, options) {
    var this$1 = this;
    if ( options === void 0 ) options = {
    fastExit: true
};

    this.strict = STRICT_MODE;
    this.errors = new ErrorBag();
    this.fields = new FieldBag();
    this.flags = {};
    this._createFields(validations);
    this.paused = false;
    this.fastExit = options.fastExit || false;
    this.ownerId = options.vm && options.vm._uid;
    this._localeListener = (function () {
        this$1.errors.regenerate();
    });
    if (this._vm) {
        this._vm.$on('localeChanged', this._localeListener);
    }
};

var prototypeAccessors$4 = { dictionary: { configurable: true },_vm: { configurable: true },locale: { configurable: true },rules: { configurable: true } };
var staticAccessors$1 = { dictionary: { configurable: true },locale: { configurable: true },rules: { configurable: true } };
prototypeAccessors$4.dictionary.get = function () {
    return Config.dependency('dictionary');
};
prototypeAccessors$4._vm.get = function () {
    return Config.dependency('vm');
};
staticAccessors$1.dictionary.get = function () {
    return Config.dependency('dictionary');
};
prototypeAccessors$4.locale.get = function () {
    return this.dictionary.locale;
};
prototypeAccessors$4.locale.set = function (value) {
    Validator.locale = value;
};
staticAccessors$1.locale.get = function () {
    return Validator.dictionary.locale;
};
staticAccessors$1.locale.set = function (value) {
    var hasChanged = value !== Validator.dictionary.locale;
    Validator.dictionary.locale = value;
    if (hasChanged && Config.dependency('vm')) {
        Config.dependency('vm').$emit('localeChanged');
    }
};
prototypeAccessors$4.rules.get = function () {
    return RULES;
};
staticAccessors$1.rules.get = function () {
    return RULES;
};
Validator.create = function create (validations, options) {
    return new Validator(validations, options);
};
Validator.extend = function extend (name, validator, options) {
        if ( options === void 0 ) options = {};

    Validator._guardExtend(name, validator);
    Validator._merge(name, validator);
    if (options && options.hasTarget) {
        TARGET_RULES.push(name);
    }
};
Validator.remove = function remove (name) {
    delete RULES[name];
    var idx = TARGET_RULES.indexOf(name);
    if (idx === -1) 
        { return; }
    TARGET_RULES.splice(idx, 1);
};
Validator.isTargetRule = function isTargetRule (name) {
    return TARGET_RULES.indexOf(name) !== -1;
};
Validator.setStrictMode = function setStrictMode (strictMode) {
        if ( strictMode === void 0 ) strictMode = true;

    STRICT_MODE = strictMode;
};
Validator.prototype.localize = function localize (lang, dictionary) {
    Validator.localize(lang, dictionary);
};
Validator.localize = function localize (lang, dictionary) {
        var obj;

    if (isObject(lang)) {
        Validator.dictionary.merge(lang);
        return;
    }
    if (dictionary) {
        var locale = lang || dictionary.name;
        dictionary = assign({}, dictionary);
        Validator.dictionary.merge(( obj = {}, obj[locale] = dictionary, obj ));
    }
    if (lang) {
        Validator.locale = lang;
    }
};
Validator.prototype.attach = function attach (field) {
    if (arguments.length > 1) {
        warn('This signature of the attach method has been deprecated, please consult the docs.');
        field = assign({}, {
            name: arguments[0],
            rules: arguments[1]
        }, arguments[2] || {
            vm: {
                $validator: this
            }
        });
    }
    var value = field.initialValue;
    if (!(field instanceof Field)) {
        field = new Field(field);
    }
    this.fields.push(field);
    if (field.initial) {
        this.validate(("#" + (field.id)), value || field.value);
    } else {
        this._validate(field, value || field.value, true).then(function (result) {
            field.flags.valid = result.valid;
            field.flags.invalid = !result.valid;
        });
    }
    this._addFlag(field, field.scope);
    return field;
};
Validator.prototype.flag = function flag (name, flags) {
    var field = this._resolveField(name);
    if (!field || !flags) {
        return;
    }
    field.setFlags(flags);
};
Validator.prototype.detach = function detach (name, scope) {
    var field = name instanceof Field ? name : this._resolveField(name, scope);
    if (!field) 
        { return; }
    field.destroy();
    this.errors.remove(field.name, field.scope, field.id);
    this.fields.remove(field);
    var flags = this.flags;
    if (!isNullOrUndefined(field.scope) && flags[("$" + (field.scope))]) {
        delete flags[("$" + (field.scope))][field.name];
    } else if (isNullOrUndefined(field.scope)) {
        delete flags[field.name];
    }
    this.flags = assign({}, flags);
};
Validator.prototype.extend = function extend (name, validator, options) {
        if ( options === void 0 ) options = {};

    Validator.extend(name, validator, options);
};
Validator.prototype.reset = function reset (matcher) {
    return new Promise((function ($return, $error) {
        return this._vm.$nextTick().then((function ($await_1) {
            try {
                return this._vm.$nextTick().then((function ($await_2) {
                        var this$1 = this;

                    try {
                        this.fields.filter(matcher).forEach(function (field) {
                            field.reset();
                            this$1.errors.remove(field.name, field.scope, field.id);
                        });
                        return $return();
                    } catch ($boundEx) {
                        return $error($boundEx);
                    }
                }).bind(this), $error);
            } catch ($boundEx) {
                return $error($boundEx);
            }
        }).bind(this), $error);
    }).bind(this));
};
Validator.prototype.update = function update (id, ref) {
        var scope = ref.scope;

    var field = this._resolveField(("#" + id));
    if (!field) 
        { return; }
    this.errors.update(id, {
        scope: scope
    });
    if (!isNullOrUndefined(field.scope) && this.flags[("$" + (field.scope))]) {
        delete this.flags[("$" + (field.scope))][field.name];
    } else if (isNullOrUndefined(field.scope)) {
        delete this.flags[field.name];
    }
    this._addFlag(field, scope);
};
Validator.prototype.remove = function remove (name) {
    Validator.remove(name);
};
Validator.prototype.validate = function validate (name, value, scope, silent) {
        if ( scope === void 0 ) scope = null;
        if ( silent === void 0 ) silent = false;

    var $args = arguments;
    return new Promise((function ($return, $error) {
        var matched, field, result;
        if (this.paused) 
            { return $return(Promise.resolve(true)); }
        if ($args.length === 0) {
            return $return(this.validateScopes());
        }
        if ($args.length === 1 && $args[0] === '*') {
            return $return(this.validateAll());
        }
        if ($args.length === 1 && typeof $args[0] === 'string' && /^(.+)\.\*$/.test($args[0])) {
            matched = $args[0].match(/^(.+)\.\*$/)[1];
            return $return(this.validateAll(matched));
        }
        field = this._resolveField(name, scope);
        if (!field) {
            return $return(this._handleFieldNotFound(name, scope));
        }
        if (!silent) 
            { field.flags.pending = true; }
        if ($args.length === 1) {
            value = field.value;
        }
        if (field.isDisabled) {
            return $return(true);
        }
        return this._validate(field, value).then((function ($await_3) {
            try {
                result = $await_3;
                if (!silent) {
                    this._handleValidationResults([result]);
                }
                return $return(result.valid);
            } catch ($boundEx) {
                return $error($boundEx);
            }
        }).bind(this), $error);
    }).bind(this));
};
Validator.prototype.pause = function pause () {
    this.paused = true;
    return this;
};
Validator.prototype.resume = function resume () {
    this.paused = false;
    return this;
};
Validator.prototype.validateAll = function validateAll (values, scope, silent) {
        if ( scope === void 0 ) scope = null;
        if ( silent === void 0 ) silent = false;

    return new Promise((function ($return, $error) {
            var this$1 = this;

        var results;
        var matcher, providedValues;
        if (this.paused) 
            { return $return(true); }
        matcher = null;
        providedValues = false;
        if (typeof values === 'string') {
            matcher = {
                scope: values
            };
        } else if (isObject(values)) {
            matcher = Object.keys(values).map(function (key) { return ({
                name: key,
                scope: scope
            }); });
            providedValues = true;
        } else if (Array.isArray(values)) {
            matcher = values.map(function (key) { return ({
                name: key,
                scope: scope
            }); });
        } else {
            matcher = {
                scope: scope
            };
        }
        return Promise.all(this.fields.filter(matcher).map(function (field) { return this$1._validate(field, providedValues ? values[field.name] : field.value); })).then((function ($await_4) {
            try {
                results = $await_4;
                if (!silent) {
                    this._handleValidationResults(results);
                }
                return $return(results.every(function (t) { return t.valid; }));
            } catch ($boundEx) {
                return $error($boundEx);
            }
        }).bind(this), $error);
    }).bind(this));
};
Validator.prototype.validateScopes = function validateScopes (silent) {
        if ( silent === void 0 ) silent = false;

    return new Promise((function ($return, $error) {
            var this$1 = this;

        var results;
        if (this.paused) 
            { return $return(true); }
        return Promise.all(this.fields.map(function (field) { return this$1._validate(field, field.value); })).then((function ($await_5) {
            try {
                results = $await_5;
                if (!silent) {
                    this._handleValidationResults(results);
                }
                return $return(results.every(function (t) { return t.valid; }));
            } catch ($boundEx) {
                return $error($boundEx);
            }
        }).bind(this), $error);
    }).bind(this));
};
Validator.prototype.destroy = function destroy () {
    this._vm.$off('localeChanged', this._localeListener);
};
Validator.prototype._createFields = function _createFields (validations) {
        var this$1 = this;

    if (!validations) 
        { return; }
    Object.keys(validations).forEach(function (field) {
        var options = assign({}, {
            name: field,
            rules: validations[field]
        });
        this$1.attach(options);
    });
};
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
    var format = null;
    if (validations.date_format && Array.isArray(validations.date_format)) {
        format = validations.date_format[0];
    }
    return format || this.dictionary.getDateFormat(this.locale);
};
Validator.prototype._isADateRule = function _isADateRule (rule) {
    return !(!(~['after','before','date_between','date_format'].indexOf(rule)));
};
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
        if ( data === void 0 ) data = {};
        if ( targetName === void 0 ) targetName = null;

    var name = this._getFieldDisplayName(field);
    var params = this._getLocalizedParams(rule, targetName);
    return this.dictionary.getFieldMessage(this.locale, field.name, rule.name, [name,
        params,data]);
};
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
        if ( targetName === void 0 ) targetName = null;

    if (~TARGET_RULES.indexOf(rule.name) && rule.params && rule.params[0]) {
        var localizedName = targetName || this.dictionary.getAttribute(this.locale, rule.params[0], rule.params[0]);
        return [localizedName].concat(rule.params.slice(1));
    }
    return rule.params;
};
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
    return field.alias || this.dictionary.getAttribute(this.locale, field.name, field.name);
};
Validator.prototype._addFlag = function _addFlag (field, scope) {
        var obj, obj$1, obj$2;

        if ( scope === void 0 ) scope = null;
    if (isNullOrUndefined(scope)) {
        this.flags = assign({}, this.flags, ( obj = {}, obj[("" + (field.name))] = field.flags, obj ));
        return;
    }
    var scopeObj = assign({}, this.flags[("$" + scope)] || {}, ( obj$1 = {}, obj$1[("" + (field.name))] = field.flags, obj$1 ));
    this.flags = assign({}, this.flags, ( obj$2 = {}, obj$2[("$" + scope)] = scopeObj, obj$2 ));
};
Validator.prototype._test = function _test (field, value, rule) {
        var this$1 = this;

    var validator = RULES[rule.name];
    var params = Array.isArray(rule.params) ? toArray(rule.params) : [];
    var targetName = null;
    if (!validator || typeof validator !== 'function') {
        throw createError(("No such validator '" + (rule.name) + "' exists."));
    }
    if (TARGET_RULES.indexOf(rule.name) !== -1) {
        var target = find(field.dependencies, function (d) { return d.name === rule.name; });
        if (target) {
            targetName = target.field.alias;
            params = [target.field.value].concat(params.slice(1));
        }
    } else if (rule.name === 'required' && field.rejectsFalse) {
        params = params.length ? params : [true];
    }
    if (this._isADateRule(rule.name)) {
        var dateFormat = this._getDateFormat(field.rules);
        if (rule.name !== 'date_format') {
            params.push(dateFormat);
        }
    }
    var result = validator(value, params);
    if (isCallable(result.then)) {
        return result.then(function (values) {
            var allValid = true;
            var data = {};
            if (Array.isArray(values)) {
                allValid = values.every(function (t) { return isObject(t) ? t.valid : t; });
            } else {
                allValid = isObject(values) ? values.valid : values;
                data = values.data;
            }
            return {
                valid: allValid,
                errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
            };
        });
    }
    if (!isObject(result)) {
        result = {
            valid: result,
            data: {}
        };
    }
    return {
        valid: result.valid,
        errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
    };
};
Validator._merge = function _merge (name, validator) {
    if (isCallable(validator)) {
        RULES[name] = validator;
        return;
    }
    RULES[name] = validator.validate;
    if (validator.getMessage) {
        Validator.dictionary.setMessage(this.locale, name, validator.getMessage);
    }
};
Validator._guardExtend = function _guardExtend (name, validator) {
    if (isCallable(validator)) {
        return;
    }
    if (!isCallable(validator.validate)) {
        throw createError(("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method."));
    }
};
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
        var this$1 = this;

    return {
        id: field.id,
        field: field.name,
        msg: this._formatErrorMessage(field, rule, data, targetName),
        rule: rule.name,
        scope: field.scope,
        regenerate: function () { return this$1._formatErrorMessage(field, rule, data, targetName); }
    };
};
Validator.prototype._resolveField = function _resolveField (name, scope) {
    if (!isNullOrUndefined(scope)) {
        return this.fields.find({
            name: name,
            scope: scope
        });
    }
    if (name[0] === '#') {
        return this.fields.find({
            id: name.slice(1)
        });
    }
    if (name.indexOf('.') > -1) {
        var ref = name.split('.');
            var fieldScope = ref[0];
            var fieldName = ref.slice(1);
        var field = this.fields.find({
            name: fieldName.join('.'),
            scope: fieldScope
        });
        if (field) {
            return field;
        }
    }
    return this.fields.find({
        name: name,
        scope: null
    });
};
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
    if (!this.strict) 
        { return true; }
    var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);
    throw createError(("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first."));
};
Validator.prototype._handleValidationResults = function _handleValidationResults (results) {
    var matchers = results.map(function (result) { return ({
        id: result.id
    }); });
    this.errors.removeById(matchers.map(function (m) { return m.id; }));
    var allErrors = results.reduce(function (prev, curr) {
        prev.push.apply(prev, curr.errors);
        return prev;
    }, []);
    this.errors.add(allErrors);
    this.fields.filter(matchers).forEach(function (field) {
        var result = find(results, function (r) { return r.id === field.id; });
        field.setFlags({
            pending: false,
            valid: result.valid,
            validated: true
        });
    });
};
Validator.prototype._validate = function _validate (field, value) {
    return new Promise((function ($return, $error) {
            var this$1 = this;

        var promises, errors;
        var isExitEarly;
        if (!field.isRequired && (isNullOrUndefined(value) || value === '')) {
            return $return({
                valid: true,
                id: field.id,
                errors: []
            });
        }
        promises = [];
        errors = [];
        isExitEarly = false;
        Object.keys(field.rules).some(function (rule) {
            var result = this$1._test(field, value, {
                name: rule,
                params: field.rules[rule]
            });
            if (isCallable(result.then)) {
                promises.push(result);
            } else if (this$1.fastExit && !result.valid) {
                errors.push.apply(errors, result.errors);
                isExitEarly = true;
            } else {
                promises.push(new Promise(function (resolve) { return resolve(result); }));
            }
            return isExitEarly;
        });
        if (isExitEarly) {
            return $return({
                valid: false,
                errors: errors,
                id: field.id
            });
        }
        return Promise.all(promises).then((function ($await_6) {
            try {
                return $return($await_6.reduce(function (prev, v) {
                        var ref;

                    if (!v.valid) {
                        (ref = prev.errors).push.apply(ref, v.errors);
                    }
                    prev.valid = prev.valid && v.valid;
                    return prev;
                }, {
                    valid: true,
                    errors: errors,
                    id: field.id
                }));
            } catch ($boundEx) {
                return $error($boundEx);
            }
        }).bind(this), $error);
    }).bind(this));
};

Object.defineProperties( Validator.prototype, prototypeAccessors$4 );
Object.defineProperties( Validator, staticAccessors$1 );

var requestsValidator = function (injections) {
    if (isObject(injections) && injections.$validator) {
        return true;
    }
    return false;
};
var createValidator = function (vm, options) { return new Validator(null, {
    vm: vm,
    fastExit: options.fastExit
}); };
var mixin = {
    provide: function provide() {
        if (this.$validator && !isBuiltInComponent(this.$vnode)) {
            return {
                $validator: this.$validator
            };
        }
        return {};
    },
    beforeCreate: function beforeCreate() {
        if (isBuiltInComponent(this.$vnode)) {
            return;
        }
        if (!this.$parent) {
            Config.merge(this.$options.$_veeValidate || {});
        }
        var options = Config.resolve(this);
        var Vue = this.$options._base;
        if (this.$options.$validates) {
            warn('The ctor $validates option has been deprecated please set the $_veeValidate.validator option to "new" instead');
            this.$validator = createValidator(this, options);
        }
        if (!this.$parent || this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator)) {
            this.$validator = createValidator(this, options);
        }
        var requested = requestsValidator(this.$options.inject);
        if (!this.$validator && options.inject && !requested) {
            this.$validator = createValidator(this, options);
        }
        if (!requested && !this.$validator) {
            return;
        }
        if (!requested && this.$validator) {
            Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
            Vue.util.defineReactive(this.$validator, 'flags', this.$validator.flags);
        }
        if (!this.$options.computed) {
            this.$options.computed = {};
        }
        this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter() {
            return this.$validator.errors;
        };
        this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter() {
            return this.$validator.flags;
        };
    },
    beforeDestroy: function beforeDestroy() {
        if (isBuiltInComponent(this.$vnode)) 
            { return; }
        if (this.$validator && this.$validator.ownerId === this._uid) {
            this.$validator.pause();
            this.$validator.destroy();
        }
    }
}

var findField = function (el, context) {
    if (!context || !context.$validator) {
        return null;
    }
    return context.$validator.fields.find({
        id: getDataAttribute(el, 'id')
    });
};
var directive = {
    bind: function bind(el, binding, vnode) {
        var validator = vnode.context.$validator;
        if (!validator) {
            warn("No validator instance is present on vm, did you forget to inject '$validator'?");
            return;
        }
        var fieldOptions = Generator.generate(el, binding, vnode);
        validator.attach(fieldOptions);
    },
    inserted: function (el, binding, vnode) {
        var field = findField(el, vnode.context);
        var scope = Generator.resolveScope(el, binding, vnode);
        if (!field || scope === field.scope) 
            { return; }
        field.update({
            scope: scope
        });
        field.updated = false;
    },
    update: function (el, binding, vnode) {
        var field = findField(el, vnode.context);
        if (!field || field.updated && isEqual(binding.value, binding.oldValue)) 
            { return; }
        var scope = Generator.resolveScope(el, binding, vnode);
        var rules = Generator.resolveRules(el, binding);
        field.update({
            scope: scope,
            rules: rules
        });
    },
    unbind: function unbind(el, binding, ref) {
        var context = ref.context;

        var field = findField(el, context);
        if (!field) 
            { return; }
        context.$validator.detach(field);
    }
}

var Vue;
function install(_Vue, options) {
    if ( options === void 0 ) options = {};

    if (Vue && _Vue === Vue) {
        if (false) {
            warn('already installed, Vue.use(VeeValidate) should only be called once.');
        }
        return;
    }
    detectPassiveSupport();
    Vue = _Vue;
    Config.register('vm', new Vue());
    Config.merge(options);
    var ref = Config.current;
    var dictionary = ref.dictionary;
    var i18n = ref.i18n;
    if (dictionary) {
        Validator.localize(dictionary);
    }
    if (i18n && i18n._vm && isCallable(i18n._vm.$watch)) {
        i18n._vm.$watch('locale', function () {
            Validator.regenerate();
        });
    }
    if (!i18n && options.locale) {
        Validator.localize(options.locale);
    }
    Validator.setStrictMode(Config.current.strict);
    Vue.mixin(mixin);
    Vue.directive('validate', directive);
}

var formatFileSize = function (size) {
    var units = ['Byte','KB','MB','GB','TB','PB','EB','ZB','YB'];
    var threshold = 1024;
    size = Number(size) * threshold;
    var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
    return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};
var isDefinedGlobally = function () { return typeof VeeValidate !== 'undefined'; };

var obj;
var messages = {
    _default: function (field) { return ("The " + field + " value is not valid."); },
    after: function (field, ref) {
        var target = ref[0];
        var inclusion = ref[1];

        return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target + ".");
},
    alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores."); },
    alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters."); },
    alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces."); },
    alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters."); },
    before: function (field, ref) {
        var target = ref[0];
        var inclusion = ref[1];

        return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target + ".");
},
    between: function (field, ref) {
        var min = ref[0];
        var max = ref[1];

        return ("The " + field + " field must be between " + min + " and " + max + ".");
},
    confirmed: function (field) { return ("The " + field + " confirmation does not match."); },
    credit_card: function (field) { return ("The " + field + " field is invalid."); },
    date_between: function (field, ref) {
        var min = ref[0];
        var max = ref[1];

        return ("The " + field + " must be between " + min + " and " + max + ".");
},
    date_format: function (field, ref) {
        var format = ref[0];

        return ("The " + field + " must be in the format " + format + ".");
},
    decimal: function (field, ref) {
        if ( ref === void 0 ) ref = [];
        var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

        return ("The " + field + " field must be numeric and may contain " + (!decimals || decimals === '*' ? '' : decimals) + " decimal points.");
},
    digits: function (field, ref) {
        var length = ref[0];

        return ("The " + field + " field must be numeric and exactly contain " + length + " digits.");
},
    dimensions: function (field, ref) {
        var width = ref[0];
        var height = ref[1];

        return ("The " + field + " field must be " + width + " pixels by " + height + " pixels.");
},
    email: function (field) { return ("The " + field + " field must be a valid email."); },
    ext: function (field) { return ("The " + field + " field must be a valid file."); },
    image: function (field) { return ("The " + field + " field must be an image."); },
    in: function (field) { return ("The " + field + " field must be a valid value."); },
    integer: function (field) { return ("The " + field + " field must be an integer."); },
    ip: function (field) { return ("The " + field + " field must be a valid ip address."); },
    length: function (field, ref) {
        var length = ref[0];
        var max = ref[1];

        if (max) {
            return ("The " + field + " length must be between " + length + " and " + max + ".");
        }
        return ("The " + field + " length must be " + length + ".");
    },
    max: function (field, ref) {
        var length = ref[0];

        return ("The " + field + " field may not be greater than " + length + " characters.");
},
    max_value: function (field, ref) {
        var max = ref[0];

        return ("The " + field + " field must be " + max + " or less.");
},
    mimes: function (field) { return ("The " + field + " field must have a valid file type."); },
    min: function (field, ref) {
        var length = ref[0];

        return ("The " + field + " field must be at least " + length + " characters.");
},
    min_value: function (field, ref) {
        var min = ref[0];

        return ("The " + field + " field must be " + min + " or more.");
},
    not_in: function (field) { return ("The " + field + " field must be a valid value."); },
    numeric: function (field) { return ("The " + field + " field may only contain numeric characters."); },
    regex: function (field) { return ("The " + field + " field format is invalid."); },
    required: function (field) { return ("The " + field + " field is required."); },
    size: function (field, ref) {
        var size = ref[0];

        return ("The " + field + " size must be less than " + (formatFileSize(size)) + ".");
},
    url: function (field) { return ("The " + field + " field is not a valid URL."); }
};
var locale = {
    name: 'en',
    messages: messages,
    attributes: {}
};
if (isDefinedGlobally()) {
    VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
}

function use(plugin, options) {
    if ( options === void 0 ) options = {};

    if (!isCallable(plugin)) {
        return warn('The plugin must be a callable function');
    }
    plugin({
        Validator: Validator,
        ErrorBag: ErrorBag,
        Rules: Validator.rules
    }, options);
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
    dateTimeDelimeter: /[T ]/,
    plainTime: /:/,
    YY: /^(\d{2})$/,
    YYY: [/^([+-]\d{2})$/,/^([+-]\d{3})$/,/^([+-]\d{4})$/],
    YYYY: /^(\d{4})/,
    YYYYY: [/^([+-]\d{4})/,/^([+-]\d{5})/,/^([+-]\d{6})/],
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-])(\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function toDate(argument, dirtyOptions) {
    if (arguments.length < 1) {
        throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    }
    if (argument === null) {
        return new Date(NaN);
    }
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
        throw new RangeError('additionalDigits must be 0, 1 or 2');
    }
    if (argument instanceof Date) {
        return new Date(argument.getTime());
    } else if (typeof argument !== 'string') {
        return new Date(argument);
    }
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate(restDateString, year);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
        }
        if (dateStrings.timezone) {
            offset = parseTimezone(dateStrings.timezone);
        } else {
            offset = new Date(timestamp + time).getTimezoneOffset();
            offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
        }
        return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE);
    } else {
        return new Date(argument);
    }
}

function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimeter);
    var timeString;
    if (patterns.plainTime.test(array[0])) {
        dateStrings.date = null;
        timeString = array[0];
    } else {
        dateStrings.date = array[0];
        timeString = array[1];
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else {
            dateStrings.time = timeString;
        }
    }
    return dateStrings;
}

function parseYear(dateString, additionalDigits) {
    var patternYYY = patterns.YYY[additionalDigits];
    var patternYYYYY = patterns.YYYYY[additionalDigits];
    var token;
    token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    return {
        year: null
    };
}

function parseDate(dateString, year) {
    if (year === null) {
        return null;
    }
    var token;
    var date;
    var month;
    var week;
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        date.setUTCFullYear(year, month);
        return date;
    }
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        return dayOfISOYear(year, week);
    }
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        return dayOfISOYear(year, week, dayOfWeek);
    }
    return null;
}

function parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    return null;
}

function parseTimezone(timezoneString) {
    var token;
    var absoluteOffset;
    token = patterns.timezoneZ.exec(timezoneString);
    if (token) {
        return 0;
    }
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        absoluteOffset = parseInt(token[2], 10) * 60;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    return 0;
}

function dayOfISOYear(isoYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

function addMilliseconds(dirtyDate, dirtyAmount, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
    var amount = Number(dirtyAmount);
    return new Date(timestamp + amount);
}

function cloneObject(dirtyObject) {
    dirtyObject = dirtyObject || {};
    var object = {};
    for (var property in dirtyObject) {
        if (dirtyObject.hasOwnProperty(property)) {
            object[property] = dirtyObject[property];
        }
    }
    return object;
}

var MILLISECONDS_IN_MINUTE$2 = 60000;
function addMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var amount = Number(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2, dirtyOptions);
}

function isValid(dirtyDate, dirtyOptions) {
    if (arguments.length < 1) {
        throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    }
    var date = toDate(dirtyDate, dirtyOptions);
    return !isNaN(date);
}

var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof formatDistanceLocale[token] === 'string') {
        result = formatDistanceLocale[token];
    } else if (count === 1) {
        result = formatDistanceLocale[token].one;
    } else {
        result = formatDistanceLocale[token].other.replace('{{count}}', count);
    }
    if (options.addSuffix) {
        if (options.comparison > 0) {
            return 'in ' + result;
        } else {
            return result + ' ago';
        }
    }
    return result;
}

var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;
function buildShortLongFormat(format) {
    return format.replace(tokensToBeShortedPattern, function (token) {
        return token.slice(1);
    });
}

function buildFormatLongFn(obj) {
    var formatLongLocale = {
        LTS: obj.LTS,
        LT: obj.LT,
        L: obj.L,
        LL: obj.LL,
        LLL: obj.LLL,
        LLLL: obj.LLLL,
        l: obj.l || buildShortLongFormat(obj.L),
        ll: obj.ll || buildShortLongFormat(obj.LL),
        lll: obj.lll || buildShortLongFormat(obj.LLL),
        llll: obj.llll || buildShortLongFormat(obj.LLLL)
    };
    return function (token) {
        return formatLongLocale[token];
    };
}

var formatLong = buildFormatLongFn({
    LT: 'h:mm aa',
    LTS: 'h:mm:ss aa',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D YYYY',
    LLL: 'MMMM D YYYY h:mm aa',
    LLLL: 'dddd, MMMM D YYYY h:mm aa'
});

var formatRelativeLocale = {
    lastWeek: '[last] dddd [at] LT',
    yesterday: '[yesterday at] LT',
    today: '[today at] LT',
    tomorrow: '[tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    other: 'L'
};
function formatRelative(token, date, baseDate, options) {
    return formatRelativeLocale[token];
}

function buildLocalizeFn(values, defaultType, indexCallback) {
    return function (dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var type = options.type ? String(options.type) : defaultType;
        var valuesArray = values[type] || values[defaultType];
        var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
        return valuesArray[index];
    };
}

function buildLocalizeArrayFn(values, defaultType) {
    return function (dirtyOptions) {
        var options = dirtyOptions || {};
        var type = options.type ? String(options.type) : defaultType;
        return values[type] || values[defaultType];
    };
}

var weekdayValues = {
    narrow: ['Su','Mo','Tu','We','Th','Fr','Sa'],
    short: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
    long: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
};
var monthValues = {
    short: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    long: ['January','February','March','April','May','June','July','August','September',
        'October','November','December']
};
var timeOfDayValues = {
    uppercase: ['AM','PM'],
    lowercase: ['am','pm'],
    long: ['a.m.','p.m.']
};
function ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
    }
    return number + 'th';
}

var localize = {
    ordinalNumber: ordinalNumber,
    weekday: buildLocalizeFn(weekdayValues, 'long'),
    weekdays: buildLocalizeArrayFn(weekdayValues, 'long'),
    month: buildLocalizeFn(monthValues, 'long'),
    months: buildLocalizeArrayFn(monthValues, 'long'),
    timeOfDay: buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
        return hours / 12 >= 1 ? 1 : 0;
    }),
    timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'long')
};

function buildMatchFn(patterns, defaultType) {
    return function (dirtyString, dirtyOptions) {
        var options = dirtyOptions || {};
        var type = options.type ? String(options.type) : defaultType;
        var pattern = patterns[type] || patterns[defaultType];
        var string = String(dirtyString);
        return string.match(pattern);
    };
}

function buildParseFn(patterns, defaultType) {
    return function (matchResult, dirtyOptions) {
        var options = dirtyOptions || {};
        var type = options.type ? String(options.type) : defaultType;
        var patternsArray = patterns[type] || patterns[defaultType];
        var string = matchResult[1];
        return patternsArray.findIndex(function (pattern) {
            return pattern.test(string);
        });
    };
}

function buildMatchPatternFn(pattern) {
    return function (dirtyString) {
        var string = String(dirtyString);
        return string.match(pattern);
    };
}

function parseDecimal(matchResult) {
    return parseInt(matchResult[1], 10);
}

var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;
var matchWeekdaysPatterns = {
    narrow: /^(su|mo|tu|we|th|fr|sa)/i,
    short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseWeekdayPatterns = {
    any: [/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]
};
var matchMonthsPatterns = {
    short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    any: [/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,
        /^n/i,/^d/i]
};
var matchTimesOfDayPatterns = {
    short: /^(am|pm)/i,
    long: /^([ap]\.?\s?m\.?)/i
};
var parseTimeOfDayPatterns = {
    any: [/^a/i,/^p/i]
};
var match = {
    ordinalNumbers: buildMatchPatternFn(matchOrdinalNumbersPattern),
    ordinalNumber: parseDecimal,
    weekdays: buildMatchFn(matchWeekdaysPatterns, 'long'),
    weekday: buildParseFn(parseWeekdayPatterns, 'any'),
    months: buildMatchFn(matchMonthsPatterns, 'long'),
    month: buildParseFn(parseMonthPatterns, 'any'),
    timesOfDay: buildMatchFn(matchTimesOfDayPatterns, 'long'),
    timeOfDay: buildParseFn(parseTimeOfDayPatterns, 'any')
};

var locale$1 = {
    formatDistance: formatDistance,
    formatLong: formatLong,
    formatRelative: formatRelative,
    localize: localize,
    match: match,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};

var MILLISECONDS_IN_DAY$1 = 86400000;
function getUTCDayOfYear(dirtyDate, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}

function startOfUTCISOWeek(dirtyDate, dirtyOptions) {
    var weekStartsOn = 1;
    var date = toDate(dirtyDate, dirtyOptions);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

function getUTCISOWeekYear(dirtyDate, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
    } else {
        return year - 1;
    }
}

function startOfUTCISOWeekYear(dirtyDate, dirtyOptions) {
    var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
    return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
function getUTCISOWeek(dirtyDate, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();
    return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

var formatters = {
    'M': function (date) {
        return date.getUTCMonth() + 1;
    },
    'Mo': function (date, options) {
        var month = date.getUTCMonth() + 1;
        return options.locale.localize.ordinalNumber(month, {
            unit: 'month'
        });
    },
    'MM': function (date) {
        return addLeadingZeros(date.getUTCMonth() + 1, 2);
    },
    'MMM': function (date, options) {
        return options.locale.localize.month(date.getUTCMonth(), {
            type: 'short'
        });
    },
    'MMMM': function (date, options) {
        return options.locale.localize.month(date.getUTCMonth(), {
            type: 'long'
        });
    },
    'Q': function (date) {
        return Math.ceil((date.getUTCMonth() + 1) / 3);
    },
    'Qo': function (date, options) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        return options.locale.localize.ordinalNumber(quarter, {
            unit: 'quarter'
        });
    },
    'D': function (date) {
        return date.getUTCDate();
    },
    'Do': function (date, options) {
        return options.locale.localize.ordinalNumber(date.getUTCDate(), {
            unit: 'dayOfMonth'
        });
    },
    'DD': function (date) {
        return addLeadingZeros(date.getUTCDate(), 2);
    },
    'DDD': function (date) {
        return getUTCDayOfYear(date);
    },
    'DDDo': function (date, options) {
        return options.locale.localize.ordinalNumber(getUTCDayOfYear(date), {
            unit: 'dayOfYear'
        });
    },
    'DDDD': function (date) {
        return addLeadingZeros(getUTCDayOfYear(date), 3);
    },
    'dd': function (date, options) {
        return options.locale.localize.weekday(date.getUTCDay(), {
            type: 'narrow'
        });
    },
    'ddd': function (date, options) {
        return options.locale.localize.weekday(date.getUTCDay(), {
            type: 'short'
        });
    },
    'dddd': function (date, options) {
        return options.locale.localize.weekday(date.getUTCDay(), {
            type: 'long'
        });
    },
    'd': function (date) {
        return date.getUTCDay();
    },
    'do': function (date, options) {
        return options.locale.localize.ordinalNumber(date.getUTCDay(), {
            unit: 'dayOfWeek'
        });
    },
    'E': function (date) {
        return date.getUTCDay() || 7;
    },
    'W': function (date) {
        return getUTCISOWeek(date);
    },
    'Wo': function (date, options) {
        return options.locale.localize.ordinalNumber(getUTCISOWeek(date), {
            unit: 'isoWeek'
        });
    },
    'WW': function (date) {
        return addLeadingZeros(getUTCISOWeek(date), 2);
    },
    'YY': function (date) {
        return addLeadingZeros(date.getUTCFullYear(), 4).substr(2);
    },
    'YYYY': function (date) {
        return addLeadingZeros(date.getUTCFullYear(), 4);
    },
    'GG': function (date) {
        return String(getUTCISOWeekYear(date)).substr(2);
    },
    'GGGG': function (date) {
        return getUTCISOWeekYear(date);
    },
    'H': function (date) {
        return date.getUTCHours();
    },
    'HH': function (date) {
        return addLeadingZeros(date.getUTCHours(), 2);
    },
    'h': function (date) {
        var hours = date.getUTCHours();
        if (hours === 0) {
            return 12;
        } else if (hours > 12) {
            return hours % 12;
        } else {
            return hours;
        }
    },
    'hh': function (date) {
        return addLeadingZeros(formatters['h'](date), 2);
    },
    'm': function (date) {
        return date.getUTCMinutes();
    },
    'mm': function (date) {
        return addLeadingZeros(date.getUTCMinutes(), 2);
    },
    's': function (date) {
        return date.getUTCSeconds();
    },
    'ss': function (date) {
        return addLeadingZeros(date.getUTCSeconds(), 2);
    },
    'S': function (date) {
        return Math.floor(date.getUTCMilliseconds() / 100);
    },
    'SS': function (date) {
        return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2);
    },
    'SSS': function (date) {
        return addLeadingZeros(date.getUTCMilliseconds(), 3);
    },
    'Z': function (date, options) {
        var originalDate = options._originalDate || date;
        return formatTimezone(originalDate.getTimezoneOffset(), ':');
    },
    'ZZ': function (date, options) {
        var originalDate = options._originalDate || date;
        return formatTimezone(originalDate.getTimezoneOffset());
    },
    'X': function (date, options) {
        var originalDate = options._originalDate || date;
        return Math.floor(originalDate.getTime() / 1000);
    },
    'x': function (date, options) {
        var originalDate = options._originalDate || date;
        return originalDate.getTime();
    },
    'A': function (date, options) {
        return options.locale.localize.timeOfDay(date.getUTCHours(), {
            type: 'uppercase'
        });
    },
    'a': function (date, options) {
        return options.locale.localize.timeOfDay(date.getUTCHours(), {
            type: 'lowercase'
        });
    },
    'aa': function (date, options) {
        return options.locale.localize.timeOfDay(date.getUTCHours(), {
            type: 'long'
        });
    }
};
function formatTimezone(offset, delimeter) {
    delimeter = delimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2);
}

function addLeadingZeros(number, targetLength) {
    var output = Math.abs(number).toString();
    while (output.length < targetLength) {
        output = '0' + output;
    }
    return output;
}

function addUTCMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var amount = Number(dirtyAmount);
    date.setUTCMinutes(date.getUTCMinutes() + amount);
    return date;
}

var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || locale$1;
    if (!locale.localize) {
        throw new RangeError('locale must contain localize property');
    }
    if (!locale.formatLong) {
        throw new RangeError('locale must contain formatLong property');
    }
    var localeFormatters = locale.formatters || {};
    var formattingTokensRegExp = locale.formattingTokensRegExp || defaultFormattingTokensRegExp;
    var formatLong = locale.formatLong;
    var originalDate = toDate(dirtyDate, options);
    if (!isValid(originalDate, options)) {
        return 'Invalid Date';
    }
    var timezoneOffset = originalDate.getTimezoneOffset();
    var utcDate = addUTCMinutes(originalDate, -timezoneOffset, options);
    var formatterOptions = cloneObject(options);
    formatterOptions.locale = locale;
    formatterOptions.formatters = formatters;
    formatterOptions._originalDate = originalDate;
    var result = formatStr.replace(longFormattingTokensRegExp, function (substring) {
        if (substring[0] === '[') {
            return substring;
        }
        if (substring[0] === '\\') {
            return cleanEscapedString(substring);
        }
        return formatLong(substring);
    }).replace(formattingTokensRegExp, function (substring) {
        var formatter = localeFormatters[substring] || formatters[substring];
        if (formatter) {
            return formatter(utcDate, formatterOptions);
        } else {
            return cleanEscapedString(substring);
        }
    });
    return result;
}

function cleanEscapedString(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function subMinutes(dirtyDate, dirtyAmount, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var amount = Number(dirtyAmount);
    return addMinutes(dirtyDate, -amount, dirtyOptions);
}

function isAfter(dirtyDate, dirtyDateToCompare, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var date = toDate(dirtyDate, dirtyOptions);
    var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
    return date.getTime() > dateToCompare.getTime();
}

function isBefore(dirtyDate, dirtyDateToCompare, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var date = toDate(dirtyDate, dirtyOptions);
    var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
    return date.getTime() < dateToCompare.getTime();
}

function isEqual$1(dirtyLeftDate, dirtyRightDate, dirtyOptions) {
    if (arguments.length < 2) {
        throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
    }
    var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
    var dateRight = toDate(dirtyRightDate, dirtyOptions);
    return dateLeft.getTime() === dateRight.getTime();
}

var patterns$1 = {
    'M': /^(1[0-2]|0?\d)/,
    'D': /^(3[0-1]|[0-2]?\d)/,
    'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    'W': /^(5[0-3]|[0-4]?\d)/,
    'YYYY': /^(\d{1,4})/,
    'H': /^(2[0-3]|[0-1]?\d)/,
    'm': /^([0-5]?\d)/,
    'Z': /^([+-])(\d{2}):(\d{2})/,
    'ZZ': /^([+-])(\d{2})(\d{2})/,
    singleDigit: /^(\d)/,
    twoDigits: /^(\d{2})/,
    threeDigits: /^(\d{3})/,
    fourDigits: /^(\d{4})/,
    anyDigits: /^(\d+)/
};
function parseDecimal$1(matchResult) {
    return parseInt(matchResult[1], 10);
}

var parsers = {
    'YY': {
        unit: 'twoDigitYear',
        match: patterns$1.twoDigits,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult);
        }
    },
    'YYYY': {
        unit: 'year',
        match: patterns$1.YYYY,
        parse: parseDecimal$1
    },
    'GG': {
        unit: 'isoYear',
        match: patterns$1.twoDigits,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) + 1900;
        }
    },
    'GGGG': {
        unit: 'isoYear',
        match: patterns$1.YYYY,
        parse: parseDecimal$1
    },
    'Q': {
        unit: 'quarter',
        match: patterns$1.singleDigit,
        parse: parseDecimal$1
    },
    'Qo': {
        unit: 'quarter',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'quarter'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'quarter'
            });
        }
    },
    'M': {
        unit: 'month',
        match: patterns$1.M,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) - 1;
        }
    },
    'Mo': {
        unit: 'month',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'month'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'month'
            }) - 1;
        }
    },
    'MM': {
        unit: 'month',
        match: patterns$1.twoDigits,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) - 1;
        }
    },
    'MMM': {
        unit: 'month',
        match: function (string, options) {
            return options.locale.match.months(string, {
                type: 'short'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.month(matchResult, {
                type: 'short'
            });
        }
    },
    'MMMM': {
        unit: 'month',
        match: function (string, options) {
            return options.locale.match.months(string, {
                type: 'long'
            }) || options.locale.match.months(string, {
                type: 'short'
            });
        },
        parse: function (matchResult, options) {
            var parseResult = options.locale.match.month(matchResult, {
                type: 'long'
            });
            if (parseResult == null) {
                parseResult = options.locale.match.month(matchResult, {
                    type: 'short'
                });
            }
            return parseResult;
        }
    },
    'W': {
        unit: 'isoWeek',
        match: patterns$1.W,
        parse: parseDecimal$1
    },
    'Wo': {
        unit: 'isoWeek',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'isoWeek'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'isoWeek'
            });
        }
    },
    'WW': {
        unit: 'isoWeek',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    'd': {
        unit: 'dayOfWeek',
        match: patterns$1.singleDigit,
        parse: parseDecimal$1
    },
    'do': {
        unit: 'dayOfWeek',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'dayOfWeek'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'dayOfWeek'
            });
        }
    },
    'dd': {
        unit: 'dayOfWeek',
        match: function (string, options) {
            return options.locale.match.weekdays(string, {
                type: 'narrow'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.weekday(matchResult, {
                type: 'narrow'
            });
        }
    },
    'ddd': {
        unit: 'dayOfWeek',
        match: function (string, options) {
            return options.locale.match.weekdays(string, {
                type: 'short'
            }) || options.locale.match.weekdays(string, {
                type: 'narrow'
            });
        },
        parse: function (matchResult, options) {
            var parseResult = options.locale.match.weekday(matchResult, {
                type: 'short'
            });
            if (parseResult == null) {
                parseResult = options.locale.match.weekday(matchResult, {
                    type: 'narrow'
                });
            }
            return parseResult;
        }
    },
    'dddd': {
        unit: 'dayOfWeek',
        match: function (string, options) {
            return options.locale.match.weekdays(string, {
                type: 'long'
            }) || options.locale.match.weekdays(string, {
                type: 'short'
            }) || options.locale.match.weekdays(string, {
                type: 'narrow'
            });
        },
        parse: function (matchResult, options) {
            var parseResult = options.locale.match.weekday(matchResult, {
                type: 'long'
            });
            if (parseResult == null) {
                parseResult = options.locale.match.weekday(matchResult, {
                    type: 'short'
                });
                if (parseResult == null) {
                    parseResult = options.locale.match.weekday(matchResult, {
                        type: 'narrow'
                    });
                }
            }
            return parseResult;
        }
    },
    'E': {
        unit: 'dayOfISOWeek',
        match: patterns$1.singleDigit,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult);
        }
    },
    'D': {
        unit: 'dayOfMonth',
        match: patterns$1.D,
        parse: parseDecimal$1
    },
    'Do': {
        unit: 'dayOfMonth',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'dayOfMonth'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'dayOfMonth'
            });
        }
    },
    'DD': {
        unit: 'dayOfMonth',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    'DDD': {
        unit: 'dayOfYear',
        match: patterns$1.DDD,
        parse: parseDecimal$1
    },
    'DDDo': {
        unit: 'dayOfYear',
        match: function (string, options) {
            return options.locale.match.ordinalNumbers(string, {
                unit: 'dayOfYear'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.ordinalNumber(matchResult, {
                unit: 'dayOfYear'
            });
        }
    },
    'DDDD': {
        unit: 'dayOfYear',
        match: patterns$1.threeDigits,
        parse: parseDecimal$1
    },
    'A': {
        unit: 'timeOfDay',
        match: function (string, options) {
            return options.locale.match.timesOfDay(string, {
                type: 'short'
            });
        },
        parse: function (matchResult, options) {
            return options.locale.match.timeOfDay(matchResult, {
                type: 'short'
            });
        }
    },
    'aa': {
        unit: 'timeOfDay',
        match: function (string, options) {
            return options.locale.match.timesOfDay(string, {
                type: 'long'
            }) || options.locale.match.timesOfDay(string, {
                type: 'short'
            });
        },
        parse: function (matchResult, options) {
            var parseResult = options.locale.match.timeOfDay(matchResult, {
                type: 'long'
            });
            if (parseResult == null) {
                parseResult = options.locale.match.timeOfDay(matchResult, {
                    type: 'short'
                });
            }
            return parseResult;
        }
    },
    'H': {
        unit: 'hours',
        match: patterns$1.H,
        parse: parseDecimal$1
    },
    'HH': {
        unit: 'hours',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    'h': {
        unit: 'timeOfDayHours',
        match: patterns$1.M,
        parse: parseDecimal$1
    },
    'hh': {
        unit: 'timeOfDayHours',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    'm': {
        unit: 'minutes',
        match: patterns$1.m,
        parse: parseDecimal$1
    },
    'mm': {
        unit: 'minutes',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    's': {
        unit: 'seconds',
        match: patterns$1.m,
        parse: parseDecimal$1
    },
    'ss': {
        unit: 'seconds',
        match: patterns$1.twoDigits,
        parse: parseDecimal$1
    },
    'S': {
        unit: 'milliseconds',
        match: patterns$1.singleDigit,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) * 100;
        }
    },
    'SS': {
        unit: 'milliseconds',
        match: patterns$1.twoDigits,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) * 10;
        }
    },
    'SSS': {
        unit: 'milliseconds',
        match: patterns$1.threeDigits,
        parse: parseDecimal$1
    },
    'Z': {
        unit: 'timezone',
        match: patterns$1.Z,
        parse: function (matchResult) {
            var sign = matchResult[1];
            var hours = parseInt(matchResult[2], 10);
            var minutes = parseInt(matchResult[3], 10);
            var absoluteOffset = hours * 60 + minutes;
            return sign === '+' ? absoluteOffset : -absoluteOffset;
        }
    },
    'ZZ': {
        unit: 'timezone',
        match: patterns$1.ZZ,
        parse: function (matchResult) {
            var sign = matchResult[1];
            var hours = parseInt(matchResult[2], 10);
            var minutes = parseInt(matchResult[3], 10);
            var absoluteOffset = hours * 60 + minutes;
            return sign === '+' ? absoluteOffset : -absoluteOffset;
        }
    },
    'X': {
        unit: 'timestamp',
        match: patterns$1.anyDigits,
        parse: function (matchResult) {
            return parseDecimal$1(matchResult) * 1000;
        }
    },
    'x': {
        unit: 'timestamp',
        match: patterns$1.anyDigits,
        parse: parseDecimal$1
    }
};
parsers['a'] = parsers['A'];

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var date = toDate(dirtyDate, dirtyOptions);
    var day = Number(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

function setUTCISODay(dirtyDate, dirtyDay, dirtyOptions) {
    var day = Number(dirtyDay);
    if (day % 7 === 0) {
        day = day - 7;
    }
    var weekStartsOn = 1;
    var date = toDate(dirtyDate, dirtyOptions);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

function setUTCISOWeek(dirtyDate, dirtyISOWeek, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var isoWeek = Number(dirtyISOWeek);
    var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

var MILLISECONDS_IN_DAY$3 = 86400000;
function setUTCISOWeekYear(dirtyDate, dirtyISOYear, dirtyOptions) {
    var date = toDate(dirtyDate, dirtyOptions);
    var isoYear = Number(dirtyISOYear);
    var dateStartOfYear = startOfUTCISOWeekYear(date, dirtyOptions);
    var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY$3);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    date = startOfUTCISOWeekYear(fourthOfJanuary, dirtyOptions);
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

var MILLISECONDS_IN_MINUTE$6 = 60000;
function setTimeOfDay(hours, timeOfDay) {
    var isAM = timeOfDay === 0;
    if (isAM) {
        if (hours === 12) {
            return 0;
        }
    } else {
        if (hours !== 12) {
            return 12 + hours;
        }
    }
    return hours;
}

var units = {
    twoDigitYear: {
        priority: 10,
        set: function (dateValues, value) {
            var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
            var year = century * 100 + value;
            dateValues.date.setUTCFullYear(year, 0, 1);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    year: {
        priority: 10,
        set: function (dateValues, value) {
            dateValues.date.setUTCFullYear(value, 0, 1);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    isoYear: {
        priority: 10,
        set: function (dateValues, value, options) {
            dateValues.date = startOfUTCISOWeekYear(setUTCISOWeekYear(dateValues.date, value, options), options);
            return dateValues;
        }
    },
    quarter: {
        priority: 20,
        set: function (dateValues, value) {
            dateValues.date.setUTCMonth((value - 1) * 3, 1);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    month: {
        priority: 30,
        set: function (dateValues, value) {
            dateValues.date.setUTCMonth(value, 1);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    isoWeek: {
        priority: 40,
        set: function (dateValues, value, options) {
            dateValues.date = startOfUTCISOWeek(setUTCISOWeek(dateValues.date, value, options), options);
            return dateValues;
        }
    },
    dayOfWeek: {
        priority: 50,
        set: function (dateValues, value, options) {
            dateValues.date = setUTCDay(dateValues.date, value, options);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    dayOfISOWeek: {
        priority: 50,
        set: function (dateValues, value, options) {
            dateValues.date = setUTCISODay(dateValues.date, value, options);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    dayOfMonth: {
        priority: 50,
        set: function (dateValues, value) {
            dateValues.date.setUTCDate(value);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    dayOfYear: {
        priority: 50,
        set: function (dateValues, value) {
            dateValues.date.setUTCMonth(0, value);
            dateValues.date.setUTCHours(0, 0, 0, 0);
            return dateValues;
        }
    },
    timeOfDay: {
        priority: 60,
        set: function (dateValues, value, options) {
            dateValues.timeOfDay = value;
            return dateValues;
        }
    },
    hours: {
        priority: 70,
        set: function (dateValues, value, options) {
            dateValues.date.setUTCHours(value, 0, 0, 0);
            return dateValues;
        }
    },
    timeOfDayHours: {
        priority: 70,
        set: function (dateValues, value, options) {
            var timeOfDay = dateValues.timeOfDay;
            if (timeOfDay != null) {
                value = setTimeOfDay(value, timeOfDay);
            }
            dateValues.date.setUTCHours(value, 0, 0, 0);
            return dateValues;
        }
    },
    minutes: {
        priority: 80,
        set: function (dateValues, value) {
            dateValues.date.setUTCMinutes(value, 0, 0);
            return dateValues;
        }
    },
    seconds: {
        priority: 90,
        set: function (dateValues, value) {
            dateValues.date.setUTCSeconds(value, 0);
            return dateValues;
        }
    },
    milliseconds: {
        priority: 100,
        set: function (dateValues, value) {
            dateValues.date.setUTCMilliseconds(value);
            return dateValues;
        }
    },
    timezone: {
        priority: 110,
        set: function (dateValues, value) {
            dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE$6);
            return dateValues;
        }
    },
    timestamp: {
        priority: 120,
        set: function (dateValues, value) {
            dateValues.date = new Date(value);
            return dateValues;
        }
    }
};

var TIMEZONE_UNIT_PRIORITY = 110;
var MILLISECONDS_IN_MINUTE$7 = 60000;
var longFormattingTokensRegExp$1 = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
function parse(dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
    if (arguments.length < 3) {
        throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
    }
    var dateString = String(dirtyDateString);
    var options = dirtyOptions || {};
    var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var locale = options.locale || locale$1;
    var localeParsers = locale.parsers || {};
    var localeUnits = locale.units || {};
    if (!locale.match) {
        throw new RangeError('locale must contain match property');
    }
    if (!locale.formatLong) {
        throw new RangeError('locale must contain formatLong property');
    }
    var formatString = String(dirtyFormatString).replace(longFormattingTokensRegExp$1, function (substring) {
        if (substring[0] === '[') {
            return substring;
        }
        if (substring[0] === '\\') {
            return cleanEscapedString$1(substring);
        }
        return locale.formatLong(substring);
    });
    if (formatString === '') {
        if (dateString === '') {
            return toDate(dirtyBaseDate, options);
        } else {
            return new Date(NaN);
        }
    }
    var subFnOptions = cloneObject(options);
    subFnOptions.locale = locale;
    var tokens = formatString.match(locale.parsingTokensRegExp || defaultParsingTokensRegExp);
    var tokensLength = tokens.length;
    var setters = [{
        priority: TIMEZONE_UNIT_PRIORITY,
        set: dateToSystemTimezone,
        index: 0
    }];
    var i;
    for (i = 0; i < tokensLength; i++) {
        var token = tokens[i];
        var parser = localeParsers[token] || parsers[token];
        if (parser) {
            var matchResult;
            if (parser.match instanceof RegExp) {
                matchResult = parser.match.exec(dateString);
            } else {
                matchResult = parser.match(dateString, subFnOptions);
            }
            if (!matchResult) {
                return new Date(NaN);
            }
            var unitName = parser.unit;
            var unit = localeUnits[unitName] || units[unitName];
            setters.push({
                priority: unit.priority,
                set: unit.set,
                value: parser.parse(matchResult, subFnOptions),
                index: setters.length
            });
            var substring = matchResult[0];
            dateString = dateString.slice(substring.length);
        } else {
            var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
            if (dateString.indexOf(head) === 0) {
                dateString = dateString.slice(head.length);
            } else {
                return new Date(NaN);
            }
        }
    }
    var uniquePrioritySetters = setters.map(function (setter) {
        return setter.priority;
    }).sort(function (a, b) {
        return a - b;
    }).filter(function (priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function (priority) {
        return setters.filter(function (setter) {
            return setter.priority === priority;
        }).reverse();
    }).map(function (setterArray) {
        return setterArray[0];
    });
    var date = toDate(dirtyBaseDate, options);
    if (isNaN(date)) {
        return new Date(NaN);
    }
    var utcDate = subMinutes(date, date.getTimezoneOffset());
    var dateValues = {
        date: utcDate
    };
    var settersLength = uniquePrioritySetters.length;
    for (i = 0; i < settersLength; i++) {
        var setter = uniquePrioritySetters[i];
        dateValues = setter.set(dateValues, setter.value, subFnOptions);
    }
    return dateValues.date;
}

function dateToSystemTimezone(dateValues) {
    var date = dateValues.date;
    var time = date.getTime();
    var offset = date.getTimezoneOffset();
    offset = new Date(time + offset * MILLISECONDS_IN_MINUTE$7).getTimezoneOffset();
    dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE$7);
    return dateValues;
}

function cleanEscapedString$1(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function parseDate$1(date, format$$1) {
    if (typeof date !== 'string') {
        return isValid(date) ? date : null;
    }
    var parsed = parse(date, format$$1, new Date());
    if (!isValid(parsed) || format(parsed, format$$1) !== date) {
        return null;
    }
    return parsed;
}

function after (value, ref) {
    var otherValue = ref[0];
    var inclusion = ref[1];
    var format$$1 = ref[2];

    if (typeof format$$1 === 'undefined') {
        format$$1 = inclusion;
        inclusion = false;
    }
    value = parseDate$1(value, format$$1);
    otherValue = parseDate$1(otherValue, format$$1);
    if (!value || !otherValue) {
        return false;
    }
    return isAfter(value, otherValue) || inclusion && isEqual$1(value, otherValue);
}

var alpha = {
    en: /^[A-Z]*$/i,
    cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
    da: /^[A-ZÆØÅ]*$/i,
    de: /^[A-ZÄÖÜß]*$/i,
    es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
    fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
    lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
    nl: /^[A-ZÉËÏÓÖÜ]*$/i,
    hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
    pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
    pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
    ru: /^[А-ЯЁ]*$/i,
    sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
    sr: /^[A-ZČĆŽŠĐ]*$/i,
    tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
    uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};
var alphaSpaces = {
    en: /^[A-Z\s]*$/i,
    cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
    da: /^[A-ZÆØÅ\s]*$/i,
    de: /^[A-ZÄÖÜß\s]*$/i,
    es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
    fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
    lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
    nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
    hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
    pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
    pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
    ru: /^[А-ЯЁ\s]*$/i,
    sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
    sr: /^[A-ZČĆŽŠĐ\s]*$/i,
    tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
    uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/
};
var alphanumeric = {
    en: /^[0-9A-Z]*$/i,
    cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
    da: /^[0-9A-ZÆØÅ]$/i,
    de: /^[0-9A-ZÄÖÜß]*$/i,
    es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
    fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
    lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
    hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
    nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
    pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
    pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
    ru: /^[0-9А-ЯЁ]*$/i,
    sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
    sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
    tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
    uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
};
var alphaDash = {
    en: /^[0-9A-Z_-]*$/i,
    cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
    da: /^[0-9A-ZÆØÅ_-]*$/i,
    de: /^[0-9A-ZÄÖÜß_-]*$/i,
    es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
    fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
    lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
    nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
    hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
    pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
    pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
    ru: /^[0-9А-ЯЁ_-]*$/i,
    sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
    sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
    tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
    uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/
};

var validate = function (value, ref) {
    if ( ref === void 0 ) ref = [];
    var locale = ref[0]; if ( locale === void 0 ) locale = null;

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate(val, [locale]); });
    }
    if (!locale) {
        return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
    }
    return (alpha[locale] || alpha.en).test(value);
};

var validate$1 = function (value, ref) {
    if ( ref === void 0 ) ref = [];
    var locale = ref[0]; if ( locale === void 0 ) locale = null;

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$1(val, [locale]); });
    }
    if (!locale) {
        return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
    }
    return (alphaDash[locale] || alphaDash.en).test(value);
};

var validate$2 = function (value, ref) {
    if ( ref === void 0 ) ref = [];
    var locale = ref[0]; if ( locale === void 0 ) locale = null;

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$2(val, [locale]); });
    }
    if (!locale) {
        return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
    }
    return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var validate$3 = function (value, ref) {
    if ( ref === void 0 ) ref = [];
    var locale = ref[0]; if ( locale === void 0 ) locale = null;

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$3(val, [locale]); });
    }
    if (!locale) {
        return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
    }
    return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

function before (value, ref) {
    var otherValue = ref[0];
    var inclusion = ref[1];
    var format$$1 = ref[2];

    if (typeof format$$1 === 'undefined') {
        format$$1 = inclusion;
        inclusion = false;
    }
    value = parseDate$1(value, format$$1);
    otherValue = parseDate$1(otherValue, format$$1);
    if (!value || !otherValue) {
        return false;
    }
    return isBefore(value, otherValue) || inclusion && isEqual$1(value, otherValue);
}

var validate$4 = function (value, ref) {
    var min = ref[0];
    var max = ref[1];

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$4(val, [min,max]); });
    }
    return Number(min) <= value && Number(max) >= value;
};

function confirmed (value, other) { return String(value) === String(other); }

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = assertString;
    function assertString(input) {
        var isString = typeof input === 'string' || input instanceof String;
        if (!isString) {
            throw new TypeError('This library (validator.js) validates strings only');
        }
    }
    
    module.exports = exports['default'];
});
var assertString = unwrapExports(assertString_1)

var assertString$1 = /*#__PURE__*/Object.freeze({
  default: assertString,
  __moduleExports: assertString_1
});

var _assertString = ( assertString$1 && assertString ) || assertString$1;

var isCreditCard_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = isCreditCard;
    var _assertString2 = _interopRequireDefault(_assertString);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
    function isCreditCard(str) {
        (0, _assertString2.default)(str);
        var sanitized = str.replace(/[- ]+/g, '');
        if (!creditCard.test(sanitized)) {
            return false;
        }
        var sum = 0;
        var digit = void 0;
        var tmpNum = void 0;
        var shouldDouble = void 0;
        for (var i = sanitized.length - 1;i >= 0; i--) {
            digit = sanitized.substring(i, i + 1);
            tmpNum = parseInt(digit, 10);
            if (shouldDouble) {
                tmpNum *= 2;
                if (tmpNum >= 10) {
                    sum += tmpNum % 10 + 1;
                } else {
                    sum += tmpNum;
                }
            } else {
                sum += tmpNum;
            }
            shouldDouble = !shouldDouble;
        }
        return !(!(sum % 10 === 0 ? sanitized : false));
    }
    
    module.exports = exports['default'];
});
var isCreditCard = unwrapExports(isCreditCard_1)

function credit_card (value) { return isCreditCard(String(value)); }

var validate$5 = function (value, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';
    var separator = ref[1]; if ( separator === void 0 ) separator = '.';

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$5(val, [decimals,separator]); });
    }
    if (value === null || value === undefined || value === '') {
        return true;
    }
    if (Number(decimals) === 0) {
        return /^-?\d*$/.test(value);
    }
    var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
    var regex = new RegExp(("^-?\\d*(\\" + separator + "\\d" + regexPart + ")?$"));
    if (!regex.test(value)) {
        return false;
    }
    var parsedValue = parseFloat(value);
    return parsedValue === parsedValue;
};

function date_between (value, params) {
    var assign, assign$1;

    var min$$1;
    var max$$1;
    var format$$1;
    var inclusivity = '()';
    if (params.length > 3) {
        (assign = params, min$$1 = assign[0], max$$1 = assign[1], inclusivity = assign[2], format$$1 = assign[3]);
    } else {
        (assign$1 = params, min$$1 = assign$1[0], max$$1 = assign$1[1], format$$1 = assign$1[2]);
    }
    var minDate = parseDate$1(String(min$$1), format$$1);
    var maxDate = parseDate$1(String(max$$1), format$$1);
    var dateVal = parseDate$1(String(value), format$$1);
    if (!minDate || !maxDate || !dateVal) {
        return false;
    }
    if (inclusivity === '()') {
        return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
    }
    if (inclusivity === '(]') {
        return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
    }
    if (inclusivity === '[)') {
        return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
    }
    return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) || isBefore(dateVal, maxDate) && isAfter(dateVal, minDate);
}

function date_format (value, ref) {
	var format = ref[0];

	return !(!parseDate$1(value, format));
}

var validate$6 = function (value, ref) {
    var length = ref[0];

    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$6(val, [length]); });
    }
    var strVal = String(value);
    return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var validateImage = function (file, width, height) {
    var URL = window.URL || window.webkitURL;
    return new Promise(function (resolve) {
        var image = new Image();
        image.onerror = (function () { return resolve({
            valid: false
        }); });
        image.onload = (function () { return resolve({
            valid: image.width === Number(width) && image.height === Number(height)
        }); });
        image.src = URL.createObjectURL(file);
    });
};
function dimensions (files, ref) {
    var width = ref[0];
    var height = ref[1];

    var list = [];
    for (var i = 0;i < files.length; i++) {
        if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
            return false;
        }
        list.push(files[i]);
    }
    return Promise.all(list.map(function (file) { return validateImage(file, width, height); }));
}

var merge_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = merge;
    function merge() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var defaults = arguments[1];
        for (var key in defaults) {
            if (typeof obj[key] === 'undefined') {
                obj[key] = defaults[key];
            }
        }
        return obj;
    }
    
    module.exports = exports['default'];
});
var merge$1 = unwrapExports(merge_1)

var merge$2 = /*#__PURE__*/Object.freeze({
  default: merge$1,
  __moduleExports: merge_1
});

var isByteLength_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    exports.default = isByteLength;
    var _assertString2 = _interopRequireDefault(_assertString);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    function isByteLength(str, options) {
        (0, _assertString2.default)(str);
        var min = void 0;
        var max = void 0;
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            min = options.min || 0;
            max = options.max;
        } else {
            min = arguments[1];
            max = arguments[2];
        }
        var len = encodeURI(str).split(/%..|./).length - 1;
        return len >= min && (typeof max === 'undefined' || len <= max);
    }
    
    module.exports = exports['default'];
});
var isByteLength = unwrapExports(isByteLength_1)

var isByteLength$1 = /*#__PURE__*/Object.freeze({
  default: isByteLength,
  __moduleExports: isByteLength_1
});

var _merge = ( merge$2 && merge$1 ) || merge$2;

var isFQDN_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = isFQDN;
    var _assertString2 = _interopRequireDefault(_assertString);
    var _merge2 = _interopRequireDefault(_merge);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    var default_fqdn_options = {
        require_tld: true,
        allow_underscores: false,
        allow_trailing_dot: false
    };
    function isFQDN(str, options) {
        (0, _assertString2.default)(str);
        options = (0, _merge2.default)(options, default_fqdn_options);
        if (options.allow_trailing_dot && str[str.length - 1] === '.') {
            str = str.substring(0, str.length - 1);
        }
        var parts = str.split('.');
        if (options.require_tld) {
            var tld = parts.pop();
            if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
                return false;
            }
            if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
                return false;
            }
        }
        for (var part, i = 0;i < parts.length; i++) {
            part = parts[i];
            if (options.allow_underscores) {
                part = part.replace(/_/g, '');
            }
            if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
                return false;
            }
            if (/[\uff01-\uff5e]/.test(part)) {
                return false;
            }
            if (part[0] === '-' || part[part.length - 1] === '-') {
                return false;
            }
        }
        return true;
    }
    
    module.exports = exports['default'];
});
var isFQDN = unwrapExports(isFQDN_1)

var isFQDN$1 = /*#__PURE__*/Object.freeze({
  default: isFQDN,
  __moduleExports: isFQDN_1
});

var _isByteLength = ( isByteLength$1 && isByteLength ) || isByteLength$1;

var _isFQDN = ( isFQDN$1 && isFQDN ) || isFQDN$1;

var isEmail_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = isEmail;
    var _assertString2 = _interopRequireDefault(_assertString);
    var _merge2 = _interopRequireDefault(_merge);
    var _isByteLength2 = _interopRequireDefault(_isByteLength);
    var _isFQDN2 = _interopRequireDefault(_isFQDN);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    var default_email_options = {
        allow_display_name: false,
        require_display_name: false,
        allow_utf8_local_part: true,
        require_tld: true
    };
    var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
    var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
    var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
    var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
    var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
    function isEmail(str, options) {
        (0, _assertString2.default)(str);
        options = (0, _merge2.default)(options, default_email_options);
        if (options.require_display_name || options.allow_display_name) {
            var display_email = str.match(displayName);
            if (display_email) {
                str = display_email[1];
            } else if (options.require_display_name) {
                return false;
            }
        }
        var parts = str.split('@');
        var domain = parts.pop();
        var user = parts.join('@');
        var lower_domain = domain.toLowerCase();
        if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
            user = user.replace(/\./g, '').toLowerCase();
        }
        if (!(0, _isByteLength2.default)(user, {
            max: 64
        }) || !(0, _isByteLength2.default)(domain, {
            max: 254
        })) {
            return false;
        }
        if (!(0, _isFQDN2.default)(domain, {
            require_tld: options.require_tld
        })) {
            return false;
        }
        if (user[0] === '"') {
            user = user.slice(1, user.length - 1);
            return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
        }
        var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
        var user_parts = user.split('.');
        for (var i = 0;i < user_parts.length; i++) {
            if (!pattern.test(user_parts[i])) {
                return false;
            }
        }
        return true;
    }
    
    module.exports = exports['default'];
});
var isEmail = unwrapExports(isEmail_1)

var validate$7 = function (value) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return isEmail(String(val)); });
    }
    return isEmail(String(value));
};

function ext (files, extensions) {
    var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
    return files.every(function (file) { return regex.test(file.name); });
}

function image (files) { return files.every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }); }

var validate$8 = function (value, options) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$8(val, options); });
    }
    return !(!options.filter(function (option) { return option == value; }).length);
};

var isIP_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = isIP;
    var _assertString2 = _interopRequireDefault(_assertString);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    var ipv6Block = /^[0-9A-F]{1,4}$/i;
    function isIP(str) {
        var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        (0, _assertString2.default)(str);
        version = String(version);
        if (!version) {
            return isIP(str, 4) || isIP(str, 6);
        } else if (version === '4') {
            if (!ipv4Maybe.test(str)) {
                return false;
            }
            var parts = str.split('.').sort(function (a, b) {
                return a - b;
            });
            return parts[3] <= 255;
        } else if (version === '6') {
            var blocks = str.split(':');
            var foundOmissionBlock = false;
            var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
            var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
            if (blocks.length > expectedNumberOfBlocks) {
                return false;
            }
            if (str === '::') {
                return true;
            } else if (str.substr(0, 2) === '::') {
                blocks.shift();
                blocks.shift();
                foundOmissionBlock = true;
            } else if (str.substr(str.length - 2) === '::') {
                blocks.pop();
                blocks.pop();
                foundOmissionBlock = true;
            }
            for (var i = 0;i < blocks.length; ++i) {
                if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
                    if (foundOmissionBlock) {
                        return false;
                    }
                    foundOmissionBlock = true;
                } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ; else if (!ipv6Block.test(blocks[i])) {
                    return false;
                }
            }
            if (foundOmissionBlock) {
                return blocks.length >= 1;
            }
            return blocks.length === expectedNumberOfBlocks;
        }
        return false;
    }
    
    module.exports = exports['default'];
});
var isIP = unwrapExports(isIP_1)

var isIP$1 = /*#__PURE__*/Object.freeze({
  default: isIP,
  __moduleExports: isIP_1
});

function ip (value, ref) {
    if ( ref === void 0 ) ref = [];
    var version = ref[0]; if ( version === void 0 ) version = 4;

    if (isNullOrUndefined(value)) {
        value = '';
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return isIP(val, version); });
    }
    return isIP(value, version);
}

function is (value, ref) {
	if ( ref === void 0 ) ref = [];
	var other = ref[0];

	return value === other;
}

function is_not (value, ref) {
	if ( ref === void 0 ) ref = [];
	var other = ref[0];

	return value !== other;
}

var compare = function (value, length, max) {
    if (max === undefined) {
        return value.length === length;
    }
    max = Number(max);
    return value.length >= length && value.length <= max;
};
function length (value, ref) {
    var length = ref[0];
    var max = ref[1]; if ( max === void 0 ) max = undefined;

    length = Number(length);
    if (value === undefined || value === null) {
        return false;
    }
    if (typeof value === 'number') {
        value = String(value);
    }
    if (!value.length) {
        value = toArray(value);
    }
    return compare(value, length, max);
}

function integer (value) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
    }
    return /^-?[0-9]+$/.test(String(value));
}

function max$1 (value, ref) {
    var length = ref[0];

    if (value === undefined || value === null) {
        return length >= 0;
    }
    return String(value).length <= length;
}

function max_value (value, ref) {
    var max = ref[0];

    if (Array.isArray(value) || value === null || value === undefined || value === '') {
        return false;
    }
    return Number(value) <= max;
}

function mimes (files, mimes) {
    var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
    return files.every(function (file) { return regex.test(file.type); });
}

function min$1 (value, ref) {
    var length = ref[0];

    if (value === undefined || value === null) {
        return false;
    }
    return String(value).length >= length;
}

function min_value (value, ref) {
    var min = ref[0];

    if (Array.isArray(value) || value === null || value === undefined || value === '') {
        return false;
    }
    return Number(value) >= min;
}

var validate$9 = function (value, options) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return validate$9(val, options); });
    }
    return !options.filter(function (option) { return option == value; }).length;
};

function numeric (value) {
    if (Array.isArray(value)) {
        return value.every(function (val) { return /^[0-9]+$/.test(String(val)); });
    }
    return /^[0-9]+$/.test(String(value));
}

function regex (value, ref) {
    var regex = ref[0];
    var flags = ref.slice(1);

    if (regex instanceof RegExp) {
        return regex.test(value);
    }
    return new RegExp(regex, flags).test(String(value));
}

function required (value, ref) {
    if ( ref === void 0 ) ref = [];
    var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

    if (Array.isArray(value)) {
        return !(!value.length);
    }
    if (value === false && invalidateFalse) {
        return false;
    }
    if (value === undefined || value === null) {
        return false;
    }
    return !(!String(value).trim().length);
}

function size (files, ref) {
    var size = ref[0];

    if (isNaN(size)) {
        return false;
    }
    var nSize = Number(size) * 1024;
    for (var i = 0;i < files.length; i++) {
        if (files[i].size > nSize) {
            return false;
        }
    }
    return true;
}

var _isIP = ( isIP$1 && isIP ) || isIP$1;

var isURL_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = isURL;
    var _assertString2 = _interopRequireDefault(_assertString);
    var _isFQDN2 = _interopRequireDefault(_isFQDN);
    var _isIP2 = _interopRequireDefault(_isIP);
    var _merge2 = _interopRequireDefault(_merge);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    
    var default_url_options = {
        protocols: ['http','https','ftp'],
        require_tld: true,
        require_protocol: false,
        require_host: true,
        require_valid_protocol: true,
        allow_underscores: false,
        allow_trailing_dot: false,
        allow_protocol_relative_urls: false
    };
    var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function isRegExp(obj) {
        return Object.prototype.toString.call(obj) === '[object RegExp]';
    }
    
    function checkHost(host, matches) {
        for (var i = 0;i < matches.length; i++) {
            var match = matches[i];
            if (host === match || isRegExp(match) && match.test(host)) {
                return true;
            }
        }
        return false;
    }
    
    function isURL(url, options) {
        (0, _assertString2.default)(url);
        if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
            return false;
        }
        if (url.indexOf('mailto:') === 0) {
            return false;
        }
        options = (0, _merge2.default)(options, default_url_options);
        var protocol = void 0, auth = void 0, host = void 0, hostname = void 0, port = void 0, port_str = void 0, split = void 0, ipv6 = void 0;
        split = url.split('#');
        url = split.shift();
        split = url.split('?');
        url = split.shift();
        split = url.split('://');
        if (split.length > 1) {
            protocol = split.shift();
            if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
                return false;
            }
        } else if (options.require_protocol) {
            return false;
        } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
            split[0] = url.substr(2);
        }
        url = split.join('://');
        if (url === '') {
            return false;
        }
        split = url.split('/');
        url = split.shift();
        if (url === '' && !options.require_host) {
            return true;
        }
        split = url.split('@');
        if (split.length > 1) {
            auth = split.shift();
            if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
                return false;
            }
        }
        hostname = split.join('@');
        port_str = null;
        ipv6 = null;
        var ipv6_match = hostname.match(wrapped_ipv6);
        if (ipv6_match) {
            host = '';
            ipv6 = ipv6_match[1];
            port_str = ipv6_match[2] || null;
        } else {
            split = hostname.split(':');
            host = split.shift();
            if (split.length) {
                port_str = split.join(':');
            }
        }
        if (port_str !== null) {
            port = parseInt(port_str, 10);
            if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
                return false;
            }
        }
        if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
            return false;
        }
        host = host || ipv6;
        if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
            return false;
        }
        if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
            return false;
        }
        return true;
    }
    
    module.exports = exports['default'];
});
var isURL = unwrapExports(isURL_1)

function url (value, ref) {
    if ( ref === void 0 ) ref = [];
    var requireProtocol = ref[0]; if ( requireProtocol === void 0 ) requireProtocol = false;

    var options = {
        require_protocol: !(!requireProtocol),
        allow_underscores: true
    };
    if (isNullOrUndefined(value)) {
        value = '';
    }
    if (Array.isArray(value)) {
        return value.every(function (val) { return isURL(val, options); });
    }
    return isURL(value, options);
}

var Rules = {
    after: after,
    alpha_dash: validate$1,
    alpha_num: validate$2,
    alpha_spaces: validate$3,
    alpha: validate,
    before: before,
    between: validate$4,
    confirmed: confirmed,
    credit_card: credit_card,
    date_between: date_between,
    date_format: date_format,
    decimal: validate$5,
    digits: validate$6,
    dimensions: dimensions,
    email: validate$7,
    ext: ext,
    image: image,
    in: validate$8,
    integer: integer,
    length: length,
    ip: ip,
    is_not: is_not,
    is: is,
    max: max$1,
    max_value: max_value,
    mimes: mimes,
    min: min$1,
    min_value: min_value,
    not_in: validate$9,
    numeric: numeric,
    regex: regex,
    required: required,
    size: size,
    url: url
}

var normalize = function (fields) {
    if (Array.isArray(fields)) {
        return fields.reduce(function (prev, curr) {
            if (~curr.indexOf('.')) {
                prev[curr.split('.')[1]] = curr;
            } else {
                prev[curr] = curr;
            }
            return prev;
        }, {});
    }
    return fields;
};
var combine = function (lhs, rhs) {
    var mapper = {
        pristine: function (lhs, rhs) { return lhs && rhs; },
        dirty: function (lhs, rhs) { return lhs || rhs; },
        touched: function (lhs, rhs) { return lhs || rhs; },
        untouched: function (lhs, rhs) { return lhs && rhs; },
        valid: function (lhs, rhs) { return lhs && rhs; },
        invalid: function (lhs, rhs) { return lhs || rhs; },
        pending: function (lhs, rhs) { return lhs || rhs; },
        required: function (lhs, rhs) { return lhs || rhs; },
        validated: function (lhs, rhs) { return lhs && rhs; }
    };
    return Object.keys(mapper).reduce(function (flags, flag) {
        flags[flag] = mapper[flag](lhs[flag], rhs[flag]);
        return flags;
    }, {});
};
var mapScope = function (scope, deep) {
    if ( deep === void 0 ) deep = true;

    return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
        flags = assign({}, scope[field]);
        return flags;
    }
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
        return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
        return flags;
    }
    flags = combine(flags, scope[field]);
    return flags;
}, null);
};
var mapFields = function (fields) {
    if (!fields) {
        return function () {
            return mapScope(this.$validator.flags);
        };
    }
    var normalized = normalize(fields);
    return Object.keys(normalized).reduce(function (prev, curr) {
        var field = normalized[curr];
        prev[curr] = function mappedField() {
            if (this.$validator.flags[field]) {
                return this.$validator.flags[field];
            }
            if (normalized[curr] === '*') {
                return mapScope(this.$validator.flags, false);
            }
            var index = field.indexOf('.');
            if (index <= 0) {
                return {};
            }
            var ref = field.split('.');
            var scope = ref[0];
            var name = ref.slice(1);
            scope = this.$validator.flags[("$" + scope)];
            name = name.join('.');
            if (name === '*' && scope) {
                return mapScope(scope);
            }
            if (scope && scope[name]) {
                return scope[name];
            }
            return {};
        };
        return prev;
    }, {});
};

var ErrorComponent = {
    name: 'vv-error',
    inject: ['$validator'],
    functional: true,
    props: {
        for: {
            type: String,
            required: true
        },
        tag: {
            type: String,
            default: 'span'
        }
    },
    render: function render(createElement, ref) {
        var props = ref.props;
        var injections = ref.injections;

        return createElement(props.tag, injections.$validator.errors.first(props.for));
    }
};

var version = '2.0.8';
var rulesPlugin = function (ref) {
    var Validator$$1 = ref.Validator;

    Object.keys(Rules).forEach(function (rule) {
        Validator$$1.extend(rule, Rules[rule]);
    });
    Validator$$1.localize('en', locale);
};
use(rulesPlugin);
var index_esm = {
    install: install,
    use: use,
    directive: directive,
    mixin: mixin,
    mapFields: mapFields,
    Validator: Validator,
    ErrorBag: ErrorBag,
    ErrorComponent: ErrorComponent,
    Rules: Rules,
    version: version
}

/* harmony default export */ __webpack_exports__["b"] = (index_esm);



/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(35)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(11);
var normalizeHeaderName = __webpack_require__(434);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(40);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(40);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_takePhoto_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fc9a71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_takePhoto_vue__ = __webpack_require__(638);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_takePhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fc9a71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_takePhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(27)(module)))

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewActionLog_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d29b1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewActionLog_vue__ = __webpack_require__(754);
function injectStyle (ssrContext) {
  __webpack_require__(752)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewActionLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d29b1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewActionLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundExportOrder_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989943c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundExportOrder_vue__ = __webpack_require__(1191);
function injectStyle (ssrContext) {
  __webpack_require__(1189)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989943c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16), __webpack_require__(22).setImmediate))

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loginComponent_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_staffLogin_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pageContainer_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_customerVerification_CustomerVerification_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PrivacyAndPolicy_vue__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import customerRegistration from './components/customerRegistration.vue'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      logged_in: localStorage.getItem('logged_in'),
      url: 'api/login',
      userData: {},
      adminLogin: false,
      verifyUser: false,
      privacyAndPolicy: false
    };
  },
  mounted: function mounted() {
    if (this.logged_in) {
      this.getUserPermissions(localStorage.getItem('access_token'));
    }

    if (this.$router.currentRoute.fullPath === '/customer-verification') {
      this.verifyUser = true;
    } else if (this.$router.currentRoute.fullPath === '/privacy-and-policy') {
      this.privacyAndPolicy = true;
    } else if (this.$router.currentRoute.fullPath === '/shipzone-admin') {
      this.adminLogin = true;
    }
  },


  watch: {
    $route: function $route() {
      if (this.$router.currentRoute.fullPath === '/customer-verification') {
        this.verifyUser = true;
      } else {
        this.verifyUser = false;
      }

      if (this.$router.currentRoute.fullPath === '/privacy-and-policy') {
        this.privacyAndPolicy = true;
      } else {
        this.privacyAndPolicy = false;
      }

      if (!this.logged_in) {
        this.$router.push('login');
      }
    }
  },

  methods: {
    handleLogin: function handleLogin(token) {
      localStorage.setItem('access_token', token);
      this.getUser(localStorage.getItem('access_token'));
      this.getUserPermissions(localStorage.getItem('access_token'));
    },
    changeLogin: function changeLogin(loginData) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.url, loginData).then(function (response) {
        _this.handleLogin(response.data.access_token);
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    changePhoneLogin: function changePhoneLogin(form) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('api/phone-login', form).then(function (response) {
        _this2.handleLogin(response.data.access_token);
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    getUserPermissions: function getUserPermissions(token) {
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/auth_user_permissions', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_permissions', JSON.stringify(response.data));
      });
    },
    getUser: function getUser(token) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
        _this3.userData = JSON.parse(localStorage.getItem('user_data'));
      }).then(function () {
        if (_this3.userData.is_staff) {
          _this3.checkExpiredCoupons();
          localStorage.setItem('logged_in', true);
          _this3.logged_in = localStorage.getItem('logged_in');
          localStorage.setItem('secret_key', false);
        } else {
          console.log('else');
          if (!_this3.userData.phone_number || !_this3.userData.full_name || !_this3.userData.email || !_this3.userData.address) {
            console.log('else -> if');
            localStorage.setItem('logged_in', true);
            _this3.logged_in = localStorage.getItem('logged_in');
            _this3.$router.push('/');
          } else {
            console.log('else -> else');
            localStorage.setItem('logged_in', true);
            _this3.logged_in = localStorage.getItem('logged_in');
            _this3.$router.push('/make-new-order');
          }
        }
        setTimeout(function () {
          location.reload(true);
        }, 1);
      });
    },
    checkExpiredCoupons: function checkExpiredCoupons() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/check_expired_coupons', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {});
    }
  },
  components: {
    'login-component': __WEBPACK_IMPORTED_MODULE_0__components_loginComponent_vue__["a" /* default */],
    'page-container': __WEBPACK_IMPORTED_MODULE_2__components_pageContainer_vue__["a" /* default */],
    'staff-login': __WEBPACK_IMPORTED_MODULE_1__components_staffLogin_vue__["a" /* default */],
    // customerRegistration,
    CustomerVerification: __WEBPACK_IMPORTED_MODULE_5__components_customerVerification_CustomerVerification_vue__["a" /* default */],
    PrivacyAndPolicy: __WEBPACK_IMPORTED_MODULE_6__PrivacyAndPolicy_vue__["default"]
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_google_login__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_google_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_google_login__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['changeLogin', 'changePhoneLogin'],

  components: {
    GoogleLogin: __WEBPACK_IMPORTED_MODULE_1_vue_google_login___default.a
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      e1: false,
      activeTab: 1,
      loading: false,
      formData: {
        phone_number: null,
        password: null
      },
      params: {
        client_id: '17629677592-96u7gdi6phhtb1t02lajhauf7dnir6ul.apps.googleusercontent.com'
        // client_id: '252910102757-b65d5qvd0nutbnemjq8prbssv4pt9i5n.apps.googleusercontent.com'
      },
      fromFacebook: false,
      facebookData: {
        email: '',
        full_name: '',
        facebook_id: '',
        phone_number: ''
      },
      googleData: {
        the_google_id: null,
        full_name: '',
        email: ''
      },
      phoneData: {
        code: '',
        csrf: ''
      },
      phoneUserData: {
        phone_number: ''
      }
    };
  },

  methods: {
    googleLogin: function googleLogin(gData) {
      var data = Object.entries(gData);
      var theData = Object.entries(data[2][1]);

      this.googleData.the_google_id = theData[0][1];
      this.googleData.full_name = theData[1][1];
      this.googleData.email = theData[5][1];
      this.changeLogin(this.googleData);
    },
    onFailure: function onFailure(error) {
      console.log(error);
    },
    auth: function auth(network) {
      var _this = this;

      var hello = this.hello;
      hello(network).login().then(function () {
        var authRes = hello(network).getAuthResponse();
        hello(network).api('me').then(function (json) {
          _this.fromFacebook = true;
          _this.facebookData.email = json.email;
          _this.facebookData.full_name = json.name;
          _this.facebookData.facebook_id = json.id;
          _this.changeLogin(_this.facebookData);
          _this.checkPhoneVerification(json.id);
        });
      });
    },
    checkPhoneVerification: function checkPhoneVerification(facebookId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/check_phone_verification/' + facebookId).then(function (response) {
        if (response.data.success == true) {
          _this2.facebookData.phone_number = response.data.data.phone_number;
          _this2.changeLogin(_this2.facebookData);
        } else {
          $('#modal_showApp').modal({ backdrop: 'static' });
        }
      });
    },
    loginCallback: function loginCallback(response) {
      if (response != null) {
        if (response.status === 'PARTIALLY_AUTHENTICATED') {
          this.phoneData.code = response.code;
          this.phoneData.csrf = response.state;
          $('#phone').click();
        }
      }
    },
    smsLogin: function smsLogin() {
      // eslint-disable-next-line no-undef
      AccountKit.login('PHONE', { countryCode: '+964' }, this.loginCallback);
    },
    phoneLogin: function phoneLogin() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/phone-login', this.phoneData).then(function (response) {
        if (_this3.fromFacebook == true) {
          _this3.facebookData.phone_number = response.data.data.phone.number;
          _this3.changeLogin(_this3.facebookData);
        } else {
          _this3.phoneUserData.phone_number = response.data.data.phone.number;
          _this3.changeLogin(_this3.phoneUserData);
        }
      });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    loginWithPhoneAndPassword: function loginWithPhoneAndPassword() {
      var _this4 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var payload = _extends({}, _this4.formData);
          // replace all white spaces in phone number
          payload.phone_number = payload.phone_number.replace(/\s+/g, '');

          // append country code
          payload.phone_number = '+964' + payload.phone_number;
          _this4.changePhoneLogin(payload);
        }
      });
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var settle = __webpack_require__(435);
var buildURL = __webpack_require__(437);
var parseHeaders = __webpack_require__(438);
var isURLSameOrigin = __webpack_require__(439);
var createError = __webpack_require__(41);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(440);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(441);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(436);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['changeLogin'],

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      e1: true,
      loginData: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.changeLogin(_this.loginData);
        }
      });
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    sidebar: __WEBPACK_IMPORTED_MODULE_0__sidebar__["a" /* default */],
    navbar: __WEBPACK_IMPORTED_MODULE_1__navbar__["a" /* default */]
  },

  created: function created() {
    this.getUser();
  },
  data: function data() {
    return {
      loggedInUserData: {},
      show: false,
      toggleSidebar: true
    };
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      this.show = true;
    },
    getUser: function getUser() {
      var _this = this;

      this.show = false;
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      }).then(function () {
        _this.getLoggedInUser();
      });
    },
    onClickChild: function onClickChild() {
      this.getUser();
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['loggedInUserData'],

  data: function data() {
    return {
      showAdminSections: false,
      allNavigationsExpanded: false
    };
  },


  methods: {
    toggleAllNavigations: function toggleAllNavigations() {
      var _this = this;

      this.allNavigationsExpanded = !this.allNavigationsExpanded;

      // Get all navigation sections with user-nav in their ID
      var navElements = document.querySelectorAll('[id^="user-nav"]');

      navElements.forEach(function (nav) {
        if (_this.allNavigationsExpanded) {
          // Expand all navigations
          if (!nav.classList.contains('in')) {
            // Find the corresponding toggle and click it to expand
            var toggle = document.querySelector('[href="#' + nav.id + '"]');
            if (toggle) {
              toggle.classList.remove('collapsed');
              nav.classList.add('in');
              nav.style.height = 'auto';
              nav.setAttribute('aria-expanded', 'true');
            }
          }
        } else {
          // Collapse all navigations
          if (nav.classList.contains('in')) {
            // Find the corresponding toggle and click it to collapse
            var _toggle = document.querySelector('[href="#' + nav.id + '"]');
            if (_toggle) {
              _toggle.classList.add('collapsed');
              nav.classList.remove('in');
              nav.style.height = '0px';
              nav.setAttribute('aria-expanded', 'false');
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AmazonSessionModal_vue__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AmazonSessionModal: __WEBPACK_IMPORTED_MODULE_1__AmazonSessionModal_vue__["a" /* default */]
  },
  props: ['loggedInUserData'],

  created: function created() {
    this.getResults();
    this.storeWarehousePassed();

    // if (this.loggedInUserData.is_staff) {
    //   setInterval(() => {
    //     this.getResults()
    //   }, 10000)
    // }
  },
  data: function data() {
    return {
      url: 'api/order_notification',
      openNotificationURL: 'api/open_notification',
      apiResults: [],
      showSidebar: false,
      tableData: {
        per_page: 10
      },
      count: 0,
      apiResults2: [],
      tableData2: {
        per_page: 10
      },
      count2: 0
    };
  },


  computed: {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },

  watch: {
    $route: function $route() {
      this.showSidebar = false;
      if (this.isMobile) {
        this.toggleAdminSidebar();
      }
    }
  },

  methods: {
    openAmazonSessionModal: function openAmazonSessionModal() {
      if (this.$refs.amazonSessionModal) {
        this.$refs.amazonSessionModal.open();
      }
    },
    toggleShowSidebar: function toggleShowSidebar() {
      this.showSidebar = !this.showSidebar;
      this.toggleAdminSidebar();
    },
    toggleAdminSidebar: function toggleAdminSidebar() {
      if (this.loggedInUserData.is_staff) {
        // show sidebar
        var sidebar = document.querySelector('.sidebar');
        if (sidebar) {
          sidebar.style.display === 'block' ? sidebar.style.display = 'none' : sidebar.style.display = 'block';
        }
      }
    },
    verifyAccount: function verifyAccount() {
      this.$router.push('/customer-verification');
    },
    storeWarehousePassed: function storeWarehousePassed() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      if (this.loggedInUserData.is_staff) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/store_warehouse_passed', { headers: { Authorization: 'Bearer ' + token } }).then(function () {
          _this.getWarehousePassed();
        });
      }
    },
    getWarehousePassed: function getWarehousePassed() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/get_warehouse_passed', {
        params: this.tableData2,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this2.apiResults2 = data.data.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      this.count = 0;
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, {
        params: this.tableData,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        if (!response.data.message) {
          var data = response.data;
          _this3.apiResults = data.data.data;
        }
      }).catch(function (errors) {});
    },
    logout: function logout() {
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/logout', '', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        localStorage.clear();
        window.location.href = '/';
      });
    },
    openNotification: function openNotification(id, notiId) {
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.openNotificationURL + '/' + id, '', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {}).then(function () {
        $('#' + notiId).click();
      });
    },
    hideNotification: function hideNotification(id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/hide_notification/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        var noti = document.querySelector('#wh-noti-' + id);
        noti.classList.add('hide-animation');
        setTimeout(function () {
          noti.classList.remove('hide-animation');
          _this4.getWarehousePassed();
        }, 500);
      });
    },
    moreResult: function moreResult() {
      this.tableData.per_page = this.tableData.per_page + 5;
      this.getResults();
    },
    lesResult: function lesResult() {
      if (this.tableData.per_page !== 10) {
        this.tableData.per_page = 10;
        this.getResults();
      }
    },
    moreResult2: function moreResult2() {
      this.tableData2.per_page += 5;
      this.getWarehousePassed();
    },
    lesResult2: function lesResult2() {
      if (this.tableData2.per_page !== 10) {
        this.tableData2.per_page = 10;
        this.getWarehousePassed();
      }
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AmazonSessionModal_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db16310_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AmazonSessionModal_vue__ = __webpack_require__(467);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AmazonSessionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5db16310_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AmazonSessionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AmazonSessionModal',
  data: function data() {
    return {
      dialog: false,
      loadingStatus: false,
      testingConnection: false,
      updatingCookies: false,
      statusData: null,
      testResult: null,
      newCookies: ''
    };
  },

  methods: {
    open: function open() {
      this.dialog = true;
      this.testResult = null;
      this.newCookies = '';
      this.fetchStatus();
    },
    fetchStatus: function fetchStatus() {
      var _this = this;

      this.loadingStatus = true;
      var token = localStorage.getItem('access_token') || localStorage.getItem('token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/amazon-session/status', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this.statusData = res.data;
        _this.loadingStatus = false;
      }).catch(function () {
        _this.loadingStatus = false;
      });
    },
    testLiveConnection: function testLiveConnection() {
      var _this2 = this;

      this.testingConnection = true;
      this.testResult = null;
      var token = localStorage.getItem('access_token') || localStorage.getItem('token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/amazon-session/test', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.testingConnection = false;
        _this2.testResult = res.data.test_result;
        _this2.fetchStatus();
      }).catch(function (err) {
        _this2.testingConnection = false;
        var errMsg = err.response && err.response.data && err.response.data.error || 'Test failed';
        _this2.testResult = { error: errMsg, status: 'error' };
      });
    },
    saveCookies: function saveCookies() {
      var _this3 = this;

      if (!this.newCookies || this.newCookies.trim().length < 30) return;
      this.updatingCookies = true;
      this.testResult = null;
      var token = localStorage.getItem('access_token') || localStorage.getItem('token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/amazon-session/update', { cookies: this.newCookies.trim() }, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.updatingCookies = false;
        _this3.newCookies = '';
        _this3.testResult = res.data.test_result;
        _this3.fetchStatus();
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Saved!', 'Amazon cookies were saved after the server reached the test product.', 'success');
      }).catch(function (err) {
        _this3.updatingCookies = false;
        var errMsg = err.response && err.response.data && err.response.data.error || 'Failed to update cookies.';
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', errMsg, 'error');
      });
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerVerification_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c41ae92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerVerification_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerVerification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c41ae92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerVerification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      step: 1,
      phone_number: null,
      otpCode: '',
      phoneError: '',
      passwordNotMatch: false,
      customer: {
        full_name: null,
        email: null,
        dob: null,
        address: null,
        password: null,
        confirm_password: null
      }
    };
  },


  methods: {
    submit1: function submit1() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        _this.loading = true;
        var token = localStorage.getItem('access_token');

        var payload = {
          phone_number: '+964' + _this.phone_number
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/website-verify-phone-number', payload, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
          _this.step = 2;
        }).catch(function (err) {
          _this.phoneError = err.response.data.message;
        }).finally(function () {
          _this.loading = false;
        });
      });
    },
    handleCompleteOtp: function handleCompleteOtp(val) {
      this.otpCode = val.join('');
      this.submit2();
    },
    submit2: function submit2() {
      var _this2 = this;

      this.loading = true;
      var token = localStorage.getItem('access_token');

      var payload = {
        phone_number: '+964' + this.phone_number,
        otp_code: this.otpCode
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/website-verify-otp-code', payload, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.customer = res.data;
        _this2.step = 3;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    submit3: function submit3() {
      var _this3 = this;

      this.passwordNotMatch = false;
      // check if password match with confirm password
      if (this.customer.password !== this.customer.confirm_password) {
        this.passwordNotMatch = true;
        return;
      }

      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          _this3.loading = true;
          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/website-verify-customer', _this3.customer, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this3.step = 4;
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    },
    downloadApp: function downloadApp() {
      window.open('https://onelink.to/u4amdf');
    },
    backToHome: function backToHome() {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyAndPolicy_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyAndPolicy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyAndPolicy_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd0771d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyAndPolicy_vue__ = __webpack_require__(475);
function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd0771d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyAndPolicy_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd0771d0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyAndPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addNewOrder_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__processTheOrder_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__adminCancelOrder__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'add-new-order': __WEBPACK_IMPORTED_MODULE_7__addNewOrder_vue__["a" /* default */],
    'process-the-order': __WEBPACK_IMPORTED_MODULE_8__processTheOrder_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'admin-cancel-order': __WEBPACK_IMPORTED_MODULE_9__adminCancelOrder__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
        var value = window.location.search.replace('?order=', '');
        this.searchOneCol('order_id', value);
      }
    }
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getItemType();
    this.getWarehouses();
    this.getReasons();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  watch: {
    $route: function $route() {
      if (this.queryParameter === true) {
        if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
          var value = window.location.search.replace('?order=', '');
          this.searchOneCol('order_id', value);
        }
      }
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'URL',
      text: 'URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'order_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      processOrderUrl: 'api/orders',
      makeNewOrderUrl: 'api/orders',
      url: 'api/new_order',
      orderDetailUrl: 'api/show_order_detail',
      getCustomerUrl: 'api/get-customer-to-select',
      getItemTypeUrl: 'api/get-item-type',
      cancelingOrderUrl: 'api/canceling_order_by_admin',
      qrCodeValues: [],
      rowIndex: '',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      alertValue: false,
      checkAlert: false,
      checkURL: false,
      addNewOrderModal: false,
      warehouses: [],
      reasons: [],
      deliveryTypes: [{ text: 'Home Delivery', value: 'home delivery' }, { text: 'Office Delivery', value: 'office delivery' }],
      customers: [],
      itemTypeResult: [],
      itemTypes: [],
      makeOrderData: {
        customer_id_fk: null,
        warehouse_id_fk: null,
        transportation_type: null,
        product_name: null,
        product_url: null,
        quantity: null,
        delivery_type: null,
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        is_repackage: false,
        is_hold: false,
        other_service: '',
        image: null,
        fileName: '',
        image_url: ''
      },
      temp_shipping: '',
      cancelData: {
        cancel_reason: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      updateData: {
        item_price: null,
        the_tl_price: null,
        tax: null,
        national_tax: null,
        item_weight: null,
        internal_shipping_handling: null,
        delivery_price: null,
        kreenex_fee: null,
        quantity_charge: null,
        insurance: null,
        total_amount: null,
        from_date: null,
        to_date: null,
        description: '',
        tmp_shipping: null,
        item_weight_lb: null,
        price_weight: null,
        send_sms: false,
        discount: null,
        item_type: '',
        transportation_type: null,
        is_repackage: false,
        is_hold: false,
        other_service: '',
        local_delivery: 0,
        process_note: '',
        customer_process_note: '',
        repackage_price: null,
        hold_price: null,
        other_service_price: null,
        order_type_id_fk: null,
        auto_image_url: null
      },
      detialData: {},
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      customersResult: [],
      theQuantity: {
        quantity: ''
      },
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToPendingAnswer: function sendToPendingAnswer(orderId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Send to Pending Answer',
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('api/pending_answer_order/' + orderId, {}, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getReasons: function getReasons() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        _this3.reasons = result.map(function (r) {
          return {
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          };
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.resetCancelData();
    },
    resetCancelData: function resetCancelData() {
      this.cancelData.cancel_reason = '';
      this.cancelData.cancel_reason_ar = '';
      this.cancelData.cancel_reason_ku = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.getResults();
        _this4.cancelAlert = true;
        var self = _this4;
        setTimeout(function () {
          self.closeCancelingOrderModal();
        }, 1500);
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();

      var a = this;
      setTimeout(function () {
        a.queryParameter = true;
      }, 1000);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    makeNewOrder: function makeNewOrder() {
      var _this6 = this;

      this.loading = true;
      var token = localStorage.getItem('access_token');
      var formData = new FormData();

      this.makeOrderData.delivery_type = 'office delivery';

      // Append form data
      for (var key in this.makeOrderData) {
        // Only append image_url if it's not empty and no file is selected
        if (key === 'image_url' && this.makeOrderData.image_url && !this.makeOrderData.image) {
          formData.append(key, this.makeOrderData[key]);
        } else if (key !== 'image_url') {
          formData.append(key, this.makeOrderData[key]);
        }
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.makeNewOrderUrl, formData, {
        headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
      }).then(function () {
        _this6.loading = false;
        _this6.checkURL = false;
        _this6.checkAlert = true;
        var a = _this6;
        setTimeout(function () {
          a.clearNewOrerData();
        }, 2000);
        _this6.getResults();
      }).catch(function (error) {
        _this6.loading = false;
        _this6.checkAlert = false;
        if (error.response.data.message.product_url) {
          _this6.checkURL = true;
        } else {
          _this6.checkURL = false;
          __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    openAddNewOrderModal: function openAddNewOrderModal() {
      this.addNewOrderModal = true;
    },
    closeAddNewOrderModal: function closeAddNewOrderModal() {
      this.addNewOrderModal = false;
      this.clearNewOrerData();
    },
    getCustomer: function getCustomer() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this7.customersResult = response.data.data;
        _this7.customersResult.forEach(function (c) {
          _this7.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getItemType: function getItemType() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this8.itemTypeResult = response.data.data;
        _this8.itemTypeResult.forEach(function (c) {
          _this8.itemTypes.push({
            text: c.type_name,
            value: c.type_name,
            shippingPrice: c.type_int_shipping_price
          });
        });
      });
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;
      var repackagePrice = Number(this.updateData.repackage_price) || 0;
      var holdPrice = Number(this.updateData.hold_price) || 0;
      var otherServicePrice = Number(this.updateData.other_service_price) || 0;
      var localDelivery = Number(this.updateData.local_delivery) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge + localDelivery;

      if (this.updateData.is_repackage) {
        total += repackagePrice;
      }

      if (this.updateData.is_hold) {
        total += holdPrice;
      }

      if (otherServicePrice > 0) {
        total += otherServicePrice;
      }

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    clearNewOrerData: function clearNewOrerData() {
      this.makeOrderData.warehouse_id_fk = null;
      this.makeOrderData.transportation_type = null;
      this.makeOrderData.product_name = null;
      this.makeOrderData.product_url = null;
      this.makeOrderData.quantity = null;
      this.makeOrderData.note = '';
      this.makeOrderData.coupon = '';
      this.makeOrderData.size = '';
      this.makeOrderData.type = '';
      this.makeOrderData.color = '';
      this.makeOrderData.c_o_d = null;
      this.makeOrderData.is_repackage = false;
      this.makeOrderData.is_hold = false;
      this.makeOrderData.other_service = '';
      this.makeOrderData.local_delivery = '';
      this.makeOrderData.image = null;
      this.makeOrderData.fileName = '';
      this.makeOrderData.image_url = '';
      this.checkAlert = false;
      this.checkURL = false;
      this.loading = false;
    },
    clearProcessOrderData: function clearProcessOrderData() {
      this.updateData.item_price = null;
      this.updateData.the_tl_price = null;
      this.updateData.tax = null;
      this.updateData.item_weight = null;
      this.updateData.internal_shipping_handling = 0;
      this.updateData.delivery_price = null;
      this.updateData.kreenex_fee = null;
      this.updateData.insurance = null;
      this.updateData.total_amount = null;
      this.updateData.from_date = null;
      this.updateData.to_date = null;
      this.updateData.quantity_charge = null;
      this.updateData.description = '';
      this.updateData.item_type = '';
      this.updateData.item_weight_lb = null;
      this.updateData.discount = null;
      this.updateData.send_sms = false;
      this.updateData.is_repackage = false;
      this.updateData.is_hold = false;
      this.updateData.other_service = '';
      this.updateData.repackage_price = null;
      this.updateData.hold_price = null;
      this.updateData.other_service_price = null;
      this.updateData.local_delivery = null;
      this.updateData.tax = null;
      this.updateData.national_tax = null;
      this.updateData.process_note = '';
      this.updateData.customer_process_note = '';
      this.updateData.order_type_id_fk = null;
      this.updateData.auto_image_url = null;
      this.checkAlert = false;
    },
    processOrder: function processOrder(event, id, stime, stime1, stime2) {
      var _this9 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      this.updateData.send_sms = this.updateData.send_sms.toString();

      var formData = new FormData();

      Object.keys(this.updateData).forEach(function (key) {
        if (key !== 'customer_process_note_image' || !_this9.updateData[key] instanceof File) {
          formData.append(key, _this9.updateData[key]);
        }
      });

      if (this.updateData.customer_process_note_image instanceof File) {
        formData.append('customer_process_note_image', this.updateData.customer_process_note_image);
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.processOrderUrl + '/' + id, formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this9.loading = false;
        _this9.clearProcessOrderData();
        stime.time = '';
        stime1.time = '';
        stime2.time = '';
        _this9.checkAlert = true;
        var b = _this9;
        setTimeout(function () {
          b.getResults();
          b.checkAlert = false;
        }, 1500);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        _this9.loading = false;
        _this9.clearProcessOrderData();
        stime.time = '';
        stime1.time = '';
        stime2.time = '';
        _this9.checkAlert = true;
        var b = _this9;
        setTimeout(function () {
          b.getResults();
          b.checkAlert = false;
        }, 1500);
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this10.detailResults = data.data;
        _this10.detialData = _this10.detailResults[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['pagination', 'changePage'],

  data: function data() {
    return {
      itemsPerPage: 3,
      x: 0
    };
  },


  methods: {
    decreaseX: function decreaseX() {
      if (this.x !== 0) {
        this.x = this.x - 1;
      }
    },
    increaseX: function increaseX() {
      if (this.x !== this.pagination.lastPage - this.totalPages) {
        this.x = this.x + 1;
      }
    }
  },

  computed: {
    totalPages: function totalPages() {
      if (this.pagination.lastPage <= 5) {
        return this.pagination.lastPage;
      } else {
        return this.pagination.lastPage % (this.pagination.lastPage - 1) + 4;
      }
    },

    p: function p() {
      return 1 + this.x;
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getLoggedInUser();
    this.getConnectedBranches();
    this.setDefaultPerPage();
  },


  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__["default"]
  },

  props: ['permissions', 'showApproveAllShiponly', 'showApproveAll', 'loadApproveAllShiponly', 'approvingMultipleOrder', 'showPurchaseAll', 'confirmPurchaseAll', 'filterMade', 'removeFromToDate', 'totalResult', 'hideSelectingColumn', 'showHideColumn', 'defaultHideCol', 'columns', 'getDependDate', 'addSelect', 'addBankButton', 'openAddBankModal', 'addPrepareToPrintButton', 'prepareToPrint', 'removeWarehouseDeliverButton', 'tableData', 'resetGetResults', 'resetGetResults2', 'searchMe', 'pagination', 'removeAddButton', 'perPageFix', 'filterTable', 'openSendToWarehouseModal', 'addInsertStaffButton', 'openAddStaffModal', 'deleteAllSubscriptionPricingButton', 'deleteAllSubscriptionPricing', 'addEditSubscriptionPricing', 'deleteAllSubscriptionButton', 'deleteAllCustomerSubscription', 'addEditCustomerSubscription', 'openAddEditSubscriptionPricingModal', 'openAddEditCustomerSubscriptionModal', 'openAddWarehouseModal', 'openAddNewOrderModal', 'addNewOrderButton', 'addGovernorateButton', 'openAddGovernorateModal', 'checkAlert', 'showCreateCustomerButton', 'openCreateCustomerModal', 'addCreatCreditButton', 'addSecondOrderInvoiceButton', 'openSecondOrderInvoiceModal', 'openCreatCreditModal', 'addQrCodeGenerateButton', 'showAddExportOrderButton', 'handleAddExportOrder', 'openGenerateQrCodeModal', 'addSendToIntShipmentButton', 'openSendToIntShipmentModal', 'addSendAllToIntShipmentButton', 'sendAllToIntShipment', 'addSendToBranchButton', 'addSendToPendingToBranchButton', 'addSendToErbilButton', 'openSendToErbilModal', 'openSendToBranchModal', 'addSendToUserButton', 'openSendToUserModal', 'addExportButton', 'addWarehouseButton', 'sendToExport', 'addGenerateCouponButton', 'openGenerateCouponModal', 'cashBackButton', 'openCashBackModal', 'intShipment', 'addNewShiponlyButton', 'openAddNewShiponlyModal', 'getByWarehouse', 'addExchangeRateButton', 'openAddExchangeRateModal', 'addSupplierButton', 'openAddSupplierModal', 'addOrderInvoiceButton', 'openOrderInvoiceModal', 'addSendAllToUserButton', 'sendAllToUser', 'addExpenseTypeButton', 'openAddExpenseTypeModal', 'addExpenseButton', 'openAddExpenseModal', 'addRoleButton', 'openAddRoleModal', 'addBranchButton', 'openAddBranchModal', 'addMoneyTransferButton', 'openAddMoneyTransferModal', 'addMoneyButton', 'openAddMoneyModal', 'hideBranch', 'addDeliveryInvoiceButton', 'openDeliveryInvoiceModal', 'openSendToPendingToBranchModal', 'addSendAllToBranchButton', 'sendAllToPendingToBranch', 'addCityButton', 'addReasonButton', 'addAboutButton', 'openAddAboutModal', 'openAddCityModal', 'openAddReasonModal', 'addNotFoundOrderButton', 'openAddNotFoundOrderModal', 'addCurrencyRateButton', 'openAddCurrencyRateModal', 'addNewExportOrderButton', 'openAddNewExportOrderModal'],

  data: function data() {
    return {
      colVal: [],
      prevColVal: [],
      branchesList: [],
      branches: [],
      loggedInUserData: {},
      options: [{ text: '10', value: 10 }, { text: '25', value: 25 }, { text: '50', value: 50 }, { text: '100', value: 100 }, { text: '150', value: 150 }, { text: '200', value: 200 }, { text: '250', value: 250 }, { text: '300', value: 300 }, { text: '350', value: 350 }, { text: '400', value: 400 }, { text: '450', value: 450 }, { text: '500', value: 500 }],
      warehouses: [{ text: 'Select', value: 'Select' }, { text: 'USA', value: 1 },
      // { text: 'Turkey', value: 2 },
      { text: 'China', value: 3 }, { text: 'UAE', value: 4 }],
      dates: [{ text: 'Choose', value: '' }, { text: 'Order', value: 'orders.created_at' }, { text: 'Confirm', value: 'orders.confirm_date' }, { text: 'Purchase', value: 'orders.purchase_date' }],
      val: 50,
      dateValue: '',
      ware: 'Select',
      filterApplied: false,
      wareError: false,
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      limit: [{
        type: 'weekday',
        available: [1, 2, 3, 4, 5]
      }, {
        type: 'fromto',
        from: '2016-02-01',
        to: '2016-02-20'
      }]
    };
  },


  watch: {
    colVal: function colVal(newVal, oldVal) {
      this.prevColVal = oldVal;
    },
    branches: function branches(newVal) {
      if (newVal.length === 0) {
        this.$emit('branch-edit', newVal);
      }
    },
    defaultHideCol: function defaultHideCol(newVal) {
      this.colVal = newVal;
      this.showHideColumn([], this.colVal);
    }
  },

  methods: {
    setDefaultPerPage: function setDefaultPerPage() {
      if (this.loggedInUserData && !this.loggedInUserData.is_staff) {
        this.val = 50;
      } else {
        this.val = 10;
      }
      // Update tableData to match
      if (this.tableData) {
        this.tableData.per_page = this.val;
      }
    },
    filterBranch: function filterBranch(branches) {
      var filterBtn = document.querySelector('.filter-branch-btn');
      filterBtn.classList.add('animate-filter-branch-btn');
      this.$emit('branch-edit', branches);
      setTimeout(function () {
        filterBtn.classList.remove('animate-filter-branch-btn');
      }, 400);
    },
    prepareToShowHideColumn: function prepareToShowHideColumn(currentColVal) {
      var _this = this;

      setTimeout(function () {
        _this.showHideColumn(_this.prevColVal, currentColVal);
      }, 500);
    },
    prepareToExport: function prepareToExport() {
      if (this.dateValue === '') {
        this.dateValue = 'orders.created_at';
      } else {
        this.getDependDate(this.dateValue);
      }
    },
    getPerPage: function getPerPage() {
      this.tableData.per_page = this.val;
      this.perPageFix(this.tableData.per_page);
    },
    prepareGetByWarehouse: function prepareGetByWarehouse() {
      if (this.ware === 'Select') {
        this.wareError = true;
      } else {
        this.wareError = false;
        this.tableData.warehouse = this.ware;
        this.getByWarehouse(this.tableData.warehouse);
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getConnectedBranches: function getConnectedBranches() {
      var _this2 = this;

      this.branchesList = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        result.forEach(function (r) {
          _this2.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    checkDates: function checkDates() {
      if (this.startTime.time === '' || this.startTime1.time === '') {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('', 'Please select both date!', 'warning');
      } else {
        this.filterTable(this.startTime.time, this.startTime1.time, this.dateValue);
        this.filterApplied = true;
      }
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: false,
          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          format: 'YYYY-MM-DD',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          placeholder: 'when?',
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = (0, _moment2.default)();
      } else {
        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
      // gettting previous and next month
      // let currentMonth = moment(currentMoment)
      var previousMonth = (0, _moment2.default)(currentMoment);
      var nextMonth = (0, _moment2.default)(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).date(i)
        });
        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.limit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      var tmpMoment = (0, _moment2.default)(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
      if (limit.from && !limit.to) {
        return !tmpMoment.isAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isBefore(limit.to);
      } else {
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');
          // shift activated time items to visible position.
          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = (0, _moment2.default)(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck() {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = JSON.stringify(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      // shift activated time items to visible position.
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['columns', 'sortKey', 'sortOrders', 'sortByColumn', 'sortDir', 'searchOneCol', 'checkAll', 'unCheckAll', 'loggedInUserData'],
  methods: {
    checkMainCheck: function checkMainCheck() {
      if ($('#mainCheck').is(':checked')) {
        this.checkAll();
      } else {
        this.unCheckAll();
        $('#mainCheck').is(':checked');
      }
    },
    updateArrows: function updateArrows(event, columnName) {
      var el = $(event.target).children('i');
      var className = '';

      className = this.sortDir === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
      $('.the-datatable th i').attr('class', 'fa fa-sort');
      el.attr('class', className);
    },
    singleSearch: function singleSearch(event, columnName, columnLabel) {
      var _this = this;

      event.stopPropagation();
      swal('Search ' + columnLabel, {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Type to search',
            className: 'form-control'
          }
        },
        buttons: [this.Cancel, this.Search]
      }).then(function (value) {
        if (value) {
          _this.searchOneCol(columnName, value);
        }
      });
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detialData', 'closeModal'],

  data: function data() {
    return {
      imageDialog: false,
      theImg: '',
      size: 50,
      palletNumber: '',
      bankEditing: false,
      bankSaving: false,
      banks: [],
      newBankId: null
    };
  },


  watch: {
    // The pallet is asked for separately, and only for admins who may see the pallet report.
    'detialData.order_id': {
      immediate: true,
      handler: function handler(orderId) {
        var _this = this;

        this.palletNumber = '';
        this.bankEditing = false;
        if (!orderId || !this.$_has_perm('view_pallet_report')) {
          return;
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/pallets/order/' + orderId, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
        }).then(function (response) {
          if (_this.detialData && _this.detialData.order_id === orderId) {
            _this.palletNumber = response.data.tracking_number || '';
          }
        }).catch(function () {});
      }
    }
  },

  methods: {
    startBankEdit: function startBankEdit() {
      var _this2 = this;

      var current = this.banks.find(function (b) {
        return b.bank_name === _this2.detialData.bank_name;
      });
      this.newBankId = current ? current.bank_id : null;
      this.bankEditing = true;
      if (this.banks.length) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/get_banks', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
      }).then(function (response) {
        _this2.banks = response.data.data;
        var found = _this2.banks.find(function (b) {
          return b.bank_name === _this2.detialData.bank_name;
        });
        _this2.newBankId = found ? found.bank_id : null;
      });
    },
    saveBank: function saveBank() {
      var _this3 = this;

      this.bankSaving = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/change-order-bank', { order_id: this.detialData.order_id, bank_id: this.newBankId }, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') }
      }).then(function () {
        var bank = _this3.banks.find(function (b) {
          return b.bank_id === _this3.newBankId;
        });
        _this3.detialData.bank_name = bank.bank_name;
        _this3.bankEditing = false;
      }).catch(function () {
        alert('Could not change the bank');
      }).finally(function () {
        _this3.bankSaving = false;
      });
    },
    showImage: function showImage(img) {
      this.theImg = img.order_image;
      this.imageDialog = true;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isPurchase', 'checkAll', 'unCheckAll', 'isStaff', 'isCustomer', 'isCustomerCredit', 'isOrder', 'isCoupon', 'isTransactionOrder', 'isTransactionCredit', 'isExchange'],
  methods: {
    checkMainCheck: function checkMainCheck() {
      if ($('#mainCheck').is(':checked')) {
        this.checkAll();
      } else {
        this.unCheckAll();
      }
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewOrder_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edd6922_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewOrder_vue__ = __webpack_require__(503);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edd6922_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('max_file_size', {
  getMessage: function getMessage(field, params) {
    return 'The ' + field + ' must not exceed ' + params[0] + ' MB.';
  },
  params: ['size'],
  validate: function validate(value, args) {
    if (!value || !value.length) return true; // No file selected
    var file = value[0];
    var size = parseFloat(args[0]); // Convert parameter to number
    if (!file || !file.size) return false;
    return file.size <= size * 1024 * 1024; // Convert MB to bytes
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getLoggedInUser();
  },


  props: ['addNewOrderModal', 'warehouses', 'closeAddNewOrderModal', 'checkAlert', 'deliveryTypes', 'makeOrderData', 'makeNewOrder', 'customers', 'checkURL', 'loading'],

  data: function data() {
    return {
      loggedInUserData: {},
      notCouponCode: false,
      transportationTypes: [],
      imagePreview: null
    };
  },


  methods: {
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.makeOrderData.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
    },
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      this.makeOrderData.image = null;
      this.makeOrderData.fileName = '';
      this.$validator.errors.remove('file');
      var file = event.target.files[0];
      if (file && !this.errors.has('file')) {
        this.file = file;
        this.makeOrderData.image = file;
        this.makeOrderData.fileName = file.name;
        this.imagePreview = URL.createObjectURL(file);
        // Clear URL when file is selected
        this.makeOrderData.image_url = '';
      } else {
        this.file = null;
        this.makeOrderData.image = null;
        this.imagePreview = null;
      }
    },
    clearFileOnUrlInput: function clearFileOnUrlInput() {
      if (this.makeOrderData.image_url && this.makeOrderData.image_url.trim() !== '') {
        this.makeOrderData.image = null;
        this.makeOrderData.fileName = '';
        this.imagePreview = null;
        this.$refs.fileInput.value = '';
      }
    },
    handleImageError: function handleImageError(event) {
      // Fallback to default image if URL fails to load
      event.target.src = '../../assets/images/shipzone.png';
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.makeOrderData.coupon && _this.makeOrderData.coupon.length) {
            if (_this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              _this.notCouponCode = false;
              _this.makeNewOrder();
            } else {
              _this.notCouponCode = true;
            }
          } else {
            _this.notCouponCode = false;
            _this.makeNewOrder();
          }
        }
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processTheOrder_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a91e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processTheOrder_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processTheOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5a91e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processTheOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_editPriceForTurkey_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_editPriceForUSA_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_editQuantityBaseUsa_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_editQuantityOtherUsa_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_editQuantityBaseTurkey_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_editQuantityOtherTurkey_vue__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datepicker__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editDeliveryType_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editQuantity_vue__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editProductUrl_vue__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editProductName_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editWarehouse_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__editSize_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editColor_vue__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editType_vue__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__editTransportationType_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AmazonSessionModal_vue__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'edit-price-for-turkey': __WEBPACK_IMPORTED_MODULE_0__user_editPriceForTurkey_vue__["a" /* default */],
    'edit-price-for-usa': __WEBPACK_IMPORTED_MODULE_1__user_editPriceForUSA_vue__["a" /* default */],
    'edit-quantity-base-usa': __WEBPACK_IMPORTED_MODULE_2__user_editQuantityBaseUsa_vue__["a" /* default */],
    'edit-quantity-other-usa': __WEBPACK_IMPORTED_MODULE_3__user_editQuantityOtherUsa_vue__["a" /* default */],
    'edit-quantity-base-turkey': __WEBPACK_IMPORTED_MODULE_4__user_editQuantityBaseTurkey_vue__["a" /* default */],
    'edit-quantity-other-turkey': __WEBPACK_IMPORTED_MODULE_5__user_editQuantityOtherTurkey_vue__["a" /* default */],
    'date-picker': __WEBPACK_IMPORTED_MODULE_6_vue_datepicker__["default"],
    'edit-delivery-type': __WEBPACK_IMPORTED_MODULE_7__editDeliveryType_vue__["a" /* default */],
    'edit-quantity': __WEBPACK_IMPORTED_MODULE_8__editQuantity_vue__["a" /* default */],
    'edit-product-url': __WEBPACK_IMPORTED_MODULE_9__editProductUrl_vue__["a" /* default */],
    'edit-product-name': __WEBPACK_IMPORTED_MODULE_10__editProductName_vue__["a" /* default */],
    'edit-warehouse': __WEBPACK_IMPORTED_MODULE_11__editWarehouse_vue__["a" /* default */],
    'edit-size': __WEBPACK_IMPORTED_MODULE_12__editSize_vue__["a" /* default */],
    'edit-color': __WEBPACK_IMPORTED_MODULE_13__editColor_vue__["a" /* default */],
    'edit-type': __WEBPACK_IMPORTED_MODULE_14__editType_vue__["a" /* default */],
    editTransportationType: __WEBPACK_IMPORTED_MODULE_17__editTransportationType_vue__["a" /* default */],
    AmazonSessionModal: __WEBPACK_IMPORTED_MODULE_18__AmazonSessionModal_vue__["a" /* default */]
  },

  props: ['processOrder', 'r', 'checkAlert', 'updateData', 'calculateTotalAmount', 'loading', 'getResults', 'clearProcessOrderData', 'theQuantity', 'itemTypes', 'warehouses'],

  $_veeValidate: {
    validator: 'new'
  },

  created: function created() {
    this.getLoggedInUser();
    var t = new Date();
    var dd = t.getDate();
    var mm = t.getMonth() + 1; // January is 0!
    var yyyy = t.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    t = yyyy + '-' + mm + '-' + dd;
    this.today = t;
    this.startTime.time = t;
    this.startTime1.time = t;
  },
  data: function data() {
    return {
      // editPriceForTurkeyUrl: 'api/change_price_per_weight_turkey',
      // editPriceForUSAUrl: 'api/change_price_per_weight_usa',
      // editQttBaseUSAUrl: 'api/change_usa_base_quantity',
      // editQttOtherUSAUrl: 'api/change_usa_other_quantity',
      // editQttBaseTurkeyUrl: 'api/change_turkey_base_quantity',
      // editQttOtherTurkeyUrl: 'api/change_turkey_other_quantity',
      editProductUrlUrl: 'api/change_product_url',
      editProductNameUrl: 'api/change_product_name',
      editWarehouseUrl: 'api/change_warehouse',
      editSizeUrl: 'api/change_size',
      editColorUrl: 'api/change_color',
      editTypeUrl: 'api/change_type',
      getActiveChangeRateUrl: 'api/get_active_exchange_rate',
      transportationTypes: [],
      activeChangeRate: [],
      orderTypes: [],
      subscription: [],
      exchangeBase: 0,
      order_type_id_fk: null,
      the_user_id: '',
      seccessAlert: false,
      dialog: false,
      has_other_service: false,
      edit1Modal: false,
      fromDateError: false,
      toDateError: false,
      editQttBaseUSAModal: false,
      editQttOtherUSAModal: false,
      // editQttBaseTurkeyModal: false,
      // editQttOtherTurkeyModal: false,
      deliveryTypeModal: false,
      quantityModal: false,
      editProductUrlModal: false,
      editProductNameModal: false,
      editWarehouseModal: false,
      editSizeModal: false,
      editColorModal: false,
      editTypeModal: false,
      UrlError: false,
      theEditOrderID: '',
      theImage: null,
      imagePreview: null,
      file: null,
      imgDialog: false,
      orderObj: {},
      editTransTypeModal: false,
      editProductUrlData: {
        product_url: ''
      },
      editProductNameData: {
        product_name: ''
      },
      editSizeData: {
        size: ''
      },
      editColorData: {
        color: ''
      },
      editTypeData: {
        type: ''
      },
      today: '',
      the_order_id: '',
      deliveryTypes: [{ text: 'Home Delivery', value: 'home delivery' }, { text: 'Office Delivery', value: 'office delivery' }],
      editDeliveryTypeData: {
        delivery_type: ''
      },
      editQuantityData: {
        quantity: '',
        country: ''
      },
      loggedInUserData: {},
      temp_shipping: '',
      // edit1Data: {
      //   item_weight_price_turkey: ''
      // },
      // edit2Modal: false,
      // edit2Data: {
      //   item_weight_price_usa: ''
      // },
      editQttBaseUSAData: {
        quantity_charge_base_usa: '',
        order_id: ''
      },
      // editQttBaseTurkeyData: {
      //   quantity_charge_base_turkey: '',
      //   order_id: ''
      // },
      editQttOtherUSAData: {
        quantity_charge_other_usa: '',
        order_id: ''
      },
      // editQttOtherTurkeyData: {
      //   quantity_charge_other_turkey: '',
      //   order_id: ''
      // },
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      startTime2: {
        time: ''
      },
      isInitializingDates: false,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option2: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Warehouse Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      panel: null,
      autoFillLoading: false,
      autoFillInfo: null // e.g. { source: 'amazon', item_price: 99.95, item_weight_kg: 1.2 } or { error: '...' }
    };
  },


  computed: {
    caculatePurchaseCost: function caculatePurchaseCost() {
      return Number(Number(this.updateData.item_price) * Number(this.theQuantity.quantity || this.r.quantity || 1) + Number(this.updateData.national_tax) + Number(this.updateData.delivery_price)).toFixed(2);
    },
    selectedOrderTypePrice: function selectedOrderTypePrice() {
      if (!this.subscription || !this.r.transportation_type_obj || this.r.transportation_type_obj.id === null) {
        return '0.00';
      }

      switch (this.r.transportation_type_obj.id) {
        case 1:
          // Air
          return this.subscription.item_price_air || '0.00';
        case 2:
          // Sea
          return this.subscription.item_price_sea || '0.00';
        default:
          // Land
          return this.subscription.item_price_land || '0.00';
      }
    }
  },

  watch: {
    dialog: function dialog(val) {
      var _this = this;

      if (val) {
        this.autoFillInfo = null;
        this.autoFillLoading = false;
        this.imagePreview = null;
        this.updateData.transportation_type = this.r.transportation_type;

        this.updateData.is_repackage = this.r.is_repackage;
        this.updateData.is_hold = this.r.is_hold;
        this.updateData.other_service = this.r.other_service;
        this.has_other_service = !!(this.r.other_service && this.r.other_service.trim());
        this.transportationTypes = this.r.warehouse.transportation_types;

        // 1. Immediately default order_type_id_fk to 'Normal Goods' or order's existing type
        if (this.r.order_type_id_fk) {
          this.order_type_id_fk = this.r.order_type_id_fk;
        } else if (this.orderTypes && this.orderTypes.length > 0) {
          var normalGoods = this.orderTypes.find(function (t) {
            return t.text && t.text.toLowerCase().includes('normal');
          });
          this.order_type_id_fk = normalGoods ? normalGoods.value : this.orderTypes[0].value;
        } else {
          this.order_type_id_fk = 1; // Standard 'Normal Goods' id
        }
        this.updateData.order_type_id_fk = this.order_type_id_fk;
        this.getOrderTypes();

        // 2. Immediately initialize pre-filled values from this.r if present in the database
        var hasPreFilledPrice = this.r.item_price !== null && this.r.item_price !== undefined && this.r.item_price !== '' && Number(this.r.item_price) > 0;
        var hasPreFilledWeight = this.r.item_weight !== null && this.r.item_weight !== undefined && this.r.item_weight !== '' && Number(this.r.item_weight) > 0;

        if (hasPreFilledPrice) {
          this.updateData.item_price = Number(this.r.item_price);
        }
        if (hasPreFilledWeight) {
          this.updateData.item_weight = Number(this.r.item_weight);
          this.updateData.item_weight_lb = Number((Number(this.r.item_weight) / 0.4545).toFixed(2));
        }

        // Initialize taxes and delivery fees
        if (this.r.country === 'United States') {
          this.updateData.national_tax = Number(this.r.national_tax) || 0;
          this.updateData.delivery_price = Number(this.r.delivery_price) || 0;
        } else {
          if (this.r.national_tax !== null && this.r.national_tax !== undefined) {
            this.updateData.national_tax = Number(this.r.national_tax);
          }
          if (this.r.delivery_price !== null && this.r.delivery_price !== undefined) {
            this.updateData.delivery_price = Number(this.r.delivery_price);
          }
        }

        // Dates: Warehouse Date, From Date, To Date
        this.isInitializingDates = true;
        if (this.r.warehouse_date) {
          this.startTime2.time = this.r.warehouse_date;
        } else {
          this.startTime2.time = this.today;
        }

        if (this.r.from_date) {
          this.startTime.time = this.r.from_date;
        } else {
          var computed = this.calculateDatesFromWarehouse(this.startTime2.time || this.today);
          this.startTime.time = computed.from_date;
        }

        if (this.r.to_date) {
          this.startTime1.time = this.r.to_date;
        } else {
          var _computed = this.calculateDatesFromWarehouse(this.startTime2.time || this.today);
          this.startTime1.time = _computed.to_date;
        }

        this.$nextTick(function () {
          _this.isInitializingDates = false;
        });

        this.fromDateError = false;
        this.toDateError = false;

        if (this.r.image) {
          this.imagePreview = this.r.image.startsWith('http') ? this.r.image : '' + this.$_image_path() + this.r.image;
        }

        // 3. AutoFill behavior:
        // If the order already has item_price populated in DB, do NOT show loading or delay staff.
        // Immediately show pre-filled banner ready for 1-click approval.
        if (hasPreFilledPrice) {
          this.autoFillLoading = false;
          this.autoFillInfo = {
            source: 'Pre-filled Order',
            item_price: this.updateData.item_price,
            item_weight_kg: this.updateData.item_weight,
            warehouse_date: this.startTime2.time,
            from_date: this.startTime.time,
            to_date: this.startTime1.time
          };
          this.calculateIntShipping();
          this.calculateTotalAmount();
        } else if (this.r.country === 'United States' && this.r.product_url) {
          this.autoFillFromProductUrl(this.r.order_id);
        }
      }
    },
    'has_other_service': function has_other_service(val) {
      if (!val && !this.updateData.other_service) {
        // Clear other service price when checkbox is unchecked and there's no existing other service data
        this.updateData.other_service_price = 0;
        this.calculateTotalAmount();
      }
    },
    'startTime2.time': function startTime2Time(newVal, oldVal) {
      if (this.isInitializingDates) return;
      if (newVal && newVal !== oldVal && this.dialog) {
        var computed = this.calculateDatesFromWarehouse(newVal);
        if (computed.from_date) {
          this.startTime.time = computed.from_date;
        }
        if (computed.to_date) {
          this.startTime1.time = computed.to_date;
        }
      }
    },
    selectedOrderTypePrice: function selectedOrderTypePrice(newPrice) {
      if (newPrice && newPrice !== '0.00') {
        this.updateData.price_weight = newPrice;
        this.calculateTotalAmount();
      }
    }
  },

  methods: {
    showImage: function showImage(img) {
      this.theImage = img;
      this.imgDialog = true;
    },
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      this.updateData.customer_process_note_image = null;
      this.updateData.fileName = '';
      this.$validator.errors.remove('file');
      var file = event.target.files[0];
      if (file && !this.errors.has('file')) {
        this.file = file;
        this.updateData.customer_process_note_image = file;
        this.updateData.fileName = file.name;
        this.imagePreview = URL.createObjectURL(file);
      } else {
        this.file = null;
        this.updateData.customer_process_note_image = null;
        this.imagePreview = null;
      }
    },


    // calculateUSDPrice(tlPrice, country) {
    //   let usdPrice = tlPrice / this.exchangeBase
    //   usdPrice = Number(usdPrice).toFixed(2)
    //   this.updateData.item_price = usdPrice

    //   this.calculateShipzoneFee(
    //     this.updateData.item_price,
    //     this.defaultPriceData.kreenex_fee_percentage,
    //     country
    //   )
    //   this.calculateTotalAmount()
    // },

    openAmazonSessionModal: function openAmazonSessionModal() {
      if (this.$refs.amazonSessionModal) {
        this.$refs.amazonSessionModal.open();
      }
    },
    isAmazonUrl: function isAmazonUrl(url) {
      if (!url) return false;
      var lower = url.toLowerCase();
      return lower.includes('amazon') || lower.includes('a.co') || lower.includes('amzn.');
    },


    // ---------------------------------------------------------------
    // Auto-fill price / weight / image from product URL (US orders)
    // ---------------------------------------------------------------
    autoFillFromProductUrl: function autoFillFromProductUrl(orderId) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.autoFillLoading = true;
      this.autoFillInfo = null;

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get('api/orders/' + orderId + '/auto-fill', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;

        if (data.error) {
          _this2.autoFillInfo = { error: data.error };
          return;
        }

        // If canonical URL was resolved, update the order's product_url in the modal
        if (data.canonical_url && _this2.r) {
          _this2.r.product_url = data.canonical_url;
        }

        // ── Item Price ──
        if (data.item_price !== null && data.item_price !== undefined) {
          _this2.updateData.item_price = Number(data.item_price);
        }

        // ── Item Weight (KG) ──
        if (data.item_weight_kg !== null && data.item_weight_kg !== undefined) {
          _this2.updateData.item_weight = Number(data.item_weight_kg);
          _this2.updateData.item_weight_lb = Number((Number(data.item_weight_kg) / 0.4545).toFixed(2));
        }

        // ── International Tax = 0; Delivery Price = retailer shipping to the warehouse (eBay), else 0 ──
        _this2.updateData.national_tax = 0;
        _this2.updateData.delivery_price = Number(data.delivery_price) || 0;

        // ── Auto-fill Dates from Product Delivery info (Warehouse, From, To) ──
        _this2.isInitializingDates = true;
        if (data.warehouse_date) {
          _this2.startTime2.time = data.warehouse_date;
        } else if (!_this2.startTime2.time) {
          _this2.startTime2.time = _this2.today;
        }

        if (data.from_date) {
          _this2.startTime.time = data.from_date;
        } else {
          var computed = _this2.calculateDatesFromWarehouse(_this2.startTime2.time || _this2.today);
          _this2.startTime.time = computed.from_date;
        }

        if (data.to_date) {
          _this2.startTime1.time = data.to_date;
        } else {
          var _computed2 = _this2.calculateDatesFromWarehouse(_this2.startTime2.time || _this2.today);
          _this2.startTime1.time = _computed2.to_date;
        }

        _this2.$nextTick(function () {
          _this2.isInitializingDates = false;
        });

        // Clear validation errors if any were showing
        _this2.fromDateError = false;
        _this2.toDateError = false;

        // ── Product image URL (stored separately so the submit can send it) ──
        if (data.image_url) {
          _this2.updateData.auto_image_url = data.image_url;
          _this2.$set(_this2.r, 'image', data.image_url);
          // Show a preview thumbnail if no image was manually uploaded
          if (!_this2.imagePreview) {
            _this2.imagePreview = data.image_url;
          }
        }

        // Re-calculate totals after filling
        _this2.calculateIntShipping();
        _this2.calculateTotalAmount();

        // Show success info banner
        _this2.autoFillInfo = {
          source: data.source,
          warning: data.warning,
          item_price: data.item_price,
          item_weight_kg: data.item_weight_kg,
          ai_weight_kg: data.ai_weight_kg,
          ai_confidence: data.ai_confidence,
          ai_reasoning: data.ai_reasoning,
          weight_breakdown: data.weight_breakdown,
          delivery_text: data.delivery_text,
          warehouse_date: _this2.startTime2.time,
          from_date: _this2.startTime.time,
          to_date: _this2.startTime1.time
        };
      }).catch(function (err) {
        console.warn('Auto-fill failed:', err);
        _this2.autoFillInfo = { error: 'Could not auto-fill product data.' };
      }).finally(function () {
        _this2.autoFillLoading = false;
      });
    },
    getExchangeRate: function getExchangeRate() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(this.getActiveChangeRateUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.activeChangeRate = [];
        _this3.activeChangeRate = response.data.data;
        var base = _this3.activeChangeRate.tl_price / _this3.activeChangeRate.usd_price;
        base = Number(base).toFixed(2);
        _this3.exchangeBase = base;
      });
    },
    convertLbToKg: function convertLbToKg() {
      if (this.updateData.item_weight_lb && this.updateData.item_weight_lb > 0) {
        // Convert LB to KG (1 pound = 0.453592 kg)
        var kgValue = this.updateData.item_weight_lb * 0.4545;
        this.updateData.item_weight = Number(kgValue.toFixed(4));

        // Trigger the calculations that depend on weight
        this.calculateIntShipping();
        this.calculateTotalAmount();
      }
    },
    openEditProductUrlModal: function openEditProductUrlModal(url, orderID) {
      this.theEditOrderID = orderID;
      this.editProductUrlData.product_url = url;
      this.editProductUrlModal = true;
    },
    openEditProductNameModal: function openEditProductNameModal(name, orderID) {
      this.theEditOrderID = orderID;
      this.editProductNameData.product_name = name;
      this.editProductNameModal = true;
    },
    closeEditProductUrlModal: function closeEditProductUrlModal() {
      this.editProductUrlData.product_url = '';
      this.editProductUrlModal = false;
      this.UrlError = false;
      this.seccessAlert = false;
    },
    closeEditProductNameModal: function closeEditProductNameModal() {
      this.editProductNameData.product_name = '';
      this.editProductNameModal = false;
      this.NameError = false;
      this.seccessAlert = false;
    },
    editProductUrl: function editProductUrl() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editProductUrlUrl + '/' + this.theEditOrderID, this.editProductUrlData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.UrlError = false;
        _this4.seccessAlert = true;
        setTimeout(function () {
          _this4.closeEditProductUrlModal();
        }, 1500);
        _this4.getResults();
      }).catch(function (error) {
        _this4.seccessAlert = false;
        if (error.response.data.message.product_url) {
          _this4.UrlError = true;
        }
      });
    },
    editProductName: function editProductName() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editProductNameUrl + '/' + this.theEditOrderID, this.editProductNameData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this5.UrlError = false;
        _this5.seccessAlert = true;
        setTimeout(function () {
          _this5.closeEditProductUrlModal();
        }, 1500);
        _this5.getResults();
      }).catch(function (error) {
        _this5.seccessAlert = false;
        if (error.response.data.message.product_name) {
          _this5.NameError = true;
        }
      });
    },
    openEditTransportationTypeModal: function openEditTransportationTypeModal(order) {
      this.orderObj = order;
      this.editTransTypeModal = true;
    },
    openEditWarehouseModal: function openEditWarehouseModal(warehouse, orderID) {
      this.theEditOrderID = orderID;
      this.editWarehouseData.warehouse_id_fk = warehouse;
      this.editWarehouseModal = true;
    },
    closeEditWarehouseModal: function closeEditWarehouseModal() {
      this.theEditOrderID = '';
      this.editWarehouseData.warehouse_id_fk = '';
      this.editWarehouseModal = false;
      this.seccessAlert = false;
    },
    editWarehouse: function editWarehouse(orderId, warehouseIdFk) {
      var _this6 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editWarehouseUrl + '/' + orderId, { warehouse_id_fk: warehouseIdFk }, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this6.seccessAlert = true;
        _this6.getResults();
        _this6.getOrderTypes();
      }).then(function () {
        setTimeout(function () {
          _this6.transportationTypes = _this6.r.warehouse.transportation_types;
          _this6.order_type_id_fk = null;
        }, 1000);
      });
    },
    editTransportationTypeSave: function editTransportationTypeSave(orderId, transportationType) {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put('api/order/' + orderId + '/change-transportation-type', { transportation_type: transportationType }, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
        _this7.getResults();
        _this7.order_type_id_fk = null;
        _this7.updateData.transportation_type = transportationType;
      });
    },
    openEditSizeModal: function openEditSizeModal(size, orderID) {
      this.theEditOrderID = orderID;
      this.editSizeData.size = size;
      this.editSizeModal = true;
    },
    closeEditSizeModal: function closeEditSizeModal() {
      this.theEditOrderID = '';
      this.editSizeData.size = '';
      this.editSizeModal = false;
      this.seccessAlert = false;
    },
    editSize: function editSize() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editSizeUrl + '/' + this.theEditOrderID, this.editSizeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this8.seccessAlert = true;
        _this8.getResults();
      });
    },
    openEditColorModal: function openEditColorModal(color, orderID) {
      this.theEditOrderID = orderID;
      this.editColorData.color = color;
      this.editColorModal = true;
    },
    openEditTypeModal: function openEditTypeModal(type, orderID) {
      this.theEditOrderID = orderID;
      this.editTypeData.type = type;
      this.editTypeModal = true;
    },
    closeEditColorModal: function closeEditColorModal() {
      this.theEditOrderID = '';
      this.editColorData.size = '';
      this.editColorModal = false;
      this.seccessAlert = false;
    },
    editColor: function editColor() {
      var _this9 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editColorUrl + '/' + this.theEditOrderID, this.editColorData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this9.seccessAlert = true;
        _this9.getResults();
      });
    },
    closeEditTypeModal: function closeEditTypeModal() {
      this.theEditOrderID = '';
      this.editTypeData.type = '';
      this.editTypeModal = false;
      this.seccessAlert = false;
    },
    editType: function editType() {
      var _this10 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editTypeUrl + '/' + this.theEditOrderID, this.editTypeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this10.seccessAlert = true;
        _this10.getResults();
      });
    },
    openEditQuantityModal: function openEditQuantityModal(orderId) {
      this.quantityModal = true;
      this.the_order_id = orderId;
    },
    closeEditQuantityModal: function closeEditQuantityModal() {
      this.quantityModal = false;
      this.editQuantityData.quantity = '';
      this.editQuantityData.country = '';
      this.seccessAlert = false;
    },
    editQuantity: function editQuantity() {
      var _this11 = this;

      this.editQuantityData.country = this.r.country;
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put('api/orders/' + this.the_order_id + '/quantity', this.editQuantityData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this11.updateData.quantity_charge = response.data.data.quantity_charge;
        _this11.theQuantity.quantity = response.data.data.quantity;
        _this11.calculateIntShipping();
        _this11.calculateTotalAmount();
        _this11.seccessAlert = true;
        _this11.editQuantityData.quantity = '';
        _this11.editQuantityData.country = '';
        _this11.the_order_id = '';
        _this11.getResults();
      }).catch(function () {
        _this11.editQuantityData.quantity = '';
        _this11.editQuantityData.country = '';
        _this11.the_order_id = '';
      });
    },
    openEditDeliveryTypeModal: function openEditDeliveryTypeModal(orderId) {
      this.deliveryTypeModal = true;
      this.the_order_id = orderId;
    },
    closeEditDeliveryTypeModal: function closeEditDeliveryTypeModal() {
      this.deliveryTypeModal = false;
      this.editDeliveryTypeData.delivery_type = '';
      this.seccessAlert = false;
    },
    editDeliveryType: function editDeliveryType() {
      var _this12 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put('api/orders/' + this.the_order_id + '/delivery_type', this.editDeliveryTypeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this12.seccessAlert = true;
        _this12.editDeliveryTypeData.delivery_type = '';
        _this12.the_order_id = '';
        _this12.getResults();
      }).catch(function () {
        _this12.editDeliveryTypeData.delivery_type = '';
        _this12.the_order_id = '';
      });
    },


    // calculateIntShipping(warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
    //   if (coupon) {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shippingPrice2 = 0
    //       this.temp_shipping = (priceForTurkey * this.updateData.item_weight).toFixed(2)
    //       shippingPrice2 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //       shippingPrice2 = shippingPrice2 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
    //     } else {
    //       let shippingPrice1 = 0
    //       this.temp_shipping = (priceForUsa * this.updateData.item_weight).toFixed(2)
    //       shippingPrice1 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //       shippingPrice1 = shippingPrice1 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
    //     }
    //   } else {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shipPrice1 = priceForTurkey * this.updateData.item_weight
    //       shipPrice1 = shipPrice1 * qtt
    //       shipPrice1 = Number(shipPrice1).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice1
    //       this.temp_shipping = shipPrice1
    //     } else {
    //       let shipPrice = priceForUsa * this.updateData.item_weight
    //       shipPrice = shipPrice * qtt
    //       shipPrice = Number(shipPrice).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice
    //       this.temp_shipping = shipPrice
    //     }
    //   }
    // },

    // calculateIntShipping2(tmp, warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
    //   if (coupon) {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shippingPrice2 = 0
    //       shippingPrice2 = tmp
    //       shippingPrice2 = shippingPrice2 - (shippingPrice2 * percentage) / 100
    //       shippingPrice2 = shippingPrice2 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
    //     } else {
    //       let shippingPrice1 = 0
    //       shippingPrice1 = tmp
    //       shippingPrice1 = shippingPrice1 - (shippingPrice1 * percentage) / 100
    //       shippingPrice1 = shippingPrice1 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
    //     }
    //   } else {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shipPrice1 = priceForTurkey * this.updateData.item_weight
    //       shipPrice1 = shipPrice1 * qtt
    //       shipPrice1 = Number(shipPrice1).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice1
    //       this.temp_shipping = shipPrice1
    //     } else {
    //       let shipPrice = priceForUsa * this.updateData.item_weight
    //       shipPrice = shipPrice * qtt
    //       shipPrice = Number(shipPrice).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice
    //       this.temp_shipping = shipPrice
    //     }
    //   }
    // },

    // calculateIntShipping3(coupon, percentage, itemType, qtt) {
    //   let itemTypeShippingPrice = 0

    //   let k = this.itemTypes.findIndex((item) => item.value === itemType)
    //   itemTypeShippingPrice = this.itemTypes[k].shippingPrice

    //   itemTypeShippingPrice = Number(itemTypeShippingPrice)

    //   if (coupon) {
    //     let shippingPrice3 = 0
    //     this.temp_shipping = itemTypeShippingPrice.toFixed(2)
    //     shippingPrice3 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //     shippingPrice3 = shippingPrice3 * qtt
    //     this.updateData.internal_shipping_handling = shippingPrice3.toFixed(2)
    //   } else {
    //     let shipPrice = itemTypeShippingPrice
    //     shipPrice = shipPrice * qtt
    //     shipPrice = Number(shipPrice)
    //     this.updateData.internal_shipping_handling = shipPrice
    //     this.temp_shipping = shipPrice
    //   }
    // },

    // calculateShipzoneFee(itemPrice, percentage, country) {
    //   percentage = Number(percentage)
    //   if (itemPrice < this.defaultPriceData.kreenex_fee_base_usa && itemPrice > 0) {
    //     this.updateData.kreenex_fee = this.defaultPriceData.kreenex_fee_usa.toFixed(2)
    //   } else {
    //     this.updateData.kreenex_fee = (
    //       this.defaultPriceData.kreenex_fee_usa +
    //       itemPrice * percentage
    //     ).toFixed(2)
    //   }
    // },

    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    submitOrder: function submitOrder(event, id) {
      var _this13 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this13.startTime.time <= _this13.today) {
            _this13.toDateError = false;
            _this13.fromDateError = true;
          } else if (_this13.startTime1.time <= _this13.startTime.time) {
            _this13.fromDateError = false;
            _this13.toDateError = true;
          } else {
            _this13.toDateError = false;
            _this13.fromDateError = false;
            _this13.updateData.from_date = _this13.startTime.time;
            _this13.updateData.to_date = _this13.startTime1.time;
            _this13.updateData.warehouse_date = _this13.startTime2.time;
            _this13.updateData.tmp_shipping = _this13.temp_shipping;
            _this13.updateData.order_type_id_fk = _this13.order_type_id_fk;
            _this13.temp_shipping = '';
            _this13.processOrder(event, id, _this13.startTime, _this13.startTime1, _this13.startTime2);
          }
        }
      });
    },
    openEdit1Modal: function openEdit1Modal(id) {
      this.edit1Modal = true;
      this.the_user_id = id;
    },
    closeEdit1Modal: function closeEdit1Modal() {
      this.edit1Modal = false;
      // this.edit1Data.item_weight_price_turkey = ''
      this.seccessAlert = false;
    },
    getOrderTypes: function getOrderTypes() {
      var _this14 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get('api/subscription-pricing/get-order-types/' + this.r.warehouse_id_fk, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        _this14.orderTypes = []; // Clear existing order types
        result.forEach(function (r) {
          _this14.orderTypes.push({
            text: r.type_name,
            value: r.order_type_id,
            type_price_air: r.type_price_air,
            type_price_sea: r.type_price_sea,
            type_price_land: r.type_price_land
          });
        });

        // Default Order Type to "Normal Goods" if not already set or invalid
        if (_this14.orderTypes.length > 0) {
          var normalGoods = _this14.orderTypes.find(function (t) {
            return t.text && t.text.toLowerCase().includes('normal');
          });
          var normalVal = normalGoods ? normalGoods.value : _this14.orderTypes[0].value;
          if (!_this14.order_type_id_fk || !_this14.orderTypes.some(function (t) {
            return t.value === _this14.order_type_id_fk;
          })) {
            _this14.order_type_id_fk = normalVal;
          }
        }
        _this14.updateData.order_type_id_fk = _this14.order_type_id_fk;

        _this14.getCustomerPriceList();
      });
    },
    getCustomerPriceList: function getCustomerPriceList() {
      var _this15 = this;

      var token = localStorage.getItem('access_token');
      var params = {
        customer_id_fk: this.r.user_id,
        warehouse_id_fk: this.r.warehouse_id_fk,
        order_type_id_fk: this.order_type_id_fk
      };
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.post('api/subscription-pricing/customer-price', params, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this15.subscription = data.data;
        _this15.calculateIntShipping();
      }).catch(function (errors) {}).finally(function () {
        _this15.calculateTotalAmount();
      });
    },
    calculateIntShipping: function calculateIntShipping() {
      if (!this.subscription || Array.isArray(this.subscription)) {
        return;
      }
      this.updateData.local_delivery = Number(this.subscription.local_delivery || 0);
      this.updateData.kreenex_fee = (Number(this.updateData.item_price) <= 0 ? 0 : 0.5 * Number(this.subscription.order_shipzone_fee || 0) * (Math.floor(this.caculatePurchaseCost / 50) + 1)).toFixed(2);
      var transId = this.r.transportation_type_obj ? this.r.transportation_type_obj.id : this.r.transportation_type || 1;
      var unitPrice = transId === 1 ? Number(this.subscription.item_price_air || 0) : transId === 2 ? Number(this.subscription.item_price_sea || 0) : Number(this.subscription.item_price_land || 0);
      this.updateData.internal_shipping_handling = (unitPrice * Number(this.updateData.item_weight || 0) * (this.theQuantity.quantity || this.r.quantity || 1)).toFixed(2);
    },
    calculateDatesFromWarehouse: function calculateDatesFromWarehouse(warehouseDateStr) {
      if (!warehouseDateStr) return { from_date: '', to_date: '' };
      var parts = String(warehouseDateStr).split('-');
      if (parts.length !== 3) return { from_date: '', to_date: '' };

      var y = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10) - 1;
      var d = parseInt(parts[2], 10);
      var whDate = new Date(y, m, d);
      if (isNaN(whDate.getTime())) return { from_date: '', to_date: ''

        // Flight = the first Friday strictly after warehouse arrival (same as the backend)
      };var base = new Date(y, m, d);
      var daysToFriday = 5 - base.getDay();
      if (daysToFriday <= 0) {
        daysToFriday += 7;
      }
      var flightDay = base.getDate() + daysToFriday;

      var fromDate = new Date(base.getFullYear(), base.getMonth(), flightDay + 9);
      var toDate = new Date(base.getFullYear(), base.getMonth(), flightDay + 16);

      var fromY = fromDate.getFullYear();
      var fromM = String(fromDate.getMonth() + 1).padStart(2, '0');
      var fromD = String(fromDate.getDate()).padStart(2, '0');

      var toY = toDate.getFullYear();
      var toM = String(toDate.getMonth() + 1).padStart(2, '0');
      var toD = String(toDate.getDate()).padStart(2, '0');

      return {
        from_date: fromY + '-' + fromM + '-' + fromD,
        to_date: toY + '-' + toM + '-' + toD
      };
    },


    // editPriceForTurkey() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .put(this.editPriceForTurkeyUrl + '/' + this.the_user_id, this.edit1Data, {
    //       headers: { Authorization: 'Bearer ' + token }
    //     })
    //     .then((response) => {
    //       this.seccessAlert = true
    //       // this.edit1Data.item_weight_price_turkey = ''
    //       this.getResults()
    //     })
    //     .catch((error) => {
    //       // this.edit1Data.item_weight_price_turkey = ''
    //       swal('Error', `${error.response.data.message}`, 'error')
    //     })
    // },

    handleOrderTypeChange: function handleOrderTypeChange() {
      this.isShipmentManual = false;
      this.isHandlingFeeManual = false;
      this.updateData.order_type_id_fk = this.order_type_id_fk;
      this.getCustomerPriceList();
    },
    openEdit2Modal: function openEdit2Modal(id) {
      this.edit2Modal = true;
      this.the_user_id = id;
    },
    closeEdit2Modal: function closeEdit2Modal() {
      this.edit2Modal = false;
      // this.edit2Data.item_weight_price_usa = ''
      this.seccessAlert = false;
    },
    editPriceForUSA: function editPriceForUSA() {
      var _this16 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editPriceForUSAUrl + '/' + this.the_user_id, this.edit2Data, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this16.seccessAlert = true;
        // this.edit2Data.item_weight_price_usa = ''
        _this16.getResults();
      }).catch(function (error) {
        // this.edit2Data.item_weight_price_usa = ''
        __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openEditQttBaseUSAModal: function openEditQttBaseUSAModal(id, orderId) {
      this.editQttBaseUSAModal = true;
      this.the_user_id = id;
      this.editQttBaseUSAData.order_id = orderId;
    },
    closeEditQttBaseUSAModal: function closeEditQttBaseUSAModal() {
      this.editQttBaseUSAModal = false;
      this.editQttBaseUSAData.quantity_charge_base_usa = '';
      this.seccessAlert = false;
    },
    editQttBaseUSA: function editQttBaseUSA() {
      var _this17 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editQttBaseUSAUrl + '/' + this.the_user_id, this.editQttBaseUSAData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this17.seccessAlert = true;
        _this17.editQttBaseUSAData.quantity_charge_base_usa = '';
        _this17.getResults();
        var a = _this17;
        setTimeout(function () {
          a.updateData.quantity_charge = a.r.quantity_charge;
          a.calculateTotalAmount();
        }, 1000);
      }).catch(function (error) {
        _this17.editQttBaseUSAData.quantity_charge_base_usa = '';
        __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openEditQttOtherUSAModal: function openEditQttOtherUSAModal(id, orderId) {
      this.editQttOtherUSAModal = true;
      this.the_user_id = id;
      this.editQttOtherUSAData.order_id = orderId;
    },
    closeEditQttOtherUSAModal: function closeEditQttOtherUSAModal() {
      this.editQttOtherUSAModal = false;
      this.editQttOtherUSAData.quantity_charge_base_usa = '';
      this.seccessAlert = false;
    },
    editQttOtherUSA: function editQttOtherUSA() {
      var _this18 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editQttOtherUSAUrl + '/' + this.the_user_id, this.editQttOtherUSAData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this18.seccessAlert = true;
        _this18.editQttOtherUSAData.quantity_charge_base_usa = '';
        _this18.getResults();
        var a = _this18;
        setTimeout(function () {
          a.updateData.quantity_charge = a.r.quantity_charge;
          a.calculateTotalAmount();
        }, 1000);
      }).catch(function (error) {
        _this18.editQttOtherUSAData.quantity_charge_base_usa = '';
        __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openEditQttBaseTurkeyModal: function openEditQttBaseTurkeyModal(id, orderId) {
      this.editQttBaseTurkeyModal = true;
      this.the_user_id = id;
      this.editQttBaseTurkeyData.order_id = orderId;
    },
    closeEditQttBaseTurkeyModal: function closeEditQttBaseTurkeyModal() {
      this.editQttBaseTurkeyModal = false;
      this.editQttBaseTurkeyData.quantity_charge_base_turkey = '';
      this.seccessAlert = false;
    },
    editQttBaseTurkey: function editQttBaseTurkey() {
      var _this19 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editQttBaseTurkeyUrl + '/' + this.the_user_id, this.editQttBaseTurkeyData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this19.seccessAlert = true;
        _this19.editQttBaseTurkeyData.quantity_charge_base_turkey = '';
        _this19.getResults();
        var a = _this19;
        setTimeout(function () {
          a.updateData.quantity_charge = a.r.quantity_charge;
          a.calculateTotalAmount();
        }, 1000);
      }).catch(function (error) {
        _this19.editQttBaseTurkeyData.quantity_charge_base_turkey = '';
        __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openEditQttOtherTurkeyModal: function openEditQttOtherTurkeyModal(id, orderId) {
      this.editQttOtherTurkeyModal = true;
      this.the_user_id = id;
      this.editQttOtherTurkeyData.order_id = orderId;
    },
    closeEditQttOtherTurkeyModal: function closeEditQttOtherTurkeyModal() {
      this.editQttOtherTurkeyModal = false;
      this.editQttOtherTurkeyData.quantity_charge_other_turkey = '';
      this.seccessAlert = false;
    },
    editQttOtherTurkey: function editQttOtherTurkey() {
      var _this20 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(this.editQttOtherTurkeyUrl + '/' + this.the_user_id, this.editQttOtherTurkeyData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this20.seccessAlert = true;
        _this20.editQttOtherTurkeyData.quantity_charge_other_turkey = '';
        _this20.getResults();
        var a = _this20;
        setTimeout(function () {
          a.updateData.quantity_charge = a.r.quantity_charge;
          a.calculateTotalAmount();
        }, 1000);
      }).catch(function (error) {
        _this20.editQttOtherTurkeyData.quantity_charge_other_turkey = '';
        __WEBPACK_IMPORTED_MODULE_16_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'edit1Modal', 'closeEdit1Modal', 'edit1Data', 'editPriceForTurkey'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editPriceForTurkey();
        }
      });
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'edit2Modal', 'closeEdit2Modal', 'edit2Data', 'editPriceForUSA'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editPriceForUSA();
        }
      });
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editQttBaseUSAModal', 'closeEditQttBaseUSAModal', 'editQttBaseUSAData', 'editQttBaseUSA'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editQttBaseUSA();
        }
      });
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editQttOtherUSAModal', 'closeEditQttOtherUSAModal', 'editQttOtherUSAData', 'editQttOtherUSA'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editQttOtherUSA();
        }
      });
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editQttBaseTurkeyModal', 'closeEditQttBaseTurkeyModal', 'editQttBaseTurkeyData', 'editQttBaseTurkey'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editQttBaseTurkey();
        }
      });
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editQttOtherTurkeyModal', 'closeEditQttOtherTurkeyModal', 'editQttOtherTurkeyData', 'editQttOtherTurkey'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editQttOtherTurkey();
        }
      });
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'deliveryTypeModal', 'closeEditDeliveryTypeModal', 'editDeliveryTypeData', 'editDeliveryType', 'deliveryTypes'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editDeliveryType();
        }
      });
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'quantityModal', 'closeEditQuantityModal', 'editQuantityData', 'editQuantity'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editQuantity();
        }
      });
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editProductUrlModal', 'closeEditProductUrlModal', 'editProductUrlData', 'editProductUrl', 'UrlError'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editProductUrl();
        }
      });
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editProductNameModal', 'closeEditProductNameModal', 'editProductNameData', 'editProductName', 'UrlError'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editProductName();
        }
      });
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editWarehouseModal', 'closeEditWarehouseModal', 'editWarehouseData', 'editWarehouse', 'warehouses'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editWarehouse();
        }
      });
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editSizeModal', 'closeEditSizeModal', 'editSizeData', 'editSize'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editSize();
        }
      });
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editColorModal', 'closeEditColorModal', 'editColorData', 'editColor'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editColor();
        }
      });
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['seccessAlert', 'editTypeModal', 'closeEditTypeModal', 'editTypeData', 'editType'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editType();
        }
      });
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editTransTypeModal', 'form'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/order/' + _this.form.order_id + '/change-transportation-type', _this.form, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Done', '', 'success');
            _this.$emit('close');
            _this.$emit('update-data');
          });
        }
      });
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cancelOrderModal', 'closeCancelingOrderModal', 'cancelAlert', 'cancelData', 'cancelingOrder', 'reasons'],

  data: function data() {
    return {
      selectedReason: null
    };
  },


  watch: {
    cancelOrderModal: function cancelOrderModal(newVal) {
      if (!newVal) {
        this.selectedReason = null;
      }
    }
  },

  methods: {
    updateReasons: function updateReasons() {
      var _this = this;

      if (this.selectedReason) {
        // Find the selected reason object with all translations
        var reasonObj = this.reasons.find(function (r) {
          return r.value === _this.selectedReason;
        });
        if (reasonObj) {
          // Add a short timeout to ensure Vue has updated the model
          setTimeout(function () {
            _this.cancelData.cancel_reason = reasonObj.value;
            _this.cancelData.cancel_reason_ar = reasonObj.ar;
            _this.cancelData.cancel_reason_ku = reasonObj.ku;
          }, 0);
        }
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this2.cancelingOrder();
        }
      });
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__processTheOrder_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__adminCancelOrder__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'process-the-order': __WEBPACK_IMPORTED_MODULE_7__processTheOrder_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    adminCancelOrder: __WEBPACK_IMPORTED_MODULE_8__adminCancelOrder__["a" /* default */]
  },

  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
        var value = window.location.search.replace('?order=', '');
        this.searchOneCol('order_id', value);
      }
    }
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getItemType();
    this.getDefaultPrices();
    this.getWarehouses();
    this.getReasons();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },


  $_veeValidate: {
    validator: 'new'
  },

  watch: {
    $route: function $route() {
      if (this.queryParameter === true) {
        if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
          var value = window.location.search.replace('?order=', '');
          this.searchOneCol('order_id', value);
        }
      }
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '3',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches'
    // },
    {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'order_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      processOrderUrl: 'api/orders',
      url: 'api/pending_answer_order',
      orderDetailUrl: 'api/show_order_detail',
      getCustomerUrl: 'api/get-customer-to-select',
      getItemTypeUrl: 'api/get-item-type',
      getDefaultPriceUrl: 'api/default_price',
      qrCodeValues: [],
      rowIndex: '',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      alertValue: false,
      checkAlert: false,
      checkURL: false,
      warehouses: [],
      reasons: [],
      deliveryTypes: [{ text: 'Home Delivery', value: 'home delivery' }, { text: 'Office Delivery', value: 'office delivery' }],
      customers: [],
      itemTypeResult: [],
      itemTypes: [],
      temp_shipping: '',
      theCancelOrderID: '',
      cancelAlert: false,
      cancelData: {
        cancel_reason: ''
      },
      cancelOrderModal: false,
      updateData: {
        item_price: '',
        the_tl_price: '',
        tax: '',
        national_tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        delivery_price: '',
        kreenex_fee: '',
        quantity_charge: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        description: '',
        tmp_shipping: '',
        send_sms: false,
        discount: '',
        item_type: '',
        is_hold: false,
        is_repackage: false,
        other_service_price: '',
        auto_image_url: null,
        process_note: '',
        customer_process_note: '',
        order_type_id_fk: null
      },
      detialData: {},
      priceValues: {
        item_price: 0,
        internal_shipping_handling: 0,
        tax: 0,
        delivery_price: 0,
        quantity_charge: 0,
        kreenex_fee: 0,
        insurance: 0,
        discount: 0
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      customersResult: [],
      theQuantity: {
        quantity: ''
      },
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      defaultPriceData: {
        kreenex_fee_base_usa: '',
        kreenex_fee_base_turkey: '',
        kreenex_fee_turkey: '',
        kreenex_fee_usa: '',
        kreenex_fee_percentage: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('api/canceling_order_by_admin/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this.getResults();
        _this.cancelAlert = true;
        var self = _this;
        setTimeout(function () {
          self.closeCancelingOrderModal();
        }, 1500);
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getReasons: function getReasons() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        _this3.reasons = result.map(function (r) {
          return {
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          };
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    getDefaultPrices: function getDefaultPrices() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        _this4.defaultPriceData.kreenex_fee_base_usa = result[0].kreenex_fee_base_usa;
        _this4.defaultPriceData.kreenex_fee_base_turkey = result[0].kreenex_fee_base_turkey;
        _this4.defaultPriceData.kreenex_fee_turkey = result[0].kreenex_fee_turkey;
        _this4.defaultPriceData.kreenex_fee_usa = result[0].kreenex_fee_usa;
        _this4.defaultPriceData.kreenex_fee_percentage = result[0].kreenex_fee_percentage;
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      var _this6 = this;

      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();

      setTimeout(function () {
        _this6.queryParameter = true;
      }, 1000);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    getCustomer: function getCustomer() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this7.customersResult = response.data.data;
        _this7.customersResult.forEach(function (c) {
          _this7.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getItemType: function getItemType() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this8.itemTypeResult = response.data.data;
        _this8.itemTypeResult.forEach(function (c) {
          _this8.itemTypes.push({
            text: c.type_name,
            value: c.type_name,
            shippingPrice: c.type_int_shipping_price
          });
        });
      });
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;
      var repackagePrice = Number(this.updateData.repackage_price) || 0;
      var holdPrice = Number(this.updateData.hold_price) || 0;
      var otherServicePrice = Number(this.updateData.other_service_price) || 0;
      var localDelivery = Number(this.updateData.local_delivery) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge + localDelivery;

      if (this.updateData.is_repackage) {
        total += repackagePrice;
      }

      if (this.updateData.is_hold) {
        total += holdPrice;
      }

      if (otherServicePrice > 0) {
        total += otherServicePrice;
      }

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    clearProcessOrderData: function clearProcessOrderData() {
      this.updateData.item_price = '';
      this.updateData.the_tl_price = '';
      this.updateData.tax = '';
      this.updateData.item_weight = '';
      this.updateData.internal_shipping_handling = 0;
      this.updateData.delivery_price = '';
      this.updateData.kreenex_fee = '';
      this.updateData.insurance = '';
      this.updateData.total_amount = '';
      this.updateData.from_date = '';
      this.updateData.to_date = '';
      this.updateData.quantity_charge = '';
      this.updateData.description = '';
      this.updateData.item_type = '';
      this.updateData.discount = '';
      this.updateData.send_sms = false;
      this.updateData.national_tax = null;
      this.updateData.other_service = '';
      this.updateData.process_note = '';
      this.updateData.customer_process_note = '';
      this.updateData.order_type_id_fk = null;
      this.updateData.auto_image_url = null;

      this.priceValues.item_price = 0;
      this.priceValues.internal_shipping_handling = 0;
      this.priceValues.tax = 0;
      this.priceValues.delivery_price = 0;
      this.priceValues.kreenex_fee = 0;
      this.priceValues.insurance = 0;
      this.priceValues.quantity_charge = 0;
      this.priceValues.discount = 0;
      this.checkAlert = false;
    },
    processOrder: function processOrder(event, id, stime, stime1, stime2) {
      var _this9 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      this.updateData.send_sms = this.updateData.send_sms.toString();

      var formData = new FormData();

      Object.keys(this.updateData).forEach(function (key) {
        if (key !== 'customer_process_note_image' || !_this9.updateData[key] instanceof File) {
          formData.append(key, _this9.updateData[key]);
        }
      });

      if (this.updateData.customer_process_note_image instanceof File) {
        formData.append('customer_process_note_image', this.updateData.customer_process_note_image);
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.processOrderUrl + '/' + id, formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this9.loading = false;
        _this9.clearProcessOrderData();
        stime.time = '';
        stime1.time = '';
        stime2.time = '';
        _this9.checkAlert = true;
        var b = _this9;
        setTimeout(function () {
          b.getResults();
          b.checkAlert = false;
        }, 1500);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        _this9.loading = false;
        _this9.clearProcessOrderData();
        stime.time = '';
        stime1.time = '';
        stime2.time = '';
        _this9.checkAlert = true;
        var b = _this9;
        setTimeout(function () {
          b.getResults();
          b.checkAlert = false;
        }, 1500);
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this10.detailResults = data.data;
        _this10.detialData = _this10.detailResults[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__adminCancelOrder__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logs_viewLogDetails_vue__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'admin-cancel-order': __WEBPACK_IMPORTED_MODULE_7__adminCancelOrder__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_8__logs_viewLogDetails_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getReasons();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'process_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loadSingleApprove: false,
      approvingDialog: false,
      approveValue: '1',
      loading: false,
      url: 'api/processed_order',
      orderDetailUrl: 'api/show_order_detail',
      approvingOrderUrl: 'api/approving_order_by_admin',
      cancelingOrderUrl: 'api/canceling_order_by_admin',
      rowIndex: '',
      orderData: {},
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      orderIds: [],
      reasons: [],
      totalResult: 0,
      queryParameter: true,
      cancelData: {
        cancel_reason: ''
      },
      logDetailUrl: 'api/credit_log_transactions',
      companyUrl: 'api/company_info',
      detialData: {},
      loadApproveAll: false,
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      creditLogResponse: null,
      updateData: {
        item_price: '',
        tax: '',
        item_weight: '',
        kreenex_fee: '',
        insurance: '',
        total_amount: '',
        estimated_time: ''
      },
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  computed: {
    sumOfSelectedOrders: function sumOfSelectedOrders() {
      var _this = this;

      var sum = 0;
      this.apiResults.filter(function (order) {
        return _this.orderIds.includes(order.order_id);
      }).forEach(function (x) {
        sum += x.item_price * x.quantity + x.national_tax + x.delivery_price;
      });

      return sum;
    },
    sumOfSelectedOrdersTotalCost: function sumOfSelectedOrdersTotalCost() {
      var _this2 = this;

      var sum = 0;
      this.apiResults.filter(function (order) {
        return _this2.orderIds.includes(order.order_id);
      }).forEach(function (x) {
        sum += x.total_amount;
      });

      return sum;
    }
  },

  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.companyData = response.data.data;
      });
    },
    initInvoice: function initInvoice(modal, id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this4.detailResults = data.data;

        _this4.detialData = _this4.detailResults[0];
      });
      this.modal(modal);
    },
    returnOrderToNewOrder: function returnOrderToNewOrder(orderId) {
      var _this5 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/return_order_to_new_order/' + orderId, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this5.getResults();
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          title: 'Done',
          text: 'The orders returned to new order section',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        _this5.getResults();
      });
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.getResults();
        _this6.cancelAlert = true;
        var self = _this6;
        setTimeout(function () {
          self.closeCancelingOrderModal();
        }, 1500);
      });
    },
    getReasons: function getReasons() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        _this7.reasons = result.map(function (r) {
          return {
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          };
        });
      });
    },
    getResults: function getResults() {
      var _this8 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this8.filterMade = true;
          _this8.apiResults = data.data;
        } else {
          _this8.filterMade = false;
          _this8.apiResults = data.data.data;
        }

        if (_this8.apiResults.length === 0) {
          _this8.tableData.searchOneCol = '';
          _this8.tableData.searchOneVal = '';
          _this8.tableData.search = '';
          _this8.alertValue = true;
        } else {
          _this8.alertValue = false;
        }

        if (data.data.length > 0) {
          _this8.removeConfigPagination();
        } else {
          _this8.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this8.totalResult = 0;
        for (var i = 0; i < _this8.apiResults.length; i++) {
          _this8.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this9 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this9.detailResults = data.data;
        _this9.detialData = _this9.detailResults[0];
      });
      this.modal(modal);
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    approvingMultipleOrder: function approvingMultipleOrder() {
      var _this10 = this;

      if (this.orderIds.length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', 'Please check some order to approve', 'error');
        return;
      }

      this.loadApproveAll = true;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once confirmed, all checked order will be approved',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var len = _this10.orderIds.length;
          var ids = '';
          for (var i = 0; i < len; i++) {
            ids += String(_this10.orderIds[i]);
            if (i !== len - 1) {
              ids += ',';
            }
          }
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/approving_multiple_order', {
            headers: { Authorization: 'Bearer ' + token },
            params: { ids: ids }
          }).then(function (response) {
            _this10.getResults();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
            _this10.unCheckAll();
            _this10.orderIds = [];
            _this10.loadApproveAll = false;
          }).catch(function (error) {
            _this10.loadApproveAll = false;
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        } else {
          _this10.loadApproveAll = false;
          _this10.getResults();
        }
      }).catch(function () {
        _this10.loadApproveAll = false;
        _this10.getResults();
      });
    },
    approveOrder: function approveOrder() {
      var _this11 = this;

      this.loadSingleApprove = true;
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.approvingOrderUrl, this.orderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this11.loadSingleApprove = false;
        _this11.creditLogResponse = response.data.message;
        _this11.getResults();
        _this11.approvingDialog = false;
        _this11.orderData = {};
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          title: '',
          text: 'Do you want to see this order invoice ?',
          icon: 'warning',
          buttons: true
        }).then(function (confirm) {
          if (confirm) {
            _this11.initInvoice('modal_showAppLog', _this11.creditLogResponse[0].credit_log_transaction_id);
          }
        });
      }).catch(function (error) {
        _this11.loadSingleApprove = false;
        if (typeof error.response.data.message === 'string') {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', error.response.data.message, 'error');
        } else {
          var errMsg = '';
          var index = 1;
          for (var x in error.response.data.message) {
            errMsg += index + '- ' + error.response.data.message[x] + ' ';
            index += 1;
          }

          __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', errMsg, 'error');
        }
      });
    },
    approvingOrder: function approvingOrder(data) {
      this.orderData = data;
      this.approvingDialog = true;
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detialData', 'closeModal', 'companyData'],

  data: function data() {
    return {
      partialRefunds: []
    };
  },


  computed: {
    totalAfterPartialRefund: function totalAfterPartialRefund() {
      var refunded = 0;
      this.partialRefunds.forEach(function (refund) {
        refunded += Number(refund.amount);
      });

      return Number(this.detialData.amount) - refunded;
    }
  },

  watch: {
    detialData: function detialData(invoice) {
      this.getPartialRefunds(invoice);
    }
  },

  mounted: function mounted() {
    var theModal = document.querySelector('.modal');
    theModal.style.overflowX = 'auto';
  },


  methods: {
    getPartialRefunds: function getPartialRefunds(invoice) {
      var _this = this;

      this.partialRefunds = [];
      if (!invoice || !invoice.credit_log_transaction_id || invoice.description === 'Add to Credit') {
        return;
      }

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/credit_log_transactions/' + invoice.credit_log_transaction_id + '/partial-refunds', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        // ignore an old answer if another invoice was opened meanwhile
        if (_this.detialData.credit_log_transaction_id === invoice.credit_log_transaction_id) {
          _this.partialRefunds = response.data.data;
        }
      }).catch(function () {
        _this.partialRefunds = [];
      });
    },
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();

      $('#print-area').printMe({
        path: ['assets/ltr/css/print_style.css'],
        filename: 'SZ_Invoice_' + this.detialData.invoice_number
      });

      $('#close-button').show();
      $('#print-button').show();
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Cancel Reason',
      text: 'Cancel Reason',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'cancel_reason'
    }, {
      label: 'Order Note',
      text: 'Order note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'cancel_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/canceled_order',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.detailResults = data.data;
        _this2.detialData = _this2.detailResults[0];
      });
      this.modal(modal);
    },
    undoCancelOrder: function undoCancelOrder(orderId, statusId) {
      var _this3 = this;

      var isShipOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
        title: 'Are you sure?',
        text: isShipOnly ? 'This order will go back to Ship Only and can be approved again.' : 'Undo Cancel Order will restore the order to the previous status.',
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('api/undo_canceling_order_by_admin/' + orderId, { status: statusId }, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
              title: 'Done',
              text: isShipOnly ? 'The order is back in Ship Only' : '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__refundingOrder_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partialRefundingOrder_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addBarcode_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purchaseOrder__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orderCase_addEditOrderCase_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import adminCancelOrder from './adminCancelOrder'




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'refunding-order': __WEBPACK_IMPORTED_MODULE_4__refundingOrder_vue__["a" /* default */],
    'add-barcode': __WEBPACK_IMPORTED_MODULE_6__addBarcode_vue__["a" /* default */],
    'purchase-order': __WEBPACK_IMPORTED_MODULE_7__purchaseOrder__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__["a" /* default */],
    partialRefundingOrder: __WEBPACK_IMPORTED_MODULE_5__partialRefundingOrder_vue__["a" /* default */],
    addEditOrderCase: __WEBPACK_IMPORTED_MODULE_9__orderCase_addEditOrderCase_vue__["a" /* default */]
    // 'admin-cancel-order': adminCancelOrder
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getBanks();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  computed: {
    sumOfSelectedOrders: function sumOfSelectedOrders() {
      var _this = this;

      var sum = 0;
      this.apiResults.filter(function (order) {
        return _this.orderIds.includes(order.order_id);
      }).forEach(function (x) {
        sum += x.item_price * x.quantity + x.national_tax + x.delivery_price;
      });

      return sum;
    },
    sumOfSelectedOrdersTotalCost: function sumOfSelectedOrdersTotalCost() {
      var _this2 = this;

      var sum = 0;
      this.apiResults.filter(function (order) {
        return _this2.orderIds.includes(order.order_id);
      }).forEach(function (x) {
        sum += x.total_amount;
      });

      return sum;
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'confirm_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/approved_order',
      refundOrderUrl: 'api/refunding_order',
      purchaseOrderUrl: 'api/purchasing_order',
      orderDetailUrl: 'api/show_order_detail',
      addBarcodeUrl: 'api/add_barcode',
      bankUrl: 'api/get_banks',
      cancelingOrderUrl: 'api/canceling_approved_order',
      refundOrderModal: false,
      orderIds: [],
      isUpdate: false,
      formData: {},
      addEditOrderCaseModal: false,
      addBarcodeModal: false,
      filterMade: false,
      totalResult: 0,
      purchaseOrderModal: false,
      cancelAlert: false,
      the_order_id: '',
      the_order_id2: '',
      theCancelOrderID: '',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      cancelOrderModal: false,
      queryParameter: true,
      theOrderTotalAmount: '',
      btnsave: true,
      cancelData: {
        cancel_reason: ''
      },
      updateData: {
        refundingOrder: ''
      },
      refundData: {
        send_sms: false
      },
      partialRefundOrderModal: false,
      partialRefundData: {},
      addBarcodeData: {
        barcode: ''
      },
      purchaseOrderData: {
        bank_id: '',
        item_cost_in_tl: '',
        item_cost_in_usd: '',
        country: '',
        purchase_note: '',
        barcode: null,
        warehouse_date: null,
        from_date: null,
        to_date: null,
        ids: []
      },
      detialData: {
        the_tl_price: '',
        order_id: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        coupon_percentage: '',
        type: '',
        theOrderID: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        note: '',
        item_type: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      bankResults: [],
      banks: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    openCreateOrderCaseModal: function openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      };
      this.isUpdate = false;
      this.addEditOrderCaseModal = true;
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },


    // openCancelingOrderModal(orderId) {
    //   this.cancelOrderModal = true
    //   this.theCancelOrderID = orderId
    // },

    // closeCancelingOrderModal() {
    //   this.cancelOrderModal = false
    //   this.cancelAlert = false
    //   this.cancelData.cancel_reason = ''
    // },

    // cancelingOrder() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
    //       headers: { Authorization: 'Bearer ' + token }
    //     })
    //     .then((response) => {
    //       this.getResults()
    //       this.cancelAlert = true
    //       let self = this
    //       setTimeout(() => {
    //         self.closeCancelingOrderModal()
    //       }, 1500)
    //     })
    // },

    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    confirmPurchaseAll: function confirmPurchaseAll() {
      if (this.orderIds.length === 0) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', 'Please select some order to purchase', 'error');
        return;
      }

      this.purchaseOrderModal = true;
      this.purchaseOrderData.ids = this.orderIds;
    },
    handlePurchaseModal: function handlePurchaseModal(orderData) {
      this.closeModal('modal_showApp'); // Close the current modal
      this.openPurchaseOrderModal(orderData); // Open the purchase modal
    },
    handleRefundModal: function handleRefundModal(orderData) {
      this.closeModal('modal_showApp'); // Close the current modal
      console.log(orderData);
      this.openRefundOrderModal(orderData.order_id, orderData.total_amount); // Open the purchase modal
    },
    handlePartialRefundModal: function handlePartialRefundModal(orderData) {
      this.closeModal('modal_showApp'); // Close the current modal
      console.log(orderData);
      this.openPartialRefundOrderModal(orderData.order_id, orderData.total_amount); // Open the purchase modal
    },
    purchaseAll: function purchaseAll() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('api/purchasing_multiple_order', this.purchaseOrderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this3.getResults();
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
          title: 'Done',
          text: 'Orders purchased successfully',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this3.closePurchaseOrderModal();
        _this3.unCheckAll();
        _this3.orderIds = [];
      }).catch(function () {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', 'Please refresh the page and try again', 'error');
      });
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    getBanks: function getBanks() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.bankUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.bankResults = response.data.data;
        _this4.bankResults.forEach(function (c) {
          _this4.banks.push({ text: c.bank_name, value: c.bank_id });
        });
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this6.detailResults = data.data;

        _this6.detialData = _this6.detailResults[0];
      });
      this.modal(modal);
    },
    openPurchaseOrderModal: function openPurchaseOrderModal(order) {
      this.purchaseOrderModal = true;
      this.purchaseOrderID = order.order_id;
      this.purchaseOrderData = _extends({}, order);
    },
    closePurchaseOrderModal: function closePurchaseOrderModal() {
      this.purchaseOrderModal = false;
      this.successAlert = false;
      this.clearPurchaseOrderModal();
    },
    clearPurchaseOrderModal: function clearPurchaseOrderModal() {
      this.purchaseOrderData.bank_id = '';
      this.purchaseOrderData.item_cost_in_tl = '';
      this.purchaseOrderData.item_cost_in_usd = '';
      this.purchaseOrderData.country = '';
      this.purchaseOrderData.purchase_note = '';
      this.purchaseOrderData.barcode = null;
      this.purchaseOrderData.warehouse_date = null;
      this.purchaseOrderData.from_date = null;
      this.purchaseOrderData.to_date = null;
      this.purchaseOrderData.ids = [];
    },
    purchaseOrder: function purchaseOrder() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(this.purchaseOrderUrl + '/' + this.purchaseOrderID, this.purchaseOrderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this7.getResults();
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
          title: 'Done',
          text: 'Order purchased successfully',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        // this.successAlert = true
        _this7.closePurchaseOrderModal();
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
      // swal({
      //   title: 'Are you sure?',
      //   text: 'Once confirmed, selected order will be purchased',
      //   icon: 'warning',
      //   buttons: true,
      // }).then((approved) => {
      //   if (approved) {
      //     //
      //   }
      // })
    },
    openRefundOrderModal: function openRefundOrderModal(orderId, totalAmount) {
      var _this8 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/order/' + orderId + '/partial-refunds', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this8.refundData = {
          partial_refunds: res.data.data.partial_refunds,
          send_sms: false
        };
        _this8.the_order_id = orderId;
        _this8.theOrderTotalAmount = totalAmount;
        _this8.refundOrderModal = true;
      });
    },
    closeRefundOrderModal: function closeRefundOrderModal() {
      this.refundOrderModal = false;
      this.checkAlert = false;
      this.clear();
    },
    clear: function clear() {
      this.refundData = {
        send_sms: false
      };
      this.theOrderTotalAmount = '';
      this.$validator.reset();
    },
    refundOrder: function refundOrder() {
      var _this9 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(this.refundOrderUrl + '/' + this.the_order_id, this.refundData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this9.getResults();
        _this9.checkAlert = true;
        _this9.loading = false;
        _this9.clear();
        setTimeout(function () {
          _this9.closeRefundOrderModal();
        }, 1500);
      }).catch(function (error) {
        // swal('Error', 'There is an error please try again', 'error')
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
        _this9.getResults();
        _this9.loading = false;
        // this.clear()
        // setTimeout(() => {
        //   this.closeRefundOrderModal()
        // }, 1500)
      });
    },
    openPartialRefundOrderModal: function openPartialRefundOrderModal(orderId, totalAmount) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/order/' + orderId + '/partial-refunds', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this10.partialRefundData = {
          order_id_fk: orderId,
          partial_refunds: res.data.data.partial_refunds
        };
        _this10.theOrderTotalAmount = totalAmount;
        _this10.partialRefundOrderModal = true;
      });
    },
    closePartialRefundOrderModal: function closePartialRefundOrderModal() {
      this.partialRefundOrderModal = false;
      this.checkAlert = false;
      this.partialClear();
    },
    partialClear: function partialClear() {
      this.partialRefundData = {};
      this.theOrderTotalAmount = '';
      this.$validator.reset();
    },
    partialRefundOrder: function partialRefundOrder() {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('api/partial-refund', this.partialRefundData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this11.getResults();
        _this11.checkAlert = true;
        _this11.loading = false;
        setTimeout(function () {
          _this11.clear();
          _this11.closePartialRefundOrderModal();
        }, 1500);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        _this11.getResults();
        _this11.loading = false;
      });
    },
    openAddBarcodeModal: function openAddBarcodeModal(id) {
      this.addBarcodeModal = true;
      this.the_order_id2 = id;
    },
    closeAddBarcodeModal: function closeAddBarcodeModal() {
      this.addBarcodeModal = false;
      this.addBarcodeData.barcode = '';
      this.checkAlert = false;
    },
    addBarcode: function addBarcode() {
      var _this12 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(this.addBarcodeUrl + '/' + this.the_order_id2, this.addBarcodeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this12.getResults();
        _this12.checkAlert = true;
        _this12.addBarcodeData.barcode = '';
      }).catch(function (error) {
        _this12.addBarcodeData.barcode = '';
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundingOrder_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ca42d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundingOrder_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundingOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ca42d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundingOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['refundOrderModal', 'closeRefundOrderModal', 'checkAlert', 'refundData', 'refundOrder', 'loading', 'theOrderTotalAmount'],

  data: function data() {
    return {
      loggedInUserData: {}
    };
  },


  computed: {
    orderRemainAmount: function orderRemainAmount() {
      if (this.refundData.partial_refunds && this.refundData.partial_refunds.length > 0) {
        var reAmount = 0;
        this.refundData.partial_refunds.forEach(function (x) {
          reAmount += Number(x.amount);
        });

        return this.theOrderTotalAmount - reAmount;
      }

      return this.theOrderTotalAmount;
    }
  },

  mounted: function mounted() {
    this.getLoggedInUser();
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.refundOrder();
        }
      });
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partialRefundingOrder_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aecce590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partialRefundingOrder_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partialRefundingOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aecce590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partialRefundingOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['partialRefundOrderModal', 'closePartialRefundOrderModal', 'checkAlert', 'partialRefundData', 'partialRefundOrder', 'loading', 'theOrderTotalAmount'],

  data: function data() {
    return {
      loggedInUserData: {}
    };
  },


  computed: {
    orderRemainAmount: function orderRemainAmount() {
      if (this.partialRefundData.partial_refunds && this.partialRefundData.partial_refunds.length > 0) {
        var reAmount = 0;
        this.partialRefundData.partial_refunds.forEach(function (x) {
          reAmount += Number(x.amount);
        });

        var amount = this.theOrderTotalAmount - reAmount;
        return amount.toFixed(2);
      }

      return this.theOrderTotalAmount.toFixed(2);
    }
  },

  mounted: function mounted() {
    this.getLoggedInUser();
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.partialRefundOrder();
        }
      });
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addBarcode_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c96dd7f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addBarcode_vue__ = __webpack_require__(597);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addBarcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c96dd7f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addBarcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['checkAlert', 'closeAddBarcodeModal', 'addBarcodeModal', 'addBarcodeData', 'addBarcode'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.addBarcode();
        }
      });
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['purchaseOrderModal', 'closePurchaseOrderModal', 'checkAlert', 'purchaseOrderData', 'purchaseOrder', 'purchaseAll', 'successAlert', 'banks'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.purchaseOrderData.ids && _this.purchaseOrderData.ids.length > 0) {
            _this.purchaseAll();
          } else {
            _this.purchaseOrder();
          }
        }
      });
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    addEditOrderCaseModal: { type: Boolean, default: false },
    formData: { type: Object, default: function _default() {} },
    isUpdate: { type: Boolean, default: false },
    fromCustomer: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      var url = 'api/order-case';
      if (this.fromCustomer) {
        url = 'api/order-case/customer-store';
      }

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url + '/' + _this.formData.order_case_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addRefundNumber__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'add-refund-number': __WEBPACK_IMPORTED_MODULE_5__addRefundNumber__["a" /* default */]
  },
  mounted: function mounted() {
    this.getLoggedInUser();
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Invoice Number',
      text: 'Invoice Number',
      value: '3',
      sortable: true,
      searchable: false,
      name: 'last_order_invoice'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'user_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'cutomer_note'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Item Price',
      text: 'Item Price',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'item_price'
    }, {
      label: 'Shipping',
      text: 'Shipping',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'internal_shipping_handling'
    }, {
      label: 'Int. Tax',
      text: 'Int. Tax',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'national_tax'
    }, {
      label: 'Tax',
      text: 'Tax',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'tax'
    }, {
      label: 'Shipzone Fee',
      text: 'Shipzone Fee',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'kreenex_fee'
    }, {
      label: 'Discount',
      text: 'Discount',
      value: '17',
      sortable: true,
      searchable: true,
      name: 'discount'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '18',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Back Name',
      text: 'Back Name',
      value: '19',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }, {
      label: 'Type',
      text: 'Type',
      value: '20',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '21',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Refund Number',
      text: 'Refund Number',
      value: '22',
      sortable: true,
      searchable: true,
      name: 'refund_number'
    }, {
      label: 'Date',
      text: 'Date',
      value: '23',
      sortable: true,
      searchable: true,
      name: 'refund_date'
    }, {
      label: 'Refund Note',
      text: 'Refund Note',
      value: '24',
      sortable: true,
      searchable: true,
      name: 'refund_note'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      loggedInUserData: {},
      isMobile: false,
      url: 'api/refunded_order',
      orderDetailUrl: 'api/show_order_detail',
      addRefundNumberUrl: 'api/add_refund_number',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      addRefundNumberModal: false,
      orderID: '',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        coupon_percentage: '',
        type: '',
        theOrderID: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        bank_name: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        discount: '',
        item_type: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        note: ''
      },
      prevSearchQuery: '',
      addRefundNumberData: {
        refund_number: ''
      },
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'orders.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;

      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/refunded_order/export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage + '&remove_pagination=true');
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddRefundNumberModal: function openAddRefundNumberModal(orderID, refundNumber) {
      this.orderID = orderID;
      this.addRefundNumberData.refund_number = refundNumber;
      this.addRefundNumberModal = true;
    },
    closeAddRefundNumberModal: function closeAddRefundNumberModal() {
      this.addRefundNumberModal = false;
      this.successAlert = false;
    },
    addRefundNumber: function addRefundNumber() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.addRefundNumberUrl + '/' + this.orderID, this.addRefundNumberData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this.successAlert = true;
        _this.getResults();
        var self = _this;
        setTimeout(function () {
          self.closeAddRefundNumberModal();
        }, 1500);
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'orders.updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'orders.updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this3.detailResults = data.data;
        _this3.detialData = _this3.detailResults[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'orders.updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'orders.updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addRefundNumberData', 'closeAddRefundNumberModal', 'addRefundNumberModal', 'successAlert', 'addRefundNumber'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.addRefundNumber();
        }
      });
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createQrCode_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sendToWarehouse_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__refundingOrder_vue__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addBarcode_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addTrackNumber_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__takeOrderImage__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__addWarehouseDate__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__takePhoto_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__partialRefundingOrder_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__orderCase_addEditOrderCase_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__adminCancelOrder__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'create-qr-code': __WEBPACK_IMPORTED_MODULE_6__createQrCode_vue__["a" /* default */],
    'send-to-warehouse': __WEBPACK_IMPORTED_MODULE_7__sendToWarehouse_vue__["a" /* default */],
    'refunding-order': __WEBPACK_IMPORTED_MODULE_8__refundingOrder_vue__["a" /* default */],
    'add-barcode': __WEBPACK_IMPORTED_MODULE_9__addBarcode_vue__["a" /* default */],
    'add-track-number': __WEBPACK_IMPORTED_MODULE_10__addTrackNumber_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_11__mobileDatatable__["a" /* default */],
    'admin-cancel-order': __WEBPACK_IMPORTED_MODULE_17__adminCancelOrder__["a" /* default */],
    takeOrderImage: __WEBPACK_IMPORTED_MODULE_12__takeOrderImage__["a" /* default */],
    addWarehouseDate: __WEBPACK_IMPORTED_MODULE_13__addWarehouseDate__["a" /* default */],
    takePhoto: __WEBPACK_IMPORTED_MODULE_14__takePhoto_vue__["a" /* default */],
    partialRefundingOrder: __WEBPACK_IMPORTED_MODULE_15__partialRefundingOrder_vue__["a" /* default */],
    addEditOrderCase: __WEBPACK_IMPORTED_MODULE_16__orderCase_addEditOrderCase_vue__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '2',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches'
    // },
    {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '4',
      sortable: false,
      searchable: false,
      name: 'last_order_invoice'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Track Number',
      text: 'Track Number',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'track_number'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '17',
      sortable: true,
      searchable: false,
      name: 'purchase_date'
    }, {
      label: 'Warehouse Date',
      text: 'Warehouse Date',
      value: '18',
      sortable: true,
      searchable: false,
      name: 'warehouse_date'
    }, {
      label: 'Order Number',
      text: 'Order Number',
      value: '19',
      sortable: true,
      searchable: true,
      name: 'barcode'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '20',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/purchased_order',
      sendToWarehouseUrl: 'api/warehouse_delivering_order',
      orderDetailUrl: 'api/show_order_detail',
      refundOrderUrl: 'api/refunding_order',
      addBarcodeUrl: 'api/add_barcode',
      addTrackNumberUrl: 'api/add_track_number',
      qrCodeValues: [],
      loggedInUserData: {},
      addWarehouseDateModal: false,
      warehouseDateData: {},
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      cancelData: {
        cancel_reason: ''
      },
      sendToWarehouseData: {
        qrcode: ''
      },
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      sendToWarehouseModal: false,
      refundOrderModal: false,
      queryParameter: true,
      the_order_id: '',
      btnsave: true,
      addBarcodeModal: false,
      addTrackNumberModal: false,
      the_order_id2: '',
      the_order_id3: '',
      oID: null,
      orderData: {},
      takePhotoModal: false,
      takeOrderImageDialog: false,
      formData: {},
      isUpdate: false,
      addEditOrderCaseModal: false,
      addBarcodeData: {
        barcode: ''
      },
      addTrackNumberData: {
        track_number: ''
      },
      updateData: {
        order: []
      },
      refundData: {
        refund_reason: '',
        money_amount: '',
        refund_note: '',
        send_sms: false
      },
      detialData: {
        the_tl_price: '',
        order_id: '',
        bank_name: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      theOrderTotalAmount: '',
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'orders.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        wh_dt_passed: 0,
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      partialRefundOrderModal: false,
      partialRefundData: {}
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var whDtPassed = this.tableData.wh_dt_passed !== '' ? this.tableData.wh_dt_passed : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/purchased-order-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage + '&wh_dt_passed=' + whDtPassed);
    },
    openCreateOrderCaseModal: function openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      };
      this.isUpdate = false;
      this.addEditOrderCaseModal = true;
    },
    openPartialRefundOrderModal: function openPartialRefundOrderModal(orderId, totalAmount) {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/order/' + orderId + '/partial-refunds', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.partialRefundData = {
          order_id_fk: orderId,
          partial_refunds: res.data.data.partial_refunds
        };
        _this.theOrderTotalAmount = totalAmount;
        _this.partialRefundOrderModal = true;
        _this.the_order_id = orderId;
      });
    },
    closePartialRefundOrderModal: function closePartialRefundOrderModal() {
      this.partialRefundOrderModal = false;
      this.checkAlert = false;
      this.partialClear();
    },
    partialClear: function partialClear() {
      this.partialRefundData = {};
      this.theOrderTotalAmount = '';
      this.$validator.reset();
    },
    partialRefundOrder: function partialRefundOrder() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('api/partial-refund', this.partialRefundData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.getResults();
        _this2.checkAlert = true;
        _this2.loading = false;
        setTimeout(function () {
          _this2.clear();
          _this2.closePartialRefundOrderModal();
        }, 1500);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        _this2.getResults();
        _this2.loading = false;
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    openAddWarehouseDateModal: function openAddWarehouseDateModal(orderId, warehouseDate) {
      this.addWarehouseDateModal = true;
      this.warehouseDateData = {
        order_id: orderId,
        warehouse_date: warehouseDate
      };
    },
    closeWarehouseDateModal: function closeWarehouseDateModal() {
      this.addWarehouseDateModal = false;
      this.warehouseDateData = {};
    },
    submitWarehouseDate: function submitWarehouseDate() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/api/change-warehouse-date', this.warehouseDateData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Success', 'Warehouse date changed', 'success');
        _this3.closeWarehouseDateModal();
        _this3.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    getRowStyle: function getRowStyle(data) {
      var today = new Date();
      var warehouseDate = new Date(data.warehouse_date);
      var next8Days = new Date(warehouseDate.getTime());
      next8Days.setDate(next8Days.getDate() + 8);

      if (next8Days < today) return 'background-color: #FFAB91';

      return '';
    },
    openTakeOrderImageModal: function openTakeOrderImageModal(orderId) {
      this.oID = orderId;
      this.takeOrderImageDialog = true;
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.wh_dt_passed = '0';
      this.getResults();
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.wh_dt_passed = '0';
      this.getResults();
    },
    openGenerateQrCodeModal: function openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      } else {
        this.generateQrCodeModal = true;
      }
    },
    closeGenerateQrCodeModal: function closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false;
      this.qrCodeValues = [];
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    openSendToWarehouseModal: function openSendToWarehouseModal() {
      this.sendToWarehouseModal = true;
    },
    closeSendToWarehouseModal: function closeSendToWarehouseModal() {
      this.sendToWarehouseModal = false;
      this.sendToWarehouseData.qrcode = '';
      this.$validator.reset();
    },
    sendToWarehouse: function sendToWarehouse() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.sendToWarehouseUrl, this.sendToWarehouseData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this5.sendToWarehouseData.qrcode = '';
        _this5.orderData = response.data.message.order;
        _this5.takePhotoModal = true;
        _this5.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 500,
          buttons: false
        });
        if (response.data.message.process_note && response.data.message.process_note.length > 0) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Warning', response.data.message.process_note);
        }
      }).catch(function (error) {
        _this5.sendToWarehouseData.qrcode = '';

        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/canceling_order_by_admin/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this6.getResults();
        _this6.cancelAlert = true;
        setTimeout(function () {
          _this6.closeCancelingOrderModal();
        }, 1500);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openRefundOrderModal: function openRefundOrderModal(orderId, totalAmount) {
      var _this7 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/order/' + orderId + '/partial-refunds', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this7.refundData = {
          partial_refunds: res.data.data.partial_refunds,
          send_sms: false
        };
        _this7.the_order_id = orderId;
        _this7.theOrderTotalAmount = totalAmount;
        _this7.refundOrderModal = true;
      });
    },
    closeRefundOrderModal: function closeRefundOrderModal() {
      this.refundOrderModal = false;
      this.checkAlert = false;
      this.clear();
    },
    clear: function clear() {
      this.refundData.refund_reason = '';
      this.refundData.money_amount = '';
      this.refundData.refund_note = '';
      this.theOrderTotalAmount = '';
      this.$validator.reset();
    },
    refundOrder: function refundOrder() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.refundOrderUrl + '/' + this.the_order_id, this.refundData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this8.getResults();
        _this8.checkAlert = true;
        _this8.loading = false;
        _this8.clear();
        var self = _this8;
        setTimeout(function () {
          self.closeRefundOrderModal();
        }, 1500);
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    openAddBarcodeModal: function openAddBarcodeModal(id, barcode) {
      this.addBarcodeModal = true;
      this.the_order_id2 = id;
      this.addBarcodeData.barcode = barcode;
    },
    closeAddBarcodeModal: function closeAddBarcodeModal() {
      this.addBarcodeModal = false;
      this.addBarcodeData.barcode = '';
      this.checkAlert = false;
    },
    addBarcode: function addBarcode() {
      var _this9 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.addBarcodeUrl + '/' + this.the_order_id2, this.addBarcodeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this9.getResults();
        _this9.checkAlert = true;
        setTimeout(function () {
          _this9.closeAddBarcodeModal();
        }, 1500);
      }).catch(function (error) {
        _this9.addBarcodeData.barcode = '';
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openAddTrackNumberModal: function openAddTrackNumberModal(id, trackNumber) {
      this.addTrackNumberModal = true;
      this.the_order_id3 = id;
      this.addTrackNumberData.track_number = trackNumber;
    },
    closeAddTrackNumberModal: function closeAddTrackNumberModal() {
      this.addTrackNumberModal = false;
      this.addTrackNumberData.track_number = '';
      this.checkAlert = false;
    },
    addTrackNumber: function addTrackNumber() {
      var _this10 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.addTrackNumberUrl + '/' + this.the_order_id3, this.addTrackNumberData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this10.getResults();
        _this10.checkAlert = true;
        setTimeout(function () {
          _this10.closeAddTrackNumberModal();
        }, 1500);
      }).catch(function (error) {
        _this10.addTrackNumberData.track_number = '';
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this11.detailResults = data.data;
        _this11.detialData = _this11.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() != '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_print_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_print_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['generateQrCodeModal', 'closeGenerateQrCodeModal', 'qrCodeValues', 'generateQrCode', 'getResults'],

  data: function data() {
    return {
      size: 60,
      generateQrCodeUrl: 'api/generate_qrcode'
    };
  },


  methods: {
    generator: function generator() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.generateQrCodeUrl, this.qrCodeValues, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this.getResults();
        _this.closeGenerateQrCodeModal();
      });
    },
    printMe: function printMe() {
      var btnPrint = document.getElementById('print-button');
      var closePrint = document.getElementById('close-button');

      btnPrint.style.display = 'none';
      closePrint.style.display = 'none';

      setTimeout(function () {
        printJS({
          printable: 'printArea',
          type: 'html',
          targetStyles: ['*']
        });
      }, 1000);

      btnPrint.style.display = 'block';
      closePrint.style.display = 'block';

      // printJS({
      //     printable: 'print-area',
      //     type: 'html',
      //     documentTitle: '',
      //     targetStyles: ['*'],
      //     maxWidth: '76.20mm'
      // })
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sendToWarehouseModal', 'closeSendToWarehouseModal', 'sendToWarehouseData', 'sendToWarehouse'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.sendToWarehouse();
        }
      });
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['checkAlert', 'closeAddTrackNumberModal', 'addTrackNumberModal', 'addTrackNumberData', 'addTrackNumber'],

  methods: {
    removeSpaces: function removeSpaces() {
      this.addTrackNumberData.track_number = this.addTrackNumberData.track_number.replaceAll(/\s+/g, '');
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.addTrackNumber();
        }
      });
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['order_id_fk', 'takeOrderImageDialog'],

  data: function data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#',
      imgResult: [],
      oid: 100,
      facingMode: 'user', // 'user' for front camera, 'environment' for rear camera
      zoom: 1 // Zoom level from 1 to 3
    };
  },


  methods: {
    getImg: function getImg() {
      console.log(document.getElementById('testImg').files[0]);
    },
    toggleCamera: function toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement: function createCameraElement() {
      var _this = this;

      this.isLoading = true;

      var constraints = window.constraints = {
        audio: false,
        video: { facingMode: this.facingMode }
      };

      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        _this.isLoading = false;
        _this.$refs.camera.srcObject = stream;
      }).catch(function () {
        _this.isLoading = false;
        alert("May the browser didn't support or there is some errors.");
      });
    },
    stopCameraStream: function stopCameraStream() {
      var tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(function (track) {
        track.stop();
      });
    },
    flipCamera: function flipCamera() {
      // Toggle between front and rear camera
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';

      // Stop current stream and restart with new facing mode
      this.stopCameraStream();
      this.createCameraElement();
    },
    takePhoto: function takePhoto() {
      var _this2 = this;

      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        var FLASH_TIMEOUT = 50;

        setTimeout(function () {
          _this2.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      var context = this.$refs.canvas.getContext('2d');

      // Clear canvas
      context.clearRect(0, 0, 450, 337.5);

      // Apply zoom by scaling and centering
      context.save();
      var scaledWidth = 450 * this.zoom;
      var scaledHeight = 337.5 * this.zoom;
      var offsetX = (scaledWidth - 450) / 2;
      var offsetY = (scaledHeight - 337.5) / 2;

      context.drawImage(this.$refs.camera, -offsetX, -offsetY, scaledWidth, scaledHeight);
      context.restore();
    },
    downloadImage: function downloadImage() {
      var _this3 = this;

      var download = document.getElementById('downloadPhoto');
      var canvas = document.getElementById('photoTaken').toDataURL('image/jpeg');
      download.setAttribute('href', canvas);

      // Convert dataUrl to File
      var arr = canvas.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var file = new File([u8arr], 'filename', { type: mime });

      var formData = new FormData();
      formData.append('order_image', file);
      formData.append('order_id_fk', this.order_id_fk);

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/order_image', formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.imgResult = response.data.data;
      });
    },
    submitForm: function submitForm() {
      var _this4 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this4.refundOrder();
        }
      });
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addWarehouseDate_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406dc94b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addWarehouseDate_vue__ = __webpack_require__(635);
function injectStyle (ssrContext) {
  __webpack_require__(633)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addWarehouseDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_406dc94b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addWarehouseDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['closeWarehouseDateModal', 'addWarehouseDateModal', 'warehouseDateData', 'submitWarehouseDate'],

  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__["default"]
  },

  data: function data() {
    return {
      startTime2: {
        time: ''
      },
      option2: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Warehouse Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    };
  },


  watch: {
    addWarehouseDateModal: {
      immediate: false,
      handler: function handler() {
        if (this.addWarehouseDateModal) {
          this.startTime2.time = this.warehouseDateData.warehouse_date;
        }
      }
    }
  },

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          // this.warehouseDateData.warehouse_date = this.startTime2.time
          _this.submitWarehouseDate();
        }
      });
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    takePhotoModal: { type: Boolean, default: false },
    orderData: { type: Object, default: function _default() {} },
    url: { type: String, default: 'api/order_image' },
    filenameKey: { type: String, default: 'order_image' },
    modelFk: { type: String, default: 'order_id_fk' },
    modelPk: { type: String, default: 'order_id' }
  },

  data: function data() {
    return {
      showCanvas: true,
      showSeccessMsg: false,
      photoExist: false,
      takenPhotos: [],
      displayPhotos: [],
      facingMode: 'user', // 'user' for front camera, 'environment' for rear camera
      zoom: 1 // Zoom level from 1 to 3
    };
  },


  watch: {
    takePhotoModal: {
      immediate: false,
      handler: function handler() {
        if (this.takePhotoModal) {
          this.openCamera();
        }
      }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      var _this = this;

      this.showCanvas = false;
      setTimeout(function () {
        _this.showCanvas = true;
        _this.$emit('close');
      }, 200);
    },
    newPhoto: function newPhoto() {
      var _this2 = this;

      this.showCanvas = false;
      this.openCamera();
      setTimeout(function () {
        _this2.showCanvas = true;
      }, 500);
    },
    openCamera: function openCamera() {
      var video = document.getElementById('video');

      // Get access to the camera!
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Not adding `{ audio: true }` since we only want video now
        navigator.mediaDevices.getUserMedia({ video: { facingMode: this.facingMode } }).then(function (stream) {
          // video.src = window.URL.createObjectURL(stream)
          video.srcObject = stream;
          video.play();
        });
      }
    },
    flipCamera: function flipCamera() {
      // Toggle between front and rear camera
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user';

      // Stop current stream and restart with new facing mode
      var video = document.getElementById('video');
      if (video.srcObject) {
        var tracks = video.srcObject.getTracks();
        tracks.forEach(function (track) {
          track.stop();
        });
      }
      this.openCamera();
    },
    takePhoto: function takePhoto() {
      var canvas = document.getElementById('canvas');
      var context = canvas.getContext('2d');
      var video = document.getElementById('video');

      // Clear canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Apply zoom by scaling and centering
      context.save();
      var scaledWidth = 350 * this.zoom;
      var scaledHeight = 250 * this.zoom;
      var offsetX = (scaledWidth - 350) / 2;
      var offsetY = (scaledHeight - 250) / 2;

      context.drawImage(video, -offsetX, -offsetY, scaledWidth, scaledHeight);
      context.restore();

      var ph = this.getTakenPhoto();
      this.takenPhotos.push(ph);

      this.displayPhotos.push(this.getPhotoForDisplay(ph));

      // this.newPhoto()
    },
    getPhotoForDisplay: function getPhotoForDisplay(file) {
      return URL.createObjectURL(file);
    },
    removeImage: function removeImage(index) {
      this.takenPhotos.splice(index, 1);
      this.displayPhotos.splice(index, 1);
    },


    // downloadImage() {
    //     const download = document.getElementById('downloadPhoto')
    //     const canvas = document.getElementById('canvas').toDataURL('image/jpeg')
    //     download.setAttribute('href', canvas)
    // },

    getTakenPhoto: function getTakenPhoto() {
      var download = document.getElementById('downloadPhoto');
      var canvas = document.getElementById('canvas').toDataURL('image/jpeg');
      download.setAttribute('href', canvas);

      // Convert dataUrl to File
      var arr = canvas.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.filenameKey + Math.floor(Date.now() / 1000), { type: mime });
    },
    saveImage: function saveImage() {
      var _this3 = this;

      var formData = new FormData();
      this.takenPhotos.forEach(function (ph) {
        formData.append(_this3.filenameKey + '[]', ph);
      });
      formData.append(this.modelFk, this.orderData[this.modelPk]);

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url, formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this3.showSeccessMsg = true;
        _this3.takenPhotos = [];
        _this3.displayPhotos = [];
        _this3.$emit('photo-saved');
        setTimeout(function () {
          _this3.showSeccessMsg = false;
          _this3.closeDialog();
        }, 1000);
      });
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendToIntShipment_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__takePhoto_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createQrCode_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addNewOrder_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addNewShiponly_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__orderCase_addEditOrderCase_vue__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'send-to-int-shipment': __WEBPACK_IMPORTED_MODULE_4__sendToIntShipment_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */],
    'create-qr-code': __WEBPACK_IMPORTED_MODULE_9__createQrCode_vue__["a" /* default */],
    takePhoto: __WEBPACK_IMPORTED_MODULE_8__takePhoto_vue__["a" /* default */],
    'add-new-order': __WEBPACK_IMPORTED_MODULE_10__addNewOrder_vue__["a" /* default */],
    'add-new-shiponly': __WEBPACK_IMPORTED_MODULE_11__addNewShiponly_vue__["a" /* default */],
    addEditOrderCase: __WEBPACK_IMPORTED_MODULE_12__orderCase_addEditOrderCase_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getWarehouses();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Shiponly',
      text: 'Shiponly',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'is_ship_only'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'warehouse_deliver_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '17',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/warehouse_delivered_order',
      intPendingShipmentUrl: 'api/pending_shipmenting',
      // intShipmentUrl: 'api/int_shipmenting',
      initMultiplePendingShipmentUrl: 'api/pending_shipmenting_multiple_order',
      // initMultipleShipmentUrl: 'api/pending_shipmenting_multiple_order',
      intPendingShipmentByQrCodeUrl: 'api/pending_shipmenting_by_qrcode',
      // intShipmentByQrCodeUrl: 'api/int_shipmenting_by_qrcode',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      sendToIntShipmentModal: false,
      generateQrCodeModal: false,
      qrCodeValues: [],
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      btnsave: true,
      queryParameter: true,
      orderData: {},
      takePhotoModal: false,
      addNewOrderModal: false,
      addNewShiponlyModal: false,
      formData: {},
      isUpdate: false,
      addEditOrderCaseModal: false,
      warehouses: [],
      customers: [],
      checkURL: false,
      makeOrderData: {
        customer_id_fk: '',
        warehouse_id_fk: '',
        transportation_type: null,
        product_name: '',
        product_url: '',
        quantity: '',
        delivery_type: '',
        item_weight: '',
        volume: '',
        track_number: '',
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        is_from_warehouse: 1,
        is_ship_only: 1
      },
      sendToIntShipmentData: {
        order_id: ''
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    openCreateOrderCaseModal: function openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      };
      this.isUpdate = false;
      this.addEditOrderCaseModal = true;
    },
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getCustomer: function getCustomer() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (c) {
          _this2.customers.push({
            text: c.user_id + ' - ' + c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getItemType: function getItemType() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get-item-type', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (c) {
          _this3.itemTypes.push({
            text: c.type_name,
            value: c.type_name,
            shippingPrice: c.type_int_shipping_price
          });
        });
      });
    },
    clearNewOrderData: function clearNewOrderData() {
      this.makeOrderData.warehouse_id_fk = null;
      this.makeOrderData.transportation_type = null;
      this.makeOrderData.product_name = '';
      this.makeOrderData.product_url = '';
      this.makeOrderData.quantity = '';
      this.makeOrderData.item_weight = '';
      this.makeOrderData.volume = '';
      this.makeOrderData.track_number = '';
      this.makeOrderData.note = '';
      this.makeOrderData.coupon = '';
      this.makeOrderData.size = '';
      this.makeOrderData.type = '';
      this.makeOrderData.color = '';
      this.makeOrderData.c_o_d = '';
      this.makeOrderData.is_from_warehouse = 1;
      this.makeOrderData.is_ship_only = 1;
      this.makeOrderData.customer_id_fk = null;
      this.checkAlert = false;
      this.checkURL = false;
      this.loading = false;
    },
    openAddNewOrderModal: function openAddNewOrderModal() {
      this.makeOrderData.warehouse_id_fk = this.warehouses[0].value;
      this.addNewOrderModal = true;
    },
    openAddNewShiponlyModal: function openAddNewShiponlyModal() {
      this.addNewShiponlyModal = true;
    },
    closeAddNewOrderModal: function closeAddNewOrderModal() {
      this.addNewOrderModal = false;
      this.clearNewOrderData();
    },
    closeAddNewShiponlyModal: function closeAddNewShiponlyModal() {
      this.addNewShiponlyModal = false;
      this.clearNewOrderData();
    },
    makeNewOrder: function makeNewOrder() {
      var _this4 = this;

      this.loading = true;
      var token = localStorage.getItem('access_token');

      this.makeOrderData.delivery_type = 'office delivery';
      this.makeOrderData.status = 'warehouse_delivered_order';

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('api/orders', this.makeOrderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this4.loading = false;
        _this4.checkURL = false;
        _this4.checkAlert = true;
        setTimeout(function () {
          _this4.closeAddNewShiponlyModal();
          _this4.openTakePhotoModal(res.data.data);
        }, 500);
        _this4.getResults();
      }).catch(function (error) {
        _this4.loading = false;
        _this4.checkAlert = false;
        if (error.response.data.message.product_url) {
          _this4.checkURL = true;
        } else {
          _this4.checkURL = false;
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    openGenerateQrCodeModal: function openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      } else {
        this.generateQrCodeModal = true;
      }
    },
    closeGenerateQrCodeModal: function closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false;
      this.qrCodeValues = [];
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    openTakePhotoModal: function openTakePhotoModal(order) {
      this.orderData = order;
      this.takePhotoModal = true;
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/warehouse-export?' + arr);
    },
    getOrderID: function getOrderID(orders) {
      this.orderID = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id;
      }
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        _this5.getOrderID(_this5.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    sendAllToIntShipment: function sendAllToIntShipment() {
      var _this6 = this;

      var ordersId = this.qrCodeValues.map(function (e) {
        return e[0];
      });

      if (ordersId.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Please select order', 'error');
      }

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this6.initMultiplePendingShipmentUrl, { orders_id: ordersId }, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this6.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    openSendToIntShipmentModal: function openSendToIntShipmentModal() {
      this.sendToIntShipmentModal = true;
    },
    closeSendToIntShipmentModal: function closeSendToIntShipmentModal() {
      this.sendToIntShipmentModal = false;
      this.sendToIntShipmentData.order_id = '';
      this.$validator.reset();
    },
    sendToIntShipment: function sendToIntShipment() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.intPendingShipmentByQrCodeUrl + '/' + this.sendToIntShipmentData.order_id, '', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this7.sendToIntShipmentData.order_id = '';
        _this7.getResults();
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    pendingShipmentOrder: function pendingShipmentOrder(id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once Pending shipmented, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this8.intPendingShipmentUrl + '/' + id, '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this8.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    returnToPurchase: function returnToPurchase(id) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this9.returnToPurchaseUrl + id + '/return_to_purchase', '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this9.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this10.detailResults = data.data;

        _this10.detialData = _this10.detailResults[0];
      });
      this.modal(modal);
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToIntShipment_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26436b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToIntShipment_vue__ = __webpack_require__(645);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToIntShipment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26436b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToIntShipment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['pendingShipment', 'sendToIntShipmentModal', 'closeSendToIntShipmentModal', 'sendToIntShipmentData', 'sendToIntShipment'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.sendToIntShipment();
        }
      });
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('max_file_size', {
  getMessage: function getMessage(field, params) {
    return 'The ' + field + ' must not exceed ' + params[0] + ' MB.';
  },
  params: ['size'],
  validate: function validate(value, args) {
    if (!value || !value.length) return true; // No file selected
    var file = value[0];
    var size = parseFloat(args[0]); // Convert parameter to number
    if (!file || !file.size) return false;
    return file.size <= size * 1024 * 1024; // Convert MB to bytes
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getLoggedInUser();
  },


  props: ['addNewShiponlyModal', 'warehouses', 'closeAddNewShiponlyModal', 'checkAlert', 'deliveryTypes', 'makeOrderData', 'makeNewOrder', 'customers', 'checkURL', 'loading'],

  data: function data() {
    return {
      loggedInUserData: {},
      notCouponCode: false,
      transportationTypes: [],
      imagePreview: null
    };
  },


  methods: {
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.makeOrderData.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
    },
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      this.makeOrderData.image = null;
      this.makeOrderData.fileName = '';
      this.$validator.errors.remove('file');
      var file = event.target.files[0];
      if (file && !this.errors.has('file')) {
        this.file = file;
        this.makeOrderData.image = file;
        this.makeOrderData.fileName = file.name;
        this.imagePreview = URL.createObjectURL(file);
      } else {
        this.file = null;
        this.makeOrderData.image = null;
        this.imagePreview = null;
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.makeOrderData.coupon && _this.makeOrderData.coupon.length) {
            if (_this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              _this.notCouponCode = false;
              _this.makeNewOrder();
            } else {
              _this.notCouponCode = true;
            }
          } else {
            _this.notCouponCode = false;
            _this.makeNewOrder();
          }
        }
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendToPendingToBranch_vue__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createQrCode_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'send-to-pending-to-branch': __WEBPACK_IMPORTED_MODULE_4__sendToPendingToBranch_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */],
    'create-qr-code': __WEBPACK_IMPORTED_MODULE_6__createQrCode_vue__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
    if (this.$_has_perm('deliver_to_pending_to_branch')) this.getScanPallets();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check Box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Shiponly',
      text: 'Shiponly',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'is_ship_only'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'int_shipment_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '17',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/int_shipment_order',
      deliverToPendingToBranchUrl: 'api/deliver_to_pending_to_branch',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      sendToPendingToBranchModal: false,
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      qrCodeValues: [],
      scanCode: '',
      scanQueue: [],
      scanBusy: false,
      scanPallets: [],
      scanPalletId: null,
      checkingAll: false,
      unpaidNotice: '',
      unpaidNoticeTimer: null,
      sendToErbilModal: false,
      sendToErbilData: {
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      loggedInUserData: {},
      sendToPendingToBranchData: {
        order_id: '',
        send_sms: false
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    getScanPallets: function getScanPallets() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('api/pallets/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.scanPallets = response.data;
      }).catch(function () {});
    },
    scanQrCode: function scanQrCode() {
      var _this2 = this;

      var code = this.scanCode;
      this.scanCode = '';
      if (!/^\d+$/.test(code)) {
        if (code) __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', 'Invalid QR code: ' + code, 'error').then(function () {
          return _this2.focusScanInput();
        });
        return;
      }
      this.scanQueue.push(code);
      this.processScanQueue();
    },


    // Scans run one at a time so fast scanner input is not lost; the table reloads after the last one.
    processScanQueue: function processScanQueue() {
      var _this3 = this;

      if (this.scanBusy) return;
      if (!this.scanQueue.length) return this.getResults();
      this.scanBusy = true;
      var token = localStorage.getItem('access_token');
      // An order the warehouse never sent has no pallet: the server asks for one, picked next to the Scan box.
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put('api/int_shipment_scan/' + this.scanQueue.shift(), { ask_pallet: true, pallet_id: this.scanPalletId }, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var o = response.data.data;
        _this3.qrCodeValues = _this3.qrCodeValues.filter(function (x) {
          return x[0] != o.order_id;
        });
        if (o.paid) {
          _this3.qrCodeValues.push([o.order_id, o.full_name, o.phone_number, o.user_id, o.theOrderID, o.is_ship_only, o.product_name]);
        } else {
          _this3.showUnpaid(o.theOrderID + (o.is_ship_only == 1 ? ' Ship Only' : ' Int shipping not paid'));
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', error.response ? error.response.data.message : 'Scan failed', 'error').then(function () {
          return _this3.focusScanInput();
        });
      }).then(function () {
        _this3.scanBusy = false;
        _this3.processScanQueue();
      });
    },
    focusScanInput: function focusScanInput() {
      if (this.$refs.scanInput) this.$refs.scanInput.focus({ preventScroll: true });
    },
    rowTicked: function rowTicked(r, event) {
      // A single tick on an unpaid order works like a scan; Check All only selects.
      if (!event.target.checked || this.checkingAll) return;
      if (r.is_ship_only == 1 || !(Number(r.internal_shipping_handling) > 0)) {
        this.scanQueue.push(r.order_id);
        this.processScanQueue();
      }
    },
    showUnpaid: function showUnpaid(text) {
      var _this4 = this;

      this.unpaidNotice = text;
      clearTimeout(this.unpaidNoticeTimer);
      this.unpaidNoticeTimer = setTimeout(function () {
        _this4.unpaidNotice = '';
      }, 2000);
    },
    openSendToErbilModal: function openSendToErbilModal() {
      var _this5 = this;

      if (this.qrCodeValues.length < 1) {
        return __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({ text: 'Please at least select one order!', icon: 'warning', dangerMode: true });
      }
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('api/whatsapp-message-template', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var template = response.data.data;
        if (template) {
          _this5.sendToErbilData.englishMessage = template.english_message;
          _this5.sendToErbilData.arabicMessage = template.arabic_message;
          _this5.sendToErbilData.kurdishMessage = template.kurdish_message;
        }
      }).catch(function () {});
      this.sendToErbilData.send_sms = true;
      this.sendToErbilModal = true;
    },
    sendToErbilSubmit: function sendToErbilSubmit() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      var payload = { order_ids: this.qrCodeValues.map(function (x) {
          return x[0];
        }), send_sms: this.sendToErbilData.send_sms };
      if (this.sendToErbilData.send_sms) {
        if (!(this.sendToErbilData.englishMessage || this.sendToErbilData.arabicMessage || this.sendToErbilData.kurdishMessage)) {
          return __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', 'The WhatsApp message is empty', 'error');
        }
        payload.message_template = this.sendToErbilData.englishMessage + '\n\n---\n\n' + this.sendToErbilData.arabicMessage + '\n\n---\n\n' + this.sendToErbilData.kurdishMessage;
      }
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put('api/int_shipment_to_erbil', payload, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var _response$data$data = response.data.data,
            unpaid = _response$data$data.unpaid,
            skipped = _response$data$data.skipped;

        _this6.sendToErbilModal = false;
        _this6.qrCodeValues = [];
        $('#mainCheck').prop('checked', false);
        _this6.getResults();
        if (skipped) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Done', skipped + ' selected orders were no longer in International Shipment and were skipped', 'warning');
        } else if (!unpaid.length) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({ title: 'Done', text: '', icon: 'success', timer: 1500, buttons: false });
        }
        if (unpaid.length) {
          _this6.showUnpaid((unpaid.length === 1 ? unpaid[0] : unpaid.length + ' orders') + ' Int shipping not paid');
        }
      }).catch(function (error) {
        _this6.sendToErbilModal = false;
        _this6.getResults();
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', error.response ? error.response.data.message : 'Failed', 'error');
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openGenerateQrCodeModal: function openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      } else {
        this.generateQrCodeModal = true;
      }
    },
    closeGenerateQrCodeModal: function closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false;
      this.qrCodeValues = [];
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/shipping-export?' + arr);
    },
    getOrderID: function getOrderID(orders) {
      this.orderID = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id;
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this7 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this7.filterMade = true;
          _this7.apiResults = data.data;
        } else {
          _this7.filterMade = false;
          _this7.apiResults = data.data.data;
        }

        if (_this7.apiResults.length === 0) {
          _this7.tableData.searchOneCol = '';
          _this7.tableData.searchOneVal = '';
          _this7.tableData.search = '';
          _this7.alertValue = true;
        } else {
          _this7.alertValue = false;
        }
        if (data.data.length > 0) {
          _this7.removeConfigPagination();
        } else {
          _this7.configPagination(data.data);
        }
        _this7.getOrderID(_this7.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this7.totalResult = 0;
        for (var i = 0; i < _this7.apiResults.length; i++) {
          _this7.totalResult += 1;
        }
      }).catch(function () {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.warehouse = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openSendToPendingToBranchModal: function openSendToPendingToBranchModal() {
      this.sendToPendingToBranchModal = true;
    },
    closeSendToPendingToBranchModal: function closeSendToPendingToBranchModal() {
      this.sendToPendingToBranchModal = false;
      this.sendToPendingToBranchData.order_id = '';
      this.$validator.reset();
    },
    sendToPendingToBranch: function sendToPendingToBranch() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.deliverToPendingToBranchUrl + '/' + this.sendToPendingToBranchData.order_id, this.sendToPendingToBranchData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this8.sendToPendingToBranchData.order_id = '';
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          title: 'Success',
          text: 'Sent successfully',
          icon: 'success',
          timer: 1000
        });
        _this8.getResults();
      }).catch(function (error) {
        _this8.sendToPendingToBranchData.order_id = '';
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          title: 'Error',
          text: error.response.data.message,
          icon: 'error',
          timer: 1000
        });
        _this8.getResults();
      });
    },
    deliverToPendingToBranch: function deliverToPendingToBranch(id) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once delivered to pending to branch, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(_this9.deliverToPendingToBranchUrl + '/' + id, '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this9.getResults();
            __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            _this9.getResults();
            __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          });
        }
      });
    },
    returnToPurchase: function returnToPurchase(id) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
        title: 'Are you sure ?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true,
        className: 'danger-swal'
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(_this10.returnToPurchaseUrl + id + '/return_to_purchase', '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this10.getResults();
            __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this11.detailResults = data.data;
        _this11.detialData = _this11.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    getByWarehouse: function getByWarehouse(warehouse) {
      this.tableData.warehouse = warehouse;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      this.checkingAll = true;
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
      this.checkingAll = false;
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sendToPendingToBranchModal', 'closeSendToPendingToBranchModal', 'sendToPendingToBranchData', 'sendToPendingToBranch'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.sendToPendingToBranch();

          setTimeout(function () {
            _this.focusQrCodeInput();
          }, 1100);
        }
      });
    },
    focusQrCodeInput: function focusQrCodeInput() {
      setTimeout(function () {
        var qrcodeInput = document.getElementById('qrcode');
        if (qrcodeInput) qrcodeInput.focus();
      }, 100);
    }
  },

  watch: {
    sendToPendingToBranchModal: function sendToPendingToBranchModal(isOpen) {
      var _this2 = this;

      if (isOpen) {
        this.$nextTick(function () {
          _this2.focusQrCodeInput();
          _this2.$refs.sendForm && _this2.$refs.sendForm.resetValidation();
        });
      }
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendToIntShipment_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'send-to-int-shipment': __WEBPACK_IMPORTED_MODULE_3__sendToIntShipment_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
    this.getPallets();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check Box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'int_shipment_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/pending_to_shipment_order',
      intShipmentUrl: 'api/int_shipmenting',
      initMultipleShipmentUrl: 'api/int_shipmenting_multiple_order',
      intShipmentByQrCodeUrl: 'api/int_shipmenting_by_qrcode',
      // the send window: which plane each group of orders goes on
      sendWindow: false,
      sendGroups: [],
      sendMode: 'multiple',
      sendBusy: false,
      openPallets: [],
      warehouses: [],
      originOf: {},
      orderDetailUrl: 'api/show_order_detail',
      sendToIntShipmentModal: false,
      sendToIntShipmentData: {
        order_id: ''
      },
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      generateQrCodeModal: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      qrCodeValues: [],
      loggedInUserData: {},
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      orderID: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },


    // the window needs the origin (USA, China, UAE) of each selected order; rows carry it
    rememberOrigins: function rememberOrigins() {
      var _this = this;

      this.apiResults.forEach(function (r) {
        _this.$set(_this.originOf, r.order_id, { warehouse_id: r.warehouse_id_fk, country: r.country });
      });
    },
    getPallets: function getPallets() {
      var _this2 = this;

      var headers = { Authorization: 'Bearer ' + localStorage.getItem('access_token') };
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/pallets/list', { params: { open: 1 }, headers: headers }).then(function (response) {
        _this2.openPallets = response.data;
      }).catch(function () {});
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/warehouses', { headers: headers }).then(function (response) {
        _this2.warehouses = response.data.data || [];
      }).catch(function () {});
    },
    palletsFor: function palletsFor(group) {
      return this.openPallets.filter(function (p) {
        return !group.warehouse_id || p.warehouse_id_fk == group.warehouse_id;
      });
    },


    // One group per origin; the newest open pallet of that origin is chosen, otherwise a new one.
    openSendWindow: function openSendWindow(orderIds, mode) {
      var _this3 = this;

      var groups = {};
      orderIds.forEach(function (id) {
        var origin = _this3.originOf[id] || { warehouse_id: null, country: null };
        var key = origin.warehouse_id || 'unknown';
        if (!groups[key]) {
          groups[key] = { key: key, warehouse_id: origin.warehouse_id, country: origin.country, order_ids: [], pallet_id: 'new', new_number: '', new_date: '', new_warehouse_id: null };
        }
        groups[key].order_ids.push(id);
      });
      this.sendGroups = Object.values(groups);
      this.sendGroups.forEach(function (g) {
        var open = _this3.palletsFor(g);
        g.pallet_id = open.length > 0 ? open[0].pallet_id : 'new';
      });
      this.sendMode = mode;
      this.sendWindow = true;
      this.getPallets();
    },
    confirmSend: function confirmSend() {
      var _this4 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.sendGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var g = _step.value;

          if (g.pallet_id === 'new' && !g.new_number.trim()) {
            return __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Write the plane number for ' + (g.country || 'the new pallet'), 'error');
          }
          if (g.pallet_id === 'new' && !g.warehouse_id && !g.new_warehouse_id) {
            return __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Choose the origin of the plane', 'error');
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var toSend = this.sendGroups.filter(function (g) {
        return g.pallet_id !== 'skip';
      });
      if (toSend.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Nothing is chosen to send', 'error');
      }
      var headers = { Authorization: 'Bearer ' + localStorage.getItem('access_token') };
      this.sendBusy = true;
      var chain = Promise.resolve();
      toSend.forEach(function (g) {
        chain = chain.then(function () {
          if (g.pallet_id === 'none') {
            // sent the old way: the order gets no pallet
            return null;
          }
          if (g.pallet_id !== 'new') {
            return g.pallet_id;
          }
          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('api/pallets', { tracking_number: g.new_number.trim(), warehouse_id_fk: g.warehouse_id || g.new_warehouse_id, flight_date: g.new_date || null }, { headers: headers }).then(function (response) {
            return response.data.pallet_id;
          });
        }).then(function (palletId) {
          if (_this4.sendMode === 'multiple') {
            return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this4.initMultipleShipmentUrl, { orders_id: g.order_ids, pallet_id: palletId }, { headers: headers });
          }
          var url = _this4.sendMode === 'qr' ? _this4.intShipmentByQrCodeUrl : _this4.intShipmentUrl;
          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url + '/' + g.order_ids[0], { pallet_id: palletId }, { headers: headers });
        });
      });
      chain.then(function () {
        _this4.sendWindow = false;
        _this4.sendToIntShipmentData.order_id = '';
        _this4.qrCodeValues = [];
        _this4.getResults();
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({ title: 'Done', text: '', icon: 'success', timer: 1500, buttons: false });
      }).catch(function (error) {
        _this4.getResults();
        var message = error.response && error.response.data.message || 'Something went wrong';
        if (typeof message !== 'string') {
          message = Object.values(message).map(function (m) {
            return [].concat(m).join(' ');
          }).join(' ');
        }
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', message, 'error');
      }).then(function () {
        _this4.sendBusy = false;
      });
    },
    sendAllToIntShipment: function sendAllToIntShipment() {
      var ordersId = this.qrCodeValues.map(function (e) {
        return e[0];
      });

      if (ordersId.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Please select order', 'error');
      }

      this.openSendWindow(ordersId, 'multiple');
    },
    openSendToIntShipmentModal: function openSendToIntShipmentModal() {
      this.sendToIntShipmentModal = true;
    },
    closeSendToIntShipmentModal: function closeSendToIntShipmentModal() {
      this.sendToIntShipmentModal = false;
      this.sendToIntShipmentData.order_id = '';
      this.$validator.reset();
    },


    // the QR window: the typed order is sent through the send window like the others
    sendToIntShipment: function sendToIntShipment() {
      this.openSendWindow([this.sendToIntShipmentData.order_id], 'qr');
    },
    shipmentOrder: function shipmentOrder(id) {
      this.openSendWindow([id], 'single');
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.orderID.length; i++) {
        if (i < this.orderID.length - 1) {
          arr = arr.concat('arr[]=' + this.orderID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.orderID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/pending-shipping-export?' + arr);
    },
    getOrderID: function getOrderID(orders) {
      this.orderID = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id;
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
          _this5.rememberOrigins();
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
          _this5.rememberOrigins();
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        _this5.getOrderID(_this5.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function () {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.warehouse = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this6.detailResults = data.data;
        _this6.detialData = _this6.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    getByWarehouse: function getByWarehouse(warehouse) {
      this.tableData.warehouse = warehouse;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendToUser_vue__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__prepareToPrint__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createQrCode_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_orderInvoice_AddOrderInvoice_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_deliveryInvoice_AddDeliveryInvoice_vue__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deliveryInvoice_ViewCustomerDeliveryInvoice_vue__ = __webpack_require__(240);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'send-to-user': __WEBPACK_IMPORTED_MODULE_4__sendToUser_vue__["a" /* default */],
    'prepare-to-print': __WEBPACK_IMPORTED_MODULE_5__prepareToPrint__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__["a" /* default */],
    'create-qr-code': __WEBPACK_IMPORTED_MODULE_9__createQrCode_vue__["a" /* default */],
    AddOrderInvoice: __WEBPACK_IMPORTED_MODULE_10__components_orderInvoice_AddOrderInvoice_vue__["a" /* default */],
    AddDeliveryInvoice: __WEBPACK_IMPORTED_MODULE_11__components_deliveryInvoice_AddDeliveryInvoice_vue__["a" /* default */],
    ViewCustomerDeliveryInvoice: __WEBPACK_IMPORTED_MODULE_12__deliveryInvoice_ViewCustomerDeliveryInvoice_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check Box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Shiponly',
      text: 'Shiponly',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'is_ship_only'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'branch_delivery_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/branch_delivery_order',
      archiveOrderUrl: 'api/user_delivering',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      prepareToPrintUrl: 'api/prepare_to_print',
      getCustomerPrice: 'api/subscriptions/customer-price',
      sendToUserModal: false,
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      customersList: [],
      orderInvoiceModal: false,
      generateInvoiceData: {},
      deliveryInvoiceData: {},
      deliveryInvoiceModal: false,
      companyData: {},
      invoiceData: {},
      viewDeliveryInvoiceModal: false,
      generateQrCodeModal: false,
      qrCodeValues: [],
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      sendToUserData: {
        order_id: ''
      },
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      orderID: {
        orders_id: []
      },
      printData: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewDeliveryInvoice: function viewDeliveryInvoice(data) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/delivery_invoice/' + data.delivery_invoice_id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewDeliveryInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCustomer: function getCustomer() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get-customer-to-select', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.customersList = [];
        var result = response.data.data;

        result.forEach(function (c) {
          _this3.customersList.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id,
            phone: c.phone_number
          });
        });
      });
    },
    checkDiff: function checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1;
    },
    openDeliveryInvoiceModal: function openDeliveryInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      var customerIds = [];
      var ordersArr = [];
      this.qrCodeValues.forEach(function (x, i) {
        var obj = {
          order_id: null,
          customer_name: null,
          phone_number: null,
          customer_credit: null,
          customer_id: null,
          the_order_id: null
        };
        x.forEach(function (y, j) {
          if (j === 0) {
            obj.order_id = y;
          } else if (j === 1) {
            obj.customer_name = y;
          } else if (j === 2) {
            obj.phone_number = y;
          } else if (j === 3) {
            customerIds.push(y);
            obj.customer_id = y;
          } else if (j === 4) {
            obj.the_order_id = y;
          } else if (j === 8) {
            obj.customer_credit = Number(y);
          }
        });
        ordersArr.push(obj);
      });

      if (this.checkDiff(customerIds)) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      this.deliveryInvoiceData = {
        customer_id_fk: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        phone_number: ordersArr[0].phone_number,
        customer_credit: ordersArr[0].customer_credit,
        orders: ordersArr,
        orders_id: ordersArr.map(function (order) {
          return order.order_id;
        })
      };

      this.deliveryInvoiceModal = true;
    },
    openOrderInvoiceModal: function openOrderInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      var customerIds = [];
      var ordersArr = [];
      this.qrCodeValues.forEach(function (x, i) {
        var obj = {
          order_id: null,
          customer_name: null,
          phone: null,
          customer_id: null,
          the_order_id: null,
          warehouse_id: null,
          transportation_type: null,
          is_ship_only: null
        };
        x.forEach(function (y, j) {
          if (j === 0) {
            obj.order_id = y;
          } else if (j === 1) {
            obj.customer_name = y;
          } else if (j === 2) {
            obj.phone = y;
          } else if (j === 3) {
            customerIds.push(y);
            obj.customer_id = y;
          } else if (j === 4) {
            obj.the_order_id = y;
          } else if (j === 8) {
            obj.warehouse_id = y;
          } else if (j === 9) {
            obj.transportation_type = y;
          } else if (j === 10) {
            obj.is_ship_only = y;
          }
        });
        ordersArr.push(obj);
      });

      if (this.checkDiff(customerIds)) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      this.generateInvoiceData = {
        volume: 0,
        delivery_price: 0,
        customer_id: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        warehouse_id: ordersArr[0].warehouse_id,
        transportation_type: ordersArr[0].transportation_type,
        is_ship_only: ordersArr[0].is_ship_only,
        phone: ordersArr[0].phone,
        orders: ordersArr
      };

      this.orderInvoiceModal = true;
    },
    generateInvoiceCustomer: function generateInvoiceCustomer(id) {
      var customer = this.customersList.find(function (x) {
        return x.value === id;
      });
      this.generateInvoiceData = {
        customer_id: customer.value,
        customer_name: customer.text,
        phone: customer.phone,
        orders: []
      };

      this.orderInvoiceModal = true;
    },
    openGenerateQrCodeModal: function openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      } else {
        this.generateQrCodeModal = true;
      }
    },
    closeGenerateQrCodeModal: function closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false;
      this.qrCodeValues = [];
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    prepareToPrint: function prepareToPrint() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.prepareToPrintUrl, {
        params: this.orderID,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = [];
        data = response.data.data;
        _this4.printData = [];
        _this4.printData = data;
      });
      this.modal('prepare_modal');
    },
    getOrderID: function getOrderID(orders) {
      this.orderID.orders_id = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID.orders_id[i] = orders[i].order_id;
      }
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        _this5.getOrderID(_this5.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    sendToExport: function sendToExport() {
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      // Build URL parameters from current table state
      var params = new URLSearchParams({
        searchedOneCol: this.tableData.searchOneCol || '',
        searchedOneVal: this.tableData.searchOneVal || '',
        column: this.tableData.column || 'updated_at',
        sortDir: this.tableData.sortDir || 'desc',
        searchValue: this.tableData.search || '',
        from_date: this.tableData.from_date || '',
        to_date: this.tableData.to_date || '',
        warehouses: localStorage.getItem('warehouse_id_fk') || '',
        per_page: this.tableData.per_page || 10,
        branches_id: this.tableData.branches_id || ''
      });

      window.location.replace(fullHostName + '/api/delivered-to-erbil-export?' + params.toString());
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    sendAllToUser: function sendAllToUser() {
      var _this6 = this;

      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }
      var customerIds = [];
      var orderIds = [];
      this.qrCodeValues.forEach(function (x, i) {
        x.forEach(function (y, j) {
          if (j === 0) {
            orderIds.push(y);
          } else if (j === 3) {
            customerIds.push(y);
          }
        });
      });

      if (this.checkDiff(customerIds)) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      var _loop = function _loop(i) {
        var order = _this6.apiResults.find(function (x) {
          return x.order_id === orderIds[i];
        });

        if (Number(order.internal_shipping_handling) < 1 && !order.order_invoice_id_fk) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Order ' + order.theOrderID + ' does not have shipping price', 'error');
          return {
            v: void 0
          };
        }
      };

      for (var i = 0; i < orderIds.length; i++) {
        var _ret = _loop(i);

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      }

      var data = this.apiResults.find(function (x) {
        return x.user_id === customerIds[0];
      });

      if (Number(data.credit) < 0) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          title: 'Warning',
          text: 'This customer (' + data.full_name + ') has loan and must pay at least $' + Number(data.credit) * -1,
          icon: 'warning',
          buttons: ['Cancel', 'Skip']
        }).then(function (confirm) {
          if (confirm) {
            var token = localStorage.getItem('access_token');

            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('api/user_delivering_multiple', { orders: orderIds }, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this6.getResults();
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1000,
                buttons: false
              });
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Warning', err.response.data.message, 'error');
            });
          }
        });

        return;
      }

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once sent, you will not be able to return these order to this step!',
        icon: 'warning',
        buttons: true
      }).then(function (confirm) {
        if (confirm) {
          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('api/user_delivering_multiple', { orders: orderIds }, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this6.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1000,
              buttons: false
            });
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Warning', err.response.data.message, 'error');
          });
        }
      });
    },
    openSendToUserModal: function openSendToUserModal() {
      this.sendToUserModal = true;
    },
    closeSendToUserModal: function closeSendToUserModal() {
      this.sendToUserModal = false;
      this.sendToUserData.order_id = '';
    },
    sendToUser: function sendToUser() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get_order_detail/' + this.sendToUserData.order_id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        if (Number(response.data.data.internal_shipping_handling) < 1 && !response.data.data.order_invoice_id_fk) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'This order #' + response.data.data.theOrderID + ' does not have shipping price', 'error');
          return;
        }

        if (response.data.data.customer.credit < 0) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'This customer (' + response.data.data.customer.full_name + ') has loan and must pay at least $' + response.data.data.customer.credit * -1, 'error');
          return;
        }

        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this7.archiveOrderUrl + '/' + _this7.sendToUserData.order_id, '', {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this7.sendToUserData.order_id = '';
          _this7.getResults();
        }).catch(function (error) {
          _this7.sendToUserData.order_id = '';
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        });
      });
    },
    returnToPurchase: function returnToPurchase(id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this8.returnToPurchaseUrl + id + '/return_to_purchase', '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this8.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    deliverToUser: function deliverToUser(data) {
      var _this9 = this;

      if (Number(data.internal_shipping_handling) < 1 && !data.order_invoice_id_fk) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'This order does not have shipping price', 'error');
        return;
      }

      if (data.credit < 0) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          title: 'Warning',
          text: 'This customer (' + data.full_name + ') has loan and must pay at least $' + data.credit * -1,
          icon: 'warning',
          buttons: ['Cancel', 'Skip']
        }).then(function (confirm) {
          if (confirm) {
            var token = localStorage.getItem('access_token');
            __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this9.archiveOrderUrl + '/' + data.order_id, '', {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this9.getResults();
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1000,
                buttons: false
              });
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        });
        return;
      }

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once sent, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then(function (accept) {
        if (accept) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(_this9.archiveOrderUrl + '/' + data.order_id, '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this9.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          });
        }
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this10.detailResults = data.data;
        _this10.detialData = _this10.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sendToUserModal', 'closeSendToUserModal', 'sendToUserData', 'sendToUser'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.sendToUser();
        }
      });
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['printData', 'closeModal'],

  methods: {
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] });

      $('#close-button').show();
      $('#print-button').show();
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddOrderInvoice_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4143f9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddOrderInvoice_vue__ = __webpack_require__(676);
function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddOrderInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4143f9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddOrderInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    orderInvoiceModal: {},
    formData: {},
    is_second_invoice: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      warehouses: [],
      apiCustomerPrice: [],
      transportationTypes: [],
      orderTypes: [],
      shiponly_handle_fee: 0,
      shipment: 0,
      transportation_type: null,
      isHandlingFeeManual: false,
      isShipmentManual: false
    };
  },


  watch: {
    orderInvoiceModal: function orderInvoiceModal(newValue) {
      if (newValue) {
        this.getWarehouses();
      }
    }
  },

  methods: {
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      }).finally(function () {
        if (_this.formData.warehouse_id) {
          _this.handleSelectWarehouse(_this.formData.warehouse_id);
        }
      });
    },
    getCustomerPriceList: function getCustomerPriceList() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      var params = {
        customer_id_fk: this.formData.customer_id,
        warehouse_id_fk: this.formData.warehouse_id,
        order_type_id_fk: this.formData.order_type_id
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/subscription-pricing/customer-price', params, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this2.apiCustomerPrice = data.data;
        _this2.formData.shiponly_handling_fee = _this2.transportation_type === 1 ? data.data.shiponly_handling_fee_air : data.data.shiponly_handling_fee_sea;
        _this2.formData.shipment = _this2.transportation_type === 1 ? data.data.item_price_air : _this2.transportation_type === 2 ? data.data.item_price_sea : data.data.item_price_land;
        _this2.isHandlingFeeManual = false;
        _this2.isShipmentManual = false;
      }).catch(function (errors) {}).finally(function () {
        _this2.calculateTotalAmount();
      });
    },
    getOrderTypes: function getOrderTypes() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/subscription-pricing/get-order-types/' + this.formData.warehouse_id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        _this3.getCustomerPriceList();
        _this3.orderTypes = []; // Clear existing order types
        result.forEach(function (r) {
          _this3.orderTypes.push({
            text: r.type_name,
            value: r.order_type_id,
            type_price_air: r.type_price_air,
            type_price_sea: r.type_price_sea,
            type_price_land: r.type_price_land
          });
        });
        _this3.getCustomerPriceList();
      });
    },
    handleOrderTypeChange: function handleOrderTypeChange() {
      this.isShipmentManual = false;
      this.isHandlingFeeManual = false;
      this.getCustomerPriceList();
    },
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
      this.transportation_type = this.formData.transportation_type;

      this.getOrderTypes();
    },
    removeOrder: function removeOrder(index) {
      this.formData.orders.splice(index, 1);
    },
    handleHandlingFeeInput: function handleHandlingFeeInput() {
      this.isHandlingFeeManual = true;
      this.calculateTotalAmount();
    },
    handleShipmentInput: function handleShipmentInput() {
      this.isShipmentManual = true;
      this.calculateTotalAmount();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var tax = Number(this.formData.tax) || 0;
      var deliveryPrice = Number(this.formData.delivery_price) || 0;
      var discount = Number(this.formData.discount) || 0;

      if (this.formData.is_ship_only == 1 && !this.isHandlingFeeManual) {
        this.shiponly_handle_fee = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shiponly_handling_fee || 0).toFixed(2));
      } else if (this.formData.is_ship_only != 1) {
        this.shiponly_handle_fee = 0;
      }

      if (!this.isShipmentManual) {
        this.shipment = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shipment || 0).toFixed(2));
      }

      var total = Number(this.shipment) + tax + deliveryPrice + Number(this.shiponly_handle_fee);
      this.formData.handling_fee = this.shiponly_handle_fee;
      this.formData.total_price = total.toFixed(2);
      this.formData.net_price = (total - discount).toFixed(2);
    },
    submitForm: function submitForm() {
      var _this4 = this;

      if (this._submitTimeout) {
        return;
      }
      this._submitTimeout = setTimeout(function () {
        _this4._submitTimeout = null;
      }, 500);

      // if (this.formData.orders.length === 0) {
      //   swal('Warning', 'Please at least select one order', 'error')
      //   return
      // }

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');
          _this4.formData.is_second_invoice = _this4.is_second_invoice;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/order_invoice', _this4.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Done',
              text: 'Invoice generated successfully',
              icon: 'success',
              timer: 750,
              buttons: false
            });
            _this4.$emit('invoice-created');
            _this4.$emit('close');
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Warning', err.response.data.message, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['deliveryInvoiceModal', 'formData'],

  data: function data() {
    return {};
  },


  methods: {
    removeOrder: function removeOrder(index) {
      this.formData.orders.splice(index, 1);
      this.formData.orders_id.splice(index, 1);
    },
    submitForm: function submitForm() {
      var _this = this;

      if (this.formData.orders.length === 0) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Warning', 'Please at least select one order', 'error');
        return;
      }

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/delivery_invoice', _this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              text: 'Invoice generated successfully',
              icon: 'success',
              timer: 1000,
              buttons: false
            });
            _this.$emit('invoice-created', res.data);
            _this.$emit('close');
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Warning', err.response.data.message, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewCustomerDeliveryInvoice_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee1328e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewCustomerDeliveryInvoice_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewCustomerDeliveryInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee1328e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewCustomerDeliveryInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['viewDeliveryInvoiceModal', 'companyData', 'invoiceData'],

  methods: {
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();
      $('.show-in-print').show();

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] });

      $('#close-button').show();
      $('#print-button').show();
      $('.show-in-print').hide();
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__createQrCode_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sendToBranch_vue__ = __webpack_require__(688);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__["a" /* default */],
    'create-qr-code': __WEBPACK_IMPORTED_MODULE_7__createQrCode_vue__["a" /* default */],
    'send-to-branch': __WEBPACK_IMPORTED_MODULE_8__sendToBranch_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.fetchWhatsAppTemplate();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check Box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'branch_delivery_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/pending_to_branch_order',
      archiveOrderUrl: 'api/user_delivering',
      orderDetailUrl: 'api/show_order_detail',
      deliverToBranchUrl: 'api/branch_delivering',
      sendToBranchModal: false,
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      sendToBranchData: {
        order_id: '',
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      deliverToBranchModal: false,
      deliverToBranchData: {
        id: '',
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      sendAllToBranchModal: false,
      sendAllToBranchData: {
        send_sms: true,
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      savedTemplate: {
        englishMessage: '',
        arabicMessage: '',
        kurdishMessage: ''
      },
      generateQrCodeModal: false,
      qrCodeValues: [],
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      orderID: {
        orders_id: []
      },
      printData: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    fetchWhatsAppTemplate: function fetchWhatsAppTemplate() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/whatsapp-message-template', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        if (response.data.success && response.data.data) {
          var template = response.data.data;
          _this.savedTemplate.englishMessage = template.english_message;
          _this.savedTemplate.arabicMessage = template.arabic_message;
          _this.savedTemplate.kurdishMessage = template.kurdish_message;

          // Populate all three data objects with the saved template
          _this.sendToBranchData.englishMessage = template.english_message;
          _this.sendToBranchData.arabicMessage = template.arabic_message;
          _this.sendToBranchData.kurdishMessage = template.kurdish_message;

          _this.deliverToBranchData.englishMessage = template.english_message;
          _this.deliverToBranchData.arabicMessage = template.arabic_message;
          _this.deliverToBranchData.kurdishMessage = template.kurdish_message;

          _this.sendAllToBranchData.englishMessage = template.english_message;
          _this.sendAllToBranchData.arabicMessage = template.arabic_message;
          _this.sendAllToBranchData.kurdishMessage = template.kurdish_message;
        }
      }).catch(function (error) {
        console.error('Error fetching WhatsApp template:', error);
      });
    },
    saveWhatsAppTemplate: function saveWhatsAppTemplate() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      // Use the messages from whichever dialog is currently open
      var englishMessage = '';
      var arabicMessage = '';
      var kurdishMessage = '';

      if (this.sendToBranchModal) {
        englishMessage = this.sendToBranchData.englishMessage;
        arabicMessage = this.sendToBranchData.arabicMessage;
        kurdishMessage = this.sendToBranchData.kurdishMessage;
      } else if (this.deliverToBranchModal) {
        englishMessage = this.deliverToBranchData.englishMessage;
        arabicMessage = this.deliverToBranchData.arabicMessage;
        kurdishMessage = this.deliverToBranchData.kurdishMessage;
      } else if (this.sendAllToBranchModal) {
        englishMessage = this.sendAllToBranchData.englishMessage;
        arabicMessage = this.sendAllToBranchData.arabicMessage;
        kurdishMessage = this.sendAllToBranchData.kurdishMessage;
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/whatsapp-message-template', {
        english_message: englishMessage,
        arabic_message: arabicMessage,
        kurdish_message: kurdishMessage
      }, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        if (response.data.success) {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Success', 'Template saved successfully', 'success');
          _this2.fetchWhatsAppTemplate();
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', 'Failed to save template', 'error');
        console.error('Error saving WhatsApp template:', error);
      });
    },
    sendAllToPendingToBranch: function sendAllToPendingToBranch() {
      if (this.qrCodeValues.length < 1) {
        return __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      }

      this.sendAllToBranchModal = true;
    },
    getCompanyData: function getCompanyData(token) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.companyData = response.data.data;
      });
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    checkDiff: function checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1;
    },
    openGenerateQrCodeModal: function openGenerateQrCodeModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Please at least select one order!',
          icon: 'warning',
          dangerMode: true
        });
      } else {
        this.generateQrCodeModal = true;
      }
    },
    closeGenerateQrCodeModal: function closeGenerateQrCodeModal() {
      this.generateQrCodeModal = false;
      this.qrCodeValues = [];
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    getOrderID: function getOrderID(orders) {
      this.orderID.orders_id = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID.orders_id[i] = orders[i].order_id;
      }
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        _this4.getOrderID(_this4.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    sendToExport: function sendToExport() {
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      // Build URL parameters from current table state
      var params = new URLSearchParams({
        searchedOneCol: this.tableData.searchOneCol || '',
        searchedOneVal: this.tableData.searchOneVal || '',
        column: this.tableData.column || 'updated_at',
        sortDir: this.tableData.sortDir || 'desc',
        searchValue: this.tableData.search || '',
        from_date: this.tableData.from_date || '',
        to_date: this.tableData.to_date || '',
        warehouses: localStorage.getItem('warehouse_id_fk') || '',
        per_page: this.tableData.per_page || 10,
        branches_id: this.tableData.branches_id || ''
      });

      window.location.replace(fullHostName + '/api/pending-to-branch-export?' + params.toString());
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openSendToBranchModal: function openSendToBranchModal() {
      this.sendToBranchModal = true;
    },
    closeSendToBranchModal: function closeSendToBranchModal() {
      this.sendToBranchModal = false;
      this.sendToBranchData.order_id = '';
      // Reset to saved template
      this.sendToBranchData.englishMessage = this.savedTemplate.englishMessage;
      this.sendToBranchData.arabicMessage = this.savedTemplate.arabicMessage;
      this.sendToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage;
      this.$validator.reset();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    deliverToBranch: function deliverToBranch(order) {
      this.deliverToBranchData.id = order.order_id;

      // Use the saved template without customer name and order ID
      this.deliverToBranchData.englishMessage = this.savedTemplate.englishMessage;
      this.deliverToBranchData.arabicMessage = this.savedTemplate.arabicMessage;
      this.deliverToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage;

      this.deliverToBranchModal = true;
    },
    sendToBranch: function sendToBranch() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      // First, get the order details to append customer info to messages
      if (this.sendToBranchData.send_sms) {
        // Fetch order details by QR code
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + this.sendToBranchData.order_id, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          var orderData = response.data.data[0];
          var customerName = orderData.full_name || '';
          var orderId = orderData.theOrderID || '';

          // Append customer name and order ID to the end of each message
          if (!_this5.sendToBranchData.englishMessage.includes(customerName)) {
            _this5.sendToBranchData.englishMessage += '\n\nCustomer: ' + customerName + '\nOrder ID: ' + orderId;
          }
          if (!_this5.sendToBranchData.arabicMessage.includes(customerName)) {
            _this5.sendToBranchData.arabicMessage += '\n\nالعميل: ' + customerName + '\nرقم الطلب: ' + orderId;
          }
          if (!_this5.sendToBranchData.kurdishMessage.includes(customerName)) {
            _this5.sendToBranchData.kurdishMessage += '\n\nکڕیار: ' + customerName + '\nژمارەی داواکاری: ' + orderId;
          }

          // Now send to branch
          _this5.submitSendToBranch(token);
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', 'Could not fetch order details', 'error');
        });
      } else {
        // Send directly if SMS not enabled
        this.submitSendToBranch(token);
      }
    },
    submitSendToBranch: function submitSendToBranch(token) {
      var _this6 = this;

      var payload = {
        send_sms: this.sendToBranchData.send_sms
      };

      if (this.sendToBranchData.send_sms) {
        // Generate full concatenated message in frontend
        var fullMessage = this.sendToBranchData.englishMessage + '\n\n---\n\n' + this.sendToBranchData.arabicMessage + '\n\n---\n\n' + this.sendToBranchData.kurdishMessage;
        payload.message = fullMessage;
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.deliverToBranchUrl + '/' + this.sendToBranchData.order_id, payload, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.sendToBranchData.order_id = '';
        // Reset to generic messages
        _this6.sendToBranchData.englishMessage = 'Hello,\n\nYour order has arrived in Erbil. Please visit us between 10:00 AM to 5:30 PM except Friday to pick up your goods from Ship Zone warehouse.';
        _this6.sendToBranchData.arabicMessage = 'مرحبا،\n\nوصل طلبك إلى أربيل. يرجى زيارتنا بين الساعة 10:00 صباحاً إلى 5:30 مساءً باستثناء الجمعة لاستلام بضائعك من مستودع Ship Zone.';
        _this6.sendToBranchData.kurdishMessage = 'سڵاو\n\nکالات گەیشتووەتە هەولێر. سەردانمان بکە لەنێوان 10:00  تا  5:30 ی ئێوارە جگە لە هەینی بۆ وەرگرتنەوەی کالاکانت لە کۆگای شیپ زۆن.';
        _this6.closeSendToBranchModal();
        _this6.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        _this6.sendToBranchData.order_id = '';
        // Reset to generic messages
        _this6.sendToBranchData.englishMessage = 'Hello,\n\nYour order has arrived in Erbil. Please visit us between 10:00 AM to 5:30 PM except Friday to pick up your goods from Ship Zone warehouse.';
        _this6.sendToBranchData.arabicMessage = 'مرحبا،\n\nوصل طلبك إلى أربيل. يرجى زيارتنا بين الساعة 10:00 صباحاً إلى 5:30 مساءً باستثناء الجمعة لاستلام بضائعك من مستودع Ship Zone.';
        _this6.sendToBranchData.kurdishMessage = 'سڵاو\n\nکالات گەیشتووەتە هەولێر. سەردانمان بکە لەنێوان 10:00  تا  5:30 ی ئێوارە جگە لە هەینی بۆ وەرگرتنەوەی کالاکانت لە کۆگای شیپ زۆن.';
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    deliverToBranchSubmit: function deliverToBranchSubmit() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      // First, get the order details to append customer info to messages
      if (this.deliverToBranchData.send_sms) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + this.deliverToBranchData.id, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          // Generate full concatenated message
          var fullMessage = _this7.deliverToBranchData.englishMessage + '\n\n---\n\n' + _this7.deliverToBranchData.arabicMessage + '\n\n---\n\n' + _this7.deliverToBranchData.kurdishMessage;

          var payload = {
            send_sms: _this7.deliverToBranchData.send_sms,
            message: fullMessage

            // Now send the request
          };_this7.submitDeliverToBranch(token, payload);
        }).catch(function () {
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', 'Could not fetch order details', 'error');
        });
      } else {
        // Send directly if SMS not enabled
        var payload = {
          send_sms: this.deliverToBranchData.send_sms
        };
        this.submitDeliverToBranch(token, payload);
      }
    },
    submitDeliverToBranch: function submitDeliverToBranch(token, payload) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.deliverToBranchUrl + '/' + this.deliverToBranchData.id, payload, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this8.closeDeliverToBranchModal();
        _this8.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        _this8.closeDeliverToBranchModal();
        _this8.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    closeDeliverToBranchModal: function closeDeliverToBranchModal() {
      this.deliverToBranchModal = false;
      this.deliverToBranchData.id = '';
      this.deliverToBranchData.send_sms = true;
      // Reset to saved template
      this.deliverToBranchData.englishMessage = this.savedTemplate.englishMessage;
      this.deliverToBranchData.arabicMessage = this.savedTemplate.arabicMessage;
      this.deliverToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage;
    },
    sendAllToBranchSubmit: function sendAllToBranchSubmit() {
      var _this9 = this;

      var orderIds = this.qrCodeValues.map(function (val) {
        return val[0];
      });
      var token = localStorage.getItem('access_token');
      var payload = {
        order_ids: orderIds,
        send_sms: this.sendAllToBranchData.send_sms
      };

      if (this.sendAllToBranchData.send_sms) {
        // Generate full concatenated message template for bulk operations
        var messageTemplate = this.sendAllToBranchData.englishMessage + '\n\n---\n\n' + this.sendAllToBranchData.arabicMessage + '\n\n---\n\n' + this.sendAllToBranchData.kurdishMessage;
        payload.message_template = messageTemplate;
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/deliver_multiple_order_to_branch', payload, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
        _this9.closeSendAllToBranchModal();
        _this9.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        _this9.closeSendAllToBranchModal();
        _this9.getResults();
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    closeSendAllToBranchModal: function closeSendAllToBranchModal() {
      this.sendAllToBranchModal = false;
      this.sendAllToBranchData.send_sms = true;
      // Reset to saved template
      this.sendAllToBranchData.englishMessage = this.savedTemplate.englishMessage;
      this.sendAllToBranchData.arabicMessage = this.savedTemplate.arabicMessage;
      this.sendAllToBranchData.kurdishMessage = this.savedTemplate.kurdishMessage;
      this.qrCodeValues = [];
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this10.detailResults = data.data;
        _this10.detialData = _this10.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sendToBranchModal', 'closeSendToBranchModal', 'sendToBranchData', 'sendToBranch', 'saveWhatsAppTemplate'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.sendToBranch();
        }
      });
    },
    saveTemplate: function saveTemplate() {
      if (this.saveWhatsAppTemplate) {
        this.saveWhatsAppTemplate();
      }
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addStaff_vue__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editStaff_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resetPassword_vue__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'add-staff': __WEBPACK_IMPORTED_MODULE_3__addStaff_vue__["a" /* default */],
    'edit-staff': __WEBPACK_IMPORTED_MODULE_4__editStaff_vue__["a" /* default */],
    'reset-password': __WEBPACK_IMPORTED_MODULE_5__resetPassword_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?name=', '') !== null || window.location.search.replace('?name=', '') !== '') {
        var value = window.location.search.replace('?name=', '');
        this.searchOneCol('full_name', value);
      }
    }
    this.getResults();
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    this.getWarehouses();
    this.getBranches();
    this.getRoles();
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'user_id' }, {
      label: 'Name',
      text: 'Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'full_name'
    },
    // {
    //   label: 'Default Branch',
    //   text: 'Default Branch',
    //   value: '3',
    //   sortable: true,
    //   searchable: true,
    //   name: 'branch_name'
    // },
    {
      label: 'Email',
      text: 'Email',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'email'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Status',
      text: 'Status',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'is_blocked'
    }, { label: 'Role', text: 'Role', value: '6', sortable: false, searchable: false, name: 'user_roles' }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'country'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/users',
      addStaffModal: false,
      resetPasswordModal: false,
      blockUserUrl: 'api/users',
      unBlockUserUrl: 'api/users',
      resetPasswordUrl: 'api/users',
      editStaffUrl: 'api/update-staff',
      rowIndex: '',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      checkAlert: false,
      validationError: false,
      phoneValidation: false,
      editStaffModal: false,
      backendError: false,
      queryParameter: true,
      emailError: '',
      phoneError: '',
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      loggedInUserData: {},
      roles: [],
      warehouses: [],
      branches: [],
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      resetPasswordData: {
        new_password: '',
        confirm_password: ''
      },
      addData: {
        rolesId: [],
        warehouse_id_fk: []
      },
      editStaffData: {
        rolesId: [],
        warehouse_id_fk: [1]
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getRoles: function getRoles() {
      var _this = this;

      this.roles = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('api/role/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (r) {
          _this.roles.push({ text: r.status, value: r.role_id });
        });
      });
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      this.warehouses = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getBranches: function getBranches() {
      var _this3 = this;

      this.branches = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        result.forEach(function (r) {
          _this3.branches.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    blockUser: function blockUser(id) {
      var _this5 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.delete(this.blockUserUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this5.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    unblockUser: function unblockUser(id) {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.unBlockUserUrl + '/' + id + '/unblock', '', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this6.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openResetPasswordModal: function openResetPasswordModal(userId) {
      this.the_user_id = userId;
      this.resetPasswordModal = true;
    },
    closeResetPasswordModal: function closeResetPasswordModal() {
      this.resetPasswordModal = false;
      this.checkAlert = false;
      this.clearResetPassword();
    },
    clearResetPassword: function clearResetPassword() {
      this.resetPasswordData.new_password = '';
      this.resetPasswordData.confirm_password = '';
      this.$validator.reset();
    },
    resetPassword: function resetPassword() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');
      var user = JSON.parse(localStorage.getItem('user_data'));

      if (this.the_user_id === user.user_id) {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Not Allowed', "You can't reset your password here, You can only reset password for others", 'error');
      } else {
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.resetPasswordUrl + '/' + this.the_user_id + '/reset_password', this.resetPasswordData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
          _this7.checkAlert = true;
          _this7.getResults();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        });
      }
    },
    openAddStaffModal: function openAddStaffModal() {
      this.addStaffModal = true;
    },
    closeAddStaffModal: function closeAddStaffModal() {
      this.addStaffModal = false;
      this.validationError = false;
      this.checkAlert = false;
      this.clear();
    },
    clear: function clear() {
      this.addData = {
        rolesId: [],
        warehouse_id_fk: []
      };
      this.$validator.reset();
    },
    addStaff: function addStaff() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(this.url, this.addData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this8.validationError = false;
        _this8.phoneValidation = false;
        _this8.checkAlert = true;
        _this8.getResults();
        _this8.clear();
      }).catch(function (error) {
        if (error.response.data.message.email) {
          _this8.checkAlert = false;
          _this8.phoneValidation = false;
          _this8.validationError = true;
          _this8.emailError = error.response.data.message.email[0];
        } else if (error.response.data.message.phone_number) {
          _this8.checkAlert = false;
          _this8.validationError = false;
          _this8.phoneValidation = true;
          _this8.phoneError = error.response.data.message.phone_number[0];
        }
      });
    },
    openEditStaffModal: function openEditStaffModal(r) {
      var w = [];
      r.warehouse_id_fk.split(',').forEach(function (x) {
        w.push(Number(x));
      });
      var rolesId = r.user_roles.map(function (role) {
        return role.role_id_fk;
      });
      // let branchesId = r.user_branches.map(role => role.branch_id_fk)
      var branchesId = [];
      this.the_user_id = r.user_id;
      this.editStaffData = r;
      this.editStaffData.rolesId = rolesId;
      this.editStaffData.branchesId = branchesId;
      this.editStaffData.warehouse_id_fk = w;
      this.editStaffModal = true;
    },
    closeEditStaffModal: function closeEditStaffModal() {
      this.editStaffData = {
        rolesId: [],
        warehouse_id_fk: []
      };
      this.validationError = false;
      this.checkAlert = false;
      this.editStaffModal = false;
    },
    editStaff: function editStaff() {
      var _this9 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.editStaffUrl + '/' + this.the_user_id, this.editStaffData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this9.validationError = false;
        _this9.backendError = false;
        _this9.checkAlert = true;
        setTimeout(function () {
          _this9.checkAlert = false;
          _this9.editStaffModal = false;
        }, 2000);
        _this9.getResults();
      }).catch(function (error) {
        _this9.checkAlert = false;
        if (error.response.data.message) {
          _this9.validationError = false;
          _this9.backendError = true;
          setTimeout(function () {
            _this9.backendError = false;
          }, 2000);
        }
        if (error.response.data.message.email[0]) {
          _this9.backendError = false;
          _this9.emailError = error.response.data.message.email[0];
          _this9.validationError = true;
          setTimeout(function () {
            _this9.validationError = false;
          }, 2000);
        }
      });
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addStaff', 'roles', 'warehouses', 'branches', 'addData', 'addStaffModal', 'checkAlert', 'closeAddStaffModal', 'emailError', 'validationError', 'phoneValidation', 'phoneError'],

  data: function data() {
    return {
      passwordAlert: false,
      e1: true,
      e2: true
    };
  },


  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.addData.password.trim() === _this.addData.confirm_password.trim()) {
            _this.passwordAlert = false;
            _this.addStaff();
          } else {
            _this.passwordAlert = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editStaff', 'roles', 'warehouses', 'branches', 'editStaffData', 'editStaffModal', 'checkAlert', 'closeEditStaffModal', 'emailError', 'validationError', 'backendError'],

  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editStaff();
        }
      });
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['resetPasswordModal', 'closeResetPasswordModal', 'checkAlert', 'resetPasswordData', 'resetPassword', 'customers'],

  data: function data() {
    return {
      errorAlert: false,
      e1: true,
      e2: true
    };
  },


  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.resetPasswordData.new_password.trim() === _this.resetPasswordData.confirm_password.trim()) {
            _this.errorAlert = false;
            _this.resetPassword();
          } else {
            _this.errorAlert = true;
          }
        }
      });
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getLoggedInUser();
    this.hostName = window.location.hostname;
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      branchesList: [],
      hostName: '',
      e1: true,
      e2: true,
      e3: true,
      e4: true,
      e5: true,
      e6: true,
      e7: true,
      e8: true,
      errorResponse: false,
      successResponse: false,
      currSec: false,
      newSec: false,
      confSec: false,
      matchSec: false,
      backErr: false,
      backSucc: false,
      Sec: false,
      compsuccess: false,
      comperror: false,
      errorMessages: {
        email: '',
        phone_number: ''
      },
      errorMessage: '',
      successMessage: '',
      updateProfileUrl: 'api/users',
      changePasswordUrl: 'api/users',
      updateProfileImageUrl: 'api/users',
      updateSecretUrl: 'api/update_secret',
      createSecretUrl: 'api/add_secret',
      companyUrl: 'api/company_info',
      loggedInUserData: {},
      governoratesList: [],
      filteredCitiesList: [],
      selectedGovernorateId: null,
      selectedCityId: null,
      changePasswordData: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      },
      updateSecretData: {
        current_secret_key: '',
        secret_key: '',
        confirm_secret_key: ''
      },
      createSecretData: {
        secret_key: '',
        confirm_secret_key: ''
      },
      updateProfileData: {
        full_name: '',
        email: '',
        address: '',
        phone_number: '',
        governorate_id_fk: null,
        city_id_fk: null
      },
      companyData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;

    $('.panel-flat').css({ 'overflow-x': 'hidden' });
    this.getCompanyInfo();
    this.getBranchesList();
    // Load user data first
    this.getLoggedInUser();
    // Then load governorates
    this.getGovernorateList();
    // Wait for governorates and user data to be loaded, then set selected values and load cities
    var checkAndInitLocation = function checkAndInitLocation() {
      if (_this.governoratesList.length > 0 && _this.loggedInUserData && _this.loggedInUserData.governorate_id_fk) {
        _this.selectedGovernorateId = _this.loggedInUserData.governorate_id_fk;
        _this.onGovernorateChange();
      }
    };
    // Poll until both are loaded
    var pollCount = 0;
    var poll = function poll() {
      pollCount++;
      checkAndInitLocation();
      if (!(_this.governoratesList.length > 0 && _this.loggedInUserData && _this.loggedInUserData.governorate_id_fk) && pollCount < 20) {
        setTimeout(poll, 200);
      }
    };
    poll();
  },


  watch: {
    governoratesList: function governoratesList(newList) {
      // When governorates are loaded, set selected values from user data
      if (this.loggedInUserData.governorate_id_fk) {
        this.selectedGovernorateId = this.loggedInUserData.governorate_id_fk;
        this.onGovernorateChange();
      }
    },

    loggedInUserData: {
      handler: function handler(newVal) {
        if (newVal.governorate_id_fk) {
          this.selectedGovernorateId = newVal.governorate_id_fk;
          this.onGovernorateChange();
        }
      },

      deep: true
    }
  },

  methods: {
    getGovernorateList: function getGovernorateList() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      console.log(token);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.governoratesList = response.data;
        console.log(_this2.governoratesList);
      });
    },
    onGovernorateChange: function onGovernorateChange() {
      var _this3 = this;

      // Use updateProfileData.governorate_id_fk as the selected governorate
      var governorateId = this.updateProfileData.governorate_id_fk;
      this.selectedGovernorateId = governorateId; // keep this in sync if needed

      if (governorateId) {
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/city/list/' + governorateId, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this3.filteredCitiesList = response.data.map(function (city) {
            return _extends({}, city, {
              city_id: Number(city.city_id)
            });
          });
          // If user already has a city, set it
          if (_this3.loggedInUserData.city_id_fk) {
            var cityIdToSelect = Number(_this3.loggedInUserData.city_id_fk);
            var cityExists = _this3.filteredCitiesList.some(function (city) {
              return city.city_id === cityIdToSelect;
            });
            if (cityExists) {
              _this3.updateProfileData.city_id_fk = cityIdToSelect;
            } else {
              _this3.updateProfileData.city_id_fk = null;
            }
          } else {
            _this3.updateProfileData.city_id_fk = null;
          }
        }).catch(function () {
          _this3.filteredCitiesList = [];
          _this3.updateProfileData.city_id_fk = null;
        });
      } else {
        this.filteredCitiesList = [];
        this.updateProfileData.city_id_fk = null;
      }
    },
    getBranchesList: function getBranchesList() {
      var _this4 = this;

      this.branchesList = [];

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (r) {
          _this4.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    updateCompanyInfo: function updateCompanyInfo() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.companyUrl + '/' + 1, this.companyData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this5.comperror = false;
        _this5.compsuccess = true;
      }).then(function () {
        var a = _this5;
        setTimeout(function () {
          a.compsuccess = false;
        }, 3000);
      }).catch(function () {
        _this5.compsuccess = false;
        _this5.comperror = true;
      }).then(function () {
        var b = _this5;
        setTimeout(function () {
          b.comperror = false;
        }, 3000);
      });
    },
    getCompanyInfo: function getCompanyInfo() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this6.companyData = response.data.data;
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      // Copy values to updateProfileData for form binding
      this.updateProfileData.full_name = this.loggedInUserData.full_name;
      this.updateProfileData.email = this.loggedInUserData.email;
      this.updateProfileData.address = this.loggedInUserData.address;
      this.updateProfileData.phone_number = this.loggedInUserData.phone_number;
      this.updateProfileData.governorate_id_fk = this.loggedInUserData.governorate_id_fk;
      this.updateProfileData.city_id_fk = this.loggedInUserData.city_id_fk;
    },
    updateProfile: function updateProfile(id) {
      var _this7 = this;

      this.$validator.validate('Full name').then(function (nameValid) {
        if (!nameValid) throw new Error('Invalid name');
        return _this7.$validator.validate('Email');
      }).then(function (emailValid) {
        if (!emailValid) throw new Error('Invalid email');
        return _this7.$validator.validate('Phone Number');
      }).then(function (phoneValid) {
        if (!phoneValid) throw new Error('Invalid phone');
        return _this7.$validator.validate('Governorate');
      }).then(function (governorateValid) {
        if (!governorateValid) throw new Error('Invalid governorate');
        return _this7.$validator.validate('City');
      }).then(function (cityValid) {
        if (!cityValid) throw new Error('Invalid city');
        return _this7.$validator.validate('Address');
      }).then(function (addressValid) {
        if (!addressValid) throw new Error('Invalid address');
        // All fields valid, proceed with update
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this7.updateProfileUrl + '/' + id, _this7.updateProfileData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this7.getUser();
          _this7.successMessage = response.data.message;
          _this7.successResponse = true;
          _this7.errorResponse = false;
        }).then(function () {
          var a = _this7;
          setTimeout(function () {
            a.successResponse = false;
          }, 3000);
        }).catch(function (error) {
          if (!error.response.data.message.email && !error.response.data.message.phone_number) {
            _this7.errorMessages.phone_number = '';
            _this7.errorMessages.email = '';
            _this7.errorMessage = error.response.data.message;
          } else if (error.response.data.message.email) {
            _this7.errorMessage = '';
            _this7.errorMessages.phone_number = '';
            _this7.errorMessages.email = error.response.data.message.email[0];
          } else if (error.response.data.message.phone_number) {
            _this7.errorMessage = '';
            _this7.errorMessages.email = '';
            _this7.errorMessages.phone_number = error.response.data.message.phone_number[0];
          }
          _this7.errorResponse = true;
          _this7.successResponse = false;
        }).then(function () {
          var b = _this7;
          setTimeout(function () {
            b.errorResponse = false;
          }, 3000);
        });
      });
    },
    getUser: function getUser() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
        _this8.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      });
    },
    changePassword: function changePassword(id) {
      var _this9 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this9.changePasswordData.new_password.trim() !== _this9.changePasswordData.confirm_password.trim()) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', 'Confirm password not match', 'error');
          } else {
            var token = localStorage.getItem('access_token');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this9.changePasswordUrl + '/' + id + '/change_password', _this9.changePasswordData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
              _this9.$validator.reset();
              _this9.changePasswordData.current_password = '';
              _this9.changePasswordData.new_password = '';
              _this9.changePasswordData.confirm_password = '';

              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Success', 'Password Changed Successfully', 'success');
            }).catch(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', 'Current Password is not correct', 'error');
            });
          }
        }
      });
    },
    updateSecret: function updateSecret(id) {
      var _this10 = this;

      if (this.updateSecretData.current_secret_key.trim() === '') {
        this.currSec = true;
        var x = this;
        setTimeout(function () {
          x.currSec = false;
        }, 2000);
      }
      if (this.updateSecretData.secret_key.trim() === '') {
        this.newSec = true;
        var y = this;
        setTimeout(function () {
          y.newSec = false;
        }, 2000);
      }
      if (this.updateSecretData.confirm_secret_key.trim() === '') {
        this.confSec = true;
        var z = this;
        setTimeout(function () {
          z.confSec = false;
        }, 2000);
      } else if (this.updateSecretData.secret_key.trim() !== this.updateSecretData.confirm_secret_key.trim()) {
        this.matchSec = true;
        var m = this;
        setTimeout(function () {
          m.matchSec = false;
        }, 2000);
      } else {
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.updateSecretUrl + '/' + id, this.updateSecretData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this10.backSucc = true;
          _this10.updateSecretData.current_secret_key = '';
          _this10.updateSecretData.secret_key = '';
          _this10.updateSecretData.confirm_secret_key = '';

          var n = _this10;
          setTimeout(function () {
            n.backSucc = false;
          }, 2000);
        }).catch(function () {
          _this10.backErr = true;
          var i = _this10;
          setTimeout(function () {
            i.backErr = false;
          }, 2000);
        });
      }
    },
    createSecret: function createSecret() {
      var _this11 = this;

      if (this.createSecretData.secret_key.trim() === '') {
        this.Sec = true;
        var y = this;
        setTimeout(function () {
          y.Sec = false;
        }, 2000);
      }
      if (this.createSecretData.confirm_secret_key.trim() === '') {
        this.confSec = true;
        var z = this;
        setTimeout(function () {
          z.confSec = false;
        }, 2000);
      } else if (this.createSecretData.secret_key.trim() !== this.createSecretData.confirm_secret_key.trim()) {
        this.matchSec = true;
        var m = this;
        setTimeout(function () {
          m.matchSec = false;
        }, 2000);
      } else {
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.createSecretUrl, this.createSecretData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this11.backSucc = true;
          _this11.createSecretData.secret_key = '';
          _this11.createSecretData.confirm_secret_key = '';

          var n = _this11;
          setTimeout(function () {
            n.backSucc = false;
          }, 2000);
        }).catch(function () {
          _this11.backErr = true;
          var i = _this11;
          setTimeout(function () {
            i.backErr = false;
          }, 2000);
        });
      }
    },
    openExplorer: function openExplorer() {
      $('#profile_image').click();
      $('#profile_image').on('change', function (event) {
        $('#updateButton').click();
      });
    },
    openCoverExplorer: function openCoverExplorer() {
      $('#cover_image').click();
      $('#cover_image').on('change', function (event) {
        $('#updateCoverButton').click();
      });
    },
    submit: function submit(event) {
      var _this12 = this;

      var profilePic = document.getElementById('profile_image').files[0];
      if (profilePic.type.includes('image/')) {
        var formData = new FormData(event.target);

        formData.append('profile_image', document.getElementById('profile_image').files[0]);
        var token = localStorage.getItem('access_token');
        var userData = JSON.parse(localStorage.getItem('user_data'));

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.updateProfileImageUrl + '/' + userData.user_id + '/profile_image', formData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this12.getUser();
          _this12.$emit('clicked');
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message.profile_image[0], 'error');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', 'Profile must be an image', 'error');
      }
    },
    submitCover: function submitCover() {
      var _this13 = this;

      var coverPic = document.getElementById('cover_image').files[0];
      if (coverPic.type.includes('image/')) {
        var formData = new FormData(event.target);
        formData.append('cover_image', document.getElementById('cover_image').files[0]);
        var token = localStorage.getItem('access_token');
        var userData = JSON.parse(localStorage.getItem('user_data'));

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.updateProfileImageUrl + '/' + userData.user_id + '/cover_image', formData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this13.getUser();
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message.cover_image[0], 'error');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', 'Cover must be an image', 'error');
      }
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Profile_avatar.png?b8c2f78a8a8ba3f37ce2516986196062";

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createUser_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editCustomer_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__customerTransactions_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_credit_createCredit_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import mobileDatatable from '../mobileDatatable'






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    customerTransactions: __WEBPACK_IMPORTED_MODULE_7__customerTransactions_vue__["a" /* default */],
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'create-user': __WEBPACK_IMPORTED_MODULE_3__createUser_vue__["a" /* default */],
    'edit-customer': __WEBPACK_IMPORTED_MODULE_4__editCustomer_vue__["a" /* default */],
    // 'mobile-datatable': mobileDatatable,
    'creat-credit': __WEBPACK_IMPORTED_MODULE_8__user_credit_createCredit_vue__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?name=', '') !== null || window.location.search.replace('?name=', '') !== '') {
        var value = window.location.search.replace('?name=', '').replace(/%20/g, ' ');
        this.searchOneCol('full_name', value);
      }
    }
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getDefaultPrices();
    this.getCustomer();
    this.getCityList();
    this.getCurrentExchangeRate();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  computed: {
    // all customers that match the current search/filter, on every page
    totalFiltered: function totalFiltered() {
      return this.filterMade ? this.apiResults.length : this.pagination.total;
    },
    sumOfSelectedCredit: function sumOfSelectedCredit() {
      var _this = this;

      var sum = 0;
      this.selectedUserIds.forEach(function (id) {
        sum += Number(_this.creditById[id] || 0);
      });

      return sum;
    }
  },
  watch: {
    selectedUserIds: function selectedUserIds() {
      this.syncMainCheck();
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'ID',
      text: 'ID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'user_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Email',
      text: 'Email',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'email'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Phone Number 2',
      text: 'Phone Number 2',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'phone_number_2'
    }, {
      label: 'Governorate',
      text: 'Governorate',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'governorate_name'
    }, {
      label: 'City',
      text: 'City',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'city_name'
    }, {
      label: 'Address',
      text: 'Address',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'address'
    }, {
      label: 'Credit',
      text: 'Credit',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'credit'
    }, {
      label: 'Status',
      text: 'Status',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'is_blocked'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      load: false,
      getCustomerUrl: 'api/get-customer-to-select',
      url: 'api/get-customer',
      createCustomerUrl: 'api/customer',
      editCustomerUrl: 'api/update-customer',
      getDefaultPriceUrl: 'api/default_price',
      blockUserUrl: 'api/users',
      unBlockUserUrl: 'api/users',
      createCustomerModal: false,
      tranDialog: false,
      tranData: [],
      customerId: 0,
      customerName: '',
      the_user_id: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      validationError: false,
      phoneError: false,
      editCustomerModal: false,
      backendError: false,
      emailError: '',
      phoneNumberError: '',
      btnsave: true,
      totalCredit: 0,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      currentExchangeRate: 0,
      prevSearchQuery: '',
      apiResults: [],
      selectedUserIds: [],
      creditById: {},
      lastFilterKey: null,
      selectingAll: false,
      exportingSelected: false,
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      createCreditModal: false,
      customersResult: [],
      customers: [],
      addCreditData: {},
      defaultPriceData: {
        customer_price_per_weight_usa: '',
        customer_price_per_weight_turkey: '',
        customer_base_qtt_charge_turkey: '',
        customer_base_qtt_charge_usa: '',
        customer_other_qtt_charge_turkey: '',
        customer_other_qtt_charge_usa: ''
      },
      addData: {
        full_name: '',
        customer_note: '',
        email: '',
        password: '',
        confirm_password: '',
        phone_number: '',
        phone_number_2: '',
        city_id_fk: null,
        address: '',
        item_weight_price_usa: '',
        item_weight_price_turkey: '',
        quantity_charge_base_turkey: '',
        quantity_charge_other_turkey: '',
        quantity_charge_base_usa: '',
        quantity_charge_other_usa: ''
      },
      editCustomerData: {
        full_name: '',
        customer_note: '',
        email: '',
        phone_number: '',
        phone_number_2: '',
        city_id_fk: null,
        address: '',
        item_weight_price_usa: '',
        item_weight_price_turkey: '',
        quantity_charge_base_turkey: '',
        quantity_charge_other_turkey: '',
        quantity_charge_base_usa: '',
        quantity_charge_other_usa: '',
        new_password: null,
        phone_verified: false,
        base_phone_verified: false
      },
      resetPasswordData: {
        new_password: ''
      },
      verifiedList: [{ text: 'All', value: null }, { text: 'Verified', value: 1 }, { text: 'Unverified', value: 0 }],
      citiesList: [],
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        phone_verified: null
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    // select every customer that matches the current search/filter, not only this page
    checkAll: function checkAll() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.selectingAll = true;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.url, {
        params: Object.assign({}, this.tableData, { only_ids: 1 }),
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var credits = response.data.data || {};
        _this2.creditById = Object.assign({}, _this2.creditById, credits);
        _this2.selectedUserIds = Object.keys(credits).map(Number);
        _this2.selectingAll = false;
      }).catch(function () {
        _this2.selectingAll = false;
        _this2.syncMainCheck();
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', 'Could not select all customers, please try again', 'error');
      });
    },
    unCheckAll: function unCheckAll() {
      this.selectedUserIds = [];
    },
    syncMainCheck: function syncMainCheck() {
      var allSelected = this.selectedUserIds.length > 0 && this.selectedUserIds.length >= this.totalFiltered;
      $('#mainCheck').prop('checked', allSelected);
    },


    // ticks stay when changing page, sorting or rows per page; a new search or filter clears them
    keepOrClearSelection: function keepOrClearSelection() {
      var filterKey = JSON.stringify([this.tableData.search, this.tableData.searchOneCol, this.tableData.searchOneVal, this.tableData.from_date, this.tableData.to_date, this.tableData.phone_verified]);

      if (this.lastFilterKey !== null && filterKey !== this.lastFilterKey) {
        this.selectedUserIds = [];
      }
      this.lastFilterKey = filterKey;
    },
    rememberCredits: function rememberCredits() {
      var credits = {};
      this.apiResults.forEach(function (r) {
        credits[Number(r.user_id)] = r.credit;
      });
      this.creditById = Object.assign({}, this.creditById, credits);
      this.syncMainCheck();
    },
    exportSelected: function exportSelected() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      this.exportingSelected = true;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/customer-export-selected', { ids: this.selectedUserIds }, {
        headers: { Authorization: 'Bearer ' + token },
        responseType: 'blob'
      }).then(function (response) {
        var link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = 'Customers-selected-' + new Date().toISOString().slice(0, 10) + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        _this3.exportingSelected = false;
      }).catch(function () {
        _this3.exportingSelected = false;
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', 'Could not export the selected customers', 'error');
      });
    },
    getCurrentExchangeRate: function getCurrentExchangeRate() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/currency-rate/latest', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.currentExchangeRate = response.data.ex_rate;
      });
    },
    getCityList: function getCityList() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/cities', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this5.citiesList = response.data.data;
      });
    },
    openCreatCreditModal: function openCreatCreditModal() {
      this.createCreditModal = true;
    },
    closeCreatCreditModal: function closeCreatCreditModal() {
      this.createCreditModal = false;
      this.checkAlert = false;
      this.clearCredit();
    },
    clearCredit: function clearCredit() {
      this.addCreditData = {};
      this.$validator.reset();
    },
    createCredit: function createCredit() {
      var _this6 = this;

      this.load = true;
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('api/credit_invoices', this.addCreditData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.checkAlert = true;
        _this6.getResults();
        _this6.clearCredit();
        _this6.load = false;
      }).catch(function () {
        _this6.checkAlert = true;
        _this6.getResults();
        _this6.clearCredit();
        _this6.load = false;
      });
    },
    getCustomer: function getCustomer() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getCustomerUrl, {
        params: this.customerParam,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this7.customersResult = response.data.data;

        _this7.customersResult.forEach(function (c) {
          _this7.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    sendToExport: function sendToExport() {
      if (this.selectedUserIds.length) {
        this.exportSelected();
        return;
      }
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/customer-export');
    },
    getDefaultPrices: function getDefaultPrices() {
      var _this8 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getDefaultPriceUrl, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var result = response.data.data;

        _this8.defaultPriceData.customer_base_qtt_charge_turkey = result[0].customer_base_qtt_charge_turkey;
        _this8.defaultPriceData.customer_base_qtt_charge_usa = result[0].customer_base_qtt_charge_usa;
        _this8.defaultPriceData.customer_other_qtt_charge_turkey = result[0].customer_other_qtt_charge_turkey;
        _this8.defaultPriceData.customer_other_qtt_charge_usa = result[0].customer_other_qtt_charge_usa;
        _this8.defaultPriceData.customer_price_per_weight_turkey = result[0].customer_price_per_weight_turkey;
        _this8.defaultPriceData.customer_price_per_weight_usa = result[0].customer_price_per_weight_usa;
      });
    },
    getResults: function getResults() {
      var _this9 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
        params: this.tableData,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this9.keepOrClearSelection();
        if (data.data.length > 0) {
          _this9.filterMade = true;
          _this9.apiResults = data.data;
        } else {
          _this9.filterMade = false;
          _this9.apiResults = data.data.data;
        }

        if (_this9.apiResults.length === 0) {
          _this9.tableData.searchOneCol = '';
          _this9.tableData.searchOneVal = '';
          _this9.tableData.search = '';
          _this9.alertValue = true;
        } else {
          _this9.alertValue = false;
        }
        if (data.data.length > 0) {
          _this9.removeConfigPagination();
        } else {
          _this9.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this9.totalResult = 0;
        var total = 0;
        for (var i = 0; i < _this9.apiResults.length; i++) {
          total = total + Number(_this9.apiResults[i].credit);
          _this9.totalResult += 1;
        }
        _this9.totalCredit = total.toFixed(2);
        _this9.rememberCredits();
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openCreateCustomerModal: function openCreateCustomerModal() {
      this.createCustomerModal = true;
    },
    closeCreateCustomerModal: function closeCreateCustomerModal() {
      this.createCustomerModal = false;
      this.validationError = false;
      this.checkAlert = false;
      this.clear();
    },
    customerTransaction: function customerTransaction(id, name) {
      this.customerName = name;
      this.customerId = id;
      this.tranDialog = true;
    },
    blockUser: function blockUser(id) {
      var _this10 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(this.blockUserUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this10.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    unblockUser: function unblockUser(id) {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(this.unBlockUserUrl + '/' + id + '/unblock', '', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this11.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    clear: function clear() {
      this.addData.full_name = '';
      this.addData.note = '';
      this.addData.email = '';
      this.addData.password = '';
      this.addData.confirm_password = '';
      this.addData.phone_number = '';
      this.addData.phone_number_2 = '';
      this.addData.city_id_fk = null;
      this.addData.address = '';
      this.addData.item_weight_price_usa = '';
      this.addData.item_weight_price_turkey = '';
      this.addData.quantity_charge_base_turkey = '';
      this.addData.quantity_charge_other_turkey = '';
      this.addData.quantity_charge_base_usa = '';
      this.addData.quantity_charge_other_usa = '';
      this.$validator.reset();
    },
    createCustomer: function createCustomer() {
      var _this12 = this;

      var token = localStorage.getItem('access_token');

      this.addData.full_name = this.addData.first_name + ' ' + this.addData.last_name;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.createCustomerUrl, this.addData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Success', 'Added successfully', 'success');
        _this12.getResults();
        _this12.clear();
        _this12.createCustomerModal = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    openEditCustomerModal: function openEditCustomerModal(r) {
      this.the_user_id = r.user_id;
      var nameParts = r.full_name.split(' ');
      this.editCustomerData = _extends({}, r, {
        base_phone_verified: r.phone_verified,
        first_name: nameParts[0] || '',
        last_name: nameParts.slice(1).join(' ') || ''
      });
      this.editCustomerModal = true;
    },
    closeEditCustomerModal: function closeEditCustomerModal() {
      this.editCustomerModal = false;
      this.validationError = false;
      this.backendError = false;
      this.checkAlert = false;
    },
    editCustomer: function editCustomer() {
      var _this13 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(this.editCustomerUrl + '/' + this.the_user_id, this.editCustomerData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this13.editCustomerModal = false;
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Success', 'Updated successfully', 'success');
        _this13.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createUser_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c19a966_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createUser_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c19a966"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c19a966_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['createCustomer', 'addData', 'createCustomerModal', 'checkAlert', 'closeCreateCustomerModal', 'emailError', 'phoneNumberError', 'validationError', 'phoneError', 'defaultPriceData'],

  data: function data() {
    return {
      citiesList: [],
      governoratesList: [],
      phoneData: {
        code: '',
        csrf: ''
      }
    };
  },
  mounted: function mounted() {
    this.getGovernorateList();
  },


  watch: {
    'addData.governorate_id_fk': function addDataGovernorate_id_fk(newVal) {
      if (newVal) {
        this.getCityList(newVal);
      } else {
        this.citiesList = [];
      }
    },


    // Watch for modal close to clear form on successful submission
    createCustomerModal: function createCustomerModal(newVal, oldVal) {
      // If modal was open and now closed, and form has data, it means successful submission
      if (oldVal === true && newVal === false && this.hasFormData()) {
        this.clearForm();
      }
    }
  },

  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          // Call the parent's createCustomer method and handle the response
          var result = _this.createCustomer();

          // If createCustomer returns a promise, handle it
          if (result && typeof result.then === 'function') {
            result.then(function () {
              // Clear form only on successful creation
              _this.clearForm();
            }).catch(function (error) {
              // Keep form data if there's an error
              console.error('Error creating customer:', error);
            });
          } else {
            // If createCustomer doesn't return a promise, we need to listen for success
            // This will be handled by watching for modal close or success event
            _this.$nextTick(function () {
              // Check if modal is still open - if closed, creation was successful
              if (!_this.createCustomerModal) {
                _this.clearForm();
              }
            });
          }
        }
      });
    },
    getCityList: function getCityList(governorateId) {
      var _this2 = this;

      if (!governorateId) {
        this.citiesList = [];
        return;
      }

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/city/list/' + governorateId, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.citiesList = response.data;
      }).catch(function (error) {
        console.error('Error fetching cities:', error);
        _this2.citiesList = [];
      });
    },
    getGovernorateList: function getGovernorateList() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.governoratesList = response.data;
      });
    },
    loginCallback: function loginCallback(response) {
      if (response != null) {
        if (response.status === 'PARTIALLY_AUTHENTICATED') {
          this.phoneData.code = response.code;
          this.phoneData.csrf = response.state;
          $('#phone').click();
        }
      }
    },
    smsLogin: function smsLogin() {
      AccountKit.login('PHONE', { countryCode: '+964' }, this.loginCallback);
    },
    phoneLogin: function phoneLogin() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/phone-login', this.phoneData).then(function (response) {
        _this4.addData.phone_number = response.data.data.phone.number;
        _this4.createCustomer();
      });
    },
    hasFormData: function hasFormData() {
      // Check if form has any data
      return this.addData.first_name || this.addData.last_name || this.addData.phone_number || this.addData.phone_number_2 || this.addData.email || this.addData.governorate_id_fk || this.addData.city_id_fk || this.addData.address || this.addData.customer_note;
    },
    clearForm: function clearForm() {
      // Clear all form fields
      this.addData.first_name = '';
      this.addData.last_name = '';
      this.addData.phone_number = '';
      this.addData.phone_number_2 = '';
      this.addData.email = '';
      this.addData.governorate_id_fk = null;
      this.addData.city_id_fk = null;
      this.addData.address = '';
      this.addData.customer_note = '';
      this.citiesList = [];
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCustomer_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4703a7d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCustomer_vue__ = __webpack_require__(721);
function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4703a7d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editCustomer', 'editCustomerData', 'editCustomerModal', 'checkAlert', 'closeEditCustomerModal', 'emailError', 'validationError', 'backendError', 'citiesList'],

  data: function data() {
    return {
      localCitiesList: [],
      localGovernoratesList: []
    };
  },
  mounted: function mounted() {
    this.getGovernorateList();
  },


  watch: {
    'editCustomerData.governorate_id_fk': function editCustomerDataGovernorate_id_fk(newVal) {
      if (newVal) {
        this.getCityList(newVal);
      } else {
        this.localCitiesList = [];
      }
    },


    // Watch for modal opening to load cities if governorate is already selected
    editCustomerModal: function editCustomerModal(newVal) {
      if (newVal && this.editCustomerData.governorate_id) {
        this.getCityList(this.editCustomerData.governorate_id);
      }
    }
  },

  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editCustomer();
        }
      });
    },
    getCityList: function getCityList(governorateId) {
      var _this2 = this;

      if (!governorateId) {
        this.localCitiesList = [];
        return;
      }

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/city/list/' + governorateId, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.localCitiesList = response.data;
      }).catch(function (error) {
        console.error('Error fetching cities:', error);
        _this2.localCitiesList = [];
      });
    },
    getGovernorateList: function getGovernorateList() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.localGovernoratesList = response.data;
      });
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerTransactions_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d06a32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerTransactions_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61d06a32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerTransactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61d06a32_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerTransactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['tranDialog', 'customerName', 'customerId'],

  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__["default"]
  },

  data: function data() {
    return {
      tranData: {
        data: []
      },
      form: {},
      companyData: {},
      fromDate: {},
      toDate: {},
      search: null,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    };
  },


  computed: {
    filteredData: function filteredData() {
      var _this = this;

      if (this.search) {
        return this.tranData.data.filter(function (data) {
          if (data.description) {
            if (data.type === 'order') {
              return data.description.toLowerCase().includes(_this.search.toLowerCase()) || data.product_name.toLowerCase().includes(_this.search.toLowerCase());
              // data.branch_name.toLowerCase().includes(this.search.toLowerCase())
            }
            return data.description.toLowerCase().includes(_this.search.toLowerCase());
            // data.branch_name.toLowerCase().includes(this.search.toLowerCase())
          }
        });
      }

      return this.tranData.data;
    },
    totals: function totals() {
      var credit = 0;
      var debit = 0;
      this.filteredData.forEach(function (x) {
        credit += Number(x.credit);
        debit += Number(x.debit);
      });

      return {
        credit: credit.toLocaleString(),
        debit: debit.toLocaleString(),
        balance: (credit - debit).toLocaleString()
      };
    }
  },

  watch: {
    tranDialog: {
      immediate: false,
      handler: function handler() {
        if (this.tranDialog) {
          this.getTranData();
          this.getCompanyData();
        }
      }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.form = {};
      this.fromDate = {};
      this.toDate = {};
      this.tranData = {};
      this.$emit('close-dialog');
    },
    getCompanyData: function getCompanyData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.companyData = response.data.data;
      });
    },
    print: function print() {
      var notPrintable = document.querySelectorAll('.not-printable');
      notPrintable.forEach(function (e) {
        e.style.display = 'none';
      });

      var fs14 = document.querySelectorAll('.fs-14');
      fs14.forEach(function (e) {
        e.style.fontSize = '10px';
      });

      this.$htmlToPaper('print-area-invoices');

      notPrintable.forEach(function (e) {
        e.style.display = 'flex';
      });

      fs14.forEach(function (e) {
        e.style.fontSize = '14px';
      });
    },
    getTranData: function getTranData() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/customer_transaction/' + this.customerId, this.form, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.tranData = response.data;
      });
    },
    filterByDate: function filterByDate() {
      this.form = {};
      if (this.fromDate.time && this.toDate.time) {
        this.form = {
          from_date: this.fromDate.time,
          to_date: this.toDate.time
        };
        this.getTranData();
      } else {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('', 'Please select both date!', 'warning');
      }
    },
    removeDateFilter: function removeDateFilter() {
      this.form = {};
      this.fromDate = {};
      this.toDate = {};
      this.getTranData();
    },
    sendToExport: function sendToExport() {
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      var params = new URLSearchParams();

      if (this.form.from_date) {
        params.append('from_date', this.form.from_date);
      }
      if (this.form.to_date) {
        params.append('to_date', this.form.to_date);
      }
      if (this.search) {
        params.append('search', this.search);
      }

      var query = params.toString();
      window.location.replace(fullHostName + '/api/customer_transaction/' + this.customerId + '/export' + (query ? '?' + query : ''));
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createCredit_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8c4ee2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createCredit_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createCredit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8c4ee2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createCredit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['createCreditModal', 'closeCreatCreditModal', 'checkAlert', 'addData', 'createCredit', 'customers', 'currentExchangeRate', 'load'],

  data: function data() {
    return {
      iqdAmount: null
    };
  },


  computed: {
    calculateIQDAmount: {
      get: function get() {
        return this.formatNumber(this.iqdAmount);
      },
      set: function set(value) {
        // Parse the input value to remove commas
        var parsedValue = this.parseNumber(value);
        this.iqdAmount = parsedValue;
        // Calculate USD amount from IQD input
        if (this.currentExchangeRate && parsedValue) {
          this.addData.amount = parseFloat((parsedValue / this.currentExchangeRate).toFixed(2));
        }
      }
    }
  },

  methods: {
    formatNumber: function formatNumber(value) {
      if (!value && value !== 0) return '';
      // Convert to integer for IQD by removing decimal part
      var numValue = parseFloat(value);
      var roundedValue = Math.round(numValue);
      return roundedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parseNumber: function parseNumber(value) {
      if (!value) return 0;
      // Remove thousand separators and convert to integer number for IQD
      var parsedValue = value.toString().replace(/,/g, '');
      return Math.round(parseFloat(parsedValue));
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.createCredit();
          _this.iqdAmount = null;
        }
      });
    },
    resetForm: function resetForm() {
      this.iqdAmount = null;
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_orderInvoice_AddOrderInvoice_vue__ = __webpack_require__(237);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    AddOrderInvoice: __WEBPACK_IMPORTED_MODULE_7__components_orderInvoice_AddOrderInvoice_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'deliver_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      generateInvoiceData: {},
      orderInvoiceModal: false,
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/user_delivery_order',
      orderDetailUrl: 'api/show_order_detail',
      returnToPurchaseUrl: 'api/orders/',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        coupon_percentage: '',
        item_type: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        theOrderID: '',
        refund_reason: '',
        bank_name: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    openSecondOrderInvoiceModal: function openSecondOrderInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Please at least select one order or customer!',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      var customerIds = [];
      var ordersArr = [];
      this.qrCodeValues.forEach(function (x, i) {
        var obj = {
          order_id: null,
          customer_name: null,
          phone: null,
          customer_id: null,
          the_order_id: null
        };
        x.forEach(function (y, j) {
          if (j === 0) {
            obj.order_id = y;
          } else if (j === 1) {
            obj.customer_name = y;
          } else if (j === 2) {
            obj.phone = y;
          } else if (j === 3) {
            customerIds.push(y);
            obj.customer_id = y;
          } else if (j === 4) {
            obj.the_order_id = y;
          }
        });
        ordersArr.push(obj);
      });

      if (this.checkDiff(customerIds)) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'You selected different customers',
          icon: 'warning',
          dangerMode: true
        });

        return;
      }

      this.generateInvoiceData = {
        volume: 0,
        delivery_price: 0,
        customer_id: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        phone: ordersArr[0].phone,
        orders: ordersArr
      };
      console.log(this.generateInvoiceData);
      this.orderInvoiceModal = true;
    },
    generateInvoiceCustomer: function generateInvoiceCustomer(id) {
      var customer = this.customersList.find(function (x) {
        return x.value === id;
      });

      this.generateInvoiceData = {
        customer_id: customer.value,
        customer_name: customer.text,
        phone: customer.phone,
        orders: []
      };

      this.orderInvoiceModal = true;
    },
    checkDiff: function checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    returnToPurchase: function returnToPurchase(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
        title: 'Are you sure?',
        text: 'You really want to return this order to Purchased section?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(_this2.returnToPurchaseUrl + id + '/return_to_purchase', '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this2.getResults();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this3.detailResults = data.data;
        _this3.detialData = _this3.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'deliver_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/admin_archived_order',
      orderDetailUrl: 'api/show_order_detail',
      alertValue: false,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        coupon_percentage: '',
        item_type: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        theOrderID: '',
        refund_reason: '',
        bank_name: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },

  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.detialData = data.data[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCredit_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editCredit_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editCashBack_vue__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cashBack_vue__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logs_viewActionLog_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'creat-credit': __WEBPACK_IMPORTED_MODULE_3__createCredit_vue__["a" /* default */],
    'edit-credit': __WEBPACK_IMPORTED_MODULE_4__editCredit_vue__["a" /* default */],
    'edit-cash-back': __WEBPACK_IMPORTED_MODULE_5__editCashBack_vue__["a" /* default */],
    'cash-back': __WEBPACK_IMPORTED_MODULE_6__cashBack_vue__["a" /* default */],
    'view-action-log': __WEBPACK_IMPORTED_MODULE_7__logs_viewActionLog_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_8__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getCurrentExchangeRate();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  computed: {
    sumOfSelectedOrders: function sumOfSelectedOrders() {
      var _this = this;

      var sum = 0;
      this.apiResults.filter(function (order) {
        return _this.creditIds.includes(order.credit_invoice_id);
      }).forEach(function (x) {
        sum += x.item_price * x.quantity + x.national_tax + x.delivery_price;
      });

      return sum;
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Staff Name',
      text: 'Staff Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'staff_name'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Customer Phone',
      text: 'Customer Phone',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Action',
      text: 'Action',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'credit_status'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Rate Log',
      text: 'Rate Log',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'ex_rate'
    }, {
      label: 'Paid via',
      text: 'Paid via',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'payment_method'
    }, {
      label: 'Invoice Number',
      text: 'Invoice Number',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    }, {
      label: 'Note',
      text: 'Note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Credit Date',
      text: 'Credit Date',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'credit_invoice_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/credit_invoices',
      baseUrl: 'api/credit_invoices',
      getCustomerUrl: 'api/get-customer-to-select',
      cashBackUrl: 'api/cash_back',
      invoiceUrl: 'api/customer_last_invoice',
      companyUrl: 'api/company_info',
      deleteCashBackUrl: 'api/delete_cash_back',
      editCashBackUrl: 'api/edit_cash_back',
      createCreditModal: false,
      editCreditModal: false,
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      currentExchangeRate: 0,
      backendError: false,
      btnsave: true,
      load: false,
      load2: false,
      cashBackModal: false,
      cashBackError: false,
      editCashBackModal: false,
      editCashBackData: {
        amount: ''
      },
      totalAdd: 0,
      totalCashBack: 0,
      generalTotal: 0,
      prevSearchQuery: '',
      apiResults: [],
      customersResult: [],
      customers: [],
      rowIndex: '',
      creditIds: [],
      customerCreditId: [],
      columns: columns,
      sortKey: 'credit_invoice_id',
      sortOrders: sortOrders,
      the_credit_invoice_id: '',
      companyData: {},
      addData: {},
      cashBackData: {},
      editData: {},
      detailData: {
        credit_log_action_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        customer_name: '',
        customer_email: '',
        customer_address: '',
        phone_number: '',
        note: '',
        credit_log_action_date: '',
        old_price: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_invoice_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_invoice_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        _this2.getCustomerCreditID(_this2.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        var totalAdd = 0;
        var totalCashBack = 0;
        var generalTotal = 0;

        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
          if (_this2.apiResults[i].credit_status === 'add') {
            totalAdd = totalAdd + Number(_this2.apiResults[i].amount);
          } else {
            totalCashBack = totalCashBack + Number(_this2.apiResults[i].amount);
          }
        }

        _this2.totalAdd = Number(totalAdd).toFixed(2);
        _this2.totalCashBack = Number(totalCashBack).toFixed(2);
        generalTotal = Number(totalAdd) - Number(totalCashBack);
        _this2.generalTotal = generalTotal.toFixed(2);
      });
    },
    getCurrentExchangeRate: function getCurrentExchangeRate() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get('api/currency-rate/latest', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.currentExchangeRate = response.data.ex_rate;
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getCustomerCreditID: function getCustomerCreditID(credits) {
      this.customerCreditId = [];
      for (var i = 0; i < credits.length; i++) {
        this.customerCreditId[i] = credits[i].credit_invoice_id;
      }
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_invoice_id';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'credit_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.customerCreditId.length; i++) {
        if (i < this.customerCreditId.length - 1) {
          arr = arr.concat('arr[]=' + this.customerCreditId[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.customerCreditId[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/customer-credit-export?' + arr);
    },
    openCreatCreditModal: function openCreatCreditModal() {
      this.createCreditModal = true;
    },
    openCashBackModal: function openCashBackModal() {
      this.cashBackModal = true;
    },
    openEditCreditModal: function openEditCreditModal(r) {
      this.the_credit_invoice_id = r.credit_invoice_id;
      this.editData.amount = r.amount;
      this.editData.note = r.note;
      this.editData.user_id_fk = r.customer_id;
      this.editCreditModal = true;
    },
    closeCreatCreditModal: function closeCreatCreditModal() {
      this.createCreditModal = false;
      this.checkAlert = false;
      this.clear();
    },
    closeCashBackModal: function closeCashBackModal() {
      this.cashBackModal = false;
      this.checkAlert = false;
      this.cashBackError = false;
      this.clearCashBack();
    },
    closeEditCreditModal: function closeEditCreditModal() {
      this.editCreditModal = false;
      this.checkAlert = false;
      this.backendError = false;
    },
    clear: function clear() {
      this.addData = {};
      this.$validator.reset();
    },
    clearCashBack: function clearCashBack() {
      this.cashBackData = {};
      this.cashBackModal = false;
      this.checkAlert = false;
      this.cashBackError = false;
      this.$validator.reset();
    },
    cashBack: function cashBack() {
      var _this4 = this;

      this.load2 = true;
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(this.cashBackUrl, this.cashBackData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.cashBackError = false;
        _this4.checkAlert = true;
        _this4.getResults();
        _this4.clearCashBack();
        _this4.load2 = false;
      }).catch(function (error) {
        if (error.response.data.message === 'cash back') {
          _this4.load2 = false;
          _this4.checkAlert = false;
          _this4.cashBackError = true;
        } else {
          _this4.cashBackError = false;
          _this4.checkAlert = true;
          _this4.getResults();
          _this4.clearCashBack();
          _this4.load2 = false;
        }
      });
    },
    createCredit: function createCredit() {
      var _this5 = this;

      this.load = true;
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(this.baseUrl, this.addData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this5.checkAlert = true;
        _this5.getResults();
        _this5.clear();
        _this5.load = false;
      }).catch(function () {
        _this5.checkAlert = true;
        _this5.getResults();
        _this5.clear();
        _this5.load = false;
      });
    },
    editCredit: function editCredit() {
      var _this6 = this;

      this.load2 = true;
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(this.baseUrl + '/' + this.the_credit_invoice_id, this.editData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.backendError = false;
        _this6.checkAlert = true;
        _this6.getResults();
        _this6.load2 = false;
      }).catch(function (error) {
        if (error.response.data.message === 'please') {
          _this6.checkAlert = false;
          _this6.backendError = true;
        } else {
          _this6.backendError = false;
          _this6.checkAlert = true;
          _this6.getResults();
          _this6.load2 = false;
        }
      });
    },
    getCustomer: function getCustomer() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(this.getCustomerUrl, {
        params: this.customerParam,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this7.customersResult = response.data.data;

        _this7.customersResult.forEach(function (c) {
          _this7.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    deleteCredit: function deleteCredit(id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to return this credit!',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_9_axios___default.a.delete(_this8.baseUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this8.getResults();
            __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {
            _this8.getResults();
            __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    deleteCashBack: function deleteCashBack(id) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to return this cash back!',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_9_axios___default.a.delete(_this9.deleteCashBackUrl + '/' + id, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this9.getResults();
            __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    openEditCashBackModal: function openEditCashBackModal(data) {
      this.editCashBackModal = true;
      this.editCashBackData = _extends({}, data);
      this.the_credit_invoice_id = data.credit_invoice_id;
    },
    closeEditCashBackModal: function closeEditCashBackModal() {
      this.editCashBackData = {};
      this.editCashBackModal = false;
      this.checkAlert = false;
      this.backendError = false;
    },
    editCashBack: function editCashBack() {
      var _this10 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(this.editCashBackUrl + '/' + this.the_credit_invoice_id, this.editCashBackData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this10.backendError = false;
        _this10.checkAlert = true;
        _this10.closeEditCashBackModal();
        _this10.getResults();
      }).catch(function () {
        _this10.checkAlert = false;
        _this10.backendError = true;
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      this.getResults();
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(this.invoiceUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this11.detailResults = data.data;

        _this11.detailData.credit_log_action_date = _this11.detailResults.credit_log_action_date;
        _this11.detailData.credit_log_action_id = _this11.detailResults.credit_log_action_id;
        _this11.detailData.invoice_number = _this11.detailResults.invoice_number;
        _this11.detailData.description = _this11.detailResults.description;
        _this11.detailData.action = _this11.detailResults.action;
        _this11.detailData.created_at = _this11.detailResults.created_at;
        _this11.detailData.amount = _this11.detailResults.amount;
        _this11.detailData.customer_name = _this11.detailResults.customer_name;
        _this11.detailData.customer_email = _this11.detailResults.customer_email;
        _this11.detailData.phone_number = _this11.detailResults.customer_phone_number;
        _this11.detailData.customer_address = _this11.detailResults.customer_address;
        _this11.detailData.note = _this11.detailResults.note;
        _this11.detailData.old_price = _this11.detailResults.old_price;
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this12.companyData = response.data.data;
      });
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_10_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editCreditModal', 'closeEditCreditModal', 'checkAlert', 'editData', 'editCredit', 'backendError', 'load2'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editCredit();
        }
      });
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editCashBackModal', 'closeEditCashBackModal', 'checkAlert', 'editCashBackData', 'editCashBack', 'backendError'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editCashBack();
        }
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cashBackModal', 'closeCashBackModal', 'checkAlert', 'cashBackError', 'cashBackData', 'cashBack', 'backendError', 'load2', 'customers'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.cashBack();
        }
      });
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detailData', 'closeModal', 'companyData'],

  mounted: function mounted() {
    var theModal = document.querySelector('.modal');
    theModal.style.overflowX = 'auto';
  },


  methods: {
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] });

      $('#close-button').show();
      $('#print-button').show();
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multipleInvoices_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_3__viewLogDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    multipleInvoices: __WEBPACK_IMPORTED_MODULE_5__multipleInvoices_vue__["a" /* default */]
  },
  created: function created() {
    this.getResults();
  },
  mounted: function mounted() {
    this.getCustomer();
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check Box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Order Status',
      text: 'Order Status',
      value: '3',
      sortable: true,
      searchable: false,
      name: 'order_status'
    }, {
      label: 'Invoice No',
      text: 'Invoice No',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '5',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'user_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Transaction Date',
      text: 'Transaction Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'credit_log_transaction_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      transactionsArray: [],
      customersList: [],
      selectedCustomer: 0,
      url: 'api/credit_log_transactions',
      logDetailUrl: 'api/credit_log_transactions',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      creditLogTransactionID: [],
      detialData: {},
      invoicesData: {},
      invoicesModal: false,
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'credit_log_transaction_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_transaction_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        customer: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    printInvoices: function printInvoices() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('api/get_invoices', { ids: this.transactionsArray }, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this.invoicesData = response.data.data;
        _this.invoicesModal = true;
        _this.modal('invoicesModal');
      });
    },
    getCustomer: function getCustomer() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get-customer-to-select', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.customersList = [];
        var result = response.data.data;

        result.forEach(function (c) {
          _this2.customersList.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    filterByCustomer: function filterByCustomer() {
      this.transactionsArray = [];
      this.getResults();
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        _this3.getCreditLogTransactionID(_this3.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getCreditLogTransactionID: function getCreditLogTransactionID(creditLog) {
      this.creditLogTransactionID = [];
      for (var i = 0; i < creditLog.length; i++) {
        this.creditLogTransactionID[i] = creditLog[i].credit_log_transaction_id;
      }
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_transaction_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_log_transaction_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_transaction_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_log_transaction_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/order-transaction-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage);
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      this.getResults();
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this4.detailResults = data.data;

        _this4.detialData = _this4.detailResults[0];
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this5.companyData = response.data.data;
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.transactionsArray = [];
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['invoicesData', 'closeModal', 'companyData', 'invoicesModal'],

  mounted: function mounted() {
    var theModal = document.querySelector('.modal');
    theModal.style.overflowX = 'auto';
  },


  methods: {
    printInvoiceMultiple: function printInvoiceMultiple() {
      $('#close-button-multiple').hide();
      $('#print-button-multiple').hide();

      // $('#print-area-invoices').printMe({ path: ['assets/ltr/css/print_style.css'] })
      this.$htmlToPaper('print-area-invoices');
      $('#close-button-multiple').show();
      $('#print-button-multiple').show();
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewActionLog_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-action-log': __WEBPACK_IMPORTED_MODULE_3__viewActionLog_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Staff Name',
      text: 'Staff Name',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'staff_name'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'customer_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    },
    // {label: "Customer Email", text: 'OrderID', value: '2', sortable: true, searchable: true, name: "customer_email"},
    {
      label: 'Action',
      text: 'Action',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'action'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Log Date',
      text: 'Log Date',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'credit_log_action_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/credit_log_actions',
      logDetailUrl: 'api/credit_log_actions',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      detailData: {
        credit_log_action_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        customer_name: '',
        customer_email: '',
        customer_address: '',
        phone_number: '',
        note: '',
        credit_log_action_date: '',
        base_invoice_number: ''
      },
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      creditLogActionID: [],
      columns: columns,
      sortKey: 'credit_log_action_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_action_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.creditLogActionID.length; i++) {
        if (i < this.creditLogActionID.length - 1) {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.creditLogActionID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/transaction-credit-export?' + arr);
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        _this.getCreditLogActionID(_this.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    getCreditLogActionID: function getCreditLogActionID(creditLog) {
      this.creditLogActionID = [];
      for (var i = 0; i < creditLog.length; i++) {
        this.creditLogActionID[i] = creditLog[i].credit_log_action_id;
      }
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_action_id';
      this.tableData.sortDir = 'dsc';
      this.tableData.column = 'credit_log_action_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_action_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_log_action_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      this.getResults();
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.detailData = response.data.data;
        _this2.detailData.phone_number = response.data.data.customer_phone_number;
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        var companyResult = [];
        companyResult = data.data;

        _this3.companyData.company_name = companyResult.company_name;
        _this3.companyData.company_address = companyResult.company_address;
        _this3.companyData.company_email = companyResult.company_email;
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generateCoupon_vue__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editCoupon_vue__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__giveToCustomer_vue__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'generate-coupon': __WEBPACK_IMPORTED_MODULE_3__generateCoupon_vue__["a" /* default */],
    'edit-coupon': __WEBPACK_IMPORTED_MODULE_4__editCoupon_vue__["a" /* default */],
    'give-to-customer': __WEBPACK_IMPORTED_MODULE_5__giveToCustomer_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'coupon_id' }, {
      label: 'Coupon',
      text: 'Coupon',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'coupon'
    }, {
      label: 'Staff Name',
      text: 'Staff Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'staff_name'
    },
    // {label: "Customer Name", text: 'OrderID', value: '3', sortable: true, searchable: true, name: "customer_name"},
    { label: '%', text: '%', value: '4', sortable: true, searchable: true, name: 'percentage' }, {
      label: 'Status',
      text: 'Status',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'coupon_status'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }, {
      label: 'Expire Date',
      text: 'Expire Date',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'expire_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/coupons',
      editUrl: 'api/coupons',
      deleteUrl: 'api/coupons',
      getCustomerUrl: 'api/get-customer',
      updateStatusUrl: 'api/coupon-status',
      giveToCustomerUrl: 'api/give-to-customer',
      callExportUrl: 'api/call-export',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      generateCouponModal: false,
      giveToCustomerModal: false,
      editCouponModal: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      customersResult: [],
      customers: [],
      detailResults: [],
      columns: columns,
      sortKey: 'coupon_id',
      sortOrders: sortOrders,
      the_coupon_id: '',
      exportedCouponId: [],
      generateData: {
        percentage: '',
        coupon_number: '',
        expire_date: ''
      },
      editData: {
        percentage: ''
      },
      giveData: {
        customer_id_fk: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'coupon_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    openGenerateCouponModal: function openGenerateCouponModal() {
      this.generateCouponModal = true;
    },
    closeGenerateCouponModal: function closeGenerateCouponModal() {
      this.generateCouponModal = false;
      this.clearGenerateData();
    },
    clearGenerateData: function clearGenerateData() {
      this.generateCouponModal = false;
      this.checkAlert = false;
      this.generateData.coupon_number = '';
      this.generateData.percentage = '';
    },
    generateCoupon: function generateCoupon(expireDate) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post(this.url, this.generateData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.getResults();
        _this2.checkAlert = true;
        var a = _this2;
        setTimeout(function () {
          a.clearGenerateData();
          expireDate.time = '';
        }, 2000);
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    deleteCoupon: function deleteCoupon(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once deleted, you will not be able to return this coupon!',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_7_axios___default.a.delete(_this3.deleteUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    openEditCouponModal: function openEditCouponModal(r) {
      this.the_coupon_id = r.coupon_id;
      this.editData.percentage = r.percentage;
      this.editCouponModal = true;
    },
    closeEditCouponModal: function closeEditCouponModal() {
      this.editCouponModal = false;
      this.checkAlert = false;
    },
    editCoupon: function editCoupon() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.editUrl + '/' + this.the_coupon_id, this.editData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.getResults();
        _this4.checkAlert = true;
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    openGiveToCustomerModal: function openGiveToCustomerModal(r) {
      this.the_coupon_id = r.coupon_id;
      this.giveData.customer_id_fk = r.customer_id;
      this.giveToCustomerModal = true;
    },
    closeGiveToCustomerModal: function closeGiveToCustomerModal() {
      this.checkAlert = false;
      this.giveToCustomerModal = false;
    },
    giveToCustomer: function giveToCustomer() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.giveToCustomerUrl + '/' + this.the_coupon_id, this.giveData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this5.getResults();
        _this5.checkAlert = true;
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    getCustomer: function getCustomer() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(this.getCustomerUrl, {
        params: this.customerParam,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.customersResult = response.data.data.data;

        _this6.customersResult.forEach(function (c) {
          _this6.customers.push({ text: c.full_name, value: c.user_id });
        });
      });
    },
    sendToExport: function sendToExport() {
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/coupon-export');

      var a = this;
      setTimeout(function () {
        a.updateCouponStatus();
      }, 2000);
    },
    updateCouponStatus: function updateCouponStatus() {
      var _this7 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.put(this.updateStatusUrl, this.exportedCouponId, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this7.getResults();
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'coupon_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'coupon_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'coupon_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'coupon_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_0_vue_datepicker__["default"]
  },

  props: ['generateCouponModal', 'closeGenerateCouponModal', 'checkAlert', 'generateData', 'generateCoupon'],

  data: function data() {
    return {
      startTime: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'Expire Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    };
  },


  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; // January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = yyyy + '-' + mm + '-' + dd;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.startTime.time === '' || _this.startTime.time === null) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('', 'Please determine the Expire Date', 'warning');
          } else if (_this.startTime.time > today) {
            _this.generateData.expire_date = _this.startTime.time;
            _this.generateCoupon(_this.startTime);
          } else {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('', 'Expire Date should be greater than today', 'warning');
          }
        }
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editCouponModal', 'closeEditCouponModal', 'checkAlert', 'editData', 'editCoupon'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editCoupon();
        }
      });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['giveToCustomerModal', 'closeGiveToCustomerModal', 'checkAlert', 'giveData', 'giveToCustomer', 'customers'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.giveToCustomer();
        }
      });
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getLoggedInUser();
    this.assignUserData();
    this.openHome();
    // this.getBranchesList()
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      branchesList: [],
      fillCustomerInfoUrl: 'api/users/web/create-profile',
      emailHint: false,
      errorResponse: false,
      successResponse: false,
      errorMessages: {
        email: '',
        phone_number: ''
      },
      successMessage: '',
      showPallets: false,
      palletsLoaded: false,
      pallets: [],
      loggedInUserData: {},
      customerInfoData: {
        full_name: '',
        email: '',
        phone_number: '',
        address: ''
      }
    };
  },


  methods: {
    // sendOtp() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/test-otp', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(res => {
    //       console.log(res.data)
    //     })
    // },

    // getBranchesList() {
    //   this.branchesList = []

    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(response => {
    //       response.data.forEach(r => {
    //         this.branchesList.push({ text: r.branch_name, value: r.branch_id })
    //       })
    //     })
    // },

    // Admins who may see the pallet report stay here and get the latest pallets;
    // everyone else goes on to My Orders as before.
    openHome: function openHome() {
      var _this = this;

      var triesLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      if (this._isDestroyed) {
        return;
      }
      if (!this.loggedInUserData || !this.loggedInUserData.is_staff) {
        // customers go straight on, exactly as before
        this.$router.push('/my-order');
        return;
      }
      if (localStorage.getItem('user_permissions') === null && triesLeft > 0) {
        // right after login the permissions can still be on their way
        setTimeout(function () {
          return _this.openHome(triesLeft - 1);
        }, 300);
        return;
      }
      if (this.loggedInUserData && this.loggedInUserData.is_staff && this.$_has_perm('view_pallet_report')) {
        this.showPallets = true;
        this.getPallets();
      } else {
        this.$router.push('/my-order');
      }
    },


    // why a pallet is not completed yet (it completes by itself)
    palletReasons: function palletReasons(p) {
      var reasons = [];
      var missing = p.missing_expenses || [];
      if (p.orders_count == 0) {
        reasons.push('No orders yet');
      }
      if (p.waiting_invoice_count > 0) {
        reasons.push(p.waiting_invoice_count + (p.waiting_invoice_count == 1 ? ' order' : ' orders') + ' not weighed in Erbil yet');
      }
      if (missing.length > 0) {
        reasons.push('Not entered yet: ' + missing.join(', '));
      }
      return reasons;
    },
    getPallets: function getPallets() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/pallets', { params: { limit: 6 }, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.pallets = response.data;
      }).catch(function () {}).then(function () {
        _this2.palletsLoaded = true;
      });
    },
    assignUserData: function assignUserData() {
      this.customerInfoData.full_name = this.loggedInUserData.full_name;
      this.customerInfoData.email = this.loggedInUserData.email;
      this.customerInfoData.phone_number = this.loggedInUserData.phone_number;
      this.customerInfoData.address = this.loggedInUserData.address;
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');

          var phone = _this3.customerInfoData.phone_number;
          if (!_this3.customerInfoData.phone_number.startsWith('+964')) {
            phone = '+964' + _this3.customerInfoData.phone_number;
          }

          var payload = _extends({}, _this3.customerInfoData, {
            phone_number: phone
          });

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this3.fillCustomerInfoUrl, payload, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this3.errorResponse = false;
            _this3.successResponse = true;
            _this3.getUser();
          }).then(function () {
            _this3.$router.push('/my-order');
          }).catch(function (error) {
            if (error.response.data.message.email) {
              _this3.errorMessages.phone_number = '';
              _this3.errorMessages.email = error.response.data.message.email[0];
            } else if (error.response.data.message.phone_number) {
              _this3.errorMessages.email = '';
              _this3.errorMessages.phone_number = error.response.data.message.phone_number[0];
            } else if (error.response.data.message) {
              _this3.errorMessages.email = '';
              _this3.errorMessages.phone_number = error.response.data.message;
            }
            _this3.errorResponse = true;
            _this3.successResponse = false;
          }).then(function () {
            var b = _this3;
            setTimeout(function () {
              b.errorResponse = false;
            }, 4000);
          });
        }
      });
    },
    getUser: function getUser() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
        _this4.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      }).then(function () {
        location.reload(true);
      });
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs_viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customerCancelOrder__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__approveOrder_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addTrackNumber__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addAddress_vue__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orderCase_addEditOrderCase_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_3__logs_viewLogDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'customer-cancel-order': __WEBPACK_IMPORTED_MODULE_5__customerCancelOrder__["a" /* default */],
    addTrackNumber: __WEBPACK_IMPORTED_MODULE_7__addTrackNumber__["a" /* default */],
    addAddress: __WEBPACK_IMPORTED_MODULE_8__addAddress_vue__["a" /* default */],
    approveOrder: __WEBPACK_IMPORTED_MODULE_6__approveOrder_vue__["a" /* default */],
    addEditOrderCase: __WEBPACK_IMPORTED_MODULE_9__orderCase_addEditOrderCase_vue__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
    this.perPageFix(50);
    this.getStatusesList();
    this.getGovernorateList();
    this.getCityList();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' }, { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' }, { label: 'Quantity', sortable: true, searchable: true, name: 'quantity' }, { label: 'Warehouse', sortable: true, searchable: true, name: 'country' }, { label: 'Transportation Type', sortable: false, searchable: false, name: 'transportation_type_obj' }, { label: 'Orders Status', sortable: true, searchable: true, name: 'order_status' }, { label: 'Total Price', sortable: true, searchable: true, name: 'total_amount' }, { label: 'Order note', sortable: true, searchable: true, name: 'note' }, { label: 'Date', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      trackNumDialog: false,
      orderId: 0,
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      approveDialog: false,
      url: 'api/orders',
      logDetailUrl: 'api/order_credit_log_transaction',
      cancelingOrderUrl: 'api/canceling_order',
      archivingOrderUrl: 'api/archiving_order',
      companyUrl: 'api/company_info',
      dependDate: 'orders.created_at',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      formData: {},
      addEditOrderCaseModal: false,
      loggedInUserData: {},
      statusesList: [],
      governoratesList: [],
      citiesList: [],
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      detialData: {
        credit_log_transaction_date: '',
        credit_log_transaction_id: '',
        invoice_number: '',
        amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: ''
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      cancelData: {
        cancel_reason: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      tableData: {
        per_page: 50,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getGovernorateList: function getGovernorateList() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/governorate/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this.governoratesList = response.data;
      });
    },
    getCityList: function getCityList() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/city/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.citiesList = response.data;
      });
    },
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      var page = this.pagination.currentPage || 1;
      var statusId = this.tableData.status_id || '0';
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/my-order-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&depend_date=' + this.dependDate + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&per_page=' + perPage + '&page=' + page + '&status=' + statusId + '&access_token=' + localStorage.getItem('access_token'));
    },
    openCreateOrderCaseModal: function openCreateOrderCaseModal(order) {
      this.formData = {
        order_id_fk: order.order_id,
        order: order,
        note: null
      };
      this.addEditOrderCaseModal = true;
    },
    filterByStatus: function filterByStatus(statusId) {
      this.tableData.status_id = statusId;
      this.getResults();
    },
    getBgColor: function getBgColor(index) {
      if (index === 0) return 'bg-grey-600';
      if (index === 1) return 'bg-primary-600';
      if (index === 2) return 'bg-indigo-600';
      if (index === 3) return 'bg-orange-600';
      if (index === 4) return 'bg-green-600';
      if (index === 5) return 'bg-danger-600';
      if (index === 6) return 'bg-teal-400';
      if (index === 7) return 'bg-purple-400';
      if (index === 8) return 'bg-info-400';
      if (index === 9) return 'bg-violet-600';
      if (index === 10) return 'bg-warning-300';
      if (index === 11) return 'bg-blue-300';
      if (index === 12) return 'bg-pink-400';
      if (index === 13) return 'bg-warning-400';
    },
    getStatusesList: function getStatusesList() {
      var _this3 = this;

      this.statusesList = [{ text: 'all', value: null }];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/status/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        res.data.forEach(function (item) {
          if (item.status_id !== 13) {
            _this3.statusesList.push({ text: item.type.replaceAll('_', ' ').replaceAll('order', ''), value: item.status_id });
            if (item.status_id === 8) {
              _this3.statusesList.push({ text: 'Delivered to Erbil', value: item.status_id });
            }
          }
        });
      });
    },
    openAddTrackNumberDialog: function openAddTrackNumberDialog(row) {
      this.orderId = row.order_id;
      this.trackNumDialog = true;
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(this.cancelingOrderUrl + '/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.getResults();
        _this4.cancelAlert = true;
        var self = _this4;
        setTimeout(function () {
          self.closeCancelingOrderModal();
        }, 1500);
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
        _this5.loggedInUserData = response.data;
      });
    },
    getResults: function getResults() {
      var _this6 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this6.apiResults = data.data.data;

        if (_this6.apiResults.length === 0) {
          _this6.tableData.searchOneCol = '';
          _this6.tableData.searchOneVal = '';
          _this6.tableData.search = '';
          _this6.alertValue = true;
        } else {
          _this6.alertValue = false;
        }
        _this6.configPagination(data.data);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    approvingOrder: function approvingOrder(id) {
      this.orderId = id;
      this.approveDialog = true;
    },
    archiveOrder: function archiveOrder(id) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Once archived, you will not be able to return this order to this step!',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(_this7.archivingOrderUrl + '/' + id, '', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this7.getResults();
            __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
              title: 'Done',
              text: 'Archived',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()('Error', '' + error.response.message, 'error');
            }
          });
        }
      });
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this8 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this8.detailResults = data.data;
        _this8.detialData = _this8.detailResults[0];
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this9.companyData = response.data.data;
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_11_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCancelOrder_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2bc30a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCancelOrder_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCancelOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2bc30a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCancelOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cancelOrderModal', 'closeCancelingOrderModal', 'cancelAlert', 'cancelData', 'cancelingOrder'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.cancelingOrder();
        }
      });
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approveOrder_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a931bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approveOrder_vue__ = __webpack_require__(796);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26a931bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approveOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a931bc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approveOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    approveDialog: { type: Boolean, default: false },
    orderId: { type: Number, required: true }
  },

  data: function data() {
    return {
      branchesList: [],
      formData: {},
      inValid: false
    };
  },
  mounted: function mounted() {
    this.getBranchesList();
    this.getLoggedInUser();
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.authUser = JSON.parse(localStorage.getItem('user_data'));
      // this.formData.deliver_branch_id_fk = this.authUser.default_branch_id_fk
    },
    getBranchesList: function getBranchesList() {
      var _this = this;

      this.branchesList = [];

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (r) {
          _this.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    closeDialog: function closeDialog() {
      this.formData = {};
      this.$emit('close');
    },
    save: function save() {
      var _this2 = this;

      // if (!this.formData.deliver_branch_id_fk) {
      //   this.inValid = true
      //   setTimeout(() => {
      //     this.inValid = false
      //   }, 2500)
      //   return
      // }

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/approving_order/' + this.orderId, this.formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.$emit('resetTable');
        _this2.closeDialog();
        _this2.$emit('clicked');
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'Done',
          text: 'Approved',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
        // if (error.response.data.message === 'money') {
        //   swal('Error', "You don't have enough money to approve this order", 'error')
        // } else {
        //   this.$emit('resetTable')
        //   this.closeDialog()
        //   this.$emit('clicked')
        //   swal({
        //     title: 'Done',
        //     text: 'Approved',
        //     icon: 'success',
        //     timer: 1500,
        //     buttons: false
        //   })
        // }
      });
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['trackNumDialog', 'orderId'],

  data: function data() {
    return {
      form: {},
      isDone: false,
      isFailed: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.form = {};
      this.isDone = false;
      this.isFailed = false;
      this.$validator.reset();
      this.$emit('close');
      this.$emit('resetTable');
    },
    submitForm: function submitForm() {
      var _this = this;

      this.isDone = false;
      this.isFailed = false;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/update_track_number/' + _this.orderId, _this.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.isDone = true;
            setTimeout(function () {
              _this.closeDialog();
            }, 2000);
          }).catch(function () {
            _this.isFailed = true;
          });
        }
      });
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addressDialog', 'governoratesList', 'citiesList', 'customer'],

  data: function data() {
    return {
      form: {},
      isDone: false,
      isFailed: false,
      selectedGovernorateId: null,
      filteredCitiesList: []
    };
  },


  methods: {
    onGovernorateChange: function onGovernorateChange() {
      var _this = this;

      // Clear city selection when governorate changes
      this.form.city_id_fk = null;
      if (this.selectedGovernorateId) {
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/city/list/' + this.selectedGovernorateId, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this.filteredCitiesList = response.data;
        }).catch(function () {
          _this.filteredCitiesList = [];
        });
      } else {
        this.filteredCitiesList = [];
      }
    },
    closeDialog: function closeDialog() {
      this.form = {};
      this.isDone = false;
      this.isFailed = false;
      this.selectedGovernorateId = null;
      this.filteredCitiesList = [];
      this.$validator.reset();
      this.$emit('close');
      this.$emit('resetTable');
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.isDone = false;
      this.isFailed = false;
      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');
          _this2.form.full_name = _this2.customer.full_name;
          _this2.form.phone_number = _this2.customer.phone_number;
          _this2.form.governorate_id_fk = _this2.selectedGovernorateId;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/update-customer/' + _this2.customer.user_id, _this2.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this2.isDone = true;
            _this2.$emit('refetchUser');
            setTimeout(function () {
              _this2.closeDialog();
            }, 2000);
          }).catch(function () {
            _this2.isFailed = true;
          });
        }
      });
    }
  },
  watch: {
    addressDialog: function addressDialog(val) {
      // When dialog opens, if governorate is selected, load cities
      if (val && this.selectedGovernorateId) {
        this.onGovernorateChange();
      }
    }
  }

});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    mobileDatatable: __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Case ID', text: 'Case ID', value: '1', sortable: true, searchable: true, name: 'order_case_id' }, { label: 'Status', text: 'Status', value: '2', sortable: true, searchable: true, name: 'status_name' }, { label: 'Order ID', text: 'Order ID', value: '3', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Created By', text: 'Created By', value: '4', sortable: true, searchable: true, name: 'full_name' }, { label: 'Product Name', text: 'Product Name', value: '5', sortable: true, searchable: true, name: 'product_name' }, { label: 'Note', text: 'Note', value: '6', sortable: true, searchable: true, name: 'note' }, { label: 'Create Date', text: 'Create Date', value: '7', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/order-case/customer-index',
      alertValue: false,
      filterMade: false,
      isMobile: false,
      totalResult: 0,
      isUpdate: false,
      checkAlert: false,
      addEditOrderCaseModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      sendToStaffModal: false,
      staffList: [],
      warehouses: [],
      columns: columns,
      statusList: [{ text: 'Pending', value: 1 }, { text: 'Processing', value: 2 }, { text: 'Refund', value: 3 }, { text: 'Replace', value: 4 }],
      sortKey: 'order_case_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_case_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('' + error.response.data.message, '', 'error');
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customerCancelExportOrder__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    Datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    customerCancelExportOrder: __WEBPACK_IMPORTED_MODULE_4__customerCancelExportOrder__["a" /* default */],
    mobileDatatable: __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Order No.', sortable: true, searchable: true, name: 'order_number' }, { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' }, { label: 'Quantity', sortable: true, searchable: true, name: 'quantity' }, { label: 'Country', sortable: true, searchable: true, name: 'country_name' }, { label: 'Status', sortable: true, searchable: true, name: 'status' }, { label: 'Price', sortable: true, searchable: true, name: 'price' }, { label: 'Date', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      orderId: 0,
      isMobile: false,
      url: 'api/my-export-order',
      alertValue: false,
      checkAlert: false,
      loggedInUserData: {},
      statusesList: [{ text: 'All', value: 0, color: 'bg-grey-600' }, { text: 'Pending', value: 1, color: 'bg-orange-600' }, { text: 'Canceled', value: 3, color: 'bg-danger-600' }, { text: 'Approved', value: 4, color: 'bg-green-600' }, { text: 'Sent', value: 5, color: 'bg-primary-600' }, { text: 'Received', value: 6, color: 'bg-teal-600' }, { text: 'Refunded', value: 7, color: 'bg-purple-600' }],
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      cancelModal: false,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        statuses: []
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    handleAddExportOrder: function handleAddExportOrder() {
      this.$router.push('/add-new-export-order');
    },
    filterByStatus: function filterByStatus(status) {
      if (status === 0) {
        this.tableData.statuses = [];
      } else {
        this.tableData.statuses = [status];
      }
      this.getResults();
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelModal = true;
      this.orderId = orderId;
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this.apiResults = data.data.data;

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        _this.configPagination(data.data);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    approvingOrder: function approvingOrder(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/export-order/' + id + '/customer-approve', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this2.getResults();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
              title: 'Done',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cancelModal', 'id'],

  data: function data() {
    return {
      form: {
        cancel_note: null
      },
      showAlert: false
    };
  },


  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/export-order/' + this.id + '/customer-cancel', this.form, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this.getResults();
        _this.showAlert = true;
        setTimeout(function () {
          _this.$emit('close');
        }, 1500);
      });
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getCountryList();

    // if edit mode get order data
    if (this.$route.params.id) {
      this.getOrder();
    }
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      weightUnitList: [{ text: 'KG', value: 'kg' }, { text: 'LB', value: 'lb' }],
      countryList: [],
      checkAlert: false,
      loading: false,
      form: {
        product_name: null,
        quantity: null,
        weight: null,
        image: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      }
    };
  },


  methods: {
    getCountryList: function getCountryList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/country/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.countryList = response.data.map(function (item) {
          return { text: item.country_name, value: item.country_id };
        });
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/customer_order_detail/' + this.$route.params.id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.form = response.data.data[0];
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this3.loading = true;
          var token = localStorage.getItem('access_token');

          var formData = new FormData();
          for (var key in _this3.form) {
            if (_this3.form[key]) {
              formData.append(key, _this3.form[key]);
            }
          }

          if (_this3.form.export_order_id) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-order/' + _this3.form.export_order_id, formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this3.loading = false;
              _this3.checkAlert = true;
              setTimeout(function () {
                _this3.checkAlert = false;
                _this3.clearForm();
                _this3.$router.push('/my-export-order');
              }, 2000);
            }).catch(function (error) {
              _this3.loading = false;
              _this3.checkAlert = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-order', formData, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
              _this3.loading = false;
              _this3.checkAlert = true;
              _this3.clearForm();
              setTimeout(function () {
                _this3.checkAlert = false;
              }, 2000);
            }).catch(function (error) {
              _this3.loading = false;
              _this3.checkAlert = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        }
      });
    },
    clearForm: function clearForm() {
      this.form = {
        product_name: null,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        image: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      };

      this.$validator.reset();
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instance: {
        customer: {},
        to_country: {},
        canceled_by: {},
        approved_by: {},
        sent_by: {},
        received_by: {}
      }
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/export-order/' + this.$route.params.id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.instance = response.data.data;
      });
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__logs_viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_4__logs_viewLogDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' }, { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' }, { label: 'quantity', sortable: true, searchable: true, name: 'quantity' }, { label: 'Warehouse', sortable: true, searchable: true, name: 'country' }, { label: 'Note', sortable: true, searchable: true, name: 'note' }, { label: 'Order Date', sortable: true, searchable: true, name: 'order_date' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      url: 'api/archived_order',
      orderDetailUrl: 'api/show_order_detail',
      companyUrl: 'api/company_info',
      logDetailUrl: 'api/order_credit_log_transaction',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      loggedInUserData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      invoiceDetailData: {
        credit_log_transaction_id: '',
        credit_log_transaction_date: '',
        invoice_number: '',
        amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: ''
      },
      detialData: {
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        refund_reason: '',
        country: '',
        created_at: ''
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initInvDetail: function initInvDetail(modal, id) {
      var _this = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        var detailResults = [];
        detailResults = data.data;

        _this.invoiceDetailData.credit_log_transaction_date = detailResults[0].credit_log_transaction_date;
        _this.invoiceDetailData.credit_log_transaction_id = detailResults[0].credit_log_transaction_id;
        _this.invoiceDetailData.invoice_number = detailResults[0].invoice_number;
        _this.invoiceDetailData.amount = detailResults[0].amount;
        _this.invoiceDetailData.full_name = detailResults[0].full_name;
        _this.invoiceDetailData.email = detailResults[0].email;
        _this.invoiceDetailData.address = detailResults[0].address;
        _this.invoiceDetailData.phone_number = detailResults[0].phone_number;
        _this.invoiceDetailData.product_name = detailResults[0].product_name;
        _this.invoiceDetailData.quantity = detailResults[0].quantity;
        _this.invoiceDetailData.item_weight = detailResults[0].item_weight;
        _this.invoiceDetailData.item_price = detailResults[0].item_price;
        _this.invoiceDetailData.tax = detailResults[0].tax;
        _this.invoiceDetailData.internal_shipping_handling = detailResults[0].internal_shipping_handling;
        _this.invoiceDetailData.insurance = detailResults[0].insurance;
        _this.invoiceDetailData.kreenex_fee = detailResults[0].kreenex_fee;
        _this.invoiceDetailData.delivery_price = detailResults[0].delivery_price;
        _this.invoiceDetailData.quantity_charge = detailResults[0].quantity_charge;
        _this.invoiceDetailData.created_at = detailResults[0].created_at;
        _this.invoiceDetailData.description = detailResults[0].description;
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        var companyResult = [];
        companyResult = data.data;

        _this2.companyData.company_name = companyResult.company_name;
        _this2.companyData.company_address = companyResult.company_address;
        _this2.companyData.company_email = companyResult.company_email;
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this3.apiResults = data.data.data;

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        _this3.configPagination(data.data);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      });
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    initDetail: function initDetail(modal, id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this4.detailResults = data.data;
        _this4.detialData = _this4.detailResults[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs_viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_3__logs_viewLogDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
    this.getResults();
    this.getCalculation();
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Invoice Number', sortable: true, searchable: true, name: 'invoice_number' }, { label: 'Order Status', sortable: false, searchable: false, name: 'order_status' }, { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' }, { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' }, { label: 'Amount', sortable: true, searchable: true, name: 'amount' }, {
      label: 'Invoice Date',
      sortable: true,
      searchable: true,
      name: 'credit_log_transaction_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/customer_invoices',
      logDetailUrl: 'api/credit_log_transactions',
      calculationUrl: 'api/customer_transaction_calculation',
      rowIndex: '',
      companyUrl: 'api/company_info',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      loggedInUserData: {},
      detialData: {
        credit_log_transaction_date: '',
        credit_log_transaction_id: '',
        invoice_number: '',
        amount: '',
        money_amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: '',
        refund_reason: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      calculationResults: {},
      detailResults: [],
      columns: columns,
      sortKey: 'credit_log_transaction_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_log_transaction_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    getCalculation: function getCalculation() {
      var _this = this;

      var theUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calculationUrl;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(theUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.calculationResults = response.data.data;
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.apiResults = data.data.data;

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        _this2.configPagination(data.data);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_transaction_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_log_transaction_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
      this.getCalculation();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_log_transaction_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_log_transaction_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      this.getResults();
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this3.detailResults = data.data;

        _this3.detialData = _this3.detailResults[0];
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        var companyResult = [];
        companyResult = data.data;

        _this4.companyData.company_name = companyResult.company_name;
        _this4.companyData.company_address = companyResult.company_address;
        _this4.companyData.company_email = companyResult.company_email;
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__approveOrder_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerCancelOrder__ = __webpack_require__(275);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    approveOrder: __WEBPACK_IMPORTED_MODULE_2__approveOrder_vue__["a" /* default */],
    customerCancelOrder: __WEBPACK_IMPORTED_MODULE_3__customerCancelOrder__["a" /* default */]
  },

  created: function created() {
    this.getLoggedInUser();
    if (window.location.search.replace('?id=', '') !== null || window.location.search.replace('?id=', '') !== '') {
      this.theOrderId = Number(window.location.search.replace('?id=', ''));
      this.getOrderDetail();
    }
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
  },
  data: function data() {
    return {
      theOrderId: '',
      approveDialog: false,
      orderDetailUrl: 'api/customer_order_detail',
      cancelingOrderUrl: 'api/canceling_order',
      detailResults: [],
      cancelAlert: false,
      cancelOrderModal: false,
      cancelData: {
        cancel_reason: ''
      },
      loggedInUserData: {},
      currentStep: 0,
      isCanceled: false,
      isRefunded: false,
      notfound: false,
      imageDialog: false,
      theImg: '',
      detailData: {}
    };
  },


  methods: {
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/canceling_order/' + this.theOrderId, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        _this.getOrderDetail();
        _this.cancelAlert = true;
        setTimeout(function () {
          _this.closeCancelingOrderModal();
        }, 1500);
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    requestDelivery: function requestDelivery() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'نرخی گەیاندن بۆ کاڵای ئاسایی بۆ ناو هەولێر ٥٠٠٠ دینار، بۆ دەرەوەی هەولێر ١٠٠٠٠ دینار',
        buttons: true,
        className: 'swal-title-1'
      }).then(function (canceled) {
        if (canceled) {
          var token = localStorage.getItem('access_token');
          var data = {
            order_id_fk: _this2.theOrderId
          };

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/order-delivery', data, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this2.getOrderDetail();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    showImage: function showImage(img) {
      var mainImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.theImg = mainImage ? img : img.order_image;
      this.imageDialog = true;
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    getOrderDetail: function getOrderDetail() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.orderDetailUrl + '/' + this.theOrderId, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this3.detailResults = data.data;

        _this3.detailData = _this3.detailResults[0];
        _this3.$nextTick(function () {
          _this3.getCurrentStep();
        });
      }).catch(function (error) {
        if (error.response && error.response.data.code_status === 404) {
          _this3.notfound = true;
        }
      });
    },
    getCurrentStep: function getCurrentStep() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.detailData.status;

      if (step === 'new_order') {
        this.currentStep = 0;
      } else if (step === 'canceled' && (this.detailData.item_price == null || this.detailData.item_price === '')) {
        this.currentStep = 1;
        this.isCanceled = true;
      } else if (step === 'processed_order') {
        this.currentStep = 2;
      } else if (step === 'canceled' && (this.detailData.item_price != null || this.detailData.item_price !== '')) {
        this.currentStep = 3;
        this.isCanceled = true;
      } else if (step === 'approved_order') {
        this.currentStep = 4;
      } else if (step === 'refunded') {
        this.currentStep = 5;
        this.isRefunded = true;
      } else if (step === 'purchased') {
        this.currentStep = 6;
      } else if (step === 'warehouse_delivered_order' || step === 'pending_to_shipment') {
        this.currentStep = 7;
      } else if (step === 'int_shipment') {
        this.currentStep = 8;
      } else if (step === 'pending_to_branch') {
        this.currentStep = 9;
      } else if (step === 'branch_delivery') {
        this.currentStep = 10;
      } else if (step === 'delivered') {
        this.currentStep = 11;
      } else {
        this.currentStep = 0; // Default to first step if status doesn't match
      }
    },
    approvingOrder: function approvingOrder(id) {
      this.theOrderId = id;
      this.approveDialog = true;
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('max_file_size', {
  getMessage: function getMessage(field, params) {
    return 'The ' + field + ' must not exceed ' + params[0] + ' MB.';
  },
  params: ['size'],
  validate: function validate(value, args) {
    if (!value || !value.length) return true; // No file selected
    var file = value[0];
    var size = parseFloat(args[0]); // Convert parameter to number
    if (!file || !file.size) return false;
    return file.size <= size * 1024 * 1024; // Convert MB to bytes
  }
});

__WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].extend('url', {
  getMessage: function getMessage(field) {
    return 'The ' + field + ' must be a valid HTTP URL.';
  },
  validate: function validate(value) {
    if (!value) return true;
    return (/^https?:\/\/.+/.test(value)
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  // created() {
  //   let thePanel = document.querySelector('.panel-flat')
  //   thePanel.style.overflowX = 'hidden'
  // },

  mounted: function mounted() {
    this.getLoggedInUser();
    this.getWarehouses();
    this.getWarehousesToSelect();
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }

    // if edit mode get order data
    if (window.location.search.replace('?order_id=', '') !== null || window.location.search.replace('?order_id=', '') !== '') {
      this.theOrderId = Number(window.location.search.replace('?order_id=', ''));
      if (this.theOrderId && this.theOrderId > 0) {
        this.getOrder();
      }
    }
    // console.log(this.$route.query.order_id)
    // console.log(this.$route.query && this.$route.query.order_id ? 'true' : 'false')
    // if (this.$route)
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      makeNewOrderUrl: 'api/orders/customer-store',
      showWarehouseUrl: 'api/warehouses',
      loggedInUserData: {},
      theOrderId: null,
      checkAlert: false,
      checkURL: false,
      loading: false,
      notCouponCode: false,
      x: 1,
      usaWarehouse: [],
      turkeyWarehouse: [],
      transportationTypes: [],
      warehouses: [],
      deliveryTypes: [{ text: 'Home Delivery', value: 'home delivery' }, { text: 'Office Delivery', value: 'office delivery' }],
      file: null,
      makeOrderData: {
        warehouse_id_fk: null,
        transportation_type: null,
        product_name: '',
        product_url: '',
        quantity: '',
        // delivery_type: "",
        coupon: '',
        size: '',
        type: '',
        color: '',
        note: '',
        other_service: '',
        image: null,
        fileName: ''
      },
      imagePreview: null
    };
  },


  computed: {
    checkImageOrEdit: function checkImageOrEdit() {
      return this.makeOrderData.order_id > 0 && this.file === null;
    }
  },

  methods: {
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      this.makeOrderData.image = null;
      this.makeOrderData.fileName = '';
      this.$validator.errors.remove('file');
      var file = event.target.files[0];
      if (file && !this.errors.has('file')) {
        this.file = file;
        this.makeOrderData.image = file;
        this.makeOrderData.fileName = file.name;
        this.imagePreview = URL.createObjectURL(file);
      } else {
        this.file = null;
        this.makeOrderData.image = null;
        this.imagePreview = null;
      }
    },
    handleSelectWarehouse: function handleSelectWarehouse(id, selected) {
      this.makeOrderData.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }

      if (selected > 0) this.makeOrderData.transportation_type = selected;
    },
    getOrder: function getOrder() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/customer_order_detail/' + this.theOrderId, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.makeOrderData = response.data.data[0];
        _this.handleSelectWarehouse(_this.makeOrderData.warehouse_id_fk, response.data.data[0].transportation_type_obj.id);
      });
    },
    getWarehousesToSelect: function getWarehousesToSelect() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    showWarehouseSection: function showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2;
        $('#ware').show('slow');
      } else if (this.x === 2) {
        this.x = 1;
        $('#ware').hide('slow');
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getWarehouses: function getWarehouses() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.showWarehouseUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.usaWarehouse = response.data.data[0];
        _this3.turkeyWarehouse = response.data.data[1];
      });
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    submitForm: function submitForm() {
      var _this4 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this4.makeOrderData.coupon && _this4.makeOrderData.coupon !== '') {
            if (_this4.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              _this4.notCouponCode = false;
              _this4.makeNewOrder();
            } else {
              _this4.notCouponCode = true;
            }
          } else {
            _this4.notCouponCode = false;
            _this4.makeNewOrder();
          }
        }
      });
    },
    makeNewOrder: function makeNewOrder() {
      var _this5 = this;

      this.loading = true;
      var token = localStorage.getItem('access_token');
      var formData = new FormData();

      // Append form data
      for (var key in this.makeOrderData) {
        formData.append(key, this.makeOrderData[key]);
      }

      // edit
      if (this.makeOrderData.order_id) {
        formData.append('_method', 'PUT');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/update-order-by-customer/' + this.makeOrderData.order_id, formData, {
          headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
        }).then(function () {
          _this5.checkURL = false;
          _this5.loading = false;
          _this5.checkAlert = true;
          setTimeout(function () {
            _this5.clearNewOrerData();
            _this5.$router.push('/my-order');
          }, 2000);
        }).catch(function (error) {
          _this5.loading = false;
          _this5.checkAlert = false;
          if (error.response.data.message.product_url) {
            _this5.checkURL = true;
          } else {
            _this5.checkURL = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          }
        });
      } else {
        // add
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.makeNewOrderUrl, formData, {
          headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
        }).then(function (response) {
          _this5.checkURL = false;
          _this5.loading = false;
          _this5.checkAlert = true;
          var a = _this5;
          setTimeout(function () {
            a.clearNewOrerData();
          }, 2000);
        }).catch(function (error) {
          _this5.loading = false;
          _this5.checkAlert = false;
          if (error.response.data.message.product_url) {
            _this5.checkURL = true;
          } else {
            _this5.checkURL = false;
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          }
        });
      }
    },
    clearNewOrerData: function clearNewOrerData() {
      this.makeOrderData.warehouse_id_fk = '';
      this.makeOrderData.transportation_type = null;
      this.makeOrderData.product_name = '';
      this.makeOrderData.product_url = '';
      this.makeOrderData.quantity = '';
      this.makeOrderData.coupon = '';
      this.makeOrderData.size = '';
      this.makeOrderData.type = '';
      this.makeOrderData.color = '';
      this.makeOrderData.c_o_d = '';
      this.makeOrderData.is_repackage = false;
      this.makeOrderData.is_hold = false;
      this.makeOrderData.other_service = null;
      this.makeOrderData.image = null;
      this.checkAlert = false;
      this.checkURL = false;
      this.$validator.reset();
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getLoggedInUser();
    this.getWarehouses();
    this.getWarehousesToSelect();
    this.getOurAddresses();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      transportationTypes: [],
      loggedInUserData: {},
      loading: false,
      form: {
        transportation_type: null
      },
      warehouses: [],
      ourAddresses: [],
      isDone: false,
      x: 1,
      usaWarehouse: {}
    };
  },


  methods: {
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.form.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
    },
    getOurAddresses: function getOurAddresses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/our-address/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.ourAddresses = res.data.map(function (d) {
          d.showCopyIcon = true;
          return d;
        });
      });
    },
    copyDescription: function copyDescription(address) {
      address.showCopyIcon = false;
      navigator.clipboard.writeText(address.description);

      setTimeout(function () {
        address.showCopyIcon = true;
      }, 1500);
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.usaWarehouse = response.data.data[0];
      });
    },
    showWarehouseSection: function showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2;
        $('#ware').show('slow');
      } else if (this.x === 2) {
        this.x = 1;
        $('#ware').hide('slow');
      }
    },
    removeSpaces: function removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '');
    },
    getWarehousesToSelect: function getWarehousesToSelect() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this3.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.form = {};
    },
    submitForm: function submitForm() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/customer/store_ship_only_order', _this4.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this4.isDone = true;
            _this4.form = {};
            setTimeout(function () {
              _this4.isDone = false;
            }, 2000);
          });
        }
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getLoggedInUser();
    this.getWarehouses();
    this.getWarehousesToSelect();
    this.getOurAddresses();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      transportationTypes: [],
      loggedInUserData: {},
      loading: false,
      form: {
        transportation_type: null
      },
      warehouses: [],
      ourAddresses: [],
      isDone: false,
      x: 1,
      usaWarehouse: {}
    };
  },


  methods: {
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.form.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }

      this.getOurAddresses();
    },
    addCustomerCode: function addCustomerCode(description) {
      var bold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!description) return '';
      var userId = this.loggedInUserData.user_id || '';
      var customerInfo = bold ? '<strong>' + userId + '</strong>' : userId;
      var withCustomer = description.replace(/Customer/gi, customerInfo);
      return withCustomer.replace(/\r?\n/g, '<br>');
    },
    getOurAddresses: function getOurAddresses() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      // Build query parameters
      var params = {};
      if (this.form.warehouse_id_fk) {
        params.warehouse_id_fk = this.form.warehouse_id_fk;
      }
      if (this.form.transportation_type) {
        params.transportation_type = this.form.transportation_type;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/our-address/list', {
        headers: { Authorization: 'Bearer ' + token },
        params: params
      }).then(function (res) {
        _this.ourAddresses = res.data.map(function (d) {
          d.showCopyIcon = true;
          return d;
        });
      });
    },
    copyDescription: function copyDescription(address) {
      address.showCopyIcon = false;
      navigator.clipboard.writeText(this.addCustomerCode(address.description, false));

      setTimeout(function () {
        address.showCopyIcon = true;
      }, 1500);
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.usaWarehouse = response.data.data[0];
      });
    },
    showWarehouseSection: function showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2;
        $('#ware').show('slow');
      } else if (this.x === 2) {
        this.x = 1;
        $('#ware').hide('slow');
      }
    },
    removeSpaces: function removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '');
    },
    getWarehousesToSelect: function getWarehousesToSelect() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this3.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.form = {};
    },
    submitForm: function submitForm() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/customer/store_ship_only_order', _this4.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this4.isDone = true;
            _this4.form = {};
            setTimeout(function () {
              _this4.isDone = false;
            }, 2000);
          });
        }
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    this.token = this.$route.query.token;
    if (this.token) {
      this.postToWebhook();
    }
  },
  data: function data() {
    return {
      selected: null,
      loggedInUserData: null,
      token: null
    };
  },


  methods: {
    nextStep: function nextStep() {
      if (!this.selected) return;

      if (this.selected === 'fib') {
        this.$router.push('/pay-with-fib');
      } else if (this.selected === 'fastpay') {
        this.$router.push('/pay-with-fastpay');
      } else if (this.selected === 'qi') {
        this.$router.push('/pay-with-qi');
      } else if (this.selected === 'zaincash') {
        this.$router.push('/pay-with-zaincash');
      }
    },
    postToWebhook: function postToWebhook() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/zaincash-payment-webhook', { token: this.token }).then(function (response) {
        console.log('Webhook processed successfully:', response.data);
        // Redirect to the URL provided in the response
        if (response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
        }
      }).catch(function (error) {
        console.error('Error posting to webhook:', error);
        // Handle error, perhaps show a message
      });
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fib.svg?9b8b633cc3128ce02ab7e0f2e967dd8a";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fastpay.svg?4095deb2b34d6d92602f637babd15f51";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "qi.svg?6e4ccf4ad595eb2000abd03418481b36";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zaincash.svg?271e2a809f7156c06af2a29c7a8b3c2d";

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import DisplayBranchInLog from '../DisplayBranchInLog.vue'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */]
    // DisplayBranchInLog
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/logs',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      logID: [],
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'log_id',
      sortOrders: sortOrders,
      detialData: {
        the_tl_price: '',
        cancel_reason: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        bank_name: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        coupon_percentage: '',
        delivery_type: '',
        theOrderID: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      tableData: {
        per_page: 10,
        search: '',
        column: 'log_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'log_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'log_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        // if (data.data.length > 0) {
        //   this.filterMade = true
        //   this.apiResults = data.data
        // } else {
        _this.filterMade = false;
        _this.apiResults = data.data.data;
        // }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        // if (data.data.length > 0) {
        //   this.removeConfigPagination()
        // } else {
        _this.configPagination(data.data);
        // }
        _this.getLogID(_this.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getLogID: function getLogID(logs) {
      this.logID = [];
      for (var i = 0; i < logs.length; i++) {
        this.logID[i] = logs[i].log_id;
      }
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.logID.length; i++) {
        if (i < this.logID.length - 1) {
          arr = arr.concat('arr[]=' + this.logID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.logID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/order-log-export?' + arr);
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.detailResults = data.data;
        _this2.detialData = _this2.detailResults[0];
      });
      this.modal(modal);
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'log_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'log_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.getLoggedInUser();
    if (localStorage.getItem('secret_key') === 'true') {
      var component = window.location.search.replace('?component=', '');
      this.$router.push('/' + component);
    }
  },


  watch: {
    $route: function $route() {
      if (localStorage.getItem('secret_key') === 'true') {
        var component = window.location.search.replace('?component=', '');
        this.$router.push('/' + component);
      }
    }
  },

  data: function data() {
    return {
      x: 1,
      checkSecretUrl: 'api/check_secret',
      addSecretUrl: 'api/add_secret',
      loggedInUserData: [],
      theComponent: '',
      secretKeyData: {
        secret_key: ''
      },
      addSecretKeyData: {
        secret_key: '',
        confirm_secret_key: ''
      },
      checkSecret: false,
      validat: false,
      validat2: false,
      validat3: false,
      validat4: false,
      e1: true,
      e2: true,
      e3: true
    };
  },


  methods: {
    showSecondForm: function showSecondForm() {
      if (this.x === 1) {
        this.x = 2;
        $('#second-form').show();
      } else if (this.x === 2) {
        this.x = 1;
        $('#second-form').hide();
      }
    },
    submitForm1: function submitForm1() {
      var _this = this;

      this.theComponent = window.location.search.replace('?component=', '');
      if (this.secretKeyData.secret_key === '') {
        this.validat = true;
        var a = this;
        setTimeout(function () {
          a.validat = false;
        }, 2000);
      } else {
        this.validat = false;
        var token = localStorage.getItem('access_token');

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.checkSecretUrl + '/' + this.loggedInUserData.user_id, this.secretKeyData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          _this.checkSecret = false;
          localStorage.setItem('secret_key', true);
          localStorage.setItem('secret_duration', 15);
          _this.$router.push('/' + _this.theComponent);
        }).catch(function () {
          _this.checkSecret = true;
          var a = _this;
          setTimeout(function () {
            a.checkSecret = false;
          }, 1500);
        });
      }
    },
    submitForm2: function submitForm2() {
      var _this2 = this;

      this.theComponent = window.location.search.replace('?component=', '');
      if (this.addSecretKeyData.secret_key === '' || this.addSecretKeyData.confirm_secret_key === '') {
        this.validat2 = true;
        var a = this;
        setTimeout(function () {
          a.validat2 = false;
        }, 4000);
      } else if (this.addSecretKeyData.secret_key !== this.addSecretKeyData.confirm_secret_key) {
        this.validat3 = true;
        var _a = this;
        setTimeout(function () {
          _a.validat3 = false;
        }, 2000);
      } else {
        this.validat3 = false;
        var token = localStorage.getItem('access_token');

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.addSecretUrl, this.addSecretKeyData, {
          headers: { Authorization: 'Bearer ' + token }
        }).then(function (response) {
          localStorage.setItem('secret_key', true);
          localStorage.setItem('secret_duration', 15);
          _this2.$router.push('/' + _this2.theComponent);
        }).catch(function (error) {
          if (error.response.data.code_status === 422) {
            _this2.validat4 = true;
            var b = _this2;
            setTimeout(function () {
              b.validat4 = false;
            }, 3000);
          }
        });
      }
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logs_viewActionLog_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-action-log': __WEBPACK_IMPORTED_MODULE_3__logs_viewActionLog_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
    this.getResults();
    this.getCalculation();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted: function mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser();
    }
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Invoice No', sortable: true, searchable: true, name: 'invoice_number' }, { label: 'Date', sortable: true, searchable: true, name: 'credit_invoice_date' }, { label: 'Description', sortable: true, searchable: true, name: 'description' }, { label: 'Action', sortable: true, searchable: true, name: 'credit_status' }, { label: 'Amount', sortable: true, searchable: true, name: 'amount' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/customer_credit_invoice',
      logDetailUrl: 'api/credit_log_actions',
      calculationUrl: 'api/customer_action_calculation',
      invoiceUrl: 'api/customer_last_invoice',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      loggedInUserData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      detailData: {
        credit_invoice_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        note: '',
        credit_log_action_date: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      calculationResults: {},
      detailResults: [],
      columns: columns,
      sortKey: 'credit_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_invoice_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getUser: function getUser() {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        localStorage.setItem('user_data', JSON.stringify(response.data));
      });
    },
    getCalculation: function getCalculation() {
      var _this = this;

      var theUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.calculationUrl;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(theUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.calculationResults = response.data.data;
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.apiResults = data.data.data;

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        _this2.configPagination(data.data);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_invoice_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
      this.getCalculation();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'credit_invoice_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'credit_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      this.getResults();
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.invoiceUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this3.detailResults = data.data;

        _this3.detailData.credit_log_action_date = _this3.detailResults.credit_log_action_date;
        _this3.detailData.credit_log_action_id = _this3.detailResults.credit_log_action_id;
        _this3.detailData.invoice_number = _this3.detailResults.invoice_number;
        _this3.detailData.description = _this3.detailResults.description;
        _this3.detailData.action = _this3.detailResults.action;
        _this3.detailData.created_at = _this3.detailResults.created_at;
        _this3.detailData.amount = _this3.detailResults.amount;
        _this3.detailData.customer_name = _this3.detailResults.customer_name;
        _this3.detailData.customer_email = _this3.detailResults.customer_email;
        _this3.detailData.phone_number = _this3.detailResults.customer_phone_number;
        _this3.detailData.customer_address = _this3.detailResults.customer_address;
        _this3.detailData.note = _this3.detailResults.note;
        _this3.detailData.old_price = _this3.detailResults.old_price;
      });
      this.modal(modal);
    },
    getCompanyData: function getCompanyData(token) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.companyData = response.data.data;
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orderInvoice_viewOrderInvoice_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    ViewOrderInvoice: __WEBPACK_IMPORTED_MODULE_5__orderInvoice_viewOrderInvoice_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_6__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '2',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Weight',
      text: 'Weight',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'weight'
    }, {
      label: 'Volume',
      text: 'Volume',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'volume'
    }, {
      label: 'Shipment',
      text: 'Shipment',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'shipment'
    }, {
      label: 'Tax',
      text: 'Tax',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'tax'
    }, {
      label: 'Delivery price',
      text: 'Delivery price',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'delivery_price'
    }, {
      label: 'Total price',
      text: 'Total price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'total_price'
    }, {
      label: 'Discount',
      text: 'Discount',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'discount'
    }, {
      label: 'Net price',
      text: 'Net price',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'net_price'
    }, {
      label: 'Note',
      text: 'Note',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Created At',
      text: 'Created At',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/customer/order_invoice',
      isMobile: false,
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'order_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewRecord: function viewRecord(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order_invoice/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewOrderInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderInvoice_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8493da96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderInvoice_vue__ = __webpack_require__(872);
function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8493da96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['viewOrderInvoiceModal', 'companyData', 'invoiceData'],

  methods: {
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();
      $('.show-in-print').show();

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] });

      $('#close-button').show();
      $('#print-button').show();
      $('.show-in-print').hide();
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      },
      fibResponse: {
        access_token: null,
        data: {
          paymentId: null,
          readableCode: null,
          qrCode: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.getLastExRate();
  },


  methods: {
    calcAmount: function calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate);
      this.form.amount = Math.round(this.form.amount);
      this.form.amount = parseInt(this.form.amount);
    },
    tryAgain: function tryAgain() {
      this.fibResponse = {
        access_token: null,
        data: {
          paymentId: null,
          readableCode: null,
          qrCode: null
        }
      };
    },
    getLastExRate: function getLastExRate() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.exRate = res.data.ex_rate;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.loading = true;
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pay-with-fib', _this2.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
          _this2.fibResponse = res.data;
        }).finally(function () {
          _this2.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      }
    };
  },
  mounted: function mounted() {
    this.getLastExRate();
  },


  methods: {
    calcAmount: function calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate);
      this.form.amount = parseInt(this.form.amount);
    },
    getLastExRate: function getLastExRate() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.exRate = res.data.ex_rate;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.loading = true;
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pay-with-fastpay', _this2.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
          window.open(res.data.data.redirect_uri);
        }).finally(function () {
          _this2.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      },
      qiResponse: {
        access_token: null,
        data: {
          paymentId: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.getLastExRate();
  },


  methods: {
    calcAmount: function calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate);
      this.form.amount = Math.round(this.form.amount);
      this.form.amount = parseInt(this.form.amount);
    },
    tryAgain: function tryAgain() {
      this.qiResponse = {
        access_token: null,
        data: {
          paymentId: null
        }
      };
    },
    getLastExRate: function getLastExRate() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.exRate = res.data.ex_rate;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.loading = true;
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pay-with-qi', _this2.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
          _this2.qiResponse = res.data;
          if (_this2.qiResponse.status === 'CREATED') {
            window.open(_this2.qiResponse.formUrl, '_blank');
            _this2.$router.push('/charge-balance');
          }
        }).finally(function () {
          _this2.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      exRate: 0,
      form: {
        amount_usd: null,
        amount: null,
        currency: 'IQD'
      },
      zainCashResponse: {
        access_token: null,
        data: {
          id: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.getLastExRate();
  },


  methods: {
    calcAmount: function calcAmount() {
      this.form.amount = Number(this.form.amount_usd) * Number(this.exRate);
      this.form.amount = Math.round(this.form.amount);
      this.form.amount = parseInt(this.form.amount);
    },
    tryAgain: function tryAgain() {
      this.zainCashResponse = {
        access_token: null,
        data: {
          id: null
        }
      };
    },
    getLastExRate: function getLastExRate() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.exRate = res.data.ex_rate;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.loading = true;
        var token = localStorage.getItem('access_token');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pay-with-zaincash', _this2.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
          _this2.zainCashResponse = res.data;
          if (_this2.zainCashResponse.status === 'initiated') {
            window.open(_this2.zainCashResponse.payment_url, '_blank');
            _this2.$router.push('/charge-balance');
          }
        }).finally(function () {
          _this2.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeTab: 'import',
      weightUnitList: [{ text: 'KG', value: 'kg' }, { text: 'LB', value: 'lb' }],
      importCheckRateData: null,
      exportCheckRateData: null,
      countryList: [],
      importForm: {
        from_country_id: null,
        is_document: true,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null
      },
      exportForm: {
        to_country_id: null,
        is_document: true,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null
      }
    };
  },


  computed: {
    filteredCountryList: function filteredCountryList() {
      if (this.activeTab === 'import') {
        return this.countryList.filter(function (item) {
          return [43, 219].includes(item.value);
        });
      }

      return this.countryList;
    }
  },

  mounted: function mounted() {
    this.getCountryList();
  },


  methods: {
    importCountrySelected: function importCountrySelected(countryId) {
      if (countryId === 219) {
        this.importForm.weight_unit = 'lb';
      } else if (countryId === 43) {
        this.importForm.weight_unit = 'kg';
      }
    },
    getCountryList: function getCountryList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/country/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.countryList = response.data.map(function (item) {
          return { text: item.country_name, value: item.country_id };
        });
      });
    },
    submitImport: function submitImport() {
      var _this2 = this;

      // this.$validator.validateAll().then(res => {
      // if (res) {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/import-check-rate', this.importForm, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.importCheckRateData = response.data.data;
      });
      // }
      // })
    },
    submitExport: function submitExport() {
      var _this3 = this;

      // this.$validator.validateAll().then(res => {
      // if (res) {
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-check-rate', this.exportForm, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.exportCheckRateData = response.data.data;
      });
      // }
      // })
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_2__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_3__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_1__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_0__mobileDatatable__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '3',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches'
    // },
    {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Order Status',
      text: 'Order Status',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'order_status'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Transportation Type',
      text: 'Transportation Type',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'order_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      isMobile: false,
      loader: null,
      loading: false,
      filterMade: false,
      totalResult: 0,
      url: 'api/admin-order',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      orderID: [],
      detialData: {
        the_tl_price: '',
        order_id: '',
        bank_name: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        coupon_percentage: '',
        delivery_type: '',
        theOrderID: '',
        item_weight: '',
        item_price: '',
        discount: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      dependDate: 'orders.created_at',
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        depend_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getDependDate: function getDependDate(date) {
      this.dependDate = date;
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        _this.getOrderID(_this.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getOrderID: function getOrderID(orders) {
      this.orderID = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id;
      }
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date, this.dependDate);
      this.sortByColumn();
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/order-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&depend_date=' + this.dependDate + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage + '&all_order=false');

      // let arr = '';
      //
      // for (let i=0; i < this.orderID.length; i++) {
      //     if (i < this.orderID.length-1) {
      //         arr = arr.concat('arr[]=' + this.orderID[i] + '&')
      //     } else {
      //         arr = arr.concat('arr[]=' + this.orderID[i])
      //     }
      // }
      //
      // let hostName = window.location.hostname;
      // let protocol = window.location.protocol + '//';
      // let fullHostName = protocol + hostName;
      // window.location.replace(fullHostName + '/api/order-export?' + arr + '&depend_date=' + this.dependDate + '&from_date=' + this.tableData.from_date + '&to_date=' + this.tableData.to_date + '&all_order=false');
      //
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.detailResults = data.data;
        _this2.detialData = _this2.detailResults[0];
      });
      this.modal(modal);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate, date) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.tableData.depend_date = date;
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.depend_date = 'orders.created_at';
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_2__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_3__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_4__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_1__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '3',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches'
    // },
    {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Order Status',
      text: 'Order Status',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'order_status'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Actual Cost',
      text: 'Actual Cost',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'actual_price'
    }, {
      label: 'Date',
      text: 'Date',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'the_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/all-order',
      orderDetailUrl: 'api/show_order_detail',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      orderID: [],
      detialData: {
        the_tl_price: '',
        order_id: '',
        cancel_reason: '',
        full_name: '',
        bank_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        theOrderID: '',
        type: '',
        coupon_percentage: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        discount: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      dependDate: 'orders.created_at',
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        depend_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getDependDate: function getDependDate(date) {
      this.dependDate = date;
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.depend_date = 'orders.created_at';
      this.getResults();
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, {
        params: this.tableData,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        _this.getOrderID(_this.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    getOrderID: function getOrderID(orders) {
      this.orderID = [];
      for (var i = 0; i < orders.length; i++) {
        this.orderID[i] = orders[i].order_id;
      }
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/order-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&depend_date=' + this.dependDate + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage + '&all_order=true');
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this2.detailResults = data.data;

        _this2.detialData = _this2.detailResults[0];
      });
      this.modal(modal);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate, date) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.tableData.depend_date = date;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logs_viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addWarehouseDate__ = __webpack_require__(224);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_7__logs_viewLogDetails_vue__["a" /* default */],
    addWarehouseDate: __WEBPACK_IMPORTED_MODULE_8__addWarehouseDate__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'order_date'
    }, {
      label: 'Warehouse Date',
      text: 'Warehouse Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'warehouse_date'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      isMobile: false,
      loadSingleApprove: false,
      approveValue: '1',
      loading: false,
      url: 'api/warehouse_date_passed',
      orderDetailUrl: 'api/show_order_detail',
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      orderIds: [],
      totalResult: 0,
      queryParameter: true,
      addWarehouseDateModal: false,
      warehouseDateData: {},
      cancelData: {
        cancel_reason: ''
      },
      companyUrl: 'api/company_info',
      detialData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      updateData: {
        item_price: '',
        tax: '',
        item_weight: '',
        kreenex_fee: '',
        insurance: '',
        total_amount: '',
        estimated_time: ''
      },
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    openAddWarehouseDateModal: function openAddWarehouseDateModal(orderId, warehouseDate) {
      this.addWarehouseDateModal = true;
      this.warehouseDateData = {
        order_id: orderId,
        warehouse_date: warehouseDate
      };
    },
    closeWarehouseDateModal: function closeWarehouseDateModal() {
      this.addWarehouseDateModal = false;
      this.warehouseDateData = {};
    },
    submitWarehouseDate: function submitWarehouseDate() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/api/change-warehouse-date', this.warehouseDateData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Success', 'Warehouse date changed', 'success');
        _this.closeWarehouseDateModal();
        _this.getResults();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', '' + error.response.data.message, 'error');
      });
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.companyData = response.data.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }

        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.detialData = response.data.data[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var thePanel = document.querySelector('.panel-flat');
    thePanel.style.overflowX = 'hidden';
  },
  mounted: function mounted() {
    this.getDefaultPrices();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      getDefaultPriceUrl: 'api/default_price',
      successAlert: false,
      errorAlert: false,
      defaultPriceData: {
        customer_price_per_weight_usa: 0,
        customer_price_per_weight_turkey: 0,
        customer_base_qtt_charge_turkey: 0,
        customer_base_qtt_charge_usa: 0,
        customer_other_qtt_charge_turkey: 0,
        customer_other_qtt_charge_usa: 0
      },
      updateDefaultPriceData: {
        customer_price_per_weight_usa: 0,
        customer_price_per_weight_turkey: 0,
        customer_base_qtt_charge_turkey: 0,
        customer_base_qtt_charge_usa: 0,
        customer_other_qtt_charge_turkey: 0,
        customer_other_qtt_charge_usa: 0
      }
    };
  },


  methods: {
    getDefaultPrices: function getDefaultPrices() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;

        _this.defaultPriceData.customer_base_qtt_charge_turkey = result[0].customer_base_qtt_charge_turkey;
        _this.defaultPriceData.customer_base_qtt_charge_usa = result[0].customer_base_qtt_charge_usa;
        _this.defaultPriceData.customer_other_qtt_charge_turkey = result[0].customer_other_qtt_charge_turkey;
        _this.defaultPriceData.customer_other_qtt_charge_usa = result[0].customer_other_qtt_charge_usa;
        _this.defaultPriceData.customer_price_per_weight_turkey = result[0].customer_price_per_weight_turkey;
        _this.defaultPriceData.customer_price_per_weight_usa = result[0].customer_price_per_weight_usa;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this2.updateDefaultPriceData.customer_price_per_weight_usa = _this2.defaultPriceData.customer_price_per_weight_usa;
          _this2.updateDefaultPriceData.customer_price_per_weight_turkey = _this2.defaultPriceData.customer_price_per_weight_turkey;
          _this2.updateDefaultPriceData.customer_base_qtt_charge_turkey = _this2.defaultPriceData.customer_base_qtt_charge_turkey;
          _this2.updateDefaultPriceData.customer_base_qtt_charge_usa = _this2.defaultPriceData.customer_base_qtt_charge_usa;
          _this2.updateDefaultPriceData.customer_other_qtt_charge_turkey = _this2.defaultPriceData.customer_other_qtt_charge_turkey;
          _this2.updateDefaultPriceData.customer_other_qtt_charge_usa = _this2.defaultPriceData.customer_other_qtt_charge_usa;

          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this2.getDefaultPriceUrl + '/' + 1, _this2.updateDefaultPriceData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this2.errorAlert = false;
            _this2.successAlert = true;

            var self = _this2;
            setTimeout(function () {
              self.successAlert = false;
            }, 2000);
          }).catch(function () {
            _this2.successAlert = false;
            _this2.errorAlert = true;

            var self = _this2;
            setTimeout(function () {
              self.errorAlert = false;
            }, 2000);
          });
        }
      });
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var thePanel = document.querySelector('.panel-flat');
    thePanel.style.overflowX = 'hidden';
  },
  mounted: function mounted() {
    this.getDefaultPrices();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      getDefaultPriceUrl: 'api/default_price',
      successAlert: false,
      errorAlert: false,
      defaultPriceData: {
        kreenex_fee_percentage: 0,
        kreenex_fee_base_usa: 0,
        kreenex_fee_base_turkey: 0,
        kreenex_fee_usa: 0,
        kreenex_fee_turkey: 0
      },
      updateDefaultPriceData: {
        kreenex_fee_percentage: 0,
        kreenex_fee_base_usa: 0,
        kreenex_fee_base_turkey: 0,
        kreenex_fee_usa: 0,
        kreenex_fee_turkey: 0
      }
    };
  },


  methods: {
    getDefaultPrices: function getDefaultPrices() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getDefaultPriceUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;

        _this.defaultPriceData.kreenex_fee_percentage = result[0].kreenex_fee_percentage;
        _this.defaultPriceData.kreenex_fee_base_usa = result[0].kreenex_fee_base_usa;
        _this.defaultPriceData.kreenex_fee_base_turkey = result[0].kreenex_fee_base_turkey;
        _this.defaultPriceData.kreenex_fee_usa = result[0].kreenex_fee_usa;
        _this.defaultPriceData.kreenex_fee_turkey = result[0].kreenex_fee_turkey;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this2.updateDefaultPriceData.kreenex_fee_percentage = _this2.defaultPriceData.kreenex_fee_percentage;
          _this2.updateDefaultPriceData.kreenex_fee_base_usa = _this2.defaultPriceData.kreenex_fee_base_usa;
          _this2.updateDefaultPriceData.kreenex_fee_base_turkey = _this2.defaultPriceData.kreenex_fee_base_turkey;
          _this2.updateDefaultPriceData.kreenex_fee_usa = _this2.defaultPriceData.kreenex_fee_usa;
          _this2.updateDefaultPriceData.kreenex_fee_turkey = _this2.defaultPriceData.kreenex_fee_turkey;

          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this2.getDefaultPriceUrl + '/' + 1 + '/kreenex_fee', _this2.updateDefaultPriceData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this2.errorAlert = false;
            _this2.successAlert = true;

            var self = _this2;
            setTimeout(function () {
              self.successAlert = false;
            }, 2000);
          }).catch(function () {
            _this2.successAlert = false;
            _this2.errorAlert = true;

            var self = _this2;
            setTimeout(function () {
              self.errorAlert = false;
            }, 2000);
          });
        }
      });
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addItemType__ = __webpack_require__(917);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'add-item-type': __WEBPACK_IMPORTED_MODULE_2__addItemType__["a" /* default */]
  },

  mounted: function mounted() {
    var thePanel = document.querySelector('.panel-flat');
    thePanel.style.overflowX = 'hidden';

    this.getItemType();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      getItemTypeUrl: 'api/get-item-type',
      updateItemTypeUrl: 'api/update-item-type',
      addItemTypeUrl: 'api/add-item-type',
      deleteItemTypeUrl: 'api/delete-item-type',
      addItemTypeModal: false,
      successAlert: false,
      errorAlert: false,
      checkAlert: false,
      itemTypeResult: [],
      itemTypes: [],
      addItemTypeData: {
        type_name: '',
        type_int_shipping_price: ''
      },
      updateShippingPriceData: {
        shippingID: [],
        shippingValue: []
      }
    };
  },


  methods: {
    deleteItemType: function deleteItemType(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(_this.deleteItemTypeUrl + '/' + id, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this.getItemType();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Warning', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    getItemType: function getItemType() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.itemTypeResult = [];
        _this2.itemTypes = [];

        _this2.itemTypeResult = response.data.data;
        _this2.itemTypeResult.forEach(function (c) {
          _this2.itemTypes.push({
            text: c.type_name,
            value: c.type_int_shipping_price,
            itemID: c.item_type_id
          });
        });
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');
          for (var i = 0; i < _this3.itemTypes.length; i++) {
            _this3.updateShippingPriceData.shippingID[i] = _this3.itemTypes[i].itemID;
            _this3.updateShippingPriceData.shippingValue[i] = _this3.itemTypes[i].value;
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(_this3.updateItemTypeUrl, _this3.updateShippingPriceData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function (response) {
            _this3.getItemType();

            _this3.errorAlert = false;
            _this3.successAlert = true;
            var self = _this3;
            setTimeout(function () {
              self.successAlert = false;
            }, 2000);
          }).catch(function () {
            _this3.successAlert = false;
            _this3.errorAlert = true;
            var self = _this3;
            setTimeout(function () {
              self.errorAlert = false;
            }, 2000);
          });
        }
      });
    },
    openAddItemTypeModal: function openAddItemTypeModal() {
      this.addItemTypeModal = true;
    },
    closeAddItemTypeModal: function closeAddItemTypeModal() {
      this.addItemTypeModal = false;
      this.checkAlert = false;
      this.clearAddItemTypeData();
    },
    clearAddItemTypeData: function clearAddItemTypeData() {
      this.addItemTypeData.type_name = '';
      this.addItemTypeData.type_int_shipping_price = '';
    },
    addItemType: function addItemType() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.addItemTypeUrl, this.addItemTypeData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this4.getItemType();
        _this4.checkAlert = true;
      });
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addItemTypeModal', 'closeAddItemTypeModal', 'checkAlert', 'addItemTypeData', 'addItemType'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.addItemType();
        }
      });
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addBank__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editBank__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__["a" /* default */],
    'add-bank': __WEBPACK_IMPORTED_MODULE_4__addBank__["a" /* default */],
    'edit-bank': __WEBPACK_IMPORTED_MODULE_5__editBank__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'bank_id' }, {
      label: 'Bank Name',
      text: 'Bank Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/banks',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      btnsave: true,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      addBankModal: false,
      editBankModal: false,
      theBankID: '',
      prevSearchQuery: '',
      apiResults: [],
      addBankData: {
        bank_name: ''
      },
      editBankData: {
        bank_name: ''
      },
      columns: columns,
      sortKey: 'bank_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddBankModal: function openAddBankModal() {
      this.addBankModal = true;
    },
    closeAddBankModal: function closeAddBankModal() {
      this.addBankModal = false;
      this.checkAlert = false;
      this.clearAddBankModal();
    },
    clearAddBankModal: function clearAddBankModal() {
      this.addBankData.bank_name = '';
    },
    addBank: function addBank() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.url, this.addBankData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.checkAlert = true;
        _this.clearAddBankModal();
        _this.getResults();
      }).catch(function () {});
    },
    openEditBankModal: function openEditBankModal(bank) {
      this.editBankData.bank_name = bank.bank_name;
      this.theBankID = bank.bank_id;
      this.editBankModal = true;
    },
    closeEditBankModal: function closeEditBankModal() {
      this.editBankModal = false;
      this.checkAlert = false;
      this.errorAlert = false;
      this.clearEditBankModal();
    },
    clearEditBankModal: function clearEditBankModal() {
      this.editBankData.bank_name = '';
    },
    editBank: function editBank() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.url + '/' + this.theBankID, this.editBankData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.errorAlert = false;
        _this2.checkAlert = true;
        _this2.clearEditBankModal();
        _this2.getResults();
      }).catch(function () {
        _this2.checkAlert = false;
        _this2.errorAlert = true;
      });
    },
    deleteBank: function deleteBank(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(_this3.url + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');
      //   let noResultRow = $('#no-result-row')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addBank', 'addBankData', 'addBankModal', 'checkAlert', 'closeAddBankModal'],

  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.addBank();
        }
      });
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editBank', 'editBankData', 'editBankModal', 'checkAlert', 'errorAlert', 'closeEditBankModal'],

  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editBank();
        }
      });
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addExchangeRate__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editExchangeRate__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_3__mobileDatatable__["a" /* default */],
    'add-exchange-rate': __WEBPACK_IMPORTED_MODULE_4__addExchangeRate__["a" /* default */],
    'edit-exchange-rate': __WEBPACK_IMPORTED_MODULE_5__editExchangeRate__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'ID',
      text: 'ID',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'exchange_rate_id'
    }, {
      label: 'Staff Name',
      text: 'Staff Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'staff_name'
    }, {
      label: 'USD Price',
      text: 'USD Price',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'usd_price'
    }, {
      label: 'TL Price',
      text: 'TL Price',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'tl_price'
    }, {
      label: 'Active',
      text: 'Active',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'active'
    }, {
      label: 'Exchange Date',
      text: 'Exchange Date',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'exchange_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      url: 'api/exchange_rate',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      successAlert: false,
      errorAlert: false,
      openExchangeModal: false,
      openEditExchangeModal: false,
      btnsave: true,
      exchangeRateID: [],
      queryParameter: true,
      prevSearchQuery: '',
      apiResults: [],
      theExchangeRateID: '',
      addExchangeRateData: {
        usd_price: '',
        tl_price: ''
      },
      editExchangeRateData: {
        usd_price: '',
        tl_price: ''
      },
      columns: columns,
      sortKey: 'exchange_rate_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'exchange_rate_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    sendToExport: function sendToExport() {
      var arr = '';

      for (var i = 0; i < this.exchangeRateID.length; i++) {
        if (i < this.exchangeRateID.length - 1) {
          arr = arr.concat('arr[]=' + this.exchangeRateID[i] + '&');
        } else {
          arr = arr.concat('arr[]=' + this.exchangeRateID[i]);
        }
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/exchange-rate-export?' + arr);
    },
    openAddExchangeRateModal: function openAddExchangeRateModal() {
      this.openExchangeModal = true;
    },
    closeAddExchangeRateModal: function closeAddExchangeRateModal() {
      this.openExchangeModal = false;
      this.successAlert = false;
    },
    clearAddExchangeRateModal: function clearAddExchangeRateModal() {
      this.addExchangeRateData.tl_price = '';
      this.addExchangeRateData.usd_price = '';
    },
    exchangeRate: function exchangeRate() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.url, this.addExchangeRateData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.successAlert = true;
        _this.clearAddExchangeRateModal();
        _this.getResults();
      });
    },
    openEditExchangeRateModal: function openEditExchangeRateModal(data) {
      this.theExchangeRateID = data.exchange_rate_id;
      this.editExchangeRateData.usd_price = data.usd_price;
      this.editExchangeRateData.tl_price = data.tl_price;
      this.openEditExchangeModal = true;
    },
    closeEditExchangeRateModal: function closeEditExchangeRateModal() {
      this.openEditExchangeModal = false;
      this.successAlert = false;
      this.errorAlert = false;
    },
    editExchangeRate: function editExchangeRate() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.url + '/' + this.theExchangeRateID, this.editExchangeRateData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.errorAlert = false;
        _this2.successAlert = true;
        _this2.getResults();
      }).catch(function () {
        _this2.successAlert = false;
        _this2.errorAlert = true;
      });
    },
    deleteExchangeRate: function deleteExchangeRate(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(_this3.url + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Warning', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    activeExchangeRate: function activeExchangeRate(id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.url + '/' + id + '/active', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.getResults();
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        if (error.response) {
          __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Warning', '' + error.response.data.message, 'error');
        }
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.apiResults = data.data;
        } else {
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        _this5.getExchangeRateID(_this5.apiResults);
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).catch(function (errors) {});
    },
    getExchangeRateID: function getExchangeRateID(exchangeRate) {
      this.exchangeRateID = [];
      for (var i = 0; i < exchangeRate.length; i++) {
        this.exchangeRateID[i] = exchangeRate[i].exchange_rate_id;
      }
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'exchange_rate_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'exchange_rate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['openExchangeModal', 'closeAddExchangeRateModal', 'successAlert', 'addExchangeRateData', 'exchangeRate'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.exchangeRate();
        }
      });
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['openEditExchangeModal', 'closeEditExchangeRateModal', 'successAlert', 'errorAlert', 'editExchangeRateData', 'editExchangeRate'],

  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.editExchangeRate();
        }
      });
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datepicker__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  $_veeValidate: {
    validator: 'new'
  },

  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_2_vue_datepicker__["default"]
  },

  data: function data() {
    return {
      branchesList: [],
      branches: [],
      apiResult: {},
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
          width: '100%'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    };
  },
  mounted: function mounted() {
    this.getConnectedBranches();
  },


  methods: {
    getConnectedBranches: function getConnectedBranches() {
      var _this = this;

      this.branchesList = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        result.forEach(function (r) {
          _this.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      if (this.startTime.time.length === 0 || !this.startTime1.time.length === 0) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', 'please select from date and to date', 'error');
        return;
      }

      var form = {
        from_date: this.startTime.time,
        to_date: this.startTime1.time,
        branches_id: this.branches
      };

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/delivered_report', form, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.apiResult = response.data.data;
      });
    }
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createUser_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editCustomer_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__customerTransactions_vue__ = __webpack_require__(255);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    customerTransactions: __WEBPACK_IMPORTED_MODULE_8__customerTransactions_vue__["a" /* default */],
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'create-user': __WEBPACK_IMPORTED_MODULE_3__createUser_vue__["a" /* default */],
    'edit-customer': __WEBPACK_IMPORTED_MODULE_4__editCustomer_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?name=', '') !== null || window.location.search.replace('?name=', '') !== '') {
        var value = window.location.search.replace('?name=', '').replace(/%20/g, ' ');
        this.searchOneCol('full_name', value);
      }
    }
    this.getResults();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  computed: {
    // all customers that match the current search/filter, on every page
    totalFiltered: function totalFiltered() {
      return this.filterMade ? this.apiResults.length : this.pagination.total;
    },
    sumOfSelectedCredit: function sumOfSelectedCredit() {
      var _this = this;

      var sum = 0;
      this.selectedUserIds.forEach(function (id) {
        sum += Number(_this.creditById[id] || 0);
      });

      return sum;
    }
  },
  watch: {
    selectedUserIds: function selectedUserIds() {
      this.syncMainCheck();
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'ID',
      text: 'ID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'user_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Email',
      text: 'Email',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'email'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Status',
      text: 'Status',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'is_blocked'
    }, {
      label: 'Address',
      text: 'Address',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'address'
    }, {
      label: 'Credit',
      text: 'Credit',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'credit'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/loan_customers',
      tranDialog: false,
      customerName: '',
      the_user_id: '',
      alertValue: false,
      checkAlert: false,
      errorAlert: false,
      validationError: false,
      phoneError: false,
      editCustomerModal: false,
      backendError: false,
      emailError: '',
      phoneNumberError: '',
      btnsave: true,
      totalCredit: 0,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      selectedUserIds: [],
      creditById: {},
      lastFilterKey: null,
      selectingAll: false,
      exportingSelected: false,
      columns: columns,
      sortKey: 'user_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    // select every customer that matches the current search/filter, not only this page
    checkAll: function checkAll() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.selectingAll = true;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(this.url, {
        params: Object.assign({}, this.tableData, { only_ids: 1 }),
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var credits = response.data.data || {};
        _this2.creditById = Object.assign({}, _this2.creditById, credits);
        _this2.selectedUserIds = Object.keys(credits).map(Number);
        _this2.selectingAll = false;
      }).catch(function () {
        _this2.selectingAll = false;
        _this2.syncMainCheck();
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Could not select all customers, please try again', 'error');
      });
    },
    unCheckAll: function unCheckAll() {
      this.selectedUserIds = [];
    },
    syncMainCheck: function syncMainCheck() {
      var allSelected = this.selectedUserIds.length > 0 && this.selectedUserIds.length >= this.totalFiltered;
      $('#mainCheck').prop('checked', allSelected);
    },


    // ticks stay when changing page, sorting or rows per page; a new search or filter clears them
    keepOrClearSelection: function keepOrClearSelection() {
      var filterKey = JSON.stringify([this.tableData.search, this.tableData.searchOneCol, this.tableData.searchOneVal, this.tableData.from_date, this.tableData.to_date, this.tableData.phone_verified]);

      if (this.lastFilterKey !== null && filterKey !== this.lastFilterKey) {
        this.selectedUserIds = [];
      }
      this.lastFilterKey = filterKey;
    },
    rememberCredits: function rememberCredits() {
      var credits = {};
      this.apiResults.forEach(function (r) {
        credits[Number(r.user_id)] = r.credit;
      });
      this.creditById = Object.assign({}, this.creditById, credits);
      this.syncMainCheck();
    },
    exportSelected: function exportSelected() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      this.exportingSelected = true;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('api/loan-customer-export-selected', { ids: this.selectedUserIds }, {
        headers: { Authorization: 'Bearer ' + token },
        responseType: 'blob'
      }).then(function (response) {
        var link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = 'LoanedCustomers-selected-' + new Date().toISOString().slice(0, 10) + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        _this3.exportingSelected = false;
      }).catch(function () {
        _this3.exportingSelected = false;
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('Error', 'Could not export the selected customers', 'error');
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    sendToExport: function sendToExport() {
      if (this.selectedUserIds.length) {
        this.exportSelected();
        return;
      }
      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      window.location.replace(fullHostName + '/api/loan-customer-export');
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, {
        params: this.tableData,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        var data = response.data;
        _this4.keepOrClearSelection();
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        var total = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          total = total + Number(_this4.apiResults[i].credit);
          _this4.totalResult += 1;
        }
        _this4.totalCredit = total.toFixed(2);
        _this4.rememberCredits();
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.filterTable(this.tableData.from_date, this.tableData.to_date);
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    customerTransaction: function customerTransaction(id, name) {
      this.customerName = name;
      this.customerId = id;
      this.tranDialog = true;
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addShipOnly_vue__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logs_viewLogDetails_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__adminCancelOrder__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */],
    addShipOnly: __WEBPACK_IMPORTED_MODULE_7__addShipOnly_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_4__mobileDatatable__["a" /* default */],
    'view-log-details': __WEBPACK_IMPORTED_MODULE_8__logs_viewLogDetails_vue__["a" /* default */],
    'admin-cancel-order': __WEBPACK_IMPORTED_MODULE_9__adminCancelOrder__["a" /* default */]
  },

  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
        var value = window.location.search.replace('?order=', '');
        this.searchOneCol('order_id', value);
      }
    }
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getItemType();
    this.getWarehouses();
    this.getReasons();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  watch: {
    $route: function $route() {
      if (this.queryParameter === true) {
        if (window.location.search.replace('?order=', '') !== null || window.location.search.replace('?order=', '') !== '') {
          var value = window.location.search.replace('?order=', '');
          this.searchOneCol('order_id', value);
        }
      }
    }
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '2',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches'
    // },
    {
      label: 'User',
      text: 'User',
      value: '2',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'user_id'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Track number',
      text: 'Track number',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'track_number'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'order_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      qrCodeValues: [],
      approveValue: '1',
      loadSingleApprove: false,
      isMobile: false,
      loader: null,
      loading: false,
      isUpdate: false,
      approvingDialog: false,
      checkAlert: false,
      formData: {},
      showApproveAllShiponly: true,
      approvingMultipleOrder: false,
      url: 'api/get_ship_only_orders',
      approvingOrderUrl: 'api/approving_order_by_admin',
      orderDetailUrl: 'api/show_order_detail',
      getCustomerUrl: 'api/get-customer-to-select',
      getItemTypeUrl: 'api/get-item-type',
      logDetailUrl: 'api/credit_log_transactions',
      purchaseOrderUrl: 'api/purchasing_order',
      companyUrl: 'api/company_info',
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      alertValue: false,
      addShipOnlyModal: false,
      companyData: {},
      warehouses: [],
      reasons: [],
      customers: [],
      itemTypeResult: [],
      itemTypes: [],
      detialData: {},
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      customersResult: [],
      cancelData: {
        cancel_reason: '',
        cancel_reason_ar: '',
        cancel_reason_ku: ''
      },
      theCancelOrderID: '',
      cancelOrderModal: false,
      cancelAlert: false,
      orderData: {},
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    handleResetTable: function handleResetTable(order) {
      this.getResults();
      this.initDetail('modal_showApp', order.order_id);
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    editOrder: function editOrder(row) {
      this.formData = _extends({}, row);
      this.isUpdate = true;
      this.addShipOnlyModal = true;
    },
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getReasons: function getReasons() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        result.forEach(function (r) {
          _this2.reasons.push({
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openCancelingOrderModal: function openCancelingOrderModal(orderId) {
      this.cancelOrderModal = true;
      this.theCancelOrderID = orderId;
    },
    closeCancelingOrderModal: function closeCancelingOrderModal() {
      this.cancelOrderModal = false;
      this.cancelAlert = false;
      this.cancelData.cancel_reason = '';
      this.cancelData.cancel_reason_ar = '';
      this.cancelData.cancel_reason_ku = '';
    },
    resetCancelData: function resetCancelData() {
      this.cancelData.cancel_reason = '';
      this.cancelData.cancel_reason_ar = '';
      this.cancelData.cancel_reason_ku = '';
    },
    cancelingOrder: function cancelingOrder() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('api/canceling_order_by_admin/' + this.theCancelOrderID, this.cancelData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this3.getResults();
        _this3.cancelAlert = true;
        var self = _this3;
        setTimeout(function () {
          self.closeCancelingOrderModal();
        }, 1500);
      });
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    getCompanyData: function getCompanyData(token) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.companyData.company_name = response.data.data.company_name;
        _this4.companyData.company_address = response.data.data.company_address;
        _this4.companyData.company_email = response.data.data.company_email;
      });
    },
    initInvoice: function initInvoice(modal, id) {
      var _this5 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this5.detailResults = data.data;

        _this5.detialData = _this5.detailResults[0];
      });
      this.modal(modal);
    },
    approveOrder: function approveOrder() {
      var _this6 = this;

      this.loadSingleApprove = true;
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.approvingOrderUrl, this.orderData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this6.loadSingleApprove = false;
        _this6.creditLogResponse = response.data.message;
        _this6.getResults();
        _this6.approvingDialog = false;

        // Purchase the order immediately after approving it
        // axios
        //   .put(this.purchaseOrderUrl + '/' + this.orderData.order_id, '', {
        //     headers: { Authorization: 'Bearer ' + token }
        //   })
        //   .then(() => {
        //     this.orderData = {}
        //     swal({
        //       title: '',
        //       text: 'Do you want to see this order invoice ?',
        //       icon: 'warning',
        //       buttons: true
        //     }).then((confirm) => {
        //       if (confirm) {
        //         this.initInvoice(
        //           'modal_showAppLog',
        //           this.creditLogResponse.credit_log_transaction_id
        //         )
        //       }
        //     })
        //   })
      }).catch(function (error) {
        _this6.loadSingleApprove = false;
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    loadApproveAllShiponly: function loadApproveAllShiponly() {
      var _this7 = this;

      this.approvingMultipleOrder = true;
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.approvingOrderUrl, { orders: this.qrCodeValues }, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        // Purchase after approve for each order
        // let purchasePromises = this.qrCodeValues.map(orderId => {
        //   return axios.put(this.purchaseOrderUrl + '/' + orderId, '', {
        //     headers: { Authorization: 'Bearer ' + token }
        //   })
        // })

        // return Promise.all(purchasePromises)
      }).then(function () {
        _this7.approvingMultipleOrder = false;
        _this7.qrCodeValues = [];
        _this7.getResults();
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Success', 'All selected orders have been approved and purchased.', 'success');
      }).catch(function (error) {
        _this7.approvingMultipleOrder = false;
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    approvingOrder: function approvingOrder(data) {
      this.orderData = data;
      this.approvingDialog = true;
    },
    getResults: function getResults() {
      var _this8 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this8.filterMade = true;
          _this8.apiResults = data.data;
        } else {
          _this8.filterMade = false;
          _this8.apiResults = data.data.data;
        }

        if (_this8.apiResults.length === 0) {
          _this8.tableData.searchOneCol = '';
          _this8.tableData.searchOneVal = '';
          _this8.tableData.search = '';
          _this8.alertValue = true;
        } else {
          _this8.alertValue = false;
        }
        if (data.data.length > 0) {
          _this8.removeConfigPagination();
        } else {
          _this8.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this8.totalResult = 0;
        for (var i = 0; i < _this8.apiResults.length; i++) {
          _this8.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();

      var a = this;
      setTimeout(function () {
        a.queryParameter = true;
      }, 1000);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    openAddNewOrderModal: function openAddNewOrderModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addShipOnlyModal = true;
    },
    getCustomer: function getCustomer() {
      var _this9 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this9.customersResult = response.data.data;
        _this9.customersResult.forEach(function (c) {
          _this9.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getItemType: function getItemType() {
      var _this10 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.getItemTypeUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this10.itemTypeResult = response.data.data;
        _this10.itemTypeResult.forEach(function (c) {
          _this10.itemTypes.push({
            text: c.type_name,
            value: c.type_name,
            shippingPrice: c.type_int_shipping_price
          });
        });
      });
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this11 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this11.detailResults = data.data;

        _this11.detialData = _this11.detailResults[0];
      });
      this.modal(modal);
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getLoggedInUser();
  },


  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__["default"]
  },

  props: ['addShipOnlyModal', 'warehouses', 'closeAddNewOrderModal', 'customers', 'checkURL', 'isUpdate', 'formData'],

  data: function data() {
    return {
      transportationTypes: [],
      loggedInUserData: {},
      loading: false,
      form: {
        transportation_type: null
      },
      isDone: false,
      fromDateError: false,
      toDateError: false,
      startTime: {},
      startTime1: {},
      today: null,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm'
      }
    };
  },


  watch: {
    addShipOnlyModal: {
      immediate: false,
      handler: function handler() {
        var _this = this;

        if (this.addShipOnlyModal) {
          var t = new Date();
          var dd = t.getDate();
          var mm = t.getMonth() + 1; // January is 0!
          var yyyy = t.getFullYear();

          if (dd < 10) {
            dd = '0' + dd;
          }

          if (mm < 10) {
            mm = '0' + mm;
          }

          t = yyyy + '-' + mm + '-' + dd;
          this.today = t;

          if (this.isUpdate) {
            this.form = this.formData;

            var warehouse = this.warehouses.find(function (w) {
              return w.value === _this.formData.warehouse_id_fk;
            });

            if (warehouse) {
              this.transportationTypes = warehouse.transportation_types;
            }

            this.startTime.time = this.formData.from_date;
            this.startTime1.time = this.formData.to_date;
          } else {
            this.startTime.time = t;
            this.startTime1.time = t;
          }
        }
      }
    }
  },

  methods: {
    repackageChanged: function repackageChanged() {
      if (!this.form.is_repackage) {
        this.form.repackage_price = 0;
      }
      this.calculateTotalAmount();
    },
    holdChanged: function holdChanged() {
      if (!this.form.is_hold) {
        this.form.hold_price = 0;
      }
      this.calculateTotalAmount();
    },
    otherServiceChanged: function otherServiceChanged() {
      if (!this.form.other_service) {
        this.form.other_service_price = 0;
      }
      this.calculateTotalAmount();
    },
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.form.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
    },
    removeSpaces: function removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '');
    },
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.form = {};
      this.$emit('close');
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var shipping = this.form.internal_shipping_handling ? this.form.internal_shipping_handling : 0;
      var tax = this.form.tax ? this.form.tax : 0;
      var repackage = this.form.repackage_price ? this.form.repackage_price : 0;
      var hold = this.form.hold_price ? this.form.hold_price : 0;
      var otherService = this.form.other_service_price ? this.form.other_service_price : 0;
      var handlingFee = this.form.handling_fee ? this.form.handling_fee : 0;

      this.form.total_amount = Number(shipping) + Number(tax) + Number(repackage) + Number(hold) + Number(otherService) + Number(handlingFee);
      this.form.total_amount = Number(this.form.total_amount.toFixed(2));
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this2.startTime && _this2.startTime.time <= _this2.today) {
            _this2.toDateError = false;
            _this2.fromDateError = true;
            return;
          }

          if (_this2.startTime1 && _this2.startTime && _this2.startTime1.time <= _this2.startTime.time) {
            _this2.fromDateError = false;
            _this2.toDateError = true;
            return;
          }

          _this2.form.from_date = _this2.startTime.time;
          _this2.form.to_date = _this2.startTime1.time;

          if (_this2.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/update_ship_only_order/' + _this2.form.order_id, _this2.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this2.isDone = true;
              _this2.startTime = {};
              _this2.startTime1 = {};
              _this2.form = {};
              _this2.toDateError = false;
              _this2.fromDateError = false;
              setTimeout(function () {
                _this2.isDone = false;
                _this2.$emit('resetTable');
                _this2.$emit('close');
              }, 2000);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/store_ship_only_order', _this2.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function (res) {
              _this2.isDone = true;
              _this2.startTime = {};
              _this2.startTime1 = {};
              _this2.form = {};
              _this2.toDateError = false;
              _this2.fromDateError = false;
              setTimeout(function () {
                _this2.isDone = false;
                _this2.$emit('resetTable', res.data);
                _this2.$emit('close');
              }, 2000);
            });
          }
        }
      });
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditSupplier__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditSupplier: __WEBPACK_IMPORTED_MODULE_3__addEditSupplier__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'supplier_id' }, {
      label: 'Name',
      text: 'Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'name'
    }, {
      label: 'Phone',
      text: 'Phone',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'phone'
    }, {
      label: 'Address',
      text: 'Address',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'address'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/suppliers',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditSupplierModal: false,
      theSupplierID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'supplier_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddSupplierModal: function openAddSupplierModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditSupplierModal = true;
    },
    openEditSupplierModal: function openEditSupplierModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addEditSupplierModal = true;
    },


    // addSupplier() {
    //   let token = localStorage.getItem('access_token')

    //   axios
    //     .post(this.url, this.addSupplierData, { headers: { Authorization: 'Bearer ' + token } })
    //     .then(response => {
    //       this.clearAddSupplierModal()
    //       this.getResults()
    //     })
    //     .catch(() => {})
    // },

    deleteSupplier: function deleteSupplier(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/suppliers/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditSupplierModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/suppliers/' + _this.formData.supplier_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/suppliers', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditExpenseType__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditExpenseType: __WEBPACK_IMPORTED_MODULE_3__addEditExpenseType__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'expense_type_id' }, {
      label: 'Name',
      text: 'Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'name'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/expense_types',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditExpenseTypeModal: false,
      theExpenseTypeID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'expense_type_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddExpenseTypeModal: function openAddExpenseTypeModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditExpenseTypeModal = true;
    },
    openEditExpenseTypeModal: function openEditExpenseTypeModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addEditExpenseTypeModal = true;
    },
    deleteExpenseType: function deleteExpenseType(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/expense_types/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditExpenseTypeModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/expense_types/' + _this.formData.expense_type_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/expense_types', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEdit__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEdit: __WEBPACK_IMPORTED_MODULE_3__addEdit__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getSuppliersList();
    this.getExpenseTypesList();
    this.getBanksList();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Expense Type',
      text: 'Expense Type',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'expense_type_name'
    }, {
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    }, {
      label: 'Supplier Inv. No.',
      text: 'Supplier Inv. No.',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'supplier_invoice_number'
    }, {
      label: 'Supplier',
      text: 'Supplier',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'supplier_name'
    }, {
      label: 'Bank',
      text: 'Bank',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Status',
      text: 'Status',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'status'
    }, {
      label: 'Note',
      text: 'Note',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Staff',
      text: 'Staff',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Expense Date',
      text: 'Expense Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'expense_date'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/expenses',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditExpenseModal: false,
      theExpenseID: '',
      prevSearchQuery: '',
      expenseTypesList: [],
      suppliersList: [],
      banksList: [],
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'expense_id',
      sortOrders: sortOrders,
      footer: [],
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        supplier_id: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getSuppliersList: function getSuppliersList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/suppliers/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.suppliersList = [];
        res.data.forEach(function (e) {
          _this.suppliersList.push({ text: e.name, value: e.supplier_id });
        });
      });
    },
    getExpenseTypesList: function getExpenseTypesList() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/expense_types/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.expenseTypesList = [];
        res.data.forEach(function (e) {
          _this2.expenseTypesList.push({ text: e.name, value: e.expense_type_id });
        });
      });
    },
    getBanksList: function getBanksList() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.banksList = [];
        res.data.data.forEach(function (e) {
          _this3.banksList.push({ text: e.bank_name, value: e.bank_id });
        });
      });
    },
    openAddExpenseModal: function openAddExpenseModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditExpenseModal = true;
    },
    openEditExpenseModal: function openEditExpenseModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addEditExpenseModal = true;
    },
    deleteExpense: function deleteExpense(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/expenses/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this4.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
          _this5.footer = data.data.footer;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditExpenseModal', 'formData', 'isUpdate', 'expenseTypesList', 'suppliersList', 'banksList'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
      expenseStatusList: [{ text: 'Paid', value: 'paid' }, { text: 'Unpaid', value: 'unpaid' }, { text: 'Cash', value: 'cash' }]
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/expenses/' + _this.formData.expense_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/expenses', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewOrderInvoice_vue__ = __webpack_require__(301);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    ViewOrderInvoice: __WEBPACK_IMPORTED_MODULE_5__viewOrderInvoice_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '2',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '2',
      sortable: true,
      searchable: false,
      name: 'country'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer',
      text: 'Customer',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Phone',
      text: 'Phone',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'phone'
    }, {
      label: 'Shiponly',
      text: 'Shiponly',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'shiponly'
    }, {
      label: 'Weight',
      text: 'Weight',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'weight'
    }, {
      label: 'Volume',
      text: 'Volume',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'volume'
    }, {
      label: 'Handling Fee',
      text: 'Handling Fee',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'handling_fee'
    }, {
      label: 'Shipment',
      text: 'Shipment',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'shipment'
    }, {
      label: 'Tax',
      text: 'Tax',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'tax'
    }, {
      label: 'Delivery price',
      text: 'Delivery price',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'delivery_price'
    }, {
      label: 'Total price',
      text: 'Total price',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'total_price'
    }, {
      label: 'Discount',
      text: 'Discount',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'discount'
    }, {
      label: 'Net price',
      text: 'Net price',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'net_price'
    }, {
      label: 'Note',
      text: 'Note',
      value: '17',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Created At',
      text: 'Created At',
      value: '18',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/order_invoice',
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'order_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_invoices.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;
      // let fullHostName = 'http://shipzone.test'

      window.location.replace(fullHostName + '/api/order_invoice/export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate);
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewRecord: function viewRecord(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order_invoice/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewOrderInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    deleteRow: function deleteRow(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete('api/order_invoice/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      apiData: {}
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/capital', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_1_vue_datepicker__["default"]
  },

  data: function data() {
    return {
      branchesList: [],
      branches: [],
      apiData: {},
      queryParams: {
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    };
  },
  mounted: function mounted() {
    this.getConnectedBranches();
    this.getData();
  },


  methods: {
    getConnectedBranches: function getConnectedBranches() {
      var _this = this;

      this.branchesList = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data;
        result.forEach(function (r) {
          _this.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    },
    getData: function getData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/profit', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.apiData = res.data;
      });
    },
    resetFilter: function resetFilter() {
      this.startTime.time = '';
      this.startTime1.time = '';

      this.queryParams.from_date = '';
      this.queryParams.to_date = '';

      this.getData();
    },
    applyFilter: function applyFilter() {
      this.queryParams.from_date = this.startTime.time;
      this.queryParams.to_date = this.startTime1.time;
      this.queryParams.branches_id = this.branches.toString();

      this.getData();
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pallets: [],
      queryParams: {
        search: '',
        from_date: '',
        to_date: '',
        warehouse_id: '',
        is_completed: ''
      },
      warehouses: [],
      formModal: false,
      formData: {
        pallet_id: null,
        tracking_number: '',
        warehouse_id_fk: null,
        flight_date: '',
        note: ''
      },
      palletModal: false,
      pallet: null,
      expenses: [],
      orders: [],
      items: [],
      loaded: false,
      itemForm: { name: '', customer_name: '', item_price: '', shipzone_fee: '', int_shipping: '', local_tax: '', handling_fee: '', note: '' },
      itemLines: [{ key: 'shipzone_fee', label: 'ShipZone fee' }, { key: 'int_shipping', label: 'Int Shipping' }, { key: 'local_tax', label: 'Local Tax' }, { key: 'handling_fee', label: 'Handling fee' }],
      itemFormOpen: false,
      expenseFormOpen: false,
      addOrdersOpen: false,
      addOrdersText: '',
      moveModal: false,
      moveOrder: null,
      moveTo: null,
      pickerPallets: [],
      expenseNames: ['Turkish Airlines invoice', 'Airport expenses', 'Airport tax', 'Other'],
      stageNames: {
        purchased: 'Purchased',
        warehouse_delivered_order: 'Warehouse Delivered',
        pending_to_shipment: 'Pending To Shipment',
        int_shipment: 'International Shipment',
        pending_to_branch: 'Pending To Branch',
        branch_delivery: 'Delivered to Erbil',
        delivered: 'Delivered',
        archived: 'Archived',
        refunded: 'Refunded',
        canceled: 'Canceled'
      },
      expenseForm: {
        name: '',
        amount: '',
        expense_date: '',
        note: ''
      }
    };
  },


  computed: {
    // orders still waiting to be weighed in Erbil come first
    openCount: function openCount() {
      return this.pallets.filter(function (p) {
        return !p.is_completed;
      }).length;
    },
    itemFormTotal: function itemFormTotal() {
      var _this = this;

      return this.itemLines.reduce(function (total, line) {
        return total + (Number(_this.itemForm[line.key]) || 0);
      }, 0);
    },
    otherPallets: function otherPallets() {
      var _this2 = this;

      // an order can only move to another plane from the same origin
      return this.pickerPallets.filter(function (p) {
        return _this2.pallet && p.pallet_id != _this2.pallet.pallet_id && p.warehouse_id_fk == _this2.pallet.warehouse_id_fk;
      });
    },
    sortedOrders: function sortedOrders() {
      return this.orders.slice().sort(function (a, b) {
        return (b.waiting_invoice ? 1 : 0) - (a.waiting_invoice ? 1 : 0);
      });
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    // a pallet card on the home page links here with ?pallet=ID and opens that report
    this.getData(this.$route.query.pallet);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: this.headers() }).then(function (response) {
      _this3.warehouses = response.data.data || [];
    }).catch(function () {});
  },


  methods: {
    headers: function headers() {
      return { Authorization: 'Bearer ' + localStorage.getItem('access_token') };
    },
    getData: function getData(openPalletId) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/pallets', { params: this.queryParams, headers: this.headers() }).then(function (response) {
        _this4.pallets = response.data;
        var toOpen = _this4.pallets.find(function (p) {
          return String(p.pallet_id) === String(openPalletId);
        });
        if (toOpen) {
          _this4.showPallet(toOpen);
        }
      }).catch(function (error) {
        return _this4.showError(error);
      });
    },
    resetFilter: function resetFilter() {
      this.queryParams.search = '';
      this.queryParams.from_date = '';
      this.queryParams.to_date = '';
      this.queryParams.warehouse_id = '';
      this.queryParams.is_completed = '';
      this.getData();
    },
    sum: function sum(key) {
      return this.pallets.reduce(function (total, p) {
        return total + (Number(p[key]) || 0);
      }, 0);
    },


    // What a pallet still needs before it is completed (nobody switches that by hand).
    statusReasons: function statusReasons(p) {
      var reasons = [];
      if (p.orders_count == 0 && p.items_count == 0) {
        reasons.push('Orders are sent on this pallet');
      }
      if (p.waiting_invoice_count > 0) {
        reasons.push(p.waiting_invoice_count + (p.waiting_invoice_count == 1 ? ' order is' : ' orders are') + ' weighed in Erbil and get a Shipping Invoice (listed first below; their money is not counted yet)');
      }
      ;(p.missing_expenses || []).forEach(function (name) {
        return reasons.push(name + ' is entered');
      });
      return reasons;
    },
    shortReasons: function shortReasons(p) {
      if (p.is_completed) {
        return [];
      }
      var reasons = [];
      var missing = (p.missing_expenses || []).length;
      if (p.orders_count == 0 && p.items_count == 0) {
        reasons.push('no orders yet');
      }
      if (p.waiting_invoice_count > 0) {
        reasons.push(p.waiting_invoice_count + ' not weighed');
      }
      if (missing > 0) {
        reasons.push(missing + (missing == 1 ? ' expense' : ' expenses') + ' missing');
      }
      return reasons;
    },
    stageName: function stageName(status) {
      return this.stageNames[status] || status;
    },


    // hover text of the "On order" amount: the three things it is made of
    onOrderParts: function onOrderParts(o) {
      var money = this.$options.filters.usdFormat;
      return 'ShipZone fee ' + money(o.shipzone_fee) + ' + Int Shipping ' + money(o.int_shipping) + ' + Local Tax ' + money(o.local_tax);
    },


    // hover text of a hand item's income: the lines it is made of
    itemParts: function itemParts(item) {
      var money = this.$options.filters.usdFormat;
      return this.itemLines.map(function (line) {
        return line.label + ' ' + money(item[line.key] || 0);
      }).join(' + ');
    },
    profitStyle: function profitStyle(profit) {
      return 'font-weight: bold; color: ' + (profit < 0 ? '#d9534f' : '#27ae60');
    },
    openForm: function openForm(pallet) {
      this.formData = {
        pallet_id: pallet ? pallet.pallet_id : null,
        tracking_number: pallet ? pallet.tracking_number : '',
        warehouse_id_fk: pallet ? pallet.warehouse_id_fk : this.warehouses.length > 0 ? this.warehouses[0].warehouse_id : null,
        flight_date: pallet ? pallet.flight_date : '',
        note: pallet ? pallet.note : ''
      };
      this.formModal = true;
    },
    savePallet: function savePallet() {
      var _this5 = this;

      var request = this.formData.pallet_id ? __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/pallets/' + this.formData.pallet_id, this.formData, { headers: this.headers() }) : __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pallets', this.formData, { headers: this.headers() });

      request.then(function () {
        _this5.formModal = false;
        _this5.getData();
      }).catch(function (error) {
        return _this5.showError(error);
      });
    },
    deletePallet: function deletePallet(pallet) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete pallet ' + pallet.tracking_number,
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/pallets/' + pallet.pallet_id, { headers: _this6.headers() }).then(function () {
            return _this6.getData();
          }).catch(function (error) {
            return _this6.showError(error);
          });
        }
      });
    },
    showPallet: function showPallet(pallet) {
      this.pallet = pallet;
      this.expenses = [];
      this.orders = [];
      this.items = [];
      this.loaded = false;
      this.addOrdersOpen = false;
      this.itemFormOpen = false;
      this.expenseFormOpen = false;
      this.addOrdersText = '';
      this.palletModal = true;
      this.loadPallet();
    },
    loadPallet: function loadPallet() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/pallets/' + this.pallet.pallet_id, { headers: this.headers() }).then(function (response) {
        _this7.pallet = response.data.pallet;
        _this7.expenses = response.data.expenses;
        _this7.orders = response.data.orders;
        _this7.items = response.data.items;
        _this7.loaded = true;
      }).catch(function (error) {
        return _this7.showError(error);
      });
    },
    openExpenseForm: function openExpenseForm(name) {
      this.expenseForm.name = name;
      this.expenseFormOpen = true;
    },
    addExpense: function addExpense() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pallets/' + this.pallet.pallet_id + '/expenses', this.expenseForm, { headers: this.headers() }).then(function () {
        _this8.expenseForm = { name: '', amount: '', expense_date: '', note: '' };
        _this8.expenseFormOpen = false;
        _this8.loadPallet();
        _this8.getData();
      }).catch(function (error) {
        return _this8.showError(error);
      });
    },
    deleteExpense: function deleteExpense(expense) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete ' + expense.name,
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/pallet_expenses/' + expense.pallet_expense_id, { headers: _this9.headers() }).then(function () {
            _this9.loadPallet();
            _this9.getData();
          }).catch(function (error) {
            return _this9.showError(error);
          });
        }
      });
    },


    // Orders already in the system that flew on this pallet without being put on it.
    addOrders: function addOrders(move) {
      var _this10 = this;

      var codes = this.addOrdersText.split(/[\s,]+/).filter(function (code) {
        return code;
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pallets/' + this.pallet.pallet_id + '/orders', { codes: codes, move: move }, { headers: this.headers() }).then(function (response) {
        _this10.addOrdersText = '';
        _this10.addOrdersOpen = false;
        _this10.loadPallet();
        _this10.getData();
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({ title: 'Done', text: response.data.message, icon: 'success', timer: 1800, buttons: false });
      }).catch(function (error) {
        var onOtherPallet = error.response && error.response.status == 409 && error.response.data.needs_move;
        if (!onOtherPallet) {
          return _this10.showError(error);
        }
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'Are you sure?',
          text: 'These are on another pallet and will be moved to this one: ' + onOtherPallet.join(', '),
          icon: 'warning',
          buttons: true
        }).then(function (confirmed) {
          if (confirmed) {
            _this10.addOrders(true);
          }
        });
      });
    },
    openMove: function openMove(order) {
      var _this11 = this;

      this.moveOrder = order;
      this.moveTo = null;
      this.moveModal = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/pallets/list', { headers: this.headers() }).then(function (response) {
        _this11.pickerPallets = response.data;
      }).catch(function (error) {
        return _this11.showError(error);
      });
    },
    moveSubmit: function moveSubmit() {
      var _this12 = this;

      var target = this.pickerPallets.find(function (p) {
        return p.pallet_id == _this12.moveTo;
      });
      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Move ' + this.moveOrder.theOrderID + ' to pallet ' + target.tracking_number,
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (!confirmed) {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pallets/' + target.pallet_id + '/orders', { order_ids: [_this12.moveOrder.order_id], move: true }, { headers: _this12.headers() }).then(function () {
          _this12.moveModal = false;
          _this12.loadPallet();
          _this12.getData();
        }).catch(function (error) {
          return _this12.showError(error);
        });
      });
    },
    addItem: function addItem() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/pallets/' + this.pallet.pallet_id + '/items', this.itemForm, { headers: this.headers() }).then(function () {
        _this13.itemForm = { name: '', customer_name: '', item_price: '', shipzone_fee: '', int_shipping: '', local_tax: '', handling_fee: '', note: '' };
        _this13.itemFormOpen = false;
        _this13.loadPallet();
        _this13.getData();
      }).catch(function (error) {
        return _this13.showError(error);
      });
    },
    deleteItem: function deleteItem(item) {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete ' + item.name,
        icon: 'warning',
        buttons: true
      }).then(function (confirmed) {
        if (confirmed) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/pallet_items/' + item.pallet_item_id, { headers: _this14.headers() }).then(function () {
            _this14.loadPallet();
            _this14.getData();
          }).catch(function (error) {
            return _this14.showError(error);
          });
        }
      });
    },
    showError: function showError(error) {
      var message = error.response && error.response.data.message || 'Something went wrong';
      if (typeof message !== 'string') {
        // validation errors come as { field: [messages] }
        message = Object.values(message).map(function (m) {
          return [].concat(m).join(' ');
        }).join(' ');
      }
      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', message, 'error');
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    add: __WEBPACK_IMPORTED_MODULE_3__add__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getBanksList();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name',
    // },
    {
      label: 'From Bank',
      text: 'From Bank',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'from_bank'
    }, {
      label: 'To Bank',
      text: 'To Bank',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'to_bank'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Expense Amount',
      text: 'Expense Amount',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'expense_amount'
    }, {
      label: 'Status',
      text: 'Status',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'status'
    }, {
      label: 'Note',
      text: 'Note',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Staff',
      text: 'Staff',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Date',
      text: 'Date',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/money_transfers',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addMoneyTransferModal: false,
      theMoneyTransferID: '',
      prevSearchQuery: '',
      money_transferTypesList: [],
      suppliersList: [],
      banksList: [],
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'money_transfer_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getBanksList: function getBanksList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.banksList = [];
        res.data.data.forEach(function (e) {
          _this.banksList.push({ text: e.bank_name, value: e.bank_id });
        });
      });
    },
    openAddMoneyTransferModal: function openAddMoneyTransferModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addMoneyTransferModal = true;
    },
    openEditMoneyTransferModal: function openEditMoneyTransferModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addMoneyTransferModal = true;
    },
    approveMoneyTransfer: function approveMoneyTransfer(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/money_transfers/approve/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this2.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1000,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    deleteMoneyTransfer: function deleteMoneyTransfer(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/money_transfers/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addMoneyTransferModal', 'formData', 'isUpdate', 'banksList'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/money_transfers', _this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.errorAlert = false;
            _this.isDone = true;
            setTimeout(function () {
              _this.isDone = false;
              _this.$emit('resetTable');
              _this.closeDialog();
            }, 1000);
          }).catch(function () {
            _this.isDone = false;
            _this.errorAlert = true;
            setTimeout(function () {
              _this.errorAlert = false;
            }, 1500);
          });
        }
      });
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEdit__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEdit: __WEBPACK_IMPORTED_MODULE_3__addEdit__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getBanksList();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'Bank',
      text: 'Bank',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '2',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Amount',
      text: 'Amount',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Staff',
      text: 'Staff',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/put_money',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditModal: false,
      theMoneyID: '',
      prevSearchQuery: '',
      put_moneyTypesList: [],
      suppliersList: [],
      banksList: [],
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'put_money_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'created_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getBanksList: function getBanksList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.banksList = [];
        res.data.data.forEach(function (e) {
          _this.banksList.push({ text: e.bank_name, value: e.bank_id });
        });
      });
    },
    openAddMoneyModal: function openAddMoneyModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditModal = true;
    },
    openEditMoneyModal: function openEditMoneyModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addEditModal = true;
    },
    deleteMoney: function deleteMoney(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/put_money/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this2.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function () {});
        }
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'created_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'created_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'created_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'created_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditModal', 'formData', 'isUpdate', 'banksList'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/put_money/' + _this.formData.put_money_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/put_money', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditRole__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assignPermission_vue__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditRole: __WEBPACK_IMPORTED_MODULE_3__addEditRole__["a" /* default */],
    assignPermission: __WEBPACK_IMPORTED_MODULE_4__assignPermission_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'Name',
      text: 'Name',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'status'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/role',
      assignPermissionModal: false,
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditRoleModal: false,
      theRoleID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'role_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'role_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddRoleModal: function openAddRoleModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditRoleModal = true;
    },
    openEditRoleModal: function openEditRoleModal(data) {
      this.formData = data;
      this.isUpdate = true;
      this.addEditRoleModal = true;
    },
    assignPermission: function assignPermission(id) {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/api/role/' + id + '/permissions', { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this.formData = res.data;
        _this.assignPermissionModal = true;
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'role_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'role_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'role_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'role_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditRoleModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/role/' + _this.formData.role_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/role', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.errorAlert = false;
              _this.isDone = true;
              setTimeout(function () {
                _this.isDone = false;
                _this.$emit('resetTable');
                _this.closeDialog();
              }, 2000);
            }).catch(function () {
              _this.isDone = false;
              _this.errorAlert = true;
              setTimeout(function () {
                _this.errorAlert = false;
              }, 1500);
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['assignPermissionModal', 'formData'],

  data: function data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
      checkAll: false
    };
  },


  methods: {
    handleCheckAll: function handleCheckAll(checkAll) {
      if (checkAll) {
        for (var permission in this.formData.permissions) {
          this.formData.permissions[permission].forEach(function (p) {
            p.checked = true;
          });
        }
      } else {
        for (var _permission in this.formData.permissions) {
          this.formData.permissions[_permission].forEach(function (p) {
            p.checked = false;
          });
        }
      }
    },
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/role/' + _this.formData.role.role_id + '/assign-permission', _this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Saved',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
            // this.errorAlert = false
            // this.isDone = true
            // setTimeout(() => {
            // this.isDone = false
            _this.$emit('resetTable');
            _this.closeDialog();
            // }, 2000)
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('' + error.response.data.message, '', 'error');
            // this.isDone = false
            // this.errorAlert = true
            // setTimeout(() => {
            //   this.errorAlert = false
            // }, 1500)
          }).finally(function () {
            _this.loading = false;
          });
        }
      });
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import ViewOrderInvoice from './viewOrderInvoice.vue'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */]
    // ViewOrderInvoice
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Order ID',
      text: 'Order ID',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Invoice Number',
      text: 'Invoice Number',
      value: '2',
      sortable: true,
      searchable: false,
      name: 'last_order_invoice'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer',
      text: 'Customer',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Phone',
      text: 'Phone',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Bank Name',
      text: 'Bank Name',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'User',
      text: 'User',
      value: '10',
      sortable: false,
      searchable: false,
      name: 'user'
    }, {
      label: 'Created At',
      text: 'Created At',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/partial-refund',
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'partial_refund_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'partial_refunds.updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;

      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/partial-refund/export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&per_page=' + perPage);
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewRecord: function viewRecord(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order_invoice/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewOrderInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'partial_refunds.updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'partial_refunds.updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'partial_refunds.updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'partial_refunds.updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'mobile-datatable': __WEBPACK_IMPORTED_MODULE_5__mobileDatatable__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '1',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name'
    // },
    {
      label: 'Order ID',
      text: 'Order ID',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Amount',
      text: 'Amount',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'amount'
    }, {
      label: 'Note',
      text: 'Note',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Created At',
      text: 'Created At',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/customer/partial-refund',
      alertValue: false,
      btnsave: true,
      viewOrderInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'partial_refund_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewRecord: function viewRecord(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order_invoice/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewOrderInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ViewCustomerDeliveryInvoice_vue__ = __webpack_require__(240);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    ViewCustomerDeliveryInvoice: __WEBPACK_IMPORTED_MODULE_5__ViewCustomerDeliveryInvoice_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '1',
      sortable: true,
      searchable: true,
      name: 'invoice_number'
    },
    // {
    //   label: 'Branch',
    //   text: 'Branch',
    //   value: '2',
    //   sortable: true,
    //   searchable: false,
    //   name: 'branch_name',
    // },
    {
      label: 'Customer',
      text: 'Customer',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'customer_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Phone',
      text: 'Phone',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Phone2',
      text: 'Phone2',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'phone_number_2'
    }, {
      label: 'Total',
      text: 'Total',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'customer_credit'
    }, {
      label: 'Pay On Delivery IQD',
      text: 'Pay On Delivery IQD',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'pay_on_delivery_iqd'
    }, {
      label: 'Orders',
      text: 'Orders',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'orders'
    }, {
      label: 'Staff',
      text: 'Staff',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'staff_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Created At',
      text: 'Created At',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/delivery_invoice',
      alertValue: false,
      viewDeliveryInvoiceModal: false,
      invoiceData: {
        customer: {},
        orders: []
      },
      companyData: {},
      filterMade: false,
      totalResult: 0,
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'delivery_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'delivery_invoice_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    getCompanyData: function getCompanyData(token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    viewRecord: function viewRecord(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      this.getCompanyData(token);

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/delivery_invoice/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.viewDeliveryInvoiceModal = true;
        _this2.invoiceData = res.data;
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'delivery_invoice_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'delivery_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'delivery_invoice_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'delivery_invoice_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    'view-order-details': __WEBPACK_IMPORTED_MODULE_3__viewOrderDetails_vue__["a" /* default */]
  },
  created: function created() {
    this.getLoggedInUser();
  },
  mounted: function mounted() {
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' },
    // {
    //   label: 'Branches',
    //   text: 'Branches',
    //   value: '2',
    //   sortable: false,
    //   searchable: false,
    //   name: 'branches',
    // },
    {
      label: 'Qr ID',
      text: 'Qr ID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_id'
    }, {
      label: 'Invoice No.',
      text: 'Invoice No.',
      value: '3',
      sortable: false,
      searchable: false,
      name: 'last_order_invoice'
    }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'theOrderID'
    }, {
      label: 'Customer ID',
      text: 'Customer ID',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_id_fk'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Product URL',
      text: 'Product URL',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'product_url'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Order Status',
      text: 'Order Status',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'order_status'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Type',
      text: 'Type',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'transportation_type_obj'
    }, {
      label: 'Purchase Note',
      text: 'Purchase Note',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'purchase_note'
    }, {
      label: 'Order Note',
      text: 'Order Note',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Purchase Date',
      text: 'Purchase Date',
      value: '17',
      sortable: true,
      searchable: false,
      name: 'purchase_date'
    }, {
      label: 'Warehouse Date',
      text: 'Warehouse Date',
      value: '18',
      sortable: true,
      searchable: false,
      name: 'warehouse_date'
    }, {
      label: 'Bank Name',
      text: 'Bank Name',
      value: '19',
      sortable: true,
      searchable: true,
      name: 'bank_name'
    }, {
      label: 'Item Price',
      text: 'Item Price',
      value: '20',
      sortable: true,
      searchable: true,
      name: 'item_price'
    }, {
      label: 'Actual Cost',
      text: 'Actual Cost',
      value: '21',
      sortable: true,
      searchable: true,
      name: 'actual_price'
    }, {
      label: 'Purchase Cost',
      text: 'Purchase Cost',
      value: '22',
      sortable: false,
      searchable: false,
      name: ''
    }, {
      label: 'Total Amount',
      text: 'Total Amount',
      value: '23',
      sortable: true,
      searchable: true,
      name: 'total_amount'
    }, {
      label: 'Shipment',
      text: 'Shipment',
      value: '24',
      sortable: true,
      searchable: true,
      name: 'internal_shipping_handling'
    }, {
      label: 'Tax',
      text: 'Tax',
      value: '25',
      sortable: true,
      searchable: true,
      name: 'tax'
    }, {
      label: 'Shipzone Fee',
      text: 'Shipzone Fee',
      value: '26',
      sortable: true,
      searchable: true,
      name: 'kreenex_fee'
    }, {
      label: 'Quantity charge',
      text: 'Quantity charge',
      value: '27',
      sortable: true,
      searchable: true,
      name: 'quantity_charge'
    }, {
      label: 'International Tax',
      text: 'International Tax',
      value: '28',
      sortable: true,
      searchable: true,
      name: 'national_tax'
    }, {
      label: 'Insurance',
      text: 'Insurance',
      value: '29',
      sortable: true,
      searchable: true,
      name: 'insurance'
    }, {
      label: 'Delivery Price',
      text: 'Delivery Price',
      value: '30',
      sortable: true,
      searchable: true,
      name: 'delivery_price'
    }, {
      label: 'Discount',
      text: 'Discount',
      value: '31',
      sortable: true,
      searchable: true,
      name: 'discount'
    }, {
      label: 'Purchased By',
      text: 'Purchased By',
      value: '32',
      sortable: true,
      searchable: true,
      name: 'purchases_by_user'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/purchase_history',
      orderDetailUrl: 'api/show_order_detail',
      qrCodeValues: [],
      loggedInUserData: {},
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      totalResult: 0,
      queryParameter: true,
      btnsave: true,
      orderData: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        bank_name: '',
        discount: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        refund_reason: '',
        country: '',
        order_date: '',
        track_number: '',
        item_type: '',
        note: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      theOrderTotalAmount: '',
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        wh_dt_passed: 0,
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/purchase-history-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage);
    },
    branchEdit: function branchEdit(branches) {
      this.tableData.branches_id = branches.toString();
      this.getResults();
    },
    getRowStyle: function getRowStyle(data) {
      var today = new Date();
      var warehouseDate = new Date(data.warehouse_date);
      var next8Days = new Date(warehouseDate.getTime());
      next8Days.setDate(next8Days.getDate() + 8);

      if (next8Days < today) return 'background-color: #FFAB91';

      return '';
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.wh_dt_passed = '0';
      this.getResults();
    },
    getLoggedInUser: function getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.tableData.wh_dt_passed = '0';
      this.getResults();
    },
    generateQrCode: function generateQrCode() {
      this.closeGenerateQrCodeModal();
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this2.detailResults = data.data;
        _this2.detialData = _this2.detailResults[0];
      });
      this.modal(modal);
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() != '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditCity__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditCity: __WEBPACK_IMPORTED_MODULE_3__addEditCity__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getGovernorates();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'city_id' }, {
      label: 'Governorate',
      text: 'Governorate',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'governorate_name'
    }, {
      label: 'Name',
      text: 'Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'city_name'
    }, {
      label: 'Name (Arabic)',
      text: 'Name (Arabic)',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'city_name_ar'
    }, {
      label: 'Name (Kurdish)',
      text: 'Name (Kurdish)',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'city_name_ku'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/city',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditCityModal: false,
      theCityID: '',
      prevSearchQuery: '',
      apiResults: [],
      governorates: [],
      formData: {},
      columns: columns,
      sortKey: 'city_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddCityModal: function openAddCityModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditCityModal = true;
    },
    openEditCityModal: function openEditCityModal(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditCityModal = true;
    },
    deleteCity: function deleteCity(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/city/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getGovernorates: function getGovernorates() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/governorate/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.governoratesResult = response.data;
        _this2.governoratesResult.forEach(function (c) {
          _this2.governorates.push({
            text: c.governorate_name,
            value: c.governorate_id
          });
        });
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'governorate_id';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'governorate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'governorate_id';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'governorate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditCityModal', 'formData', 'governorates', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/city/' + _this.formData.city_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/city', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditGovernorate_vue__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditGovernorate: __WEBPACK_IMPORTED_MODULE_3__addEditGovernorate_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'city_id' }, {
      label: 'Name',
      text: 'Name',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'governorate_name'
    }, {
      label: 'Name (Arabic)',
      text: 'Name (Arabic)',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'governorate_name_ar'
    }, {
      label: 'Name (Kurdish)',
      text: 'Name (Kurdish)',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'governorate_name_ku'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/governorate',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditGovernorateModal: false,
      theGovernorateID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'governorate_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'governorate_id',
        sortDir: 'asc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddGovernorateModal: function openAddGovernorateModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditGovernorateModal = true;
    },
    openEditGovernorateModal: function openEditGovernorateModal(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditGovernorateModal = true;
    },
    deleteGovernorate: function deleteGovernorate(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/governorate/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'governorate_id';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'governorate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'governorate_id';
      this.tableData.sortDir = 'asc';
      this.tableData.column = 'governorate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditGovernorateModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/governorate/' + _this.formData.governorate_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/governorate', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditReason_vue__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditReason: __WEBPACK_IMPORTED_MODULE_3__addEditReason_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'reason_id' }, {
      label: 'Cancel Reason English',
      text: 'Cancel Reason English',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'cancel_reason'
    }, {
      label: 'Cancel Reason Arabic',
      text: 'Cancel Reason Arabic',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'cancel_reason_ar'
    }, {
      label: 'Cancel Reason Kurdish',
      text: 'Cancel Reason Kurdish',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'cancel_reason_ku'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/reason',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditReasonModal: false,
      thereasonID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'reason_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddReasonModal: function openAddReasonModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditReasonModal = true;
    },
    openEditReasonModal: function openEditReasonModal(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditReasonModal = true;
    },
    deleteReason: function deleteReason(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/reason/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'reason_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'reason_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'reason_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'reason_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditReasonModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/reason/' + _this.formData.reason_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/reason', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditAbout_vue__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditAbout: __WEBPACK_IMPORTED_MODULE_3__addEditAbout_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'about_id' }, {
      label: 'Title',
      text: 'Title',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'title'
    }, {
      label: 'URL',
      text: 'URL',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'url'
    }, {
      label: 'Order',
      text: 'Order',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'order'
    }, {
      label: 'Active',
      text: 'Active',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'is_active'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/about',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditAboutModal: false,
      theaboutID: '',
      prevSearchQuery: '',
      apiResults: [],
      formData: {
        order: 1
      },
      columns: columns,
      sortKey: 'about_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    updateActive: function updateActive(data) {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/about/' + data.about_id, data, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Updated successfully',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this.$emit('resetTable');
        _this.closeDialog();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    openAddAboutModal: function openAddAboutModal() {
      this.formData = {
        order: 1
      };
      this.isUpdate = false;
      this.addEditAboutModal = true;
    },
    openEditAboutModal: function openEditAboutModal(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditAboutModal = true;
    },
    deleteAbout: function deleteAbout(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/about/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this2.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'about_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'about_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'about_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'about_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditAboutModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/about/' + _this.formData.about_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/about', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditNotFoundOrder__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__convertToOrder_vue__ = __webpack_require__(1085);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditNotFoundOrder: __WEBPACK_IMPORTED_MODULE_3__addEditNotFoundOrder__["a" /* default */],
    convertToOrder: __WEBPACK_IMPORTED_MODULE_6__convertToOrder_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
    this.getWarehouses();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'not_found_order_id' }, { label: 'Status', text: 'Status', value: '2', sortable: true, searchable: true, name: 'status_name' }, { label: 'Product Name', text: 'Product Name', value: '3', sortable: true, searchable: true, name: 'product_name' }, { label: 'Weight', text: 'Weight', value: '4', sortable: true, searchable: true, name: 'item_weight' }, { label: 'Track Number', text: 'Track Number', value: '5', sortable: true, searchable: true, name: 'track_number' }, { label: 'Order Number', text: 'Order Number', value: '5', sortable: true, searchable: true, name: 'order_number' }, { label: 'Staff', text: 'Staff', value: '6', sortable: true, searchable: true, name: 'full_name' }, { label: 'Create Date', text: 'Create Date', value: '7', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/not-found-order',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditNotFoundOrderModal: false,
      convertToOrderModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      customers: [],
      warehouses: [],
      columns: columns,
      statusList: [{ text: 'New', value: 1 }, { text: 'Trash', value: 2 }, { text: 'Allow to send', value: 3 }, { text: 'Sent', value: 4 }, { text: 'Converted to order', value: 5 }],
      sortKey: 'not_found_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'not_found_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getCustomer: function getCustomer() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (c) {
          _this.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddNotFoundOrderModal: function openAddNotFoundOrderModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditNotFoundOrderModal = true;
    },
    edit: function edit(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditNotFoundOrderModal = true;
    },
    trash: function trash(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/not-found-order/' + id + '/trash', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    allowToSend: function allowToSend(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/not-found-order/' + id + '/allow-to-send', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this4.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    send: function send(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('api/not-found-order/' + id + '/send', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this5.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    convertToOrder: function convertToOrder(data) {
      this.formData = _extends({}, data);
      this.convertToOrderModal = true;
    },
    getResults: function getResults() {
      var _this6 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this6.filterMade = true;
          _this6.apiResults = data.data;
        } else {
          _this6.filterMade = false;
          _this6.apiResults = data.data.data;
        }

        if (_this6.apiResults.length === 0) {
          _this6.tableData.searchOneCol = '';
          _this6.tableData.searchOneVal = '';
          _this6.tableData.search = '';
          _this6.alertValue = true;
        } else {
          _this6.alertValue = false;
        }
        if (data.data.length > 0) {
          _this6.removeConfigPagination();
        } else {
          _this6.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this6.totalResult = 0;
        for (var i = 0; i < _this6.apiResults.length; i++) {
          _this6.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'not_found_order_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'not_found_order_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'not_found_order_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'not_found_order_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditNotFoundOrderModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/not-found-order/' + _this.formData.not_found_order_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/not-found-order', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['convertToOrderModal', 'formData', 'customers', 'warehouses'],

  data: function data() {
    return {
      loading: false,
      orderStatusList: [{ text: 'Shipment', value: 8 }, { text: 'Delivered to Erbil', value: 9 }]
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/not-found-order/' + _this.formData.not_found_order_id + '/convert-to-order', _this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Added',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
            _this.$emit('resetTable');
            _this.closeDialog();
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditOrderCase__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sendToStaff_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orderCaseFiles_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditOrderCase: __WEBPACK_IMPORTED_MODULE_3__addEditOrderCase__["a" /* default */],
    sendToStaff: __WEBPACK_IMPORTED_MODULE_4__sendToStaff_vue__["a" /* default */],
    orderCaseFiles: __WEBPACK_IMPORTED_MODULE_5__orderCaseFiles_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.getStaffList();
    this.getWarehouses();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Case ID', text: 'Case ID', value: '1', sortable: true, searchable: true, name: 'order_case_id' }, { label: 'Status', text: 'Status', value: '2', sortable: true, searchable: true, name: 'status_name' }, { label: 'Order ID', text: 'Order ID', value: '3', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Created By', text: 'Created By', value: '4', sortable: true, searchable: true, name: 'full_name' }, { label: 'Customer Name', text: 'Customer Name', value: '5', sortable: true, searchable: true, name: 'customer_name' }, { label: 'Customer Note', text: 'Customer Note', value: '6', sortable: true, searchable: true, name: 'customer_note' }, { label: 'Customer Phone', text: 'Customer Phone', value: '7', sortable: true, searchable: true, name: 'phone_number' }, { label: 'Product Name', text: 'Product Name', value: '8', sortable: true, searchable: true, name: 'product_name' }, { label: 'Note', text: 'Note', value: '9', sortable: true, searchable: true, name: 'note' }, { label: 'Create Date', text: 'Create Date', value: '10', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/order-case',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditOrderCaseModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      sendToStaffModal: false,
      orderCaseFileModal: false,
      staffList: [],
      warehouses: [],
      columns: columns,
      statusList: [{ text: 'Pending', value: 1 }, { text: 'Processing', value: 2 }, { text: 'Refund', value: 3 }, { text: 'Replace', value: 4 }],
      sortKey: 'order_case_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_case_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getStaffList: function getStaffList() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/get-staff-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (c) {
          _this.staffList.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    showCaseFiles: function showCaseFiles(data) {
      this.formData = _extends({}, data);
      this.orderCaseFileModal = true;
    },
    edit: function edit(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditOrderCaseModal = true;
    },


    // deleteRow(id) {
    //   swal({
    //     title: 'Are you sure?',
    //     icon: 'warning',
    //     buttons: true
    //   }).then(willDelete => {
    //     if (willDelete) {
    //       let token = localStorage.getItem('access_token')
    //       axios
    //         .delete(`api/order-case/${id}`, { headers: { Authorization: 'Bearer ' + token } })
    //         .then(() => {
    //           this.getResults()
    //           swal({
    //             title: 'Done',
    //             text: '',
    //             icon: 'success',
    //             timer: 1500,
    //             buttons: false
    //           })
    //         })
    //     }
    //   })
    // },

    sendToStaff: function sendToStaff(data) {
      this.formData = {
        order_case_id_fk: data.order_case_id,
        user_id_fk: null,
        theOrderID: data.theOrderID,
        full_name: data.full_name,
        deadline: null
      };
      this.sendToStaffModal = true;
    },
    process: function process(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('api/order-case/' + id + '/process', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    refund: function refund(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('api/order-case/' + id + '/refund', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this4.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    replace: function replace(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put('api/order-case/' + id + '/replace', {}, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this5.getResults();
            __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    getResults: function getResults() {
      var _this6 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this6.filterMade = true;
          _this6.apiResults = data.data;
        } else {
          _this6.filterMade = false;
          _this6.apiResults = data.data.data;
        }

        if (_this6.apiResults.length === 0) {
          _this6.tableData.searchOneCol = '';
          _this6.tableData.searchOneVal = '';
          _this6.tableData.search = '';
          _this6.alertValue = true;
        } else {
          _this6.alertValue = false;
        }
        if (data.data.length > 0) {
          _this6.removeConfigPagination();
        } else {
          _this6.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this6.totalResult = 0;
        for (var i = 0; i < _this6.apiResults.length; i++) {
          _this6.totalResult += 1;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()('' + error.response.data.message, '', 'error');
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_7_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToStaff_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_820cacf8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToStaff_vue__ = __webpack_require__(1095);
function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToStaff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_820cacf8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToStaff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sendToStaffModal', 'formData', 'staffList'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/order-case-user', _this.formData, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Sent',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
            _this.$emit('resetTable');
            _this.closeDialog();
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCaseFiles_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66613b7f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCaseFiles_vue__ = __webpack_require__(1098);
function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCaseFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66613b7f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCaseFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    orderCaseFileModal: { type: Boolean, default: false },
    formData: { type: Object, default: function _default() {} },
    isUpdate: { type: Boolean, default: false },
    fromCustomer: { type: Boolean, default: false }
  },

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      var url = 'api/order-case';
      if (this.fromCustomer) {
        url = 'api/order-case/customer-store';
      }

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url + '/' + _this.formData.order_case_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sendToStaff_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__orderCaseFiles_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    sendToStaff: __WEBPACK_IMPORTED_MODULE_3__sendToStaff_vue__["a" /* default */],
    orderCaseFiles: __WEBPACK_IMPORTED_MODULE_4__orderCaseFiles_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.getStaffList();
    this.getWarehouses();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Case ID', text: 'Case ID', value: '1', sortable: true, searchable: true, name: 'order_case_id_fk' }, { label: 'Order ID', text: 'Order ID', value: '2', sortable: true, searchable: true, name: 'theOrderID' }, { label: 'Created By', text: 'Created By', value: '3', sortable: true, searchable: true, name: 'full_name' }, { label: 'Customer Name', text: 'Customer Name', value: '4', sortable: true, searchable: true, name: 'customer_name' }, { label: 'Customer Note', text: 'Customer Note', value: '5', sortable: true, searchable: true, name: 'customer_name' }, { label: 'Customer Phone', text: 'Customer Phone', value: '6', sortable: true, searchable: true, name: 'phone_number' }, { label: 'Product Name', text: 'Product Name', value: '7', sortable: true, searchable: true, name: 'product_name' }, { label: 'Sent By', text: 'Sent By', value: '8', sortable: true, searchable: true, name: 'sent_by' }, { label: 'Deadline', text: 'Deadline', value: '9', sortable: true, searchable: true, name: 'deadline' }, { label: 'Create Date', text: 'Create Date', value: '10', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/order-case-user',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditOrderCaseModal: false,
      orderCaseFileModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      sendToStaffModal: false,
      staffList: [],
      warehouses: [],
      columns: columns,
      statusList: [{ text: 'Pending', value: 1 }, { text: 'Processing', value: 2 }, { text: 'Refund', value: 3 }, { text: 'Replace', value: 4 }],
      sortKey: 'order_case_user_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_case_user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    getStaffList: function getStaffList() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/get-staff-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (c) {
          _this.staffList.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getWarehouses: function getWarehouses() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.data.forEach(function (r) {
          _this2.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    showCaseFiles: function showCaseFiles(data) {
      this.formData = _extends({}, data, {
        order_case_id: data.order_case_id_fk
      });
      this.orderCaseFileModal = true;
    },
    sendToStaff: function sendToStaff(data) {
      this.formData = {
        order_case_id: data.order_case_id_fk,
        order_case_id_fk: data.order_case_id_fk,
        order_case_user_id: data.order_case_user_id,
        user_id_fk: null,
        theOrderID: data.theOrderID,
        full_name: data.full_name,
        deadline: null
      };
      this.sendToStaffModal = true;
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('' + error.response.data.message, '', 'error');
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_case_user_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_case_user_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeTab: 0,
      e1: true,
      showOtpInput: false,
      loginForm: {
        phone_number: '+9647708948086',
        password: null
      },
      signupForm: {
        phone_number: '+9647708948086',
        otp_code: null
      }
    };
  },


  methods: {
    login: function login() {
      var _this = this;

      // let token = localStorage.getItem('access_token')
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/mobile/login', this.loginForm).then(function (res) {
        _this.$emit('logged-in', res.data.access_token);
        _this.showOtpInput = true;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    signup: function signup() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/verify-phone-number', this.signupForm).then(function () {
        _this2.showOtpInput = true;
      });
    },
    verifyOtpCode: function verifyOtpCode() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/verify-otp-code', this.signupForm).then(function () {
        _this3.showOtpInput = false;
        _this3.activeTab = 0;
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Done', '', 'success');
      });
    }
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEditHomeSlider_vue__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEditHomeSlider: __WEBPACK_IMPORTED_MODULE_1__addEditHomeSlider_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: [],
      addEditHomeSliderModal: false,
      isUpdate: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        order: 1,
        imageUrl: null,
        image: null,
        url: null
      };
      this.addEditHomeSliderModal = true;
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data, {
        imageUrl: this.$_image_path() + data.image,
        image_updated: false
      });
      this.isUpdate = true;
      this.addEditHomeSliderModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/home-slider/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/home-slider', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditHomeSliderModal', 'form', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    chooseImage: function chooseImage() {
      this.$refs.sliderImageRef.click();
    },
    imageSelected: function imageSelected() {
      var imageFile = this.$refs.sliderImageRef.files[0];
      if (imageFile.type.includes('image/')) {
        this.form.image = imageFile;
        // this.showImageUploader = false
        this.form.imageUrl = URL.createObjectURL(imageFile);
        this.$nextTick(function () {
          // this.showImageUploader = true
        });
        this.form.image_updated = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'File type must be an image',
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        });
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          var formData = new FormData();
          formData.append('image', _this.form.image);
          formData.append('order', _this.form.order);
          formData.append('is_active', _this.form.is_active);
          formData.append('image_updated', _this.form.image_updated);
          if (_this.form.title) {
            formData.append('title', _this.form.title);
          }
          if (_this.form.url) {
            formData.append('url', _this.form.url);
          }

          if (_this.isUpdate) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/home-slider/' + _this.form.home_slider_id, formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/home-slider', formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      url: 'api/home-banner',
      form: {
        home_banners_id: null,
        title: '',
        title_ar: '',
        title_ku: '',
        description: '',
        description_ar: '',
        description_ku: '',
        start_date: null,
        end_date: null,
        is_active: true,
        color: '#000000',
        bgcolor: '#000000',
        color_dark: '#000000',
        bgcolor_dark: '#000000'
      },
      descriptionError: '',
      descriptionArError: '',
      descriptionKuError: '',
      titleRules: [function (v) {
        return !!v || 'Title is required';
      }],
      titleArRules: [function (v) {
        return !!v || 'Title Arabic is required';
      }],
      titleKuRules: [function (v) {
        return !!v || 'Title Kurdish is required';
      }],
      startDateRules: [function (v) {
        return !!v || 'Start date is required';
      }],
      endDateRules: [function (v) {
        return !!v || 'End date is required';
      }, function (v) {
        return !_this.form.start_date || new Date(v) > new Date(_this.form.start_date) || 'End date must be after start date';
      }],
      colorRules: [function (v) {
        return (/^#[0-9A-F]{6}$/i.test(v) || 'Color must be a valid hex color code'
        );
      }]
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    getData: function getData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        var data = res.data.data;
        if (data) {
          // Format dates for datetime-local inputs
          if (data.start_date) {
            data.start_date = _this2.formatDateForInput(data.start_date);
          }
          if (data.end_date) {
            data.end_date = _this2.formatDateForInput(data.end_date);
          }
          _this2.form = data;
        }
      });
    },
    save: function save() {
      // Reset errors
      this.descriptionError = '';
      this.descriptionArError = '';
      this.descriptionKuError = '';

      var isValid = this.$refs.form.validate();

      if (!this.form.description.trim()) {
        this.descriptionError = 'Description is required';
        isValid = false;
      }
      if (!this.form.description_ar.trim()) {
        this.descriptionArError = 'Description Arabic is required';
        isValid = false;
      }
      if (!this.form.description_ku.trim()) {
        this.descriptionKuError = 'Description Kurdish is required';
        isValid = false;
      }

      if (!isValid) {
        return;
      }
      this.update();
    },
    update: function update() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url, this.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.getData();
        swal({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 500,
          buttons: false
        });
      }).catch(function (err) {
        console.error('Error response:', err.response);
      });
    },
    formatDateForInput: function formatDateForInput(dateString) {
      if (!dateString) return null;
      // Convert ISO string to datetime-local format (YYYY-MM-DDTHH:MM)
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
    }
  }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEditPopularWebsite_vue__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEditPopularWebsite: __WEBPACK_IMPORTED_MODULE_1__addEditPopularWebsite_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: [],
      warehouses: [],
      addEditPopularWebsiteModal: false,
      isUpdate: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getWarehouses();
  },


  methods: {
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        order: 1,
        logoUrl: null,
        logo: null,
        url: null
      };
      this.addEditPopularWebsiteModal = true;
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data, {
        logoUrl: this.$_image_path() + data.logo,
        logo_updated: false
      });
      this.isUpdate = true;
      this.addEditPopularWebsiteModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/popular-website/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this2.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/popular-website', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditPopularWebsiteModal', 'form', 'isUpdate', 'warehouses'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    chooseImage: function chooseImage() {
      this.$refs.websiteLogoRef.click();
    },
    imageSelected: function imageSelected() {
      var imageFile = this.$refs.websiteLogoRef.files[0];
      if (imageFile.type.includes('image/')) {
        this.form.logo = imageFile;
        this.form.logoUrl = URL.createObjectURL(imageFile);
        this.form.logo_updated = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'File type must be an image',
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        });
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          var formData = new FormData();
          formData.append('logo', _this.form.logo);
          formData.append('order', _this.form.order);
          formData.append('warehouse_id_fk', _this.form.warehouse_id_fk);
          formData.append('is_active', _this.form.is_active);
          formData.append('logo_updated', _this.form.logo_updated);
          formData.append('url', _this.form.url);

          if (_this.isUpdate) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/popular-website/' + _this.form.popular_website_id, formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/popular-website', formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEditGlobalWebsiteGroup_vue__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEditGlobalWebsiteGroup: __WEBPACK_IMPORTED_MODULE_1__addEditGlobalWebsiteGroup_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: [],
      addEditGlobalWebsiteGroupModal: false,
      isUpdate: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        order: 1,
        name: null
      };
      this.addEditGlobalWebsiteGroupModal = true;
    },
    viewSites: function viewSites(data) {
      this.$router.push({ name: 'global-website-group.sites', params: { id: data.global_website_group_id } });
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data);
      this.isUpdate = true;
      this.addEditGlobalWebsiteGroupModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/global-website-group/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/global-website-group', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditGlobalWebsiteGroupModal', 'form', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/global-website-group/' + _this.form.global_website_group_id, _this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/global-website-group', _this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEditGlobalWebsite_vue__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEditGlobalWebsite: __WEBPACK_IMPORTED_MODULE_1__addEditGlobalWebsite_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: { details: [] },
      warehouses: [],
      addEditGlobalWebsiteModal: false,
      isUpdate: false,
      form: {}
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getWarehouses();
  },


  methods: {
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        global_website_group_id_fk: this.apiData.global_website_group_id,
        order: 1,
        logoUrl: null,
        logo: null,
        url: null
      };
      this.addEditGlobalWebsiteModal = true;
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data, {
        logoUrl: this.$_image_path() + data.logo,
        logo_updated: false
      });
      this.isUpdate = true;
      this.addEditGlobalWebsiteModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/global-website/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this2.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      var queryParams = {
        global_website_group_id: this.$route.params.id
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/global-website', {
        params: queryParams,
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this3.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditGlobalWebsiteModal', 'form', 'isUpdate', 'warehouses'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    chooseImage: function chooseImage() {
      this.$refs.globalWebsiteLogoRef.click();
    },
    imageSelected: function imageSelected() {
      var imageFile = this.$refs.globalWebsiteLogoRef.files[0];
      if (imageFile.type.includes('image/')) {
        this.form.logo = imageFile;
        this.form.logoUrl = URL.createObjectURL(imageFile);
        this.form.logo_updated = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'File type must be an image',
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        });
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          var formData = new FormData();
          formData.append('logo', _this.form.logo);
          formData.append('order', _this.form.order);
          formData.append('warehouse_id_fk', _this.form.warehouse_id_fk);
          formData.append('global_website_group_id_fk', _this.form.global_website_group_id_fk);
          formData.append('is_active', _this.form.is_active);
          formData.append('logo_updated', _this.form.logo_updated);
          formData.append('url', _this.form.url);

          if (_this.isUpdate) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/global-website/' + _this.form.global_website_id, formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/global-website', formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__orderDeliveryInvoice_vue__ = __webpack_require__(1147);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    orderDetailInvoice: __WEBPACK_IMPORTED_MODULE_5__orderDeliveryInvoice_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.getCompanyData();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'Invoice No.', text: 'Invoice No.', value: '1', sortable: true, searchable: true, name: 'invoice_number' }, { label: 'Customer Name', text: 'Customer Name', value: '2', sortable: true, searchable: true, name: 'customer_name' }, { label: 'Customer Note', text: 'Customer Note', value: '3', sortable: true, searchable: true, name: 'customer_note' }, { label: 'Customer Phone', text: 'Customer Phone', value: '4', sortable: true, searchable: true, name: 'customer_phone' }, { label: 'Customer Phone 2', text: 'Customer Phone 2', value: '5', sortable: true, searchable: true, name: 'customer_phone2' }, { label: 'Product Name', text: 'Product Name', value: '6', sortable: true, searchable: true, name: 'product_name' }, { label: 'Status', text: 'Status', value: '7', sortable: true, searchable: false, name: 'status_name' }, { label: 'Delivery Price', text: 'Delivery Price', value: '8', sortable: true, searchable: true, name: 'delivery_price' }, { label: 'Create Date', text: 'Create Date', value: '9', sortable: true, searchable: true, name: 'created_at' }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/order-delivery',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      viewData: {
        order: {
          customer: {}
        }
      },
      companyData: {},
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      statusList: [{ text: 'Pending', value: 1 },
      // { text: 'Cancel', value: 2 },
      { text: 'Sent', value: 3 }, { text: 'Received', value: 4 }],
      sortKey: 'order_delivery_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_delivery_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    closeModal: function closeModal(modal) {
      var theModal = $('#' + modal);
      theModal.modal('toggle');
    },
    getCompanyData: function getCompanyData() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/company_info', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.companyData = response.data.data;
      });
    },
    modal: function modal(_modal) {
      $('#' + _modal).modal({ backdrop: 'static' });
    },
    initDetail: function initDetail(modal, id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order-delivery/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.viewData = res.data;
        _this2.modal(modal);
      });
    },
    send: function send(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order-delivery/' + id + '/send', { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    receive: function receive(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/order-delivery/' + id + '/receive', { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this4.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_delivery_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_delivery_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'order_delivery_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'order_delivery_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['viewData', 'closeModal', 'companyData'],

  mounted: function mounted() {
    var theModal = document.querySelector('.modal');
    theModal.style.overflowX = 'auto';
    $('.show-in-print').hide();
  },


  methods: {
    printInvoice: function printInvoice() {
      $('#close-button').hide();
      $('#print-button').hide();
      $('.show-in-print').show();

      $('#print-area').printMe({ path: ['assets/ltr/css/print_style.css'] });

      $('#close-button').show();
      $('#print-button').show();
      $('.show-in-print').hide();
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showSearch: true,
      loading: false,
      customer: {},
      customersList: [],
      selectedCustomers: [],
      form: {
        addall: false,
        customer_ids: [],
        title: null,
        body: null
      }
    };
  },
  mounted: function mounted() {
    this.getCustomers();
  },


  methods: {
    getCustomers: function getCustomers() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.customersList = response.data.data.map(function (item) {
          item.text = item.full_name + ' - Tel: ' + item.phone_number;
          item.value = item.user_id;

          return item;
        });
      });
    },
    customerSelected: function customerSelected() {
      var _this2 = this;

      if (!this.customer) return;

      var found = this.selectedCustomers.find(function (el) {
        return el.user_id === _this2.customer.user_id;
      });
      if (found) {
        return __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: '',
          text: 'Customer already in the list',
          icon: 'error',
          timer: 2000,
          buttons: false
        });
      }

      this.selectedCustomers.push(_extends({}, this.customer));
      this.customer = null;
      this.showSearch = false;
      setTimeout(function () {
        _this2.showSearch = true;
      }, 50);
    },
    removeCustomer: function removeCustomer(index) {
      this.selectedCustomers.splice(index, 1);
    },
    clearData: function clearData() {
      this.selectedCustomers = [];
      this.customer = null;
      this.form = {
        customer_ids: [],
        title: null,
        body: null
      };
    },
    submit: function submit() {
      var _this3 = this;

      this.form.customer_ids = this.selectedCustomers.map(function (el) {
        return el.user_id;
      });

      if (this.form.addall === false && this.form.customer_ids.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: '',
          text: 'Please select customer',
          icon: 'error',
          timer: 2000,
          buttons: false
        });
      }

      if (!this.form.title || this.form.title.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: '',
          text: 'Please enter title',
          icon: 'error',
          timer: 2000,
          buttons: false
        });
      }

      if (!this.form.body || this.form.body.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: '',
          text: 'Please enter body',
          icon: 'error',
          timer: 2000,
          buttons: false
        });
      }

      this.loading = true;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/send-notification', this.form, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
        _this3.clearData();
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'Sent',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__processExportOrder_vue__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addEditExportOrder_vue__ = __webpack_require__(1169);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */],
    processExportOrder: __WEBPACK_IMPORTED_MODULE_7__processExportOrder_vue__["a" /* default */],
    addEditExportOrder: __WEBPACK_IMPORTED_MODULE_8__addEditExportOrder_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
    this.getCustomer();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Country',
      text: 'Country',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/pending',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      processDialog: false,
      instance: {
        customer: {},
        to_country: {}
      },
      customers: [],
      addEditDialog: false,
      form: {
        customer_if_fk: null,
        product_name: null,
        quantity: null,
        weight: null,
        image: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddNewExportOrderModal: function openAddNewExportOrderModal() {
      this.form = {
        customer_if_fk: null,
        product_name: null,
        quantity: null,
        weight: null,
        image: null,
        weight_unit: 'kg',
        volume_l: null,
        volume_w: null,
        volume_h: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      };
      this.addEditDialog = true;
    },
    getCustomer: function getCustomer() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        res.data.data.forEach(function (c) {
          _this.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    process: function process(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this2.instance = res.data.data;
        _this2.processDialog = true;
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    getResults: function getResults() {
      var _this3 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this3.filterMade = true;
          _this3.apiResults = data.data;
        } else {
          _this3.filterMade = false;
          _this3.apiResults = data.data.data;
        }

        if (_this3.apiResults.length === 0) {
          _this3.tableData.searchOneCol = '';
          _this3.tableData.searchOneVal = '';
          _this3.tableData.search = '';
          _this3.alertValue = true;
        } else {
          _this3.alertValue = false;
        }
        if (data.data.length > 0) {
          _this3.removeConfigPagination();
        } else {
          _this3.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this3.totalResult = 0;
        for (var i = 0; i < _this3.apiResults.length; i++) {
          _this3.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data);
      this.addEditDialog = true;
    },
    showDetail: function showDetail(id) {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this4.detailDialog = true;
        _this4.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['cancelDialog', 'id'],

  data: function data() {
    return {
      form: {
        cancel_note: null
      }
    };
  },


  methods: {
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/export-order/' + this.id + '/cancel', this.form, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'Canceled',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
        _this.$emit('update-table');
        _this.$emit('close');
      });
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['detailDialog', 'instance']
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    processDialog: { type: Boolean, default: false },
    form: { type: Object, default: function _default() {} }
  },

  data: function data() {
    return {
      weightUnitList: [{ text: 'KG', value: 'kg' }, { text: 'LB', value: 'lb' }]
    };
  },


  methods: {
    calcPrice: function calcPrice() {
      var shipping = Number(this.form.shipping) || 0;
      var tax = Number(this.form.national_tax) || 0;
      var delivery = Number(this.form.delivery_price) || 0;
      var discount = Number(this.form.discount) || 0;
      this.form.price = shipping + tax + delivery - discount;
    },
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          var token = localStorage.getItem('access_token');

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/export-order/' + _this.form.export_order_id + '/process', _this.form, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
            _this.$emit('update-table');
            _this.$emit('close');
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('', error.response.data.message, 'error');
          });
        }
      });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    addEditDialog: { type: Boolean, default: false },
    form: { type: Object, default: function _default() {} },
    customers: { type: Array, default: function _default() {
        return [];
      } }
  },

  mounted: function mounted() {
    this.getCountryList();

    // if edit mode get order data
    if (this.$route.params.id) {
      this.getOrder();
    }
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    return {
      weightUnitList: [{ text: 'KG', value: 'kg' }, { text: 'LB', value: 'lb' }],
      countryList: [],
      loading: false
    };
  },


  methods: {
    getCountryList: function getCountryList() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/country/list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this.countryList = response.data.map(function (item) {
          return { text: item.country_name, value: item.country_id };
        });
      });
    },
    getOrder: function getOrder() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/customer_order_detail/' + this.$route.params.id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.form = response.data.data[0];
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this3.loading = true;
          var token = localStorage.getItem('access_token');

          var formData = new FormData();
          for (var key in _this3.form) {
            if (_this3.form[key]) {
              formData.append(key, _this3.form[key]);
            }
          }

          if (_this3.form.export_order_id) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-order/' + _this3.form.export_order_id + '/update', formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this3.loading = false;
              _this3.$validator.reset();
              _this3.$emit('close');
              _this3.$emit('update-table');
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Success', 'Updated successfully', 'success');
            }).catch(function (error) {
              _this3.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-order/store', formData, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
              _this3.loading = false;
              _this3.$validator.reset();
              _this3.$emit('close');
              _this3.$emit('update-table');
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Success', 'Added successfully', 'success');
            }).catch(function (error) {
              _this3.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Country',
      text: 'Country',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/processed',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    approve: function approve(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        text: '',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id + '/approve', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Approved',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.detailDialog = true;
        _this3.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Total Refunded',
      text: 'Total Refunded',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'total_refunded_amount'
    }, {
      label: 'Refund Status',
      text: 'Refund Status',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'is_fully_refunded'
    }, {
      label: 'Country',
      text: 'Country',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/refunded',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    approve: function approve(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        text: '',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id + '/approve', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Approved',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.detailDialog = true;
        _this3.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewExportOrderDetails_vue__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_5__viewExportOrderDetails_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Country',
      text: 'Country',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/canceled',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.detailDialog = true;
        _this2.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refundExportOrder_vue__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */],
    refundExportOrder: __WEBPACK_IMPORTED_MODULE_7__refundExportOrder_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Country',
      text: 'Country',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/approved',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      refundDialog: false,
      selectedOrderId: 0,
      selectedRefundType: 'partial',
      selectedOrderPrice: 0,
      selectedAlreadyRefunded: 0,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    send: function send(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        text: '',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id + '/send', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Sent',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    openRefundDialog: function openRefundDialog(orderId, price, alreadyRefunded, refundType) {
      this.selectedOrderId = orderId;
      this.selectedOrderPrice = parseFloat(price) || 0;
      this.selectedAlreadyRefunded = parseFloat(alreadyRefunded) || 0;
      this.selectedRefundType = refundType;
      this.refundDialog = true;
    },
    handleRefundSuccess: function handleRefundSuccess() {
      this.refundDialog = false;
      this.getResults();
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.detailDialog = true;
        _this3.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    refundDialog: {
      type: Boolean,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    refundType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['full', 'partial'].includes(value);
      }
    },
    orderPrice: {
      type: Number,
      default: 0
    },
    alreadyRefunded: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      loading: false,
      checkAlert: false,
      refundData: {
        amount: '',
        refund_reason: '',
        refund_note: ''
      },
      errors: {
        amount: '',
        refund_reason: ''
      }
    };
  },


  computed: {
    remainingAmount: function remainingAmount() {
      return this.orderPrice - this.alreadyRefunded;
    }
  },

  watch: {
    refundDialog: function refundDialog(val) {
      if (val) {
        this.resetForm();
        if (this.refundType === 'full') {
          this.refundData.amount = this.remainingAmount.toFixed(2);
        }
      }
    }
  },

  methods: {
    resetForm: function resetForm() {
      this.refundData = {
        amount: '',
        refund_reason: '',
        refund_note: ''
      };
      this.errors = {
        amount: '',
        refund_reason: ''
      };
      this.checkAlert = false;
    },
    submitForm: function submitForm() {
      var _this = this;

      if (!this.validateForm()) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'This will refund $' + parseFloat(this.refundData.amount).toFixed(2) + ' to the customer\'s credit.',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (confirmed) {
        if (confirmed) {
          _this.processRefund();
        }
      });
    },
    validateForm: function validateForm() {
      var isValid = true;
      this.errors = {
        amount: '',
        refund_reason: ''
      };

      if (!this.refundData.amount || parseFloat(this.refundData.amount) <= 0) {
        this.errors.amount = 'Please enter a valid refund amount';
        isValid = false;
      } else if (parseFloat(this.refundData.amount) > this.remainingAmount) {
        this.errors.amount = 'Amount cannot exceed remaining amount: $' + this.remainingAmount.toFixed(2);
        isValid = false;
      } else if (this.refundType === 'partial' && parseFloat(this.refundData.amount) >= this.remainingAmount) {
        this.errors.amount = 'Partial refund must be less than remaining amount: $' + this.remainingAmount.toFixed(2);
        isValid = false;
      }

      if (this.refundType === 'full' && !this.refundData.refund_reason.trim()) {
        this.errors.refund_reason = 'Refund reason is required for full refunds';
        isValid = false;
      }

      return isValid;
    },
    processRefund: function processRefund() {
      var _this2 = this;

      this.loading = true;
      this.checkAlert = false;
      var token = localStorage.getItem('access_token');

      var payload = {
        export_order_id_fk: this.orderId,
        amount: parseFloat(this.refundData.amount),
        refund_type: this.refundType,
        refund_reason: this.refundData.refund_reason || null,
        refund_note: this.refundData.refund_note || null
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/export-order-refund', payload, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (response) {
        _this2.checkAlert = true;
        _this2.loading = false;
        setTimeout(function () {
          _this2.closeDialog();
          _this2.$emit('refund-success');
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
            title: 'Success',
            text: (_this2.refundType === 'full' ? 'Full' : 'Partial') + ' refund processed successfully',
            icon: 'success',
            timer: 2000,
            buttons: false
          });
        }, 1500);
      }).catch(function (error) {
        var message = error.response && error.response.data && error.response.data.message || 'Failed to process refund';
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', message, 'error');
        _this2.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.resetForm();
      this.$emit('close');
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refundExportOrder_vue__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */],
    refundExportOrder: __WEBPACK_IMPORTED_MODULE_7__refundExportOrder_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Country',
      text: 'Country',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/sent',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      refundDialog: false,
      selectedOrderId: 0,
      selectedRefundType: 'partial',
      selectedOrderPrice: 0,
      selectedAlreadyRefunded: 0,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    receive: function receive(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        text: '',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id + '/receive', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Received',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    openRefundDialog: function openRefundDialog(orderId, price, alreadyRefunded, refundType) {
      this.selectedOrderId = orderId;
      this.selectedOrderPrice = parseFloat(price) || 0;
      this.selectedAlreadyRefunded = parseFloat(alreadyRefunded) || 0;
      this.selectedRefundType = refundType;
      this.refundDialog = true;
    },
    handleRefundSuccess: function handleRefundSuccess() {
      this.refundDialog = false;
      this.getResults();
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.detailDialog = true;
        _this3.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__viewExportOrderDetails_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__refundExportOrder_vue__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_5__viewExportOrderDetails_vue__["a" /* default */],
    refundExportOrder: __WEBPACK_IMPORTED_MODULE_6__refundExportOrder_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Quantity',
      text: 'Quantity',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Country',
      text: 'Country',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Note',
      text: 'Note',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/received',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      refundDialog: false,
      selectedOrderId: 0,
      selectedRefundType: 'partial',
      selectedOrderPrice: 0,
      selectedAlreadyRefunded: 0,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openRefundDialog: function openRefundDialog(orderId, price, alreadyRefunded, refundType) {
      this.selectedOrderId = orderId;
      this.selectedOrderPrice = parseFloat(price) || 0;
      this.selectedAlreadyRefunded = parseFloat(alreadyRefunded) || 0;
      this.selectedRefundType = refundType;
      this.refundDialog = true;
    },
    handleRefundSuccess: function handleRefundSuccess() {
      this.refundDialog = false;
      this.getResults();
    },
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this.filterMade = true;
          _this.apiResults = data.data;
        } else {
          _this.filterMade = false;
          _this.apiResults = data.data.data;
        }

        if (_this.apiResults.length === 0) {
          _this.tableData.searchOneCol = '';
          _this.tableData.searchOneVal = '';
          _this.tableData.search = '';
          _this.alertValue = true;
        } else {
          _this.alertValue = false;
        }
        if (data.data.length > 0) {
          _this.removeConfigPagination();
        } else {
          _this.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this.totalResult = 0;
        for (var i = 0; i < _this.apiResults.length; i++) {
          _this.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.instance = res.data.data;
        _this2.detailDialog = true;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    cancelExportOrder: __WEBPACK_IMPORTED_MODULE_5__cancelExportOrder_vue__["a" /* default */],
    viewExportOrderDetails: __WEBPACK_IMPORTED_MODULE_6__viewExportOrderDetails_vue__["a" /* default */]
  },

  mounted: function mounted() {
    this.perPageFix();
  },


  $_veeValidate: {
    validator: 'new'
  },

  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, {
      label: 'OrderID',
      text: 'OrderID',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'order_number'
    }, {
      label: 'Customer Name',
      text: 'Customer Name',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'full_name'
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'phone_number'
    }, {
      label: 'Customer Note',
      text: 'Customer Note',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'customer_note'
    }, {
      label: 'Product Name',
      text: 'Product Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'product_name'
    }, {
      label: 'Qty',
      text: 'Qty',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'quantity'
    }, {
      label: 'Price',
      text: 'Price',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'price'
    }, {
      label: 'Discount',
      text: 'Discount',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'discount'
    }, {
      label: 'Weight',
      text: 'Weight',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'weight'
    }, {
      label: 'Shipping',
      text: 'Shipping',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'shipping'
    }, {
      label: 'Delivery Price',
      text: 'Delivery Price',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'delivery_price'
    }, {
      label: 'National Tax',
      text: 'National Tax',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'national_tax'
    }, {
      label: 'Country',
      text: 'Country',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'country_name'
    }, {
      label: 'Status',
      text: 'Status',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'status'
    }, {
      label: 'Note',
      text: 'Note',
      value: '15',
      sortable: true,
      searchable: true,
      name: 'note'
    }, {
      label: 'Date',
      text: 'Date',
      value: '16',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/export-order/export-history',
      selectedRows: [],
      id: 0,
      filterMade: false,
      totalResult: 0,
      alertValue: false,
      checkAlert: false,
      detailDialog: false,
      cancelDialog: false,
      instance: {
        customer: {},
        to_country: {}
      },
      prevSearchQuery: '',
      apiResults: [],
      columns: columns,
      sortKey: 'export_order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'export_order_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    sendToExport: function sendToExport() {
      var searchValue = this.tableData.search !== '' ? this.tableData.search : '0';
      var column = this.tableData.column !== '' ? this.tableData.column : '0';
      var sortDir = this.tableData.sortDir !== '' ? this.tableData.sortDir : '0';
      var searchedOneCol = this.tableData.searchOneCol !== '' ? this.tableData.searchOneCol : '0';
      var searchedOneVal = this.tableData.searchOneVal !== '' ? this.tableData.searchOneVal : '0';
      var fromDate = this.tableData.from_date !== '' ? this.tableData.from_date : '0';
      var toDate = this.tableData.to_date !== '' ? this.tableData.to_date : '0';
      var loggedInUserData = JSON.parse(localStorage.getItem('user_data'));
      var warehouses = loggedInUserData.warehouse_id_fk;
      var perPage = this.tableData.per_page == null ? 10 : this.tableData.per_page;
      if (searchValue !== '0' || searchedOneCol !== '0' || searchedOneVal !== '0' || toDate !== '0' || fromDate !== '0') {
        perPage = '0';
      }

      var hostName = window.location.hostname;
      var protocol = window.location.protocol + '//';
      var fullHostName = protocol + hostName;

      window.location.replace(fullHostName + '/api/export-history-export?searchValue=' + searchValue + '&column=' + column + '&sortDir=' + sortDir + '&searchedOneCol=' + searchedOneCol + '&searchedOneVal=' + searchedOneVal + '&from_date=' + fromDate + '&to_date=' + toDate + '&warehouses=' + warehouses + '&per_page=' + perPage);
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    receive: function receive(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
        title: 'Are you sure?',
        text: '',
        icon: 'warning',
        buttons: true
      }).then(function (approved) {
        if (approved) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/export-history', {
            headers: { Authorization: 'Bearer ' + token }
          }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
              title: 'Received',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    openCancelDialog: function openCancelDialog(id) {
      this.cancelDialog = true;
      this.id = id;
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'updated_at';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'updated_at';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    calculateTotalAmount: function calculateTotalAmount() {
      var itemPrice = Number(this.updateData.item_price) || 0;
      var shipping = Number(this.updateData.internal_shipping_handling) || 0;
      var tax = Number(this.updateData.tax) || 0;
      var nationalTax = Number(this.updateData.national_tax) || 0;
      var delivery = Number(this.updateData.delivery_price) || 0;
      var fee = Number(this.updateData.kreenex_fee) || 0;
      var insurance = Number(this.updateData.insurance) || 0;
      var qttCharge = Number(this.updateData.quantity_charge) || 0;
      var discount = Number(this.updateData.discount) || 0;
      var qtt = Number(this.theQuantity.quantity) || 0;

      var total = itemPrice * qtt + shipping + tax + nationalTax + delivery + fee + insurance + qttCharge;

      if (discount > 0) {
        total -= discount;
      }

      this.updateData.total_amount = total.toFixed(2);
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    showDetail: function showDetail(id) {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('api/export-order/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.detailDialog = true;
        _this3.instance = res.data.data;
      });
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEdit__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEdit: __WEBPACK_IMPORTED_MODULE_3__addEdit__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'currency_rate_id' }, {
      label: 'Exchange Rate',
      text: 'Exchange Rate',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'ex_rate'
    }, {
      label: 'Staff',
      text: 'Staff',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'user.full_name'
    }, {
      label: 'Create Date',
      text: 'Create Date',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'created_at'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/currency-rate',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'currency_rate_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'currency_rate_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    openAddCurrencyRateModal: function openAddCurrencyRateModal() {
      this.formData = {};
      this.isUpdate = false;
      this.addEditModal = true;
    },
    openEditModal: function openEditModal(data) {
      this.formData = _extends({}, data);
      this.isUpdate = true;
      this.addEditModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('api/currency-rate/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'currency_rate_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'currency_rate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'currency_rate_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'currency_rate_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditModal', 'formData', 'isUpdate'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/currency-rate/' + _this.formData.currency_rate_id, _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/currency-rate', _this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditWarehouse__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent_vue__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable_vue__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination_vue__["a" /* default */],
    addEditWarehouse: __WEBPACK_IMPORTED_MODULE_3__addEditWarehouse__["a" /* default */]
  },
  mounted: function mounted() {
    this.perPageFix();
    this.getTransportationTypes();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: 'ID', text: 'ID', value: '1', sortable: true, searchable: true, name: 'warehouse_id' }, {
      label: 'Logo',
      text: 'Logo',
      value: '2',
      sortable: true,
      searchable: true,
      name: 'logo'
    }, {
      label: 'Default Image',
      text: 'Default Image',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'default_image',
      visible: false
    }, {
      label: 'Country',
      text: 'Country',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'country'
    }, {
      label: 'Prefix',
      text: 'Prefix',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'prefix'
    }, {
      label: 'Name',
      text: 'Name',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'name'
    }, {
      label: 'Transportation Types',
      text: 'Transportation Types',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'transportation_types'
    }, {
      label: 'City',
      text: 'City',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'city',
      visible: false
    }, {
      label: 'Street',
      text: 'Street',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'street',
      visible: false
    }, {
      label: 'Code',
      text: 'Code',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'code',
      visible: false
    }, {
      label: 'Phone Number',
      text: 'Phone Number',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'phone_number',
      visible: false
    }, {
      label: 'House Number',
      text: 'House Number',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'house_number',
      visible: false
    }, {
      label: 'State - Province',
      text: 'State - Province',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'state_province',
      visible: false
    }, {
      label: 'Active',
      text: 'Active',
      value: '14',
      sortable: true,
      searchable: true,
      name: 'is_active'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      url: 'api/warehouses/all',
      alertValue: false,
      btnsave: true,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditWarehouseModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      columns: columns,
      sortKey: 'warehouse_id',
      sortOrders: sortOrders,
      transportationTypes: [],
      tableData: {
        per_page: 10,
        search: '',
        column: 'warehouse_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      defaultHideCol: []
    };
  },


  methods: {
    hideDefaultColumns: function hideDefaultColumns() {
      this.defaultHideCol = this.columns.filter(function (column) {
        return column.visible === false;
      }).map(function (column) {
        return column.value;
      });
    },
    showHideColumn: function showHideColumn(prevColVal, currentColVal) {
      console.log(prevColVal);
      console.log(currentColVal);
      var a = [];
      var diff = [];

      if (currentColVal.length < prevColVal.length) {
        for (var i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true;
        }

        for (var _i = 0; _i < currentColVal.length; _i++) {
          if (a[currentColVal[_i]]) {
            delete a[currentColVal[_i]];
          } else {
            a[currentColVal[_i]] = true;
          }
        }

        for (var k in a) {
          diff.push(k);
        }

        for (var c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle();
        }
      } else {
        for (var _i2 = 0; _i2 < currentColVal.length; _i2++) {
          var visible = $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').is(':visible');
          if (visible) {
            $('td:nth-child(' + currentColVal[_i2] + '),th:nth-child(' + currentColVal[_i2] + ')').toggle();
          }
        }
      }
    },
    changeActive: function changeActive(data) {
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses/' + data.warehouse_id + '/toggle-active', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Updated successfully',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    getTransportationTypes: function getTransportationTypes() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/transportation-type/list', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function (res) {
        _this.transportationTypes = res.data;
      });
    },
    openAddWarehouseModal: function openAddWarehouseModal() {
      this.addEditWarehouseModal = true;
    },
    openEditModal: function openEditModal(data) {
      this.formData = _extends({}, data, {
        transportation_type_ids: data.transportation_type_ids ? data.transportation_type_ids.split(',').map(function (id) {
          return parseInt(id);
        }) : []
      });
      this.isUpdate = true;
      this.addEditWarehouseModal = true;
    },
    getResults: function getResults() {
      var _this2 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this2.filterMade = true;
          _this2.apiResults = data.data;
        } else {
          _this2.filterMade = false;
          _this2.apiResults = data.data.data;
        }

        if (_this2.apiResults.length === 0) {
          _this2.tableData.searchOneCol = '';
          _this2.tableData.searchOneVal = '';
          _this2.tableData.search = '';
          _this2.alertValue = true;
        } else {
          _this2.alertValue = false;
        }
        if (data.data.length > 0) {
          _this2.removeConfigPagination();
        } else {
          _this2.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this2.totalResult = 0;
        for (var i = 0; i < _this2.apiResults.length; i++) {
          _this2.totalResult += 1;
        }
      }).catch(function (errors) {});

      setTimeout(function () {
        _this2.hideDefaultColumns();
      }, 500);
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'warehouse_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'warehouse_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'warehouse_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'warehouse_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    filterTable: function filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate;
      this.tableData.to_date = toDate;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditWarehouseModal', 'formData', 'isUpdate', 'transportationTypes'],

  data: function data() {
    return {
      loading: false
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    logoChange: function logoChange() {
      this.formData.logo = this.$refs.logoRef.files[0];
    },
    defaultImageChange: function defaultImageChange() {
      this.formData.default_image = this.$refs.defaultImageRef.files[0];
    },
    clearFiles: function clearFiles() {
      this.$refs.logoRef.value = '';
      this.$refs.defaultImageRef.value = '';
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          if (_this.isUpdate) {
            var fd = new FormData();

            if (_this.formData.transportation_type_ids.length) {
              _this.formData.transportation_type_ids = _this.formData.transportation_type_ids.join(',');
            }

            for (var key in _this.formData) {
              if (_this.formData[key]) {
                fd.append(key, _this.formData[key]);
              }
            }

            fd.append('_method', 'put');

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/warehouses/' + _this.formData.warehouse_id, fd, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.clearFiles();
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            var _fd = new FormData();

            if (_this.formData.transportation_type_ids.length) {
              _this.formData.transportation_type_ids = _this.formData.transportation_type_ids.join(',');
            }

            for (var _key in _this.formData) {
              if (_this.formData[_key]) {
                _fd.append(_key, _this.formData[_key]);
              }
            }

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/warehouses', _fd, {
              headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }).then(function () {
              _this.clearFiles();
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Add successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEdit_vue__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEdit: __WEBPACK_IMPORTED_MODULE_1__addEdit_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: [],
      addEditModal: false,
      isUpdate: false,
      form: {},
      queryParams: {
        operating_system: null,
        type: null,
        keyword: null
      },
      operatingSystems: [{ text: 'Android', value: 'android' }, { text: 'iOS', value: 'ios' }],
      types: [{ text: 'Soft', value: 'soft' }, { text: 'Hard', value: 'hard' }]
    };
  },
  mounted: function mounted() {
    this.getData();
  },


  methods: {
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        title: null,
        description: null,
        operating_system: null,
        build_number: null,
        type: null,
        image: null,
        imageUrl: null,
        image_updated: false
      };
      this.addEditModal = true;
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data, {
        imageUrl: this.$_image_path() + data.image,
        image_updated: false
      });
      this.isUpdate = true;
      this.addEditModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/force-update/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/force-update', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditModal', 'form', 'isUpdate'],

  data: function data() {
    return {
      loading: false,
      operatingSystems: [{ text: 'Android', value: 'android' }, { text: 'iOS', value: 'ios' }],
      types: [{ text: 'Soft', value: 'soft' }, { text: 'Hard', value: 'hard' }]
    };
  },


  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    chooseImage: function chooseImage() {
      this.$refs.imageRef.click();
    },
    imageSelected: function imageSelected() {
      var imageFile = this.$refs.imageRef.files[0];
      if (imageFile.type.includes('image/')) {
        this.form.image = imageFile;
        this.form.imageUrl = URL.createObjectURL(imageFile);
        this.form.image_updated = true;
      } else {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
          title: 'File type must be an image',
          text: '',
          icon: 'error',
          timer: 1500,
          buttons: false
        });
      }
    },
    submitForm: function submitForm() {
      var _this = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.loading = true;

          var formData = new FormData();

          if (_this.form.image) {
            formData.append('image', _this.form.image);
          }

          formData.append('build_number', _this.form.build_number);
          formData.append('title', _this.form.title);
          formData.append('description', _this.form.description);
          formData.append('operating_system', _this.form.operating_system);
          formData.append('type', _this.form.type);

          if (_this.isUpdate) {
            formData.append('_method', 'put');
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/force-update/' + _this.form.force_update_id, formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/force-update', formData, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this.$emit('resetTable');
              _this.closeDialog();
            }).catch(function (error) {
              _this.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEdit_vue__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addEdit: __WEBPACK_IMPORTED_MODULE_1__addEdit_vue__["a" /* default */] },
  data: function data() {
    return {
      apiData: [],
      warehouses: [],
      addEditModal: false,
      isUpdate: false,
      form: {},
      queryParams: {
        keyword: null
      }
    };
  },
  mounted: function mounted() {
    this.getData();
    this.getWarehouses();
  },


  methods: {
    getWarehouses: function getWarehouses() {
      var _this = this;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    addNew: function addNew() {
      this.isUpdate = false;
      this.form = {
        title: null,
        description: null
      };
      this.addEditModal = true;
    },
    editRow: function editRow(data) {
      this.form = _extends({}, data);
      this.isUpdate = true;
      this.addEditModal = true;
    },
    deleteRow: function deleteRow(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('api/our-address/' + id, { headers: { Authorization: 'Bearer ' + token } }).then(function () {
            _this2.getData();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Error', error.response.data.message, 'error');
          });
        }
      });
    },
    getData: function getData() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/our-address', { params: this.queryParams, headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.apiData = res.data;
      });
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditModal', 'form', 'isUpdate', 'warehouses'],

  data: function data() {
    return {
      loading: false,
      transportationTypes: []
    };
  },


  watch: {
    addEditModal: {
      immediate: false,
      handler: function handler() {
        var _this = this;

        if (this.isUpdate) {
          var warehouse = this.warehouses.find(function (w) {
            return w.value === _this.form.warehouse_id_fk;
          });

          if (warehouse) {
            this.transportationTypes = warehouse.transportation_types;
          }
        }
      }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$validator.reset();
      this.$emit('close');
    },
    handleSelectWarehouse: function handleSelectWarehouse(id) {
      this.form.transportation_type = null;
      var warehouse = this.warehouses.find(function (w) {
        return w.value === id;
      });

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types;
      }
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this2.loading = true;

          if (_this2.isUpdate) {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('api/our-address/' + _this2.form.our_address_id, _this2.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this2.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Updated successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this2.$emit('resetTable');
              _this2.closeDialog();
            }).catch(function (error) {
              _this2.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/our-address', _this2.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(function () {
              _this2.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
                title: 'Added successfully',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              });
              _this2.$emit('resetTable');
              _this2.closeDialog();
            }).catch(function (error) {
              _this2.loading = false;
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', error.response.data.message, 'error');
            });
          }
        }
      });
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addEditSubscription_vue__ = __webpack_require__(1240);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'add-edit-subscription': __WEBPACK_IMPORTED_MODULE_2__addEditSubscription_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.getResults();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      loading: false,
      addEditSubscriptionModal: false,
      url: 'api/subscriptions',
      apiResults: [],
      warehouses: [],
      addEditData: {
        subscription_name: ''
      }
    };
  },


  methods: {
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this.apiResults = data.data;
      });
    },
    openAddEditSubscriptionModal: function openAddEditSubscriptionModal() {
      this.addEditSubscriptionModal = true;
    },
    closeAddEditSubscriptionModal: function closeAddEditSubscriptionModal() {
      this.addEditSubscriptionModal = false;
      this.clear();
    },
    clear: function clear() {
      this.addEditData = {
        subscription_name: ''
      };
      this.addEditSubscriptionModal = false;
      this.$validator.reset();
    },
    submitAddEditSubscription: function submitAddEditSubscription() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      var isEditing = this.addEditData.subscription_id;
      var method = isEditing ? 'patch' : 'post';
      var url = isEditing ? this.url + '/' + this.addEditData.subscription_id : this.url;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.validationError = false;
        _this2.checkAlert = true;
        _this2.getResults();
        _this2.clear();
      }).catch(function (error) {
        if (error.response.data.message) {
          _this2.checkAlert = false;
          _this2.validationError = true;
        }
      });
    },
    editRecord: function editRecord(item, idx) {
      this.addEditData = {
        subscription_id: item.subscription_id,
        subscription_name: item.subscription_name
      };
      this.addEditSubscriptionModal = true;
      this.$validator.reset();
    },
    deleteRecord: function deleteRecord(item, idx) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete subscription: ' + item.subscription_name + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(_this3.url + '/' + item.subscription_id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['addEditData', 'addEditSubscriptionModal', 'closeAddEditSubscriptionModal', 'submitAddEditSubscription'],

  data: function data() {
    return {};
  },


  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.submitAddEditSubscription();
        }
      });
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditUserSubscription_vue__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'add-edit-user-subscription': __WEBPACK_IMPORTED_MODULE_3__addEditUserSubscription_vue__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?name=', '') !== null || window.location.search.replace('?name=', '') !== '') {
        var value = window.location.search.replace('?name=', '');
        this.searchOneCol('full_name', value);
      }
    }
    this.getResults();
  },
  mounted: function mounted() {
    this.getCustomer();
    this.getWarehouses();
    this.getSubscriptions();
    this.getOrderTypes();
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, { label: 'ID', text: 'ID', value: '2', sortable: true, searchable: true, name: 'user_subscription_id' }, {
      label: 'CID',
      text: 'CID',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'customer_id'
    }, {
      label: 'Customer',
      text: 'Customer',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'customer_name'
    }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'warehouses.country'
    }, {
      label: 'Subscription',
      text: 'Subscription',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'subscription_name'
    }, {
      label: 'Type',
      text: 'Type',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'order_types.type_name'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      url: 'api/customer-subscription',
      editStaffUrl: 'api/update-staff',
      getCustomerUrl: 'api/get-customer-to-select',
      addEditCustomerSubscriptionModal: false,
      rowIndex: '',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      checkAlert: false,
      validationError: false,
      backendError: false,
      queryParameter: true,
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      warehouses: [],
      customers: [],
      subscriptions: [],
      orderTypes: [],
      userSubscriptionIds: [],
      columns: columns,
      sortKey: 'user_subscription_id',
      sortOrders: sortOrders,
      addEditData: {},
      tableData: {
        per_page: 10,
        search: '',
        column: 'user_subscription_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    changeActive: function changeActive(data) {
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses/' + data.warehouse_id + '/toggle-active', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Updated successfully',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    getWarehouses: function getWarehouses() {
      var _this = this;

      this.warehouses = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getCustomer: function getCustomer() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.getCustomerUrl, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.customersResult = response.data.data;
        _this2.customersResult.forEach(function (c) {
          _this2.customers.push({
            text: c.full_name + ' - Tel: ' + c.phone_number,
            value: c.user_id
          });
        });
      });
    },
    getSubscriptions: function getSubscriptions() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/subscriptions', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.subscriptionResult = response.data.data;
        _this3.subscriptionResult.forEach(function (c) {
          _this3.subscriptions.push({
            text: c.subscription_name,
            value: c.subscription_id
          });
        });
      });
    },
    getOrderTypes: function getOrderTypes() {
      var _this4 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/order-types', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this4.orderTypesResult = response.data.data;
        _this4.orderTypesResult.forEach(function (c) {
          _this4.orderTypes.push({
            text: c.type_name,
            value: c.order_type_id
          });
        });
      });
    },
    getResults: function getResults() {
      var _this5 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this5.filterMade = true;
          _this5.apiResults = data.data;
        } else {
          _this5.filterMade = false;
          _this5.apiResults = data.data.data;
        }

        if (_this5.apiResults.length === 0) {
          _this5.tableData.searchOneCol = '';
          _this5.tableData.searchOneVal = '';
          _this5.tableData.search = '';
          _this5.alertValue = true;
        } else {
          _this5.alertValue = false;
        }
        if (data.data.length > 0) {
          _this5.removeConfigPagination();
        } else {
          _this5.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this5.totalResult = 0;
        for (var i = 0; i < _this5.apiResults.length; i++) {
          _this5.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_subscription_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_subscription_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'user_subscription_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'user_subscription_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openAddEditCustomerSubscriptionModal: function openAddEditCustomerSubscriptionModal() {
      this.addEditCustomerSubscriptionModal = true;
    },
    closeAddEditCustomerSubscriptionModal: function closeAddEditCustomerSubscriptionModal() {
      this.addEditCustomerSubscriptionModal = false;
      this.validationError = false;
      this.checkAlert = false;
      this.clear();
    },
    clear: function clear() {
      this.addEditCustomerSubscriptionModal = false;
      this.addEditData = {
        warehouse_id_fk: [],
        order_type_id_fk: []
      };
      this.$validator.reset();
      this.unCheckAll();
    },
    submitAddEditUserSubscription: function submitAddEditUserSubscription() {
      var _this6 = this;

      var token = localStorage.getItem('access_token');

      var isEditing = this.addEditData.user_subscription_id;
      var method = isEditing ? 'patch' : 'post';
      var url = isEditing ? this.url + '/' + this.addEditData.user_subscription_id : this.url;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this6.validationError = false;
        _this6.checkAlert = true;
        _this6.getResults();
        _this6.clear();
      }).catch(function (error) {
        if (error.response.data.message) {
          _this6.checkAlert = false;
          _this6.validationError = true;
          __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
        }
      });
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    editCustomerSubscription: function editCustomerSubscription(r) {
      console.log(r.user_id);
      this.addEditData = {
        user_subscription_id: r.user_subscription_id,
        customer_id_fk: r.user_id,
        warehouse_id_fk: [r.warehouse_id_fk],
        subscription_id: r.subscription_id_fk,
        order_type_id_fk: [r.order_type_id_fk],
        order_shipzone_fee: r.order_shipzone_fee,
        shiponly_handling_fee_air: r.shiponly_handling_fee_air,
        shiponly_handling_fee_sea: r.shiponly_handling_fee_sea,
        item_price_air: r.item_price_air,
        item_price_sea: r.item_price_sea,
        item_price_land: r.item_price_land
      };
      this.openAddEditCustomerSubscriptionModal();
      this.$validator.reset();
    },
    deleteCustomerSubscription: function deleteCustomerSubscription(item) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete customer subscription: ' + item.subscription_name + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(_this7.url + '/' + item.user_subscription_id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this7.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    deleteAllCustomerSubscription: function deleteAllCustomerSubscription() {
      var _this8 = this;

      if (this.userSubscriptionIds.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Please select at least one customer subscription to delete',
          icon: 'warning',
          dangerMode: true
        });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete all selected customer subscriptions?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this8.url + '/bulk-delete', { ids: _this8.userSubscriptionIds }, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this8.getResults();
            _this8.unCheckAll();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
      $('#mainCheck').prop('checked', false);
      this.userSubscriptionIds = [];
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['warehouses', 'orderTypes', 'addEditData', 'addEditCustomerSubscriptionModal', 'submitAddEditUserSubscription', 'checkAlert', 'customers', 'subscriptions', 'closeAddEditCustomerSubscriptionModal', 'validationError'],

  data: function data() {
    return {};
  },


  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.submitAddEditUserSubscription();
        }
      });
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datatable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addEditSubscriptionPricing_vue__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    preDatatableComponent: __WEBPACK_IMPORTED_MODULE_1__preDatatableComponent__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_2__Datatable__["a" /* default */],
    paginate: __WEBPACK_IMPORTED_MODULE_0__Pagination__["a" /* default */],
    'add-edit-user-subscription': __WEBPACK_IMPORTED_MODULE_3__addEditSubscriptionPricing_vue__["a" /* default */]
  },
  created: function created() {
    if (this.queryParameter === true) {
      if (window.location.search.replace('?name=', '') !== null || window.location.search.replace('?name=', '') !== '') {
        var value = window.location.search.replace('?name=', '');
        this.searchOneCol('full_name', value);
      }
    }
    this.getResults();
  },
  mounted: function mounted() {
    this.getWarehouses();
    this.getSubscriptions();
    this.getOrderTypes();
    this.perPageFix();

    if (screen.width <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    var sortOrders = {};
    var columns = [{ label: '', name: '', text: 'Check box', value: '1' }, { label: 'ID', text: 'ID', value: '2', sortable: true, searchable: true, name: 'pricing_id' }, {
      label: 'Warehouse',
      text: 'Warehouse',
      value: '3',
      sortable: true,
      searchable: true,
      name: 'warehouses.country'
    }, {
      label: 'Subscription',
      text: 'Subscription',
      value: '4',
      sortable: true,
      searchable: true,
      name: 'subscription_name'
    }, {
      label: 'Type',
      text: 'Type',
      value: '5',
      sortable: true,
      searchable: true,
      name: 'order_types.type_name'
    }, {
      label: 'Shipzone\nFee',
      text: 'Shipzone\nFee',
      value: '6',
      sortable: true,
      searchable: true,
      name: 'order_shipzone_fee'
    }, {
      label: 'Handling\nFee (Air)',
      text: 'Handling\nFee (Air)',
      value: '7',
      sortable: true,
      searchable: true,
      name: 'shiponly_handling_fee_air'
    }, {
      label: 'Handling\nFee (Sea)',
      text: 'Handling\nFee (Sea)',
      value: '8',
      sortable: true,
      searchable: true,
      name: 'shiponly_handling_fee_sea'
    }, {
      label: 'Item\nPrice (Air)',
      text: 'Item\nPrice (Air)',
      value: '9',
      sortable: true,
      searchable: true,
      name: 'item_price_air'
    }, {
      label: 'Item\nPrice (Sea)',
      text: 'Item\nPrice (Sea)',
      value: '10',
      sortable: true,
      searchable: true,
      name: 'item_price_sea'
    }, {
      label: 'Item\nPrice (Land)',
      text: 'Item\nPrice (Land)',
      value: '11',
      sortable: true,
      searchable: true,
      name: 'item_price_land'
    }, {
      label: 'Local\nDelivery',
      text: 'Local\nDelivery',
      value: '12',
      sortable: true,
      searchable: true,
      name: 'local_delivery'
    }, {
      label: 'Default',
      text: 'Default',
      value: '13',
      sortable: true,
      searchable: true,
      name: 'is_default'
    }];
    columns.forEach(function (column) {
      sortOrders[column.name] = -1;
    });

    return {
      isMobile: false,
      loading: false,
      baseUrl: 'api/subscription-pricing',
      url: 'api/subscription-pricing',
      editStaffUrl: 'api/update-staff',
      getCustomerUrl: 'api/get-customer-to-select',
      addEditSubscriptionPricingModal: false,
      rowIndex: '',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      checkAlert: false,
      validationError: false,
      backendError: false,
      queryParameter: true,
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      warehouses: [],
      customers: [],
      subscriptions: [],
      orderTypes: [],
      userSubscriptionIds: [],
      columns: columns,
      sortKey: 'pricing_id',
      sortOrders: sortOrders,
      addEditData: {},
      tableData: {
        per_page: 10,
        search: '',
        column: 'pricing_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    };
  },


  methods: {
    changeActive: function changeActive(data) {
      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses/' + data.warehouse_id + '/toggle-active', {
        headers: { Authorization: 'Bearer ' + token }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          title: 'Updated successfully',
          text: '',
          icon: 'success',
          timer: 1500,
          buttons: false
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', error.response.data.message, 'error');
      });
    },
    getWarehouses: function getWarehouses() {
      var _this = this;

      this.warehouses = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var result = response.data.data;
        result.forEach(function (r) {
          _this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types });
        });
      });
    },
    getSubscriptions: function getSubscriptions() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/subscriptions', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.subscriptionResult = response.data.data;
        _this2.subscriptionResult.forEach(function (c) {
          _this2.subscriptions.push({
            text: c.subscription_name,
            value: c.subscription_id
          });
        });
      });
    },
    getOrderTypes: function getOrderTypes() {
      var _this3 = this;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('api/order-types', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this3.orderTypesResult = response.data.data;
        _this3.orderTypesResult.forEach(function (c) {
          _this3.orderTypes.push({
            text: c.type_name,
            value: c.order_type_id
          });
        });
      });
    },
    getResults: function getResults() {
      var _this4 = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');
      var theDatatable = document.querySelector('.the-datatable');
      var thePanel = document.querySelector('.panel-flat');

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out');
        thePanel.style.overflowX = 'auto';
      }

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        if (data.data.length > 0) {
          _this4.filterMade = true;
          _this4.apiResults = data.data;
        } else {
          _this4.filterMade = false;
          _this4.apiResults = data.data.data;
        }

        if (_this4.apiResults.length === 0) {
          _this4.tableData.searchOneCol = '';
          _this4.tableData.searchOneVal = '';
          _this4.tableData.search = '';
          _this4.alertValue = true;
        } else {
          _this4.alertValue = false;
        }
        if (data.data.length > 0) {
          _this4.removeConfigPagination();
        } else {
          _this4.configPagination(data.data);
        }
        theDatatable.classList.remove('slide-table-out');
        setTimeout(function () {
          thePanel.style.overflowX = 'auto';
        }, 0);
      }).then(function () {
        _this4.totalResult = 0;
        for (var i = 0; i < _this4.apiResults.length; i++) {
          _this4.totalResult += 1;
        }
      });
    },
    removeConfigPagination: function removeConfigPagination() {
      this.pagination.lastPage = '';
      this.pagination.currentPage = '';
      this.pagination.total = '';
      this.pagination.lastPageUrl = '';
      this.pagination.nextPageUrl = '';
      this.pagination.prevPageUrl = '';
      this.pagination.from = '';
      this.pagination.to = '';
    },
    resetGetResults: function resetGetResults() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'pricing_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'pricing_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.sortByColumn();
      this.getResults();
    },
    resetGetResults2: function resetGetResults2() {
      this.queryParameter = false;
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      this.tableData.search = '';
      this.sortKey = 'pricing_id';
      this.tableData.sortDir = 'desc';
      this.tableData.column = 'pricing_id';
      this.tableData.from_date = '';
      this.tableData.to_date = '';
      this.getResults();
    },
    openAddEditSubscriptionPricingModal: function openAddEditSubscriptionPricingModal() {
      this.addEditSubscriptionPricingModal = true;
    },
    closeAddEditSubscriptionPricingModal: function closeAddEditSubscriptionPricingModal() {
      this.addEditSubscriptionPricingModal = false;
      this.validationError = false;
      this.checkAlert = false;
      this.clear();
    },
    clear: function clear() {
      this.addEditSubscriptionPricingModal = false;
      this.addEditData = {
        warehouse_id_fk: [],
        order_type_id_fk: []
      };
      this.$validator.reset();
      this.unCheckAll();
    },
    submitAddEditUserSubscription: function submitAddEditUserSubscription() {
      var _this5 = this;

      var token = localStorage.getItem('access_token');

      var isEditing = this.addEditData.pricing_id;
      var method = isEditing ? 'patch' : 'post';
      var url = isEditing ? this.baseUrl + '/' + this.addEditData.pricing_id : this.baseUrl;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this5.validationError = false;
        _this5.checkAlert = true;
        _this5.getResults();
        _this5.clear();
      }).catch(function (error) {
        if (error.response.data.message) {
          _this5.checkAlert = false;
          _this5.validationError = true;
        }
      });
    },
    perPageFix: function perPageFix(perPage) {
      this.tableData.per_page = perPage;
      this.getResults();
    },
    changePage: function changePage(pageUrl) {
      this.url = pageUrl;
      this.getResults();
    },
    searchMe: function searchMe(str) {
      this.tableData.searchOneCol = '';
      this.tableData.searchOneVal = '';
      if (str.trim() !== '') {
        this.tableData.search = str;
        this.prevSearchQuery = str;
        this.getResults();
      } else {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'type something to search!',
          icon: 'warning',
          dangerMode: true
        });
        if (this.prevSearchQuery !== '') {
          this.tableData.search = '';
          this.prevSearchQuery = '';
          this.getResults();
        }
      }
    },
    editSubscriptionPricing: function editSubscriptionPricing(r) {
      console.log(r.user_id);
      this.addEditData = {
        pricing_id: r.pricing_id,
        customer_id_fk: r.user_id,
        warehouse_id_fk: [r.warehouse_id_fk],
        subscription_id: r.subscription_id_fk,
        order_type_id_fk: [r.order_type_id_fk],
        order_shipzone_fee: r.order_shipzone_fee,
        shiponly_handling_fee_air: r.shiponly_handling_fee_air,
        shiponly_handling_fee_sea: r.shiponly_handling_fee_sea,
        item_price_air: r.item_price_air,
        item_price_sea: r.item_price_sea,
        item_price_land: r.item_price_land
      };
      this.openAddEditSubscriptionPricingModal();
      this.$validator.reset();
    },
    deleteSubscriptionPricing: function deleteSubscriptionPricing(item) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete user subscription: ' + item.subscription_name + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(_this6.baseUrl + '/' + item.pricing_id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this6.getResults();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    deleteAllSubscriptionPricing: function deleteAllSubscriptionPricing() {
      var _this7 = this;

      if (this.userSubscriptionIds.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
          text: 'Please select at least one user subscription to delete',
          icon: 'warning',
          dangerMode: true
        });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete all selected user subscriptions?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(_this7.baseUrl + '/bulk-delete', { ids: _this7.userSubscriptionIds }, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this7.getResults();
            _this7.unCheckAll();
            __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_5_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    },
    sortByColumn: function sortByColumn(str) {
      this.tableData.column = str;
      this.tableData.sortKey = str;
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc';
      this.getResults();
    },
    searchOneCol: function searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName;
      this.tableData.searchOneVal = str;
      this.getResults();
    },
    configPagination: function configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
    },
    checkAll: function checkAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
    },
    unCheckAll: function unCheckAll() {
      for (var i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click();
        }
      }
      $('#mainCheck').prop('checked', false);
      this.userSubscriptionIds = [];
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['warehouses', 'orderTypes', 'addEditData', 'addEditSubscriptionPricingModal', 'submitAddEditUserSubscription', 'checkAlert', 'subscriptions', 'closeAddEditSubscriptionPricingModal', 'validationError'],

  data: function data() {
    return {};
  },


  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.submitAddEditUserSubscription();
        }
      });
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addEditOrderType_vue__ = __webpack_require__(1264);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'create-order-type': __WEBPACK_IMPORTED_MODULE_2__addEditOrderType_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.getResults();
  },

  $_veeValidate: {
    validator: 'new'
  },
  data: function data() {
    return {
      loading: false,
      addOrderTypeModal: false,
      url: 'api/order-types',
      apiResults: [],
      warehouses: [],
      subscriptions: [],
      addEditData: {
        type_name: ''
      }
    };
  },


  methods: {
    getResults: function getResults() {
      var _this = this;

      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.url;

      var token = localStorage.getItem('access_token');

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        var data = response.data;
        _this.apiResults = data.data;
      });
    },
    openAddOrderTypeModal: function openAddOrderTypeModal() {
      this.addOrderTypeModal = true;
    },
    closeAddOrderTypeModal: function closeAddOrderTypeModal() {
      this.addOrderTypeModal = false;
      this.clear();
    },
    clear: function clear() {
      this.addEditData = {
        type_name: ''
      };
      this.addOrderTypeModal = false;
      this.$validator.reset();
    },
    submitOrderType: function submitOrderType() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');

      // Check if we're editing (has order_type_id) or adding new
      var isEditing = this.addEditData.order_type_id;
      var method = isEditing ? 'patch' : 'post';
      var url = isEditing ? this.url + '/' + this.addEditData.order_type_id : this.url;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        _this2.validationError = false;
        _this2.checkAlert = true;
        _this2.getResults();
        _this2.clear();
      }).catch(function (error) {
        if (error.response.data.message) {
          _this2.checkAlert = false;
          _this2.validationError = true;
        }
      });
    },
    editRecord: function editRecord(item, idx) {
      console.log(item);
      this.addEditData = _extends({}, item, {
        order_type_id: item.order_type_id
      });
      this.addOrderTypeModal = true;
    },
    deleteRecord: function deleteRecord(item, idx) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
        title: 'Are you sure?',
        text: 'Delete Order Type: ' + item.type_name + '?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(_this3.url + '/' + item.order_type_id, { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
            _this3.getResults();
            __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()({
              title: 'Done',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          }).catch(function (error) {
            if (error.response) {
              __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Error', '' + error.response.data.message, 'error');
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['submitOrderType', 'addEditData', 'addOrderTypeModal', 'closeAddOrderTypeModal'],

  data: function data() {
    return {};
  },


  methods: {
    submitForm: function submitForm(event) {
      var _this = this;

      this.$validator.validateAll().then(function (res) {
        if (res) {
          _this.submitOrderType();
        }
      });
    }
  }
});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(32);
var core = __webpack_require__(33);
var ctx = __webpack_require__(1279);
var hide = __webpack_require__(1281);
var has = __webpack_require__(407);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(1282);
var IE8_DOM_DEFINE = __webpack_require__(1283);
var toPrimitive = __webpack_require__(1285);
var dP = Object.defineProperty;

exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(409);
var defined = __webpack_require__(410);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(1290);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'flag',
    props: {
        iso: { type: String, default: null },
        title: { type: String, default: null },
        squared: { type: Boolean, default: true }
    },
    computed: {
        flagIconClass: function flagIconClass() {
            return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
        }
    }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['orderData'],

  methods: {
    getOrderDate: function getOrderDate(order) {
      return order.order_date ? order.order_date : order.created_at;
    },
    getDate: function getDate(order) {
      if (order.status_id_fk === 1) {
        return order.order_date ? order.order_date : order.created_at;
      }

      if (order.status_id_fk === 2) return order.process_date;

      if (order.status_id_fk === 3 || order.is_canceled === '1') return order.cancel_date;

      if (order.status_id_fk === 4) return order.confirm_date;

      if (order.status_id_fk === 5) return order.refund_date;

      if (order.status_id_fk === 6) return order.purchase_date;

      if (order.status_id_fk === 7 || order.status_id_fk === 15) return order.warehouse_deliver_date;

      if (order.status_id_fk === 8) return order.int_shipment_date;

      if (order.status_id_fk === 9) return order.branch_delivery_date;

      if (order.status_id_fk === 10) return order.deliver_date;

      if (order.status_id_fk === 12) return order.order_date;

      if (order.status_id_fk === 13) return order.pending_to_branch_at;

      if (order.status_id_fk === 14) return order.pending_answer_at;
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['date']
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['orderData'],

  methods: {
    getUser: function getUser(order) {
      if (order.status_id_fk === 1 && order.ordered_by) return order.ordered_by.full_name;

      if (order.status_id_fk === 12 && order.shiponlied_by) return order.shiponlied_by.full_name;

      if (order.status_id_fk === 14 && order.pending_answer_by) return order.pending_answer_by.full_name;

      if (order.status_id_fk === 2 && order.processed_by) return order.processed_by.full_name;

      if ((order.status_id_fk === 3 || order.is_canceled === '1') && order.canceled_by) return order.canceled_by.full_name;

      if (order.status_id_fk === 4 && order.approved_by) return order.approved_by.full_name;

      if (order.status_id_fk === 5 && order.refunded_by) return order.refunded_by.full_name;

      if (order.status_id_fk === 6 && order.purchased_by) return order.purchased_by.full_name;

      if (order.status_id_fk === 7 && order.warehouse_delivered_by) return order.warehouse_delivered_by.full_name;

      if (order.status_id_fk === 15 && order.pending_shipmented_by) return order.pending_shipmented_by.full_name;

      if (order.status_id_fk === 8 && order.shipmented_by) return order.shipmented_by.full_name;

      if (order.status_id_fk === 13 && order.pending_to_branch_by) return order.pending_to_branch_by.full_name;

      if (order.status_id_fk === 9 && order.branch_delivered_by) return order.branch_delivered_by.full_name;

      if (order.status_id_fk === 10 && order.delivered_by) return order.delivered_by.full_name;

      if (order.status_id_fk === 11 && order.archived_by) return order.archived_by.full_name;

      return '';
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    phoneNumber: { type: String, default: null }
  },

  methods: {
    openWhatsApp: function openWhatsApp() {
      var phone = this.phoneNumber.replace('+', '');

      // if phone does not start 964 append it
      if (!phone.startsWith('964')) {
        phone = '964' + phone;
      }

      window.open('https://api.whatsapp.com/send?phone=' + phone);
    },
    openViber: function openViber() {
      var phone = this.phoneNumber.replace('+', '');

      // if phone does not start 964 append it
      if (!phone.startsWith('964')) {
        phone = '964' + phone;
      }

      window.open('viber://chat?number=' + phone);
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    clearable: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: 'Branch *' },
    value: { type: [Number, String], default: null }
  },

  data: function data() {
    return {
      branchesList: [],
      showSelect: false,
      // branchId: 0,
      authUser: {}
    };
  },


  computed: {
    branchId: {
      get: function get() {
        var branch = this.value ? this.value : this.authUser.default_branch_id_fk;
        if (!this.value) {
          this.$emit('input', branch);
        }
        return branch;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },

  // watch: {
  //   value(newValue) {
  //     if (newValue) {
  //       this.branchId = Number(newValue)
  //     } else {
  //       this.branchId = this.authUser.default_branch_id_fk
  //     }
  //   },

  //   branchId(newValue) {
  //     this.$emit('input', newValue)
  //   }
  // },

  mounted: function mounted() {
    this.getConnectedBranches();
    this.getLoggedInUser();
    this.branchId = this.authUser.default_branch_id_fk;
  },


  methods: {
    getLoggedInUser: function getLoggedInUser() {
      this.authUser = JSON.parse(localStorage.getItem('user_data'));
    },
    getConnectedBranches: function getConnectedBranches() {
      var _this = this;

      this.branchesList = [];
      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/branch/connected-branch-list', { headers: { Authorization: 'Bearer ' + token } }).then(function (response) {
        response.data.forEach(function (r) {
          _this.branchesList.push({ text: r.branch_name, value: r.branch_id });
        });
      });
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: { type: Object, required: true }
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takePhoto_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    takePhoto: __WEBPACK_IMPORTED_MODULE_1__takePhoto_vue__["a" /* default */]
  },

  props: {
    formData: { type: Object, required: true },
    url: { type: String, default: 'api/order_image' },
    singleStoreUrl: { type: String, default: 'api/order_image/single_upload' },
    filenameKey: { type: String, default: 'order_image' },
    modelFk: { type: String, default: 'order_id_fk' },
    modelPk: { type: String, default: 'order_id' }
  },

  data: function data() {
    return {
      imageDialog: false,
      image: null,
      images: [],
      takePhotoModal: false
    };
  },
  mounted: function mounted() {
    this.getFiles();
  },


  watch: {
    formData: {
      deep: true,
      handler: function handler() {
        this.getFiles();
      }
    }
  },

  methods: {
    openExplorer: function openExplorer() {
      this.$refs.uploadPhotoRef.click();
    },
    saveUploadedImage: function saveUploadedImage() {
      var _this = this;

      var file = this.$refs.uploadPhotoRef.files[0];

      if (!file.type.includes('image')) {
        return __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('', 'File type must be an image', 'error');
      }

      var formData = new FormData();
      formData.append(this.filenameKey, file);
      formData.append(this.modelFk, this.formData[this.modelPk]);

      var token = localStorage.getItem('access_token');
      var payload = {
        headers: { Authorization: 'Bearer ' + token }
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.singleStoreUrl, formData, payload).then(function () {
        _this.getFiles();
      });
    },
    getFiles: function getFiles() {
      var _this2 = this;

      var token = localStorage.getItem('access_token');
      var payload = {
        params: { id: this.formData[this.modelPk] },
        headers: { Authorization: 'Bearer ' + token }
      };

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, payload).then(function (res) {
        _this2.images = res.data;
      });
    },
    deleteImage: function deleteImage(image) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(function (willDelete) {
        if (willDelete) {
          var token = localStorage.getItem('access_token');
          var payload = {
            headers: { Authorization: 'Bearer ' + token }
          };

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(_this3.url + '/' + image.order_image_id, payload).then(function () {
            _this3.getFiles();
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
              title: 'Deleted',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            });
          });
        }
      });
    },
    showImage: function showImage(img) {
      var mainImage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.image = mainImage ? img : img[this.filenameKey];
      this.imageDialog = true;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    modelId: { type: Number, required: true },
    modelName: { type: String, required: true },
    title: { type: String, required: true }
  },

  data: function data() {
    return {
      drawer: false,
      form: {},
      comments: [],
      colors: ['blue lighten-2', 'green lighten-2', 'pink lighten-2', 'yellow darken-1', 'orange lighten-2', 'brown lighten-2', 'cyan lighten-2', 'teal lighten-2', 'purple lighten-2'],
      userColors: [],
      selectedColors: []
    };
  },


  watch: {
    drawer: function drawer(val) {
      if (val) {
        this.getComments();
      }
    }
  },

  methods: {
    avatarColor: function avatarColor(comment) {
      var _this = this;

      var foundUserColor = this.userColors.find(function (c) {
        return c.user_id === comment.user_id_fk;
      });

      if (foundUserColor) {
        return foundUserColor.color;
      }

      var filteredColors = this.colors.filter(function (color) {
        return !_this.selectedColors.includes(color);
      });
      var newColor = filteredColors[Math.floor(Math.random() * filteredColors.length)];

      this.selectedColors.push(newColor);
      this.userColors.push({ user_id: comment.user_id_fk, color: newColor });

      return newColor;
    },
    getComments: function getComments() {
      var _this2 = this;

      var payload = {
        model_id: this.modelId,
        model_name: this.modelName
      };

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('api/comment', { params: payload, headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this2.comments = res.data;
      });
    },
    storeComment: function storeComment() {
      var _this3 = this;

      this.form.model_id = this.modelId;
      this.form.model_name = this.modelName;

      var token = localStorage.getItem('access_token');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/comment', this.form, { headers: { Authorization: 'Bearer ' + token } }).then(function (res) {
        _this3.form = {};
        document.querySelector('#comment-input-field').focus();
        _this3.comments.push(res.data);
        _this3.$nextTick(function () {
          _this3.scrollToBottom();
        });
      });
    },
    scrollToBottom: function scrollToBottom() {
      var objDiv = document.getElementById('comment-panel');
      objDiv.scroll({ top: objDiv.scrollHeight, behavior: 'smooth' });
    }
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseurl__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseurl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__baseurl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_print_nb__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_print_nb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_print_nb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_qrcode_component__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_google_signin_button__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_google_signin_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_google_signin_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_html_to_paper__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_html_to_paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_html_to_paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_viewOrderDates_vue__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_viewStepsDates_vue__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_viewOrderUsers_vue__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_openWhatsAppAndViber_vue__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__mixins_helpers__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BranchSelect_vue__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DisplayBranch_vue__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_orderImages_vue__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Comment_vue__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_otp_2__ = __webpack_require__(1861);



















// import swal from 'sweetalert'






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_google_signin_button___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_23_vue_otp_2__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('qr-code', __WEBPACK_IMPORTED_MODULE_11_vue_qrcode_component__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('view-order-dates', __WEBPACK_IMPORTED_MODULE_14__components_viewOrderDates_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('view-steps-dates', __WEBPACK_IMPORTED_MODULE_15__components_viewStepsDates_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('view-order-users', __WEBPACK_IMPORTED_MODULE_16__components_viewOrderUsers_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('branch-select', __WEBPACK_IMPORTED_MODULE_19__BranchSelect_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('display-branch', __WEBPACK_IMPORTED_MODULE_20__DisplayBranch_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('open-whatsapp-and-viber', __WEBPACK_IMPORTED_MODULE_17__components_openWhatsAppAndViber_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('order-images', __WEBPACK_IMPORTED_MODULE_21__components_orderImages_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('comment', __WEBPACK_IMPORTED_MODULE_22__Comment_vue__["a" /* default */]);

var options = {
  // name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ['assets/ltr/css/print_style.css']
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_18__mixins_helpers__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_html_to_paper___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_flag_icon__["a" /* default */]);

var HelloJs = __webpack_require__(1862);
var VueHello = __webpack_require__(1864);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__(1865));

HelloJs.init({
  // OLD TOKEN
  // google: '874739111711-tdaea8acef469ov1ip14kakljr2te44q.apps.googleusercontent.com',

  google: '17629677592-96u7gdi6phhtb1t02lajhauf7dnir6ul.apps.googleusercontent.com', // ShipZone <Google Developer>
  facebook: 3408050599367161 // ShipZone <Facebook Developer>
}, {
  redirect_uri: 'https://ship-zone.com/'
  // redirect_uri: 'http://localhost/'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueHello, HelloJs);

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_8__baseurl___default.a.url;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.getFilePath = __WEBPACK_IMPORTED_MODULE_8__baseurl___default.a.filePath;

setInterval(function () {
  var secretDuration = localStorage.getItem('secret_duration');
  if (secretDuration != null) {
    if (secretDuration > 0) {
      secretDuration = secretDuration - 1;
      localStorage.setItem('secret_duration', secretDuration);
    }
    if (secretDuration === 0) {
      localStorage.setItem('secret_key', false);
    }
  }
}, 60000);

// setInterval(function () {
//   let duration = localStorage.getItem('duration')
//   if (duration != null) {
//     //  COUNT DURATION ONLY FOR STAFFS
//     let userData = JSON.parse(localStorage.getItem('user_data'))
//     if (userData.is_staff) {
//       if (duration < 3) {
//         let token = localStorage.getItem('access_token')
//         axios.post('api/logout', '', { headers: { Authorization: 'Bearer ' + token } }).then(() => {
//           localStorage.clear()
//           window.location.href = '/'
//         })
//       } else {
//         duration = duration - 1
//         localStorage.setItem('duration', duration)
//       }
//     }
//   }
// }, 60000)

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('usdFormat', function (number) {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  return formatter.format(number);
});

// setInterval(function () {
//     let token = localStorage.getItem('access_token');
//     let now = Date.now() / 1000;
//     let base64Url = token.split('.')[1];
//     let base64 = base64Url.replace('-', '+').replace('_', '/');
//     let jwtPayload = JSON.parse(window.atob(base64));
//
//     if ( ( (jwtPayload.exp + 59 ) - now) < 120 ) {
//         axios.post("api/refresh", '', { headers: { Authorization: 'Bearer ' + token }})
//             .then(response => {
//                 localStorage.setItem('access_token', response.data.access_token);
//             })
//             .catch(error => {
//                 // console.log(error.response);
//             });
//     }
// }, 60000);

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
  if (config.url !== 'api/order_notification') {
    localStorage.setItem('duration', 20);
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// axios.interceptors.response.use(
//   function (response) {
//     return response
//   },
//   function (error) {
//     if (error.request.status === 401) {
//       if (
//         !error.request.responseURL.includes('api/order_notification') &&
//         !error.request.responseURL.includes('api/login')
//       ) {
//         localStorage.clear()
//         window.location.href = '/'
//       }
//     } else if (error.request.status === 403) {
//       swal('Unauthorized', "You don't have permission", 'error')
//     }
//     return Promise.reject(error)
//   }
// )

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_4_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["b" /* default */], {
  events: ''
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_print_nb___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(25)))

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377517e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(476);
function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377517e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(426);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8d7f6986", content, true, {});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".ws-nowrap{white-space:nowrap!important}.hover-container{position:relative}.hover-container:hover .hover-content{visibility:visible;opacity:1}.hover-content{visibility:hidden;opacity:0;transition:all .3 linear;position:absolute;top:-10px;right:130px;z-index:1000;background-color:#fff;border:1px solid #e4e7ed;border-radius:8px!important;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);padding:8px 16px;width:310px}.popover-arrow{right:-7px;transform:rotate(135deg)}.popover-arrow,.popover-arrow-left{position:absolute;top:25px;z-index:3000;height:13px;width:13px;border-radius:0;border:1px solid #e4e7ed;background:#fff;border-bottom:none;border-right:none}.popover-arrow-left{left:-7px;transform:rotate(-45deg)}", ""]);

// exports


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginComponent_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b181bc46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginComponent_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loginComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b181bc46_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loginComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(430);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42a6c007", content, true, {});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".glogin-btn{width:100%;color:#333;background-color:#fff;padding:6px;border-radius:5px;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.glogin-btn:hover{background-color:#ddd}.icons{color:#000}.icons:hover{color:#999}.the-li{display:inline;text-transform:uppercase;font-family:Raleway,Arial,sans-serif;padding:6px;font-size:15px}li a{color:#5e5e5e}li a:hover{color:#999}.dot{height:3px;width:3px;background-color:#5c5c5c;border-radius:50%;display:inline-block;margin-bottom:4px}#list-section,#social{border-bottom-style:solid;border-width:1px;border-color:#000;padding-left:6%;padding-bottom:9px;padding-top:10px;border-color:#ebebeb}.login-container .page-container{padding-top:0}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}#navbar-mobile{padding-left:300px}@media screen and (max-width:767px){.the-li{display:block;text-transform:uppercase;font-family:Raleway,Arial,sans-serif;padding:6px;font-size:15px;text-align:left;line-height:65px}.dot{display:none}#navbar-mobile{padding-left:0}}", ""]);

// exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var bind = __webpack_require__(39);
var Axios = __webpack_require__(433);
var defaults = __webpack_require__(26);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(43);
axios.CancelToken = __webpack_require__(447);
axios.isCancel = __webpack_require__(42);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(448);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(26);
var utils = __webpack_require__(11);
var InterceptorManager = __webpack_require__(442);
var dispatchRequest = __webpack_require__(443);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(41);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);
var transformData = __webpack_require__(444);
var isCancel = __webpack_require__(42);
var defaults = __webpack_require__(26);
var isAbsoluteURL = __webpack_require__(445);
var combineURLs = __webpack_require__(446);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(11);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(43);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self)["vue-google-login"]={})}(this,function(t){"use strict";var e,n,o=function(t){return e?Promise.resolve(e):(n||(n=function(t){return new Promise(function(n,o){window.onGapiLoad=function(){window.gapi.load("auth2",function(){try{e=window.gapi.auth2.init(Object.assign({},t))}catch(t){o({err:"client_id missing or is incorrect, or if you added extra params maybe they are written incorrectly, did you add it to the component or plugin?"})}n(e)})}})}(t)),n)},i=function(t,e){if(t)return t[e]();return Promise.reject({err:"Script not loaded correctly, did you added the plugin or the client_id to the component?"})},r={load:function(t){return Promise.all([o(t),new Promise(function(t,e){if(!document.getElementById("auth2_script_id")){var n=document.createElement("script");n.setAttribute("src","https://apis.google.com/js/platform.js?onload=onGapiLoad"),n.setAttribute("async",!0),n.setAttribute("defer","defer"),n.setAttribute("id","auth2_script_id"),document.head.appendChild(n)}t()})]).then(function(t){return t[0]})},signIn:function(){return i(e,"signIn")},signOut:function(){return i(e,"signOut")}},s=0;var d=function(t,e,n,o,i,r,s,d,u,a){"boolean"!=typeof s&&(u=d,d=s,s=!1);var c,l="function"==typeof n?n.options:n;if(t&&t.render&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns,l._compiled=!0,i&&(l.functional=!0)),o&&(l._scopeId=o),r?(c=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),e&&e.call(this,u(t)),t&&t._registeredComponents&&t._registeredComponents.add(r)},l._ssrRegister=c):e&&(c=s?function(){e.call(this,a(this.$root.$options.shadowRoot))}:function(t){e.call(this,d(t))}),c)if(l.functional){var f=l.render;l.render=function(t,e){return c.call(e),f(t,e)}}else{var h=l.beforeCreate;l.beforeCreate=h?[].concat(h,c):[c]}return n}({render:function(){var t=this.$createElement,e=this._self._c||t;return this.renderParams&&!this.logoutButton?e("div",{attrs:{id:this.id},on:{click:this.handleClick}}):e("button",{attrs:{id:this.id},on:{click:this.handleClick}},[this._t("default")],2)},staticRenderFns:[]},void 0,{name:"GoogleLogin",props:{params:{type:Object,required:!0},onSuccess:{type:Function,default:function(){}},onFailure:{type:Function,default:function(){}},logoutButton:{type:Boolean,default:!1},renderParams:{type:Object,required:!1}},beforeCreate:function(){this.id="google-signin-btn-".concat(s++)},methods:{handleClick:function(){var t=this,e=this.logoutButton?"signOut":"signIn";r[e]().then(function(e){return t.onSuccess(e)}).catch(function(e){return t.onFailure(e)})}},mounted:function(){var t=this;r.load(this.params).then(function(){t.renderParams&&!1===t.logoutButton&&window.gapi.signin2.render(t.id,t.renderParams)}).catch(function(t){console.log(t)})}},void 0,!1,void 0,void 0,void 0),u={install:function(t,e){t.GoogleAuth=r.load(e)}};t.GoogleLogin=d,t.LoaderPlugin=u,t.default=d,Object.defineProperty(t,"__esModule",{value:!0})});
//# sourceMappingURL=vue-google-login.min.js.map


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('body',{staticClass:"login-container",staticStyle:{"background-color":"white"}},[_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content pb-20"},[_c('div',{staticClass:"tabbable panel login-form width-400",staticStyle:{"margin-top":"20px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content panel-body"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"basic-tab1"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"d-flex mb-4 pb-2"},[_c('v-btn',{staticStyle:{"height":"auto"},style:(_vm.activeTab == 1 ? 'color: white; background-color: #323232;' : 'color: #333; background-color: #fff'),on:{"click":function($event){_vm.activeTab = 1}}},[_vm._v("\n                      Phone Number\n                    ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},style:(_vm.activeTab == 2 ? 'color: white; background-color: #323232;' : 'color: #333; background-color: #fff'),on:{"click":function($event){_vm.activeTab = 2}}},[_vm._v("\n                      Google or Facebook\n                    ")])],1),_vm._v(" "),(_vm.activeTab == 1)?[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.loginWithPhoneAndPassword()}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"mr-2",staticStyle:{"font-size":"15px"}},[_vm._v("+964")]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:10|max:10'),expression:"'required|min:10|max:10'"}],attrs:{"label":"Phone Number","placeholder":"7xxxxxxxxx","error-messages":_vm.errors.collect('Phone Number'),"data-vv-name":"Phone Number"},model:{value:(_vm.formData.phone_number),callback:function ($$v) {_vm.$set(_vm.formData, "phone_number", $$v)},expression:"formData.phone_number"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"passwordField",attrs:{"label":"Password","error-messages":_vm.errors.collect('Password'),"data-vv-name":"Password","append-icon":_vm.e1 ? 'visibility_off' : 'visibility',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'text' : 'password'},model:{value:(_vm.formData.password),callback:function ($$v) {_vm.$set(_vm.formData, "password", $$v)},expression:"formData.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"color":"primary"}},[_vm._v("\n                            Login\n                          ")])],1)],1)],1)]:[_c('v-flex',{attrs:{"sm12":"","md":"","12":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%","color":"white","background-color":"#3b5998","margin":"0px"},on:{"click":function($event){return _vm.auth('facebook')}}},[_c('i',{staticClass:"fa fa-facebook-f fa-2x"}),_vm._v("     Facebook")])],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":""}},[_c('GoogleLogin',{staticClass:"glogin-btn",attrs:{"params":_vm.params,"onSuccess":_vm.googleLogin,"onFailure":_vm.onFailure}},[_c('img',{attrs:{"src":__webpack_require__(451),"width":"30px"}}),_vm._v("   Google\n                      ")])],1)]],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal_showApp"}},[_c('div',{staticClass:"modal-dialog modal-full",staticStyle:{"max-width":"450px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"title":"close","type":"button"},on:{"click":function($event){return _vm.closeModal('modal_showApp')}}},[_vm._v("\n            ×\n          ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('v-btn',{staticStyle:{"padding-left":"0px","padding-right":"0px","height":"auto","color":"white","background-color":"#FF6F00"},attrs:{"id":"sms"},on:{"click":function($event){_vm.smsLogin(), _vm.closeModal('modal_showApp')}}},[_vm._v("Verify")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs nav-justified"},[_c('li',{staticClass:"active",staticStyle:{"background-image":"radial-gradient(circle farthest-corner at 10% 20%,rgba(0, 107, 141, 1) 0%,rgba(0, 69, 91, 1) 90%)"}},[_c('a',{attrs:{"href":"#basic-tab1","data-toggle":"tab"}},[_c('img',{attrs:{"src":__webpack_require__(452),"width":"150px","alt":"shipzone logo"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h5',{staticClass:"content-group"},[_vm._v("Login to your account with")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-divider text-muted form-group",staticStyle:{"margin-top":"5%"}},[_c('span',[_vm._v("or")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9"},[_c('h4',{staticClass:"lead"},[_vm._v("Please verify your phone number")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "google_logo.png?9b224c9884c2bb081d4ac92b23675c2e";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "shipzone.png?a40c2c64e8d8ead75d41af48d079de03";

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staffLogin_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b589e1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staffLogin_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staffLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b589e1d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staffLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(455);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bd535ac", content, true, {});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".login-container .page-container{padding-top:0}", ""]);

// exports


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('body',{staticClass:"login-container"},[_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content pb-20"},[_c('div',{staticClass:"tabbable panel login-form width-400"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tab-content panel-body"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"basic-tab1"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_vm._m(1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"append-icon":"mail","label":"Email","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.loginData.email),callback:function ($$v) {_vm.$set(_vm.loginData, "email", $$v)},expression:"loginData.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md":"","12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"label":"Password","error-messages":_vm.errors.collect('password'),"data-vv-name":"password"},model:{value:(_vm.loginData.password),callback:function ($$v) {_vm.$set(_vm.loginData, "password", $$v)},expression:"loginData.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":"","md":"","12":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%","color":"white","background-color":"#36457f"},attrs:{"type":"submit"}},[_vm._v("Login   "),_c('i',{staticClass:"material-icons"},[_vm._v("forward")])])],1)],1)])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs nav-justified"},[_c('li',{staticClass:"active",staticStyle:{"background-image":"radial-gradient(circle farthest-corner at 10% 20%,rgba(0, 107, 141, 1) 0%,rgba(0, 69, 91, 1) 90%)"}},[_c('a',{attrs:{"href":"#basic-tab1","data-toggle":"tab"}},[_c('h6',{staticStyle:{"color":"#fafafa"}},[_vm._v("Sign in")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"icon-object border-slate-300 text-slate-300"},[_c('i',{staticClass:"material-icons"},[_vm._v("person")])]),_vm._v(" "),_c('h5',{staticClass:"content-group"},[_vm._v("Login to your account")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageContainer_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8452c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageContainer_vue__ = __webpack_require__(469);
function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pageContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8452c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pageContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(459);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e88d41f0", content, true, {});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-flat{width:100%;display:block}", ""]);

// exports


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bead2ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bead2ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(462);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c9f25574", content, true, {});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "[data-toggle=collapse].collapsed .fa-angle-down{transform:rotate(-90deg);transition:transform .2s ease}.fa-angle-down,.fa-caret-down{transition:transform .2s ease}.fa-caret-down.rotated{transform:rotate(180deg)}.toggle-nav-btn{width:100%;padding:10px 15px;border:none;background-color:hsla(0,0%,100%,.1);color:#fff;text-align:left;font-size:14px;font-weight:500;transition:background-color .2s ease;border-radius:3px;cursor:pointer}.toggle-nav-btn:hover{background-color:hsla(0,0%,100%,.2)}.toggle-nav-btn:active{background-color:hsla(0,0%,100%,.15)}.bg{height:150px;width:220px}.fit-img{width:62%;height:90%}.sidebar-content{height:94vh;overflow:scroll}.group-title{font-size:14px;text-transform:uppercase;font-weight:700;opacity:.8;padding:6px 8px;margin-top:8px;letter-spacing:1.1px}.navigation{padding:0!important}.pending-boat-icon{position:relative;display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center;margin-right:12px}.pending-boat-icon .boat-base{font-size:24px;line-height:24px}.pending-boat-icon .boat-badge{position:absolute;bottom:-4px;right:-6px;font-size:14px;background:#fff;color:#ff9800;border-radius:50%;padding:2px;box-shadow:0 0 0 1px #ddd}", ""]);

// exports


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar sidebar-main",class:_vm.loggedInUserData.is_staff ? 'sidebar-admin' : 'cus-sidebar'},[_c('div',{staticClass:"sidebar-content"},[(_vm.loggedInUserData.is_staff || _vm.showAdminSections)?_c('div',{staticClass:"sidebar-category sidebar-category-visible"},[_c('button',{staticClass:"toggle-nav-btn",on:{"click":_vm.toggleAllNavigations}},[_c('i',{staticClass:"fa fa-caret-down mr-1",class:{ 'rotated': _vm.allNavigationsExpanded }}),_vm._v("\n        Toggle All Navigations\n      ")]),_vm._v(" "),_c('div',{staticClass:"category-content no-padding"},[_c('ul',{staticClass:"navigation navigation-main navigation-accordion"},[(_vm.$_has_perm('view_pallet_report'))?_c('div',{staticClass:"sidebar-user-material"},[_c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#16182EFF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('router-link',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"to":"/"}},[_c('span',[_c('i',{staticClass:"fa fa-th-large",staticStyle:{"font-size":"14px","margin-right":"8px"}}),_vm._v("Dashboard")])])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material orders"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse in",attrs:{"id":"user-nav10","aria-expanded":"true"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#2C315BFF"}},[(_vm.$_has_perm('view_ship_only'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/ship-only","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"16px"}}),_vm._v(" Ship Only\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_new_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/new-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("add_box")]),_vm._v("\n                  New Orders\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_pending_answer_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/pending-answer-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-adn",staticStyle:{"font-size":"16px"}}),_vm._v("\n                  Pending Answer\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_processed_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/processed_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-cog",staticStyle:{"font-size":"16px"}}),_vm._v("Processed Orders")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_canceled_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/canceled_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-times",staticStyle:{"font-size":"16px"}}),_vm._v("Canceled")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_approved_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/approved_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"16px"}}),_vm._v("Approved Orders")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_refunded_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/refunded_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("block")]),_vm._v("Refunded")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_partial_refund'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=partial-refund","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"16px"}}),_vm._v("\n                  Partial Refund\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_purchased_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/purchased_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("add_shopping_cart")]),_vm._v("Purchased")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_warehouse_delivered_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/warehouse_delivered_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-wordpress",staticStyle:{"font-size":"16px"}}),_vm._v(" Warehouse Delivered")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_pending_to_shipment_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/pending_to_shipment_order","tag":"li","active-class":"active"}},[_c('a',[_c('span',{staticClass:"pending-boat-icon"},[_c('i',{staticClass:"material-icons boat-base"},[_vm._v("directions_boat")]),_vm._v(" "),_c('i',{staticClass:"material-icons boat-badge"},[_vm._v("schedule")])]),_vm._v("\n                  Pending To\n                  Shipment")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_shipment_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/int_shipment_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("directions_boat")]),_vm._v("International\n                  Shipment")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_pallet_report'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/pallets","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plane",staticStyle:{"font-size":"16px"}}),_vm._v("Pallets")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_pending_to_branch'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/pending_to_branch_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-product-hunt",staticStyle:{"font-size":"18px"}}),_vm._v("\n                  Pending To Branch\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_branch_delivered_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/branch_delivery_order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("local_shipping")]),_vm._v("\n                  Delivered to Erbil\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_delivered_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/user-delivered-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("\n                    local_taxi\n                  ")]),_vm._v("\n                  Delivered\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_archived_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/admin-archived-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("\n                    archive\n                  ")]),_vm._v("\n                  Archived\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_exportable_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/exportable-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-excel-o",staticStyle:{"font-size":"16px"}}),_vm._v(" Exportable Orders")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_warehouse_passed_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/warehouse-date-passed","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-calendar",staticStyle:{"font-size":"16px"}}),_vm._v("Warehouse Passed")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_all_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/all-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-cubes",staticStyle:{"font-size":"16px"}}),_vm._v("All Orders")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_not_found_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/not-found-orders","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-eye-slash",staticStyle:{"font-size":"16px"}}),_vm._v("\n                  Not Found Orders\n                ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_purchase_history'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/purchase-history","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-clock-o",staticStyle:{"font-size":"16px"}}),_vm._v("Purchase History")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material export-order"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav5"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#9EA6B0FF"}},[(_vm.$_has_perm('view_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/pending","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"16px"}}),_vm._v("\n              New Export Orders\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_processed_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/processed","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-cog",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Processed\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_canceled_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/canceled","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-times",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Canceled\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_approved_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/approved","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Approved\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_sent_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/sent","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plane",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Sent\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_received_export_order'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/received","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Received\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_export_history'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/export-history","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-history",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Export History\n            ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_export_order_refund'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/export-order/refunded","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-undo",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Refunded Orders\n            ")])]):_vm._e()],1)])]),_vm._v(" "),_c('hr',{staticClass:"my-0"}),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material delivery"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav13"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#912121FF"}},[(_vm.$_has_perm('view_order_delivery'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/order-delivery","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-motorcycle",staticStyle:{"font-size":"16px"}}),_vm._v("\n              Order Delivery\n            ")])]):_vm._e()],1)])]),_vm._v(" "),(_vm.$_has_perm('view_not_found_order') || _vm.$_has_perm('view_order_case'))?_c('hr',{staticClass:"my-0"}):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"my-0"}),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material invoices"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav11"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#AE8F09FF"}},[(_vm.$_has_perm('view_shipping_invoice'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/order_invoice","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"16px"}}),_vm._v("Shipping Invoice")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_order_invoice'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=credit-log-transaction","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"16px"}}),_vm._v("Order Invoice")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_credit'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=credit-log-action","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"16px"}}),_vm._v("Credit Invoice")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_delivery_invoice'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=delivery-invoice","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-motorcycle",staticStyle:{"font-size":"16px"}}),_vm._v("Delivery Invoice")])]):_vm._e()],1)])]),_vm._v(" "),_c('hr',{staticClass:"my-0"}),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material finance"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav4"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#4C9EB8"}},[(_vm.$_has_perm('view_expense'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=expense","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-eur",staticStyle:{"font-size":"16px"}}),_vm._v("Expenses")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_bank'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/banks","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("account_balance")]),_vm._v("Banks")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_currency_rate'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/currency-rate","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("\n                      loop\n                    ")]),_vm._v("\n                    Currency Rates\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_profit'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=profit","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-pie-chart",staticStyle:{"font-size":"16px"}}),_vm._v("Profit")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_capital'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=capital","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-database",staticStyle:{"font-size":"16px"}}),_vm._v("Capital")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_money'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=put_money","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Add Money\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_money_transfer'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=money-transfer","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-share",staticStyle:{"font-size":"16px"}}),_vm._v("Money Transfer")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_expense_type'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=expense-type","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-file-text",staticStyle:{"font-size":"16px"}}),_vm._v("Expense Type")])]):_vm._e()],1)])]),_vm._v(" "),_c('hr',{staticClass:"my-0"}),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material cases"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav6"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#956D4B"}},[(_vm.$_has_perm('view_order_case'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/order-cases","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Order Cases\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_progress_order_case') || _vm.$_has_perm('view_order_case'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/order-case-progress","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Order Cases Progress\n                  ")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material customers"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav7"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#601674FF"}},[(_vm.$_has_perm('view_customer'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/regular-user","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("person")]),_vm._v("Customer")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_customer_subscription'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-subscription","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("card_membership")]),_vm._v("Customer Subscription")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_loaned_customer'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/loan-customers","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("person")]),_vm._v("Loaned customer")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_credit'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=credit","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("attach_money")]),_vm._v("Customer\n                  Credit")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_customer_price'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=customer-prices","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-money",staticStyle:{"font-size":"16px"}}),_vm._v("Customer prices")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material report"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav8"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#9BA25C"}},[(_vm.$_has_perm('view_delivered_report'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/delivered-report","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-line-chart pl-2"}),_vm._v("Delivered report")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material mobile-app"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav2"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#FF8F00"}},[(_vm.$_has_perm('view_about'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/about","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-info-circle pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    About App\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_notification'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/send-notification","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-bell pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Send Notification\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_home_banner'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/home-banner","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-image pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Home Banner\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_home_slider'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/home-slider","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-image pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Home Slider\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_popular_website'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/popular-website","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-globe pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Popular Websites\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_global_website'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/global-website-group","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-globe pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Global Websites\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_force_update'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/force-update","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-underline pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Force Update\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_our_address'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/our-address","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-map-marker pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Our Address\n                  ")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar-user-material admin"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"navigation-wrapper collapse",attrs:{"id":"user-nav3"}},[_c('ul',{staticClass:"navigation",staticStyle:{"background-color":"#3261A3FF"}},[(_vm.$_has_perm('view_order_type'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/order-types","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("category")]),_vm._v("Order Types")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_subscription'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/subscription","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("subscriptions")]),_vm._v("Subscription")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_subscription_pricing'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/subscription-pricing","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("category")]),_vm._v("Subscription Pricing")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_reason'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/reason","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-ban",staticStyle:{"font-size":"16px"}}),_vm._v("Cancellation Reason")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_staff'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/users","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("group")]),_vm._v("Staff")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_role'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/roles","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-shield pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Roles\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_coupon'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=coupon","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-credit-card-alt",staticStyle:{"font-size":"16px"}}),_vm._v("Coupons")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_warehouse'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/warehouse","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-home pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Warehouse\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_governorate'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/governorate","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-globe pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Governorates\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_city'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/city","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-home pl-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                    Cities\n                  ")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_company_fee'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=kreenex-fee-prices","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-money",staticStyle:{"font-size":"16px"}}),_vm._v("ShipZone Fee")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_supplier'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/supplier","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-users",staticStyle:{"font-size":"16px"}}),_vm._v("Suppliers")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_order_log'))?_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/secret?component=order-log","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("swap_vert")]),_vm._v("\n              Order Log\n            ")])]):_vm._e()],1)])])])])]):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.is_staff)?_c('div',[(_vm.loggedInUserData.phone_number && _vm.loggedInUserData.address)?_c('div',{staticClass:"sidebar-category sidebar-category-visible"},[_c('div',{staticClass:"category-content no-padding"},[_c('ul',{staticClass:"navigation navigation-main navigation-accordion"},[_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/make-new-ship-only","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Ship Only")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/new-ship-only","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"font-size":"16px"}}),_vm._v(" Ship Only (New)\n                ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/make-new-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("New Order")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-export-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-share-square-o",staticStyle:{"font-size":"18px"}}),_vm._v("\n                Export Order\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("filter_none")]),_vm._v(" "),_c('span',[_vm._v("Orders")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/archived-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px"}},[_vm._v("\n                  archive\n                ")]),_vm._v("\n                Archived Orders\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-order-cases","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"16px"}}),_vm._v("\n                Order Cases\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/charge-balance","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-money",staticStyle:{"font-size":"18px"}}),_vm._v("\n                Charge Balance\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/check-rate","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-calculator",staticStyle:{"font-size":"18px"}}),_vm._v("\n                Check Rate\n              ")])]),_vm._v(" "),_c('li',[_vm._m(10),_vm._v(" "),_c('ul',{staticClass:"collapse",attrs:{"id":"invoice-menu"}},[_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Order Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-order-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Shipping Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-credit-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Credit Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-partial-refund","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Partial Refund Invoices")])])],1)])],1)])]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#16182EFF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav10","data-toggle":"collapse","aria-expanded":"true"}},[_c('span',[_vm._v("Orders")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#7A8088FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav5","data-toggle":"collapse"}},[_c('span',[_vm._v("Export")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#731212FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav13","data-toggle":"collapse"}},[_c('span',[_vm._v("Delivery")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#927805FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav11","data-toggle":"collapse"}},[_c('span',[_vm._v("Invoices")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#3E8195FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav4","data-toggle":"collapse"}},[_c('span',[_vm._v("Finance")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#7A5A3EFF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav6","data-toggle":"collapse"}},[_c('span',[_vm._v("Cases")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#4D125EFF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav7","data-toggle":"collapse"}},[_c('span',[_vm._v("Customers")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#80864DFF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav8","data-toggle":"collapse"}},[_c('span',[_vm._v("Reports")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#C67101FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav2","data-toggle":"collapse"}},[_c('span',[_vm._v("Mobile App")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-content pt-0",staticStyle:{"background-color":"#2A4A77FF"}},[_c('div',{staticClass:"sidebar-user-material-menu mt-0"},[_c('a',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"id":"user-nav","href":"#user-nav3","data-toggle":"collapse"}},[_c('span',[_vm._v("Admin")]),_vm._v(" "),_c('i',{staticClass:"caret"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","width":"100%"},attrs:{"href":"#invoice-menu","data-toggle":"collapse"}},[_c('span',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px","padding":"1px"}},[_vm._v("assignment")]),_c('span',{staticStyle:{"padding":"10px 15px"}},[_vm._v("Invoices")])]),_vm._v(" "),_c('i',{staticClass:"fa fa-angle-down mt-1",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5098c6a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__(468);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5098c6a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(466);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("486c3ec8", content, true, {});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".navigation>li ul{border-bottom:none!important}.verify-alert{background:linear-gradient(135deg,#e94057,#f27121);padding:10px;display:flex;justify-content:center;align-items:center;gap:10px}.verify-message{font-size:16px;font-weight:700;color:#fff}.verify-btn{padding:6px 16px;background-color:#fff;color:#000;border:none;border-radius:10px;font-size:14px;text-decoration:none;text-transform:capitalize}#mobile-sidebar-list{color:#fafafa;-webkit-box-shadow:0 1px 3px rgb(0 0 0/12%),0 1px 2px rgb(0 0 0/24%);box-shadow:0 1px 3px rgb(0 0 0/12%),0 1px 2px rgb(0 0 0/24%)}.disabled{pointer-events:none;color:gray}.hide-animation{animation:linear;animation-name:rightLeft;animation-duration:.5s}@keyframes rightLeft{0%{right:0}to{right:calc(100% - 100px)}}", ""]);

// exports


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"650px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline indigo darken-2 white--text d-flex justify-space-between align-center",staticStyle:{"padding":"12px 20px"}},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"bold"}},[_c('i',{staticClass:"material-icons",staticStyle:{"vertical-align":"middle","margin-right":"6px"}},[_vm._v("vpn_key")]),_vm._v("\n        Amazon Server Session\n      ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"margin":"0"},attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"panel panel-default",staticStyle:{"border-radius":"6px","margin-bottom":"18px"}},[_c('div',{staticClass:"panel-body",staticStyle:{"background":"#fbfbfb"}},[_c('div',{staticClass:"row align-center"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('strong',[_vm._v("Status: ")]),_vm._v(" "),(_vm.loadingStatus)?_c('span',{staticClass:"text-muted"},[_vm._v("Checking...")]):(_vm.statusData && _vm.statusData.is_configured && !_vm.statusData.needs_refresh)?_c('span',{staticClass:"label label-success",staticStyle:{"font-size":"12px","padding":"4px 8px"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"13px","vertical-align":"middle"}},[_vm._v("check_circle")]),_vm._v(" Active & Configured\n              ")]):(_vm.statusData && _vm.statusData.needs_refresh)?_c('span',{staticClass:"label label-warning",staticStyle:{"font-size":"12px","padding":"4px 8px"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"13px","vertical-align":"middle"}},[_vm._v("warning")]),_vm._v(" Needs Refresh ("+_vm._s(_vm.statusData.days_old)+"d old)\n              ")]):_c('span',{staticClass:"label label-danger",staticStyle:{"font-size":"12px","padding":"4px 8px"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"13px","vertical-align":"middle"}},[_vm._v("error")]),_vm._v(" Not Configured\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[(_vm.statusData && _vm.statusData.days_old !== null)?_c('span',{staticStyle:{"font-size":"13px","color":"#555"}},[_c('strong',[_vm._v("Age: ")]),_vm._v(" "+_vm._s(_vm.statusData.days_old)+" days old\n                "),(_vm.statusData.days_old < 25)?_c('span',{staticClass:"text-success"},[_vm._v("(Fresh)")]):_c('span',{staticClass:"text-danger"},[_vm._v("(Refresh recommended)")])]):_vm._e()])]),_vm._v(" "),(_vm.statusData && _vm.statusData.last_updated)?_c('div',{staticStyle:{"margin-top":"8px","font-size":"12px","color":"#777"}},[_c('span',[_c('strong',[_vm._v("Last Updated: ")]),_vm._v(" "+_vm._s(_vm.statusData.last_updated))]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('strong',[_vm._v("Source: ")]),_vm._v(" "+_vm._s(_vm.statusData.cookie_source))])]):_vm._e(),_vm._v(" "),(_vm.statusData && _vm.statusData.refresh_warning)?_c('div',{staticClass:"alert alert-warning",staticStyle:{"margin-top":"12px","margin-bottom":"0","padding":"8px 12px","font-size":"12px"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("warning")]),_vm._v("\n            "+_vm._s(_vm.statusData.refresh_warning)+"\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.testResult)?_c('div',{class:['alert', _vm.testResult.status === 'connected' ? 'alert-success' : 'alert-danger'],staticStyle:{"padding":"10px 14px","margin-bottom":"18px"}},[_c('div',{staticStyle:{"font-weight":"bold","margin-bottom":"4px"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"16px","vertical-align":"middle"}},[_vm._v(_vm._s(_vm.testResult.status === 'connected' ? 'check_circle' : 'error'))]),_vm._v("\n          "+_vm._s(_vm.testResult.status === 'connected' ? 'Amazon Product Page Reachable' : 'Connection Error')+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","line-height":"1.6"}},[(_vm.testResult.item_price)?_c('span',[_c('strong',[_vm._v("Live Price: ")]),_vm._v(" $"+_vm._s(_vm.testResult.item_price)+"  |  ")]):_vm._e(),_vm._v(" "),(_vm.testResult.warehouse_date)?_c('span',[_c('strong',[_vm._v("Delivery Date: ")]),_vm._v(" "+_vm._s(_vm.testResult.warehouse_date)+"  |  ")]):_vm._e(),_vm._v(" "),(_vm.testResult.item_weight_kg)?_c('span',[_c('strong',[_vm._v("Package Weight: ")]),_vm._v(" "+_vm._s(_vm.testResult.item_weight_kg)+" kg")]):_vm._e(),_vm._v(" "),(_vm.testResult.status === 'connected')?_c('div',{staticStyle:{"color":"#555"}},[_vm._v("This confirms page reachability only; Prime eligibility varies by account and product.")]):_vm._e(),_vm._v(" "),(_vm.testResult.prime_delivery_detected)?_c('div',{staticStyle:{"color":"#3c763d"}},[_vm._v("A Prime delivery cue was displayed for this test product.")]):_vm._e(),_vm._v(" "),(_vm.testResult.error)?_c('div',{staticStyle:{"color":"#a94442"}},[_vm._v(_vm._s(_vm.testResult.error))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"12px"}},[_c('label',{staticStyle:{"font-weight":"600","font-size":"13px"}},[_vm._v("\n          Paste Amazon Cookies (Header String):\n        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCookies),expression:"newCookies"}],staticClass:"form-control",staticStyle:{"font-family":"monospace","font-size":"12px"},attrs:{"rows":"4","placeholder":"Paste your exported cookie string here (e.g. session-id=...; at-main=...; ubid-main=...)"},domProps:{"value":(_vm.newCookies)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newCookies=$event.target.value}}})]),_vm._v(" "),_c('div',{staticStyle:{"background":"#eef2f7","border-left":"3px solid #3f51b5","padding":"8px 12px","border-radius":"4px","font-size":"12px","margin-bottom":"15px"}},[_c('strong',[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("help_outline")]),_vm._v(" How to refresh in 15 seconds:")]),_vm._v(" "),_c('ol',{staticStyle:{"margin-top":"4px","margin-bottom":"0","padding-left":"18px"}},[_c('li',[_vm._v("Open "),_c('a',{attrs:{"href":"https://www.amazon.com","target":"_blank"}},[_vm._v("amazon.com")]),_vm._v(" on your computer.")]),_vm._v(" "),_c('li',[_vm._v("Click your "),_c('strong',[_vm._v("Cookie-Editor")]),_vm._v(" Chrome extension → "),_c('strong',[_vm._v("Export")]),_vm._v(" → "),_c('strong',[_vm._v("Header String")]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("Paste above and click "),_c('strong',[_vm._v("\"Save & Update Server\"")]),_vm._v(".")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-space-between align-center",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button","disabled":_vm.testingConnection || _vm.updatingCookies},on:{"click":_vm.testLiveConnection}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("sync")]),_vm._v(" "),(_vm.testingConnection)?_c('span',[_vm._v("Testing Amazon...")]):_c('span',[_vm._v("Test Live Connection")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","disabled":!_vm.newCookies || _vm.newCookies.trim().length < 30 || _vm.updatingCookies},on:{"click":_vm.saveCookies}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("save")]),_vm._v(" "),(_vm.updatingCookies)?_c('span',[_vm._v("Saving & Verifying...")]):_c('span',[_vm._v("Save & Update Server")])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loggedInUserData.is_staff && !_vm.loggedInUserData.phone_verified)?_c('div',{staticClass:"verify-alert"},[_c('div',[_c('button',{staticClass:"verify-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.verifyAccount()}}},[_vm._v("\n        Verify your account\n      ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navbar navbar-default header-highlight",staticStyle:{"padding-left":"0px !important"}},[_c('ul',{staticClass:"nav navbar-nav",staticStyle:{"margin-left":"0px !important"}},[_c('li',[_c('a',{staticClass:"sidebar-control sidebar-main-toggle hidden-xs",staticStyle:{"padding-top":"20px"},attrs:{"data-toggle":"collapse"},on:{"click":function($event){return _vm.$emit('toggle-sidebar')}}},[_c('i',{staticClass:"fa fa-align-justify",class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout',staticStyle:{"font-size":"20px"}})])])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav visible-xs-block"},[_vm._m(1),_vm._v(" "),_c('li',{staticStyle:{"padding-top":"18px","padding-right":"13px","color":"#000","font-size":"16px","font-weight":"500"}},[_vm._v("\n          Shipzone\n        ")]),_vm._v(" "),(!_vm.loggedInUserData.is_staff)?_c('li',[(_vm.loggedInUserData.credit === null)?_c('h5',{staticStyle:{"color":"white","padding-top":"5px"}},[_vm._v("\n            Credit: $0\n          ")]):_c('h5',{staticStyle:{"color":"white","padding-top":"5px"}},[_vm._v("\n            Credit: $"+_vm._s(_vm.loggedInUserData.credit)+"\n          ")])]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('li',[_c('a',{staticStyle:{"font-size":"20px","padding-top":"18px"},on:{"click":function($event){return _vm.toggleShowSidebar()}}},[_c('i',{staticClass:"fa fa-align-justify"})])])])]),_vm._v(" "),_c('div',{staticClass:"navbar-collapse collapse",attrs:{"id":"navbar-mobile"}},[_c('div',{staticClass:"navbar-right"},[(false)?_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",staticStyle:{"text-align":"center"},attrs:{"data-toggle":"dropdown","id":"notification-icon"}},[_c('i',{staticClass:"fa fa-bell",staticStyle:{"font-size":"20px","padding-top":"5px","position":"relative"}},[(_vm.count !== 0)?_c('span',{staticClass:"status-mark bg-danger-400 media-badge",staticStyle:{"border":"5px","background-color":"#f44","position":"absolute","top":"3px","right":"-5px"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-content"},[_c('div',{staticClass:"dropdown-content-heading"},[_vm._v("\n                Notifications\n              ")]),_vm._v(" "),_c('ul',{staticClass:"media-list dropdown-content-body width-300"},_vm._l((_vm.apiResults),function(n){return _c('li',{key:n.order_notification_id,staticClass:"media"},[_c('div',{staticClass:"media-body"},[(n.is_open == 0 ? (_vm.count = 1) : '')?_c('span',{staticClass:"status-mark bg-danger-600 media-badge",staticStyle:{"border":"5px","margin-top":"2px","left":"-10px"}}):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":'/new-order?order=' + n.order_id,"tag":"a","active-class":"active"}},[_c('a',{staticStyle:{"color":"#555555"},on:{"click":function($event){return _vm.openNotification(n.order_notification_id, 'notification-icon')}}},[_vm._v(_vm._s(n.full_name)+" requested a new order\n                        "),_c('div',{staticClass:"media-annotation",staticStyle:{"color":"#555555"}},[_vm._v("\n                          "+_vm._s(n.created_at)+"\n                        ")])])])],1)])}),0),_vm._v(" "),_c('div',{staticClass:"dropdown-content-footer"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{on:{"click":function($event){return _vm.moreResult()}}},[_vm._v("View more")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('a',{on:{"click":function($event){return _vm.lesResult()}}},[_vm._v("View less")])])])])])]):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.is_staff)?_c('p',{staticClass:"navbar-text",staticStyle:{"padding-top":"20px","font-size":"17px","color":"black"}},[(_vm.loggedInUserData.credit === null)?_c('b',[_vm._v("Credit: $0")]):_c('b',[_vm._v("Credit: $"+_vm._s(_vm.loggedInUserData.credit))])]):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.is_staff)?_c('p',{staticClass:"navbar-text",staticStyle:{"padding-top":"20px"}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/charge-balance"}},[_c('span',{staticClass:"label",staticStyle:{"font-size":"13px","height":"auto","background-color":"#c26f02","padding":"1px 7px","border-radius":"20px","cursor":"pointer"}},[_c('span',{staticClass:"pr-1"},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v("\n              Add Balance\n            ")])])],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"navbar-text",staticStyle:{"padding-top":"20px"}},[(_vm.loggedInUserData.is_staff && _vm.$_has_perm('view_subscription'))?_c('router-link',{staticStyle:{"text-decoration":"none","margin":"0 10px"},attrs:{"to":"/subscription-pricing"}},[_c('span',{staticClass:"label",staticStyle:{"font-size":"13px","height":"auto","background-color":"#5B0D8FFF","padding":"1px 7px","border-radius":"20px","cursor":"pointer"}},[_c('span',{staticClass:"pr-1"},[_c('i',{staticClass:"fa fa-credit-card"})]),_vm._v("\n              Subscription\n            ")])]):_vm._e(),_vm._v(" "),(_vm.loggedInUserData.is_staff)?_c('router-link',{staticStyle:{"text-decoration":"none","margin":"0 10px"},attrs:{"to":"/currency-rate"}},[_c('span',{staticClass:"label",staticStyle:{"font-size":"13px","height":"auto","background-color":"#1C4F2BFF","padding":"1px 7px","border-radius":"20px","cursor":"pointer"}},[_c('span',{staticClass:"pr-1"},[_c('i',{staticClass:"fa fa-exchange"})]),_vm._v("\n              Exchange Rate: "+_vm._s(_vm.loggedInUserData.ex_rate)+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.loggedInUserData.is_staff && _vm.$_has_perm('process_new_order'))?_c('span',{staticClass:"label",staticStyle:{"font-size":"13px","height":"auto","background-color":"#FF9900","color":"#111","font-weight":"bold","padding":"2px 9px","border-radius":"20px","cursor":"pointer","margin":"0 8px","display":"inline-block"},attrs:{"title":"Amazon Server Session Settings"},on:{"click":_vm.openAmazonSessionModal}},[_vm._m(3),_vm._v("\n          Amazon Session\n        ")]):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-profile"}},[_c('span',{staticClass:"label",class:_vm.loggedInUserData.is_staff ? 'sidebar-admin' : 'cus-sidebar',staticStyle:{"font-size":"13px","height":"auto","padding":"1px 7px","border-radius":"20px","cursor":"pointer"}},[_c('span',{staticClass:"pr-1"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v("\n            "+_vm._s(_vm.loggedInUserData.full_name)+"\n          ")])])],1),_vm._v(" "),(_vm.loggedInUserData.is_staff)?_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",staticStyle:{"text-align":"center"},attrs:{"data-toggle":"dropdown","id":"notification-icon-2"}},[_c('i',{staticClass:"fa fa-bell",staticStyle:{"font-size":"20px","padding-top":"5px","position":"relative"}},[(_vm.apiResults2.length > 0)?_c('span',{staticClass:"status-mark bg-danger-400 media-badge",staticStyle:{"border":"5px","background-color":"#f44","position":"absolute","top":"3px","right":"-5px"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-content"},[_c('div',{staticClass:"dropdown-content-heading"},[_vm._v("\n                Warehouse date passed orders\n              ")]),_vm._v(" "),_c('ul',{staticClass:"media-list dropdown-content-body width-300"},_vm._l((_vm.apiResults2),function(n){return _c('li',{key:n.order_notification_id,staticClass:"media",attrs:{"id":("wh-noti-" + (n.order_notification_id))}},[_c('div',{staticClass:"media-body"},[_vm._v("\n                    #"+_vm._s(n.theOrderId)+"\n                    "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("Wh. Date: ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(n.warehouse_date))]),_vm._v(" "),_c('i',{staticClass:"fa fa-times error--text",staticStyle:{"margin-left":"20px","font-size":"16px","cursor":"pointer"},on:{"click":function($event){return _vm.hideNotification(n.order_notification_id)}}})])])}),0),_vm._v(" "),_c('div',{staticClass:"dropdown-content-footer"},[_c('div',{staticClass:"col-sm-6"},[_c('a',{on:{"click":function($event){return _vm.moreResult2()}}},[_vm._v("View more")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('a',{on:{"click":function($event){return _vm.lesResult2()}}},[_vm._v("View less")])])])])])]):_vm._e(),_vm._v(" "),_c('v-btn',{class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout',staticStyle:{"height":"auto","padding-top":"15px"},attrs:{"flat":""},on:{"click":function($event){return _vm.logout()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("power_settings_new")]),_vm._v("Logout")])],1)]),_vm._v(" "),(_vm.showSidebar && !_vm.loggedInUserData.is_staff)?_c('div',{staticClass:"cus-sidebar",attrs:{"id":"mobile-sidebar-list"}},[_c('div',{staticClass:"sidebar-category sidebar-category-visible sidebar-list"},[_c('div',{staticClass:"category-content no-padding"},[_c('ul',{staticClass:"navigation navigation-main navigation-accordion"},[_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/make-new-ship-only","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Ship Only")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/make-new-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons"},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("New Order")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons"},[_vm._v("filter_none")]),_vm._v(" "),_c('span',[_vm._v("Orders")])])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/my-order-cases","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"16px"}}),_vm._v("\n                Order Cases\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/archived-order","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"material-icons"},[_vm._v("archive")]),_vm._v("Archived Orders")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/charge-balance","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-money",staticStyle:{"font-size":"18px"}}),_vm._v("\n                Charge Balance\n              ")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/check-rate","tag":"li","active-class":"active"}},[_c('a',[_c('i',{staticClass:"fa fa-money",staticStyle:{"font-size":"18px"}}),_vm._v("\n                Check Rate\n              ")])]),_vm._v(" "),_c('li',[_vm._m(4),_vm._v(" "),_c('ul',[_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Order Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-order-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Shipping Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-credit-invoice","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Credit Invoices")])]),_vm._v(" "),_c('router-link',{staticClass:"sidebar-mobile-main-toggle",attrs:{"to":"/customer-partial-refund","tag":"li","active-class":"active"}},[_c('a',[_vm._v("Partial Refund Invoices")])])],1)])],1)])])]):_vm._e()]),_vm._v(" "),_c('amazon-session-modal',{ref:"amazonSessionModal"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"navbar-brand hidden-xs",staticStyle:{"padding-top":"8px"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"height":"40px","width":"40px","float":"left"},attrs:{"src":__webpack_require__(12),"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#333","padding":"13px 0px 10px 20px","font-size":"18px","font-weight":"500"}},[_vm._v("\n          Shipzone\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticStyle:{"padding-top":"10px","padding-right":"13px"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"height":"40px","width":"40px"},attrs:{"src":__webpack_require__(12),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"data-toggle":"collapse","data-target":"#navbar-mobile"}},[_c('i',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pr-1"},[_c('i',{staticClass:"fa fa-amazon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":""}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_c('span',[_vm._v("Invoices")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('navbar',{attrs:{"loggedInUserData":_vm.loggedInUserData},on:{"toggle-sidebar":function($event){_vm.toggleSidebar = !_vm.toggleSidebar}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"page-content"},[(_vm.toggleSidebar)?_c('sidebar',{attrs:{"loggedInUserData":_vm.loggedInUserData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content pb-0"},[_c('div',{staticClass:"panel panel-flat",staticStyle:{"height":"90vh","overflow":"scroll"}},[_c('router-view',{on:{"clicked":_vm.onClickChild}})],1)])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(471);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("48c2ec1e", content, true, {});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".my-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:16px}.my-card-title{font-size:20px;font-weight:500}.my-card-body{padding:16px}.vue-otp-2 div input{max-width:50px!important;padding:11.5px 8px;font-size:20px;border-radius:8px!important;border:1px solid #cecece;text-align:center}.container{max-width:400px;margin:auto}.congrats-box{background:linear-gradient(135deg,#006b8d,#00455b);padding:40px;border-radius:15px;box-shadow:0 4px 30px rgba(0,0,0,.1);text-align:center;animation:fadeIn 1s ease-in-out}.custom-icon{font-size:60px;opacity:1!important;animation:bounce 1.5s infinite}h1{font-size:2.5em;margin:20px 0}h1,p{color:#fff!important}p{font-size:1.2em;margin-bottom:30px}.custom-btn{padding:12px 30px;color:#fff;border:none;border-radius:25px;font-size:1em;text-decoration:none;transition:background-color .3s ease}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes bounce{0%,to{transform:translateY(0)}50%{transform:translateY(-10px)}}", ""]);

// exports


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row",staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{staticClass:"col-12 col-md-10 col-lg-5 col-xl-6"},[_c('div',{staticClass:"my-card"},[_c('div',{staticClass:"my-card-title text-center"},[_vm._v("Verify your account")]),_vm._v(" "),_c('div',{staticClass:"my-card-body"},[(_vm.step  == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-alert',{attrs:{"value":_vm.phoneError.length > 0,"color":"error"}},[_vm._v("\n                "+_vm._s(_vm.phoneError)+"\n              ")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number","error-messages":_vm.errors.collect('Phone Number'),"placeholder":"7701234567","data-vv-name":"Phone Number","hide-details":""},model:{value:(_vm.phone_number),callback:function ($$v) {_vm.phone_number=$$v},expression:"phone_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pt-4 text-center"},[_c('v-btn',{staticStyle:{"height":"auto","border-radius":"8px"},attrs:{"color":"primary","depressed":"","disabled":!_vm.phone_number || _vm.phone_number.length != 10,"loading":_vm.loading},on:{"click":function($event){return _vm.submit1()}}},[_vm._v("\n                Next\n              ")])],1)]):_vm._e(),_vm._v(" "),(_vm.step  == 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('vue-otp-2',{attrs:{"length":"6","join-character":"-","inputmode":"numeric","pattern":"[0-9]*"},on:{"onComplete":_vm.handleCompleteOtp}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pt-4 text-center"},[_c('v-btn',{staticStyle:{"height":"auto","border-radius":"8px"},attrs:{"color":"primary","depressed":"","disabled":!_vm.otpCode || _vm.otpCode.length != 6,"loading":_vm.loading},on:{"click":function($event){return _vm.submit2()}}},[_vm._v("\n                Next\n              ")])],1)]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit3()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Full Name","error-messages":_vm.errors.collect('Full Name'),"data-vv-name":"Full Name"},model:{value:(_vm.customer.full_name),callback:function ($$v) {_vm.$set(_vm.customer, "full_name", $$v)},expression:"customer.full_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Email","error-messages":_vm.errors.collect('Email'),"data-vv-name":"Email"},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Address","error-messages":_vm.errors.collect('Address'),"data-vv-name":"Address"},model:{value:(_vm.customer.address),callback:function ($$v) {_vm.$set(_vm.customer, "address", $$v)},expression:"customer.address"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"label":"Password","error-messages":_vm.errors.collect('Password'),"data-vv-name":"Password"},model:{value:(_vm.customer.password),callback:function ($$v) {_vm.$set(_vm.customer, "password", $$v)},expression:"customer.password"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"label":"Confirm Password","error-messages":_vm.errors.collect('Confirm Password'),"data-vv-name":"Confirm Password"},model:{value:(_vm.customer.confirm_password),callback:function ($$v) {_vm.$set(_vm.customer, "confirm_password", $$v)},expression:"customer.confirm_password"}})],1),_vm._v(" "),(_vm.passwordNotMatch)?_c('div',{staticClass:"col-sm-12"},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v("\n                  Confirm Password not match with Password\n                ")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pt-4 text-center"},[_c('v-btn',{staticStyle:{"height":"auto","border-radius":"8px"},attrs:{"color":"primary","depressed":"","type":"submit","loading":_vm.loading}},[_vm._v("\n                  Submit\n                ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.step  == 4)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"congrats-box"},[_c('div',{staticClass:"custom-icon"},[_vm._v("🎉")]),_vm._v(" "),_c('h1',[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',[_vm._v("Your account has been verified successfully.")]),_vm._v(" "),_c('v-btn',{staticClass:"rounded-pill custom-btn px-6",staticStyle:{"height":"auto","text-transform":"none","letter-spacing":"0.5px"},on:{"click":function($event){return _vm.backToHome()}}},[_vm._v("\n                Back To Home\n              ")])],1)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-1"},[_c('div',{staticStyle:{"padding-top":"20px","font-size":"16px"}},[_vm._v("+964")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(474);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f97a7962", content, true, {});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".fw-bold[data-v-cd0771d0],h2[data-v-cd0771d0],h3[data-v-cd0771d0],h5[data-v-cd0771d0]{font-weight:700}div[data-v-cd0771d0]{font-size:14px}", ""]);

// exports


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('h2',{staticClass:"mt-0 fw-bold"},[_vm._v("Privacy Policy for ShipZone")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Effective Date")]),_vm._v(": November 23, 2024")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('b',[_vm._v("Last Updated")]),_vm._v(": November 23, 2024")]),_vm._v(" "),_c('div',[_vm._v("\n    At "),_c('b',[_vm._v("ShipZone")]),_vm._v(" (\"we,\" \"our,\" or \"us\"), your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you use our mobile application (\"App\") and services. By using the App, you signify your agreement to this Privacy Policy.\n  ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("1. Definitions and Key Terms")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("To clarify frequently used terms in this policy, the following definitions apply:")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("App")]),_vm._v(": The ShipZone mobile application, through which services are provided.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Cookies")]),_vm._v(": Small files placed on your device to improve your experience, track app usage, and remember preferences.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Personal Data")]),_vm._v(": Any information that directly or indirectly identifies a person, such as name, email, or location.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Service")]),_vm._v(": Refers to the import/export services provided by ShipZone through the App.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("You")]),_vm._v(": A person or entity using ShipZone's services.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("2. Information We Collect")]),_vm._v(" "),_c('div',[_vm._v("We collect the following types of information:")]),_vm._v(" "),_c('h5',[_vm._v("a. Personal Information")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Name")]),_vm._v(": For identification and order processing.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Email Address")]),_vm._v(": For account setup, notifications, and customer communication.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Phone Number")]),_vm._v(": For account verification and support.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Location Data")]),_vm._v(": To calculate shipping costs and delivery options.")])]),_vm._v(" "),_c('h5',[_vm._v("b. Optional Permissions")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Photo Gallery")]),_vm._v(": If you upload images for product descriptions or order verification.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("GPS Location")]),_vm._v(": To enhance the accuracy of delivery and location-based services.")])]),_vm._v(" "),_c('h5',[_vm._v("c. Non-Personal Information")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Device Information")]),_vm._v(": Such as your operating system, device model, and unique device identifiers.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Usage Data")]),_vm._v(": Includes app interaction data, such as visited pages and clicked features.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("3. How We Use Your Information")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("We use the information we collect for the following purposes:")]),_vm._v(" "),_c('b',[_vm._v("To Provide Services:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Process import/export orders.")]),_vm._v(" "),_c('li',[_vm._v("Verify user identity through phone number verification.")]),_vm._v(" "),_c('li',[_vm._v("Calculate shipping costs and delivery times.")]),_vm._v(" "),_c('li',[_vm._v("Provide order tracking and updates.")])]),_vm._v(" "),_c('b',[_vm._v("For Communication:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Notify you about updates, promotions, or changes to our services.")]),_vm._v(" "),_c('li',[_vm._v("Respond to customer inquiries and provide support.")])]),_vm._v(" "),_c('b',[_vm._v("For Improvement and Personalization:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Enhance the functionality and user experience of the App.")]),_vm._v(" "),_c('li',[_vm._v("Customize content and recommendations.")])]),_vm._v(" "),_c('b',[_vm._v("For Legal Compliance:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Comply with applicable laws, such as customs regulations.")]),_vm._v(" "),_c('li',[_vm._v("Prevent fraud, unauthorized access, or other illegal activities.")])]),_vm._v(" "),_c('b',[_vm._v("Account Management:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To create, verify, and maintain your account")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("4. Cookies and Tracking Technologies")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("We use cookies and similar tracking technologies to:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Improve App functionality and user experience.")]),_vm._v(" "),_c('li',[_vm._v("Analyze usage patterns to enhance performance.")]),_vm._v(" "),_c('li',[_vm._v("Enable personalized advertising (if applicable).")])]),_vm._v(" "),_c('div',[_vm._v("You can manage or disable cookies through your device settings, but this may affect App functionality.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("5. Sharing Your Information")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("We may share your information with:")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Service Providers")]),_vm._v(": For payment processing, shipping, and customer support.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Government Authorities")]),_vm._v(": To comply with customs or legal requirements.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Business Partners")]),_vm._v(": If required to fulfill your orders.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Successors")]),_vm._v(": In the event of a merger, acquisition, or sale of assets.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Advertising Partners")]),_vm._v(": For analytics and remarketing, with your consent.")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("6. Data Transfers to Other Countries")]),_vm._v(" "),_c('div',[_vm._v("If you are located outside Iraq, your data may be transferred to and processed in Iraq or other countries where we operate. By using the App, you consent to such transfers.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("7. Data Retention")]),_vm._v(" "),_c('div',[_vm._v("We retain your information as long as necessary to provide our services and comply with legal obligations. Once no longer needed, your data will be securely deleted or anonymized.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("8. Security Measures")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("We implement strong technical and administrative measures to safeguard your data, including:")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("SSL Encryption")]),_vm._v(": For secure transmission of sensitive data.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Restricted Access")]),_vm._v(": Ensuring only authorized personnel can access your data.")])]),_vm._v(" "),_c('div',[_vm._v("However, no system is completely secure, and we cannot guarantee absolute protection.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("9. Your Rights")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("Depending on your location, you may have the following rights:")]),_vm._v(" "),_c('ul',[_c('li',[_c('b',[_vm._v("Access")]),_vm._v(": Request a copy of the data we hold about you.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Correction")]),_vm._v(": Update inaccurate or incomplete information.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Deletion")]),_vm._v(": Request the removal of your personal data, subject to legal requirements.")]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Data Portability")]),_vm._v(": Receive your data in a machine-readable format.")])]),_vm._v(" "),_c('div',[_vm._v("To exercise your rights, contact us at info@shipzone.co.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("10. Remarketing and Advertising")]),_vm._v(" "),_c('div',[_vm._v("We may use third-party advertising tools (e.g., Facebook Pixel, Google Ads) to show targeted ads based on your interactions with the App.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("11. Changes to This Privacy Policy")]),_vm._v(" "),_c('div',[_vm._v("We may update this Privacy Policy periodically. Significant changes will be communicated via the App or email. Continued use of the App after updates constitutes acceptance of the revised policy.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("12. Third-Party Links and Content")]),_vm._v(" "),_c('div',[_vm._v("The App may include links to external websites or services. We are not responsible for the privacy practices or content of these third parties.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("13. Contact Us")]),_vm._v(" "),_c('div',[_vm._v("If you have questions or concerns about this Privacy Policy, contact us at:")]),_vm._v(" "),_c('div',{staticClass:"fw-bold"},[_vm._v("ShipZone")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Email")]),_vm._v(": info@shipzone.co")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Phone")]),_vm._v(": +9647504650778")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Address")]),_vm._v(": Sultan Mudhafar Street, Erbil, Iraq")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-content',[(_vm.verifyUser)?_c('CustomerVerification'):(_vm.privacyAndPolicy)?_c('PrivacyAndPolicy'):[(!_vm.logged_in)?[(_vm.adminLogin)?_c('staff-login',{attrs:{"changeLogin":_vm.changeLogin}}):(!_vm.adminLogin)?_c('login-component',{attrs:{"changeLogin":_vm.changeLogin,"changePhoneLogin":_vm.changePhoneLogin}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.logged_in)?_c('page-container'):_vm._e()]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_newOrder_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pendingAnswerOrder_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_processedOrder_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_canceledOrder_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_approvedOrder_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_refundedOrder_vue__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_purchasedOrder_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_warehouseDeliveredOrder_vue__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_intShipmentOrder_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pendingToShipment_pendingToShipment_vue__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_branchDeliveredOrder_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pendingToBranchOrder_vue__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_user_user_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_user_userProfile_vue__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_user_regularUser_vue__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_userDeliveredOrder_vue__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_adminArchivedOrder_vue__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_user_user_credit_credit_vue__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_logs_creditLogTransaction_vue__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_logs_creditLogAction_vue__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_coupons_coupon_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_home_vue__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_customer_myOrders_vue__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_customer_myOrderCases_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_customer_exportOrder_myExportOrders_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_customer_exportOrder_addExportOrder_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_customer_exportOrder_myExportOrderDetail_vue__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_customer_archivedOrder_vue__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_customer_invoices_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_customer_orderDetail_vue__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_customer_makeNewOrder_vue__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_customer_addNewShipOnly_vue__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_customer_newShipOnly_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_customer_chargeBalance_vue__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_orderLog_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_secret_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_customer_customerCreditInvoice_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_customer_customerOrderInvoices_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_customer_payWithFib_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_customer_payWithFastPay_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_customer_payWithQi_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_customer_payWithZainCash_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_customer_checkRate_vue__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_exportableOrder_vue__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_allOrder_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_warehouseDatePassed_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_customerPrices__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_kreenexFeePrices__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_shippingPrices__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_bank_banks__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_exchangeRate_exchangeRate__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_report_deliveredReport__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_user_loanedCustomers_vue__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_shipOnly_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_supplier_suppliers_vue__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_expenseType_expenseTypes_vue__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_expense_expenses_vue__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_orderInvoice_orderInvoices_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_capital_vue__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_profit_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_pallet_pallets_vue__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_moneyTransfer_moneyTransfer_vue__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_putMoney_putMoney_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_roles_roles_vue__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_partialRefundInvoices_vue__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_customer_customerPartialRefundInvoices_vue__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_deliveryInvoice_deliveryInvoices_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_purchaseHistory_vue__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_city_city_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_governorate_governorate_vue__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_CancellationReason_reason_vue__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_about_about_vue__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_notFoundOrder_notFoundOrders_vue__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_orderCase_orderCases_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_orderCase_orderCaseUsers_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_customerRegistration_vue__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_homeSlider_homeSlider_vue__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_homeBanner_homeBanner_vue__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_popularWebsite_popularWebsite_vue__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_globalWebsite_globalWebsiteGroup_vue__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_globalWebsite_globalWebsite_vue__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_orderDelivery_orderDeliveries_vue__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_notification_sendNotification_vue__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_exportOrder_pendingExportOrder_vue__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_exportOrder_processedExportOrder_vue__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_exportOrder_refundedExportOrder_vue__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_exportOrder_canceledExportOrder_vue__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_exportOrder_approvedExportOrder_vue__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_exportOrder_sentExportOrder_vue__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_exportOrder_receivedExportOrder_vue__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_exportOrder_exportHistory_vue__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_currencyRate_currencyRate_vue__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_customerVerification_CustomerVerification_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__PrivacyAndPolicy_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_warehouse_warehouse_vue__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_forceUpdate_forceUpdate_vue__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_ourAddress_ourAddress_vue__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_subscription_subscription_vue__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_user_subscription_userSubscription_vue__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_subscription_pricing_subscriptionPricing_vue__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_orderType_orderTypes_vue__ = __webpack_require__(1261);


































































// import Branch from './components/branch/branches.vue'






































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/customer-registration',
    component: __WEBPACK_IMPORTED_MODULE_77__components_customerRegistration_vue__["a" /* default */]
  }, {
    path: '/customer-verification',
    component: __WEBPACK_IMPORTED_MODULE_94__components_customerVerification_CustomerVerification_vue__["a" /* default */]
  }, {
    path: '/privacy-and-policy',
    component: __WEBPACK_IMPORTED_MODULE_95__PrivacyAndPolicy_vue__["default"]
  },
  // {
  //   path: '/branch',
  //   component: Branch
  // },
  {
    path: '/force-update',
    component: __WEBPACK_IMPORTED_MODULE_97__components_forceUpdate_forceUpdate_vue__["a" /* default */]
  }, {
    path: '/our-address',
    component: __WEBPACK_IMPORTED_MODULE_98__components_ourAddress_ourAddress_vue__["a" /* default */]
  }, {
    path: '/warehouse',
    component: __WEBPACK_IMPORTED_MODULE_96__components_warehouse_warehouse_vue__["a" /* default */]
  }, {
    path: '/send-notification',
    component: __WEBPACK_IMPORTED_MODULE_84__components_notification_sendNotification_vue__["a" /* default */]
  }, {
    path: '/roles',
    component: __WEBPACK_IMPORTED_MODULE_65__components_roles_roles_vue__["a" /* default */]
  }, {
    path: '/put_money',
    component: __WEBPACK_IMPORTED_MODULE_64__components_putMoney_putMoney_vue__["a" /* default */]
  }, {
    path: '/partial-refund',
    component: __WEBPACK_IMPORTED_MODULE_66__components_partialRefundInvoices_vue__["a" /* default */]
  }, {
    path: '/not-found-orders',
    component: __WEBPACK_IMPORTED_MODULE_74__components_notFoundOrder_notFoundOrders_vue__["a" /* default */]
  }, {
    path: '/order-cases',
    component: __WEBPACK_IMPORTED_MODULE_75__components_orderCase_orderCases_vue__["a" /* default */]
  }, {
    path: '/order-case-progress',
    component: __WEBPACK_IMPORTED_MODULE_76__components_orderCase_orderCaseUsers_vue__["a" /* default */]
  }, {
    path: '/customer-partial-refund',
    component: __WEBPACK_IMPORTED_MODULE_67__components_customer_customerPartialRefundInvoices_vue__["a" /* default */]
  }, {
    path: '/delivery-invoice',
    component: __WEBPACK_IMPORTED_MODULE_68__components_deliveryInvoice_deliveryInvoices_vue__["a" /* default */]
  }, {
    path: '/purchase-history',
    component: __WEBPACK_IMPORTED_MODULE_69__components_purchaseHistory_vue__["a" /* default */]
  }, {
    path: '/export-order/pending',
    component: __WEBPACK_IMPORTED_MODULE_85__components_exportOrder_pendingExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/processed',
    component: __WEBPACK_IMPORTED_MODULE_86__components_exportOrder_processedExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/canceled',
    component: __WEBPACK_IMPORTED_MODULE_88__components_exportOrder_canceledExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/approved',
    component: __WEBPACK_IMPORTED_MODULE_89__components_exportOrder_approvedExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/sent',
    component: __WEBPACK_IMPORTED_MODULE_90__components_exportOrder_sentExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/received',
    component: __WEBPACK_IMPORTED_MODULE_91__components_exportOrder_receivedExportOrder_vue__["a" /* default */]
  }, {
    path: '/export-order/export-history',
    component: __WEBPACK_IMPORTED_MODULE_92__components_exportOrder_exportHistory_vue__["a" /* default */]
  }, {
    path: '/export-order/refunded',
    component: __WEBPACK_IMPORTED_MODULE_87__components_exportOrder_refundedExportOrder_vue__["a" /* default */]
  }, {
    path: '/profit',
    component: __WEBPACK_IMPORTED_MODULE_61__components_profit_vue__["a" /* default */]
  }, {
    path: '/money-transfer',
    component: __WEBPACK_IMPORTED_MODULE_63__components_moneyTransfer_moneyTransfer_vue__["a" /* default */]
  }, {
    path: '/capital',
    component: __WEBPACK_IMPORTED_MODULE_60__components_capital_vue__["a" /* default */]
  }, {
    path: '/expense-type',
    component: __WEBPACK_IMPORTED_MODULE_57__components_expenseType_expenseTypes_vue__["a" /* default */]
  }, {
    path: '/expense',
    component: __WEBPACK_IMPORTED_MODULE_58__components_expense_expenses_vue__["a" /* default */]
  }, {
    path: '/order_invoice',
    component: __WEBPACK_IMPORTED_MODULE_59__components_orderInvoice_orderInvoices_vue__["a" /* default */]
  }, {
    path: '/order-types',
    component: __WEBPACK_IMPORTED_MODULE_102__components_orderType_orderTypes_vue__["a" /* default */]
  }, {
    path: '/supplier',
    component: __WEBPACK_IMPORTED_MODULE_56__components_supplier_suppliers_vue__["a" /* default */]
  }, {
    path: '/ship-only',
    component: __WEBPACK_IMPORTED_MODULE_55__components_shipOnly_vue__["a" /* default */]
  }, {
    path: '/loan-customers',
    component: __WEBPACK_IMPORTED_MODULE_54__components_user_loanedCustomers_vue__["a" /* default */]
  }, {
    path: '/delivered-report',
    component: __WEBPACK_IMPORTED_MODULE_53__components_report_deliveredReport__["a" /* default */]
  }, {
    path: '/exchange-rate',
    component: __WEBPACK_IMPORTED_MODULE_52__components_exchangeRate_exchangeRate__["a" /* default */]
  }, {
    path: '/banks',
    component: __WEBPACK_IMPORTED_MODULE_51__components_bank_banks__["a" /* default */]
  }, {
    path: '/currency-rate',
    component: __WEBPACK_IMPORTED_MODULE_93__components_currencyRate_currencyRate_vue__["a" /* default */]
  }, {
    path: '/shipping-prices',
    component: __WEBPACK_IMPORTED_MODULE_50__components_shippingPrices__["a" /* default */]
  }, {
    path: '/kreenex-fee-prices',
    component: __WEBPACK_IMPORTED_MODULE_49__components_kreenexFeePrices__["a" /* default */]
  }, {
    path: '/customer-prices',
    component: __WEBPACK_IMPORTED_MODULE_48__components_customerPrices__["a" /* default */]
  }, {
    path: '/new-order',
    component: __WEBPACK_IMPORTED_MODULE_2__components_newOrder_vue__["a" /* default */]
  }, {
    path: '/pending-answer-order',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pendingAnswerOrder_vue__["a" /* default */]
  }, {
    path: '/processed_order',
    component: __WEBPACK_IMPORTED_MODULE_4__components_processedOrder_vue__["a" /* default */]
  }, {
    path: '/canceled_order',
    component: __WEBPACK_IMPORTED_MODULE_5__components_canceledOrder_vue__["a" /* default */]
  }, {
    path: '/approved_order',
    component: __WEBPACK_IMPORTED_MODULE_6__components_approvedOrder_vue__["a" /* default */]
  }, {
    path: '/refunded_order',
    component: __WEBPACK_IMPORTED_MODULE_7__components_refundedOrder_vue__["a" /* default */]
  }, {
    path: '/purchased_order',
    component: __WEBPACK_IMPORTED_MODULE_8__components_purchasedOrder_vue__["a" /* default */]
  }, {
    path: '/warehouse_delivered_order',
    component: __WEBPACK_IMPORTED_MODULE_9__components_warehouseDeliveredOrder_vue__["a" /* default */]
  }, {
    path: '/pending_to_shipment_order',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pendingToShipment_pendingToShipment_vue__["a" /* default */]
  }, {
    path: '/int_shipment_order',
    component: __WEBPACK_IMPORTED_MODULE_10__components_intShipmentOrder_vue__["a" /* default */]
  }, {
    path: '/pallets',
    component: __WEBPACK_IMPORTED_MODULE_62__components_pallet_pallets_vue__["a" /* default */]
  }, {
    path: '/pending_to_branch_order',
    component: __WEBPACK_IMPORTED_MODULE_13__components_pendingToBranchOrder_vue__["a" /* default */]
  }, {
    path: '/branch_delivery_order',
    component: __WEBPACK_IMPORTED_MODULE_12__components_branchDeliveredOrder_vue__["a" /* default */]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_23__components_home_vue__["a" /* default */]
  }, {
    path: '/subscription',
    component: __WEBPACK_IMPORTED_MODULE_99__components_subscription_subscription_vue__["a" /* default */]
  }, {
    path: '/customer-subscription',
    component: __WEBPACK_IMPORTED_MODULE_100__components_user_subscription_userSubscription_vue__["a" /* default */]
  }, {
    path: '/subscription-pricing',
    component: __WEBPACK_IMPORTED_MODULE_101__components_subscription_pricing_subscriptionPricing_vue__["a" /* default */]
  }, {
    path: '/users',
    component: __WEBPACK_IMPORTED_MODULE_14__components_user_user_vue__["a" /* default */]
  }, {
    path: '/my-profile',
    component: __WEBPACK_IMPORTED_MODULE_15__components_user_userProfile_vue__["a" /* default */]
  }, {
    path: '/regular-user',
    component: __WEBPACK_IMPORTED_MODULE_16__components_user_regularUser_vue__["a" /* default */]
  }, {
    path: '/user-delivered-order',
    component: __WEBPACK_IMPORTED_MODULE_17__components_userDeliveredOrder_vue__["a" /* default */]
  }, {
    path: '/admin-archived-order',
    component: __WEBPACK_IMPORTED_MODULE_18__components_adminArchivedOrder_vue__["a" /* default */]
  }, {
    path: '/credit',
    component: __WEBPACK_IMPORTED_MODULE_19__components_user_user_credit_credit_vue__["a" /* default */]
  }, {
    path: '/credit-log-transaction',
    component: __WEBPACK_IMPORTED_MODULE_20__components_logs_creditLogTransaction_vue__["a" /* default */]
  }, {
    path: '/credit-log-action',
    component: __WEBPACK_IMPORTED_MODULE_21__components_logs_creditLogAction_vue__["a" /* default */]
  }, {
    path: '/coupon',
    component: __WEBPACK_IMPORTED_MODULE_22__components_coupons_coupon_vue__["a" /* default */]
  }, {
    path: '/my-order',
    component: __WEBPACK_IMPORTED_MODULE_24__components_customer_myOrders_vue__["a" /* default */]
  }, {
    path: '/my-order-cases',
    component: __WEBPACK_IMPORTED_MODULE_25__components_customer_myOrderCases_vue__["a" /* default */]
  }, {
    path: '/my-export-order',
    component: __WEBPACK_IMPORTED_MODULE_26__components_customer_exportOrder_myExportOrders_vue__["a" /* default */]
  }, {
    path: '/add-new-export-order',
    component: __WEBPACK_IMPORTED_MODULE_27__components_customer_exportOrder_addExportOrder_vue__["a" /* default */]
  }, {
    path: '/my-export-order-detail/:id',
    component: __WEBPACK_IMPORTED_MODULE_28__components_customer_exportOrder_myExportOrderDetail_vue__["a" /* default */]
  }, {
    path: '/archived-order',
    component: __WEBPACK_IMPORTED_MODULE_29__components_customer_archivedOrder_vue__["a" /* default */]
  }, {
    path: '/customer-invoice',
    component: __WEBPACK_IMPORTED_MODULE_30__components_customer_invoices_vue__["a" /* default */]
  }, {
    path: '/order-detail',
    component: __WEBPACK_IMPORTED_MODULE_31__components_customer_orderDetail_vue__["a" /* default */]
  }, {
    path: '/make-new-order/:order_id?',
    component: __WEBPACK_IMPORTED_MODULE_32__components_customer_makeNewOrder_vue__["a" /* default */]
  }, {
    path: '/make-new-ship-only',
    component: __WEBPACK_IMPORTED_MODULE_33__components_customer_addNewShipOnly_vue__["a" /* default */]
  }, {
    path: '/new-ship-only',
    component: __WEBPACK_IMPORTED_MODULE_34__components_customer_newShipOnly_vue__["a" /* default */]
  }, {
    path: '/shipzone-admin',
    component: __WEBPACK_IMPORTED_MODULE_23__components_home_vue__["a" /* default */]
  }, {
    path: '/order-log',
    component: __WEBPACK_IMPORTED_MODULE_36__components_orderLog_vue__["a" /* default */]
  }, {
    path: '/secret',
    component: __WEBPACK_IMPORTED_MODULE_37__components_secret_vue__["a" /* default */]
  }, {
    path: '/customer-credit-invoice',
    component: __WEBPACK_IMPORTED_MODULE_38__components_customer_customerCreditInvoice_vue__["a" /* default */]
  }, {
    path: '/customer-order-invoice',
    component: __WEBPACK_IMPORTED_MODULE_39__components_customer_customerOrderInvoices_vue__["a" /* default */]
  }, {
    path: '/charge-balance',
    component: __WEBPACK_IMPORTED_MODULE_35__components_customer_chargeBalance_vue__["a" /* default */]
  }, {
    path: '/pay-with-fib',
    component: __WEBPACK_IMPORTED_MODULE_40__components_customer_payWithFib_vue__["a" /* default */]
  }, {
    path: '/pay-with-fastpay',
    component: __WEBPACK_IMPORTED_MODULE_41__components_customer_payWithFastPay_vue__["a" /* default */]
  }, {
    path: '/pay-with-qi',
    component: __WEBPACK_IMPORTED_MODULE_42__components_customer_payWithQi_vue__["a" /* default */]
  }, {
    path: '/pay-with-zaincash',
    component: __WEBPACK_IMPORTED_MODULE_43__components_customer_payWithZainCash_vue__["a" /* default */]
  }, {
    path: '/check-rate',
    component: __WEBPACK_IMPORTED_MODULE_44__components_customer_checkRate_vue__["a" /* default */]
  }, {
    path: '/exportable-order',
    component: __WEBPACK_IMPORTED_MODULE_45__components_exportableOrder_vue__["a" /* default */]
  }, {
    path: '/all-order',
    component: __WEBPACK_IMPORTED_MODULE_46__components_allOrder_vue__["a" /* default */]
  }, {
    path: '/warehouse-date-passed',
    component: __WEBPACK_IMPORTED_MODULE_47__components_warehouseDatePassed_vue__["a" /* default */]
  }, {
    path: '/city',
    component: __WEBPACK_IMPORTED_MODULE_70__components_city_city_vue__["a" /* default */]
  }, {
    path: '/governorate',
    component: __WEBPACK_IMPORTED_MODULE_71__components_governorate_governorate_vue__["a" /* default */]
  }, {
    path: '/reason',
    component: __WEBPACK_IMPORTED_MODULE_72__components_CancellationReason_reason_vue__["a" /* default */]
  }, {
    path: '/about',
    component: __WEBPACK_IMPORTED_MODULE_73__components_about_about_vue__["a" /* default */]
  }, {
    path: '/home-banner',
    component: __WEBPACK_IMPORTED_MODULE_79__components_homeBanner_homeBanner_vue__["a" /* default */]
  }, {
    path: '/home-slider',
    component: __WEBPACK_IMPORTED_MODULE_78__components_homeSlider_homeSlider_vue__["a" /* default */]
  }, {
    path: '/popular-website',
    component: __WEBPACK_IMPORTED_MODULE_80__components_popularWebsite_popularWebsite_vue__["a" /* default */]
  }, {
    path: '/global-website-group',
    component: __WEBPACK_IMPORTED_MODULE_81__components_globalWebsite_globalWebsiteGroup_vue__["a" /* default */]
  }, {
    path: '/global-website-group/:id/sites',
    name: 'global-website-group.sites',
    component: __WEBPACK_IMPORTED_MODULE_82__components_globalWebsite_globalWebsite_vue__["a" /* default */]
  }, {
    path: '/order-delivery',
    component: __WEBPACK_IMPORTED_MODULE_83__components_orderDelivery_orderDeliveries_vue__["a" /* default */]
  }, {
    path: '*',
    component: {
      template: '<div width="100%" class="text-center">\n                                    <img src="../assets/images/not_found.jpg" alt="">\n                                </div>'
    }
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newOrder_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab49fb82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newOrder_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab49fb82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(481);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52a55dca", content, true, {});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.product-meta-row{flex-wrap:wrap;gap:3px 5px;margin-top:3px;line-height:1}.product-meta-row,.product-pill{display:inline-flex;align-items:center}.product-pill{font-size:10px;font-weight:500;line-height:1.35;padding:1px 6px;border-radius:4px;text-transform:none!important;letter-spacing:.01em;white-space:nowrap;box-shadow:0 1px 2px rgba(0,0,0,.04)}.product-pill.pill-price{background-color:#ecfdf5;color:#065f46;border:1px solid #a7f3d0}.product-pill.pill-weight{background-color:#eff6ff;color:#1e40af;border:1px solid #bfdbfe}.product-pill .pill-unit{font-weight:600}.product-pill .pill-mult{font-weight:500;opacity:.85;margin-left:3px;font-size:9.5px}", ""]);

// exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(483);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("724a5f32", content, true, {});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "a.disabled[data-v-31a09f94]{pointer-events:none}.pagination[data-v-31a09f94]{justify-content:flex-end!important}.pagination .page-stats[data-v-31a09f94]{align-items:center;margin-right:5px}i[data-v-31a09f94]{color:#4caf50}.pagination__item1[data-v-31a09f94]{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);border-radius:4px;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:transparent;height:34px;width:34px;margin:.3rem;text-decoration:none;transition:.3s cubic-bezier(0,0,.2,1);background-color:#4caf50}", ""]);

// exports


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 text-right"},[_c('nav',{staticClass:"pagination"},[_c('ul',[(_vm.pagination.prevPageUrl)?_c('li',{staticStyle:{"display":"inline"}},[_c('a',{staticClass:"pagination__item",on:{"click":function($event){_vm.changePage(_vm.pagination.prevPageUrl), _vm.decreaseX()}}},[_c('i',{staticClass:"fa fa-angle-left",staticStyle:{"font-size":"30px","padding-right":"10px"}})])]):_c('li',{staticStyle:{"display":"inline"}},[_vm._m(0)]),_vm._v(" "),_vm._l((_vm.totalPages),function(p){return _c('li',{key:p,staticStyle:{"display":"inline"}},[_c('a',{class:p + _vm.x === _vm.pagination.currentPage ? 'pagination__item1' : 'pagination__item',style:(p + _vm.x === _vm.pagination.currentPage
              ? 'font-size: 24px; color: white'
              : 'font-size: 24px; color: #4caf50;'),on:{"click":function($event){_vm.changePage(
              _vm.pagination.lastPageUrl
                .substring(0, _vm.pagination.lastPageUrl.lastIndexOf('='))
                .concat('=')
                .concat(p + _vm.x)
            )}}},[_vm._v("\n          "+_vm._s(p + _vm.x)+"\n        ")])])}),_vm._v(" "),(_vm.pagination.nextPageUrl)?_c('li',{staticStyle:{"display":"inline"}},[_c('a',{staticClass:"pagination__item",on:{"click":function($event){_vm.changePage(_vm.pagination.nextPageUrl), _vm.increaseX()}}},[_c('i',{staticClass:"fa fa-angle-right",staticStyle:{"font-size":"30px","padding-left":"10px"}})])]):_c('li',{staticStyle:{"display":"inline"}},[_vm._m(1)])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"disabled pagination__item"},[_c('i',{staticClass:"fa fa-angle-left",staticStyle:{"color":"grey","font-size":"30px","padding-right":"10px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"disabled pagination__item"},[_c('i',{staticClass:"fa fa-angle-right",staticStyle:{"color":"grey","font-size":"30px","padding-left":"10px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(486);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4154f649", content, true, {});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".input-group--select.input-group--single-line.primary--text[data-v-0d87483d]{padding:0!important}a[data-v-0d87483d]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-0d87483d]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:768px){.mobile[data-v-0d87483d]{float:left}}.pointer[data-v-0d87483d]{cursor:pointer}.not-allowed[data-v-0d87483d]{cursor:not-allowed}.filter-branch-btn[data-v-0d87483d]:hover{background-color:#2887e5!important}.animate-filter-branch-btn[data-v-0d87483d]{animation:filter-branch-animation-data-v-0d87483d .4s 1}@keyframes filter-branch-animation-data-v-0d87483d{0%{opacity:1}50%{opacity:.5}to{opacity:1}}", ""]);

// exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(488);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f47c0b8", content, true, {});

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".datepicker-overlay[data-v-6332d68b]{position:fixed;width:100%;height:100%;z-index:998;top:0;left:0;overflow:hidden;-webkit-animation:fadein-data-v-6332d68b .5s;-moz-animation:fadein-data-v-6332d68b .5s;-ms-animation:fadein-data-v-6332d68b .5s;-o-animation:fadein-data-v-6332d68b .5s;animation:fadein-data-v-6332d68b .5s}@keyframes fadein-data-v-6332d68b{0%{opacity:0}to{opacity:1}}@-moz-keyframes fadein-data-v-6332d68b{0%{opacity:0}to{opacity:1}}@-webkit-keyframes fadein-data-v-6332d68b{0%{opacity:0}to{opacity:1}}@-ms-keyframes fadein-data-v-6332d68b{0%{opacity:0}to{opacity:1}}@-o-keyframes fadein-data-v-6332d68b{0%{opacity:0}to{opacity:1}}.cov-date-body[data-v-6332d68b]{display:inline-block;background:#3f51b5;overflow:hidden;position:relative;font-size:16px;font-family:Roboto;font-weight:400;position:fixed;display:block;width:400px;max-width:100%;z-index:999;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);box-shadow:0 1px 3px 0 rgba(0,0,0,.2)}.cov-picker-box[data-v-6332d68b]{background:#fff;width:100%;display:inline-block;padding:25px;box-sizing:border-box!important;-moz-box-sizing:border-box!important;-webkit-box-sizing:border-box!important;-ms-box-sizing:border-box!important;width:400px;max-width:100%;height:280px;text-align:start!important}.cov-picker-box td[data-v-6332d68b]{height:34px;width:34px;padding:0;line-height:34px;color:#000;background:#fff;text-align:center;cursor:pointer}.cov-picker-box td[data-v-6332d68b]:hover{background:#e6e6e6}table[data-v-6332d68b]{border-collapse:collapse;border-spacing:0;width:100%}.day[data-v-6332d68b]{width:14.2857143%;display:inline-block;text-align:center;cursor:pointer;height:34px;padding:0;line-height:34px;color:#000;background:#fff;vertical-align:middle}.week ul[data-v-6332d68b]{margin:0 0 8px;padding:0;list-style:none}.week ul li[data-v-6332d68b]{width:14.2%;display:inline-block;text-align:center;background:transparent;color:#000;font-weight:700}.passive-day[data-v-6332d68b]{color:#bbb}.checked[data-v-6332d68b]{background:#f50057;color:#fff!important;border-radius:3px}.unavailable[data-v-6332d68b]{color:#ccc;cursor:not-allowed}.cov-date-monthly[data-v-6332d68b]{height:150px}.cov-date-monthly>div[data-v-6332d68b]{display:inline-block;padding:0;margin:0;vertical-align:middle;color:#fff;height:150px;float:left;text-align:center;cursor:pointer}.cov-date-next[data-v-6332d68b],.cov-date-previous[data-v-6332d68b]{position:relative;width:20%!important;text-indent:-300px;overflow:hidden;color:#fff}.cov-date-caption[data-v-6332d68b]{width:60%;padding:50px 0!important;box-sizing:border-box;font-size:24px}.cov-date-caption span[data-v-6332d68b]:hover{color:hsla(0,0%,100%,.7)}.cov-date-next[data-v-6332d68b]:hover,.cov-date-previous[data-v-6332d68b]:hover{background:hsla(0,0%,100%,.1)}.day[data-v-6332d68b]:hover{background:#eaeaea}.unavailable[data-v-6332d68b]:hover{background:none}.checked[data-v-6332d68b]:hover{background:#ff4f8e}.cov-date-next[data-v-6332d68b]:before,.cov-date-previous[data-v-6332d68b]:before{width:20px;height:2px;text-align:center;position:absolute;background:#fff;top:50%;margin-top:-7px;margin-left:-7px;left:50%;line-height:0;content:\"\";-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);transform:rotate(45deg)}.cov-date-next[data-v-6332d68b]:after,.cov-date-previous[data-v-6332d68b]:after{width:20px;height:2px;text-align:center;position:absolute;background:#fff;margin-top:6px;margin-left:-7px;top:50%;left:50%;line-height:0;content:\"\";-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);transform:rotate(-45deg)}.cov-date-previous[data-v-6332d68b]:after{-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);transform:rotate(45deg)}.cov-date-previous[data-v-6332d68b]:before{-webkit-transform:rotate(-45deg);-moz-transform:rotate(-45deg);transform:rotate(-45deg)}.date-item[data-v-6332d68b]{text-align:center;font-size:20px;padding:10px 0;cursor:pointer}.date-item[data-v-6332d68b]:hover{background:#e0e0e0}.date-list[data-v-6332d68b]{overflow:auto;vertical-align:top;padding:0}.cov-vue-date[data-v-6332d68b]{display:inline-block;color:#5d5d5d}.button-box[data-v-6332d68b]{background:#fff;vertical-align:top;height:50px;line-height:50px;text-align:right;padding-right:20px}.button-box span[data-v-6332d68b]{cursor:pointer;padding:10px 20px}.watch-box[data-v-6332d68b]{height:100%;overflow:hidden}.hour-box[data-v-6332d68b],.min-box[data-v-6332d68b]{display:inline-block;width:50%;text-align:center;height:100%;overflow:auto;float:left}.hour-box ul[data-v-6332d68b],.min-box ul[data-v-6332d68b]{list-style:none;margin:0;padding:0}.hour-item[data-v-6332d68b],.min-item[data-v-6332d68b]{padding:10px;font-size:36px;cursor:pointer}.hour-item[data-v-6332d68b]:hover,.min-item[data-v-6332d68b]:hover{background:#e3e3e3}.hour-box .active[data-v-6332d68b],.min-box .active[data-v-6332d68b]{background:#f50057;color:#fff!important}[data-v-6332d68b]::-webkit-scrollbar{width:2px}[data-v-6332d68b]::-webkit-scrollbar-track{background:#e3e3e3}[data-v-6332d68b]::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:2px}", ""]);

// exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 58,
	"./af.js": 58,
	"./ar": 59,
	"./ar-dz": 60,
	"./ar-dz.js": 60,
	"./ar-kw": 61,
	"./ar-kw.js": 61,
	"./ar-ly": 62,
	"./ar-ly.js": 62,
	"./ar-ma": 63,
	"./ar-ma.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 59,
	"./az": 66,
	"./az.js": 66,
	"./be": 67,
	"./be.js": 67,
	"./bg": 68,
	"./bg.js": 68,
	"./bm": 69,
	"./bm.js": 69,
	"./bn": 70,
	"./bn.js": 70,
	"./bo": 71,
	"./bo.js": 71,
	"./br": 72,
	"./br.js": 72,
	"./bs": 73,
	"./bs.js": 73,
	"./ca": 74,
	"./ca.js": 74,
	"./cs": 75,
	"./cs.js": 75,
	"./cv": 76,
	"./cv.js": 76,
	"./cy": 77,
	"./cy.js": 77,
	"./da": 78,
	"./da.js": 78,
	"./de": 79,
	"./de-at": 80,
	"./de-at.js": 80,
	"./de-ch": 81,
	"./de-ch.js": 81,
	"./de.js": 79,
	"./dv": 82,
	"./dv.js": 82,
	"./el": 83,
	"./el.js": 83,
	"./en-au": 84,
	"./en-au.js": 84,
	"./en-ca": 85,
	"./en-ca.js": 85,
	"./en-gb": 86,
	"./en-gb.js": 86,
	"./en-ie": 87,
	"./en-ie.js": 87,
	"./en-il": 88,
	"./en-il.js": 88,
	"./en-nz": 89,
	"./en-nz.js": 89,
	"./eo": 90,
	"./eo.js": 90,
	"./es": 91,
	"./es-do": 92,
	"./es-do.js": 92,
	"./es-us": 93,
	"./es-us.js": 93,
	"./es.js": 91,
	"./et": 94,
	"./et.js": 94,
	"./eu": 95,
	"./eu.js": 95,
	"./fa": 96,
	"./fa.js": 96,
	"./fi": 97,
	"./fi.js": 97,
	"./fo": 98,
	"./fo.js": 98,
	"./fr": 99,
	"./fr-ca": 100,
	"./fr-ca.js": 100,
	"./fr-ch": 101,
	"./fr-ch.js": 101,
	"./fr.js": 99,
	"./fy": 102,
	"./fy.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./gu": 106,
	"./gu.js": 106,
	"./he": 107,
	"./he.js": 107,
	"./hi": 108,
	"./hi.js": 108,
	"./hr": 109,
	"./hr.js": 109,
	"./hu": 110,
	"./hu.js": 110,
	"./hy-am": 111,
	"./hy-am.js": 111,
	"./id": 112,
	"./id.js": 112,
	"./is": 113,
	"./is.js": 113,
	"./it": 114,
	"./it.js": 114,
	"./ja": 115,
	"./ja.js": 115,
	"./jv": 116,
	"./jv.js": 116,
	"./ka": 117,
	"./ka.js": 117,
	"./kk": 118,
	"./kk.js": 118,
	"./km": 119,
	"./km.js": 119,
	"./kn": 120,
	"./kn.js": 120,
	"./ko": 121,
	"./ko.js": 121,
	"./ky": 122,
	"./ky.js": 122,
	"./lb": 123,
	"./lb.js": 123,
	"./lo": 124,
	"./lo.js": 124,
	"./lt": 125,
	"./lt.js": 125,
	"./lv": 126,
	"./lv.js": 126,
	"./me": 127,
	"./me.js": 127,
	"./mi": 128,
	"./mi.js": 128,
	"./mk": 129,
	"./mk.js": 129,
	"./ml": 130,
	"./ml.js": 130,
	"./mn": 131,
	"./mn.js": 131,
	"./mr": 132,
	"./mr.js": 132,
	"./ms": 133,
	"./ms-my": 134,
	"./ms-my.js": 134,
	"./ms.js": 133,
	"./mt": 135,
	"./mt.js": 135,
	"./my": 136,
	"./my.js": 136,
	"./nb": 137,
	"./nb.js": 137,
	"./ne": 138,
	"./ne.js": 138,
	"./nl": 139,
	"./nl-be": 140,
	"./nl-be.js": 140,
	"./nl.js": 139,
	"./nn": 141,
	"./nn.js": 141,
	"./pa-in": 142,
	"./pa-in.js": 142,
	"./pl": 143,
	"./pl.js": 143,
	"./pt": 144,
	"./pt-br": 145,
	"./pt-br.js": 145,
	"./pt.js": 144,
	"./ro": 146,
	"./ro.js": 146,
	"./ru": 147,
	"./ru.js": 147,
	"./sd": 148,
	"./sd.js": 148,
	"./se": 149,
	"./se.js": 149,
	"./si": 150,
	"./si.js": 150,
	"./sk": 151,
	"./sk.js": 151,
	"./sl": 152,
	"./sl.js": 152,
	"./sq": 153,
	"./sq.js": 153,
	"./sr": 154,
	"./sr-cyrl": 155,
	"./sr-cyrl.js": 155,
	"./sr.js": 154,
	"./ss": 156,
	"./ss.js": 156,
	"./sv": 157,
	"./sv.js": 157,
	"./sw": 158,
	"./sw.js": 158,
	"./ta": 159,
	"./ta.js": 159,
	"./te": 160,
	"./te.js": 160,
	"./tet": 161,
	"./tet.js": 161,
	"./tg": 162,
	"./tg.js": 162,
	"./th": 163,
	"./th.js": 163,
	"./tl-ph": 164,
	"./tl-ph.js": 164,
	"./tlh": 165,
	"./tlh.js": 165,
	"./tr": 166,
	"./tr.js": 166,
	"./tzl": 167,
	"./tzl.js": 167,
	"./tzm": 168,
	"./tzm-latn": 169,
	"./tzm-latn.js": 169,
	"./tzm.js": 168,
	"./ug-cn": 170,
	"./ug-cn.js": 170,
	"./uk": 171,
	"./uk.js": 171,
	"./ur": 172,
	"./ur.js": 172,
	"./uz": 173,
	"./uz-latn": 174,
	"./uz-latn.js": 174,
	"./uz.js": 173,
	"./vi": 175,
	"./vi.js": 175,
	"./x-pseudo": 176,
	"./x-pseudo.js": 176,
	"./yo": 177,
	"./yo.js": 177,
	"./zh-cn": 178,
	"./zh-cn.js": 178,
	"./zh-hk": 179,
	"./zh-hk.js": 179,
	"./zh-tw": 180,
	"./zh-tw.js": 180
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cov-vue-date"},[_c('div',{staticClass:"datepickbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date.time),expression:"date.time"}],staticClass:"cov-datepicker",style:(_vm.option.inputStyle ? _vm.option.inputStyle : {}),attrs:{"type":"text","title":"input date","readonly":"readonly","placeholder":_vm.option.placeholder,"required":_vm.required},domProps:{"value":(_vm.date.time)},on:{"click":_vm.showCheck,"foucus":_vm.showCheck,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.date, "time", $event.target.value)}}})]),_vm._v(" "),(_vm.showInfo.check)?_c('div',{staticClass:"datepicker-overlay",style:({'background' : _vm.option.overlayOpacity? 'rgba(0,0,0,'+_vm.option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}),on:{"click":function($event){return _vm.dismiss($event)}}},[_c('div',{staticClass:"cov-date-body",style:({'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'})},[_c('div',{staticClass:"cov-date-monthly"},[_c('div',{staticClass:"cov-date-previous",on:{"click":function($event){return _vm.nextMonth('pre')}}},[_vm._v("«")]),_vm._v(" "),_c('div',{staticClass:"cov-date-caption",style:({'color': _vm.option.color ? _vm.option.color.headerText : '#fff'})},[_c('span',{on:{"click":_vm.showYear}},[_c('small',[_vm._v(_vm._s(_vm.checked.year))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{on:{"click":_vm.showMonth}},[_vm._v(_vm._s(_vm.displayInfo.month))])]),_vm._v(" "),_c('div',{staticClass:"cov-date-next",on:{"click":function($event){return _vm.nextMonth('next')}}},[_vm._v("»")])]),_vm._v(" "),(_vm.showInfo.day)?_c('div',{staticClass:"cov-date-box"},[_c('div',{staticClass:"cov-picker-box"},[_c('div',{staticClass:"week"},[_c('ul',_vm._l((_vm.library.week),function(weekie){return _c('li',[_vm._v(_vm._s(weekie))])}),0)]),_vm._v(" "),_vm._l((_vm.dayList),function(day){return _c('div',{staticClass:"day",class:{'checked':day.checked,'unavailable':day.unavailable,'passive-day': !(day.inMonth)},style:(day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? { background: _vm.option.color.checkedDay } : { background: '#F50057' }) : {}),attrs:{"track-by":"$index"},on:{"click":function($event){return _vm.checkDay(day)}}},[_vm._v(_vm._s(day.value))])})],2)]):_vm._e(),_vm._v(" "),(_vm.showInfo.year)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list",attrs:{"id":"yearList"}},_vm._l((_vm.library.year),function(yearItem){return _c('div',{staticClass:"date-item",attrs:{"track-by":"$index"},on:{"click":function($event){return _vm.setYear(yearItem)}}},[_vm._v(_vm._s(yearItem))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showInfo.month)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list"},_vm._l((_vm.library.month),function(monthItem){return _c('div',{staticClass:"date-item",attrs:{"track-by":"$index"},on:{"click":function($event){return _vm.setMonth(monthItem)}}},[_vm._v(_vm._s(monthItem))])}),0)]):_vm._e(),_vm._v(" "),(_vm.showInfo.hour)?_c('div',{staticClass:"cov-date-box list-box"},[_c('div',{staticClass:"cov-picker-box date-list"},[_c('div',{staticClass:"watch-box"},[_c('div',{staticClass:"hour-box"},[_c('div',{staticClass:"mui-pciker-rule mui-pciker-rule-ft"}),_vm._v(" "),_c('ul',_vm._l((_vm.hours),function(hitem){return _c('li',{staticClass:"hour-item",class:{'active':hitem.checked},on:{"click":function($event){return _vm.setTime('hour', hitem, _vm.hours)}}},[_vm._v(_vm._s(hitem.value))])}),0)]),_vm._v(" "),_c('div',{staticClass:"min-box"},[_c('div',{staticClass:"mui-pciker-rule mui-pciker-rule-ft"}),_vm._v(" "),_vm._l((_vm.mins),function(mitem){return _c('div',{staticClass:"min-item",class:{'active':mitem.checked},on:{"click":function($event){return _vm.setTime('min',mitem, _vm.mins)}}},[_vm._v(_vm._s(mitem.value))])})],2)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-box"},[_c('span',{on:{"click":function($event){_vm.showInfo.check=false}}},[_vm._v(_vm._s(_vm.option.buttons? _vm.option.buttons.cancel : 'Cancel'))]),_vm._v(" "),_c('span',{on:{"click":_vm.picked}},[_vm._v(_vm._s(_vm.option.buttons? _vm.option.buttons.ok : 'Ok'))])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[(!_vm.loggedInUserData.is_staff)?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"to":"/make-new-order","depressed":""}},[_c('i',{staticClass:"material-icons",class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout',staticStyle:{"font-size":"23px"}},[_vm._v("add_box")]),_vm._v(" \n        New Order\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.addExportButton || _vm.addPrepareToPrintButton)?_c('div',{staticClass:"col-sm-4 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"depressed":""},on:{"click":function($event){_vm.resetGetResults()
          _vm.filterApplied = false
          _vm.startTime.time = ''
          _vm.startTime1.time = ''
          _vm.ware = 'Select'}}},[_c('v-icon',{class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout',attrs:{"icon":""}},[_vm._v("cached")]),_vm._v("  Reload Table\n      ")],1)],1):_c('div',{staticClass:"text-left",class:!_vm.loggedInUserData.is_staff ? 'col-sm-4 col-md-3' : 'col-sm-6 col-md-6',staticStyle:{"padding-top":"4px"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){_vm.resetGetResults()
          _vm.filterApplied = false
          _vm.startTime.time = ''
          _vm.startTime1.time = ''
          _vm.ware = 'Select'}}},[_c('v-icon',{class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout',attrs:{"icon":""}},[_vm._v("cached")]),_vm._v("  Reload Table\n      ")],1)],1),_vm._v(" "),(_vm.addExportButton)?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"depressed":""},on:{"click":_vm.sendToExport}},[_c('v-icon',{class:_vm.loggedInUserData.is_staff ? 'blue-logout' : 'orange-logout'},[_vm._v("explicit")]),_vm._v("  Export\n      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.addPrepareToPrintButton)?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.prepareToPrint()}}},[_c('v-icon',{staticStyle:{"color":"#006b8d"}},[_vm._v("print")]),_vm._v("   Prepare to print\n      ")],1)],1):_vm._e(),_vm._v(" "),(!_vm.removeAddButton)?_c('div',{staticClass:"col-sm-6 col-md-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("  Add\n        New\n      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.showAddExportOrderButton)?_c('div',{staticClass:"col-sm-6 col-md-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":_vm.handleAddExportOrder}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg mr-2",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("\n        Add New\n      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.addQrCodeGenerateButton && _vm.$_has_perm(_vm.permissions.generate_qr_code))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openGenerateQrCodeModal()}}},[_c('i',{staticClass:"fa fa-qrcode fa-2x",attrs:{"aria-hidden":"true"}}),_vm._v("  Generate QrCode")])],1):_vm._e(),_vm._v(" "),(_vm.addOrderInvoiceButton && _vm.$_has_perm(_vm.permissions.add_shipping_invoice))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openOrderInvoiceModal()}}},[_c('i',{staticClass:"fa fa-file-text-o mr-2 py-1",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("  Generate Invoice")])],1):_vm._e(),_vm._v(" "),(_vm.addSecondOrderInvoiceButton && _vm.$_has_perm(_vm.permissions.add_second_shipping_invoice))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSecondOrderInvoiceModal()}}},[_c('i',{staticClass:"fa fa-file-text-o mr-2 py-1",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("  Generate 2nd Invoice")])],1):_vm._e(),_vm._v(" "),(_vm.addDeliveryInvoiceButton && _vm.$_has_perm(_vm.permissions.add_delivery_invoice))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openDeliveryInvoiceModal()}}},[_c('i',{staticClass:"fa fa-motorcycle mr-2 py-1",staticStyle:{"font-size":"18px"},attrs:{"aria-hidden":"true"}}),_vm._v("  Delivery Invoice")])],1):_vm._e(),_vm._v(" "),(!_vm.removeWarehouseDeliverButton && _vm.$_has_perm(_vm.permissions.send_to_warehouse))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToWarehouseModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to warehouse")])],1):_vm._e(),_vm._v(" "),(_vm.addSendToIntShipmentButton && _vm.$_has_perm(_vm.permissions.send_to_pending_shipment))?_c('div',{staticClass:"col-sm-6 col-md-3 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToIntShipmentModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Pending Shipment")])],1):_vm._e(),_vm._v(" "),(_vm.addSendAllToIntShipmentButton && _vm.$_has_perm(_vm.permissions.send_to_pending_shipment))?_c('div',{staticClass:"col-sm-6 col-md-3 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.sendAllToIntShipment()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send all to Pending Shipment")])],1):_vm._e(),_vm._v(" "),(_vm.addSendToIntShipmentButton && _vm.$_has_perm(_vm.permissions.send_to_shipment))?_c('div',{staticClass:"col-sm-6 col-md-2 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToIntShipmentModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Shipment")])],1):_vm._e(),_vm._v(" "),(_vm.addSendAllToIntShipmentButton && _vm.$_has_perm(_vm.permissions.send_to_shipment))?_c('div',{staticClass:"col-sm-6 col-md-2 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.sendAllToIntShipment()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send all to Shipment")])],1):_vm._e(),_vm._v(" "),(_vm.addNewShiponlyButton && _vm.$_has_perm(_vm.permissions.new_shiponly))?_c('div',{staticClass:"col-sm-6 col-md-2 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px","background":"transparent","border":"1px solid green","color":"green"},attrs:{"outlined":"","flat":""},on:{"click":function($event){return _vm.openAddNewShiponlyModal()}}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg",staticStyle:{"color":"green"},attrs:{"icon":""}}),_vm._v(" New Shiponly")],1)],1):_vm._e(),_vm._v(" "),(_vm.addSendToPendingToBranchButton && _vm.$_has_perm(_vm.permissions.deliver_to_pending_to_branch))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToPendingToBranchModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Pending To Branch")])],1):_vm._e(),_vm._v(" "),(_vm.addSendToErbilButton && _vm.$_has_perm(_vm.permissions.deliver_to_pending_to_branch))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToErbilModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Delivered to Erbil")])],1):_vm._e(),_vm._v(" "),(_vm.addSendToBranchButton && _vm.$_has_perm(_vm.permissions.deliver_to_branch))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToBranchModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Branch")])],1):_vm._e(),_vm._v(" "),(_vm.addSendAllToBranchButton && _vm.$_has_perm(_vm.permissions.deliver_to_branch))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.sendAllToPendingToBranch()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send All To Branch")])],1):_vm._e(),_vm._v(" "),(_vm.addSendToUserButton && _vm.$_has_perm(_vm.permissions.send_to_customer))?_c('div',{staticClass:"col-sm-6 col-md-2 text-left"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openSendToUserModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send to Customer")])],1):_vm._e(),_vm._v(" "),(_vm.addSendAllToUserButton && _vm.$_has_perm(_vm.permissions.send_to_customer))?_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('v-btn',{staticStyle:{"height":"auto","padding-right":"0px","padding-left":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.sendAllToUser()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("send")]),_vm._v(" Send All To Customer")])],1):_vm._e(),_vm._v(" "),(_vm.addInsertStaffButton && _vm.$_has_perm(_vm.permissions.add_staff))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddStaffModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("person_add")]),_vm._v("   Add Staff")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right mobile"}),_vm._v(" "),_c('div',{staticClass:"text-right mobile",class:(_vm.addSendToIntShipmentButton || _vm.addSendAllToIntShipmentButton) && _vm.$_has_perm(_vm.permissions.send_to_shipment) ? 'col-sm-2 col-md-6' : 'col-sm-3 col-md-6'},[(_vm.showApproveAllShiponly && _vm.$_has_perm(_vm.permissions.approve_all_shiponly))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"loading":_vm.approvingMultipleOrder,"depressed":"","color":"success"},on:{"click":_vm.loadApproveAllShiponly}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"white"}},[_vm._v("check_circle")]),_vm._v("   Approve All Shiponly")]):_vm._e(),_vm._v(" "),(_vm.addNewOrderButton && _vm.$_has_perm(_vm.permissions.add_permission))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){_vm.openAddNewOrderModal(), (_vm.checkAlert = false)}}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("   New Order\n      ")],1):_vm._e()],1),_vm._v(" "),(_vm.cashBackButton && _vm.$_has_perm(_vm.permissions.add_cashback))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openCashBackModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v(" monetization_on")]),_vm._v("   Cash\n        Back")])],1):_vm._e(),_vm._v(" "),(_vm.addCreatCreditButton && _vm.$_has_perm(_vm.permissions.add_credit))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openCreatCreditModal()}}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("   Add\n        Credit\n      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.addWarehouseButton && _vm.$_has_perm(_vm.permissions.add_warehouse))?_c('div',{staticClass:"col-sm-6 col-md-3 text-left"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddWarehouseModal()}}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("   Add\n        Warehouse\n      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.showCreateCustomerButton && _vm.$_has_perm(_vm.permissions.add_customer))?_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-3 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openCreateCustomerModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("person_add")]),_vm._v("   ADD\n        Customer")])],1):_vm._e(),_vm._v(" "),(_vm.addGenerateCouponButton && _vm.$_has_perm(_vm.permissions.add_coupon))?_c('div',{staticClass:"col-sm-6 col-md-6 text-left"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openGenerateCouponModal()}}},[_vm._v("\n        Generate Coupon\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.addBankButton && _vm.$_has_perm(_vm.permissions.add_bank))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddBankModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Bank")])],1):_vm._e(),_vm._v(" "),(_vm.addSupplierButton)?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddSupplierModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Supplier")])],1):_vm._e(),_vm._v(" "),(_vm.addExpenseTypeButton && _vm.$_has_perm(_vm.permissions.add_expense_type))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddExpenseTypeModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Expense Type")])],1):_vm._e(),_vm._v(" "),(_vm.addExpenseButton && _vm.$_has_perm(_vm.permissions.add_expense))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddExpenseModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Expense")])],1):_vm._e(),_vm._v(" "),(_vm.addNotFoundOrderButton && _vm.$_has_perm(_vm.permissions.add_not_found_order))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddNotFoundOrderModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New")])],1):_vm._e(),_vm._v(" "),(_vm.addCityButton && _vm.$_has_perm(_vm.permissions.add_city))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddCityModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New City")])],1):_vm._e(),_vm._v(" "),(_vm.addGovernorateButton && _vm.$_has_perm(_vm.permissions.add_governorate))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddGovernorateModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Governorate")])],1):_vm._e(),_vm._v(" "),(_vm.addReasonButton && _vm.$_has_perm(_vm.permissions.add_reason))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddReasonModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Reason")])],1):_vm._e(),_vm._v(" "),(_vm.addAboutButton && _vm.$_has_perm(_vm.permissions.add_about))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddAboutModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New About App")])],1):_vm._e(),_vm._v(" "),(_vm.addCurrencyRateButton && _vm.$_has_perm(_vm.permissions.add_currency_rate))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddCurrencyRateModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("\n          add\n        ")]),_vm._v("\n          Add New")])],1):_vm._e(),_vm._v(" "),(_vm.addNewExportOrderButton && _vm.$_has_perm(_vm.permissions.add_permission))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddNewExportOrderModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("\n          add\n        ")]),_vm._v("\n          Add New")])],1):_vm._e(),_vm._v(" "),(_vm.addRoleButton && _vm.$_has_perm(_vm.permissions.add_role))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddRoleModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Role")])],1):_vm._e(),_vm._v(" "),((_vm.addEditSubscriptionPricing && _vm.$_has_perm(_vm.permissions.add_subscription_pricing)) || (_vm.deleteAllSubscriptionPricingButton && _vm.$_has_perm(_vm.permissions.delete_subscription_pricing)))?_c('div',{staticClass:"col-xs-6 text-right mobile",staticStyle:{"display":"flex","justify-content":"flex-end","gap":"10px"}},[(_vm.deleteAllSubscriptionPricingButton && _vm.$_has_perm(_vm.permissions.delete_subscription_pricing))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"error"},on:{"click":function($event){return _vm.deleteAllSubscriptionPricing()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"white"}},[_vm._v("delete")]),_vm._v("   Delete Selected Subscription")]):_vm._e(),_vm._v(" "),(_vm.addEditSubscriptionPricing && _vm.$_has_perm(_vm.permissions.add_subscription_pricing))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddEditSubscriptionPricingModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Customer Subscription")]):_vm._e()],1):_vm._e(),_vm._v(" "),((_vm.addEditCustomerSubscription && _vm.$_has_perm(_vm.permissions.add_customer_subscription)) || (_vm.deleteAllSubscriptionButton && _vm.$_has_perm(_vm.permissions.delete_customer_subscription)))?_c('div',{staticClass:"col-xs-6 text-right mobile",staticStyle:{"display":"flex","justify-content":"flex-end","gap":"10px"}},[(_vm.deleteAllSubscriptionButton && _vm.$_has_perm(_vm.permissions.delete_customer_subscription))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"error"},on:{"click":function($event){return _vm.deleteAllCustomerSubscription()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"white"}},[_vm._v("delete")]),_vm._v("   Delete Selected Subscription")]):_vm._e(),_vm._v(" "),(_vm.addEditCustomerSubscription && _vm.$_has_perm(_vm.permissions.add_customer_subscription))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddEditCustomerSubscriptionModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Customer Subscription")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.addBranchButton && _vm.$_has_perm(_vm.permissions.add_branch))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddBranchModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add New Branch")])],1):_vm._e(),_vm._v(" "),(_vm.addMoneyButton && _vm.$_has_perm(_vm.permissions.add_money))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddMoneyModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Money")])],1):_vm._e(),_vm._v(" "),(_vm.addMoneyTransferButton && _vm.$_has_perm(_vm.permissions.add_money_transfer))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddMoneyTransferModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Transfer Money")])],1):_vm._e(),_vm._v(" "),(_vm.showPurchaseAll && _vm.$_has_perm(_vm.permissions.purchase_permission))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.confirmPurchaseAll()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add_shopping_cart")]),_vm._v("  \n        Purchase")])],1):_vm._e(),_vm._v(" "),(_vm.showApproveAll && _vm.$_has_perm(_vm.permissions.approve_all_permission))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"loading":_vm.loadApproveAll,"depressed":""},on:{"click":function($event){return _vm.approvingMultipleOrder()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("check_circle")]),_vm._v("   Approve")])],1):_vm._e(),_vm._v(" "),(_vm.addExchangeRateButton && _vm.$_has_perm(_vm.permissions.add_exchange_rate))?_c('div',{staticClass:"col-xs-6 text-right mobile"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.openAddExchangeRateModal()}}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#006b8d"}},[_vm._v("add")]),_vm._v("   Add Exchange Rate")])],1):_vm._e()]),_vm._v(" "),_c('v-layout',{staticClass:"mx-2",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-text-field',{attrs:{"append-icon":"search","append-icon-cb":function () { return _vm.searchMe(_vm.tableData.search); },"id":"search-field","label":"Search","hide-details":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchMe(_vm.tableData.search)}},model:{value:(_vm.tableData.search),callback:function ($$v) {_vm.$set(_vm.tableData, "search", $$v)},expression:"tableData.search"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"10px","padding-left":"20px"},attrs:{"sm12":"","md5":"","lg6":""}},[_c('v-layout',{attrs:{"wrap":""}},[(_vm.addSelect)?_c('v-flex',{staticStyle:{"padding-top":"10px"},attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.dates,"label":"Select","single-line":"","hide-details":""},on:{"input":function($event){return _vm.prepareToExport()}},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})],1):_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.removeFromToDate),expression:"!removeFromToDate"}],staticStyle:{"padding-top":"25px","margin-right":"10px"},attrs:{"xs2":"","sm1":"","md1":""}},[_c('p',[_vm._v("Filter:")])]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.removeFromToDate),expression:"!removeFromToDate"}],staticClass:"px-2",attrs:{"xs4":"","sm4":"","md3":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"2px","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime,"option":_vm.option}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.removeFromToDate),expression:"!removeFromToDate"}],staticClass:"px-2",attrs:{"xs4":"","sm4":"","md3":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"2px","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime1,"option":_vm.option1}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.removeFromToDate),expression:"!removeFromToDate"}],staticClass:"px-2",staticStyle:{"padding-top":"17px"},attrs:{"xs1":"","sm1":"","md1":""}},[(!_vm.filterApplied)?_c('a',{attrs:{"tooltip":"Apply Filter"},on:{"click":function($event){return _vm.checkDates()}}},[_c('i',{staticClass:"fa fa-filter fa-2x"})]):_vm._e(),_vm._v(" "),(_vm.filterApplied)?_c('a',{staticStyle:{"color":"orange"},attrs:{"tooltip":"Cancel Filter"},on:{"click":function($event){_vm.resetGetResults2()
                _vm.filterApplied = false
                _vm.startTime.time = ''
                _vm.startTime1.time = ''}}},[_c('span',{staticClass:"fa-stack"},[_c('i',{staticClass:"fa fa-filter fa-stack-2x"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times fa-stack-1x",staticStyle:{"padding-left":"14px","padding-top":"7px"}})])]):_vm._e()])],1)],1),_vm._v(" "),(!_vm.intShipment)?_c('v-flex',{staticClass:"px-2",staticStyle:{"padding-top":"25px"},attrs:{"sm12":"","md4":"","lg3":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"sm8":"","md6":"","lg8":"","xl6":""}},[(!_vm.filterMade)?_c('label',{staticStyle:{"padding-top":"10px"}},[_vm._v("\n            Show\n            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.from && _vm.pagination.to),expression:"pagination.from && pagination.to"}]},[_vm._v(_vm._s(_vm.pagination.from || 0)+"-"+_vm._s(_vm.pagination.to)+" of "+_vm._s(_vm.pagination.total)+" ")]),_vm._v("Result\n          ")]):_c('label',{staticStyle:{"padding-top":"10px","float":"right","font-size":"14px"}},[_vm._v("Total Result "+_vm._s(_vm.totalResult))])]),_vm._v(" "),(!_vm.filterMade)?_c('v-flex',{attrs:{"sm1":"","md1":""}},[_c('v-select',{attrs:{"items":_vm.options,"item-value":"value","label":"Select","single-line":"","hide-details":""},on:{"input":function($event){return _vm.getPerPage()}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1):_vm._e()],1)],1):_c('v-flex',{staticStyle:{"padding-top":"30px"},attrs:{"sm12":"","md4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm5":"","md5":""}},[(!_vm.filterMade)?_c('label',{staticStyle:{"padding-top":"10px","float":"right","font-size":"14px"}},[_vm._v("\n            Show\n            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.from && _vm.pagination.to),expression:"pagination.from && pagination.to"}]},[_vm._v(_vm._s(_vm.pagination.from || 0)+" - "+_vm._s(_vm.pagination.to)+" of\n              "+_vm._s(_vm.pagination.total)+"\n            ")]),_vm._v("\n              \n          ")]):_c('label',{staticStyle:{"padding-top":"10px","float":"right","font-size":"14px"}},[_vm._v("Total Result "+_vm._s(_vm.totalResult))])]),_vm._v(" "),(!_vm.filterMade)?_c('v-flex',{attrs:{"sm2":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.options,"label":"Select","single-line":"","hide-details":""},on:{"input":function($event){return _vm.getPerPage()}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1):_vm._e(),_vm._v(" "),(!_vm.filterMade)?_c('v-flex',{attrs:{"sm1":"","md1":""}},[_c('v-select',{attrs:{"items":_vm.warehouses,"label":"Select","single-line":"","hide-details":"","hint":_vm.wareError === true ? 'Please select warehouse' : ''},on:{"input":function($event){return _vm.prepareGetByWarehouse()}},model:{value:(_vm.ware),callback:function ($$v) {_vm.ware=$$v},expression:"ware"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[(!_vm.hideSelectingColumn)?_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md7":"","lg7":"","xl8":""}},[_c('v-select',{attrs:{"items":_vm.columns,"multiple":"","hide-details":"","chips":"","deletable-chips":"","label":"Show/Hide Columns"},on:{"input":function($event){return _vm.prepareToShowHideColumn(_vm.colVal)}},model:{value:(_vm.colVal),callback:function ($$v) {_vm.colVal=$$v},expression:"colVal"}})],1):_vm._e(),_vm._v(" "),_vm._t("custom-filter")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(493);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f9f8bed2", content, true, {});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "th[data-v-dfd11ee8]{font-weight:700;color:#273246}.fa-sort[data-v-dfd11ee8]{color:#bbb;pointer-events:none}.fa-sort-down[data-v-dfd11ee8],.fa-sort-up[data-v-dfd11ee8]{color:blue;pointer-events:none}.editable-container[data-v-dfd11ee8]{position:absolute;top:100px;z-index:9999}", ""]);

// exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table the-datatable",attrs:{"id":"datatable"}},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{key:column.name,style:('width:' +
            column.width +
            ';position:relative;' +
            (column.sortable ? 'cursor:pointer;' : 'user-select:none;')),on:{"click":function($event){column.sortable ? (_vm.sortByColumn(column.name), _vm.updateArrows($event, column.name)) : ''}}},[_c('span',[_vm._v("\n          "+_vm._s(column.label)+"\n          "),(column.sortable)?_c('i',{ref:"isort",refInFor:true,staticClass:"fa fa-sort sorting-arrow"}):_vm._e(),_vm._v(" "),(column.searchable)?_c('span',{staticClass:"fa fa-search legitRipple",on:{"click":function($event){return _vm.singleSearch($event, column.name, column.label)}}}):_vm._e()]),_vm._v(" "),(column.label === '')?_c('input',{attrs:{"id":"mainCheck","type":"checkbox"},on:{"click":function($event){return _vm.checkMainCheck()}}}):_vm._e()])}),0)]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(496);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0d2a6851", content, true, {});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}", ""]);

// exports


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal_showApp"}},[_c('div',{staticClass:"modal-dialog modal-full",staticStyle:{"max-width":"1000px"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",staticStyle:{"background":"transparent","border":"none","font-size":"2rem","color":"#000000FF","outline":"none","cursor":"pointer"},attrs:{"type":"button","aria-label":"Close","title":"Close"},on:{"click":function($event){return _vm.closeModal('modal_showApp')}}},[_vm._m(0)]),_vm._v(" "),(_vm.detialData.status_id_fk === 4)?_c('button',{staticClass:"close",staticStyle:{"position":"none","margin-right":"115px","color":"rgb(46, 125, 50)"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('open-purchase-modal', _vm.detialData)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"vertical-align":"middle","margin-right":"8px"}},[_vm._v("add_shopping_cart")])]):_vm._e(),_vm._v(" "),(_vm.detialData.status_id_fk === 4)?_c('button',{staticClass:"close",staticStyle:{"position":"none","margin-right":"75px","color":"rgb(198, 40, 40)"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('open-refund-modal', _vm.detialData)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"vertical-align":"middle","margin-right":"8px"}},[_vm._v("block")])]):_vm._e(),_vm._v(" "),(_vm.detialData.status_id_fk === 4)?_c('button',{staticClass:"close",staticStyle:{"position":"none","margin-right":"40px","color":"rgb(255, 87, 34)"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('open-partial-refund-modal', _vm.detialData)}}},[_c('i',{staticClass:"fa fa-registered",staticStyle:{"vertical-align":"middle","margin-right":"8px"}})]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v("View Order Details")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.detialData.order_id)?_c('order-images',{attrs:{"formData":_vm.detialData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Customer: ")]),_vm._v(_vm._s(_vm.detialData.full_name))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Email: ")]),_vm._v(" "+_vm._s(_vm.detialData.email))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('h5',[_c('strong',[_vm._v("Customer Note: ")]),_vm._v(_vm._s(_vm.detialData.customer_note))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Phone Number: ")]),_vm._v(" "+_vm._s(_vm.detialData.phone_number))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Order ID: ")]),_vm._v(" "+_vm._s(_vm.detialData.theOrderID))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Product url: ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.detialData.product_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.detialData.product_url ? _vm.detialData.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                  (_vm.detialData.product_url.length > 25 ? '...' : '') : _vm.detialData.product_url)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Product Name : ")]),_vm._v(" "+_vm._s(_vm.detialData.product_name))])]),_vm._v(" "),(_vm.detialData.process_note)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Admin Process note : ")]),_vm._v(" "+_vm._s(_vm.detialData.process_note))])]):_vm._e(),_vm._v(" "),(_vm.detialData.customer_process_note)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Customer Process note : ")]),_vm._v(" "+_vm._s(_vm.detialData.customer_process_note))])]):_vm._e(),_vm._v(" "),(_vm.detialData.customer_process_note_image)?_c('div',{staticClass:"col-sm-6"},[_c('img',{staticStyle:{"width":"70px","height":"70px","object-fit":"cover","border":"1px solid #ccc","flex":"none !important"},attrs:{"src":("" + (_vm.$_image_path()) + (_vm.detialData.customer_process_note_image)),"alt":"Preview"}})]):_vm._e(),_vm._v(" "),(_vm.detialData.size)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Size: ")]),_vm._v(_vm._s(_vm.detialData.size))])]):_vm._e(),_vm._v(" "),(_vm.detialData.type)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Type: ")]),_vm._v(_vm._s(_vm.detialData.type))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Status : ")]),_vm._v(_vm._s(_vm.detialData.status))])]),_vm._v(" "),(_vm.detialData.color)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Color: ")]),_vm._v(_vm._s(_vm.detialData.color))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Quantity: ")]),_vm._v(_vm._s(_vm.detialData.quantity))])]),_vm._v(" "),(_vm.detialData.coupon)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Coupon: ")]),_vm._v(_vm._s(_vm.detialData.coupon))])]):_vm._e(),_vm._v(" "),(_vm.detialData.coupon)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Coupon Percentage: ")]),_vm._v(_vm._s(_vm.detialData.coupon_percentage)+"%")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.detialData.delivery_type == 'office delivery')?_c('h5',[_c('strong',[_vm._v("Delivery Type: ")]),_vm._v(" "),_c('span',{staticClass:"fa fa-building",staticStyle:{"color":"teal"}}),_vm._v("\n            "+_vm._s(_vm.detialData.delivery_type)+"\n          ")]):_c('h5',[_c('strong',[_vm._v("Delivery Type: ")]),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-home ",staticStyle:{"color":"teal"}}),_vm._v("\n            "+_vm._s(_vm.detialData.delivery_type)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticStyle:{"color":"#ff5252"}},[_c('strong',[_vm._v("Transportation Type: ")]),_vm._v(_vm._s(_vm.detialData.transportation_type_obj ? _vm.detialData.transportation_type_obj.name : ''))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"d-flex mt-3"},[_c('div',[(_vm.detialData.is_repackage)?_c('i',{staticClass:"fa fa-check-square text-primary",staticStyle:{"font-size":"18px"}}):_c('i',{staticClass:"fa fa-square-o",staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('span',{staticClass:"ml-2",staticStyle:{"font-size":"15px"}},[_vm._v("Repackage")])]),_vm._v(" "),_c('div',[(_vm.detialData.is_hold)?_c('i',{staticClass:"fa fa-check-square text-primary",staticStyle:{"font-size":"18px"}}):_c('i',{staticClass:"fa fa-square-o",staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('span',{staticClass:"ml-2",staticStyle:{"font-size":"15px"}},[_vm._v("Hold")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Other service: ")]),_vm._v(" "+_vm._s(_vm.detialData.other_service))])]),_vm._v(" "),(_vm.detialData.repackage_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Repackage Price: ")]),_vm._v(" $"+_vm._s(_vm.detialData.repackage_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.hold_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Hold Price: ")]),_vm._v(" $"+_vm._s(_vm.detialData.hold_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.other_service_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Other Service Price: ")]),_vm._v(" $"+_vm._s(_vm.detialData.other_service_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.handling_fee)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Handling Fee: ")]),_vm._v(" $"+_vm._s(_vm.detialData.handling_fee))])]):_vm._e(),_vm._v(" "),(_vm.detialData.bank_name)?_c('div',{staticClass:"col-sm-6"},[(!_vm.bankEditing)?_c('h5',[_c('strong',[_vm._v("Bank name: ")]),_vm._v(" "+_vm._s(_vm.detialData.bank_name)+"\n            "),(_vm.$_has_perm('purchase_approved_order'))?_c('a',{staticStyle:{"margin-left":"6px"},attrs:{"href":"#","title":"Change bank"},on:{"click":function($event){$event.preventDefault();return _vm.startBankEdit.apply(null, arguments)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"18px","vertical-align":"middle"}},[_vm._v("edit")])]):_vm._e()]):_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"8px"}},[_c('strong',[_vm._v("Bank name: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.newBankId),expression:"newBankId"}],staticClass:"form-control",staticStyle:{"max-width":"220px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.newBankId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.banks),function(b){return _c('option',{key:b.bank_id,domProps:{"value":b.bank_id}},[_vm._v(_vm._s(b.bank_name))])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":!_vm.newBankId || _vm.bankSaving},on:{"click":_vm.saveBank}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button","disabled":_vm.bankSaving},on:{"click":function($event){_vm.bankEditing = false}}},[_vm._v("Cancel")])])]):_vm._e(),_vm._v(" "),(_vm.detialData.cancel_reason)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Cancel reason: ")]),_vm._v(" "+_vm._s(_vm.detialData.cancel_reason))])]):_vm._e(),_vm._v(" "),(_vm.detialData.quantity_charge)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Quantity charge: ")]),_vm._v("$"+_vm._s(_vm.detialData.quantity_charge))])]):_vm._e(),_vm._v(" "),(_vm.detialData.the_tl_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Item Price TL: ")]),_vm._v("tl "+_vm._s(_vm.detialData.the_tl_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.item_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Item Price USD: ")]),_vm._v("$"+_vm._s(_vm.detialData.item_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.tax)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Tax: ")]),_vm._v("$"+_vm._s(_vm.detialData.tax))])]):_vm._e(),_vm._v(" "),(_vm.detialData.national_tax)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("International Tax: ")]),_vm._v("$"+_vm._s(_vm.detialData.national_tax))])]):_vm._e(),_vm._v(" "),(_vm.detialData.item_weight)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Item Weight: ")]),_vm._v(_vm._s(_vm.detialData.item_weight)+" KG / "+_vm._s((_vm.detialData.item_weight / 0.4545).toFixed(2))+" LB")])]):_vm._e(),_vm._v(" "),(_vm.detialData.volume)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Volume: ")]),_vm._v(_vm._s(_vm.detialData.volume))])]):_vm._e(),_vm._v(" "),(_vm.detialData.internal_shipping_handling)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Int Shipping: ")]),_vm._v("$"+_vm._s(_vm.detialData.internal_shipping_handling))])]):_vm._e(),_vm._v(" "),(_vm.detialData.kreenex_fee)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("ShipZone Fee: ")]),_vm._v("$"+_vm._s(_vm.detialData.kreenex_fee))])]):_vm._e(),_vm._v(" "),(_vm.detialData.insurance)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Insurance: ")]),_vm._v("$"+_vm._s(_vm.detialData.insurance))])]):_vm._e(),_vm._v(" "),(_vm.detialData.delivery_price)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Delivery Price: ")]),_vm._v("$"+_vm._s(_vm.detialData.delivery_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.local_delivery)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Local Delivery: ")]),_vm._v("$"+_vm._s(_vm.detialData.local_delivery))])]):_vm._e(),_vm._v(" "),(_vm.detialData.price_weight)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Processed At Price Weight: ")]),_vm._v("$"+_vm._s(_vm.detialData.price_weight))])]):_vm._e(),_vm._v(" "),(_vm.detialData.item_type)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Item Type: ")]),_vm._v(_vm._s(_vm.detialData.item_type))])]):_vm._e(),_vm._v(" "),(_vm.detialData.discount)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Discount: ")]),_vm._v(_vm._s(_vm.detialData.discount))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"}),_vm._v(" "),(_vm.detialData.status == 'refunded')?_c('div',{staticClass:"col-sm-6 red--text"},[_c('h5',[_c('strong',[_vm._v("Refund Amount: ")]),_vm._v(_vm._s(_vm._f("usdFormat")(_vm.detialData.money_amount)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Warehouse: ")]),_vm._v(" "),(_vm.detialData.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(_vm.detialData.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(_vm.detialData.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(_vm.detialData.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(_vm.detialData.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n              "+_vm._s(_vm.detialData.country)+"\n          ")])]),_vm._v(" "),(_vm.detialData.track_number)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Track number: ")]),_vm._v(" "+_vm._s(_vm.detialData.track_number))])]):_vm._e(),_vm._v(" "),(_vm.detialData.barcode)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Order Number: ")]),_vm._v(" "+_vm._s(_vm.detialData.barcode))])]):_vm._e(),_vm._v(" "),(_vm.detialData.qrcode)?_c('div',{staticClass:"col-sm-6 col-md-6"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-4"},[_c('qr-code',{attrs:{"text":_vm.detialData.order_id.toString(),"size":_vm.size}})],1)]):_vm._e(),_vm._v(" "),(_vm.detialData.description)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Description : ")]),_vm._v(_vm._s(_vm.detialData.description))])]):_vm._e(),_vm._v(" "),(_vm.detialData.refund_reason)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Refund Reason: ")]),_vm._v(_vm._s(_vm.detialData.refund_reason))])]):_vm._e(),_vm._v(" "),(_vm.detialData.note)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Note: ")]),_vm._v(_vm._s(_vm.detialData.note))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"row"},[(_vm.detialData.partial_refunds && _vm.detialData.partial_refunds.length)?_c('div',{staticClass:"col-sm-6"},[_vm._m(2),_vm._v(" "),_c('ol',_vm._l((_vm.detialData.partial_refunds),function(pr){return _c('li',{key:pr.partial_refund_id,staticClass:"mb-1",staticStyle:{"font-size":"14px"}},[_c('div',{staticClass:"ml-2"},[_vm._v("\n                    Amount: $"+_vm._s(pr.amount)+"\n                    "),_c('span',{staticClass:"ml-2 text--secondary"},[_vm._v("at "+_vm._s(_vm._f("moment")(pr.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('span',{staticClass:"ml-2 text--secondary"},[_vm._v("by "+_vm._s(pr.user.full_name))])]),_vm._v(" "),_c('div',{staticClass:"ml-2"},[_vm._v(_vm._s(pr.note))])])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #bbb","border-radius":"5px"}},[_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Order Date: ")]),_vm._v(_vm._s(_vm.detialData.order_date))])]),_vm._v(" "),(_vm.detialData.confirm_date)?_c('div',{staticClass:"col-sm-6"},[_c('h5',[_c('strong',[_vm._v("Confirm Date: ")]),_vm._v(" "+_vm._s(_vm.detialData.confirm_date))])]):_vm._e(),_vm._v(" "),(_vm.detialData.warehouse_date)?_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("Warehouse Date: ")]),_vm._v(_vm._s(_vm.detialData.warehouse_date))])]):_vm._e(),_vm._v(" "),(_vm.palletNumber)?_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("Pallet / Plane No: ")]),_vm._v(_vm._s(_vm.palletNumber))])]):_vm._e(),_vm._v(" "),(_vm.detialData.from_date)?_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("From Date: ")]),_vm._v(_vm._s(_vm.detialData.from_date))])]):_vm._e(),_vm._v(" "),(_vm.detialData.to_date)?_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("To Date: ")]),_vm._v(_vm._s(_vm.detialData.to_date))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"background-color":"#f5d7a8","border":"1px solid #bbb","border-radius":"5px"}},[_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("Purchase cost: ")]),_vm._v(_vm._s(_vm._f("usdFormat")(_vm.detialData.item_price * _vm.detialData.quantity + _vm.detialData.national_tax + _vm.detialData.delivery_price)))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("Actual cost: ")]),_vm._v(_vm._s(_vm._f("usdFormat")(_vm.detialData.actual_price)))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h5',[_c('strong',[_vm._v("Total Amount: ")]),_vm._v(_vm._s(_vm._f("usdFormat")(_vm.detialData.total_amount)))])])])],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4 col-sm-4 col-md-3"},[_c('h5',[_c('strong',[_vm._v("QrCode:")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('strong',[_vm._v("Partial Refunds")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("071c3303", content, true, {});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "th[data-v-52a222c7]{font-weight:700;color:#273246}.fa-sort[data-v-52a222c7]{color:#bbb;pointer-events:none}.fa-sort-down[data-v-52a222c7],.fa-sort-up[data-v-52a222c7]{color:blue;pointer-events:none}.editable-container[data-v-52a222c7]{position:absolute;top:100px;z-index:9999}", ""]);

// exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-hover the-datatable",attrs:{"id":"datatable"}},[_c('thead',[(_vm.isOrder)?_c('tr',[(_vm.isPurchase === true)?_c('th',[_c('input',{attrs:{"id":"mainCheck","type":"checkbox"},on:{"click":function($event){return _vm.checkMainCheck()}}})]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Order Detail")]),_vm._v(" "),_c('th',[_vm._v("Info & Date")])]):_vm._e(),_vm._v(" "),(_vm.isStaff)?_c('tr',[_c('th',[_vm._v("Staff Detail")]),_vm._v(" "),_c('th',[_vm._v("Info & Status")])]):_vm._e(),_vm._v(" "),(_vm.isCustomer)?_c('tr',[_c('th',[_vm._v("Customer Detail")]),_vm._v(" "),_c('th',[_vm._v("Credit")])]):_vm._e(),_vm._v(" "),(_vm.isCustomerCredit)?_c('tr',[_c('th',[_vm._v("Invoice Detail")]),_vm._v(" "),_c('th',[_vm._v("Action & Date")])]):_vm._e(),_vm._v(" "),(_vm.isCoupon)?_c('tr',[_c('th',[_vm._v("Coupon Detail")]),_vm._v(" "),_c('th',[_vm._v("Status & Dates")])]):_vm._e(),_vm._v(" "),(_vm.isTransactionOrder)?_c('tr',[_c('th',[_vm._v("Order Detail")]),_vm._v(" "),_c('th',[_vm._v("Customer & Date")])]):_vm._e(),_vm._v(" "),(_vm.isTransactionCredit)?_c('tr',[_c('th',[_vm._v("Staff & Customer")]),_vm._v(" "),_c('th',[_vm._v("Status & Date")])]):_vm._e(),_vm._v(" "),(_vm.isExchange)?_c('tr',[_c('th',[_vm._v("Rate Detail")]),_vm._v(" "),_c('th',[_vm._v("Date & Actions")])]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(502);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7f8a2924", content, true, {});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.addNewOrderModal),callback:function ($$v) {_vm.addNewOrderModal=$$v},expression:"addNewOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("New order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddNewOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Item ordered successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.checkURL}},[_vm._v("\n              URL format not acceptable\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[(_vm.loggedInUserData.is_staff)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('customer_id_fk'),"data-vv-name":"customer_id_fk","label":"Customer*","single-line":""},model:{value:(_vm.makeOrderData.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "customer_id_fk", $$v)},expression:"makeOrderData.customer_id_fk"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name*","error-messages":_vm.errors.collect('product_name'),"data-vv-name":"product_name"},model:{value:(_vm.makeOrderData.product_name),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "product_name", $$v)},expression:"makeOrderData.product_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product url*","error-messages":_vm.errors.collect('product_url'),"data-vv-name":"product_url"},model:{value:(_vm.makeOrderData.product_url),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "product_url", $$v)},expression:"makeOrderData.product_url"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('quantity'),"data-vv-name":"quantity"},model:{value:(_vm.makeOrderData.quantity),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "quantity", $$v)},expression:"makeOrderData.quantity"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.makeOrderData.warehouse_id_fk)}},model:{value:(_vm.makeOrderData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "warehouse_id_fk", $$v)},expression:"makeOrderData.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.makeOrderData.transportation_type),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "transportation_type", $$v)},expression:"makeOrderData.transportation_type"}})],1),_vm._v(" "),(!_vm.makeOrderData.is_from_warehouse == 1)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Type","data-vv-name":"type"},model:{value:(_vm.makeOrderData.type),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "type", $$v)},expression:"makeOrderData.type"}})],1):_vm._e(),_vm._v(" "),(!_vm.makeOrderData.is_from_warehouse == 1)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Size","data-vv-name":"size"},model:{value:(_vm.makeOrderData.size),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "size", $$v)},expression:"makeOrderData.size"}})],1):_vm._e(),_vm._v(" "),(!_vm.makeOrderData.is_from_warehouse == 1)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Color","data-vv-name":"color"},model:{value:(_vm.makeOrderData.color),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "color", $$v)},expression:"makeOrderData.color"}})],1):_vm._e(),_vm._v(" "),(!_vm.makeOrderData.is_from_warehouse == 1)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Coupon","data-vv-name":"coupon"},model:{value:(_vm.makeOrderData.coupon),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "coupon", $$v)},expression:"makeOrderData.coupon"}}),_vm._v(" "),(_vm.notCouponCode)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("This field must contain a Coupon Code")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note","data-vv-name":"note"},model:{value:(_vm.makeOrderData.note),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "note", $$v)},expression:"makeOrderData.note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('url'),expression:"'url'"}],attrs:{"label":"Image URL (optional)","error-messages":_vm.errors.collect('image_url'),"data-vv-name":"image_url","placeholder":"https://example.com/image.jpg","disabled":_vm.makeOrderData.image !== null},on:{"input":_vm.clearFileOnUrlInput},model:{value:(_vm.makeOrderData.image_url),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "image_url", $$v)},expression:"makeOrderData.image_url"}}),_vm._v(" "),(_vm.makeOrderData.image_url)?_c('span',{staticStyle:{"color":"#4CAF50","font-size":"12px"}},[_vm._v("\n                  URL will be used instead of file upload\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm3":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Repackage"},model:{value:(_vm.makeOrderData.is_repackage),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "is_repackage", $$v)},expression:"makeOrderData.is_repackage"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm2":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Hold"},model:{value:(_vm.makeOrderData.is_hold),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "is_hold", $$v)},expression:"makeOrderData.is_hold"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm7":""}},[_c('v-text-field',{attrs:{"label":"Other service (please specify)","data-vv-name":"other_service"},model:{value:(_vm.makeOrderData.other_service),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "other_service", $$v)},expression:"makeOrderData.other_service"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 d-flex align-items-center"},[_c('img',{staticStyle:{"width":"70px","height":"70px","object-fit":"cover","border":"1px solid #ccc","flex":"none !important"},attrs:{"src":_vm.makeOrderData.image_url ? _vm.makeOrderData.image_url : (_vm.makeOrderData.image ? _vm.imagePreview : '../../assets/images/shipzone.png'),"alt":"Preview"},on:{"error":_vm.handleImageError}}),_vm._v(" "),_c('v-btn',{staticStyle:{"margin":"16px","max-width":"300px","display":"flex","align-items":"center","justify-content":"center"},attrs:{"block":"","disabled":_vm.makeOrderData.image_url !== '' && _vm.makeOrderData.image_url !== null},on:{"click":_vm.triggerFileInput}},[_vm._v("\n                Upload Image\n              ")]),_vm._v(" "),(_vm.makeOrderData.fileName)?_c('span',{staticStyle:{"margin-left":"15px","display":"flex","align-items":"center"}},[_vm._v("\n                "+_vm._s(_vm.makeOrderData.fileName)+"\n              ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('max_file_size:2'),expression:"'max_file_size:2'"}],ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","data-vv-name":"file"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),(_vm.errors.has('file'))?_c('div',{staticStyle:{"color":"red","display":"block","margin-top":"5px"}},[_vm._v("\n                "+_vm._s(_vm.errors.first('file'))+"\n              ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddNewOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(505);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("59532d18", content, true, {});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}.input-group.input-group--selection-controls label{left:0!important}", ""]);

// exports


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editPriceForTurkey_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c76508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editPriceForTurkey_vue__ = __webpack_require__(509);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editPriceForTurkey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c76508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editPriceForTurkey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(508);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("de23d6a8", content, true, {});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.edit1Modal),callback:function ($$v) {_vm.edit1Modal=$$v},expression:"edit1Modal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEdit1Modal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Price updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Price per weight for Turkey*","error-messages":_vm.errors.collect('Price per weight for Turkey'),"data-vv-name":"Price per weight for Turkey","autofocus":""},model:{value:(_vm.edit1Data.item_weight_price_turkey),callback:function ($$v) {_vm.$set(_vm.edit1Data, "item_weight_price_turkey", $$v)},expression:"edit1Data.item_weight_price_turkey"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editPriceForUSA_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf6f275_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editPriceForUSA_vue__ = __webpack_require__(513);
function injectStyle (ssrContext) {
  __webpack_require__(511)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editPriceForUSA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf6f275_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editPriceForUSA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e17d876a", content, true, {});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.edit2Modal),callback:function ($$v) {_vm.edit2Modal=$$v},expression:"edit2Modal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEdit2Modal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Price updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Price per weight for USA*","error-messages":_vm.errors.collect('Price per weight for USA'),"data-vv-name":"Price per weight for USA"},model:{value:(_vm.edit2Data.item_weight_price_usa),callback:function ($$v) {_vm.$set(_vm.edit2Data, "item_weight_price_usa", $$v)},expression:"edit2Data.item_weight_price_usa"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityBaseUsa_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43084ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityBaseUsa_vue__ = __webpack_require__(517);
function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityBaseUsa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f43084ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityBaseUsa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(516);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("42f29638", content, true, {});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editQttBaseUSAModal),callback:function ($$v) {_vm.editQttBaseUSAModal=$$v},expression:"editQttBaseUSAModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditQttBaseUSAModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              USA Base Quantity Charge updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"USA Base Quantity Charge*","error-messages":_vm.errors.collect('USA Base Quantity Charge'),"data-vv-name":"USA Base Quantity Charge","autofocus":""},model:{value:(_vm.editQttBaseUSAData.quantity_charge_base_usa),callback:function ($$v) {_vm.$set(_vm.editQttBaseUSAData, "quantity_charge_base_usa", $$v)},expression:"editQttBaseUSAData.quantity_charge_base_usa"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityOtherUsa_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227b7ca2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityOtherUsa_vue__ = __webpack_require__(521);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityOtherUsa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227b7ca2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityOtherUsa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b079f846", content, true, {});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editQttOtherUSAModal),callback:function ($$v) {_vm.editQttOtherUSAModal=$$v},expression:"editQttOtherUSAModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditQttOtherUSAModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              USA Other Quantity Charge updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"USA Other Quantity Charge*","error-messages":_vm.errors.collect('USA Other Quantity Charge'),"data-vv-name":"USA Other Quantity Charge","autofocus":""},model:{value:(_vm.editQttOtherUSAData.quantity_charge_other_usa),callback:function ($$v) {_vm.$set(_vm.editQttOtherUSAData, "quantity_charge_other_usa", $$v)},expression:"editQttOtherUSAData.quantity_charge_other_usa"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityBaseTurkey_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f13ba0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityBaseTurkey_vue__ = __webpack_require__(525);
function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityBaseTurkey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f13ba0b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityBaseTurkey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7233de7c", content, true, {});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editQttBaseTurkeyModal),callback:function ($$v) {_vm.editQttBaseTurkeyModal=$$v},expression:"editQttBaseTurkeyModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditQttBaseTurkeyModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Turkey Base Quantity Charge updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Turkey Base Quantity Charge*","error-messages":_vm.errors.collect('Turkey Base Quantity Charge'),"data-vv-name":"Turkey Base Quantity Charge","autofocus":""},model:{value:(_vm.editQttBaseTurkeyData.quantity_charge_base_turkey),callback:function ($$v) {_vm.$set(_vm.editQttBaseTurkeyData, "quantity_charge_base_turkey", $$v)},expression:"editQttBaseTurkeyData.quantity_charge_base_turkey"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityOtherTurkey_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13034615_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityOtherTurkey_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantityOtherTurkey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13034615_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantityOtherTurkey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1e03284c", content, true, {});

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editQttOtherTurkeyModal),callback:function ($$v) {_vm.editQttOtherTurkeyModal=$$v},expression:"editQttOtherTurkeyModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditQttOtherTurkeyModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Turkey Other Quantity Charge updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Turkey Other Quantity Charge*","error-messages":_vm.errors.collect('Turkey Other Quantity Charge'),"data-vv-name":"Turkey Other Quantity Charge","autofocus":""},model:{value:(_vm.editQttOtherTurkeyData.quantity_charge_other_turkey),callback:function ($$v) {_vm.$set(_vm.editQttOtherTurkeyData, "quantity_charge_other_turkey", $$v)},expression:"editQttOtherTurkeyData.quantity_charge_other_turkey"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editDeliveryType_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c83ac6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editDeliveryType_vue__ = __webpack_require__(533);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editDeliveryType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c83ac6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editDeliveryType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(532);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2e5f768b", content, true, {});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.deliveryTypeModal),callback:function ($$v) {_vm.deliveryTypeModal=$$v},expression:"deliveryTypeModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditDeliveryTypeModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              delivery type updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.deliveryTypes,"item-value":"value","error-messages":_vm.errors.collect('Delivery type'),"data-vv-name":"Delivery type","label":"Delivery Type","single-line":""},model:{value:(_vm.editDeliveryTypeData.delivery_type),callback:function ($$v) {_vm.$set(_vm.editDeliveryTypeData, "delivery_type", $$v)},expression:"editDeliveryTypeData.delivery_type"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantity_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9144148a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantity_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editQuantity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9144148a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editQuantity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(536);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a4599d0", content, true, {});

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.quantityModal),callback:function ($$v) {_vm.quantityModal=$$v},expression:"quantityModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Quantity")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeEditQuantityModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Quantity updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"label":"Quantity","error-messages":_vm.errors.collect('Quantity'),"data-vv-name":"Quantity"},model:{value:(_vm.editQuantityData.quantity),callback:function ($$v) {_vm.$set(_vm.editQuantityData, "quantity", $$v)},expression:"editQuantityData.quantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editProductUrl_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0e1b9ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editProductUrl_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editProductUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0e1b9ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editProductUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(540);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7d3fbb0a", content, true, {});

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"540px"},model:{value:(_vm.editProductUrlModal),callback:function ($$v) {_vm.editProductUrlModal=$$v},expression:"editProductUrlModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit ProductUrl")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditProductUrlModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              ProductUrl updated successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.UrlError}},[_vm._v("\n              URL format not acceptable\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Url","error-messages":_vm.errors.collect('Product Url'),"data-vv-name":"Product Url"},model:{value:(_vm.editProductUrlData.product_url),callback:function ($$v) {_vm.$set(_vm.editProductUrlData, "product_url", $$v)},expression:"editProductUrlData.product_url"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editProductName_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0f2e42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editProductName_vue__ = __webpack_require__(545);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editProductName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d0f2e42_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editProductName_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(544);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3ae83e66", content, true, {});

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"540px"},model:{value:(_vm.editProductNameModal),callback:function ($$v) {_vm.editProductNameModal=$$v},expression:"editProductNameModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Product Name")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditProductNameModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Product Name updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name","error-messages":_vm.errors.collect('Product Name'),"data-vv-name":"Product Name"},model:{value:(_vm.editProductNameData.product_name),callback:function ($$v) {_vm.$set(_vm.editProductNameData, "product_name", $$v)},expression:"editProductNameData.product_name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editWarehouse_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71072db7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editWarehouse_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editWarehouse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71072db7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editWarehouse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(548);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5806ce3a", content, true, {});

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editWarehouseModal),callback:function ($$v) {_vm.editWarehouseModal=$$v},expression:"editWarehouseModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Warehouse")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditWarehouseModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Warehouse updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},model:{value:(_vm.editWarehouseData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.editWarehouseData, "warehouse_id_fk", $$v)},expression:"editWarehouseData.warehouse_id_fk"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editSize_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3370fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editSize_vue__ = __webpack_require__(553);
function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editSize_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e3370fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editSize_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("044d91da", content, true, {});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editSizeModal),callback:function ($$v) {_vm.editSizeModal=$$v},expression:"editSizeModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Size")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditSizeModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Size updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Size","error-messages":_vm.errors.collect('Size'),"data-vv-name":"Size"},model:{value:(_vm.editSizeData.size),callback:function ($$v) {_vm.$set(_vm.editSizeData, "size", $$v)},expression:"editSizeData.size"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editColor_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b19f09a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editColor_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editColor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b19f09a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editColor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(556);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("db73c40c", content, true, {});

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editColorModal),callback:function ($$v) {_vm.editColorModal=$$v},expression:"editColorModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Color")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditColorModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Color updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Color","error-messages":_vm.errors.collect('Color'),"data-vv-name":"Color"},model:{value:(_vm.editColorData.color),callback:function ($$v) {_vm.$set(_vm.editColorData, "color", $$v)},expression:"editColorData.color"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editType_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8b0f48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editType_vue__ = __webpack_require__(561);
function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a8b0f48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(560);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2d8ec362", content, true, {});

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editTypeModal),callback:function ($$v) {_vm.editTypeModal=$$v},expression:"editTypeModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Type")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeEditTypeModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.seccessAlert,"type":"success"}},[_vm._v("\n              Type updated successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Type","error-messages":_vm.errors.collect('Type'),"data-vv-name":"Type"},model:{value:(_vm.editTypeData.type),callback:function ($$v) {_vm.$set(_vm.editTypeData, "type", $$v)},expression:"editTypeData.type"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTransportationType_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e420ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTransportationType_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editTransportationType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e420ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editTransportationType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8dfb7cf6", content, true, {});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"540px"},model:{value:(_vm.editTransTypeModal),callback:function ($$v) {_vm.editTransTypeModal=$$v},expression:"editTransTypeModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Transportation Type")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.form.warehouse ? _vm.form.warehouse.transportation_types : [],"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.form.transportation_type),callback:function ($$v) {_vm.$set(_vm.form, "transportation_type", $$v)},expression:"form.transportation_type"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"20px"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"Process This Order"},on:{"click":function($event){;(_vm.checkAlert = false),
        (_vm.dialog = true),
        (_vm.updateData.total_amount = 0),
        (_vm.updateData.local_delivery = 0),
        (_vm.theQuantity.quantity = _vm.r.quantity),
        (_vm.updateData.quantity_charge = _vm.r.quantity_charge),
        _vm.calculateTotalAmount(),
        _vm.getExchangeRate()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1300px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitOrder($event, _vm.r.order_id)}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_c('strong',[_vm._v(" Process The Order "),_c('span',{staticClass:"text-primary ml-2"},[_vm._v(_vm._s(_vm.r.theOrderID))])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.clearProcessOrderData(), (_vm.dialog = false), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.autoFillLoading)?_c('v-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"info","value":true,"icon":"info"}},[_vm._v("\n                Fetching product details from URL...\n                "),_c('v-progress-circular',{staticClass:"ml-2",attrs:{"indeterminate":"","color":"white","size":"20"}})],1):_vm._e(),_vm._v(" "),(_vm.autoFillInfo && _vm.autoFillInfo.source)?_c('v-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"success","value":true,"icon":"check_circle","dismissible":""}},[_c('strong',[_vm._v("Auto-filled from "+_vm._s(_vm.autoFillInfo.source)+":")]),_vm._v("\n                Price: $"+_vm._s(_vm.autoFillInfo.item_price || 'N/A')+",\n                Weight: "+_vm._s(_vm.autoFillInfo.item_weight_kg ? _vm.autoFillInfo.item_weight_kg + ' kg' : 'N/A')+"\n                "),(_vm.autoFillInfo.ai_weight_kg && _vm.autoFillInfo.ai_weight_kg != _vm.autoFillInfo.item_weight_kg)?_c('span',{staticStyle:{"opacity":"0.9"},attrs:{"title":_vm.autoFillInfo.ai_reasoning}},[_vm._v(" (AI estimated: "+_vm._s(_vm.autoFillInfo.ai_weight_kg)+" kg)")]):_vm._e(),_vm._v(" "),(_vm.autoFillInfo.weight_breakdown && _vm.autoFillInfo.weight_breakdown.method === 'dimensions')?_c('span',{staticStyle:{"opacity":"0.9"},attrs:{"title":'Shipping carton ' + _vm.autoFillInfo.weight_breakdown.carton_cm.join(' x ') + ' cm, volumetric ' + _vm.autoFillInfo.weight_breakdown.volumetric_kg + ' kg (not billed)'}},[_vm._v("\n                  (item "+_vm._s(_vm.autoFillInfo.weight_breakdown.item_kg)+" + accessories "+_vm._s(_vm.autoFillInfo.weight_breakdown.accessories_kg)+" + retail box "+_vm._s(_vm.autoFillInfo.weight_breakdown.retail_packaging_kg)+" + shipping carton "+_vm._s(_vm.autoFillInfo.weight_breakdown.carton_kg)+" kg)\n                ")]):(_vm.autoFillInfo.weight_breakdown)?_c('span',{staticStyle:{"opacity":"0.9"},attrs:{"title":"No usable dimensions listed - packaging estimated from the product type"}},[_vm._v("\n                  (item "+_vm._s(_vm.autoFillInfo.weight_breakdown.item_kg)+" + packaging est. "+_vm._s(_vm.autoFillInfo.weight_breakdown.packaging_kg)+" kg)\n                ")]):_vm._e(),_vm._v(" "),(_vm.autoFillInfo.delivery_text)?_c('span',[_vm._v(", Delivery: "+_vm._s(_vm.autoFillInfo.delivery_text)+" ("+_vm._s(_vm.autoFillInfo.warehouse_date)+" & "+_vm._s(_vm.autoFillInfo.from_date)+" → "+_vm._s(_vm.autoFillInfo.to_date)+")")]):_vm._e(),_vm._v(" "),(!_vm.autoFillLoading && _vm.r.product_url)?_c('a',{staticStyle:{"color":"white","text-decoration":"underline","margin-left":"12px","cursor":"pointer"},attrs:{"title":"Re-fetch fresh details from product URL"},on:{"click":function($event){$event.preventDefault();return _vm.autoFillFromProductUrl(_vm.r.order_id)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("refresh")]),_vm._v(" Re-fetch\n                ")]):_vm._e(),_vm._v(" "),(_vm.r.product_url && _vm.isAmazonUrl(_vm.r.product_url))?_c('a',{staticStyle:{"color":"white","text-decoration":"underline","margin-left":"14px","cursor":"pointer"},attrs:{"title":"View or update Amazon session cookies"},on:{"click":function($event){$event.preventDefault();return _vm.openAmazonSessionModal.apply(null, arguments)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("vpn_key")]),_vm._v(" Prime Session\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.autoFillInfo && _vm.autoFillInfo.warning)?_c('v-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"info","value":true,"icon":"info","dismissible":""}},[_c('strong',[_vm._v("Partly auto-filled:")]),_vm._v(" "+_vm._s(_vm.autoFillInfo.warning)+" Delivery dates were estimated — please check them.\n              ")]):_vm._e(),_vm._v(" "),(_vm.autoFillInfo && _vm.autoFillInfo.error)?_c('v-alert',{staticStyle:{"margin-bottom":"15px"},attrs:{"type":"warning","value":true,"icon":"warning","dismissible":""}},[_c('strong',[_vm._v("Auto-fill failed:")]),_vm._v(" "+_vm._s(_vm.autoFillInfo.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #bbb","border-radius":"5px"}},[_c('h5',{staticClass:"col-sm-12 col-md-3"},[_c('strong',[_vm._v("  Customer ID: ")]),_vm._v(" "+_vm._s(_vm.r.user_id)+"\n                  ")]),_vm._v(" "),_c('h5',{staticClass:"col-sm-12 col-md-4"},[_c('strong',[_vm._v("Customer Name: ")]),_vm._v(" "+_vm._s(_vm.r.full_name)+"\n                  ")]),_vm._v(" "),_c('h5',{staticClass:"col-sm-12 col-md-5"},[_c('strong',[_vm._v("Customer Note: ")]),_vm._v(" "+_vm._s(_vm.r.customer_note)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #bbb","border-radius":"5px"}},[_c('h5',{staticClass:"col-sm-12 col-md-6"},[_c('strong',[_vm._v("  Product Name: ")]),_vm._v(" "+_vm._s(_vm.r.product_name.substr(0, 40) + (_vm.r.product_name.length > 40 ? '...' : ''))+"\n                    "),(_vm.$_has_perm('edit_url_at_process'))?_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditProductNameModal(_vm.r.product_name, _vm.r.order_id)}}},[_vm._v("edit?")])]):_vm._e()]),_vm._v(" "),_c('h5',{staticClass:"col-sm-12 col-md-6"},[_c('strong',[_vm._v(" Product Url:")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.r.product_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.r.product_url.replace(/http(s)?:\/\//, '').substr(0, 40) +
                        (_vm.r.product_url.length > 25 ? '...' : '')))]),_vm._v("\n                     \n                    "),(_vm.$_has_perm('edit_url_at_process'))?_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditProductUrlModal(_vm.r.product_url, _vm.r.order_id)}}},[_vm._v("edit?")])]):_vm._e(),_vm._v(" "),(_vm.r.product_url)?_c('span',{staticStyle:{"font-size":"15px","margin-left":"6px"}},[_c('a',{attrs:{"title":"Auto-fill product details from URL"},on:{"click":function($event){$event.preventDefault();return _vm.autoFillFromProductUrl(_vm.r.order_id)}}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"14px","vertical-align":"middle"}},[_vm._v("autorenew")]),_vm._v(" autofill\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#f5d7a8","border":"1px solid #bbbbbb","border-radius":"5px"}},[_c('h5',{staticClass:"col-md-2"},[_c('strong',[_vm._v(" Quantity: ")]),_vm._v(" "+_vm._s(_vm.r.quantity)+"\n                    "),(_vm.$_has_perm('edit_quantity_at_process'))?_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditQuantityModal(_vm.r.order_id)}}},[_vm._v("edit?")])]):_vm._e()]),_vm._v(" "),(_vm.$_has_perm('edit_size_at_process'))?_c('h5',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Size: ")]),_vm._v(" "+_vm._s(_vm.r.size)+"\n                    "),_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditSizeModal(_vm.r.size, _vm.r.order_id)}}},[_vm._v("edit?")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_color_at_process'))?_c('h5',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Color: ")]),_vm._v(" "+_vm._s(_vm.r.color)+"\n                    "),_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditColorModal(_vm.r.color, _vm.r.order_id)}}},[_vm._v("edit?")])])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Type: ")]),_vm._v(" "+_vm._s(_vm.r.type)+"\n                    "),_c('span',{staticStyle:{"font-size":"15px"}},[_c('a',{on:{"click":function($event){return _vm.openEditTypeModal(_vm.r.type, _vm.r.order_id)}}},[_vm._v("edit?")])])]),_vm._v(" "),_c('h5',{staticClass:"col-md-2"},[_c('strong',[_vm._v("Coupon: ")]),_vm._v(" "+_vm._s(_vm.r.coupon)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #FF0101FF","border-radius":"5px"}},[_c('h5',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Order Note: ")]),_vm._v(" "+_vm._s(_vm.r.note)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #bbb","border-radius":"5px"}},[_c('h5',{staticClass:"col-sm-12 col-md-4"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},on:{"input":function($event){return _vm.editWarehouse(_vm.r.order_id,_vm.r.warehouse_id_fk)}},model:{value:(_vm.r.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.r, "warehouse_id_fk", $$v)},expression:"r.warehouse_id_fk"}})],1)],1),_vm._v(" "),_c('h5',{staticClass:"col-sm-12 col-md-4",staticStyle:{"color":"#FF0101FF"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.r.warehouse.transportation_types,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},on:{"input":function($event){return _vm.editTransportationTypeSave(_vm.r.order_id,_vm.r.transportation_type)}},model:{value:(_vm.r.transportation_type),callback:function ($$v) {_vm.$set(_vm.r, "transportation_type", $$v)},expression:"r.transportation_type"}})],1)],1),_vm._v(" "),_c('h5',{staticClass:"col-sm-12 col-md-4 d-flex align-items-center",staticStyle:{"gap":"12px"}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.orderTypes,"item-value":"value","error-messages":_vm.errors.collect('order_type_id_fk'),"data-vv-name":"order_type_id_fk","label":"Order Type*"},on:{"input":_vm.handleOrderTypeChange},model:{value:(_vm.order_type_id_fk),callback:function ($$v) {_vm.order_type_id_fk=$$v},expression:"order_type_id_fk"}})],1),_vm._v(" "),_c('h5',{staticClass:"col-sm-12",class:_vm.r.coupon != null ? 'col-md-6' : 'col-md-12'},[_c('strong',[_vm._v(" Price/Weight "+_vm._s(_vm.r.country)+": ")]),_vm._v("\n                    $"+_vm._s(_vm.selectedOrderTypePrice)+"\n                  ")]),_vm._v(" "),(_vm.r.coupon != null)?_c('h5',{staticClass:"col-sm-12 col-md-6"},[_c('strong',[_vm._v(" Coupon: ")]),_vm._v(" "+_vm._s(_vm.r.coupon)+"\n                    "),_c('span',{staticStyle:{"font-size":"small"}},[_c('strong',[_vm._v("percentage:")])]),_vm._v("\n                    "+_vm._s(_vm.r.percentage)+"%\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"padding":"0px"}},[_c('div',{staticStyle:{"margin":"5px 0 0 5px","border":"1px solid #bbb","border-radius":"5px"}},[(_vm.r.image || _vm.updateData.auto_image_url)?_c('img',{staticStyle:{"border-radius":"4px","object-fit":"contain","cursor":"pointer"},attrs:{"src":(_vm.r.image || _vm.updateData.auto_image_url).startsWith('http') ? (_vm.r.image || _vm.updateData.auto_image_url) : ("" + (_vm.$_image_path()) + (_vm.r.image || _vm.updateData.auto_image_url)),"alt":"Image","width":"100%","height":"195px"},on:{"click":function($event){return _vm.showImage(_vm.r.image || _vm.updateData.auto_image_url)},"error":function($event){$event.target.src = __webpack_require__(12)}}}):_c('img',{staticStyle:{"border-radius":"4px","object-fit":"contain","cursor":"pointer"},attrs:{"src":__webpack_require__(12),"alt":"Image","width":"100%","height":"193px"}})])])],1),_vm._v(" "),_c('div',{staticClass:"row"})],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              The Order is Processed\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('div',{staticClass:"col-md-12",staticStyle:{"color":"#2d315c","border-bottom":"1px solid #2d315c","margin-bottom":"5px"}},[_c('h4',[_vm._v("Calculate Fees")])]),_vm._v(" "),(_vm.r.country === 'Turkey')?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg2":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Item Price USD*","error-messages":_vm.errors.collect('Item price USD'),"data-vv-name":"Item price USD","readonly":""},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.item_price),callback:function ($$v) {_vm.$set(_vm.updateData, "item_price", _vm._n($$v))},expression:"updateData.item_price"}})],1):_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Item Price*","error-messages":_vm.errors.collect('Item price'),"data-vv-name":"Item price"},on:{"input":function($event){_vm.calculateIntShipping(),_vm.calculateTotalAmount()},"change":function($event){_vm.calculateIntShipping(),_vm.calculateTotalAmount()}},model:{value:(_vm.updateData.item_price),callback:function ($$v) {_vm.$set(_vm.updateData, "item_price", _vm._n($$v))},expression:"updateData.item_price"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"International Tax","error-messages":_vm.errors.collect('International Tax'),"data-vv-name":"International Tax"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.national_tax),callback:function ($$v) {_vm.$set(_vm.updateData, "national_tax", _vm._n($$v))},expression:"updateData.national_tax"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Delivery Price","error-messages":_vm.errors.collect('Delivery price'),"data-vv-name":"Delivery price"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.delivery_price),callback:function ($$v) {_vm.$set(_vm.updateData, "delivery_price", _vm._n($$v))},expression:"updateData.delivery_price"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Local Delivery","error-messages":_vm.errors.collect('Local Delivery'),"data-vv-name":"Local Delivery"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.local_delivery),callback:function ($$v) {_vm.$set(_vm.updateData, "local_delivery", _vm._n($$v))},expression:"updateData.local_delivery"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal'),expression:"'decimal'"}],attrs:{"label":"Item Weight (KG)","error-messages":_vm.errors.collect('Item weight'),"data-vv-name":"Item weight"},on:{"input":function($event){_vm.calculateIntShipping(),_vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.item_weight),callback:function ($$v) {_vm.$set(_vm.updateData, "item_weight", _vm._n($$v))},expression:"updateData.item_weight"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal'),expression:"'decimal'"}],attrs:{"label":"Item Weight (LB)","data-vv-name":"Item weight (LB)"},on:{"input":_vm.convertLbToKg,"change":_vm.convertLbToKg},model:{value:(_vm.updateData.item_weight_lb),callback:function ($$v) {_vm.$set(_vm.updateData, "item_weight_lb", _vm._n($$v))},expression:"updateData.item_weight_lb"}})],1)],1)],1),_vm._v(" "),(_vm.r.coupon == null)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Int Shipping","error-messages":_vm.errors.collect('Int. Shipping'),"data-vv-name":"Int. Shipping"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.internal_shipping_handling),callback:function ($$v) {_vm.$set(_vm.updateData, "internal_shipping_handling", _vm._n($$v))},expression:"updateData.internal_shipping_handling"}})],1):_vm._e(),_vm._v(" "),(_vm.r.coupon != null)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Int Shipping","error-messages":_vm.errors.collect('Int. Shipping'),"data-vv-name":"Int. Shipping"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.temp_shipping),callback:function ($$v) {_vm.temp_shipping=_vm._n($$v)},expression:"temp_shipping"}})],1):_vm._e(),_vm._v(" "),(_vm.r.coupon != null)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Discounted shipping price","error-messages":_vm.errors.collect('Int. Shipping'),"data-vv-name":"Int. Shipping"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.internal_shipping_handling),callback:function ($$v) {_vm.$set(_vm.updateData, "internal_shipping_handling", _vm._n($$v))},expression:"updateData.internal_shipping_handling"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Local Tax","error-messages":_vm.errors.collect('tax'),"data-vv-name":"tax"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.tax),callback:function ($$v) {_vm.$set(_vm.updateData, "tax", _vm._n($$v))},expression:"updateData.tax"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"ShipZone Fee","error-messages":_vm.errors.collect('ShipZone fee'),"data-vv-name":"ShipZone fee","readonly":!_vm.$_has_perm('add_company_fee_at_process')},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.kreenex_fee),callback:function ($$v) {_vm.$set(_vm.updateData, "kreenex_fee", _vm._n($$v))},expression:"updateData.kreenex_fee"}})],1),_vm._v(" "),_c('v-expansion-panel',{model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel-content',[_c('div',{staticStyle:{"font-size":"14px","font-weight":"bold"},attrs:{"slot":"header"},slot:"header"},[_vm._v("Additional Services")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","pa-2":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md3":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Insurance","error-messages":_vm.errors.collect('insurance'),"data-vv-name":"insurance"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.insurance),callback:function ($$v) {_vm.$set(_vm.updateData, "insurance", _vm._n($$v))},expression:"updateData.insurance"}})],1),_vm._v(" "),(_vm.$_has_perm('add_discount_at_process'))?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md3":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Discount","error-messages":_vm.errors.collect('Discount'),"data-vv-name":"Discount"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.discount),callback:function ($$v) {_vm.$set(_vm.updateData, "discount", _vm._n($$v))},expression:"updateData.discount"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2 d-flex align-center",attrs:{"xs12":"","sm6":"","md3":"","lg2":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0",staticStyle:{"font-size":"16px","margin-bottom":"0"},attrs:{"label":"Repackage","color":"primary","hide-details":""},model:{value:(_vm.updateData.is_repackage),callback:function ($$v) {_vm.$set(_vm.updateData, "is_repackage", $$v)},expression:"updateData.is_repackage"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 d-flex align-center",attrs:{"xs12":"","sm6":"","md3":"","lg2":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0",staticStyle:{"font-size":"16px","margin-bottom":"0"},attrs:{"label":"Hold","color":"primary","hide-details":""},model:{value:(_vm.updateData.is_hold),callback:function ($$v) {_vm.$set(_vm.updateData, "is_hold", $$v)},expression:"updateData.is_hold"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 d-flex align-center",attrs:{"xs12":"","sm6":"","md3":"","lg2":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0",staticStyle:{"font-size":"16px","margin-bottom":"0"},attrs:{"label":"Other Service","color":"primary","hide-details":""},model:{value:(_vm.has_other_service),callback:function ($$v) {_vm.has_other_service=$$v},expression:"has_other_service"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"col-md-12",attrs:{"row":"","wrap":""}},[(_vm.has_other_service || _vm.updateData.other_service)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Other Service Price","error-messages":_vm.errors.collect('Other Service Price'),"data-vv-name":"Other Service Price"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.other_service_price),callback:function ($$v) {_vm.$set(_vm.updateData, "other_service_price", _vm._n($$v))},expression:"updateData.other_service_price"}})],1):_vm._e(),_vm._v(" "),(_vm.updateData.is_repackage)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Repackage Price","error-messages":_vm.errors.collect('Repackage Price'),"data-vv-name":"Repackage Price"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.repackage_price),callback:function ($$v) {_vm.$set(_vm.updateData, "repackage_price", _vm._n($$v))},expression:"updateData.repackage_price"}})],1):_vm._e(),_vm._v(" "),(_vm.updateData.is_hold)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Hold Price","error-messages":_vm.errors.collect('Hold Price'),"data-vv-name":"Hold Price"},on:{"input":function($event){return _vm.calculateTotalAmount()},"change":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.updateData.hold_price),callback:function ($$v) {_vm.$set(_vm.updateData, "hold_price", _vm._n($$v))},expression:"updateData.hold_price"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"color":"#2d315c","border-bottom":"1px solid #2d315c","margin-bottom":"8px","padding-left":"8px"}},[_c('h4',{staticStyle:{"margin":"0","padding":"4px 0"}},[_vm._v("Delivery & Flight Schedule")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg4":""}},[_c('label',{staticStyle:{"font-size":"11px","font-weight":"600","color":"#2d315c","display":"block","margin-bottom":"2px"}},[_vm._v("\n                  US Warehouse Arrival Date\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"2px","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime2,"option":_vm.option2}}),_vm._v(" "),_c('small',{staticStyle:{"color":"#777","font-size":"10px","display":"block","margin-top":"2px"}},[_vm._v("Amazon Delivery + 1 day")])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg4":""}},[_c('label',{staticStyle:{"font-size":"11px","font-weight":"600","color":"#2d315c","display":"block","margin-bottom":"2px"}},[_vm._v("\n                  Erbil Arrival Date (From Date)\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"2px","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime,"option":_vm.option}}),_vm._v(" "),_c('small',{staticStyle:{"color":"#777","font-size":"10px","display":"block","margin-top":"2px"}},[_vm._v("Friday Flight + 9 days")]),_vm._v(" "),(_vm.fromDateError)?_c('span',{staticStyle:{"color":"orangered"}},[_c('br'),_vm._v("From date must be greater than Today")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md3":"","lg4":""}},[_c('label',{staticStyle:{"font-size":"11px","font-weight":"600","color":"#2d315c","display":"block","margin-bottom":"2px"}},[_vm._v("\n                  Delivery Window End Date (To Date)\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"2px","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime1,"option":_vm.option1}}),_vm._v(" "),_c('small',{staticStyle:{"color":"#777","font-size":"10px","display":"block","margin-top":"2px"}},[_vm._v("Friday Flight + 16 days")]),_vm._v(" "),(_vm.toDateError)?_c('span',{staticStyle:{"color":"orangered"}},[_c('br'),_vm._v("To date must be greater than From date")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{staticClass:"col-md-12",attrs:{"wrap":""}}),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"color":"#2d315c","border-bottom":"1px solid #2d315c","margin":"10px 0"}},[_c('h4',[_vm._v("Notes")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":"","lg4":""}},[_c('v-text-field',{attrs:{"label":"Admin Process note"},model:{value:(_vm.updateData.process_note),callback:function ($$v) {_vm.$set(_vm.updateData, "process_note", $$v)},expression:"updateData.process_note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":"","lg4":""}},[_c('v-text-field',{attrs:{"label":"Customer Process note"},model:{value:(_vm.updateData.customer_process_note),callback:function ($$v) {_vm.$set(_vm.updateData, "customer_process_note", $$v)},expression:"updateData.customer_process_note"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","lg4":""}},[_c('div',{staticClass:"col-md-12 d-flex align-items-center"},[_c('v-btn',{staticStyle:{"margin":"16px","max-width":"300px","display":"flex","align-items":"center","justify-content":"center"},attrs:{"block":""},on:{"click":_vm.triggerFileInput}},[_vm._v("\n                    Upload Image\n                  ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('max_file_size:2'),expression:"'max_file_size:2'"}],ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","data-vv-name":"file"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),(_vm.imagePreview)?_c('img',{staticStyle:{"width":"70px","height":"70px","object-fit":"cover","border":"1px solid #ccc","flex":"none !important"},attrs:{"src":_vm.imagePreview,"alt":"Preview"},on:{"error":function($event){$event.target.style.display = 'none'}}}):_vm._e(),_vm._v(" "),(_vm.updateData.fileName)?_c('span',{staticStyle:{"margin-left":"15px","display":"flex","align-items":"center"}},[_vm._v("\n                    "+_vm._s(_vm.updateData.fileName)+"\n                  ")]):_vm._e()],1)]),_vm._v(" "),(_vm.updateData.other_service && _vm.updateData.other_service.trim())?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm5":"","lg4":""}},[_c('v-text-field',{attrs:{"label":"Other service note","data-vv-name":"other_service","readonly":""},model:{value:(_vm.updateData.other_service),callback:function ($$v) {_vm.$set(_vm.updateData, "other_service", $$v)},expression:"updateData.other_service"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"color":"#2d315c","border-bottom":"1px solid #2d315c","margin-bottom":"10px"}},[_c('h4',[_vm._v("Summary Price")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{staticClass:"no-disabled-style",style:({ backgroundColor: 'white', color: '#2d2d2d', opacity: 1 }),attrs:{"label":"Purchase Cost","readonly":true},model:{value:(_vm.caculatePurchaseCost),callback:function ($$v) {_vm.caculatePurchaseCost=_vm._n($$v)},expression:"caculatePurchaseCost"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Total Amount","error-messages":_vm.errors.collect('total_amount'),"data-vv-name":"total_amount"},model:{value:(_vm.updateData.total_amount),callback:function ($$v) {_vm.$set(_vm.updateData, "total_amount", _vm._n($$v))},expression:"updateData.total_amount"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","color":"#989595"},attrs:{"outline":"","color":"normal"},nativeOn:{"click":function($event){_vm.clearProcessOrderData(), (_vm.dialog = false), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"blue-logout",staticStyle:{"height":"auto","margin-right":"1.5%"},attrs:{"type":"submit","loading":_vm.loading,"outline":""}},[_vm._v("Process")])],1)],1)])],1)],1),_vm._v(" "),_c('edit-quantity-base-usa',{attrs:{"editQttBaseUSAModal":_vm.editQttBaseUSAModal,"editQttBaseUSAData":_vm.editQttBaseUSAData,"closeEditQttBaseUSAModal":_vm.closeEditQttBaseUSAModal,"editQttBaseUSA":_vm.editQttBaseUSA,"seccessAlert":_vm.seccessAlert}}),_vm._v(" "),_c('edit-quantity-other-usa',{attrs:{"editQttOtherUSAModal":_vm.editQttOtherUSAModal,"editQttOtherUSAData":_vm.editQttOtherUSAData,"closeEditQttOtherUSAModal":_vm.closeEditQttOtherUSAModal,"editQttOtherUSA":_vm.editQttOtherUSA,"seccessAlert":_vm.seccessAlert}}),_vm._v(" "),_c('edit-delivery-type',{attrs:{"deliveryTypeModal":_vm.deliveryTypeModal,"editDeliveryTypeData":_vm.editDeliveryTypeData,"closeEditDeliveryTypeModal":_vm.closeEditDeliveryTypeModal,"editDeliveryType":_vm.editDeliveryType,"seccessAlert":_vm.seccessAlert,"deliveryTypes":_vm.deliveryTypes}}),_vm._v(" "),_c('edit-quantity',{attrs:{"quantityModal":_vm.quantityModal,"editQuantityData":_vm.editQuantityData,"closeEditQuantityModal":_vm.closeEditQuantityModal,"editQuantity":_vm.editQuantity,"seccessAlert":_vm.seccessAlert}}),_vm._v(" "),_c('edit-product-url',{attrs:{"seccessAlert":_vm.seccessAlert,"editProductUrlModal":_vm.editProductUrlModal,"closeEditProductUrlModal":_vm.closeEditProductUrlModal,"editProductUrlData":_vm.editProductUrlData,"editProductUrl":_vm.editProductUrl,"UrlError":_vm.UrlError}}),_vm._v(" "),_c('edit-product-name',{attrs:{"seccessAlert":_vm.seccessAlert,"editProductNameModal":_vm.editProductNameModal,"closeEditProductNameModal":_vm.closeEditProductNameModal,"editProductNameData":_vm.editProductNameData,"editProductName":_vm.editProductName,"UrlError":_vm.UrlError}}),_vm._v(" "),_c('edit-size',{attrs:{"seccessAlert":_vm.seccessAlert,"editSizeModal":_vm.editSizeModal,"closeEditSizeModal":_vm.closeEditSizeModal,"editSizeData":_vm.editSizeData,"editSize":_vm.editSize}}),_vm._v(" "),_c('edit-color',{attrs:{"seccessAlert":_vm.seccessAlert,"editColorModal":_vm.editColorModal,"closeEditColorModal":_vm.closeEditColorModal,"editColorData":_vm.editColorData,"editColor":_vm.editColor}}),_vm._v(" "),_c('edit-type',{attrs:{"seccessAlert":_vm.seccessAlert,"editTypeModal":_vm.editTypeModal,"closeEditTypeModal":_vm.closeEditTypeModal,"editTypeData":_vm.editTypeData,"editType":_vm.editType}}),_vm._v(" "),_c('edit-transportation-type',{attrs:{"form":_vm.orderObj,"editTransTypeModal":_vm.editTransTypeModal},on:{"close":function($event){_vm.editTransTypeModal = false},"update-data":function($event){_vm.getResults(), _vm.updateData.transportation_type = _vm.r.transportation_type}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.imgDialog),callback:function ($$v) {_vm.imgDialog=$$v},expression:"imgDialog"}},[_c('v-card',[_c('img',{staticStyle:{"border-radius":"4px"},attrs:{"src":_vm.theImage && _vm.theImage.startsWith('http') ? _vm.theImage : ("" + (_vm.$_image_path()) + _vm.theImage),"alt":"Image","width":"100%","height":"100%"}})])],1),_vm._v(" "),_c('amazon-session-modal',{ref:"amazonSessionModal"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(568);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1dc708dc", content, true, {});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.cancelOrderModal),callback:function ($$v) {_vm.cancelOrderModal=$$v},expression:"cancelOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Cancel Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeCancelingOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.cancelAlert}},[_vm._v("\n              Order canceled successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.reasons,"item-value":"value","item-text":"text","label":"Cancel reason list*","data-vv-name":"Cancel reason"},on:{"input":_vm.updateReasons},model:{value:(_vm.selectedReason),callback:function ($$v) {_vm.selectedReason=$$v},expression:"selectedReason"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel reason english*","error-messages":_vm.errors.collect('Cancel reason'),"data-vv-name":"Cancel reason"},model:{value:(_vm.cancelData.cancel_reason),callback:function ($$v) {_vm.$set(_vm.cancelData, "cancel_reason", $$v)},expression:"cancelData.cancel_reason"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel reason arabic*","error-messages":_vm.errors.collect('Cancel reason arabic'),"data-vv-name":"Cancel reason arabic"},model:{value:(_vm.cancelData.cancel_reason_ar),callback:function ($$v) {_vm.$set(_vm.cancelData, "cancel_reason_ar", $$v)},expression:"cancelData.cancel_reason_ar"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel reason kurdish*","error-messages":_vm.errors.collect('Cancel reason kurdish'),"data-vv-name":"Cancel reason kurdish"},model:{value:(_vm.cancelData.cancel_reason_ku),callback:function ($$v) {_vm.$set(_vm.cancelData, "cancel_reason_ku", $$v)},expression:"cancelData.cancel_reason_ku"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeCancelingOrderModal(), _vm.$validator.reset()}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addNewOrderButton":true,"permissions":{
          add_permission: 'add_new_order'
        },"openAddNewOrderModal":_vm.openAddNewOrderModal,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":r.profile_image && r.profile_image.startsWith('http') ? r.profile_image : ("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"135px","max-width":"220px","word-break":"break-word"}},[_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+"\n                "),(r.item_price || r.item_weight)?_c('div',{staticClass:"product-meta-row"},[(r.item_price)?_c('span',{staticClass:"product-pill pill-price",attrs:{"title":'Unit Price: $' + r.item_price + (r.quantity > 1 ? ' × ' + r.quantity + ' = $' + (r.item_price * r.quantity).toFixed(2) : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v("$"+_vm._s(r.item_price))]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": $"+_vm._s((r.item_price * r.quantity).toFixed(2))+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(r.item_weight)?_c('span',{staticClass:"product-pill pill-weight",attrs:{"title":'Unit Weight: ' + r.item_weight + ' kg' + (r.quantity > 1 ? ' × ' + r.quantity + ' = ' + (r.item_weight * r.quantity).toFixed(2) + ' kg' : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v(_vm._s(r.item_weight)+" kg")]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": "+_vm._s((r.item_weight * r.quantity).toFixed(2))+" kg)")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_new_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('process-the-order',{attrs:{"processOrder":_vm.processOrder,"r":r,"checkAlert":_vm.checkAlert,"updateData":_vm.updateData,"calculateTotalAmount":_vm.calculateTotalAmount,"loading":_vm.loading,"getResults":_vm.getResults,"clearProcessOrderData":_vm.clearProcessOrderData,"theQuantity":_vm.theQuantity,"itemTypes":_vm.itemTypes,"warehouses":_vm.warehouses}})],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_new_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_pending_answer_order'))?_c('td',{staticStyle:{"padding":"0px 10px 0px 5px"}},[_c('a',{staticStyle:{"color":"#FF9966"},attrs:{"tooltip":"Send to pending answer"},on:{"click":function($event){return _vm.sendToPendingAnswer(r.order_id)}}},[_c('i',{staticClass:"fa fa-adn",staticStyle:{"font-size":"24px"}})])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n                "),(r.item_price || r.item_weight)?_c('div',{staticClass:"product-meta-row"},[(r.item_price)?_c('span',{staticClass:"product-pill pill-price",attrs:{"title":'Unit Price: $' + r.item_price + (r.quantity > 1 ? ' × ' + r.quantity + ' = $' + (r.item_price * r.quantity).toFixed(2) : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v("$"+_vm._s(r.item_price))]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": $"+_vm._s((r.item_price * r.quantity).toFixed(2))+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(r.item_weight)?_c('span',{staticClass:"product-pill pill-weight",attrs:{"title":'Unit Weight: ' + r.item_weight + ' kg' + (r.quantity > 1 ? ' × ' + r.quantity + ' = ' + (r.item_weight * r.quantity).toFixed(2) + ' kg' : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v(_vm._s(r.item_weight)+" kg")]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": "+_vm._s((r.item_weight * r.quantity).toFixed(2))+" kg)")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-left":"5px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_new_order'))?_c('span',{staticStyle:{"float":"left"}},[_c('process-the-order',{attrs:{"processOrder":_vm.processOrder,"r":r,"checkAlert":_vm.checkAlert,"updateData":_vm.updateData,"calculateTotalAmount":_vm.calculateTotalAmount,"loading":_vm.loading,"getResults":_vm.getResults,"clearProcessOrderData":_vm.clearProcessOrderData,"theQuantity":_vm.theQuantity,"itemTypes":_vm.itemTypes,"warehouses":_vm.warehouses}})],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_new_order'))?_c('a',{staticStyle:{"color":"#C62828","float":"left","padding-left":"3px"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-new-order',{attrs:{"addNewOrderModal":_vm.addNewOrderModal,"warehouses":_vm.warehouses,"closeAddNewOrderModal":_vm.closeAddNewOrderModal,"checkAlert":_vm.checkAlert,"checkURL":_vm.checkURL,"makeNewOrder":_vm.makeNewOrder,"deliveryTypes":_vm.deliveryTypes,"makeOrderData":_vm.makeOrderData,"customers":_vm.customers,"loading":_vm.loading}}),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('admin-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder,"reasons":_vm.reasons}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("New Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingAnswerOrder_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b60ff3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingAnswerOrder_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(572)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingAnswerOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b60ff3e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingAnswerOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(573);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0df70f05", content, true, {});

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.product-meta-row{flex-wrap:wrap;gap:3px 5px;margin-top:3px;line-height:1}.product-meta-row,.product-pill{display:inline-flex;align-items:center}.product-pill{font-size:10px;font-weight:500;line-height:1.35;padding:1px 6px;border-radius:4px;text-transform:none!important;letter-spacing:.01em;white-space:nowrap;box-shadow:0 1px 2px rgba(0,0,0,.04)}.product-pill.pill-price{background-color:#ecfdf5;color:#065f46;border:1px solid #a7f3d0}.product-pill.pill-weight{background-color:#eff6ff;color:#1e40af;border:1px solid #bfdbfe}.product-pill .pill-unit{font-weight:600}.product-pill .pill-mult{font-weight:500;opacity:.85;margin-left:3px;font-size:9.5px}", ""]);

// exports


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container"},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color",staticStyle:{"max-width":"120px","word-break":"break-word"}},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',{staticStyle:{"word-break":"break-all","max-width":"150px"}},[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"135px","max-width":"220px","word-break":"break-word"}},[_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+"\n                "),(r.item_price || r.item_weight)?_c('div',{staticClass:"product-meta-row"},[(r.item_price)?_c('span',{staticClass:"product-pill pill-price",attrs:{"title":'Unit Price: $' + r.item_price + (r.quantity > 1 ? ' × ' + r.quantity + ' = $' + (r.item_price * r.quantity).toFixed(2) : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v("$"+_vm._s(r.item_price))]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": $"+_vm._s((r.item_price * r.quantity).toFixed(2))+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(r.item_weight)?_c('span',{staticClass:"product-pill pill-weight",attrs:{"title":'Unit Weight: ' + r.item_weight + ' kg' + (r.quantity > 1 ? ' × ' + r.quantity + ' = ' + (r.item_weight * r.quantity).toFixed(2) + ' kg' : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v(_vm._s(r.item_weight)+" kg")]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": "+_vm._s((r.item_weight * r.quantity).toFixed(2))+" kg)")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',{staticStyle:{"max-width":"120px","word-break":"break-word"}},[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container"},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_new_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('process-the-order',{attrs:{"processOrder":_vm.processOrder,"r":r,"checkAlert":_vm.checkAlert,"updateData":_vm.updateData,"calculateTotalAmount":_vm.calculateTotalAmount,"loading":_vm.loading,"getResults":_vm.getResults,"clearProcessOrderData":_vm.clearProcessOrderData,"theQuantity":_vm.theQuantity,"itemTypes":_vm.itemTypes,"defaultPriceData":_vm.defaultPriceData,"warehouses":_vm.warehouses}})],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_new_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n                "),(r.item_price || r.item_weight)?_c('div',{staticClass:"product-meta-row"},[(r.item_price)?_c('span',{staticClass:"product-pill pill-price",attrs:{"title":'Unit Price: $' + r.item_price + (r.quantity > 1 ? ' × ' + r.quantity + ' = $' + (r.item_price * r.quantity).toFixed(2) : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v("$"+_vm._s(r.item_price))]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": $"+_vm._s((r.item_price * r.quantity).toFixed(2))+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(r.item_weight)?_c('span',{staticClass:"product-pill pill-weight",attrs:{"title":'Unit Weight: ' + r.item_weight + ' kg' + (r.quantity > 1 ? ' × ' + r.quantity + ' = ' + (r.item_weight * r.quantity).toFixed(2) + ' kg' : '')}},[_c('span',{staticClass:"pill-unit"},[_vm._v(_vm._s(r.item_weight)+" kg")]),_vm._v(" "),(r.quantity > 1)?_c('span',{staticClass:"pill-mult"},[_vm._v("(x"+_vm._s(r.quantity)+": "+_vm._s((r.item_weight * r.quantity).toFixed(2))+" kg)")]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-left":"5px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_new_order'))?_c('span',{staticStyle:{"float":"left"}},[_c('process-the-order',{attrs:{"processOrder":_vm.processOrder,"r":r,"checkAlert":_vm.checkAlert,"updateData":_vm.updateData,"calculateTotalAmount":_vm.calculateTotalAmount,"loading":_vm.loading,"getResults":_vm.getResults,"clearProcessOrderData":_vm.clearProcessOrderData,"theQuantity":_vm.theQuantity,"itemTypes":_vm.itemTypes,"defaultPriceData":_vm.defaultPriceData,"warehouses":_vm.warehouses}})],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_new_order'))?_c('a',{staticStyle:{"color":"#C62828","float":"left","padding-left":"3px"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('admin-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder,"reasons":_vm.reasons}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Pending Answer Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedOrder_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c463aaca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedOrder_vue__ = __webpack_require__(581);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c463aaca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6365bd5e", content, true, {});

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ec9969e4", content, true, {});

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area{max-width:850px}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#table-header{width:500px;padding-left:60px}#price-section2{width:500px;padding-left:10px;padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{margin-left:0;margin-right:20px;padding:0}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal_showAppLog"}},[_c('div',{staticClass:"modal-dialog modal-full",attrs:{"id":"print-area"}},[_c('div',{staticClass:"modal-content",staticStyle:{"border-style":"dashed","border-width":"1px"}},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"id":"close-button","type":"button"},on:{"click":function($event){return _vm.closeModal('modal_showAppLog')}}},[_vm._v("\n          ×\n        ")])]),_vm._v(" "),_c('table',{attrs:{"id":"head-table"}},[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_name)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_address)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_email)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.phone_number)+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table1"}},[_c('tr',[_c('td',{attrs:{"id":"table-header"}},[_c('h4',{staticStyle:{"margin-bottom":"0px"}},[_c('strong',[(_vm.detialData.description === 'Add to Credit')?_c('span',[_vm._v("Refund Invoice")]):_c('span',[_vm._v("Shopping Online Invoice")])])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table2"}},[_c('tr',[_c('td',{attrs:{"id":"info-section1"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Invoice Number:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(" "+_vm._s(_vm.detialData.invoice_number))])]),_vm._v(" "),(_vm.detialData.credit_log_transaction_date != null)?_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v("\n                  "+_vm._s(_vm.detialData.credit_log_transaction_date))])]):_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(" "+_vm._s(_vm.detialData.created_at))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Description:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(" "+_vm._s(_vm.detialData.description))])]),_vm._v(" "),(_vm.detialData.description != 'Add to Credit')?_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                From/To Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(" "+_vm._s(_vm.detialData.from_date)+" - "+_vm._s(_vm.detialData.to_date))])]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"id":"info-section2"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Order: "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detialData.theOrderID))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Name: "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detialData.full_name))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Address:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detialData.address))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Tel:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detialData.phone_number))])])])])]),_vm._v(" "),(_vm.detialData.description === 'Add to Credit')?_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table3"}},[_c('tr',[_vm._m(1),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"30px","padding-bottom":"30px"},attrs:{"id":"price-section1"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"normal"}},[_vm._v(": "+_vm._s(_vm.detialData.refund_reason))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"normal"}},[_vm._v(": $"+_vm._s(_vm.detialData.money_amount))])])])]):_c('table',{staticStyle:{"width":"100%","border":"1px solid"},attrs:{"id":"print-table3"}},[_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Product Name: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v(_vm._s(_vm.detialData.product_name))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Quantity: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v(_vm._s(_vm.detialData.quantity))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Quantity Charge: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.quantity_charge))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Item Price: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.item_price))])]),_vm._v(" "),(_vm.detialData.tax)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Tax: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.tax))])]):_vm._e(),_vm._v(" "),(_vm.detialData.internal_shipping_handling)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Int. Shipment: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.internal_shipping_handling))])]):_vm._e(),_vm._v(" "),(_vm.detialData.insurance)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Insurance: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.insurance))])]):_vm._e(),_vm._v(" "),(_vm.detialData.delivery_price)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Delivery Price: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.delivery_price))])]):_vm._e(),_vm._v(" "),(_vm.detialData.local_delivery)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("Local Delivery: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.local_delivery))])]):_vm._e(),_vm._v(" "),(_vm.detialData.kreenex_fee)?_c('tr',[_c('td',{staticClass:"order-invoice-left-td"},[_vm._v("ShipZone Fee: ")]),_vm._v(" "),_c('td',{staticClass:"order-invoice-right-td"},[_vm._v("$"+_vm._s(_vm.detialData.kreenex_fee))])]):_vm._e()]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[(_vm.detialData.description === 'Add to Credit')?_c('tr',[_c('td',{staticStyle:{"border":"1px solid #000","text-align":"right","padding-right":"10px"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Total:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.detialData.money_amount))])])])])]):_c('tr',[_c('td',{staticStyle:{"border":"1px solid #000","text-align":"right","padding-right":"10px"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Total:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.detialData.amount))])])]),_vm._v(" "),(_vm.detialData.paid_amount)?_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Paid:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.detialData.paid_amount))])])]):_vm._e(),_vm._v(" "),(_vm.detialData.paid_amount)?_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Remain:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s((_vm.detialData.amount - Number(_vm.detialData.paid_amount)).toFixed(2)))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.partialRefunds),function(refund){return _c('p',{key:refund.partial_refund_id,staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Partial Refund ("+_vm._s(_vm._f("moment")(refund.created_at,'YYYY-MM-DD'))),(refund.note)?_c('span',[_vm._v(", "+_vm._s(refund.note))]):_vm._e(),_vm._v("):\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("-$"+_vm._s(Number(refund.amount).toFixed(2)))])])])}),_vm._v(" "),(_vm.partialRefunds.length)?_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Total after partial refund:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.totalAfterPartialRefund.toFixed(2)))])])]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":_vm.printInvoice}},[_vm._v("Print")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"src":__webpack_require__(12),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"padding-top":"30px","padding-bottom":"30px"},attrs:{"id":"price-section"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("Refund reason")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("Money amount")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"permissions":{
          approve_all_permission: 'approve_processed_order'
        },"showApproveAll":true,"loadApproveAll":_vm.loadApproveAll,"approvingMultipleOrder":_vm.approvingMultipleOrder,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[(_vm.sumOfSelectedOrders)?_c('div',{staticClass:"row text-center"},[_c('h5',{staticClass:"ma-0",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            Sum of selected orders: Purchase Cost: "+_vm._s(_vm.sumOfSelectedOrders.toFixed(3))+", Total Cost: "+_vm._s(_vm.sumOfSelectedOrdersTotalCost.toFixed(3))+" ("+_vm._s((_vm.sumOfSelectedOrdersTotalCost - _vm.sumOfSelectedOrders).toFixed(2))+")\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.orderIds.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderIds),expression:"orderIds"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":r.order_id,"checked":Array.isArray(_vm.orderIds)?_vm._i(_vm.orderIds,r.order_id)>-1:(_vm.orderIds)},on:{"change":function($event){var $$a=_vm.orderIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=r.order_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.orderIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.orderIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.orderIds=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579b"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('approve_processed_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#43a047"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_processed_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#c62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_processed_order_to_new_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to new order"},on:{"click":function($event){return _vm.returnOrderToNewOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                  (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('approve_processed_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#43a047"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_processed_order_to_new_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to new order"},on:{"click":function($event){return _vm.returnOrderToNewOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_processed_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"15px","float":"right"}},[_c('a',{staticStyle:{"color":"#c62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('admin-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder,"reasons":_vm.reasons}}),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('v-dialog',{attrs:{"overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.approvingDialog),callback:function ($$v) {_vm.approvingDialog=$$v},expression:"approvingDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"pb-2 pt-3",attrs:{"primary-title":""}},[_c('h3',{staticClass:"my-0"},[_vm._v("Are you sure?")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mx-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Customer: "+_vm._s(_vm.orderData.full_name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Balance: $"+_vm._s(_vm.orderData.credit))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Order price: $"+_vm._s(_vm.orderData.total_amount))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{model:{value:(_vm.approveValue),callback:function ($$v) {_vm.approveValue=$$v},expression:"approveValue"}},[_c('v-radio',{attrs:{"label":"Will pay","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Loan","value":"2","disabled":_vm.orderData.credit >= _vm.orderData.total_amount}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.approveValue === '1'),expression:"approveValue === '1'"}],attrs:{"xs12":""}},[_c('a',{staticStyle:{"font-size":"14px","text-decoration":"underline"},attrs:{"href":"/secret?component=credit","target":"blank"}},[_vm._v("\n                    Go to customer credit\n                  ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.approvingDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"1.5%"},attrs:{"outline":"","color":"success","loading":_vm.loadSingleApprove},on:{"click":_vm.approveOrder}},[_vm._v("ok")])],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Processed Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canceledOrder_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c145aea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canceledOrder_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canceledOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c145aea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canceledOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("58e3fda5", content, true, {});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(r.is_ship_only == '1' ? 'background-color: rgba(20, 130, 20, 0.4)' : (_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '' ))},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.cancel_reason))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('undo_cancel_order'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#15019BFF"},attrs:{"tooltip":r.is_ship_only == '1' ? 'Return to Ship Only' : 'Return to New Order'},on:{"click":function($event){return _vm.undoCancelOrder(r.order_id, 1, r.is_ship_only == '1')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_upward")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('undo_cancel_order'))?_c('td',{directives:[{name:"show",rawName:"v-show",value:(r.is_ship_only != '1' && r.process_date != null),expression:"r.is_ship_only != '1' && r.process_date != null"}],staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#15019BFF"},attrs:{"tooltip":"Return to Processed Order"},on:{"click":function($event){return _vm.undoCancelOrder(r.order_id,2)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("undo")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Canceled Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approvedOrder_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bd8e90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approvedOrder_vue__ = __webpack_require__(605);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approvedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bd8e90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approvedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("767c59b6", content, true, {});

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("05f822ac", content, true, {});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.refundOrderModal),callback:function ($$v) {_vm.refundOrderModal=$$v},expression:"refundOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Refund Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeRefundOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Order refunded successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Refund Reason*","error-messages":_vm.errors.collect('refund_reason'),"data-vv-name":"refund_reason"},model:{value:(_vm.refundData.refund_reason),callback:function ($$v) {_vm.$set(_vm.refundData, "refund_reason", $$v)},expression:"refundData.refund_reason"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2|between:0.1,' + _vm.orderRemainAmount),expression:"'required|decimal:2|between:0.1,' + orderRemainAmount"}],attrs:{"label":"Money amount*","error-messages":_vm.errors.collect('Money amount'),"data-vv-name":"Money amount"},model:{value:(_vm.refundData.money_amount),callback:function ($$v) {_vm.$set(_vm.refundData, "money_amount", $$v)},expression:"refundData.money_amount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{attrs:{"label":"Refund note"},model:{value:(_vm.refundData.refund_note),callback:function ($$v) {_vm.$set(_vm.refundData, "refund_note", $$v)},expression:"refundData.refund_note"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send SMS","color":"indigo","hide-details":""},model:{value:(_vm.refundData.send_sms),callback:function ($$v) {_vm.$set(_vm.refundData, "send_sms", $$v)},expression:"refundData.send_sms"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('h5',[_vm._v("Order Total amount is $"+_vm._s(_vm.theOrderTotalAmount))])]),_vm._v(" "),(_vm.refundData.partial_refunds && _vm.refundData.partial_refunds.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Partial Refunds")]),_vm._v(" "),_c('ol',_vm._l((_vm.refundData.partial_refunds),function(obj,index){return _c('li',{key:index,staticStyle:{"font-size":"14px"}},[_vm._v("\n                    Amount $"+_vm._s(obj.amount)+" "),_c('span',{staticClass:"px-2"},[_vm._v("at "+_vm._s(_vm._f("moment")(obj.created_at,'YYYY-MM-DD hh:mm A')))]),_vm._v(" by "+_vm._s(obj.user.full_name)+"\n                  ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.refundData.partial_refunds && _vm.refundData.partial_refunds.length > 0)?_c('v-flex',{attrs:{"sm12":""}},[_c('h5',[_vm._v("Order Total remain amount is $"+_vm._s(_vm.orderRemainAmount))])]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeRefundOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("Refund")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(593);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bd7a9a92", content, true, {});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.partialRefundOrderModal),callback:function ($$v) {_vm.partialRefundOrderModal=$$v},expression:"partialRefundOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Partial Refund")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closePartialRefundOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Done successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2|between:0.1,' + (_vm.theOrderTotalAmount)),expression:"'required|decimal:2|between:0.1,' + (theOrderTotalAmount)"}],attrs:{"label":"Amount*","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount"},model:{value:(_vm.partialRefundData.amount),callback:function ($$v) {_vm.$set(_vm.partialRefundData, "amount", $$v)},expression:"partialRefundData.amount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.partialRefundData.note),callback:function ($$v) {_vm.$set(_vm.partialRefundData, "note", $$v)},expression:"partialRefundData.note"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('h6',[_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")]),_vm._v(" The order Total amount is $"+_vm._s(_vm.theOrderTotalAmount)+"\n                ")])]),_vm._v(" "),(_vm.partialRefundData.partial_refunds && _vm.partialRefundData.partial_refunds.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Partial Refunds")]),_vm._v(" "),_c('ol',_vm._l((_vm.partialRefundData.partial_refunds),function(obj,index){return _c('li',{key:index,staticStyle:{"font-size":"14px"}},[_vm._v("\n                    Amount $"+_vm._s(obj.amount)+" "),_c('span',{staticClass:"px-2"},[_vm._v("at "+_vm._s(_vm._f("moment")(obj.created_at,'YYYY-MM-DD hh:mm A')))]),_vm._v(" by "+_vm._s(obj.user.full_name)+"\n                  ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.partialRefundData.partial_refunds && _vm.partialRefundData.partial_refunds.length > 0)?_c('v-flex',{attrs:{"sm12":""}},[_c('h5',[_vm._v("Order Total remain amount is $"+_vm._s(_vm.orderRemainAmount))])]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closePartialRefundOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(596);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2463ef32", content, true, {});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.addBarcodeModal),callback:function ($$v) {_vm.addBarcodeModal=$$v},expression:"addBarcodeModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Order Number")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddBarcodeModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.checkAlert,"type":"success"}},[_vm._v("\n              Order Number added successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order Number*","error-messages":_vm.errors.collect('Order Number'),"data-vv-name":"Order Number"},model:{value:(_vm.addBarcodeData.barcode),callback:function ($$v) {_vm.$set(_vm.addBarcodeData, "barcode", $$v)},expression:"addBarcodeData.barcode"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"7%"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("ADD")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchaseOrder_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3271e8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchaseOrder_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchaseOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3271e8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchaseOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(600);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("26657fa8", content, true, {});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.purchaseOrderModal),callback:function ($$v) {_vm.purchaseOrderModal=$$v},expression:"purchaseOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Purchase Order "+_vm._s(_vm.purchaseOrderData.theOrderID))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closePurchaseOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v(" Order purchased successfully ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"font-size":"1.7rem"},attrs:{"xs12":"","sm12":""}},[_vm._v(" Please select payment method ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.banks,"error-messages":_vm.errors.collect('Bank'),"data-vv-name":"Bank","label":"Bank"},model:{value:(_vm.purchaseOrderData.bank_id),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "bank_id", $$v)},expression:"purchaseOrderData.bank_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order Number","error-messages":_vm.errors.collect('Order Number'),"data-vv-name":"Order Number"},model:{value:(_vm.purchaseOrderData.barcode),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "barcode", $$v)},expression:"purchaseOrderData.barcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Actual Price","type":"number","step":0.01,"rules":[function (v) { return !!v || 'Actual Price is required'; }, function (v) { return /^\d+(\.\d+)?$/.test(v) || 'Must be a valid number'; }],"data-vv-name":'Actual Price',"error-messages":_vm.errors.collect('Actual Price')},model:{value:(_vm.purchaseOrderData.actual_price),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "actual_price", _vm._n($$v))},expression:"purchaseOrderData.actual_price"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Warehouse Date","type":"date","error-messages":_vm.errors.collect('Warehouse Date'),"data-vv-name":"Warehouse Date"},model:{value:(_vm.purchaseOrderData.warehouse_date),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "warehouse_date", $$v)},expression:"purchaseOrderData.warehouse_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"From Date","type":"date","error-messages":_vm.errors.collect('From Date'),"data-vv-name":"From Date"},model:{value:(_vm.purchaseOrderData.from_date),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "from_date", $$v)},expression:"purchaseOrderData.from_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"To Date","type":"date","error-messages":_vm.errors.collect('To Date'),"data-vv-name":"To Date"},model:{value:(_vm.purchaseOrderData.to_date),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "to_date", $$v)},expression:"purchaseOrderData.to_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.purchaseOrderData.purchase_note),callback:function ($$v) {_vm.$set(_vm.purchaseOrderData, "purchase_note", $$v)},expression:"purchaseOrderData.purchase_note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closePurchaseOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Purchase")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("41158bf6", content, true, {});

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditOrderCaseModal),callback:function ($$v) {_vm.addEditOrderCaseModal=$$v},expression:"addEditOrderCaseModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Update Order Case' : 'Add New Order Case')+"\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),(_vm.addEditOrderCaseModal)?_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-size-large pb-2 px-2",attrs:{"xs12":""}},[_c('b',[_vm._v("Order ID: ")]),_vm._v(" "+_vm._s(_vm.formData.order.theOrderID)+"\n            ")]),_vm._v(" "),(!_vm.fromCustomer)?_c('v-flex',{staticClass:"text-size-large pb-2 px-2",attrs:{"xs12":""}},[_c('b',[_vm._v("Customer: ")]),_vm._v(" "+_vm._s(_vm.formData.order.full_name)+"\n            ")]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Note *","error-messages":_vm.errors.collect('Note'),"data-vv-name":"Note"},model:{value:(_vm.formData.note),callback:function ($$v) {_vm.$set(_vm.formData, "note", $$v)},expression:"formData.note"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n            "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"showPurchaseAll":true,"confirmPurchaseAll":_vm.confirmPurchaseAll,"tableData":_vm.tableData,"permissions":{
          purchase_permission: 'purchase_approved_order',
        },"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(_vm.orderIds.length > 0)?_c('div',{staticClass:"row text-center"},[_c('h5',{staticClass:"ma-0",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            Sum of selected orders: Purchase Cost: "+_vm._s(_vm.sumOfSelectedOrders.toFixed(3))+", Total Cost: "+_vm._s(_vm.sumOfSelectedOrdersTotalCost.toFixed(3))+" ("+_vm._s((_vm.sumOfSelectedOrdersTotalCost - _vm.sumOfSelectedOrders).toFixed(2))+")\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.orderIds.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orderIds),expression:"orderIds"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":r.order_id,"checked":Array.isArray(_vm.orderIds)?_vm._i(_vm.orderIds,r.order_id)>-1:(_vm.orderIds)},on:{"change":function($event){var $$a=_vm.orderIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=r.order_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.orderIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.orderIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.orderIds=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#01579b"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('purchase_approved_order'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#2e7d32"},attrs:{"tooltip":"Purchase This Order"},on:{"click":function($event){return _vm.openPurchaseOrderModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_shopping_cart")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('refund_approved_order'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#c62828"},attrs:{"tooltip":"Refund This Order"},on:{"click":function($event){return _vm.openRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_partial_refund'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#ff5722"},attrs:{"tooltip":"Partial Refund"},on:{"click":function($event){return _vm.openPartialRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"fa fa-registered",staticStyle:{"font-size":"1.6em"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_order_case'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#555"},attrs:{"tooltip":"Create Case"},on:{"click":function($event){return _vm.openCreateOrderCaseModal(r)}}},[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"1.6rem"}})])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"px-3"})])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('purchase_approved_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#2e7d32"},attrs:{"tooltip":"Purchase This Order"},on:{"click":function($event){return _vm.openPurchaseOrderModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_shopping_cart")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('refund_approved_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"40px","float":"right"}},[_c('a',{staticStyle:{"color":"#c62828"},attrs:{"tooltip":"Refund This Order"},on:{"click":function($event){return _vm.openRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal},on:{"open-purchase-modal":_vm.handlePurchaseModal,"open-refund-modal":_vm.handleRefundModal,"open-partial-refund-modal":_vm.handlePartialRefundModal}}),_vm._v(" "),_c('refunding-order',{attrs:{"refundOrderModal":_vm.refundOrderModal,"refundOrder":_vm.refundOrder,"refundData":_vm.refundData,"theOrderTotalAmount":_vm.theOrderTotalAmount,"checkAlert":_vm.checkAlert,"closeRefundOrderModal":_vm.closeRefundOrderModal,"loading":_vm.loading}}),_vm._v(" "),_c('partial-refunding-order',{attrs:{"partialRefundOrderModal":_vm.partialRefundOrderModal,"partialRefundOrder":_vm.partialRefundOrder,"partialRefundData":_vm.partialRefundData,"theOrderTotalAmount":_vm.theOrderTotalAmount,"checkAlert":_vm.checkAlert,"closePartialRefundOrderModal":_vm.closePartialRefundOrderModal,"loading":_vm.loading}}),_vm._v(" "),_c('add-barcode',{attrs:{"addBarcodeModal":_vm.addBarcodeModal,"addBarcode":_vm.addBarcode,"addBarcodeData":_vm.addBarcodeData,"checkAlert":_vm.checkAlert,"closeAddBarcodeModal":_vm.closeAddBarcodeModal}}),_vm._v(" "),_c('purchase-order',{attrs:{"closePurchaseOrderModal":_vm.closePurchaseOrderModal,"purchaseOrderModal":_vm.purchaseOrderModal,"successAlert":_vm.successAlert,"purchaseOrderData":_vm.purchaseOrderData,"purchaseAll":_vm.purchaseAll,"purchaseOrder":_vm.purchaseOrder,"banks":_vm.banks}}),_vm._v(" "),_c('add-edit-order-case',{attrs:{"addEditOrderCaseModal":_vm.addEditOrderCaseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditOrderCaseModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Approved Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundedOrder_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a49f988_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundedOrder_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a49f988_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(608);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a038706", content, true, {});

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addRefundNumber_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222dae80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addRefundNumber_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addRefundNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_222dae80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addRefundNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a6879c18", content, true, {});

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.addRefundNumberModal),callback:function ($$v) {_vm.addRefundNumberModal=$$v},expression:"addRefundNumberModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Refund Number")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddRefundNumberModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n              Refund number added successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticStyle:{"width":"70%"},attrs:{"label":"Refund Number*","error-messages":_vm.errors.collect('Refund Number'),"data-vv-name":"Refund Number"},model:{value:(_vm.addRefundNumberData.refund_number),callback:function ($$v) {_vm.$set(_vm.addRefundNumberData, "refund_number", $$v)},expression:"addRefundNumberData.refund_number"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddRefundNumberModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"loggedInUserData":_vm.loggedInUserData,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"65px","max-width":"65px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.last_order_invoice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.internal_shipping_handling))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.national_tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.kreenex_fee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.discount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.refund_number))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.refund_note))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_refund_number'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#039a7c"},attrs:{"tooltip":"Add refund number"},on:{"click":function($event){return _vm.openAddRefundNumberModal(r.order_id, r.refund_number)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_circle")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.note)+", "),_c('br'),_vm._v("\n                "+_vm._s(r.refund_number)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(r.refund_note))]),_vm._v(" "),_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('add-refund-number',{attrs:{"addRefundNumberData":_vm.addRefundNumberData,"closeAddRefundNumberModal":_vm.closeAddRefundNumberModal,"addRefundNumberModal":_vm.addRefundNumberModal,"successAlert":_vm.successAlert,"addRefundNumber":_vm.addRefundNumber}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Refunded Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchasedOrder_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_864ab3a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchasedOrder_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(615)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchasedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_864ab3a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchasedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("724971d1", content, true, {});

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table-tr:hover .action-td{position:sticky;right:-2px}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("13961100", content, true, {});

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{overflow-y:auto!important;overflow-x:hidden}.barcode-row{width:90mm;height:45mm;padding:10px 0;margin-bottom:3px;overflow-y:hidden}.barcode-row:not(:first-child){padding-top:10px}.item p{margin:0;font-size:15px!important;line-height:2.2rem!important}.customer-name{white-space:pre-wrap}#printArea{position:relative;top:50%;background-color:#fff}", ""]);

// exports


/***/ }),
/* 619 */
/***/ (function(module, exports) {

/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\n__webpack_require__(/*! ./sass/index.scss */ \"./src/sass/index.scss\");\n\nvar _init = __webpack_require__(/*! ./js/init */ \"./src/js/init.js\");\n\nvar _init2 = _interopRequireDefault(_init);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar printjs = _init2.default.init;\n\nif (typeof window !== 'undefined') {\n  window.printJS = printjs;\n}\n\nexports.default = printjs;\n\n//# sourceURL=webpack:///./src/index.js?");

/***/ }),

/***/ "./src/js/browser.js":
/*!***************************!*\
  !*** ./src/js/browser.js ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\nvar Browser = {\n  // Firefox 1.0+\n  isFirefox: function isFirefox() {\n    return typeof InstallTrigger !== 'undefined';\n  },\n  // Internet Explorer 6-11\n  isIE: function isIE() {\n    return navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode;\n  },\n  // Edge 20+\n  isEdge: function isEdge() {\n    return !Browser.isIE() && !!window.StyleMedia;\n  },\n  // Chrome 1+\n  isChrome: function isChrome() {\n    return !!window.chrome && !!window.chrome.webstore;\n  },\n  // At least Safari 3+: \"[object HTMLElementConstructor]\"\n  isSafari: function isSafari() {\n    return Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.toLowerCase().indexOf('safari') !== -1;\n  }\n};\n\nexports.default = Browser;\n\n//# sourceURL=webpack:///./src/js/browser.js?");

/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\nexports.addWrapper = addWrapper;\nexports.capitalizePrint = capitalizePrint;\nexports.collectStyles = collectStyles;\nexports.loopNodesCollectStyles = loopNodesCollectStyles;\nexports.addHeader = addHeader;\nfunction addWrapper(htmlData, params) {\n  var bodyStyle = 'font-family:' + params.font + ' !important; font-size: ' + params.font_size + ' !important; width:100%;';\n  return '<div style=\"' + bodyStyle + '\">' + htmlData + '</div>';\n}\n\nfunction capitalizePrint(obj) {\n  return obj.charAt(0).toUpperCase() + obj.slice(1);\n}\n\nfunction collectStyles(element, params) {\n  var win = document.defaultView || window;\n\n  // String variable to hold styling for each element\n  var elementStyle = '';\n\n  // Loop over computed styles\n  var styles = win.getComputedStyle(element, '');\n\n  Object.keys(styles).map(function (key) {\n    // Check if style should be processed\n    if (params.targetStyles.indexOf('*') !== -1 || params.targetStyle.indexOf(styles[key]) !== -1 || targetStylesMatch(params.targetStyles, styles[key])) {\n      if (styles.getPropertyValue(styles[key])) elementStyle += styles[key] + ':' + styles.getPropertyValue(styles[key]) + ';';\n    }\n  });\n\n  // Print friendly defaults\n  elementStyle += 'max-width: ' + params.maxWidth + 'px !important;' + params.font_size + ' !important;';\n\n  return elementStyle;\n}\n\nfunction targetStylesMatch(styles, value) {\n  for (var i = 0; i < styles.length; i++) {\n    if (value.indexOf(styles[i]) !== -1) return true;\n  }\n  return false;\n}\n\nfunction loopNodesCollectStyles(elements, params) {\n  for (var n = 0; n < elements.length; n++) {\n    var currentElement = elements[n];\n\n    // Check if we are skiping this element\n    if (params.ignoreElements.indexOf(currentElement.getAttribute('id')) !== -1) {\n      currentElement.parentNode.removeChild(currentElement);\n      continue;\n    }\n\n    // Form Printing - check if is element Input\n    var tag = currentElement.tagName;\n    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {\n      // Save style to variable\n      var textStyle = collectStyles(currentElement, params);\n\n      // Remove INPUT element and insert a text node\n      var parent = currentElement.parentNode;\n\n      // Get text value\n      var textNode = tag === 'SELECT' ? document.createTextNode(currentElement.options[currentElement.selectedIndex].text) : document.createTextNode(currentElement.value);\n\n      // Create text element\n      var textElement = document.createElement('div');\n      textElement.appendChild(textNode);\n\n      // Add style to text\n      textElement.setAttribute('style', textStyle);\n\n      // Add text\n      parent.appendChild(textElement);\n\n      // Remove input\n      parent.removeChild(currentElement);\n    } else {\n      // Get all styling for print element\n      currentElement.setAttribute('style', collectStyles(currentElement, params));\n    }\n\n    // Check if more elements in tree\n    var children = currentElement.children;\n\n    if (children && children.length) {\n      loopNodesCollectStyles(children, params);\n    }\n  }\n}\n\nfunction addHeader(printElement, header, headerStyle) {\n  // Create header element\n  var headerElement = document.createElement('h1');\n\n  // Create header text node\n  var headerNode = document.createTextNode(header);\n\n  // Build and style\n  headerElement.appendChild(headerNode);\n  headerElement.setAttribute('style', headerStyle);\n\n  printElement.insertBefore(headerElement, printElement.childNodes[0]);\n}\n\n//# sourceURL=webpack:///./src/js/functions.js?");

/***/ }),

/***/ "./src/js/html.js":
/*!************************!*\
  !*** ./src/js/html.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _functions = __webpack_require__(/*! ./functions */ \"./src/js/functions.js\");\n\nvar _print = __webpack_require__(/*! ./print */ \"./src/js/print.js\");\n\nvar _print2 = _interopRequireDefault(_print);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nexports.default = {\n  print: function print(params, printFrame) {\n    // Get HTML printable element\n    var printElement = document.getElementById(params.printable);\n\n    // Check if element exists\n    if (!printElement) {\n      window.console.error('Invalid HTML element id: ' + params.printable);\n\n      return false;\n    }\n\n    // Make a copy of the printElement to prevent DOM changes\n    var printableElement = document.createElement('div');\n    printableElement.appendChild(printElement.cloneNode(true));\n\n    // Add cloned element to DOM, to have DOM element methods available. It will also be easier to colect styles\n    printableElement.setAttribute('style', 'height:0; overflow:hidden;');\n    printableElement.setAttribute('id', 'printJS-html');\n    printElement.parentNode.appendChild(printableElement);\n\n    // Update printableElement variable with newly created DOM element\n    printableElement = document.getElementById('printJS-html');\n\n    // Process html styles\n    if (params.scanStyles === true) {\n      // Optional - include margin and padding\n      if (params.honorMarginPadding) params.targetStyles.push('margin', 'padding');\n\n      // Optional - include color\n      if (params.honorColor) params.targetStyles.push('color');\n\n      // Get main element styling\n      printableElement.setAttribute('style', (0, _functions.collectStyles)(printableElement, params) + 'margin:0 !important;');\n\n      // Get all children elements\n      var elements = printableElement.children;\n\n      // Get styles for all children elements\n      (0, _functions.loopNodesCollectStyles)(elements, params);\n    }\n\n    // Add header\n    if (params.header) {\n      (0, _functions.addHeader)(printableElement, params.header, params.headerStyle);\n    }\n\n    // Remove DOM printableElement\n    printableElement.parentNode.removeChild(printableElement);\n\n    // Store html data\n    params.htmlData = (0, _functions.addWrapper)(printableElement.innerHTML, params);\n\n    // Print html element contents\n    _print2.default.send(params, printFrame);\n  }\n};\n\n//# sourceURL=webpack:///./src/js/html.js?");

/***/ }),

/***/ "./src/js/image.js":
/*!*************************!*\
  !*** ./src/js/image.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _functions = __webpack_require__(/*! ./functions */ \"./src/js/functions.js\");\n\nvar _print = __webpack_require__(/*! ./print */ \"./src/js/print.js\");\n\nvar _print2 = _interopRequireDefault(_print);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nexports.default = {\n  print: function print(params, printFrame) {\n    // Check if we are printing one image or multiple images\n    if (params.printable.constructor !== Array) {\n      // Create array with one image\n      params.printable = [params.printable];\n    }\n\n    // Create printable element (container)\n    var printableElement = document.createElement('div');\n    printableElement.setAttribute('style', 'width:100%');\n\n    // Load images and append\n    loadImagesAndAppendToPrintableElement(printableElement, params).then(function () {\n      // Check if we are adding a header\n      if (params.header) (0, _functions.addHeader)(printableElement, params.header, params.headerStyle);\n\n      // Store html data\n      params.htmlData = printableElement.outerHTML;\n\n      // Print image\n      _print2.default.send(params, printFrame);\n    });\n  }\n};\n\n\nfunction loadImagesAndAppendToPrintableElement(printableElement, params) {\n  var promises = [];\n\n  params.printable.forEach(function (image, index) {\n    // Create the image element\n    var img = document.createElement('img');\n\n    // Set image src with image file url\n    img.src = image;\n\n    // Load image\n    promises.push(loadImageAndAppendToPrintableElement(printableElement, params, img, index));\n  });\n\n  return Promise.all(promises);\n}\n\nfunction loadImageAndAppendToPrintableElement(printableElement, params, img, index) {\n  return new Promise(function (resolve) {\n    img.onload = function () {\n      // Create image wrapper\n      var imageWrapper = document.createElement('div');\n      imageWrapper.setAttribute('style', params.imageStyle);\n\n      img.setAttribute('style', 'width:100%;');\n      img.setAttribute('id', 'printableImage' + index);\n\n      // Append image to wrapper element\n      imageWrapper.appendChild(img);\n\n      // Append wrapper element to printable element\n      printableElement.appendChild(imageWrapper);\n\n      resolve();\n    };\n  });\n}\n\n//# sourceURL=webpack:///./src/js/image.js?");

/***/ }),

/***/ "./src/js/init.js":
/*!************************!*\
  !*** ./src/js/init.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\nvar _browser = __webpack_require__(/*! ./browser */ \"./src/js/browser.js\");\n\nvar _browser2 = _interopRequireDefault(_browser);\n\nvar _modal = __webpack_require__(/*! ./modal */ \"./src/js/modal.js\");\n\nvar _modal2 = _interopRequireDefault(_modal);\n\nvar _pdf = __webpack_require__(/*! ./pdf */ \"./src/js/pdf.js\");\n\nvar _pdf2 = _interopRequireDefault(_pdf);\n\nvar _html = __webpack_require__(/*! ./html */ \"./src/js/html.js\");\n\nvar _html2 = _interopRequireDefault(_html);\n\nvar _image = __webpack_require__(/*! ./image */ \"./src/js/image.js\");\n\nvar _image2 = _interopRequireDefault(_image);\n\nvar _json = __webpack_require__(/*! ./json */ \"./src/js/json.js\");\n\nvar _json2 = _interopRequireDefault(_json);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar printTypes = ['pdf', 'html', 'image', 'json'];\n\nexports.default = {\n  init: function init() {\n    var params = {\n      printable: null,\n      fallbackPrintable: null,\n      type: 'pdf',\n      header: null,\n      headerStyle: 'font-weight: 300;',\n      maxWidth: 800,\n      font: 'TimesNewRoman',\n      font_size: '12pt',\n      honorMarginPadding: true,\n      honorColor: false,\n      properties: null,\n      gridHeaderStyle: 'font-weight: bold; padding: 5px; border: 1px solid #dddddd;',\n      gridStyle: 'border: 1px solid lightgray; margin-bottom: -1px;',\n      showModal: false,\n      onLoadingStart: null,\n      onLoadingEnd: null,\n      onPrintDialogClose: null,\n      modalMessage: 'Retrieving Document...',\n      frameId: 'printJS',\n      htmlData: '',\n      documentTitle: 'Document',\n      targetStyle: ['clear', 'display', 'width', 'min-width', 'height', 'min-height', 'max-height'],\n      targetStyles: ['border', 'box', 'break', 'text-decoration'],\n      ignoreElements: [],\n      imageStyle: 'width:100%;',\n      repeatTableHeader: true,\n      css: null,\n      style: null,\n      scanStyles: true\n\n      // Check if a printable document or object was supplied\n    };var args = arguments[0];\n    if (args === undefined) throw new Error('printJS expects at least 1 attribute.');\n\n    // Process parameters\n    switch (typeof args === 'undefined' ? 'undefined' : _typeof(args)) {\n      case 'string':\n        params.printable = encodeURI(args);\n        params.fallbackPrintable = params.printable;\n        params.type = arguments[1] || params.type;\n        break;\n      case 'object':\n        params.printable = args.printable;\n        params.fallbackPrintable = typeof args.fallbackPrintable !== 'undefined' ? args.fallbackPrintable : params.printable;\n        params.type = typeof args.type !== 'undefined' ? args.type : params.type;\n        params.frameId = typeof args.frameId !== 'undefined' ? args.frameId : params.frameId;\n        params.header = typeof args.header !== 'undefined' ? args.header : params.header;\n        params.headerStyle = typeof args.headerStyle !== 'undefined' ? args.headerStyle : params.headerStyle;\n        params.maxWidth = typeof args.maxWidth !== 'undefined' ? args.maxWidth : params.maxWidth;\n        params.font = typeof args.font !== 'undefined' ? args.font : params.font;\n        params.font_size = typeof args.font_size !== 'undefined' ? args.font_size : params.font_size;\n        params.honorMarginPadding = typeof args.honorMarginPadding !== 'undefined' ? args.honorMarginPadding : params.honorMarginPadding;\n        params.properties = typeof args.properties !== 'undefined' ? args.properties : params.properties;\n        params.gridHeaderStyle = typeof args.gridHeaderStyle !== 'undefined' ? args.gridHeaderStyle : params.gridHeaderStyle;\n        params.gridStyle = typeof args.gridStyle !== 'undefined' ? args.gridStyle : params.gridStyle;\n        params.showModal = typeof args.showModal !== 'undefined' ? args.showModal : params.showModal;\n        params.onLoadingStart = typeof args.onLoadingStart !== 'undefined' ? args.onLoadingStart : params.onLoadingStart;\n        params.onLoadingEnd = typeof args.onLoadingEnd !== 'undefined' ? args.onLoadingEnd : params.onLoadingEnd;\n        params.onPrintDialogClose = typeof args.onPrintDialogClose !== 'undefined' ? args.onPrintDialogClose : params.onPrintDialogClose;\n        params.modalMessage = typeof args.modalMessage !== 'undefined' ? args.modalMessage : params.modalMessage;\n        params.documentTitle = typeof args.documentTitle !== 'undefined' ? args.documentTitle : params.documentTitle;\n        params.targetStyle = typeof args.targetStyle !== 'undefined' ? args.targetStyle : params.targetStyle;\n        params.targetStyles = typeof args.targetStyles !== 'undefined' ? args.targetStyles : params.targetStyles;\n        params.ignoreElements = typeof args.ignoreElements !== 'undefined' ? args.ignoreElements : params.ignoreElements;\n        params.imageStyle = typeof args.imageStyle !== 'undefined' ? args.imageStyle : params.imageStyle;\n        params.repeatTableHeader = typeof args.repeatTableHeader !== 'undefined' ? args.repeatTableHeader : params.repeatTableHeader;\n        params.css = typeof args.css !== 'undefined' ? args.css : params.css;\n        params.style = typeof args.style !== 'undefined' ? args.style : params.style;\n        params.scanStyles = typeof args.scanStyles !== 'undefined' ? args.scanStyles : params.scanStyles;\n        break;\n      default:\n        throw new Error('Unexpected argument type! Expected \"string\" or \"object\", got ' + (typeof args === 'undefined' ? 'undefined' : _typeof(args)));\n    }\n\n    // Validate printable\n    if (!params.printable) throw new Error('Missing printable information.');\n\n    // Validate type\n    if (!params.type || typeof params.type !== 'string' || printTypes.indexOf(params.type.toLowerCase()) === -1) {\n      throw new Error('Invalid print type. Available types are: pdf, html, image and json.');\n    }\n\n    // Check if we are showing a feedback message to the user (useful for large files)\n    if (params.showModal) _modal2.default.show(params);\n\n    // Check for a print start hook function\n    if (params.onLoadingStart) params.onLoadingStart();\n\n    // To prevent duplication and issues, remove any used printFrame from the DOM\n    var usedFrame = document.getElementById(params.frameId);\n\n    if (usedFrame) usedFrame.parentNode.removeChild(usedFrame);\n\n    // Create a new iframe or embed element (IE prints blank pdf's if we use iframe)\n    var printFrame = void 0;\n\n    // Create iframe element\n    printFrame = document.createElement('iframe');\n\n    // Hide iframe\n    printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 0; position: absolute;');\n\n    // Set iframe element id\n    printFrame.setAttribute('id', params.frameId);\n\n    // For non pdf printing, pass an html document string to srcdoc (force onload callback)\n    if (params.type !== 'pdf') {\n      printFrame.srcdoc = '<html><head><title>' + params.documentTitle + '</title>';\n\n      // Attach css files\n      if (params.css !== null) {\n        // Add support for single file\n        if (!Array.isArray(params.css)) params.css = [params.css];\n\n        // Create link tags for each css file\n        params.css.forEach(function (file) {\n          printFrame.srcdoc += '<link rel=\"stylesheet\" href=\"' + file + '\">';\n        });\n      }\n\n      printFrame.srcdoc += '</head><body></body></html>';\n    }\n\n    // Check printable type\n    switch (params.type) {\n      case 'pdf':\n        // Check browser support for pdf and if not supported we will just open the pdf file instead\n        if (_browser2.default.isFirefox() || _browser2.default.isEdge() || _browser2.default.isIE()) {\n          console.info('PrintJS currently doesn\\'t support PDF printing in Firefox, Internet Explorer and Edge.');\n          var win = window.open(params.fallbackPrintable, '_blank');\n          win.focus();\n          // Make sure there is no loading modal opened\n          if (params.showModal) _modal2.default.close();\n          if (params.onLoadingEnd) params.onLoadingEnd();\n        } else {\n          _pdf2.default.print(params, printFrame);\n        }\n        break;\n      case 'image':\n        _image2.default.print(params, printFrame);\n        break;\n      case 'html':\n        _html2.default.print(params, printFrame);\n        break;\n      case 'json':\n        _json2.default.print(params, printFrame);\n        break;\n    }\n  }\n};\n\n//# sourceURL=webpack:///./src/js/init.js?");

/***/ }),

/***/ "./src/js/json.js":
/*!************************!*\
  !*** ./src/js/json.js ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\nvar _functions = __webpack_require__(/*! ./functions */ \"./src/js/functions.js\");\n\nvar _print = __webpack_require__(/*! ./print */ \"./src/js/print.js\");\n\nvar _print2 = _interopRequireDefault(_print);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nexports.default = {\n  print: function print(params, printFrame) {\n    // Check if we received proper data\n    if (_typeof(params.printable) !== 'object') {\n      throw new Error('Invalid javascript data object (JSON).');\n    }\n\n    // Validate repeatTableHeader\n    if (typeof params.repeatTableHeader !== 'boolean') {\n      throw new Error('Invalid value for repeatTableHeader attribute (JSON).');\n    }\n\n    // Validate properties\n    if (!params.properties || !Array.isArray(params.properties)) {\n      throw new Error('Invalid properties array for your JSON data.');\n    }\n\n    // We will format the property objects to keep the JSON api compatible with older releases\n    params.properties = params.properties.map(function (property) {\n      return {\n        field: (typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object' ? property.field : property,\n        displayName: (typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object' ? property.displayName : property,\n        columnSize: (typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object' && property.columnSize + ';' ? property.columnSize : 100 / params.properties.length + '%;'\n      };\n    });\n\n    // Variable to hold the html string\n    var htmlData = '';\n\n    // Check if there is a header on top of the table\n    if (params.header) htmlData += '<h1 style=\"' + params.headerStyle + '\">' + params.header + '</h1>';\n\n    // Build the printable html data\n    htmlData += jsonToHTML(params);\n\n    // Store the data\n    params.htmlData = (0, _functions.addWrapper)(htmlData, params);\n\n    // Print the json data\n    _print2.default.send(params, printFrame);\n  }\n};\n\n\nfunction jsonToHTML(params) {\n  // Get the row and column data\n  var data = params.printable;\n  var properties = params.properties;\n\n  // Create a html table\n  var htmlData = '<table style=\"border-collapse: collapse; width: 100%;\">';\n\n  // Check if the header should be repeated\n  if (params.repeatTableHeader) {\n    htmlData += '<thead>';\n  }\n\n  // Add the table header row\n  htmlData += '<tr>';\n\n  // Add the table header columns\n  for (var a = 0; a < properties.length; a++) {\n    htmlData += '<th style=\"width:' + properties[a].columnSize + ';' + params.gridHeaderStyle + '\">' + (0, _functions.capitalizePrint)(properties[a].displayName) + '</th>';\n  }\n\n  // Add the closing tag for the table header row\n  htmlData += '</tr>';\n\n  // If the table header is marked as repeated, add the closing tag\n  if (params.repeatTableHeader) {\n    htmlData += '</thead>';\n  }\n\n  // Create the table body\n  htmlData += '<tbody>';\n\n  // Add the table data rows\n  for (var i = 0; i < data.length; i++) {\n    // Add the row starting tag\n    htmlData += '<tr>';\n\n    // Print selected properties only\n    for (var n = 0; n < properties.length; n++) {\n      var stringData = data[i];\n\n      // Support nested objects\n      var property = properties[n].field.split('.');\n      if (property.length > 1) {\n        for (var p = 0; p < property.length; p++) {\n          stringData = stringData[property[p]];\n        }\n      } else {\n        stringData = stringData[properties[n].field];\n      }\n\n      // Add the row contents and styles\n      htmlData += '<td style=\"width:' + properties[n].columnSize + params.gridStyle + '\">' + stringData + '</td>';\n    }\n\n    // Add the row closing tag\n    htmlData += '</tr>';\n  }\n\n  // Add the table and body closing tags\n  htmlData += '</tbody></table>';\n\n  return htmlData;\n}\n\n//# sourceURL=webpack:///./src/js/json.js?");

/***/ }),

/***/ "./src/js/modal.js":
/*!*************************!*\
  !*** ./src/js/modal.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\nvar Modal = {\n  show: function show(params) {\n    // Build modal\n    var modalStyle = 'font-family:sans-serif; ' + 'display:table; ' + 'text-align:center; ' + 'font-weight:300; ' + 'font-size:30px; ' + 'left:0; top:0;' + 'position:fixed; ' + 'z-index: 9990;' + 'color: #0460B5; ' + 'width: 100%; ' + 'height: 100%; ' + 'background-color:rgba(255,255,255,.9);' + 'transition: opacity .3s ease;';\n\n    // Create wrapper\n    var printModal = document.createElement('div');\n    printModal.setAttribute('style', modalStyle);\n    printModal.setAttribute('id', 'printJS-Modal');\n\n    // Create content div\n    var contentDiv = document.createElement('div');\n    contentDiv.setAttribute('style', 'display:table-cell; vertical-align:middle; padding-bottom:100px;');\n\n    // Add close button (requires print.css)\n    var closeButton = document.createElement('div');\n    closeButton.setAttribute('class', 'printClose');\n    closeButton.setAttribute('id', 'printClose');\n    contentDiv.appendChild(closeButton);\n\n    // Add spinner (requires print.css)\n    var spinner = document.createElement('span');\n    spinner.setAttribute('class', 'printSpinner');\n    contentDiv.appendChild(spinner);\n\n    // Add message\n    var messageNode = document.createTextNode(params.modalMessage);\n    contentDiv.appendChild(messageNode);\n\n    // Add contentDiv to printModal\n    printModal.appendChild(contentDiv);\n\n    // Append print modal element to document body\n    document.getElementsByTagName('body')[0].appendChild(printModal);\n\n    // Add event listener to close button\n    document.getElementById('printClose').addEventListener('click', function () {\n      Modal.close();\n    });\n  },\n  close: function close() {\n    var printFrame = document.getElementById('printJS-Modal');\n\n    printFrame.parentNode.removeChild(printFrame);\n  }\n};\n\nexports.default = Modal;\n\n//# sourceURL=webpack:///./src/js/modal.js?");

/***/ }),

/***/ "./src/js/pdf.js":
/*!***********************!*\
  !*** ./src/js/pdf.js ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _print = __webpack_require__(/*! ./print */ \"./src/js/print.js\");\n\nvar _print2 = _interopRequireDefault(_print);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nexports.default = {\n  print: function print(params, printFrame) {\n    // Format pdf url\n    params.printable = params.printable.indexOf('http') !== -1 ? params.printable : window.location.origin + (params.printable.charAt(0) !== '/' ? '/' + params.printable : params.printable);\n\n    // If showing a loading modal or using a hook function, we will preload the pdf file\n    if (params.showModal || params.onLoadingStart) {\n      // Get the file through a http request\n      var req = new window.XMLHttpRequest();\n      req.responseType = 'arraybuffer';\n\n      req.addEventListener('load', function () {\n        // Pass response data to a blob and create a local object url\n        var localPdf = new window.Blob([req.response], { type: 'application/pdf' });\n        localPdf = window.URL.createObjectURL(localPdf);\n\n        // Pass the url to the printable parameter (replacing the original pdf file url)\n        // This will prevent a second request to the file (server) once the iframe loads\n        params.printable = localPdf;\n\n        send(params, printFrame);\n      });\n\n      req.open('GET', params.printable, true);\n      req.send();\n    } else {\n      send(params, printFrame);\n    }\n  }\n};\n\n\nfunction send(params, printFrame) {\n  // Set iframe src with pdf document url\n  printFrame.setAttribute('src', params.printable);\n  _print2.default.send(params, printFrame);\n}\n\n//# sourceURL=webpack:///./src/js/pdf.js?");

/***/ }),

/***/ "./src/js/print.js":
/*!*************************!*\
  !*** ./src/js/print.js ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nObject.defineProperty(exports, \"__esModule\", {\n  value: true\n});\n\nvar _browser = __webpack_require__(/*! ./browser */ \"./src/js/browser.js\");\n\nvar _browser2 = _interopRequireDefault(_browser);\n\nvar _modal = __webpack_require__(/*! ./modal */ \"./src/js/modal.js\");\n\nvar _modal2 = _interopRequireDefault(_modal);\n\nfunction _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }\n\nvar Print = {\n  send: function send(params, printFrame) {\n    // Append iframe element to document body\n    document.getElementsByTagName('body')[0].appendChild(printFrame);\n\n    // Get iframe element\n    var iframeElement = document.getElementById(params.frameId);\n\n    // Wait for iframe to load all content\n    if (params.type === 'pdf' && (_browser2.default.isIE() || _browser2.default.isEdge())) {\n      iframeElement.setAttribute('onload', finishPrint(iframeElement, params));\n    } else {\n      printFrame.onload = function () {\n        if (params.type === 'pdf') {\n          finishPrint(iframeElement, params);\n        } else {\n          // Get iframe element document\n          var printDocument = iframeElement.contentWindow || iframeElement.contentDocument;\n          if (printDocument.document) printDocument = printDocument.document;\n\n          // Inject printable html into iframe body\n          printDocument.body.innerHTML = params.htmlData;\n\n          // Add custom style\n          if (params.type !== 'pdf' && params.style !== null) {\n            // Create style element\n            var style = document.createElement('style');\n            style.innerHTML = params.style;\n\n            // Append style element to iframe's head\n            printDocument.head.appendChild(style);\n          }\n\n          // If printing image, wait for it to load inside the iframe\n          if (params.type === 'image') {\n            loadIframeImages(printDocument, params).then(function () {\n              finishPrint(iframeElement, params);\n            });\n          } else {\n            finishPrint(iframeElement, params);\n          }\n        }\n      };\n    }\n  }\n};\n\nfunction finishPrint(iframeElement, params) {\n  iframeElement.focus();\n\n  // If Edge or IE, try catch with execCommand\n  if (_browser2.default.isEdge() || _browser2.default.isIE()) {\n    try {\n      iframeElement.contentWindow.document.execCommand('print', false, null);\n    } catch (e) {\n      iframeElement.contentWindow.print();\n    }\n  } else {\n    // Other browsers\n    iframeElement.contentWindow.print();\n  }\n\n  // If we are showing a feedback message to user, remove it\n  if (params.showModal) _modal2.default.close();\n\n  // Check for a finished loading hook function\n  if (params.onLoadingEnd) params.onLoadingEnd();\n\n  // If preloading pdf files, clean blob url\n  if (params.showModal || params.onLoadingStart) window.URL.revokeObjectURL(params.printable);\n\n  // If a onPrintDialogClose callback is given, execute it\n  if (params.onPrintDialogClose) {\n    var event = 'mouseover';\n\n    if (_browser2.default.isChrome() || _browser2.default.isFirefox()) {\n      // Firefox will require an extra click in the document\n      // to fire the focus event. Should we console.warn that?\n      event = 'focus';\n    }\n    var handler = function handler() {\n      // Make sure the event only happens once.\n      window.removeEventListener(event, handler);\n\n      params.onPrintDialogClose();\n    };\n\n    window.addEventListener(event, handler);\n  }\n}\n\nfunction loadIframeImages(printDocument, params) {\n  var promises = [];\n\n  params.printable.forEach(function (image, index) {\n    return promises.push(loadIframeImage(printDocument, index));\n  });\n\n  return Promise.all(promises);\n}\n\nfunction loadIframeImage(printDocument, index) {\n  return new Promise(function (resolve) {\n    var image = printDocument ? printDocument.getElementById('printableImage' + index) : null;\n\n    if (!image || typeof image.naturalWidth === 'undefined' || image.naturalWidth === 0) {\n      setTimeout(function () {\n        loadIframeImage(printDocument, index);\n      }, 500);\n    } else {\n      resolve();\n    }\n  });\n}\n\nexports.default = Print;\n\n//# sourceURL=webpack:///./src/js/print.js?");

/***/ }),

/***/ "./src/sass/index.scss":
/*!*****************************!*\
  !*** ./src/sass/index.scss ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

eval("// extracted by mini-css-extract-plugin\n\n//# sourceURL=webpack:///./src/sass/index.scss?");

/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

eval("module.exports = __webpack_require__(/*! ./src/index.js */\"./src/index.js\");\n\n\n//# sourceURL=webpack:///multi_./src/index.js?");

/***/ })

/******/ });

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.generateQrCodeModal),callback:function ($$v) {_vm.generateQrCodeModal=$$v},expression:"generateQrCodeModal"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"col-sm-2 col-md-2 col-md-offset-10"},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","id":"close-button"},on:{"click":function($event){return _vm.generator()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)]),_vm._v(" "),_c('v-card-text',[_c('div',{attrs:{"id":"printArea"}},_vm._l((_vm.qrCodeValues),function(qr,index){return _c('div',{key:index,staticClass:"barcode-row",style:(qr[7] == 2 ? 'border: 3px solid #000; border-radius: 6px' : '')},[_c('div',{staticClass:"item col-xs-9"},[_c('p',[_c('b',[_vm._v("Order ID: ")]),_vm._v(_vm._s(qr[4]))]),_vm._v(" "),_c('p',{staticClass:"customer-name"},[_c('b',[_vm._v("Name: ")]),_vm._v(_vm._s(qr[1]))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Phone: ")]),_vm._v(_vm._s(qr[2]))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Product: ")]),_vm._v(_vm._s(qr[qr.length - 1]))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('qr-code',{attrs:{"text":qr[0].toString(),"size":65}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","margin":"0px"}},[_c('b',[_vm._v(_vm._s(qr[0]))])]),_vm._v(" "),(qr[5] === '1' )?_c('div',{staticClass:"mt-1 text-center",staticStyle:{"border":"2px solid black","border-radius":"4px","font-size":"11px","text-transform":"uppercase","font-weight":"bold"}},[_vm._v("\n                Ship only\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"page-break-before":"always"}})])}),0)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":function($event){return _vm.printMe()}}},[_vm._v("Print")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToWarehouse_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b75ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToWarehouse_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToWarehouse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32b75ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToWarehouse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6e3c78d0", content, true, {});

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.sendToWarehouseModal),callback:function ($$v) {_vm.sendToWarehouseModal=$$v},expression:"sendToWarehouseModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('div',{staticClass:"col-sm-10"},[_c('span',{staticClass:"headline"},[_vm._v("Send order to warehouse")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendToWarehouseModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":"","sm5":"","md4":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToWarehouseData.qrcode),expression:"sendToWarehouseData.qrcode"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"QrCode*","error-messages":_vm.errors.collect('qrcode'),"data-vv-name":"qrcode"},domProps:{"value":(_vm.sendToWarehouseData.qrcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToWarehouseData, "qrcode", $event.target.value)}}})])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Send")])],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addTrackNumber_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56abb858_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addTrackNumber_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addTrackNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56abb858_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addTrackNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3cc63a15", content, true, {});

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.addTrackNumberModal),callback:function ($$v) {_vm.addTrackNumberModal=$$v},expression:"addTrackNumberModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Track number")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddTrackNumberModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.checkAlert,"type":"success"}},[_vm._v("\n              Track number added successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Track number*","error-messages":_vm.errors.collect('Track number'),"data-vv-name":"Track number"},on:{"input":function($event){return _vm.removeSpaces()}},model:{value:(_vm.addTrackNumberData.track_number),callback:function ($$v) {_vm.$set(_vm.addTrackNumberData, "track_number", $$v)},expression:"addTrackNumberData.track_number"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"7%"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("ADD")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_takeOrderImage_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f6554a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_takeOrderImage_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_takeOrderImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f6554a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_takeOrderImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7b7e1ab6", content, true, {});

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".web-camera-container{margin-top:2rem;margin-bottom:2rem;padding:2rem;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #ccc;border-radius:4px;width:500px}.camera-button{margin-bottom:2rem}.camera-box .camera-shutter{opacity:0;width:450px;height:337.5px;background-color:#fff;position:absolute}.camera-zoom{width:100%}.camera-shoot,.camera-zoom{margin:1rem 0}.camera-shoot button{height:60px;width:60px;display:flex;align-items:center;justify-content:center;border-radius:100%}.camera-shoot button img{height:35px;object-fit:cover}.camera-loading{overflow:hidden;min-height:150px;margin:3rem 0 0 -1.2rem}.camera-loading,.camera-loading ul{height:100%;position:absolute;width:100%}.camera-loading ul{z-index:999999;margin:0}.camera-loading .loader-circle{display:block;height:14px;margin:0 auto;top:50%;left:100%;transform:translateY(-50%);transform:translateX(-50%);position:absolute;width:100%;padding:0}.camera-loading .loader-circle li{display:block;float:left;width:10px;height:10px;line-height:10px;padding:0;position:relative;margin:0 0 0 4px;background:#999;animation:preload 1s infinite;top:-50%;border-radius:100%}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.takeOrderImageDialog),callback:function ($$v) {_vm.takeOrderImageDialog=$$v},expression:"takeOrderImageDialog"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Order Image")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"web-camera-container",attrs:{"xs12":"","sm12":"","md12":"","lg5":""}},[_c('div',{staticClass:"camera-button"},[_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"outline":"","color":"success"},on:{"click":_vm.toggleCamera}},[(!_vm.isCameraOpen)?_c('span',[_vm._v("Open Camera")]):_c('span',[_vm._v("Close Camera")])]),_vm._v(" "),(_vm.isCameraOpen)?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"primary"},on:{"click":_vm.flipCamera}},[_vm._v("Flip Camera")]):_vm._e()],1),_vm._v(" "),(_vm.isCameraOpen)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"camera-box",class:{ 'flash' : _vm.isShotPhoto },staticStyle:{"overflow":"hidden","width":"450px","height":"337.5px"}},[_c('div',{staticClass:"camera-shutter",class:{'flash' : _vm.isShotPhoto}}),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPhotoTaken),expression:"!isPhotoTaken"}],ref:"camera",style:({ transform: ("scale(" + _vm.zoom + ")") }),attrs:{"width":450,"height":337.5,"autoplay":""}}),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPhotoTaken),expression:"isPhotoTaken"}],ref:"canvas",attrs:{"id":"photoTaken","width":450,"height":337.5}})]):_vm._e(),_vm._v(" "),(_vm.isCameraOpen && !_vm.isLoading)?_c('div',{staticClass:"camera-zoom"},[_c('div',{staticClass:"d-flex align-items-center",staticStyle:{"width":"100%","padding":"0 1rem"}},[_c('v-slider',{staticStyle:{"flex":"1"},attrs:{"min":1,"max":3,"step":0.1,"thumb-label":""},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isCameraOpen && !_vm.isLoading)?_c('div',{staticClass:"camera-shoot"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.takePhoto}},[_c('img',{attrs:{"src":"https://img.icons8.com/material-outlined/50/000000/camera--v2.png"}})])]):_vm._e(),_vm._v(" "),(_vm.isPhotoTaken && _vm.isCameraOpen)?_c('div',{staticClass:"camera-download"},[_c('a',{staticClass:"button",attrs:{"id":"downloadPhoto","download":("Order #" + _vm.oid + ".jpg"),"role":"button"},on:{"click":_vm.downloadImage}},[_vm._v("\n                      Download\n                    ")])]):_vm._e()])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeRefundOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(634);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("64ab079c", content, true, {});

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"400px"},model:{value:(_vm.addWarehouseDateModal),callback:function ($$v) {_vm.addWarehouseDateModal=$$v},expression:"addWarehouseDateModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Warehouse Date")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.closeWarehouseDateModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Warehouse Date","type":"date","error-messages":_vm.errors.collect('Warehouse Date'),"data-vv-name":"Warehouse Date"},model:{value:(_vm.warehouseDateData.warehouse_date),callback:function ($$v) {_vm.$set(_vm.warehouseDateData, "warehouse_date", $$v)},expression:"warehouseDateData.warehouse_date"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"7%"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0208bbea", content, true, {});

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.takePhotoModal),callback:function ($$v) {_vm.takePhotoModal=$$v},expression:"takePhotoModal"}},[_c('v-card',{staticClass:"px-4 py-2",attrs:{"flat":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center",staticStyle:{"overflow":"hidden","width":"440px","height":"250px","margin":"0 auto"}},[_c('video',{style:({ transform: ("scale(" + _vm.zoom + ")") }),attrs:{"id":"video","width":"440","height":"250","autoplay":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-2 text-center"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center"},[_c('v-slider',{staticStyle:{"flex":"1"},attrs:{"min":1,"max":3,"step":0.1,"thumb-label":""},model:{value:(_vm.zoom),callback:function ($$v) {_vm.zoom=$$v},expression:"zoom"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-4 text-center"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"primary","small":""},on:{"click":function($event){return _vm.takePhoto()}}},[_vm._v("\n            Take Photo\n          ")])],1),_vm._v(" "),_vm._l((_vm.displayPhotos),function(photo,phIndex){return _c('div',{key:phIndex,staticClass:"col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2",staticStyle:{"position":"relative"}},[_c('i',{staticClass:"fa fa-times fa-2x",staticStyle:{"position":"absolute","top":"-10px","right":"0px","color":"#EF5350","cursor":"pointer"},on:{"click":function($event){return _vm.removeImage(phIndex)}}}),_vm._v(" "),_c('img',{staticStyle:{"margin-bottom":"10px"},attrs:{"src":photo,"alt":"Image","width":"100%","height":"120px"}})])}),_vm._v(" "),_c('div',{staticClass:"col-12",staticStyle:{"display":"none"}},[(_vm.showCanvas)?_c('canvas',{attrs:{"id":"canvas","width":"350","height":"250"}}):_vm._e()])],2),_vm._v(" "),_c('v-card-actions',[_c('a',{staticClass:"btn white",staticStyle:{"box-shadow":"none","border":"1px solid #FFB74D !important","color":"#FFB74D","display":"none"},style:(!_vm.photoExist ? 'pointer-events: none' : ''),attrs:{"id":"downloadPhoto","download":("Order #" + (_vm.orderData.theOrderID) + ".jpg"),"role":"button"},on:{"click":function($event){return _vm.downloadImage()}}},[_vm._v("\n          Download\n        ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","small":""},on:{"click":function($event){return _vm.newPhoto()}}},[_vm._v("Open Camera")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-left":"8px"},attrs:{"outline":"","small":"","color":"primary"},on:{"click":function($event){return _vm.flipCamera()}}},[_vm._v("Flip Camera")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","small":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"color":"success","depressed":"","outline":"","small":"","disabled":_vm.takenPhotos.length < 1},on:{"click":function($event){return _vm.saveImage()}}},[_vm._v("Save")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSeccessMsg),expression:"showSeccessMsg"}],staticClass:"col-12 green lighten-1 py-1 px-3",staticStyle:{"font-size":"16px","color":"#fff","border-radius":"4px"}},[_vm._v("\n          Image Saved\n        ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          generate_qr_code: 'purchase_generate_qrcode',
          send_to_warehouse: 'send_to_warehouse',
        },"removeAddButton":true,"removeWarehouseDeliverButton":false,"openSendToWarehouseModal":_vm.openSendToWarehouseModal,"addQrCodeGenerateButton":true,"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 pt-0"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pl-3",attrs:{"xs5":"","sm4":"","md5":"","lg3":""}},[_c('v-checkbox',{attrs:{"hide-details":"","label":"Warehouse Passed","true-value":"1","false-value":"0"},on:{"change":function($event){return _vm.getResults()}},model:{value:(_vm.tableData.wh_dt_passed),callback:function ($$v) {_vm.$set(_vm.tableData, "wh_dt_passed", $$v)},expression:"tableData.wh_dt_passed"}})],1)],1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,staticClass:"table-tr",style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; }) ? 'background-color: #FFF9C4' : (r.is_ship_only == '1' ? 'background-color: #A5D6A7' : _vm.getRowStyle(r)))},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.last_order_invoice))]),_vm._v(" "),(r.qrcode == null || r.qrcode == '')?_c('td',[_vm._v(_vm._s(r.theOrderID))]):_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticStyle:{"max-width":"200px"}},[_vm._v(_vm._s(r.track_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":_vm.$_image_path(r.profile_image)}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.warehouse_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.barcode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',{staticClass:"action-td"},[_c('div',{staticClass:"action-container",staticStyle:{"display":"flex"}},[(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","padding":"0px 6px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('purchase_cancel_order') && r.is_ship_only == '1')?_c('a',{staticStyle:{"color":"#c62828","padding":"0px 6px"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('refund_purchased_order'))?_c('a',{staticStyle:{"color":"#C62828","padding":"0px 6px"},attrs:{"tooltip":"Refund This Order"},on:{"click":function($event){return _vm.openRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_track_number'))?_c('a',{staticStyle:{"color":"rgb(4, 137, 151)","padding":"0px 6px"},attrs:{"tooltip":"Add Track number"},on:{"click":function($event){return _vm.openAddTrackNumberModal(r.order_id, r.track_number)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_box")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_order_number'))?_c('a',{staticStyle:{"color":"#00796B","padding":"0px 6px"},attrs:{"tooltip":"Add Order Number"},on:{"click":function($event){return _vm.openAddBarcodeModal(r.order_id, r.barcode)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_circle")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_warehouse_date'))?_c('a',{staticStyle:{"color":"#5579fB","padding":"0px 6px"},attrs:{"tooltip":"Add warehouse date"},on:{"click":function($event){return _vm.openAddWarehouseDateModal(r.order_id, r.warehouse_date)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_partial_refund'))?_c('a',{staticStyle:{"padding-left":"6px","padding-right":"6px","color":"#FF5722"},attrs:{"tooltip":"Partial Refund"},on:{"click":function($event){return _vm.openPartialRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"fa fa-registered",staticStyle:{"font-size":"1.7em"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_order_case'))?_c('a',{staticClass:"px-2",staticStyle:{"color":"#555"},attrs:{"tooltip":"Create Case"},on:{"click":function($event){return _vm.openCreateOrderCaseModal(r)}}},[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"1.6rem"}})]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isPurchase":true,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll,"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[(r.qrcode == null || r.qrcode == '')?_c('span',[_vm._v(_vm._s(r.theOrderID))]):_c('span',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.theOrderID))]),_vm._v(" "),_c('br'),_vm._v(_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n                "),_c('br'),_vm._v("\n                QrValue : "+_vm._s(r.order_id)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(r.track_number != null)?_c('span',[_vm._v("Track No: "+_vm._s(r.track_number)+", "),_c('br')]):_vm._e(),_vm._v(" "),(r.barcode != null)?_c('span',[_vm._v("Order Number: "+_vm._s(r.barcode)+", "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('refund_purchased_order'))?_c('span',{staticStyle:{"padding-left":"1px","padding-right":"2px","float":"left"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Refund This Order"},on:{"click":function($event){return _vm.openRefundOrderModal(r.order_id, r.total_amount)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("block")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_track_number'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"2px","float":"left"}},[_c('a',{staticStyle:{"color":"rgb(4, 137, 151)"},attrs:{"tooltip":"Add Track number"},on:{"click":function($event){return _vm.openAddTrackNumberModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_box")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('Order Number'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"60px","float":"right"}},[_c('a',{staticStyle:{"color":"#00796B"},attrs:{"tooltip":"Add Order Number"},on:{"click":function($event){return _vm.openAddBarcodeModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_circle")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_warehouse_date'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"60px","float":"right"}},[_c('a',{staticStyle:{"color":"#5579fB","padding":"0px 6px"},attrs:{"tooltip":"Add warehouse date"},on:{"click":function($event){return _vm.openAddWarehouseDateModal(r.order_id, r.warehouse_date)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('create-qr-code',{attrs:{"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"generateQrCodeModal":_vm.generateQrCodeModal,"closeGenerateQrCodeModal":_vm.closeGenerateQrCodeModal,"qrCodeValues":_vm.qrCodeValues,"generateQrCode":_vm.generateQrCode,"getResults":_vm.getResults}}),_vm._v(" "),_c('send-to-warehouse',{attrs:{"sendToWarehouseModal":_vm.sendToWarehouseModal,"closeSendToWarehouseModal":_vm.closeSendToWarehouseModal,"sendToWarehouseData":_vm.sendToWarehouseData,"sendToWarehouse":_vm.sendToWarehouse}}),_vm._v(" "),_c('refunding-order',{attrs:{"refundOrderModal":_vm.refundOrderModal,"refundOrder":_vm.refundOrder,"refundData":_vm.refundData,"checkAlert":_vm.checkAlert,"closeRefundOrderModal":_vm.closeRefundOrderModal,"loading":_vm.loading,"theOrderTotalAmount":_vm.theOrderTotalAmount}}),_vm._v(" "),_c('add-barcode',{attrs:{"addBarcodeModal":_vm.addBarcodeModal,"addBarcode":_vm.addBarcode,"addBarcodeData":_vm.addBarcodeData,"checkAlert":_vm.checkAlert,"closeAddBarcodeModal":_vm.closeAddBarcodeModal}}),_vm._v(" "),_c('add-track-number',{attrs:{"addTrackNumberModal":_vm.addTrackNumberModal,"addTrackNumber":_vm.addTrackNumber,"addTrackNumberData":_vm.addTrackNumberData,"checkAlert":_vm.checkAlert,"closeAddTrackNumberModal":_vm.closeAddTrackNumberModal}}),_vm._v(" "),_c('take-order-image',{attrs:{"order_id_fk":_vm.oID,"takeOrderImageDialog":_vm.takeOrderImageDialog}}),_vm._v(" "),_c('add-warehouse-date',{attrs:{"addWarehouseDateModal":_vm.addWarehouseDateModal,"warehouseDateData":_vm.warehouseDateData,"closeWarehouseDateModal":_vm.closeWarehouseDateModal,"submitWarehouseDate":_vm.submitWarehouseDate}}),_vm._v(" "),_c('take-photo',{attrs:{"takePhotoModal":_vm.takePhotoModal,"orderData":_vm.orderData},on:{"close":function($event){_vm.takePhotoModal = false}}}),_vm._v(" "),_c('partial-refunding-order',{attrs:{"partialRefundOrderModal":_vm.partialRefundOrderModal,"partialRefundOrder":_vm.partialRefundOrder,"partialRefundData":_vm.partialRefundData,"theOrderTotalAmount":_vm.theOrderTotalAmount,"checkAlert":_vm.checkAlert,"closePartialRefundOrderModal":_vm.closePartialRefundOrderModal,"loading":_vm.loading}}),_vm._v(" "),_c('add-edit-order-case',{attrs:{"addEditOrderCaseModal":_vm.addEditOrderCaseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditOrderCaseModal = false}}}),_vm._v(" "),_c('admin-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Purchased Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouseDeliveredOrder_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27551d8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouseDeliveredOrder_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouseDeliveredOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27551d8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouseDeliveredOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(642);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1b11af04", content, true, {});

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".ship-only-label{display:inline-block;padding:2px 8px;border:2px solid #333;border-radius:5px;font-weight:700;font-size:.9em;color:green;border-color:green}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.pending-boat-icon{position:relative;display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center}.pending-boat-icon .boat-base{font-size:24px;line-height:24px}.pending-boat-icon .boat-badge{position:absolute;bottom:-4px;right:-6px;font-size:14px;background:#fff;color:#ff9800;border-radius:50%;padding:2px;box-shadow:0 0 0 1px #ddd}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("779e4b3a", content, true, {});

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.sendToIntShipmentModal),callback:function ($$v) {_vm.sendToIntShipmentModal=$$v},expression:"sendToIntShipmentModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Send to "+_vm._s(_vm.pendingShipment ? 'Int' : 'Pending')+" Shipment")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendToIntShipmentModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md4":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToIntShipmentData.order_id),expression:"sendToIntShipmentData.order_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"QrCode*","error-messages":_vm.errors.collect('qrcode'),"data-vv-name":"qrcode","autofocus":""},domProps:{"value":(_vm.sendToIntShipmentData.order_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToIntShipmentData, "order_id", $event.target.value)}}})])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Send")])],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewShiponly_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285582fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewShiponly_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewShiponly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_285582fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewShiponly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("76196d9d", content, true, {});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.addNewShiponlyModal),callback:function ($$v) {_vm.addNewShiponlyModal=$$v},expression:"addNewShiponlyModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("New order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddNewShiponlyModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Item ordered successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.checkURL}},[_vm._v("\n              URL format not acceptable\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[(_vm.loggedInUserData.is_staff)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('customer_id_fk'),"data-vv-name":"customer_id_fk","label":"Customer*","single-line":""},model:{value:(_vm.makeOrderData.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "customer_id_fk", $$v)},expression:"makeOrderData.customer_id_fk"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('quantity'),"data-vv-name":"quantity"},model:{value:(_vm.makeOrderData.quantity),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "quantity", $$v)},expression:"makeOrderData.quantity"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.makeOrderData.warehouse_id_fk)}},model:{value:(_vm.makeOrderData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "warehouse_id_fk", $$v)},expression:"makeOrderData.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.makeOrderData.transportation_type),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "transportation_type", $$v)},expression:"makeOrderData.transportation_type"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.makeOrderData.item_weight),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "item_weight", $$v)},expression:"makeOrderData.item_weight"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Volume"},model:{value:(_vm.makeOrderData.volume),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "volume", $$v)},expression:"makeOrderData.volume"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Track number","data-vv-name":"track_number"},on:{"input":function($event){return _vm.removeSpaces()}},model:{value:(_vm.makeOrderData.track_number),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "track_number", $$v)},expression:"makeOrderData.track_number"}})],1),_vm._v(" "),(!_vm.makeOrderData.is_from_warehouse == 1)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Coupon","data-vv-name":"coupon"},model:{value:(_vm.makeOrderData.coupon),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "coupon", $$v)},expression:"makeOrderData.coupon"}}),_vm._v(" "),(_vm.notCouponCode)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("This field must contain a Coupon Code")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.makeOrderData.order_id)?_c('order-images',{attrs:{"formData":_vm.makeOrderData}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddNewShiponlyModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          send_to_pending_shipment: 'send_to_pending_shipment',
          generate_qr_code: 'purchase_generate_qrcode',
          add_permission: 'add_new_order',
          new_shiponly: 'new_shiponly',
        },"addNewOrderButton":false,"addNewShiponlyButton":true,"openAddNewShiponlyModal":_vm.openAddNewShiponlyModal,"openAddNewOrderModal":_vm.openAddNewOrderModal,"removeAddButton":true,"removeWarehouseDeliverButton":true,"addSendToIntShipmentButton":true,"addSendAllToIntShipmentButton":true,"addQrCodeGenerateButton":true,"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"openSendToIntShipmentModal":_vm.openSendToIntShipmentModal,"sendAllToIntShipment":_vm.sendAllToIntShipment,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,staticClass:"table-tr",style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[(r.is_ship_only == 1)?_c('span',{staticClass:"ship-only-label"},[_vm._v("Ship Only")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_pending_shipment'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#4FC3F7"},attrs:{"tooltip":"Pending Shipment this order"},on:{"click":function($event){return _vm.pendingShipmentOrder(r.order_id)}}},[_c('span',{staticClass:"pending-boat-icon"},[_c('i',{staticClass:"material-icons boat-base"},[_vm._v("directions_boat")]),_vm._v(" "),_c('i',{staticClass:"material-icons boat-badge"},[_vm._v("schedule")])])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_warehouse_delivered_order_to_purchased_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('take_photo'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#666","font-size":"16px"},attrs:{"tooltip":"Take Photo"},on:{"click":function($event){return _vm.openTakePhotoModal(r)}}},[_c('i',{staticClass:"fa fa-camera"})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_order_case'))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#555"},attrs:{"tooltip":"Create Case"},on:{"click":function($event){return _vm.openCreateOrderCaseModal(r)}}},[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"1.6rem"}})])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.order_id)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_pending_shipment'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#4FC3F7"},attrs:{"tooltip":"Shipment this order"},on:{"click":function($event){return _vm.pendingShipmentOrder(r.order_id)}}},[_c('span',{staticClass:"pending-boat-icon"},[_c('i',{staticClass:"material-icons boat-base"},[_vm._v("directions_boat")]),_vm._v(" "),_c('i',{staticClass:"material-icons boat-badge"},[_vm._v("schedule")])])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_warehouse_delivered_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('take_photo'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#666","font-size":"16px"},attrs:{"tooltip":"Take Photo"},on:{"click":function($event){return _vm.openTakePhotoModal(r)}}},[_c('i',{staticClass:"fa fa-camera"})])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('send-to-int-shipment',{attrs:{"closeSendToIntShipmentModal":_vm.closeSendToIntShipmentModal,"sendToIntShipmentModal":_vm.sendToIntShipmentModal,"sendToIntShipmentData":_vm.sendToIntShipmentData,"sendToIntShipment":_vm.sendToIntShipment}}),_vm._v(" "),_c('take-photo',{attrs:{"takePhotoModal":_vm.takePhotoModal,"orderData":_vm.orderData},on:{"close":function($event){_vm.takePhotoModal = false}}}),_vm._v(" "),_c('add-new-order',{attrs:{"addNewOrderModal":_vm.addNewOrderModal,"warehouses":_vm.warehouses,"closeAddNewOrderModal":_vm.closeAddNewOrderModal,"checkAlert":_vm.checkAlert,"checkURL":_vm.checkURL,"makeNewOrder":_vm.makeNewOrder,"makeOrderData":_vm.makeOrderData,"customers":_vm.customers,"loading":_vm.loading}}),_vm._v(" "),_c('add-new-shiponly',{attrs:{"addNewShiponlyModal":_vm.addNewShiponlyModal,"warehouses":_vm.warehouses,"closeAddNewShiponlyModal":_vm.closeAddNewShiponlyModal,"checkAlert":_vm.checkAlert,"checkURL":_vm.checkURL,"makeNewOrder":_vm.makeNewOrder,"makeOrderData":_vm.makeOrderData,"customers":_vm.customers,"loading":_vm.loading}}),_vm._v(" "),_c('create-qr-code',{attrs:{"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"generateQrCodeModal":_vm.generateQrCodeModal,"closeGenerateQrCodeModal":_vm.closeGenerateQrCodeModal,"qrCodeValues":_vm.qrCodeValues,"generateQrCode":_vm.generateQrCode,"getResults":_vm.getResults}}),_vm._v(" "),_c('add-edit-order-case',{attrs:{"addEditOrderCaseModal":_vm.addEditOrderCaseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditOrderCaseModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Warehouse Delivered Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intShipmentOrder_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1b460_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intShipmentOrder_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_intShipmentOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c1b460_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_intShipmentOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(653);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("620ee538", content, true, {});

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".ship-only-label{display:inline-block;padding:2px 8px;border:2px solid green;border-radius:5px;font-weight:700;font-size:.9em;color:green}.unpaid-notice{position:fixed;z-index:10001;top:30%;left:50%;transform:translateX(-50%);width:240px;height:240px;border-radius:50%;background:#d32f2f;color:#fff;display:flex;align-items:center;justify-content:center;text-align:center;padding:20px;font-size:18px;font-weight:700}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.danger-swal{background:#ff6262!important}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToPendingToBranch_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03786dae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToPendingToBranch_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToPendingToBranch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03786dae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToPendingToBranch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(656);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("057ccdac", content, true, {});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.sendToPendingToBranchModal),callback:function ($$v) {_vm.sendToPendingToBranchModal=$$v},expression:"sendToPendingToBranchModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Send to pending to branch")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendToPendingToBranchModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send SMS","color":"indigo"},model:{value:(_vm.sendToPendingToBranchData.send_sms),callback:function ($$v) {_vm.$set(_vm.sendToPendingToBranchData, "send_sms", $$v)},expression:"sendToPendingToBranchData.send_sms"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToPendingToBranchData.order_id),expression:"sendToPendingToBranchData.order_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"id":"qrcode","type":"text","placeholder":"QrCode*","error-messages":_vm.errors.collect('qrcode'),"data-vv-name":"qrcode","autofocus":""},domProps:{"value":(_vm.sendToPendingToBranchData.order_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToPendingToBranchData, "order_id", $event.target.value)}}})])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Send")])],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          deliver_to_pending_to_branch: 'deliver_to_pending_to_branch',
          generate_qr_code: 'shipment_generate_qrcode'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addSendToPendingToBranchButton":true,"openSendToPendingToBranchModal":_vm.openSendToPendingToBranchModal,"addSendToErbilButton":true,"openSendToErbilModal":_vm.openSendToErbilModal,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"getByWarehouse":_vm.getByWarehouse,"addQrCodeGenerateButton":true,"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),(_vm.$_has_perm('deliver_to_pending_to_branch'))?_c('div',{staticClass:"col-xs-12"},[_c('form',{staticClass:"form-inline",staticStyle:{"margin":"8px 0 15px"},on:{"submit":function($event){$event.preventDefault();return _vm.scanQrCode.apply(null, arguments)}}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.scanCode),expression:"scanCode",modifiers:{"trim":true}}],ref:"scanInput",staticClass:"form-control",attrs:{"type":"text","placeholder":"Scan QR code"},domProps:{"value":(_vm.scanCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.scanCode=$event.target.value.trim()},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Scan")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.scanPalletId),expression:"scanPalletId"}],staticClass:"form-control",staticStyle:{"margin-left":"12px","appearance":"auto","-webkit-appearance":"menulist"},attrs:{"title":"Only for an order that was not sent from the warehouse: the pallet it came on"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.scanPalletId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Pallet of a forgotten order")]),_vm._v(" "),_vm._l((_vm.scanPallets),function(p){return _c('option',{key:p.pallet_id,domProps:{"value":p.pallet_id}},[_vm._v(_vm._s(p.origin)+" · "+_vm._s(p.tracking_number)+_vm._s(p.flight_date ? ' (' + p.flight_date + ')' : ''))])})],2),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"12px"}},[_vm._v(_vm._s(_vm.qrCodeValues.length)+" selected")])])]):_vm._e(),_vm._v(" "),(_vm.unpaidNotice)?_c('div',{staticClass:"unpaid-notice"},[_vm._v("\n        "+_vm._s(_vm.unpaidNotice)),_c('br'),_vm._v("Sent to Pending to Branch\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ])>-1:(_vm.qrCodeValues)},on:{"change":[function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}},function($event){return _vm.rowTicked(r, $event)}]}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[(r.is_ship_only == 1)?_c('span',{staticClass:"ship-only-label"},[_vm._v("Ship Only")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('deliver_to_pending_to_branch'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#EE4545"},attrs:{"tooltip":"Deliver to pending to branch"},on:{"click":function($event){return _vm.deliverToPendingToBranch(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_shipping")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_shipment_order_to_purchased_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isPurchase":true,"isOrder":true,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID])>-1:(_vm.qrCodeValues)},on:{"change":[function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}},function($event){return _vm.rowTicked(r, $event)}]}})]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.order_id)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                purchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('deliver_to_pending_to_branch'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#EE4545"},attrs:{"tooltip":"Deliver to pending to branch"},on:{"click":function($event){return _vm.deliverToPendingToBranch(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_shipping")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_shipment_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('send-to-pending-to-branch',{attrs:{"sendToPendingToBranchData":_vm.sendToPendingToBranchData,"sendToPendingToBranch":_vm.sendToPendingToBranch,"sendToPendingToBranchModal":_vm.sendToPendingToBranchModal,"openSendToPendingToBranchModal":_vm.openSendToPendingToBranchModal,"closeSendToPendingToBranchModal":_vm.closeSendToPendingToBranchModal}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.sendToErbilModal),callback:function ($$v) {_vm.sendToErbilModal=$$v},expression:"sendToErbilModal"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Send to Delivered to Erbil ("+_vm._s(_vm.qrCodeValues.length)+")")])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"mr-2",staticStyle:{"width":"32px","margin-top":"-10px"},attrs:{"src":__webpack_require__(21),"alt":"whatsapp"}}),_vm._v(" "),_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send Whatsapp Message","color":"indigo"},model:{value:(_vm.sendToErbilData.send_sms),callback:function ($$v) {_vm.$set(_vm.sendToErbilData, "send_sms", $$v)},expression:"sendToErbilData.send_sms"}})],1),_vm._v(" "),(_vm.sendToErbilData.send_sms)?_c('div',[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px"}},[_vm._v("English Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToErbilData.englishMessage),expression:"sendToErbilData.englishMessage"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.sendToErbilData.englishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToErbilData, "englishMessage", $event.target.value)}}}),_vm._v(" "),_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px"}},[_vm._v("Arabic Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToErbilData.arabicMessage),expression:"sendToErbilData.arabicMessage"}],staticClass:"form-control",staticStyle:{"direction":"rtl"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendToErbilData.arabicMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToErbilData, "arabicMessage", $event.target.value)}}}),_vm._v(" "),_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px"}},[_vm._v("Kurdish Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToErbilData.kurdishMessage),expression:"sendToErbilData.kurdishMessage"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.sendToErbilData.kurdishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToErbilData, "kurdishMessage", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",on:{"click":function($event){_vm.sendToErbilModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",attrs:{"color":"success"},on:{"click":_vm.sendToErbilSubmit}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('create-qr-code',{attrs:{"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"generateQrCodeModal":_vm.generateQrCodeModal,"closeGenerateQrCodeModal":_vm.closeGenerateQrCodeModal,"qrCodeValues":_vm.qrCodeValues,"generateQrCode":_vm.generateQrCode,"getResults":_vm.getResults}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("International Shipment Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingToShipment_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd3777b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingToShipment_vue__ = __webpack_require__(662);
function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingToShipment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd3777b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingToShipment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("64383b90", content, true, {});

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".send-group{margin-bottom:14px;padding:12px 14px;background:#f7f8fc;border:1px solid #e6e8f0;border-radius:6px}.send-group-title{display:flex;justify-content:space-between;margin-bottom:6px}.send-group input.form-control,.send-group select.form-control{height:36px;padding:6px 10px;background:#fff;border:1px solid #d5d9e3;border-radius:4px;-webkit-appearance:menulist;appearance:auto}.send-new{display:flex;gap:8px;margin-top:8px}.send-new .form-control{flex:1 1 0;width:auto;min-width:0}.send-new input[type=text]{flex:2 1 0}.send-hint{display:block;margin-top:6px;color:#c96a12}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.danger-swal{background:#ff6262!important}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          send_to_shipment: 'send_to_shipment',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addSendToIntShipmentButton":true,"addSendAllToIntShipmentButton":true,"addQrCodeGenerateButton":true,"openSendToIntShipmentModal":_vm.openSendToIntShipmentModal,"sendAllToIntShipment":_vm.sendAllToIntShipment,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"getByWarehouse":_vm.getByWarehouse,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.product_name ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_shipment'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#4FC3F7"},attrs:{"tooltip":"Shipment this order"},on:{"click":function($event){return _vm.shipmentOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("directions_boat")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isPurchase":true,"isOrder":true,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.order_id)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                purchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_shipment_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('send-to-int-shipment',{attrs:{"pendingShipment":true,"closeSendToIntShipmentModal":_vm.closeSendToIntShipmentModal,"sendToIntShipmentModal":_vm.sendToIntShipmentModal,"sendToIntShipmentData":_vm.sendToIntShipmentData,"sendToIntShipment":_vm.sendToIntShipment}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.sendWindow),callback:function ($$v) {_vm.sendWindow=$$v},expression:"sendWindow"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" Send to International Shipment")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Which plane do these orders go on? Orders sent together on one plane make one pallet.")]),_vm._v(" "),_vm._l((_vm.sendGroups),function(g){return _c('div',{key:g.key,staticClass:"send-group"},[_c('div',{staticClass:"send-group-title"},[_c('strong',[_vm._v(_vm._s(g.country || 'Origin not known'))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(g.order_ids.length)+" "+_vm._s(g.order_ids.length == 1 ? 'order' : 'orders'))])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(g.pallet_id),expression:"g.pallet_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(g, "pallet_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_vm._l((_vm.palletsFor(g)),function(p){return _c('option',{key:p.pallet_id,domProps:{"value":p.pallet_id}},[_vm._v(_vm._s(p.tracking_number)+_vm._s(p.flight_date ? ' · flight ' + p.flight_date : '')+_vm._s(g.warehouse_id ? '' : ' · ' + p.origin))])}),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v("New pallet (a new plane)")]),_vm._v(" "),_c('option',{attrs:{"value":"none"}},[_vm._v("No pallet (send them without a pallet)")]),_vm._v(" "),_c('option',{attrs:{"value":"skip"}},[_vm._v("Do not send these now")])],2),_vm._v(" "),(g.pallet_id === 'new')?_c('div',{staticClass:"send-new"},[(!g.warehouse_id)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(g.new_warehouse_id),expression:"g.new_warehouse_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(g, "new_warehouse_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Origin of the plane")]),_vm._v(" "),_vm._l((_vm.warehouses),function(w){return _c('option',{key:w.warehouse_id,domProps:{"value":w.warehouse_id}},[_vm._v(_vm._s(w.country))])})],2):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(g.new_number),expression:"g.new_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Plane / pallet tracking number"},domProps:{"value":(g.new_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(g, "new_number", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(g.new_date),expression:"g.new_date"}],staticClass:"form-control",attrs:{"type":"date","title":"Flight date"},domProps:{"value":(g.new_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(g, "new_date", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(g.pallet_id === 'new' && g.warehouse_id && _vm.palletsFor(g).length == 0)?_c('small',{staticClass:"send-hint"},[_vm._v("No open pallet from "+_vm._s(g.country)+" yet: write the number of the new plane, or choose \"No pallet\" above.")]):_vm._e(),_vm._v(" "),(g.pallet_id === 'none')?_c('small',{staticClass:"send-hint"},[_vm._v("These orders will not be in any pallet report. They can be added to a pallet later from the Pallets page.")]):_vm._e(),_vm._v(" "),(g.pallet_id === 'skip')?_c('small',{staticClass:"send-hint"},[_vm._v("These orders stay in Pending To Shipment.")]):_vm._e()])})],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","disabled":_vm.sendBusy},on:{"click":function($event){_vm.sendWindow = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"success","disabled":_vm.sendBusy},on:{"click":function($event){return _vm.confirmSend()}}},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Send")])],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Pending To Shipment Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_branchDeliveredOrder_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fdc0d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_branchDeliveredOrder_vue__ = __webpack_require__(684);
function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_branchDeliveredOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84fdc0d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_branchDeliveredOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("47ae9207", content, true, {});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.ship-only-label{display:inline-block;padding:2px 8px;border:2px solid #333;border-radius:5px;font-weight:700;font-size:.9em;color:green;border-color:green}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToUser_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629e1f0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToUser_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629e1f0d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("de418d96", content, true, {});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.sendToUserModal),callback:function ($$v) {_vm.sendToUserModal=$$v},expression:"sendToUserModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Send to Customer")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendToUserModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md4":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToUserData.order_id),expression:"sendToUserData.order_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"QrCode*","error-messages":_vm.errors.collect('qrcode'),"data-vv-name":"qrcode","autofocus":""},domProps:{"value":(_vm.sendToUserData.order_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToUserData, "order_id", $event.target.value)}}})])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Send")])],1)],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepareToPrint_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae24db16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepareToPrint_vue__ = __webpack_require__(673);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae24db16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepareToPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae24db16_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepareToPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7566bca8", content, true, {});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".modal[data-v-ae24db16]{text-align:center;padding:0!important;overflow-x:auto}.modal[data-v-ae24db16]:before{content:\"\";display:inline-block;height:100%;vertical-align:middle;margin-right:-4px}.modal-dialog[data-v-ae24db16]{display:inline-block;text-align:left;vertical-align:middle}", ""]);

// exports


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"prepare_modal"}},[_c('div',{staticClass:"modal-dialog modal-full",staticStyle:{"max-width":"660px"},attrs:{"id":"print-area"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticStyle:{"float":"left"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":_vm.printInvoice}},[_vm._v("Print")])],1),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"id":"close-button","type":"button"},on:{"click":function($event){return _vm.closeModal('prepare_modal')}}},[_vm._v("\n          ×\n        ")])]),_vm._v(" "),_vm._l((_vm.printData),function(data,index){return _c('div',{key:data.order_id},[_c('table',{attrs:{"id":"prepare-print-table","border":"1"}},[_c('tr',[_c('td',{staticClass:"left-td"},[_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Customer id: "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.user_id)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Customer name: "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.full_name)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Order ID: "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.theOrderID)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Product name: "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.product_name)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Quantity: "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.quantity)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_vm._v("\n                Arrived date:\n                "),_c('span',{staticClass:"info-text"},[_vm._v(" "+_vm._s(data.from_date)+" - "+_vm._s(data.to_date)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size"},[_c('qr-code',{attrs:{"text":data.order_id.toString(),"size":65}})],1)]),_vm._v(" "),_c('td',{staticClass:"right-td"},[_c('p',{staticClass:"the-text-size customer-address"},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"the-text-size the-address",staticStyle:{"margin-bottom":"20px"}},[_c('span',{staticClass:"info-text"},[_vm._v(_vm._s(data.address)+" ")])]),_vm._v(" "),_c('p',{staticClass:"the-text-size signature"},[_vm._v("Signature")])])])]),_vm._v(" "),((index + 1) % 3 === 0)?_c('div',{staticStyle:{"page-break-after":"always"}},[_vm._v(" ")]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"modal-footer"})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5a0b5307", content, true, {});

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{overflow-y:auto!important;overflow-x:hidden}.orange-text .v-input__slot,.orange-text input,.orange-text label{color:#ce7706!important}", ""]);

// exports


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.orderInvoiceModal),callback:function ($$v) {_vm.orderInvoiceModal=$$v},expression:"orderInvoiceModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("\n            Generate Invoice\n          ")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0 px-4"},[_c('div',{staticClass:"row",staticStyle:{"margin":"5px 0","background-color":"#FAF8F8FF","border":"1px solid #bbb","border-radius":"5px"}},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('h5',[_vm._v("Customer: "+_vm._s(_vm.formData.customer_name))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('h5',[_vm._v("Phone number: "+_vm._s(_vm.formData.phone))])]),_vm._v(" "),(_vm.formData.orders && _vm.formData.orders.length > 0)?_c('div',{staticClass:"col-12 col-sm-12"},[_c('h5',[_vm._v("Orders")])]):_vm._e(),_vm._v(" "),(_vm.formData.orders && _vm.formData.orders.length > 0)?_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.formData.orders),function(order,index){return _c('div',{key:index,staticClass:"mr-3 mb-2 d-flex align-center"},[_c('h6',{staticStyle:{"display":"inline","margin":"0"}},[_vm._v("#"+_vm._s(order.the_order_id)+"\n                    "),_c('i',{staticClass:"fa fa-remove ml-2",staticStyle:{"font-size":"16px","color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.removeOrder(index)}}})])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 col-sm-4"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Warehouse","items":_vm.warehouses,"error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","item-text":"text","item-value":"value"},on:{"input":function($event){_vm.isShipmentManual = false,_vm.isHandlingFeeManual = false,_vm.handleSelectWarehouse(_vm.formData.warehouse_id)}},model:{value:(_vm.formData.warehouse_id),callback:function ($$v) {_vm.$set(_vm.formData, "warehouse_id", $$v)},expression:"formData.warehouse_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-4"},[_c('v-select',{attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},on:{"input":function($event){_vm.isShipmentManual = false,_vm.isHandlingFeeManual = false,_vm.getCustomerPriceList()}},model:{value:(_vm.transportation_type),callback:function ($$v) {_vm.transportation_type=$$v},expression:"transportation_type"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 col-sm-4"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order Type","items":_vm.orderTypes,"error-messages":_vm.errors.collect('order_type_id'),"data-vv-name":"order_type_id","item-text":"text","item-value":"value"},on:{"input":_vm.handleOrderTypeChange},model:{value:(_vm.formData.order_type_id),callback:function ($$v) {_vm.$set(_vm.formData, "order_type_id", $$v)},expression:"formData.order_type_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Weight","error-messages":_vm.errors.collect('Weight'),"data-vv-name":"Weight"},on:{"input":function($event){_vm.isShipmentManual = false,_vm.isHandlingFeeManual = false,_vm.calculateTotalAmount()}},model:{value:(_vm.formData.weight),callback:function ($$v) {_vm.$set(_vm.formData, "weight", $$v)},expression:"formData.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{attrs:{"label":"Volume"},on:{"input":function($event){_vm.isShipmentManual = false,_vm.isHandlingFeeManual = false,_vm.calculateTotalAmount()}},model:{value:(_vm.formData.volume),callback:function ($$v) {_vm.$set(_vm.formData, "volume", $$v)},expression:"formData.volume"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Shipment","error-messages":_vm.errors.collect('Shipment'),"data-vv-name":"Shipment"},on:{"input":function($event){return _vm.handleShipmentInput()}},model:{value:(_vm.shipment),callback:function ($$v) {_vm.shipment=_vm._n($$v)},expression:"shipment"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Tax","error-messages":_vm.errors.collect('Tax'),"data-vv-name":"Tax"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.formData.tax),callback:function ($$v) {_vm.$set(_vm.formData, "tax", _vm._n($$v))},expression:"formData.tax"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Delivery price","error-messages":_vm.errors.collect('Delivery price'),"data-vv-name":"Delivery price"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.formData.delivery_price),callback:function ($$v) {_vm.$set(_vm.formData, "delivery_price", _vm._n($$v))},expression:"formData.delivery_price"}})],1),_vm._v(" "),(_vm.formData.is_ship_only == 1)?_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Handling Fee","error-messages":_vm.errors.collect('Handling Fee'),"data-vv-name":"Handling Fee"},on:{"input":_vm.handleHandlingFeeInput},model:{value:(_vm.shiponly_handle_fee),callback:function ($$v) {_vm.shiponly_handle_fee=_vm._n($$v)},expression:"shiponly_handle_fee"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Discount","error-messages":_vm.errors.collect('Discount'),"data-vv-name":"Discount"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.formData.discount),callback:function ($$v) {_vm.$set(_vm.formData, "discount", _vm._n($$v))},expression:"formData.discount"}})],1),_vm._v(" "),_c('div',{staticClass:"row"}),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticClass:"orange-text",attrs:{"label":"Total price","readonly":"","error-messages":_vm.errors.collect('Total price'),"data-vv-name":"Total price"},model:{value:(_vm.formData.total_price),callback:function ($$v) {_vm.$set(_vm.formData, "total_price", _vm._n($$v))},expression:"formData.total_price"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Net price","readonly":"","error-messages":_vm.errors.collect('Net price'),"data-vv-name":"Net price"},model:{value:(_vm.formData.net_price),callback:function ($$v) {_vm.$set(_vm.formData, "net_price", _vm._n($$v))},expression:"formData.net_price"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Paid amount","error-messages":_vm.errors.collect('Paid amount'),"data-vv-name":"Paid amount"},model:{value:(_vm.formData.paid_amount),callback:function ($$v) {_vm.$set(_vm.formData, "paid_amount", $$v)},expression:"formData.paid_amount"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.formData.note),callback:function ($$v) {_vm.$set(_vm.formData, "note", $$v)},expression:"formData.note"}})],1)])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"type":"submit","outline":"","color":"primary"}},[_vm._v("Save")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryInvoice_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0752654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryInvoice_vue__ = __webpack_require__(680);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDeliveryInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0752654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDeliveryInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(679);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("28e3a664", content, true, {});

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{overflow-y:auto!important;overflow-x:hidden}", ""]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.deliveryInvoiceModal),callback:function ($$v) {_vm.deliveryInvoiceModal=$$v},expression:"deliveryInvoiceModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Delivery Invoice")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0 px-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Customer: "+_vm._s(_vm.formData.customer_name))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Phone number: "+_vm._s(_vm.formData.phone_number))])]),_vm._v(" "),(_vm.formData.orders && _vm.formData.orders.length > 0)?_c('div',{staticClass:"col-12"},[_c('h5',[_vm._v("Orders")])]):_vm._e(),_vm._v(" "),(_vm.formData.orders && _vm.formData.orders.length > 0)?_c('div',{staticClass:"col-12"},[_c('ol',_vm._l((_vm.formData.orders),function(order,index){return _c('li',{key:index},[_c('h6',{staticStyle:{"display":"inline-block"}},[_vm._v("#"+_vm._s(order.the_order_id))]),_vm._v(" "),_c('i',{staticClass:"fa fa-remove ml-4",staticStyle:{"font-size":"16px","color":"red","cursor":"pointer"},on:{"click":function($event){return _vm.removeOrder(index)}}})])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-text-field',{attrs:{"label":"Total","readonly":"","error-messages":_vm.errors.collect('Total'),"data-vv-name":"Total"},model:{value:(_vm.formData.customer_credit),callback:function ($$v) {_vm.$set(_vm.formData, "customer_credit", $$v)},expression:"formData.customer_credit"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"label":"Pay on delivery (IQD)","error-messages":_vm.errors.collect('Pay on delivery (IQD)'),"data-vv-name":"Pay on delivery (IQD)"},model:{value:(_vm.formData.pay_on_delivery_iqd),callback:function ($$v) {_vm.$set(_vm.formData, "pay_on_delivery_iqd", _vm._n($$v))},expression:"formData.pay_on_delivery_iqd"}})],1)])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"type":"submit","outline":"","color":"primary"}},[_vm._v("Save")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2f8f8ab9", content, true, {});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area{max-width:850px}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#credit-table-header,#price-section2{width:500px;padding-left:10px}#price-section2{padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"780px"},model:{value:(_vm.viewDeliveryInvoiceModal),callback:function ($$v) {_vm.viewDeliveryInvoiceModal=$$v},expression:"viewDeliveryInvoiceModal"}},[_c('v-card',{attrs:{"id":"print-area"}},[(_vm.viewDeliveryInvoiceModal)?_c('v-card-text',[_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"head-table"}},[_c('tr',[_c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"id":"header-img","src":__webpack_require__(12),"alt":""}})]),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_name)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_address)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_email)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.phone_number)+"\n                  ")])])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table1"}},[_c('tr',[_c('td',{attrs:{"id":"credit-table-header"}},[_c('strong',{staticStyle:{"font-size":"20px"}},[_c('span',[_vm._v("Delivery Invoice")])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table2"}},[_c('tr',[_c('td',{attrs:{"id":"info-section1"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Invoice Number:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.invoice_number))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm._f("moment")(_vm.invoiceData.created_at,'YYYY-MM-DD hh:mm A')))])])]),_vm._v(" "),_c('td',{attrs:{"id":"info-section2"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Name:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.full_name))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Phone:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.phone_number))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Phone2:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.phone_number_2))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"6px 0px"}},[_vm._v("\n                Address:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.city.governorate.governorate_name + ' - ' + _vm.invoiceData.customer.city.city_name + ' - ' + _vm.invoiceData.customer.address))])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","border":"1px solid #000"}},[_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"150px","font-weight":"bold"}},[_vm._v("Orders:")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},_vm._l((_vm.invoiceData.orders),function(order,index){return _c('span',{key:order.order_id},[_vm._v("\n                "+_vm._s(order.theOrderID)+"\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index < _vm.invoiceData.orders.length - 1),expression:"index < invoiceData.orders.length - 1"}],staticStyle:{"padding-right":"5px"}},[_vm._v("\n                  ,\n                ")])])}),0)]),_vm._v(" "),(_vm.invoiceData.customer && _vm.invoiceData.customer.credit < 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"150px","font-weight":"bold"}},[_vm._v("Total:")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v(_vm._s(_vm.invoiceData.customer.credit)+" USD")])]):_vm._e(),_vm._v(" "),_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"150px","font-weight":"bold"}},[_vm._v("Pay on delivery:")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v(_vm._s(_vm.invoiceData.pay_on_delivery_iqd.toLocaleString())+" IQD")])])])]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"close-button","outline":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":function($event){return _vm.printInvoice()}}},[_vm._v("Print")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          send_to_customer: 'send_to_customer',
          add_shipping_invoice: 'add_shipping_invoice',
          generate_qr_code: 'branch_delivered_order_generate_qrcode',
          add_delivery_invoice: 'add_delivery_invoice',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addSendToUserButton":true,"openSendToUserModal":_vm.openSendToUserModal,"addSendAllToUserButton":true,"sendAllToUser":_vm.sendAllToUser,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addPrepareToPrintButton":true,"prepareToPrint":_vm.prepareToPrint,"addQrCodeGenerateButton":true,"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"addOrderInvoiceButton":true,"openOrderInvoiceModal":_vm.openOrderInvoiceModal,"addDeliveryInvoiceButton":true,"openDeliveryInvoiceModal":_vm.openDeliveryInvoiceModal,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin":"0px"},attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md5":""}},[_c('v-select',{staticStyle:{"width":"100%"},attrs:{"autocomplete":"","items":_vm.customersList,"label":"Customer","single-line":"","clearable":""},model:{value:(_vm.generateInvoiceData.customer_id),callback:function ($$v) {_vm.$set(_vm.generateInvoiceData, "customer_id", $$v)},expression:"generateInvoiceData.customer_id"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"15px"},attrs:{"xs12":"","sm4":"","md5":""}},[_c('v-btn',{staticStyle:{"height":"auto","padding":"4px","margin-left":"15px"},attrs:{"disabled":!_vm.generateInvoiceData.customer_id,"depressed":"","color":"primary","small":""},on:{"click":function($event){return _vm.generateInvoiceCustomer(_vm.generateInvoiceData.customer_id)}}},[_vm._v("\n              Generate Invoice\n            ")])],1)],1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; })
                  ? 'background-color: #FFF9C4'
                  : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                  ? 'background-color: #ee7272'
                  : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name,
                    r.warehouse_id_fk,
                    r.transportation_type,
                    r.is_ship_only ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name,
                    r.warehouse_id_fk,
                    r.transportation_type,
                    r.is_ship_only ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name,
                    r.warehouse_id_fk,
                    r.transportation_type,
                    r.is_ship_only ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[(r.qrcode)?_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(_vm._s(r.order_id)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[(r.is_ship_only == 1)?_c('span',{staticClass:"ship-only-label"},[_vm._v("Ship Only")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                  (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579b"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_customer'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#ffb300"},attrs:{"tooltip":"Send to customer"},on:{"click":function($event){return _vm.deliverToUser(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_taxi")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_branch_delivered_order_to_purchased_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isPurchase":true,"isOrder":true,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; })
                  ? 'background-color: #FFF9C4'
                  : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                  ? 'background-color: #ee7272'
                  : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[(r.qrcode)?_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(r.order_id)+" ,\n                "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.is_ship_only)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                  (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_customer'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#ffb300"},attrs:{"tooltip":"Send to customer"},on:{"click":function($event){return _vm.deliverToUser(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_taxi")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_branch_delivered_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('create-qr-code',{attrs:{"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"generateQrCodeModal":_vm.generateQrCodeModal,"closeGenerateQrCodeModal":_vm.closeGenerateQrCodeModal,"qrCodeValues":_vm.qrCodeValues,"generateQrCode":_vm.generateQrCode,"getResults":_vm.getResults}}),_vm._v(" "),_c('send-to-user',{attrs:{"closeSendToUserModal":_vm.closeSendToUserModal,"sendToUserModal":_vm.sendToUserModal,"sendToUserData":_vm.sendToUserData,"sendToUser":_vm.sendToUser}}),_vm._v(" "),_c('prepare-to-print',{attrs:{"closeModal":_vm.closeModal,"printData":_vm.printData}}),_vm._v(" "),_c('add-order-invoice',{attrs:{"formData":_vm.generateInvoiceData,"orderInvoiceModal":_vm.orderInvoiceModal},on:{"close":function($event){_vm.orderInvoiceModal = false, _vm.qrCodeValues = []},"invoice-created":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('add-delivery-invoice',{attrs:{"formData":_vm.deliveryInvoiceData,"deliveryInvoiceModal":_vm.deliveryInvoiceModal},on:{"close":function($event){_vm.deliveryInvoiceModal = false},"invoice-created":_vm.viewDeliveryInvoice}}),_vm._v(" "),_c('view-customer-delivery-invoice',{attrs:{"viewDeliveryInvoiceModal":_vm.viewDeliveryInvoiceModal,"invoiceData":_vm.invoiceData,"companyData":_vm.companyData},on:{"close":function($event){_vm.viewDeliveryInvoiceModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Delivered to Erbil Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingToBranchOrder_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccb61d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingToBranchOrder_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingToBranchOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ccb61d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingToBranchOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(687);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0f863584", content, true, {});

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}.buttonPadding{padding:0!important}", ""]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToBranch_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e19b7e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToBranch_vue__ = __webpack_require__(691);
function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendToBranch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e19b7e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendToBranch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(690);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6db5a033", content, true, {});

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.input-group__details{min-height:0!important}", ""]);

// exports


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.sendToBranchModal),callback:function ($$v) {_vm.sendToBranchModal=$$v},expression:"sendToBranchModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Send to Branch")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendToBranchModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"align-self-center mr-2",staticStyle:{"width":"32px","margin-top":"-10px"},attrs:{"src":__webpack_require__(21),"alt":"whatsapp"}}),_vm._v(" "),_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send Whatsapp Message","color":"indigo"},model:{value:(_vm.sendToBranchData.send_sms),callback:function ($$v) {_vm.$set(_vm.sendToBranchData, "send_sms", $$v)},expression:"sendToBranchData.send_sms"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToBranchData.order_id),expression:"sendToBranchData.order_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"QrCode*","error-messages":_vm.errors.collect('qrcode'),"data-vv-name":"qrcode","autofocus":""},domProps:{"value":(_vm.sendToBranchData.order_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToBranchData, "order_id", $event.target.value)}}})]),_vm._v(" "),(_vm.sendToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"englishMessage"}},[_vm._v("\n                  English Message\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToBranchData.englishMessage),expression:"sendToBranchData.englishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendToBranchData.englishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToBranchData, "englishMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.sendToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"arabicMessage"}},[_vm._v("\n                  Arabic Message\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToBranchData.arabicMessage),expression:"sendToBranchData.arabicMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","direction":"rtl","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendToBranchData.arabicMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToBranchData, "arabicMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.sendToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"kurdishMessage"}},[_vm._v("\n                  Kurdish Message\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendToBranchData.kurdishMessage),expression:"sendToBranchData.kurdishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendToBranchData.kurdishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendToBranchData, "kurdishMessage", $event.target.value)}}})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"buttonPadding",attrs:{"outline":"","color":"primary"},on:{"click":_vm.saveTemplate}},[_vm._v("Save as Default Template")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Send")])],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          deliver_to_branch: 'deliver_to_branch',
          generate_qr_code: 'pending_to_branch_generate_qrcode',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addSendToBranchButton":true,"openSendToBranchModal":_vm.openSendToBranchModal,"addSendAllToBranchButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"sendAllToPendingToBranch":_vm.sendAllToPendingToBranch,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addQrCodeGenerateButton":true,"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; })
                  ? 'background-color: #FFF9C4'
                  : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                  ? 'background-color: #ee7272'
                  : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only,
                    r.credit,
                    r.product_name ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[(r.qrcode)?_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(_vm._s(r.order_id)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                  (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579b"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('deliver_to_branch'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#5D4037"},attrs:{"tooltip":"Deliver to branch"},on:{"click":function($event){return _vm.deliverToBranch(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_shipping")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isPurchase":true,"isOrder":true,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; })
                  ? 'background-color: #FFF9C4'
                  : ((r.item_weight === 0 || r.item_weight == null) || (Number(r.is_ship_only) === 1)) && !r.order_invoice_id_fk
                  ? 'background-color: #ee7272'
                  : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.credit ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[(r.qrcode)?_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "+_vm._s(r.order_id)+" ,\n                "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                  (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('deliver_to_branch'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#ffb300"},attrs:{"tooltip":"Send to customer"},on:{"click":function($event){return _vm.deliverToBranch(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_taxi")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_branch_delivered_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('create-qr-code',{attrs:{"openGenerateQrCodeModal":_vm.openGenerateQrCodeModal,"generateQrCodeModal":_vm.generateQrCodeModal,"closeGenerateQrCodeModal":_vm.closeGenerateQrCodeModal,"qrCodeValues":_vm.qrCodeValues,"generateQrCode":_vm.generateQrCode,"getResults":_vm.getResults}}),_vm._v(" "),_c('send-to-branch',{attrs:{"sendToBranchData":_vm.sendToBranchData,"sendToBranch":_vm.sendToBranch,"sendToBranchModal":_vm.sendToBranchModal,"openSendToBranchModal":_vm.openSendToBranchModal,"closeSendToBranchModal":_vm.closeSendToBranchModal,"saveWhatsAppTemplate":_vm.saveWhatsAppTemplate}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.deliverToBranchModal),callback:function ($$v) {_vm.deliverToBranchModal=$$v},expression:"deliverToBranchModal"}},[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Deliver to Branch")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeDeliverToBranchModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"align-self-center mr-2",staticStyle:{"width":"32px","margin-top":"-10px"},attrs:{"src":__webpack_require__(21),"alt":"whatsapp"}}),_vm._v(" "),_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send Whatsapp Message","color":"indigo"},model:{value:(_vm.deliverToBranchData.send_sms),callback:function ($$v) {_vm.$set(_vm.deliverToBranchData, "send_sms", $$v)},expression:"deliverToBranchData.send_sms"}})],1)]),_vm._v(" "),(_vm.deliverToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"englishMessage"}},[_vm._v("\n                      English Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliverToBranchData.englishMessage),expression:"deliverToBranchData.englishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.deliverToBranchData.englishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deliverToBranchData, "englishMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.deliverToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"arabicMessage"}},[_vm._v("\n                      Arabic Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliverToBranchData.arabicMessage),expression:"deliverToBranchData.arabicMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","direction":"rtl","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.deliverToBranchData.arabicMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deliverToBranchData, "arabicMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.deliverToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"kurdishMessage"}},[_vm._v("\n                      Kurdish Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.deliverToBranchData.kurdishMessage),expression:"deliverToBranchData.kurdishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.deliverToBranchData.kurdishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.deliverToBranchData, "kurdishMessage", $event.target.value)}}})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"buttonPadding",attrs:{"outline":"","color":"primary"},on:{"click":_vm.saveWhatsAppTemplate}},[_vm._v("Save as Default Template")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",on:{"click":_vm.closeDeliverToBranchModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",attrs:{"color":"success"},on:{"click":_vm.deliverToBranchSubmit}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.sendAllToBranchModal),callback:function ($$v) {_vm.sendAllToBranchModal=$$v},expression:"sendAllToBranchModal"}},[_c('v-card',[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Send All to Branch")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeSendAllToBranchModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('img',{staticClass:"align-self-center mr-2",staticStyle:{"width":"32px","margin-top":"-10px"},attrs:{"src":__webpack_require__(21),"alt":"whatsapp"}}),_vm._v(" "),_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Send Whatsapp Message","color":"indigo"},model:{value:(_vm.sendAllToBranchData.send_sms),callback:function ($$v) {_vm.$set(_vm.sendAllToBranchData, "send_sms", $$v)},expression:"sendAllToBranchData.send_sms"}})],1)]),_vm._v(" "),(_vm.sendAllToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"englishMessage"}},[_vm._v("\n                      English Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendAllToBranchData.englishMessage),expression:"sendAllToBranchData.englishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendAllToBranchData.englishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendAllToBranchData, "englishMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.sendAllToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"arabicMessage"}},[_vm._v("\n                      Arabic Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendAllToBranchData.arabicMessage),expression:"sendAllToBranchData.arabicMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","direction":"rtl","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendAllToBranchData.arabicMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendAllToBranchData, "arabicMessage", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.sendAllToBranchData.send_sms)?_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"kurdishMessage"}},[_vm._v("\n                      Kurdish Message\n                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sendAllToBranchData.kurdishMessage),expression:"sendAllToBranchData.kurdishMessage"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem","width":"50%","max-width":"100%","box-sizing":"border-box"},attrs:{"rows":"4"},domProps:{"value":(_vm.sendAllToBranchData.kurdishMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sendAllToBranchData, "kurdishMessage", $event.target.value)}}})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"buttonPadding",attrs:{"outline":"","color":"primary"},on:{"click":_vm.saveWhatsAppTemplate}},[_vm._v("Save as Default Template")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",on:{"click":_vm.closeSendAllToBranchModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"buttonPadding",attrs:{"color":"success"},on:{"click":_vm.sendAllToBranchSubmit}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Pending to Branch Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e4ddc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e4ddc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(695);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a3d9e3ac", content, true, {});

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a.disabled{pointer-events:none;color:gray}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addStaff_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ec2bbd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addStaff_vue__ = __webpack_require__(699);
function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addStaff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ec2bbd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addStaff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(698);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7ea7f4f3", content, true, {});

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent,.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}", ""]);

// exports


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.addStaffModal),callback:function ($$v) {_vm.addStaffModal=$$v},expression:"addStaffModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add staff")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddStaffModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Staff added successfully\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.validationError}},[_c('h4',[_vm._v(_vm._s(_vm.emailError))])]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.phoneValidation}},[_c('h4',[_vm._v(_vm._s(_vm.phoneError))])]),_vm._v(" "),_c('v-alert',{staticStyle:{"height":"50px"},attrs:{"value":_vm.passwordAlert,"type":"error"}},[_c('h4',{staticStyle:{"padding-top":"10px"}},[_vm._v("Password do not match")])]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Full Name*","error-messages":_vm.errors.collect('full_name'),"data-vv-name":"full_name"},model:{value:(_vm.addData.full_name),callback:function ($$v) {_vm.$set(_vm.addData, "full_name", $$v)},expression:"addData.full_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Email*","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.addData.email),callback:function ($$v) {_vm.$set(_vm.addData, "email", $$v)},expression:"addData.email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number*","error-messages":_vm.errors.collect('phone_number'),"data-vv-name":"phone_number"},model:{value:(_vm.addData.phone_number),callback:function ($$v) {_vm.$set(_vm.addData, "phone_number", $$v)},expression:"addData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text',"label":"Password*","error-messages":_vm.errors.collect('password'),"data-vv-name":"password"},model:{value:(_vm.addData.password),callback:function ($$v) {_vm.$set(_vm.addData, "password", $$v)},expression:"addData.password"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"label":"Confirm Password*","error-messages":_vm.errors.collect('confirm_password'),"data-vv-name":"confirm_password"},model:{value:(_vm.addData.confirm_password),callback:function ($$v) {_vm.$set(_vm.addData, "confirm_password", $$v)},expression:"addData.confirm_password"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.roles,"item-value":"value","error-messages":_vm.errors.collect('roles'),"data-vv-name":"roles","label":"Role*","multiple":"","chips":"","deletable-chips":"","autocomplete":""},model:{value:(_vm.addData.rolesId),callback:function ($$v) {_vm.$set(_vm.addData, "rolesId", $$v)},expression:"addData.rolesId"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*","multiple":"","chips":"","deletable-chips":""},model:{value:(_vm.addData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.addData, "warehouse_id_fk", $$v)},expression:"addData.warehouse_id_fk"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddStaffModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editStaff_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c976c1f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editStaff_vue__ = __webpack_require__(703);
function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editStaff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c976c1f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editStaff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(702);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e061f1c4", content, true, {});

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.editStaffModal),callback:function ($$v) {_vm.editStaffModal=$$v},expression:"editStaffModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update staff")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditStaffModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Staff updated successfully\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.validationError}},[_vm._v("\n            "+_vm._s(_vm.emailError)+"\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.backendError}},[_vm._v("\n            Please update anything\n          ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Full Name","error-messages":_vm.errors.collect('Full Name'),"data-vv-name":"Full Name"},model:{value:(_vm.editStaffData.full_name),callback:function ($$v) {_vm.$set(_vm.editStaffData, "full_name", $$v)},expression:"editStaffData.full_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Email","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.editStaffData.email),callback:function ($$v) {_vm.$set(_vm.editStaffData, "email", $$v)},expression:"editStaffData.email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Phone Number"},model:{value:(_vm.editStaffData.phone_number),callback:function ($$v) {_vm.$set(_vm.editStaffData, "phone_number", $$v)},expression:"editStaffData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.editStaffData.address),callback:function ($$v) {_vm.$set(_vm.editStaffData, "address", $$v)},expression:"editStaffData.address"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.roles,"item-value":"value","error-messages":_vm.errors.collect('roles'),"data-vv-name":"roles","label":"Role*","multiple":"","chips":"","deletable-chips":"","autocomplete":""},model:{value:(_vm.editStaffData.rolesId),callback:function ($$v) {_vm.$set(_vm.editStaffData, "rolesId", $$v)},expression:"editStaffData.rolesId"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*","multiple":"","chips":"","deletable-chips":""},model:{value:(_vm.editStaffData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.editStaffData, "warehouse_id_fk", $$v)},expression:"editStaffData.warehouse_id_fk"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditStaffModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2.5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resetPassword_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d91decae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resetPassword_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d91decae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(706);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39f9b48f", content, true, {});

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.resetPasswordModal),callback:function ($$v) {_vm.resetPasswordModal=$$v},expression:"resetPasswordModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Reset Password")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeResetPasswordModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Password reset successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              Password not match\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticStyle:{"width":"90%"},attrs:{"append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text',"label":"New Password*","error-messages":_vm.errors.collect('new_password'),"data-vv-name":"new_password"},model:{value:(_vm.resetPasswordData.new_password),callback:function ($$v) {_vm.$set(_vm.resetPasswordData, "new_password", $$v)},expression:"resetPasswordData.new_password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],staticStyle:{"width":"90%"},attrs:{"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"label":"Confirm Password*","error-messages":_vm.errors.collect('confirm_password'),"data-vv-name":"confirm_password"},model:{value:(_vm.resetPasswordData.confirm_password),callback:function ($$v) {_vm.$set(_vm.resetPasswordData, "confirm_password", $$v)},expression:"resetPasswordData.confirm_password"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeResetPasswordModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Reset")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_staff: 'add_staff'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addInsertStaffButton":true,"openAddStaffModal":_vm.openAddStaffModal,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.user_id},[_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),(r.is_blocked === '0')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v("Active")])]):_c('td',[_c('span',{staticClass:"label bg-warning"},[_vm._v("Block")])]),_vm._v(" "),_c('td',_vm._l((r.user_roles),function(userRole,index){return _c('span',{key:index,staticClass:"label bg-grey mr-2"},[_vm._v("\n                  "+_vm._s(userRole.role.status)+"\n                ")])}),0),_vm._v(" "),_c('td',_vm._l((r.warehouse_id_fk),function(w,index){return _c('span',{key:index},[(index % 2 == 0)?_c('span',{staticStyle:{"display":"inline"}},[(w == 1)?_c('span',[_c('flag',{attrs:{"iso":"um"}}),_vm._v(" USA,  \n                    ")],1):(w == 2)?_c('span',[_c('flag',{attrs:{"iso":"tr"}}),_vm._v(" Turkey,  \n                    ")],1):(w == 3)?_c('span',[_c('flag',{attrs:{"iso":"cn"}}),_vm._v(" China,  \n                    ")],1):(w == 4)?_c('span',[_c('flag',{attrs:{"iso":"de"}}),_vm._v(" German,  \n                    ")],1):(w == 5)?_c('span',[_c('flag',{attrs:{"iso":"gb"}}),_vm._v(" UK,  \n                    ")],1):_vm._e(),_vm._v(" "),(index == 2 || index == 6)?_c('span',[_c('br')]):_vm._e()]):_vm._e()])}),0),_vm._v(" "),(_vm.$_has_perm('edit_staff'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit Staff"},on:{"click":function($event){return _vm.openEditStaffModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('reset_password'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#494949"},attrs:{"tooltip":"Reset Password"},on:{"click":function($event){return _vm.openResetPasswordModal(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("vpn_key")])])]):_vm._e(),_vm._v(" "),(r.is_blocked === '0' && _vm.$_has_perm('block_unblock_staff'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#FF5722"},attrs:{"tooltip":"Block This User"},on:{"click":function($event){return _vm.blockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_outline")])])]):(_vm.$_has_perm('block_unblock_staff'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#7CB342"},attrs:{"tooltip":"Unblock This User"},on:{"click":function($event){return _vm.unblockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_open")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isStaff":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.email)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.phone_number)+"\n              ")]),_vm._v(" "),_c('td',[(r.is_blocked === '0')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v("Unblock")])]):_c('span',[_c('span',{staticClass:"label bg-warning"},[_vm._v("Block")])]),_vm._v(" "),(r.status === 'admin')?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"label bg-teal-600",staticStyle:{"margin-top":"3px"}},[_vm._v(" "+_vm._s(r.status))])]):(r.status === 'order')?_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"label bg-purple-400",staticStyle:{"margin-top":"3px"}},[_vm._v(" "+_vm._s(r.status))])]):_c('span',[_c('br'),_vm._v(" "),_c('span',{staticClass:"label bg-slate-400",staticStyle:{"margin-top":"3px"}},[_vm._v(" "+_vm._s(r.status))])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((r.warehouse_id_fk),function(w,index){return _c('span',{key:index},[(index % 2 == 0)?_c('span',{staticStyle:{"display":"inline"}},[(w == 1)?_c('span',[_c('flag',{attrs:{"iso":"um"}}),_vm._v(" USA,  \n                    ")],1):(w == 2)?_c('span',[_c('flag',{attrs:{"iso":"tr"}}),_vm._v(" Turkey,  \n                    ")],1):(w == 3)?_c('span',[_c('flag',{attrs:{"iso":"cn"}}),_vm._v(" China,  \n                    ")],1):(w == 4)?_c('span',[_c('flag',{attrs:{"iso":"de"}}),_vm._v(" German,  \n                    ")],1):(w == 5)?_c('span',[_c('flag',{attrs:{"iso":"gb"}}),_vm._v(" UK,  \n                    ")],1):_vm._e(),_vm._v(" "),(index == 2 || index == 6)?_c('span',[_c('br')]):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('edit_staff'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","display":"inline-block"}},[_c('a',{class:_vm.loggedInUserData.user_id == r.user_id ? 'disabled' : '',staticStyle:{"color":"#01579B","padding-left":"5px"},attrs:{"tooltip":"Edit Staff"},on:{"click":function($event){return _vm.openEditStaffModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('reset_password'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","float":"left"}},[_c('a',{class:_vm.loggedInUserData.user_id == r.user_id ? 'disabled' : '',staticStyle:{"color":"#494949"},attrs:{"tooltip":"Reset Password"},on:{"click":function($event){return _vm.openResetPasswordModal(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("vpn_key")])])]):_vm._e(),_vm._v(" "),(r.is_blocked === '0' && r.status !== 'admin' && _vm.$_has_perm('block_unblock_staff'))?_c('span',{staticStyle:{"float":"left","padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#FF5722","padding-left":"5px"},attrs:{"tooltip":"Block This User"},on:{"click":function($event){return _vm.blockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_outline")])])]):(r.status !== 'admin' && _vm.$_has_perm('block_unblock_staff'))?_c('span',{staticStyle:{"float":"left","padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#7CB342"},attrs:{"tooltip":"Unblock This User"},on:{"click":function($event){return _vm.unblockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_open")])])]):_vm._e()],2)])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-staff',{attrs:{"addStaffModal":_vm.addStaffModal,"addStaff":_vm.addStaff,"roles":_vm.roles,"warehouses":_vm.warehouses,"branches":_vm.branches,"addData":_vm.addData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError,"emailError":_vm.emailError,"phoneValidation":_vm.phoneValidation,"phoneError":_vm.phoneError,"closeAddStaffModal":_vm.closeAddStaffModal}}),_vm._v(" "),_c('edit-staff',{attrs:{"editStaffModal":_vm.editStaffModal,"editStaff":_vm.editStaff,"roles":_vm.roles,"warehouses":_vm.warehouses,"branches":_vm.branches,"editStaffData":_vm.editStaffData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError,"backendError":_vm.backendError,"emailError":_vm.emailError,"closeEditStaffModal":_vm.closeEditStaffModal}}),_vm._v(" "),_c('reset-password',{attrs:{"resetPasswordModal":_vm.resetPasswordModal,"resetPassword":_vm.resetPassword,"resetPasswordData":_vm.resetPasswordData,"checkAlert":_vm.checkAlert,"closeResetPasswordModal":_vm.closeResetPasswordModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Staff")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProfile_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4226c236_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProfile_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4226c236"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4226c236_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(711);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5515025c", content, true, {});

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading[data-v-4226c236]{color:#314149!important;border-bottom:2px solid #314149!important}.panel-heading h4[data-v-4226c236]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}", ""]);

// exports


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"profile-cover"},[(_vm.loggedInUserData.cover_image == null || _vm.loggedInUserData.cover_image == '')?_c('div',{staticClass:"profile-cover-img img-responsive",style:({ backgroundImage: 'url(../../../assets/images/cover_placeholder.png)' })}):_c('div',{staticClass:"profile-cover-img img-responsive",style:({ backgroundImage: ("url(" + (_vm.$_image_path()) + (_vm.loggedInUserData.cover_image) + ")") })}),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('a',{staticClass:"profile-thumb",attrs:{"href":"#"},on:{"click":function($event){return _vm.openExplorer()}}},[(
                  _vm.loggedInUserData.profile_image == null || _vm.loggedInUserData.profile_image == ''
                )?_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__(249)}}):_c('img',{staticClass:"img-circle",attrs:{"src":_vm.$_image_path() + _vm.loggedInUserData.profile_image}})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h1',{staticClass:"pt-3"},[_vm._v(_vm._s(_vm.loggedInUserData.full_name))]),_vm._v(" "),_c('span',[_vm._v("Customer ID: "+_vm._s(_vm.loggedInUserData.customer_code || _vm.loggedInUserData.user_id))])]),_vm._v(" "),_c('div',{staticClass:"media-left media-middle"},[_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('input',{attrs:{"type":"file","name":"profile_image","id":"profile_image","value":""}}),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"updateButton","type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)])]),_vm._v(" "),_c('div',{staticClass:"media-right media-middle"},[_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){$event.preventDefault();return _vm.submitCover($event)}}},[_c('div',{staticStyle:{"height":"0px","overflow":"hidden"}},[_c('input',{attrs:{"type":"file","name":"cover_image","id":"cover_image","value":""}}),_vm._v(" "),_c('v-btn',{attrs:{"id":"updateCoverButton","type":"submit"}})],1),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","width":"60%"},attrs:{"color":"white"},on:{"click":function($event){return _vm.openCoverExplorer()}}},[_vm._v("Update Cover Image")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"navbar navbar-default navbar-xs content-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar navbar-default navbar-xs navbar-component no-border-radius-top"},[_c('div',{staticClass:"navbar-collapse collapse",attrs:{"id":"navbar-filter"}},[_c('ul',{staticClass:"nav navbar-nav"},[_vm._m(1),_vm._v(" "),(_vm.loggedInUserData.is_staff)?_c('li',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_secret_key'))?_c('li',[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_secret_key'))?_c('li',[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_edit_company_info'))?_c('li',[_vm._m(5)]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"tabbable"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"activity"}},[_c('div',{staticClass:"panel panel-flat"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',[_c('br'),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.successResponse,"type":"success"}},[_vm._v("\n                        "+_vm._s(_vm.successMessage)+"\n                      ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.errorResponse,"type":"error"}},[_vm._v("\n                        "+_vm._s(_vm.errorMessage)+"\n                        "+_vm._s(_vm.errorMessages.email)+"\n                        "+_vm._s(_vm.errorMessages.phone_number)+"\n                      ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.updateProfile(_vm.loggedInUserData.user_id)}}},[_c('div',{staticClass:"row"},[_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"}],attrs:{"name":"full_name","label":"Full Name","data-vv-name":"Full name","error-messages":_vm.errors.collect('Full name')},model:{value:(_vm.updateProfileData.full_name),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "full_name", $$v)},expression:"updateProfileData.full_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"name":"email","label":"Email","data-vv-name":"Email","error-messages":_vm.errors.collect('Email')},model:{value:(_vm.updateProfileData.email),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "email", $$v)},expression:"updateProfileData.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"name":"phone_number","label":"Phone Number","readonly":!_vm.loggedInUserData.is_staff,"data-vv-name":"Phone Number","error-messages":_vm.errors.collect('Phone Number')},model:{value:(_vm.updateProfileData.phone_number),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "phone_number", $$v)},expression:"updateProfileData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.governoratesList,"item-value":"governorate_id","item-text":"governorate_name","label":"Governorate","autocomplete":"","clearable":"","data-vv-name":"Governorate","error-messages":_vm.errors.collect('Governorate')},on:{"input":_vm.onGovernorateChange},model:{value:(_vm.updateProfileData.governorate_id_fk),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "governorate_id_fk", $$v)},expression:"updateProfileData.governorate_id_fk"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.filteredCitiesList,"item-value":"city_id","item-text":"city_name","label":"City","autocomplete":"","clearable":"","disabled":!_vm.updateProfileData.governorate_id_fk,"data-vv-name":"City","error-messages":_vm.errors.collect('City')},model:{value:(_vm.updateProfileData.city_id_fk),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "city_id_fk", $$v)},expression:"updateProfileData.city_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"col-sm-12 col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"}],attrs:{"name":"address","label":"Address","error-messages":_vm.errors.collect('Address'),"data-vv-name":"Address"},model:{value:(_vm.updateProfileData.address),callback:function ($$v) {_vm.$set(_vm.updateProfileData, "address", $$v)},expression:"updateProfileData.address"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{staticClass:"col-sm-12 col-md-6 col-md-offset-3"},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)])],1)])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"settings"}},[_c('div',{staticClass:"panel panel-flat"},[_vm._m(7),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-sm-8 col-md-offset-2",staticStyle:{"text-align":"left","color":"#ff4c22","font-size":"large"},attrs:{"id":"password_validation"}}),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-offset-2",staticStyle:{"text-align":"left","color":"#4cb743","font-size":"large"},attrs:{"id":"password_success"}}),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.changePassword(_vm.loggedInUserData.user_id)}}},[_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"name":"current_password","label":"Current password","error-messages":_vm.errors.collect('Current password'),"data-vv-name":"Current password"},model:{value:(_vm.changePasswordData.current_password),callback:function ($$v) {_vm.$set(_vm.changePasswordData, "current_password", $$v)},expression:"changePasswordData.current_password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text',"name":"new_password","label":"New password","error-messages":_vm.errors.collect('New password'),"data-vv-name":"New password"},model:{value:(_vm.changePasswordData.new_password),callback:function ($$v) {_vm.$set(_vm.changePasswordData, "new_password", $$v)},expression:"changePasswordData.new_password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:6'),expression:"'required|min:6'"}],attrs:{"append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text',"name":"confirm_password","label":"Confirm password","error-messages":_vm.errors.collect('Confirm password'),"data-vv-name":"Confirm password"},model:{value:(_vm.changePasswordData.confirm_password),callback:function ($$v) {_vm.$set(_vm.changePasswordData, "confirm_password", $$v)},expression:"changePasswordData.confirm_password"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Change Password")])],1)],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"secret"}},[_c('div',{staticClass:"panel panel-flat"},[_vm._m(8),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.backErr,"color":"red","icon":"warning"}},[_vm._v("\n                      Current secret key is not correct\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.backSucc,"color":"green","icon":"success"}},[_vm._v("\n                      Secret key changed successfully\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.currSec,"color":"red","icon":"warning"}},[_vm._v("\n                      Current secret key is required\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.newSec,"color":"red","icon":"warning"}},[_vm._v("\n                      New secret key is required\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.confSec,"color":"red","icon":"warning"}},[_vm._v("\n                      Confirm secret key is required\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.matchSec,"color":"red","icon":"warning"}},[_vm._v("\n                      Confirm secret is not match\n                    ")])],1),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-sm-12"},[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateSecret(_vm.loggedInUserData.user_id)}}},[_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.e4 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e4 = !_vm.e4); },"type":_vm.e4 ? 'password' : 'text',"label":"Current secret"},model:{value:(_vm.updateSecretData.current_secret_key),callback:function ($$v) {_vm.$set(_vm.updateSecretData, "current_secret_key", $$v)},expression:"updateSecretData.current_secret_key"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.e5 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e5 = !_vm.e5); },"type":_vm.e5 ? 'password' : 'text',"label":"New secret"},model:{value:(_vm.updateSecretData.secret_key),callback:function ($$v) {_vm.$set(_vm.updateSecretData, "secret_key", $$v)},expression:"updateSecretData.secret_key"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.e6 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e6 = !_vm.e6); },"type":_vm.e6 ? 'password' : 'text',"label":"Confirm secret"},model:{value:(_vm.updateSecretData.confirm_secret_key),callback:function ($$v) {_vm.$set(_vm.updateSecretData, "confirm_secret_key", $$v)},expression:"updateSecretData.confirm_secret_key"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"create-secret"}},[_c('div',{staticClass:"panel panel-flat"},[_vm._m(9),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.backSucc,"color":"green","icon":"success"}},[_vm._v("\n                      Secret key created successfully\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.backErr,"color":"red","icon":"warning"}},[_vm._v("\n                      You already have a secret key\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.Sec,"color":"red","icon":"warning"}},[_vm._v("\n                      Secret key is required\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.confSec,"color":"red","icon":"warning"}},[_vm._v("\n                      Confirm secret key is required\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.matchSec,"color":"red","icon":"warning"}},[_vm._v("\n                      Confirm secret is not match\n                    ")])],1),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-sm-12"},[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.createSecret()}}},[_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.e7 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e7 = !_vm.e7); },"type":_vm.e7 ? 'password' : 'text',"label":"Secret key"},model:{value:(_vm.createSecretData.secret_key),callback:function ($$v) {_vm.$set(_vm.createSecretData, "secret_key", $$v)},expression:"createSecretData.secret_key"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{attrs:{"append-icon":_vm.e8 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e8 = !_vm.e8); },"type":_vm.e8 ? 'password' : 'text',"label":"Confirm secret"},model:{value:(_vm.createSecretData.confirm_secret_key),callback:function ($$v) {_vm.$set(_vm.createSecretData, "confirm_secret_key", $$v)},expression:"createSecretData.confirm_secret_key"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Create")])],1)],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"company"}},[_c('div',{staticClass:"panel panel-flat"},[_vm._m(10),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('v-alert',{staticStyle:{"padding":"6px","margin-bottom":"4%"},attrs:{"value":_vm.compsuccess,"color":"green","icon":"success"}},[_vm._v("\n                      Company info updated successfully\n                    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"6px","margin-bottom":"4%"},attrs:{"value":_vm.comperror,"color":"red","icon":"warning"}},[_vm._v("\n                      Please update anything\n                    ")])],1),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-sm-12"},[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.updateCompanyInfo()}}},[_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Company name","data-vv-name":"Company name","error-messages":_vm.errors.collect('Company name')},model:{value:(_vm.companyData.company_name),callback:function ($$v) {_vm.$set(_vm.companyData, "company_name", $$v)},expression:"companyData.company_name"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Company email","data-vv-name":"Company email","error-messages":_vm.errors.collect('Company email')},model:{value:(_vm.companyData.company_email),callback:function ($$v) {_vm.$set(_vm.companyData, "company_email", $$v)},expression:"companyData.company_email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number","data-vv-name":"Phone Number","error-messages":_vm.errors.collect('Phone Number')},model:{value:(_vm.companyData.phone_number),callback:function ($$v) {_vm.$set(_vm.companyData, "phone_number", $$v)},expression:"companyData.phone_number"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Company address","data-vv-name":"Company address","error-messages":_vm.errors.collect('Company address')},model:{value:(_vm.companyData.company_address),callback:function ($$v) {_vm.$set(_vm.companyData, "company_address", $$v)},expression:"companyData.company_address"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav visible-xs-block"},[_c('li',{staticClass:"full-width text-center"},[_c('a',{attrs:{"data-toggle":"collapse","data-target":"#navbar-filter"}},[_c('i',{staticClass:"fa fa-align-justify",staticStyle:{"font-size":"20px"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#activity","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-user",staticStyle:{"font-size":"16px"}}),_vm._v("  Personal\n                  Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#settings","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-key",staticStyle:{"font-size":"16px"}}),_vm._v("   Change Password")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#create-secret","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-key",staticStyle:{"font-size":"16px"}}),_vm._v("  Create Secret Key")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#secret","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-key",staticStyle:{"font-size":"16px"}}),_vm._v("   Change Secret Key")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#company","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-group",staticStyle:{"font-size":"16px"}}),_vm._v("   Company Info")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Personal Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Change Password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Change Secret Key")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Create Secret Key")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Company info")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regularUser_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8d56aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regularUser_vue__ = __webpack_require__(728);
function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_regularUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8d56aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_regularUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(715);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("39b35439", content, true, {});

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".verify-badge{display:inline-flex;justify-content:center;align-items:center;width:16px;height:16px;border-radius:50%;background:linear-gradient(135deg,#42a5f5,#007aff);font-size:10px;font-weight:700}.verify-badge:before{color:#fff;content:\"\\2714\";font-size:10px;line-height:1}.tooltip-container{position:relative}.tooltip-container:hover .tooltip-content{visibility:visible;opacity:1}.tooltip-content{visibility:hidden;opacity:0;transition:all .3 linear;position:absolute;top:-10px;left:20px;z-index:1000;font-size:12px;font-weight:400;background-color:#fff;border:1px solid #e4e7ed;border-radius:6px!important;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);padding:8px 12px;min-width:210px}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.custom-loader{animation:loader 1s infinite;display:flex}@-moz-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-webkit-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-o-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("71fe63cc", content, true, {});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active[data-v-5c19a966]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.createCustomerModal),callback:function ($$v) {_vm.createCustomerModal=$$v},expression:"createCustomerModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Customer")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){;(_vm.passwordAlert = false), _vm.closeCreateCustomerModal(), _vm.$validator.reset(), _vm.clearForm()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Customer First Name*","error-messages":_vm.errors.collect('Customer First Name'),"data-vv-name":"Customer First Name"},model:{value:(_vm.addData.first_name),callback:function ($$v) {_vm.$set(_vm.addData, "first_name", $$v)},expression:"addData.first_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Customer Last Name*","error-messages":_vm.errors.collect('Customer Last Name'),"data-vv-name":"Customer Last Name"},model:{value:(_vm.addData.last_name),callback:function ($$v) {_vm.$set(_vm.addData, "last_name", $$v)},expression:"addData.last_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number*","error-messages":_vm.errors.collect('Phone Number'),"data-vv-name":"Phone Number"},model:{value:(_vm.addData.phone_number),callback:function ($$v) {_vm.$set(_vm.addData, "phone_number", $$v)},expression:"addData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Phone Number 2","error-messages":_vm.errors.collect('Phone Number 2'),"data-vv-name":"Phone Number 2"},model:{value:(_vm.addData.phone_number_2),callback:function ($$v) {_vm.$set(_vm.addData, "phone_number_2", $$v)},expression:"addData.phone_number_2"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('email'),expression:"'email'"}],attrs:{"label":"Email","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.addData.email),callback:function ($$v) {_vm.$set(_vm.addData, "email", $$v)},expression:"addData.email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.governoratesList,"item-value":"governorate_id","item-text":"governorate_name","error-messages":_vm.errors.collect('Governorate'),"data-vv-name":"Governorate","label":"Governorate","clearable":""},model:{value:(_vm.addData.governorate_id_fk),callback:function ($$v) {_vm.$set(_vm.addData, "governorate_id_fk", $$v)},expression:"addData.governorate_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.citiesList,"item-value":"city_id","item-text":"city_name","error-messages":_vm.errors.collect('City'),"data-vv-name":"City","label":"City","clearable":""},model:{value:(_vm.addData.city_id_fk),callback:function ($$v) {_vm.$set(_vm.addData, "city_id_fk", $$v)},expression:"addData.city_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Address","data-vv-name":"Address","error-messages":_vm.errors.collect('Address')},model:{value:(_vm.addData.address),callback:function ($$v) {_vm.$set(_vm.addData, "address", $$v)},expression:"addData.address"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"description"}},[_vm._v("\n              Customer Note\n            ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.addData.customer_note),expression:"addData.customer_note"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.addData.customer_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.addData, "customer_note", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){;(_vm.passwordAlert = false), _vm.closeCreateCustomerModal(), _vm.$validator.reset(), _vm.clearForm()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2.5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1),_vm._v(" "),_c('form',{attrs:{"id":"login_success99"},on:{"submit":function($event){$event.preventDefault();return _vm.phoneLogin.apply(null, arguments)}}},[_c('input',{attrs:{"type":"hidden","name":"_token","value":"QH65OXMU7MRnJg6UIS2LucakcxXX5LP88cFsEEwL"}}),_vm._v(" "),_c('input',{attrs:{"id":"csrf","type":"hidden","name":"csrf"}}),_vm._v(" "),_c('input',{attrs:{"id":"code","type":"hidden","name":"code"}}),_vm._v(" "),_c('button',{attrs:{"type":"submit","id":"phone"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(720);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("36b1cb15", content, true, {});

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.editCustomerModal),callback:function ($$v) {_vm.editCustomerModal=$$v},expression:"editCustomerModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update Customer")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditCustomerModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Customer First Name*","error-messages":_vm.errors.collect('Customer First Name'),"data-vv-name":"Customer First Name"},model:{value:(_vm.editCustomerData.first_name),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "first_name", $$v)},expression:"editCustomerData.first_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Customer Last Name*","error-messages":_vm.errors.collect('Customer Last Name'),"data-vv-name":"Customer Last Name"},model:{value:(_vm.editCustomerData.last_name),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "last_name", $$v)},expression:"editCustomerData.last_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number","error-messages":_vm.errors.collect('phone_number'),"data-vv-name":"phone_number"},model:{value:(_vm.editCustomerData.phone_number),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "phone_number", $$v)},expression:"editCustomerData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Phone Number 2","error-messages":_vm.errors.collect('Phone Number 2'),"data-vv-name":"Phone Number 2"},model:{value:(_vm.editCustomerData.phone_number_2),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "phone_number_2", $$v)},expression:"editCustomerData.phone_number_2"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('email'),expression:"'email'"}],attrs:{"label":"Email","error-messages":_vm.errors.collect('email'),"data-vv-name":"email"},model:{value:(_vm.editCustomerData.email),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "email", $$v)},expression:"editCustomerData.email"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.localGovernoratesList,"item-value":"governorate_id","item-text":"governorate_name","error-messages":_vm.errors.collect('Governorate'),"data-vv-name":"Governorate","label":"Governorate","clearable":""},model:{value:(_vm.editCustomerData.governorate_id_fk),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "governorate_id_fk", $$v)},expression:"editCustomerData.governorate_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"autocomplete":"","items":_vm.localCitiesList,"item-value":"city_id","item-text":"city_name","error-messages":_vm.errors.collect('City'),"data-vv-name":"City","label":"City","clearable":""},model:{value:(_vm.editCustomerData.city_id_fk),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "city_id_fk", $$v)},expression:"editCustomerData.city_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Address","data-vv-name":"address"},model:{value:(_vm.editCustomerData.address),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "address", $$v)},expression:"editCustomerData.address"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('min:6'),expression:"'min:6'"}],attrs:{"label":"New Password","data-vv-name":"New Password","error-messages":_vm.errors.collect('New Password')},model:{value:(_vm.editCustomerData.new_password),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "new_password", _vm._n($$v))},expression:"editCustomerData.new_password"}})],1),_vm._v(" "),(!_vm.editCustomerData.base_phone_verified)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-checkbox',{staticStyle:{"padding":"0px"},attrs:{"label":"Verified","ripple":false},model:{value:(_vm.editCustomerData.phone_verified),callback:function ($$v) {_vm.$set(_vm.editCustomerData, "phone_verified", $$v)},expression:"editCustomerData.phone_verified"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"description"}},[_vm._v("\n                Customer Note\n              ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editCustomerData.customer_note),expression:"editCustomerData.customer_note"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.editCustomerData.customer_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editCustomerData, "customer_note", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditCustomerModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2.5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(723);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c6b5d306", content, true, {});

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".on-hover[data-v-61d06a32]:hover{background-color:#eee}.overlay--active[data-v-61d06a32]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"74%"},model:{value:(_vm.tranDialog),callback:function ($$v) {_vm.tranDialog=$$v},expression:"tranDialog"}},[_c('v-card',[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.customerName)+" Transactions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"id":"print-area-invoices"}},[_c('table',{attrs:{"cellspacing":"0","id":"head-table"}},[_c('tr',[_c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"src":__webpack_require__(12),"alt":""}})]),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"cellspacing":"0","id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_name)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_address)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_email)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.phone_number)+"\n                  ")])])])])])]),_vm._v(" "),_c('v-layout',{staticClass:"not-printable",staticStyle:{"margin-bottom":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-left":"5px"},attrs:{"xs4":"","sm3":"","md2":"","lg2":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191"},attrs:{"date":_vm.fromDate,"option":_vm.option}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20px"},attrs:{"xs4":"","sm3":"","md2":"","lg2":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191"},attrs:{"date":_vm.toDate,"option":_vm.option1}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20px"},attrs:{"xs4":"","sm6":"","md2":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.filterByDate()}}},[_vm._v("\n              Filter\n            ")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20px"},attrs:{"xs4":"","sm4":"","md2":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":function($event){return _vm.removeDateFilter()}}},[_vm._v("\n              Remove Filter\n            ")])],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"20px"},attrs:{"xs4":"","sm4":"","md2":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"primary"},on:{"click":function($event){return _vm.sendToExport()}}},[_vm._v("\n              Export\n            ")])],1)],1),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","margin-top":"15px","margin-bottom":"15px"},attrs:{"cellspacing":"0"}},[_c('tr',[_c('td',{staticClass:"fm-roboto fs-14"},[_vm._v("Customer: "+_vm._s(_vm.customerName))]),_vm._v(" "),(_vm.form.from_date)?_c('td',{staticClass:"fm-roboto fs-14"},[_vm._v("From date: "+_vm._s(_vm.form.from_date))]):_vm._e(),_vm._v(" "),(_vm.form.to_date)?_c('td',{staticClass:"fm-roboto fs-14"},[_vm._v("To date: "+_vm._s(_vm.form.to_date))]):_vm._e()])]),_vm._v(" "),_c('v-layout',{staticClass:"not-printable px-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":"","lg4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Date")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Description")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Invoice No")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Credit")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Debit")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Balance")]),_vm._v(" "),_c('th',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v("Note")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.filteredData),function(row,index){return _c('tr',{key:index,staticClass:"on-hover"},[(index == 0)?[_c('td',{staticClass:"text-align-center fs-14 bottom-border fm-roboto py-4px px-6px",attrs:{"colspan":"7"}},[_vm._v("Opening Balance")]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(row.balance)))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"})]:[_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(_vm._f("moment")(row.created_at,'YYYY-MM-DD')))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(row.description))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(row.invoice_number))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px",staticStyle:{"max-width":"250px"}},[_vm._v(_vm._s(row.type == 'order' ? row.product_name : ''))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(row.type == 'order' ? row.quantity : ''))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(row.credit)))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(row.debit)))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(row.balance)))]),_vm._v(" "),_c('td',{staticClass:"text-align-left fs-14 bottom-border fm-roboto py-4px px-6px"},[_vm._v(_vm._s(row.note))])]],2)}),_vm._v(" "),(_vm.tranData.totals)?_c('tr',{staticStyle:{"background-color":"#ddd","font-weight":"bold"}},[_c('td',{attrs:{"colspan":"5"}}),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.tranData.totals.credit)))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.tranData.totals.debit)))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.tranData.totals.balance)))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px"})]):_vm._e()],2)])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"primary"},on:{"click":function($event){return _vm.print()}}},[_vm._v("Print")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(726);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("451d9509", content, true, {});

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.createCreditModal),callback:function ($$v) {_vm.createCreditModal=$$v},expression:"createCreditModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Credit")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeCreatCreditModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Credit added successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"error-messages":_vm.errors.collect('Customer'),"data-vv-name":"Customer","label":"Customer*","single-line":""},model:{value:(_vm.addData.user_id_fk),callback:function ($$v) {_vm.$set(_vm.addData, "user_id_fk", $$v)},expression:"addData.user_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Amount USD*","error-messages":_vm.errors.collect('amount'),"data-vv-name":"amount"},model:{value:(_vm.addData.amount),callback:function ($$v) {_vm.$set(_vm.addData, "amount", _vm._n($$v))},expression:"addData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Amount IQD","data-vv-name":"amount"},model:{value:(_vm.calculateIQDAmount),callback:function ($$v) {_vm.calculateIQDAmount=$$v},expression:"calculateIQDAmount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.addData.note),callback:function ($$v) {_vm.$set(_vm.addData, "note", $$v)},expression:"addData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeCreatCreditModal(), _vm.$validator.reset(), _vm.resetForm()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","loading":_vm.load,"outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_credit: 'add_credit',
          add_customer: 'add_customer',
        },"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"showCreateCustomerButton":true,"openCreateCustomerModal":_vm.openCreateCustomerModal,"addCreatCreditButton":true,"openCreatCreditModal":_vm.openCreatCreditModal,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExportButton":true,"sendToExport":_vm.sendToExport,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},scopedSlots:_vm._u([{key:"custom-filter",fn:function(){return [_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md4":"","lg3":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.verifiedList,"label":"Verify Filter"},on:{"input":function($event){return _vm.getResults()}},model:{value:(_vm.tableData.phone_verified),callback:function ($$v) {_vm.$set(_vm.tableData, "phone_verified", $$v)},expression:"tableData.phone_verified"}})],1)]},proxy:true}])}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[(_vm.selectedUserIds.length || _vm.selectingAll)?_c('div',{staticClass:"row text-center"},[_c('h5',{staticClass:"ma-0",staticStyle:{"font-weight":"bold"}},[(_vm.selectingAll)?_c('span',[_vm._v("Selecting all customers...")]):_c('span',[_vm._v("\n              Selected customers: "+_vm._s(_vm.selectedUserIds.length)+" of "+_vm._s(_vm.totalFiltered)+"   |   Sum of selected credit: $"+_vm._s(_vm.sumOfSelectedCredit.toFixed(2))+"\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"primary","loading":_vm.exportingSelected,"disabled":_vm.selectingAll},on:{"click":function($event){return _vm.exportSelected()}}},[_vm._v("Export selected")]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){return _vm.unCheckAll()}}},[_vm._v("Clear selection")])],1)]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.user_id,style:(_vm.selectedUserIds.includes(Number(r.user_id)) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUserIds),expression:"selectedUserIds"}],attrs:{"type":"checkbox"},domProps:{"value":Number(r.user_id),"checked":Array.isArray(_vm.selectedUserIds)?_vm._i(_vm.selectedUserIds,Number(r.user_id))>-1:(_vm.selectedUserIds)},on:{"change":function($event){var $$a=_vm.selectedUserIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=Number(r.user_id),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedUserIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedUserIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedUserIds=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v("\n                "+_vm._s(r.full_name)+"\n                "),(r.phone_verified)?_c('div',{staticClass:"verify-badge tooltip-container"},[_c('div',{staticClass:"tooltip-content"},[_vm._v("\n                    Verified at "+_vm._s(_vm._f("moment")(r.verified_at,'YYYY-MM-DD hh:mm A'))+"\n                  ")])]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.email))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[_vm._v("\n                "+_vm._s(r.phone_number)+"\n                "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[_vm._v("\n                "+_vm._s(r.phone_number_2)+"\n                "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number_2}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.governorate_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.city_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.address))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.credit))]),_vm._v(" "),(r.is_blocked === '0')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v("Active")])]):_c('td',[_c('span',{staticClass:"label bg-warning"},[_vm._v("Block")])]),_vm._v(" "),(_vm.$_has_perm('edit_customer'))?_c('td',{staticStyle:{"padding-left":"5px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579b"},attrs:{"tooltip":"Edit Customer"},on:{"click":function($event){return _vm.openEditCustomerModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('view_customer_transaction'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#555"},attrs:{"tooltip":"Customer transaction"},on:{"click":function($event){return _vm.customerTransaction(r.user_id, r.full_name)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("swap_horiz")])])]):_vm._e(),_vm._v(" "),(r.is_blocked === '0' && r.status !== 'admin' && _vm.$_has_perm('block_unblock_customer'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#ff5722"},attrs:{"tooltip":"Block This User"},on:{"click":function($event){return _vm.blockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_outline")])])]):(r.status !== 'admin' && _vm.$_has_perm('block_unblock_customer'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#7cb342"},attrs:{"tooltip":"Unblock This User"},on:{"click":function($event){return _vm.unblockUser(r.user_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("lock_open")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',{staticStyle:{"width":"100%","padding-top":"5px"}},[_c('span',{staticStyle:{"float":"right","font-weight":"bold","padding-right":"30px"}},[_vm._v("Total income   $"+_vm._s(_vm.totalCredit))])])])]),_vm._v(" "),_c('create-user',{attrs:{"createCustomerModal":_vm.createCustomerModal,"createCustomer":_vm.createCustomer,"citiesList":_vm.citiesList,"addData":_vm.addData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError,"phoneError":_vm.phoneError,"emailError":_vm.emailError,"phoneNumberError":_vm.phoneNumberError,"closeCreateCustomerModal":_vm.closeCreateCustomerModal,"defaultPriceData":_vm.defaultPriceData}}),_vm._v(" "),_c('edit-customer',{attrs:{"editCustomerModal":_vm.editCustomerModal,"editCustomer":_vm.editCustomer,"editCustomerData":_vm.editCustomerData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError,"emailError":_vm.emailError,"backendError":_vm.backendError,"closeEditCustomerModal":_vm.closeEditCustomerModal}}),_vm._v(" "),_c('customer-transactions',{attrs:{"tranDialog":_vm.tranDialog,"customerId":_vm.customerId,"customerName":_vm.customerName},on:{"close-dialog":function($event){_vm.tranDialog = false}}}),_vm._v(" "),_c('creat-credit',{attrs:{"createCreditModal":_vm.createCreditModal,"createCredit":_vm.createCredit,"addData":_vm.addCreditData,"checkAlert":_vm.checkAlert,"closeCreatCreditModal":_vm.closeCreatCreditModal,"customers":_vm.customers,"currentExchangeRate":_vm.currentExchangeRate,"load":_vm.load}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customers")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDeliveredOrder_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4beedc65_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDeliveredOrder_vue__ = __webpack_require__(732);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDeliveredOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4beedc65_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDeliveredOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(731);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d1f2328", content, true, {});

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_second_shipping_invoice: 'add_second_shipping_invoice'
        },"addSecondOrderInvoiceButton":true,"openSecondOrderInvoiceModal":_vm.openSecondOrderInvoiceModal,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"filterTable":_vm.filterTable,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_delivered_order_to_purchased_order'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.order_id)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name.substr(0, 35) +
                    (r.product_name.length > 35 ? '...' : ''))+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('return_delivered_order_to_purchased_order'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","float":"left"}},[_c('a',{staticStyle:{"color":"#eb8545"},attrs:{"tooltip":"Return to purchase"},on:{"click":function($event){return _vm.returnToPurchase(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings_backup_restore")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-order-invoice',{attrs:{"formData":_vm.generateInvoiceData,"orderInvoiceModal":_vm.orderInvoiceModal,"is_second_invoice":true},on:{"close":function($event){_vm.orderInvoiceModal = false},"invoice-created":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customer Delivered Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminArchivedOrder_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b01bc20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminArchivedOrder_vue__ = __webpack_require__(736);
function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminArchivedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b01bc20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminArchivedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(735);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1006d693", content, true, {});

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{},"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"filterTable":_vm.filterTable,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Archived Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credit_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e351e74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_credit_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_credit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e351e74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_credit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(739);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3065a060", content, true, {});

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCredit_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26522bc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCredit_vue__ = __webpack_require__(743);
function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCredit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26522bc5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCredit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(742);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("547d1ce2", content, true, {});

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.editCreditModal),callback:function ($$v) {_vm.editCreditModal=$$v},expression:"editCreditModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Credit")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditCreditModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Credit updated successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.backendError}},[_vm._v("\n              Please update anything\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Amount*","error-messages":_vm.errors.collect('amount'),"data-vv-name":"amount"},model:{value:(_vm.editData.amount),callback:function ($$v) {_vm.$set(_vm.editData, "amount", _vm._n($$v))},expression:"editData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.editData.note),callback:function ($$v) {_vm.$set(_vm.editData, "note", $$v)},expression:"editData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditCreditModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"5%"},attrs:{"type":"submit","loading":_vm.load2,"outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCashBack_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4290f1ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCashBack_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCashBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4290f1ab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCashBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(746);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("032d8ca6", content, true, {});

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.editCashBackModal),callback:function ($$v) {_vm.editCashBackModal=$$v},expression:"editCashBackModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Cash Back")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditCashBackModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Cash back updated successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.backendError}},[_vm._v("\n              Please update anything\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Amount*","error-messages":_vm.errors.collect('amount'),"data-vv-name":"amount"},model:{value:(_vm.editCashBackData.amount),callback:function ($$v) {_vm.$set(_vm.editCashBackData, "amount", _vm._n($$v))},expression:"editCashBackData.amount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.editCashBackData.note),callback:function ($$v) {_vm.$set(_vm.editCashBackData, "note", $$v)},expression:"editCashBackData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditCashBackModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cashBack_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbd85ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cashBack_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cashBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bbd85ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cashBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ada87354", content, true, {});

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.cashBackModal),callback:function ($$v) {_vm.cashBackModal=$$v},expression:"cashBackModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Credit Cash Back")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeCashBackModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Credit cashed back successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.cashBackError}},[_vm._v("\n              Cash back amount is more than customer credit\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"error-messages":_vm.errors.collect('Customer'),"data-vv-name":"Customer","label":"Customer*","single-line":""},model:{value:(_vm.cashBackData.user_id_fk),callback:function ($$v) {_vm.$set(_vm.cashBackData, "user_id_fk", $$v)},expression:"cashBackData.user_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm10":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Amount*","error-messages":_vm.errors.collect('amount'),"data-vv-name":"amount"},model:{value:(_vm.cashBackData.amount),callback:function ($$v) {_vm.$set(_vm.cashBackData, "amount", _vm._n($$v))},expression:"cashBackData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.cashBackData.note),callback:function ($$v) {_vm.$set(_vm.cashBackData, "note", $$v)},expression:"cashBackData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeCashBackModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","loading":_vm.load2,"outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(753);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b752e224", content, true, {});

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area{max-width:850px}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#credit-table-header,#price-section2{width:500px;padding-left:10px}#price-section2{padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal_showApp"}},[_c('div',{staticClass:"modal-dialog modal-full",staticStyle:{"max-width":"850px"},attrs:{"id":"print-area"}},[_c('div',{staticClass:"modal-content",staticStyle:{"border-style":"dashed","border-width":"1px"}},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"id":"close-button","type":"button"},on:{"click":function($event){return _vm.closeModal('modal_showApp')}}},[_vm._v("\n          ×\n        ")])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"head-table"}},[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_name)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_address)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_email)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.phone_number)+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table1"}},[_c('tr',[_c('td',{attrs:{"id":"credit-table-header"}},[_c('strong',{staticStyle:{"font-size":"20px"}},[(_vm.detailData.action === 'cash back')?_c('span',[_vm._v("CashBack Invoice")]):_c('span',[_vm._v("\n                           Receipt\n                ")])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table2"}},[_c('tr',[_c('td',{attrs:{"id":"info-section1"}},[_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Invoice Number:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.invoice_number))])]),_vm._v(" "),(_vm.detailData.base_invoice_number != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Credit Invoice Number:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.base_invoice_number))])]):_vm._e(),_vm._v(" "),(_vm.detailData.credit_log_action_date != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.credit_log_action_date))])]):_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.created_at))])])]),_vm._v(" "),_c('td',{attrs:{"id":"info-section2"}},[_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Customer Name:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.customer_name))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Customer Address:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.customer_address))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold","margin":"8px 0px"}},[_vm._v("\n                Customer Tel:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.detailData.phone_number))])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table3"}},[_c('tr',{staticStyle:{"height":"120px"}},[_c('td',{attrs:{"id":"price-section00"}},[_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Description")]),_vm._v(" "),(_vm.detailData.note != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Note\n              ")]):_vm._e(),_vm._v(" "),(_vm.detailData.old_price != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Old Amount\n              ")]):_vm._e(),_vm._v(" "),(_vm.detailData.old_price != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                New Amount\n              ")]):_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("Amount")])]),_vm._v(" "),_c('td',{attrs:{"id":"price-section11"}},[_c('p',{staticStyle:{"font-size":"14px","font-weight":"normal"}},[_vm._v(": "+_vm._s(_vm.detailData.description))]),_vm._v(" "),(_vm.detailData.note != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"normal"}},[_vm._v("\n                : "+_vm._s(_vm.detailData.note)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.detailData.old_price != null)?_c('p',{staticStyle:{"font-size":"14px","font-weight":"normal"}},[_vm._v("\n                : $"+_vm._s(_vm.detailData.old_price)+"\n              ")]):_vm._e(),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"normal"}},[_vm._v(": $"+_vm._s(_vm.detailData.amount))])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('td',{staticStyle:{"text-align":"right","padding-right":"10px","border":"1px solid #000"}},[_c('p',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Total:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.detailData.amount))])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":_vm.printInvoice}},[_vm._v("Print")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"id":"header-img","src":__webpack_require__(12),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_credit: 'add_credit',
          add_cashback: 'add_cashback',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addCreatCreditButton":true,"openCreatCreditModal":_vm.openCreatCreditModal,"cashBackButton":true,"openCashBackModal":_vm.openCashBackModal,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults2":_vm.resetGetResults2,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(_vm.sumOfSelectedOrders)?_c('div',{staticClass:"row text-center"},[_c('h5',{staticClass:"ma-0",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            Sum of selected orders: "+_vm._s(_vm.sumOfSelectedOrders.toFixed(3))+"\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.credit_invoice_id,style:(_vm.creditIds.find(function (x) { return x == r.credit_invoice_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.creditIds),expression:"creditIds"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":r.credit_invoice_id,"checked":Array.isArray(_vm.creditIds)?_vm._i(_vm.creditIds,r.credit_invoice_id)>-1:(_vm.creditIds)},on:{"change":function($event){var $$a=_vm.creditIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=r.credit_invoice_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.creditIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.creditIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.creditIds=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.staff_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[_vm._v("\n                "+_vm._s(r.customer_name)+"\n                "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),(r.credit_status === 'add')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.ex_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.payment_method))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),(r.credit_invoice_date != null)?_c('td',[_vm._v(_vm._s(r.credit_invoice_date))]):_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]),_vm._v(" "),(r.credit_status === 'add' && _vm.$_has_perm('edit_credit'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditCreditModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):(_vm.$_has_perm('edit_cashback'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditCashBackModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(r.credit_status === 'add' && _vm.$_has_perm('delete_credit'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCredit(r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):(_vm.$_has_perm('delete_cashback'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCashBack(r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',{staticStyle:{"padding":"3px","font-weight":"bold"}},[_vm._v("\n              Total income (Add +):   $"+_vm._s(_vm.totalAdd)+"\n            ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"3px","font-weight":"bold"}},[_vm._v("\n              Total outgoing (CashBack -):   $"+_vm._s(_vm.totalCashBack)+"\n            ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"padding":"3px","font-weight":"bold"}},[_vm._v("\n              General Total:   $"+_vm._s(_vm.generalTotal)+"\n            ")])])]),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isCustomerCredit":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                Invoice No: "+_vm._s(r.invoice_number)+" , "),_c('br'),_vm._v("\n                Staff: "+_vm._s(r.staff_name)+" , "),_c('br'),_vm._v("\n                CustomerID: "+_vm._s(r.customer_id)+" , "),_c('br'),_vm._v("\n                Customer: "+_vm._s(r.customer_name)+" , "),_c('br'),_vm._v("\n                CustomerPhone: "+_vm._s(r.phone_number)+", "),_c('br')]),_vm._v(" "),_c('td',[(r.credit_status === 'add')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("$"+_vm._s(r.amount))]),_vm._v(" , "),_c('br'),_vm._v(" "),(r.note != null)?_c('span',[_vm._v("Note: "+_vm._s(r.note)+", "),_c('br')]):_vm._e(),_vm._v(" "),(r.credit_invoice_date != null)?_c('span',[_vm._v(_vm._s(r.credit_invoice_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px","display":"inline-block"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]),_vm._v(" "),(r.credit_status === 'add' && _vm.$_has_perm('edit_credit'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","float":"left"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditCreditModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):(_vm.$_has_perm('edit_cashback'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","float":"left"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditCashBackModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(r.credit_status === 'add' && _vm.$_has_perm('delete_credit'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","float":"left"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCredit(r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):(_vm.$_has_perm('delete_cashback'))?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"0px","float":"left"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCashBack(r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('creat-credit',{attrs:{"createCreditModal":_vm.createCreditModal,"createCredit":_vm.createCredit,"addData":_vm.addData,"checkAlert":_vm.checkAlert,"closeCreatCreditModal":_vm.closeCreatCreditModal,"customers":_vm.customers,"currentExchangeRate":_vm.currentExchangeRate,"load":_vm.load}}),_vm._v(" "),_c('cash-back',{attrs:{"cashBackModal":_vm.cashBackModal,"cashBack":_vm.cashBack,"cashBackData":_vm.cashBackData,"checkAlert":_vm.checkAlert,"cashBackError":_vm.cashBackError,"closeCashBackModal":_vm.closeCashBackModal,"customers":_vm.customers,"load2":_vm.load2}}),_vm._v(" "),_c('edit-credit',{attrs:{"editCreditModal":_vm.editCreditModal,"editCredit":_vm.editCredit,"editData":_vm.editData,"checkAlert":_vm.checkAlert,"closeEditCreditModal":_vm.closeEditCreditModal,"customers":_vm.customers,"backendError":_vm.backendError,"load2":_vm.load2}}),_vm._v(" "),_c('edit-cash-back',{attrs:{"editCashBackModal":_vm.editCashBackModal,"closeEditCashBackModal":_vm.closeEditCashBackModal,"checkAlert":_vm.checkAlert,"editCashBackData":_vm.editCashBackData,"editCashBack":_vm.editCashBack,"backendError":_vm.backendError}}),_vm._v(" "),_c('view-action-log',{attrs:{"detailData":_vm.detailData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customer Credit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_creditLogTransaction_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c2b8f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_creditLogTransaction_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_creditLogTransaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09c2b8f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_creditLogTransaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("595ba130", content, true, {});

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleInvoices_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a1dab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleInvoices_vue__ = __webpack_require__(762);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multipleInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a1dab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multipleInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(761);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2da849df", content, true, {});

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area-invoices{max-width:900px}", ""]);

// exports


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"invoicesModal"}},[_c('div',{staticClass:"modal-dialog modal-full",attrs:{"id":"print-area-invoices"}},[_c('div',{staticClass:"modal-content",staticStyle:{"border-style":"dashed","border-width":"1px"}},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"id":"close-button-multiple","type":"button"},on:{"click":function($event){_vm.closeModal('invoicesModal'), _vm.$emit('close')}}},[_vm._v("\n          ×\n        ")])]),_vm._v(" "),_c('table',{attrs:{"cellspacing":"0","id":"head-table"}},[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"cellspacing":"0","id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_name)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_address)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_email)+"\n                ")])])])])])]),_vm._v(" "),(_vm.invoicesModal)?_c('div',{staticClass:"modal-body"},[_vm._m(1),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0"}},[_c('tr',[_c('td',{staticClass:"fm-roboto py-4px px-6px left-border top-border bottom-border"},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"0px"}},[_vm._v("\n                Customer Name: "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoicesData.customer.full_name))])])]),_vm._v(" "),_c('td',{staticClass:"fm-roboto py-4px px-6px top-border bottom-border"},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"0px"}},[_vm._v("\n                Address:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoicesData.customer.address))])])]),_vm._v(" "),_c('td',{staticClass:"fm-roboto py-4px px-6px right-border top-border bottom-border"},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"0px"}},[_vm._v("\n                Phone:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoicesData.customer.phone_number))])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.invoicesData.details),function(row,index){return _c('tr',{key:row.credit_log_transaction_id},[_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border left-border"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v(_vm._s(row.quantity))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v("$"+_vm._s(row.amount))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v(_vm._s(row.invoice_number))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border width-100px"},[_vm._v(_vm._s(row.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v("$"+_vm._s(row.paid_amount || 0))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border"},[_vm._v("$"+_vm._s((row.amount - Number(row.paid_amount)).toFixed(2)))]),_vm._v(" "),_c('td',{staticClass:"fm-roboto fs-14 py-4px px-6px right-border width-100px"},[_vm._v(_vm._s(row.credit_log_transaction_date))])])}),0)]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0"}},[_c('tr',[_c('td',{staticClass:"fm-roboto",staticStyle:{"border":"1px solid #000","text-align":"right","padding-right":"10px"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Sub Total:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.invoicesData.total_amount.toFixed(2)))])])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Total Paid:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.invoicesData.total_paid.toFixed(2)))])])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold","margin":"2px 0px"}},[_vm._v("\n                Total Remain:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_c('b',[_vm._v("$"+_vm._s(_vm.invoicesData.total_remain.toFixed(2)))])])])])])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button-multiple","outline":"","color":"primary"},on:{"click":_vm.printInvoiceMultiple}},[_vm._v("Print")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"src":__webpack_require__(12),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","id":"print-table1"}},[_c('tr',[_c('td',{attrs:{"id":"table-header"}},[_c('h4',{staticStyle:{"margin-bottom":"0px"}},[_c('strong',[_c('span',[_vm._v("Shopping Online Invoice")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border left-border py-4px px-6px"},[_vm._v("No.")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Item Price")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Invoice No.")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px width-100px"},[_vm._v("Order No.")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Paid")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px"},[_vm._v("Remain")]),_vm._v(" "),_c('th',{staticClass:"fm-roboto fs-14 bottom-border right-border py-4px px-6px width-100px"},[_vm._v("Date")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 pt-0"},[_c('v-layout',{staticStyle:{"margin":"0px"},attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md5":""}},[_c('v-select',{staticStyle:{"width":"100%"},attrs:{"autocomplete":"","items":_vm.customersList,"label":"Customer","single-line":"","clearable":""},on:{"input":function($event){return _vm.filterByCustomer()}},model:{value:(_vm.tableData.customer),callback:function ($$v) {_vm.$set(_vm.tableData, "customer", $$v)},expression:"tableData.customer"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"15px"},attrs:{"xs12":"","sm4":"","md5":""}},[_c('v-btn',{staticStyle:{"height":"auto","padding":"4px","margin-left":"15px"},attrs:{"disabled":_vm.transactionsArray.length < 1,"depressed":"","color":"primary","small":""},on:{"click":_vm.printInvoices}},[_vm._v("\n              Print all\n            ")])],1)],1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.credit_log_transaction_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactionsArray),expression:"transactionsArray"}],attrs:{"id":'cb' + index,"disabled":!_vm.tableData.customer,"type":"checkbox"},domProps:{"value":r.credit_log_transaction_id,"checked":Array.isArray(_vm.transactionsArray)?_vm._i(_vm.transactionsArray,r.credit_log_transaction_id)>-1:(_vm.transactionsArray)},on:{"change":function($event){var $$a=_vm.transactionsArray,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=r.credit_log_transaction_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.transactionsArray=$$a.concat([$$v]))}else{$$i>-1&&(_vm.transactionsArray=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.transactionsArray=$$c}}}})]),_vm._v(" "),(r.is_open === '0')?_c('td',[_c('div',{staticClass:"media-left"},[_vm._v("\n                  "+_vm._s(r.theOrderID)+"\n                  "),_c('span',{staticClass:"status-mark bg-danger-600 media-badge",staticStyle:{"margin-top":"2px","left":"-10px"}})])]):_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[(r.order_status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('span',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('span',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('span',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status))])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_c('span',{class:r.country == 'USA' ? 'flag-icon flag-icon-us' : 'flag-icon flag-icon-tr'}),_vm._v("\n                  "+_vm._s(r.country)+"\n              ")]),_vm._v(" "),(r.credit_log_transaction_date != null)?_c('td',[_vm._v("\n                "+_vm._s(r.credit_log_transaction_date)+"\n              ")]):_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.credit_log_transaction_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isTransactionOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[(r.is_open === '0')?_c('span',[_c('div',{staticClass:"media-left"},[_vm._v("\n                    "+_vm._s(r.theOrderID)+"\n                    "),_c('span',{staticClass:"status-mark bg-danger-600 media-badge",staticStyle:{"margin-top":"2px","left":"-10px"}})])]):_c('span',[_vm._v(_vm._s(r.theOrderID))]),_vm._v("\n                , "),_c('br'),_vm._v("\n                Invoice No: "+_vm._s(r.invoice_number)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{class:r.country == 'USA' ? 'flag-icon flag-icon-us' : 'flag-icon flag-icon-tr'}),_vm._v("\n                  "+_vm._s(r.country)+" ,\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                CustomerID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v("\n                Phone: "+_vm._s(r.phone_number)+" , "),_c('br'),_vm._v(" "),(r.credit_log_transaction_date != null)?_c('span',[_vm._v("\n                  "+_vm._s(r.credit_log_transaction_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v("\n                , "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.credit_log_transaction_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('multiple-invoices',{attrs:{"invoicesData":_vm.invoicesData,"closeModal":_vm.closeModal,"invoicesModal":_vm.invoicesModal,"companyData":_vm.companyData},on:{"close":function($event){_vm.invoicesModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Orders Invoice")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_creditLogAction_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec88a422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_creditLogAction_vue__ = __webpack_require__(767);
function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_creditLogAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec88a422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_creditLogAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(766);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7ca3069a", content, true, {});

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExportButton":true,"sendToExport":_vm.sendToExport,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.credit_log_action_id},[(r.is_open === '0')?_c('td',[_c('div',{staticClass:"media-left"},[_vm._v("\n                  "+_vm._s(r.staff_name)+"\n                  "),_c('span',{staticClass:"status-mark bg-danger-600 media-badge",staticStyle:{"margin-top":"2px","left":"-10px"}})])]):_c('td',[_vm._v(_vm._s(r.staff_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[_vm._v("\n                "+_vm._s(r.customer_name)+"\n                "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.customer_phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),(r.action === 'add')?_c('td',[_c('span',{staticClass:"label bg-green-400"},[_vm._v(" "+_vm._s(r.action))])]):(r.action === 'update')?_c('td',[_c('span',{staticClass:"label bg-blue-400"},[_vm._v(" "+_vm._s(r.action))])]):(r.action === 'delete')?_c('td',[_c('span',{staticClass:"label bg-danger-400"},[_vm._v(" "+_vm._s(r.action))])]):_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.action))])]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.amount))]),_vm._v(" "),(r.credit_log_action_date != null)?_c('td',[_vm._v(_vm._s(r.credit_log_action_date))]):_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_log_action_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isTransactionCredit":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                Staff: "+_vm._s(r.staff_name)+" , "),_c('br'),_vm._v("\n                CustomerID: "+_vm._s(r.customer_id)+" , "),_c('br'),_vm._v("\n                CustomerName: "+_vm._s(r.customer_name)+"\n              ")]),_vm._v(" "),_c('td',[(r.action === 'add')?_c('span',[_c('span',{staticClass:"label bg-green-400"},[_vm._v(" "+_vm._s(r.action))])]):(r.action === 'update')?_c('span',[_c('span',{staticClass:"label bg-blue-400"},[_vm._v(" "+_vm._s(r.action))])]):(r.action === 'delete')?_c('span',[_c('span',{staticClass:"label bg-danger-400"},[_vm._v(" "+_vm._s(r.action))])]):_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.action))])]),_vm._v(" "),_c('br'),_vm._v("$"+_vm._s(r.amount)+" , "),_c('br'),_vm._v(" "),(r.credit_log_action_date != null)?_c('span',[_vm._v(_vm._s(r.credit_log_action_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v("\n                , "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_log_action_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-action-log',{attrs:{"detailData":_vm.detailData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Credit Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coupon_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db0d6590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coupon_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_coupon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db0d6590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_coupon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(770);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a868f1f6", content, true, {});

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generateCoupon_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0411e710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generateCoupon_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(772)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generateCoupon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0411e710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_generateCoupon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(773);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a3abd9c", content, true, {});

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"620px","id":"mobile"},model:{value:(_vm.generateCouponModal),callback:function ($$v) {_vm.generateCouponModal=$$v},expression:"generateCouponModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('div',{staticClass:"col-sm-10"},[_c('span',{staticClass:"headline"},[_vm._v("Generate Coupon")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeGenerateCouponModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Coupons Generated Successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticStyle:{"margin-top":"4.5%","width":"85%"},attrs:{"label":"Number of coupon*","error-messages":_vm.errors.collect('Number of coupon'),"data-vv-name":"Number of coupon"},model:{value:(_vm.generateData.coupon_number),callback:function ($$v) {_vm.$set(_vm.generateData, "coupon_number", $$v)},expression:"generateData.coupon_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"85%"},attrs:{"label":"Discount percentage*","error-messages":_vm.errors.collect('Discount percentage'),"data-vv-name":"Discount percentage"},model:{value:(_vm.generateData.percentage),callback:function ($$v) {_vm.$set(_vm.generateData, "percentage", $$v)},expression:"generateData.percentage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191","width":"85%"},attrs:{"date":_vm.startTime,"option":_vm.option}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeGenerateCouponModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Generate")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCoupon_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501c46f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCoupon_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editCoupon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_501c46f5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editCoupon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(777);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("17eb684f", content, true, {});

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.editCouponModal),callback:function ($$v) {_vm.editCouponModal=$$v},expression:"editCouponModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Percentage")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditCouponModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Coupons Updated Successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],attrs:{"label":"Discount percentage*","error-messages":_vm.errors.collect('Discount percentage'),"data-vv-name":"Discount percentage"},model:{value:(_vm.editData.percentage),callback:function ($$v) {_vm.$set(_vm.editData, "percentage", $$v)},expression:"editData.percentage"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditCouponModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"6%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_giveToCustomer_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138ec051_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_giveToCustomer_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_giveToCustomer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138ec051_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_giveToCustomer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(781);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6327dfc6", content, true, {});

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"25%"},model:{value:(_vm.giveToCustomerModal),callback:function ($$v) {_vm.giveToCustomerModal=$$v},expression:"giveToCustomerModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('div',{staticClass:"col-sm-10"},[_c('span',{staticClass:"headline"},[_vm._v("Edit Percentage")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeGiveToCustomerModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Coupon gave to customer successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('Customer'),"data-vv-name":"Customer","label":"Customer","single-line":""},model:{value:(_vm.giveData.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.giveData, "customer_id_fk", $$v)},expression:"giveData.customer_id_fk"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":_vm.closeGiveToCustomerModal}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"6%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Give")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_coupon: 'add_coupon',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"addGenerateCouponButton":true,"openGenerateCouponModal":_vm.openGenerateCouponModal,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.coupon_id},[_c('td',[_vm._v(_vm._s(r.coupon_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.coupon))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.staff_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.percentage)+"%")]),_vm._v(" "),(r.coupon_status === 'used')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")])]):(r.coupon_status === 'unused')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")])]):(r.coupon_status === 'exported')?_c('td',[_c('span',{staticClass:"label bg-blue-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")])]):_c('td',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.expire_date))]),_vm._v(" "),(_vm.$_has_perm('edit_coupon'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#2E7D32"},attrs:{"tooltip":"Edit percentage"},on:{"click":function($event){return _vm.openEditCouponModal(r)}}},[_c('i',{staticClass:"fa fa-percent"})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_coupon'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCoupon(r.coupon_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isCoupon":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.coupon)+" , "),_c('br'),_vm._v("\n                Staff: "+_vm._s(r.staff_name)+" , "),_c('br'),_vm._v("\n                Percentage: "+_vm._s(r.percentage)+"%\n              ")]),_vm._v(" "),_c('td',[(r.coupon_status === 'used')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")]),_vm._v(" "),_c('br')]):(r.coupon_status === 'unused')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")]),_vm._v(" "),_c('br')]):(r.coupon_status === 'exported')?_c('span',[_c('span',{staticClass:"label bg-blue-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")]),_vm._v(" "),_c('br')]):_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.coupon_status)+" ")]),_vm._v(" "),_c('br')]),_vm._v("\n                "+_vm._s(r.created_at)+" "),_c('br'),_vm._v("\n                Expire Date: "+_vm._s(r.expire_date)+" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#2E7D32","display":"inline-block","padding-left":"5px"},attrs:{"tooltip":"Edit percentage"},on:{"click":function($event){return _vm.openEditCouponModal(r)}}},[_c('i',{staticClass:"fa fa-percent"})]),_vm._v(" "),_c('a',{staticStyle:{"color":"#C62828","float":"left"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCoupon(r.coupon_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('generate-coupon',{attrs:{"generateCouponModal":_vm.generateCouponModal,"closeGenerateCouponModal":_vm.closeGenerateCouponModal,"generateData":_vm.generateData,"generateCoupon":_vm.generateCoupon,"checkAlert":_vm.checkAlert}}),_vm._v(" "),_c('edit-coupon',{attrs:{"closeEditCouponModal":_vm.closeEditCouponModal,"editCouponModal":_vm.editCouponModal,"editCoupon":_vm.editCoupon,"checkAlert":_vm.checkAlert,"editData":_vm.editData}}),_vm._v(" "),_c('give-to-customer',{attrs:{"closeGiveToCustomerModal":_vm.closeGiveToCustomerModal,"giveToCustomerModal":_vm.giveToCustomerModal,"giveToCustomer":_vm.giveToCustomer,"checkAlert":_vm.checkAlert,"giveData":_vm.giveData,"customers":_vm.customers}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Coupons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6db90_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(787);
function injectStyle (ssrContext) {
  __webpack_require__(785)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60d6db90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6db90_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(786);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b5c79b30", content, true, {});

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".home-pallets[data-v-60d6db90]{padding-right:2%}.home-pallets-head[data-v-60d6db90]{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}.home-pallets-head h4[data-v-60d6db90]{margin:0;font-weight:600}.home-pallets-empty[data-v-60d6db90]{color:#777}.pallet-card[data-v-60d6db90]{margin-bottom:20px;padding:16px 18px;background:#fff;border:1px solid #e3e3e3;border-left:5px solid #e67e22;border-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.06);cursor:pointer;transition:box-shadow .15s}.pallet-card[data-v-60d6db90]:hover{box-shadow:0 3px 10px rgba(0,0,0,.14)}.pallet-card-done[data-v-60d6db90]{border-left-color:#27ae60}.pallet-card-top[data-v-60d6db90]{display:flex;justify-content:space-between;align-items:center;font-size:17px}.pallet-card-sub[data-v-60d6db90]{margin:6px 0 14px;color:#777;font-size:13px}.pallet-card-money[data-v-60d6db90]{display:flex;justify-content:space-between}.pallet-card-money small[data-v-60d6db90]{display:block;color:#888}.pallet-card-money span[data-v-60d6db90]{font-size:16px;font-weight:600}.money-good[data-v-60d6db90]{color:#27ae60}.money-bad[data-v-60d6db90]{color:#d9534f}.pallet-card-note[data-v-60d6db90]{margin-top:12px;padding-top:10px;border-top:1px dashed #e3e3e3;color:#e67e22;font-size:13px}", ""]);

// exports


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-left":"2%"}},[_c('h1',{staticClass:"lead",staticStyle:{"font-size":"24px"}},[_vm._v("Welcome to the Ship zone")]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.showPallets)?_c('div',{staticClass:"home-pallets"},[_c('div',{staticClass:"home-pallets-head"},[_vm._m(0),_vm._v(" "),_c('router-link',{attrs:{"to":"/pallets"}},[_vm._v("All pallets "),_c('i',{staticClass:"fa fa-angle-right"})])],1),_vm._v(" "),(_vm.palletsLoaded && _vm.pallets.length == 0)?_c('p',{staticClass:"home-pallets-empty"},[_vm._v("\n      No pallets yet. A pallet appears here after orders are sent to Int Shipment with a pallet number.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.pallets),function(p){return _c('div',{key:p.pallet_id,staticClass:"col-sm-6 col-lg-4"},[_c('router-link',{staticClass:"pallet-card",class:p.is_completed ? 'pallet-card-done' : 'pallet-card-open',attrs:{"to":'/pallets?pallet=' + p.pallet_id,"tag":"div"}},[_c('div',{staticClass:"pallet-card-top"},[_c('strong',[_vm._v(_vm._s(p.tracking_number))]),_vm._v(" "),_c('span',{staticClass:"label",class:p.is_completed ? 'label-success' : 'label-warning'},[_vm._v(_vm._s(p.is_completed ? 'Completed' : 'Not completed'))])]),_vm._v(" "),_c('div',{staticClass:"pallet-card-sub"},[(p.flight_date)?_c('span',[_vm._v("Flight "+_vm._s(p.flight_date)+" · ")]):_vm._e(),_vm._v(_vm._s(p.orders_count)+" orders ·\n            "+_vm._s(p.arrived_count)+" arrived · "+_vm._s(p.delivered_count)+" delivered\n          ")]),_vm._v(" "),_c('div',{staticClass:"pallet-card-money"},[_c('div',[_c('small',[_vm._v("Income")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("usdFormat")(p.income)))])]),_vm._v(" "),_c('div',[_c('small',[_vm._v("Expenses")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("usdFormat")(p.expense)))])]),_vm._v(" "),_c('div',[_c('small',[_vm._v(_vm._s(p.is_completed ? 'Final profit' : 'Provisional profit'))]),_vm._v(" "),_c('span',{class:p.profit < 0 ? 'money-bad' : 'money-good'},[_vm._v(_vm._s(_vm._f("usdFormat")(p.profit)))])])]),_vm._v(" "),(!p.is_completed)?_c('div',{staticClass:"pallet-card-note"},_vm._l((_vm.palletReasons(p)),function(reason){return _c('div',{key:reason},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "+_vm._s(reason))])}),0):_vm._e()])],1)}),0)]):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.is_staff)?_c('div',[(
        !_vm.loggedInUserData.phone_number ||
        !_vm.loggedInUserData.address ||
        !_vm.loggedInUserData.email ||
        !_vm.loggedInUserData.full_name
      )?_c('div',[_c('h5',{staticClass:"lead",staticStyle:{"font-size":"18px"}},[_vm._v("\n        Please fill out these information\n      ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.successResponse,"type":"success"}},[_vm._v("\n        The process was successful\n      ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.errorResponse,"type":"error"}},[_vm._v("\n        "+_vm._s(_vm.errorMessages.email)+"\n        "+_vm._s(_vm.errorMessages.phone_number)+"\n      ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[(!_vm.loggedInUserData.full_name)?_c('v-flex',{attrs:{"xs10":"","sm10":"","md5":""},on:{"click":function($event){_vm.emailHint = false}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Full name","error-messages":_vm.errors.collect('Full name'),"data-vv-name":"Full name"},model:{value:(_vm.customerInfoData.full_name),callback:function ($$v) {_vm.$set(_vm.customerInfoData, "full_name", $$v)},expression:"customerInfoData.full_name"}})],1):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.email)?_c('v-flex',{attrs:{"xs10":"","sm10":"","md5":""},on:{"click":function($event){_vm.emailHint = true}}},[_c('v-text-field',{attrs:{"label":"Email"},model:{value:(_vm.customerInfoData.email),callback:function ($$v) {_vm.$set(_vm.customerInfoData, "email", $$v)},expression:"customerInfoData.email"}}),_vm._v(" "),(_vm.emailHint === true)?_c('div',{staticStyle:{"background-color":"#ee9600","border-radius":"5px"}},[_c('p',{staticStyle:{"color":"white","padding":"2%"}},[_vm._v("\n              The email must be a real email, because every actions on your order will send to\n              this email\n            ")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.phone_number)?_c('v-flex',{attrs:{"xs10":"","sm10":"","md5":""},on:{"click":function($event){_vm.emailHint = false}}},[_c('div',{staticClass:"d-flex",staticStyle:{"align-items":"center"}},[_c('div',{staticStyle:{"font-size":"16px","margin-right":"10px"}},[_vm._v("+964")]),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone Number","placeholder":"7701234567","error-messages":_vm.errors.collect('Phone Number'),"type":"number","data-vv-name":"Phone Number"},model:{value:(_vm.customerInfoData.phone_number),callback:function ($$v) {_vm.$set(_vm.customerInfoData, "phone_number", $$v)},expression:"customerInfoData.phone_number"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.loggedInUserData.address)?_c('v-flex',{attrs:{"xs10":"","sm10":"","md5":""},on:{"click":function($event){_vm.emailHint = false}}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Address","error-messages":_vm.errors.collect('Address'),"data-vv-name":"Address"},model:{value:(_vm.customerInfoData.address),callback:function ($$v) {_vm.$set(_vm.customerInfoData, "address", $$v)},expression:"customerInfoData.address"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md5":""}},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%","margin-bottom":"5%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)],1):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" Latest pallets")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myOrders_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d47d9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myOrders_vue__ = __webpack_require__(805);
function injectStyle (ssrContext) {
  __webpack_require__(789)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myOrders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d47d9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myOrders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(790);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d5686c24", content, true, {});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.pointer{cursor:pointer}.not-selectable{user-select:none}.custom-label{font-size:11px;border-radius:4px;padding:2px 10px;width:95%}", ""]);

// exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(792);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6e4c2342", content, true, {});

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.cancelOrderModal),callback:function ($$v) {_vm.cancelOrderModal=$$v},expression:"cancelOrderModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Cancel Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeCancelingOrderModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.cancelAlert}},[_vm._v("\n              Order canceled successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-text-field',{attrs:{"label":"Cancel reason","data-vv-name":"Cancel reason"},model:{value:(_vm.cancelData.cancel_reason),callback:function ($$v) {_vm.$set(_vm.cancelData, "cancel_reason", $$v)},expression:"cancelData.cancel_reason"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeCancelingOrderModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(795);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("199fc314", content, true, {});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".branch-description[data-v-26a931bc]{font-size:18px}", ""]);

// exports


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.approveDialog),callback:function ($$v) {_vm.approveDialog=$$v},expression:"approveDialog"}},[_c('v-card',[_c('v-card-text',{staticClass:"px-4"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"branch-description py-3"},[_vm._v("\n              Are you sure?\n            ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"outline":"","color":"success"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addTrackNumber_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f71c459_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addTrackNumber_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addTrackNumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f71c459_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addTrackNumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(799);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d2156ce0", content, true, {});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"340px"},model:{value:(_vm.trackNumDialog),callback:function ($$v) {_vm.trackNumDialog=$$v},expression:"trackNumDialog"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Track Number")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.isDone,"type":"success"}},[_vm._v("\n              Added successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.isFailed,"type":"error"}},[_vm._v("\n              You cannot update track number\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Track number*","error-messages":_vm.errors.collect('Track number'),"data-vv-name":"Track number"},model:{value:(_vm.form.track_number),callback:function ($$v) {_vm.$set(_vm.form, "track_number", $$v)},expression:"form.track_number"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"7%"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addAddress_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd169aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addAddress_vue__ = __webpack_require__(804);
function injectStyle (ssrContext) {
  __webpack_require__(802)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd169aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(803);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("048f8a71", content, true, {});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"350px"},model:{value:(_vm.addressDialog),callback:function ($$v) {_vm.addressDialog=$$v},expression:"addressDialog"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Address")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"value":_vm.isDone,"type":"success"}},[_vm._v("\n              Added successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.isFailed,"type":"error"}},[_vm._v("\n              Address is required\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.governoratesList,"item-value":"governorate_id","item-text":"governorate_name","error-messages":_vm.errors.collect('Governorate'),"data-vv-name":"Governorate","label":"Governorate","clearable":""},on:{"input":_vm.onGovernorateChange},model:{value:(_vm.selectedGovernorateId),callback:function ($$v) {_vm.selectedGovernorateId=$$v},expression:"selectedGovernorateId"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.filteredCitiesList,"item-value":"city_id","item-text":"city_name","error-messages":_vm.errors.collect('City'),"data-vv-name":"City","label":"City","clearable":"","disabled":!_vm.selectedGovernorateId},model:{value:(_vm.form.city_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "city_id_fk", $$v)},expression:"form.city_id_fk"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"}],attrs:{"label":"Address*","error-messages":_vm.errors.collect('address'),"data-vv-name":"address"},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"7%"},attrs:{"id":"sendButton","type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.statusesList),function(status,index){return _c('v-flex',{key:status.value,staticClass:"mb-3 text-center",attrs:{"xs6":"","sm3":"","md3":"","lg2":"","xl1":""}},[_c('div',{staticClass:"label pointer not-selectable custom-label",class:_vm.getBgColor(index),style:(_vm.tableData.status_id === status.value ? 'border: 2px solid #000;' : ''),on:{"click":function($event){return _vm.filterByStatus(status.value)}}},[_vm._v("\n              "+_vm._s(status.text)+"\n            ")])])}),1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name : ''))]),_vm._v(" "),_c('td',[(r.order_status === 'new_order')?_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('span',{staticClass:"label bg-green-600"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' '))+"\n                ")]):_vm._e(),_vm._v(" "),(r.order_status === 'pending_answer')?_c('span',{staticClass:"label bg-grey-600"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' '))+"\n                ")]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))]):_vm._e(),_vm._v(" "),(r.order_status === 'pending_to_shipment')?_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  Warehouse Delivered")]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment' || r.order_status === 'pending_to_branch')?_c('span',{staticClass:"label bg-info-400"},[_vm._v("\n                  int shipment\n                  ")]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status))]):_vm._e(),_vm._v(" "),(r.order_status === 'ship_only')?_c('span',{staticClass:"label bg-blue-300"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' '))+"\n                  "),_c('span',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(r.track_number))])]):_vm._e()]),_vm._v(" "),_c('td',[(r.total_amount)?_c('div',[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(r.order_status !== 'ship_only')?_c('router-link',{staticStyle:{"padding-left":"0px","padding-right":"5px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"td"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(r.status_id_fk == 1)?_c('router-link',{staticStyle:{"padding-left":"0px","padding-right":"5px"},attrs:{"to":("/make-new-order?order_id=" + (r.order_id)),"tag":"td"}},[_c('a',{attrs:{"tooltip":"Edit Order"}},[_c('i',{staticClass:"fa fa-edit",staticStyle:{"font-size":"22px"}})])]):_vm._e(),_vm._v(" "),(r.order_status === 'ship_only' && !r.track_number)?_c('td',{staticStyle:{"padding-left":"5px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#44aa44"},attrs:{"tooltip":"Add track number"},on:{"click":function($event){return _vm.openAddTrackNumberDialog(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_box")])])]):_vm._e(),_vm._v(" "),(r.order_status === 'new_order' || r.order_status === 'processed_order')?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#43A047"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e(),_vm._v(" "),(r.status_id_fk > 3 && r.status_id_fk < 12)?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e(),_vm._v(" "),(['approved_order', 'purchased', 'warehouse_delivered_order'].includes(r.order_status))?_c('td',{staticClass:"px-2"},[_c('a',{staticStyle:{"color":"#555"},attrs:{"tooltip":"Create Case"},on:{"click":function($event){return _vm.openCreateOrderCaseModal(r)}}},[_c('i',{staticClass:"fa fa-folder-open",staticStyle:{"font-size":"1.6rem"}})])]):_vm._e(),_vm._v(" "),(
                  r.order_status === 'delivered' ||
                    r.order_status === 'canceled' ||
                    r.order_status === 'refunded'
                )?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"Archive This Order"},on:{"click":function($event){return _vm.archiveOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("archive")])])]):_vm._e()],1)}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+", "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity : "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),(r.order_status === 'new_order')?_c('td',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])])],1):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('td',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#43A047"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])])],1):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('td',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('td',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('td',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' ').replace('_order', ''))+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('td',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('td',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('td',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),(r.status_id_fk > 3)?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"Archive This Order"},on:{"click":function($event){return _vm.archiveOrder(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("archive")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(r.order_status === 'ship_only')?_c('td',[_c('span',{staticClass:"label bg-blue-300"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' '))+"\n                  "),_c('span',{staticStyle:{"display":"block"}},[_vm._v(_vm._s(r.track_number))])]),_vm._v(" "),_c('br'),_vm._v(" "),(r.total_amount)?_c('span',{staticClass:"mt-1 d-inline-block"},[_vm._v("$"+_vm._s(r.total_amount))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(" "+_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.order_status === 'ship_only' && !r.track_number)?_c('span',{staticStyle:{"padding-left":"5px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#44aa44"},attrs:{"tooltip":"Add track number"},on:{"click":function($event){return _vm.openAddTrackNumberDialog(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add_box")])])]):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('customer-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder}}),_vm._v(" "),_c('add-track-number',{attrs:{"orderId":_vm.orderId,"trackNumDialog":_vm.trackNumDialog},on:{"close":function($event){_vm.trackNumDialog = false},"resetTable":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('add-address',{attrs:{"addressDialog":!_vm.loggedInUserData.governorate_id_fk ||
            !_vm.loggedInUserData.city_id_fk ||
            !_vm.loggedInUserData.address ||
            _vm.loggedInUserData.address.length < 3,"customer":_vm.loggedInUserData,"governoratesList":_vm.governoratesList,"citiesList":_vm.citiesList},on:{"resetTable":function($event){return _vm.getResults()},"refetchUser":_vm.getUser}}),_vm._v(" "),_c('approve-order',{attrs:{"orderId":_vm.orderId,"approveDialog":_vm.approveDialog},on:{"close":function($event){_vm.approveDialog = false},"resetTable":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('add-edit-order-case',{attrs:{"addEditOrderCaseModal":_vm.addEditOrderCaseModal,"formData":_vm.formData,"fromCustomer":""},on:{"close":function($event){_vm.addEditOrderCaseModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("My Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myOrderCases_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221efb9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myOrderCases_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myOrderCases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_221efb9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myOrderCases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(808);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bb4ad594", content, true, {});

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}a{position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:0;bottom:110%;white-space:nowrap;z-index:20;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_case_id,class:{
                'orange lighten-2': r.status == 2,
                'red lighten-2': r.status == 3,
                'blue lighten-2': r.status == 4,
              }},[_c('td',[_vm._v(_vm._s(r.order_case_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.status_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_case_id},[_c('td',[_vm._v("\n                Case ID: "+_vm._s(r.order_case_id)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.status_name)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                Created By: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v("\n                Created At: "+_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a'))+" , "),_c('br')]),_vm._v(" "),_c('td',[_vm._v("\n                Product Name: "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v("\n                Note: "+_vm._s(r.note)+"\n              ")])])}),0)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Order Cases")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myExportOrders_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63163599_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myExportOrders_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myExportOrders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63163599_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myExportOrders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(812);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7b2ee360", content, true, {});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.pointer{cursor:pointer}.not-selectable{user-select:none}.custom-label{font-size:11px;border-radius:4px;padding:2px 10px;width:95%}", ""]);

// exports


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCancelExportOrder_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db6070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCancelExportOrder_vue__ = __webpack_require__(816);
function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCancelExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57db6070_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCancelExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(815);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9828b702", content, true, {});

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.cancelModal),callback:function ($$v) {_vm.cancelModal=$$v},expression:"cancelModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Cancel Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.showAlert}},[_vm._v("\n              Order canceled successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Cancel Note"},model:{value:(_vm.form.cancel_note),callback:function ($$v) {_vm.$set(_vm.form, "cancel_note", $$v)},expression:"form.cancel_note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"showAddExportOrderButton":true,"handleAddExportOrder":_vm.handleAddExportOrder,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.statusesList),function(status){return _c('v-flex',{key:status.value,staticClass:"mb-3 text-center",attrs:{"xs6":"","sm2":"","md2":"","lg2":"","xl1":""}},[_c('div',{staticClass:"label pointer not-selectable custom-label",class:status.color,style:((status.value === 0 && _vm.tableData.statuses.length === 0) || (status.value !== 0 && _vm.tableData.statuses.includes(status.value)) ? 'border: 2px solid #000;' : ''),on:{"click":function($event){return _vm.filterByStatus(status.value)}}},[_vm._v("\n              "+_vm._s(status.text)+"\n            ")])])}),1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.export_order_id},[_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label",class:{
                    'bg-orange-600': r.status === 1,
                    'bg-indigo-600': r.status === 2,
                    'bg-danger-600': r.status === 3,
                    'bg-green-600': r.status === 4,
                    'bg-primary-600': r.status === 5,
                    'bg-teal-600': r.status === 6,
                    'bg-purple-600': r.status === 7
                  }},[_vm._v("\n                  "+_vm._s(r.status_text)+"\n                ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('router-link',{staticStyle:{"padding-left":"0px","padding-right":"5px"},attrs:{"to":'/my-export-order-detail/' + r.export_order_id,"tag":"td"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("\n                    aspect_ratio\n                  ")])])]),_vm._v(" "),(r.status === 1 || r.status === 2)?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),(r.status === 2)?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#43A047"},attrs:{"tooltip":"Approve Order"},on:{"click":function($event){return _vm.approvingOrder(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e()],1)}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.export_order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.order_number)+", "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country_name)+" ,\n                "),_c('br'),_vm._v("\n                Quantity : "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label",class:{
                    'bg-warning-600': r.status === 1,
                    'bg-indigo-600': r.status === 2,
                    'bg-danger-600': r.status === 3,
                    'bg-green-600': r.status === 4,
                    'bg-primary-600': r.status === 5,
                    'bg-teal-600': r.status === 6,
                    'bg-purple-600': r.status === 7
                  }},[_vm._v("\n                  "+_vm._s(r.status_text)+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/my-export-order-detail?id=' + r.export_order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[(r.status === 1)?_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]):_vm._e(),_vm._v(" "),(r.status === 2)?_c('a',{staticStyle:{"color":"#43A047"},attrs:{"tooltip":"Approve Order"},on:{"click":function($event){return _vm.approvingOrder(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]):_vm._e()])],1)])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('customer-cancel-export-order',{attrs:{"cancelModal":_vm.cancelModal,"id":_vm.orderId},on:{"close":function($event){_vm.cancelModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addExportOrder_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cae0a18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addExportOrder_vue__ = __webpack_require__(821);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cae0a18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cae0a18_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("73b9637c", content, true, {});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-4cae0a18]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-4cae0a18]{overflow-x:hidden!important}", ""]);

// exports


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mx-4"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',{staticStyle:{"color":"#2E7D32"}},[_vm._v("\n        "+_vm._s(_vm.form.export_order_id ? ("Update Export Order " + (_vm.form.order_number)) : 'Request Export Order')+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"border-bottom-style":"solid","border-width":"2px","border-color":"#388E3C"}}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n      Requested successfully\n    ")]),_vm._v(" "),_c('div',{staticClass:"row mx-4"},[_c('div',{staticClass:"col-md-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Description*","error-messages":_vm.errors.collect('Product Description'),"data-vv-name":"Product Description"},model:{value:(_vm.form.product_name),callback:function ($$v) {_vm.$set(_vm.form, "product_name", $$v)},expression:"form.product_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('Quantity'),"data-vv-name":"Quantity"},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-1"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.weightUnitList,"error-messages":_vm.errors.collect('Weight Unit'),"data-vv-name":"Weight Unit","autocomplete":""},model:{value:(_vm.form.weight_unit),callback:function ($$v) {_vm.$set(_vm.form, "weight_unit", $$v)},expression:"form.weight_unit"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Length","type":"number"},model:{value:(_vm.form.volume_l),callback:function ($$v) {_vm.$set(_vm.form, "volume_l", $$v)},expression:"form.volume_l"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Width","type":"number"},model:{value:(_vm.form.volume_w),callback:function ($$v) {_vm.$set(_vm.form, "volume_w", $$v)},expression:"form.volume_w"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Height","type":"number"},model:{value:(_vm.form.volume_h),callback:function ($$v) {_vm.$set(_vm.form, "volume_h", $$v)},expression:"form.volume_h"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","name":"image","id":"image"},on:{"input":function($event){_vm.form.image = $event.target.files[0]}}}),_vm._v(" "),_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" Upload Image\n          "),_c('i',{staticClass:"pl-1"},[_vm._v(_vm._s(_vm.form.image ? _vm.form.image.name : ''))])])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"row mx-4"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name*","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.form.receiver_name),callback:function ($$v) {_vm.$set(_vm.form, "receiver_name", $$v)},expression:"form.receiver_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone*","error-messages":_vm.errors.collect('Phone'),"data-vv-name":"Phone"},model:{value:(_vm.form.receiver_phone),callback:function ($$v) {_vm.$set(_vm.form, "receiver_phone", $$v)},expression:"form.receiver_phone"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Address*","error-messages":_vm.errors.collect('Address'),"data-vv-name":"Address"},model:{value:(_vm.form.receiver_address),callback:function ($$v) {_vm.$set(_vm.form, "receiver_address", $$v)},expression:"form.receiver_address"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"City*","error-messages":_vm.errors.collect('City'),"data-vv-name":"City"},model:{value:(_vm.form.receiver_city),callback:function ($$v) {_vm.$set(_vm.form, "receiver_city", $$v)},expression:"form.receiver_city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Zip Code*","error-messages":_vm.errors.collect('Zip Code'),"data-vv-name":"Zip Code"},model:{value:(_vm.form.receiver_zip_code),callback:function ($$v) {_vm.$set(_vm.form, "receiver_zip_code", $$v)},expression:"form.receiver_zip_code"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.countryList,"item-value":"value","error-messages":_vm.errors.collect('Destination'),"data-vv-name":"Destination","label":"Destination*"},model:{value:(_vm.form.to_country_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "to_country_id_fk", $$v)},expression:"form.to_country_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Email*","type":"email"},model:{value:(_vm.form.receiver_email),callback:function ($$v) {_vm.$set(_vm.form, "receiver_email", $$v)},expression:"form.receiver_email"}})],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"col-sm-10 col-md-6 col-md-offset-3"},[_c('v-btn',{staticStyle:{"width":"100%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","loading":_vm.loading,"color":"success"}},[_vm._v("\n        "+_vm._s(_vm.form.export_order_id ? 'Update' : 'Request')+"\n      ")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_vm._v("Dimensions Per Package "),_c('span',{staticClass:"inch-div"},[_vm._v("(inch)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v("Receiver Detail")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myExportOrderDetail_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421ed3ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myExportOrderDetail_vue__ = __webpack_require__(825);
function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-421ed3ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_myExportOrderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421ed3ae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_myExportOrderDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("12d7f47c", content, true, {});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".detail-table .section-title[data-v-421ed3ae]{padding-left:0;padding-top:0;opacity:.7}.detail-table tr td[data-v-421ed3ae]{padding:3px 10px;font-size:14px}", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('v-card',{staticClass:"my-3",staticStyle:{"border-radius":"8px","border":"1px solid #ddd"},attrs:{"flat":""}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs12":""}},[_c('router-link',{staticClass:"mr-2",attrs:{"to":"/my-export-order"}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v("\n              Back\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v("Export Order Detail")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('table',{staticClass:"detail-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Order Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Order Number")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.order_number))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Customer Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.customer.full_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Customer Phone")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.customer.phone_number))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Product Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.product_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Quantity")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.quantity))])]),_vm._v(" "),(_vm.instance.weight)?_c('tr',[_c('td',[_c('b',[_vm._v("Weight")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.weight)+" "+_vm._s(_vm.instance.weight ? _vm.instance.weight_unit : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_l)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (L)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_l))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_w)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (W)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_w))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_h)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (H)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_h))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Price Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Shipping")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.shipping)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("International Tax")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.national_tax)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Delivery")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.delivery_price)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Discount")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.discount)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Price")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.price)))])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Status Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Status")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label px-2",class:{
                    'bg-orange-600': _vm.instance.status === 1,
                    'bg-indigo-600': _vm.instance.status === 2,
                    'bg-danger-600': _vm.instance.status === 3,
                    'bg-green-600': _vm.instance.status === 4,
                    'bg-primary-600': _vm.instance.status === 5,
                    'bg-teal-600': _vm.instance.status === 6,
                    'bg-purple-600': _vm.instance.status === 7
                  },staticStyle:{"border-radius":"6px","text-transform":"capitalize","font-size":"11px"}},[_vm._v("\n                    "+_vm._s(_vm.instance.status_text)+"\n                  ")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Ordered At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.created_at,"YYYY-MM-DD hh:mm a")))])]),_vm._v(" "),(_vm.instance.canceled_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Canceled At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.canceled_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.canceled_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Canceled By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.canceled_by ? _vm.instance.canceled_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.approved_at && _vm.instance.status !== 7)?_c('tr',[_c('td',[_c('b',[_vm._v("Approved At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.approved_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.approved_by && _vm.instance.status !== 7)?_c('tr',[_c('td',[_c('b',[_vm._v("Approved By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.approved_by ? _vm.instance.approved_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.status === 7 && _vm.instance.last_refund_date)?_c('tr',[_c('td',[_c('b',[_vm._v("Refunded At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.last_refund_date,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.status === 7 && _vm.instance.refunds && _vm.instance.refunds.length > 0)?_c('tr',[_c('td',[_c('b',[_vm._v("Refunded By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.refunds[0].created_by ? _vm.instance.refunds[0].created_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.is_fully_refunded)?_c('tr',[_c('td',[_c('b',[_vm._v("Refund Status")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label bg-purple-600",staticStyle:{"border-radius":"6px","font-size":"11px"}},[_vm._v("\n                    Fully Refunded\n                  ")])])]):_vm._e(),_vm._v(" "),(_vm.instance.sent_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Sent At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.sent_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.sent_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Sent By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.sent_by ? _vm.instance.sent_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.received_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Received At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.received_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.received_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Received By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.received_by ? _vm.instance.received_by.full_name : ''))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Receiver Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Phone")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_phone))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Email")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_email))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Country")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.to_country ? _vm.instance.to_country.country_name : ''))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("City")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_city))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Address")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_address))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("ZIP Code")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_zip_code))])])])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_archivedOrder_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4358171a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_archivedOrder_vue__ = __webpack_require__(829);
function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_archivedOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4358171a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_archivedOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0de011f8", content, true, {});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))])]),_vm._v(" "),_c('router-link',{staticStyle:{"padding-left":"0px","padding-right":"5px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"td"}},[_c('a',{attrs:{"tooltip":"View Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),_c('td',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initInvDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])],1)}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity : "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticStyle:{"display":"inline-block","padding-left":"0px","padding-right":"3px"},attrs:{"to":'/order-detail?id=' + r.order_id,"tag":"span"}},[_c('a',{attrs:{"tooltip":"Order Detail"}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initInvDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])],1)])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.invoiceDetailData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Archived Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789e6816_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__ = __webpack_require__(833);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_789e6816_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4d726dde", content, true, {});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.credit_log_transaction_id},[(r.is_open === '0')?_c('td',[_c('div',{staticClass:"media-left"},[_vm._v("\n                  "+_vm._s(r.theOrderID)+"\n                  "),_c('span',{staticClass:"status-mark bg-danger-600 media-badge"})])]):_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[(r.order_status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_order', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('span',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment' || r.order_status === 'pending_to_branch')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" shipment ")])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('span',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('span',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status))])]):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[(r.description.includes('Subtract'))?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")]),_vm._v("\n                $"+_vm._s(r.amount)+"\n              ")]),_vm._v(" "),(r.credit_log_transaction_date != null)?_c('td',[_vm._v("\n                "+_vm._s(r.credit_log_transaction_date)+"\n              ")]):_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.credit_log_transaction_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{staticStyle:{"height":"90px"}},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"float":"right","text-align":"right","font-size":"14px","font-weight":"bold","padding-top":"10px"}},[_vm._v("\n                Total Sub:\n                "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total_sub))]),_vm._v(" "),_c('br'),_vm._v("\n                Total Refund:  "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total_refund))]),_vm._v(" "),_c('br'),_vm._v("\n                General Total:\n                "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total))])])]),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                Invoice No. : "+_vm._s(r.invoice_number)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[(r.description.includes('Subtract'))?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")]),_vm._v("\n                $"+_vm._s(r.amount)+" "),_c('br'),_vm._v(" "),(r.credit_log_transaction_date != null)?_c('span',[_vm._v("\n                  "+_vm._s(r.credit_log_transaction_date)+"\n                ")]):_c('span',[_vm._v(" "+_vm._s(r.created_at)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showAppLog', r.credit_log_transaction_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Total Sub\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                $"+_vm._s(_vm.calculationResults.total_sub)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Total Refund\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                $"+_vm._s(_vm.calculationResults.total_refund)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                General Total\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total))])]),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Invoices")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDetail_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6b3581_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDetail_vue__ = __webpack_require__(837);
function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d6b3581"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6b3581_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1827e9b7", content, true, {});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".thumbnail[data-v-1d6b3581]{width:100px;height:100px;object-fit:cover;border-radius:4px}a.disabled[data-v-1d6b3581]{pointer-events:none;color:gray}.price-section[data-v-1d6b3581]{border-style:solid;border-width:1px;width:230px;padding-left:10px}.price-section1[data-v-1d6b3581]{border-right-style:solid;border-bottom-style:solid;border-top-style:solid;border-width:1px;width:670px;padding-left:10px}#detailTable[data-v-1d6b3581]{width:700px;margin-left:200px;margin-top:20px;margin-bottom:40px}a[data-v-1d6b3581]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-1d6b3581]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.theStepper[data-v-1d6b3581]{width:100%;overflow:visible;margin-bottom:20px}.custom-stepper[data-v-1d6b3581]{width:100%;display:block!important}.v-stepper__header[data-v-1d6b3581]{box-shadow:none}.v-stepper__step[data-v-1d6b3581]{padding:24px}.v-divider[data-v-1d6b3581]{margin:0}@media screen and (max-width:1025px){#detailTable[data-v-1d6b3581]{margin-left:0;width:100%}.price-section1[data-v-1d6b3581]{width:40%}.price-section[data-v-1d6b3581]{width:21%}.theStepper[data-v-1d6b3581]{width:100%;overflow-x:auto;overflow-y:hidden;margin-bottom:15px}.custom-stepper[data-v-1d6b3581]{min-width:800px}.v-stepper__step[data-v-1d6b3581]{padding:12px}.divider[data-v-1d6b3581]{display:block}}", ""]);

// exports


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notfound)?_c('div',[_c('img',{attrs:{"src":__webpack_require__(838),"alt":""}})]):_c('div',[_c('div',{staticStyle:{"padding":"15px","display":"flex","align-items":"center"}},[_c('v-btn',{staticStyle:{"padding":"3px","width":"90px","flex-shrink":"0"},attrs:{"flat":"","text":""},on:{"click":function($event){_vm.$router ? _vm.$router.back() : _vm.window.history.back()}}},[_c('v-icon',{attrs:{"left":"","color":"darken-2"}},[_vm._v("arrow_back")]),_vm._v("Back\n      ")],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","text-align":"center","margin":"0","flex-grow":"1"}},[_vm._v("\n        ORDER NO.  "+_vm._s(_vm.detailData.theOrderID)+"\n      ")])],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"col-12 col-xs-12 col-sm-6 col-md-3"},[_c('h5',[_vm._v("\n          Order Date: "),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm._f("moment")(_vm.detailData.created_at,'YYYY-MM-DD H:mm:ss')))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-sm-6 col-md-3"},[_c('h5',[_vm._v("\n          Confirm Date: "),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.detailData.confirm_date))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-sm-6 col-md-3"},[_c('h5',[_vm._v("\n          Warehouse Date: "),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.detailData.warehouse_date))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-sm-6 col-md-3 "},[_c('h5',[_vm._v("\n          Expected Date: "),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.detailData.from_date)+" - "+_vm._s(_vm.detailData.to_date))])])])]),_vm._v(" "),_c('div',{staticClass:"theStepper",staticStyle:{"padding-top":"5%","padding-bottom":"2%","box-shadow":"0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)"}},[_c('v-stepper',{staticClass:"elevation-0 custom-stepper",attrs:{"alt-labels":"","vertical":""},model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_c('v-stepper-header',[_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 0,"step":"0"}},[_vm._v("\n            Requested\n          "),_c('view-steps-dates',{attrs:{"date":_vm.detailData.order_date}})],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),(_vm.isCanceled && _vm.currentStep == 1)?_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"rules":[function () { return false; }],"step":"1"}},[_vm._v("\n            Canceled\n            "),_c('view-steps-dates',{attrs:{"date":_vm.detailData.cancel_date}})],1):_vm._e(),_vm._v(" "),(_vm.isCanceled && _vm.currentStep == 1)?_c('v-divider',{staticClass:"divider"}):_vm._e(),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 2,"step":"2"}},[_vm._v("\n            Processed\n            "),(_vm.detailData.process_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.process_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),(_vm.isCanceled && _vm.currentStep == 3)?_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"rules":[function () { return false; }],"step":"3"}},[_vm._v("\n            Canceled\n            "),(_vm.detailData.cancel_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.cancel_date}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isCanceled && _vm.currentStep == 3)?_c('v-divider',{staticClass:"divider"}):_vm._e(),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 4,"step":"4"}},[_vm._v("\n            Approved\n          "),(_vm.detailData.confirm_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.confirm_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),(_vm.isRefunded && _vm.currentStep == 5)?_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"rules":[function () { return false; }],"step":"5"}},[_vm._v("\n            Refunded\n            "),(_vm.detailData.refund_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.refund_date}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isRefunded)?_c('v-divider',{staticClass:"divider"}):_vm._e(),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 6,"step":"6"}},[_vm._v("\n            Purchased\n            "),(_vm.detailData.purchase_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.purchase_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 7,"step":"7"}},[_vm._v("\n            Warehouse Delivered\n            "),(_vm.detailData.warehouse_deliver_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.warehouse_deliver_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 8 || _vm.currentStep >= 9,"step":"8"}},[_vm._v("\n            Int. Shipping\n            "),(_vm.detailData.int_shipment_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.int_shipment_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep >= 10,"step":"10"}},[_vm._v("\n            Delivered to Erbil\n            "),(_vm.detailData.branch_delivery_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.branch_delivery_date}}):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"divider"}),_vm._v(" "),_c('v-stepper-step',{staticClass:"hover-steps-container",attrs:{"complete":_vm.currentStep == 11,"step":"11"}},[_vm._v("\n            Delivered\n            "),(_vm.detailData.deliver_date)?_c('view-steps-dates',{attrs:{"date":_vm.detailData.deliver_date}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"d-inline-block",staticStyle:{"margin-left":"25%"}},[_c('div',{staticClass:"d-inline mx-3",staticStyle:{"vertical-align":"bottom"}},[_c('a',{class:_vm.currentStep == 2 ? '' : 'disabled',attrs:{"tooltip":"Approve this order"},on:{"click":function($event){return _vm.approvingOrder(_vm.detailData.order_id)}}},[_c('i',{staticClass:"fa fa-check-circle",style:(_vm.currentStep == 2 ? 'color: green; font-size:36px; ' : 'color: grey; font-size:36px; ')})])]),_vm._v(" "),_c('div',{staticClass:"d-inline mx-3",staticStyle:{"vertical-align":"bottom"}},[_c('a',{class:_vm.currentStep == 0 || _vm.currentStep == 2 ? '' : 'disabled',attrs:{"tooltip":"Cancel this order"},on:{"click":function($event){_vm.cancelOrderModal = true}}},[_c('i',{staticClass:"fa fa-times-circle",style:(_vm.currentStep == 0 || _vm.currentStep == 2
            ? 'color:red; font-size:36px; '
            : 'color:grey; font-size:36px;')})])]),_vm._v(" "),(_vm.detailData.status == 'delivered' && _vm.detailData.order_delivery && _vm.detailData.order_delivery.order_delivery_id)?_c('div',{staticClass:"d-inline mx-3 white--text py-2 px-3",class:{
          'blue lighten-1': _vm.detailData.order_delivery.status == 3,
          'green lighten-1': _vm.detailData.order_delivery.status == 4,
        },staticStyle:{"border-radius":"6px","vertical-align":"super"}},[_vm._v("\n        Delivery "+_vm._s(_vm.detailData.order_delivery.status_name)+"\n      ")]):_vm._e()]),_vm._v(" "),((_vm.detailData.images && _vm.detailData.images.length > 0) || _vm.detailData.image)?_c('div',{staticClass:"row mx-0 mt-3 col-md-12",staticStyle:{"display":"flex","width":"99%","border":"1px solid #dbd8d8","margin":"10px !important","border-radius":"8px","justify-content":"center","flex-wrap":"wrap","padding":"10px"}},[(_vm.detailData.image)?_c('div',{staticStyle:{"cursor":"pointer","margin":"8px","width":"150px"},on:{"click":function($event){return _vm.showImage(_vm.detailData.image, true)}}},[_c('img',{staticStyle:{"border-radius":"4px","object-fit":"cover"},attrs:{"src":_vm.detailData.image && _vm.detailData.image.startsWith('http') ? _vm.detailData.image : ("" + (_vm.$_image_path()) + (_vm.detailData.image)),"alt":"Image","width":"100%","height":"150px"}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.detailData.images),function(img,i){return _c('div',{key:i,staticStyle:{"cursor":"pointer","margin":"8px","width":"150px"},on:{"click":function($event){return _vm.showImage(img)}}},[_c('img',{staticClass:"thumbnail",staticStyle:{"border-radius":"4px","object-fit":"cover"},attrs:{"src":img.order_image && img.order_image.startsWith('http') ? img.order_image : ("" + (_vm.$_image_path()) + (img.order_image)),"alt":"Image","width":"100%","height":"150px"}})])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"display":"flex","justify-content":"center"}},[(_vm.detailData.cancel_reason != null)?_c('div',{staticClass:"col-md-12",staticStyle:{"background":"#FEE2E2","color":"#000000FF","border":"1px solid #EF4444","border-radius":"4px","padding":"16px","margin":"20px 0","display":"flex","align-items":"center"}},[_c('v-icon',{staticStyle:{"color":"#EF4444","margin-right":"8px"},attrs:{"left":""}},[_vm._v("warning")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Order Canceled:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.detailData.cancel_reason))])])],1):_vm._e()]),_vm._v(" "),_c('table',{attrs:{"id":"detailTable"}},[(_vm.detailData.refund_reason != null)?_c('tr',[_vm._m(0),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.refund_reason))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.customer_process_note)?_c('tr',[_vm._m(1),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.customer_process_note))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.customer_process_note_image)?_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('div',{staticStyle:{"cursor":"pointer","margin":"8px","width":"150px"},on:{"click":function($event){return _vm.showImage(_vm.detailData.customer_process_note_image, true)}}},[_c('img',{staticClass:"thumbnail",staticStyle:{"border-radius":"4px","object-fit":"cover"},attrs:{"src":("" + (_vm.$_image_path()) + (_vm.detailData.customer_process_note_image)),"alt":"Image","width":"100%","height":"150px"}})])])]):_vm._e(),_vm._v(" "),_c('tr',[_vm._m(3),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.product_name))])])]),_vm._v(" "),(_vm.detailData.is_ship_only === '1')?_c('tr',[_vm._m(4),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.track_number))])])]):_vm._e(),_vm._v(" "),_c('tr',[_vm._m(5),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_c('a',{attrs:{"href":_vm.detailData.product_url,"target":"_blank"}},[_vm._v("Link")])])])]),_vm._v(" "),(_vm.detailData.coupon != null)?_c('tr',[_vm._m(6),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.coupon))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.coupon != null)?_c('tr',[_vm._m(7),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.percentage)+"%")])])]):_vm._e(),_vm._v(" "),(_vm.detailData.type != null)?_c('tr',[_vm._m(8),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.type))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.color != null)?_c('tr',[_vm._m(9),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.color))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.note != null)?_c('tr',[_vm._m(10),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.note))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.size != null)?_c('tr',[_vm._m(11),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.size))])])]):_vm._e(),_vm._v(" "),_c('tr',[_vm._m(12),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.delivery_type))])])]),_vm._v(" "),_c('tr',[_vm._m(13),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.transportation_type_obj ? _vm.detailData.transportation_type_obj.name : ''))])])]),_vm._v(" "),_c('tr',[_vm._m(14),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.is_repackage ? 'Yes' : 'No'))])])]),_vm._v(" "),_c('tr',[_vm._m(15),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.is_hold ? 'Yes' : 'No'))])])]),_vm._v(" "),_c('tr',[_vm._m(16),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.other_service))])])]),_vm._v(" "),_c('tr',[_vm._m(17),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.quantity))])])]),_vm._v(" "),(_vm.detailData.item_price != null)?_c('tr',[_vm._m(18),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.quantity_charge))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.item_price != null)?_c('tr',[_vm._m(19),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.item_price))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.tax != null)?_c('tr',[_vm._m(20),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.tax))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.national_tax != null)?_c('tr',[_vm._m(21),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.national_tax))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.item_weight != null)?_c('tr',[_vm._m(22),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s((Number(_vm.detailData.item_weight) / 0.453592).toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.item_type != null)?_c('tr',[_vm._m(23),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v(_vm._s(_vm.detailData.item_type))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.coupon == null && _vm.detailData.internal_shipping_handling != null)?_c('tr',[_vm._m(24),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.internal_shipping_handling))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.coupon != null && _vm.detailData.tmp_shipping != null)?_c('tr',[_vm._m(25),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.tmp_shipping))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.coupon != null && _vm.detailData.tmp_shipping != null)?_c('tr',[_vm._m(26),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.internal_shipping_handling))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.delivery_price != null)?_c('tr',[_vm._m(27),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.delivery_price))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.local_delivery != null)?_c('tr',[_vm._m(28),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.local_delivery))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.kreenex_fee != null)?_c('tr',[_vm._m(29),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.kreenex_fee))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.insurance != null)?_c('tr',[_vm._m(30),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.insurance))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.repackage_price)?_c('tr',[_vm._m(31),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.repackage_price))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.hold_price)?_c('tr',[_vm._m(32),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.hold_price))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.other_service_price)?_c('tr',[_vm._m(33),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.other_service_price))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.handling_fee)?_c('tr',[_vm._m(34),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.handling_fee))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.discount != null)?_c('tr',[_vm._m(35),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.discount))])])]):_vm._e(),_vm._v(" "),(_vm.detailData.total_amount != null)?_c('tr',[_vm._m(36),_vm._v(" "),_c('td',{staticClass:"price-section1"},[_c('h6',[_vm._v("$"+_vm._s(_vm.detailData.total_amount))])])]):_vm._e()])]),_vm._v(" "),_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.imageDialog),callback:function ($$v) {_vm.imageDialog=$$v},expression:"imageDialog"}},[_c('v-card',[_c('img',{attrs:{"src":_vm.theImg && _vm.theImg.startsWith('http') ? _vm.theImg : ("" + (_vm.$_image_path()) + _vm.theImg),"alt":"","width":"100%"}})])],1),_vm._v(" "),_c('customer-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder}}),_vm._v(" "),_c('approve-order',{attrs:{"orderId":_vm.theOrderId,"approveDialog":_vm.approveDialog},on:{"close":function($event){_vm.approveDialog = false},"resetTable":function($event){return _vm.getOrderDetail()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Refund reason")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Process Note")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Process Note Image")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Product Name")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Track No")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Product URL")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Coupon")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Coupon percentage")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Type")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Color")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Note")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Size")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Delivery type")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Transportation type")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Repackage")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Hold")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Other Service")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Quantity")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Quantity charge")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Item price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Tax")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("International Tax")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Item weight(LB)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Item type")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Shipping Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Shipping Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Discounted Shipping Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Delivery price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Local Delivery")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("ShipZone fee")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Insurance")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Repackage Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Hold Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Other Service Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Handling Fee")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Discount")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"price-section"},[_c('h6',[_c('b',[_vm._v("Total Price")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "not_found.jpg?56bdd0eefafa9b136c6b610c39e64cdf";

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_makeNewOrder_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97699af0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_makeNewOrder_vue__ = __webpack_require__(842);
function injectStyle (ssrContext) {
  __webpack_require__(840)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97699af0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_makeNewOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97699af0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_makeNewOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(841);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("8eb849e8", content, true, {});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading[data-v-97699af0]{color:#c26f02;border-bottom:0 solid #c26f02!important}.panel-heading h4[data-v-97699af0]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-97699af0]{overflow-x:hidden!important}", ""]);

// exports


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("\n      "+_vm._s(_vm.makeOrderData.order_id ? ("UPDATE ORDER " + (_vm.makeOrderData.theOrderID)) : 'REQUEST ORDER')+"\n    ")])]),_vm._v(" "),(false)?_c('div',{staticClass:"col-dm-12 col-md-12 cus-orange-dark",staticStyle:{"margin-top":"10px","border-top-style":"solid","border-width":"2px"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"ware"}},[_c('div',{staticClass:"col-sm-12 col-md-5 col-md-offset-1"},[_vm._m(0),_vm._v(" "),_c('h6',[_c('b',[_vm._v("Username: ")]),_vm._v(_vm._s(_vm.loggedInUserData.full_name))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.usaWarehouse.street))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.usaWarehouse.state_province))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.usaWarehouse.phone_number))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 cus-orange-dark",staticStyle:{"border-bottom-style":"solid","border-width":"2px"}}),_vm._v(" "),_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n      Order Requested successfully\n    ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.checkURL}},[_vm._v("\n      URL format not acceptable\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name*","error-messages":_vm.errors.collect('product_name'),"data-vv-name":"product_name"},model:{value:(_vm.makeOrderData.product_name),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "product_name", $$v)},expression:"makeOrderData.product_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product url*","error-messages":_vm.errors.collect('product_url'),"data-vv-name":"product_url"},model:{value:(_vm.makeOrderData.product_url),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "product_url", $$v)},expression:"makeOrderData.product_url"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('quantity'),"data-vv-name":"quantity"},model:{value:(_vm.makeOrderData.quantity),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "quantity", $$v)},expression:"makeOrderData.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.makeOrderData.warehouse_id_fk)}},model:{value:(_vm.makeOrderData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "warehouse_id_fk", $$v)},expression:"makeOrderData.warehouse_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.makeOrderData.transportation_type),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "transportation_type", $$v)},expression:"makeOrderData.transportation_type"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Type","data-vv-name":"type"},model:{value:(_vm.makeOrderData.type),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "type", $$v)},expression:"makeOrderData.type"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Size","data-vv-name":"size"},model:{value:(_vm.makeOrderData.size),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "size", $$v)},expression:"makeOrderData.size"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Color","data-vv-name":"color"},model:{value:(_vm.makeOrderData.color),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "color", $$v)},expression:"makeOrderData.color"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Note","data-vv-name":"note"},model:{value:(_vm.makeOrderData.note),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "note", $$v)},expression:"makeOrderData.note"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Coupon","data-vv-name":"coupon"},model:{value:(_vm.makeOrderData.coupon),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "coupon", $$v)},expression:"makeOrderData.coupon"}}),_vm._v(" "),(_vm.notCouponCode)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("This field must contain a Coupon Code")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"d-flex"},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Repackage","hide-details":""},model:{value:(_vm.makeOrderData.is_repackage),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "is_repackage", $$v)},expression:"makeOrderData.is_repackage"}}),_vm._v(" "),_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Hold","hide-details":""},model:{value:(_vm.makeOrderData.is_hold),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "is_hold", $$v)},expression:"makeOrderData.is_hold"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('v-text-field',{attrs:{"label":"Other service (please specify)","data-vv-name":"other_service"},model:{value:(_vm.makeOrderData.other_service),callback:function ($$v) {_vm.$set(_vm.makeOrderData, "other_service", $$v)},expression:"makeOrderData.other_service"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 d-flex align-items-center"},[(_vm.checkImageOrEdit || _vm.imagePreview)?_c('img',{staticStyle:{"width":"70px","height":"70px","object-fit":"cover","border":"1px solid #ccc","flex":"none !important"},attrs:{"src":_vm.checkImageOrEdit ? ("" + (_vm.$_image_path()) + (_vm.makeOrderData.image)) : (_vm.imagePreview || '../../assets/images/shipzone.png'),"alt":"Preview"}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","sm5":"","md10":""}},[_c('v-btn',{staticStyle:{"margin":"16px","display":"flex","align-items":"center"},attrs:{"text":"","flat":"","color":"orange"},on:{"click":_vm.triggerFileInput}},[_vm._v("\n          Upload Image\n        ")])],1),_vm._v(" "),(_vm.makeOrderData.fileName)?_c('span',{staticStyle:{"margin-left":"15px","display":"flex","align-items":"center"}},[_vm._v("\n          "+_vm._s(_vm.makeOrderData.fileName)+"\n        ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('max_file_size:2'),expression:"'max_file_size:2'"}],ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","data-vv-name":"file"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),(_vm.errors.has('file'))?_c('div',{staticStyle:{"color":"red","display":"block","margin-top":"5px"}},[_vm._v("\n          "+_vm._s(_vm.errors.first('file'))+"\n        ")]):_vm._e()],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-3 col-md-offset-6 submit-padding"},[_c('v-btn',{staticClass:"cus-custom-warning",staticStyle:{"width":"100%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","loading":_vm.loading}},[_vm._v("\n        "+_vm._s(_vm.makeOrderData.order_id ? 'Update' : 'Request')+"\n      ")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_vm._v("USA")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewShipOnly_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0cfd920_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewShipOnly_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0cfd920"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addNewShipOnly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0cfd920_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addNewShipOnly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(845);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1b881c86", content, true, {});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-b0cfd920]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-b0cfd920]{overflow-x:hidden!important}.address-card[data-v-b0cfd920]{background-color:#ffebee;border:1px solid #ffcdd2;border-radius:8px;padding:12px}.address-card-title[data-v-b0cfd920]{font-weight:700;font-size:15px;margin-bottom:8px}", ""]);

// exports


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md10":""}},[_c('h4',{staticClass:"cus-panel-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v("\n          ADD SHIP ONLY")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"5px"},attrs:{"xs6":"","sm6":"","md2":""}},[_c('v-btn',{staticClass:"cus-orange-light",staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"flat":"","outline":""},on:{"click":function($event){return _vm.showWarehouseSection()}}},[_vm._v("\n          Our Addresses\n          "),_c('i',{class:_vm.x === 1 ? 'fa fa-angle-down' : 'fa fa-angle-up',staticStyle:{"font-size":"20px","padding-left":"8px"}})])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 cus-orange-light",staticStyle:{"margin-top":"10px","border-top-style":"solid","border-width":"2px"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"ware"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.ourAddresses),function(address){return _c('v-flex',{key:address.our_address_id,staticClass:"pa-2",attrs:{"xs12":"","sm6":"","md4":""}},[_c('div',{staticClass:"address-card"},[_c('div',{staticClass:"address-card-title d-flex"},[_vm._v("\n              "+_vm._s(address.title)+"\n              "),_c('div',{staticStyle:{"text-align":"right"}},[(address.showCopyIcon)?_c('i',{staticClass:"fa fa-copy",staticStyle:{"font-size":"16px","color":"#F57C00","cursor":"pointer"},on:{"click":function($event){return _vm.copyDescription(address)}}}):_c('span',{staticStyle:{"font-weight":"normal","font-size":"14px"}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"14px"}}),_vm._v("\n                  Copied\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"address-card-description"},[_vm._v(_vm._s(address.description))])])])}),1),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"border-bottom-style":"solid","border-width":"2px","border-color":"lightgrey"}})],1)]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-text',{staticStyle:{"padding-top":"0px"}},[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n        Ordered successfully\n      ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name*","error-messages":_vm.errors.collect('Product Name'),"data-vv-name":"Product Name"},model:{value:(_vm.form.product_name),callback:function ($$v) {_vm.$set(_vm.form, "product_name", $$v)},expression:"form.product_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Product url"},model:{value:(_vm.form.product_url),callback:function ($$v) {_vm.$set(_vm.form, "product_url", $$v)},expression:"form.product_url"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Quantity","data-vv-name":"Quantity","error-messages":_vm.errors.collect('Quantity')},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.form.warehouse_id_fk)}},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.form.transportation_type),callback:function ($$v) {_vm.$set(_vm.form, "transportation_type", $$v)},expression:"form.transportation_type"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.form.item_weight),callback:function ($$v) {_vm.$set(_vm.form, "item_weight", $$v)},expression:"form.item_weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Volume"},model:{value:(_vm.form.volume),callback:function ($$v) {_vm.$set(_vm.form, "volume", $$v)},expression:"form.volume"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Track number","data-vv-name":"track_number"},on:{"input":function($event){return _vm.removeSpaces()}},model:{value:(_vm.form.track_number),callback:function ($$v) {_vm.$set(_vm.form, "track_number", $$v)},expression:"form.track_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.form.note),callback:function ($$v) {_vm.$set(_vm.form, "note", $$v)},expression:"form.note"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Repackage","hide-details":""},model:{value:(_vm.form.is_repackage),callback:function ($$v) {_vm.$set(_vm.form, "is_repackage", $$v)},expression:"form.is_repackage"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Hold","hide-details":""},model:{value:(_vm.form.is_hold),callback:function ($$v) {_vm.$set(_vm.form, "is_hold", $$v)},expression:"form.is_hold"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-text-field',{attrs:{"label":"Other service (please specify)","data-vv-name":"other_service"},model:{value:(_vm.form.other_service),callback:function ($$v) {_vm.$set(_vm.form, "other_service", $$v)},expression:"form.other_service"}})],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-3 col-md-offset-8 submit-padding"},[_c('v-btn',{staticClass:"cus-custom-warning",staticStyle:{"width":"95%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","loading":_vm.loading}},[_vm._v("Add")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newShipOnly_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5110a431_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newShipOnly_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5110a431"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_newShipOnly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5110a431_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_newShipOnly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(849);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("81cead0a", content, true, {});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-5110a431]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-5110a431]{overflow-x:hidden!important}.address-card[data-v-5110a431]{background-color:#ffebee;border:1px solid #ffcdd2;border-radius:8px;padding:12px}.address-card-title[data-v-5110a431]{font-weight:700;font-size:15px;margin-bottom:8px}.address-card-description[data-v-5110a431]{white-space:pre-line}.note-card-description[data-v-5110a431]{background-color:#f7f9fc;border:1px solid #e2e8f0;border-radius:8px;padding:12px;margin-bottom:10px;color:#334155;white-space:pre-line;box-shadow:0 1px 2px rgba(16,24,40,.06)}", ""]);

// exports


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md10":""}},[_c('h4',{staticClass:"cus-panel-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v("\n          ADD SHIP ONLY")])])],1)],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-text',{staticStyle:{"padding-top":"0px"}},[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n        Ordered successfully\n      ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.form.warehouse_id_fk)}},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},on:{"input":_vm.getOurAddresses},model:{value:(_vm.form.transportation_type),callback:function ($$v) {_vm.$set(_vm.form, "transportation_type", $$v)},expression:"form.transportation_type"}})],1),_vm._v(" "),(_vm.form.transportation_type)?_c('div',{staticClass:"col-md-12"},_vm._l((_vm.ourAddresses),function(address){return _c('v-flex',{key:address.our_address_id,staticClass:"pa-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('div',{staticClass:"note-card-description"},[_c('div',[_c('strong',[_vm._v("Note:")])]),_vm._v("\n            "+_vm._s(address.note)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"address-card"},[_c('div',{staticClass:"address-card-title d-flex"},[_vm._v("\n              "+_vm._s(address.title)+"\n              "),_c('div',{staticStyle:{"text-align":"right"}},[(address.showCopyIcon)?_c('i',{staticClass:"fa fa-copy",staticStyle:{"font-size":"16px","color":"#F57C00","cursor":"pointer"},on:{"click":function($event){return _vm.copyDescription(address)}}}):_c('span',{staticStyle:{"font-weight":"normal","font-size":"14px"}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"14px"}}),_vm._v("\n                  Copied\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"address-card-description",domProps:{"innerHTML":_vm._s(_vm.addCustomerCode(address.description))}})])])}),1):_vm._e()])])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 cus-orange-light",staticStyle:{"margin-top":"10px","border-top-style":"solid","border-width":"2px"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"ware"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chargeBalance_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a715e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chargeBalance_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-399a715e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chargeBalance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399a715e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chargeBalance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("12b1e7c7", content, true, {});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".payment-card[data-v-399a715e]{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title[data-v-399a715e]{font-size:20px;font-weight:500}.payment-currency-btn .btn__content[data-v-399a715e]{width:60px!important}.payment-methods[data-v-399a715e]{margin-bottom:20px;display:flex;align-items:center;cursor:pointer;border:1px solid #ddd;border-radius:16px;padding:16px}", ""]);

// exports


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('div',{staticClass:"payment-card"},[_c('div',{staticClass:"payment-card-title mb-4"},[_vm._v("Charge your account")]),_vm._v(" "),_c('div',{staticClass:"payment-card-body"},[_c('div',{staticClass:"mb-4",staticStyle:{"font-size":"16px"}},[_vm._v("Select payment method")]),_vm._v(" "),_c('div',{staticClass:"payment-methods",on:{"click":function($event){_vm.selected = 'fib'}}},[_c('div',{staticClass:"mr-3"},[(_vm.selected == 'fib')?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#1976d2","font-size":"18px"}}):_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff","font-size":"18px"}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100px","height":"40px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":__webpack_require__(293)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-methods",on:{"click":function($event){_vm.selected = 'fastpay'}}},[_c('div',{staticClass:"mr-3"},[(_vm.selected == 'fastpay')?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#1976d2","font-size":"18px"}}):_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff","font-size":"18px"}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100px","height":"40px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":__webpack_require__(294)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-methods",on:{"click":function($event){_vm.selected = 'qi'}}},[_c('div',{staticClass:"mr-3"},[(_vm.selected == 'qi')?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#1976d2","font-size":"18px"}}):_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff","font-size":"18px"}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100px","height":"40px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":__webpack_require__(295)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-methods",on:{"click":function($event){_vm.selected = 'zaincash'}}},[_c('div',{staticClass:"mr-3"},[(_vm.selected == 'zaincash')?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#1976d2","font-size":"18px"}}):_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#fff","font-size":"18px"}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100px","height":"40px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":__webpack_require__(296)}})])]),_vm._v(" "),_c('div',[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":"","disabled":!_vm.selected},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n              Next\n            ")])],1)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderLog_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a810d0c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderLog_vue__ = __webpack_require__(858);
function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a810d0c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(857);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5655f2c5", content, true, {});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.log_id},[(r.is_staff)?[_c('td',{staticStyle:{"padding-left":"20%"}},[_vm._v("\n                  your staff\n                  "),_c('router-link',{attrs:{"to":'/users?name=' + r.full_name}},[_c('a',{attrs:{"tooltip":"View Staff"}},[_vm._v(_vm._s(r.full_name))])]),_vm._v(" \n                  "),(r.status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" requested")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'branch_delivery')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" branch ")])]):(r.status === 'delivered' || r.status === 'archived')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" customer")])]):(r.status === 'warehouse_delivered_order')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-purple-400"},[_vm._v(" warehouse")])]):(r.status === 'int_shipment')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" shipmented ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" processed ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" canceled")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" approved ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" refunded ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" purchased ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'pending_to_branch')?_c('span',[_c('span',{staticClass:"label bg-orange-400"},[_vm._v(" pended to branch ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):_vm._e(),_vm._v("\n                    at "),(r.log_date != null)?_c('span',[_vm._v(_vm._s(r.log_date))]):_c('span',[_vm._v(_vm._s(r.created_at))])],1)]:[_c('td',{staticStyle:{"padding-left":"20%"}},[_vm._v("\n                  #"+_vm._s(r.log_id)+"   your customer\n                  "),_c('router-link',{attrs:{"to":'/regular-user?name=' + r.full_name}},[_c('a',{attrs:{"tooltip":"View customer"}},[_vm._v(_vm._s(r.full_name))])]),_vm._v(" \n                  "),(r.status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" requested")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'branch_delivery')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" branch ")])]):(r.status === 'delivered')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" customer")])]):(r.status === 'warehouse_delivered_order')?_c('span',[_vm._v("\n                    delivered the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))]),_vm._v("\n                    to "),_c('span',{staticClass:"label bg-purple-400"},[_vm._v(" warehouse")])]):(r.status === 'int_shipment')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" shipmented ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" processed ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" canceled")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" approved ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" refunded ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" purchased ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):(r.status === 'pending_to_branch')?_c('span',[_c('span',{staticClass:"label bg-orange-400"},[_vm._v(" pended to branch ")]),_vm._v(" the order\n                    "),_c('a',{attrs:{"tooltip":"View Order"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_vm._v("\n                      #"+_vm._s(r.theOrderID))])]):_vm._e(),_vm._v("\n                    at "),(r.log_date != null)?_c('span',[_vm._v(_vm._s(r.log_date))]):_c('span',[_vm._v(_vm._s(r.created_at))])],1)]],2)}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Order Log")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_secret_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4308c05f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_secret_vue__ = __webpack_require__(862);
function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4308c05f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_secret_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4308c05f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_secret_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(861);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("469315ae", content, true, {});

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#secret-div[data-v-4308c05f]{border-style:solid;border-width:1px;box-shadow:1px 1px 10px 2px;color:#ccc;border-radius:10px;padding:10px;margin-left:25%;margin-top:10%;margin-bottom:10%}", ""]);

// exports


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-6 col-md-6",attrs:{"id":"secret-div"}},[_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.checkSecret,"color":"red","icon":"warning"}},[_vm._v("\n      Secret Key is not correct\n    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.validat,"color":"red","icon":"warning"}},[_vm._v("\n      Secret Key is required\n    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.validat2,"color":"red","icon":"warning"}},[_vm._v("\n      Secret Key is required "),_c('br'),_vm._v("\n      Confirm Secret Key is required\n    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.validat3,"color":"red","icon":"warning"}},[_vm._v("\n      Confirm Secret Key is not match\n    ")]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-bottom":"4%"},attrs:{"value":_vm.validat4,"color":"red","icon":"warning"}},[_vm._v("\n      You already have secret key\n    ")]),_vm._v(" "),_c('h4',{staticStyle:{"color":"black"}},[_vm._v("Hi "+_vm._s(_vm.loggedInUserData.full_name))]),_vm._v(" "),(_vm.loggedInUserData.profile_image == null)?_c('img',{staticClass:"img-circle",staticStyle:{"height":"60px","width":"60px"},attrs:{"src":__webpack_require__(249),"alt":""}}):_c('img',{staticClass:"img-circle",staticStyle:{"height":"60px","width":"60px"},attrs:{"src":'/images/' + _vm.loggedInUserData.profile_image,"alt":""}}),_vm._v(" "),_c('span',{staticStyle:{"color":"black"}},[_vm._v(_vm._s(_vm.loggedInUserData.email))]),_vm._v(" "),_c('v-alert',{staticStyle:{"padding":"2px","margin-top":"4%"},attrs:{"value":"true","outline":"","color":"pink","icon":"info"}},[_vm._v("\n      To see this section you have to enter your Secret Key\n    ")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm1()}}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md12":""}},[_c('v-text-field',{attrs:{"color":"green","label":"Secret key","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text'},model:{value:(_vm.secretKeyData.secret_key),callback:function ($$v) {_vm.$set(_vm.secretKeyData, "secret_key", $$v)},expression:"secretKeyData.secret_key"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 text-left",staticStyle:{"padding-top":"20px"}},[_c('a',{on:{"click":function($event){return _vm.showSecondForm()}}},[_vm._v("Don't have Secret Key?")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"type":"submit ","outline":"","color":"success"}},[_vm._v("Let me in")])],1)],1),_vm._v(" "),_c('form',{staticStyle:{"display":"none"},attrs:{"id":"second-form"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm2()}}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Secret key","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text'},model:{value:(_vm.addSecretKeyData.secret_key),callback:function ($$v) {_vm.$set(_vm.addSecretKeyData, "secret_key", $$v)},expression:"addSecretKeyData.secret_key"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm10":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Confirm Secret key","append-icon":_vm.e3 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e3 = !_vm.e3); },"type":_vm.e3 ? 'password' : 'text'},model:{value:(_vm.addSecretKeyData.confirm_secret_key),callback:function ($$v) {_vm.$set(_vm.addSecretKeyData, "confirm_secret_key", $$v)},expression:"addSecretKeyData.confirm_secret_key"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12 text-right"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"type":"submit ","outline":"","color":"primary"}},[_vm._v("Create")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCreditInvoice_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2266b7b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCreditInvoice_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerCreditInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2266b7b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerCreditInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(865);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("98cd07c2", content, true, {});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"hideSelectingColumn":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.credit_invoice_id},[_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),(r.credit_invoice_date != null)?_c('td',[_vm._v(_vm._s(r.credit_invoice_date))]):_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),(r.credit_status === 'add')?_c('td',[(r.payment_method == 'fib')?[_vm._v("\n                  Adding Balance with FIB\n                ")]:(r.payment_method == 'fastpay')?[_vm._v("\n                  Adding Balance with FastPay\n                ")]:(r.payment_method == 'qi')?[_vm._v("\n                  Adding Balance with Qi\n                ")]:[_vm._v("\n                  Adding Balance from ShipZone Office\n                ")]],2):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('td',[_vm._v("\n                Returning Balance from ShipZone Office\n              ")]):_vm._e(),_vm._v(" "),(r.credit_status === 'add')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.amount))]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","padding-left":"5px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{staticStyle:{"height":"90px"}},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"float":"right","text-align":"right","font-size":"14px","font-weight":"bold","padding-top":"10px"}},[_vm._v("\n                Total Add:\n                "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total_add))]),_vm._v(" "),_c('br'),_vm._v("\n                Total CashBack:  "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total_cash_back))]),_vm._v(" "),_c('br'),_vm._v("\n                General Total:\n                "),_c('span',{staticStyle:{"padding-left":"10px"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total))])])]),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                Invoice No. : "+_vm._s(r.invoice_number)+" , "),_c('br'),_vm._v(" "),(r.credit_status === 'add')?_c('span',[_vm._v("\n                  Adding Balance from ShipZone Office\n                ")]):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('span',[_vm._v("\n                  Returning Balance from ShipZone Office\n                ")]):_vm._e()]),_vm._v(" "),_c('td',[(r.credit_status === 'add')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v(" "),(r.credit_status === 'cash back')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.credit_status))])]):_vm._e(),_vm._v("\n                  $"+_vm._s(r.amount)+" "),_c('br'),_vm._v(" "),(r.credit_invoice_date != null)?_c('span',[_vm._v(_vm._s(r.credit_invoice_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.credit_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Total Add\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                $"+_vm._s(_vm.calculationResults.total_add)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                Total CashBack\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                $"+_vm._s(_vm.calculationResults.total_cash_back)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("\n                General Total\n              ")]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"14px","font-weight":"bold"}},[_vm._v("$"+_vm._s(_vm.calculationResults.total))])]),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-action-log',{attrs:{"detailData":_vm.detailData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Invoices")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerOrderInvoices_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17e8f1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerOrderInvoices_vue__ = __webpack_require__(873);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerOrderInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17e8f1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerOrderInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(869);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6c995338", content, true, {});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d247edfe", content, true, {});

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area{max-width:850px}.dialog:not(.dialog--fullscreen){max-height:95%}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#credit-table-header,#price-section2{width:500px;padding-left:10px}#price-section2{padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"780px"},model:{value:(_vm.viewOrderInvoiceModal),callback:function ($$v) {_vm.viewOrderInvoiceModal=$$v},expression:"viewOrderInvoiceModal"}},[_c('v-card',{attrs:{"id":"print-area"}},[_c('v-card-text',[_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"head-table"}},[_c('tr',[_c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"id":"header-img","src":__webpack_require__(12),"alt":""}})]),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_name)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_address)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.company_email)+"\n                  ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                    "+_vm._s(_vm.companyData.phone_number)+"\n                  ")])])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table1"}},[_c('tr',[_c('td',{attrs:{"id":"credit-table-header"}},[_c('strong',{staticStyle:{"font-size":"20px"}},[_c('span',[_vm._v("Shipping Invoice")])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table2"}},[_c('tr',[_c('td',{attrs:{"id":"info-section1"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Invoice Number:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.invoice_number))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Invoice Date:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.created_at))])])]),_vm._v(" "),_c('td',{attrs:{"id":"info-section2"}},[_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Name:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.full_name))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Address:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.address))])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","font-weight":"bold"}},[_vm._v("\n                Customer Tel:\n                "),_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.invoiceData.customer.phone_number))])])])])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","border":"1px solid #000"}},[_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto pt-8px",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Weight: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto pt-8px"},[_vm._v(_vm._s(_vm.invoiceData.weight))])]),_vm._v(" "),(_vm.invoiceData.volume > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Volume: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v(_vm._s(_vm.invoiceData.volume))])]):_vm._e(),_vm._v(" "),(_vm.invoiceData.handling_fee > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Handling Fee: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.handling_fee))])]):_vm._e(),_vm._v(" "),(_vm.invoiceData.tax > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Tax: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.tax))])]):_vm._e(),_vm._v(" "),(_vm.invoiceData.delivery_price > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Delivery price: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.delivery_price))])]):_vm._e(),_vm._v(" "),_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Total price: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.total_price))])]),_vm._v(" "),(_vm.invoiceData.discount > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Discount: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.discount))])]):_vm._e(),_vm._v(" "),(_vm.invoiceData.discount)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Net price: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("$ "+_vm._s(_vm.invoiceData.net_price))])]):_vm._e(),_vm._v(" "),_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Orders: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._l((_vm.invoiceData.orders),function(order,index){return _c('span',{key:order.order_id},[_vm._v("\n                "+_vm._s(order.theOrderID)+"\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index < _vm.invoiceData.orders.length - 1),expression:"index < invoiceData.orders.length - 1"}],staticStyle:{"padding-right":"5px"}},[_vm._v("\n                  ,\n                ")])])}),_vm._v(" "),_vm._l((_vm.invoiceData.second_orders),function(secondorder,index){return _c('span',{key:secondorder.order_id},[_vm._v("\n                "+_vm._s(secondorder.theOrderID)+"\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index < _vm.invoiceData.second_orders.length - 1),expression:"index < invoiceData.second_orders.length - 1"}],staticStyle:{"padding-right":"5px"}},[_vm._v("\n                  ,\n                ")])])})],2)]),_vm._v(" "),_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Note: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v(_vm._s(_vm.invoiceData.note))])]),_vm._v(" "),(_vm.invoiceData.second_orders && _vm.invoiceData.second_orders.length > 0)?_c('tr',{staticStyle:{"font-size":"15px"}},[_c('td',{staticClass:"px-3-py-2 f-fm-roboto",staticStyle:{"width":"130px","font-weight":"bold"}},[_vm._v("Invoice Note: ")]),_vm._v(" "),_c('td',{staticClass:"px-3-py-2 f-fm-roboto"},[_vm._v("Secondary invoice for this order is generated")])]):_vm._e()])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"close-button","outline":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":function($event){return _vm.printInvoice()}}},[_vm._v("Print")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_invoice_id},[_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.weight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.volume))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.shipment))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.delivery_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.total_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.discount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.net_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[_c('a',{staticClass:"px-1",attrs:{"tooltip":"Invoice"},on:{"click":function($event){return _vm.viewRecord(r.order_invoice_id)}}},[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"18px","color":"#666"}})])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_invoice_id},[_c('td',[_vm._v("\n                Invoice No.: "+_vm._s(r.invoice_number)+" , "),_c('br'),_vm._v(" "),_vm._v("\n                Weight: "+_vm._s(r.weight)+" , "),_c('br'),_vm._v("\n                Volume: "+_vm._s(r.volume)+" , "),_c('br'),_vm._v("\n                Shipment: "+_vm._s(r.shipment)+" , "),_c('br'),_vm._v("\n                Tax: "+_vm._s(r.tax)+" , "),_c('br')]),_vm._v(" "),_c('td',[_vm._v("\n                Delivery Price: "+_vm._s(r.delivery_price)+" , "),_c('br'),_vm._v("\n                Total Price: "+_vm._s(r.total_price)+" , "),_c('br'),_vm._v("\n                Discount: "+_vm._s(r.discount)+" , "),_c('br'),_vm._v("\n                Net Price: "+_vm._s(r.net_price)+" , "),_c('br'),_vm._v("\n                Created At: "+_vm._s(r.created_at)+" , "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.viewRecord(r.order_invoice_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)]),_vm._v(" "),_c('view-order-invoice',{attrs:{"viewOrderInvoiceModal":_vm.viewOrderInvoiceModal,"invoiceData":_vm.invoiceData,"companyData":_vm.companyData},on:{"close":function($event){_vm.viewOrderInvoiceModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Shipping Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithFib_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5073ad08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithFib_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithFib_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5073ad08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithFib_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a1c30320", content, true, {});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".payment-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title{font-size:20px;font-weight:500}.payment-currency-btn .btn__content{width:60px!important}", ""]);

// exports


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('div',{staticClass:"payment-card"},[_c('div',{staticClass:"payment-card-title d-flex align-center"},[_vm._v("\n          Pay with\n          "),_c('div',{staticClass:"pl-2"},[_c('img',{staticStyle:{"width":"100px","height":"30px","object-fit":"contain"},attrs:{"src":__webpack_require__(293)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-card-body"},[(!_vm.fibResponse.data.paymentId)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount","type":"number","step":"0.01","min":"0.2","prepend-icon":"attach_money"},on:{"input":function($event){return _vm.calcAmount()}},model:{value:(_vm.form.amount_usd),callback:function ($$v) {_vm.$set(_vm.form, "amount_usd", $$v)},expression:"form.amount_usd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Minimum amount "),_c('b',[_vm._v("($0.2)")]),_vm._v(" or "),_c('b',[_vm._v("(IQD250)")])])])]),_vm._v(" "),(_vm.form.amount)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Amount in IQD is:")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"6px"}},[_vm._v("IQD"+_vm._s(_vm.form.amount.toLocaleString()))])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":"","type":"submit","loading":_vm.loading,"disabled":!_vm.form.amount || _vm.form.amount < 250}},[_vm._v("\n                  Next\n                ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.fibResponse.data.paymentId)?_c('v-layout',{staticClass:"mt-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"14px"}},[_vm._v("Scan this QrCode")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('img',{attrs:{"src":_vm.fibResponse.data.qrCode,"alt":""}})]),_vm._v(" "),_c('v-flex',{staticClass:"pt-4",attrs:{"xs12":""}},[_c('div',{staticClass:"pb-2",staticStyle:{"font-size":"14px"}},[_vm._v("\n                or enter this code manually\n              ")]),_vm._v(" "),_c('code',{staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(_vm.fibResponse.data.readableCode))])]),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto","padding":"4px 8px"},attrs:{"depressed":"","small":""},on:{"click":function($event){return _vm.tryAgain()}}},[_vm._v("\n                Try Again\n              ")])],1)],1):_vm._e()],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithFastPay_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d4caa7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithFastPay_vue__ = __webpack_require__(881);
function injectStyle (ssrContext) {
  __webpack_require__(879)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithFastPay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d4caa7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithFastPay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(880);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("799c58b4", content, true, {});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".payment-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title{font-size:20px;font-weight:500}.payment-currency-btn .btn__content{width:60px!important}", ""]);

// exports


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('div',{staticClass:"payment-card"},[_c('div',{staticClass:"payment-card-title d-flex align-center"},[_vm._v("\n          Pay with\n          "),_c('div',{staticClass:"pl-2"},[_c('img',{staticStyle:{"width":"100px","height":"30px","object-fit":"contain"},attrs:{"src":__webpack_require__(294)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-card-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount","prepend-icon":"attach_money"},on:{"input":function($event){return _vm.calcAmount()}},model:{value:(_vm.form.amount_usd),callback:function ($$v) {_vm.$set(_vm.form, "amount_usd", $$v)},expression:"form.amount_usd"}})],1),_vm._v(" "),(_vm.form.amount)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Amount in IQD is:")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"6px"}},[_vm._v("IQD"+_vm._s(_vm.form.amount.toLocaleString()))])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":"","disabled":!_vm.form.amount || _vm.form.amount < 250,"type":"submit","loading":_vm.loading}},[_vm._v("\n                  Next\n                ")])],1)],1)],1)])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithQi_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf9815b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithQi_vue__ = __webpack_require__(885);
function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithQi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf9815b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithQi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(884);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("19db0fea", content, true, {});

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".payment-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title{font-size:20px;font-weight:500}.payment-currency-btn .btn__content{width:60px!important}", ""]);

// exports


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('div',{staticClass:"payment-card"},[_c('div',{staticClass:"payment-card-title d-flex align-center"},[_vm._v("\n          Pay with\n          "),_c('div',{staticClass:"pl-2"},[_c('img',{staticStyle:{"width":"100px","height":"30px","object-fit":"contain"},attrs:{"src":__webpack_require__(295)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-card-body"},[(!_vm.qiResponse.data.paymentId)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount","type":"number","step":"0.01","min":"0.2","prepend-icon":"attach_money"},on:{"input":function($event){return _vm.calcAmount()}},model:{value:(_vm.form.amount_usd),callback:function ($$v) {_vm.$set(_vm.form, "amount_usd", $$v)},expression:"form.amount_usd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Minimum amount "),_c('b',[_vm._v("($0.2)")]),_vm._v(" or "),_c('b',[_vm._v("(IQD250)")])])])]),_vm._v(" "),(_vm.form.amount)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Amount in IQD is:")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"6px"}},[_vm._v("IQD"+_vm._s(_vm.form.amount.toLocaleString()))])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":"","type":"submit","loading":_vm.loading,"disabled":!_vm.form.amount || _vm.form.amount < 250}},[_vm._v("\n                  Next\n                ")])],1)],1)],1):_vm._e()])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithZainCash_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a155f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithZainCash_vue__ = __webpack_require__(889);
function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payWithZainCash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a155f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payWithZainCash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(888);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b138f40", content, true, {});

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".payment-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title{font-size:20px;font-weight:500}.payment-currency-btn .btn__content{width:60px!important}", ""]);

// exports


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('div',{staticClass:"payment-card"},[_c('div',{staticClass:"payment-card-title d-flex align-center"},[_vm._v("\n          Pay with\n          "),_c('div',{staticClass:"pl-2"},[_c('img',{staticStyle:{"width":"100px","height":"30px","object-fit":"contain"},attrs:{"src":__webpack_require__(296)}})])]),_vm._v(" "),_c('div',{staticClass:"payment-card-body"},[(!_vm.zainCashResponse.data.paymentId)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount","type":"number","step":"0.01","min":"0.2","prepend-icon":"attach_money"},on:{"input":function($event){return _vm.calcAmount()}},model:{value:(_vm.form.amount_usd),callback:function ($$v) {_vm.$set(_vm.form, "amount_usd", $$v)},expression:"form.amount_usd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Minimum amount "),_c('b',[_vm._v("($0.2)")]),_vm._v(" or "),_c('b',[_vm._v("(IQD250)")])])])]),_vm._v(" "),(_vm.form.amount)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticStyle:{"font-size":"16px"}},[_c('span',[_vm._v("Amount in IQD is:")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"6px"}},[_vm._v("IQD"+_vm._s(_vm.form.amount.toLocaleString()))])])]):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":"","type":"submit","loading":_vm.loading,"disabled":!_vm.form.amount || _vm.form.amount < 250}},[_vm._v("\n                  Next\n                ")])],1)],1)],1):_vm._e()])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkRate_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0c01cd2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkRate_vue__ = __webpack_require__(893);
function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0c01cd2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(892);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a36501e6", content, true, {});

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".btn-group .btn__content{min-width:130px!important}.tab-btn-container{display:flex;flex-direction:row;background:#eee;border-radius:8px}.import-export-btn{width:50%;text-align:center;padding:6px}.tab-btn{height:32px;display:flex;justify-content:center;align-items:center;border-radius:8px;cursor:pointer;user-select:none;transition:all .3s}.active-tab-btn,.response-div{background-color:#006b8d;color:#fff}.response-div{font-size:20px;font-weight:500;display:inline;padding:6px 8px;border-radius:4px}.inch-div{font-style:italic;font-weight:500}", ""]);

// exports


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":"","xl5":""}},[_c('v-card',{staticClass:"my-4",staticStyle:{"border":"1px solid #ddd","border-radius":"8px"},attrs:{"flat":""}},[_c('h4',{staticClass:"px-3 mb-0"},[_vm._v("Check Rate")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"tab-btn-container mb-4"},[_c('div',{staticClass:"import-export-btn"},[_c('div',{staticClass:"tab-btn",class:_vm.activeTab == 'import' ? 'active-tab-btn' : '',on:{"click":function($event){_vm.activeTab = 'import'}}},[_vm._v("\n                Import\n              ")])]),_vm._v(" "),_c('div',{staticClass:"import-export-btn"},[_c('div',{staticClass:"tab-btn",class:_vm.activeTab == 'export' ? 'active-tab-btn' : '',on:{"click":function($event){_vm.activeTab = 'export'}}},[_vm._v("\n                Export\n              ")])])]),_vm._v(" "),(_vm.activeTab == 'import')?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitImport()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.filteredCountryList,"item-value":"value","error-messages":_vm.errors.collect('Origin Country'),"data-vv-name":"Origin Country","label":"Origin Country*"},on:{"input":function($event){return _vm.importCountrySelected(_vm.importForm.from_country_id)}},model:{value:(_vm.importForm.from_country_id),callback:function ($$v) {_vm.$set(_vm.importForm, "from_country_id", $$v)},expression:"importForm.from_country_id"}})],1),_vm._v(" "),_c('div',{staticClass:"\n                  col-xs-12"},[_c('v-btn-toggle',{model:{value:(_vm.importForm.is_document),callback:function ($$v) {_vm.$set(_vm.importForm, "is_document", $$v)},expression:"importForm.is_document"}},[_c('v-btn',{staticClass:"btn-group",attrs:{"flat":"","depressed":"","value":true,"color":_vm.importForm.is_document ? 'primary' : ''}},[_vm._v("\n                    Document\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-group",attrs:{"flat":"","depressed":"","value":false,"color":_vm.importForm.is_document ? '' : 'primary'}},[_vm._v("\n                    None Document\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('Quantity'),"data-vv-name":"Quantity","type":"number"},model:{value:(_vm.importForm.quantity),callback:function ($$v) {_vm.$set(_vm.importForm, "quantity", $$v)},expression:"importForm.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('numeric|min_value:0.1'),expression:"'numeric|min_value:0.1'"}],attrs:{"label":"Weight Per Package*","error-messages":_vm.errors.collect('Weight Per Package'),"data-vv-name":"Weight Per Package"},model:{value:(_vm.importForm.weight),callback:function ($$v) {_vm.$set(_vm.importForm, "weight", $$v)},expression:"importForm.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.weightUnitList,"error-messages":_vm.errors.collect('Weight Unit'),"data-vv-name":"Weight Unit","autocomplete":"","readonly":""},model:{value:(_vm.importForm.weight_unit),callback:function ($$v) {_vm.$set(_vm.importForm, "weight_unit", $$v)},expression:"importForm.weight_unit"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._v("Dimensions Per Package "),_c('span',{staticClass:"inch-div"},[_vm._v("(inch)")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Length","type":"number"},model:{value:(_vm.importForm.size_l),callback:function ($$v) {_vm.$set(_vm.importForm, "size_l", $$v)},expression:"importForm.size_l"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Width","type":"number"},model:{value:(_vm.importForm.size_w),callback:function ($$v) {_vm.$set(_vm.importForm, "size_w", $$v)},expression:"importForm.size_w"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Height","type":"number"},model:{value:(_vm.importForm.size_h),callback:function ($$v) {_vm.$set(_vm.importForm, "size_h", $$v)},expression:"importForm.size_h"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('v-btn',{staticClass:"cus-custom-warning",staticStyle:{"height":"auto"},attrs:{"depressed":"","type":"submit"}},[_vm._v("\n                  Show Rate\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 text-right pt-2"},[(_vm.importCheckRateData)?_c('div',{staticClass:"response-div"},[_vm._v("\n                  "+_vm._s(_vm.importCheckRateData.price)+" USD\n                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.activeTab == 'export')?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitExport()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.filteredCountryList,"item-value":"value","error-messages":_vm.errors.collect('Destination Country'),"data-vv-name":"Destination Country","label":"Destination Country*"},model:{value:(_vm.exportForm.to_country_id),callback:function ($$v) {_vm.$set(_vm.exportForm, "to_country_id", $$v)},expression:"exportForm.to_country_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-btn-toggle',{model:{value:(_vm.exportForm.is_document),callback:function ($$v) {_vm.$set(_vm.exportForm, "is_document", $$v)},expression:"exportForm.is_document"}},[_c('v-btn',{staticClass:"btn-group",attrs:{"flat":"","depressed":"","value":true,"color":_vm.exportForm.is_document ? 'primary' : ''}},[_vm._v("\n                    Document\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-group",attrs:{"flat":"","depressed":"","value":false,"color":_vm.exportForm.is_document ? '' : 'primary'}},[_vm._v("\n                    None Document\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('Quantity'),"data-vv-name":"Quantity","type":"number"},model:{value:(_vm.exportForm.quantity),callback:function ($$v) {_vm.$set(_vm.exportForm, "quantity", $$v)},expression:"exportForm.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('numeric|min_value:0.1'),expression:"'numeric|min_value:0.1'"}],attrs:{"label":"Weight Per Package*","error-messages":_vm.errors.collect('Weight Per Package'),"data-vv-name":"Weight Per Package"},model:{value:(_vm.exportForm.weight),callback:function ($$v) {_vm.$set(_vm.exportForm, "weight", $$v)},expression:"exportForm.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.weightUnitList,"error-messages":_vm.errors.collect('Weight Unit'),"data-vv-name":"Weight Unit","autocomplete":""},model:{value:(_vm.exportForm.weight_unit),callback:function ($$v) {_vm.$set(_vm.exportForm, "weight_unit", $$v)},expression:"exportForm.weight_unit"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._v("Dimensions Per Package "),_c('span',{staticClass:"inch-div"},[_vm._v("(inch)")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Length","type":"number"},model:{value:(_vm.exportForm.size_l),callback:function ($$v) {_vm.$set(_vm.exportForm, "size_l", $$v)},expression:"exportForm.size_l"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Width","type":"number"},model:{value:(_vm.exportForm.size_w),callback:function ($$v) {_vm.$set(_vm.exportForm, "size_w", $$v)},expression:"exportForm.size_w"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('v-text-field',{attrs:{"label":"Height","type":"number"},model:{value:(_vm.exportForm.size_h),callback:function ($$v) {_vm.$set(_vm.exportForm, "size_h", $$v)},expression:"exportForm.size_h"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('v-btn',{staticClass:"cus-custom-warning",staticStyle:{"height":"auto"},attrs:{"depressed":"","type":"submit"}},[_vm._v("\n                  Show Rate\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 text-right pt-2"},[(_vm.exportCheckRateData)?_c('div',{staticClass:"response-div"},[_vm._v("\n                  "+_vm._s(_vm.exportCheckRateData.price)+" USD\n                ")]):_vm._e()])])]):_vm._e()])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportableOrder_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353db9b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportableOrder_vue__ = __webpack_require__(897);
function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportableOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_353db9b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportableOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(896);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("41da45e2", content, true, {});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{},"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addSelect":true,"getDependDate":_vm.getDependDate,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),(r.order_status === 'new_order')?_c('td',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('td',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('td',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('td',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('td',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('td',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('td',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('td',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('td',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_vm._e(),_vm._v(" "),(r.is_refunded == '1')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v("refunded")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label bg-grey-600 mt-1"},[_vm._v("archived")])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[(r.order_status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('span',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('span',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('span',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('archived', 'delivered')))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v("\n                Purchase date: "+_vm._s(_vm._f("moment")(r.purchase_date,'YYYY-MM-DD hh:mm A'))+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Exportable Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allOrder_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ad2a08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allOrder_vue__ = __webpack_require__(901);
function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ad2a08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(900);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("24f4234d", content, true, {});

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"addExportButton":true,"sendToExport":_vm.sendToExport,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"addSelect":true,"getDependDate":_vm.getDependDate,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),(r.order_status === 'new_order')?_c('td',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('td',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('td',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('td',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('td',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('td',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('td',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('td',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'ship_only')?_c('td',[_c('span',{staticClass:"label bg-blue-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('td',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_vm._e(),_vm._v(" "),(r.is_refunded == '1')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v("refunded")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label bg-grey-600 mt-1"},[_vm._v("archived")])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.actual_price))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                PurchaseNote: "+_vm._s(r.purchase_note)+"\n                "),_c('br'),_vm._v("\n                Actual Cost: "+_vm._s(r.actual_price)+"\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[(r.order_status === 'new_order')?_c('span',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('span',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('span',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('span',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('span',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('span',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('span',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('span',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_c('span',{staticClass:"label bg-warning-300"},[_vm._v("\n                    "+_vm._s(r.order_status.replace('archived', 'delivered')))])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v("\n                Confirm date: "+_vm._s(r.confirm_date)+" , "),_c('br'),_vm._v("\n                Purchase date: "+_vm._s(_vm._f("moment")(r.purchase_date,'YYYY-MM-DD hh:mm A'))+" , "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("All Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouseDatePassed_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf988f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouseDatePassed_vue__ = __webpack_require__(905);
function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouseDatePassed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf988f1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouseDatePassed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(904);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("52fa6d4e", content, true, {});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{},"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.warehouse_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',{staticClass:"action-td"},[_c('div',{staticClass:"action-container",staticStyle:{"display":"flex"}},[(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"padding":"0px 5px","color":"#01579b"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_warehouse_date'))?_c('a',{staticStyle:{"color":"#5579fB","padding":"0px 5px"},attrs:{"tooltip":"Add warehouse date"},on:{"click":function($event){return _vm.openAddWarehouseDateModal(r.order_id, r.warehouse_date)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")])]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))]),_vm._v(" "),_c('br'),_vm._v(" "),(r.country == 'USA')?_c('span',[_c('flag',{attrs:{"iso":"um"}})],1):(r.country == 'Turkey')?_c('span',[_c('flag',{attrs:{"iso":"tr"}})],1):(r.country == 'China')?_c('span',[_c('flag',{attrs:{"iso":"cn"}})],1):(r.country == 'German')?_c('span',[_c('flag',{attrs:{"iso":"de"}})],1):(r.country == 'UK')?_c('span',[_c('flag',{attrs:{"iso":"gb"}})],1):_vm._e(),_vm._v("\n                  "+_vm._s(r.country)+" ,\n                "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","display":"inline-block","padding-right":"3px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('add-warehouse-date',{attrs:{"addWarehouseDateModal":_vm.addWarehouseDateModal,"warehouseDateData":_vm.warehouseDateData,"closeWarehouseDateModal":_vm.closeWarehouseDateModal,"submitWarehouseDate":_vm.submitWarehouseDate}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Warehouse Passed Orders")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPrices_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e851baf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPrices_vue__ = __webpack_require__(909);
function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e851baf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e851baf_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPrices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(908);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("82828782", content, true, {});

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-2e851baf]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}", ""]);

// exports


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n      Customer Prices updated successfully\n    ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n      Please update anything\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"90%"},attrs:{"label":"Price per weight (USA)*","error-messages":_vm.errors.collect('Price per weight (USA)'),"data-vv-name":"Price per weight (USA)"},model:{value:(_vm.defaultPriceData.customer_price_per_weight_usa),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "customer_price_per_weight_usa", _vm._n($$v))},expression:"defaultPriceData.customer_price_per_weight_usa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"90%"},attrs:{"label":"Base Qtt charge (USA)*","error-messages":_vm.errors.collect('Base Qtt charge (USA)'),"data-vv-name":"Base Qtt charge (USA)"},model:{value:(_vm.defaultPriceData.customer_base_qtt_charge_usa),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "customer_base_qtt_charge_usa", _vm._n($$v))},expression:"defaultPriceData.customer_base_qtt_charge_usa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"90%"},attrs:{"label":"Other Qtt charge (USA)*","error-messages":_vm.errors.collect('Other Qtt charge (USA)'),"data-vv-name":"Other Qtt charge (USA)"},model:{value:(_vm.defaultPriceData.customer_other_qtt_charge_usa),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "customer_other_qtt_charge_usa", _vm._n($$v))},expression:"defaultPriceData.customer_other_qtt_charge_usa"}})],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-btn',{staticStyle:{"width":"95%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customer default prices")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kreenexFeePrices_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_706b7942_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kreenexFeePrices_vue__ = __webpack_require__(913);
function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-706b7942"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_kreenexFeePrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_706b7942_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_kreenexFeePrices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(912);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f0d80a4c", content, true, {});

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-706b7942]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}", ""]);

// exports


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n      ShipZone fee prices updated successfully\n    ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n      Please update anything\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:4'),expression:"'required|decimal:4'"}],staticStyle:{"width":"90%"},attrs:{"label":"ShipZone fee percentage*","error-messages":_vm.errors.collect('ShipZone fee percentage'),"data-vv-name":"ShipZone fee percentage"},model:{value:(_vm.defaultPriceData.kreenex_fee_percentage),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "kreenex_fee_percentage", _vm._n($$v))},expression:"defaultPriceData.kreenex_fee_percentage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"90%"},attrs:{"label":"ShipZone fee base (USA)*","error-messages":_vm.errors.collect('ShipZone fee base (USA)'),"data-vv-name":"ShipZone fee base (USA)"},model:{value:(_vm.defaultPriceData.kreenex_fee_base_usa),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "kreenex_fee_base_usa", _vm._n($$v))},expression:"defaultPriceData.kreenex_fee_base_usa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"90%"},attrs:{"label":"ShipZone fee (USA)*","error-messages":_vm.errors.collect('ShipZone fee (USA)'),"data-vv-name":"ShipZone fee (USA)"},model:{value:(_vm.defaultPriceData.kreenex_fee_usa),callback:function ($$v) {_vm.$set(_vm.defaultPriceData, "kreenex_fee_usa", _vm._n($$v))},expression:"defaultPriceData.kreenex_fee_usa"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('span',{staticStyle:{"color":"red","font-size":"16px"}},[_vm._v("* ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px"}},[_vm._v("\n            In "),_c('b',[_vm._v("Process Order")]),_vm._v(" if "),_c('b',[_vm._v("Item price")]),_vm._v(" less than\n            "),_c('i',{staticStyle:{"text-decoration":"underline"}},[_vm._v("ShipZone fee base (usa)")]),_vm._v(" "),_c('br'),_c('b',[_vm._v("ShipZone fee")]),_vm._v(" will be\n            "),_c('i',{staticStyle:{"text-decoration":"underline"}},[_vm._v("ShipZone fee (usa)")]),_vm._v(" , Otherwise\n            "),_c('b',[_vm._v("ShipZone fee")]),_vm._v(" will be "),_c('br'),_vm._v(" "),_c('b',[_vm._v(" ShipZone fee (usa) + (item_price * ShipZone fee percentage)")])])])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":""}},[_c('v-btn',{staticStyle:{"width":"95%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("ShipZone fee prices")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shippingPrices_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5cbc9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shippingPrices_vue__ = __webpack_require__(921);
function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shippingPrices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b5cbc9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shippingPrices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(916);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("aea1f228", content, true, {});

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addItemType_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216db592_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addItemType_vue__ = __webpack_require__(920);
function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addItemType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216db592_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addItemType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(919);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("76082eee", content, true, {});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.addItemTypeModal),callback:function ($$v) {_vm.addItemTypeModal=$$v},expression:"addItemTypeModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Item Type")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddItemTypeModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Item added successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticStyle:{"width":"70%"},attrs:{"label":"Item type*","error-messages":_vm.errors.collect('Item type'),"data-vv-name":"Item type"},model:{value:(_vm.addItemTypeData.type_name),callback:function ($$v) {_vm.$set(_vm.addItemTypeData, "type_name", $$v)},expression:"addItemTypeData.type_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"70%"},attrs:{"label":"Shipping price*","error-messages":_vm.errors.collect('Shipping price'),"data-vv-name":"Shipping price"},model:{value:(_vm.addItemTypeData.type_int_shipping_price),callback:function ($$v) {_vm.$set(_vm.addItemTypeData, "type_int_shipping_price", $$v)},expression:"addItemTypeData.type_int_shipping_price"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddItemTypeModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"primary"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n      Shipping prices updated successfully\n    ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n      Please update anything\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.itemTypes),function(item){return _c('v-flex',{key:item.itemID,staticStyle:{"padding":"0px"},attrs:{"xs12":"","sm12":"","md5":""}},[(item.text !== 'others')?_c('v-flex',{attrs:{"xs12":"","sm12":"","md11":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:4'),expression:"'required|decimal:4'"}],attrs:{"append-icon":"delete","append-icon-cb":function () { return _vm.deleteItemType(item.itemID); },"label":item.text + '*',"error-messages":_vm.errors.collect(item.text),"data-vv-name":item.text},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", _vm._n($$v))},expression:"item.value"}})],1):_vm._e(),_vm._v(" "),(item.text === 'others')?_c('v-flex',{attrs:{"xs12":"","sm12":"","md11":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:4'),expression:"'decimal:4'"}],attrs:{"append-icon":"delete","append-icon-cb":function () { return _vm.deleteItemType(item.itemID); },"label":item.text + '*',"error-messages":_vm.errors.collect(item.text),"data-vv-name":item.text},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", _vm._n($$v))},expression:"item.value"}})],1):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-btn',{staticStyle:{"width":"96%","height":"auto","margin-bottom":"3%"},attrs:{"type":"submit","color":"success"}},[_vm._v("Save")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","dm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":""}},[_c('v-btn',{staticStyle:{"width":"96%","height":"auto","margin-bottom":"3%"},attrs:{"color":"primary"},on:{"click":_vm.openAddItemTypeModal}},[_vm._v("Add type")])],1)],1)],1),_vm._v(" "),_c('add-item-type',{attrs:{"addItemTypeModal":_vm.addItemTypeModal,"closeAddItemTypeModal":_vm.closeAddItemTypeModal,"checkAlert":_vm.checkAlert,"addItemTypeData":_vm.addItemTypeData,"addItemType":_vm.addItemType}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Shipping prices (Turkey)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banks_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae85a18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banks_vue__ = __webpack_require__(933);
function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bae85a18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(924);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d5ea6302", content, true, {});

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addBank_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de87ace_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addBank_vue__ = __webpack_require__(928);
function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addBank_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7de87ace_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addBank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(927);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b9b54338", content, true, {});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent,.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}", ""]);

// exports


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"440px"},model:{value:(_vm.addBankModal),callback:function ($$v) {_vm.addBankModal=$$v},expression:"addBankModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Bank")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddBankModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Bank added successfully\n          ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Bank Name*","error-messages":_vm.errors.collect('Bank Name'),"data-vv-name":"Bank Name"},model:{value:(_vm.addBankData.bank_name),callback:function ($$v) {_vm.$set(_vm.addBankData, "bank_name", $$v)},expression:"addBankData.bank_name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddBankModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editBank_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f5b3f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editBank_vue__ = __webpack_require__(932);
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editBank_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f5b3f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editBank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("34241464", content, true, {});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent,.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}", ""]);

// exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"440px"},model:{value:(_vm.editBankModal),callback:function ($$v) {_vm.editBankModal=$$v},expression:"editBankModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update Bank")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditBankModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Bank updated successfully\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n            Please update anything\n          ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Bank Name*","error-messages":_vm.errors.collect('Bank Name'),"data-vv-name":"Bank Name"},model:{value:(_vm.editBankData.bank_name),callback:function ($$v) {_vm.$set(_vm.editBankData, "bank_name", $$v)},expression:"editBankData.bank_name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditBankModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Update")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_bank: 'add_bank'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addBankButton":true,"openAddBankModal":_vm.openAddBankModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.bank_id},[_c('td',[_vm._v(_vm._s(r.bank_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_bank'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditBankModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_bank'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteBank(r.bank_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                No Results Found\n              ")])],1)])],2)]),_vm._v(" "),_c('add-bank',{attrs:{"addBankModal":_vm.addBankModal,"closeAddBankModal":_vm.closeAddBankModal,"addBankData":_vm.addBankData,"addBank":_vm.addBank,"checkAlert":_vm.checkAlert}}),_vm._v(" "),_c('edit-bank',{attrs:{"editBankModal":_vm.editBankModal,"closeEditBankModal":_vm.closeEditBankModal,"editBankData":_vm.editBankData,"editBank":_vm.editBank,"checkAlert":_vm.checkAlert,"errorAlert":_vm.errorAlert}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Banks")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exchangeRate_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06e364e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exchangeRate_vue__ = __webpack_require__(945);
function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exchangeRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b06e364e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exchangeRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("01c6ce88", content, true, {});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addExchangeRate_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b081c57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addExchangeRate_vue__ = __webpack_require__(940);
function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addExchangeRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b081c57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addExchangeRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(939);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dc0cbbc6", content, true, {});

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.openExchangeModal),callback:function ($$v) {_vm.openExchangeModal=$$v},expression:"openExchangeModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Exchange Rate")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddExchangeRateModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n              Exchange rate added successfully\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|integer'),expression:"'required|integer'"}],staticStyle:{"width":"70%"},attrs:{"label":"USD price*","error-messages":_vm.errors.collect('USD price'),"data-vv-name":"USD price"},model:{value:(_vm.addExchangeRateData.usd_price),callback:function ($$v) {_vm.$set(_vm.addExchangeRateData, "usd_price", $$v)},expression:"addExchangeRateData.usd_price"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"70%"},attrs:{"label":"TL price*","error-messages":_vm.errors.collect('TL price'),"data-vv-name":"TL price"},model:{value:(_vm.addExchangeRateData.tl_price),callback:function ($$v) {_vm.$set(_vm.addExchangeRateData, "tl_price", $$v)},expression:"addExchangeRateData.tl_price"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddExchangeRateModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Add")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editExchangeRate_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5d7b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editExchangeRate_vue__ = __webpack_require__(944);
function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editExchangeRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5d7b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editExchangeRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6b77446f", content, true, {});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit-new-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.openEditExchangeModal),callback:function ($$v) {_vm.openEditExchangeModal=$$v},expression:"openEditExchangeModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update Exchange Rate")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeEditExchangeRateModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.successAlert}},[_vm._v("\n              Exchange rate updated successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"success","value":_vm.errorAlert}},[_vm._v("\n              Please update anything\n            ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|integer'),expression:"'required|integer'"}],staticStyle:{"width":"70%"},attrs:{"label":"USD price*","error-messages":_vm.errors.collect('USD price'),"data-vv-name":"USD price"},model:{value:(_vm.editExchangeRateData.usd_price),callback:function ($$v) {_vm.$set(_vm.editExchangeRateData, "usd_price", $$v)},expression:"editExchangeRateData.usd_price"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm7":"","md7":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal:2'),expression:"'required|decimal:2'"}],staticStyle:{"width":"70%"},attrs:{"label":"TL price*","error-messages":_vm.errors.collect('TL price'),"data-vv-name":"TL price"},model:{value:(_vm.editExchangeRateData.tl_price),callback:function ($$v) {_vm.$set(_vm.editExchangeRateData, "tl_price", $$v)},expression:"editExchangeRateData.tl_price"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeEditExchangeRateModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_exchange_rate: 'add_exchange_rate'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExchangeRateButton":true,"openAddExchangeRateModal":_vm.openAddExchangeRateModal,"addExportButton":true,"sendToExport":_vm.sendToExport,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.exchange_rate_id},[_c('td',[_vm._v(_vm._s(r.exchange_rate_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.staff_name))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.usd_price))]),_vm._v(" "),_c('td',[_vm._v("TL"+_vm._s(r.tl_price))]),_vm._v(" "),_c('td',[(r.active === '1')?_c('span',{staticStyle:{"padding":"5px","text-transform":"uppercase"}},[_c('a',{staticClass:"disabled",staticStyle:{"color":"#27ae60"}},[_c('i',{staticClass:"fa fa-toggle-on",staticStyle:{"font-size":"20px"}})])]):(_vm.$_has_perm('add_exchange_rate'))?_c('span',{staticStyle:{"padding":"5px","text-transform":"uppercase"}},[_c('a',{staticStyle:{"color":"#757575"},attrs:{"tooltip":"Active"},on:{"click":function($event){return _vm.activeExchangeRate(r.exchange_rate_id)}}},[_c('i',{staticClass:"fa fa-toggle-off",staticStyle:{"font-size":"20px"}})])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.exchange_date))]),_vm._v(" "),(_vm.$_has_perm('edit_exchange_rate'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#3867d6"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditExchangeRateModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_exchange_rate'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('a',{staticStyle:{"color":"#db3958"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteExchangeRate(r.exchange_rate_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isExchange":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.exchange_rate_id},[_c('td',[_vm._v("\n                ID: "+_vm._s(r.exchange_rate_id)+" "),_c('br'),_vm._v("\n                Staff: "+_vm._s(r.staff_name)+"  \n                "),_c('br'),_vm._v(" "),(r.active === '1')?_c('span',{staticStyle:{"padding":"5px","text-transform":"uppercase"}},[_c('a',{staticClass:"disabled",staticStyle:{"color":"#27ae60"}},[_c('i',{staticClass:"fa fa-toggle-on",staticStyle:{"font-size":"20px"}})])]):(_vm.$_has_perm('add_exchange_rate'))?_c('span',{staticStyle:{"padding":"5px","text-transform":"uppercase"}},[_c('a',{staticStyle:{"color":"#757575"},attrs:{"tooltip":"Active"},on:{"click":function($event){return _vm.activeExchangeRate(r.exchange_rate_id)}}},[_c('i',{staticClass:"fa fa-toggle-off",staticStyle:{"font-size":"20px"}})])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                $"+_vm._s(r.usd_price)+" -> tl "+_vm._s(r.tl_price)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.exchange_date)+" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('edit_exchange_rate'))?_c('a',{staticStyle:{"color":"#3867d6","display":"inline-block","padding-left":"0px","padding-right":"0px"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditExchangeRateModal(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_exchange_rate'))?_c('a',{staticStyle:{"color":"#db3958","padding-left":"0px","padding-right":"15px","float":"left"},attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteExchangeRate(r.exchange_rate_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-exchange-rate',{attrs:{"openExchangeModal":_vm.openExchangeModal,"closeAddExchangeRateModal":_vm.closeAddExchangeRateModal,"successAlert":_vm.successAlert,"addExchangeRateData":_vm.addExchangeRateData,"exchangeRate":_vm.exchangeRate}}),_vm._v(" "),_c('edit-exchange-rate',{attrs:{"openEditExchangeModal":_vm.openEditExchangeModal,"closeEditExchangeRateModal":_vm.closeEditExchangeRateModal,"successAlert":_vm.successAlert,"errorAlert":_vm.errorAlert,"editExchangeRateData":_vm.editExchangeRateData,"editExchangeRate":_vm.editExchangeRate}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Exchange Rates")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deliveredReport_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe1bba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deliveredReport_vue__ = __webpack_require__(949);
function injectStyle (ssrContext) {
  __webpack_require__(947)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deliveredReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fe1bba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deliveredReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(948);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d6f9f968", content, true, {});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.card-container{padding:16px}.shipping{background-color:#e57373}.fee,.shipping{padding:10px 16px;border-radius:4px}.fee{background-color:#64b5f6}.card-title{font-size:18px;font-weight:700}.card-content,.card-title{text-align:center;display:block;width:100%}.card-content{margin-top:20px;font-size:16px}", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3"},[_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"4%","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime,"option":_vm.option}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3"},[_c('date-picker',{staticClass:"form-control",staticStyle:{"margin-top":"4%","border-bottom-color":"#919191"},attrs:{"date":_vm.startTime1,"option":_vm.option1}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3"},[_c('v-btn',{staticStyle:{"height":"auto","padding-left":"0px","padding-right":"0px"},attrs:{"depressed":""},on:{"click":function($event){return _vm.getData()}}},[_vm._v("  Apply")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 card-container"},[_c('div',{staticClass:"shipping"},[_c('div',{staticClass:"card-title"},[_vm._v("Total Shipping")]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._v("$"+_vm._s(_vm.apiResult.shipping_sum))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 card-container"},[_c('div',{staticClass:"fee"},[_c('div',{staticClass:"card-title"},[_vm._v("Total Shipzone Fee")]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._v("$"+_vm._s(_vm.apiResult.shipzone_fee))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Delivered Report")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loanedCustomers_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7cbb54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loanedCustomers_vue__ = __webpack_require__(953);
function injectStyle (ssrContext) {
  __webpack_require__(951)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loanedCustomers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7cbb54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loanedCustomers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fb91f514", content, true, {});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.custom-loader{animation:loader 1s infinite;display:flex}@-moz-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-webkit-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-o-keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loader{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExportButton":true,"sendToExport":_vm.sendToExport,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(_vm.selectedUserIds.length || _vm.selectingAll)?_c('div',{staticClass:"row text-center"},[_c('h5',{staticClass:"ma-0",staticStyle:{"font-weight":"bold"}},[(_vm.selectingAll)?_c('span',[_vm._v("Selecting all customers...")]):_c('span',[_vm._v("\n              Selected customers: "+_vm._s(_vm.selectedUserIds.length)+" of "+_vm._s(_vm.totalFiltered)+"   |   Sum of selected credit: $"+_vm._s(_vm.sumOfSelectedCredit.toFixed(2))+"\n            ")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"primary","loading":_vm.exportingSelected,"disabled":_vm.selectingAll},on:{"click":function($event){return _vm.exportSelected()}}},[_vm._v("Export selected")]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){return _vm.unCheckAll()}}},[_vm._v("Clear selection")])],1)]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.user_id,style:(_vm.selectedUserIds.includes(Number(r.user_id)) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedUserIds),expression:"selectedUserIds"}],attrs:{"type":"checkbox"},domProps:{"value":Number(r.user_id),"checked":Array.isArray(_vm.selectedUserIds)?_vm._i(_vm.selectedUserIds,Number(r.user_id))>-1:(_vm.selectedUserIds)},on:{"change":function($event){var $$a=_vm.selectedUserIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=Number(r.user_id),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedUserIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedUserIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedUserIds=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),(r.is_blocked === '0')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v("Unblock")])]):_c('td',[_c('span',{staticClass:"label bg-warning"},[_vm._v("Block")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.address))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(r.credit))]),_vm._v(" "),(_vm.$_has_perm('view_customer_transaction'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#555"},attrs:{"tooltip":"Customer transaction"},on:{"click":function($event){return _vm.customerTransaction(r.user_id, r.full_name)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("swap_horiz")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',{staticStyle:{"width":"100%","padding-top":"5px"}},[_c('span',{staticStyle:{"float":"right","font-weight":"bold","padding-right":"30px"}},[_vm._v("Total income   $"+_vm._s(_vm.totalCredit))])])])]),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isCustomer":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.email)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.phone_number)+", "),_c('br'),_vm._v("\n                "+_vm._s(r.address)+"\n              ")]),_vm._v(" "),_c('td',[(r.is_blocked === '0')?_c('span',[_c('span',{staticClass:"label bg-green-600"},[_vm._v("Unblock")])]):_c('span',[_c('span',{staticClass:"label bg-warning"},[_vm._v("Block")])]),_vm._v("\n                $"+_vm._s(r.credit)+" "),_c('br')])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('customer-transactions',{attrs:{"tranDialog":_vm.tranDialog,"customerId":_vm.customerId,"customerName":_vm.customerName},on:{"close-dialog":function($event){_vm.tranDialog = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shipOnly_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad38ac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shipOnly_vue__ = __webpack_require__(961);
function injectStyle (ssrContext) {
  __webpack_require__(955)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shipOnly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ad38ac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shipOnly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57586c3f", content, true, {});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}", ""]);

// exports


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addShipOnly_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2ac270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addShipOnly_vue__ = __webpack_require__(960);
function injectStyle (ssrContext) {
  __webpack_require__(958)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addShipOnly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2ac270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addShipOnly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1f277ec8", content, true, {});

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.addShipOnlyModal),callback:function ($$v) {_vm.addShipOnlyModal=$$v},expression:"addShipOnlyModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update shiponly' : 'New shiponly')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Ordered successfully')+"\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[(_vm.loggedInUserData.is_staff)?_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('customer_id_fk'),"data-vv-name":"customer_id_fk","label":"Customer*","single-line":""},model:{value:(_vm.form.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "customer_id_fk", $$v)},expression:"form.customer_id_fk"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name*","error-messages":_vm.errors.collect('product_name'),"data-vv-name":"product_name"},model:{value:(_vm.form.product_name),callback:function ($$v) {_vm.$set(_vm.form, "product_name", $$v)},expression:"form.product_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Product url"},model:{value:(_vm.form.product_url),callback:function ($$v) {_vm.$set(_vm.form, "product_url", $$v)},expression:"form.product_url"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Quantity"},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.form.warehouse_id_fk)}},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.form.transportation_type),callback:function ($$v) {_vm.$set(_vm.form, "transportation_type", $$v)},expression:"form.transportation_type"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.form.item_weight),callback:function ($$v) {_vm.$set(_vm.form, "item_weight", $$v)},expression:"form.item_weight"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Volume"},model:{value:(_vm.form.volume),callback:function ($$v) {_vm.$set(_vm.form, "volume", $$v)},expression:"form.volume"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Track number","data-vv-name":"track_number"},on:{"input":function($event){return _vm.removeSpaces()}},model:{value:(_vm.form.track_number),callback:function ($$v) {_vm.$set(_vm.form, "track_number", $$v)},expression:"form.track_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Shipping","error-messages":_vm.errors.collect('Shipping'),"data-vv-name":"Shipping"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.internal_shipping_handling),callback:function ($$v) {_vm.$set(_vm.form, "internal_shipping_handling", _vm._n($$v))},expression:"form.internal_shipping_handling"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Tax","error-messages":_vm.errors.collect('Tax'),"data-vv-name":"Tax"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.tax),callback:function ($$v) {_vm.$set(_vm.form, "tax", _vm._n($$v))},expression:"form.tax"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 mb-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191"},attrs:{"date":_vm.startTime,"option":_vm.option}}),_vm._v(" "),(_vm.fromDateError)?_c('span',{staticStyle:{"color":"orangered"}},[_c('br'),_vm._v("From date must be greater than Today")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 mb-2",attrs:{"xs12":"","sm12":"","md6":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191"},attrs:{"date":_vm.startTime1,"option":_vm.option1}}),_vm._v(" "),(_vm.toDateError)?_c('span',{staticStyle:{"color":"orangered"}},[_c('br'),_vm._v("To date must be greater than From date")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note"},model:{value:(_vm.form.note),callback:function ($$v) {_vm.$set(_vm.form, "note", $$v)},expression:"form.note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm3":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Repackage","hide-details":""},on:{"change":function($event){return _vm.repackageChanged()}},model:{value:(_vm.form.is_repackage),callback:function ($$v) {_vm.$set(_vm.form, "is_repackage", $$v)},expression:"form.is_repackage"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm2":""}},[_c('v-checkbox',{staticClass:"ma-0 pa-0 mt-4",attrs:{"label":"Hold","hide-details":""},on:{"change":function($event){return _vm.holdChanged()}},model:{value:(_vm.form.is_hold),callback:function ($$v) {_vm.$set(_vm.form, "is_hold", $$v)},expression:"form.is_hold"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md7":""}},[_c('v-text-field',{attrs:{"label":"Other service (please specify)","data-vv-name":"other_service"},on:{"input":function($event){return _vm.otherServiceChanged()}},model:{value:(_vm.form.other_service),callback:function ($$v) {_vm.$set(_vm.form, "other_service", $$v)},expression:"form.other_service"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Repackage Price","disabled":!_vm.form.is_repackage,"error-messages":_vm.errors.collect('Repackage Price'),"data-vv-name":"Repackage Price"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.repackage_price),callback:function ($$v) {_vm.$set(_vm.form, "repackage_price", _vm._n($$v))},expression:"form.repackage_price"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Hold Price","disabled":!_vm.form.is_hold,"error-messages":_vm.errors.collect('Hold Price'),"data-vv-name":"Hold Price"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.hold_price),callback:function ($$v) {_vm.$set(_vm.form, "hold_price", _vm._n($$v))},expression:"form.hold_price"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('decimal:2'),expression:"'decimal:2'"}],attrs:{"label":"Other Service Price","disabled":!_vm.form.other_service || !_vm.form.other_service.length,"error-messages":_vm.errors.collect('Other Service Price'),"data-vv-name":"Other Service Price"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.other_service_price),callback:function ($$v) {_vm.$set(_vm.form, "other_service_price", _vm._n($$v))},expression:"form.other_service_price"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":"","lg6":""}},[_c('v-text-field',{attrs:{"label":"Handling Fee","data-vv-name":"handling_fee"},on:{"input":function($event){return _vm.calculateTotalAmount()}},model:{value:(_vm.form.handling_fee),callback:function ($$v) {_vm.$set(_vm.form, "handling_fee", $$v)},expression:"form.handling_fee"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addNewOrderButton":true,"permissions":{
          add_permission: 'add_ship_only',
          approve_all_permission: 'approve_ship_only',
          approve_all_shiponly: 'approve_all_shiponly'
        },"openAddNewOrderModal":_vm.openAddNewOrderModal,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"checkAlert":_vm.checkAlert,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"showApproveAllShiponly":_vm.showApproveAllShiponly,"loadApproveAllShiponly":_vm.loadApproveAllShiponly,"approvingMultipleOrder":_vm.approvingMultipleOrder},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,style:(_vm.qrCodeValues.find(function (x) { return x == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.order_id],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[r.order_id])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-users',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v("\n                  "+_vm._s(r.product_url ?  r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) + (r.product_url.length > 10 ? '...' : '') : r.product_url)+"\n                ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.track_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_ship_only'))?_c('td',{staticStyle:{"padding-left":"10px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#424242"},attrs:{"tooltip":"Edit This Order"},on:{"click":function($event){return _vm.editOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_ship_only'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e(),_vm._v(" "),(r.track_number && r.from_date && _vm.$_has_perm('approve_ship_only'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"10px"}},[_c('a',{staticStyle:{"color":"#43a047"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_id},[_c('td',[_vm._v("\n                "+_vm._s(r.theOrderID)+" , "),_c('br'),_vm._v("\n                "+_vm._s(r.product_name)+" , "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url ? r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '') : r.product_url))]),_vm._v(" "),_c('br'),_vm._v("\n                Quantity: "+_vm._s(r.quantity)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Customer ID: "+_vm._s(r.user_id)+" , "),_c('br'),_vm._v("\n                Name: "+_vm._s(r.full_name)+" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}}),_vm._v(" , "),_c('br'),_vm._v(" "),(r.order_date != null)?_c('span',[_vm._v(_vm._s(r.order_date))]):_c('span',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579B","display":"inline-block","padding-left":"5px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_ship_only'))?_c('a',{staticStyle:{"color":"#4347a0","padding-left":"15px"},attrs:{"tooltip":"Edit This Order"},on:{"click":function($event){return _vm.editOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings")])]):_vm._e(),_vm._v(" "),(r.track_number && r.from_date && _vm.$_has_perm('approve_ship_only'))?_c('a',{staticStyle:{"color":"#43a047","padding-left":"15px"},attrs:{"tooltip":"Approve This Order"},on:{"click":function($event){return _vm.approvingOrder(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_ship_only'))?_c('a',{staticStyle:{"color":"#C62828","float":"left","padding-left":"3px"},attrs:{"tooltip":"Cancel This Order"},on:{"click":function($event){return _vm.openCancelingOrderModal(r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])]):_vm._e()],1)])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-ship-only',{attrs:{"addShipOnlyModal":_vm.addShipOnlyModal,"warehouses":_vm.warehouses,"customers":_vm.customers,"isUpdate":_vm.isUpdate,"formData":_vm.formData},on:{"close":function($event){_vm.addShipOnlyModal = false},"resetTable":_vm.handleResetTable}}),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('view-log-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('v-dialog',{attrs:{"overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.approvingDialog),callback:function ($$v) {_vm.approvingDialog=$$v},expression:"approvingDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"pb-2 pt-3",attrs:{"primary-title":""}},[_c('h3',{staticClass:"my-0"},[_vm._v("Are you sure?")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mx-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Customer: "+_vm._s(_vm.orderData.full_name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Balance: $"+_vm._s(_vm.orderData.credit))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h6',[_vm._v("Order price: $"+_vm._s(_vm.orderData.total_amount))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{model:{value:(_vm.approveValue),callback:function ($$v) {_vm.approveValue=$$v},expression:"approveValue"}},[_c('v-radio',{attrs:{"label":"Will pay","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Loan","value":"2","disabled":_vm.orderData.credit >= _vm.orderData.total_amount && _vm.orderData.total_amount !== 0}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.approveValue === '1'),expression:"approveValue === '1'"}],attrs:{"xs12":""}},[_c('a',{staticStyle:{"font-size":"14px","text-decoration":"underline"},attrs:{"href":"/secret?component=credit","target":"blank"}},[_vm._v("\n                    Go to customer credit\n                  ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.approvingDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"1.5%"},attrs:{"disabled":!_vm.orderData.total_amount && _vm.orderData.total_amount !== 0,"outline":"","color":"success","loading":_vm.loadSingleApprove},on:{"click":_vm.approveOrder}},[_vm._v("ok")])],1)],1)],1),_vm._v(" "),_c('admin-cancel-order',{attrs:{"closeCancelingOrderModal":_vm.closeCancelingOrderModal,"cancelOrderModal":_vm.cancelOrderModal,"cancelAlert":_vm.cancelAlert,"cancelData":_vm.cancelData,"cancelingOrder":_vm.cancelingOrder,"reasons":_vm.reasons},on:{"reset-form":_vm.resetCancelData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Ship Only")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f53df08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_vue__ = __webpack_require__(969);
function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_suppliers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f53df08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_suppliers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a45dbda", content, true, {});

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSupplier_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16310e2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSupplier_vue__ = __webpack_require__(968);
function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSupplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16310e2b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSupplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4505906c", content, true, {});

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditSupplierModal),callback:function ($$v) {_vm.addEditSupplierModal=$$v},expression:"addEditSupplierModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Supplier' : 'Add New Supplier')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Added successfully')+"\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name *","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Phone"},model:{value:(_vm.formData.phone),callback:function ($$v) {_vm.$set(_vm.formData, "phone", $$v)},expression:"formData.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.formData.address),callback:function ($$v) {_vm.$set(_vm.formData, "address", $$v)},expression:"formData.address"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_supplier: 'add_supplier'
        },"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addSupplierButton":true,"openAddSupplierModal":_vm.openAddSupplierModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.supplier_id},[_c('td',[_vm._v(_vm._s(r.supplier_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_supplier'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditSupplierModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_supplier'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteSupplier(r.supplier_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-supplier',{attrs:{"addEditSupplierModal":_vm.addEditSupplierModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditSupplierModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Suppliers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenseTypes_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9196400_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenseTypes_vue__ = __webpack_require__(977);
function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenseTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9196400_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenseTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("11ce5fe8", content, true, {});

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditExpenseType_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185ea20c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditExpenseType_vue__ = __webpack_require__(976);
function injectStyle (ssrContext) {
  __webpack_require__(974)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditExpenseType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_185ea20c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditExpenseType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(975);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("400ad595", content, true, {});

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditExpenseTypeModal),callback:function ($$v) {_vm.addEditExpenseTypeModal=$$v},expression:"addEditExpenseTypeModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update ExpenseType' : 'Add New ExpenseType')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Added successfully')+"\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name *","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_expense_type: 'add_expense_type'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExpenseTypeButton":true,"openAddExpenseTypeModal":_vm.openAddExpenseTypeModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.expense_type_id},[_c('td',[_vm._v(_vm._s(r.expense_type_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_expense_type'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditExpenseTypeModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_expense_type'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteExpenseType(r.expense_type_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-expense-type',{attrs:{"addEditExpenseTypeModal":_vm.addEditExpenseTypeModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditExpenseTypeModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Expense Types")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bc7caf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__ = __webpack_require__(985);
function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76bc7caf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(980);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0cd6bd8d", content, true, {});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2443f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__ = __webpack_require__(984);
function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab2443f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5f5a6984", content, true, {});

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addEditExpenseModal),callback:function ($$v) {_vm.addEditExpenseModal=$$v},expression:"addEditExpenseModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Expense' : 'Add New Expense')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Added successfully')+"\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.expenseTypesList,"error-messages":_vm.errors.collect('Expense Type'),"data-vv-name":"Expense Type","label":"Expense Type *"},model:{value:(_vm.formData.expense_type_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "expense_type_id_fk", $$v)},expression:"formData.expense_type_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.suppliersList,"error-messages":_vm.errors.collect('Supplier'),"data-vv-name":"Supplier","label":"Supplier *"},model:{value:(_vm.formData.supplier_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "supplier_id_fk", $$v)},expression:"formData.supplier_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.banksList,"error-messages":_vm.errors.collect('Bank'),"data-vv-name":"Bank","label":"Bank *"},model:{value:(_vm.formData.bank_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "bank_id_fk", $$v)},expression:"formData.bank_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{attrs:{"label":"Supplier Invoice Number","error-messages":_vm.errors.collect('Supplier Invoice Number'),"data-vv-name":"Supplier Invoice Number"},model:{value:(_vm.formData.supplier_invoice_number),callback:function ($$v) {_vm.$set(_vm.formData, "supplier_invoice_number", $$v)},expression:"formData.supplier_invoice_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount *","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount"},model:{value:(_vm.formData.amount),callback:function ($$v) {_vm.$set(_vm.formData, "amount", $$v)},expression:"formData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.expenseStatusList,"error-messages":_vm.errors.collect('Status'),"data-vv-name":"Status","label":"Status *"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('label',{staticClass:"d-block mb-1"},[_vm._v("Expense Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.expense_date),expression:"formData.expense_date"}],staticClass:"base-date-picker",attrs:{"type":"date"},domProps:{"value":(_vm.formData.expense_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "expense_date", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{attrs:{"label":"Note","error-messages":_vm.errors.collect('Note'),"data-vv-name":"Note"},model:{value:(_vm.formData.note),callback:function ($$v) {_vm.$set(_vm.formData, "note", $$v)},expression:"formData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_expense: 'add_expense'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addExpenseButton":true,"openAddExpenseModal":_vm.openAddExpenseModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 pt-0"},[_c('v-layout',{staticStyle:{"margin":"0px"},attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md5":""}},[_c('v-select',{staticStyle:{"width":"100%"},attrs:{"autocomplete":"","items":_vm.suppliersList,"label":"Supplier","single-line":"","clearable":""},on:{"input":function($event){return _vm.getResults()}},model:{value:(_vm.tableData.supplier_id),callback:function ($$v) {_vm.$set(_vm.tableData, "supplier_id", $$v)},expression:"tableData.supplier_id"}})],1)],1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.expense_id},[_c('td',[_vm._v(_vm._s(r.expense_type_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.supplier_invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.supplier_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.expense_date))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('delete_expense'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteExpense(r.expense_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('table',{staticClass:"table"},_vm._l((_vm.footer),function(f,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"padding":"3px","font-weight":"bold"}},[_vm._v("\n              "+_vm._s(f.status)+":   "+_vm._s(_vm._f("usdFormat")(f.amount))+"\n            ")])])}),0),_vm._v(" "),_c('add-edit',{attrs:{"addEditExpenseModal":_vm.addEditExpenseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate,"expenseTypesList":_vm.expenseTypesList,"suppliersList":_vm.suppliersList,"banksList":_vm.banksList},on:{"close":function($event){_vm.addEditExpenseModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Expenses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderInvoices_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18191181_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderInvoices_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18191181_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(988);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("353f0a19", content, true, {});

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"addExportButton":true,"sendToExport":_vm.sendToExport,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_invoice_id},[_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[(r.handling_fee > 0)?_c('span',{staticClass:"ship-only-label"},[_vm._v("Ship Only")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.weight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.volume))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.handling_fee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.shipment))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.delivery_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.total_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.discount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.net_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[_c('a',{staticClass:"px-1",attrs:{"tooltip":"Invoice"},on:{"click":function($event){return _vm.viewRecord(r.order_invoice_id)}}},[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"18px","color":"#666"}})]),_vm._v(" "),(_vm.$_has_perm('delete_shipping_invoice'))?_c('a',{staticClass:"px-1",attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteRow(r.order_invoice_id)}}},[_c('i',{staticClass:"fa fa-trash error--text",staticStyle:{"font-size":"18px"}})]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)]),_vm._v(" "),_c('view-order-invoice',{attrs:{"viewOrderInvoiceModal":_vm.viewOrderInvoiceModal,"invoiceData":_vm.invoiceData,"companyData":_vm.companyData},on:{"close":function($event){_vm.viewOrderInvoiceModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Shipping Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_capital_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a16fe46_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_capital_vue__ = __webpack_require__(993);
function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a16fe46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_capital_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a16fe46_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_capital_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("698b7154", content, true, {});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-4a16fe46]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}", ""]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Kurdistan Bank")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.kurBalance)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("America Bank")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.usaBalance)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"orange lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Our Loan On Customers")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.ourLoanOnCustomer)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"red lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Customer Loan On Us")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.customerLoanOnUs)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"red lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Supplier Loan On Us")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.supplierLoanOnUs)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"green lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Capital")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.capital)))])])],1)],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Capital")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f92bfa12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_vue__ = __webpack_require__(997);
function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f92bfa12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f92bfa12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(996);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4307e4a0", content, true, {});

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-f92bfa12]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}", ""]);

// exports


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('v-layout',{staticStyle:{"margin-bottom":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 pb-2 mt-2",attrs:{"xs12":"","sm6":"","md4":"","lg2":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191","width":"100%"},attrs:{"date":_vm.startTime,"option":_vm.option}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3 pb-2 mt-2",attrs:{"xs12":"","sm6":"","md4":"","lg2":""}},[_c('date-picker',{staticClass:"form-control",staticStyle:{"border-bottom-color":"#919191"},attrs:{"date":_vm.startTime1,"option":_vm.option1}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs2":"","sm2":"","md2":"","lg1":"","xl1":""}},[_c('v-btn',{staticClass:"pt-0",attrs:{"outline":"","depressed":"","small":""},on:{"click":function($event){return _vm.resetFilter()}}},[_vm._v("\n          Reset\n        ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"xs2":"","sm2":"","md2":"","lg1":"","xl1":""}},[_c('v-btn',{staticClass:"pt-0",attrs:{"outline":"","depressed":"","small":"","color":"primary"},on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v("\n          Apply\n        ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total International Shipment")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.total_shipment)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Shipping Invoice Shipment")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.total_invoice_shipment)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Local Tax")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.total_tax)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"blue lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Fee")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.total_fee)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"red lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Refund")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.total_refund)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"green lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Income")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.income)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"red lighten-3"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Total Expense")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.expense)))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pb-4 px-3 text-center",attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"grey darken-3 white--text"},[_c('v-card-text',[_c('h4',{staticClass:"mt-0"},[_vm._v("Profit")]),_vm._v(" "),_c('h3',{staticClass:"mt-0"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.apiData.profit)))])])],1)],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Profit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pallets_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb0389b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pallets_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bb0389b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pallets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bb0389b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pallets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1000);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4c2c2596", content, true, {});

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".pallets-head[data-v-0bb0389b]{display:flex;justify-content:space-between;align-items:center}.pallets-head h4[data-v-0bb0389b]{text-transform:uppercase;font-weight:500}.summary[data-v-0bb0389b]{display:flex;flex-wrap:wrap;margin:0 -8px 18px}.summary-tile[data-v-0bb0389b]{flex:1 1 170px;margin:0 8px 12px;padding:14px 18px;background:#f7f8fc;border:1px solid #e6e8f0;border-radius:6px}.summary-tile small[data-v-0bb0389b]{display:block;color:#7a8194;text-transform:uppercase;letter-spacing:.5px;font-size:11px}.summary-tile span[data-v-0bb0389b]{display:block;margin:4px 0 2px;font-size:24px;font-weight:600;color:#2c315b}.summary-tile em[data-v-0bb0389b]{font-style:normal;font-size:12px;color:#9aa0b0}.summary-tile em.warn[data-v-0bb0389b]{color:#e67e22}.summary-profit[data-v-0bb0389b]{background:#eaf7ef;border-color:#cfead9}.summary-profit span[data-v-0bb0389b]{color:#1e8e4e}.summary-loss[data-v-0bb0389b]{background:#fdecea;border-color:#f5c6c2}.summary-loss span[data-v-0bb0389b]{color:#d9534f}.filters[data-v-0bb0389b]{display:flex;flex-wrap:wrap;align-items:flex-end;margin-bottom:18px;padding:14px 16px 4px;border:1px solid #e6e8f0;border-radius:6px}.filter[data-v-0bb0389b]{margin:0 14px 10px 0}.filter-wide[data-v-0bb0389b]{flex:1 1 220px}.filter label[data-v-0bb0389b]{display:block;margin-bottom:4px;font-size:12px;font-weight:400;color:#7a8194}.filters .form-control[data-v-0bb0389b],form.form-inline .form-control[data-v-0bb0389b]{height:36px;padding:6px 10px;background:#fff;border:1px solid #d5d9e3;border-radius:4px}.filter-wide .form-control[data-v-0bb0389b]{width:100%}.filter-buttons .btn[data-v-0bb0389b]{margin-right:6px}form.form-inline .form-control[data-v-0bb0389b]{margin:0 6px 6px 0}select.form-control[data-v-0bb0389b]{-webkit-appearance:menulist;appearance:auto}.pallets-table[data-v-0bb0389b]{border:1px solid #e6e8f0}.pallets-table thead th[data-v-0bb0389b]{background:#f7f8fc;color:#7a8194;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.4px;border-bottom:1px solid #e6e8f0}.pallets-table tbody tr[data-v-0bb0389b]{cursor:pointer}.pallets-table tbody tr[data-v-0bb0389b]:hover{background:#f4f6ff}.pallets-table td[data-v-0bb0389b]{vertical-align:middle}.pallets-table td small[data-v-0bb0389b]{display:block;color:#9aa0b0;white-space:nowrap}.pallet-no[data-v-0bb0389b]{white-space:nowrap;font-size:15px;font-weight:600;color:#2c315b}.pallet-no i[data-v-0bb0389b]{margin-right:4px;color:#5a67d8}.origin[data-v-0bb0389b]{margin-left:6px;padding:1px 8px;border-radius:10px;background:#eef0fb;color:#5a67d8;font-size:12px;font-weight:600}.pallets-table td small.closed[data-v-0bb0389b]{color:#7a8194}.pallets-table td small.loading[data-v-0bb0389b]{color:#1e8e4e}.money[data-v-0bb0389b]{text-align:right;white-space:nowrap}.profit[data-v-0bb0389b]{font-weight:700;color:#1e8e4e}.profit.loss[data-v-0bb0389b]{color:#d9534f}.note[data-v-0bb0389b]{max-width:180px;color:#777}.none[data-v-0bb0389b]{color:#c3c7d1}.pill[data-v-0bb0389b]{display:inline-block;padding:3px 10px;border-radius:12px;font-size:12px;font-weight:600;white-space:nowrap}.pill-open[data-v-0bb0389b]{background:#fff1e0;color:#c96a12}.pill-done[data-v-0bb0389b]{background:#e3f6ea;color:#1e8e4e}.pill-wait[data-v-0bb0389b]{background:#fde8e6;color:#d9534f}.actions[data-v-0bb0389b]{white-space:nowrap;text-align:right;cursor:default}.actions a[data-v-0bb0389b]{display:inline-block;width:30px;height:30px;margin-left:4px;line-height:30px;text-align:center;border-radius:4px;color:#5a67d8;background:#eef0fb}.actions a[data-v-0bb0389b]:hover{background:#dfe3f8}.actions a.danger[data-v-0bb0389b]{color:#d9534f;background:#fdecea}.empty-state[data-v-0bb0389b]{padding:50px 20px;text-align:center;color:#9aa0b0;border:1px dashed #d5d9e3;border-radius:6px}.empty-state i[data-v-0bb0389b]{font-size:40px;color:#c3c7d1}.empty-state h4[data-v-0bb0389b]{margin:12px 0 6px;color:#555}.legend[data-v-0bb0389b]{display:flex;margin-top:16px;padding:10px 14px;background:#f7f8fc;border-radius:6px;color:#6b7285;font-size:13px}.legend i[data-v-0bb0389b]{margin:2px 10px 0 0;color:#5a67d8}.report-body[data-v-0bb0389b]{max-height:calc(100vh - 190px);overflow-y:auto}.section-title[data-v-0bb0389b]{margin:18px 0 8px;font-weight:600;color:#2c315b}.report-tiles small.warn[data-v-0bb0389b]{color:#e67e22}.row-action[data-v-0bb0389b]{margin-left:10px;color:#b4b9c6;cursor:pointer}.row-action[data-v-0bb0389b]:hover{color:#d9534f}.add-help[data-v-0bb0389b]{display:block;margin-top:4px;color:#9aa0b0}.item-fields[data-v-0bb0389b]{display:flex;flex-wrap:wrap;margin:0 -5px}.item-field[data-v-0bb0389b]{flex:1 1 120px;margin:0 5px 8px}.item-field.item-wide[data-v-0bb0389b]{flex:2 1 190px}.item-field small[data-v-0bb0389b]{display:block;margin-bottom:2px;color:#7a8194}.item-field .form-control[data-v-0bb0389b]{width:100%;height:36px;padding:6px 10px;background:#fff;border:1px solid #d5d9e3;border-radius:4px}.item-total[data-v-0bb0389b]{display:flex;justify-content:flex-end;align-items:center;color:#2c315b}.item-total .btn[data-v-0bb0389b]{margin-left:14px}.hand-row td[data-v-0bb0389b]{background:#fbfaff}.report-tiles>div[data-v-0bb0389b]{padding-top:6px;padding-bottom:10px}.report-tiles h5[data-v-0bb0389b]{color:#7a8194;text-transform:uppercase;letter-spacing:.5px;font-size:12px}.report-tiles h3[data-v-0bb0389b]{margin:6px 0;font-weight:600}.status-box[data-v-0bb0389b]{margin:14px 0 0;padding:12px 16px;border-radius:4px}.status-box ul[data-v-0bb0389b]{margin:6px 0 0;padding-left:20px}.status-open[data-v-0bb0389b]{background:#fff8e1;border-left:4px solid #e67e22;color:#7a4a00}.status-done[data-v-0bb0389b]{background:#eaf7ef;border-left:4px solid #27ae60;color:#1a6b3c}.pill-big[data-v-0bb0389b]{padding:6px 14px;font-size:13px}.pending-row[data-v-0bb0389b]{cursor:pointer;color:#9a6a2c}.pending-row[data-v-0bb0389b]:hover{background:#fff8e1}.section-bar[data-v-0bb0389b]{display:flex;justify-content:space-between;align-items:center}.orders-scroll[data-v-0bb0389b]{max-height:420px;overflow-y:auto;border:1px solid #e6e8f0}.orders-scroll .pallet-orders[data-v-0bb0389b]{width:100%;margin-bottom:0;border:0}.orders-scroll .pallet-orders thead th[data-v-0bb0389b]{position:sticky;top:0;z-index:1;background:#f7f8fc;box-shadow:0 1px 0 #e6e8f0}.pallet-orders td[data-v-0bb0389b],.pallet-orders th[data-v-0bb0389b]{padding:8px 10px}.add-box[data-v-0bb0389b]{margin-bottom:14px;padding:12px 14px;background:#f7f8fc;border:1px solid #e6e8f0;border-radius:6px}.add-box label[data-v-0bb0389b]{display:block;margin-bottom:6px;font-weight:400;color:#6b7285}.add-box textarea.form-control[data-v-0bb0389b]{margin-bottom:8px;padding:6px 10px;background:#fff;border:1px solid #d5d9e3;border-radius:4px}.invoice-money[data-v-0bb0389b]{margin-left:10px;font-weight:600}.income-table td[data-v-0bb0389b]{vertical-align:middle}.income-table td small[data-v-0bb0389b]{display:block;margin-top:2px;color:#9aa0b0;font-size:12px}.income-table .income-total td[data-v-0bb0389b]{font-weight:700}", ""]);

// exports


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading pallets-head"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.openForm()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" New pallet")])]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary-tile"},[_c('small',[_vm._v("Pallets")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.pallets.length))]),_vm._v(" "),_c('em',[_vm._v(_vm._s(_vm.openCount)+" not completed")])]),_vm._v(" "),_c('div',{staticClass:"summary-tile"},[_c('small',[_vm._v("Orders")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.sum('orders_count')))]),_vm._v(" "),_c('em',{class:_vm.sum('waiting_invoice_count') > 0 ? 'warn' : ''},[_vm._v(_vm._s(_vm.sum('waiting_invoice_count'))+" not weighed yet")])]),_vm._v(" "),_c('div',{staticClass:"summary-tile"},[_c('small',[_vm._v("Income")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.sum('income'))))]),_vm._v(" "),_c('em',[_vm._v("from customers")])]),_vm._v(" "),_c('div',{staticClass:"summary-tile"},[_c('small',[_vm._v("Expenses")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.sum('expense'))))]),_vm._v(" "),_c('em',[_vm._v("entered so far")])]),_vm._v(" "),_c('div',{staticClass:"summary-tile summary-profit",class:_vm.sum('profit') < 0 ? 'summary-loss' : ''},[_c('small',[_vm._v("Profit")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.sum('profit'))))]),_vm._v(" "),_c('em',[_vm._v("income − expenses")])])]),_vm._v(" "),_c('div',{staticClass:"filters"},[_c('div',{staticClass:"filter filter-wide"},[_c('label',[_vm._v("Search")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryParams.search),expression:"queryParams.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pallet / plane number"},domProps:{"value":(_vm.queryParams.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getData()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.queryParams, "search", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('label',[_vm._v("Flight date from")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryParams.from_date),expression:"queryParams.from_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.queryParams.from_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.queryParams, "from_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('label',[_vm._v("Flight date to")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryParams.to_date),expression:"queryParams.to_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.queryParams.to_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.queryParams, "to_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('label',[_vm._v("Origin")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryParams.warehouse_id),expression:"queryParams.warehouse_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.queryParams, "warehouse_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("All origins")]),_vm._v(" "),_vm._l((_vm.warehouses),function(w){return _c('option',{key:w.warehouse_id,domProps:{"value":w.warehouse_id}},[_vm._v(_vm._s(w.country))])})],2)]),_vm._v(" "),_c('div',{staticClass:"filter"},[_c('label',[_vm._v("Accounts")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.queryParams.is_completed),expression:"queryParams.is_completed"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.queryParams, "is_completed", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("All accounts")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Not completed")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Completed")])])]),_vm._v(" "),_c('div',{staticClass:"filter filter-buttons"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Filter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetFilter()}}},[_vm._v("Reset")])])]),_vm._v(" "),(_vm.pallets.length == 0)?_c('div',{staticClass:"empty-state"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('h4',[_vm._v("No pallets here")]),_vm._v(" "),_c('p',[_vm._v("A pallet is made on the Pending To Shipment page when orders are sent, or with \"New pallet\".")])]):_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table pallets-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.pallets),function(p){return _c('tr',{key:p.pallet_id,on:{"click":function($event){return _vm.showPallet(p)}}},[_c('td',[_c('div',{staticClass:"pallet-no"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "+_vm._s(p.tracking_number)+" "),_c('span',{staticClass:"origin"},[_vm._v(_vm._s(p.origin))])]),_vm._v(" "),(p.flight_date)?_c('small',[_vm._v("Flight "+_vm._s(p.flight_date))]):_c('small',[_vm._v("No flight date")]),_vm._v(" "),(p.is_closed)?_c('small',{staticClass:"closed"},[_vm._v("Flew, takes no new orders")]):_c('small',{staticClass:"loading"},[_vm._v("Loading at the warehouse")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"pill",class:p.is_completed ? 'pill-done' : 'pill-open'},[_vm._v(_vm._s(p.is_completed ? 'Completed' : 'Not completed'))]),_vm._v(" "),_vm._l((_vm.shortReasons(p)),function(reason){return _c('small',{key:reason},[_vm._v(_vm._s(reason))])})],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(p.orders_count))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(p.arrived_count)+" arrived · "+_vm._s(p.delivered_count)+" delivered")])]),_vm._v(" "),_c('td',[(p.waiting_invoice_count > 0)?_c('span',{staticClass:"pill pill-wait"},[_vm._v(_vm._s(p.waiting_invoice_count))]):_c('span',{staticClass:"none"},[_vm._v("—")])]),_vm._v(" "),_c('td',{staticClass:"money"},[_vm._v(_vm._s(_vm._f("usdFormat")(p.income)))]),_vm._v(" "),_c('td',{staticClass:"money"},[_vm._v(_vm._s(_vm._f("usdFormat")(p.expense)))]),_vm._v(" "),_c('td',{staticClass:"money profit",class:p.profit < 0 ? 'loss' : ''},[_vm._v(_vm._s(_vm._f("usdFormat")(p.profit)))]),_vm._v(" "),_c('td',{staticClass:"note"},[_vm._v(_vm._s(p.note))]),_vm._v(" "),_c('td',{staticClass:"actions",on:{"click":function($event){$event.stopPropagation();}}},[_c('a',{attrs:{"title":"Report"},on:{"click":function($event){return _vm.showPallet(p)}}},[_c('i',{staticClass:"fa fa-bar-chart"})]),_vm._v(" "),_c('a',{attrs:{"title":"Edit"},on:{"click":function($event){return _vm.openForm(p)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),(p.orders_count == 0 && p.items_count == 0)?_c('a',{staticClass:"danger",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.deletePallet(p)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()])])}),0)])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.formModal),callback:function ($$v) {_vm.formModal=$$v},expression:"formModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.savePallet()}}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formData.pallet_id ? 'Edit pallet' : 'New pallet'))])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Origin (where the plane comes from)*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.warehouse_id_fk),expression:"formData.warehouse_id_fk"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "warehouse_id_fk", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Choose origin")]),_vm._v(" "),_vm._l((_vm.warehouses),function(w){return _c('option',{key:w.warehouse_id,domProps:{"value":w.warehouse_id}},[_vm._v(_vm._s(w.country))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pallet / Plane tracking number*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.tracking_number),expression:"formData.tracking_number"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.formData.tracking_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "tracking_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Flight date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.flight_date),expression:"formData.flight_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.formData.flight_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "flight_date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Note")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.note),expression:"formData.note"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.formData.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "note", $event.target.value)}}})])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":""},on:{"click":function($event){_vm.formModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1250px","scrollable":""},model:{value:(_vm.palletModal),callback:function ($$v) {_vm.palletModal=$$v},expression:"palletModal"}},[(_vm.pallet)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "+_vm._s(_vm.pallet.tracking_number)+" "),_c('span',{staticClass:"origin"},[_vm._v(_vm._s(_vm.pallet.origin))])]),_vm._v(" "),(_vm.pallet.flight_date)?_c('small',{staticStyle:{"margin-left":"12px","color":"#777"}},[_vm._v("Flight date: "+_vm._s(_vm.pallet.flight_date))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"pill pill-big",class:_vm.pallet.is_completed ? 'pill-done' : 'pill-open'},[_c('i',{staticClass:"fa",class:_vm.pallet.is_completed ? 'fa-check-circle' : 'fa-clock-o'}),_vm._v(" "+_vm._s(_vm.pallet.is_completed ? 'Accounts completed' : 'Accounts not completed'))])],1),_vm._v(" "),_c('v-card-text',{staticClass:"report-body"},[_c('div',{staticClass:"row text-center report-tiles"},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_vm._v("Orders")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.pallet.orders_count + _vm.pallet.items_count))]),_vm._v(" "),(_vm.pallet.waiting_invoice_count > 0)?_c('small',{staticClass:"warn"},[_vm._v(_vm._s(_vm.pallet.waiting_invoice_count)+" not weighed yet")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h5',[_vm._v("Income")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.income)))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h5',[_vm._v("Expenses")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.expense)))]),_vm._v(" "),((_vm.pallet.missing_expenses || []).length > 0)?_c('small',{staticClass:"warn"},[_vm._v(_vm._s(_vm.pallet.missing_expenses.length)+" not entered yet")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h5',[_vm._v(_vm._s(_vm.pallet.is_completed ? 'Final profit' : 'Provisional profit'))]),_vm._v(" "),_c('h3',{style:(_vm.profitStyle(_vm.pallet.profit))},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.profit)))])])]),_vm._v(" "),(_vm.pallet.is_completed)?_c('div',{staticClass:"status-box status-done"},[_c('strong',[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" Completed.")]),_vm._v("\n          Every order is weighed and every expense is entered, so this profit is final.\n        ")]):_c('div',{staticClass:"status-box status-open"},[_c('strong',[_vm._v("Not completed yet.")]),_vm._v(" Still needed:\n          "),_c('ul',_vm._l((_vm.statusReasons(_vm.pallet)),function(reason){return _c('li',{key:reason},[_vm._v(_vm._s(reason))])}),0)]),_vm._v(" "),_c('div',{staticClass:"row report-money"},[_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"section-title"},[_vm._v("Income")]),_vm._v(" "),_c('table',{staticClass:"table table-condensed income-table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("\n                    From orders\n                    "),_c('small',[_vm._v("\n                      ShipZone fee "+_vm._s(_vm._f("usdFormat")(_vm.pallet.shipzone_fee))+" ·\n                      Int Shipping "+_vm._s(_vm._f("usdFormat")(_vm.pallet.int_shipping))+" ·\n                      Local Tax "+_vm._s(_vm._f("usdFormat")(_vm.pallet.local_tax))+"\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.on_order)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                    From Shipping Invoices\n                    "),_c('small',[_vm._v("\n                      Shipment "+_vm._s(_vm._f("usdFormat")(_vm.pallet.invoice_shipment))+" ·\n                      Handling fee "+_vm._s(_vm._f("usdFormat")(_vm.pallet.invoice_handling))+" ·\n                      Tax "+_vm._s(_vm._f("usdFormat")(_vm.pallet.invoice_tax))+"\n                      "),(_vm.pallet.invoice_discount > 0)?[_vm._v("\n                        · Discount −"+_vm._s(_vm._f("usdFormat")(_vm.pallet.invoice_discount))+"\n                      ")]:_vm._e()],2)]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.on_invoice)))])]),_vm._v(" "),(_vm.pallet.items_count > 0)?_c('tr',[_c('td',[_vm._v("\n                    Added by hand\n                    "),_c('small',[_vm._v("\n                      "+_vm._s(_vm.pallet.items_count)+" "+_vm._s(_vm.pallet.items_count == 1 ? 'item' : 'items')+" not in the system ·\n                      ShipZone fee "+_vm._s(_vm._f("usdFormat")(_vm.pallet.by_hand_shipzone_fee))+" ·\n                      Int Shipping "+_vm._s(_vm._f("usdFormat")(_vm.pallet.by_hand_int_shipping))+" ·\n                      Local Tax "+_vm._s(_vm._f("usdFormat")(_vm.pallet.by_hand_local_tax))+" ·\n                      Handling fee "+_vm._s(_vm._f("usdFormat")(_vm.pallet.by_hand_handling_fee))+"\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.by_hand)))])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"income-total"},[_c('td',[_vm._v("Total income")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.income)))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h5',{staticClass:"section-title section-bar"},[_vm._v("\n              Expenses\n              "),_c('button',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"},on:{"click":function($event){return _vm.openExpenseForm('')}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add expense")])]),_vm._v(" "),_c('table',{staticClass:"table table-condensed income-table"},[_c('tbody',[_vm._l((_vm.expenses),function(e){return _c('tr',{key:e.pallet_expense_id},[_c('td',[_vm._v("\n                    "+_vm._s(e.name)+"\n                    "),(e.expense_date || e.note)?_c('small',[_vm._v(_vm._s([e.expense_date, e.note].filter(function (x) { return x; }).join(' · ')))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(_vm._f("usdFormat")(e.amount))+"\n                    "),_c('a',{staticClass:"row-action",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.deleteExpense(e)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),_vm._l(((_vm.pallet.missing_expenses || [])),function(name){return _c('tr',{key:'missing-' + name,staticClass:"pending-row",attrs:{"title":"Click to enter it"},on:{"click":function($event){return _vm.openExpenseForm(name)}}},[_c('td',[_vm._v(_vm._s(name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"pill pill-open"},[_vm._v("Not entered")])])])}),_vm._v(" "),_c('tr',{staticClass:"income-total"},[_c('td',[_vm._v("Total expenses")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.pallet.expense)))])])],2)]),_vm._v(" "),(_vm.expenseFormOpen)?_c('form',{staticClass:"add-box form-inline",on:{"submit":function($event){$event.preventDefault();return _vm.addExpense()}}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.expenseForm.name),expression:"expenseForm.name"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.expenseForm, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Expense type")]),_vm._v(" "),_vm._l((_vm.expenseNames),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.expenseForm.amount),expression:"expenseForm.amount",modifiers:{"number":true}}],staticClass:"form-control",staticStyle:{"width":"110px"},attrs:{"type":"number","step":"0.01","min":"0","placeholder":"Amount $","required":""},domProps:{"value":(_vm.expenseForm.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.expenseForm, "amount", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expenseForm.expense_date),expression:"expenseForm.expense_date"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.expenseForm.expense_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.expenseForm, "expense_date", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.expenseForm.note),expression:"expenseForm.note"}],staticClass:"form-control",staticStyle:{"width":"130px"},attrs:{"type":"text","placeholder":"Note"},domProps:{"value":(_vm.expenseForm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.expenseForm, "note", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add")]),_vm._v(" "),_c('small',{staticClass:"add-help"},[_vm._v("If the pallet has none of this expense, enter 0.")])]):_vm._e()])]),_vm._v(" "),_c('h5',{staticClass:"section-title section-bar"},[_vm._v("\n          Orders\n          "),_c('span',[_c('button',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"},on:{"click":function($event){_vm.addOrdersOpen = !_vm.addOrdersOpen; _vm.itemFormOpen = false}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add orders")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-xs",staticStyle:{"margin-left":"6px"},attrs:{"type":"button"},on:{"click":function($event){_vm.itemFormOpen = !_vm.itemFormOpen; _vm.addOrdersOpen = false}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add item not in the system")])])]),_vm._v(" "),(_vm.addOrdersOpen)?_c('form',{staticClass:"add-box",on:{"submit":function($event){$event.preventDefault();return _vm.addOrders(false)}}},[_c('label',[_vm._v("Orders that flew on this pallet but are not listed here. Write the order numbers (US-72911) or scan their QR codes, one per line or with commas.")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.addOrdersText),expression:"addOrdersText"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":"US-72911, US-72926","required":""},domProps:{"value":(_vm.addOrdersText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.addOrdersText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add to this pallet")])]):_vm._e(),_vm._v(" "),(_vm.itemFormOpen)?_c('form',{staticClass:"add-box",on:{"submit":function($event){$event.preventDefault();return _vm.addItem()}}},[_c('label',[_vm._v("\n            Something on this pallet that is not an order in the system. Fill the lines like an order.\n            The item price is kept for the record only; it is not counted in the income, same as for orders.\n          ")]),_vm._v(" "),_c('div',{staticClass:"item-fields"},[_c('div',{staticClass:"item-field item-wide"},[_c('small',[_vm._v("Item name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemForm.name),expression:"itemForm.name"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.itemForm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.itemForm, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-field item-wide"},[_c('small',[_vm._v("Customer")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemForm.customer_name),expression:"itemForm.customer_name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.itemForm.customer_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.itemForm, "customer_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"item-field"},[_c('small',[_vm._v("Item price $ (not counted)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.itemForm.item_price),expression:"itemForm.item_price",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","min":"0","placeholder":"0.00"},domProps:{"value":(_vm.itemForm.item_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.itemForm, "item_price", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_vm._l((_vm.itemLines),function(line){return _c('div',{key:line.key,staticClass:"item-field"},[_c('small',[_vm._v(_vm._s(line.label)+" $")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.itemForm[line.key]),expression:"itemForm[line.key]",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","step":"0.01","min":"0","placeholder":"0.00"},domProps:{"value":(_vm.itemForm[line.key])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.itemForm, line.key, _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])}),_vm._v(" "),_c('div',{staticClass:"item-field item-wide"},[_c('small',[_vm._v("Note")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.itemForm.note),expression:"itemForm.note"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.itemForm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.itemForm, "note", $event.target.value)}}})])],2),_vm._v(" "),_c('div',{staticClass:"item-total"},[_vm._v("\n            Income of this item: "),_c('strong',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.itemFormTotal)))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add item")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive orders-scroll"},[_c('table',{staticClass:"table table-bordered pallet-orders"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Order")]),_vm._v(" "),_c('th',[_vm._v("Customer")]),_vm._v(" "),_c('th',[_vm._v("Stage")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"title":"ShipZone fee + Int Shipping + Local Tax paid on the order"}},[_vm._v("On order")]),_vm._v(" "),_c('th',[_vm._v("Shipping Invoice")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Income")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[(!_vm.loaded)?_c('tr',[_c('td',{staticClass:"text-center",staticStyle:{"color":"#999"},attrs:{"colspan":"7"}},[_vm._v("Loading…")])]):(_vm.orders.length == 0 && _vm.items.length == 0)?_c('tr',[_c('td',{staticClass:"text-center",staticStyle:{"color":"#999"},attrs:{"colspan":"7"}},[_vm._v("No orders on this pallet yet. They are put on it when sent from Pending To Shipment.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.sortedOrders),function(o){return _c('tr',{key:o.order_id},[_c('td',{staticStyle:{"white-space":"nowrap"}},[_vm._v("\n                  "+_vm._s(o.theOrderID)+"\n                  "),(o.is_ship_only)?_c('small',{staticStyle:{"margin-left":"6px","color":"#8e44ad"}},[_vm._v("Ship only")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(o.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stageName(o.status)))]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"title":_vm.onOrderParts(o)}},[_vm._v(_vm._s(_vm._f("usdFormat")(o.on_order)))]),_vm._v(" "),_c('td',{staticStyle:{"white-space":"nowrap"}},[(o.invoice_number)?_c('span',[_vm._v("\n                    "+_vm._s(o.invoice_number)+"\n                    "),_c('span',{staticClass:"invoice-money"},[_vm._v(_vm._s(_vm._f("usdFormat")(o.on_invoice)))])]):(o.waiting_invoice)?_c('span',{staticStyle:{"color":"#e67e22","font-weight":"bold"}},[_vm._v("Not weighed yet")]):(o.pays_on_invoice)?_c('span',{staticStyle:{"color":"#999"}},[_vm._v("No invoice")]):_c('span',{staticClass:"none"},[_vm._v("–")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm._f("usdFormat")(o.income)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"row-action",attrs:{"title":"Move to another pallet"},on:{"click":function($event){return _vm.openMove(o)}}},[_c('i',{staticClass:"fa fa-exchange"})])])])}),_vm._v(" "),_vm._l((_vm.items),function(i){return _c('tr',{key:'item-' + i.pallet_item_id,staticClass:"hand-row"},[_c('td',[_vm._v("\n                  "+_vm._s(i.name)+"\n                  "),_c('small',{staticStyle:{"margin-left":"6px","color":"#8e44ad"}},[_vm._v("By hand")]),_vm._v(" "),(i.item_price > 0)?_c('small',{staticStyle:{"display":"block","color":"#999"}},[_vm._v("Item price "+_vm._s(_vm._f("usdFormat")(i.item_price))+" (not counted)")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(i.customer_name))]),_vm._v(" "),_c('td',[_vm._v("Not in the system")]),_vm._v(" "),_c('td',{staticClass:"text-right none"},[_vm._v("–")]),_vm._v(" "),_c('td',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(i.note))]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"title":_vm.itemParts(i)}},[_c('strong',[_vm._v(_vm._s(_vm._f("usdFormat")(i.amount)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"row-action",attrs:{"title":"Delete"},on:{"click":function($event){return _vm.deleteItem(i)}}},[_c('i',{staticClass:"fa fa-trash"})])])])})],2)])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":""},on:{"click":function($event){_vm.palletModal = false}}},[_vm._v("Close")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"450px"},model:{value:(_vm.moveModal),callback:function ($$v) {_vm.moveModal=$$v},expression:"moveModal"}},[(_vm.moveOrder)?_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.moveSubmit()}}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Move "+_vm._s(_vm.moveOrder.theOrderID))])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Move it to pallet*")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.moveTo),expression:"moveTo"}],staticClass:"form-control",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.moveTo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Choose pallet")]),_vm._v(" "),_vm._l((_vm.otherPallets),function(p){return _c('option',{key:p.pallet_id,domProps:{"value":p.pallet_id}},[_vm._v(_vm._s(p.tracking_number)+_vm._s(p.flight_date ? ' (' + p.flight_date + ')' : ''))])})],2)])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":""},on:{"click":function($event){_vm.moveModal = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Move")])],1)],1)]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"panel-title"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" Pallets")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Pallet / Plane No")]),_vm._v(" "),_c('th',[_vm._v("Accounts")]),_vm._v(" "),_c('th',[_vm._v("Orders")]),_vm._v(" "),_c('th',{attrs:{"title":"Ship Only and pay-by-weight orders that have no Shipping Invoice yet"}},[_vm._v("Not weighed yet")]),_vm._v(" "),_c('th',{staticClass:"money"},[_vm._v("Income")]),_vm._v(" "),_c('th',{staticClass:"money"},[_vm._v("Expenses")]),_vm._v(" "),_c('th',{staticClass:"money"},[_vm._v("Profit")]),_vm._v(" "),_c('th',[_vm._v("Note")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Income")]),_vm._v(" = ShipZone fee + Int Shipping + Local Tax paid on the order + Shipping Invoice (shipment + handling + tax − discount).\n        "),_c('strong',[_vm._v("Profit")]),_vm._v(" = Income − Expenses.\n        A pallet becomes "),_c('strong',[_vm._v("Completed")]),_vm._v(" by itself when every Ship Only and pay-by-weight order is weighed in Erbil\n        and the Turkish Airlines invoice, airport expenses and airport tax are entered. Until then the profit is provisional.\n        A pallet is one plane from one origin; once it has flown it takes no more orders from the warehouse.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moneyTransfer_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647fa88e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moneyTransfer_vue__ = __webpack_require__(1009);
function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moneyTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647fa88e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moneyTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1004);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dd7bea18", content, true, {});

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b86c6376_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__ = __webpack_require__(1008);
function injectStyle (ssrContext) {
  __webpack_require__(1006)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b86c6376_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3a1c26a2", content, true, {});

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addMoneyTransferModal),callback:function ($$v) {_vm.addMoneyTransferModal=$$v},expression:"addMoneyTransferModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                Transfer Money\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              Done successfully\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.banksList,"error-messages":_vm.errors.collect('From Bank'),"data-vv-name":"From Bank","label":"From Bank *"},model:{value:(_vm.formData.from_bank_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "from_bank_id_fk", $$v)},expression:"formData.from_bank_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.banksList,"error-messages":_vm.errors.collect('To Bank'),"data-vv-name":"To Bank","label":"To Bank *"},model:{value:(_vm.formData.to_bank_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "to_bank_id_fk", $$v)},expression:"formData.to_bank_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount *","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount"},model:{value:(_vm.formData.amount),callback:function ($$v) {_vm.$set(_vm.formData, "amount", $$v)},expression:"formData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Expense Amount *","error-messages":_vm.errors.collect('Expense Amount'),"data-vv-name":"Expense Amount"},model:{value:(_vm.formData.expense_amount),callback:function ($$v) {_vm.$set(_vm.formData, "expense_amount", $$v)},expression:"formData.expense_amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":"","lg6":""}},[_c('v-text-field',{attrs:{"label":"Note","error-messages":_vm.errors.collect('Note'),"data-vv-name":"Note"},model:{value:(_vm.formData.note),callback:function ($$v) {_vm.$set(_vm.formData, "note", $$v)},expression:"formData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_money_transfer: 'add_money_transfer'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addMoneyTransferButton":true,"openAddMoneyTransferModal":_vm.openAddMoneyTransferModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.money_transfer_id},[_c('td',[_vm._v(_vm._s(r.from_bank))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.to_bank))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(r.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("currency")(r.expense_amount)))]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"small":"","label":"","color":r.status == 'pending' ? 'orange' : 'green',"outline":""}},[_vm._v("\n                  "+_vm._s(r.status)+"\n                ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[(r.status == 'pending' && _vm.$_has_perm('approve_money_transfer'))?_c('a',{staticClass:"px-2",staticStyle:{"color":"#43a047"},attrs:{"tooltip":"Approve"},on:{"click":function($event){return _vm.approveMoneyTransfer(r.money_transfer_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])]):_vm._e(),_vm._v(" "),(r.status == 'pending' && _vm.$_has_perm('delete_money_transfer'))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteMoneyTransfer(r.money_transfer_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add',{attrs:{"addMoneyTransferModal":_vm.addMoneyTransferModal,"formData":_vm.formData,"isUpdate":false,"banksList":_vm.banksList},on:{"close":function($event){_vm.addMoneyTransferModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Money Transfers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_putMoney_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9b389f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_putMoney_vue__ = __webpack_require__(1017);
function injectStyle (ssrContext) {
  __webpack_require__(1011)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_putMoney_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9b389f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_putMoney_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1012);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0c8c3496", content, true, {});

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0388ee1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__ = __webpack_require__(1016);
function injectStyle (ssrContext) {
  __webpack_require__(1014)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0388ee1c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1015);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9f9af2e8", content, true, {});

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.addEditModal),callback:function ($$v) {_vm.addEditModal=$$v},expression:"addEditModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Money' : 'Add Money')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Added successfully')+"\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.banksList,"error-messages":_vm.errors.collect('Bank'),"data-vv-name":"Bank","label":"Bank *"},model:{value:(_vm.formData.bank_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "bank_id_fk", $$v)},expression:"formData.bank_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Amount *","error-messages":_vm.errors.collect('Amount'),"data-vv-name":"Amount"},model:{value:(_vm.formData.amount),callback:function ($$v) {_vm.$set(_vm.formData, "amount", $$v)},expression:"formData.amount"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Note","error-messages":_vm.errors.collect('Note'),"data-vv-name":"Note"},model:{value:(_vm.formData.note),callback:function ($$v) {_vm.$set(_vm.formData, "note", $$v)},expression:"formData.note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_money: 'add_money'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addMoneyButton":true,"openAddMoneyModal":_vm.openAddMoneyModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.put_money_id},[_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))]),_vm._v(" "),(_vm.$_has_perm('delete_money'))?_c('td',[_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteMoney(r.put_money_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1)]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit',{attrs:{"addEditModal":_vm.addEditModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate,"banksList":_vm.banksList},on:{"close":function($event){_vm.addEditModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Put Money")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roles_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf34567c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roles_vue__ = __webpack_require__(1029);
function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf34567c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("81cb6af2", content, true, {});

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditRole_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236be2ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditRole_vue__ = __webpack_require__(1024);
function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditRole_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236be2ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditRole_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("27048c1a", content, true, {});

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditRoleModal),callback:function ($$v) {_vm.addEditRoleModal=$$v},expression:"addEditRoleModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Role' : 'Add New Role')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Updated successfully' : 'Added successfully')+"\n            ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n              There is an error\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name *","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assignPermission_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b0b294_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assignPermission_vue__ = __webpack_require__(1028);
function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assignPermission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b0b294_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assignPermission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("d20594d6", content, true, {});

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.permission-group{border:1px solid #ccc;border-radius:6px;position:relative}.group-name{position:absolute;top:-10px;left:5px;background:#fff;font-size:14px;text-transform:capitalize;color:rgba(0,0,0,.5)}.input-group.input-group--selection-controls label{left:0!important;top:-3px!important}", ""]);

// exports


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"900px"},model:{value:(_vm.assignPermissionModal),callback:function ($$v) {_vm.assignPermissionModal=$$v},expression:"assignPermissionModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              Assign permission to ["+_vm._s(_vm.formData.role ? _vm.formData.role.status : '')+"] role\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.isDone}},[_vm._v("\n            "+_vm._s('Saved successfully')+"\n          ")]),_vm._v(" "),_c('v-alert',{attrs:{"type":"error","value":_vm.errorAlert}},[_vm._v("\n            There is an error\n          ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{staticClass:"my-0",attrs:{"label":"Check all"},on:{"change":function($event){return _vm.handleCheckAll(_vm.checkAll)}},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}})],1),_vm._v(" "),_vm._l((_vm.formData.permissions),function(permission,index){return _c('v-flex',{key:index,staticClass:"mb-4 px-3 pt-3 pb-1 permission-group",attrs:{"xs12":""}},[_c('div',{staticClass:"group-name px-3"},[_vm._v(_vm._s(index.replaceAll('_', ' ')))]),_vm._v(" "),_vm._l((permission),function(p,pIndex){return _c('div',{key:pIndex,staticClass:"col-sm-6"},[_c('v-checkbox',{staticClass:"my-1",attrs:{"value":p.id,"hide-details":"","label":p.name},model:{value:(p.checked),callback:function ($$v) {_vm.$set(p, "checked", $$v)},expression:"p.checked"}})],1)})],2)})],2)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"loading":_vm.loading,"outline":"","color":"success"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("\n            "+_vm._s('Save')+"\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_role: 'add_role'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addRoleButton":true,"openAddRoleModal":_vm.openAddRoleModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.role_id},[_c('td',[_vm._v(_vm._s(r.status))]),_vm._v(" "),_c('td',{staticStyle:{"width":"140px"}},[(_vm.$_has_perm('edit_role'))?_c('a',{staticClass:"mx-2",attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditRoleModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_role'))?_c('a',{staticClass:"mx-2",attrs:{"tooltip":"Assign permission"},on:{"click":function($event){return _vm.assignPermission(r.role_id)}}},[_c('i',{staticClass:"fa fa-key",staticStyle:{"color":"#4caf50","font-size":"18px"}})]):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-role',{attrs:{"addEditRoleModal":_vm.addEditRoleModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditRoleModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)]),_vm._v(" "),_c('assign-permission',{attrs:{"assignPermissionModal":_vm.assignPermissionModal,"formData":_vm.formData},on:{"close":function($event){_vm.assignPermissionModal = false},"resetTable":function($event){return _vm.getResults()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Roles")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partialRefundInvoices_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b59eb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partialRefundInvoices_vue__ = __webpack_require__(1033);
function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_partialRefundInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4b59eb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_partialRefundInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1032);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("276ebafa", content, true, {});

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.partial_refund_id},[_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.last_order_invoice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Partial Refund Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPartialRefundInvoices_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d4df94_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPartialRefundInvoices_vue__ = __webpack_require__(1037);
function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPartialRefundInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d4df94_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPartialRefundInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1036);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("bed29a22", content, true, {});

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.partial_refund_id},[_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.created_at))])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('mobile-datatable',{attrs:{"isOrder":true}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_invoice_id},[_c('td',[_vm._v("\n                Order ID: "+_vm._s(r.theOrderID)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                Amount: "+_vm._s(r.amount)+" , "),_c('br'),_vm._v("\n                Note: "+_vm._s(r.note)+" , "),_c('br'),_vm._v("\n                Created At: "+_vm._s(r.created_at)+"\n              ")])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cus-panel-heading"},[_c('h4',{staticClass:"cus-panel-title"},[_vm._v("Partial Refund Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deliveryInvoices_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa6fbcf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deliveryInvoices_vue__ = __webpack_require__(1041);
function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deliveryInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa6fbcf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deliveryInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1040);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("72ae6c56", content, true, {});

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.delivery_invoice_id},[_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[_vm._v("\n                "+_vm._s(r.customer_name)+"\n                "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number_2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_credit.toLocaleString()))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.pay_on_delivery_iqd.toLocaleString()))]),_vm._v(" "),_c('td',_vm._l((r.orders),function(order){return _c('div',{key:order.order_id,staticClass:"badge badge-primary my-1"},[_vm._v("\n                  "+_vm._s(order.theOrderID)+"\n                ")])}),0),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.staff_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm A')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[_c('a',{staticClass:"px-1",attrs:{"tooltip":"Invoice"},on:{"click":function($event){return _vm.viewRecord(r.delivery_invoice_id)}}},[_c('i',{staticClass:"fa fa-file-text-o",staticStyle:{"font-size":"18px","color":"#666"}})])])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)]),_vm._v(" "),_c('view-customer-delivery-invoice',{attrs:{"viewDeliveryInvoiceModal":_vm.viewDeliveryInvoiceModal,"invoiceData":_vm.invoiceData,"companyData":_vm.companyData},on:{"close":function($event){_vm.viewDeliveryInvoiceModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Delivery Invoices")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchaseHistory_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_058679c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchaseHistory_vue__ = __webpack_require__(1045);
function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchaseHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_058679c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchaseHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1044);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f6218ce0", content, true, {});

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}.table-tr:hover .action-td{position:sticky;right:-2px}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult},on:{"branch-edit":_vm.branchEdit}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 pt-0"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.order_id,staticClass:"table-tr",style:(_vm.qrCodeValues.find(function (x) { return x[0] == r.order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrCodeValues),expression:"qrCodeValues"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only ],"checked":Array.isArray(_vm.qrCodeValues)?_vm._i(_vm.qrCodeValues,[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only ])>-1:(_vm.qrCodeValues)},on:{"change":function($event){var $$a=_vm.qrCodeValues,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[
                    r.order_id,
                    r.full_name,
                    r.phone_number,
                    r.user_id,
                    r.theOrderID,
                    r.is_ship_only ],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.qrCodeValues=$$a.concat([$$v]))}else{$$i>-1&&(_vm.qrCodeValues=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.qrCodeValues=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.last_order_invoice))]),_vm._v(" "),(r.qrcode == null || r.qrcode == '')?_c('td',[_vm._v(_vm._s(r.theOrderID))]):_c('td',[_c('i',{staticClass:"fa fa-qrcode",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_id_fk))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.fcm_token)?_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("smartphone")]):_c('i',{staticClass:"material-icons customer-device-icon"},[_vm._v("language")]),_vm._v(" "),(r.profile_image)?_c('img',{staticClass:"customer-profile-image",attrs:{"src":("" + (_vm.$_image_path()) + (r.profile_image))}}):_vm._e(),_vm._v(" "),(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":r.product_url,"target":"_blank"}},[_vm._v(_vm._s(r.product_url.replace(/http(s)?:\/\//, '').substr(0, 10) +
                    (r.product_url.length > 10 ? '...' : '')))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),(r.order_status === 'new_order')?_c('td',[_c('span',{staticClass:"label bg-primary-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'processed_order')?_c('td',[_c('span',{staticClass:"label bg-indigo-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'canceled')?_c('td',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'refunded')?_c('td',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'approved_order')?_c('td',[_c('span',{staticClass:"label bg-green-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'purchased')?_c('td',[_c('span',{staticClass:"label bg-teal-400"},[_vm._v(" "+_vm._s(r.order_status))])]):_vm._e(),_vm._v(" "),(r.order_status === 'warehouse_delivered_order')?_c('td',[_c('span',{staticClass:"label bg-purple-400"},[_vm._v("\n                  "+_vm._s(r.order_status.replace('_', ' ').replace('_order', '')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'int_shipment')?_c('td',[_c('span',{staticClass:"label bg-info-400"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'branch_delivery')?_c('td',[_c('span',{staticClass:"label bg-violet-600"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'delivered')?_c('td',[_c('span',{staticClass:"label bg-warning-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'ship_only')?_c('td',[_c('span',{staticClass:"label bg-blue-300"},[_vm._v(" "+_vm._s(r.order_status.replace('_', ' ')))])]):_vm._e(),_vm._v(" "),(r.order_status === 'archived')?_c('td',[(r.is_canceled == '1')?_c('span',[_c('span',{staticClass:"label bg-orange-600"},[_vm._v("canceled")])]):_vm._e(),_vm._v(" "),(r.is_refunded == '1')?_c('span',[_c('span',{staticClass:"label bg-danger-600"},[_vm._v("refunded")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label bg-grey-600 mt-1"},[_vm._v("archived")])]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchase_note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',{staticClass:"hover-container",staticStyle:{"min-width":"130px"}},[_c('view-order-dates',{attrs:{"orderData":r}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.warehouse_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.actual_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.item_price * r.quantity + r.national_tax + r.delivery_price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.total_amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.internal_shipping_handling))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.kreenex_fee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity_charge))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.national_tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.insurance))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.delivery_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.discount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.purchases_by_user))]),_vm._v(" "),_c('td',{staticClass:"action-td"},[_c('div',{staticClass:"action-container",staticStyle:{"display":"flex"}},[(_vm.$_has_perm('view_order_detail'))?_c('a',{staticStyle:{"color":"#01579b","padding":"0px 6px"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.initDetail('modal_showApp', r.order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v(" No Results Found ")])],1)])],2)]),_vm._v(" "),_c('view-order-details',{attrs:{"detialData":_vm.detialData,"closeModal":_vm.closeModal}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Purchase History")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_city_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300346f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_city_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_city_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_300346f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_city_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1048);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0b658d10", content, true, {});

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditCity_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35317477_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditCity_vue__ = __webpack_require__(1052);
function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditCity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35317477_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditCity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1051);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b00d4d58", content, true, {});

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditCityModal),callback:function ($$v) {_vm.addEditCityModal=$$v},expression:"addEditCityModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update City' : 'Add New City')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.governorates,"item-value":"value","error-messages":_vm.errors.collect('governorate_id'),"data-vv-name":"governorate_id","label":"Governorate*","single-line":""},model:{value:(_vm.formData.governorate_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "governorate_id_fk", $$v)},expression:"formData.governorate_id_fk"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name *","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.formData.city_name),callback:function ($$v) {_vm.$set(_vm.formData, "city_name", $$v)},expression:"formData.city_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name (Arabic) *","error-messages":_vm.errors.collect('Name (Arabic)'),"data-vv-name":"Name (Arabic)"},model:{value:(_vm.formData.city_name_ar),callback:function ($$v) {_vm.$set(_vm.formData, "city_name_ar", $$v)},expression:"formData.city_name_ar"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name (Kurdish) *","error-messages":_vm.errors.collect('Name (Kurdish)'),"data-vv-name":"Name (Kurdish)"},model:{value:(_vm.formData.city_name_ku),callback:function ($$v) {_vm.$set(_vm.formData, "city_name_ku", $$v)},expression:"formData.city_name_ku"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_city: 'add_city'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addCityButton":true,"openAddCityModal":_vm.openAddCityModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.city_id},[_c('td',[_vm._v(_vm._s(r.city_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.governorate_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.city_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.city_name_ar))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.city_name_ku))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_city'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditCityModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_city'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteCity(r.city_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-city',{attrs:{"addEditCityModal":_vm.addEditCityModal,"formData":_vm.formData,"governorates":_vm.governorates,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditCityModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Cities")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_governorate_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb4b946_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_governorate_vue__ = __webpack_require__(1061);
function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_governorate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb4b946_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_governorate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7228fe74", content, true, {});

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGovernorate_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e74d5fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGovernorate_vue__ = __webpack_require__(1060);
function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGovernorate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e74d5fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGovernorate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1059);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("193d974a", content, true, {});

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditGovernorateModal),callback:function ($$v) {_vm.addEditGovernorateModal=$$v},expression:"addEditGovernorateModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Governorate' : 'Add New Governorate')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Governorate Name *","error-messages":_vm.errors.collect('Governorate Name'),"data-vv-name":"Governorate Name"},model:{value:(_vm.formData.governorate_name),callback:function ($$v) {_vm.$set(_vm.formData, "governorate_name", $$v)},expression:"formData.governorate_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Governorate Name (Arabic) *","error-messages":_vm.errors.collect('Governorate Name (Arabic)'),"data-vv-name":"Governorate Name (Arabic)"},model:{value:(_vm.formData.governorate_name_ar),callback:function ($$v) {_vm.$set(_vm.formData, "governorate_name_ar", $$v)},expression:"formData.governorate_name_ar"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Governorate Name (Kurdish) *","error-messages":_vm.errors.collect('Governorate Name (Kurdish)'),"data-vv-name":"Governorate Name (Kurdish)"},model:{value:(_vm.formData.governorate_name_ku),callback:function ($$v) {_vm.$set(_vm.formData, "governorate_name_ku", $$v)},expression:"formData.governorate_name_ku"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_governorate: 'add_governorate',
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addGovernorateButton":true,"openAddGovernorateModal":_vm.openAddGovernorateModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.governorate_id},[_c('td',[_vm._v(_vm._s(r.governorate_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.governorate_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.governorate_name_ar))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.governorate_name_ku))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_governorate'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditGovernorateModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_governorate'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteGovernorate(r.governorate_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-governorate',{attrs:{"addEditGovernorateModal":_vm.addEditGovernorateModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditGovernorateModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Governorates")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reason_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358cc4d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reason_vue__ = __webpack_require__(1069);
function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_358cc4d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reason_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("282dd852", content, true, {});

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditReason_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e229036_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditReason_vue__ = __webpack_require__(1068);
function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditReason_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e229036_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditReason_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1067);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4bb662b7", content, true, {});

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditReasonModal),callback:function ($$v) {_vm.addEditReasonModal=$$v},expression:"addEditReasonModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Reason' : 'Add New Reason')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel Reason English*","error-messages":_vm.errors.collect('cancel_reason'),"data-vv-name":"cancel_reason"},model:{value:(_vm.formData.cancel_reason),callback:function ($$v) {_vm.$set(_vm.formData, "cancel_reason", $$v)},expression:"formData.cancel_reason"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel Reason Arabic*","error-messages":_vm.errors.collect('cancel_reason_ar'),"data-vv-name":"cancel_reason_ar"},model:{value:(_vm.formData.cancel_reason_ar),callback:function ($$v) {_vm.$set(_vm.formData, "cancel_reason_ar", $$v)},expression:"formData.cancel_reason_ar"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Cancel Reason Kurdish*","error-messages":_vm.errors.collect('cancel_reason_ku'),"data-vv-name":"cancel_reason_ku"},model:{value:(_vm.formData.cancel_reason_ku),callback:function ($$v) {_vm.$set(_vm.formData, "cancel_reason_ku", $$v)},expression:"formData.cancel_reason_ku"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_reason: 'add_reason'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addReasonButton":true,"openAddReasonModal":_vm.openAddReasonModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.reason_id},[_c('td',[_vm._v(_vm._s(r.reason_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.cancel_reason))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.cancel_reason_ar))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.cancel_reason_ku))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_reason'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditReasonModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_reason'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteReason(r.reason_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-reason',{attrs:{"addEditReasonModal":_vm.addEditReasonModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditReasonModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Cancellation Reasons")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abf6e7e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__(1077);
function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abf6e7e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("532f0713", content, true, {});

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditAbout_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25dd3cee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditAbout_vue__ = __webpack_require__(1076);
function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditAbout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25dd3cee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5909aca8", content, true, {});

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditAboutModal),callback:function ($$v) {_vm.addEditAboutModal=$$v},expression:"addEditAboutModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update About' : 'Add New About')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Title*","error-messages":_vm.errors.collect('title'),"data-vv-name":"title"},model:{value:(_vm.formData.title),callback:function ($$v) {_vm.$set(_vm.formData, "title", $$v)},expression:"formData.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"URL*","error-messages":_vm.errors.collect('url'),"data-vv-name":"url"},model:{value:(_vm.formData.url),callback:function ($$v) {_vm.$set(_vm.formData, "url", $$v)},expression:"formData.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min:1'),expression:"'required|numeric|min:1'"}],attrs:{"label":"Order","type":"number","min":"1","error-messages":_vm.errors.collect('order'),"data-vv-name":"order"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{attrs:{"small":""},on:{"click":function($event){_vm.formData.order++}}},[_vm._v("mdi-plus")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){_vm.formData.order > 0 ? _vm.formData.order-- : 0}}},[_vm._v("mdi-minus")])]},proxy:true}]),model:{value:(_vm.formData.order),callback:function ($$v) {_vm.$set(_vm.formData, "order", $$v)},expression:"formData.order"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Is Active","color":"success"},model:{value:(_vm.formData.is_active),callback:function ($$v) {_vm.$set(_vm.formData, "is_active", $$v)},expression:"formData.is_active"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_about: 'add_about'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addAboutButton":true,"openAddAboutModal":_vm.openAddAboutModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.about_id},[_c('td',[_vm._v(_vm._s(r.about_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.title))]),_vm._v(" "),_c('td',[(r.url && r.url.length > 70)?_c('span',[_vm._v("\n                  "+_vm._s(r.url.slice(0, 70) + '...')+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.url)+"\n                ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order))]),_vm._v(" "),_c('td',[_c('v-switch',{attrs:{"input-value":r.is_active,"color":"success","inset":""},on:{"change":function($event){return _vm.updateActive(r)}},model:{value:(r.is_active),callback:function ($$v) {_vm.$set(r, "is_active", $$v)},expression:"r.is_active"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_about'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditAboutModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_about'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteAbout(r.about_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-about',{attrs:{"addEditAboutModal":_vm.addEditAboutModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditAboutModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("About App Section")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notFoundOrders_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dadf79c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notFoundOrders_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notFoundOrders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dadf79c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notFoundOrders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1080);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("dcf4c958", content, true, {});

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditNotFoundOrder_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f213faa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditNotFoundOrder_vue__ = __webpack_require__(1084);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditNotFoundOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f213faa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditNotFoundOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4f2ef18a", content, true, {});

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditNotFoundOrderModal),callback:function ($$v) {_vm.addEditNotFoundOrderModal=$$v},expression:"addEditNotFoundOrderModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Update Not Found Order' : 'Add New Not Found Order')+"\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name *","error-messages":_vm.errors.collect('Product Name'),"data-vv-name":"Product Name"},model:{value:(_vm.formData.product_name),callback:function ($$v) {_vm.$set(_vm.formData, "product_name", $$v)},expression:"formData.product_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Weight","error-messages":_vm.errors.collect('Weight'),"data-vv-name":"Weight"},model:{value:(_vm.formData.item_weight),callback:function ($$v) {_vm.$set(_vm.formData, "item_weight", $$v)},expression:"formData.item_weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Track Number","error-messages":_vm.errors.collect('Track Number'),"data-vv-name":"Track Number"},model:{value:(_vm.formData.track_number),callback:function ($$v) {_vm.$set(_vm.formData, "track_number", $$v)},expression:"formData.track_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order Number","error-messages":_vm.errors.collect('Order Number'),"data-vv-name":"Order Number"},model:{value:(_vm.formData.order_number),callback:function ($$v) {_vm.$set(_vm.formData, "order_number", $$v)},expression:"formData.order_number"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n            "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_convertToOrder_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c41ce7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_convertToOrder_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_convertToOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c41ce7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_convertToOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ec505b54", content, true, {});

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.convertToOrderModal),callback:function ($$v) {_vm.convertToOrderModal=$$v},expression:"convertToOrderModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              Convert To Order\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('customer'),"data-vv-name":"customer","label":"Customer*"},model:{value:(_vm.formData.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "customer_id_fk", $$v)},expression:"formData.customer_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Name *","error-messages":_vm.errors.collect('Product Name'),"data-vv-name":"Product Name"},model:{value:(_vm.formData.product_name),callback:function ($$v) {_vm.$set(_vm.formData, "product_name", $$v)},expression:"formData.product_name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},model:{value:(_vm.formData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "warehouse_id_fk", $$v)},expression:"formData.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.orderStatusList,"error-messages":_vm.errors.collect('Status'),"data-vv-name":"Status","label":"Status*"},model:{value:(_vm.formData.status_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "status_id_fk", $$v)},expression:"formData.status_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('quantity'),"data-vv-name":"quantity"},model:{value:(_vm.formData.quantity),callback:function ($$v) {_vm.$set(_vm.formData, "quantity", $$v)},expression:"formData.quantity"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Weight","error-messages":_vm.errors.collect('Weight'),"data-vv-name":"Weight"},model:{value:(_vm.formData.item_weight),callback:function ($$v) {_vm.$set(_vm.formData, "item_weight", $$v)},expression:"formData.item_weight"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Track Number","error-messages":_vm.errors.collect('Track Number'),"data-vv-name":"Track Number"},model:{value:(_vm.formData.track_number),callback:function ($$v) {_vm.$set(_vm.formData, "track_number", $$v)},expression:"formData.track_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order Number","error-messages":_vm.errors.collect('Order Number'),"data-vv-name":"Order Number"},model:{value:(_vm.formData.order_number),callback:function ($$v) {_vm.$set(_vm.formData, "order_number", $$v)},expression:"formData.order_number"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n            Save\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_not_found_order: 'add_not_found_order'
        },"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addNotFoundOrderButton":true,"openAddNotFoundOrderModal":_vm.openAddNotFoundOrderModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm9":"","md9":"","lg6":""}},[_c('v-select',{attrs:{"items":_vm.statusList,"label":"Statuses","multiple":"","chips":"","hide-details":"","deletable-chips":""},model:{value:(_vm.tableData.statuses),callback:function ($$v) {_vm.$set(_vm.tableData, "statuses", $$v)},expression:"tableData.statuses"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 pt-3",attrs:{"xs12":"","sm3":"","md3":"","lg6":""}},[_c('v-btn',{staticClass:"pa-1",staticStyle:{"height":"auto","transition":"all 0.1s"},attrs:{"color":"primary","depressed":"","small":""},on:{"click":function($event){return _vm.getResults()}}},[_vm._v("\n              Search\n            ")])],1)],1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.not_found_order_id,class:{
                'red lighten-2': r.status == 2,
                'green lighten-2': r.status == 3,
                'blue lighten-2': r.status == 4,
                'grey lighten-2': r.status == 5,
              }},[_c('td',[_vm._v(_vm._s(r.not_found_order_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.status_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_weight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.track_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[(_vm.$_has_perm('edit_not_found_order') && r.status == 1)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.edit(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('trash_not_found_order') && r.status == 1)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Trash"},on:{"click":function($event){return _vm.trash(r.not_found_order_id)}}},[_c('i',{staticClass:"fa fa-trash error--text",staticStyle:{"font-size":"20px"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('allow_to_send_not_found_order') && r.status == 1)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Allow to send"},on:{"click":function($event){return _vm.allowToSend(r.not_found_order_id)}}},[_c('i',{staticClass:"fa fa-check success--text",staticStyle:{"font-size":"20px"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('sent_not_found_order') && r.status == 3)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Send"},on:{"click":function($event){return _vm.send(r.not_found_order_id)}}},[_c('i',{staticClass:"fa fa-send warning--text",staticStyle:{"font-size":"20px"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('convert_to_order_not_found_order') && r.status == 4)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Convert to order"},on:{"click":function($event){return _vm.convertToOrder(r)}}},[_c('i',{staticClass:"fa fa-plus purple--text",staticStyle:{"font-size":"20px"}})]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-not-found-order',{attrs:{"addEditNotFoundOrderModal":_vm.addEditNotFoundOrderModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditNotFoundOrderModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('convert-to-order',{attrs:{"convertToOrderModal":_vm.convertToOrderModal,"formData":_vm.formData,"customers":_vm.customers,"warehouses":_vm.warehouses},on:{"close":function($event){_vm.convertToOrderModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Not Found Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCases_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177ceacc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCases_vue__ = __webpack_require__(1099);
function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCases_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_177ceacc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCases_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("747156d0", content, true, {});

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}a{position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:0;bottom:110%;white-space:nowrap;z-index:20;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1094);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3e8a6f12", content, true, {});

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.sendToStaffModal),callback:function ($$v) {_vm.sendToStaffModal=$$v},expression:"sendToStaffModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n              Send to staff\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),(_vm.sendToStaffModal)?_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-size-large pb-2 px-2",attrs:{"xs12":""}},[_c('b',[_vm._v("Case ID: ")]),_vm._v(" "+_vm._s(_vm.formData.order_case_id_fk)+"\n            ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-size-large pb-2 px-2",attrs:{"xs12":""}},[_c('b',[_vm._v("Order ID: ")]),_vm._v(" "+_vm._s(_vm.formData.theOrderID)+"\n            ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-size-large pb-2 px-2",attrs:{"xs12":""}},[_c('b',[_vm._v("Customer: ")]),_vm._v(" "+_vm._s(_vm.formData.full_name)+"\n            ")]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.staffList,"error-messages":_vm.errors.collect('Staff'),"data-vv-name":"Staff","label":"Staff*","single-line":""},model:{value:(_vm.formData.user_id_fk),callback:function ($$v) {_vm.$set(_vm.formData, "user_id_fk", $$v)},expression:"formData.user_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 pb-4 mb-1",attrs:{"xs12":""}},[_c('label',{staticClass:"d-block mb-1"},[_vm._v("Deadline")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.deadline),expression:"formData.deadline"}],staticClass:"base-date-picker",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.formData.deadline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "deadline", $event.target.value)}}})])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n            Send\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1097);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("79aa78cb", content, true, {});

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.orderCaseFileModal),callback:function ($$v) {_vm.orderCaseFileModal=$$v},expression:"orderCaseFileModal"}},[_c('v-card',[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n            Order Case Images\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',{staticClass:"pb-3 px-2",staticStyle:{"font-size":"1.6rem"},attrs:{"xs12":""}},[_c('b',[_vm._v("Case ID: ")]),_vm._v(" "+_vm._s(_vm.formData.order_case_id)+"\n        ")]),_vm._v(" "),(_vm.formData.order_case_id)?_c('order-images',{attrs:{"formData":_vm.formData,"url":"api/order-case-file","singleStoreUrl":"api/order-case-file/single-store","filenameKey":"file_name","modelFk":"order_case_id_fk","modelPk":"order_case_id"}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("\n          Cancel\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm9":"","md9":"","lg6":""}},[_c('v-select',{attrs:{"items":_vm.statusList,"label":"Statuses","multiple":"","chips":"","hide-details":"","deletable-chips":""},model:{value:(_vm.tableData.statuses),callback:function ($$v) {_vm.$set(_vm.tableData, "statuses", $$v)},expression:"tableData.statuses"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 pt-3",attrs:{"xs12":"","sm3":"","md3":"","lg6":""}},[_c('v-btn',{staticClass:"pa-1",staticStyle:{"height":"auto","transition":"all 0.1s"},attrs:{"color":"primary","depressed":"","small":""},on:{"click":function($event){return _vm.getResults()}}},[_vm._v("\n              Search\n            ")])],1)],1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_case_id,class:{
                'orange lighten-2': r.status == 2,
                'red lighten-2': r.status == 3,
                'blue lighten-2': r.status == 4,
              }},[_c('td',[_vm._v(_vm._s(r.order_case_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.status_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_name))]),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[(_vm.$_has_perm('comment_order_case'))?_c('comment',{staticClass:"px-2",attrs:{"modelId":r.order_case_id,"modelName":"Order Case","title":("Order Case #" + (r.order_case_id) + " Comments")}}):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_staff_order_case') && [1,2].includes(r.status))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Send to staff"},on:{"click":function($event){return _vm.sendToStaff(r)}}},[_c('v-icon',{attrs:{"color":"success darken-2"}},[_vm._v("send")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_order_case') && r.status == 1)?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Process"},on:{"click":function($event){return _vm.process(r.order_case_id)}}},[_c('i',{staticClass:"fa fa-cog warning--text",staticStyle:{"font-size":"22px"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('refund_order_case') && [1,2].includes(r.status))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Refund"},on:{"click":function($event){return _vm.refund(r.order_case_id)}}},[_c('i',{staticClass:"material-icons error--text"},[_vm._v("block")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('replace_order_case') && r.status == 2)?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Replace"},on:{"click":function($event){return _vm.replace(r.order_case_id)}}},[_c('i',{staticClass:"fa fa-refresh info--text",staticStyle:{"font-size":"22px"}})]):_vm._e(),_vm._v(" "),([1,2].includes(r.status))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Images"},on:{"click":function($event){return _vm.showCaseFiles(r)}}},[_c('i',{staticClass:"fa fa-image grey--text text--darken-2",staticStyle:{"font-size":"22px"}})]):_vm._e()],1)])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-order-case',{attrs:{"addEditOrderCaseModal":_vm.addEditOrderCaseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditOrderCaseModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('send-to-staff',{attrs:{"sendToStaffModal":_vm.sendToStaffModal,"formData":_vm.formData,"staffList":_vm.staffList},on:{"close":function($event){_vm.sendToStaffModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('order-case-files',{attrs:{"formData":_vm.formData,"orderCaseFileModal":_vm.orderCaseFileModal},on:{"close":function($event){_vm.orderCaseFileModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Order Cases")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCaseUsers_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0b2fa7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCaseUsers_vue__ = __webpack_require__(1103);
function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderCaseUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0b2fa7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderCaseUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0080f25f", content, true, {});

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_case_user_id},[_c('td',[_vm._v(_vm._s(r.order_case_id_fk))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.theOrderID))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.sent_by))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.deadline,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[(_vm.$_has_perm('comment_order_case'))?_c('comment',{staticClass:"px-2",attrs:{"modelId":r.order_case_id_fk,"modelName":"Order Case","title":("Order Case #" + (r.order_case_id_fk) + " Comments")}}):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_to_staff_order_case') && [1,2].includes(r.status))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Send to staff"},on:{"click":function($event){return _vm.sendToStaff(r)}}},[_c('v-icon',{attrs:{"color":"success darken-2"}},[_vm._v("send")])],1):_vm._e(),_vm._v(" "),([1,2].includes(r.status))?_c('a',{staticClass:"px-2",attrs:{"tooltip":"Images"},on:{"click":function($event){return _vm.showCaseFiles(r)}}},[_c('i',{staticClass:"fa fa-image grey--text text--darken-2",staticStyle:{"font-size":"22px"}})]):_vm._e()],1)])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('send-to-staff',{attrs:{"sendToStaffModal":_vm.sendToStaffModal,"formData":_vm.formData,"staffList":_vm.staffList},on:{"close":function($event){_vm.sendToStaffModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('order-case-files',{attrs:{"formData":_vm.formData,"orderCaseFileModal":_vm.orderCaseFileModal},on:{"close":function($event){_vm.orderCaseFileModal = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Order Case Progress")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerRegistration_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bedcb7b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerRegistration_vue__ = __webpack_require__(1107);
function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerRegistration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bedcb7b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerRegistration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1106);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("09ba97de", content, true, {});

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":"","sm10":"","md10":"","lg5":"","xl5":""}},[_c('v-card',{attrs:{"raised":""}},[_c('v-tabs',{attrs:{"slider-color":"blue","grow":""},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',[_vm._v("\n            Login\n          ")]),_vm._v(" "),_c('v-tab',[_vm._v("\n            Signup\n          ")]),_vm._v(" "),_c('v-tab-item',[_c('v-card',[_c('v-card-text',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone number","error-messages":_vm.errors.collect('Phone number'),"data-vv-name":"Phone number"},model:{value:(_vm.loginForm.phone_number),callback:function ($$v) {_vm.$set(_vm.loginForm, "phone_number", $$v)},expression:"loginForm.phone_number"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Password","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"error-messages":_vm.errors.collect('Password'),"data-vv-name":"Password"},model:{value:(_vm.loginForm.password),callback:function ($$v) {_vm.$set(_vm.loginForm, "password", $$v)},expression:"loginForm.password"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"success","depressed":""}},[_vm._v("\n                        Login "),_c('i',{staticClass:"fa fa-arrow-right ml-2"})])],1)])])])],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(!_vm.showOtpInput)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signup()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 mt-20 pt-1 text-right",staticStyle:{"font-size":"1.5rem"}},[_vm._v("\n                      +964\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-11"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone number","placeholder":"7701234567","error-messages":_vm.errors.collect('Phone number'),"data-vv-name":"Phone number"},model:{value:(_vm.signupForm.phone_number),callback:function ($$v) {_vm.$set(_vm.signupForm, "phone_number", $$v)},expression:"signupForm.phone_number"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"primary","depressed":""}},[_vm._v("\n                        Next "),_c('i',{staticClass:"fa fa-arrow-right ml-2"})])],1)])]):_vm._e(),_vm._v(" "),(_vm.showOtpInput)?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.verifyOtpCode()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Code","error-messages":_vm.errors.collect('Code'),"data-vv-name":"Code"},model:{value:(_vm.signupForm.otp_code),callback:function ($$v) {_vm.$set(_vm.signupForm, "otp_code", $$v)},expression:"signupForm.otp_code"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('v-btn',{staticStyle:{"height":"auto","width":"100%"},attrs:{"type":"submit","color":"primary","depressed":""}},[_vm._v("\n                        Next "),_c('i',{staticClass:"fa fa-arrow-right ml-2"})])],1)])]):_vm._e()])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeSlider_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c986f5c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeSlider_vue__ = __webpack_require__(1115);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c986f5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c986f5c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("06751106", content, true, {});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".my-btn[data-v-1c986f5c]{color:#fff;border-radius:.5rem;display:inline-block;text-align:center;padding:4px 10px;cursor:pointer}@media screen and (max-width:600px){th[data-v-1c986f5c]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-1c986f5c]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-1c986f5c]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-1c986f5c]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-1c986f5c]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-1c986f5c]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-1c986f5c]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-1c986f5c]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-1c986f5c]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-1c986f5c]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-1c986f5c]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditHomeSlider_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be75fd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditHomeSlider_vue__ = __webpack_require__(1114);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditHomeSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9be75fd0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditHomeSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1113);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57b41b38", content, true, {});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditHomeSliderModal),callback:function ($$v) {_vm.addEditHomeSliderModal=$$v},expression:"addEditHomeSliderModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Home Slider' : 'Add New Home Slider')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('input',{ref:"sliderImageRef",staticStyle:{"position":"absolute","visibility":"hidden","top":"-9999999"},attrs:{"type":"file","accept":"image/*"},on:{"input":function($event){return _vm.imageSelected()}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"image-upload",staticStyle:{"width":"100%","height":"200px"},style:(_vm.form.imageUrl
                      ? ("background-image: url(" + (_vm.form.imageUrl) + ")")
                      : ''),on:{"click":function($event){return _vm.chooseImage()}}},[_c('div',{staticClass:"image-upload-icon text-center",style:(_vm.form.imageUrl ? 'display: none' : '')},[_c('i',{staticClass:"fa fa-cloud"}),_vm._v(" "),_c('span',{staticClass:"d-block text-caption text--secondary"},[_vm._v("\n                      Upload image\n                    ")])])])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Title","error-messages":_vm.errors.collect('Title'),"data-vv-name":"Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", _vm._n($$v))},expression:"form.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"URL","error-messages":_vm.errors.collect('URL')},model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", _vm._n($$v))},expression:"form.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order *","error-messages":_vm.errors.collect('Order'),"data-vv-name":"Order"},model:{value:(_vm.form.order),callback:function ($$v) {_vm.$set(_vm.form, "order", _vm._n($$v))},expression:"form.order"}})],1),_vm._v(" "),(_vm.isUpdate)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Active","color":"success"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Home Slider (App)")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New Home Slider\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},_vm._l((_vm.apiData),function(data){return _c('div',{key:data.home_slider_id,staticClass:"col-12 col-sm-6 col-md-4 col-lg-2 mb-3"},[_c('div',{staticClass:"pb-2",staticStyle:{"border":"1px solid #ccc","border-radius":"1rem"}},[_c('div',{staticStyle:{"width":"100%","height":"200px"}},[_c('img',{staticStyle:{"border-radius":"1rem","object-fit":"cover"},attrs:{"src":("" + (_vm.$_image_path()) + (data.image)),"alt":"Image","width":"100%","height":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"px-2 py-1",staticStyle:{"font-size":"1.5rem","opacity":"0.7"}},[_vm._v("\n            #"+_vm._s(data.order)+"\n\n            "),(!data.is_active)?_c('span',{staticClass:"label bg-orange-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("Inactive")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"px-2"},[_c('div',{staticStyle:{"display":"inline"}},[_c('div',{staticClass:"mr-4",staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn blue",on:{"click":function($event){return _vm.editRow(data)}}},[_vm._v("\n                  Edit\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn error",on:{"click":function($event){return _vm.deleteRow(data.home_slider_id)}}},[_vm._v("\n                  Delete\n                ")])])])])])])}),0)]),_vm._v(" "),_c('add-edit-home-slider',{attrs:{"addEditHomeSliderModal":_vm.addEditHomeSliderModal,"form":_vm.form,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditHomeSliderModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeBanner_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a5b887_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeBanner_vue__ = __webpack_require__(1119);
function injectStyle (ssrContext) {
  __webpack_require__(1117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homeBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a5b887_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homeBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1118);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("be34048e", content, true, {});

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".switchbutton .input-group__details{min-height:0!important}.switchbutton{margin-top:10px!important}.error{background-color:#fff!important;border-color:#fff!important}.input-group__details{min-height:0!important}.switch{margin-top:10px!important}", ""]);

// exports


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"form"},[_c('div',{staticClass:"panel-heading d-flex"},[_c('h4',{staticClass:"col-md-6 panel-title"},[_vm._v("Mobile Home Banner (App)")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"col-md-12 d-flex"},[_c('v-switch',{attrs:{"label":"Is Counter"},model:{value:(_vm.form.is_datetime),callback:function ($$v) {_vm.$set(_vm.form, "is_datetime", $$v)},expression:"form.is_datetime"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Is Active"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","color":"white"},attrs:{"color":"green","depressed":""},on:{"click":_vm.save}},[_vm._v("\n          Save\n        ")])],1)])]),_vm._v(" "),_c('div',[_c('v-card',{staticStyle:{"margin":"10px"}},[_c('v-card-text',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('v-text-field',{attrs:{"label":"Title","rules":_vm.titleRules},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('v-text-field',{attrs:{"label":"Title Arabic","rules":_vm.titleArRules},model:{value:(_vm.form.title_ar),callback:function ($$v) {_vm.$set(_vm.form, "title_ar", $$v)},expression:"form.title_ar"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('v-text-field',{attrs:{"label":"Title Kurdish","rules":_vm.titleKuRules},model:{value:(_vm.form.title_ku),callback:function ($$v) {_vm.$set(_vm.form, "title_ku", $$v)},expression:"form.title_ku"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"font-size":"14px","margin-bottom":"-8px"},style:({ color: _vm.descriptionError ? 'red' : 'inherit', opacity: _vm.descriptionError ? 1 : 0.8 }),attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}}),_vm._v(" "),(_vm.descriptionError)?_c('div',{staticClass:"error",staticStyle:{"color":"red","font-size":"12px"}},[_vm._v(_vm._s(_vm.descriptionError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"font-size":"14px","margin-bottom":"-8px"},style:({ color: _vm.descriptionArError ? 'red' : 'inherit', opacity: _vm.descriptionArError ? 1 : 0.8 }),attrs:{"for":"description_ar"}},[_vm._v("Description Arabic")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description_ar),expression:"form.description_ar"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.form.description_ar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description_ar", $event.target.value)}}}),_vm._v(" "),(_vm.descriptionArError)?_c('div',{staticClass:"error",staticStyle:{"color":"red","font-size":"12px"}},[_vm._v(_vm._s(_vm.descriptionArError))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"font-size":"14px","margin-bottom":"-8px"},style:({ color: _vm.descriptionKuError ? 'red' : 'inherit', opacity: _vm.descriptionKuError ? 1 : 0.8 }),attrs:{"for":"description_ku"}},[_vm._v("Description Kurdish")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description_ku),expression:"form.description_ku"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.form.description_ku)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description_ku", $event.target.value)}}}),_vm._v(" "),(_vm.descriptionKuError)?_c('div',{staticClass:"error",staticStyle:{"color":"red","font-size":"12px"}},[_vm._v(_vm._s(_vm.descriptionKuError))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Start Date","type":"datetime-local","rules":_vm.startDateRules},model:{value:(_vm.form.start_date),callback:function ($$v) {_vm.$set(_vm.form, "start_date", $$v)},expression:"form.start_date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"End Date","type":"datetime-local","rules":_vm.endDateRules},model:{value:(_vm.form.end_date),callback:function ($$v) {_vm.$set(_vm.form, "end_date", $$v)},expression:"form.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('v-text-field',{attrs:{"label":"Color","type":"color","rules":_vm.colorRules},model:{value:(_vm.form.color),callback:function ($$v) {_vm.$set(_vm.form, "color", $$v)},expression:"form.color"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('v-text-field',{attrs:{"label":"Color Dark","type":"color","rules":_vm.colorRules},model:{value:(_vm.form.color_dark),callback:function ($$v) {_vm.$set(_vm.form, "color_dark", $$v)},expression:"form.color_dark"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('v-text-field',{attrs:{"label":"Background Color","type":"color","rules":_vm.colorRules},model:{value:(_vm.form.bgcolor),callback:function ($$v) {_vm.$set(_vm.form, "bgcolor", $$v)},expression:"form.bgcolor"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('v-text-field',{attrs:{"label":"Background Color Dark","type":"color","rules":_vm.colorRules},model:{value:(_vm.form.bgcolor_dark),callback:function ($$v) {_vm.$set(_vm.form, "bgcolor_dark", $$v)},expression:"form.bgcolor_dark"}})],1)])])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popularWebsite_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0280e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popularWebsite_vue__ = __webpack_require__(1127);
function injectStyle (ssrContext) {
  __webpack_require__(1121)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d0280e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popularWebsite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d0280e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popularWebsite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1122);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0ea8412f", content, true, {});

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".my-btn[data-v-5d0280e6]{color:#fff;border-radius:.5rem;display:inline-block;text-align:center;padding:4px 10px;cursor:pointer}@media screen and (max-width:600px){th[data-v-5d0280e6]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-5d0280e6]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-5d0280e6]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-5d0280e6]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-5d0280e6]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-5d0280e6]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-5d0280e6]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-5d0280e6]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-5d0280e6]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-5d0280e6]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-5d0280e6]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditPopularWebsite_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8940754e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditPopularWebsite_vue__ = __webpack_require__(1126);
function injectStyle (ssrContext) {
  __webpack_require__(1124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditPopularWebsite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8940754e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditPopularWebsite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("55a4826a", content, true, {});

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditPopularWebsiteModal),callback:function ($$v) {_vm.addEditPopularWebsiteModal=$$v},expression:"addEditPopularWebsiteModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Popular Website' : 'Add New Popular Website')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('input',{ref:"websiteLogoRef",staticStyle:{"position":"absolute","visibility":"hidden","top":"-9999999"},attrs:{"type":"file","accept":"image/*"},on:{"input":function($event){return _vm.imageSelected()}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"image-upload",staticStyle:{"width":"100%","height":"200px"},style:(_vm.form.logoUrl
                      ? ("background-image: url(" + (_vm.form.logoUrl) + ")")
                      : ''),on:{"click":function($event){return _vm.chooseImage()}}},[_c('div',{staticClass:"image-upload-icon text-center",style:(_vm.form.logoUrl ? 'display: none' : '')},[_c('i',{staticClass:"fa fa-cloud"}),_vm._v(" "),_c('span',{staticClass:"d-block text-caption text--secondary"},[_vm._v("\n                      Upload logo\n                    ")])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"URL","error-messages":_vm.errors.collect('URL'),"data-vv-name":"URL"},model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", _vm._n($$v))},expression:"form.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order *","error-messages":_vm.errors.collect('Order'),"data-vv-name":"Order"},model:{value:(_vm.form.order),callback:function ($$v) {_vm.$set(_vm.form, "order", _vm._n($$v))},expression:"form.order"}})],1),_vm._v(" "),(_vm.isUpdate)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Active","color":"success"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Popular Website (App)")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New Popular Website\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},_vm._l((_vm.apiData),function(data,index){return _c('div',{key:index,staticClass:"col-12 col-sm-6 col-md-4 col-lg-2 mb-3"},[_c('div',{staticClass:"pb-2",staticStyle:{"border":"1px solid #ccc","border-radius":"1rem"}},[_c('div',{staticStyle:{"width":"100%","height":"150px"}},[_c('a',{attrs:{"href":data.url,"target":"_blank"}},[_c('img',{staticStyle:{"border-radius":"1rem","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (data.logo)),"alt":"Logo","width":"100%","height":"100%"}})])]),_vm._v(" "),_c('div',{staticClass:"px-2 py-1",staticStyle:{"font-size":"1.5rem","opacity":"0.7"}},[_vm._v("\n            #"+_vm._s(data.order)+"\n\n            "),(data.warehouse)?_c('span',{staticClass:"label bg-grey-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("\n              "+_vm._s(data.warehouse ? data.warehouse.country : '')+"\n            ")]):_vm._e(),_vm._v(" "),(!data.is_active)?_c('span',{staticClass:"label bg-orange-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("\n              Inactive\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"px-2"},[_c('div',{staticStyle:{"display":"inline"}},[_c('div',{staticClass:"mr-4",staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn blue",on:{"click":function($event){return _vm.editRow(data)}}},[_vm._v("\n                  Edit\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn error",on:{"click":function($event){return _vm.deleteRow(data.home_slider_id)}}},[_vm._v("\n                  Delete\n                ")])])])])])])}),0)]),_vm._v(" "),_c('add-edit-popular-website',{attrs:{"addEditPopularWebsiteModal":_vm.addEditPopularWebsiteModal,"form":_vm.form,"warehouses":_vm.warehouses,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditPopularWebsiteModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_globalWebsiteGroup_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_029ede26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalWebsiteGroup_vue__ = __webpack_require__(1135);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-029ede26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_globalWebsiteGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_029ede26_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalWebsiteGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a79a500c", content, true, {});

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".my-btn[data-v-029ede26]{color:#fff;border-radius:.5rem;display:inline-block;text-align:center;padding:4px 10px;cursor:pointer}@media screen and (max-width:600px){th[data-v-029ede26]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-029ede26]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-029ede26]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-029ede26]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-029ede26]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-029ede26]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-029ede26]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-029ede26]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-029ede26]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-029ede26]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-029ede26]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGlobalWebsiteGroup_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e063ecee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGlobalWebsiteGroup_vue__ = __webpack_require__(1134);
function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGlobalWebsiteGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e063ecee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGlobalWebsiteGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("769a2eb6", content, true, {});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditGlobalWebsiteGroupModal),callback:function ($$v) {_vm.addEditGlobalWebsiteGroupModal=$$v},expression:"addEditGlobalWebsiteGroupModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Group' : 'Add New Group')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", _vm._n($$v))},expression:"form.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order *","error-messages":_vm.errors.collect('Order'),"data-vv-name":"Order"},model:{value:(_vm.form.order),callback:function ($$v) {_vm.$set(_vm.form, "order", _vm._n($$v))},expression:"form.order"}})],1),_vm._v(" "),(_vm.isUpdate)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Active","color":"success"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Global Website Group (App)")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New Group\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},_vm._l((_vm.apiData),function(data,index){return _c('div',{key:index,staticClass:"col-12 col-sm-6 col-md-4 col-lg-2 mb-3"},[_c('div',{staticClass:"pa-2",staticStyle:{"border":"1px solid #ccc","border-radius":"1rem"}},[_c('div',{staticStyle:{"font-size":"1.7rem","font-weight":"500"}},[_vm._v("\n            "+_vm._s(data.name)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:" py-1",staticStyle:{"font-size":"1.5rem","opacity":"0.7"}},[_vm._v("\n            #"+_vm._s(data.order)+"\n\n            "),(!data.is_active)?_c('span',{staticClass:"label bg-orange-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("Inactive")]):_vm._e()]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"display":"inline"}},[_c('div',{staticClass:"mr-2",staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn teal",on:{"click":function($event){return _vm.viewSites(data)}}},[_vm._v("\n                  Sites\n                ")])]),_vm._v(" "),_c('div',{staticClass:"mr-2",staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn blue",on:{"click":function($event){return _vm.editRow(data)}}},[_vm._v("\n                  Edit\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn error",on:{"click":function($event){return _vm.deleteRow(data.global_website_group_id)}}},[_vm._v("\n                  Delete\n                ")])])])])])])}),0)]),_vm._v(" "),_c('add-edit-global-website-group',{attrs:{"addEditGlobalWebsiteGroupModal":_vm.addEditGlobalWebsiteGroupModal,"form":_vm.form,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditGlobalWebsiteGroupModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_globalWebsite_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d6c888_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalWebsite_vue__ = __webpack_require__(1143);
function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24d6c888"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_globalWebsite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d6c888_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_globalWebsite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1138);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2c4a4a60", content, true, {});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".my-btn[data-v-24d6c888]{color:#fff;border-radius:.5rem;display:inline-block;text-align:center;padding:4px 10px;cursor:pointer}@media screen and (max-width:600px){th[data-v-24d6c888]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-24d6c888]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-24d6c888]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-24d6c888]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-24d6c888]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-24d6c888]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-24d6c888]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-24d6c888]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-24d6c888]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-24d6c888]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-24d6c888]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGlobalWebsite_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c21e502a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGlobalWebsite_vue__ = __webpack_require__(1142);
function injectStyle (ssrContext) {
  __webpack_require__(1140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditGlobalWebsite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c21e502a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditGlobalWebsite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4b32a266", content, true, {});

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditGlobalWebsiteModal),callback:function ($$v) {_vm.addEditGlobalWebsiteModal=$$v},expression:"addEditGlobalWebsiteModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Global Website' : 'Add New Global Website')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('input',{ref:"globalWebsiteLogoRef",staticStyle:{"position":"absolute","visibility":"hidden","top":"-9999999"},attrs:{"type":"file","accept":"image/*"},on:{"input":function($event){return _vm.imageSelected()}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"image-upload",staticStyle:{"width":"100%","height":"200px"},style:(_vm.form.logoUrl
                      ? ("background-image: url(" + (_vm.form.logoUrl) + ")")
                      : ''),on:{"click":function($event){return _vm.chooseImage()}}},[_c('div',{staticClass:"image-upload-icon text-center",style:(_vm.form.logoUrl ? 'display: none' : '')},[_c('i',{staticClass:"fa fa-cloud"}),_vm._v(" "),_c('span',{staticClass:"d-block text-caption text--secondary"},[_vm._v("\n                      Upload logo\n                    ")])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"URL","error-messages":_vm.errors.collect('URL'),"data-vv-name":"URL"},model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", _vm._n($$v))},expression:"form.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*"},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Order *","error-messages":_vm.errors.collect('Order'),"data-vv-name":"Order"},model:{value:(_vm.form.order),callback:function ($$v) {_vm.$set(_vm.form, "order", _vm._n($$v))},expression:"form.order"}})],1),_vm._v(" "),(_vm.isUpdate)?_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":"Active","color":"success"},model:{value:(_vm.form.is_active),callback:function ($$v) {_vm.$set(_vm.form, "is_active", $$v)},expression:"form.is_active"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title",staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"my-btn grey darken-1 mr-3",staticStyle:{"font-size":"1.2rem"},on:{"click":function($event){return _vm.$router.push('/global-website-group')}}},[_c('i',{staticClass:"fa fa-arrow-left mr-1"}),_vm._v("\n        Back\n      ")]),_vm._v(" "),_c('span',{staticClass:"mr-1",staticStyle:{"color":"tomato","font-weight":"bold"}},[_vm._v("\n        "+_vm._s(_vm.apiData.name)+"\n      ")]),_vm._v("\n      Websites (App)\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New Global Website\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},_vm._l((_vm.apiData.details),function(data,index){return _c('div',{key:index,staticClass:"col-12 col-sm-6 col-md-4 col-lg-2 mb-3"},[_c('div',{staticClass:"pb-2",staticStyle:{"border":"1px solid #ccc","border-radius":"1rem"}},[_c('div',{staticStyle:{"width":"100%","height":"150px"}},[_c('a',{attrs:{"href":data.url,"target":"_blank"}},[_c('img',{staticStyle:{"border-radius":"1rem","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (data.logo)),"alt":"Logo","width":"100%","height":"100%"}})])]),_vm._v(" "),_c('div',{staticClass:"px-2 py-1",staticStyle:{"font-size":"1.5rem","opacity":"0.7"}},[_vm._v("\n            #"+_vm._s(data.order)+"\n\n            "),(data.warehouse)?_c('span',{staticClass:"label bg-grey-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("\n              "+_vm._s(data.warehouse ? data.warehouse.country : '')+"\n            ")]):_vm._e(),_vm._v(" "),(!data.is_active)?_c('span',{staticClass:"label bg-orange-800 ml-2",staticStyle:{"border-radius":"0.5rem","text-transform":"none"}},[_vm._v("Inactive")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"px-2"},[_c('div',{staticStyle:{"display":"inline"}},[_c('div',{staticClass:"mr-4",staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn blue",on:{"click":function($event){return _vm.editRow(data)}}},[_vm._v("\n                  Edit\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('div',{staticClass:"my-btn error",on:{"click":function($event){return _vm.deleteRow(data.global_website_id)}}},[_vm._v("\n                  Delete\n                ")])])])])])])}),0)]),_vm._v(" "),_c('add-edit-global-website',{attrs:{"addEditGlobalWebsiteModal":_vm.addEditGlobalWebsiteModal,"form":_vm.form,"warehouses":_vm.warehouses,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditGlobalWebsiteModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDeliveries_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fd8973_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDeliveries_vue__ = __webpack_require__(1151);
function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDeliveries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fd8973_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDeliveries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("285fded2", content, true, {});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDeliveryInvoice_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d6f424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDeliveryInvoice_vue__ = __webpack_require__(1150);
function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderDeliveryInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d6f424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderDeliveryInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65e84d96", content, true, {});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "#print-area{max-width:850px}.modal{text-align:center;padding:0!important}.modal:before{content:\"\";height:100%;margin-right:-4px}.modal-dialog,.modal:before{display:inline-block;vertical-align:middle}.modal-dialog{text-align:left}@media screen and (max-width:650px){#credit-table-header,#price-section2{width:500px;padding-left:10px}#price-section2{padding-top:10px;font-size:15px}#price-section{width:280px}#company-info{width:100%}#header-img{width:60px;height:60px}#print-area{max-width:100%}}", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"orderDeliveryModal"}},[_c('div',{staticClass:"modal-dialog modal-full",staticStyle:{"max-width":"850px"},attrs:{"id":"print-area"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"id":"close-button","type":"button"},on:{"click":function($event){return _vm.closeModal('orderDeliveryModal')}}},[_vm._v("\n          ×\n        ")])]),_vm._v(" "),_c('table',{staticStyle:{"width":"100%"},attrs:{"id":"head-table"}},[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_c('table',{staticStyle:{"width":"100%","margin-left":"0px"},attrs:{"id":"company-info"}},[_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_name)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_address)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.company_email)+"\n                ")])]),_vm._v(" "),_c('tr',{staticClass:"header-table"},[_c('td',{staticStyle:{"font-size":"14px","padding-right":"20px"}},[_vm._v("\n                  "+_vm._s(_vm.companyData.phone_number)+"\n                ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body mx-2"},[_vm._m(1),_vm._v(" "),_c('table',{staticClass:"app-print-table app-print-table-all-border"},[_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Customer Name")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.viewData.order.customer.full_name))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Customer Phone")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.viewData.order.customer.phone_number))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Customer Phone 2")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.viewData.order.customer.phone_number_2))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Address")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.viewData.order.customer.address))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Delivery Price")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v("$"+_vm._s(_vm.viewData.delivery_price))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"w-50"},[_vm._v("Invoice No.")]),_vm._v(" "),_c('td',{staticClass:"w-50"},[_vm._v(_vm._s(_vm.viewData.invoice_number))])])]),_vm._v(" "),_c('div',{staticStyle:{"float":"right"}},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"id":"print-button","outline":"","color":"primary"},on:{"click":_vm.printInvoice}},[_vm._v("Print")])],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"padding-left":"20px"}},[_c('img',{staticStyle:{"width":"110px","height":"100px"},attrs:{"id":"header-img","src":__webpack_require__(12),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticStyle:{"width":"100%"},attrs:{"id":"print-table1"}},[_c('tr',[_c('td',{staticClass:"text-align-center",staticStyle:{"border":"1px solid #212121","padding":"6px"}},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("\n                Order Delivery Invoice\n              ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"hideBranch":true,"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm9":"","md9":"","lg6":""}},[_c('v-select',{attrs:{"items":_vm.statusList,"label":"Statuses","multiple":"","chips":"","hide-details":"","deletable-chips":""},model:{value:(_vm.tableData.statuses),callback:function ($$v) {_vm.$set(_vm.tableData, "statuses", $$v)},expression:"tableData.statuses"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2 pt-3",attrs:{"xs12":"","sm3":"","md3":"","lg6":""}},[_c('v-btn',{staticClass:"pa-1",staticStyle:{"height":"auto","transition":"all 0.1s"},attrs:{"color":"primary","depressed":"","small":""},on:{"click":function($event){return _vm.getResults()}}},[_vm._v("\n              Search\n            ")])],1)],1),_vm._v(" "),_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.order_delivery_id,class:{
                'red lighten-2': r.status == 2,
                'blue lighten-3': r.status == 3,
                'green lighten-2': r.status == 4,
              }},[_c('td',[_vm._v(_vm._s(r.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_name))]),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.customer_phone2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.status_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.delivery_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"d-flex"},[_c('a',{staticClass:"mx-1",staticStyle:{"color":"#424242"},attrs:{"tooltip":"View Invoice"},on:{"click":function($event){return _vm.initDetail('orderDeliveryModal', r.order_delivery_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")])]),_vm._v(" "),(_vm.$_has_perm('send_order_delivery') && r.status == 1)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Send"},on:{"click":function($event){return _vm.send(r.order_delivery_id)}}},[_c('i',{staticClass:"fa fa-send blue--text",staticStyle:{"font-size":"20px"}})]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('receive_order_delivery') && r.status == 3)?_c('a',{staticClass:"mx-1",attrs:{"tooltip":"Receive"},on:{"click":function($event){return _vm.receive(r.order_delivery_id)}}},[_c('i',{staticClass:"fa fa-check success--text",staticStyle:{"font-size":"20px"}})]):_vm._e()])])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('order-detail-invoice',{attrs:{"viewData":_vm.viewData,"closeModal":_vm.closeModal,"companyData":_vm.companyData}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Order Delivery")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendNotification_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac419fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendNotification_vue__ = __webpack_require__(1155);
function injectStyle (ssrContext) {
  __webpack_require__(1153)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ac419fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sendNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac419fa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sendNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f71c08ac", content, true, {});

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-7ac419fa]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-7ac419fa]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-7ac419fa]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.page-stats[data-v-7ac419fa]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-7ac419fa]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-7ac419fa]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-7ac419fa]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-7ac419fa]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 px-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('v-checkbox',{attrs:{"label":"Send To All","color":"success","disabled":_vm.customersList.length === 0,"dense":""},model:{value:(_vm.form.addall),callback:function ($$v) {_vm.$set(_vm.form, "addall", $$v)},expression:"form.addall"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[(_vm.showSearch)?_c('v-select',{attrs:{"autocomplete":"","items":_vm.customersList,"item-value":"value","label":"Select Customer","return-object":"","clearable":"","single-line":""},on:{"input":function($event){return _vm.customerSelected()}},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}}):_c('v-text-field',{attrs:{"label":"Customer"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('table',{staticClass:"table table-framed"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedCustomers),function(customer,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(index +1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(customer.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(customer.phone_number))]),_vm._v(" "),_c('td',[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.removeCustomer(index)}}},[_c('i',{staticClass:"fa fa-close",staticStyle:{"font-size":"20px","color":"red"}})])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 px-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-text-field',{attrs:{"label":"Body"},model:{value:(_vm.form.body),callback:function ($$v) {_vm.$set(_vm.form, "body", $$v)},expression:"form.body"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n              Send\n            ")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title"},[_vm._v("\n      Send Notification\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"50px"}},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Phone Number")]),_vm._v(" "),_c('th',{staticStyle:{"width":"50px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingExportOrder_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56df69e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingExportOrder_vue__ = __webpack_require__(1173);
function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pendingExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56df69e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pendingExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1158);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7f58aafa", content, true, {});

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3d0fea18", content, true, {});

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.cancelDialog),callback:function ($$v) {_vm.cancelDialog=$$v},expression:"cancelDialog"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Cancel Export Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Cancel Note"},model:{value:(_vm.form.cancel_note),callback:function ($$v) {_vm.$set(_vm.form, "cancel_note", $$v)},expression:"form.cancel_note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("28baaecd", content, true, {});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.detail-table .section-title{padding-left:0;padding-top:0;opacity:.7}.detail-table tr td{padding:3px 10px;font-size:14px}", ""]);

// exports


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px","scrollable":""},model:{value:(_vm.detailDialog),callback:function ($$v) {_vm.detailDialog=$$v},expression:"detailDialog"}},[_c('v-card',{staticStyle:{"border-radius":"8px"}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Export Order Detail")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[(_vm.instance.image)?_c('div',{staticStyle:{"width":"150px","height":"150px","border":"1px solid #ccc","margin-bottom":"10px","border-radius":"6px"}},[_c('a',{attrs:{"href":("" + (_vm.$_image_path()) + (_vm.instance.image)),"target":"_blank"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (_vm.instance.image)),"alt":"Product Image"}})])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"detail-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Order Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Order Number")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.order_number))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Customer Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.customer.full_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Customer Note")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.customer.customer_note))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Customer Phone")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.customer.phone_number))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Product Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.product_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Quantity")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.quantity))])]),_vm._v(" "),(_vm.instance.weight)?_c('tr',[_c('td',[_c('b',[_vm._v("Weight")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.weight)+" "+_vm._s(_vm.instance.weight ? _vm.instance.weight_unit : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_l)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (L)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_l))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_w)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (W)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_w))])]):_vm._e(),_vm._v(" "),(_vm.instance.volume_h)?_c('tr',[_c('td',[_c('b',[_vm._v("Volume (H)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.volume_h))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Price Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Shipping")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.shipping)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("International Tax")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.national_tax)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Delivery")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.delivery_price)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Discount")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.discount)))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Price")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.price)))])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Status Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Status")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label px-2",class:{
                    'bg-orange-600': _vm.instance.status === 1,
                    'bg-indigo-600': _vm.instance.status === 2,
                    'bg-danger-600': _vm.instance.status === 3,
                    'bg-green-600': _vm.instance.status === 4,
                    'bg-primary-600': _vm.instance.status === 5,
                    'bg-teal-600': _vm.instance.status === 6,
                    'bg-purple-600': _vm.instance.status === 7
                  },staticStyle:{"border-radius":"6px","text-transform":"capitalize","font-size":"11px"}},[_vm._v("\n                    "+_vm._s(_vm.instance.status_text)+"\n                  ")])])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Ordered At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.created_at,"YYYY-MM-DD hh:mm a")))])]),_vm._v(" "),(_vm.instance.canceled_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Canceled At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.canceled_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.canceled_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Canceled By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.canceled_by ? _vm.instance.canceled_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.approved_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Approved At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.approved_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.approved_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Approved By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.approved_by ? _vm.instance.approved_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.sent_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Sent At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.sent_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.sent_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Sent By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.sent_by ? _vm.instance.sent_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.received_at)?_c('tr',[_c('td',[_c('b',[_vm._v("Received At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.received_at,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.received_by)?_c('tr',[_c('td',[_c('b',[_vm._v("Received By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.received_by ? _vm.instance.received_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.status === 7 && _vm.instance.last_refund_date)?_c('tr',[_c('td',[_c('b',[_vm._v("Refunded At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.last_refund_date,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.status === 7 && _vm.instance.refunds && _vm.instance.refunds.length > 0)?_c('tr',[_c('td',[_c('b',[_vm._v("Refunded By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.refunds[0].created_by ? _vm.instance.refunds[0].created_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.is_fully_refunded)?_c('tr',[_c('td',[_c('b',[_vm._v("Refund Status")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label bg-purple-600",staticStyle:{"border-radius":"6px","font-size":"11px","color":"white","padding":"4px 8px"}},[_vm._v("\n                    Fully Refunded\n                  ")])])]):_vm._e(),_vm._v(" "),(_vm.instance.total_refunded_amount > 0 && !_vm.instance.is_fully_refunded && _vm.instance.last_refund_date)?_c('tr',[_c('td',[_c('b',[_vm._v("Partially Refunded At")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.instance.last_refund_date,"YYYY-MM-DD hh:mm a")))])]):_vm._e(),_vm._v(" "),(_vm.instance.total_refunded_amount > 0 && !_vm.instance.is_fully_refunded && _vm.instance.refunds && _vm.instance.refunds.length > 0)?_c('tr',[_c('td',[_c('b',[_vm._v("Partially Refunded By")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.refunds[0].created_by ? _vm.instance.refunds[0].created_by.full_name : ''))])]):_vm._e(),_vm._v(" "),(_vm.instance.total_refunded_amount > 0 && !_vm.instance.is_fully_refunded)?_c('tr',[_c('td',[_c('b',[_vm._v("Refund Status")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label bg-orange-600",staticStyle:{"border-radius":"6px","font-size":"11px","color":"white","padding":"4px 8px"}},[_vm._v("\n                    Partially Refunded\n                  ")])])]):_vm._e(),_vm._v(" "),(_vm.instance.total_refunded_amount > 0)?_c('tr',[_c('td',[_c('b',[_vm._v("Total Refunded Amount")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(_vm.instance.total_refunded_amount)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"section-title"},[_vm._v("Receiver Info")])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Name")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Phone")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_phone))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Email")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_email))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Country")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.to_country ? _vm.instance.to_country.country_name : ''))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("City")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_city))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("Address")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_address))])]),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v("ZIP Code")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.instance.receiver_zip_code))])])])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"py-1 px-2",staticStyle:{"height":"auto"},attrs:{"outline":"","small":""},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n            Cancel\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processExportOrder_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9786a416_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processExportOrder_vue__ = __webpack_require__(1168);
function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9786a416_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1167);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b16ef924", content, true, {});

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.processDialog),callback:function ($$v) {_vm.processDialog=$$v},expression:"processDialog"}},[_c('v-card',{staticStyle:{"border-radius":"16px"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Process Export Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"row mx-0 mb-4"},[_c('div',{staticClass:"col-xs-4",staticStyle:{"font-size":"14px"}},[_c('b',[_vm._v("Order No.:")]),_vm._v(" "+_vm._s(_vm.form.order_number)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-4",staticStyle:{"font-size":"14px"}},[_c('b',[_vm._v("Customer:")]),_vm._v(" "+_vm._s(_vm.form.customer.full_name)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-4",staticStyle:{"font-size":"14px"}},[_c('b',[_vm._v("Country:")]),_vm._v(" "+_vm._s(_vm.form.to_country.country_name)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"col-md-4"},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.weightUnitList,"error-messages":_vm.errors.collect('Weight Unit'),"data-vv-name":"Weight Unit","autocomplete":""},model:{value:(_vm.form.weight_unit),callback:function ($$v) {_vm.$set(_vm.form, "weight_unit", $$v)},expression:"form.weight_unit"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Shipping"},on:{"input":function($event){return _vm.calcPrice()}},model:{value:(_vm.form.shipping),callback:function ($$v) {_vm.$set(_vm.form, "shipping", $$v)},expression:"form.shipping"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"International Tax"},on:{"input":function($event){return _vm.calcPrice()}},model:{value:(_vm.form.national_tax),callback:function ($$v) {_vm.$set(_vm.form, "national_tax", $$v)},expression:"form.national_tax"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Delivery Price"},on:{"input":function($event){return _vm.calcPrice()}},model:{value:(_vm.form.delivery_price),callback:function ($$v) {_vm.$set(_vm.form, "delivery_price", $$v)},expression:"form.delivery_price"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Discount"},on:{"input":function($event){return _vm.calcPrice()}},model:{value:(_vm.form.discount),callback:function ($$v) {_vm.$set(_vm.form, "discount", $$v)},expression:"form.discount"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Total","error-messages":_vm.errors.collect('Total'),"data-vv-name":"Total","readonly":""},model:{value:(_vm.form.price),callback:function ($$v) {_vm.$set(_vm.form, "price", $$v)},expression:"form.price"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"From Date","type":"date","error-messages":_vm.errors.collect('From Date'),"data-vv-name":"From Date"},model:{value:(_vm.form.from_date),callback:function ($$v) {_vm.$set(_vm.form, "from_date", $$v)},expression:"form.from_date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"To Date","type":"date","error-messages":_vm.errors.collect('To Date'),"data-vv-name":"To Date"},model:{value:(_vm.form.to_date),callback:function ($$v) {_vm.$set(_vm.form, "to_date", $$v)},expression:"form.to_date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Description","error-messages":_vm.errors.collect('Description'),"data-vv-name":"Description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Process Note","error-messages":_vm.errors.collect('Process Note'),"data-vv-name":"Process Note"},model:{value:(_vm.form.process_note),callback:function ($$v) {_vm.$set(_vm.form, "process_note", $$v)},expression:"form.process_note"}})],1)])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-4",staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("\n            Save\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditExportOrder_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766d74e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditExportOrder_vue__ = __webpack_require__(1172);
function injectStyle (ssrContext) {
  __webpack_require__(1170)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-766d74e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_766d74e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1171);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e5c35a7c", content, true, {});

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".panel-heading h4[data-v-766d74e4]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-766d74e4]{overflow-x:hidden!important}", ""]);

// exports


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.addEditDialog),callback:function ($$v) {_vm.addEditDialog=$$v},expression:"addEditDialog"}},[_c('v-card',{staticStyle:{"border-radius":"16px"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.form.export_order_id ? 'Update Export Order' : 'Add Export Order'))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"row mx-1"},[_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","error-messages":_vm.errors.collect('Customer'),"data-vv-name":"Customer","label":"Customer*"},model:{value:(_vm.form.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "customer_id_fk", $$v)},expression:"form.customer_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Product Description*","error-messages":_vm.errors.collect('Product Description'),"data-vv-name":"Product Description"},model:{value:(_vm.form.product_name),callback:function ($$v) {_vm.$set(_vm.form, "product_name", $$v)},expression:"form.product_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|min_value:1'),expression:"'required|numeric|min_value:1'"}],attrs:{"label":"Quantity*","error-messages":_vm.errors.collect('Quantity'),"data-vv-name":"Quantity"},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('v-text-field',{attrs:{"label":"Weight"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.weightUnitList,"error-messages":_vm.errors.collect('Weight Unit'),"data-vv-name":"Weight Unit","autocomplete":""},model:{value:(_vm.form.weight_unit),callback:function ($$v) {_vm.$set(_vm.form, "weight_unit", $$v)},expression:"form.weight_unit"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._v("Dimensions Per Package "),_c('span',{staticClass:"inch-div"},[_vm._v("(inch)")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Length","type":"number"},model:{value:(_vm.form.volume_l),callback:function ($$v) {_vm.$set(_vm.form, "volume_l", $$v)},expression:"form.volume_l"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Width","type":"number"},model:{value:(_vm.form.volume_w),callback:function ($$v) {_vm.$set(_vm.form, "volume_w", $$v)},expression:"form.volume_w"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('v-text-field',{attrs:{"label":"Height","type":"number"},model:{value:(_vm.form.volume_h),callback:function ($$v) {_vm.$set(_vm.form, "volume_h", $$v)},expression:"form.volume_h"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3"},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","name":"image","id":"image"},on:{"input":function($event){_vm.form.image = $event.target.files[0]}}}),_vm._v(" "),_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image"}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" Upload Image\n                "),_c('i',{staticClass:"pl-1"},[_vm._v(_vm._s(_vm.form.image ? _vm.form.image.name : ''))])])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"row mx-1"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v("Receiver Detail")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name*","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.form.receiver_name),callback:function ($$v) {_vm.$set(_vm.form, "receiver_name", $$v)},expression:"form.receiver_name"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Phone*","error-messages":_vm.errors.collect('Phone'),"data-vv-name":"Phone"},model:{value:(_vm.form.receiver_phone),callback:function ($$v) {_vm.$set(_vm.form, "receiver_phone", $$v)},expression:"form.receiver_phone"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Address*","error-messages":_vm.errors.collect('Address'),"data-vv-name":"Address"},model:{value:(_vm.form.receiver_address),callback:function ($$v) {_vm.$set(_vm.form, "receiver_address", $$v)},expression:"form.receiver_address"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"City*","error-messages":_vm.errors.collect('City'),"data-vv-name":"City"},model:{value:(_vm.form.receiver_city),callback:function ($$v) {_vm.$set(_vm.form, "receiver_city", $$v)},expression:"form.receiver_city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|integer'),expression:"'required|integer'"}],attrs:{"label":"Zip Code*","error-messages":_vm.errors.collect('Zip Code'),"type":"number","data-vv-name":"Zip Code"},model:{value:(_vm.form.receiver_zip_code),callback:function ($$v) {_vm.$set(_vm.form, "receiver_zip_code", $$v)},expression:"form.receiver_zip_code"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.countryList,"item-value":"value","error-messages":_vm.errors.collect('Destination'),"data-vv-name":"Destination","label":"Destination*"},model:{value:(_vm.form.to_country_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "to_country_id_fk", $$v)},expression:"form.to_country_id_fk"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('v-text-field',{attrs:{"label":"Email*","type":"email"},model:{value:(_vm.form.receiver_email),callback:function ($$v) {_vm.$set(_vm.form, "receiver_email", $$v)},expression:"form.receiver_email"}})],1)])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-4",staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("\n            Save\n          ")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addNewExportOrderButton":true,"permissions":{
          add_permission: 'add_export_order',
        },"openAddNewExportOrderModal":_vm.openAddNewExportOrderModal,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('edit_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#2E7Dff"},attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.editRow(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('process_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#333"},attrs:{"tooltip":"Process"},on:{"click":function($event){return _vm.process(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("settings")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel"},on:{"click":function($event){return _vm.openCancelDialog(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-export-order',{attrs:{"addEditDialog":_vm.addEditDialog,"form":_vm.form,"customers":_vm.customers},on:{"close":function($event){_vm.addEditDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('process-export-order',{attrs:{"processDialog":_vm.processDialog,"form":_vm.instance},on:{"close":function($event){_vm.processDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("New Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedExportOrder_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7715c9df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedExportOrder_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_processedExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7715c9df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_processedExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fd957b10", content, true, {});

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('approve_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#43a047"},attrs:{"tooltip":"Approve"},on:{"click":function($event){return _vm.approve(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('cancel_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#C62828"},attrs:{"tooltip":"Cancel"},on:{"click":function($event){return _vm.openCancelDialog(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Processed Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundedExportOrder_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946dad84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundedExportOrder_vue__ = __webpack_require__(1181);
function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refundedExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_946dad84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundedExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1180);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5119b74c", content, true, {});

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}.label-danger{background-color:#d32f2f}.label-danger,.label-warning{color:#fff;padding:4px 8px;border-radius:3px;font-weight:500}.label-warning{background-color:#f57c00}", ""]);

// exports


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.total_refunded_amount)))]),_vm._v(" "),_c('td',[(r.is_fully_refunded)?_c('span',{staticClass:"label label-danger"},[_vm._v("Fully Refunded")]):_c('span',{staticClass:"label label-warning"},[_vm._v("Partially Refunded")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Refunded Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canceledExportOrder_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcfcb040_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canceledExportOrder_vue__ = __webpack_require__(1185);
function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_canceledExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcfcb040_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_canceledExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7f29f436", content, true, {});

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Canceled Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approvedExportOrder_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_703c6124_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approvedExportOrder_vue__ = __webpack_require__(1192);
function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approvedExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_703c6124_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_approvedExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1188);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1b1be598", content, true, {});

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1190);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("4b7c777f", content, true, {});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"refund-export-order-modal"}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"530px"},model:{value:(_vm.refundDialog),callback:function ($$v) {_vm.refundDialog=$$v},expression:"refundDialog"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.refundType === 'full' ? 'Full Refund' : 'Partial Refund')+" Export Order")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":_vm.closeDialog}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n              Order refunded successfully\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('h5',[_vm._v("Order Total amount is $"+_vm._s(_vm.orderPrice.toFixed(2)))])]),_vm._v(" "),(_vm.alreadyRefunded > 0)?_c('v-flex',{attrs:{"sm12":""}},[_c('h6',[_vm._v("Already Refunded: $"+_vm._s(_vm.alreadyRefunded.toFixed(2)))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{attrs:{"label":"Money amount*","error-messages":_vm.errors.amount},on:{"input":function($event){_vm.errors.amount = ''}},model:{value:(_vm.refundData.amount),callback:function ($$v) {_vm.$set(_vm.refundData, "amount", $$v)},expression:"refundData.amount"}})],1),_vm._v(" "),(_vm.refundType === 'full')?_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{attrs:{"label":"Refund Reason*","error-messages":_vm.errors.refund_reason},on:{"input":function($event){_vm.errors.refund_reason = ''}},model:{value:(_vm.refundData.refund_reason),callback:function ($$v) {_vm.$set(_vm.refundData, "refund_reason", $$v)},expression:"refundData.refund_reason"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-text-field',{attrs:{"label":"Refund note"},model:{value:(_vm.refundData.refund_note),callback:function ($$v) {_vm.$set(_vm.refundData, "refund_note", $$v)},expression:"refundData.refund_note"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":_vm.closeDialog}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"4%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("Refund")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('send_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#4347a0"},attrs:{"tooltip":"Send"},on:{"click":function($event){return _vm.send(r.export_order_id)}}},[_c('i',{staticClass:"fa fa-plane",staticStyle:{"font-size":"20px"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#ff9800"},attrs:{"tooltip":"Partial Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'partial')}}},[_c('i',{staticClass:"fa fa-undo",staticStyle:{"font-size":"18px"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#d32f2f"},attrs:{"tooltip":"Full Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'full')}}},[_c('i',{staticClass:"fa fa-reply-all",staticStyle:{"font-size":"18px"}})])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('refund-export-order',{attrs:{"refundDialog":_vm.refundDialog,"orderId":_vm.selectedOrderId,"refundType":_vm.selectedRefundType,"orderPrice":_vm.selectedOrderPrice,"alreadyRefunded":_vm.selectedAlreadyRefunded},on:{"close":function($event){_vm.refundDialog = false},"refund-success":_vm.handleRefundSuccess}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Approved Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sentExportOrder_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e680540_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sentExportOrder_vue__ = __webpack_require__(1196);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sentExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e680540_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sentExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6a67d5ec", content, true, {});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('receive_export_order'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#cc4347"},attrs:{"tooltip":"Receive"},on:{"click":function($event){return _vm.receive(r.export_order_id)}}},[_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"20px"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#ff9800"},attrs:{"tooltip":"Partial Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'partial')}}},[_c('i',{staticClass:"fa fa-undo",staticStyle:{"font-size":"18px"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#d32f2f"},attrs:{"tooltip":"Full Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'full')}}},[_c('i',{staticClass:"fa fa-reply-all",staticStyle:{"font-size":"18px"}})])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('refund-export-order',{attrs:{"refundDialog":_vm.refundDialog,"orderId":_vm.selectedOrderId,"refundType":_vm.selectedRefundType,"orderPrice":_vm.selectedOrderPrice,"alreadyRefunded":_vm.selectedAlreadyRefunded},on:{"close":function($event){_vm.refundDialog = false},"refund-success":_vm.handleRefundSuccess}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Sent Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receivedExportOrder_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_591ea46a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receivedExportOrder_vue__ = __webpack_require__(1200);
function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receivedExportOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_591ea46a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receivedExportOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1199);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e74300f0", content, true, {});

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#ff9800"},attrs:{"tooltip":"Partial Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'partial')}}},[_c('i',{staticClass:"fa fa-undo",staticStyle:{"font-size":"18px"}})])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('add_export_order_refund') && !r.is_fully_refunded)?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#d32f2f"},attrs:{"tooltip":"Full Refund"},on:{"click":function($event){return _vm.openRefundDialog(r.export_order_id, r.price, r.total_refunded_amount || 0, 'full')}}},[_c('i',{staticClass:"fa fa-reply-all",staticStyle:{"font-size":"18px"}})])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('refund-export-order',{attrs:{"refundDialog":_vm.refundDialog,"orderId":_vm.selectedOrderId,"refundType":_vm.selectedRefundType,"orderPrice":_vm.selectedOrderPrice,"alreadyRefunded":_vm.selectedAlreadyRefunded},on:{"close":function($event){_vm.refundDialog = false},"refund-success":_vm.handleRefundSuccess}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Received Export Orders")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportHistory_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca34a22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportHistory_vue__ = __webpack_require__(1204);
function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca34a22_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1203);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("112d48b8", content, true, {});

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0 5px!important}@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.icon-enlarge,.icon-pencil{color:navy}.icon-bin2{color:red}.icon-calendar{color:green}.btn{transition:all .5s}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.dialog:not(.dialog--fullscreen){max-height:95%}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"removeAddButton":true,"removeWarehouseDeliverButton":true,"addExportButton":true,"sendToExport":_vm.sendToExport,"checkAlert":_vm.checkAlert,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"resetGetResults2":_vm.resetGetResults2,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.export_order_id,style:(_vm.selectedRows.find(function (x) { return x == r.export_order_id; }) ? 'background-color: #FFF9C4' : '')},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRows),expression:"selectedRows"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.export_order_id],"checked":Array.isArray(_vm.selectedRows)?_vm._i(_vm.selectedRows,[r.export_order_id])>-1:(_vm.selectedRows)},on:{"change":function($event){var $$a=_vm.selectedRows,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.export_order_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedRows=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedRows=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedRows=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v("EX-"+_vm._s(r.order_number))]),_vm._v(" "),_c('td',{staticClass:"ws-nowrap"},[(r.full_name && r.full_name.trim().split(/\s+/).length > 3)?_c('span',{staticStyle:{"word-break":"break-word","white-space":"pre-line"}},[_vm._v("\n                  "+_vm._s(r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n'))+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(r.full_name)+"\n                ")]),_vm._v(" "),_c('open-whatsapp-and-viber',{attrs:{"phoneNumber":r.phone_number}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',{staticClass:"customer-note-color"},[_vm._v(" "+_vm._s(r.customer_note)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.product_name.substr(0, 35) +
                  (r.product_name.length > 35 ? '...' : '')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("usdFormat")(r.price)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.discount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.weight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.shipping))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.delivery_price))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.national_tax))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country_name))]),_vm._v(" "),_c('td',[(r.status == 5)?_c('span',[_vm._v("Sent")]):(r.status == 6)?_c('span',[_vm._v("Received")]):_c('span',[_vm._v(_vm._s(r.status))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,"YYYY-MM-DD hh:mm A")))]),_vm._v(" "),(_vm.$_has_perm('view_export_order_detail'))?_c('td',{staticStyle:{"padding":"0px 5px"}},[_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"View Details"},on:{"click":function($event){return _vm.showDetail(r.export_order_id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("aspect_ratio")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('view-export-order-details',{attrs:{"instance":_vm.instance,"detailDialog":_vm.detailDialog},on:{"close":function($event){_vm.detailDialog = false}}}),_vm._v(" "),_c('cancel-export-order',{attrs:{"cancelDialog":_vm.cancelDialog,"id":_vm.id},on:{"close":function($event){_vm.cancelDialog = false},"update-table":function($event){return _vm.getResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('pagination',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Export History")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currencyRate_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11123f7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currencyRate_vue__ = __webpack_require__(1212);
function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currencyRate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11123f7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currencyRate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1207);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("933c62c6", content, true, {});

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121a9ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__ = __webpack_require__(1211);
function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121a9ba2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1210);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("03db36f6", content, true, {});

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditModal),callback:function ($$v) {_vm.addEditModal=$$v},expression:"addEditModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Currency Rate' : 'Add New Currency Rate')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Exchange Rate *","error-messages":_vm.errors.collect('Exchange Rate'),"data-vv-name":"Exchange Rate","type":"number"},model:{value:(_vm.formData.ex_rate),callback:function ($$v) {_vm.$set(_vm.formData, "ex_rate", $$v)},expression:"formData.ex_rate"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_currency_rate: 'add_currency_rate'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"addCurrencyRateButton":true,"openAddCurrencyRateModal":_vm.openAddCurrencyRateModal,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.currency_rate_id},[_c('td',[_vm._v(_vm._s(r.currency_rate_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.ex_rate.toLocaleString()))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(r.created_at,'YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_currency_rate'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_currency_rate'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteRow(r.currency_rate_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit',{attrs:{"addEditModal":_vm.addEditModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Currency Rates")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouse_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c683f68a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouse_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1214)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warehouse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c683f68a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warehouse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1215);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("fd6d263c", content, true, {});

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opawarehouse:50!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditWarehouse_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982a30e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditWarehouse_vue__ = __webpack_require__(1219);
function injectStyle (ssrContext) {
  __webpack_require__(1217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditWarehouse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982a30e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditWarehouse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1218);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("40fa8134", content, true, {});

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditWarehouseModal),callback:function ($$v) {_vm.addEditWarehouseModal=$$v},expression:"addEditWarehouseModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("Update Warehouse")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Country *","error-messages":_vm.errors.collect('Country'),"data-vv-name":"Country"},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Name *","error-messages":_vm.errors.collect('Name'),"data-vv-name":"Name"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"City"},model:{value:(_vm.formData.city),callback:function ($$v) {_vm.$set(_vm.formData, "city", $$v)},expression:"formData.city"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Code"},model:{value:(_vm.formData.code),callback:function ($$v) {_vm.$set(_vm.formData, "code", $$v)},expression:"formData.code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Street"},model:{value:(_vm.formData.street),callback:function ($$v) {_vm.$set(_vm.formData, "street", $$v)},expression:"formData.street"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Phone Number"},model:{value:(_vm.formData.phone_number),callback:function ($$v) {_vm.$set(_vm.formData, "phone_number", $$v)},expression:"formData.phone_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"House Number"},model:{value:(_vm.formData.house_number),callback:function ($$v) {_vm.$set(_vm.formData, "house_number", $$v)},expression:"formData.house_number"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"State - Province"},model:{value:(_vm.formData.state_province),callback:function ($$v) {_vm.$set(_vm.formData, "state_province", $$v)},expression:"formData.state_province"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Prefix"},model:{value:(_vm.formData.prefix),callback:function ($$v) {_vm.$set(_vm.formData, "prefix", $$v)},expression:"formData.prefix"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.transportationTypes,"item-text":"name","item-value":"id","multiple":"","chips":"","label":"Transportation Types"},model:{value:(_vm.formData.transportation_type_ids),callback:function ($$v) {_vm.$set(_vm.formData, "transportation_type_ids", $$v)},expression:"formData.transportation_type_ids"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('label',{attrs:{"for":"logo"}},[_vm._v("Logo")]),_vm._v(" "),_c('input',{ref:"logoRef",attrs:{"type":"file","id":"logo","name":"logo","accept":"image/*"},on:{"input":function($event){return _vm.logoChange()}}})]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('label',{attrs:{"for":"logo"}},[_vm._v("Default Image")]),_vm._v(" "),_c('input',{ref:"defaultImageRef",attrs:{"type":"file","id":"logo","name":"logo","accept":"image/*"},on:{"input":function($event){return _vm.defaultImageChange()}}})])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_warehouse: 'add_warehouse'
        },"removeAddButton":true,"removeWarehouseDeliverButton":true,"openAddWarehouseModal":_vm.openAddWarehouseModal,"addWarehouseButton":true,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"filterTable":_vm.filterTable,"columns":_vm.columns,"showHideColumn":_vm.showHideColumn,"defaultHideCol":_vm.defaultHideCol,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult,"hideBranch":true}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('datatable',{attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders}},[_c('tbody',[_vm._l((_vm.apiResults),function(r){return _c('tr',{key:r.warehouse_id},[_c('td',[_vm._v(_vm._s(r.warehouse_id))]),_vm._v(" "),_c('td',[(r.logo)?_c('img',{staticStyle:{"border-radius":"4px","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (r.logo)),"alt":"Image","width":"100%","height":"70px"}}):_vm._e()]),_vm._v(" "),_c('td',[(r.default_image)?_c('img',{staticStyle:{"border-radius":"4px","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (r.default_image)),"alt":"Image","width":"100%","height":"70px"}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.prefix))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.name))]),_vm._v(" "),_c('td',[(r.transportation_types && r.transportation_types.length)?_vm._l((r.transportation_types),function(type){return _c('div',{key:type.id,staticClass:"mb-1",staticStyle:{"white-space":"nowrap"}},[_c('span',{staticClass:"mr-1",staticStyle:{"font-size":"14px"}},[_vm._v("\n                      "+_vm._s(type.icon)+"\n                    ")]),_vm._v("\n                    "+_vm._s(type.name)+"\n                  ")])}):_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.street))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.phone_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.house_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.state_province))]),_vm._v(" "),_c('td',[_c('v-switch',{attrs:{"color":"success","ripple":false},on:{"change":function($event){return _vm.changeActive(r)}},model:{value:(r.is_active),callback:function ($$v) {_vm.$set(r, "is_active", $$v)},expression:"r.is_active"}})],1),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_warehouse'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.openEditModal(r)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e()])])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"type":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]),_vm._v(" "),_c('add-edit-warehouse',{attrs:{"addEditWarehouseModal":_vm.addEditWarehouseModal,"formData":_vm.formData,"isUpdate":_vm.isUpdate,"transportationTypes":_vm.transportationTypes},on:{"close":function($event){_vm.addEditWarehouseModal = false},"resetTable":function($event){return _vm.resetGetResults()}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Warehouses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forceUpdate_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c089282_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forceUpdate_vue__ = __webpack_require__(1228);
function injectStyle (ssrContext) {
  __webpack_require__(1222)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c089282"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forceUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c089282_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forceUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1223);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("57cdd340", content, true, {});

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th[data-v-9c089282]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-9c089282]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-9c089282]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-9c089282]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-9c089282]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-9c089282]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-9c089282]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-9c089282]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-9c089282]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-9c089282]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-9c089282]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098b1d0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__ = __webpack_require__(1227);
function injectStyle (ssrContext) {
  __webpack_require__(1225)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098b1d0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("9fc9227a", content, true, {});

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditModal),callback:function ($$v) {_vm.addEditModal=$$v},expression:"addEditModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Force Update' : 'Add New Force Update')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('input',{ref:"imageRef",staticStyle:{"position":"absolute","visibility":"hidden","top":"-9999999"},attrs:{"type":"file","accept":"image/*"},on:{"input":function($event){return _vm.imageSelected()}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"image-upload",staticStyle:{"width":"100%","height":"200px"},style:(_vm.form.imageUrl
                      ? ("background-image: url(" + (_vm.form.imageUrl) + ")")
                      : ''),on:{"click":function($event){return _vm.chooseImage()}}},[_c('div',{staticClass:"image-upload-icon text-center",style:(_vm.form.imageUrl ? 'display: none' : '')},[_c('i',{staticClass:"fa fa-cloud"}),_vm._v(" "),_c('span',{staticClass:"d-block text-caption text--secondary"},[_vm._v("\n                      Upload image\n                    ")])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Title","error-messages":_vm.errors.collect('Title'),"data-vv-name":"Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", _vm._n($$v))},expression:"form.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Description","rows":"3","error-messages":_vm.errors.collect('Description'),"data-vv-name":"Description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", _vm._n($$v))},expression:"form.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],attrs:{"label":"Build Number","type":"number","error-messages":_vm.errors.collect('Build Number'),"data-vv-name":"Build Number"},model:{value:(_vm.form.build_number),callback:function ($$v) {_vm.$set(_vm.form, "build_number", _vm._n($$v))},expression:"form.build_number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.operatingSystems,"error-messages":_vm.errors.collect('Operating System'),"data-vv-name":"Operating System","label":"Operating System*"},model:{value:(_vm.form.operating_system),callback:function ($$v) {_vm.$set(_vm.form, "operating_system", $$v)},expression:"form.operating_system"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.types,"error-messages":_vm.errors.collect('Type'),"data-vv-name":"Type","label":"Type*"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Force Update")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[(_vm.$_has_perm('add_force_update'))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md4":"","lg3":"","xl3":""}},[_c('v-text-field',{attrs:{"label":"Search..."},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getData()}},model:{value:(_vm.queryParams.keyword),callback:function ($$v) {_vm.$set(_vm.queryParams, "keyword", $$v)},expression:"queryParams.keyword"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md4":"","lg3":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.operatingSystems,"label":"Operating System","clearable":""},on:{"input":function($event){return _vm.getData()}},model:{value:(_vm.queryParams.operating_system),callback:function ($$v) {_vm.$set(_vm.queryParams, "operating_system", $$v)},expression:"queryParams.operating_system"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md4":"","lg3":"","xl3":""}},[_c('v-select',{attrs:{"items":_vm.types,"label":"Type","clearable":""},on:{"input":function($event){return _vm.getData()}},model:{value:(_vm.queryParams.type),callback:function ($$v) {_vm.$set(_vm.queryParams, "type", $$v)},expression:"queryParams.type"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.apiData),function(data,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(data.build_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.operating_system))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.type))]),_vm._v(" "),_c('td',[(data.image)?_c('div',{staticStyle:{"width":"100px","height":"100px"}},[_c('img',{staticStyle:{"border-radius":"1rem","object-fit":"contain"},attrs:{"src":("" + (_vm.$_image_path()) + (data.image)),"alt":"Logo","width":"100%","height":"100%"}})]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(data.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_force_update'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.editRow(data)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_force_update'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteRow(data.force_update_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),0)])])],1),_vm._v(" "),_c('add-edit',{attrs:{"addEditModal":_vm.addEditModal,"form":_vm.form,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Build Number")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Operating System")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Created At")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ourAddress_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488f2ee0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ourAddress_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-488f2ee0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ourAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488f2ee0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ourAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("efcf0002", content, true, {});

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th[data-v-488f2ee0]{font-weight:700;color:#273246;padding-left:5px!important}td[data-v-488f2ee0]{padding-left:5px!important;padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4[data-v-488f2ee0]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.col-xs-12[data-v-488f2ee0]{padding-top:10px;padding-bottom:10px}.overlay--active[data-v-488f2ee0]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog[data-v-488f2ee0]{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats[data-v-488f2ee0]{align-items:center;position:relative;top:-8px;margin-right:5px}.has-error .select2-selection--single[data-v-488f2ee0]:not([class*=bg-]):not([class*=border-]){border-bottom-color:red}a[data-v-488f2ee0]:hover{color:#03a9f4;position:relative}a[tooltip][data-v-488f2ee0]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group[data-v-488f2ee0]{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63376914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__ = __webpack_require__(1235);
function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63376914_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1234);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("66e4c3d1", content, true, {});

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.image-upload-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-upload{border:1px dashed #ccc;cursor:pointer;position:relative;background-position:50%;background-size:cover;border-radius:6px}", ""]);

// exports


/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditModal),callback:function ($$v) {_vm.addEditModal=$$v},expression:"addEditModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticClass:"pb-0"},[_c('v-flex',{attrs:{"xs11":"","sm10":"","md10":""}},[_c('span',{staticClass:"headline"},[_vm._v("\n                "+_vm._s(_vm.isUpdate ? 'Update Our Address' : 'Add New Our Address')+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('warehouse_id_fk'),"data-vv-name":"warehouse_id_fk","label":"Warehouse*"},on:{"input":function($event){return _vm.handleSelectWarehouse(_vm.form.warehouse_id_fk)}},model:{value:(_vm.form.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.form, "warehouse_id_fk", $$v)},expression:"form.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.transportationTypes,"item-value":"id","item-text":"name","error-messages":_vm.errors.collect('Transportation Type'),"data-vv-name":"Transportation Type","label":"Transportation Type*"},model:{value:(_vm.form.transportation_type),callback:function ($$v) {_vm.$set(_vm.form, "transportation_type", $$v)},expression:"form.transportation_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Title *","error-messages":_vm.errors.collect('Title'),"data-vv-name":"Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"description"}},[_vm._v("\n                  Description\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticStyle:{"opacity":"0.8","font-size":"14px","margin-bottom":"-8px"},attrs:{"for":"note"}},[_vm._v("\n                  Note\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.note),expression:"form.note"}],staticClass:"form-control",staticStyle:{"border-bottom":"1px solid blue","font-size":"1.5rem"},attrs:{"rows":"4"},domProps:{"value":(_vm.form.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "note", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2%"},attrs:{"type":"submit","loading":_vm.loading,"outline":"","color":"success"}},[_vm._v("\n              "+_vm._s(_vm.isUpdate ? 'Save' : 'Add')+"\n            ")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel-heading d-flex align-center py-2"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Our Address")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"end"}},[(_vm.$_has_perm('add_our_address'))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.addNew()}}},[_vm._v("\n        Add New\n      ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3",attrs:{"sm12":"","md4":"","lg4":"","xl4":""}},[_c('v-text-field',{attrs:{"label":"Search...","hide-details":""},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getData()}},model:{value:(_vm.queryParams.keyword),callback:function ($$v) {_vm.$set(_vm.queryParams, "keyword", $$v)},expression:"queryParams.keyword"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.apiData),function(data,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(data.title))]),_vm._v(" "),_c('td',[_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(data.description))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.note))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.transby))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(data.created_at,'YYYY-MM-DD hh:mm a')))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_our_address'))?_c('a',{attrs:{"tooltip":"Edit"},on:{"click":function($event){return _vm.editRow(data)}}},[_c('v-icon',{attrs:{"color":"blue darken-2"}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_our_address'))?_c('a',{attrs:{"tooltip":"Delete"},on:{"click":function($event){return _vm.deleteRow(data.our_address_id)}}},[_c('v-icon',{attrs:{"color":"red darken-2"}},[_vm._v("delete")])],1):_vm._e()])])}),0)])])],1),_vm._v(" "),_c('add-edit',{attrs:{"addEditModal":_vm.addEditModal,"warehouses":_vm.warehouses,"form":_vm.form,"isUpdate":_vm.isUpdate},on:{"close":function($event){_vm.addEditModal = false},"resetTable":function($event){return _vm.getData()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Note")]),_vm._v(" "),_c('th',[_vm._v("Warehouse")]),_vm._v(" "),_c('th',[_vm._v("TransBy")]),_vm._v(" "),_c('th',[_vm._v("Created At")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscription_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197651b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscription_vue__ = __webpack_require__(1244);
function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_197651b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1239);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("49323462", content, true, {});

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table.table-bordered td,.table.table-bordered th{padding:2px 4px!important;font-size:13px!important;vertical-align:middle!important}.table.table-bordered input.form-control{height:20px!important;padding:2px 6px!important;font-size:13px!important}.table.table-bordered{margin-bottom:0}.btn.btn-danger.btn-sm,.btn.btn-sm{padding:2px 8px!important;font-size:12px!important}", ""]);

// exports


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSubscription_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6600a79e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSubscription_vue__ = __webpack_require__(1243);
function injectStyle (ssrContext) {
  __webpack_require__(1241)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6600a79e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6600a79e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1242);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("21ec5f70", content, true, {});

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active[data-v-6600a79e]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addEditSubscriptionModal),callback:function ($$v) {_vm.addEditSubscriptionModal=$$v},expression:"addEditSubscriptionModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add Subscription")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddEditSubscriptionModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Subscription Name*","error-messages":_vm.errors.collect('Subscription Name'),"data-vv-name":"Subscription Name"},model:{value:(_vm.addEditData.subscription_name),callback:function ($$v) {_vm.$set(_vm.addEditData, "subscription_name", $$v)},expression:"addEditData.subscription_name"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddEditSubscriptionModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2.5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('form',{attrs:{"id":"login_success99"},on:{"submit":function($event){$event.preventDefault();return _vm.phoneLogin.apply(null, arguments)}}},[_c('input',{attrs:{"type":"hidden","name":"_token","value":"QH65OXMU7MRnJg6UIS2LucakcxXX5LP88cFsEEwL"}}),_vm._v(" "),_c('input',{attrs:{"id":"csrf","type":"hidden","name":"csrf"}}),_vm._v(" "),_c('input',{attrs:{"id":"code","type":"hidden","name":"code"}}),_vm._v(" "),_c('button',{attrs:{"type":"submit","id":"phone"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitChanges.apply(null, arguments)}}},[_c('div',{staticClass:"panel-heading",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('h4',{staticClass:"panel-title",staticStyle:{"margin":"0"}},[_vm._v("Subscription")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":_vm.openAddEditSubscriptionModal}},[(_vm.$_has_perm('add_subscription'))?_c('v-icon',{staticClass:"fa fa-plus fa-lg mr-2",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}):_vm._e(),_vm._v("\n        Add New Subscription\n      ")],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.apiResults),function(item,idx){return _c('tr',{key:item.id || idx,style:(item.subscription_name.toLowerCase() === 'normal' ? 'background-color: #f5b767;' : '')},[_c('td',[_vm._v(_vm._s(item.subscription_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.subscription_name))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_subscription'))?_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit Subscription"},on:{"click":function($event){return _vm.editRecord(item, idx)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_subscription'))?_c('a',{staticStyle:{"color":"#B22708FF"},attrs:{"tooltip":"Delete Subscription"},on:{"click":function($event){return _vm.deleteRecord(item, idx)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e()])])}),0)])])])])]),_vm._v(" "),_c('add-edit-subscription',{attrs:{"addEditSubscriptionModal":_vm.addEditSubscriptionModal,"closeAddEditSubscriptionModal":_vm.closeAddEditSubscriptionModal,"submitAddEditSubscription":_vm.submitAddEditSubscription,"addEditData":_vm.addEditData}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Subscription Name")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userSubscription_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5c1aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userSubscription_vue__ = __webpack_require__(1252);
function injectStyle (ssrContext) {
  __webpack_require__(1246)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5c1aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userSubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("66ff7c7d", content, true, {});

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.customer-subscription-table th[data-v-7aa7ac64] span{white-space:pre-line;text-align:center}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a.disabled{pointer-events:none;color:gray}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditUserSubscription_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c822f80e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditUserSubscription_vue__ = __webpack_require__(1251);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditUserSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c822f80e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditUserSubscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("3d5fc0c5", content, true, {});

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent,.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}", ""]);

// exports


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.addEditCustomerSubscriptionModal),callback:function ($$v) {_vm.addEditCustomerSubscriptionModal=$$v},expression:"addEditCustomerSubscriptionModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.addEditData.user_subscription_id ? 'Edit' : 'Add')+" Customer Subscription")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddEditCustomerSubscriptionModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Staff added successfully\n          ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.customers,"item-value":"value","item-text":"text","error-messages":_vm.errors.collect('customer_id_fk'),"data-vv-name":"customer_id_fk","label":"Customer*","single-line":"","disabled":!!_vm.addEditData.user_subscription_id},model:{value:(_vm.addEditData.customer_id_fk),callback:function ($$v) {_vm.$set(_vm.addEditData, "customer_id_fk", $$v)},expression:"addEditData.customer_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*","multiple":"","chips":"","deletable-chips":"","disabled":!!_vm.addEditData.user_subscription_id},model:{value:(_vm.addEditData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.addEditData, "warehouse_id_fk", $$v)},expression:"addEditData.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.orderTypes,"item-value":"value","error-messages":_vm.errors.collect('order_type_id_fk'),"data-vv-name":"order_type_id_fk","label":"Order Type*","multiple":"","chips":"","deletable-chips":"","disabled":!!_vm.addEditData.user_subscription_id},model:{value:(_vm.addEditData.order_type_id_fk),callback:function ($$v) {_vm.$set(_vm.addEditData, "order_type_id_fk", $$v)},expression:"addEditData.order_type_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.subscriptions,"item-value":"value","error-messages":_vm.errors.collect('subscription_id'),"data-vv-name":"subscription_id","label":"Subscription*","single-line":""},model:{value:(_vm.addEditData.subscription_id),callback:function ($$v) {_vm.$set(_vm.addEditData, "subscription_id", $$v)},expression:"addEditData.subscription_id"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddEditCustomerSubscriptionModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_customer_subscription: 'add_customer_subscription',
          delete_customer_subscription: 'delete_customer_subscription',
        },"removeAddButton":true,"deleteAllSubscriptionButton":true,"deleteAllCustomerSubscription":_vm.deleteAllCustomerSubscription,"addEditCustomerSubscription":true,"removeWarehouseDeliverButton":true,"openAddEditCustomerSubscriptionModal":_vm.openAddEditCustomerSubscriptionModal,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"columns":_vm.columns,"hideSelectingColumn":true,"removeFromToDate":true,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{staticClass:"customer-subscription-table",attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.user_subscription_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userSubscriptionIds),expression:"userSubscriptionIds"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.user_subscription_id],"checked":Array.isArray(_vm.userSubscriptionIds)?_vm._i(_vm.userSubscriptionIds,[r.user_subscription_id])>-1:(_vm.userSubscriptionIds)},on:{"change":function($event){var $$a=_vm.userSubscriptionIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.user_subscription_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.userSubscriptionIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.userSubscriptionIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.userSubscriptionIds=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_subscription_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.user_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.subscription_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.type_name))]),_vm._v(" "),(_vm.$_has_perm('delete_customer_subscription'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[(_vm.$_has_perm('edit_subscription'))?_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit Subscription"},on:{"click":function($event){return _vm.editCustomerSubscription(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"color":"#DF0845FF"},attrs:{"tooltip":"Delete Customer Subscription"},on:{"click":function($event){return _vm.deleteCustomerSubscription(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-edit-user-subscription',{attrs:{"addEditCustomerSubscriptionModal":_vm.addEditCustomerSubscriptionModal,"submitAddEditUserSubscription":_vm.submitAddEditUserSubscription,"closeAddEditCustomerSubscriptionModal":_vm.closeAddEditCustomerSubscriptionModal,"warehouses":_vm.warehouses,"orderTypes":_vm.orderTypes,"customers":_vm.customers,"subscriptions":_vm.subscriptions,"addEditData":_vm.addEditData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Customer Subscriptions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscriptionPricing_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ca0862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscriptionPricing_vue__ = __webpack_require__(1260);
function injectStyle (ssrContext) {
  __webpack_require__(1254)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscriptionPricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87ca0862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscriptionPricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1255);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2b731962", content, true, {});

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "@media screen and (max-width:600px){th{font-weight:700;color:#273246}td,th{padding-left:5px!important}td{padding-top:10px!important;padding-bottom:10px!important}}.panel-heading h4{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.btn{transition:all .5s}.customer-subscription-table th[data-v-7aa7ac64] span{white-space:pre-line;text-align:center}.col-xs-12{padding-top:10px;padding-bottom:10px}.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden;overflow-y:hidden}.page-stats{align-items:center;position:relative;top:-8px;margin-right:5px}a.disabled{pointer-events:none;color:gray}a:hover{color:#03a9f4;position:relative}a[tooltip]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:80%;bottom:150%;white-space:nowrap;z-index:20;-moz-border-radius:3px;-webkit-border-radius:3px;border-radius:3px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}@media screen and (max-width:767px){.form-group{margin-top:0;margin-bottom:0}}", ""]);

// exports


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSubscriptionPricing_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d7a2f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSubscriptionPricing_vue__ = __webpack_require__(1259);
function injectStyle (ssrContext) {
  __webpack_require__(1257)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditSubscriptionPricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d7a2f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditSubscriptionPricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1258);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("339c3bf8", content, true, {});

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".dialog-dialog--active-dialog--persistent,.overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}.dialog:not(.dialog--fullscreen){max-height:95%}", ""]);

// exports


/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.addEditSubscriptionPricingModal),callback:function ($$v) {_vm.addEditSubscriptionPricingModal=$$v},expression:"addEditSubscriptionPricingModal"}},[_c('v-card',[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.addEditData.pricing_id ? 'Edit' : 'Add')+" Subscription Pricing")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddEditSubscriptionPricingModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"success","value":_vm.checkAlert}},[_vm._v("\n            Staff added successfully\n          ")]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.warehouses,"item-value":"value","error-messages":_vm.errors.collect('Warehouse'),"data-vv-name":"Warehouse","label":"Warehouse*","multiple":"","chips":"","deletable-chips":"","disabled":!!_vm.addEditData.pricing_id},model:{value:(_vm.addEditData.warehouse_id_fk),callback:function ($$v) {_vm.$set(_vm.addEditData, "warehouse_id_fk", $$v)},expression:"addEditData.warehouse_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.orderTypes,"item-value":"value","error-messages":_vm.errors.collect('order_type_id_fk'),"data-vv-name":"order_type_id_fk","label":"Order Type*","multiple":"","chips":"","deletable-chips":"","disabled":!!_vm.addEditData.pricing_id},model:{value:(_vm.addEditData.order_type_id_fk),callback:function ($$v) {_vm.$set(_vm.addEditData, "order_type_id_fk", $$v)},expression:"addEditData.order_type_id_fk"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autocomplete":"","items":_vm.subscriptions,"item-value":"value","error-messages":_vm.errors.collect('subscription_id'),"data-vv-name":"subscription_id","label":"Subscription*","single-line":""},model:{value:(_vm.addEditData.subscription_id),callback:function ($$v) {_vm.$set(_vm.addEditData, "subscription_id", $$v)},expression:"addEditData.subscription_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('order_shipzone_fee'),"data-vv-name":"order_shipzone_fee","label":"Order Shipzone Fee*","single-line":""},model:{value:(_vm.addEditData.order_shipzone_fee),callback:function ($$v) {_vm.$set(_vm.addEditData, "order_shipzone_fee", $$v)},expression:"addEditData.order_shipzone_fee"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('shiponly_handling_fee_air'),"data-vv-name":"shiponly_handling_fee_air","label":"Shiponly Handling Fee (Air)*","single-line":""},model:{value:(_vm.addEditData.shiponly_handling_fee_air),callback:function ($$v) {_vm.$set(_vm.addEditData, "shiponly_handling_fee_air", $$v)},expression:"addEditData.shiponly_handling_fee_air"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('shiponly_handling_fee_sea'),"data-vv-name":"shiponly_handling_fee_sea","label":"Shiponly Handling Fee (Sea)*","single-line":""},model:{value:(_vm.addEditData.shiponly_handling_fee_sea),callback:function ($$v) {_vm.$set(_vm.addEditData, "shiponly_handling_fee_sea", $$v)},expression:"addEditData.shiponly_handling_fee_sea"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('item_price_air'),"data-vv-name":"item_price_air","label":"Shipping Price (Air)*","single-line":""},model:{value:(_vm.addEditData.item_price_air),callback:function ($$v) {_vm.$set(_vm.addEditData, "item_price_air", $$v)},expression:"addEditData.item_price_air"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('item_price_sea'),"data-vv-name":"item_price_sea","label":"Shipping Price (Sea)*","single-line":""},model:{value:(_vm.addEditData.item_price_sea),callback:function ($$v) {_vm.$set(_vm.addEditData, "item_price_sea", $$v)},expression:"addEditData.item_price_sea"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('item_price_land'),"data-vv-name":"item_price_land","label":"Shipping Price (Land)*","single-line":""},model:{value:(_vm.addEditData.item_price_land),callback:function ($$v) {_vm.$set(_vm.addEditData, "item_price_land", $$v)},expression:"addEditData.item_price_land"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|decimal'),expression:"'required|decimal'"}],attrs:{"error-messages":_vm.errors.collect('local_delivery'),"data-vv-name":"local_delivery","label":"Local Delivery*","single-line":""},model:{value:(_vm.addEditData.local_delivery),callback:function ($$v) {_vm.$set(_vm.addEditData, "local_delivery", $$v)},expression:"addEditData.local_delivery"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddEditSubscriptionPricingModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"3%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('preDatatableComponent',{attrs:{"permissions":{
          add_subscription_pricing: 'add_subscription_pricing',
          delete_subscription_pricing: 'delete_subscription_pricing',
        },"removeAddButton":true,"deleteAllSubscriptionPricingButton":true,"deleteAllSubscriptionPricing":_vm.deleteAllSubscriptionPricing,"addEditSubscriptionPricing":true,"removeWarehouseDeliverButton":true,"openAddEditSubscriptionPricingModal":_vm.openAddEditSubscriptionPricingModal,"tableData":_vm.tableData,"resetGetResults":_vm.resetGetResults,"resetGetResults2":_vm.resetGetResults2,"searchMe":_vm.searchMe,"pagination":_vm.pagination,"perPageFix":_vm.perPageFix,"columns":_vm.columns,"hideSelectingColumn":true,"removeFromToDate":true,"filterMade":_vm.filterMade,"totalResult":_vm.totalResult}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._m(1),_vm._v(" "),(!_vm.isMobile)?_c('datatable',{staticClass:"customer-subscription-table",attrs:{"sortDir":_vm.tableData.sortDir,"columns":_vm.columns,"sortByColumn":_vm.sortByColumn,"searchOneCol":_vm.searchOneCol,"sortKey":_vm.sortKey,"sortOrders":_vm.sortOrders,"checkAll":_vm.checkAll,"unCheckAll":_vm.unCheckAll}},[_c('tbody',[_vm._l((_vm.apiResults),function(r,index){return _c('tr',{key:r.pricing_id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userSubscriptionIds),expression:"userSubscriptionIds"}],attrs:{"id":'cb' + index,"type":"checkbox"},domProps:{"value":[r.pricing_id],"checked":Array.isArray(_vm.userSubscriptionIds)?_vm._i(_vm.userSubscriptionIds,[r.pricing_id])>-1:(_vm.userSubscriptionIds)},on:{"change":function($event){var $$a=_vm.userSubscriptionIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=[r.pricing_id],$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.userSubscriptionIds=$$a.concat([$$v]))}else{$$i>-1&&(_vm.userSubscriptionIds=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.userSubscriptionIds=$$c}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.pricing_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.subscription_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.type_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.order_shipzone_fee))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.shiponly_handling_fee_air))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.shiponly_handling_fee_sea))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_price_air))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_price_sea))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.item_price_land))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.local_delivery))]),_vm._v(" "),_c('td',[_c('v-switch',{attrs:{"color":"success","ripple":false},on:{"change":function($event){return _vm.changeActive(r)}},model:{value:(r.is_default),callback:function ($$v) {_vm.$set(r, "is_default", $$v)},expression:"r.is_default"}})],1),_vm._v(" "),(_vm.$_has_perm('delete_subscription_pricing'))?_c('td',{staticStyle:{"padding-left":"0px","padding-right":"5px"}},[(_vm.$_has_perm('edit_subscription'))?_c('a',{staticStyle:{"color":"#01579B"},attrs:{"tooltip":"Edit Subscription"},on:{"click":function($event){return _vm.editSubscriptionPricing(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),_c('a',{staticStyle:{"color":"#DF0845FF"},attrs:{"tooltip":"Delete Customer Subscription"},on:{"click":function($event){return _vm.deleteSubscriptionPricing(r)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])]):_vm._e()])}),_vm._v(" "),_c('tr',{attrs:{"id":"no-result-row"}},[_c('td',{staticClass:"text-center",attrs:{"colspan":_vm.columns.length}},[_c('v-alert',{attrs:{"phone_number":"error","value":_vm.alertValue}},[_vm._v("\n                  No Results Found\n                ")])],1)])],2)]):_vm._e(),_vm._v(" "),_c('add-edit-user-subscription',{attrs:{"addEditSubscriptionPricingModal":_vm.addEditSubscriptionPricingModal,"submitAddEditUserSubscription":_vm.submitAddEditUserSubscription,"closeAddEditSubscriptionPricingModal":_vm.closeAddEditSubscriptionPricingModal,"warehouses":_vm.warehouses,"orderTypes":_vm.orderTypes,"subscriptions":_vm.subscriptions,"addEditData":_vm.addEditData,"checkAlert":_vm.checkAlert,"validationError":_vm.validationError}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-right"},[_c('paginate',{attrs:{"page-count":_vm.pagination.lastPage,"page-range":2,"changePage":_vm.changePage,"container-class":'pagination',"pagination":_vm.pagination,"page-class":'page-item'}})],1)])],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Subscription Pricing")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('span',{staticStyle:{"opacity":"0"},attrs:{"id":"test-editable"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderTypes_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f386c8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderTypes_vue__ = __webpack_require__(1268);
function injectStyle (ssrContext) {
  __webpack_require__(1262)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f386c8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1263);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c514a8d0", content, true, {});

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".table.table-bordered td,.table.table-bordered th{padding:2px 4px!important;font-size:13px!important;vertical-align:middle!important}.table.table-bordered input.form-control{height:20px!important;padding:2px 6px!important;font-size:13px!important}.table.table-bordered{margin-bottom:0}.btn.btn-danger.btn-sm,.btn.btn-sm{padding:2px 8px!important;font-size:12px!important}", ""]);

// exports


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditOrderType_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a24dbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditOrderType_vue__ = __webpack_require__(1267);
function injectStyle (ssrContext) {
  __webpack_require__(1265)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18a24dbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEditOrderType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a24dbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addEditOrderType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1266);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b73a4984", content, true, {});

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".overlay--active[data-v-18a24dbe]:before{opacity:1!important;background:rgba(0,0,0,.5)!important}", ""]);

// exports


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.addOrderTypeModal),callback:function ($$v) {_vm.addOrderTypeModal=$$v},expression:"addOrderTypeModal"}},[_c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('v-card-title',{staticStyle:{"padding-bottom":"0px"}},[_c('v-flex',{attrs:{"xs11":"","sm11":"","md11":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add OrderType")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"close",attrs:{"flat":""},on:{"click":function($event){_vm.closeAddOrderTypeModal(), _vm.$validator.reset()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"material-icons",staticStyle:{"font-size":"24px","vertical-align":"middle"}},[_vm._v("close")])])])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Type Name*","error-messages":_vm.errors.collect('Type Name'),"data-vv-name":"Type Name"},model:{value:(_vm.addEditData.type_name),callback:function ($$v) {_vm.$set(_vm.addEditData, "type_name", $$v)},expression:"addEditData.type_name"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"outline":"","color":"normal"},on:{"click":function($event){_vm.closeAddOrderTypeModal(), _vm.$validator.reset()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticStyle:{"height":"auto","margin-right":"2.5%"},attrs:{"type":"submit","outline":"","color":"success"}},[_vm._v("Save")])],1)],1),_vm._v(" "),_c('form',{attrs:{"id":"login_success99"},on:{"submit":function($event){$event.preventDefault();return _vm.phoneLogin.apply(null, arguments)}}},[_c('input',{attrs:{"type":"hidden","name":"_token","value":"QH65OXMU7MRnJg6UIS2LucakcxXX5LP88cFsEEwL"}}),_vm._v(" "),_c('input',{attrs:{"id":"csrf","type":"hidden","name":"csrf"}}),_vm._v(" "),_c('input',{attrs:{"id":"code","type":"hidden","name":"code"}}),_vm._v(" "),_c('button',{attrs:{"type":"submit","id":"phone"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitChanges.apply(null, arguments)}}},[_c('div',{staticClass:"panel-heading",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('h4',{staticClass:"panel-title",staticStyle:{"margin":"0"}},[_vm._v("Order Types")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[(_vm.$_has_perm('add_order_type'))?_c('v-btn',{staticStyle:{"height":"auto"},attrs:{"depressed":""},on:{"click":_vm.openAddOrderTypeModal}},[_c('v-icon',{staticClass:"fa fa-plus fa-lg mr-2",staticStyle:{"color":"#006b8d"},attrs:{"icon":""}}),_vm._v("\n        Add New Order Type\n      ")],1):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"display":"block"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.apiResults),function(item,idx){return _c('tr',{key:item.id || idx},[_c('td',[_vm._v(_vm._s(item.order_type_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type_name))]),_vm._v(" "),_c('td',[(_vm.$_has_perm('edit_order_type'))?_c('a',{staticStyle:{"color":"#085AB2FF"},attrs:{"tooltip":"Edit Order Type"},on:{"click":function($event){return _vm.editRecord(item, idx)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),(_vm.$_has_perm('delete_order_type'))?_c('a',{staticStyle:{"color":"#B22708FF"},attrs:{"tooltip":"Delete Order Type"},on:{"click":function($event){return _vm.deleteRecord(item, idx)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e()])])}),0)])])])])]),_vm._v(" "),_c('create-order-type',{attrs:{"addOrderTypeModal":_vm.addOrderTypeModal,"closeAddOrderTypeModal":_vm.closeAddOrderTypeModal,"submitOrderType":_vm.submitOrderType,"addEditData":_vm.addEditData}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Order Type Name")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o};!function(){function o(e,t){if(!o.installed){if(o.installed=!0,!t)return void console.error("You have to install axios");e.axios=t,Object.defineProperties(e.prototype,{axios:{get:function(){return t}},$http:{get:function(){return t}}})}}"object"==( false?"undefined":_typeof(exports))?module.exports=o: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return o}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):window.Vue&&window.axios&&Vue.use(o,window.axios)}();

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 72);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'colorable',

  props: {
    color: String
  },

  data: function data() {
    return {
      defaultColor: null
    };
  },


  computed: {
    computedColor: function computedColor() {
      return this.color || this.defaultColor;
    }
  },

  methods: {
    addBackgroundColorClassChecks: function addBackgroundColorClassChecks() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.computedColor;

      var classes = Object.assign({}, obj);

      if (color) {
        classes[color] = true;
      }

      return classes;
    },
    addTextColorClassChecks: function addTextColorClassChecks() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.computedColor;

      var classes = Object.assign({}, obj);

      if (color) {
        var _color$trim$split = color.trim().split(' '),
            _color$trim$split2 = _slicedToArray(_color$trim$split, 2),
            colorName = _color$trim$split2[0],
            colorModifier = _color$trim$split2[1];

        classes[colorName + '--text'] = true;
        colorModifier && (classes['text--' + colorModifier] = true);
      }

      return classes;
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'themeable',

  props: {
    dark: Boolean,
    light: Boolean
  },

  computed: {
    themeClasses: function themeClasses() {
      return {
        'theme--light': this.light,
        'theme--dark': this.dark
      };
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["f"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["c"] = createJavaScriptTransition;
/* unused harmony export directiveConfig */
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["i"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = createRange;
/* harmony export (immutable) */ __webpack_exports__["j"] = getZIndex;
/* harmony export (immutable) */ __webpack_exports__["g"] = escapeHTML;
/* harmony export (immutable) */ __webpack_exports__["h"] = filterObjectOnKeys;
/* unused harmony export filterChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = convertToUnit;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var name = arguments[2];

  name = name || c.replace(/__/g, '-');

  return {
    name: 'v-' + name,
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    name: name,

    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};
      if (!Object.isExtensible(context.data.on)) {
        context.data.on = _extends({}, context.data.on);
      }

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = context.props.origin;
        el.style.webkitTransformOrigin = context.props.origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    name: name,

    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;

  var index = window.getComputedStyle(el).getPropertyValue('z-index');

  if (isNaN(index)) return getZIndex(el.parentNode);
  return index;
}

var tagsToReplace = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
};

function escapeHTML(str) {
  return str.replace(/[&<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
}

function filterObjectOnKeys(obj, keys) {
  var filtered = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (typeof obj[key] !== 'undefined') {
      filtered[key] = obj[key];
    }
  }

  return filtered;
}

function filterChildren() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tag = arguments[1];

  return array.filter(function (child) {
    return child.componentOptions && child.componentOptions.Ctor.options.name === tag;
  });
}

function convertToUnit(str) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

  return isNaN(str) ? str : '' + Number(str) + unit;
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(92);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inject;
/* harmony export (immutable) */ __webpack_exports__["b"] = provide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function generateWarning(child, parent) {
  return function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["b" /* consoleWarn */])('The ' + child + ' component must be used inside a ' + parent);
  };
}

function inject(namespace, child, parent) {
  var defaultImpl = child && parent ? {
    register: generateWarning(child, parent),
    unregister: generateWarning(child, parent)
  } : null;

  return {
    name: 'registrable-inject',

    inject: _defineProperty({}, namespace, {
      default: defaultImpl
    })
  };
}

function provide(namespace) {
  return {
    name: 'registrable-provide',

    methods: {
      register: null,
      unregister: null
    },
    provide: function provide() {
      return _defineProperty({}, namespace, {
        register: this.register,
        unregister: this.unregister
      });
    }
  };
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = consoleWarn;
/* harmony export (immutable) */ __webpack_exports__["a"] = consoleError;
function createMessage(message, componentInstance) {
  var componentInfo = componentInstance ? ' in "' + componentInstance.$options.name + '"' : '';
  return '[Vuetify] ' + message + componentInfo;
}

function consoleWarn(message) {
  var componentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  console.warn(createMessage(message, componentInstance));
}

function consoleError(message) {
  var componentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  console.error(createMessage(message, componentInstance));
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = factory;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function factory() {
  var _watch;

  var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'value';
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'input';

  return {
    name: 'toggleable',

    model: { prop: prop, event: event },

    props: _defineProperty({}, prop, { required: false }),

    data: function data() {
      return {
        isActive: !!this[prop]
      };
    },


    watch: (_watch = {}, _defineProperty(_watch, prop, function (val) {
      this.isActive = !!val;
    }), _defineProperty(_watch, 'isActive', function isActive(val) {
      !!val !== this[prop] && this.$emit(event, val);
    }), _watch)
  };
}

var Toggleable = factory();

/* harmony default export */ __webpack_exports__["a"] = (Toggleable);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VBottomSheetTranstion */
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VTabTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VTabReverseTransition; });
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VScaleTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* unused harmony export VRowExpandTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(41);




// Component specific transitions
var VBottomSheetTranstion = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('bottom-sheet-transition');
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["c" /* createJavaScriptTransition */])('expand-transition', Object(__WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */])());
var VRowExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["c" /* createJavaScriptTransition */])('row-expand-transition', Object(__WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */])('datatable__expand-col--expanded'));

/* harmony default export */ __webpack_exports__["g"] = (install);
/* istanbul ignore next */
function install(Vue) {
  Vue.component('v-bottom-sheet-transition', VBottomSheetTranstion);
  Vue.component('v-carousel-transition', VCarouselTransition);
  Vue.component('v-carousel-reverse-transition', VCarouselReverseTransition);
  Vue.component('v-dialog-transition', VDialogTransition);
  Vue.component('v-dialog-bottom-transition', VDialogBottomTransition);
  Vue.component('v-fab-transition', VFabTransition);
  Vue.component('v-fade-transition', VFadeTransition);
  Vue.component('v-menu-transition', VMenuTransition);
  Vue.component('v-scale-transition', VScaleTransition);
  Vue.component('v-slide-x-transition', VSlideXTransition);
  Vue.component('v-slide-x-reverse-transition', VSlideXReverseTransition);
  Vue.component('v-slide-y-transition', VSlideYTransition);
  Vue.component('v-slide-y-reverse-transition', VSlideYReverseTransition);
  Vue.component('v-tab-reverse-transition', VTabReverseTransition);
  Vue.component('v-tab-transition', VTabTransition);
  Vue.component('v-expand-transition', VExpandTransition);
  Vue.component('v-row-expand-transition', VRowExpandTransition);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function closeConditional() {
  return false;
}

function directive(e, el, binding) {
  // Args may not always be supplied
  binding.args = binding.args || {};

  // If no closeConditional was supplied assign a default
  var isActive = binding.args.closeConditional || closeConditional;

  // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components
  if (!e || isActive(e) === false) return;

  // If click was triggered programmaticaly (domEl.click()) then
  // it shouldn't be treated as click-outside
  // Chrome/Firefox support isTrusted property
  // IE/Edge support pointerType property (empty if not triggered
  // by pointing device)
  if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) return;

  // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)
  var elements = (binding.args.include || function () {
    return [];
  })();
  // Add the root element for the component this directive was defined on
  elements.push(el);

  // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occure before
  // the bubbling click event on any outside elements.
  !clickedInEls(e, elements) && setTimeout(function () {
    isActive(e) && binding.value();
  }, 0);
}

function clickedInEls(e, elements) {
  // Get position of click
  var x = e.clientX,
      y = e.clientY;
  // Loop over all included elements to see if click was in any of them

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      if (clickedInEl(el, x, y)) return true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
}

function clickedInEl(el, x, y) {
  // Get bounding rect for element
  // (we're in capturing event and we want to check for multiple elements,
  //  so can't use target.)
  var b = el.getBoundingClientRect();
  // Check if the click was in the element's bounding rect

  return x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'click-outside',

  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  inserted: function inserted(el, binding) {
    var onClick = function onClick(e) {
      return directive(e, el, binding);
    };
    // iOS does not recognize click events on document
    // or body, this is the entire purpose of the v-app
    // component and [data-app], stop removing this
    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
    app.addEventListener('click', onClick, true);
    el._clickOutside = onClick;
  },
  unbind: function unbind(el) {
    var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
    app && app.removeEventListener('click', el._clickOutside, true);
    delete el._clickOutside;
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _touchstart = function _touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var _touchend = function _touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var _touchmove = function _touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  var dirRatio = 0.5;
  var minDistance = 16;
  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
    wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
    wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
  }

  if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
    wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
    wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
  }
};

function inserted(el, _ref, _ref2) {
  var value = _ref.value;
  var context = _ref2.context;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || { passive: true

    // Needed to pass unit tests
  };if (!target) return;

  var handlers = {
    touchstart: function touchstart(e) {
      return _touchstart(e, wrapper);
    },
    touchend: function touchend(e) {
      return _touchend(e, wrapper);
    },
    touchmove: function touchmove(e) {
      return _touchmove(e, wrapper);
    }
  };
  target._touchHandlers = Object.assign(Object(target._touchHandlers), _defineProperty({}, context._uid, handlers));
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(handlers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      target.addEventListener(eventName, handlers[eventName], options);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function unbind(el, _ref3, _ref4) {
  var value = _ref3.value;
  var context = _ref4.context;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  var handlers = target._touchHandlers[context._uid];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.keys(handlers)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var eventName = _step2.value;

      target.removeEventListener(eventName, handlers[eventName]);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  delete target._touchHandlers[context._uid];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'touch',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(111);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */]);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = binding.value;
  var options = binding.options || { passive: true };

  window.addEventListener('resize', callback, options);
  el._onResize = {
    callback: callback,
    options: options
  };

  if (!binding.modifiers || !binding.modifiers.quiet) {
    callback();
  }
}

function unbind(el, binding) {
  var _el$_onResize = el._onResize,
      callback = _el$_onResize.callback,
      options = _el$_onResize.options;


  window.removeEventListener('resize', callback, options);
  delete el._onResize;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resize',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = factory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


function factory() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var props = {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  };

  return {
    name: 'positionable',
    props: selected.length ? Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["h" /* filterObjectOnKeys */])(props, selected) : props
  };
}

/* harmony default export */ __webpack_exports__["a"] = (factory());

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_ripple__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'routable',

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_0__directives_ripple__["a" /* default */]
  },

  props: {
    activeClass: String,
    append: Boolean,
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: undefined
    },
    exactActiveClass: String,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    ripple: [Boolean, Object],
    tag: String,
    target: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = _defineProperty({
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple && !this.disabled ? this.ripple : false
        }]
      }, this.to ? 'nativeOn' : 'on', _extends({}, this.$listeners, {
        click: this.click
      }));

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        // Add a special activeClass hook
        // for component level styles
        var activeClass = this.activeClass;
        var exactActiveClass = this.exactActiveClass || activeClass;

        if (this.proxyClass) {
          activeClass += ' ' + this.proxyClass;
          exactActiveClass += ' ' + this.proxyClass;
        }

        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        Object.assign(data.props, {
          to: this.to,
          exact: exact,
          activeClass: activeClass,
          exactActiveClass: exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          if (this.href) data.attrs.href = this.href;
          if (this.target) data.attrs.target = this.target;
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createNativeLocaleFormatter__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__monthChange__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pad__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createNativeLocaleFormatter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__monthChange__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__pad__["a"]; });






/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applicationable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positionable__ = __webpack_require__(12);


function applicationable(value) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return {
    name: 'applicationable',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__positionable__["b" /* factory */])(['absolute', 'fixed'])],

    props: {
      app: Boolean
    },

    computed: {
      applicationProperty: function applicationProperty() {
        return value;
      }
    },

    watch: {
      // If previous value was app
      // reset the provided prop
      app: function app(x, prev) {
        prev ? this.removeApplication(true) : this.callUpdate();
      }
    },

    activated: function activated() {
      this.callUpdate();
    },
    created: function created() {
      for (var i = 0, length = events.length; i < length; i++) {
        this.$watch(events[i], this.callUpdate);
      }
      this.callUpdate();
    },
    mounted: function mounted() {
      this.callUpdate();
    },
    deactivated: function deactivated() {
      this.removeApplication();
    },
    destroyed: function destroyed() {
      this.removeApplication();
    },


    methods: {
      callUpdate: function callUpdate() {
        if (!this.app) return;

        this.$vuetify.application.bind(this._uid, this.applicationProperty, this.updateApplication());
      },
      removeApplication: function removeApplication(force) {
        if (!force && !this.app) return;

        this.$vuetify.application.unbind(this._uid, this.applicationProperty);
      },

      updateApplication: function updateApplication() {}
    }
  };
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Bootable
 * @mixin
 *
 * Used to add lazy content functionality to components
 * Looks for change in "isActive" to automatically boot
 * Otherwise can be set manually
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bootable',

  data: function data() {
    return {
      isBooted: false
    };
  },

  props: {
    lazy: Boolean
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.isBooted || !this.lazy || this.isActive ? content : null;
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  el.style['transform'] = value;
  el.style['webkitTransform'] = value;
}

var ripple = {
  /**
   * @param {Event} e
   * @param {Element} el
   * @param {{ class?: string, center?: boolean }} [value={}]
   */
  show: function show(e, el) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!el._ripple || !el._ripple.enabled) {
      return;
    }

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    if (!el._ripple || !el._ripple.enabled) return;

    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}

function rippleShow(e) {
  var value = {};
  var element = e.currentTarget;
  value.center = element._ripple.centered;
  if (element._ripple.class) {
    value.class = element._ripple.class;
  }
  ripple.show(e, element, value);
}

function rippleHide(e) {
  ripple.hide(e.currentTarget);
}

function updateRipple(el, binding, wasEnabled) {
  var enabled = isRippleEnabled(binding.value);
  if (!enabled) {
    ripple.hide(el);
  }
  el._ripple = el._ripple || {};
  el._ripple.enabled = enabled;
  var value = binding.value || {};
  if (value.center) {
    el._ripple.centered = true;
  }
  if (value.class) {
    el._ripple.class = binding.value.class;
  }
  if (enabled && !wasEnabled) {
    if ('ontouchstart' in window) {
      el.addEventListener('touchend', rippleHide, false);
      el.addEventListener('touchcancel', rippleHide, false);
    }

    el.addEventListener('mousedown', rippleShow, false);
    el.addEventListener('mouseup', rippleHide, false);
    el.addEventListener('mouseleave', rippleHide, false);
    // Anchor tags can be dragged, causes other hides to fail - #1537
    el.addEventListener('dragstart', rippleHide, false);
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}

function removeListeners(el) {
  el.removeEventListener('touchstart', rippleShow, false);
  el.removeEventListener('mousedown', rippleShow, false);
  el.removeEventListener('touchend', rippleHide, false);
  el.removeEventListener('touchcancel', rippleHide, false);
  el.removeEventListener('mouseup', rippleHide, false);
  el.removeEventListener('mouseleave', rippleHide, false);
  el.removeEventListener('dragstart', rippleHide, false);
}

function directive(el, binding) {
  updateRipple(el, binding, false);
}

function unbind(el, binding) {
  delete el._ripple;
  removeListeners(el);
}

function update(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }

  var wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ripple',
  bind: directive,
  unbind: unbind,
  update: update
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loadable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validatable__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VIcon__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__loadable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__validatable__["a" /* default */]],

  data: function data() {
    return {
      isFocused: false,
      tabFocused: false,
      internalTabIndex: null,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    readonly: Boolean,
    required: Boolean,
    tabindex: {
      default: 0
    },
    toggleKeys: {
      type: Array,
      default: function _default() {
        return [13, 32];
      }
    },
    value: {
      required: false
    }
  },

  computed: {
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--async-loading': this.loading !== false,
        'input-group--focused': this.isFocused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return !!this.inputValue;
    }
  },

  methods: {
    groupFocus: function groupFocus(e) {},
    groupBlur: function groupBlur(e) {
      this.tabFocused = false;
    },
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var messages = null;

      if (this.hint && (this.isFocused || this.persistentHint) && !this.validations.length) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = [this.genError(this.validations[0])];
      }

      return this.$createElement('transition', {
        props: {
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__messages input-group__hint',
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__messages input-group__error'
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var defaultCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var shouldClear = type === 'append' && this.clearable && this.isDirty;
      var icon = shouldClear ? 'clear' : this[type + 'Icon'];
      var callback = shouldClear ? this.clearableCallback : this[type + 'IconCb'] || defaultCallback;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_3__components_VIcon__["a" /* default */], {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', !!callback), _defineProperty(_class, 'input-group__icon-clearable', shouldClear), _class),
        props: {
          disabled: this.disabled
        },
        on: {
          click: function click(e) {
            if (!callback) return;

            e.stopPropagation();
            callback();
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultAppendCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.disabled ? -1 : this.internalTabIndex || this.tabindex
        },
        on: {
          focus: this.groupFocus,
          blur: this.groupBlur,
          click: function click() {
            return _this.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this.toggle) return;

            if (_this.toggleKeys.includes(e.keyCode)) {
              e.preventDefault();
              _this.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon || this.clearable) {
        wrapperChildren.push(this.genIcon('append', defaultAppendCallback));
      }

      var progress = this.genProgress();
      progress && detailsChildren.push(progress);

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      !this.hideDetails && detailsChildren.push(this.genMessages());

      if (this.counter) {
        detailsChildren.push(this.genCounter());
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function searchChildren(children) {
  var results = [];
  for (var index = 0; index < children.length; index++) {
    var child = children[index];
    if (child.isActive && child.isDependent) {
      results.push(child);
    } else {
      results.push.apply(results, _toConsumableArray(searchChildren(child.$children)));
    }
  }

  return results;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dependent',

  data: function data() {
    return {
      closeDependents: true,
      isDependent: true
    };
  },


  methods: {
    getOpenDependents: function getOpenDependents() {
      if (this.closeDependents) return searchChildren(this.$children);

      return [];
    },
    getOpenDependentElements: function getOpenDependentElements() {
      var result = [];
      var openDependents = this.getOpenDependents();

      for (var index = 0; index < openDependents.length; index++) {
        result.push.apply(result, _toConsumableArray(openDependents[index].getClickableDependentElements()));
      }

      return result;
    },
    getClickableDependentElements: function getClickableDependentElements() {
      var result = [this.$el];
      if (this.$refs.content) result.push(this.$refs.content);
      result.push.apply(result, _toConsumableArray(this.getOpenDependentElements()));

      return result;
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) return;

      var openDependents = this.getOpenDependents();
      for (var index = 0; index < openDependents.length; index++) {
        openDependents[index].isActive = false;
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_ripple__ = __webpack_require__(17);


/** @mixin */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rippleable',

  directives: { Ripple: __WEBPACK_IMPORTED_MODULE_0__directives_ripple__["a" /* default */] },

  props: {
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },

  methods: {
    genRipple: function genRipple() {
      var _this = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { directives: [] };

      data.class = this.rippleClasses || 'input-group--selection-controls__ripple';
      data.directives.push({
        name: 'ripple',
        value: this.ripple && !this.disabled && { center: true }
      });
      data.on = Object.assign({}, this.$listeners, {
        click: function click(e) {
          _this.$emit('click', e);
          _this.toggle();
        }
      });

      return this.$createElement('div', data);
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var padStart = function padStart(string, targetLength, padString) {
  targetLength = targetLength >> 0;
  string = String(string);
  padString = String(padString);
  if (string.length > targetLength) {
    return String(string);
  }

  targetLength = targetLength - string.length;
  if (targetLength > padString.length) {
    padString += padString.repeat(targetLength / padString.length);
  }
  return padString.slice(0, targetLength) + String(string);
};

/* harmony default export */ __webpack_exports__["a"] = (function (n) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return padStart(n, length, '0');
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * SSRBootable
 *
 * @mixin
 *
 * Used in layout components (drawer, toolbar, content)
 * to avoid an entry animation when using SSR
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ssr-bootable',

  data: function data() {
    return {
      isBooted: false
    };
  },

  mounted: function mounted() {
    var _this = this;

    // Use setAttribute instead of dataset
    // because dataset does not work well
    // with unit tests
    window.requestAnimationFrame(function () {
      _this.$el.setAttribute('data-booted', true);
      _this.isBooted = true;
    });
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transitionable',

  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function validateAttachTarget(val) {
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);

  if (type === 'boolean' || type === 'string') return true;

  return val.nodeType === Node.ELEMENT_NODE;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'detachable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__bootable__["a" /* default */]],

  props: {
    attach: {
      type: null,
      default: false,
      validator: validateAttachTarget
    },
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    this.initDetach();
  },
  deactivated: function deactivated() {
    this.isActive = false;
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  },


  methods: {
    initDetach: function initDetach() {
      if (this._isDestroyed || !this.$refs.content ||
      // Leave menu in place if attached
      // and dev has not changed target
      this.attach === '' || // If used as a boolean prop (<v-menu attach>)
      this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
      this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) return;

      var target = void 0;
      if (this.attach === false) {
        // Default, detach to app
        target = document.querySelector('[data-app]');
      } else if (typeof this.attach === 'string') {
        // CSS selector
        target = document.querySelector(this.attach);
      } else {
        // DOM Element
        target = this.attach;
      }

      if (!target) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('Unable to locate target ' + (this.attach || '[data-app]'), this);
        return;
      }

      target.insertBefore(this.$refs.content, target.firstChild);
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'returnable',

  data: function data() {
    return {
      originalValue: null
    };
  },

  props: {
    returnValue: null
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.originalValue = this.returnValue;
      } else {
        this.$emit('update:returnValue', this.originalValue);
      }
    }
  },

  methods: {
    save: function save(value) {
      this.originalValue = value;
      this.isActive = false;
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCardActions */
/* unused harmony export VCardText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(121);
/* unused harmony reexport VCard */
/* unused harmony reexport VCardMedia */
/* unused harmony reexport VCardTitle */





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('card__text');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]);
  Vue.component(VCardActions.name, VCardActions);
  Vue.component(VCardText.name, VCardText);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(128);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */]);

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu__ = __webpack_require__(146);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VMenu__["a" /* default */]);

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Grid;
function Grid(name) {
  return {
    name: 'v-' + name,

    functional: true,

    props: {
      id: String,
      tag: {
        type: String,
        default: 'div'
      }
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        var classes = Object.keys(data.attrs).filter(function (key) {
          var value = data.attrs[key];
          return value || typeof value === 'string';
        });

        if (classes.length) data.staticClass += ' ' + classes.join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h(props.tag, data, children);
    }
  };
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = colorToInt;
/* harmony export (immutable) */ __webpack_exports__["b"] = intToHex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__console__ = __webpack_require__(5);


/**
 * @param {string|number} color
 * @returns {number}
 */
function colorToInt(color) {
  var rgb = void 0;

  if (typeof color === 'number') {
    rgb = color;
  } else if (typeof color === 'string') {
    var c = color[0] === '#' ? color.substring(1) : color;
    if (c.length === 3) {
      c = c.split('').map(function (char) {
        return char + char;
      }).join('');
    }
    if (c.length !== 6) {
      Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('\'' + color + '\' is not a valid rgb color');
    }
    rgb = parseInt(c, 16);
  } else {
    throw new TypeError('Colors can only be numbers or strings, recieved ' + color.constructor.name + ' instead');
  }

  if (rgb < 0) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('Colors cannot be negative: \'' + color + '\'');
    rgb = 0;
  } else if (rgb > 0xffffff || isNaN(rgb)) {
    Object(__WEBPACK_IMPORTED_MODULE_0__console__["b" /* consoleWarn */])('\'' + color + '\' is not a valid rgb color');
    rgb = 0xffffff;
  }

  return rgb;
}

/**
 * @param {number} color
 * @returns {string}
 */
function intToHex(color) {
  color = color.toString(16);

  if (color.length < 6) color = '0'.repeat(6 - color.length) + color;

  return '#' + color;
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAvatar__ = __webpack_require__(94);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */]);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'button-group',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__registrable__["b" /* provide */])('buttonGroup')],

  data: function data() {
    return {
      buttons: [],
      listeners: [],
      isDestroying: false
    };
  },


  watch: {
    buttons: 'update'
  },

  methods: {
    getValue: function getValue(i) {
      if (this.buttons[i].value != null) {
        return this.buttons[i].value;
      }

      // Fix for testing, this should always be false in the browser
      if (this.buttons[i].$el.value != null && this.buttons[i].$el.value !== '') {
        return this.buttons[i].$el.value;
      }

      return i;
    },
    update: function update() {
      var selected = [];

      for (var i = 0; i < this.buttons.length; i++) {
        var elm = this.buttons[i].$el;
        var button = this.buttons[i];

        elm.removeAttribute('data-only-child');

        if (this.isSelected(i)) {
          !button.to && (button.isActive = true);
          selected.push(i);
        } else {
          !button.to && (button.isActive = false);
        }
      }

      if (selected.length === 1) {
        this.buttons[selected[0]].$el.setAttribute('data-only-child', true);
      }

      this.ensureMandatoryInvariant(selected.length > 0);
    },
    register: function register(button) {
      var index = this.buttons.length;
      this.buttons.push(button);
      this.listeners.push(this.updateValue.bind(this, index));
      button.$on('click', this.listeners[index]);
    },
    unregister: function unregister(buttonToUnregister) {
      // Basic cleanup if we're destroying
      if (this.isDestroying) {
        var index = this.buttons.indexOf(buttonToUnregister);
        if (index !== -1) {
          buttonToUnregister.$off('click', this.listeners[index]);
        }
        return;
      }

      this.redoRegistrations(buttonToUnregister);
    },
    redoRegistrations: function redoRegistrations(buttonToUnregister) {
      var selectedCount = 0;

      var buttons = [];
      for (var index = 0; index < this.buttons.length; ++index) {
        var button = this.buttons[index];
        if (button !== buttonToUnregister) {
          buttons.push(button);
          selectedCount += Boolean(this.isSelected(index));
        }

        button.$off('click', this.listeners[index]);
      }

      this.buttons = [];
      this.listeners = [];

      for (var _index = 0; _index < buttons.length; ++_index) {
        this.register(buttons[_index]);
      }

      this.ensureMandatoryInvariant(selectedCount > 0);
      this.updateAllValues && this.updateAllValues();
    },
    ensureMandatoryInvariant: function ensureMandatoryInvariant(hasSelectedAlready) {
      // Preserve the mandatory invariant by selecting the first tracked button, if needed

      if (!this.mandatory || hasSelectedAlready) return;

      if (!this.listeners.length) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('There must be at least one v-btn child if the mandatory property is true.', this);
        return;
      }

      this.listeners[0]();
    }
  },

  mounted: function mounted() {
    this.update();
  },
  beforeDestroy: function beforeDestroy() {
    this.isDestroying = true;
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_dialogs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_detachable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_overlayable__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_returnable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_stackable__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_helpers__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Mixins







// Directives


// Helpers


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_returnable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_stackable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives_click_outside__["a" /* default */]
  },

  data: function data() {
    return {
      isDependent: false,
      stackClass: 'dialog__content__active',
      stackMinZIndex: 200
    };
  },


  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 'none'
    },
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 'auto'
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, ('dialog ' + this.contentClass).trim(), true), _defineProperty(_ref, 'dialog--active', this.isActive), _defineProperty(_ref, 'dialog--persistent', this.persistent), _defineProperty(_ref, 'dialog--fullscreen', this.fullscreen), _defineProperty(_ref, 'dialog--scrollable', this.scrollable), _ref;
    },
    contentClasses: function contentClasses() {
      return {
        'dialog__content': true,
        'dialog__content__active': this.isActive
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        this.show();
      } else {
        this.removeOverlay();
        this.unbind();
      }
    }
  },

  mounted: function mounted() {
    this.isBooted = this.isActive;
    this.isActive && this.show();
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') this.unbind();
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent, clicked outside and we're the topmost dialog.
      // Since this should only be called in a capture event (bottom up), we shouldn't need to stop propagation
      return this.isActive && !this.persistent && Object(__WEBPACK_IMPORTED_MODULE_8__util_helpers__["j" /* getZIndex */])(this.$refs.content) >= this.getMaxZIndex() && !this.$refs.content.contains(e.target);
    },
    show: function show() {
      !this.fullscreen && !this.hideOverlay && this.genOverlay();
      this.fullscreen && this.hideScroll();
      this.$refs.content.focus();
      this.$listeners.keydown && this.bind();
    },
    bind: function bind() {
      window.addEventListener('keydown', this.onKeydown);
    },
    unbind: function unbind() {
      window.removeEventListener('keydown', this.onKeydown);
    },
    onKeydown: function onKeydown(e) {
      this.$emit('keydown', e);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional,
          include: this.getOpenDependentElements
        }
      }, { name: 'show', value: this.isActive }],
      on: {
        click: function click(e) {
          e.stopPropagation();
        }
      }
    };

    if (!this.fullscreen) {
      data.style = {
        maxWidth: this.maxWidth === 'none' ? undefined : isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px',
        width: this.width === 'auto' ? undefined : isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this.disabled) _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': this.contentClasses,
      domProps: { tabIndex: -1 },
      style: { zIndex: this.activeZIndex },
      ref: 'content'
    }, [dialog]));

    return h('div', {
      staticClass: 'dialog__container',
      style: {
        display: !this.$slots.activator || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_overlay_styl__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'overlayable',

  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTimeout: null,
      overlayTransitionDuration: 500 + 150 // transition + delay
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      // If fn is called and timeout is active
      // or overlay already exists
      // cancel removal of overlay and re-add active
      if (!this.isActive || this.hideOverlay || this.isActive && this.overlayTimeout || this.overlay) {
        clearTimeout(this.overlayTimeout);

        return this.overlay && this.overlay.classList.add('overlay--active');
      }

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');

      parent && parent.insertBefore(this.overlay, parent.firstChild);

      // eslint-disable-next-line no-unused-expressions
      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';

        if (_this.activeZIndex !== undefined) {
          _this.overlay.style.zIndex = _this.activeZIndex - 1;
        }
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      this.overlayTimeout = setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}

        clearTimeout(_this2.overlayTimeout);
        _this2.overlayTimeout = null;
      }, this.overlayTransitionDuration);
    },

    /**
     * @param {Event} e
     * @returns void
     */
    scrollListener: function scrollListener(e) {
      if (e.type === 'keydown') {
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return;

        var up = [38, 33];
        var down = [40, 34];

        if (up.includes(e.keyCode)) {
          e.deltaY = -1;
        } else if (down.includes(e.keyCode)) {
          e.deltaY = 1;
        } else {
          return;
        }
      }

      if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
    },
    hasScrollbar: function hasScrollbar(el) {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;

      var style = window.getComputedStyle(el);
      return ['auto', 'scroll'].includes(style['overflow-y']) && el.scrollHeight > el.clientHeight;
    },
    shouldScroll: function shouldScroll(el, delta) {
      if (el.scrollTop === 0 && delta < 0) return true;
      return el.scrollTop + el.clientHeight === el.scrollHeight && delta > 0;
    },
    isInside: function isInside(el, parent) {
      if (el === parent) {
        return true;
      } else if (el === null || el === document.body) {
        return false;
      } else {
        return this.isInside(el.parentNode, parent);
      }
    },

    /**
     * @param {Event} e
     * @returns boolean
     */
    checkPath: function checkPath(e) {
      var path = e.path || this.composedPath(e);
      var delta = e.deltaY || -e.wheelDelta;

      if (e.type === 'keydown' && path[0] === document.body) {
        var dialog = this.$refs.dialog;
        var selected = window.getSelection().anchorNode;
        if (this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
          return this.shouldScroll(dialog, delta);
        }
        return true;
      }

      for (var index = 0; index < path.length; index++) {
        var el = path[index];

        if (el === document) return true;
        if (el === document.documentElement) return true;
        if (el === this.$refs.content) return true;

        if (this.hasScrollbar(el)) return this.shouldScroll(el, delta);
      }

      return true;
    },

    /**
     * Polyfill for Event.prototype.composedPath
     * @param {Event} e
     * @returns Element[]
     */
    composedPath: function composedPath(e) {
      if (e.composedPath) return e.composedPath();

      var path = [];
      var el = e.target;

      while (el) {
        path.push(el);

        if (el.tagName === 'HTML') {
          path.push(document);
          path.push(window);

          return path;
        }

        el = el.parentElement;
      }
    },
    hideScroll: function hideScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        document.documentElement.classList.add('overflow-y-hidden');
      } else {
        window.addEventListener('wheel', this.scrollListener);
        window.addEventListener('keydown', this.scrollListener);
      }
    },
    showScroll: function showScroll() {
      document.documentElement.classList.remove('overflow-y-hidden');
      window.removeEventListener('wheel', this.scrollListener);
      window.removeEventListener('keydown', this.scrollListener);
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stackable',

  data: function data() {
    return {
      stackBase: null,
      stackClass: 'unpecified',
      stackElement: null,
      stackExclude: null,
      stackMinZIndex: 0
    };
  },

  computed: {
    /**
     * Currently active z-index
     *
     * @return {number}
     */
    activeZIndex: function activeZIndex() {
      if (typeof window === 'undefined') return 0;

      var content = this.stackElement || this.$refs.content;
      // Return current zindex if not active

      var index = !this.isActive ? Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["j" /* getZIndex */])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;

      if (index == null) return index;

      // Return max current z-index (excluding self) + 2
      // (2 to leave room for an overlay below, if needed)
      return parseInt(index);
    }
  },
  methods: {
    getMaxZIndex: function getMaxZIndex() {
      var exclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var base = this.stackBase || this.$el;
      // Start with lowest allowed z-index or z-index of
      // base component's element, whichever is greater
      var zis = [this.stackMinZIndex, Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["j" /* getZIndex */])(base)];
      // Convert the NodeList to an array to
      // prevent an Edge bug with Symbol.iterator
      // https://github.com/vuetifyjs/vuetify/issues/2146
      var activeElements = [].concat(_toConsumableArray(document.getElementsByClassName(this.stackClass)));

      // Get z-index for all active dialogs
      for (var index = 0; index < activeElements.length; index++) {
        if (!exclude.includes(activeElements[index])) {
          zis.push(Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["j" /* getZIndex */])(activeElements[index]));
        }
      }

      return Math.max.apply(Math, zis);
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressCircular__ = __webpack_require__(113);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VProgressCircular__["a" /* default */]);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VJumbotron__ = __webpack_require__(126);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */]);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    enter: function enter(el, done) {
      el._parent = el.parentNode;

      Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

      // Get height that is to be scrolled
      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.display = 'block';
      expandedParentClass && el._parent.classList.add(expandedParentClass);

      setTimeout(function () {
        return el.style.height = el.scrollHeight + 'px';
      }, 100);
    },
    afterEnter: function afterEnter(el) {
      el.style.overflow = null;
      el.style.height = null;
    },
    leave: function leave(el, done) {
      // Remove initial transition
      Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

      // Set height before we transition to 0
      el.style.overflow = 'hidden';
      el.style.height = el.offsetHeight + 'px';

      setTimeout(function () {
        return el.style.height = 0;
      }, 100);
    },
    afterLeave: function afterLeave(el) {
      expandedParentClass && el._parent && el._parent.classList.remove(expandedParentClass);
    }
  };
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectable',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  data: function data() {
    return {
      defaultColor: 'accent'
    };
  },

  props: {
    id: String,
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    },
    isDirty: function isDirty() {
      return this.isActive;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.validate(true, input);

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VProgressLinear__ = __webpack_require__(44);


/**
 * Loadable
 *
 * @mixin
 *
 * Used to add linear progress bar to components
 * Can use a default bar with a specific color
 * or designate a custom progress linear bar
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loadable',

  props: {
    loading: {
      type: [Boolean, String],
      default: false
    }
  },

  methods: {
    genProgress: function genProgress() {
      if (this.loading === false) return null;

      return this.$slots.progress || this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VProgressLinear__["a" /* default */], {
        props: {
          color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
          height: 2,
          indeterminate: true
        }
      });
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(129);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */]);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(132);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VSelect__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filterable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadable__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_console__ = __webpack_require__(5);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();












/**
 * DataIterable
 *
 * @mixin
 *
 * Base behavior for data table and data iterator
 * providing selection, pagination, sorting and filtering.
 *
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'data-iterable',

  data: function data() {
    return {
      searchLength: 0,
      defaultPagination: {
        descending: false,
        page: 1,
        rowsPerPage: 5,
        sortBy: null,
        totalItems: 0
      },
      expanded: {},
      actionsClasses: 'data-iterator__actions',
      actionsRangeControlsClasses: 'data-iterator__actions__range-controls',
      actionsSelectClasses: 'data-iterator__actions__select',
      actionsPaginationClasses: 'data-iterator__actions__pagination'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_3__filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__loadable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__themeable__["a" /* default */]],

  props: {
    expand: Boolean,
    hideActions: Boolean,
    disableInitialSort: Boolean,
    mustSort: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Items per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        if (search.trim() === '') return items;

        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_6__util_helpers__["i" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_6__util_helpers__["i" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    itemKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: function _default() {}
    }
  },

  computed: {
    computedPagination: function computedPagination() {
      return this.hasPagination ? this.pagination : this.defaultPagination;
    },
    hasPagination: function hasPagination() {
      var pagination = this.pagination || {};

      return Object.keys(pagination).length > 0;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      return this.filteredItemsImpl();
    },
    selected: function selected() {
      var selected = {};
      for (var index = 0; index < this.value.length; index++) {
        selected[this.value[index][this.itemKey]] = true;
      }
      return selected;
    }
  },

  watch: {
    itemsLength: function itemsLength(totalItems) {
      this.updatePagination({ page: 1, totalItems: totalItems });
    }
  },

  methods: {
    initPagination: function initPagination() {
      if (!this.rowsPerPageItems.length) {
        Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('The prop \'rows-per-page-items\' can not be empty', this);
      } else {
        this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
      }

      this.defaultPagination.totalItems = this.itemsLength;

      this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
    },
    updatePagination: function updatePagination(val) {
      var pagination = this.hasPagination ? this.pagination : this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);
      this.$emit('update:pagination', updatedPagination);

      if (!this.hasPagination) {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.itemKey]];
    },
    isExpanded: function isExpanded(item) {
      return this.expanded[item[this.itemKey]];
    },
    filteredItemsImpl: function filteredItemsImpl() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        for (var _len = arguments.length, additionalFilterArgs = Array(_len), _key = 0; _key < _len; _key++) {
          additionalFilterArgs[_key] = arguments[_key];
        }

        items = this.customFilter.apply(this, [items, this.search, this.filter].concat(additionalFilterArgs));
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.hasPagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (!this.mustSort) {
        this.updatePagination({ sortBy: null, descending: null });
      } else {
        this.updatePagination({ sortBy: index, descending: false });
      }
    },
    toggle: function toggle(value) {
      var _this3 = this;

      var selected = Object.assign({}, this.selected);
      for (var index = 0; index < this.filteredItems.length; index++) {
        selected[this.filteredItems[index][this.itemKey]] = value;
      }

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this3.itemKey]];
      }));
    },
    createProps: function createProps(item, index) {
      var _this4 = this;

      var props = { item: item, index: index };
      var keyProp = this.itemKey;
      var itemKey = item[keyProp];

      Object.defineProperty(props, 'selected', {
        get: function get() {
          return _this4.selected[item[_this4.itemKey]];
        },
        set: function set(value) {
          if (itemKey == null) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('"' + keyProp + '" attribute must be defined for item', _this4);
          }

          var selected = _this4.value.slice();
          if (value) selected.push(item);else selected = selected.filter(function (i) {
            return i[keyProp] !== itemKey;
          });
          _this4.$emit('input', selected);
        }
      });

      Object.defineProperty(props, 'expanded', {
        get: function get() {
          return _this4.expanded[item[_this4.itemKey]];
        },
        set: function set(value) {
          if (itemKey == null) {
            Object(__WEBPACK_IMPORTED_MODULE_7__util_console__["b" /* consoleWarn */])('"' + keyProp + '" attribute must be defined for item', _this4);
          }

          if (!_this4.expand) {
            for (var key in _this4.expanded) {
              _this4.expanded.hasOwnProperty(key) && _this4.$set(_this4.expanded, key, false);
            }
          }
          _this4.$set(_this4.expanded, itemKey, value);
        }
      });

      return props;
    },
    genItems: function genItems() {
      if (!this.itemsLength && !this.items.length) {
        var noData = this.$slots['no-data'] || this.noDataText;
        return [this.genEmptyItems(noData)];
      }

      if (!this.filteredItems.length) {
        var noResults = this.$slots['no-results'] || this.noResultsText;
        return [this.genEmptyItems(noResults)];
      }

      return this.genFilteredItems();
    },
    genPrevIcon: function genPrevIcon() {
      var _this5 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VBtn__["a" /* default */], {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this5.computedPagination.page;
            _this5.updatePagination({ page: page - 1 });
          }
        },
        attrs: {
          'aria-label': 'Previous page' // TODO: Localization
        }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_VIcon__["a" /* default */], this.prevIcon)]);
    },
    genNextIcon: function genNextIcon() {
      var _this6 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VBtn__["a" /* default */], {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this6.computedPagination.page;
            _this6.updatePagination({ page: page + 1 });
          }
        },
        attrs: {
          'aria-label': 'Next page' // TODO: Localization
        }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_VIcon__["a" /* default */], this.nextIcon)]);
    },
    genSelect: function genSelect() {
      var _this7 = this;

      return this.$createElement('div', {
        'class': this.actionsSelectClasses
      }, [this.rowsPerPageText, this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_VSelect__["a" /* default */], {
        attrs: {
          'aria-label': this.rowsPerPageText
        },
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this7.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': this.actionsPaginationClasses
      }, [pagination]);
    },
    genActions: function genActions() {
      var rangeControls = this.$createElement('div', {
        'class': this.actionsRangeControlsClasses
      }, [this.genPagination(), this.genPrevIcon(), this.genNextIcon()]);

      return [this.$createElement('div', {
        'class': this.actionsClasses
      }, [this.rowsPerPageItems.length > 1 ? this.genSelect() : null, rangeControls])];
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(137);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'filterable',

  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mask__ = __webpack_require__(139);
/**
 * Maskable
 *
 * @mixin
 *
 * Creates an input mask that is
 * generated from a masked str
 *
 * Example: mask="#### #### #### ####"
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'maskable',

  data: function data() {
    return {
      selection: 0,
      lazySelection: 0,
      preDefined: {
        'credit-card': '#### - #### - #### - ####',
        'date': '##/##/####',
        'date-with-time': '##/##/#### ##:##',
        'phone': '(###) ### - ####',
        'social': '###-##-####',
        'time': '##:##',
        'time-with-seconds': '##:##:##'
      }
    };
  },

  props: {
    dontFillMaskBlanks: Boolean,
    mask: {
      type: [Object, String],
      default: null
    },
    returnMaskedValue: Boolean
  },

  computed: {
    masked: function masked() {
      var preDefined = this.preDefined[this.mask];
      var mask = preDefined || this.mask || '';

      return mask.split('');
    }
  },

  watch: {
    /**
     * Make sure the cursor is in the correct
     * location when the mask changes
     */
    mask: function mask() {
      var _this = this;

      if (!this.$refs.input) return;

      var oldValue = this.$refs.input.value;
      var newValue = this.maskText(Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["c" /* unmaskText */])(this.lazyValue));
      var position = 0;
      var selection = this.selection;

      for (var index = 0; index < selection; index++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(oldValue[index]) || position++;
      }

      selection = 0;
      if (newValue) {
        for (var _index = 0; _index < newValue.length; _index++) {
          Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(newValue[_index]) || position--;
          selection++;
          if (position <= 0) break;
        }
      }

      this.$nextTick(function () {
        _this.$refs.input.value = newValue;
        _this.setCaretPosition(selection);
      });
    }
  },

  beforeMount: function beforeMount() {
    if (!this.mask || this.value == null || !this.returnMaskedValue) return;

    var value = this.maskText(this.value);

    // See if masked value does not
    // match the user given value
    if (value === this.value) return;

    this.$emit('input', value);
  },


  methods: {
    setCaretPosition: function setCaretPosition(selection) {
      var _this2 = this;

      this.selection = selection;
      window.setTimeout(function () {
        _this2.$refs.input && _this2.$refs.input.setSelectionRange(_this2.selection, _this2.selection);
      }, 0);
    },
    updateRange: function updateRange() {
      if (!this.$refs.input) return;

      var newValue = this.maskText(this.lazyValue);
      var selection = 0;

      this.$refs.input.value = newValue;
      if (newValue) {
        for (var index = 0; index < newValue.length; index++) {
          if (this.lazySelection <= 0) break;
          Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(newValue[index]) || this.lazySelection--;
          selection++;
        }
      }

      this.setCaretPosition(selection);
      // this.$emit() must occur only when all internal values are correct
      this.$emit('input', this.returnMaskedValue ? this.$refs.input.value : this.lazyValue);
    },
    maskText: function maskText(text) {
      return this.mask ? Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["b" /* maskText */])(text, this.masked, this.dontFillMaskBlanks) : text;
    },
    unmaskText: function unmaskText(text) {
      return this.mask && !this.returnMaskedValue ? Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["c" /* unmaskText */])(text) : text;
    },

    // When the input changes and is
    // re-created, ensure that the
    // caret location is correct
    setSelectionRange: function setSelectionRange() {
      this.$nextTick(this.updateRange);
    },
    resetSelections: function resetSelections(input) {
      if (!input.selectionEnd) return;
      this.selection = input.selectionEnd;
      this.lazySelection = 0;

      for (var index = 0; index < this.selection; index++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_mask__["a" /* isMaskDelimiter */])(input.value[index]) || this.lazySelection++;
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'soloable',

  props: {
    flat: Boolean,
    soloInverted: Boolean,
    solo: Boolean
  },

  computed: {
    isSolo: function isSolo() {
      return this.solo || this.soloInverted;
    }
  },

  methods: {
    genSoloClasses: function genSoloClasses() {
      return {
        'input-group--solo': this.isSolo,
        'input-group--solo-inverted': this.soloInverted,
        'elevation-0': this.flat
      };
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(144);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Delayable
 *
 * @mixin
 *
 * Changes the open or close
 * delay time for elements
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'delayable',

  data: function data() {
    return {
      openTimeout: null,
      closeTimeout: null
    };
  },

  props: {
    openDelay: {
      type: [Number, String],
      default: 0
    },
    closeDelay: {
      type: [Number, String],
      default: 200
    }
  },

  methods: {
    /**
     * Clear any pending delay
     * timers from executing
     *
     * @return {void}
     */
    clearDelay: function clearDelay() {
      clearTimeout(this.openTimeout);
      clearTimeout(this.closeTimeout);
    },

    /**
     * Runs callback after
     * a specified delay
     *
     * @param  {String}   type
     * @param  {Function} cb
     *
     * @return {void}
     */
    runDelay: function runDelay(type, cb) {
      this.clearDelay();

      var delay = parseInt(this[type + 'Delay'], 10);

      this[type + 'Timeout'] = setTimeout(cb, delay);
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackable__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themeable__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






/* eslint-disable object-property-newline */
var dimensions = {
  activator: {
    top: 0, left: 0,
    bottom: 0, right: 0,
    width: 0, height: 0,
    offsetTop: 0, scrollHeight: 0
  },
  content: {
    top: 0, left: 0,
    bottom: 0, right: 0,
    width: 0, height: 0,
    offsetTop: 0, scrollHeight: 0
  },
  hasWindow: false
  /* eslint-enable object-property-newline */

  /**
   * Menuable
   *
   * @mixin
   *
   * Used for fixed or absolutely positioning
   * elements within the DOM
   * Can calculate X and Y axis overflows
   * As well as be manually positioned
   */
};/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menuable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__stackable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__themeable__["a" /* default */]],

  data: function data() {
    return {
      absoluteX: 0,
      absoluteY: 0,
      dimensions: Object.assign({}, dimensions),
      isContentActive: false,
      pageYOffset: 0,
      stackClass: 'menuable__content__active',
      stackMinZIndex: 6
    };
  },

  props: {
    activator: {
      default: null,
      validator: function validator(val) {
        return ['string', 'object'].includes(typeof val === 'undefined' ? 'undefined' : _typeof(val));
      }
    },
    allowOverflow: Boolean,
    maxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    minWidth: [Number, String],
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: [Number, String],
      default: 0
    },
    nudgeRight: {
      type: [Number, String],
      default: 0
    },
    nudgeTop: {
      type: [Number, String],
      default: 0
    },
    nudgeWidth: {
      type: [Number, String],
      default: 0
    },
    offsetOverflow: Boolean,
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    zIndex: {
      type: [Number, String],
      default: null
    }
  },

  computed: {
    computedLeft: function computedLeft() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var minWidth = a.width < c.width ? c.width : a.width;
      var left = 0;

      left += this.left ? a.left - (minWidth - a.width) : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
      if (this.nudgeRight) left += parseInt(this.nudgeRight);

      return left;
    },
    computedTop: function computedTop() {
      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (!this.isAttached) top += this.pageYOffset;
      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      return top;
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    },
    isAttached: function isAttached() {
      return this.attach !== false;
    }
  },

  watch: {
    disabled: function disabled(val) {
      val && this.callDeactivate();
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val ? this.callActivate() : this.callDeactivate();
    }
  },

  beforeMount: function beforeMount() {
    this.checkForWindow();
  },


  methods: {
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    activate: function activate() {},
    calcLeft: function calcLeft() {
      return (this.isAttached ? this.computedLeft : this.calcXOverflow(this.computedLeft)) + 'px';
    },
    calcTop: function calcTop() {
      return (this.isAttached ? this.computedTop : this.calcYOverflow(this.computedTop)) + 'px';
    },
    calcXOverflow: function calcXOverflow(left) {
      var parsedMaxWidth = isNaN(parseInt(this.maxWidth)) ? 0 : parseInt(this.maxWidth);
      var innerWidth = this.getInnerWidth();
      var maxWidth = Math.max(this.dimensions.content.width, parsedMaxWidth);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 600 ? 30 : 12) // Account for scrollbar
        ;
      }

      if (left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var documentHeight = this.getInnerHeight();
      var toTop = this.pageYOffset + documentHeight;
      var activator = this.dimensions.activator;
      var contentHeight = this.dimensions.content.height;
      var totalHeight = top + contentHeight;
      var isOverflowing = toTop < totalHeight;

      // If overflowing bottom and offset
      // TODO: set 'bottom' position instead of 'top'
      if (isOverflowing && this.offsetOverflow) {
        top = this.pageYOffset + (activator.top - contentHeight);
        // If overflowing bottom
      } else if (isOverflowing && !this.allowOverflow) {
        top = toTop - contentHeight - 12;
        // If overflowing top
      } else if (top < this.pageYOffset && !this.allowOverflow) {
        top = this.pageYOffset + 12;
      }

      return top < 12 ? 12 : top;
    },
    callActivate: function callActivate() {
      if (!this.hasWindow) return;

      this.activate();
    },
    callDeactivate: function callDeactivate() {
      this.isContentActive = false;

      this.deactivate();
    },
    checkForWindow: function checkForWindow() {
      if (!this.hasWindow) {
        this.hasWindow = typeof window !== 'undefined';
      }
    },
    checkForPageYOffset: function checkForPageYOffset() {
      if (this.hasWindow) {
        this.pageYOffset = this.getOffsetTop();
      }
    },
    deactivate: function deactivate() {},
    getActivator: function getActivator() {
      if (this.activator) {
        return typeof this.activator === 'string' ? document.querySelector(this.activator) : this.activator;
      }

      return this.$refs.activator.children.length > 0 ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    getInnerHeight: function getInnerHeight() {
      if (!this.hasWindow) return 0;

      return window.innerHeight || document.documentElement.clientHeight;
    },
    getInnerWidth: function getInnerWidth() {
      if (!this.hasWindow) return 0;

      return window.innerWidth;
    },
    getOffsetTop: function getOffsetTop() {
      if (!this.hasWindow) return 0;

      return window.pageYOffset || document.documentElement.scrollTop;
    },
    getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
      var rect = el.getBoundingClientRect();
      return {
        top: Math.round(rect.top),
        left: Math.round(rect.left),
        bottom: Math.round(rect.bottom),
        right: Math.round(rect.right),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
      };
    },
    measure: function measure(el, selector) {
      el = selector ? el.querySelector(selector) : el;

      if (!el || !this.hasWindow) return null;

      var rect = this.getRoundedBoundedClientRect(el);

      // Account for activator margin
      if (this.isAttached) {
        var style = window.getComputedStyle(el);

        rect.left = parseInt(style.marginLeft);
        rect.top = parseInt(style.marginTop);
      }

      return rect;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;

        if (!el || _this.isShown(el)) return cb();

        el.style.display = 'inline-block';
        cb();
        el.style.display = 'none';
      });
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
    },
    isShown: function isShown(el) {
      return el.style.display !== 'none';
    },
    updateDimensions: function updateDimensions() {
      var _this3 = this;

      this.checkForWindow();
      this.checkForPageYOffset();

      var dimensions = {};

      // Activator should already be shown
      dimensions.activator = !this.hasActivator || this.absolute ? this.absolutePosition() : this.measure(this.getActivator());

      // Display and hide to get dimensions
      this.sneakPeek(function () {
        dimensions.content = _this3.measure(_this3.$refs.content);

        _this3.dimensions = dimensions;
      });
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(152);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__ = __webpack_require__(159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__VList__["a"]; });
/* unused harmony reexport VListGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__VListTile__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a"]; });
/* unused harmony reexport VListTileAvatar */









var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */]);
  Vue.component(VListTileActionText.name, VListTileActionText);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VListTileAvatar__["a" /* default */]);
  Vue.component(VListTileContent.name, VListTileContent);
  Vue.component(VListTileSubTitle.name, VListTileSubTitle);
  Vue.component(VListTileTitle.name, VListTileTitle);
};

/* harmony default export */ __webpack_exports__["f"] = (__WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */]);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_title_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_picker_button__ = __webpack_require__(58);


// Components


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-title',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_picker_button__["a" /* default */]],

  data: function data() {
    return {
      isReversing: false
    };
  },

  props: {
    date: {
      type: String,
      default: ''
    },
    selectingYear: Boolean,
    year: {
      type: [Number, String],
      default: ''
    },
    yearIcon: {
      type: String
    },
    value: {
      type: String
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing ? 'picker-reverse-transition' : 'picker-transition';
    }
  },

  watch: {
    value: function value(val, prev) {
      this.isReversing = val < prev;
    }
  },

  methods: {
    genYearIcon: function genYearIcon() {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], {
        props: {
          dark: true
        }
      }, this.yearIcon);
    },
    getYearBtn: function getYearBtn() {
      return this.genPickerButton('selectingYear', true, [this.year, this.yearIcon ? this.genYearIcon() : null], 'date-picker-title__year');
    },
    genTitleText: function genTitleText() {
      return this.$createElement('transition', {
        props: {
          name: this.computedTransition
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: this.date || '&nbsp;' },
        key: this.value
      })]);
    },
    genTitleDate: function genTitleDate(title) {
      return this.genPickerButton('selectingYear', false, this.genTitleText(title), 'date-picker-title__date');
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'date-picker-title'
    }, [this.getYearBtn(), this.genTitleDate()]);
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPickerButton: function genPickerButton(prop, value, content) {
      var _this = this;

      var staticClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      var active = this[prop] === value;
      var click = function click(event) {
        event.stopPropagation();
        _this.$emit('update:' + prop, value);
      };

      return this.$createElement('div', {
        staticClass: ('picker__title__btn ' + staticClass).trim(),
        'class': { active: active },
        on: active ? undefined : { click: click }
      }, Array.isArray(content) ? content : [content]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_header_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(14);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



// Components



// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-header',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      isReversing: false,
      defaultColor: 'accent'
    };
  },


  props: {
    disabled: Boolean,
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: String,
    max: String,
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    value: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    formatter: function formatter() {
      if (this.format) {
        return this.format;
      } else if (String(this.value).split('-')[1]) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* createNativeLocaleFormatter */])(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }, { length: 7 });
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
      }
    }
  },

  watch: {
    value: function value(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },

  methods: {
    genBtn: function genBtn(change) {
      var _this = this;

      var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */], {
        props: {
          dark: this.dark,
          disabled: disabled,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.$emit('input', _this.calculateChange(change));
          }
        }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], change < 0 ? this.prevIcon : this.nextIcon)]);
    },
    calculateChange: function calculateChange(sign) {
      var _String$split$map = String(this.value).split('-').map(function (v) {
        return 1 * v;
      }),
          _String$split$map2 = _slicedToArray(_String$split$map, 2),
          year = _String$split$map2[0],
          month = _String$split$map2[1];

      if (month == null) {
        return '' + (year + sign);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* monthChange */])(String(this.value), sign);
      }
    },
    genHeader: function genHeader() {
      var _this2 = this;

      var header = this.$createElement('strong', {
        'class': this.disabled ? undefined : this.addTextColorClassChecks(),
        key: String(this.value),
        on: {
          click: function click() {
            return _this2.$emit('toggle');
          }
        }
      }, [this.$slots.default || this.formatter(String(this.value))]);

      var transition = this.$createElement('transition', {
        props: {
          name: this.isReversing ? 'tab-reverse-transition' : 'tab-transition'
        }
      }, [header]);

      return this.$createElement('div', {
        staticClass: 'date-picker-header__value',
        class: {
          'date-picker-header__value--disabled': this.disabled
        }
      }, [transition]);
    }
  },

  render: function render(h) {
    return this.$createElement('div', {
      staticClass: 'date-picker-header'
    }, [this.genBtn(-1), this.genHeader(), this.genBtn(+1)]);
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(2);
// Mixins



// Utils



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-date-table',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__["a" /* default */]],

  props: {
    events: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [String, Function, Object],
      default: 'warning'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    weekdayFormat: {
      type: Function,
      default: null
    }
  },

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { day: 'numeric', timeZone: 'UTC' }, { start: 8, length: 2 });
    },
    weekdayFormatter: function weekdayFormatter() {
      return this.weekdayFormat || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { weekday: 'narrow', timeZone: 'UTC' });
    },
    weekDays: function weekDays() {
      var _this = this;

      var first = parseInt(this.firstDayOfWeek, 10);

      return this.weekdayFormatter ? Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["d" /* createRange */])(7).map(function (i) {
        return _this.weekdayFormatter('2017-01-' + (first + i + 15));
      }) // 2017-01-15 is Sunday
      : Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["d" /* createRange */])(7).map(function (i) {
        return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][(i + first) % 7];
      });
    }
  },

  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* monthChange */])(this.tableDate, Math.sign(delta || 1));
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.weekDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genEvent: function genEvent(date) {
      var eventColor = void 0;
      if (typeof this.eventColor === 'string') {
        eventColor = this.eventColor;
      } else if (typeof this.eventColor === 'function') {
        eventColor = this.eventColor(date);
      } else {
        eventColor = this.eventColor[date];
      }
      return this.$createElement('div', {
        staticClass: 'date-picker-table__event',
        class: this.addBackgroundColorClassChecks({}, eventColor || this.color)
      });
    },

    // Returns number of the days from the firstDayOfWeek to the first day of the current month
    weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
      var firstDayOfTheMonth = new Date(this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(this.displayedMonth + 1) + '-01T00:00:00+00:00');
      var weekDay = firstDayOfTheMonth.getUTCDay();
      return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
    },
    isEvent: function isEvent(date) {
      if (Array.isArray(this.events)) {
        return this.events.indexOf(date) > -1;
      } else if (this.events instanceof Function) {
        return this.events(date);
      } else {
        return false;
      }
    },
    genTBody: function genTBody() {
      var children = [];
      var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
      var rows = [];
      var day = this.weekDaysBeforeFirstDayOfTheMonth();

      while (day--) {
        rows.push(this.$createElement('td'));
      }for (day = 1; day <= daysInMonth; day++) {
        var date = this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(this.displayedMonth + 1) + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(day);

        rows.push(this.$createElement('td', [this.genButton(date, true), this.isEvent(date) ? this.genEvent(date) : null]));

        if (rows.length % 7 === 0) {
          children.push(this.genTR(rows));
          rows = [];
        }
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      return this.$createElement('tbody', children);
    },
    genTR: function genTR(children) {
      return [this.$createElement('tr', children)];
    }
  },

  render: function render(h) {
    return this.genTable('date-picker-table date-picker-table--date', [this.genTHead(), this.genTBody()]);
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_table_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_touch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isDateAllowed__ = __webpack_require__(62);


// Directives


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  directives: { Touch: __WEBPACK_IMPORTED_MODULE_1__directives_touch__["a" /* default */] },

  data: function data() {
    return {
      defaultColor: 'accent',
      isReversing: false
    };
  },


  props: {
    allowedDates: Function,
    current: String,
    disabled: Boolean,
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: String,
    max: String,
    scrollable: Boolean,
    tableDate: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.isReversing ? 'tab-reverse-transition' : 'tab-transition';
    },
    displayedMonth: function displayedMonth() {
      return this.tableDate.split('-')[1] - 1;
    },
    displayedYear: function displayedYear() {
      return this.tableDate.split('-')[0] * 1;
    }
  },

  watch: {
    tableDate: function tableDate(newVal, oldVal) {
      this.isReversing = newVal < oldVal;
    }
  },

  methods: {
    genButtonClasses: function genButtonClasses(value, isDisabled, isFloating) {
      var isSelected = value === this.value;
      var isCurrent = value === this.current;

      var classes = {
        'btn--active': isSelected,
        'btn--flat': !isSelected,
        'btn--icon': isSelected && !isDisabled && isFloating,
        'btn--floating': isFloating,
        'btn--depressed': !isFloating && isSelected,
        'btn--disabled': isDisabled || this.disabled && isSelected,
        'btn--outline': isCurrent && !isSelected
      };

      if (isSelected) return this.addBackgroundColorClassChecks(classes);
      if (isCurrent) return this.addTextColorClassChecks(classes);
      return classes;
    },
    genButton: function genButton(value, isFloating) {
      var _this = this;

      var isDisabled = !Object(__WEBPACK_IMPORTED_MODULE_2__util_isDateAllowed__["a" /* default */])(value, this.min, this.max, this.allowedDates);

      return this.$createElement('button', {
        staticClass: 'btn',
        'class': this.genButtonClasses(value, isDisabled, isFloating),
        attrs: {
          type: 'button'
        },
        domProps: {
          disabled: isDisabled,
          innerHTML: '<div class="btn__content">' + this.formatter(value) + '</div>'
        },
        on: isDisabled ? {} : {
          click: function click() {
            return _this.$emit('input', value);
          }
        }
      });
    },
    wheel: function wheel(e) {
      e.preventDefault();
      this.$emit('tableDate', this.calculateTableDate(e.deltaY));
    },
    touch: function touch(value) {
      this.$emit('tableDate', this.calculateTableDate(value));
    },
    genTable: function genTable(staticClass, children) {
      var _this2 = this;

      var transition = this.$createElement('transition', {
        props: { name: this.computedTransition }
      }, [this.$createElement('table', { key: this.tableDate }, children)]);

      var touchDirective = {
        name: 'touch',
        value: {
          left: function left(e) {
            return e.offsetX < -15 && _this2.touch(1);
          },
          right: function right(e) {
            return e.offsetX > 15 && _this2.touch(-1);
          }
        }
      };

      return this.$createElement('div', {
        staticClass: staticClass,
        on: this.scrollable ? { wheel: this.wheel } : undefined,
        directives: [touchDirective]
      }, [transition]);
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDateAllowed;
function isDateAllowed(date, min, max, allowedFn) {
  return (!allowedFn || allowedFn(date)) && (!min || date >= min) && (!max || date <= max);
}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);
// Mixins



// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-month-table',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_picker_table__["a" /* default */]],

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { month: 'short', timeZone: 'UTC' }, { start: 5, length: 2 });
    }
  },

  methods: {
    calculateTableDate: function calculateTableDate(delta) {
      return '' + (parseInt(this.tableDate, 10) + Math.sign(delta || 1));
    },
    genTBody: function genTBody() {
      var _this = this;

      var children = [];
      var cols = Array(3).fill(null);
      var rows = 12 / cols.length;

      var _loop = function _loop(row) {
        var tds = cols.map(function (_, col) {
          var month = row * cols.length + col;
          return _this.$createElement('td', {
            key: month
          }, [_this.genButton(_this.displayedYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* pad */])(month + 1), false)]);
        });

        children.push(_this.$createElement('tr', {
          key: row
        }, tds));
      };

      for (var row = 0; row < rows; row++) {
        _loop(row);
      }

      return this.$createElement('tbody', children);
    }
  },

  render: function render(h) {
    return this.genTable('date-picker-table date-picker-table--month', [this.genTBody()]);
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_date_picker_years_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(14);


// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker-years',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'primary'
    };
  },


  props: {
    format: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    min: [Number, String],
    max: [Number, String],
    value: [Number, String]
  },

  computed: {
    formatter: function formatter() {
      return this.format || Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
    }
  },

  mounted: function mounted() {
    this.$el.scrollTop = this.$el.scrollHeight / 2 - this.$el.offsetHeight / 2;
  },


  methods: {
    genYearItem: function genYearItem(year) {
      var _this = this;

      var formatted = this.formatter('' + year);

      return this.$createElement('li', {
        key: year,
        'class': parseInt(this.value, 10) === year ? this.addTextColorClassChecks({ active: true }) : {},
        on: {
          click: function click() {
            return _this.$emit('input', year);
          }
        }
      }, formatted);
    },
    genYearItems: function genYearItems() {
      var children = [];
      var selectedYear = this.value ? parseInt(this.value, 10) : new Date().getFullYear();
      var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
      var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);

      for (var year = maxYear; year >= minYear; year--) {
        children.push(this.genYearItem(year));
      }

      return children;
    }
  },

  render: function render(h) {
    return this.$createElement('ul', {
      staticClass: 'date-picker-years',
      ref: 'years'
    }, this.genYearItems());
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VPicker__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themeable__ = __webpack_require__(1);
// Components


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__themeable__["a" /* default */]],

  props: {
    fullWidth: Boolean,
    headerColor: String,
    landscape: Boolean,
    noTitle: Boolean,
    width: {
      type: [Number, String],
      default: 290,
      validator: function validator(value) {
        return parseInt(value, 10) > 0;
      }
    }
  },

  methods: {
    genPickerTitle: function genPickerTitle() {},
    genPickerBody: function genPickerBody() {},
    genPickerActionsSlot: function genPickerActionsSlot() {
      return this.$scopedSlots.default ? this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      }) : this.$slots.default;
    },
    genPicker: function genPicker(staticClass) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VPicker__["a" /* default */], {
        staticClass: staticClass,
        class: this.fullWidth ? ['picker--full-width'] : [],
        props: {
          color: this.headerColor || this.color,
          dark: this.dark,
          fullWidth: this.fullWidth,
          landscape: this.landscape,
          light: this.light,
          width: this.width
        }
      }, [this.noTitle ? null : this.genPickerTitle(), this.genPickerBody(), this.$createElement('template', { slot: 'actions' }, [this.genPickerActionsSlot()])]);
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPicker__ = __webpack_require__(182);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VPicker__["a" /* default */]);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_touch__ = __webpack_require__(9);
// Mixins


// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-items',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_0__mixins_registrable__["b" /* provide */])('tabs')],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_1__directives_touch__["a" /* default */] },

  inject: {
    registerItems: {
      default: null
    },
    tabProxy: {
      default: null
    },
    unregisterItems: {
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      lazyValue: this.value,
      reverse: false
    };
  },


  props: {
    cycle: Boolean,
    touchless: Boolean,
    value: [Number, String]
  },

  computed: {
    activeIndex: function activeIndex() {
      var _this = this;

      return this.items.findIndex(function (item, index) {
        return (item.id || index.toString()) === _this.lazyValue;
      });
    },
    activeItem: function activeItem() {
      if (!this.items.length) return undefined;

      return this.items[this.activeIndex];
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        val = val.toString();

        this.lazyValue = val;

        if (this.tabProxy) this.tabProxy(val);else this.$emit('input', val);
      }
    }
  },

  watch: {
    activeIndex: function activeIndex(current, previous) {
      this.reverse = current < previous;
      this.updateItems();
    },
    value: function value(val) {
      this.lazyValue = val;
    }
  },

  mounted: function mounted() {
    this.registerItems && this.registerItems(this.changeModel);
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterItems && this.unregisterItems();
  },


  methods: {
    changeModel: function changeModel(val) {
      this.inputValue = val;
    },
    next: function next(cycle) {
      var nextIndex = this.activeIndex + 1;

      if (!this.items[nextIndex]) {
        if (!cycle) return;
        nextIndex = 0;
      }

      this.inputValue = this.items[nextIndex].id || nextIndex;
    },
    prev: function prev(cycle) {
      var prevIndex = this.activeIndex - 1;

      if (!this.items[prevIndex]) {
        if (!cycle) return;
        prevIndex = this.items.length - 1;
      }

      this.inputValue = this.items[prevIndex].id || prevIndex;
    },
    onSwipe: function onSwipe(action) {
      this[action](this.cycle);
    },
    register: function register(item) {
      this.items.push(item);
    },
    unregister: function unregister(item) {
      this.items = this.items.filter(function (i) {
        return i !== item;
      });
    },
    updateItems: function updateItems() {
      for (var index = this.items.length; --index >= 0;) {
        this.items[index].toggle(this.lazyValue, this.reverse, this.isBooted, index);
      }
      this.isBooted = true;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var data = {
      staticClass: 'tabs__items',
      directives: []
    };

    !this.touchless && data.directives.push({
      name: 'touch',
      value: {
        left: function left() {
          return _this2.onSwipe('next');
        },
        right: function right() {
          return _this2.onSwipe('prev');
        }
      }
    });

    return h('div', data, this.$slots.default);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent'
    };
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'tabs__slider',
      class: this.addBackgroundColorClassChecks()
    });
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_title_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_picker_button__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__ = __webpack_require__(14);


// Mixins


// Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker-title',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_picker_button__["a" /* default */]],

  props: {
    ampm: Boolean,
    hour: Number,
    minute: Number,
    period: {
      type: String,
      validator: function validator(period) {
        return period === 'am' || period === 'pm';
      }
    },
    selectingHour: Boolean
  },

  methods: {
    genTime: function genTime() {
      var hour = this.hour;
      if (this.ampm) {
        hour = hour ? (hour - 1) % 12 + 1 : 12;
      }

      var displayedHour = this.hour == null ? '--' : this.ampm ? hour : Object(__WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__["c" /* pad */])(hour);
      var displayedMinute = this.minute == null ? '--' : Object(__WEBPACK_IMPORTED_MODULE_2__VDatePicker_util__["c" /* pad */])(this.minute);

      return this.$createElement('div', {
        'class': 'time-picker-title__time'
      }, [this.genPickerButton('selectingHour', true, displayedHour), this.$createElement('span', ':'), this.genPickerButton('selectingHour', false, displayedMinute)]);
    },
    genAmPm: function genAmPm() {
      return this.$createElement('div', {
        staticClass: 'time-picker-title__ampm'
      }, [this.genPickerButton('period', 'am', 'am'), this.genPickerButton('period', 'pm', 'pm')]);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'time-picker-title'
    }, [this.genTime(), this.ampm ? this.genAmPm() : null]);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_time_picker_clock_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__ = __webpack_require__(1);


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker-clock',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent',
      inputValue: this.value,
      isDragging: false
    };
  },


  props: {
    allowedValues: Function,
    double: Boolean,
    format: {
      type: Function,
      default: function _default(val) {
        return val;
      }
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    scrollable: Boolean,
    rotate: {
      type: Number,
      default: 0
    },
    size: {
      type: [Number, String],
      default: 270
    },
    step: {
      type: Number,
      default: 1
    },
    value: Number
  },

  computed: {
    count: function count() {
      return this.max - this.min + 1;
    },
    innerRadius: function innerRadius() {
      return this.radius - Math.max(this.radius * 0.4, 48);
    },
    outerRadius: function outerRadius() {
      return this.radius - 4;
    },
    roundCount: function roundCount() {
      return this.double ? this.count / 2 : this.count;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.roundCount;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    radius: function radius() {
      return this.size / 2;
    },
    displayedValue: function displayedValue() {
      return this.value == null ? this.min : this.value;
    }
  },

  watch: {
    value: function value(_value) {
      this.inputValue = _value;
    }
  },

  methods: {
    wheel: function wheel(e) {
      e.preventDefault();
      var value = this.displayedValue + Math.sign(e.wheelDelta || 1);
      this.update((value - this.min + this.count) % this.count + this.min);
    },
    handScale: function handScale(value) {
      return this.double && value - this.min >= this.roundCount ? this.innerRadius / this.radius : this.outerRadius / this.radius;
    },
    isAllowed: function isAllowed(value) {
      return !this.allowedValues || this.allowedValues(value);
    },
    genValues: function genValues() {
      var children = [];

      for (var value = this.min; value <= this.max; value = value + this.step) {
        var classes = {
          active: value === this.displayedValue,
          disabled: !this.isAllowed(value)
        };

        children.push(this.$createElement('span', {
          'class': this.addBackgroundColorClassChecks(classes, value === this.value ? this.computedColor : null),
          style: this.getTransform(value),
          domProps: { innerHTML: '<span>' + this.format(value) + '</span>' }
        }));
      }

      return children;
    },
    genHand: function genHand() {
      var scale = 'scaleY(' + this.handScale(this.displayedValue) + ')';
      var angle = this.rotate + this.degreesPerUnit * (this.displayedValue - this.min);

      return this.$createElement('div', {
        staticClass: 'time-picker-clock__hand',
        'class': this.value == null ? {} : this.addBackgroundColorClassChecks(),
        style: {
          transform: 'rotate(' + angle + 'deg) ' + scale
        }
      });
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(value) {
      var radius = (this.radius - 24) * this.handScale(value);
      var rotateRadians = this.rotate * Math.PI / 180;
      return {
        x: Math.round(Math.sin((value - this.min) * this.degrees + rotateRadians) * radius),
        y: Math.round(-Math.cos((value - this.min) * this.degrees + rotateRadians) * radius)
      };
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      this.isAllowed(this.inputValue) && this.$emit('change', this.inputValue);
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var _$refs$clock$getBound = this.$refs.clock.getBoundingClientRect(),
          width = _$refs$clock$getBound.width,
          top = _$refs$clock$getBound.top,
          left = _$refs$clock$getBound.left;

      var _ref = 'touches' in e ? e.touches[0] : e,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var center = { x: width / 2, y: -width / 2 };
      var coords = { x: clientX - left, y: top - clientY };
      var handAngle = Math.round(this.angle(center, coords) - this.rotate + 360) % 360;
      var insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;
      var value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.roundCount : 0);

      // Necessary to fix edge case when selecting left part of max value
      if (handAngle >= 360 - this.degreesPerUnit / 2) {
        this.update(insideClick ? this.max : this.min);
      } else {
        this.update(value);
      }
    },
    update: function update(value) {
      if (this.inputValue !== value && this.isAllowed(value)) {
        this.inputValue = value;
        this.$emit('input', value);
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = p1.x - p0.x;
      var dy = p1.y - p0.y;

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
      return Math.abs(value * 180 / Math.PI);
    }
  },

  render: function render(h) {
    var _this = this;

    var data = {
      staticClass: 'time-picker-clock',
      class: {
        'time-picker-clock--indeterminate': this.value == null
      },
      on: {
        mousedown: this.onMouseDown,
        mouseup: this.onMouseUp,
        mouseleave: function mouseleave() {
          return _this.isDragging && _this.onMouseUp();
        },
        touchstart: this.onMouseDown,
        touchend: this.onMouseUp,
        mousemove: this.onDragMove,
        touchmove: this.onDragMove
      },
      style: {
        height: this.size + 'px',
        width: this.size + 'px'
      },
      ref: 'clock'
    };

    this.scrollable && (data.on.wheel = this.wheel);

    return this.$createElement('div', data, [this.genHand(), this.genValues()]);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = binding.value;
  var options = binding.options || { passive: true };
  var target = binding.arg || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    callback: callback,
    options: options,
    target: target
  };
}

function unbind(el, binding) {
  if (!el._onScroll) return;

  var _el$_onScroll = el._onScroll,
      callback = _el$_onScroll.callback,
      options = _el$_onScroll.options,
      target = _el$_onScroll.target;


  target.removeEventListener('scroll', callback, options);
  delete el._onScroll;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scroll',
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_app_styl__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(258);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function Vuetify(Vue, args) {
  var Vuetify = __WEBPACK_IMPORTED_MODULE_1__components__["Vuetify"];

  Vue.use(Vuetify, _extends({
    components: __WEBPACK_IMPORTED_MODULE_1__components__,
    directives: __WEBPACK_IMPORTED_MODULE_2__directives__
  }, args));
}

Vuetify.version = '1.0.17';

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Vuetify);
}

/* harmony default export */ __webpack_exports__["default"] = (Vuetify);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Vuetify__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Vuetify", function() { return __WEBPACK_IMPORTED_MODULE_0__Vuetify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VApp__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return __WEBPACK_IMPORTED_MODULE_1__VApp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VAlert__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return __WEBPACK_IMPORTED_MODULE_2__VAlert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VAvatar__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return __WEBPACK_IMPORTED_MODULE_3__VAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VBadge__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return __WEBPACK_IMPORTED_MODULE_4__VBadge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VBottomNav__ = __webpack_require__(99);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return __WEBPACK_IMPORTED_MODULE_5__VBottomNav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VBottomSheet__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return __WEBPACK_IMPORTED_MODULE_6__VBottomSheet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VBreadcrumbs__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_7__VBreadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VBtn__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return __WEBPACK_IMPORTED_MODULE_8__VBtn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VBtnToggle__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return __WEBPACK_IMPORTED_MODULE_9__VBtnToggle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__VCard__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return __WEBPACK_IMPORTED_MODULE_10__VCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__VCarousel__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return __WEBPACK_IMPORTED_MODULE_11__VCarousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__VCheckbox__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_12__VCheckbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VChip__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return __WEBPACK_IMPORTED_MODULE_13__VChip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__VDataIterator__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return __WEBPACK_IMPORTED_MODULE_14__VDataIterator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__VDataTable__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return __WEBPACK_IMPORTED_MODULE_15__VDataTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__VDatePicker__ = __webpack_require__(174);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return __WEBPACK_IMPORTED_MODULE_16__VDatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__VDialog__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return __WEBPACK_IMPORTED_MODULE_17__VDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__VDivider__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return __WEBPACK_IMPORTED_MODULE_18__VDivider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__VExpansionPanel__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return __WEBPACK_IMPORTED_MODULE_19__VExpansionPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__VFooter__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return __WEBPACK_IMPORTED_MODULE_20__VFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__VForm__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return __WEBPACK_IMPORTED_MODULE_21__VForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__VGrid__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VGrid", function() { return __WEBPACK_IMPORTED_MODULE_22__VGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__VIcon__ = __webpack_require__(3);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return __WEBPACK_IMPORTED_MODULE_23__VIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__VJumbotron__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return __WEBPACK_IMPORTED_MODULE_24__VJumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__VList__ = __webpack_require__(56);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return __WEBPACK_IMPORTED_MODULE_25__VList__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__VMenu__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return __WEBPACK_IMPORTED_MODULE_26__VMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__VNavigationDrawer__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return __WEBPACK_IMPORTED_MODULE_27__VNavigationDrawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__VPagination__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return __WEBPACK_IMPORTED_MODULE_28__VPagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__VParallax__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return __WEBPACK_IMPORTED_MODULE_29__VParallax__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__VPicker__ = __webpack_require__(66);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return __WEBPACK_IMPORTED_MODULE_30__VPicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__VProgressCircular__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return __WEBPACK_IMPORTED_MODULE_31__VProgressCircular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__VProgressLinear__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return __WEBPACK_IMPORTED_MODULE_32__VProgressLinear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__VRadioGroup__ = __webpack_require__(210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_33__VRadioGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__VSelect__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return __WEBPACK_IMPORTED_MODULE_34__VSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__VSlider__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return __WEBPACK_IMPORTED_MODULE_35__VSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__VSnackbar__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return __WEBPACK_IMPORTED_MODULE_36__VSnackbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__VSpeedDial__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return __WEBPACK_IMPORTED_MODULE_37__VSpeedDial__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__VStepper__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return __WEBPACK_IMPORTED_MODULE_38__VStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__VSubheader__ = __webpack_require__(55);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return __WEBPACK_IMPORTED_MODULE_39__VSubheader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__VSwitch__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return __WEBPACK_IMPORTED_MODULE_40__VSwitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__VSystemBar__ = __webpack_require__(232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return __WEBPACK_IMPORTED_MODULE_41__VSystemBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__VTabs__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return __WEBPACK_IMPORTED_MODULE_42__VTabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__VTextField__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return __WEBPACK_IMPORTED_MODULE_43__VTextField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__VTimePicker__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return __WEBPACK_IMPORTED_MODULE_44__VTimePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__VToolbar__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return __WEBPACK_IMPORTED_MODULE_45__VToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__VTooltip__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return __WEBPACK_IMPORTED_MODULE_46__VTooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__transitions__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transitions", function() { return __WEBPACK_IMPORTED_MODULE_47__transitions__["g"]; });

















































/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_application__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_theme__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_options__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_goTo__ = __webpack_require__(79);






var Vuetify = {
  install: function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (this.installed) return;

    this.installed = true;

    checkVueVersion(Vue);

    Vue.prototype.$vuetify = new Vue({
      data: {
        application: __WEBPACK_IMPORTED_MODULE_0__mixins_application__["a" /* default */],
        breakpoint: {},
        dark: false,
        options: Object(__WEBPACK_IMPORTED_MODULE_2__mixins_options__["a" /* default */])(opts.options),
        theme: Object(__WEBPACK_IMPORTED_MODULE_1__mixins_theme__["a" /* default */])(opts.theme)
      },
      methods: {
        goTo: __WEBPACK_IMPORTED_MODULE_4__util_goTo__["a" /* default */]
      }
    });

    if (opts.transitions) {
      Object.values(opts.transitions).forEach(function (transition) {
        if (transition.name !== undefined && transition.name.startsWith('v-')) {
          Vue.component(transition.name, transition);
        }
      });
    }

    if (opts.directives) {
      Object.values(opts.directives).forEach(function (directive) {
        Vue.directive(directive.name, directive);
      });
    }

    if (opts.components) {
      Object.values(opts.components).forEach(function (component) {
        Vue.use(component);
      });
    }
  }
};

/* istanbul ignore next */
function checkVueVersion(Vue) {
  var vueDep = '^2.5.0';

  var required = vueDep.split('.').map(function (v) {
    return v.replace(/\D/g, '');
  });
  var actual = Vue.version.split('.');

  // Simple semver caret range comparison
  var passes = actual[0] === required[0] && ( // major matches
  actual[1] > required[1] || // minor is greater
  actual[1] === required[1] && actual[2] >= required[2] // or minor is eq and patch is >=
  );

  if (!passes) {
    Object(__WEBPACK_IMPORTED_MODULE_3__util_console__["b" /* consoleWarn */])('Vuetify requires Vue version ' + vueDep);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (Vuetify);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["a"] = ({
  bar: 0,
  bottom: 0,
  footer: 0,
  left: 0,
  right: 0,
  top: 0,
  components: {
    bar: {},
    bottom: {},
    footer: {},
    left: {},
    right: {},
    top: {}
  },
  bind: function bind(uid, target, value) {
    if (!this.components[target]) return;

    this.components[target] = _defineProperty({}, uid, value);
    this.update(target);
  },
  unbind: function unbind(uid, target) {
    if (this.components[target][uid] == null) return;

    delete this.components[target][uid];
    this.update(target);
  },
  update: function update(target) {
    this[target] = Object.values(this.components[target]).reduce(function (acc, cur) {
      return acc + cur;
    }, 0);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = theme;
/* eslint-disable no-multi-spaces */
var THEME_DEFAULTS = {
  primary: '#1976D2', // blue.darken2
  secondary: '#424242', // grey.darken3
  accent: '#82B1FF', // blue.accent1
  error: '#FF5252', // red.accent2
  info: '#2196F3', // blue.base
  success: '#4CAF50', // green.base
  warning: '#FFC107' // amber.base
};

function theme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.assign({}, THEME_DEFAULTS, theme);
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = options;
var OPTIONS_DEFAULTS = {
  themeVariations: ['primary', 'secondary', 'accent'],
  minifyTheme: null,
  themeCache: null
};

function options() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.assign({}, OPTIONS_DEFAULTS, options);
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_easing_patterns__ = __webpack_require__(80);



var defaults = {
  duration: 500,
  offset: 0,
  easing: 'easeInOutCubic'
};

function getDocumentHeight() {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
}

function getWindowHeight() {
  return window.innerHeight || (document.documentElement || document.body).clientHeight;
}

function isVueComponent(obj) {
  return obj != null && obj._isVue;
}

function getTargetLocation(target, settings) {
  var location = void 0;

  if (isVueComponent(target)) {
    target = target.$el;
  }

  if (target instanceof Element) {
    location = target.getBoundingClientRect().top + window.scrollY;
  } else if (typeof target === 'string') {
    location = document.querySelector(target).offsetTop;
  } else if (typeof target === 'number') {
    location = target;
  } else {
    return undefined;
  }

  return Math.round(Math.min(Math.max(location + settings.offset, 0), getDocumentHeight() - getWindowHeight()));
}

function goTo(target, options) {
  if (typeof window === 'undefined') return;

  var settings = Object.assign({}, defaults, options);

  var startTime = performance.now();
  var startLocation = window.pageYOffset;
  var targetLocation = getTargetLocation(target, settings);
  var distanceToScroll = targetLocation - startLocation;
  var easingFunction = typeof settings.easing === 'function' ? settings.easing : __WEBPACK_IMPORTED_MODULE_1__util_easing_patterns__[settings.easing];

  if (isNaN(targetLocation)) {
    var type = target == null ? target : target.constructor.name;
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Target must be a Selector/Number/DOMElement/VueComponent, received ' + type + ' instead.');
  }
  if (!easingFunction) return Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Easing function \'' + settings.easing + '\' not found.');

  function step(currentTime) {
    var progressPercentage = Math.min(1, (currentTime - startTime) / settings.duration);
    var targetPosition = Math.floor(startLocation + distanceToScroll * easingFunction(progressPercentage));

    window.scrollTo(0, targetPosition);

    if (Math.round(window.pageYOffset) === targetLocation || progressPercentage === 1) return;

    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuad", function() { return easeInQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuad", function() { return easeOutQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuad", function() { return easeInOutQuad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInCubic", function() { return easeInCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutCubic", function() { return easeOutCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutCubic", function() { return easeInOutCubic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuart", function() { return easeInQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuart", function() { return easeOutQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuart", function() { return easeInOutQuart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuint", function() { return easeInQuint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuint", function() { return easeOutQuint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuint", function() { return easeInOutQuint; });
// linear
var linear = function linear(t) {
  return t;
};
// accelerating from zero velocity
var easeInQuad = function easeInQuad(t) {
  return t * t;
};
// decelerating to zero velocity
var easeOutQuad = function easeOutQuad(t) {
  return t * (2 - t);
};
// acceleration until halfway, then deceleration
var easeInOutQuad = function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var easeInCubic = function easeInCubic(t) {
  return t * t * t;
};
// decelerating to zero velocity
var easeOutCubic = function easeOutCubic(t) {
  return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var easeInOutCubic = function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var easeInQuart = function easeInQuart(t) {
  return t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuart = function easeOutQuart(t) {
  return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuart = function easeInOutQuart(t) {
  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var easeInQuint = function easeInQuint(t) {
  return t * t * t * t * t;
};
// decelerating to zero velocity
var easeOutQuint = function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var easeInOutQuint = function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(82);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_app_theme__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_app_breakpoint__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_resize__ = __webpack_require__(11);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Component level mixins



// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-app',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_app_breakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_app_theme__["a" /* default */]],

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_3__directives_resize__["a" /* default */]
  },

  props: {
    id: {
      type: String,
      default: 'app'
    },
    dark: Boolean
  },

  computed: {
    classes: function classes() {
      return _defineProperty({}, 'theme--' + (this.dark ? 'dark' : 'light'), true);
    }
  },

  mounted: function mounted() {
    this.$vuetify.dark = this.dark;
  },


  watch: {
    dark: function dark() {
      this.$vuetify.dark = this.dark;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'application',
      'class': this.classes,
      attrs: { 'data-app': true },
      domProps: { id: this.id },
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    };

    var wrapper = h('div', { staticClass: 'application--wrap' }, this.$slots.default);

    return h('div', data, [wrapper]);
  }
});

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_colorUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_theme__ = __webpack_require__(85);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      style: null
    };
  },

  computed: {
    parsedTheme: function parsedTheme() {
      return __WEBPACK_IMPORTED_MODULE_1__util_theme__["c" /* parse */](this.$vuetify.theme);
    },

    /** @return string */
    generatedStyles: function generatedStyles() {
      var theme = this.parsedTheme;
      var css = void 0;

      if (this.$vuetify.options.themeCache != null) {
        css = this.$vuetify.options.themeCache.get(theme);
        if (css != null) return css;
      }

      var colors = Object.keys(theme);
      css = 'a { color: ' + Object(__WEBPACK_IMPORTED_MODULE_0__util_colorUtils__["b" /* intToHex */])(theme.primary) + '; }';

      for (var i = 0; i < colors.length; ++i) {
        var name = colors[i];
        var value = theme[name];
        if (this.$vuetify.options.themeVariations.includes(name)) {
          css += __WEBPACK_IMPORTED_MODULE_1__util_theme__["b" /* genVariations */](name, value).join('');
        } else {
          css += __WEBPACK_IMPORTED_MODULE_1__util_theme__["a" /* genBaseColor */](name, value);
        }
      }

      if (this.$vuetify.options.minifyTheme != null) {
        css = this.$vuetify.options.minifyTheme(css);
      }

      if (this.$vuetify.options.themeCache != null) {
        this.$vuetify.options.themeCache.set(theme, css);
      }

      return css;
    },
    vueMeta: function vueMeta() {
      return {
        style: [{
          cssText: this.generatedStyles,
          type: 'text/css',
          id: 'vuetify-theme-stylesheet'
        }]
      };
    }
  },

  // Regular vue-meta
  metaInfo: function metaInfo() {
    return this.vueMeta;
  },


  // Nuxt
  head: function head() {
    return this.vueMeta;
  },


  watch: {
    generatedStyles: function generatedStyles() {
      !this.meta && this.applyTheme();
    }
  },

  created: function created() {
    if (this.$meta) {
      // Vue-meta
      // Handled by metaInfo()/nuxt()
    } else if (typeof document === 'undefined' && this.$ssrContext) {
      // SSR
      this.$ssrContext.head = this.$ssrContext.head || '';
      this.$ssrContext.head += '<style type="text/css" id="vuetify-theme-stylesheet">' + this.generatedStyles + '</style>';
    } else if (typeof document !== 'undefined') {
      // Client-side
      this.genStyle();
      this.applyTheme();
    }
  },


  methods: {
    applyTheme: function applyTheme() {
      if (this.style) this.style.innerHTML = this.generatedStyles;
    },
    genStyle: function genStyle() {
      var style = document.getElementById('vuetify-theme-stylesheet');

      if (!style) {
        style = document.createElement('style');
        style.type = 'text/css';
        style.id = 'vuetify-theme-stylesheet';
        document.head.appendChild(style);
      }

      this.style = style;
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = genVariations;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return genBaseColor; });
/* unused harmony export genVariantColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorUtils__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__ = __webpack_require__(87);




/**
 * @param {object} theme
 * @returns {object}
 */
function parse(theme) {
  var colors = Object.keys(theme);
  var parsedTheme = {};

  for (var i = 0; i < colors.length; ++i) {
    var name = colors[i];
    var value = theme[name];

    parsedTheme[name] = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["a" /* colorToInt */])(value);
  }

  return parsedTheme;
}

function genVariations(name, value) {
  var values = Array(10);
  values[0] = genBaseColor(name, value);

  for (var i = 1, n = 5; i <= 5; ++i, --n) {
    values[i] = genVariantColor(name, lighten(value, n), 'lighten', n);
  }

  for (var _i = 1; _i <= 4; ++_i) {
    values[_i + 5] = genVariantColor(name, darken(value, _i), 'darken', _i);
  }

  return values;
}

function lighten(value, amount) {
  var lab = __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["b" /* toXYZ */](value));
  lab[0] = lab[0] + amount * 10;
  return __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["b" /* toXYZ */](lab));
}

function darken(value, amount) {
  var lab = __WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["b" /* toXYZ */](value));
  lab[0] = lab[0] - amount * 10;
  return __WEBPACK_IMPORTED_MODULE_1__color_transformSRGB__["a" /* fromXYZ */](__WEBPACK_IMPORTED_MODULE_2__color_transformCIELAB__["b" /* toXYZ */](lab));
}

/**
 * Generate the CSS for a base color (.primary)
 *
 * @param {string} name - The color name
 * @param {string|number} value - The color value
 * @returns {string}
 */
var genBaseColor = function genBaseColor(name, value) {
  value = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["b" /* intToHex */])(value);
  return '\n.' + name + ' {\n  background-color: ' + value + ' !important;\n  border-color: ' + value + ' !important;\n}\n.' + name + '--text {\n  color: ' + value + ' !important;\n}\n.' + name + '--text input,\n.' + name + '--text textarea {\n  caret-color: ' + value + ' !important;\n}\n.' + name + '--after::after {\n  background: ' + value + ' !important;\n}';
};

/**
 * Generate the CSS for a variant color (.primary.darken-2)
 *
 * @param {string} name - The color name
 * @param {string|number} value - The color value
 * @param {string} type - The variant type (darken/lighten)
 * @param {number} n - The darken/lighten step number
 * @returns {string}
 */
var genVariantColor = function genVariantColor(name, value, type, n) {
  value = Object(__WEBPACK_IMPORTED_MODULE_0__colorUtils__["b" /* intToHex */])(value);
  return '\n.' + name + '.' + type + '-' + n + ' {\n  background-color: ' + value + ' !important;\n  border-color: ' + value + ' !important;\n}\n.' + name + '--text.text--' + type + '-' + n + ' {\n  color: ' + value + ' !important;\n}\n.' + name + '--text.text--' + type + '-' + n + ' input,\n.' + name + '--text.text--' + type + '-' + n + ' textarea {\n  caret-color: ' + value + ' !important;\n}\n.' + name + '.' + type + '-' + n + '--after::after {\n  background: ' + value + ' !important;\n}';
};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromXYZ;
/* harmony export (immutable) */ __webpack_exports__["b"] = toXYZ;
// For converting XYZ to sRGB
var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]];

// Forward gamma adjust
var srgbForwardTransform = function srgbForwardTransform(C) {
  return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
};

// For converting sRGB to XYZ
var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];

// Reverse gamma adjust
var srgbReverseTransform = function srgbReverseTransform(C) {
  return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
};

function clamp(value) {
  return Math.max(0, Math.min(1, value));
}

function fromXYZ(xyz) {
  var rgb = Array(3);
  var transform = srgbForwardTransform;
  var matrix = srgbForwardMatrix;

  // Matrix transform, then gamma adjustment
  for (var i = 0; i < 3; ++i) {
    rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
  }

  // Rescale back to [0, 255]
  return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
}

function toXYZ(rgb) {
  var xyz = Array(3);
  var transform = srgbReverseTransform;
  var matrix = srgbReverseMatrix;

  // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
  var r = transform((rgb >> 16 & 0xff) / 255);
  var g = transform((rgb >> 8 & 0xff) / 255);
  var b = transform((rgb >> 0 & 0xff) / 255);

  // Matrix color space transform
  for (var i = 0; i < 3; ++i) {
    xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
  }

  return xyz;
}

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromXYZ;
/* harmony export (immutable) */ __webpack_exports__["b"] = toXYZ;
var delta = 0.20689655172413793; // 6÷29

var cielabForwardTransform = function cielabForwardTransform(t) {
  return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
};

var cielabReverseTransform = function cielabReverseTransform(t) {
  return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
};

function fromXYZ(xyz) {
  var transform = cielabForwardTransform;
  var transformedY = transform(xyz[1]);

  return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
}

function toXYZ(lab) {
  var transform = cielabReverseTransform;
  var Ln = (lab[0] + 16) / 116;
  return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A modified version of https://gist.github.com/cb109/b074a65f7595cffc21cea59ce8d15f9b
 */

/**
 * A Vue mixin to get the current width/height and the associated breakpoint.
 *
 * Useful to e.g. adapt the user interface from inside a Vue component
 * as opposed to using CSS classes. The breakpoint pixel values and
 * range names are taken from Vuetify (https://github.com/vuetifyjs).
 *
 * Use within a component:
 *
 *   import breakpoint from './breakpoint.js'
 *
 *   export default {
 *     name: 'my-component',
 *     mixins: [breakpoint],
 *     ...
 *
 * Then inside a template:
 *
 *   <div v-if="$breakpoint.smAndDown">...</div>
 */
var breakpoint = {
  data: function data() {
    return {
      clientWidth: clientDimensions.getWidth(),
      clientHeight: clientDimensions.getHeight(),
      resizeTimeout: null
    };
  },


  computed: {
    breakpoint: function breakpoint() {
      var xs = this.clientWidth < 600;
      var sm = this.clientWidth < 960 && !xs;
      var md = this.clientWidth < 1280 - 16 && !(sm || xs);
      var lg = this.clientWidth < 1920 - 16 && !(md || sm || xs);
      var xl = this.clientWidth >= 1920 - 16 && !(lg || md || sm || xs);

      var xsOnly = xs;
      var smOnly = sm;
      var smAndDown = (xs || sm) && !(md || lg || xl);
      var smAndUp = !xs && (sm || md || lg || xl);
      var mdOnly = md;
      var mdAndDown = (xs || sm || md) && !(lg || xl);
      var mdAndUp = !(xs || sm) && (md || lg || xl);
      var lgOnly = lg;
      var lgAndDown = (xs || sm || md || lg) && !xl;
      var lgAndUp = !(xs || sm || md) && (lg || xl);
      var xlOnly = xl;

      var name = void 0;
      switch (true) {
        case xs:
          name = 'xs';
          break;
        case sm:
          name = 'sm';
          break;
        case md:
          name = 'md';
          break;
        case lg:
          name = 'lg';
          break;
        default:
          name = 'xl';
          break;
      }

      var result = {
        // Definite breakpoint.
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,

        // Useful e.g. to construct CSS class names dynamically.
        name: name,

        // Breakpoint ranges.
        xsOnly: xsOnly,
        smOnly: smOnly,
        smAndDown: smAndDown,
        smAndUp: smAndUp,
        mdOnly: mdOnly,
        mdAndDown: mdAndDown,
        mdAndUp: mdAndUp,
        lgOnly: lgOnly,
        lgAndDown: lgAndDown,
        lgAndUp: lgAndUp,
        xlOnly: xlOnly,

        // For custom breakpoint logic.
        width: this.clientWidth,
        height: this.clientHeight
      };

      return result;
    }
  },

  watch: {
    breakpoint: function breakpoint(val) {
      this.$vuetify.breakpoint = val;
    }
  },

  created: function created() {
    this.$vuetify.breakpoint = this.breakpoint;
  },


  methods: {
    onResize: function onResize() {
      var _this = this;

      clearTimeout(this.resizeTimeout);

      // Added debounce to match what
      // v-resize used to do but was
      // removed due to a memory leak
      // https://github.com/vuetifyjs/vuetify/pull/2997
      this.resizeTimeout = setTimeout(function () {
        _this.clientWidth = clientDimensions.getWidth();
        _this.clientHeight = clientDimensions.getHeight();
      }, 200);
    }
  }

  // Cross-browser support as described in:
  // https://stackoverflow.com/questions/1248081
};var clientDimensions = {
  getWidth: function getWidth() {
    if (typeof document === 'undefined') return 0; // SSR
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  },
  getHeight: function getHeight() {
    if (typeof document === 'undefined') return 0; // SSR
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (breakpoint);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(90);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_alerts_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__ = __webpack_require__(24);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    icon: String,
    outline: Boolean,
    type: {
      type: String,
      validator: function validator(val) {
        return ['info', 'error', 'success', 'warning'].includes(val);
      }
    }
  },

  data: function data() {
    return {
      defaultColor: 'error'
    };
  },

  computed: {
    classes: function classes() {
      var color = this.type && !this.color ? this.type : this.computedColor;
      var classes = {
        'alert--dismissible': this.dismissible,
        'alert--outline': this.outline
      };

      return this.outline ? this.addTextColorClassChecks(classes, color) : this.addBackgroundColorClassChecks(classes, color);
    },
    computedIcon: function computedIcon() {
      if (this.icon || !this.type) return this.icon;

      switch (this.type) {
        case 'info':
          return 'info';
        case 'error':
          return 'warning';
        case 'success':
          return 'check_circle';
        case 'warning':
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (this.computedIcon) {
      children.unshift(h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], {
        'class': 'alert__icon'
      }, this.computedIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], {
        props: {
          right: true
        }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      staticClass: 'alert',
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_icons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var SIZE_MAP = {
  small: '16px',
  default: '24px',
  medium: '28px',
  large: '36px',
  xLarge: '40px'
};

function isFontAwesome5(iconType) {
  return ['fas', 'far', 'fal', 'fab'].some(function (val) {
    return iconType.includes(val);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-icon',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    disabled: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    size: {
      type: [Number, String]
    },
    small: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;
    var small = props.small,
        medium = props.medium,
        large = props.large,
        xLarge = props.xLarge;

    var sizes = { small: small, medium: medium, large: large, xLarge: xLarge };
    var explicitSize = Object.keys(sizes).find(function (key) {
      return sizes[key] && key;
    });
    var fontSize = explicitSize && SIZE_MAP[explicitSize] || Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["b" /* convertToUnit */])(props.size);

    if (fontSize) data.style = _extends({ fontSize: fontSize }, data.style);

    var iconName = '';
    if (children.length) iconName = children.pop().text;
    // Support usage of v-text and v-html
    else if (data.domProps) {
        iconName = data.domProps.textContent || data.domProps.innerHTML || iconName;

        // Remove nodes so it doesn't
        // overwrite our changes
        delete data.domProps.textContent;
        delete data.domProps.innerHTML;
      }

    var iconType = 'material-icons';
    // Material Icon delimiter is _
    // https://material.io/icons/
    var delimiterIndex = iconName.indexOf('-');
    var isCustomIcon = delimiterIndex > -1;

    if (isCustomIcon) {
      iconType = iconName.slice(0, delimiterIndex);

      if (isFontAwesome5(iconType)) iconType = '';
      // Assume if not a custom icon
      // is Material Icon font
    } else children.push(iconName);

    data.attrs = data.attrs || {};
    if (!('aria-hidden' in data.attrs)) {
      data.attrs['aria-hidden'] = true;
    }

    var classes = Object.assign({
      'icon--disabled': props.disabled,
      'icon--left': props.left,
      'icon--right': props.right,
      'theme--dark': props.dark,
      'theme--light': props.light
    }, props.color ? __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */].methods.addTextColorClassChecks.call(props, {}, props.color) : {});

    // Order classes
    // * Component class
    // * Vuetify classes
    // * Icon Classes
    data.staticClass = ['icon', data.staticClass, Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' '), iconType, isCustomIcon ? iconName : null].reduce(function (prev, curr) {
      return curr ? prev + ' ' + curr : prev;
    }).trim();

    return h('i', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_avatars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_helpers__ = __webpack_require__(2);


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-avatar',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('avatar ' + (data.staticClass || '')).trim();
    data.style = data.style || {};

    if (props.tile) data.staticClass += ' avatar--tile';

    var size = Object(__WEBPACK_IMPORTED_MODULE_2__util_helpers__["b" /* convertToUnit */])(props.size);
    data.style.height = size;
    data.style.width = size;
    data.class = [data.class, __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */].methods.addBackgroundColorClassChecks.call(props, {}, props.color)];

    return h('div', data, children);
  }
});

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBadge__ = __webpack_require__(97);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBadge__["a" /* default */]);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_badges_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__ = __webpack_require__(24);


// Mixins





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-badge',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["b" /* factory */])(['left', 'bottom']), __WEBPACK_IMPORTED_MODULE_4__mixins_transitionable__["a" /* default */]],

  props: {
    color: {
      type: String,
      default: 'primary'
    },
    overlap: Boolean,
    transition: {
      type: String,
      default: 'fab-transition'
    },
    value: {
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'badge--bottom': this.bottom,
        'badge--left': this.left,
        'badge--overlap': this.overlap
      };
    }
  },

  render: function render(h) {
    var badge = this.$slots.badge ? [h('span', {
      staticClass: 'badge__badge',
      'class': this.addBackgroundColorClassChecks(),
      attrs: this.attrs,
      directives: [{
        name: 'show',
        value: this.isActive
      }]
    }, this.$slots.badge)] : null;

    return h('span', {
      staticClass: 'badge',
      'class': this.classes
    }, [this.$slots.default, h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, badge)]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(100);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_navs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_button_group__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
// Styles


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-bottom-nav',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('bottom', ['height', 'value']), __WEBPACK_IMPORTED_MODULE_2__mixins_button_group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  props: {
    active: [Number, String],
    height: {
      default: 56,
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    shift: Boolean,
    value: { required: false }
  },

  watch: {
    active: function active() {
      this.update();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'bottom-nav--absolute': this.absolute,
        'bottom-nav--fixed': !this.absolute && (this.app || this.fixed),
        'bottom-nav--shift': this.shift,
        'bottom-nav--active': this.value
      };
    },
    computedHeight: function computedHeight() {
      return parseInt(this.height);
    }
  },

  methods: {
    isSelected: function isSelected(i) {
      var item = this.getValue(i);
      return this.active === item;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return !this.value ? 0 : this.computedHeight;
    },
    updateValue: function updateValue(i) {
      var item = this.getValue(i);

      this.$emit('update:active', item);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'bottom-nav',
      class: this.addBackgroundColorClassChecks(this.classes),
      style: {
        height: parseInt(this.computedHeight) + 'px'
      },
      ref: 'content'
    }, this.$slots.default);
  }
});

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomSheet__ = __webpack_require__(103);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBottomSheet__["a" /* default */]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_bottom_sheets_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDialog_VDialog__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-bottom-sheet',

  props: {
    disabled: Boolean,
    fullWidth: Boolean,
    hideOverlay: Boolean,
    inset: Boolean,
    lazy: Boolean,
    maxWidth: {
      type: [String, Number],
      default: 'auto'
    },
    persistent: Boolean,
    value: null
  },

  render: function render(h) {
    var activator = h('template', {
      slot: 'activator'
    }, this.$slots.activator);

    var contentClass = ['bottom-sheet', this.inset ? 'bottom-sheet--inset' : ''].join(' ');

    return h(__WEBPACK_IMPORTED_MODULE_1__VDialog_VDialog__["a" /* default */], {
      attrs: _extends({}, this.$props),
      on: _extends({}, this.$listeners),
      props: {
        contentClass: contentClass,
        transition: 'bottom-sheet-transition',
        value: this.value
      }
    }, [activator, this.$slots.default]);
  }
});

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(110);
/* unused harmony reexport VBreadcrumbs */
/* unused harmony reexport VBreadcrumbsItem */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */]);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_breadcrumbs_styl__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  props: {
    divider: {
      type: String,
      default: '/'
    },
    large: Boolean,
    justifyCenter: Boolean,
    justifyEnd: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs--large': this.large
      };
    },
    computedDivider: function computedDivider() {
      return this.$slots.divider ? this.$slots.divider : this.divider;
    },
    styles: function styles() {
      var justify = this.justifyCenter ? 'center' : this.justifyEnd ? 'flex-end' : 'flex-start';

      return {
        'justify-content': justify
      };
    }
  },

  methods: {
    /**
     * Add dividers between
     * v-breadcrumbs-item
     *
     * @return {array}
     */
    genChildren: function genChildren() {
      if (!this.$slots.default) return null;

      var h = this.$createElement;
      var children = [];
      var dividerData = { staticClass: 'breadcrumbs__divider' };

      var createDividers = false;
      for (var i = 0; i < this.$slots.default.length; i++) {
        var elm = this.$slots.default[i];

        if (!elm.componentOptions || elm.componentOptions.Ctor.options.name !== 'v-breadcrumbs-item') {
          children.push(elm);
        } else {
          if (createDividers) {
            children.push(h('li', dividerData, this.computedDivider));
          }
          children.push(elm);
          createDividers = true;
        }
      }

      return children;
    }
  },

  render: function render(h) {
    return h('ul', {
      staticClass: 'breadcrumbs',
      'class': this.classes,
      style: this.styles
    }, this.genChildren());
  }
});

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_routable__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_routable__["a" /* default */]],

  props: {
    // In a breadcrumb, the currently
    // active item should be dimmed
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--disabled'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, this.disabled);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_buttons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_registrable__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Styles


// Components


// Mixins







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["b" /* factory */])('inputValue'), Object(__WEBPACK_IMPORTED_MODULE_7__mixins_registrable__["a" /* inject */])('buttonGroup')],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    depressed: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    },
    value: null
  },

  computed: {
    classes: function classes() {
      var _extends2;

      var classes = _extends((_extends2 = {
        'btn': true
      }, _defineProperty(_extends2, this.activeClass, this.isActive), _defineProperty(_extends2, 'btn--absolute', this.absolute), _defineProperty(_extends2, 'btn--block', this.block), _defineProperty(_extends2, 'btn--bottom', this.bottom), _defineProperty(_extends2, 'btn--disabled', this.disabled), _defineProperty(_extends2, 'btn--flat', this.flat), _defineProperty(_extends2, 'btn--floating', this.fab), _defineProperty(_extends2, 'btn--fixed', this.fixed), _defineProperty(_extends2, 'btn--hover', this.hover), _defineProperty(_extends2, 'btn--icon', this.icon), _defineProperty(_extends2, 'btn--large', this.large), _defineProperty(_extends2, 'btn--left', this.left), _defineProperty(_extends2, 'btn--loader', this.loading), _defineProperty(_extends2, 'btn--outline', this.outline), _defineProperty(_extends2, 'btn--depressed', this.depressed && !this.flat || this.outline), _defineProperty(_extends2, 'btn--right', this.right), _defineProperty(_extends2, 'btn--round', this.round), _defineProperty(_extends2, 'btn--router', this.to), _defineProperty(_extends2, 'btn--small', this.small), _defineProperty(_extends2, 'btn--top', this.top), _extends2), this.themeClasses);

      return !this.outline && !this.flat ? this.addBackgroundColorClassChecks(classes) : this.addTextColorClassChecks(classes);
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */], {
          props: {
            indeterminate: true,
            size: 23,
            width: 2
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  mounted: function mounted() {
    if (this.buttonGroup) {
      this.buttonGroup.register(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.buttonGroup) {
      this.buttonGroup.unregister(this);
    }
  },
  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    data.attrs.value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);

    return h(tag, data, children);
  }
});

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_circular_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    button: Boolean,

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      return Number(this.size) + (this.button ? 8 : 0);
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return this.addTextColorClassChecks({
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      });
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return 20;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    strokeWidth: function strokeWidth() {
      return this.width / this.size * this.viewBoxSize * 2;
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBoxSize: function viewBoxSize() {
      return this.radius / (1 - this.width / this.size);
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: 2 * this.viewBoxSize,
          cy: 2 * this.viewBoxSize,
          r: this.radius,
          'stroke-width': this.strokeWidth,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [this.indeterminate || this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: this.viewBoxSize + ' ' + this.viewBoxSize + ' ' + 2 * this.viewBoxSize + ' ' + 2 * this.viewBoxSize
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtnToggle__ = __webpack_require__(116);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VBtnToggle__["a" /* default */]);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_button_toggle_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_button_group__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_console__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_button_group__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_themeable__["a" /* default */]],

  props: {
    inputValue: {
      required: false
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.hasValue,
        'theme--light': this.light,
        'theme--dark': this.dark
      };
    },
    hasValue: function hasValue() {
      return this.multiple && this.inputValue.length || !this.multiple && this.inputValue !== null && typeof this.inputValue !== 'undefined';
    }
  },

  watch: {
    inputValue: {
      handler: function handler() {
        this.update();
      },

      deep: true
    }
  },

  methods: {
    isSelected: function isSelected(i) {
      var item = this.getValue(i);
      if (!this.multiple) {
        return this.inputValue === item;
      }

      return this.inputValue.includes(item);
    },
    updateValue: function updateValue(i) {
      var item = this.getValue(i);
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item) return;
        return this.$emit('change', this.inputValue === item ? null : item);
      }

      var items = this.inputValue.slice();

      var index = items.indexOf(item);
      if (index > -1) {
        if (this.mandatory && items.length === 1) return;
        items.length >= 1 && items.splice(index, 1);
      } else {
        items.push(item);
      }

      this.$emit('change', items);
    },
    updateAllValues: function updateAllValues() {
      if (!this.multiple) return;

      var items = [];

      for (var i = 0; i < this.buttons.length; ++i) {
        var item = this.getValue(i);
        var index = this.inputValue.indexOf(item);
        if (index !== -1) {
          items.push(item);
        }
      }

      this.$emit('change', items);
    }
  },

  created: function created() {
    if (this.multiple && !Array.isArray(this.inputValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__util_console__["b" /* consoleWarn */])('Model must be bound to an array if the multiple property is true.', this);
    }
  },
  render: function render(h) {
    return h('div', { class: this.classes }, this.$slots.default);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_cards_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tag: {
      type: String,
      default: 'div'
    },
    tile: Boolean,
    width: [String, Number]
  },

  computed: {
    classes: function classes() {
      return this.addBackgroundColorClassChecks({
        'card': true,
        'card--flat': this.flat,
        'card--horizontal': this.horizontal,
        'card--hover': this.hover,
        'card--raised': this.raised,
        'card--tile': this.tile,
        'theme--light': this.light,
        'theme--dark': this.dark
      });
    },
    styles: function styles() {
      var style = {
        height: isNaN(this.height) ? this.height : this.height + 'px'
      };

      if (this.img) {
        style.background = 'url("' + this.img + '") center center / cover no-repeat';
      }

      if (this.width) {
        style.width = isNaN(this.width) ? this.width : this.width + 'px';
      }

      return style;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.style = this.styles;

    return h(tag, data, this.$slots.default);
  }
});

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url("' + this.src + '") center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-title',

  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(125);
/* unused harmony reexport VCarousel */
/* unused harmony reexport VCarouselItem */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */]);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_carousel_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_touch__ = __webpack_require__(9);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_5__mixins_registrable__["b" /* provide */])('carousel')],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_6__directives_touch__["a" /* default */] },

  data: function data() {
    return {
      inputValue: null,
      items: [],
      slideTimeout: null,
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    delimiterIcon: {
      type: String,
      default: 'fiber_manual_record'
    },
    hideControls: Boolean,
    hideDelimiters: Boolean,
    interval: {
      type: [Number, String],
      default: 6000,
      validator: function validator(value) {
        return value > 0;
      }
    },
    nextIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    },
    prevIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    value: Number
  },

  watch: {
    items: function items() {
      if (this.inputValue >= this.items.length) {
        this.inputValue = this.items.length - 1;
      }
    },
    inputValue: function inputValue() {
      // Evaluates items when inputValue changes to
      // account for dynamic changing of children

      var uid = (this.items[this.inputValue] || {}).uid;
      for (var index = this.items.length; --index >= 0;) {
        this.items[index].open(uid, this.reverse);
      }

      this.$emit('input', this.inputValue);
      this.restartTimeout();
    },
    value: function value(val) {
      this.inputValue = val;
    },
    interval: function interval() {
      this.restartTimeout();
    },
    cycle: function cycle(val) {
      if (val) {
        this.restartTimeout();
      } else {
        clearTimeout(this.slideTimeout);
        this.slideTimeout = null;
      }
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genDelimiters: function genDelimiters() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
        props: { 'size': '46px' }
      }, icon)])]);
    },
    genItems: function genItems() {
      var _this = this;

      return this.items.map(function (item, index) {
        return _this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this.inputValue
          },
          props: {
            icon: true,
            small: true,
            dark: _this.dark || !_this.light,
            light: _this.light
          },
          key: index,
          on: { click: _this.select.bind(_this, index) }
        }, [_this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
          props: { size: '18px' }
        }, _this.delimiterIcon)]);
      });
    },
    restartTimeout: function restartTimeout() {
      this.slideTimeout && clearTimeout(this.slideTimeout);
      this.slideTimeout = null;

      var raf = requestAnimationFrame || setTimeout;
      raf(this.startTimeout);
    },
    init: function init() {
      this.inputValue = this.value || 0;
    },
    next: function next() {
      this.reverse = false;
      this.inputValue = (this.inputValue + 1) % this.items.length;
    },
    prev: function prev() {
      this.reverse = true;
      this.inputValue = (this.inputValue + this.items.length - 1) % this.items.length;
    },
    select: function select(index) {
      this.reverse = index < this.inputValue;
      this.inputValue = index;
    },
    startTimeout: function startTimeout() {
      var _this2 = this;

      if (!this.cycle) return;

      this.slideTimeout = setTimeout(function () {
        return _this2.next();
      }, this.interval > 0 ? this.interval : 6000);
    },
    register: function register(uid, open) {
      this.items.push({ uid: uid, open: open });
    },
    unregister: function unregister(uid) {
      this.items = this.items.filter(function (i) {
        return i.uid !== uid;
      });
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.hideControls ? null : this.genIcon('left', this.prevIcon, this.prev), this.hideControls ? null : this.genIcon('right', this.nextIcon, this.next), this.hideDelimiters ? null : this.genDelimiters(), this.$slots.default]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VJumbotron__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_registrable__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_registrable__["a" /* inject */])('carousel', 'v-carousel-item', 'v-carousel')],

  inheritAttrs: false,

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    transition: {
      type: String,
      default: 'tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  mounted: function mounted() {
    this.carousel.register(this._uid, this.open);
  },
  beforeDestroy: function beforeDestroy() {
    this.carousel.unregister(this._uid, this.open);
  },
  render: function render(h) {
    var item = h(__WEBPACK_IMPORTED_MODULE_0__VJumbotron__["a" /* default */], {
      props: _extends({}, this.$attrs, {
        height: '100%'
      }),
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, this.$slots.default);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_jumbotrons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-jumbotron',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    gradient: String,
    height: {
      type: [Number, String],
      default: '400px'
    },
    src: String,
    tag: {
      type: String,
      default: 'div'
    }
  },

  computed: {
    backgroundStyles: function backgroundStyles() {
      var styles = {};

      if (this.gradient) {
        styles.background = 'linear-gradient(' + this.gradient + ')';
      }

      return styles;
    },
    classes: function classes() {
      return {
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        height: this.height
      };
    }
  },

  methods: {
    genBackground: function genBackground() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__background',
        'class': this.addBackgroundColorClassChecks(),
        style: this.backgroundStyles
      });
    },
    genContent: function genContent() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__content'
      }, this.$slots.default);
    },
    genImage: function genImage() {
      if (!this.src) return null;
      if (this.$slots.img) return this.$slots.img({ src: this.src });

      return this.$createElement('img', {
        staticClass: 'jumbotron__image',
        attrs: { src: this.src }
      });
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        staticClass: 'jumbotron__wrapper'
      }, [this.genImage(), this.genBackground(), this.genContent()]);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.staticClass = 'jumbotron';
    data.style = this.styles;

    return h(tag, data, [this.genWrapper()]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_rippleable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_selectable__ = __webpack_require__(42);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_rippleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      var classes = {
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      };

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  methods: {
    groupFocus: function groupFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    groupBlur: function groupBlur(e) {
      this.isFocused = false;
      this.tabFocused = false;
      this.$emit('blur', this.inputValue);
    }
  },

  render: function render(h) {
    var transition = h(__WEBPACK_IMPORTED_MODULE_3__transitions__["b" /* VFadeTransition */], [h(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
      staticClass: 'icon--selection-control',
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon,
      on: Object.assign({
        click: this.toggle
      }, this.$listeners)
    }, this.icon)]);

    var data = {
      attrs: {
        tabindex: this.disabled ? -1 : this.internalTabIndex || this.tabindex,
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive ? 'true' : 'false',
        'aria-label': this.label
      }
    };

    var ripple = this.ripple ? this.genRipple() : null;

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_progress_linear_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitions__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  props: {
    active: {
      type: Boolean,
      default: true
    },
    backgroundColor: {
      type: String,
      default: null
    },
    backgroundOpacity: {
      type: [Number, String],
      default: null
    },
    bufferValue: {
      type: [Number, String],
      default: 100
    },
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    query: Boolean,
    value: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (!this.indeterminate && parseInt(this.bufferValue, 10) !== 100) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    effectiveWidth: function effectiveWidth() {
      if (!this.bufferValue) {
        return 0;
      }

      return this.value * 100 / this.bufferValue;
    },
    backgroundStyle: function backgroundStyle() {
      var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);

      return {
        height: this.active ? this.height + 'px' : 0,
        opacity: backgroundOpacity,
        width: this.bufferValue + '%'
      };
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        staticClass: 'progress-linear__bar__determinate',
        class: this.addBackgroundColorClassChecks(),
        style: {
          width: this.effectiveWidth + '%'
        }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        staticClass: 'progress-linear__bar__indeterminate',
        class: this.addBackgroundColorClassChecks(_defineProperty({}, name, true))
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        staticClass: 'progress-linear__bar__indeterminate',
        class: {
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h(__WEBPACK_IMPORTED_MODULE_2__transitions__["b" /* VFadeTransition */], [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h(__WEBPACK_IMPORTED_MODULE_2__transitions__["d" /* VSlideXTransition */], [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', {
      staticClass: 'progress-linear__bar',
      style: this.styles
    }, [fade, slide]);
    var background = h('div', {
      staticClass: 'progress-linear__background',
      class: [this.backgroundColor || this.color],
      style: this.backgroundStyle
    });

    return h('div', {
      staticClass: 'progress-linear',
      class: {
        'progress-linear--query': this.query
      },
      style: {
        height: this.height + 'px'
      },
      on: this.$listeners
    }, [background, bar]);
  }
});

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'validatable',

  data: function data() {
    return {
      errorBucket: [],
      hasFocused: false,
      hasInput: false,
      shouldValidate: false,
      valid: false
    };
  },


  props: {
    error: {
      type: Boolean
    },
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    validateOnBlur: Boolean
  },

  computed: {
    validations: function validations() {
      if (!Array.isArray(this.errorMessages)) {
        return [this.errorMessages];
      } else if (this.errorMessages.length > 0) {
        return this.errorMessages;
      } else if (this.shouldValidate) {
        return this.errorBucket;
      } else {
        return [];
      }
    },
    hasError: function hasError() {
      return this.validations.length > 0 || this.errorMessages.length > 0 || this.error;
    }
  },

  watch: {
    rules: {
      handler: function handler(newVal, oldVal) {
        // TODO: This handler seems to trigger when input changes, even though
        // rules array stays the same? Solved it like this for now
        if (newVal.length === oldVal.length) return;

        this.validate();
      },

      deep: true
    },
    inputValue: function inputValue(val) {
      // If it's the first time we're setting input,
      // mark it with hasInput
      if (!!val && !this.hasInput) this.hasInput = true;

      if (this.hasInput && !this.validateOnBlur) this.shouldValidate = true;
    },
    isFocused: function isFocused(val) {
      // If we're not focused, and it's the first time
      // we're defocusing, set shouldValidate to true
      if (!val && !this.hasFocused) {
        this.hasFocused = true;
        this.shouldValidate = true;

        this.$emit('update:error', this.errorBucket.length > 0);
      }
    },
    hasError: function hasError(val) {
      if (this.shouldValidate) {
        this.$emit('update:error', val);
      }
    },
    error: function error(val) {
      this.shouldValidate = !!val;
    }
  },

  mounted: function mounted() {
    this.shouldValidate = !!this.error;
    this.validate();
  },


  methods: {
    reset: function reset() {
      var _this = this;

      // TODO: Do this another way!
      // This is so that we can reset all types of inputs
      this.$emit('input', this.isMultiple ? [] : null);
      this.$emit('change', null);

      this.$nextTick(function () {
        _this.shouldValidate = false;
        _this.hasFocused = false;
        _this.validate();
      });
    },
    validate: function validate() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.inputValue;

      if (force) this.shouldValidate = true;

      this.errorBucket = [];

      for (var index = 0; index < this.rules.length; index++) {
        var rule = this.rules[index];
        var valid = typeof rule === 'function' ? rule(value) : rule;

        if (valid === false || typeof valid === 'string') {
          this.errorBucket.push(valid);
        } else if (valid !== true) {
          Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["a" /* consoleError */])('Rules should return a string or boolean, received \'' + (typeof valid === 'undefined' ? 'undefined' : _typeof(valid)) + '\' instead', this);
        }
      }

      this.valid = this.errorBucket.length === 0;

      return this.valid;
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_chips_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    disabled: Boolean,
    label: Boolean,
    outline: Boolean,
    // Used for selects/tagging
    selected: Boolean,
    small: Boolean,
    textColor: String,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      var classes = this.addBackgroundColorClassChecks({
        'chip--disabled': this.disabled,
        'chip--selected': this.selected,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close,
        'theme--light': this.light,
        'theme--dark': this.dark
      });

      return this.textColor || this.outline ? this.addTextColorClassChecks(classes, this.textColor || this.color) : classes;
    }
  },

  methods: {
    genClose: function genClose(h) {
      var _this = this;

      var data = {
        staticClass: 'chip__close',
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      };

      return h('div', data, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], 'cancel')]);
    },
    genContent: function genContent(h) {
      var children = [this.$slots.default];

      this.close && children.push(this.genClose(h));

      return h('span', {
        staticClass: 'chip__content'
      }, children);
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'chip',
      'class': this.classes,
      attrs: { tabindex: this.disabled ? -1 : 0 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    return h('span', data, [this.genContent(h)]);
  }
});

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDataIterator__ = __webpack_require__(135);


__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDataIterator__["a" /* default */]);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_data_iterator_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_data_iterable__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-data-iterator',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_data_iterable__["a" /* default */]],

  inheritAttrs: false,

  props: {
    contentTag: {
      type: String,
      default: 'div'
    },
    contentProps: {
      type: Object,
      required: false
    },
    contentClass: {
      type: String,
      required: false
    }
  },

  computed: {
    classes: function classes() {
      return {
        'data-iterator': true,
        'data-iterator--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  methods: {
    genContent: function genContent() {
      var children = this.genItems();

      var data = {
        'class': this.contentClass,
        attrs: this.$attrs,
        on: this.$listeners,
        props: this.contentProps
      };

      return this.$createElement(this.contentTag, data, children);
    },
    genEmptyItems: function genEmptyItems(content) {
      return [this.$createElement('div', {
        'class': 'text-xs-center',
        style: 'width: 100%'
      }, content)];
    },
    genFilteredItems: function genFilteredItems() {
      if (!this.$scopedSlots.item) {
        return null;
      }

      var items = [];
      for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
        var item = this.filteredItems[index];
        var props = this.createProps(item, index);
        items.push(this.$scopedSlots.item(props));
      }

      return items;
    },
    genFooter: function genFooter() {
      var children = [];

      if (this.$slots.footer) {
        children.push(this.$slots.footer);
      }

      if (!this.hideActions) {
        children.push(this.genActions());
      }

      if (!children.length) return null;
      return this.$createElement('div', children);
    }
  },

  created: function created() {
    this.initPagination();
  },
  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, [this.genContent(), this.genFooter()]);
  }
});

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_text_fields_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_select_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_filterable__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_maskable__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_soloable__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_select_autocomplete__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_select_computed__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_select_events__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_select_generators__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_select_helpers__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_select_menu__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_select_props__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_select_watchers__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_click_outside__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles




// Mixins







// Component level mixins









// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  inheritAttrs: false,

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_17__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_select_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_select_events__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_select_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__mixins_select_helpers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_maskable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__mixins_select_menu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__mixins_select_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_soloable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__mixins_select_watchers__["a" /* default */],
  // Input and Computed both
  // contain isDirty props
  // last gets merged in
  __WEBPACK_IMPORTED_MODULE_10__mixins_select_computed__["a" /* default */]],

  data: function data() {
    return {
      cachedItems: this.cacheItems ? this.items : [],
      content: {},
      defaultColor: 'primary',
      inputValue: (this.multiple || this.tags) && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      lazySearch: null,
      isActive: false,
      menuIsActive: false,
      selectedIndex: -1,
      selectedItems: [],
      shouldBreak: false
    };
  },
  mounted: function mounted() {
    // If instance is being destroyed
    // do not run mounted functions
    if (this._isDestroyed) return;

    // Evaluate the selected items immediately
    // to avoid a unnecessary label transition
    this.genSelectedItems();

    this.content = this.$refs.menu.$refs.content;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    needsTile: function needsTile(tile) {
      // TODO: use the component name instead of tag
      return tile.componentOptions == null || tile.componentOptions.tag !== 'v-list-tile';
    },
    changeSelectedIndex: function changeSelectedIndex(keyCode) {
      // backspace, left, right, delete
      if (![8, 37, 39, 46].includes(keyCode)) return;

      var indexes = this.selectedItems.length - 1;

      if (keyCode === 37) {
        // Left arrow
        this.selectedIndex = this.selectedIndex === -1 ? indexes : this.selectedIndex - 1;
      } else if (keyCode === 39) {
        // Right arrow
        this.selectedIndex = this.selectedIndex >= indexes ? -1 : this.selectedIndex + 1;
      } else if (this.selectedIndex === -1) {
        this.selectedIndex = indexes;
        return;
      }

      // backspace/delete
      if ([8, 46].includes(keyCode)) {
        var newIndex = this.selectedIndex === indexes ? this.selectedIndex - 1 : this.selectedItems[this.selectedIndex + 1] ? this.selectedIndex : -1;

        this.combobox ? this.inputValue = null : this.selectItem(this.selectedItems[this.selectedIndex]);
        this.selectedIndex = newIndex;
      }
    },
    closeConditional: function closeConditional(e) {
      return this.isActive && !!this.content && !this.content.contains(e.target) && !!this.$el && !this.$el.contains(e.target);
    },
    filterDuplicates: function filterDuplicates(arr) {
      var uniqueValues = new Map();
      for (var index = 0; index < arr.length; ++index) {
        var item = arr[index];
        var val = this.getValue(item);

        !uniqueValues.has(val) && uniqueValues.set(val, item);
      }
      return Array.from(uniqueValues.values());
    },
    genDirectives: function genDirectives() {
      var _this = this;

      return [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional
        }
      }];
    },
    genSelectedItems: function genSelectedItems() {
      var _this2 = this;

      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.inputValue;

      // If we are using tags, don't filter results
      if (this.tags) return this.selectedItems = val;

      // Combobox is the single version
      // of a taggable select element
      if (this.combobox) return this.selectedItems = val != null ? [val] : [];

      var selectedItems = this.computedItems.filter(function (i) {
        if (!_this2.isMultiple) {
          return _this2.getValue(i) === _this2.getValue(val);
        } else {
          // Always return Boolean
          return _this2.findExistingIndex(i) > -1;
        }
      });

      if (!selectedItems.length && val != null && this.tags) {
        selectedItems = Array.isArray(val) ? val : [val];
      }

      this.selectedItems = selectedItems;
    },
    clearableCallback: function clearableCallback() {
      var _this3 = this;

      var inputValue = this.isMultiple ? [] : null;

      this.inputValue = inputValue;
      this.$emit('change', inputValue);
      this.genSelectedItems();

      // When input is cleared
      // reset search value and
      // re-focus the input
      setTimeout(function () {
        _this3.searchValue = null;
        _this3.focusInput();
      }, 0);

      if (this.openOnClear) {
        setTimeout(this.showMenu, 50);
      }
    },
    onScroll: function onScroll() {
      var _this4 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this4.content.scrollTop = 0;
        });
      } else {
        if (this.lastItem >= this.computedItems.length) return;

        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    findExistingItem: function findExistingItem(val) {
      var _this5 = this;

      var itemValue = this.getValue(val);
      return this.items.find(function (i) {
        return _this5.valueComparator(_this5.getValue(i), itemValue);
      });
    },
    findExistingIndex: function findExistingIndex(item) {
      var _this6 = this;

      var itemValue = this.getValue(item);
      return this.inputValue.findIndex(function (i) {
        return _this6.valueComparator(_this6.getValue(i), itemValue);
      });
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.isMultiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
        this.selectedItems = [item];
      } else {
        var selectedItems = [];
        var inputValue = this.inputValue.slice();
        var i = this.findExistingIndex(item);

        i !== -1 ? inputValue.splice(i, 1) : inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          selectedItems.push(i);
          return _this7.returnObject ? i : _this7.getValue(i);
        });

        this.selectedItems = selectedItems;
        this.selectedIndex = -1;
      }

      this.searchValue = !this.isMultiple && !this.chips && !this.$scopedSlots.selection ? this.getText(this.selectedItem) : null;

      this.$emit('change', this.inputValue);

      // List tile will re-render, reset index to
      // maintain highlighting
      var savedIndex = this.getMenuIndex();
      this.resetMenuIndex();

      // After selecting an item
      // refocus the input and
      // reset the caret pos
      this.$nextTick(function () {
        _this7.focusInput();
        _this7.setCaretPosition(_this7.currentRange);

        requestAnimationFrame(function () {
          if (savedIndex > -1) {
            _this7.setMenuIndex(savedIndex);
          }
        });
      });
    }
  },

  render: function render(h) {
    var _this8 = this;

    var data = {
      attrs: _extends({
        tabindex: this.isAutocomplete || this.disabled ? -1 : this.tabindex,
        'data-uid': this._uid
      }, this.isAutocomplete ? null : this.$attrs, {
        role: this.isAutocomplete ? null : 'combobox'
      })
    };

    if (!this.isAutocomplete) {
      data.on = this.genListeners();
      data.directives = this.genDirectives();
    } else {
      data.on = {
        click: function click() {
          if (_this8.disabled || _this8.readonly || _this8.isFocused) return;

          // If the input is dirty,
          // the input is not targetable
          // so we must manually focus
          if (_this8.isDirty) {
            _this8.focus();
            _this8.$nextTick(_this8.focusInput);
          }
        }
      };
    }

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], data, this.toggleMenu);
  }
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultDelimiters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isMaskDelimiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return maskText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unmaskText; });
/**
 * Default delimiter RegExp
 *
 * @type {RegExp}
 */
var defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;

/**
 *
 * @param {String} char
 *
 * @return {Boolean}
 */
var isMaskDelimiter = function isMaskDelimiter(char) {
  return char && defaultDelimiters.test(char);
};

/**
 * Mask keys
 *
 * @type {Object}
 */
var allowedMasks = {
  '#': {
    test: function test(char) {
      return char.match(/[0-9]/);
    }
  },
  'A': {
    test: function test(char) {
      return char.match(/[A-Z]/i);
    },
    convert: function convert(char) {
      return char.toUpperCase();
    }
  },
  'a': {
    test: function test(char) {
      return char.match(/[a-z]/i);
    },
    convert: function convert(char) {
      return char.toLowerCase();
    }
  },
  'N': {
    test: function test(char) {
      return char.match(/[0-9A-Z]/i);
    },
    convert: function convert(char) {
      return char.toUpperCase();
    }
  },
  'n': {
    test: function test(char) {
      return char.match(/[0-9a-z]/i);
    },
    convert: function convert(char) {
      return char.toLowerCase();
    }
  },
  'X': {
    test: isMaskDelimiter
  }

  /**
   * Is Character mask
   *
   * @param  {String} char
   *
   * @return {Boolean}
   */
};var isMask = function isMask(char) {
  return allowedMasks.hasOwnProperty(char);
};

/**
 * Automatically convert char case
 *
 * @param  {String} mask
 * @param  {String} char
 *
 * @return {String}
 */
var convert = function convert(mask, char) {
  return allowedMasks[mask].convert ? allowedMasks[mask].convert(char) : char;
};

/**
 * Mask Validation
 *
 * @param  {String} mask
 * @param  {String} char
 *
 * @return {Boolean}
 */
var maskValidates = function maskValidates(mask, char) {
  if (char == null || !isMask(mask)) return false;
  return allowedMasks[mask].test(char);
};

/**
 * Mask Text
 *
 * Takes a string or an array of characters
 * and returns a masked string
 *
 * @param {*} text
 * @param {Array|String} masked
 * @param {Boolean} [dontFillMaskBlanks]
 *
 * @return {String}
 */
var maskText = function maskText(text, masked, dontFillMaskBlanks) {
  if (text == null) return '';
  text = String(text);
  if (!masked.length || !text.length) return text;
  if (!Array.isArray(masked)) masked = masked.split('');

  var textIndex = 0;
  var maskIndex = 0;
  var newText = '';

  while (maskIndex < masked.length) {
    var mask = masked[maskIndex];

    // Assign the next character
    var char = text[textIndex];

    // Check if mask is delimiter
    // and current char matches
    if (!isMask(mask) && char === mask) {
      newText += mask;
      textIndex++;
      // Check if not mask
    } else if (!isMask(mask) && !dontFillMaskBlanks) {
      newText += mask;
      // Check if is mask and validates
    } else if (maskValidates(mask, char)) {
      newText += convert(mask, char);
      textIndex++;
    } else {
      return newText;
    }

    maskIndex++;
  }

  return newText;
};

/**
 * Unmask Text
 *
 * @param {String} text
 *
 * @return {String}
 */
var unmaskText = function unmaskText(text) {
  return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text;
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);


/**
 * Select autocomplete
 *
 * @mixin
 *
 * Handles logic when using the "autocomplete" prop
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    filter: {
      type: Function,
      default: function _default(item, queryText, itemText) {
        var hasValue = function hasValue(val) {
          return val != null ? val : '';
        };

        var text = hasValue(itemText);
        var query = hasValue(queryText);

        return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
      }
    }
  },

  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      if (!this.isAutocomplete) return this.computedItems;

      return this.computedItems.filter(function (i) {
        return _this.filter(i, _this.searchValue, _this.getText(i));
      });
    },
    genFiltered: function genFiltered(text) {
      text = (text || '').toString();

      if (!this.isAutocomplete || !this.searchValue || this.filteredItems.length < 1) return Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* escapeHTML */])(text);

      var _getMaskedCharacters = this.getMaskedCharacters(text),
          start = _getMaskedCharacters.start,
          middle = _getMaskedCharacters.middle,
          end = _getMaskedCharacters.end;

      return '' + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* escapeHTML */])(start) + this.genHighlight(middle) + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* escapeHTML */])(end);
    },
    genHighlight: function genHighlight(text) {
      if (this.isNotFiltering) return Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* escapeHTML */])(text);

      return '<span class="list__tile__mask">' + Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* escapeHTML */])(text) + '</span>';
    },
    getMaskedCharacters: function getMaskedCharacters(text) {
      var searchValue = (this.searchValue || '').toString().toLowerCase();
      var index = text.toLowerCase().indexOf(searchValue);

      if (index < 0) return { start: '', middle: text, end: '' };

      var start = text.slice(0, index);
      var middle = text.slice(index, index + searchValue.length);
      var end = text.slice(index + searchValue.length);
      return { start: start, middle: middle, end: end };
    },
    getCurrentTag: function getCurrentTag() {
      return this.isMenuItemSelected() ? this.filteredItems[this.getMenuIndex()] : this.isAnyValueAllowed ? this.searchValue : null;
    },
    tabOut: function tabOut() {
      this.blur();
    },
    onTabDown: function onTabDown(e) {
      var _this2 = this;

      // If tabbing through inputs and
      // and there is no need for an
      // update, blur the v-select
      if (!this.isAutocomplete || !this.getCurrentTag() || this.combobox) return this.tabOut();

      var menuIndex = this.getMenuIndex();

      // When adding tags, if searching and
      // there is not a filtered options,
      // add the value to the tags list
      if (this.tags && this.searchValue && menuIndex === -1) {
        e.preventDefault();

        return this.updateTags(this.searchValue);
      }

      // An item that is selected by
      // menu-index should toggled
      if (this.menuIsActive) {
        // Reset the list index if searching
        this.searchValue && this.$nextTick(function () {
          return setTimeout(_this2.resetMenuIndex, 0);
        });

        e.preventDefault();
        this.selectListTile(menuIndex);
      }
    },
    onEnterDown: function onEnterDown() {
      this.updateTags(this.getCurrentTag());
    },
    onEscDown: function onEscDown(e) {
      e.preventDefault();
      this.menuIsActive = false;
    },
    onKeyDown: function onKeyDown(e) {
      var _this3 = this;

      // If enter, space, up, or down is pressed, open menu
      if (!this.menuIsActive && [13, 32, 38, 40].includes(e.keyCode)) {
        e.preventDefault();
        return this.showMenu();
      }

      // If escape deactivate the menu
      if (e.keyCode === 27) return this.onEscDown(e);

      // If tab - select item or close menu
      if (e.keyCode === 9) return this.onTabDown(e);

      if (!this.isAutocomplete || ![32].includes(e.keyCode) // space
      ) this.$refs.menu.changeListIndex(e);

      // Up or down
      if ([38, 40].includes(e.keyCode)) this.selectedIndex = -1;

      if (this.isAutocomplete && !this.hideSelections && !this.searchValue) this.changeSelectedIndex(e.keyCode);

      if (!this.isAnyValueAllowed || !this.searchValue) return;

      // Enter
      if (e.keyCode === 13) return this.onEnterDown();

      // Left arrow
      if (e.keyCode === 37 && this.$refs.input.selectionStart === 0 && this.selectedItems.length) {
        this.updateTags(this.searchValue);
        this.$nextTick(function () {
          _this3.selectedIndex = Math.max(_this3.selectedItems.length - 2, 0);
        });
      }

      // Right arrow
      if (e.keyCode === 39 && this.$refs.input.selectionEnd === this.searchValue.length) {
        this.resetMenuIndex();
      }
    },
    selectListTile: function selectListTile(index) {
      if (!this.$refs.menu.tiles[index]) return;

      this.$refs.menu.tiles[index].click();
    },
    updateTags: function updateTags(content) {
      var _this4 = this;

      // Avoid direct mutation
      // for vuex strict mode
      var selectedItems = this.selectedItems.slice();

      // If a duplicate item
      // exists, remove it
      if (selectedItems.includes(content)) {
        this.$delete(selectedItems, selectedItems.indexOf(content));
      }

      // When updating tags ensure
      // that that the search text
      // is populated if needed
      var searchValue = null;
      if (this.combobox) {
        selectedItems = [content];
        searchValue = this.chips ? null : content;
      } else {
        selectedItems.push(content);
      }

      this.selectedItems = selectedItems;

      this.$nextTick(function () {
        _this4.searchValue = searchValue;
        _this4.$emit('input', _this4.combobox ? content : _this4.selectedItems);
      });
    }
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Select computed properties
 *
 * @mixin
 *
 * Computed properties for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    classes: function classes() {
      var classes = _extends({}, this.genSoloClasses(), {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.isAutocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple,
        'input-group--open': this.menuIsVisible,
        'input-group--select--selecting-index': this.selectedIndex > -1
      });

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    computedContentClass: function computedContentClass() {
      var children = ['menu__content--select', this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : '', this.isAutocomplete ? 'menu__content--autocomplete' : '', this.contentClass || ''];

      return children.join(' ');
    },
    computedItems: function computedItems() {
      return this.filterDuplicates(this.cachedItems.concat(this.items));
    },

    /**
     * The range of the current input text
     *
     * @return {Number}
     */
    currentRange: function currentRange() {
      if (this.selectedItem == null) return 0;

      return this.getText(this.selectedItem).toString().length;
    },
    filteredItems: function filteredItems() {
      // If we are not actively filtering
      // Show all available items
      var items = this.isNotFiltering ? this.computedItems : this.filterSearch();

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hideSelections: function hideSelections() {
      return this.isAutocomplete && !this.isMultiple && this.isFocused && !this.chips && !this.$scopedSlots.selection;
    },
    isNotFiltering: function isNotFiltering() {
      return this.isAutocomplete && this.isDirty && this.searchValue === this.getText(this.selectedItem);
    },
    isHidingSelected: function isHidingSelected() {
      return this.hideSelected && this.isAutocomplete && this.isMultiple;
    },
    isAutocomplete: function isAutocomplete() {
      return this.autocomplete || this.editable || this.tags || this.combobox;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length > 0 || this.isAutocomplete && this.searchValue;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable || this.isSolo;
    },
    isMultiple: function isMultiple() {
      return this.multiple || this.tags;
    },
    isAnyValueAllowed: function isAnyValueAllowed() {
      return this.tags || this.combobox;
    },
    menuIsVisible: function menuIsVisible() {
      return this.menuIsActive && this.computedItems.length > 0 && (!this.isAnyValueAllowed || this.filteredItems.length > 0);
    },
    menuItems: function menuItems() {
      var _this = this;

      return this.isHidingSelected ? this.filteredItems.filter(function (o) {
        return (_this.selectedItems || []).indexOf(o) === -1;
      }) : this.filteredItems;
    },
    nudgeTop: function nudgeTop() {
      var nudgeTop = -18;

      if (this.isSolo) nudgeTop = 0;else if (this.shouldOffset) {
        nudgeTop += 44;

        nudgeTop += this.hideDetails ? -24 : 0;
        nudgeTop += this.isAutocomplete && !this.isDropdown ? -2 : 0;
      }

      return nudgeTop;
    },

    searchValue: {
      get: function get() {
        return this.lazySearch;
      },
      set: function set(val) {
        if (!this.isAutocomplete || !this.multiple && this.selectedIndex > -1) return;

        this.lazySearch = val;

        this.$emit('update:searchInput', val);
      }
    },
    selectedItem: function selectedItem() {
      var _this2 = this;

      if (this.isMultiple) return null;

      return this.selectedItems.find(function (i) {
        return _this2.getValue(i) === _this2.getValue(_this2.inputValue);
      });
    },
    shouldOffset: function shouldOffset() {
      return this.isAutocomplete || this.isDropdown;
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Select events
 *
 * @mixin
 *
 * Event based methods for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    blur: function blur() {
      this.deactivateInput();
      this.menuIsActive = false;
      this.$emit('blur');
    },
    focus: function focus() {
      this.showMenu();

      this.$emit('focus');
    },
    focusInput: function focusInput() {
      var _this = this;

      if (this.$refs.input && this.isAutocomplete) {
        this.$refs.input.focus();

        this.$nextTick(function () {
          _this.$refs.input.select();
          _this.shouldBreak && (_this.$refs.input.scrollLeft = _this.$refs.input.scrollWidth);
        });
      } else {
        !this.isFocused && this.$el.focus();
      }
    },
    genListeners: function genListeners() {
      var _this2 = this;

      var listeners = Object.assign({}, this.$listeners);
      delete listeners.input;

      return _extends({}, listeners, {
        click: function click() {
          if (_this2.disabled || _this2.readonly) return;

          if (_this2.isFocused && !_this2.menuIsVisible) {
            return _this2.showMenuItems();
          }

          _this2.selectedIndex > -1 ? _this2.selectedIndex = -1 : _this2.focus();
        },
        focus: function focus(e) {
          if (_this2.disabled || _this2.readonly || _this2.isFocused) {
            return;
          }

          _this2.activateInput();
          _this2.$nextTick(_this2.focusInput);
        },
        keydown: this.onKeyDown // Located in mixins/select-autocomplete.js
      });
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCard__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VCheckbox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VChip__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VDivider__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VMenu__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VSubheader__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VList__ = __webpack_require__(56);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




// Components









/**
 * Select generators
 *
 * @mixin
 *
 * Used for creating the DOM elements for VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var data = {
        ref: 'menu',
        props: {
          activator: this.$el,
          auto: this.auto,
          attach: this.attach && '[data-uid="' + this._uid + '"]',
          closeOnClick: false,
          closeOnContentClick: !this.isMultiple,
          contentClass: this.computedContentClass,
          dark: this.dark,
          disabled: this.disabled,
          light: this.light,
          maxHeight: this.maxHeight,
          nudgeTop: this.nudgeTop,
          offsetY: this.shouldOffset,
          offsetOverflow: this.isAutocomplete,
          openOnClick: false,
          value: this.menuIsVisible,
          zIndex: this.menuZIndex
        },
        on: {
          input: function input(val) {
            if (!val) {
              _this.menuIsActive = false;
            }
          }
        }
      };

      if (this.isAutocomplete) data.props.transition = false;

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_7__VMenu__["a" /* default */], data, [this.genList()]);
    },
    getMenuIndex: function getMenuIndex() {
      return this.$refs.menu ? this.$refs.menu.listIndex : -1;
    },
    setMenuIndex: function setMenuIndex(index) {
      this.$refs.menu && (this.$refs.menu.listIndex = index);
    },
    resetMenuIndex: function resetMenuIndex() {
      this.setMenuIndex(-1);
    },
    isMenuItemSelected: function isMenuItemSelected() {
      return this.menuIsActive && this.menuItems.length && this.getMenuIndex() > -1;
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [].concat(_toConsumableArray(this.genSelections()), [this.genSearch()]));
    },
    genSelections: function genSelections() {
      if (this.hideSelections) return [];

      var length = this.selectedItems.length;
      var children = new Array(length);

      var genSelection = void 0;
      if (this.$scopedSlots.selection) {
        genSelection = this.genSlotSelection;
      } else if (this.chips) {
        genSelection = this.genChipSelection;
      } else if (this.segmented) {
        genSelection = this.genSegmentedBtn;
      } else {
        genSelection = this.genCommaSelection;
      }

      while (length--) {
        children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
      }

      return children;
    },
    genSearch: function genSearch() {
      var _this2 = this;

      var data = {
        staticClass: 'input-group--select__autocomplete',
        'class': {
          'input-group--select__autocomplete--index': this.selectedIndex > -1
        },
        style: {
          flex: this.shouldBreak ? '1 0 100%' : null
        },
        attrs: _extends({}, this.$attrs, {
          disabled: this.disabled || !this.isAutocomplete,
          readonly: this.readonly,
          tabindex: this.disabled || !this.isAutocomplete ? -1 : this.tabindex
        }),
        domProps: {
          value: this.maskText(this.lazySearch || '')
        },
        directives: [{
          name: 'show',
          value: this.isAutocomplete || this.placeholder && !this.selectedItems.length
        }],
        ref: 'input',
        key: 'input'
      };

      if (this.isAutocomplete) {
        data.attrs.role = 'combobox';
        data.domProps.autocomplete = this.browserAutocomplete;

        data.on = _extends({}, this.genListeners(), {
          input: function input(e) {
            if (_this2.selectedIndex > -1) return;

            _this2.searchValue = _this2.unmaskText(e.target.value);
          }
        });

        data.directives = data.directives.concat(this.genDirectives());
      }

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      return this.$createElement('input', data);
    },
    genSegmentedBtn: function genSegmentedBtn(item) {
      if (!item.text || !item.callback) {
        Object(__WEBPACK_IMPORTED_MODULE_1__util_console__["b" /* consoleWarn */])('When using \'segmented\' prop without a selection slot, items must contain both a text and callback property', this);
        return null;
      }

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VBtn__["a" /* default */], {
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            item.callback(e);
          }
        }
      }, [item.text]);
    },
    genSlotSelection: function genSlotSelection(item, index) {
      return this.$scopedSlots.selection({
        parent: this,
        item: item,
        index: index,
        selected: index === this.selectedIndex,
        disabled: this.disabled || this.readonly
      });
    },
    genChipSelection: function genChipSelection(item, index) {
      var _this3 = this;

      var isDisabled = this.disabled || this.readonly;
      var click = function click(e) {
        if (isDisabled) return;

        e.stopPropagation();
        _this3.focusInput();
        _this3.selectedIndex = index;
      };

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_5__VChip__["a" /* default */], {
        staticClass: 'chip--select-multi',
        attrs: { tabindex: '-1' },
        props: {
          close: this.deletableChips && !isDisabled,
          dark: this.dark,
          disabled: isDisabled,
          selected: index === this.selectedIndex
        },
        on: {
          click: click,
          focus: click,
          input: function input() {
            if (_this3.isMultiple) _this3.selectItem(item);else _this3.inputValue = null;
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, index, last) {
      return this.$createElement('div', {
        staticClass: 'input-group__selections__comma',
        'class': {
          'input-group__selections__comma--active': index === this.selectedIndex
        },
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (last ? '' : ', '));
    },
    genList: function genList() {
      var _this4 = this;

      var children = this.menuItems.map(function (o) {
        if (o.header) return _this4.genHeader(o);
        if (o.divider) return _this4.genDivider(o);else return _this4.genTile(o);
      });

      if (!children.length) {
        var noData = this.$slots['no-data'];
        if (noData) {
          children.push(noData);
        } else {
          children.push(this.genTile(this.noDataText, true));
        }
      }

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_3__VCard__["a" /* default */], [this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["a" /* VList */], {
        props: {
          dense: this.dense
        },
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_8__VSubheader__["a" /* default */], {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_6__VDivider__["a" /* default */], {
        props: item
      });
    },
    genLabel: function genLabel() {
      var singleLine = this.singleLine || this.isDropdown;

      if (singleLine && (this.isDirty || this.isFocused && this.searchValue)) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.$slots.label || this.label);
    },
    genTile: function genTile(item, disabled) {
      var _this5 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["i" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: {
          click: function click(e) {
            if (disabled) return;

            _this5.selectItem(item);
          }
        },
        props: {
          avatar: item === Object(item) && this.itemAvatar in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      data.props.activeClass = Object.keys(this.addTextColorClassChecks()).join(' ');

      if (this.$scopedSlots.item) {
        var tile = this.$scopedSlots.item({ parent: this, item: item, tile: data });
        return this.needsTile(tile) ? this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["b" /* VListTile */], data, [tile]) : tile;
      }

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["b" /* VListTile */], data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this6 = this;

      if (!this.isMultiple || this.isHidingSelected) return null;

      var data = {
        staticClass: 'list__tile__action--select-multi',
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this6.selectItem(item);
          }
        }
      };

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["c" /* VListTileAction */], data, [this.$createElement(__WEBPACK_IMPORTED_MODULE_4__VCheckbox__["a" /* default */], {
        props: {
          color: this.computedColor,
          inputValue: active
        }
      })]);
    },
    genContent: function genContent(item) {
      var text = this.getText(item);

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["d" /* VListTileContent */], [this.$createElement(__WEBPACK_IMPORTED_MODULE_9__VList__["e" /* VListTileTitle */], {
        domProps: {
          innerHTML: this.genFiltered(text)
        }
      })]);
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_dividers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-divider',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('hr', data);
  }
});

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_menus_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_delayable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_detachable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_menuable_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_returnable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_menu_activator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_menu_generators__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_menu_keyable__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_menu_position__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_resize__ = __webpack_require__(11);


// Mixins







// Component level mixins





// Directives



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_menu_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_delayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_menu_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_menu_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_menuable_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__mixins_menu_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_returnable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_11__directives_click_outside__["a" /* default */],
    Resize: __WEBPACK_IMPORTED_MODULE_12__directives_resize__["a" /* default */]
  },

  data: function data() {
    return {
      defaultOffset: 8,
      maxHeightAutoDefault: '200px',
      startIndex: 3,
      stopIndex: 0,
      hasJustFocused: false,
      resizeTimeout: null
    };
  },


  props: {
    auto: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    fullWidth: Boolean,
    maxHeight: { default: 'auto' },
    offsetX: Boolean,
    offsetY: Boolean,
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: Boolean,
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: [Boolean, String],
      default: 'menu-transition'
    }
  },

  computed: {
    calculatedLeft: function calculatedLeft() {
      if (!this.auto) return this.calcLeft();

      return this.calcXOverflow(this.calcLeftAuto()) + 'px';
    },
    calculatedMaxHeight: function calculatedMaxHeight() {
      return this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px';
    },
    calculatedMaxWidth: function calculatedMaxWidth() {
      return isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px';
    },
    calculatedMinWidth: function calculatedMinWidth() {
      if (this.minWidth) {
        return isNaN(this.minWidth) ? this.minWidth : this.minWidth + 'px';
      }

      var minWidth = this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);

      return Math.min(calculatedMaxWidth, minWidth) + 'px';
    },
    calculatedTop: function calculatedTop() {
      if (!this.auto || this.isAttached) return this.calcTop();

      return this.calcYOverflow(this.calcTopAuto()) + 'px';
    },
    styles: function styles() {
      return {
        maxHeight: this.calculatedMaxHeight,
        minWidth: this.calculatedMinWidth,
        maxWidth: this.calculatedMaxWidth,
        top: this.calculatedTop,
        left: this.calculatedLeft,
        transformOrigin: this.origin,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    isContentActive: function isContentActive(val) {
      this.hasJustFocused = val;
    }
  },

  methods: {
    activate: function activate() {
      // This exists primarily for v-select
      // helps determine which tiles to activate
      this.getTiles();
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions();
      // Start the transition
      requestAnimationFrame(this.startTransition);
      // Once transitioning, calculate scroll position
      setTimeout(this.calculateScroll, 50);
    },
    closeConditional: function closeConditional() {
      return this.isActive && this.closeOnClick;
    },
    onResize: function onResize() {
      if (!this.isActive) return;

      // Account for screen resize
      // and orientation change
      // eslint-disable-next-line no-unused-expressions
      this.$refs.content.offsetWidth;
      this.updateDimensions();

      // When resizing to a smaller width
      // content width is evaluated before
      // the new activator width has been
      // set, causing it to not size properly
      // hacky but will revisit in the future
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.updateDimensions, 100);
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'menu',
      class: {
        'menu--disabled': this.disabled
      },
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        arg: 500,
        name: 'resize',
        value: this.onResize
      }],
      on: {
        keydown: this.changeListIndex
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu activator
 *
 * @mixin
 *
 * Handles the click and hover activation
 * Supports slotted and detached activators
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;
      if (this.openOnClick && !this.isActive) {
        this.getActivator().focus();
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) {
        this.getActivator().blur();
        this.isActive = false;
      }
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      var _this = this;

      this.runDelay('open', function () {
        if (_this.hasJustFocused) return;

        _this.hasJustFocused = true;
        _this.isActive = true;
      });
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      var _this2 = this;

      // Prevent accidental re-activation
      this.runDelay('close', function () {
        if (_this2.$refs.content.contains(e.relatedTarget)) return;

        requestAnimationFrame(function () {
          _this2.isActive = false;
          _this2.callDeactivate();
        });
      });
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Menu generators
 *
 * @mixin
 *
 * Used for creating the DOM elements for VMenu
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        staticClass: 'menu__activator',
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        ref: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      if (!this.transition) return this.genContent();

      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, [this.genContent()]);
    },
    genDirectives: function genDirectives() {
      var _this = this;

      // Do not add click outside for hover menu
      var directives = !this.openOnHover ? [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional,
          include: function include() {
            return [_this.$el].concat(_toConsumableArray(_this.getOpenDependentElements()));
          }
        }
      }] : [];

      directives.push({
        name: 'show',
        value: this.isContentActive
      });

      return directives;
    },
    genContent: function genContent() {
      var _class,
          _this2 = this;

      var options = {
        staticClass: 'menu__content',
        'class': (_class = {}, _defineProperty(_class, this.contentClass.trim(), true), _defineProperty(_class, 'menuable__content__active', this.isActive), _defineProperty(_class, 'theme--dark', this.dark), _defineProperty(_class, 'theme--light', this.light), _class),
        style: this.styles,
        directives: this.genDirectives(),
        ref: 'content',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this2.closeOnContentClick) _this2.isActive = false;
          }
        }
      };

      !this.disabled && this.openOnHover && (options.on.mouseenter = this.mouseEnterHandler);
      this.openOnHover && (options.on.mouseleave = this.mouseLeaveHandler);

      return this.$createElement('div', options, this.showLazyContent(this.$slots.default));
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu keyable
 *
 * @mixin
 *
 * Primarily used to support VSelect
 * Handles opening and closing of VMenu from keystrokes
 * Will conditionally highlight VListTiles for VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        var tile = this.tiles[next];
        tile.classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = tile.offsetTop - tile.clientHeight;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      // Up, Down, Enter, Space
      if ([40, 38, 13].includes(e.keyCode) || e.keyCode === 32 && !this.isActive) {
        e.preventDefault();
      }

      // Esc, Tab
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive &&
      // Enter, Space
      [13, 32].includes(e.keyCode) && this.openOnClick) {
        return this.isActive = true;
      }

      // Down
      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
        // Up
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
        // Enter
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Menu position
 *
 * @mixin
 *
 * Used for calculating an automatic position (used for VSelect)
 * Will position the VMenu content properly over the VSelect
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * (this.defaultOffset * 6) - this.defaultOffset * 7;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      if (this.isAttached) return 0;

      return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
    },
    calcTopAuto: function calcTopAuto() {
      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.computedTop;
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = -(this.defaultOffset * 2);
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = this.defaultOffset * 3;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = -this.defaultOffset;
        actingIndex = selectedIndex - this.stopIndex;
      }

      // Is always off by 1 pixel, send help (┛ಠ_ಠ)┛彡┻━┻
      offsetPadding--;

      return this.computedTop + offsetPadding - actingIndex * (this.defaultOffset * 6);
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_subheaders_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-subheader',

  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('div', data, children);
  }
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_lists_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
// Styles


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["b" /* provide */])('list'), __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      'listClick': this.listClick
    };
  },


  data: function data() {
    return {
      groups: []
    };
  },

  props: {
    dense: Boolean,
    expand: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--dense': this.dense,
        'list--subheader': this.subheader,
        'list--two-line': this.twoLine,
        'list--three-line': this.threeLine,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  methods: {
    register: function register(uid, cb) {
      this.groups.push({ uid: uid, cb: cb });
    },
    unregister: function unregister(uid) {
      var index = this.groups.findIndex(function (g) {
        return g.uid === uid;
      });

      if (index > -1) {
        this.groups.splice(index, 1);
      }
    },
    listClick: function listClick(uid, isBooted) {
      if (this.expand) return;

      for (var i = this.groups.length; i--;) {
        this.groups[i].cb(uid);
      }
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'list',
      'class': this.classes
    };

    return h('div', data, [this.$slots.default]);
  }
});

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transitions__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Components


// Mixins




// Transitions


/**
 * List group
 *
 * @component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_bootable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_registrable__["a" /* inject */])('list', 'v-list-group', 'v-list'), __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */]],

  inject: ['listClick'],

  data: function data() {
    return {
      groups: []
    };
  },

  props: {
    activeClass: {
      type: String,
      default: 'primary--text'
    },
    appendIcon: {
      type: String,
      default: 'keyboard_arrow_down'
    },
    disabled: Boolean,
    group: String,
    noAction: Boolean,
    prependIcon: String,
    subGroup: Boolean
  },

  computed: {
    groupClasses: function groupClasses() {
      return {
        'list__group--active': this.isActive,
        'list__group--disabled': this.disabled
      };
    },
    headerClasses: function headerClasses() {
      return {
        'list__group__header--active': this.isActive,
        'list__group__header--sub-group': this.subGroup
      };
    },
    itemsClasses: function itemsClasses() {
      return {
        'list__group__items--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (!this.subGroup && val) {
        this.listClick(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }

        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    this.list.register(this._uid, this.toggle);

    if (this.group && this.$route && this.value == null) {
      this.isActive = this.matchRoute(this.$route.path);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.list.unregister(this._uid);
  },


  methods: {
    click: function click() {
      if (this.disabled) return;

      this.isActive = !this.isActive;
    },
    genIcon: function genIcon(icon) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_VIcon__["a" /* default */], icon);
    },
    genAppendIcon: function genAppendIcon() {
      var icon = !this.subGroup ? this.appendIcon : false;

      if (!icon && !this.$slots.appendIcon) return null;

      return this.$createElement('div', {
        staticClass: 'list__group__header__append-icon'
      }, [this.$slots.appendIcon || this.genIcon(icon)]);
    },
    genGroup: function genGroup() {
      return this.$createElement('div', {
        staticClass: 'list__group__header',
        'class': this.headerClasses,
        on: Object.assign({}, {
          click: this.click
        }, this.$listeners),
        ref: 'item'
      }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
    },
    genItems: function genItems() {
      return this.$createElement('div', {
        staticClass: 'list__group__items',
        'class': this.itemsClasses,
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        ref: 'group'
      }, this.showLazyContent(this.$slots.default));
    },
    genPrependIcon: function genPrependIcon() {
      var icon = this.prependIcon ? this.prependIcon : this.subGroup ? 'arrow_drop_down' : false;

      if (!icon && !this.$slots.prependIcon) return null;

      return this.$createElement('div', {
        staticClass: 'list__group__header__prepend-icon',
        'class': _defineProperty({}, this.activeClass, this.isActive)
      }, [this.$slots.prependIcon || this.genIcon(icon)]);
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'list__group',
      'class': this.groupClasses
    }, [this.genGroup(), h(__WEBPACK_IMPORTED_MODULE_4__transitions__["a" /* VExpandTransition */], [this.genItems()])]);
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ripple__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Mixins




// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_routable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_3__directives_ripple__["a" /* default */]
  },

  inheritAttrs: false,

  data: function data() {
    return {
      proxyClass: 'list__tile--active'
    };
  },

  props: {
    activeClass: {
      type: String,
      default: 'primary--text'
    },
    avatar: Boolean,
    inactive: Boolean,
    tag: String
  },

  computed: {
    listClasses: function listClasses() {
      return this.disabled ? 'text--disabled' : this.color ? this.addTextColorClassChecks() : this.defaultColor;
    },
    classes: function classes() {
      return _defineProperty({
        'list__tile': true,
        'list__tile--link': this.isLink && !this.inactive,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled,
        'list__tile--active': !this.to && this.isActive
      }, this.activeClass, this.isActive);
    },
    isLink: function isLink() {
      return this.href || this.to || this.$listeners && (this.$listeners.click || this.$listeners['!click']);
    }
  },

  render: function render(h) {
    var isRouteLink = !this.inactive && this.isLink;

    var _ref2 = isRouteLink ? this.generateRouteLink() : {
      tag: this.tag || 'div',
      data: {
        class: this.classes
      }
    },
        tag = _ref2.tag,
        data = _ref2.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('div', {
      'class': this.listClasses,
      attrs: {
        disabled: this.disabled
      },
      on: _extends({}, this.$listeners)
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'v-list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + data.staticClass : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAvatar__ = __webpack_require__(34);
// Components


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'v-list-tile-avatar',

  props: {
    color: String,
    size: {
      type: [Number, String],
      default: 40
    },
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('list__tile__avatar ' + (data.staticClass || '')).trim();

    var avatar = h(__WEBPACK_IMPORTED_MODULE_0__VAvatar__["a" /* default */], {
      props: {
        color: props.color,
        size: props.size,
        tile: props.tile
      }
    }, [children]);

    return h('div', data, [avatar]);
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
// Helpers


/**
 * Select helpers
 *
 * @mixin
 *
 * Helper methods for the
 * v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["i" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Select menu methods
 *
 * @mixin
 *
 * Menu based methods for
 * the v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    activateInput: function activateInput() {
      this.isActive = true;
      this.isFocused = true;
    },
    deactivateInput: function deactivateInput() {
      this.isFocused = false;
      this.isActive = false;
      this.selectedIndex = -1;
    },
    hideMenu: function hideMenu() {
      this.menuIsActive = false;
    },
    showMenu: function showMenu() {
      this.activateInput();
      this.showMenuItems();
      this.isMultiple && this.resetMenuIndex();
    },
    showMenuItems: function showMenuItems() {
      this.menuIsActive = true;
    },
    toggleMenu: function toggleMenu() {
      if (this.disabled || this.readonly || this.menuIsVisible) return this.hideMenu();

      this.showMenu();
      this.focusInput();
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    appendIconCb: Function,
    attach: Boolean,
    auto: Boolean,
    autocomplete: Boolean,
    browserAutocomplete: {
      type: String,
      default: 'off'
    },
    cacheItems: Boolean,
    chips: Boolean,
    clearable: Boolean,
    combobox: Boolean,
    contentClass: String,
    deletableChips: Boolean,
    dense: Boolean,
    editable: Boolean,
    hideSelected: Boolean,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemAvatar: {
      type: String,
      default: 'avatar'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    openOnClear: Boolean,
    overflow: Boolean,
    returnObject: Boolean,
    searchInput: {
      default: null
    },
    segmented: Boolean,
    singleLine: Boolean,
    tags: Boolean,
    valueComparator: {
      type: Function,
      default: function _default(a, b) {
        if (a !== Object(a)) return a === b;
        var aProps = Object.keys(a);
        var bProps = Object.keys(b);
        return aProps.length === bProps.length && aProps.every(function (propName) {
          return a[propName] === b[propName];
        });
      }
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Select watchers
 *
 * @mixin
 *
 * Watchers for the
 * v-select component
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    filteredItems: function filteredItems() {
      this.$refs.menu && this.$refs.menu.updateDimensions();
    },
    inputValue: function inputValue(val) {
      // Search for an existing item when a
      // value was selected from the menu
      if (this.combobox && this.isNotFiltering) {
        val = this.findExistingItem(val);
      }

      // Populate selected items
      this.genSelectedItems(val);

      // Only fire an update
      // if values do not
      // match
      val !== this.value && this.$emit('input', val);

      // When inputValue is changed
      // and combobox is true set
      // menu property to false
      if (this.combobox) this.menuIsActive = false;
    },
    isActive: function isActive(val) {
      if (val) {
        if (!this.chips && !this.$scopedSlots.selection) {
          this.searchValue = this.getText(this.selectedItem);
        }
        return;
      }

      this.blur();

      if (this.tags && this.searchValue) {
        this.updateTags(this.searchValue);
      }

      if (this.combobox && this.lazySearch && !this.isNotFiltering) {
        this.inputValue = this.lazySearch;
      }

      // Only set search value if
      // there is a value to set
      this.searchValue && (this.searchValue = null);
    },
    isBooted: function isBooted() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.content && _this.content.addEventListener) {
          _this.content.addEventListener('scroll', _this.onScroll, false);
        }
      });
    },
    items: function items(val) {
      var _this2 = this;

      if (this.cacheItems) {
        this.cachedItems = this.filterDuplicates(this.cachedItems.concat(val));
      }

      this.resetMenuIndex();

      // Tags and combobox should not
      // pre-select the first entry
      if (this.searchValue && !this.isAnyValueAllowed) {
        this.$nextTick(function () {
          return _this2.setMenuIndex(0);
        });
      }

      this.genSelectedItems();
    },
    menuIsActive: function menuIsActive(val) {
      if (!val) return;

      this.isBooted = true;
    },
    isMultiple: function isMultiple(val) {
      this.inputValue = val ? [] : null;
    },
    searchInput: function searchInput(val) {
      this.searchValue = val;
    },
    searchValue: function searchValue(val, prev) {
      var _this3 = this;

      // Wrap input to next line if overflowing
      if (this.$refs.input.scrollWidth > this.$refs.input.clientWidth) {
        this.shouldBreak = true;
        this.$nextTick(this.$refs.menu.updateDimensions);
      } else if (val === null) {
        this.shouldBreak = false;
      }

      // Activate menu if inactive and searching
      if (this.isActive && !this.menuIsActive && val !== this.getText(this.selectedItem)) {
        this.menuIsActive = true;
      }

      // Only reset list index
      // if typing in search
      !val && prev && this.resetMenuIndex();

      this.$nextTick(function () {
        if (val && !_this3.isAnyValueAllowed) {
          _this3.setMenuIndex(0);
        }
        if (val !== null && _this3.selectedIndex > -1) {
          _this3.selectedIndex = -1;
        }
      });
    },
    selectedItems: function selectedItems() {
      if (this.isAutocomplete) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(172);
/* unused harmony reexport VDataTable */
/* unused harmony reexport VEditDialog */





var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('table__overflow');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */]);
  Vue.component(VTableOverflow.name, VTableOverflow);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */]);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tables_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_data_table_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_data_iterable__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_head__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_body__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_foot__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_progress__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_helpers__ = __webpack_require__(2);












// Importing does not work properly
var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_7__util_helpers__["e" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-data-table',

  data: function data() {
    return {
      actionsClasses: 'datatable__actions',
      actionsRangeControlsClasses: 'datatable__actions__range-controls',
      actionsSelectClasses: 'datatable__actions__select',
      actionsPaginationClasses: 'datatable__actions__pagination'
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_data_iterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_progress__["a" /* default */]],

  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideHeaders: Boolean,
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter, headers) {
        search = search.toString().toLowerCase();
        if (search.trim() === '') return items;

        var props = headers.map(function (h) {
          return h.value;
        });

        return items.filter(function (item) {
          return props.some(function (prop) {
            return filter(Object(__WEBPACK_IMPORTED_MODULE_7__util_helpers__["i" /* getObjectValueByPath */])(item, prop), search);
          });
        });
      }
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    filteredItems: function filteredItems() {
      return this.filteredItemsImpl(this.headers);
    },
    headerColumns: function headerColumns() {
      return this.headers.length + (this.selectAll !== false);
    }
  },

  methods: {
    hasTag: function hasTag(elements, tag) {
      return Array.isArray(elements) && elements.find(function (e) {
        return e.tag === tag;
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = !this.disableInitialSort && firstSortable ? firstSortable.value : null;

    this.initPagination();
  },
  render: function render(h) {
    var tableOverflow = h(VTableOverflow, {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTBody(), this.genTFoot()])]);

    return h('div', [tableOverflow, this.genActionsFooter()]);
  }
});

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_console__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCheckbox__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sortIcon: {
      type: String,
      default: 'arrow_upward'
    }
  },

  methods: {
    genTHead: function genTHead() {
      var _this = this;

      if (this.hideHeaders) return; // Exit Early since no headers are needed.

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.everyItem
        });

        children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()];
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VCheckbox__["a" /* default */], {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true ? '' : this.selectAll,
            hideDetails: true,
            inputValue: this.everyItem,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = [this.genTR(_row), this.genTProgress()];
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var classes = ['column'];
      var data = {
        key: header[this.headerText],
        attrs: {
          role: 'columnheader',
          scope: 'col',
          width: header.width || null,
          'aria-label': header[this.headerText] || '',
          'aria-sort': 'none'
        }
      };

      if (header.sortable == null || header.sortable) {
        this.genHeaderSortingData(header, children, data, classes);
      } else {
        data.attrs['aria-label'] += ': Not sorted.'; // TODO: Localization
      }

      classes.push('text-xs-' + (header.align || 'left'));
      if (Array.isArray(header.class)) {
        classes.push.apply(classes, _toConsumableArray(header.class));
      } else if (header.class) {
        classes.push(header.class);
      }
      data.class = classes;

      return [data, children];
    },
    genHeaderSortingData: function genHeaderSortingData(header, children, data, classes) {
      var _this2 = this;

      if (!('value' in header)) {
        Object(__WEBPACK_IMPORTED_MODULE_0__util_console__["b" /* consoleWarn */])('Headers must have a value property that corresponds to a value in the v-model array', this);
      }

      data.attrs.tabIndex = 0;
      data.on = {
        click: function click() {
          _this2.expanded = {};
          _this2.sort(header.value);
        },
        keydown: function keydown(e) {
          // check for space
          if (e.keyCode === 32) {
            e.preventDefault();
            _this2.sort(header.value);
          }
        }
      };

      classes.push('sortable');
      var icon = this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
        props: {
          small: true
        }
      }, this.sortIcon);
      if (!header.align || header.align === 'left') {
        children.push(icon);
      } else {
        children.unshift(icon);
      }

      var pagination = this.computedPagination;
      var beingSorted = pagination.sortBy === header.value;
      if (beingSorted) {
        classes.push('active');
        if (pagination.descending) {
          classes.push('desc');
          data.attrs['aria-sort'] = 'descending';
          data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.'; // TODO: Localization
        } else {
          classes.push('asc');
          data.attrs['aria-sort'] = 'ascending';
          data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.'; // TODO: Localization
        }
      } else {
        data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.'; // TODO: Localization
      }
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions_expand_transition__ = __webpack_require__(41);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = this.genItems();

      return this.$createElement('tbody', children);
    },
    genExpandedRow: function genExpandedRow(props) {
      var children = [];

      if (this.isExpanded(props.item)) {
        var expand = this.$createElement('div', {
          class: 'datatable__expand-content',
          key: props.item[this.itemKey]
        }, this.$scopedSlots.expand(props));

        children.push(expand);
      }

      var transition = this.$createElement('transition-group', {
        class: 'datatable__expand-col',
        attrs: { colspan: this.headerColumns },
        props: {
          tag: 'td'
        },
        on: Object(__WEBPACK_IMPORTED_MODULE_0__transitions_expand_transition__["a" /* default */])('datatable__expand-col--expanded')
      }, children);

      return this.genTR([transition], { class: 'datatable__expand-row' });
    },
    genFilteredItems: function genFilteredItems() {
      if (!this.$scopedSlots.items) {
        return null;
      }

      var rows = [];
      for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
        var item = this.filteredItems[index];
        var props = this.createProps(item, index);
        var row = this.$scopedSlots.items(props);

        rows.push(this.hasTag(row, 'td') ? this.genTR(row, {
          key: index,
          attrs: { active: this.isSelected(item) }
        }) : row);

        if (this.$scopedSlots.expand) {
          var expandRow = this.genExpandedRow(props);
          rows.push(expandRow);
        }
      }

      return rows;
    },
    genEmptyItems: function genEmptyItems(content) {
      if (this.hasTag(content, 'tr')) {
        return content;
      } else if (this.hasTag(content, 'td')) {
        return this.genTR(content);
      } else {
        return this.genTR([this.$createElement('td', {
          class: {
            'text-xs-center': typeof content === 'string'
          },
          attrs: { colspan: this.headerColumns }
        }, content)]);
      }
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTFoot: function genTFoot() {
      if (!this.$slots.footer) {
        return null;
      }

      var footer = this.$slots.footer;
      var row = this.hasTag(footer, 'td') ? this.genTR(footer) : footer;

      return this.$createElement('tfoot', [row]);
    },
    genActionsFooter: function genActionsFooter() {
      if (this.hideActions) {
        return null;
      }

      return this.$createElement('div', {
        'class': this.classes
      }, this.genActions());
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTProgress: function genTProgress() {
      var col = this.$createElement('th', {
        staticClass: 'column',
        attrs: {
          colspan: this.headerColumns
        }
      }, [this.genProgress()]);

      return this.genTR([col], {
        staticClass: 'datatable__progress'
      });
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_small_dialog_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_returnable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VMenu__ = __webpack_require__(30);


// Mixins





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_returnable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    persistent: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && setTimeout(this.focus, 50); // Give DOM time to paint
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    genButton: function genButton(fn, text) {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VBtn__["a" /* default */], {
        props: {
          flat: true,
          color: 'primary',
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__actions'
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(function () {
        return _this.save(_this.returnValue);
      }, this.saveText)]);
    },
    genContent: function genContent() {
      var _this2 = this;

      return this.$createElement('div', {
        on: {
          keydown: function keydown(e) {
            var input = _this2.$refs.content.querySelector('input');
            e.keyCode === 27 && _this2.cancel();
            e.keyCode === 13 && input && _this2.save(input.value);
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this3 = this;

    return h(__WEBPACK_IMPORTED_MODULE_3__VMenu__["a" /* default */], {
      'class': 'small-dialog',
      props: {
        contentClass: 'small-dialog__content',
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnClick: !this.persistent,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this3.isActive = val;
        }
      }
    }, [h('a', {
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.large ? this.genActions() : null]);
  }
});

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__ = __webpack_require__(64);
/* unused harmony reexport VDatePicker */
/* unused harmony reexport VDatePickerTitle */
/* unused harmony reexport VDatePickerHeader */
/* unused harmony reexport VDatePickerDateTable */
/* unused harmony reexport VDatePickerMonthTable */
/* unused harmony reexport VDatePickerYears */









/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VDatePickerTitle__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VDatePickerHeader__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VDatePickerDateTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VDatePickerMonthTable__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__VDatePickerYears__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */]);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePickerTitle__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDatePickerHeader__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VDatePickerDateTable__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VDatePickerMonthTable__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePickerYears__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_picker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_isDateAllowed__ = __webpack_require__(62);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components






// Mixins


// Utils



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_picker__["a" /* default */]],

  data: function data() {
    var _this = this;

    var now = new Date();
    return {
      activePicker: this.type.toUpperCase(),
      defaultColor: 'accent',
      inputDay: null,
      inputMonth: null,
      inputYear: null,
      isReversing: false,
      now: now,
      // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
      tableDate: function () {
        if (_this.pickerDate) {
          return _this.pickerDate;
        }

        var date = _this.value || now.getFullYear() + '-' + (now.getMonth() + 1);
        var type = _this.type === 'date' ? 'month' : 'year';
        return _this.sanitizeDateString(date, type);
      }()
    };
  },


  props: {
    allowedDates: Function,
    // Function formatting the day in date picker table
    dayFormat: {
      type: Function,
      default: null
    },
    events: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    eventColor: {
      type: [String, Function, Object],
      default: 'warning'
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    // Function formatting the tableDate in the day/month table header
    headerDateFormat: {
      type: Function,
      default: null
    },
    locale: {
      type: String,
      default: 'en-us'
    },
    max: String,
    min: String,
    // Function formatting month in the months table
    monthFormat: {
      type: Function,
      default: null
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    pickerDate: String,
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    reactive: Boolean,
    readonly: Boolean,
    scrollable: Boolean,
    showCurrent: {
      type: [Boolean, String],
      default: true
    },
    // Function formatting currently selected date in the picker title
    titleDateFormat: {
      type: Function,
      default: null
    },
    type: {
      type: String,
      default: 'date',
      validator: function validator(type) {
        return ['date', 'month'].includes(type);
      } // TODO: year
    },
    value: String,
    // Function formatting the year in table header and pickup title
    yearFormat: {
      type: Function,
      default: null
    },
    yearIcon: String
  },

  computed: {
    current: function current() {
      if (this.showCurrent === true) {
        return this.sanitizeDateString(this.now.getFullYear() + '-' + (this.now.getMonth() + 1) + '-' + this.now.getDate(), this.type);
      }

      return this.showCurrent || null;
    },
    inputDate: function inputDate() {
      return this.type === 'date' ? this.inputYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.inputMonth + 1) + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.inputDay) : this.inputYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.inputMonth + 1);
    },
    tableMonth: function tableMonth() {
      return (this.pickerDate || this.tableDate).split('-')[1] - 1;
    },
    tableYear: function tableYear() {
      return (this.pickerDate || this.tableDate).split('-')[0] * 1;
    },
    minMonth: function minMonth() {
      return this.min ? this.sanitizeDateString(this.min, 'month') : null;
    },
    maxMonth: function maxMonth() {
      return this.max ? this.sanitizeDateString(this.max, 'month') : null;
    },
    minYear: function minYear() {
      return this.min ? this.sanitizeDateString(this.min, 'year') : null;
    },
    maxYear: function maxYear() {
      return this.max ? this.sanitizeDateString(this.max, 'year') : null;
    },
    formatters: function formatters() {
      return {
        year: this.yearFormat || Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* createNativeLocaleFormatter */])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 }),
        titleDate: this.titleDateFormat || this.defaultTitleDateFormatter
      };
    },
    defaultTitleDateFormatter: function defaultTitleDateFormatter() {
      var titleFormats = {
        year: { year: 'numeric', timeZone: 'UTC' },
        month: { month: 'long', timeZone: 'UTC' },
        date: { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }
      };

      var titleDateFormatter = Object(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* createNativeLocaleFormatter */])(this.locale, titleFormats[this.type], {
        start: 0,
        length: { date: 10, month: 7, year: 4 }[this.type]
      });

      var landscapeFormatter = function landscapeFormatter(date) {
        return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function (match, nonDigit, digit) {
          return nonDigit + ' ' + digit;
        }).replace(', ', ',<br>');
      };

      return this.landscape ? landscapeFormatter : titleDateFormatter;
    }
  },

  watch: {
    tableDate: function tableDate(val, prev) {
      // Make a ISO 8601 strings from val and prev for comparision, otherwise it will incorrectly
      // compare for example '2000-9' and '2000-10'
      var sanitizeType = this.type === 'month' ? 'year' : 'month';
      this.isReversing = this.sanitizeDateString(val, sanitizeType) < this.sanitizeDateString(prev, sanitizeType);
      this.$emit('update:pickerDate', val);
    },
    pickerDate: function pickerDate(val) {
      if (val) {
        this.tableDate = val;
      } else if (this.value && this.type === 'date') {
        this.tableDate = this.sanitizeDateString(this.value, 'month');
      } else if (this.value && this.type === 'month') {
        this.tableDate = this.sanitizeDateString(this.value, 'year');
      }
    },
    value: function value() {
      this.setInputDate();
      if (this.value && !this.pickerDate) {
        this.tableDate = this.sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
      }
    },
    type: function type(_type) {
      this.activePicker = _type.toUpperCase();

      if (this.value) {
        var date = this.sanitizeDateString(this.value, _type);
        this.$emit('input', this.isDateAllowed(date) ? date : null);
      }
    }
  },

  methods: {
    isDateAllowed: function isDateAllowed(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__util_isDateAllowed__["a" /* default */])(value, this.min, this.max, this.allowedDates);
    },
    yearClick: function yearClick(value) {
      this.inputYear = value;
      if (this.type === 'month') {
        this.tableDate = '' + value;
      } else {
        this.tableDate = value + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.tableMonth + 1);
      }
      this.activePicker = 'MONTH';
      this.reactive && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
    },
    monthClick: function monthClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
      if (this.type === 'date') {
        this.tableDate = value;
        this.activePicker = 'DATE';
        this.reactive && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
      } else {
        this.$emit('input', this.inputDate);
        this.$emit('change', this.inputDate);
      }
    },
    dateClick: function dateClick(value) {
      this.inputYear = parseInt(value.split('-')[0], 10);
      this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
      this.inputDay = parseInt(value.split('-')[2], 10);
      this.$emit('input', this.inputDate);
      this.$emit('change', this.inputDate);
    },
    genPickerTitle: function genPickerTitle() {
      var _this2 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__VDatePickerTitle__["a" /* default */], {
        props: {
          date: this.value ? this.formatters.titleDate(this.value) : '',
          selectingYear: this.activePicker === 'YEAR',
          year: this.formatters.year('' + this.inputYear),
          yearIcon: this.yearIcon,
          value: this.value
        },
        slot: 'title',
        style: this.readonly ? {
          'pointer-events': 'none'
        } : undefined,
        on: {
          'update:selectingYear': function updateSelectingYear(value) {
            return _this2.activePicker = value ? 'YEAR' : _this2.type.toUpperCase();
          }
        }
      });
    },
    genTableHeader: function genTableHeader() {
      var _this3 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VDatePickerHeader__["a" /* default */], {
        props: {
          nextIcon: this.nextIcon,
          color: this.color,
          disabled: this.readonly,
          format: this.headerDateFormat,
          locale: this.locale,
          min: this.activePicker === 'DATE' ? this.minMonth : this.minYear,
          max: this.activePicker === 'DATE' ? this.maxMonth : this.maxYear,
          prevIcon: this.prevIcon,
          value: this.activePicker === 'DATE' ? this.tableYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.tableMonth + 1) : '' + this.tableYear
        },
        on: {
          toggle: function toggle() {
            return _this3.activePicker = _this3.activePicker === 'DATE' ? 'MONTH' : 'YEAR';
          },
          input: function input(value) {
            return _this3.tableDate = value;
          }
        }
      });
    },
    genDateTable: function genDateTable() {
      var _this4 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VDatePickerDateTable__["a" /* default */], {
        props: {
          allowedDates: this.allowedDates,
          color: this.color,
          current: this.current,
          disabled: this.readonly,
          events: this.events,
          eventColor: this.eventColor,
          firstDayOfWeek: this.firstDayOfWeek,
          format: this.dayFormat,
          locale: this.locale,
          min: this.min,
          max: this.max,
          tableDate: this.tableYear + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(this.tableMonth + 1),
          scrollable: this.scrollable,
          value: this.value
        },
        ref: 'table',
        on: {
          input: this.dateClick,
          tableDate: function tableDate(value) {
            return _this4.tableDate = value;
          }
        }
      });
    },
    genMonthTable: function genMonthTable() {
      var _this5 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_3__VDatePickerMonthTable__["a" /* default */], {
        props: {
          allowedDates: this.type === 'month' ? this.allowedDates : null,
          color: this.color,
          current: this.current ? this.sanitizeDateString(this.current, 'month') : null,
          disabled: this.readonly,
          format: this.monthFormat,
          locale: this.locale,
          min: this.minMonth,
          max: this.maxMonth,
          scrollable: this.scrollable,
          value: !this.value || this.type === 'month' ? this.value : this.value.substr(0, 7),
          tableDate: '' + this.tableYear
        },
        ref: 'table',
        on: {
          input: this.monthClick,
          tableDate: function tableDate(value) {
            return _this5.tableDate = value;
          }
        }
      });
    },
    genYears: function genYears() {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_4__VDatePickerYears__["a" /* default */], {
        props: {
          color: this.color,
          format: this.yearFormat,
          locale: this.locale,
          min: this.minYear,
          max: this.maxYear,
          value: '' + this.tableYear
        },
        on: {
          input: this.yearClick
        }
      });
    },
    genPickerBody: function genPickerBody() {
      var children = this.activePicker === 'YEAR' ? [this.genYears()] : [this.genTableHeader(), this.activePicker === 'DATE' ? this.genDateTable() : this.genMonthTable()];

      return this.$createElement('div', {
        key: this.activePicker,
        style: this.readonly ? {
          'pointer-events': 'none'
        } : undefined
      }, children);
    },

    // Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
    // 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'
    sanitizeDateString: function sanitizeDateString(dateString, type) {
      var _dateString$split = dateString.split('-'),
          _dateString$split2 = _slicedToArray(_dateString$split, 3),
          year = _dateString$split2[0],
          _dateString$split2$ = _dateString$split2[1],
          month = _dateString$split2$ === undefined ? 1 : _dateString$split2$,
          _dateString$split2$2 = _dateString$split2[2],
          date = _dateString$split2$2 === undefined ? 1 : _dateString$split2$2;

      return (year + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(month) + '-' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* pad */])(date)).substr(0, { date: 10, month: 7, year: 4 }[type]);
    },
    setInputDate: function setInputDate() {
      if (this.value) {
        var array = this.value.split('-');
        this.inputYear = parseInt(array[0], 10);
        this.inputMonth = parseInt(array[1], 10) - 1;
        if (this.type === 'date') {
          this.inputDay = parseInt(array[2], 10);
        }
      } else {
        this.inputYear = this.inputYear || this.now.getFullYear();
        this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
        this.inputDay = this.inputDay || this.now.getDate();
      }
    }
  },

  created: function created() {
    if (this.pickerDate !== this.tableDate) {
      this.$emit('update:pickerDate', this.tableDate);
    }
    this.setInputDate();
  },
  render: function render(h) {
    return this.genPicker('picker--date');
  }
});

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pad__ = __webpack_require__(22);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



/* harmony default export */ __webpack_exports__["a"] = (function (locale, options) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { start: 0, length: 0 },
      start = _ref.start,
      length = _ref.length;

  var makeIsoString = function makeIsoString(dateString) {
    var _dateString$trim$spli = dateString.trim().split(' ')[0].split('-'),
        _dateString$trim$spli2 = _slicedToArray(_dateString$trim$spli, 3),
        year = _dateString$trim$spli2[0],
        month = _dateString$trim$spli2[1],
        date = _dateString$trim$spli2[2];

    return [year, Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(month || 1), Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(date || 1)].join('-');
  };

  try {
    var intlFormatter = new Intl.DateTimeFormat(locale || undefined, options);
    return function (dateString) {
      return intlFormatter.format(new Date(makeIsoString(dateString) + 'T00:00:00+00:00'));
    };
  } catch (e) {
    return start || length ? function (dateString) {
      return makeIsoString(dateString).substr(start, length);
    } : null;
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pad__ = __webpack_require__(22);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



/**
 * @param {String} value YYYY-MM format
 * @param {Number} sign -1 or +1
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value, sign) {
  var _value$split$map = value.split('-').map(function (v) {
    return 1 * v;
  }),
      _value$split$map2 = _slicedToArray(_value$split$map, 2),
      year = _value$split$map2[0],
      month = _value$split$map2[1];

  if (month + sign === 0) {
    return year - 1 + '-12';
  } else if (month + sign === 13) {
    return year + 1 + '-01';
  } else {
    return year + '-' + Object(__WEBPACK_IMPORTED_MODULE_0__pad__["a" /* default */])(month + sign);
  }
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_pickers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Components


// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'primary'
    };
  },


  props: {
    fullWidth: Boolean,
    landscape: Boolean,
    transition: {
      type: String,
      default: 'fade-transition'
    },
    width: {
      type: [Number, String],
      default: 290,
      validator: function validator(value) {
        return parseInt(value, 10) > 0;
      }
    }
  },

  computed: {
    computedTitleColor: function computedTitleColor() {
      var darkTheme = this.dark || !this.light && this.$vuetify.dark;
      var defaultTitleColor = darkTheme ? null : this.computedColor;
      return this.color || defaultTitleColor;
    }
  },

  methods: {
    genTitle: function genTitle() {
      return this.$createElement('div', {
        staticClass: 'picker__title',
        'class': this.addBackgroundColorClassChecks({
          'picker__title--landscape': this.landscape
        }, this.computedTitleColor)
      }, this.$slots.title);
    },
    genBodyTransition: function genBodyTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition
        }
      }, this.$slots.default);
    },
    genBody: function genBody() {
      return this.$createElement('div', {
        staticClass: 'picker__body',
        style: this.fullWidth ? undefined : {
          width: this.width + 'px'
        }
      }, [this.genBodyTransition()]);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        staticClass: 'picker__actions card__actions'
      }, this.$slots.actions);
    }
  },

  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */], {
      staticClass: 'picker',
      'class': _extends({
        'picker--landscape': this.landscape
      }, this.themeClasses)
    }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
  }
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(36);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(188);
/* unused harmony reexport VExpansionPanel */
/* unused harmony reexport VExpansionPanelContent */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_expansion_panel_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["b" /* provide */])('expansionPanel')],

  provide: function provide() {
    return {
      panelClick: this.panelClick,
      focusable: this.focusable
    };
  },
  data: function data() {
    return {
      items: []
    };
  },


  props: {
    expand: Boolean,
    focusable: Boolean,
    inset: Boolean,
    popout: Boolean
  },

  methods: {
    panelClick: function panelClick(uid) {
      if (!this.expand) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].toggle(uid);
        }
        return;
      }

      for (var _i = 0; _i < this.items.length; _i++) {
        if (this.items[_i].uid === uid) {
          this.items[_i].toggle(uid);
          return;
        }
      }
    },
    register: function register(uid, toggle) {
      this.items.push({ uid: uid, toggle: toggle });
    },
    unregister: function unregister(uid) {
      this.items = this.items.filter(function (i) {
        return i.uid !== uid;
      });
    }
  },

  render: function render(h) {
    return h('ul', {
      staticClass: 'expansion-panel',
      'class': _extends({
        'expansion-panel--focusable': this.focusable,
        'expansion-panel--popout': this.popout,
        'expansion-panel--inset': this.inset
      }, this.themeClasses)
    }, this.$slots.default);
  }
});

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_click_outside__ = __webpack_require__(8);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__mixins_registrable__["a" /* inject */])('expansionPanel', 'v-expansion-panel', 'v-expansion-panel-content')],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_6__directives_click_outside__["a" /* default */]
  },

  inject: ['focusable', 'panelClick'],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    expandIcon: {
      type: String,
      default: 'keyboard_arrow_down'
    },
    hideActions: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: false
    }
  },

  methods: {
    genBody: function genBody() {
      return this.$createElement('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, this.showLazyContent(this.$slots.default));
    },
    genHeader: function genHeader() {
      var _this = this;

      return this.$createElement('div', {
        staticClass: 'expansion-panel__header',
        directives: [{
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            return _this.panelClick(_this._uid);
          }
        }
      }, [this.$slots.header, this.genIcon()]);
    },
    genIcon: function genIcon(h) {
      if (this.hideActions) return null;

      var icon = this.$slots.actions || this.$createElement(__WEBPACK_IMPORTED_MODULE_5__VIcon__["a" /* default */], this.expandIcon);

      return this.$createElement('div', {
        staticClass: 'header__icon'
      }, [icon]);
    },
    toggle: function toggle(uid) {
      var _this2 = this;

      var isActive = this._uid === uid && !this.isActive;

      if (isActive) this.isBooted = true;

      // We treat bootable differently
      // Needs time to calc height
      this.$nextTick(function () {
        return _this2.isActive = isActive;
      });
    }
  },

  mounted: function mounted() {
    this.expansionPanel.register(this._uid, this.toggle);
  },
  beforeDestroy: function beforeDestroy() {
    this.expansionPanel.unregister(this._uid);
  },
  render: function render(h) {
    var _this3 = this;

    var children = [];

    this.$slots.header && children.push(this.genHeader());
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__transitions__["a" /* VExpandTransition */], [this.genBody()]));

    return h('li', {
      staticClass: 'expansion-panel__container',
      'class': {
        'expansion-panel__container--active': this.isActive
      },
      attrs: {
        tabindex: 0
      },
      on: {
        keydown: function keydown(e) {
          // Ensure element is focusable and the activeElement
          if (_this3.focusable && _this3.$el === document.activeElement && e.keyCode === 13) _this3.panelClick(_this3._uid);
        }
      }
    }, children);
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(190);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_footer_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
// Styles


// Mixins




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-footer',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('footer', ['height']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    height: {
      default: 32,
      type: [Number, String]
    },
    inset: Boolean
  },

  computed: {
    computedMarginBottom: function computedMarginBottom() {
      if (!this.app) return;

      return this.$vuetify.application.bottom;
    },
    computedPaddingLeft: function computedPaddingLeft() {
      return !this.app || !this.inset ? 0 : this.$vuetify.application.left;
    },
    computedPaddingRight: function computedPaddingRight() {
      return !this.app ? 0 : this.$vuetify.application.right;
    },
    styles: function styles() {
      var styles = {
        height: isNaN(this.height) ? this.height : this.height + 'px'
      };

      if (this.computedPaddingLeft) {
        styles.paddingLeft = this.computedPaddingLeft + 'px';
      }

      if (this.computedPaddingRight) {
        styles.paddingRight = this.computedPaddingRight + 'px';
      }

      if (this.computedMarginBottom) {
        styles.marginBottom = this.computedMarginBottom + 'px';
      }

      return styles;
    }
  },

  methods: {
    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return isNaN(this.height) ? this.$el ? this.$el.clientHeight : 0 : this.height;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'footer',
      'class': this.addBackgroundColorClassChecks({
        'footer--absolute': this.absolute,
        'footer--fixed': !this.absolute && (this.app || this.fixed),
        'footer--inset': this.inset,
        'theme--dark': this.dark,
        'theme--light': this.light
      }),
      style: this.styles,
      ref: 'content'
    };

    return h('footer', data, this.$slots.default);
  }
});

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VForm__ = __webpack_require__(193);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VForm__["a" /* default */]);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-form',

  inheritAttrs: false,

  data: function data() {
    return {
      inputs: [],
      errorBag: {}
    };
  },


  props: {
    value: Boolean,
    lazyValidation: Boolean
  },

  watch: {
    errorBag: {
      handler: function handler() {
        var errors = Object.values(this.errorBag).includes(true);

        this.$emit('input', !errors);

        return !errors;
      },

      deep: true
    }
  },

  methods: {
    getInputs: function getInputs() {
      var results = [];

      var search = function search(children) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        for (var index = 0; index < children.length; index++) {
          var child = children[index];
          if (child.errorBucket !== undefined) {
            results.push(child);
          } else {
            search(child.$children, depth + 1);
          }
        }
        if (depth === 0) return results;
      };

      return search(this.$children);
    },
    watchInputs: function watchInputs() {
      var inputs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getInputs();

      for (var index = 0; index < inputs.length; index++) {
        var child = inputs[index];
        if (this.inputs.includes(child)) {
          continue; // We already know about this input
        }

        this.inputs.push(child);
        this.watchChild(child);
      }
    },
    watchChild: function watchChild(child) {
      var _this = this;

      var watcher = function watcher(child) {
        child.$watch('valid', function (val) {
          _this.$set(_this.errorBag, child._uid, !val);
        }, { immediate: true });
      };

      if (!this.lazyValidation) return watcher(child);

      // Only start watching inputs if we need to
      child.$watch('shouldValidate', function (val) {
        if (!val) return;

        // Only watch if we're not already doing it
        if (_this.errorBag.hasOwnProperty(child._uid)) return;

        watcher(child);
      });
    },
    validate: function validate() {
      var errors = this.inputs.filter(function (input) {
        return !input.validate(true);
      }).length;
      return !errors;
    },
    reset: function reset() {
      for (var i = this.inputs.length; i--;) {
        this.inputs[i].reset();
      }
      if (this.lazyValidation) this.errorBag = {};
    }
  },

  mounted: function mounted() {
    this.watchInputs();
  },
  updated: function updated() {
    var inputs = this.getInputs();

    if (inputs.length < this.inputs.length) {
      // Something was removed, we don't want it in the errorBag any more
      var removed = this.inputs.filter(function (i) {
        return !inputs.includes(i);
      });

      for (var index = 0; index < removed.length; index++) {
        var input = removed[index];
        this.$delete(this.errorBag, input._uid);
        this.$delete(this.inputs, this.inputs.indexOf(input));
      }
    }

    this.watchInputs(inputs);
  },
  render: function render(h) {
    var _this2 = this;

    return h('form', {
      attrs: Object.assign({
        novalidate: true
      }, this.$attrs),
      on: {
        submit: function submit(e) {
          return _this2.$emit('submit', e);
        }
      }
    }, this.$slots.default);
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VSpacer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VContent__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VContainer__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VFlex__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VLayout__ = __webpack_require__(199);
/* unused harmony reexport VContainer */
/* unused harmony reexport VContent */
/* unused harmony reexport VFlex */
/* unused harmony reexport VLayout */






var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('spacer');



var VGrid = {};

/* istanbul ignore next */
VGrid.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VContent__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VContainer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VContainer__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VFlex__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VFlex__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VLayout__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VLayout__["a" /* default */]);
  Vue.component(VSpacer.name, VSpacer);
};

/* harmony default export */ __webpack_exports__["a"] = (VGrid);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_content_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ssr_bootable__ = __webpack_require__(23);
// Styles


// Mixins


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ssr_bootable__["a" /* default */]],

  props: {
    tag: {
      type: String,
      default: 'main'
    }
  },

  computed: {
    styles: function styles() {
      var _$vuetify$application = this.$vuetify.application,
          bar = _$vuetify$application.bar,
          top = _$vuetify$application.top,
          right = _$vuetify$application.right,
          footer = _$vuetify$application.footer,
          bottom = _$vuetify$application.bottom,
          left = _$vuetify$application.left;


      return {
        paddingTop: top + bar + 'px',
        paddingRight: right + 'px',
        paddingBottom: footer + bottom + 'px',
        paddingLeft: left + 'px'
      };
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'content',
      'class': this.classes,
      style: this.styles,
      ref: 'content'
    };

    return h(this.tag, data, [h('div', { staticClass: 'content--wrap' }, this.$slots.default)]);
  }
});

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('container'));

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('flex'));

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_grid_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__grid__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__grid__["a" /* default */])('layout'));

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(201);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_navigation_drawer_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_ssr_bootable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_touch__ = __webpack_require__(9);


// Mixins





// Directives




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])(null, ['miniVariant', 'right', 'width']), __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_themeable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_5__directives_click_outside__["a" /* default */],
    Resize: __WEBPACK_IMPORTED_MODULE_6__directives_resize__["a" /* default */],
    Touch: __WEBPACK_IMPORTED_MODULE_7__directives_touch__["a" /* default */]
  },

  data: function data() {
    return {
      isActive: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },

  props: {
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    disableResizeWatcher: Boolean,
    height: {
      type: [Number, String],
      default: '100%'
    },
    floating: Boolean,
    miniVariant: Boolean,
    miniVariantWidth: {
      type: [Number, String],
      default: 80
    },
    mobileBreakPoint: {
      type: [Number, String],
      default: 1264
    },
    permanent: Boolean,
    right: Boolean,
    stateless: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    width: {
      type: [Number, String],
      default: 300
    },
    value: { required: false }
  },

  computed: {
    /**
     * Used for setting an app
     * value from a dynamic
     * property. Called from
     * applicationable.js
     *
     * @return {string}
     */
    applicationProperty: function applicationProperty() {
      return this.right ? 'right' : 'left';
    },
    calculatedHeight: function calculatedHeight() {
      return isNaN(this.height) ? this.height : this.height + 'px';
    },
    calculatedTransform: function calculatedTransform() {
      if (this.isActive) return 0;

      return this.right ? this.calculatedWidth : -this.calculatedWidth;
    },
    calculatedWidth: function calculatedWidth() {
      return this.miniVariant ? this.miniVariantWidth : this.width;
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--fixed': !this.absolute && (this.app || this.fixed),
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    isMobile: function isMobile() {
      return !this.stateless && !this.permanent && !this.temporary && this.$vuetify.breakpoint.width < parseInt(this.mobileBreakPoint, 10);
    },
    marginTop: function marginTop() {
      if (!this.app) return 0;
      var marginTop = this.$vuetify.application.bar;

      marginTop += this.clipped ? this.$vuetify.application.top : 0;

      return marginTop;
    },
    maxHeight: function maxHeight() {
      if (!this.app) return '100%';

      return this.clipped ? this.$vuetify.application.top + this.$vuetify.application.bottom : this.$vuetify.application.bottom;
    },
    reactsToClick: function reactsToClick() {
      return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
    },
    reactsToMobile: function reactsToMobile() {
      return !this.disableResizeWatcher && !this.stateless && !this.permanent && !this.temporary;
    },
    reactsToRoute: function reactsToRoute() {
      return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
    },
    resizeIsDisabled: function resizeIsDisabled() {
      return this.disableResizeWatcher || this.stateless;
    },
    showOverlay: function showOverlay() {
      return this.isActive && (this.isMobile || this.temporary);
    },
    styles: function styles() {
      var styles = {
        height: this.calculatedHeight,
        marginTop: this.marginTop + 'px',
        maxHeight: 'calc(100% - ' + this.maxHeight + 'px)',
        transform: 'translateX(' + this.calculatedTransform + 'px)',
        width: this.calculatedWidth + 'px'
      };

      return styles;
    }
  },

  watch: {
    $route: function $route() {
      if (this.reactsToRoute && this.closeConditional()) {
        this.isActive = false;
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.callUpdate();
    },

    /**
     * When mobile changes, adjust
     * the active state only when
     * there has been a previous
     * value
     */
    isMobile: function isMobile(val, prev) {
      !val && this.isActive && !this.temporary && this.removeOverlay();

      if (prev == null || this.resizeIsDisabled || !this.reactsToMobile) return;

      this.isActive = !val;
      this.callUpdate();
    },
    permanent: function permanent(val) {
      // If enabling prop
      // enable the drawer
      if (val) {
        this.isActive = true;
      }
      this.callUpdate();
    },
    showOverlay: function showOverlay(val) {
      if (val) this.genOverlay();else this.removeOverlay();
    },
    temporary: function temporary() {
      this.callUpdate();
    },
    value: function value(val) {
      if (this.permanent) return;

      if (val == null) return this.init();

      if (val !== this.isActive) this.isActive = val;
    }
  },

  beforeMount: function beforeMount() {
    this.init();
  },


  methods: {
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    closeConditional: function closeConditional() {
      return this.isActive && this.reactsToClick;
    },
    genDirectives: function genDirectives() {
      var _this = this;

      var directives = [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        },
        args: {
          closeConditional: this.closeConditional
        }
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    },

    /**
     * Sets state before mount to avoid
     * entry transitions in SSR
     *
     * @return {void}
     */
    init: function init() {
      if (this.permanent) {
        this.isActive = true;
      } else if (this.stateless || this.value != null) {
        this.isActive = this.value;
      } else if (!this.temporary) {
        this.isActive = !this.isMobile;
      }
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
      if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return !this.isActive || this.temporary || this.isMobile ? 0 : this.calculatedWidth;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var data = {
      'class': this.classes,
      style: this.styles,
      directives: this.genDirectives(),
      on: {
        click: function click() {
          if (!_this2.miniVariant) return;

          _this2.$emit('update:miniVariant', false);
        },
        transitionend: function transitionend(e) {
          _this2.$emit('transitionend', e);
          window.dispatchEvent(new Event('resize'));
        }
      }
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(204);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_pagination_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_colorable__ = __webpack_require__(0);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_colorable__["a" /* default */]],

  directives: { Resize: __WEBPACK_IMPORTED_MODULE_2__directives_resize__["a" /* default */] },

  data: function data() {
    return {
      maxButtons: 0,
      defaultColor: 'primary'
    };
  },


  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    totalVisible: [Number, String],
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      var maxLength = this.totalVisible || this.maxButtons;
      if (this.length <= maxLength) {
        return this.range(1, this.length);
      }

      var even = maxLength % 2 === 0 ? 1 : 0;
      var left = Math.floor(maxLength / 2);
      var right = this.length - left + 1 + even;

      if (this.value >= left && this.value <= right) {
        var start = this.value - left + 2;
        var end = this.value + left - 2 - even;

        return [1, '...'].concat(_toConsumableArray(this.range(start, end)), ['...', this.length]);
      } else {
        return [].concat(_toConsumableArray(this.range(1, left)), ['...'], _toConsumableArray(this.range(this.length - left + 1 + even, this.length)));
      }
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      this.$nextTick(this.onResize);
      // TODO: Change this (f75dee3a, cbdf7caa)
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    onResize: function onResize() {
      var width = this.$el && this.$el.parentNode ? this.$el.parentNode.clientWidth : window.innerWidth;

      this.maxButtons = Math.floor((width - 96) / 42);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('button', {
        staticClass: 'pagination__navigation',
        class: {
          'pagination__navigation--disabled': disabled
        },
        on: disabled ? {} : { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('button', {
        staticClass: 'pagination__item',
        class: i === this.value ? this.addBackgroundColorClassChecks({
          'pagination__item--active': true
        }) : {},
        on: {
          click: function click() {
            return _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i, index) {
        return h('li', { key: index }, [isNaN(i) ? h('span', { class: 'pagination__more' }, [i]) : _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value <= 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value >= this.length, this.next)];

    return h('ul', {
      directives: [{
        modifiers: { quiet: true },
        name: 'resize',
        value: this.onResize
      }],
      class: this.classes
    }, children);
  }
});

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(207);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_parallax_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_translatable__ = __webpack_require__(209);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_translatable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: false
    };
  },


  props: {
    alt: String,
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        opacity: this.isBooted ? 1 : 0,
        transform: 'translate(-50%, ' + this.parallax + 'px)'
      };
    }
  },

  watch: {
    parallax: function parallax() {
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var imgData = {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    };

    if (this.alt) imgData.attrs.alt = this.alt;

    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', imgData)]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: this.normalizedHeight + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'translatable',

  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      if (this.jumbotron) {
        return isNaN(this.height) ? this.height : this.height + 'px';
      }

      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VRadioGroup__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(213);
/* unused harmony reexport VRadioGroup */
/* unused harmony reexport VRadio */





/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VRadioGroup__["a" /* default */]);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_radio_group_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_registrable__ = __webpack_require__(4);
// Styles




// Mixins



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-radio-group',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_4__mixins_registrable__["b" /* provide */])('radio')],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  provide: function provide() {
    var _this = this;

    return {
      isMandatory: function isMandatory() {
        return _this.mandatory;
      },
      name: function name() {
        return _this.name;
      }
    };
  },


  data: function data() {
    return {
      internalTabIndex: -1,
      radios: []
    };
  },

  props: {
    column: {
      type: Boolean,
      default: true
    },
    inputValue: null,
    mandatory: {
      type: Boolean,
      default: true
    },
    name: String,
    row: Boolean
  },

  watch: {
    hasError: function hasError(val) {
      for (var index = this.radios.length; --index >= 0;) {
        this.radios[index].parentError = val;
      }
    },
    inputValue: function inputValue(val) {
      for (var index = this.radios.length; --index >= 0;) {
        var radio = this.radios[index];
        radio.isActive = val === radio.value;
      }
    }
  },

  computed: {
    classes: function classes() {
      return {
        'radio-group': true,
        'radio-group--column': this.column && !this.row,
        'radio-group--row': this.row,
        'error--text': this.hasError
      };
    }
  },

  methods: {
    toggleRadio: function toggleRadio(value) {
      var _this2 = this;

      if (this.disabled) {
        return;
      }

      this.shouldValidate = true;
      this.$emit('change', value);
      this.$nextTick(function () {
        return _this2.validate();
      });

      for (var index = this.radios.length; --index >= 0;) {
        var radio = this.radios[index];
        if (radio.value !== value) radio.isActive = false;
      }
    },
    radioBlur: function radioBlur(e) {
      if (!e.relatedTarget || !e.relatedTarget.classList.contains('radio')) {
        this.shouldValidate = true;
        this.$emit('blur', this.inputValue);
      }
    },
    register: function register(radio) {
      radio.isActive = this.inputValue === radio.value;
      radio.$el.tabIndex = radio.$el.tabIndex > 0 ? radio.$el.tabIndex : 0;
      radio.$on('change', this.toggleRadio);
      radio.$on('blur', this.radioBlur);
      radio.$on('focus', this.radioFocus);
      this.radios.push(radio);
    },
    unregister: function unregister(radio) {
      radio.$off('change', this.toggleRadio);
      radio.$off('blur', this.radioBlur);
      radio.$off('focus', this.radioFocus);

      var index = this.radios.findIndex(function (r) {
        return r === radio;
      });

      if (index > -1) this.radios.splice(index, 1);
    }
  },

  render: function render(h) {
    var data = {
      attrs: {
        role: 'radiogroup'
      }
    };
    return this.genInputGroup(this.$slots.default, data);
  }
});

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_tab_focusable__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_registrable__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Components



// Mixins






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-radio',

  inheritAttrs: false,

  inject: ['isMandatory', 'name'],

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_6__mixins_registrable__["a" /* inject */])('radio', 'v-radio', 'v-radio-group'), __WEBPACK_IMPORTED_MODULE_4__mixins_tab_focusable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      defaultColor: 'accent',
      isActive: false,
      parentError: false
    };
  },

  props: {
    disabled: Boolean,
    value: null,
    label: String
  },

  computed: {
    classes: function classes() {
      var classes = {
        'input-group': true,
        'input-group--active': this.isActive,
        'input-group--disabled': this.disabled,
        'input-group--selection-controls': true,
        'input-group--tab-focused': this.tabFocused,
        'radio': true,
        'theme--dark': this.dark,
        'theme--light': this.light
      };

      if (!this.parentError) {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genInput: function genInput(radio) {
      var value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);
      var input = this.$createElement('input', {
        ref: 'input',
        style: {
          display: 'none'
        },
        attrs: Object.assign({
          name: this.name && this.name(),
          id: this.id,
          type: 'radio',
          value: value
        }, this.$attrs)
      }, [value]);

      radio.push(input);

      return this.$createElement('div', {
        class: 'input-group__input'
      }, radio);
    },
    genWrapper: function genWrapper(radio) {
      var _this = this;

      var children = [];

      children.push(this.genLabel());
      children.push(this.genInput(radio));

      return this.$createElement('div', {
        class: this.classes,
        attrs: {
          role: 'radio',
          'aria-checked': this.isActive ? 'true' : 'false',
          'aria-label': this.label
        },
        on: {
          keydown: function keydown(e) {
            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this.toggle();
            }
          },
          blur: function blur(e) {
            _this.$emit('blur', e);
            _this.tabFocused = false;
          }
        }
      }, children);
    },
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: {
          click: this.toggle
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      var mandatory = !!this.isMandatory && this.isMandatory();

      if (!this.disabled && (!this.isActive || !mandatory)) {
        this.$refs.input.checked = true;
        this.isActive = true;
        this.$emit('change', this.value);
      }
    }
  },

  mounted: function mounted() {
    this.radio.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.radio.unregister(this);
  },
  render: function render(h) {
    var transition = h(__WEBPACK_IMPORTED_MODULE_0__transitions__["b" /* VFadeTransition */], {}, [h(__WEBPACK_IMPORTED_MODULE_1__VIcon__["a" /* default */], {
      staticClass: 'icon--selection-control',
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon,
      on: Object.assign({
        click: this.toggle
      }, this.$listeners)
    }, this.icon)]);

    var ripple = this.ripple ? this.genRipple() : null;

    return this.genWrapper([transition, ripple]);
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tab-focusable',

  data: function data() {
    return {
      tabFocused: false
    };
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(216);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_sliders_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_console__ = __webpack_require__(5);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */]],

  directives: { ClickOutside: __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__["a" /* default */] },

  data: function data() {
    return {
      app: {},
      defaultColor: 'primary',
      isActive: false,
      keyPressed: 0
    };
  },


  props: {
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: 1
    },
    ticks: Boolean,
    thumbColor: {
      type: String,
      default: null
    },
    thumbLabel: Boolean,
    trackColor: {
      type: String,
      default: null
    },
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.stepNumeric && this.ticks
      };
    },
    computedColor: function computedColor() {
      return this.disabled ? null : this.color || this.defaultColor;
    },
    computedTrackColor: function computedTrackColor() {
      return this.disabled ? null : this.trackColor || null;
    },
    computedThumbColor: function computedThumbColor() {
      return this.disabled || !this.inputWidth ? null : this.thumbColor || this.color || this.defaultColor;
    },
    stepNumeric: function stepNumeric() {
      return this.step > 0 ? parseFloat(this.step) : 0;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max;

        val = Math.min(Math.max(val, min), max);

        // Round value to ensure the
        // entire slider range can
        // be selected with step
        var value = this.roundValue(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.stepNumeric;
    },
    thumbStyles: function thumbStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate(0, -50%)'
      };
    },
    trackPadding: function trackPadding() {
      if (this.thumbLabel && this.isActive) return 0;

      return 6 + (this.isActive && !this.disabled ? 3 : 0);
    },
    trackStyles: function trackStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        left: 'calc(' + this.inputWidth + '% + ' + this.trackPadding + 'px)',
        width: 'calc(' + (100 - this.inputWidth) + '% - ' + this.trackPadding + 'px)'
      };
    },
    trackFillStyles: function trackFillStyles() {
      return {
        transition: this.keyPressed >= 2 ? 'none' : '',
        width: 'calc(' + this.inputWidth + '% - ' + this.trackPadding + 'px)'
      };
    },
    numTicks: function numTicks() {
      return Math.ceil((this.max - this.min) / this.stepNumeric);
    },
    inputWidth: function inputWidth() {
      return (this.roundValue(this.inputValue) - this.min) / (this.max - this.min) * 100;
    }
  },

  watch: {
    isActive: function isActive(val) {
      this.isFocused = val;
    },
    min: function min(val) {
      val > this.inputValue && this.$emit('input', parseFloat(val));
    },
    max: function max(val) {
      val < this.inputValue && this.$emit('input', parseFloat(val));
    },
    value: function value(val) {
      this.inputValue = parseFloat(val);
    }
  },

  mounted: function mounted() {
    this.inputValue = this.value;

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || Object(__WEBPACK_IMPORTED_MODULE_6__util_console__["b" /* consoleWarn */])('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
  },


  methods: {
    onMouseDown: function onMouseDown(e) {
      this.keyPressed = 2;
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      this.keyPressed = 0;
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = Math.min(Math.max((clientX - offsetLeft) / trackWidth, 0), 1);

      if (clientX >= offsetLeft - 8 && clientX <= offsetLeft + trackWidth + 8) {
        this.inputValue = parseFloat(this.min) + left * (this.max - this.min);
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (this.disabled || ![33, 34, 35, 36, 37, 39].includes(e.keyCode)) return;

      e.preventDefault();
      var step = this.stepNumeric || 1;
      var steps = (this.max - this.min) / step;
      if (e.keyCode === 37 || e.keyCode === 39) {
        // Left/right
        this.keyPressed += 1;

        var direction = e.keyCode === 37 ? -1 : 1;
        var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;

        this.inputValue = this.inputValue + direction * step * multiplier;
      } else if (e.keyCode === 36) {
        // Home
        this.inputValue = parseFloat(this.min);
      } else if (e.keyCode === 35) {
        // End
        this.inputValue = parseFloat(this.max);
      } else /* if (e.keyCode === 33 || e.keyCode === 34) */{
          // Page up/down
          var _direction = e.keyCode === 34 ? -1 : 1;
          this.inputValue = this.inputValue - _direction * step * (steps > 100 ? steps / 10 : 10);
        }
    },
    onKeyUp: function onKeyUp(e) {
      this.keyPressed = 0;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h(__WEBPACK_IMPORTED_MODULE_5__transitions__["c" /* VScaleTransition */], {
        props: { origin: 'bottom center' }
      }, [h('div', {
        staticClass: 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', {
        staticClass: 'slider__thumb--label',
        'class': this.addBackgroundColorClassChecks({}, this.computedThumbColor)
      }, [h('span', {}, this.inputValue)])])]);
    },
    roundValue: function roundValue(value) {
      if (!this.stepNumeric) {
        return value;
      }

      // Format input value using the same number
      // of decimals places as in the step prop
      var trimmedStep = this.step.toString().trim();
      var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
      return 1 * (Math.round(value / this.stepNumeric) * this.stepNumeric).toFixed(decimals);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', {
        staticClass: 'slider__thumb',
        'class': this.addBackgroundColorClassChecks({}, this.computedThumbColor)
      }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        staticClass: 'slider__thumb-container',
        'class': {
          'slider__thumb-container--label': this.thumbLabel
        },
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["d" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          key: i,
          staticClass: 'slider__tick',
          style: {
            left: i * (100 / _this.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        staticClass: 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        staticClass: 'slider__track',
        'class': this.addBackgroundColorClassChecks({}, this.computedTrackColor),
        style: this.trackStyles
      }), h('div', {
        staticClass: 'slider__track-fill',
        'class': this.addBackgroundColorClassChecks(),
        style: this.trackFillStyles
      })];

      return h('div', {
        staticClass: 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && this.ticks && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', {
      staticClass: 'slider'
    }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.disabled ? -1 : this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown,
        keyup: this.onKeyUp
      }, this.$listeners),
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this2.isActive = false;
        }
      }]
    });
  }
});

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(219);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_snackbars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_positionable__ = __webpack_require__(12);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_toggleable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__mixins_positionable__["b" /* factory */])(['absolute', 'top', 'bottom', 'left', 'right'])],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    autoHeight: Boolean,
    multiLine: Boolean,
    // TODO: change this to closeDelay to match other API in delayable.js
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--auto-height': this.autoHeight,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.setTimeout();
    }
  },

  methods: {
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    })
  },

  mounted: function mounted() {
    this.setTimeout();
  },
  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        staticClass: 'snack',
        class: this.classes,
        on: this.$listeners
      }, [h('div', {
        staticClass: 'snack__wrapper',
        class: this.addBackgroundColorClassChecks()
      }, [h('div', {
        staticClass: 'snack__content'
      }, this.$slots.default)])]));
    }

    return h('transition', {
      attrs: { name: 'snack-transition' }
    }, children);
  }
});

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSpeedDial__ = __webpack_require__(222);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSpeedDial__["a" /* default */]);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_speed_dial_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_transitionable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__ = __webpack_require__(8);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_transitionable__["a" /* default */]],

  directives: { ClickOutside: __WEBPACK_IMPORTED_MODULE_4__directives_click_outside__["a" /* default */] },

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    openOnHover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this.isActive = false;
        }
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.openOnHover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        mode: this.mode,
        origin: this.origin,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VStepperHeader */
/* unused harmony export VStepperItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(228);
/* unused harmony reexport VStepper */
/* unused harmony reexport VStepperContent */
/* unused harmony reexport VStepperStep */





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('stepper__header');
var VStepperItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('stepper__items');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]);
  Vue.component(VStepperHeader.name, VStepperHeader);
  Vue.component(VStepperItems.name, VStepperItems);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */]);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_steppers_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      this.isReverse = Number(val) < Number(prev);
      for (var index = this.steps.length; --index >= 0;) {
        this.steps[index].toggle(this.inputValue);
      }
      for (var _index = this.content.length; --_index >= 0;) {
        this.content[_index].toggle(this.inputValue, this.isReverse);
      }

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      var _this = this;

      this.getSteps();
      this.$nextTick(function () {
        return _this.inputValue = _this.value;
      });
    }
  },

  mounted: function mounted() {
    this.getSteps();

    this.inputValue = this.value || this.steps[0].step || 1;
  },


  methods: {
    getSteps: function getSteps() {
      this.steps = [];
      this.content = [];
      for (var index = 0; index < this.$children.length; index++) {
        var child = this.$children[index];
        // TODO: use the component name instead of tag
        if (child.$options._componentTag === 'v-stepper-step') {
          this.steps.push(child);
        } else if (child.$options._componentTag === 'v-stepper-content') {
          child.isVertical = this.vertical;
          this.content.push(child);
        }
      }
    },
    stepClick: function stepClick(step) {
      var _this2 = this;

      this.getSteps();
      this.$nextTick(function () {
        return _this2.inputValue = step;
      });
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(17);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  directives: { Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */] },

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete,
        'error--text': this.hasError
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h(__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */], {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h(__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */], {}, this.editIcon)];
      } else {
        stepContent = [h(__WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */], {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', {
      staticClass: 'stepper__step__step',
      'class': {
        'primary': !this.hasError && (this.complete || this.isActive)
      }
    }, stepContent);

    var label = h('div', {
      staticClass: 'stepper__label'
    }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      // Must be null to allow
      // previous comparison
      isActive: null,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? __WEBPACK_IMPORTED_MODULE_0__transitions__["e" /* VTabReverseTransition */] : __WEBPACK_IMPORTED_MODULE_0__transitions__["f" /* VTabTransition */];
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive(current, previous) {
      // If active and the previous state
      // was null, is just booting up
      if (current && previous == null) {
        return this.height = 'auto';
      }

      if (!this.isVertical) return;

      if (this.isActive) this.enter();else this.leave();
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition(e) {
      if (!this.isActive || e.propertyName !== 'height') return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      requestAnimationFrame(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      });

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 10);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSwitch__ = __webpack_require__(230);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSwitch__["a" /* default */]);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_selection_controls_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_components_switch_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_selectable__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_touch__ = __webpack_require__(9);




// Mixins



// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_rippleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_selectable__["a" /* default */]],

  directives: { Touch: __WEBPACK_IMPORTED_MODULE_5__directives_touch__["a" /* default */] },

  computed: {
    classes: function classes() {
      var classes = {
        'input-group--selection-controls switch': true
      };

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return {
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      };
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  methods: {
    onSwipeLeft: function onSwipeLeft() {
      if (this.isActive) this.toggle();
    },
    onSwipeRight: function onSwipeRight() {
      if (!this.isActive) this.toggle();
    }
  },

  render: function render(h) {
    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), this.genRipple({
      directives: [{
        name: 'touch',
        value: {
          left: this.onSwipeLeft,
          right: this.onSwipeRight
        }
      }]
    })]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSystemBar__ = __webpack_require__(233);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VSystemBar__["a" /* default */]);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_system_bars_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-system-bar',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('bar', ['height', 'window']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  props: {
    height: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addBackgroundColorClassChecks(Object.assign({
        'system-bar--lights-out': this.lightsOut,
        'system-bar--absolute': this.absolute,
        'system-bar--fixed': !this.absolute && (this.app || this.fixed),
        'system-bar--status': this.status,
        'system-bar--window': this.window
      }, this.themeClasses));
    },
    computedHeight: function computedHeight() {
      if (this.height) return parseInt(this.height);

      return this.window ? 32 : 24;
    }
  },

  methods: {
    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return this.computedHeight;
    }
  },

  render: function render(h) {
    var data = {
      staticClass: 'system-bar',
      'class': this.classes,
      style: {
        height: this.computedHeight + 'px'
      }
    };

    return h('div', data, this.$slots.default);
  }
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTabs__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTab__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItems__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabItem__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsSlider__ = __webpack_require__(68);
/* unused harmony reexport VTabs */
/* unused harmony reexport VTabItem */
/* unused harmony reexport VTab */
/* unused harmony reexport VTabsItems */
/* unused harmony reexport VTabsSlider */








/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VTab__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VTab__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VTabsItems__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VTabsItems__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_3__VTabItem__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__VTabItem__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_4__VTabsSlider__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__VTabsSlider__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTabs__["a" /* default */]);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tabs_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_tabs_computed__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_tabs_generators__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_tabs_props__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_tabs_touch__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_tabs_watchers__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ssr_bootable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_touch__ = __webpack_require__(9);
// Styles


// Component level mixins






// Mixins





// Directives



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_9__mixins_registrable__["b" /* provide */])('tabs'), __WEBPACK_IMPORTED_MODULE_6__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_tabs_computed__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_tabs_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_tabs_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_tabs_touch__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_tabs_watchers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__mixins_themeable__["a" /* default */]],

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_10__directives_resize__["a" /* default */],
    Touch: __WEBPACK_IMPORTED_MODULE_11__directives_touch__["a" /* default */]
  },

  provide: function provide() {
    return {
      tabClick: this.tabClick,
      tabProxy: this.tabProxy,
      registerItems: this.registerItems,
      unregisterItems: this.unregisterItems
    };
  },
  data: function data() {
    return {
      bar: [],
      content: [],
      isBooted: false,
      isOverflowing: false,
      lazyValue: this.value,
      nextIconVisible: false,
      prevIconVisible: false,
      resizeTimeout: null,
      reverse: false,
      scrollOffset: 0,
      sliderWidth: null,
      sliderLeft: null,
      startX: 0,
      tabsContainer: null,
      tabs: [],
      tabItems: null,
      transitionTime: 300,
      widths: {
        bar: 0,
        container: 0,
        wrapper: 0
      }
    };
  },


  watch: {
    tabs: 'onResize'
  },

  mounted: function mounted() {
    this.checkIcons();
  },


  methods: {
    checkIcons: function checkIcons() {
      this.prevIconVisible = this.checkPrevIcon();
      this.nextIconVisible = this.checkNextIcon();
    },
    checkPrevIcon: function checkPrevIcon() {
      return this.scrollOffset > 0;
    },
    checkNextIcon: function checkNextIcon() {
      // Check one scroll ahead to know the width of right-most item
      return this.widths.container > this.scrollOffset + this.widths.wrapper;
    },
    callSlider: function callSlider() {
      var _this = this;

      if (this.hideSlider || !this.activeTab) return false;

      // Give screen time to paint
      var action = (this.activeTab || {}).action;
      var activeTab = action === this.activeTab ? this.activeTab : this.tabs.find(function (tab) {
        return tab.action === action;
      });

      this.$nextTick(function () {
        if (!activeTab || !activeTab.$el) return;
        _this.sliderWidth = activeTab.$el.scrollWidth;
        _this.sliderLeft = activeTab.$el.offsetLeft;
      });
    },

    /**
     * When v-navigation-drawer changes the
     * width of the container, call resize
     * after the transition is complete
     */
    onResize: function onResize() {
      var _this2 = this;

      if (this._isDestroyed) return;

      this.setWidths();

      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(function () {
        _this2.callSlider();
        _this2.scrollIntoView();
        _this2.checkIcons();
      }, this.transitionTime);
    },
    overflowCheck: function overflowCheck(e, fn) {
      this.isOverflowing && fn(e);
    },
    scrollTo: function scrollTo(direction) {
      this.scrollOffset = this.newOffset(direction);
    },
    setOverflow: function setOverflow() {
      this.isOverflowing = this.widths.bar < this.widths.container;
    },
    setWidths: function setWidths() {
      var bar = this.$refs.bar ? this.$refs.bar.clientWidth : 0;
      var container = this.$refs.container ? this.$refs.container.clientWidth : 0;
      var wrapper = this.$refs.wrapper ? this.$refs.wrapper.clientWidth : 0;

      this.widths = { bar: bar, container: container, wrapper: wrapper };

      this.setOverflow();
    },
    findActiveLink: function findActiveLink() {
      var _this3 = this;

      if (!this.tabs.length || this.lazyValue) return;

      var activeIndex = this.tabs.findIndex(function (tabItem, index) {
        var id = tabItem.action === tabItem ? index.toString() : tabItem.action;
        return id === _this3.lazyValue || tabItem.$el.firstChild.className.indexOf(_this3.activeClass) > -1;
      });

      var index = activeIndex > -1 ? activeIndex : 0;
      var tab = this.tabs[index];

      /* istanbul ignore next */
      // There is not a reliable way to test
      this.inputValue = tab.action === tab ? index : tab.action;
    },
    parseNodes: function parseNodes() {
      var item = [];
      var items = [];
      var slider = [];
      var tab = [];
      var length = (this.$slots.default || []).length;

      for (var i = 0; i < length; i++) {
        var vnode = this.$slots.default[i];

        if (vnode.componentOptions) {
          switch (vnode.componentOptions.Ctor.options.name) {
            case 'v-tabs-slider':
              slider.push(vnode);
              break;
            case 'v-tabs-items':
              items.push(vnode);
              break;
            case 'v-tab-item':
              item.push(vnode);
              break;
            // case 'v-tab' - intentionally omitted
            default:
              tab.push(vnode);
          }
        } else {
          tab.push(vnode);
        }
      }

      return { tab: tab, slider: slider, items: items, item: item };
    },
    register: function register(options) {
      this.tabs.push(options);
    },
    scrollIntoView: function scrollIntoView() {
      if (!this.activeTab) return;
      if (!this.isOverflowing) return this.scrollOffset = 0;

      var totalWidth = this.widths.wrapper + this.scrollOffset;
      var _activeTab$$el = this.activeTab.$el,
          clientWidth = _activeTab$$el.clientWidth,
          offsetLeft = _activeTab$$el.offsetLeft;

      var itemOffset = clientWidth + offsetLeft;
      var additionalOffset = clientWidth * 0.3;

      /* istanbul ignore else */
      if (offsetLeft < this.scrollOffset) {
        this.scrollOffset = Math.max(offsetLeft - additionalOffset, 0);
      } else if (totalWidth < itemOffset) {
        this.scrollOffset -= totalWidth - itemOffset - additionalOffset;
      }
    },
    tabClick: function tabClick(tab) {
      this.inputValue = tab.action === tab ? this.tabs.indexOf(tab) : tab.action;
      this.scrollIntoView();
    },
    tabProxy: function tabProxy(val) {
      this.lazyValue = val;
    },
    registerItems: function registerItems(fn) {
      this.tabItems = fn;
    },
    unregisterItems: function unregisterItems() {
      this.tabItems = null;
    },
    unregister: function unregister(tab) {
      this.tabs = this.tabs.filter(function (o) {
        return o !== tab;
      });
    },
    updateTabs: function updateTabs() {
      for (var index = this.tabs.length; --index >= 0;) {
        this.tabs[index].toggle(this.target);
      }

      this.setOverflow();
    }
  },

  render: function render(h) {
    var _parseNodes = this.parseNodes(),
        tab = _parseNodes.tab,
        slider = _parseNodes.slider,
        items = _parseNodes.items,
        item = _parseNodes.item;

    return h('div', {
      staticClass: 'tabs',
      directives: [{
        name: 'resize',
        arg: 400,
        modifiers: { quiet: true },
        value: this.onResize
      }]
    }, [this.genBar([this.hideSlider ? null : this.genSlider(slider), tab]), this.genItems(items, item)]);
  }
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs computed
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    activeIndex: function activeIndex() {
      var _this = this;

      return this.tabs.findIndex(function (tab, index) {
        var id = tab.action === tab ? index.toString() : tab.action;
        return id === _this.lazyValue;
      });
    },
    activeTab: function activeTab() {
      if (!this.tabs.length) return undefined;

      return this.tabs[this.activeIndex];
    },
    containerStyles: function containerStyles() {
      return this.height ? {
        height: parseInt(this.height, 10) + 'px'
      } : null;
    },
    hasArrows: function hasArrows() {
      return (this.showArrows || !this.isMobile) && this.isOverflowing;
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        // Always use strings
        val = val.toString();

        this.lazyValue = val;
        this.$emit('input', val);
      }
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.width < this.mobileBreakPoint;
    },
    sliderStyles: function sliderStyles() {
      return {
        left: this.sliderLeft + 'px',
        transition: this.sliderLeft != null ? null : 'none',
        width: this.sliderWidth + 'px'
      };
    },
    target: function target() {
      return this.activeTab ? this.activeTab.action : null;
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTabsItems__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabsSlider__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VIcon__ = __webpack_require__(3);




/**
 * Tabs generators
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genBar: function genBar(items) {
      return this.$createElement('div', {
        staticClass: 'tabs__bar',
        'class': this.addBackgroundColorClassChecks({
          'theme--dark': this.dark,
          'theme--light': this.light
        }),
        ref: 'bar'
      }, [this.genTransition('prev'), this.genWrapper(this.genContainer(items)), this.genTransition('next')]);
    },
    genContainer: function genContainer(items) {
      return this.$createElement('div', {
        staticClass: 'tabs__container',
        class: {
          'tabs__container--align-with-title': this.alignWithTitle,
          'tabs__container--centered': this.centered,
          'tabs__container--fixed-tabs': this.fixedTabs,
          'tabs__container--grow': this.grow,
          'tabs__container--icons-and-text': this.iconsAndText,
          'tabs__container--overflow': this.isOverflowing,
          'tabs__container--right': this.right
        },
        style: this.containerStyles,
        ref: 'container'
      }, items);
    },
    genIcon: function genIcon(direction) {
      var _this = this;

      if (!this.hasArrows || !this[direction + 'IconVisible']) return null;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_2__VIcon__["a" /* default */], {
        staticClass: 'tabs__icon tabs__icon--' + direction,
        props: {
          disabled: !this[direction + 'IconVisible']
        },
        on: {
          click: function click() {
            return _this.scrollTo(direction);
          }
        }
      }, this[direction + 'Icon']);
    },
    genItems: function genItems(items, item) {
      if (items.length > 0) return items;
      if (!item.length) return null;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__VTabsItems__["a" /* default */], item);
    },
    genTransition: function genTransition(direction) {
      return this.$createElement('transition', {
        props: { name: 'fade-transition' }
      }, [this.genIcon(direction)]);
    },
    genWrapper: function genWrapper(items) {
      var _this2 = this;

      return this.$createElement('div', {
        staticClass: 'tabs__wrapper',
        class: {
          'tabs__wrapper--show-arrows': this.hasArrows
        },
        ref: 'wrapper',
        directives: [{
          name: 'touch',
          value: {
            start: function start(e) {
              return _this2.overflowCheck(e, _this2.onTouchStart);
            },
            move: function move(e) {
              return _this2.overflowCheck(e, _this2.onTouchMove);
            },
            end: function end(e) {
              return _this2.overflowCheck(e, _this2.onTouchEnd);
            }
          }
        }]
      }, [items]);
    },
    genSlider: function genSlider(items) {
      if (!items.length) {
        items = [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VTabsSlider__["a" /* default */], {
          props: { color: this.sliderColor }
        })];
      }

      return this.$createElement('div', {
        staticClass: 'tabs__slider-wrapper',
        style: this.sliderStyles
      }, items);
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs props
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    alignWithTitle: Boolean,
    centered: Boolean,
    fixedTabs: Boolean,
    grow: Boolean,
    height: {
      type: [Number, String],
      default: undefined,
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    hideSlider: Boolean,
    iconsAndText: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1264,
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    right: Boolean,
    showArrows: Boolean,
    sliderColor: {
      type: String,
      default: 'accent'
    },
    value: [Number, String]
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs touch
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    newOffset: function newOffset(direction) {
      var clientWidth = this.$refs.wrapper.clientWidth;

      if (direction === 'prev') {
        return Math.max(this.scrollOffset - clientWidth, 0);
      } else {
        return Math.min(this.scrollOffset + clientWidth, this.$refs.container.clientWidth - clientWidth);
      }
    },
    onTouchStart: function onTouchStart(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
      this.$refs.container.style.willChange = 'transform';
    },
    onTouchMove: function onTouchMove(e) {
      this.scrollOffset = this.startX - e.touchmoveX;
    },
    onTouchEnd: function onTouchEnd() {
      var container = this.$refs.container;
      var wrapper = this.$refs.wrapper;
      var maxScrollOffset = container.clientWidth - wrapper.clientWidth;
      container.style.transition = null;
      container.style.willChange = null;

      /* istanbul ignore else */
      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= maxScrollOffset) {
        this.scrollOffset = maxScrollOffset;
      }
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Tabs watchers
 *
 * @mixin
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    activeTab: function activeTab(tab, prev) {
      !prev && tab && this.updateTabs();

      setTimeout(this.callSlider, 0);

      if (!tab) return;

      var action = tab.action;
      this.tabItems && this.tabItems(action === tab ? this.tabs.indexOf(tab).toString() : action);
    },

    alignWithTitle: 'callSlider',
    centered: 'callSlider',
    fixedTabs: 'callSlider',
    hasArrows: function hasArrows(val) {
      if (!val) this.scrollOffset = 0;
    },

    isBooted: 'findActiveLink',
    lazyValue: 'updateTabs',
    right: 'callSlider',
    value: function value(val) {
      this.lazyValue = val;
    },

    '$vuetify.application.left': 'onResize',
    '$vuetify.application.right': 'onResize',
    scrollOffset: function scrollOffset(val) {
      this.$refs.container.style.transform = 'translateX(' + -val + 'px)';
      if (this.hasArrows) {
        this.prevIconVisible = this.checkPrevIcon();
        this.nextIconVisible = this.checkNextIcon();
      }
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_routable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_helpers__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Mixins



// Utilities


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tab',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_registrable__["a" /* inject */])('tabs', 'v-tab', 'v-tabs'), __WEBPACK_IMPORTED_MODULE_0__mixins_routable__["a" /* default */]],

  inject: ['tabClick'],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    },
    ripple: {
      type: [Boolean, Object],
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      }, this.activeClass, !this.to && this.isActive);
    },
    action: function action() {
      var to = this.to || this.href;

      if (this.$router && this.to === Object(this.to)) {
        var resolve = this.$router.resolve(this.to, this.$route, this.append);

        to = resolve.href;
      }

      return typeof to === 'string' ? to.replace('#', '') : this;
    }
  },

  watch: {
    $route: 'onRouteChange'
  },

  mounted: function mounted() {
    this.tabs.register(this);
    this.onRouteChange();
  },
  beforeDestroy: function beforeDestroy() {
    this.tabs.unregister(this);
  },


  methods: {
    click: function click(e) {
      // If user provides an
      // actual link, do not
      // prevent default
      if (this.href && this.href.indexOf('#') > -1) e.preventDefault();

      this.$emit('click', e);

      this.to || this.tabClick(this);
    },
    onRouteChange: function onRouteChange() {
      var _this = this;

      if (!this.to || !this.$refs.link) return;

      var path = '_vnode.data.class.' + this.activeClass;

      this.$nextTick(function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_helpers__["i" /* getObjectValueByPath */])(_this.$refs.link, path)) {
          _this.tabClick(_this);
        }
      });
    },
    toggle: function toggle(action) {
      this.isActive = action === this || action === this.action;
    }
  },

  render: function render(h) {
    var link = this.generateRouteLink();
    var data = link.data;

    // If disabled, use div as anchor tags do not support
    // being disabled

    var tag = this.disabled ? 'div' : link.tag;

    data.ref = 'link';

    return h('div', {
      staticClass: 'tabs__div'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_registrable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_touch__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tab-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__mixins_registrable__["a" /* inject */])('tabs', 'v-tab-item', 'v-tabs-items')],

  components: {
    VTabTransition: __WEBPACK_IMPORTED_MODULE_1__transitions__["f" /* VTabTransition */],
    VTabReverseTransition: __WEBPACK_IMPORTED_MODULE_1__transitions__["e" /* VTabReverseTransition */]
  },

  directives: {
    Touch: __WEBPACK_IMPORTED_MODULE_3__directives_touch__["a" /* default */]
  },

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: String,
    transition: {
      type: [Boolean, String],
      default: 'tab-transition'
    },
    reverseTransition: {
      type: [Boolean, String],
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition, index) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = (this.id || index.toString()) === target;
    }
  },

  mounted: function mounted() {
    this.tabs.register(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.tabs.unregister(this);
  },
  render: function render(h) {
    var data = {
      staticClass: 'tabs__content',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      domProps: { id: this.id },
      on: this.$listeners
    };

    var div = h('div', data, this.showLazyContent(this.$slots.default));

    if (!this.computedTransition) return div;

    return h('transition', {
      props: { name: this.computedTransition }
    }, [div]);
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(246);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_input_groups_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_components_text_fields_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_maskable__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_soloable__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Styles



// Mixins





var dirtyTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_maskable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_soloable__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      initialValue: null,
      inputHeight: null,
      internalChange: false,
      badInput: false
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    box: Boolean,
    clearable: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    counter: [Boolean, Number, String],
    fullWidth: Boolean,
    multiLine: Boolean,
    noResize: Boolean,
    placeholder: String,
    prefix: String,
    rowHeight: {
      type: [Number, String],
      default: 24,
      validator: function validator(v) {
        return !isNaN(parseFloat(v));
      }
    },
    rows: {
      type: [Number, String],
      default: 5,
      validator: function validator(v) {
        return !isNaN(parseInt(v, 10));
      }
    },
    singleLine: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _extends({}, this.genSoloClasses(), {
        'input-group--text-field': true,
        'input-group--text-field-box': this.box,
        'input-group--single-line': this.singleLine || this.isSolo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--no-resize': this.noResizeHandle,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      });

      if (this.hasError) {
        classes['error--text'] = true;
      } else {
        return this.addTextColorClassChecks(classes);
      }

      return classes;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;

      return inputLength + ' / ' + this.counterLength;
    },
    counterLength: function counterLength() {
      var parsedLength = parseInt(this.counter, 10);
      return isNaN(parsedLength) ? 25 : parsedLength;
    },

    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        if (this.mask) {
          this.lazyValue = this.unmaskText(this.maskText(this.unmaskText(val)));
          this.setSelectionRange();
        } else {
          this.lazyValue = val;
          this.$emit('input', this.lazyValue);
        }
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue != null && this.lazyValue.toString().length > 0 || this.badInput || dirtyTypes.includes(this.type);
    },
    isTextarea: function isTextarea() {
      return this.multiLine || this.textarea;
    },
    noResizeHandle: function noResizeHandle() {
      return this.isTextarea && (this.noResize || this.shouldAutoGrow);
    },
    shouldAutoGrow: function shouldAutoGrow() {
      return this.isTextarea && this.autoGrow;
    }
  },

  watch: {
    isFocused: function isFocused(val) {
      if (val) {
        this.initialValue = this.lazyValue;
      } else if (this.initialValue !== this.lazyValue) {
        this.$emit('change', this.lazyValue);
      }
    },
    value: function value(val) {
      var _this = this;

      if (this.mask && !this.internalChange) {
        var masked = this.maskText(this.unmaskText(val));
        this.lazyValue = this.unmaskText(masked);

        // Emit when the externally set value was modified internally
        String(val) !== this.lazyValue && this.$nextTick(function () {
          _this.$refs.input.value = masked;
          _this.$emit('input', _this.lazyValue);
        });
      } else this.lazyValue = val;

      if (this.internalChange) this.internalChange = false;

      !this.validateOnBlur && this.validate();
      this.shouldAutoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    this.shouldAutoGrow && this.calculateInputHeight();
    this.autofocus && this.focus();
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input ? _this2.$refs.input.scrollHeight : 0;
        var minHeight = parseInt(_this2.rows, 10) * parseFloat(_this2.rowHeight);
        _this2.inputHeight = Math.max(minHeight, height);
      });
    },
    onInput: function onInput(e) {
      this.mask && this.resetSelections(e.target);
      this.inputValue = e.target.value;
      this.badInput = e.target.validity && e.target.validity.badInput;
      this.shouldAutoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.isFocused = false;
      // Reset internalChange state
      // to allow external change
      // to persist
      this.internalChange = false;

      this.$nextTick(function () {
        _this3.validate();
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      if (!this.$refs.input) return;

      this.isFocused = true;
      if (document.activeElement !== this.$refs.input) {
        this.$refs.input.focus();
      }
      this.$emit('focus', e);
    },
    keyDown: function keyDown(e) {
      // Prevents closing of a
      // dialog when pressing
      // enter
      if (this.isTextarea && this.isFocused && e.keyCode === 13) {
        e.stopPropagation();
      }

      this.internalChange = true;
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': this.hasError
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.isTextarea ? 'textarea' : 'input';
      var listeners = Object.assign({}, this.$listeners);
      delete listeners['change']; // Change should not be bound externally

      var data = {
        style: {},
        domProps: {
          value: this.maskText(this.lazyValue)
        },
        attrs: _extends({}, this.$attrs, {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          readonly: this.readonly,
          tabindex: this.tabindex,
          'aria-label': (!this.$attrs || !this.$attrs.id) && this.label // Label `for` will be set if we have an id
        }),
        on: Object.assign(listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus,
          keydown: this.keyDown
        }),
        ref: 'input'
      };

      if (this.shouldAutoGrow) {
        data.style.height = this.inputHeight && this.inputHeight + 'px';
      }

      if (this.placeholder) data.attrs.placeholder = this.placeholder;

      if (!this.isTextarea) {
        data.attrs.type = this.type;
      } else {
        data.attrs.rows = this.rows;
      }

      if (this.mask) {
        data.attrs.maxlength = this.masked.length;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },
    clearableCallback: function clearableCallback() {
      var _this4 = this;

      this.inputValue = null;
      this.$nextTick(function () {
        return _this4.$refs.input.focus();
      });
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTimePicker__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__ = __webpack_require__(69);
/* unused harmony reexport VTimePicker */
/* unused harmony reexport VTimePickerClock */
/* unused harmony reexport VTimePickerTitle */






/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VTimePickerTitle__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTimePicker__["a" /* default */]);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTimePickerTitle__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_picker__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__ = __webpack_require__(22);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Components



// Mixins


// Utils



var rangeHours24 = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["d" /* createRange */])(24);
var rangeHours12am = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["d" /* createRange */])(12);
var rangeHours12pm = rangeHours12am.map(function (v) {
  return v + 12;
});
var rangeMinutes = Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["d" /* createRange */])(60);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      inputHour: null,
      inputMinute: null,
      period: 'am',
      selectingHour: true
    };
  },


  props: {
    allowedHours: Function,
    allowedMinutes: Function,
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    min: String,
    max: String,
    scrollable: Boolean,
    value: null
  },

  computed: {
    isAllowedHourCb: function isAllowedHourCb() {
      var _this = this;

      if (!this.min && !this.max) return this.allowedHours;

      var minHour = this.min ? this.min.split(':')[0] : 0;
      var maxHour = this.max ? this.max.split(':')[0] : 23;

      return function (val) {
        return val >= minHour * 1 && val <= maxHour * 1 && (!_this.allowedHours || _this.allowedHours(val));
      };
    },
    isAllowedMinuteCb: function isAllowedMinuteCb() {
      var _this2 = this;

      var isHourAllowed = !this.allowedHours || this.allowedHours(this.inputHour);
      if (!this.min && !this.max) {
        return isHourAllowed ? this.allowedMinutes : function () {
          return false;
        };
      }

      var _ref = this.min ? this.min.split(':') : [0, 0],
          _ref2 = _slicedToArray(_ref, 2),
          minHour = _ref2[0],
          minMinute = _ref2[1];

      var _ref3 = this.max ? this.max.split(':') : [23, 59],
          _ref4 = _slicedToArray(_ref3, 2),
          maxHour = _ref4[0],
          maxMinute = _ref4[1];

      var minTime = minHour * 60 + minMinute * 1;
      var maxTime = maxHour * 60 + maxMinute * 1;

      return function (val) {
        var time = 60 * _this2.inputHour + val;
        return time >= minTime && time <= maxTime && isHourAllowed && (!_this2.allowedMinutes || _this2.allowedMinutes(val));
      };
    },
    isAmPm: function isAmPm() {
      return this.format === 'ampm';
    }
  },

  watch: {
    value: 'setInputData'
  },

  methods: {
    emitValue: function emitValue() {
      if (this.inputHour != null && this.inputMinute != null) {
        this.$emit('input', Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(this.inputHour) + ':' + Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(this.inputMinute));
      }
    },
    setPeriod: function setPeriod(period) {
      this.period = period;
      if (this.inputHour != null) {
        var newHour = this.inputHour + (period === 'am' ? -12 : 12);
        this.inputHour = this.firstAllowed('hour', newHour);
        this.emitValue();
      }
    },
    setInputData: function setInputData(value) {
      if (value == null) {
        this.inputHour = null;
        this.inputMinute = null;
        return;
      }

      if (value instanceof Date) {
        this.inputHour = value.getHours();
        this.inputMinute = value.getMinutes();
      } else {
        var _ref5 = value.trim().toLowerCase().match(/^(\d+):(\d+)(:\d+)?([ap]m)?$/, '') || [],
            _ref6 = _slicedToArray(_ref5, 5),
            hour = _ref6[1],
            minute = _ref6[2],
            period = _ref6[4];

        this.inputHour = period ? this.convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
        this.inputMinute = parseInt(minute, 10);
      }

      this.period = this.inputHour < 12 ? 'am' : 'pm';
    },
    convert24to12: function convert24to12(hour) {
      return hour ? (hour - 1) % 12 + 1 : 12;
    },
    convert12to24: function convert12to24(hour, period) {
      return hour % 12 + (period === 'pm' ? 12 : 0);
    },
    onInput: function onInput(value) {
      if (this.selectingHour) {
        this.inputHour = this.isAmPm ? this.convert12to24(value, this.period) : value;
      } else {
        this.inputMinute = value;
      }
      this.emitValue();
    },
    onChange: function onChange() {
      if (!this.selectingHour) {
        this.$emit('change', this.value);
      }

      this.selectingHour = !this.selectingHour;
    },
    firstAllowed: function firstAllowed(type, value) {
      var allowedFn = type === 'hour' ? this.isAllowedHourCb : this.isAllowedMinuteCb;
      if (!allowedFn) return value;

      // TODO: clean up
      var range = type === 'minute' ? rangeMinutes : this.isAmPm ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
      var first = range.find(function (v) {
        return allowedFn((v + value) % range.length + range[0]);
      });
      return ((first || 0) + value) % range.length + range[0];
    },
    genClock: function genClock() {
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_1__VTimePickerClock__["a" /* default */], {
        props: {
          allowedValues: this.selectingHour ? this.isAllowedHourCb : this.isAllowedMinuteCb,
          color: this.color,
          dark: this.dark,
          double: this.selectingHour && !this.isAmPm,
          format: this.selectingHour ? this.isAmPm ? this.convert24to12 : function (val) {
            return val;
          } : function (val) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__VDatePicker_util_pad__["a" /* default */])(val, 2);
          },
          max: this.selectingHour ? this.isAmPm && this.period === 'am' ? 11 : 23 : 59,
          min: this.selectingHour && this.isAmPm && this.period === 'pm' ? 12 : 0,
          scrollable: this.scrollable,
          size: this.width - (!this.fullWidth && this.landscape ? 80 : 20),
          step: this.selectingHour ? 1 : 5,
          value: this.selectingHour ? this.inputHour : this.inputMinute
        },
        on: {
          input: this.onInput,
          change: this.onChange
        },
        ref: 'clock'
      });
    },
    genPickerBody: function genPickerBody() {
      return this.$createElement('div', {
        staticClass: 'time-picker-clock__container',
        style: {
          width: this.width + 'px',
          height: this.width - (!this.fullWidth && this.landscape ? 60 : 0) + 'px'
        },
        key: this.selectingHour
      }, [this.genClock()]);
    },
    genPickerTitle: function genPickerTitle() {
      var _this3 = this;

      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__VTimePickerTitle__["a" /* default */], {
        props: {
          ampm: this.isAmPm,
          hour: this.inputHour,
          minute: this.inputMinute,
          period: this.period,
          selectingHour: this.selectingHour
        },
        on: {
          'update:selectingHour': function updateSelectingHour(value) {
            return _this3.selectingHour = value;
          },
          'update:period': this.setPeriod
        },
        ref: 'title',
        slot: 'title'
      });
    }
  },

  mounted: function mounted() {
    this.setInputData(this.value);
  },
  render: function render(h) {
    return this.genPicker('picker--time');
  }
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VToolbarTitle */
/* unused harmony export VToolbarItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VToolbar__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__ = __webpack_require__(254);
/* unused harmony reexport VToolbar */
/* unused harmony reexport VToolbarSideIcon */





var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleFunctional */])('toolbar__items');



/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */]);
  Vue.component(VToolbarItems.name, VToolbarItems);
  Vue.component(VToolbarTitle.name, VToolbarTitle);
  Vue.component(__WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__VToolbarSideIcon__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__VToolbar__["a" /* default */]);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_toolbar_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ssr_bootable__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_scroll__ = __webpack_require__(71);
// Styles


// Mixins





// Directives


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_applicationable__["a" /* default */])('top', ['clippedLeft', 'clippedRight', 'computedHeight', 'invertedScroll', 'manualScroll']), __WEBPACK_IMPORTED_MODULE_2__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_ssr_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  directives: { Scroll: __WEBPACK_IMPORTED_MODULE_5__directives_scroll__["a" /* default */] },

  data: function data() {
    return {
      activeTimeout: null,
      currentScroll: 0,
      heights: {
        mobileLandscape: 48,
        mobile: 56,
        desktop: 64,
        dense: 48
      },
      isActive: true,
      isExtended: false,
      isScrollingUp: false,
      previousScroll: null,
      previousScrollDirection: null,
      savedScroll: 0,
      target: null
    };
  },

  props: {
    card: Boolean,
    clippedLeft: Boolean,
    clippedRight: Boolean,
    dense: Boolean,
    extended: Boolean,
    extensionHeight: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    flat: Boolean,
    floating: Boolean,
    height: {
      type: [Number, String],
      validator: function validator(v) {
        return !isNaN(parseInt(v));
      }
    },
    invertedScroll: Boolean,
    manualScroll: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshold: {
      type: Number,
      default: 300
    },
    tabs: Boolean
  },

  computed: {
    computedContentHeight: function computedContentHeight() {
      if (this.height) return parseInt(this.height);
      if (this.dense) return this.heights.dense;

      if (this.prominent || this.$vuetify.breakpoint.mdAndUp) return this.heights.desktop;

      if (this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height) return this.heights.mobileLandscape;

      return this.heights.mobile;
    },
    computedExtensionHeight: function computedExtensionHeight() {
      if (this.tabs) return 48;
      if (this.extensionHeight) return parseInt(this.extensionHeight);

      return this.computedContentHeight;
    },
    computedHeight: function computedHeight() {
      if (!this.isExtended) return this.computedContentHeight;

      return this.computedContentHeight + this.computedExtensionHeight;
    },
    computedMarginTop: function computedMarginTop() {
      if (!this.app) return 0;

      return this.$vuetify.application.bar;
    },
    classes: function classes() {
      return this.addBackgroundColorClassChecks({
        'toolbar': true,
        'elevation-0': this.flat || !this.isActive && !this.tabs,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--clipped': this.clippedLeft || this.clippedRight,
        'toolbar--dense': this.dense,
        'toolbar--extended': this.isExtended,
        'toolbar--fixed': !this.absolute && (this.app || this.fixed),
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'theme--dark': this.dark,
        'theme--light': this.light
      });
    },
    computedPaddingLeft: function computedPaddingLeft() {
      if (!this.app || this.clippedLeft) return 0;

      return this.$vuetify.application.left;
    },
    computedPaddingRight: function computedPaddingRight() {
      if (!this.app || this.clippedRight) return 0;

      return this.$vuetify.application.right;
    },
    computedTransform: function computedTransform() {
      return !this.isActive ? -this.computedHeight : 0;
    },
    currentThreshold: function currentThreshold() {
      return Math.abs(this.currentScroll - this.savedScroll);
    },
    styles: function styles() {
      return {
        marginTop: this.computedMarginTop + 'px',
        paddingRight: this.computedPaddingRight + 'px',
        paddingLeft: this.computedPaddingLeft + 'px',
        transform: 'translateY(' + this.computedTransform + 'px)'
      };
    }
  },

  watch: {
    currentThreshold: function currentThreshold(val) {
      if (this.invertedScroll) {
        return this.isActive = this.currentScroll > this.scrollThreshold;
      }

      if (val < this.scrollThreshold || !this.isBooted) return;

      this.isActive = this.isScrollingUp;
      this.savedScroll = this.currentScroll;
    },
    isActive: function isActive() {
      this.savedScroll = 0;
    },
    invertedScroll: function invertedScroll(val) {
      this.isActive = !val;
    },
    manualScroll: function manualScroll(val) {
      this.isActive = !val;
    },
    isScrollingUp: function isScrollingUp(val) {
      this.savedScroll = this.savedScroll || this.currentScroll;
    }
  },

  created: function created() {
    if (this.invertedScroll || this.manualScroll) this.isActive = false;
  },
  mounted: function mounted() {
    if (this.scrollTarget) {
      this.target = document.querySelector(this.scrollTarget);
    }
  },


  methods: {
    onScroll: function onScroll() {
      if (!this.scrollOffScreen || this.manualScroll || typeof window === 'undefined') return;

      var target = this.target || window;

      this.currentScroll = this.scrollTarget ? target.scrollTop : target.pageYOffset || document.documentElement.scrollTop;

      this.isScrollingUp = this.currentScroll < this.previousScroll;

      this.previousScroll = this.currentScroll;
    },

    /**
     * Update the application layout
     *
     * @return {number}
     */
    updateApplication: function updateApplication() {
      return this.invertedScroll || this.manualScroll ? 0 : this.computedHeight;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;

    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    data.directives = [{
      arg: this.scrollTarget,
      name: 'scroll',
      value: this.onScroll
    }];

    children.push(h('div', {
      staticClass: 'toolbar__content',
      style: { height: this.computedContentHeight + 'px' },
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        staticClass: 'toolbar__extension',
        style: { height: this.computedExtensionHeight + 'px' }
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_VBtn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props,
        data = _ref.data;

    var classes = data.staticClass ? data.staticClass + ' toolbar__side-icon' : 'toolbar__side-icon';

    var d = Object.assign(data, {
      staticClass: classes,
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    });

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_VBtn__["a" /* default */], d, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTooltip__ = __webpack_require__(256);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */].install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VTooltip__["a" /* default */]);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stylus_components_tooltips_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_delayable__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_dependent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_detachable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_menuable__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Mixins







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tooltip',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_delayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_dependent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_menuable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      calculatedMinWidth: 0,
      closeDependents: false
    };
  },

  props: {
    debounce: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    fixed: {
      type: Boolean,
      default: true
    },
    openDelay: {
      type: [Number, String],
      default: 200
    },
    tag: {
      type: String,
      default: 'span'
    },
    transition: String,
    zIndex: {
      default: null
    }
  },

  computed: {
    calculatedLeft: function calculatedLeft() {
      var _dimensions = this.dimensions,
          activator = _dimensions.activator,
          content = _dimensions.content;

      var unknown = !this.bottom && !this.left && !this.top && !this.right;
      var left = 0;

      if (this.top || this.bottom || unknown) {
        left = activator.left + activator.width / 2 - content.width / 2;
      } else if (this.left || this.right) {
        left = activator.left + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
      }

      return this.calcXOverflow(left) + 'px';
    },
    calculatedTop: function calculatedTop() {
      var _dimensions2 = this.dimensions,
          activator = _dimensions2.activator,
          content = _dimensions2.content;

      var top = 0;

      if (this.top || this.bottom) {
        top = activator.top + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
      } else if (this.left || this.right) {
        top = activator.top + activator.height / 2 - content.height / 2;
      }

      return this.calcYOverflow(top + this.pageYOffset) + 'px';
    },
    classes: function classes() {
      return {
        'tooltip--top': this.top,
        'tooltip--right': this.right,
        'tooltip--bottom': this.bottom,
        'tooltip--left': this.left
      };
    },
    computedTransition: function computedTransition() {
      if (this.transition) return this.transition;
      if (this.top) return 'slide-y-reverse-transition';
      if (this.right) return 'slide-x-transition';
      if (this.bottom) return 'slide-y-transition';
      if (this.left) return 'slide-x-reverse-transition';
    },
    offsetY: function offsetY() {
      return this.top || this.bottom;
    },
    offsetX: function offsetX() {
      return this.left || this.right;
    },
    styles: function styles() {
      return {
        left: this.calculatedLeft,
        maxWidth: isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + 'px',
        opacity: this.isActive ? 0.9 : 0,
        top: this.calculatedTop,
        zIndex: this.zIndex || this.activeZIndex
      };
    }
  },

  methods: {
    activate: function activate() {
      // Update coordinates and dimensions of menu
      // and its activator
      this.updateDimensions();
      // Start the transition
      requestAnimationFrame(this.startTransition);
    }
  },

  mounted: function mounted() {
    this.value && this.callActivate();
  },
  render: function render(h) {
    var _addBackgroundColorCl,
        _this = this;

    var tooltip = h('div', {
      staticClass: 'tooltip__content',
      'class': this.addBackgroundColorClassChecks((_addBackgroundColorCl = {}, _defineProperty(_addBackgroundColorCl, this.contentClass, true), _defineProperty(_addBackgroundColorCl, 'menuable__content__active', this.isActive), _addBackgroundColorCl)),
      style: this.styles,
      attrs: this.attrs,
      directives: [{
        name: 'show',
        value: this.isContentActive
      }],
      ref: 'content'
    }, this.$slots.default);

    return h(this.tag, {
      staticClass: 'tooltip',
      'class': this.classes
    }, [h('transition', {
      props: {
        name: this.computedTransition
      }
    }, [tooltip]), h('span', {
      on: this.disabled ? {} : {
        mouseenter: function mouseenter() {
          _this.runDelay('open', function () {
            return _this.isActive = true;
          });
        },
        mouseleave: function mouseleave() {
          _this.runDelay('close', function () {
            return _this.isActive = false;
          });
        }
      },
      ref: 'activator'
    }, this.$slots.activator)]);
  }
});

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__click_outside__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resize__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ripple__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scroll__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__touch__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_0__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_2__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_1__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_3__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_4__touch__["a"]; });








function install(Vue) {
  Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0__click_outside__["a" /* default */]);
  Vue.directive('ripple', __WEBPACK_IMPORTED_MODULE_2__ripple__["a" /* default */]);
  Vue.directive('resize', __WEBPACK_IMPORTED_MODULE_1__resize__["a" /* default */]);
  Vue.directive('scroll', __WEBPACK_IMPORTED_MODULE_3__scroll__["a" /* default */]);
  Vue.directive('touch', __WEBPACK_IMPORTED_MODULE_4__touch__["a" /* default */]);
}

/***/ })
/******/ ])["default"];
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = {"url":"https://ship-zone.com","filePath":"https://ship-zone.com"}

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _print = __webpack_require__(1274);

var _print2 = _interopRequireDefault(_print);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_print2.default.install = function (Vue) {
  Vue.directive('print', _print2.default);
};

exports.default = _print2.default;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _printarea = __webpack_require__(1275);

var _printarea2 = _interopRequireDefault(_printarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  directiveName: 'print',
  bind: function bind(el, binding, vnode) {
    var vue = vnode.context;
    var closeBtn = true;
    el.addEventListener('click', function (event) {
      if (binding.value) {
        localPrint();
      } else {
        window.print();
      }
    });

    var localPrint = function localPrint() {
      vue.$nextTick(function () {
        if (closeBtn) {
          closeBtn = false;
          var print = new _printarea2.default({
            el: binding.value,
            endCallback: function endCallback() {
              closeBtn = true;
            }
          });
        }
      });
    };
  },
  update: function update(el, binding) {},
  unbind: function unbind(el) {}
};

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1276);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1301);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1302);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function () {
  function _class(option) {
    (0, _classCallCheck3.default)(this, _class);

    this.standards = {
      strict: 'strict',
      loose: 'loose',
      html5: 'html5'
    };
    this.counter = 0;
    this.settings = {
      standard: this.standards.html5,
      extraHead: '',
      extraCss: '',
      popTitle: '',
      endCallback: null,
      el: '' };
    (0, _assign2.default)(this.settings, option);
    this.init();
  }

  (0, _createClass3.default)(_class, [{
    key: 'init',
    value: function init() {
      this.counter++;
      this.settings.id = 'printArea_' + this.counter;
      var box = document.getElementById(this.settings.id);
      if (box) {
        box.parentNode.removeChild(box);
      }
      var PrintAreaWindow = this.getPrintWindow();
      this.write(PrintAreaWindow.doc);
      this.print(PrintAreaWindow);
      this.settings.endCallback();
    }
  }, {
    key: 'print',
    value: function print(PAWindow) {
      var paWindow = PAWindow.win;
      paWindow.onload = function () {
        paWindow.focus();
        paWindow.print();
      };
    }
  }, {
    key: 'write',
    value: function write(PADocument, $ele) {
      PADocument.open();
      PADocument.write(this.docType() + '<html>' + this.getHead() + this.getBody() + '</html>');
      PADocument.close();
    }
  }, {
    key: 'docType',
    value: function docType() {
      if (this.settings.standard === this.standards.html5) {
        return '<!DOCTYPE html>';
      }
      var transitional = this.settings.standard === this.standards.loose ? ' Transitional' : '';
      var dtd = this.settings.standard === this.standards.loose ? 'loose' : 'strict';

      return '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01' + transitional + '//EN" "http://www.w3.org/TR/html4/' + dtd + '.dtd">';
    }
  }, {
    key: 'getHead',
    value: function getHead() {
      var extraHead = '';
      var links = '';
      var style = '';
      if (this.settings.extraHead) {
        this.settings.extraHead.replace(/([^,]+)/g, function (m) {
          extraHead += m;
        });
      }
      document.querySelectorAll('link').forEach(function (item, i) {
        if (item.href.indexOf('.css') >= 0) {
          links += '<link type="text/css" rel="stylesheet" href="' + item.href + '" >';
        }
      });
      for (var i = 0; i < document.styleSheets.length; i++) {
        var rules = document.styleSheets[i].cssRules || document.styleSheets[i].rules;
        for (var b = 0; b < rules.length; b++) {
          style += rules[b].cssText;
        }
      }

      if (this.settings.extraCss) {
        this.settings.extraCss.replace(/([^,\s]+)/g, function (m) {
          links += '<link type="text/css" rel="stylesheet" href="' + m + '">';
        });
      }

      return '<head><title>' + this.settings.popTitle + '</title>' + extraHead + links + '<style type="text/css">' + style + '</style></head>';
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      var ele = this.getFormData(document.querySelector(this.settings.el));
      var htm = ele.outerHTML;
      console.log('htm', htm);
      return '<body>' + htm + '</body>';
    }
  }, {
    key: 'getFormData',
    value: function getFormData(ele) {
      var copy = ele.cloneNode(true);
      var copiedInputs = copy.querySelectorAll('input,select,textarea');

      copiedInputs.forEach(function (item, i) {
        var typeInput = item.getAttribute('type');
        var copiedInput = copiedInputs[i];
        if (typeInput === undefined) {
          typeInput = item.tagName === 'SELECT' ? 'select' : item.tagName === 'TEXTAREA' ? 'textarea' : '';
        }
        if (typeInput === 'radio' || typeInput === 'checkbox') {

          copiedInput.setAttribute('checked', item.checked);
        } else if (typeInput === 'text' || typeInput === '') {
          copiedInput.value = item.value;
          copiedInput.setAttribute('value', item.value);
        } else if (typeInput === 'select') {
          copiedInput.querySelectorAll('option').forEach(function (op, b) {
            if (op.selected) {
              op.setAttribute('selected', true);
            };
          });
        } else if (typeInput === 'textarea') {
          copiedInput.value = item.value;
          copiedInput.setAttribute('value', item.value);
        }
      });
      return copy;
    }
  }, {
    key: 'getPrintWindow',
    value: function getPrintWindow() {
      var f = this.Iframe();
      return {
        win: f.contentWindow || f,
        doc: f.doc
      };
    }
  }, {
    key: 'Iframe',
    value: function Iframe() {
      var frameId = this.settings.id;
      var iframe = void 0;

      try {
        iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.style.border = '0px';
        iframe.style.position = 'absolute';
        iframe.style.width = '0px';
        iframe.style.height = '0px';
        iframe.style.right = '0px';
        iframe.style.top = '0px';
        iframe.setAttribute('id', frameId);
        iframe.setAttribute('src', new Date().getTime());
        iframe.doc = null;
        iframe.doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow ? iframe.contentWindow.document : iframe.document;
      } catch (e) {
        throw new Error(e + '. iframes may not be supported in this browser.');
      }

      if (iframe.doc == null) {
        throw new Error('Cannot find document.');
      }

      return iframe;
    }
  }]);
  return _class;
}();

exports.default = _class;
;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1277), __esModule: true };

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1278);
module.exports = __webpack_require__(33).Object.assign;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(405);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1287) });


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1280);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(406);
var createDesc = __webpack_require__(1286);
module.exports = __webpack_require__(24) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24) && !__webpack_require__(35)(function () {
  return Object.defineProperty(__webpack_require__(1284)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
var document = __webpack_require__(32).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(34);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(1288);
var gOPS = __webpack_require__(1298);
var pIE = __webpack_require__(1299);
var toObject = __webpack_require__(1300);
var IObject = __webpack_require__(409);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(35)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1289);
var enumBugKeys = __webpack_require__(1297);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(407);
var toIObject = __webpack_require__(408);
var arrayIndexOf = __webpack_require__(1291)(false);
var IE_PROTO = __webpack_require__(1294)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(408);
var toLength = __webpack_require__(1292);
var toAbsoluteIndex = __webpack_require__(1293);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(411);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(411);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(1295)('keys');
var uid = __webpack_require__(1296);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(32);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 1297 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1299 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(410);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1303);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1304), __esModule: true };

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1305);
var $Object = __webpack_require__(33).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(405);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(406).f });


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendors__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(1823);



const VuePlugin = {
    install: function (Vue) {
        if (VuePlugin.installed) {
            return;
        }
        VuePlugin.installed = true;
        Vue.component('flag', __WEBPACK_IMPORTED_MODULE_1__components__["a" /* Flag */]);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(VuePlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__);


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1bf66100", content, true, {});

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1310);
exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".flag-icon,.flag-icon-background{background-size:contain;background-position:50%;background-repeat:no-repeat}.flag-icon{position:relative;display:inline-block;width:1.33333333em;line-height:1em}.flag-icon:before{content:\"\\A0\"}.flag-icon.flag-icon-squared{width:1em}.flag-icon-ad{background-image:url(" + escape(__webpack_require__(1311)) + ")}.flag-icon-ad.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1312)) + ")}.flag-icon-ae{background-image:url(" + escape(__webpack_require__(1313)) + ")}.flag-icon-ae.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1314)) + ")}.flag-icon-af{background-image:url(" + escape(__webpack_require__(1315)) + ")}.flag-icon-af.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1316)) + ")}.flag-icon-ag{background-image:url(" + escape(__webpack_require__(1317)) + ")}.flag-icon-ag.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1318)) + ")}.flag-icon-ai{background-image:url(" + escape(__webpack_require__(1319)) + ")}.flag-icon-ai.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1320)) + ")}.flag-icon-al{background-image:url(" + escape(__webpack_require__(1321)) + ")}.flag-icon-al.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1322)) + ")}.flag-icon-am{background-image:url(" + escape(__webpack_require__(1323)) + ")}.flag-icon-am.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1324)) + ")}.flag-icon-ao{background-image:url(" + escape(__webpack_require__(1325)) + ")}.flag-icon-ao.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1326)) + ")}.flag-icon-aq{background-image:url(" + escape(__webpack_require__(1327)) + ")}.flag-icon-aq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1328)) + ")}.flag-icon-ar{background-image:url(" + escape(__webpack_require__(1329)) + ")}.flag-icon-ar.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1330)) + ")}.flag-icon-as{background-image:url(" + escape(__webpack_require__(1331)) + ")}.flag-icon-as.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1332)) + ")}.flag-icon-at{background-image:url(" + escape(__webpack_require__(1333)) + ")}.flag-icon-at.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1334)) + ")}.flag-icon-au{background-image:url(" + escape(__webpack_require__(1335)) + ")}.flag-icon-au.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1336)) + ")}.flag-icon-aw{background-image:url(" + escape(__webpack_require__(1337)) + ")}.flag-icon-aw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1338)) + ")}.flag-icon-ax{background-image:url(" + escape(__webpack_require__(1339)) + ")}.flag-icon-ax.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1340)) + ")}.flag-icon-az{background-image:url(" + escape(__webpack_require__(1341)) + ")}.flag-icon-az.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1342)) + ")}.flag-icon-ba{background-image:url(" + escape(__webpack_require__(1343)) + ")}.flag-icon-ba.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1344)) + ")}.flag-icon-bb{background-image:url(" + escape(__webpack_require__(1345)) + ")}.flag-icon-bb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1346)) + ")}.flag-icon-bd{background-image:url(" + escape(__webpack_require__(1347)) + ")}.flag-icon-bd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1348)) + ")}.flag-icon-be{background-image:url(" + escape(__webpack_require__(1349)) + ")}.flag-icon-be.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1350)) + ")}.flag-icon-bf{background-image:url(" + escape(__webpack_require__(1351)) + ")}.flag-icon-bf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1352)) + ")}.flag-icon-bg{background-image:url(" + escape(__webpack_require__(1353)) + ")}.flag-icon-bg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1354)) + ")}.flag-icon-bh{background-image:url(" + escape(__webpack_require__(1355)) + ")}.flag-icon-bh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1356)) + ")}.flag-icon-bi{background-image:url(" + escape(__webpack_require__(1357)) + ")}.flag-icon-bi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1358)) + ")}.flag-icon-bj{background-image:url(" + escape(__webpack_require__(1359)) + ")}.flag-icon-bj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1360)) + ")}.flag-icon-bl{background-image:url(" + escape(__webpack_require__(1361)) + ")}.flag-icon-bl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1362)) + ")}.flag-icon-bm{background-image:url(" + escape(__webpack_require__(1363)) + ")}.flag-icon-bm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1364)) + ")}.flag-icon-bn{background-image:url(" + escape(__webpack_require__(1365)) + ")}.flag-icon-bn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1366)) + ")}.flag-icon-bo{background-image:url(" + escape(__webpack_require__(1367)) + ")}.flag-icon-bo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1368)) + ")}.flag-icon-bq{background-image:url(" + escape(__webpack_require__(1369)) + ")}.flag-icon-bq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1370)) + ")}.flag-icon-br{background-image:url(" + escape(__webpack_require__(1371)) + ")}.flag-icon-br.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1372)) + ")}.flag-icon-bs{background-image:url(" + escape(__webpack_require__(1373)) + ")}.flag-icon-bs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1374)) + ")}.flag-icon-bt{background-image:url(" + escape(__webpack_require__(1375)) + ")}.flag-icon-bt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1376)) + ")}.flag-icon-bv{background-image:url(" + escape(__webpack_require__(1377)) + ")}.flag-icon-bv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1378)) + ")}.flag-icon-bw{background-image:url(" + escape(__webpack_require__(1379)) + ")}.flag-icon-bw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1380)) + ")}.flag-icon-by{background-image:url(" + escape(__webpack_require__(1381)) + ")}.flag-icon-by.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1382)) + ")}.flag-icon-bz{background-image:url(" + escape(__webpack_require__(1383)) + ")}.flag-icon-bz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1384)) + ")}.flag-icon-ca{background-image:url(" + escape(__webpack_require__(1385)) + ")}.flag-icon-ca.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1386)) + ")}.flag-icon-cc{background-image:url(" + escape(__webpack_require__(1387)) + ")}.flag-icon-cc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1388)) + ")}.flag-icon-cd{background-image:url(" + escape(__webpack_require__(1389)) + ")}.flag-icon-cd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1390)) + ")}.flag-icon-cf{background-image:url(" + escape(__webpack_require__(1391)) + ")}.flag-icon-cf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1392)) + ")}.flag-icon-cg{background-image:url(" + escape(__webpack_require__(1393)) + ")}.flag-icon-cg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1394)) + ")}.flag-icon-ch{background-image:url(" + escape(__webpack_require__(1395)) + ")}.flag-icon-ch.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1396)) + ")}.flag-icon-ci{background-image:url(" + escape(__webpack_require__(1397)) + ")}.flag-icon-ci.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1398)) + ")}.flag-icon-ck{background-image:url(" + escape(__webpack_require__(1399)) + ")}.flag-icon-ck.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1400)) + ")}.flag-icon-cl{background-image:url(" + escape(__webpack_require__(1401)) + ")}.flag-icon-cl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1402)) + ")}.flag-icon-cm{background-image:url(" + escape(__webpack_require__(1403)) + ")}.flag-icon-cm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1404)) + ")}.flag-icon-cn{background-image:url(" + escape(__webpack_require__(1405)) + ")}.flag-icon-cn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1406)) + ")}.flag-icon-co{background-image:url(" + escape(__webpack_require__(1407)) + ")}.flag-icon-co.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1408)) + ")}.flag-icon-cr{background-image:url(" + escape(__webpack_require__(1409)) + ")}.flag-icon-cr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1410)) + ")}.flag-icon-cu{background-image:url(" + escape(__webpack_require__(1411)) + ")}.flag-icon-cu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1412)) + ")}.flag-icon-cv{background-image:url(" + escape(__webpack_require__(1413)) + ")}.flag-icon-cv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1414)) + ")}.flag-icon-cw{background-image:url(" + escape(__webpack_require__(1415)) + ")}.flag-icon-cw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1416)) + ")}.flag-icon-cx{background-image:url(" + escape(__webpack_require__(1417)) + ")}.flag-icon-cx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1418)) + ")}.flag-icon-cy{background-image:url(" + escape(__webpack_require__(1419)) + ")}.flag-icon-cy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1420)) + ")}.flag-icon-cz{background-image:url(" + escape(__webpack_require__(1421)) + ")}.flag-icon-cz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1422)) + ")}.flag-icon-de{background-image:url(" + escape(__webpack_require__(1423)) + ")}.flag-icon-de.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1424)) + ")}.flag-icon-dj{background-image:url(" + escape(__webpack_require__(1425)) + ")}.flag-icon-dj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1426)) + ")}.flag-icon-dk{background-image:url(" + escape(__webpack_require__(1427)) + ")}.flag-icon-dk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1428)) + ")}.flag-icon-dm{background-image:url(" + escape(__webpack_require__(1429)) + ")}.flag-icon-dm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1430)) + ")}.flag-icon-do{background-image:url(" + escape(__webpack_require__(1431)) + ")}.flag-icon-do.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1432)) + ")}.flag-icon-dz{background-image:url(" + escape(__webpack_require__(1433)) + ")}.flag-icon-dz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1434)) + ")}.flag-icon-ec{background-image:url(" + escape(__webpack_require__(1435)) + ")}.flag-icon-ec.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1436)) + ")}.flag-icon-ee{background-image:url(" + escape(__webpack_require__(1437)) + ")}.flag-icon-ee.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1438)) + ")}.flag-icon-eg{background-image:url(" + escape(__webpack_require__(1439)) + ")}.flag-icon-eg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1440)) + ")}.flag-icon-eh{background-image:url(" + escape(__webpack_require__(1441)) + ")}.flag-icon-eh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1442)) + ")}.flag-icon-er{background-image:url(" + escape(__webpack_require__(1443)) + ")}.flag-icon-er.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1444)) + ")}.flag-icon-es{background-image:url(" + escape(__webpack_require__(1445)) + ")}.flag-icon-es.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1446)) + ")}.flag-icon-et{background-image:url(" + escape(__webpack_require__(1447)) + ")}.flag-icon-et.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1448)) + ")}.flag-icon-fi{background-image:url(" + escape(__webpack_require__(1449)) + ")}.flag-icon-fi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1450)) + ")}.flag-icon-fj{background-image:url(" + escape(__webpack_require__(1451)) + ")}.flag-icon-fj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1452)) + ")}.flag-icon-fk{background-image:url(" + escape(__webpack_require__(1453)) + ")}.flag-icon-fk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1454)) + ")}.flag-icon-fm{background-image:url(" + escape(__webpack_require__(1455)) + ")}.flag-icon-fm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1456)) + ")}.flag-icon-fo{background-image:url(" + escape(__webpack_require__(1457)) + ")}.flag-icon-fo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1458)) + ")}.flag-icon-fr{background-image:url(" + escape(__webpack_require__(1459)) + ")}.flag-icon-fr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1460)) + ")}.flag-icon-ga{background-image:url(" + escape(__webpack_require__(1461)) + ")}.flag-icon-ga.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1462)) + ")}.flag-icon-gb{background-image:url(" + escape(__webpack_require__(1463)) + ")}.flag-icon-gb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1464)) + ")}.flag-icon-gd{background-image:url(" + escape(__webpack_require__(1465)) + ")}.flag-icon-gd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1466)) + ")}.flag-icon-ge{background-image:url(" + escape(__webpack_require__(1467)) + ")}.flag-icon-ge.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1468)) + ")}.flag-icon-gf{background-image:url(" + escape(__webpack_require__(1469)) + ")}.flag-icon-gf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1470)) + ")}.flag-icon-gg{background-image:url(" + escape(__webpack_require__(1471)) + ")}.flag-icon-gg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1472)) + ")}.flag-icon-gh{background-image:url(" + escape(__webpack_require__(1473)) + ")}.flag-icon-gh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1474)) + ")}.flag-icon-gi{background-image:url(" + escape(__webpack_require__(1475)) + ")}.flag-icon-gi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1476)) + ")}.flag-icon-gl{background-image:url(" + escape(__webpack_require__(1477)) + ")}.flag-icon-gl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1478)) + ")}.flag-icon-gm{background-image:url(" + escape(__webpack_require__(1479)) + ")}.flag-icon-gm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1480)) + ")}.flag-icon-gn{background-image:url(" + escape(__webpack_require__(1481)) + ")}.flag-icon-gn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1482)) + ")}.flag-icon-gp{background-image:url(" + escape(__webpack_require__(1483)) + ")}.flag-icon-gp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1484)) + ")}.flag-icon-gq{background-image:url(" + escape(__webpack_require__(1485)) + ")}.flag-icon-gq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1486)) + ")}.flag-icon-gr{background-image:url(" + escape(__webpack_require__(1487)) + ")}.flag-icon-gr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1488)) + ")}.flag-icon-gs{background-image:url(" + escape(__webpack_require__(1489)) + ")}.flag-icon-gs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1490)) + ")}.flag-icon-gt{background-image:url(" + escape(__webpack_require__(1491)) + ")}.flag-icon-gt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1492)) + ")}.flag-icon-gu{background-image:url(" + escape(__webpack_require__(1493)) + ")}.flag-icon-gu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1494)) + ")}.flag-icon-gw{background-image:url(" + escape(__webpack_require__(1495)) + ")}.flag-icon-gw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1496)) + ")}.flag-icon-gy{background-image:url(" + escape(__webpack_require__(1497)) + ")}.flag-icon-gy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1498)) + ")}.flag-icon-hk{background-image:url(" + escape(__webpack_require__(1499)) + ")}.flag-icon-hk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1500)) + ")}.flag-icon-hm{background-image:url(" + escape(__webpack_require__(1501)) + ")}.flag-icon-hm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1502)) + ")}.flag-icon-hn{background-image:url(" + escape(__webpack_require__(1503)) + ")}.flag-icon-hn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1504)) + ")}.flag-icon-hr{background-image:url(" + escape(__webpack_require__(1505)) + ")}.flag-icon-hr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1506)) + ")}.flag-icon-ht{background-image:url(" + escape(__webpack_require__(1507)) + ")}.flag-icon-ht.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1508)) + ")}.flag-icon-hu{background-image:url(" + escape(__webpack_require__(1509)) + ")}.flag-icon-hu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1510)) + ")}.flag-icon-id{background-image:url(" + escape(__webpack_require__(1511)) + ")}.flag-icon-id.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1512)) + ")}.flag-icon-ie{background-image:url(" + escape(__webpack_require__(1513)) + ")}.flag-icon-ie.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1514)) + ")}.flag-icon-il{background-image:url(" + escape(__webpack_require__(1515)) + ")}.flag-icon-il.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1516)) + ")}.flag-icon-im{background-image:url(" + escape(__webpack_require__(1517)) + ")}.flag-icon-im.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1518)) + ")}.flag-icon-in{background-image:url(" + escape(__webpack_require__(1519)) + ")}.flag-icon-in.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1520)) + ")}.flag-icon-io{background-image:url(" + escape(__webpack_require__(1521)) + ")}.flag-icon-io.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1522)) + ")}.flag-icon-iq{background-image:url(" + escape(__webpack_require__(1523)) + ")}.flag-icon-iq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1524)) + ")}.flag-icon-ir{background-image:url(" + escape(__webpack_require__(1525)) + ")}.flag-icon-ir.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1526)) + ")}.flag-icon-is{background-image:url(" + escape(__webpack_require__(1527)) + ")}.flag-icon-is.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1528)) + ")}.flag-icon-it{background-image:url(" + escape(__webpack_require__(1529)) + ")}.flag-icon-it.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1530)) + ")}.flag-icon-je{background-image:url(" + escape(__webpack_require__(1531)) + ")}.flag-icon-je.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1532)) + ")}.flag-icon-jm{background-image:url(" + escape(__webpack_require__(1533)) + ")}.flag-icon-jm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1534)) + ")}.flag-icon-jo{background-image:url(" + escape(__webpack_require__(1535)) + ")}.flag-icon-jo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1536)) + ")}.flag-icon-jp{background-image:url(" + escape(__webpack_require__(1537)) + ")}.flag-icon-jp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1538)) + ")}.flag-icon-ke{background-image:url(" + escape(__webpack_require__(1539)) + ")}.flag-icon-ke.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1540)) + ")}.flag-icon-kg{background-image:url(" + escape(__webpack_require__(1541)) + ")}.flag-icon-kg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1542)) + ")}.flag-icon-kh{background-image:url(" + escape(__webpack_require__(1543)) + ")}.flag-icon-kh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1544)) + ")}.flag-icon-ki{background-image:url(" + escape(__webpack_require__(1545)) + ")}.flag-icon-ki.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1546)) + ")}.flag-icon-km{background-image:url(" + escape(__webpack_require__(1547)) + ")}.flag-icon-km.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1548)) + ")}.flag-icon-kn{background-image:url(" + escape(__webpack_require__(1549)) + ")}.flag-icon-kn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1550)) + ")}.flag-icon-kp{background-image:url(" + escape(__webpack_require__(1551)) + ")}.flag-icon-kp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1552)) + ")}.flag-icon-kr{background-image:url(" + escape(__webpack_require__(1553)) + ")}.flag-icon-kr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1554)) + ")}.flag-icon-kw{background-image:url(" + escape(__webpack_require__(1555)) + ")}.flag-icon-kw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1556)) + ")}.flag-icon-ky{background-image:url(" + escape(__webpack_require__(1557)) + ")}.flag-icon-ky.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1558)) + ")}.flag-icon-kz{background-image:url(" + escape(__webpack_require__(1559)) + ")}.flag-icon-kz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1560)) + ")}.flag-icon-la{background-image:url(" + escape(__webpack_require__(1561)) + ")}.flag-icon-la.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1562)) + ")}.flag-icon-lb{background-image:url(" + escape(__webpack_require__(1563)) + ")}.flag-icon-lb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1564)) + ")}.flag-icon-lc{background-image:url(" + escape(__webpack_require__(1565)) + ")}.flag-icon-lc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1566)) + ")}.flag-icon-li{background-image:url(" + escape(__webpack_require__(1567)) + ")}.flag-icon-li.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1568)) + ")}.flag-icon-lk{background-image:url(" + escape(__webpack_require__(1569)) + ")}.flag-icon-lk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1570)) + ")}.flag-icon-lr{background-image:url(" + escape(__webpack_require__(1571)) + ")}.flag-icon-lr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1572)) + ")}.flag-icon-ls{background-image:url(" + escape(__webpack_require__(1573)) + ")}.flag-icon-ls.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1574)) + ")}.flag-icon-lt{background-image:url(" + escape(__webpack_require__(1575)) + ")}.flag-icon-lt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1576)) + ")}.flag-icon-lu{background-image:url(" + escape(__webpack_require__(1577)) + ")}.flag-icon-lu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1578)) + ")}.flag-icon-lv{background-image:url(" + escape(__webpack_require__(1579)) + ")}.flag-icon-lv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1580)) + ")}.flag-icon-ly{background-image:url(" + escape(__webpack_require__(1581)) + ")}.flag-icon-ly.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1582)) + ")}.flag-icon-ma{background-image:url(" + escape(__webpack_require__(1583)) + ")}.flag-icon-ma.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1584)) + ")}.flag-icon-mc{background-image:url(" + escape(__webpack_require__(1585)) + ")}.flag-icon-mc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1586)) + ")}.flag-icon-md{background-image:url(" + escape(__webpack_require__(1587)) + ")}.flag-icon-md.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1588)) + ")}.flag-icon-me{background-image:url(" + escape(__webpack_require__(1589)) + ")}.flag-icon-me.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1590)) + ")}.flag-icon-mf{background-image:url(" + escape(__webpack_require__(1591)) + ")}.flag-icon-mf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1592)) + ")}.flag-icon-mg{background-image:url(" + escape(__webpack_require__(1593)) + ")}.flag-icon-mg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1594)) + ")}.flag-icon-mh{background-image:url(" + escape(__webpack_require__(1595)) + ")}.flag-icon-mh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1596)) + ")}.flag-icon-mk{background-image:url(" + escape(__webpack_require__(1597)) + ")}.flag-icon-mk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1598)) + ")}.flag-icon-ml{background-image:url(" + escape(__webpack_require__(1599)) + ")}.flag-icon-ml.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1600)) + ")}.flag-icon-mm{background-image:url(" + escape(__webpack_require__(1601)) + ")}.flag-icon-mm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1602)) + ")}.flag-icon-mn{background-image:url(" + escape(__webpack_require__(1603)) + ")}.flag-icon-mn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1604)) + ")}.flag-icon-mo{background-image:url(" + escape(__webpack_require__(1605)) + ")}.flag-icon-mo.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1606)) + ")}.flag-icon-mp{background-image:url(" + escape(__webpack_require__(1607)) + ")}.flag-icon-mp.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1608)) + ")}.flag-icon-mq{background-image:url(" + escape(__webpack_require__(1609)) + ")}.flag-icon-mq.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1610)) + ")}.flag-icon-mr{background-image:url(" + escape(__webpack_require__(1611)) + ")}.flag-icon-mr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1612)) + ")}.flag-icon-ms{background-image:url(" + escape(__webpack_require__(1613)) + ")}.flag-icon-ms.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1614)) + ")}.flag-icon-mt{background-image:url(" + escape(__webpack_require__(1615)) + ")}.flag-icon-mt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1616)) + ")}.flag-icon-mu{background-image:url(" + escape(__webpack_require__(1617)) + ")}.flag-icon-mu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1618)) + ")}.flag-icon-mv{background-image:url(" + escape(__webpack_require__(1619)) + ")}.flag-icon-mv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1620)) + ")}.flag-icon-mw{background-image:url(" + escape(__webpack_require__(1621)) + ")}.flag-icon-mw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1622)) + ")}.flag-icon-mx{background-image:url(" + escape(__webpack_require__(1623)) + ")}.flag-icon-mx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1624)) + ")}.flag-icon-my{background-image:url(" + escape(__webpack_require__(1625)) + ")}.flag-icon-my.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1626)) + ")}.flag-icon-mz{background-image:url(" + escape(__webpack_require__(1627)) + ")}.flag-icon-mz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1628)) + ")}.flag-icon-na{background-image:url(" + escape(__webpack_require__(1629)) + ")}.flag-icon-na.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1630)) + ")}.flag-icon-nc{background-image:url(" + escape(__webpack_require__(1631)) + ")}.flag-icon-nc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1632)) + ")}.flag-icon-ne{background-image:url(" + escape(__webpack_require__(1633)) + ")}.flag-icon-ne.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1634)) + ")}.flag-icon-nf{background-image:url(" + escape(__webpack_require__(1635)) + ")}.flag-icon-nf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1636)) + ")}.flag-icon-ng{background-image:url(" + escape(__webpack_require__(1637)) + ")}.flag-icon-ng.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1638)) + ")}.flag-icon-ni{background-image:url(" + escape(__webpack_require__(1639)) + ")}.flag-icon-ni.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1640)) + ")}.flag-icon-nl{background-image:url(" + escape(__webpack_require__(1641)) + ")}.flag-icon-nl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1642)) + ")}.flag-icon-no{background-image:url(" + escape(__webpack_require__(1643)) + ")}.flag-icon-no.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1644)) + ")}.flag-icon-np{background-image:url(" + escape(__webpack_require__(1645)) + ")}.flag-icon-np.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1646)) + ")}.flag-icon-nr{background-image:url(" + escape(__webpack_require__(1647)) + ")}.flag-icon-nr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1648)) + ")}.flag-icon-nu{background-image:url(" + escape(__webpack_require__(1649)) + ")}.flag-icon-nu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1650)) + ")}.flag-icon-nz{background-image:url(" + escape(__webpack_require__(1651)) + ")}.flag-icon-nz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1652)) + ")}.flag-icon-om{background-image:url(" + escape(__webpack_require__(1653)) + ")}.flag-icon-om.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1654)) + ")}.flag-icon-pa{background-image:url(" + escape(__webpack_require__(1655)) + ")}.flag-icon-pa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1656)) + ")}.flag-icon-pe{background-image:url(" + escape(__webpack_require__(1657)) + ")}.flag-icon-pe.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1658)) + ")}.flag-icon-pf{background-image:url(" + escape(__webpack_require__(1659)) + ")}.flag-icon-pf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1660)) + ")}.flag-icon-pg{background-image:url(" + escape(__webpack_require__(1661)) + ")}.flag-icon-pg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1662)) + ")}.flag-icon-ph{background-image:url(" + escape(__webpack_require__(1663)) + ")}.flag-icon-ph.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1664)) + ")}.flag-icon-pk{background-image:url(" + escape(__webpack_require__(1665)) + ")}.flag-icon-pk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1666)) + ")}.flag-icon-pl{background-image:url(" + escape(__webpack_require__(1667)) + ")}.flag-icon-pl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1668)) + ")}.flag-icon-pm{background-image:url(" + escape(__webpack_require__(1669)) + ")}.flag-icon-pm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1670)) + ")}.flag-icon-pn{background-image:url(" + escape(__webpack_require__(1671)) + ")}.flag-icon-pn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1672)) + ")}.flag-icon-pr{background-image:url(" + escape(__webpack_require__(1673)) + ")}.flag-icon-pr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1674)) + ")}.flag-icon-ps{background-image:url(" + escape(__webpack_require__(1675)) + ")}.flag-icon-ps.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1676)) + ")}.flag-icon-pt{background-image:url(" + escape(__webpack_require__(1677)) + ")}.flag-icon-pt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1678)) + ")}.flag-icon-pw{background-image:url(" + escape(__webpack_require__(1679)) + ")}.flag-icon-pw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1680)) + ")}.flag-icon-py{background-image:url(" + escape(__webpack_require__(1681)) + ")}.flag-icon-py.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1682)) + ")}.flag-icon-qa{background-image:url(" + escape(__webpack_require__(1683)) + ")}.flag-icon-qa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1684)) + ")}.flag-icon-re{background-image:url(" + escape(__webpack_require__(1685)) + ")}.flag-icon-re.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1686)) + ")}.flag-icon-ro{background-image:url(" + escape(__webpack_require__(1687)) + ")}.flag-icon-ro.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1688)) + ")}.flag-icon-rs{background-image:url(" + escape(__webpack_require__(1689)) + ")}.flag-icon-rs.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1690)) + ")}.flag-icon-ru{background-image:url(" + escape(__webpack_require__(1691)) + ")}.flag-icon-ru.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1692)) + ")}.flag-icon-rw{background-image:url(" + escape(__webpack_require__(1693)) + ")}.flag-icon-rw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1694)) + ")}.flag-icon-sa{background-image:url(" + escape(__webpack_require__(1695)) + ")}.flag-icon-sa.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1696)) + ")}.flag-icon-sb{background-image:url(" + escape(__webpack_require__(1697)) + ")}.flag-icon-sb.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1698)) + ")}.flag-icon-sc{background-image:url(" + escape(__webpack_require__(1699)) + ")}.flag-icon-sc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1700)) + ")}.flag-icon-sd{background-image:url(" + escape(__webpack_require__(1701)) + ")}.flag-icon-sd.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1702)) + ")}.flag-icon-se{background-image:url(" + escape(__webpack_require__(1703)) + ")}.flag-icon-se.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1704)) + ")}.flag-icon-sg{background-image:url(" + escape(__webpack_require__(1705)) + ")}.flag-icon-sg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1706)) + ")}.flag-icon-sh{background-image:url(" + escape(__webpack_require__(1707)) + ")}.flag-icon-sh.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1708)) + ")}.flag-icon-si{background-image:url(" + escape(__webpack_require__(1709)) + ")}.flag-icon-si.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1710)) + ")}.flag-icon-sj{background-image:url(" + escape(__webpack_require__(1711)) + ")}.flag-icon-sj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1712)) + ")}.flag-icon-sk{background-image:url(" + escape(__webpack_require__(1713)) + ")}.flag-icon-sk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1714)) + ")}.flag-icon-sl{background-image:url(" + escape(__webpack_require__(1715)) + ")}.flag-icon-sl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1716)) + ")}.flag-icon-sm{background-image:url(" + escape(__webpack_require__(1717)) + ")}.flag-icon-sm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1718)) + ")}.flag-icon-sn{background-image:url(" + escape(__webpack_require__(1719)) + ")}.flag-icon-sn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1720)) + ")}.flag-icon-so{background-image:url(" + escape(__webpack_require__(1721)) + ")}.flag-icon-so.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1722)) + ")}.flag-icon-sr{background-image:url(" + escape(__webpack_require__(1723)) + ")}.flag-icon-sr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1724)) + ")}.flag-icon-ss{background-image:url(" + escape(__webpack_require__(1725)) + ")}.flag-icon-ss.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1726)) + ")}.flag-icon-st{background-image:url(" + escape(__webpack_require__(1727)) + ")}.flag-icon-st.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1728)) + ")}.flag-icon-sv{background-image:url(" + escape(__webpack_require__(1729)) + ")}.flag-icon-sv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1730)) + ")}.flag-icon-sx{background-image:url(" + escape(__webpack_require__(1731)) + ")}.flag-icon-sx.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1732)) + ")}.flag-icon-sy{background-image:url(" + escape(__webpack_require__(1733)) + ")}.flag-icon-sy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1734)) + ")}.flag-icon-sz{background-image:url(" + escape(__webpack_require__(1735)) + ")}.flag-icon-sz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1736)) + ")}.flag-icon-tc{background-image:url(" + escape(__webpack_require__(1737)) + ")}.flag-icon-tc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1738)) + ")}.flag-icon-td{background-image:url(" + escape(__webpack_require__(1739)) + ")}.flag-icon-td.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1740)) + ")}.flag-icon-tf{background-image:url(" + escape(__webpack_require__(1741)) + ")}.flag-icon-tf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1742)) + ")}.flag-icon-tg{background-image:url(" + escape(__webpack_require__(1743)) + ")}.flag-icon-tg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1744)) + ")}.flag-icon-th{background-image:url(" + escape(__webpack_require__(1745)) + ")}.flag-icon-th.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1746)) + ")}.flag-icon-tj{background-image:url(" + escape(__webpack_require__(1747)) + ")}.flag-icon-tj.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1748)) + ")}.flag-icon-tk{background-image:url(" + escape(__webpack_require__(1749)) + ")}.flag-icon-tk.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1750)) + ")}.flag-icon-tl{background-image:url(" + escape(__webpack_require__(1751)) + ")}.flag-icon-tl.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1752)) + ")}.flag-icon-tm{background-image:url(" + escape(__webpack_require__(1753)) + ")}.flag-icon-tm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1754)) + ")}.flag-icon-tn{background-image:url(" + escape(__webpack_require__(1755)) + ")}.flag-icon-tn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1756)) + ")}.flag-icon-to{background-image:url(" + escape(__webpack_require__(1757)) + ")}.flag-icon-to.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1758)) + ")}.flag-icon-tr{background-image:url(" + escape(__webpack_require__(1759)) + ")}.flag-icon-tr.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1760)) + ")}.flag-icon-tt{background-image:url(" + escape(__webpack_require__(1761)) + ")}.flag-icon-tt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1762)) + ")}.flag-icon-tv{background-image:url(" + escape(__webpack_require__(1763)) + ")}.flag-icon-tv.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1764)) + ")}.flag-icon-tw{background-image:url(" + escape(__webpack_require__(1765)) + ")}.flag-icon-tw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1766)) + ")}.flag-icon-tz{background-image:url(" + escape(__webpack_require__(1767)) + ")}.flag-icon-tz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1768)) + ")}.flag-icon-ua{background-image:url(" + escape(__webpack_require__(1769)) + ")}.flag-icon-ua.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1770)) + ")}.flag-icon-ug{background-image:url(" + escape(__webpack_require__(1771)) + ")}.flag-icon-ug.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1772)) + ")}.flag-icon-um{background-image:url(" + escape(__webpack_require__(1773)) + ")}.flag-icon-um.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1774)) + ")}.flag-icon-us{background-image:url(" + escape(__webpack_require__(1775)) + ")}.flag-icon-us.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1776)) + ")}.flag-icon-uy{background-image:url(" + escape(__webpack_require__(1777)) + ")}.flag-icon-uy.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1778)) + ")}.flag-icon-uz{background-image:url(" + escape(__webpack_require__(1779)) + ")}.flag-icon-uz.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1780)) + ")}.flag-icon-va{background-image:url(" + escape(__webpack_require__(1781)) + ")}.flag-icon-va.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1782)) + ")}.flag-icon-vc{background-image:url(" + escape(__webpack_require__(1783)) + ")}.flag-icon-vc.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1784)) + ")}.flag-icon-ve{background-image:url(" + escape(__webpack_require__(1785)) + ")}.flag-icon-ve.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1786)) + ")}.flag-icon-vg{background-image:url(" + escape(__webpack_require__(1787)) + ")}.flag-icon-vg.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1788)) + ")}.flag-icon-vi{background-image:url(" + escape(__webpack_require__(1789)) + ")}.flag-icon-vi.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1790)) + ")}.flag-icon-vn{background-image:url(" + escape(__webpack_require__(1791)) + ")}.flag-icon-vn.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1792)) + ")}.flag-icon-vu{background-image:url(" + escape(__webpack_require__(1793)) + ")}.flag-icon-vu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1794)) + ")}.flag-icon-wf{background-image:url(" + escape(__webpack_require__(1795)) + ")}.flag-icon-wf.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1796)) + ")}.flag-icon-ws{background-image:url(" + escape(__webpack_require__(1797)) + ")}.flag-icon-ws.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1798)) + ")}.flag-icon-ye{background-image:url(" + escape(__webpack_require__(1799)) + ")}.flag-icon-ye.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1800)) + ")}.flag-icon-yt{background-image:url(" + escape(__webpack_require__(1801)) + ")}.flag-icon-yt.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1802)) + ")}.flag-icon-za{background-image:url(" + escape(__webpack_require__(1803)) + ")}.flag-icon-za.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1804)) + ")}.flag-icon-zm{background-image:url(" + escape(__webpack_require__(1805)) + ")}.flag-icon-zm.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1806)) + ")}.flag-icon-zw{background-image:url(" + escape(__webpack_require__(1807)) + ")}.flag-icon-zw.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1808)) + ")}.flag-icon-es-ct{background-image:url(" + escape(__webpack_require__(1809)) + ")}.flag-icon-es-ct.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1810)) + ")}.flag-icon-eu{background-image:url(" + escape(__webpack_require__(1811)) + ")}.flag-icon-eu.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1812)) + ")}.flag-icon-gb-eng{background-image:url(" + escape(__webpack_require__(1813)) + ")}.flag-icon-gb-eng.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1814)) + ")}.flag-icon-gb-nir{background-image:url(" + escape(__webpack_require__(1815)) + ")}.flag-icon-gb-nir.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1816)) + ")}.flag-icon-gb-sct{background-image:url(" + escape(__webpack_require__(1817)) + ")}.flag-icon-gb-sct.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1818)) + ")}.flag-icon-gb-wls{background-image:url(" + escape(__webpack_require__(1819)) + ")}.flag-icon-gb-wls.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1820)) + ")}.flag-icon-un{background-image:url(" + escape(__webpack_require__(1821)) + ")}.flag-icon-un.flag-icon-squared{background-image:url(" + escape(__webpack_require__(1822)) + ")}", ""]);

// exports


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad.svg?2d9288138275b189625c8c2c264648ec";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad.svg?800207334fe3f06f5cefab0e161ee27d";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae.svg?998cc1fc1b86c9e1f5e381ed49bcb73c";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae.svg?8fc34d937ede25b6e171274b804b1e7f";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af.svg?1e73c9eec7a1fe8d8a4a28de746bb09c";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af.svg?ddee87a8c4cdbc2a60b5d4ddc3a1549a";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ag.svg?b8b828913dc2d38b6afaed59032f2ad9";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ag.svg?441882c5d5489780f1ab6b44927e5cd3";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ai.svg?7b4552df49750bda95a7fb860851ba60";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ai.svg?377c542ad344b6c40fd30645601fdb01";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "al.svg?4ed11fa46f929442468e9904abdbcc4a";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "al.svg?0663234670e1d6679628d6f4fbae4e90";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "am.svg?cb2561270555c1b1e80318bc637c05ea";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "am.svg?41e6105650bb108b46e153f4f043e027";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ao.svg?b69218a9dc7ff91ce97305c35b9f8991";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ao.svg?3e1baa0864a908f0cb27d06e155300ba";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aq.svg?02ad59b3dcbdd872f74d3c112f474794";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aq.svg?328821fe6adacfa7bee4f57da5d4e5c6";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ar.svg?5261e632249ca9ab5b916055603be1f6";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ar.svg?53647ae9f056d46e03205f791f2b66e3";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "as.svg?23e6ae7d55de1077626007fdfe9a5822";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "as.svg?078ba7453c7f253d3f2ceea4b8b57d37";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "at.svg?fa4cf0437de30e8cbf8952b91ffbbc3a";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "at.svg?0721b30720785a8a481ea634b50445ff";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "au.svg?bb307e7fab6969ba6d3ff7d2ceeb6288";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "au.svg?f6b7907ce4405df5f8c7d1abbbadafd5";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aw.svg?3f52fb17e14398c3a3d8e5cece4f9009";

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aw.svg?0cd7e031771900e86d3fe8dcd81e5556";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ax.svg?f8c4019f81d13aade8e732ab4a6baf32";

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ax.svg?e939bf2ecb653b16e31928f62f14161b";

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "az.svg?198dbef38643afbd74b6d1cbe6da9ec8";

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "az.svg?1edff1247e1846c4e074a479684ea6ee";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba.svg?7d6f56d23d025c0f0368ac2f85d7f8af";

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba.svg?d5ef14f05acaac11a4844e9b3bbedb00";

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb.svg?fe3ac3fea6f1abd9cfce0635cc6d610b";

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb.svg?0c916c1c17d5652f5e92b773aa1d4e2a";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd.svg?a7978d3d0cb45d9a6dfae8569f7c9969";

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd.svg?b2af31760187b0f75eb6789dda71f62f";

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be.svg?5739940da79d5fa8e595e64c05669c2a";

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be.svg?f34903cc86f134e4aa0aab9ff6a9e571";

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf.svg?57907e6611d0ab08eed5631443cdd447";

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf.svg?348494c4020e910a1c5ebf26ad17c27b";

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg.svg?494aa5696f310b06328d4768c4bacdcc";

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bg.svg?44d83f951206160867dedeb992217279";

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bh.svg?7510653e469a48d869e109f7cc5fe930";

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bh.svg?18fac7d81bf6f7575b9f7486ee55cfcd";

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bi.svg?12a40d8db0b02233e8bdfe888231bfdb";

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bi.svg?d0615c777a4d8ada254341565c49bcd5";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bj.svg?5561ec954d9c2ec533400b805354a4b6";

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bj.svg?22430301448ceea1471d979ca319be92";

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bl.svg?2a496da9f0ccf063b143d591045f587a";

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bl.svg?2deb442f266b054738dc4389f509a553";

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bm.svg?012b04b78dff697d63abb50a1193144c";

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bm.svg?f2a17828e24a83b7bb4e980543c5fab6";

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bn.svg?f6d5f4005cca9ebb9883e5fb4e3edba9";

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bn.svg?c5b91605c852ec62583c5e7498a9f4c5";

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bo.svg?5f3fef091d666ea0ed093b1a427eac1f";

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bo.svg?2b6773a9f72cc831c5fd8ac5a2115576";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bq.svg?fda6c02c937beae291172cd3f50df39c";

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bq.svg?8c6f85c7ffea34a1d11596e9945f112a";

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "br.svg?a31e25766b6f0ba6bea0e6bf7d8e91af";

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "br.svg?a30c10f8643bb31ef60f65958865a812";

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bs.svg?cf40c6afb10d012e938c1fc4975301db";

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bs.svg?0f30e82c7146b9138138a31810ae9e1e";

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bt.svg?87d65251ab5b878dd029615dd4794a8e";

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bt.svg?508393deb13245e36ff088316dbcd5da";

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bv.svg?4fbc14ad662107c170024061b40f6302";

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bv.svg?ce747379b653d0c81d931cd25779c857";

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bw.svg?15ed460a57847531507e5ba7201597b5";

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bw.svg?5f11a0beed3ff05c3accc5df7e42fd66";

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "by.svg?c05c8c07ade1f9ead97ddf35a747f95b";

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "by.svg?9b65127c617c5268e17e0997da71885b";

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bz.svg?2458dd8a8870ea822b25e1cbbd9cb0a9";

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bz.svg?81f2d6419e0debccb76714ed466b0652";

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca.svg?0efb6bf1f18132e87ea2c57d9580c45c";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca.svg?a3999867cb776b04ebddf5d9eef4f48c";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc.svg?dd392e29d025f8df6555fbb825f3ac84";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc.svg?e53abbf8dc50b464cbb11a76ff1ec9d6";

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd.svg?d4408d3c47a4436c01c71fe6af4825bd";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd.svg?a3ecd8067fcd90a99ce9385abdc99f45";

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf.svg?d8dd15d37e5023c354126187fe19327f";

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf.svg?8f764c6dedaca265cead5bd746224551";

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cg.svg?51ec77aa7dc9bd203501805508836662";

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cg.svg?4ad6f3e8cf63bc61fc684d1e23e86899";

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ch.svg?a69a50e544ff08eb122eedb7dc274cac";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ch.svg?987cb82c1cadb50c89fe1e58dec40c31";

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ci.svg?11ac689d81026c7e72a1726cc5b8e435";

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ci.svg?728ba64d6ecf525a8eb69909b6f62b58";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ck.svg?fe45a10b7d10b55b741114dcb7e75f48";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ck.svg?e2686b2a29a1d7e56e17214b72e4cb0a";

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cl.svg?2fd895c4996f542bf3b07caba07bec6e";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cl.svg?609867ee88ac78b4aaf397a6fabe6790";

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cm.svg?a56034b73ef6d0700c73206a2f72abe0";

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cm.svg?94ec67b0531daa72807d39d9c7fa2123";

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cn.svg?2c193ab31269f0da8be9830738325d0f";

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cn.svg?3a0829042f88f0dd20060d30fd7057c2";

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "co.svg?c5d7116a03266225f537cb79a0b87c21";

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "co.svg?11131041f85f1e5ebf68667f790af409";

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cr.svg?0d349fd2526b99ef265d29d840611ce6";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cr.svg?13c483a397095a9d8703d1eb46328c77";

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cu.svg?1c7cc4da857495d8b44eb88d22a51e33";

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cu.svg?e4f897dc1790e9f3d1adafb62d0f7fd1";

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cv.svg?624a2d4d919439bbd76b1431de002c18";

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cv.svg?accdfa0ea8efad323ef4711339765a4b";

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cw.svg?9c06626ee2188bfd83b63be4b009cc30";

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cw.svg?ae75cba57510891147b59f88c71d3584";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cx.svg?b2a59c5ce370cabebdcbd19672933e7e";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cx.svg?8142eab77f7fe4cfb349a14b4f94ce1d";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cy.svg?5e40be33df611e7bdecee279ccf3889e";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cy.svg?dbf92cb89053f06b273f767cc7dd3a8e";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cz.svg?09a9b116642e821937ffc1d777a99022";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cz.svg?b325cced526f0d4cb42b655eca7f40e4";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de.svg?246a5fcba5ed21747c2a108e5e635ec7";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de.svg?74018f0abdef885f425c141cc3244afb";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dj.svg?694ca31b23013c8f1127e23741dd54a0";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dj.svg?63e20123441e1fe6998df866aceb2a4c";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dk.svg?302b4687163f20c1e43779d2a3f671a0";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dk.svg?59a9d25f6d57f572f48c2c1eeecb0724";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dm.svg?b1635699ae7bb121d9efce1f2a881320";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dm.svg?fda8fe7071e4410604350b7ca25aeb4b";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "do.svg?704fd2a9ed132ee8e42c5fc4dbea31a1";

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "do.svg?88a82fcc61969d9c897ca685f5020b5e";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dz.svg?0477e542720bf395ac09392db78e17a7";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dz.svg?ff15f060b5abba792024a5b144e5a31d";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec.svg?3bafd0714678cf63330f182d9ec4cc41";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec.svg?8fb69b7933c6f712e20572580736f7c4";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee.svg?03c3d564daa8527441e943dab22a6e24";

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee.svg?9b43910c06e045dae08a96b7e185ca30";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eg.svg?b0aa9a4e893d49715b780350324cb985";

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eg.svg?4137f1081dc73f5450aa1732b27a73eb";

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eh.svg?44d979031e6ecf702d00c9d07bbfcc0c";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eh.svg?780a0a9e2e95e4971fdca31fbf97091e";

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "er.svg?b4ea80f7a2a8848ad55e31b9bf3afc90";

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "er.svg?8d5171c77e388034f48931bb77b65014";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "es.svg?bcf1ab9854fa7d81fedb1115032ab465";

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "es.svg?361eda2a8906d9753ced8c046a754606";

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "et.svg?512bde19026857a0be17fa2271224762";

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "et.svg?a61da8e203efc6ddf8be108c074e44e9";

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi.svg?8c63a9af82c69e1e067cc51fe8251693";

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fi.svg?55109a408f95186b773e8e89b5a67dcc";

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fj.svg?caf72f69ced8ffea30cc3a38bcc6011e";

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fj.svg?453532c2daca1423d88f079a82cfcfc5";

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fk.svg?1e53dc26d87dc2ff8cdec524787eb102";

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fk.svg?1bffbf9fdbc7e06d1e4ea685247c72f5";

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fm.svg?2c13a5d4f618959c50fcca1b498dd393";

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fm.svg?41b339f3be3f9e3f61694ab4a9086c09";

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fo.svg?c2f634751d1be4f5bb02637a2648823f";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fo.svg?32019da00e4ad54d1cda9ff412d32ca1";

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fr.svg?4e3ec048e64c77815332dbb34f9b6305";

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fr.svg?f4529ed89ccd5521b6895e298346e71d";

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ga.svg?8629ddf547aa8d81b25fba0579963c21";

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ga.svg?886a7348fe2900f346fe427ffb40dbea";

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb.svg?85a97dab5b090c1a8110d27fcd570939";

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb.svg?fe60f8318501f211b9583bc6d666c874";

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gd.svg?0e3d254c0cf13bf900b1eed7022fd68f";

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gd.svg?7c62ce7d1f45914b82768e971aa41745";

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ge.svg?a129579288ce45bca7de9c073c5e17a9";

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ge.svg?49a0b418c43c1db8a679832ec0310144";

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gf.svg?434bae071ab5ed1b79860ca48122b681";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gf.svg?d0185c1175c7d0fa26b1a282440d7677";

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gg.svg?c447047f465ae1303de6e46c43eb0a6a";

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gg.svg?02df8a5dc2a174160c2ff4febae8c1f6";

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gh.svg?bb3bb60464f9de0885206ae68d817026";

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gh.svg?e0ca5267471f6b47564b10068f37e874";

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gi.svg?71cfe39b19a8cf801dac52745837879d";

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gi.svg?1afed1e43b3df70621911e848165db4f";

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gl.svg?1495643c89bb2002c8d1af03cd3d68b7";

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gl.svg?59e1835690dfbbb0414e59a72686b054";

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gm.svg?39937d8fd860274df069f97aefc58e15";

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gm.svg?6b4107900a93999092ef63fb4b99b171";

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gn.svg?e2dcda47e6c4a060104aaa7be670bf86";

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gn.svg?0798100ed78e72cc9070bb01924cba7e";

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gp.svg?0dcdf9660c568a30d3dbf8caf64e9d42";

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gp.svg?8fc39c39ffec8d93e550676fec3b8b56";

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gq.svg?c095a0d44d955f381d95bc1223c5a74f";

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gq.svg?88946f8ad223fc1224a03988295e4849";

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gr.svg?334890b69eef86b49a9083dcc2f33d31";

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gr.svg?dcc2c8657fa2795dda11f625a3fd5d67";

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gs.svg?21f7c99f17bb19ebe4b9921b7fa01afc";

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gs.svg?1067356806f9346264da936cc4c9e120";

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gt.svg?01ce618dccdf1c3af88fc6cab6c375e9";

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gt.svg?4eea9e03835a6042e803aae0c5103137";

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gu.svg?beb28cdd728df39cc5016605a594cc99";

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gu.svg?d4375e9d037d29bc430f6b8f2591514e";

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gw.svg?f0742332f72950dc2c88c2793ffe423f";

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gw.svg?1ea244637aa5bc1fb63541b77e6a54c0";

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gy.svg?cbacc8b88ee72a8dcf56632a2b2b947d";

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gy.svg?333d94bf559357540545c39f94cb12ef";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hk.svg?029a6bef7507e48f79319f007585eaec";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hk.svg?50fa2f99e1b35759629a6399ea58a5c6";

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hm.svg?8bbb5756e34452e030d2ccb14d7bf622";

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hm.svg?45e61c98191d6b1210b748066ce97549";

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hn.svg?db7e3de4435a912737ae15ff8c1b8130";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hn.svg?4938f675b80bdc7e5ec2768cf4c09c18";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hr.svg?176d2d57842eb1084e5363276bcaa988";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hr.svg?635a60933b2268045706360f55b7b477";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ht.svg?5f6a49d0ed1c19657da2392ce95dc7fe";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ht.svg?06eefed919d3723c507764ee01357a2e";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hu.svg?d1065faa141b030f4d6317927525ec32";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hu.svg?a38286595b4408dcfabeea890b327320";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "id.svg?e8f1c8799e91c132917570b3442d4ed2";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "id.svg?cd7ecc1e34dd7b23af6e87d25499a77a";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ie.svg?deca9e10a3bd63cbb1cc783d2fc85625";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ie.svg?ce6c7d810f03854cd7517de4dad68c5d";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "il.svg?ad7a2d12e6947b430bc763470066d10a";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "il.svg?5a12c248e7badb386042c6f20160aef6";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "im.svg?07fac2afc75f3b5d1c234ea32738512f";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "im.svg?f6e8452ca63057270d6e65c2688bfa12";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "in.svg?98c5671706065988ddff35d83a2cadbb";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "in.svg?f1c7c9bef4ab67d1e4a6cda4f63eb86c";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "io.svg?7fc155e7fac8126870876572461fe95b";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "io.svg?1734998df85efc34d79d0fb154fffd7d";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iq.svg?77fca3a16e9b7d1b1de65cd1ae6c4973";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "iq.svg?a632108725e2eb4eebf2bc82161185d3";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ir.svg?28b0fb3b3d83de326b81a1668e21beb6";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ir.svg?1a62e10d6cfe077c86a38c4c5e8215e5";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "is.svg?ba30d1eb1308572f96dc27307903152d";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "is.svg?2c3b9decb9e6eeff88565452a4be54f6";

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "it.svg?5a3412cbe8f690dc5dfc92c3b8b68001";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "it.svg?15a1f288182170a580964fb8a64248d7";

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "je.svg?a2bead8f5c6abd826fe5b5e8c52901b4";

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "je.svg?12bf2a5fe22bbdbcf5b5187920ed633e";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jm.svg?c5279e8583934fd4fcc2b95faab316c9";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jm.svg?1b388cb263bd368e45888104001165b2";

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jo.svg?5806167645b758207aeb910e04e25ecf";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jo.svg?e0c3d125e44478b3c9fc62c9c7b07951";

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jp.svg?28157b5298df82905d87061bfe56788c";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "jp.svg?b5b509c87244a9ff54e87d54f97d64bd";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ke.svg?ac8b7d8174a8767fefb6aa4a648e9024";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ke.svg?8db0f5f99c8a152df9a5386e54302cab";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kg.svg?0e8c2a1deb7a97d5d6fae34edf6fffe0";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kg.svg?20cdf6156992570d17d7e923af3dd9d9";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kh.svg?add3236a32912b953efd4bcba465536c";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kh.svg?2be5f19d71be932f32fbfe74572384b5";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ki.svg?db9ce4a8eedd3429844cb999147e4e05";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ki.svg?84841933e626d7194ab99001eaffcca7";

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "km.svg?05c0e1c1d234ec535e809a8711e6f779";

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "km.svg?86ad579fab8211512f200facfb700eaf";

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kn.svg?8d2a2bac0a4bec64f61798ef6c86046b";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kn.svg?a1e5c90bb158a324df6f2f416b58a1a5";

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kp.svg?fc45ba59283feb5ac07259425091029e";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kp.svg?bab86a2769bae956735f43562d7a0a6e";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kr.svg?472436a2cd7adcfb81854d5e9d45267b";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kr.svg?7ce5a14098bfd2fb03e05cb0d1e178b4";

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kw.svg?8758e4ab9960cbd0372b2bdbb5a97db4";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kw.svg?0a1e78f001df0d3a9a4657ad20df9d20";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ky.svg?bc2f4070b8aede23d93492f15b23af52";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ky.svg?58b6db257c2227ed4023905121077fa6";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kz.svg?765abf25f0c5a3107513c0d71b66ea98";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "kz.svg?0855baa1155ef2663125457d2f27fb81";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "la.svg?d4742a0bc73e9af721f7b7e6c08c4720";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "la.svg?635b3d0bd4b2f2854bff71670f72d22f";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lb.svg?c43e467ffa79b69e102a3242d03863ef";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lb.svg?bdba8149d35cfa3642a7fddb7d204e19";

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lc.svg?318596539572196c7f62fc47fc2a4e5e";

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lc.svg?5ad24b4c23e1c0240d15d4de8daf6103";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "li.svg?7f2cb3e761858cd6cd0dad1e9a99c7b4";

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "li.svg?f37f498e8d8d43d49133b6b2de2b447b";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lk.svg?f8d21a6b463aa47f76f4eaaa36497fca";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lk.svg?3ce70e5002961066169f54aff5492201";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lr.svg?e026e0f7f0697fe0dd3cf3f86443b851";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lr.svg?e3059e9827267ac9bf36de53a29cb0a8";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ls.svg?6497b847f86af3b088814ff131f87ff2";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ls.svg?fd0cc2e17bcb57d703a83d0079c316bd";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lt.svg?c2b153a464289ca2eda1e4c289b65c17";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lt.svg?76ec6661382ebca94b7f03e61e76e72d";

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lu.svg?cad8b8baa96492b8507359b0dfaaad66";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lu.svg?57b9eece69ceaf18a2caa31327fa205d";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lv.svg?35ddb2f334c25ef94cafb8373be1bcae";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lv.svg?4838077bfe980fe615358fdc5ce4af8b";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ly.svg?41489295bb65a7891cc8a0c030689412";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ly.svg?27ae749c0846f8a5c2e256ed49faf819";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ma.svg?821b32398c1b5dbe1834770ef5f6ba61";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ma.svg?c91b74041cf00efd50fc30b8e4d91ffb";

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mc.svg?37be4651b8d058120dd8cb47983e9c99";

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mc.svg?04a4a202a022ccc10add49ca6cf706fd";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "md.svg?824e3e16727c39d5ad3be1d767e50584";

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "md.svg?879bb31c43329e54330fdf47b5faced9";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "me.svg?37b693f64c100e0b9a2d6be418dd4fdb";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "me.svg?be3b17db49b465d383d3ac13ad8218fd";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mf.svg?d3fbe0d987afbd8149e84ca101791d16";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mf.svg?647123880ea3877d53947e8c33ecabe4";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mg.svg?fba42999241fe114d86f32140ad674c8";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mg.svg?1491077425ac44fdd5ca2a301975640e";

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mh.svg?c1782cea933e24d2f7570be27ab5e12c";

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mh.svg?40dbb5c2801f16957059be2ca054fca1";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mk.svg?4a879fde847db3890fea5197ef3663d1";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mk.svg?12c1fffa458d1051841446e12b5f6ae8";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ml.svg?64aa836720124c581eea7ae0d5b60443";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ml.svg?02a95bc10fc1791b510be1ecbf972359";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mm.svg?a646bac36c08c5b843f8eb9efa0ddd88";

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mm.svg?95787e3a534c1ed0a1efe301f700811f";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mn.svg?5f43e0c610de2e75736483bbbd06da28";

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mn.svg?7ff5bebad5607af5a3a0fbedc02f4d37";

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mo.svg?012b278d37953c5a2e3e8ae12422e31e";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mo.svg?94c09d5818bb170ef91f26db40712e94";

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mp.svg?bccdcb5ecffe13079a8077d6cd57263a";

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mp.svg?fec806e5ccb0f18ffcadac9464333cf1";

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mq.svg?9bcc4ffb912c745aa7098c0de1905eeb";

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mq.svg?37d2d6810c154684782c747761c2e07c";

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mr.svg?55d8f233036c23373ecf6eade8d735a1";

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mr.svg?38d81da0d49d46e4227690edf3c52976";

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ms.svg?ec75da93364b2dd68705a2718c551a8f";

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ms.svg?830476bcbc2114c0edc9a88954f0816e";

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mt.svg?07ddb919be0f617b964ce47a59528c52";

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mt.svg?4f20d5a79880bb85d3733a8cea2cc22c";

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mu.svg?33b7d11749d57a61797d72ab46cc0ed7";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mu.svg?fcbb9709a43b6b1f0b94cb5ae9db08be";

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mv.svg?c11e6efecc84326132b226b7cf84bea5";

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mv.svg?f1beedaaf3f70d20d2e962a02d98c559";

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mw.svg?8627c92dc660e33b047a1ae2efe17cf9";

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mw.svg?f075545eec970dd6bea4083002f29084";

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mx.svg?1fcc3cf0c7e6ca135612d8b3ed399e3a";

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mx.svg?4e358e43beb776d5c90cca5ffec8a2bd";

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "my.svg?789a6ddf349312be499c1b20096b0240";

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "my.svg?591d1e38714cc55a73f3b556f00afb11";

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mz.svg?c8308283028cbd9a0281a61635ed3b20";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mz.svg?4fce86a88ab94af0d4719440a29bbbad";

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "na.svg?efac2847fb683491ca06372a63adc4d7";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "na.svg?ca8997745270df3094bbff555d517db6";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nc.svg?846211decb4c6a7eaf50944147654cbd";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nc.svg?b72ab6b2a834a41cb6cfec2908bf4a78";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ne.svg?9a5589731c141e7c38d8ec613a5f0304";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ne.svg?a7f07f0ce07ab31c89770dddbf56d0c4";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nf.svg?5e07162fc6710cfed614804deb6d57f2";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nf.svg?44fe5947279a723930d2d21b45017c03";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ng.svg?ba3bb51aca71f876f6d55d8ea53f7a73";

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ng.svg?f6a23478e72fa37e3b9f3869524e0dfa";

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ni.svg?7affd52e71f565734b35c729fd9a69c6";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ni.svg?3f7681e7629b2dfdcb7f7c59c1e1b3e0";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nl.svg?feb9eea9ce02f8633ea8c37354a7e1cb";

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nl.svg?db2b8b183dba8ab799213ee07763a43e";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "no.svg?fc029595f52e23b8f04102e4e3c802c2";

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "no.svg?51a7ba8c6295a52f4b253b33694eecf1";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "np.svg?4211aa60556333402993bda5cc007ec3";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "np.svg?c28b6869e7499315df56b73fd2c42a65";

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nr.svg?66dd15736f1d79053d46cb60eea52e8a";

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nr.svg?61a42463d2f4031baee80bfbb4976079";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nu.svg?39cb2412fae122cbbb2ae8fc9011fed6";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nu.svg?482618606f493a8f71e79003956049a0";

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nz.svg?07d3ae50c3576b59ca1cf5ef6eb1cf02";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nz.svg?d29645cfd55673bf87bf02f95bf79668";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "om.svg?9170bae18fb32150c2ec4fdc6826238c";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "om.svg?7171b1e2bb68f23117e15cb01ea2e90a";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pa.svg?3b4d5528e24d6aa61e049df51eb8c89f";

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pa.svg?943e160a9766c67a31c681d260e00f1d";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pe.svg?fda667297974310505272d2c7ebaf723";

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pe.svg?017a482a8e2647dc96dea5d770dab327";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pf.svg?b6f47989b5c69e0ab2ed87e26869a342";

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pf.svg?3ac8d5bdfe5d78013f568a73dd5b4d61";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pg.svg?5c17391e78b57ac623cff8401a4e303a";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pg.svg?4359608e6d3f7f7b4c471f4fe1576b6f";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ph.svg?807a7e5ded435f887dbebed8a7d8d81f";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ph.svg?605f52201b02fa5bb8a2b99ab1389ed7";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pk.svg?fbfb5582df374e123a0d4748380f406e";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pk.svg?f76952932734f7ef0d655691158a4371";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pl.svg?6607e08cafd66147db56631c31d66cec";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pl.svg?1f4f8ec32bba1e4e2ec3f4c5fc14efc6";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pm.svg?6359f9eea5d35f2cc4d89366c20e0a26";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pm.svg?68469c3f062b2fbeab2e96715a52c798";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pn.svg?97f773cab9a46804e0d4d49d3269b3d1";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pn.svg?eb94153e3111b0694e49ac4066bbf9a8";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pr.svg?563200c5ca16c47d8db68f101700cfb6";

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pr.svg?6949cd9f76c1e488de1074d5d04dc189";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ps.svg?658c8814aa70f9ef97c7be35d136e492";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ps.svg?1b8d03996bc990a274d24d660912fe66";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pt.svg?03f36e39e92b313128a702a06fe14396";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pt.svg?6143c8e6835f2dba4080dd2214db7b3f";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pw.svg?5445894875274b8709f1d6f3fd6af976";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pw.svg?069ec370e716891db264087afdcf6182";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "py.svg?795e6d0e6797cfb82c1d039a39ef1387";

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "py.svg?f1fa6887d16e8626a2ece3b50b551718";

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "qa.svg?4f997308380e5dd75fff5a89723a3172";

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "qa.svg?29cc28337ed9450a402a45452246c160";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "re.svg?9c769f63698693183e0416f99ee0ab35";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "re.svg?16aa0b5b66321c1281c063ee2619ab02";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ro.svg?b091db3bf85fd316caa80e5b05cf264a";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ro.svg?488ee906d08b52610dfb7f47cb84f2e6";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rs.svg?192092d6e9f30bd5151566a79fc77cfc";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rs.svg?95f28eccd867726d728d8973386f1a9b";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ru.svg?af31e644412f6079d91279ae7b977196";

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ru.svg?911c03c21a5ddc5df70b61f46589bd5d";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rw.svg?dbf846e1d345cbded1f7bed600a96965";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rw.svg?d724e841628d040ff3484698907a1dd1";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sa.svg?45e17088c50060fa0549d945bc987c24";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sa.svg?1c14b2ed39388b5bf16aa85c4b6d50bb";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sb.svg?ab93a7990b049074d06db8b0bc7b3ce2";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sb.svg?5bc69a36b0852ca3e1023a0bfc21660e";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sc.svg?5d8966f42246b186ca5ef3d2144ba158";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sc.svg?ed506f5afdd99e5f884903abf1da85d2";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sd.svg?aafc9cae603296bc1a353c32c9d0f8f2";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sd.svg?d702bafe1580a1d29a20610f75f28964";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "se.svg?b54f0ef0a393bb878f1eaa549bf100f1";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "se.svg?5d16ff9ec384c46df7c0261b82bc6267";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sg.svg?814c6d6547960991430a1c71871597ed";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sg.svg?279844e992ca5aa5bbf4d830b2b79be6";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sh.svg?e26b4b82312cc681dea395e1de7176e9";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sh.svg?c147b9c0254aca2a7e4e5c46931ca631";

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "si.svg?48107aebf18a50cd1f74f659dff023b3";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "si.svg?fdc1ceeae23c149deb2006431d51737a";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sj.svg?d08937cbcc45b5b72fdbca418a465986";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sj.svg?f40433689ccd69fe698f04d5d27baf44";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sk.svg?daf75e75e18b8299db61fabcc0946af1";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sk.svg?253c193837ab28e6fbc39c28024e023f";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sl.svg?f5cb409d2dfc8009c8d8d5d193068358";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sl.svg?58ef1e3b6bff58d6f4ca6047a96fc59d";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sm.svg?890ad891911e82e4bb6444077e4c4c67";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sm.svg?d69bce00e26722bba4db9516bdd7aeb3";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sn.svg?6d85da96305f317874f735494e0ac237";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sn.svg?c1a6798abc4a04fd81139f968d305a8c";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "so.svg?fd9745c3e91d65bb27e0ce1a066def8a";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "so.svg?a3c1b7507d4d51368a9c9c7ef16e50c0";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sr.svg?64fb37b49bdd1d10f833926e24da7226";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sr.svg?ceae0ffa4c003d02ae6151089d91a88d";

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ss.svg?5e0bad12f6f55064c3dbc63aa8e8128a";

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ss.svg?c8e5f380d045c394f352a0bb77d6ff60";

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "st.svg?00f5130cc14dbdb86779b734730a1d9d";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "st.svg?3589e34b716c7cbfb519d64c63aa656c";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sv.svg?abfac59c5ed910b2ddc7cc545c45cb17";

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sv.svg?88ca96e7891e09e72a3f8c0cf2e22a7b";

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sx.svg?89f96e7884f6dbcbb0496360d3937c34";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sx.svg?6c22419aeaf5deb9ca0cd85368de24bd";

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sy.svg?d648066bba18b3fedf66db0fca2da5ff";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sy.svg?96bb3c224fd1a7a3f7869ca176b6ce54";

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sz.svg?d00ba66465ba75f9a782e9f79944402c";

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sz.svg?9ec8da3eae5c07ea00da519d29071389";

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tc.svg?d01602470bf5b8c2cc51fbb9925f71a9";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tc.svg?bca9f99cb80af8a64a1249b13d08418b";

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "td.svg?d6ccfa17c984bf92472575c6cf018f80";

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "td.svg?cb622bc24400fd328947ffed78f0660a";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tf.svg?1129c04ba580e9e28171db5d40ce9f32";

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tf.svg?3f87ed9137eee673a8d3799760e5c5de";

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tg.svg?bf9d20b8945bd53245c9ea1e1eed2a4f";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tg.svg?aff94a793ed8d936373717694ddf3d99";

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "th.svg?565e3c4b62c18bb6ef101a0cf3b4c82f";

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "th.svg?9c1e01fcbd77919148db921c5ce77446";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tj.svg?e58f32ff84f001bc7168d27cdc241d71";

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tj.svg?1793caa0c484adea27824ce612e96dfc";

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tk.svg?b2df385f8dbecd292c77915242f35869";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tk.svg?e37e35bfee8ec6f39e49f95ba55b4e32";

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tl.svg?547e42152a9dfb16e33dc6bc3663d712";

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tl.svg?214b6f844896186fb3035180638b8a47";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tm.svg?f2dc59b2535194d31ce8778386b52164";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tm.svg?08d55ec816375fc81f1bc352977244e5";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tn.svg?98351bcb280b1151a28fc9fcf4c1d0f2";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tn.svg?34dba63bc62c862c8944dd2c827c1bf6";

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "to.svg?00aaa22b9af8c670b1dd4fb7855190b2";

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "to.svg?ee39c2dbb8ab06d415a474be5fc2beee";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tr.svg?ac4572ccd5aa06b5db888c21b07b728e";

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tr.svg?d4a61f6a22324244789eda3de42ebb68";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tt.svg?333675d63b5100b2ad628b0278de708a";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tt.svg?3854b853aee040dd3a36a3bbbb526a16";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tv.svg?eda22a5dfd270426a548e811128409d4";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tv.svg?ec5c179a3c54ff54fd82ddda3569f794";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tw.svg?89a1429ae91ef356268cfdd8759b89e3";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tw.svg?7794932d0d22ed75f2e1e6f1e2fbf472";

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tz.svg?ed1c43d0c76533c8e19f0e8afd0f604a";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tz.svg?206592dc6556e3cddf82e5f59dbcef24";

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ua.svg?e2202cb676678f90c10a1c1a0e04afa6";

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ua.svg?5196d8ea0993d5b917b04ddb206163ec";

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ug.svg?f6dbcb210c928f287afbbbf2a191c724";

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ug.svg?69ed4876cb991fc0c03f2ad3ca250a86";

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "um.svg?f4540fe0a4fe6d781318ce86cd25ec15";

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "um.svg?2da266d727f6a285c2c6c45404d13857";

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "us.svg?da1c4f85e66e46f759fe736e3f2a5b37";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "us.svg?269666d513f4326441bbbdc8564c7cab";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "uy.svg?2ac18c6e7d7cbee175d28bf5b7e764ad";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "uy.svg?4caed1247a7d571f081e9cf2015038a9";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "uz.svg?d9b782092304b93fa203f2e84a9a5c60";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "uz.svg?0b281dd521d66869cfba6fc17b814b19";

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "va.svg?8aae3709fb23884b7c01927b3ab56c15";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "va.svg?a44c6ba981a68dc7e9cd12f0c07c3e9a";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vc.svg?fc6aa8fea6b1679f5618d420705c9fdf";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vc.svg?0d52b1116574139a04da5c57a6b24b51";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ve.svg?05045bcea6cd452ff2110d8595ca1895";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ve.svg?d384c6ce97ba0ca4aecbc188e84a0670";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vg.svg?eef14ab6f09e3eaf612af872df742845";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vg.svg?4236b3592713a56c25d146f790e2a4f4";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vi.svg?2127440f728f099608ed690b93661341";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vi.svg?8a178e2ccba3c073eff08cb67977c858";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vn.svg?010b0c4c6dc4bdb48895ab271d4544c4";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vn.svg?7e156d1d24f51aca6179f2e54dec5c7c";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vu.svg?5bc20756ed74f649e3ce3722b2a9c5a1";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "vu.svg?9c4c893a4c07eab2b1b6b9e5419f1785";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "wf.svg?5e6aa0d6196a1db8431a4fff6937079f";

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "wf.svg?a10487a62b8516b7d842cfb1bcf9489f";

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ws.svg?c4eb05965d7ed2e7d561e80e18dc1b68";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ws.svg?2690f3d8a35c6ca0343fe931be856dc4";

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ye.svg?68c397990d00c23f85c865ba696b19fb";

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ye.svg?58d8d56309a5718c3a4f31be6cdf223e";

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "yt.svg?0f00b1036165d69eff29d5b898873ad8";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "yt.svg?a1387f1c257ea0838b27317a6606575f";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "za.svg?177080d3e910a20e5b030f916d77760a";

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "za.svg?9ed44aea09b417be8090dae8e5222232";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zm.svg?5ac3774ab0e7b84a715c175283127732";

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zm.svg?402266a05380383f933eda9a8eff3fb2";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zw.svg?58e2cbd64ee1252a407f1ca815b6817f";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zw.svg?25d67323ce7c449da65ae3af13fac562";

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "es-ct.svg?2f1565e802d4608517d8a9796d2abe88";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "es-ct.svg?e6db39f3fca00093bd7a3c2160ce0f57";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eu.svg?d8c5128679452fbb1742dc0b0fafcfe6";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eu.svg?824e473c761930ef1f65fe53a04a4f18";

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-eng.svg?e18b270f56f90ad1f19660e70b68fb3a";

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-eng.svg?99785a1e509f909b29d0aff772349748";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-nir.svg?080d05670e1d7ad2d3b7315edefa3653";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-nir.svg?5329af5915b425ea338f2eef0bac7af6";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-sct.svg?c4361672853bbab112bd4b360e6dd199";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-sct.svg?6231d4d57245374c7e7578275498310c";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-wls.svg?344dc57e2bbcc26eea7cb4f8211cb5e7";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "gb-wls.svg?d67608c4a9127c21bc7236eaa82505b9";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "un.svg?cc2eb7d1b1575db6532cbab447247a1b";

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "un.svg?424ca4dfb83e20505d9c5a92f107b151";

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_Flag__ = __webpack_require__(1824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__icon_Flag__["a"]; });




/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a3c30bea_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Flag_vue__ = __webpack_require__(1827);
function injectStyle (ssrContext) {
  __webpack_require__(1825)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Flag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a3c30bea_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Flag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("21254cd6", content, true, {});

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,attrs:{"title":_vm.title || _vm.iso}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_36f43883_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__ = __webpack_require__(1830);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_36f43883_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(row), "y": String(col)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.setProperty("display", "block", "important");
			this._elCanvas.style.setProperty("display", "none", "important");
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.setProperty("display", "none", "important");
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.setProperty("display", "none", "important");
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();

if (module && module.exports) {
  module.exports = QRCode;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj};(function(){function a(c){'undefined'!=typeof console&&console.error('[g-signin-button] '+c)}function b(c){c.component('g-signin-button',{name:'g-signin-button',render:function render(d){return d('div',{attrs:{class:'g-signin-button'},ref:'signinBtn'},this.$slots.default)},props:{params:{type:Object,required:!0,default:function _default(){return{}}}},mounted:function mounted(){var _this=this;return window.gapi?this.params.client_id?void window.gapi.load('auth2',function(){var d=window.gapi.auth2.init(_this.params);d.attachClickHandler(_this.$refs.signinBtn,{},function(e){_this.$emit('success',e)},function(e){_this.$emit('error',e),_this.$emit('failure',e)})}):void a('params.client_id must be specified.'):void a('"https://apis.google.com/js/api:client.js" needs to be included as a <script>.')}})}'object'==( false?'undefined':_typeof(exports))?module.exports=b: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return b}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):window.Vue&&window.Vue.use(b)})();


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var addStyles = function addStyles(win, styles) {
  styles.forEach(function (style) {
    var link = win.document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', style);
    win.document.getElementsByTagName('head')[0].appendChild(link);
  });
};

var VueHtmlToPaper = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Vue.prototype.$htmlToPaper = function (el) {
      var localOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return true;
      };

      var defaultName = '_blank',
          defaultSpecs = ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
          defaultStyles = [],
          defaultTimeout = 1000,
          defaultAutoClose = true,
          defaultWindowTitle = window.document.title;
      var _options$name = options.name,
          name = _options$name === undefined ? defaultName : _options$name,
          _options$specs = options.specs,
          specs = _options$specs === undefined ? defaultSpecs : _options$specs,
          _options$styles = options.styles,
          styles = _options$styles === undefined ? defaultStyles : _options$styles,
          _options$timeout = options.timeout,
          timeout = _options$timeout === undefined ? defaultTimeout : _options$timeout,
          _options$autoClose = options.autoClose,
          autoClose = _options$autoClose === undefined ? defaultAutoClose : _options$autoClose,
          _options$windowTitle = options.windowTitle,
          windowTitle = _options$windowTitle === undefined ? defaultWindowTitle : _options$windowTitle;


      if (localOptions.name) name = localOptions.name;
      if (localOptions.specs) specs = localOptions.specs;
      if (localOptions.styles) styles = localOptions.styles;
      if (localOptions.timeout) timeout = localOptions.timeout;
      if (localOptions.autoClose) autoClose = localOptions.autoClose;
      if (localOptions.windowTitle) windowTitle = localOptions.windowTitle;

      specs = !!specs.length ? specs.join(',') : '';

      var element = el;
      if (typeof el === 'string' || el instanceof String) {
        element = window.document.getElementById(el);
      }
      if (!element) {
        alert('Element to print #' + el + ' not found!');
        return;
      }

      var url = '';
      var win = window.open(url, name, specs);

      win.document.write('\n        <html>\n          <head>\n            <title>' + windowTitle + '</title>\n          </head>\n          <body>\n            ' + element.innerHTML + '\n          </body>\n        </html>\n      ');

      addStyles(win, styles);

      var promise = new Promise(function (resolve) {
        setTimeout(function () {
          win.focus();
          win.print();
          autoClose && win.document.close();
          autoClose && win.close();
          if (cb) cb();
          resolve();
        }, timeout);
      });

      return cb ? true : promise;
    };
  }
};

exports.default = VueHtmlToPaper;

/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderDates_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df4166c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderDates_vue__ = __webpack_require__(1836);
function injectStyle (ssrContext) {
  __webpack_require__(1834)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderDates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df4166c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderDates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1835);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("b382d524", content, true, {});

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm._f("moment")(_vm.getDate(_vm.orderData),'YYYY-MM-DD hh:mm A'))+"\n  "),_c('div',{staticClass:"hover-content"},[_c('div',{staticClass:"popover-arrow"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Order Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.getOrderDate(_vm.orderData),'YYYY-MM-DD hh:mm A')))])]),_vm._v(" "),(_vm.orderData.pending_answer_at)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_answer_at)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Pending Answer Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.pending_answer_at,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.process_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.process_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Process Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.process_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.cancel_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.cancel_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Cancel Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.cancel_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.confirm_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.confirm_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Approve Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.confirm_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.refund_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.refund_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Refund Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.refund_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.purchase_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.purchase_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Purchase Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.purchase_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.warehouse_deliver_date || _vm.orderData.pending_to_shipment)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.warehouse_deliver_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Warehouse Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.warehouse_deliver_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_shipment_at)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_shipment_at)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Pending Shipment Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.pending_to_shipment_at,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.int_shipment_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.int_shipment_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Shipment Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.int_shipment_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_branch_at)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_branch_at)?_c('div',{staticClass:"d-flex my-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.pending_to_branch_at,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.branch_delivery_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.branch_delivery_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Delivered to Erbil")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.branch_delivery_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e(),_vm._v(" "),(_vm.orderData.deliver_date)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.deliver_date)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Delivered Date")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.orderData.deliver_date,'YYYY-MM-DD hh:mm A')))])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"40%"}},[_c('div',[_vm._v("Pending To Branch")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewStepsDates_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29794244_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewStepsDates_vue__ = __webpack_require__(1840);
function injectStyle (ssrContext) {
  __webpack_require__(1838)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewStepsDates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29794244_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewStepsDates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1839);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2490da09", content, true, {});

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hover-steps-content"},[_c('div',{staticClass:"popover-steps-arrow"},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("moment")(_vm.date,'YYYY-MM-DD hh:mm A')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderUsers_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212cda3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderUsers_vue__ = __webpack_require__(1844);
function injectStyle (ssrContext) {
  __webpack_require__(1842)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_viewOrderUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212cda3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_viewOrderUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("ad15762a", content, true, {});

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.getUser(_vm.orderData))+"\n  "),_c('div',{staticClass:"hover-content",staticStyle:{"width":"350px !important","left":"130px !important"}},[_c('div',{staticClass:"popover-arrow-left"},[_vm._v(" ")]),_vm._v(" "),(_vm.orderData.ordered_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Ordered By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.ordered_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.ordered_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.shiponlied_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.shiponlied_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Ship Only By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.shiponlied_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.shiponlied_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.pending_answer_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_answer_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Pending Answered By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.pending_answer_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.pending_answer_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.processed_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.processed_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Processed By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.processed_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.processed_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.canceled_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.canceled_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Canceled By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.canceled_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.canceled_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.approved_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.approved_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Approved By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.approved_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.approved_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.refunded_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.refunded_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Refunded By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.refunded_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.refunded_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.purchased_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.purchased_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Purchased By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.purchased_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.purchased_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.warehouse_delivered_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.warehouse_delivered_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Warehoused By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.warehouse_delivered_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.warehouse_delivered_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.pending_shipmented_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_shipmented_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Pending Shipped By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.pending_shipmented_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.pending_shipmented_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.shipmented_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.shipmented_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Shipped By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.shipmented_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.shipmented_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_branch_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.pending_to_branch_by)?_c('div',{staticClass:"d-flex my-2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.pending_to_branch_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.pending_to_branch_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.branch_delivered_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.branch_delivered_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Brand Delivered By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.branch_delivered_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.branch_delivered_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.delivered_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.delivered_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Delivered By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.delivered_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.delivered_by.user_id))])])]):_vm._e(),_vm._v(" "),(_vm.orderData.archived_by)?_c('div',{staticStyle:{"border-bottom":"1px dashed #ddd"}}):_vm._e(),_vm._v(" "),(_vm.orderData.archived_by)?_c('div',{staticClass:"d-flex my-2"},[_c('div',{staticStyle:{"width":"40%"}},[_vm._v("Archived By")]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.orderData.archived_by.full_name)+" "),_c('span',{staticClass:"pl-1",staticStyle:{"opacity":"0.7","font-size":"12px"}},[_vm._v("#"+_vm._s(_vm.orderData.archived_by.user_id))])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"40%"}},[_c('div',[_vm._v("Pending To Branch By")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_openWhatsAppAndViber_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6359d7da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_openWhatsAppAndViber_vue__ = __webpack_require__(1846);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_openWhatsAppAndViber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6359d7da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_openWhatsAppAndViber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.phoneNumber)?_c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"d-inline"},[_c('img',{staticClass:"mx-1",staticStyle:{"width":"18px"},attrs:{"src":__webpack_require__(21),"alt":"whatsapp"},on:{"click":function($event){return _vm.openWhatsApp()}}})]),_vm._v(" "),_c('div',{staticClass:"d-inline"},[_c('img',{staticClass:"mx-1",staticStyle:{"width":"18px"},attrs:{"src":__webpack_require__(1847),"alt":"whatsapp"},on:{"click":function($event){return _vm.openViber()}}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icons8-viber-480.png?e18e88b1ec5c199715015437e8794f2c";

/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    $_image_path: function $_image_path() {
      return window.location.origin.includes('localhost') ? 'http://localhost:8081/images/' : window.location.origin + '/images/';
    },
    $_has_perm: function $_has_perm(permissionCode) {
      var authUserPermissions = JSON.parse(localStorage.getItem('user_permissions'));

      for (var index in authUserPermissions) {
        if (permissionCode === authUserPermissions[index].code) {
          return true;
        }
      }

      return false;
    }
  }
});

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BranchSelect_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc560906_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BranchSelect_vue__ = __webpack_require__(1850);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BranchSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc560906_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BranchSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSelect)?_c('v-select',{attrs:{"items":_vm.branchesList,"autocomplete":"","hide-details":_vm.hideDetails,"label":_vm.label,"clearable":_vm.clearable,"disabled":_vm.disabled},model:{value:(_vm.branchId),callback:function ($$v) {_vm.branchId=$$v},expression:"branchId"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayBranch_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288ce1bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayBranch_vue__ = __webpack_require__(1852);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayBranch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_288ce1bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayBranch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.order_branch_name),expression:"data.order_branch_name"}],staticClass:"text-nowrap py-1"},[_c('span',{staticClass:"text--secondary"},[_vm._v("Order branch:")]),_vm._v("\n    "+_vm._s(_vm.data.order_branch_name)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.approve_branch_name),expression:"data.approve_branch_name"}],staticClass:"text-nowrap pb-1"},[_c('span',{staticClass:"text--secondary"},[_vm._v("Approve branch:")]),_vm._v("\n    "+_vm._s(_vm.data.approve_branch_name)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.deliver_branch_name),expression:"data.deliver_branch_name"}],staticClass:"text-nowrap pb-1"},[_c('span',{staticClass:"text--secondary"},[_vm._v("Deliver branch:")]),_vm._v("\n    "+_vm._s(_vm.data.deliver_branch_name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderImages_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f648812_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderImages_vue__ = __webpack_require__(1856);
function injectStyle (ssrContext) {
  __webpack_require__(1854)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f648812"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orderImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f648812_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_orderImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1855);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("005a781a", content, true, {});

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xs-4 col-sm-3 col-md-3 mb-4"},[_c('div',{staticClass:"d-flex",staticStyle:{"height":"150px","border":"1px dashed #bbb","border-radius":"6px","flex-wrap":"wrap"}},[_c('v-btn',{staticClass:"white--text my-3",staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"grey darken-3"},on:{"click":function($event){_vm.takePhotoModal = true}}},[_c('i',{staticClass:"fa fa-camera pr-2"}),_vm._v("\n          Take Photo\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text my-3",staticStyle:{"height":"auto"},attrs:{"depressed":"","color":"blue darken-3"},on:{"click":function($event){return _vm.openExplorer()}}},[_c('i',{staticClass:"fa fa-cloud-upload pr-2"}),_vm._v("\n          Upload Photo\n        ")]),_vm._v(" "),_c('input',{ref:"uploadPhotoRef",staticStyle:{"position":"absolute","visibility":"hidden","top":"-99999px"},attrs:{"type":"file","accept":"image/*"},on:{"input":function($event){return _vm.saveUploadedImage()}}})],1)]),_vm._v(" "),(_vm.formData.image)?_c('div',{staticClass:"col-12 col-xs-4 col-sm-3 col-md-3 mb-4",staticStyle:{"cursor":"pointer","position":"relative"}},[_c('img',{staticStyle:{"border-radius":"4px","object-fit":"cover"},attrs:{"src":_vm.formData.image.startsWith('http') ? _vm.formData.image : ("" + (_vm.$_image_path()) + (_vm.formData.image)),"alt":"Image","width":"100%","height":"150px"},on:{"click":function($event){return _vm.showImage(_vm.formData.image, true)}}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.images),function(img,i){return _c('div',{key:i,staticClass:"col-12 col-xs-4 col-sm-3 col-md-3 mb-4",staticStyle:{"cursor":"pointer","position":"relative"}},[_c('img',{staticStyle:{"border-radius":"4px","object-fit":"cover"},attrs:{"src":img[_vm.filenameKey] && img[_vm.filenameKey].startsWith('http') ? img[_vm.filenameKey] : ("" + (_vm.$_image_path()) + (img[_vm.filenameKey])),"alt":"Image","width":"100%","height":"150px"},on:{"click":function($event){return _vm.showImage(img)}}}),_vm._v(" "),_c('button',{staticClass:"error pa-2 d-flex align-center",staticStyle:{"border-radius":"50%","height":"30px","width":"30px","position":"absolute","top":"-10px","right":"0px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteImage(img)}}},[_c('i',{staticClass:"fa fa-trash fa-lg white--text"})])])})],2),_vm._v(" "),_c('take-photo',{attrs:{"takePhotoModal":_vm.takePhotoModal,"orderData":_vm.formData,"url":_vm.url,"filenameKey":_vm.filenameKey,"modelFk":_vm.modelFk,"modelPk":_vm.modelPk},on:{"close":function($event){_vm.takePhotoModal = false},"photo-saved":function($event){return _vm.getFiles()}}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"600"},model:{value:(_vm.imageDialog),callback:function ($$v) {_vm.imageDialog=$$v},expression:"imageDialog"}},[_c('v-card',[_c('img',{attrs:{"src":_vm.image && _vm.image.startsWith('http') ? _vm.image : ("" + (_vm.$_image_path()) + _vm.image),"alt":"","width":"100%"}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ebdca9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__ = __webpack_require__(1860);
function injectStyle (ssrContext) {
  __webpack_require__(1858)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22ebdca9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ebdca9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1859);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("5bd66ee9", content, true, {});

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".comment-aside[data-v-22ebdca9]{padding:0!important}.comment-container[data-v-22ebdca9]{height:100vh;position:relative}.comment-title[data-v-22ebdca9]{position:sticky;top:0}.comment-actions[data-v-22ebdca9]{position:absolute;bottom:0;width:100%}a[data-v-22ebdca9]{position:relative}a[tooltip][data-v-22ebdca9]:hover:after{content:attr(tooltip);padding:8px 12px;color:#fff;position:absolute;right:0;bottom:160%;white-space:nowrap;z-index:20;-moz-border-radius:4px;-webkit-border-radius:4px;border-radius:4px;-moz-box-shadow:0 0 2px #484b4e;-webkit-box-shadow:0 0 2px #484b4e;box-shadow:0 0 2px #484b4e;background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,#484b4e),color-stop(1,#484b4e));background-image:-webkit-linear-gradient(top,#484b4e,#484b4e);background-image:-moz-linear-gradient(top,#484b4e,#484b4e);background-image:-ms-linear-gradient(top,#484b4e,#484b4e);background-image:-o-linear-gradient(top,#484b4e,#484b4e)}", ""]);

// exports


/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"tooltip":"Comments"},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_c('i',{staticClass:"fa fa-commenting cyan--text ",staticStyle:{"font-size":"22px"}})]),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"comment-aside",attrs:{"fixed":"","temporary":"","width":"450","right":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('div',{staticClass:"comment-container"},[_c('div',{staticClass:"py-2 px-4 black--text comment-title",staticStyle:{"font-size":"2rem","border-bottom":"1px solid #ccc"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"82vh","overflow-y":"scroll"},attrs:{"id":"comment-panel"}},[_c('div',{staticClass:"row"},_vm._l((_vm.comments),function(comment){return _c('div',{key:comment.id,staticClass:"col-12 pb-3 pl-1 pr-3"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"pr-1",staticStyle:{"width":"35px"}},[_c('v-avatar',{attrs:{"color":_vm.avatarColor(comment),"size":"30"}},[_c('span',{staticClass:"white--text text-bold",staticStyle:{"font-size":"1.5rem"}},[_vm._v("\n                    "+_vm._s(comment.user.full_name[0])+"\n                  ")])])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"grey lighten-3 pa-2 px-3",staticStyle:{"border-radius":"6px","font-size":"1.5rem"}},[_c('div',{staticClass:"text-bold mb-1"},[_vm._v("\n                    "+_vm._s(comment.user.full_name)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"black--text"},[_vm._v("\n                    "+_vm._s(comment.description)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"text-caption dir-ltr d-inline-block pl-2 text--secondary"},[_vm._v("\n                  "+_vm._s(_vm._f("moment")(comment.created_at,'YYYY-MM-DD hh:mm a'))+"\n                ")])])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"pa-3 comment-actions"},[_c('div',{staticClass:"d-flex",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control grey lighten-3",staticStyle:{"font-size":"1.5rem","border-radius":"4px"},attrs:{"id":"comment-input-field","rows":"3","placeholder":"Your comment..."},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"45px"}},[_c('button',{staticClass:"blue white--text pt-1 pl-1",staticStyle:{"border-radius":"50%","width":"35px","height":"35px","position":"absolute","bottom":"0","right":"0px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.storeComment()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("send")])])])])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ON_INPUT_COMPLETE_EVENT = "onComplete";
var ON_INPUT_CHANGE_EVENT = "onChange";
var script = {
  name: "VueOtp2",
  props: ["length", "joinCharacter", "inputmode", "pattern"],
  data: function data() {
    return {
      otpLength: +this.length || 6,
      inputMode: this.inputmode || "numeric",
      inputPattern: this.pattern || "[0-9]*",
      character: this.joinCharacter,
      otp: [],
      currentInputCursorIndex: 0,
      inputRefs: [],
      isDeleteKey: false // emulator delete key

    };
  },

  mounted: function mounted() {
    this.initInputRefs(this.otpLength);
    this.initOtpLength(this.otpLength);
  },


  computed: {
    currentOtpLength: function currentOtpLength() {
      return this.otp.filter(function (item) {
        return item;
      }).length;
    }
  },
  methods: {
    handleInput: function handleInput(e) {
      // fix samsung keyboard with keyCode on press not working normally
      var keyData = e.data;
      var keyCode = keyData ? keyData.charCodeAt(0) : 0;
      return this.isDeletePress(keyCode) ? this.onDelete() : this.onType(keyData);
    },
    handleKeyup: function handleKeyup() {
      if (this.isDeleteKey) {
        this.prevInput();
      }

      this.riseChangeIsDeleteKey(true);
    },
    isDeletePress: function isDeletePress(keyCode) {
      return keyCode === 0;
    },
    onType: function onType(keyData) {
      this.clearSoftAfterInput(this.currentInputCursorIndex);
      this.riseChangeOtp(this.currentInputCursorIndex, keyData);
      this.fillInputValue(this.currentInputCursorIndex, this.otp[this.currentInputCursorIndex]); // continue if input has value

      this.getInputValue(this.currentInputCursorIndex) && this.nextInput();
      this.riseChangeIsDeleteKey(false);
    },
    onDelete: function onDelete() {
      // this.otp[this.currentInputCursorIndex]
      //   ? this.removeInputValue(this.inputRefs[this.currentInputCursorIndex])
      //   : this.prevInput();
      if (this.otp[this.currentInputCursorIndex]) {
        this.removeInputValue(this.inputRefs[this.currentInputCursorIndex]);
      } else {
        this.prevInput();
        this.riseChangeIsDeleteKey(true);
      } // if press delete, delete all after input


      this.clearSoftAfterInput(this.currentInputCursorIndex);
    },
    riseChangeOtp: function riseChangeOtp(index, data) {
      this.otp.splice(index, 1, data);
    },
    riseChangeIsDeleteKey: function riseChangeIsDeleteKey(data) {
      this.isDeleteKey = !!data;
    },
    handleFocus: function handleFocus(e, i) {
      e.target.select();
      var inputFilled = this.otp.filter(function (item) {
        return item;
      }).length;
      this.currentInputCursorIndex = i > inputFilled ? inputFilled : i;
      this.focusInput(this.inputRefs[this.currentInputCursorIndex]);
    },
    initInputRefs: function initInputRefs(inputNums) {
      var i = 0;

      while (i < inputNums) {
        this.inputRefs = [].concat(_toConsumableArray(this.inputRefs), [this.$refs["input" + i]]);
        i++;
      }
    },
    initOtpLength: function initOtpLength(length) {
      var i = 0;

      while (i < length) {
        this.otp = [].concat(_toConsumableArray(this.otp), [null]);
        i++;
      }
    },
    changeInputCursor: function changeInputCursor(idx) {
      this.currentInputCursorIndex = idx;
    },
    nextInputCursor: function nextInputCursor(currentIdx) {
      var index = currentIdx < this.otpLength - 1 ? currentIdx + 1 : this.otpLength - 1;
      this.changeInputCursor(index);
    },
    prevInputCursor: function prevInputCursor(currentIdx) {
      var index = currentIdx > 0 ? currentIdx - 1 : 0;
      this.changeInputCursor(index);
    },
    nextInput: function nextInput() {
      this.nextInputCursor(this.currentInputCursorIndex);
      this.focusInput(this.inputRefs[this.currentInputCursorIndex]);
    },
    prevInput: function prevInput() {
      this.prevInputCursor(this.currentInputCursorIndex);
      this.focusInput(this.inputRefs[this.currentInputCursorIndex]);
    },
    focusInput: function focusInput(inputRefs) {
      inputRefs && inputRefs[0] && inputRefs[0].focus();
    },
    blurInput: function blurInput(inputRefs) {
      inputRefs && inputRefs[0] && inputRefs[0].blur();
    },
    removeInputValue: function removeInputValue(inputRefs) {
      inputRefs && inputRefs[0] && function () {
        return inputRefs[0].value = null;
      }();
    },
    getInputValue: function getInputValue(idx) {
      return this.inputRefs[idx] && this.inputRefs[idx][0] && this.inputRefs[idx][0].value;
    },
    fillInputValue: function fillInputValue(idx, value) {
      if (this.inputRefs[idx] && this.inputRefs[idx][0]) {
        this.inputRefs[idx][0].value = value;
      }
    },
    validKeyCode: function validKeyCode(code) {
      var isLetter = code >= 65 && code <= 90;
      var isLowercaseLetter = code >= 97 && code <= 122;
      var isNumber = code >= 48 && code <= 57;
      var isDelete = code === 0;
      return isNumber || isLetter || isLowercaseLetter || isDelete;
    },
    clearAfterInput: function clearAfterInput(idx) {
      var _otp;

      (_otp = this.otp).splice.apply(_otp, [idx, this.otpLength - idx].concat(_toConsumableArray(Array(this.otpLength - idx).fill(null))));

      while (idx < this.otpLength) {
        this.removeInputValue(this.inputRefs[idx]);
        idx++;
      }
    },
    clearSoftAfterInput: function clearSoftAfterInput(idx) {
      if (idx < 0) idx = 0;

      while (idx < this.otpLength) {
        this.otp[idx] = null;
        this.removeInputValue(this.inputRefs[idx]);
        idx++;
      }
    },
    emitEvent: function emitEvent(eventName, payload) {
      this.$emit(eventName, payload);
    },
    emitEventChange: function emitEventChange(payload) {
      this.emitEvent(ON_INPUT_CHANGE_EVENT, payload);
    },
    emitEventComplete: function emitEventComplete(payload) {
      this.emitEvent(ON_INPUT_COMPLETE_EVENT, payload);
    }
  },
  watch: {
    otp: function otp() {
      var otpLength = this.currentOtpLength;
      var idxCanGet = otpLength === this.otpLength ? this.currentInputCursorIndex : this.currentInputCursorIndex - 1; // onchange

      if (otpLength || otpLength === this.otpLength - 1) {
        var dataChange = {
          index: idxCanGet,
          value: this.otp[idxCanGet]
        };
        this.emitEventChange(dataChange);
      } // on complete


      if (otpLength === this.otpLength) {
        this.emitEventComplete([].concat(_toConsumableArray(this.otp)));
        this.blurInput(this.inputRefs[this.otpLength - 1]);
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  var options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  var hook = void 0;
  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = void 0;
var styles = {};
function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;
    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
      // http://stackoverflow.com/a/26603875
      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }
    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }
      HEAD.appendChild(style.element);
    }
    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-otp-2"
  }, _vm._l(_vm.otpLength * 2 - 1, function (v, i) {
    return _c('div', {
      key: i / 2
    }, [i % 2 === 0 ? _c('input', {
      ref: 'input' + i / 2,
      refInFor: true,
      attrs: {
        "minlength": "1",
        "maxlength": "1",
        "type": "text",
        "inputmode": _vm.inputMode,
        "pattern": _vm.inputPattern
      },
      on: {
        "input": _vm.handleInput,
        "keyup": _vm.handleKeyup,
        "focus": function focus($event) {
          return _vm.handleFocus($event, i / 2);
        }
      }
    }) : _vm._e(), _vm._v(" "), i % 2 !== 0 && true ? _c('span', [_vm._v(_vm._s(_vm.character))]) : _vm._e()]);
  }), 0);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-10e5d926_0", {
    source: ".vue-otp-2[data-v-10e5d926]{display:flex;justify-content:space-between}.vue-otp-2 div[data-v-10e5d926]{flex:1;display:flex;align-items:center;justify-content:center}.vue-otp-2 div input[data-v-10e5d926]{max-width:30px;padding:11.5px 8px;font-size:20px;border-radius:3px;border:1px solid #cecece;text-align:center}.vue-otp-2 div span[data-v-10e5d926]{display:block;flex:1;text-align:center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */

var __vue_scope_id__ = "data-v-10e5d926";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

var install = function installVueOtp2(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueOtp2', __vue_component__);
}; // Create module definition for Vue.use()


var plugin = {
  install: install
}; // To auto-install when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
} // Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

/* harmony default export */ __webpack_exports__["a"] = (__vue_component__);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16)))

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! hellojs v1.16.1 | (c) 2012-2017 Andrew Dodson | MIT https://adodson.com/hello.js/LICENSE */
Object.create||(Object.create=function(){function e(){}return function(t){if(1!=arguments.length)throw new Error("Object.create implementation only accepts one parameter.");return e.prototype=t,new e}}()),Object.keys||(Object.keys=function(e,t,n){n=[];for(t in e)n.hasOwnProperty.call(e,t)&&n.push(t);return n}),Array.prototype.indexOf||(Array.prototype.indexOf=function(e){for(var t=0;t<this.length;t++)if(this[t]===e)return t;return-1}),Array.prototype.forEach||(Array.prototype.forEach=function(e){if(void 0===this||null===this)throw new TypeError;var t=Object(this),n=t.length>>>0;if("function"!=typeof e)throw new TypeError;for(var i=arguments.length>=2?arguments[1]:void 0,o=0;o<n;o++)o in t&&e.call(i,t[o],o,t);return this}),Array.prototype.filter||(Array.prototype.filter=function(e,t){var n=[];return this.forEach(function(i,o,a){e.call(t||void 0,i,o,a)&&n.push(i)}),n}),Array.prototype.map||(Array.prototype.map=function(e,t){var n=[];return this.forEach(function(i,o,a){n.push(e.call(t||void 0,i,o,a))}),n}),Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),"object"!=typeof window||"object"!=typeof window.location||window.location.assign||(window.location.assign=function(e){window.location=e}),Function.prototype.bind||(Function.prototype.bind=function(e){function t(){}if("function"!=typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var n=[].slice,i=n.call(arguments,1),o=this,a=function(){return o.apply(this instanceof t?this:e||window,i.concat(n.call(arguments)))};return t.prototype=this.prototype,a.prototype=new t,a});var hello=function(e){return hello.use(e)};hello.utils={extend:function(e){return Array.prototype.slice.call(arguments,1).forEach(function(t){if(Array.isArray(e)&&Array.isArray(t))Array.prototype.push.apply(e,t);else if(e&&(e instanceof Object||"object"==typeof e)&&t&&(t instanceof Object||"object"==typeof t)&&e!==t)for(var n in t)e[n]=hello.utils.extend(e[n],t[n]);else Array.isArray(t)&&(t=t.slice(0)),e=t}),e}},hello.utils.extend(hello,{settings:{redirect_uri:window.location.href.split("#")[0],response_type:"token",display:"popup",state:"",oauth_proxy:"https://auth-server.herokuapp.com/proxy",timeout:2e4,popup:{resizable:1,scrollbars:1,width:500,height:550},scope:["basic"],scope_map:{basic:""},default_service:null,force:null,page_uri:window.location.href},services:{},use:function(e){var t=Object.create(this);return t.settings=Object.create(this.settings),e&&(t.settings.default_service=e),t.utils.Event.call(t),t},init:function(e,t){var n=this.utils;if(!e)return this.services;for(var i in e)e.hasOwnProperty(i)&&"object"!=typeof e[i]&&(e[i]={id:e[i]});return n.extend(this.services,e),t&&(n.extend(this.settings,t),"redirect_uri"in t&&(this.settings.redirect_uri=n.url(t.redirect_uri).href)),this},login:function(){function e(e,t){hello.emit(e,t)}function t(e){return e}function n(e){return!!e}var i,o=this.utils,a=o.error,r=o.Promise(),s=o.args({network:"s",options:"o",callback:"f"},arguments),l=o.diffKey(s.options,this.settings),u=s.options=o.merge(this.settings,s.options||{});if(u.popup=o.merge(this.settings.popup,s.options.popup||{}),s.network=s.network||this.settings.default_service,r.proxy.then(s.callback,s.callback),r.proxy.then(e.bind(this,"auth.login auth"),e.bind(this,"auth.failed auth")),"string"!=typeof s.network||!(s.network in this.services))return r.reject(a("invalid_network","The provided network was not recognized"));var c=this.services[s.network],f=o.globalEvent(function(e){var t;(t=e?JSON.parse(e):a("cancelled","The authentication was not completed")).error?r.reject(t):(o.store(t.network,t),r.fulfill({network:t.network,authResponse:t}))}),d=o.url(u.redirect_uri).href,p=c.oauth.response_type||u.response_type;/\bcode\b/.test(p)&&!c.oauth.grant&&(p=p.replace(/\bcode\b/,"token")),s.qs=o.merge(l,{client_id:encodeURIComponent(c.id),response_type:encodeURIComponent(p),redirect_uri:encodeURIComponent(d),state:{client_id:c.id,network:s.network,display:u.display,callback:f,state:u.state,redirect_uri:d}});var h=o.store(s.network),m=/[,\s]+/,g=this.settings.scope?[this.settings.scope.toString()]:[],v=o.merge(this.settings.scope_map,c.scope||{});if(u.scope&&g.push(u.scope.toString()),h&&"scope"in h&&h.scope instanceof String&&g.push(h.scope),g=g.join(",").split(m),g=o.unique(g).filter(n),s.qs.state.scope=g.join(","),g=g.map(function(e){return e in v?v[e]:e}),g=g.join(",").split(m),g=o.unique(g).filter(n),s.qs.scope=g.join(c.scope_delim||","),!1===u.force&&h&&"access_token"in h&&h.access_token&&"expires"in h&&h.expires>(new Date).getTime()/1e3){if(0===o.diff((h.scope||"").split(m),(s.qs.state.scope||"").split(m)).length)return r.fulfill({unchanged:!0,network:s.network,authResponse:h}),r}if("page"===u.display&&u.page_uri&&(s.qs.state.page_uri=o.url(u.page_uri).href),"login"in c&&"function"==typeof c.login&&c.login(s),(!/\btoken\b/.test(p)||parseInt(c.oauth.version,10)<2||"none"===u.display&&c.oauth.grant&&h&&h.refresh_token)&&(s.qs.state.oauth=c.oauth,s.qs.state.oauth_proxy=u.oauth_proxy),s.qs.state=encodeURIComponent(JSON.stringify(s.qs.state)),1===parseInt(c.oauth.version,10)?i=o.qs(u.oauth_proxy,s.qs,t):"none"===u.display&&c.oauth.grant&&h&&h.refresh_token?(s.qs.refresh_token=h.refresh_token,i=o.qs(u.oauth_proxy,s.qs,t)):i=o.qs(c.oauth.auth,s.qs,t),e("auth.init",s),"none"===u.display)o.iframe(i,d);else if("popup"===u.display)var y=o.popup(i,d,u.popup),w=setInterval(function(){if((!y||y.closed)&&(clearInterval(w),!r.state)){var e=a("cancelled","Login has been cancelled");y||(e=a("blocked","Popup was blocked")),e.network=s.network,r.reject(e)}},100);else window.location=i;return r.proxy},logout:function(){function e(e,t){hello.emit(e,t)}var t=this.utils,n=t.error,i=t.Promise(),o=t.args({name:"s",options:"o",callback:"f"},arguments);if(o.options=o.options||{},i.proxy.then(o.callback,o.callback),i.proxy.then(e.bind(this,"auth.logout auth"),e.bind(this,"error")),o.name=o.name||this.settings.default_service,o.authResponse=t.store(o.name),!o.name||o.name in this.services)if(o.name&&o.authResponse){var a=function(e){t.store(o.name,null),i.fulfill(hello.utils.merge({network:o.name},e||{}))},r={};if(o.options.force){var s=this.services[o.name].logout;if(s)if("function"==typeof s&&(s=s(a,o)),"string"==typeof s)t.iframe(s),r.force=null,r.message="Logout success on providers site was indeterminate";else if(void 0===s)return i.proxy}a(r)}else i.reject(n("invalid_session","There was no session to remove"));else i.reject(n("invalid_network","The network was unrecognized"));return i.proxy},getAuthResponse:function(e){return(e=e||this.settings.default_service)&&e in this.services?this.utils.store(e)||null:null},events:{}}),hello.utils.extend(hello.utils,{error:function(e,t){return{error:{code:e,message:t}}},qs:function(e,t,n){if(t){n=n||encodeURIComponent;for(var i in t){var o="([\\?\\&])"+i+"=[^\\&]*",a=new RegExp(o);e.match(a)&&(e=e.replace(a,"$1"+i+"="+n(t[i])),delete t[i])}}return this.isEmpty(t)?e:e+(e.indexOf("?")>-1?"&":"?")+this.param(t,n)},param:function(e,t){var n,i,o={};if("string"==typeof e){if(t=t||decodeURIComponent,i=e.replace(/^[\#\?]/,"").match(/([^=\/\&]+)=([^\&]+)/g))for(var a=0;a<i.length;a++)o[(n=i[a].match(/([^=]+)=(.*)/))[1]]=t(n[2]);return o}t=t||encodeURIComponent;var r=e;o=[];for(var s in r)r.hasOwnProperty(s)&&r.hasOwnProperty(s)&&o.push([s,"?"===r[s]?"?":t(r[s])].join("="));return o.join("&")},store:function(){for(var e,t=["localStorage","sessionStorage"],n=-1;t[++n];)try{(e=window[t[n]]).setItem("test"+n,n),e.removeItem("test"+n);break}catch(t){e=null}if(!e){var i=null;e={getItem:function(e){e+="=";for(var t=document.cookie.split(";"),n=0;n<t.length;n++){var o=t[n].replace(/(^\s+|\s+$)/,"");if(o&&0===o.indexOf(e))return o.substr(e.length)}return i},setItem:function(e,t){i=t,document.cookie=e+"="+t}},i=e.getItem("hello")}return function(t,n,i){var o=function(){var t={};try{t=JSON.parse(e.getItem("hello"))||{}}catch(e){}return t}();if(t&&void 0===n)return o[t]||null;if(t&&null===n)try{delete o[t]}catch(e){o[t]=null}else{if(!t)return o;o[t]=n}return function(t){e.setItem("hello",JSON.stringify(t))}(o),o||null}}(),append:function(e,t,n){var i="string"==typeof e?document.createElement(e):e;if("object"==typeof t)if("tagName"in t)n=t;else for(var o in t)if(t.hasOwnProperty(o))if("object"==typeof t[o])for(var a in t[o])t[o].hasOwnProperty(a)&&(i[o][a]=t[o][a]);else"html"===o?i.innerHTML=t[o]:/^on/.test(o)?i[o]=t[o]:i.setAttribute(o,t[o]);return"body"===n?function e(){document.body?document.body.appendChild(i):setTimeout(e,16)}():"object"==typeof n?n.appendChild(i):"string"==typeof n&&document.getElementsByTagName(n)[0].appendChild(i),i},iframe:function(e){this.append("iframe",{src:e,style:{position:"absolute",left:"-1000px",bottom:0,height:"1px",width:"1px"}},"body")},merge:function(){var e=Array.prototype.slice.call(arguments);return e.unshift({}),this.extend.apply(null,e)},args:function(e,t){var n={},i=0,o=null,a=null;for(a in e)if(e.hasOwnProperty(a))break;if(1===t.length&&"object"==typeof t[0]&&"o!"!=e[a])for(a in t[0])if(e.hasOwnProperty(a)&&a in e)return t[0];for(a in e)if(e.hasOwnProperty(a))if(o=typeof t[i],"function"==typeof e[a]&&e[a].test(t[i])||"string"==typeof e[a]&&(e[a].indexOf("s")>-1&&"string"===o||e[a].indexOf("o")>-1&&"object"===o||e[a].indexOf("i")>-1&&"number"===o||e[a].indexOf("a")>-1&&"object"===o||e[a].indexOf("f")>-1&&"function"===o))n[a]=t[i++];else if("string"==typeof e[a]&&e[a].indexOf("!")>-1)return!1;return n},url:function(e){if(e){if(window.URL&&URL instanceof Function&&0!==URL.length)return new URL(e,window.location);var t=document.createElement("a");return t.href=e,t.cloneNode(!1)}return window.location},diff:function(e,t){return t.filter(function(t){return-1===e.indexOf(t)})},diffKey:function(e,t){if(e||!t){var n={};for(var i in e)i in t||(n[i]=e[i]);return n}return e},unique:function(e){return Array.isArray(e)?e.filter(function(t,n){return e.indexOf(t)===n}):[]},isEmpty:function(e){if(!e)return!0;if(Array.isArray(e))return!e.length;if("object"==typeof e)for(var t in e)if(e.hasOwnProperty(t))return!1;return!0},Promise:function(){var e=function(t){if(!(this instanceof e))return new e(t);this.id="Thenable/1.0.6",this.state=0,this.fulfillValue=void 0,this.rejectReason=void 0,this.onFulfilled=[],this.onRejected=[],this.proxy={then:this.then.bind(this)},"function"==typeof t&&t.call(this,this.fulfill.bind(this),this.reject.bind(this))};e.prototype={fulfill:function(e){return t(this,1,"fulfillValue",e)},reject:function(e){return t(this,2,"rejectReason",e)},then:function(t,i){var a=new e;return this.onFulfilled.push(o(t,a,"fulfill")),this.onRejected.push(o(i,a,"reject")),n(this),a.proxy}};var t=function(e,t,i,o){return 0===e.state&&(e.state=t,e[i]=o,n(e)),e},n=function(e){1===e.state?i(e,"onFulfilled",e.fulfillValue):2===e.state&&i(e,"onRejected",e.rejectReason)},i=function(e,t,n){if(0!==e[t].length){var i=e[t];e[t]=[];var o=function(){for(var e=0;e<i.length;e++)i[e](n)};"object"==typeof process&&"function"==typeof process.nextTick?process.nextTick(o):"function"==typeof setImmediate?setImmediate(o):setTimeout(o,0)}},o=function(e,t,n){return function(i){if("function"!=typeof e)t[n].call(t,i);else{var o;try{o=e(i)}catch(e){return void t.reject(e)}a(t,o)}}},a=function(e,t){if(e!==t&&e.proxy!==t){var n;if("object"==typeof t&&null!==t||"function"==typeof t)try{n=t.then}catch(t){return void e.reject(t)}if("function"!=typeof n)e.fulfill(t);else{var i=!1;try{n.call(t,function(n){i||(i=!0,n===t?e.reject(new TypeError("circular thenable chain")):a(e,n))},function(t){i||(i=!0,e.reject(t))})}catch(t){i||e.reject(t)}}}else e.reject(new TypeError("cannot resolve promise with itself"))};return e}(),Event:function(){var e=/[\s\,]+/;return this.parent={events:this.events,findEvents:this.findEvents,parent:this.parent,utils:this.utils},this.events={},this.on=function(t,n){if(n&&"function"==typeof n)for(var i=t.split(e),o=0;o<i.length;o++)this.events[i[o]]=[n].concat(this.events[i[o]]||[]);return this},this.off=function(e,t){return this.findEvents(e,function(e,n){t&&this.events[e][n]!==t||(this.events[e][n]=null)}),this},this.emit=function(e){var t=Array.prototype.slice.call(arguments,1);t.push(e);for(var n=function(n,i){t[t.length-1]="*"===n?e:n,this.events[n][i].apply(this,t)},i=this;i&&i.findEvents;)i.findEvents(e+",*",n),i=i.parent;return this},this.emitAfter=function(){var e=this,t=arguments;return setTimeout(function(){e.emit.apply(e,t)},0),this},this.findEvents=function(t,n){var i=t.split(e);for(var o in this.events)if(this.events.hasOwnProperty(o)&&i.indexOf(o)>-1)for(var a=0;a<this.events[o].length;a++)this.events[o][a]&&n.call(this,o,a)},this},globalEvent:function(e,t){return t=t||"_hellojs_"+parseInt(1e12*Math.random(),10).toString(36),window[t]=function(){try{e.apply(this,arguments)&&delete window[t]}catch(e){console.error(e)}},t},popup:function(e,t,n){var i=document.documentElement;if(n.height){var o=void 0!==window.screenTop?window.screenTop:screen.top,a=screen.height||window.innerHeight||i.clientHeight;n.top=n.top?n.top:parseInt((a-n.height)/2,10)+o}if(n.width){var r=void 0!==window.screenLeft?window.screenLeft:screen.left,s=screen.width||window.innerWidth||i.clientWidth;n.left=n.left?n.left:parseInt((s-n.width)/2,10)+r}var l=[];Object.keys(n).forEach(function(e){var t=n[e];l.push(e+(null!==t?"="+t:""))}),-1!==navigator.userAgent.indexOf("Safari")&&-1===navigator.userAgent.indexOf("Chrome")&&(e=t+"#oauth_redirect="+encodeURIComponent(encodeURIComponent(e)));var u=window.open(e,"_blank",l.join(","));return u&&u.focus&&u.focus(),u},responseHandler:function(e,t){function n(e,t,n){var a=e.callback,s=e.network;if(r.store(s,e),!("display"in e&&"page"===e.display)){if(n&&a&&a in n){try{delete e.callback}catch(e){}r.store(s,e);var l=JSON.stringify(e);try{i(n,a)(l)}catch(e){}}o()}}function i(e,t){return 0!==t.indexOf("_hellojs_")?function(){throw"Could not execute callback "+t}:e[t]}function o(){if(e.frameElement)t.document.body.removeChild(e.frameElement);else{try{e.close()}catch(e){}e.addEventListener&&e.addEventListener("load",function(){e.close()})}}var a,r=this,s=e.location;if((a=r.param(s.search))&&a.state&&(a.code||a.oauth_token)){var l=JSON.parse(a.state);a.redirect_uri=l.redirect_uri||s.href.replace(/[\?\#].*$/,"");var u=r.qs(l.oauth_proxy,a);s.assign(u)}else if((a=r.merge(r.param(s.search||""),r.param(s.hash||"")))&&"state"in a){try{var c=JSON.parse(a.state);r.extend(a,c)}catch(e){var f=decodeURIComponent(a.state);try{var d=JSON.parse(f);r.extend(a,d)}catch(e){console.error("Could not decode state parameter")}}if("access_token"in a&&a.access_token&&a.network)a.expires_in&&0!==parseInt(a.expires_in,10)||(a.expires_in=0),a.expires_in=parseInt(a.expires_in,10),a.expires=(new Date).getTime()/1e3+(a.expires_in||31536e3),n(a,0,t);else if("error"in a&&a.error&&a.network)a.error={code:a.error,message:a.error_message||a.error_description},n(a,0,t);else if(a.callback&&a.callback in t){var p=!!("result"in a&&a.result)&&JSON.parse(a.result);i(t,a.callback)(p),o()}a.page_uri&&s.assign(a.page_uri)}else if("oauth_redirect"in a)return void s.assign(decodeURIComponent(a.oauth_redirect))}}),hello.utils.Event.call(hello),function(e){var t={},n={};e.on("auth.login, auth.logout",function(n){n&&"object"==typeof n&&n.network&&(t[n.network]=e.utils.store(n.network)||{})}),function i(){var o=(new Date).getTime()/1e3,a=function(t){e.emit("auth."+t,{network:r,authResponse:s})};for(var r in e.services)if(e.services.hasOwnProperty(r)){if(!e.services[r].id)continue;var s=e.utils.store(r)||{},l=e.services[r],u=t[r]||{};if(s&&"callback"in s){var c=s.callback;try{delete s.callback}catch(e){}e.utils.store(r,s);try{window[c](s)}catch(e){}}if(s&&"expires"in s&&s.expires<o){var f=l.refresh||s.refresh_token;!f||r in n&&!(n[r]<o)?f||r in n||(a("expired"),n[r]=!0):(e.emit("notice",r+" has expired trying to resignin"),e.login(r,{display:"none",force:!1}),n[r]=o+600);continue}if(u.access_token===s.access_token&&u.expires===s.expires)continue;!s.access_token&&u.access_token?a("logout"):s.access_token&&!u.access_token?a("login"):s.expires!==u.expires&&a("update"),t[r]=s,r in n&&delete n[r]}setTimeout(i,1e3)}()}(hello),hello.api=function(){function e(e){(e=e.replace(/\@\{([a-z\_\-]+)(\|.*?)?\}/gi,function(e,t,a){var r=a?a.replace(/^\|/,""):"";return t in o.query?(r=o.query[t],delete o.query[t]):o.data&&t in o.data?(r=o.data[t],delete o.data[t]):a||i.reject(n("missing_attribute","The attribute "+t+" is missing from the request")),r})).match(/^https?:\/\//)||(e=l.base+e),o.url=e,t.request(o,function(e,n){if(o.formatResponse){if(!0===e?e={success:!0}:e||(e={}),"delete"===o.method&&(e=!e||t.isEmpty(e)?{success:!0}:e),l.wrap&&(o.path in l.wrap||"default"in l.wrap)){var a=o.path in l.wrap?o.path:"default",r=((new Date).getTime(),l.wrap[a](e,n,o));r&&(e=r)}e&&"paging"in e&&e.paging.next&&("?"===e.paging.next[0]?e.paging.next=o.path+e.paging.next:e.paging.next+="#"+o.path),!e||"error"in e?i.reject(e):i.fulfill(e)}else("object"==typeof n?n.statusCode>=400:"object"==typeof e&&"error"in e)?i.reject(e):i.fulfill(e)})}var t=this.utils,n=t.error,i=t.Promise(),o=t.args({path:"s!",query:"o",method:"s",data:"o",timeout:"i",callback:"f"},arguments);o.method=(o.method||"get").toLowerCase(),o.headers=o.headers||{},o.query=o.query||{},"get"!==o.method&&"delete"!==o.method||(t.extend(o.query,o.data),o.data={});var a=o.data=o.data||{};if(i.then(o.callback,o.callback),!o.path)return i.reject(n("invalid_path","Missing the path parameter from the request"));o.path=o.path.replace(/^\/+/,"");var r=(o.path.split(/[\/\:]/,2)||[])[0].toLowerCase();if(r in this.services){o.network=r;var s=new RegExp("^"+r+":?/?");o.path=o.path.replace(s,"")}o.network=this.settings.default_service=o.network||this.settings.default_service;var l=this.services[o.network];if(!l)return i.reject(n("invalid_network","Could not match the service requested: "+o.network));if(o.method in l&&o.path in l[o.method]&&!1===l[o.method][o.path])return i.reject(n("invalid_path","The provided path is not available on the selected network"));o.oauth_proxy||(o.oauth_proxy=this.settings.oauth_proxy),"proxy"in o||(o.proxy=o.oauth_proxy&&l.oauth&&1===parseInt(l.oauth.version,10)),"timeout"in o||(o.timeout=this.settings.timeout),"formatResponse"in o||(o.formatResponse=!0),o.authResponse=this.getAuthResponse(o.network),o.authResponse&&o.authResponse.access_token&&(o.query.access_token=o.authResponse.access_token);var u,c=o.path;o.options=t.clone(o.query),o.data=t.clone(a);var f=l[{delete:"del"}[o.method]||o.method]||{};if("get"===o.method){var d=c.split(/[\?#]/)[1];d&&(t.extend(o.query,t.param(d)),c=c.replace(/\?.*?(#|$)/,"$1"))}return(u=c.match(/#(.+)/,""))?(c=c.split("#")[0],o.path=u[1]):c in f?(o.path=c,c=f[c]):"default"in f&&(c=f.default),o.redirect_uri=this.settings.redirect_uri,o.xhr=l.xhr,o.jsonp=l.jsonp,o.form=l.form,"function"==typeof c?c(o,e):e(c),i.proxy},hello.utils.extend(hello.utils,{request:function(e,t){function n(e,t){var n;e.authResponse&&e.authResponse.oauth&&1===parseInt(e.authResponse.oauth.version,10)&&(n=e.query.access_token,delete e.query.access_token,e.proxy=!0),!e.data||"get"!==e.method&&"delete"!==e.method||(i.extend(e.query,e.data),e.data=null);var o=i.qs(e.url,e.query);e.proxy&&(o=i.qs(e.oauth_proxy,{path:o,access_token:n||"",then:e.proxy_response_type||("get"===e.method.toLowerCase()?"redirect":"proxy"),method:e.method.toLowerCase(),suppress_response_codes:!0})),t(o)}var i=this,o=i.error;i.isEmpty(e.data)||"FileList"in window||!i.hasBinary(e.data)||(e.xhr=!1,e.jsonp=!1);if(this.request_cors(function(){return void 0===e.xhr||e.xhr&&("function"!=typeof e.xhr||e.xhr(e,e.query))}))n(e,function(n){var o=i.xhr(e.method,n,e.headers,e.data,t);o.onprogress=e.onprogress||null,o.upload&&e.onuploadprogress&&(o.upload.onprogress=e.onuploadprogress)});else{var a=e.query;if(e.query=i.clone(e.query),e.callbackID=i.globalEvent(),!1!==e.jsonp){if(e.query.callback=e.callbackID,"function"==typeof e.jsonp&&e.jsonp(e,e.query),"get"===e.method)return void n(e,function(n){i.jsonp(n,t,e.callbackID,e.timeout)});e.query=a}if(!1!==e.form){e.query.redirect_uri=e.redirect_uri,e.query.state=JSON.stringify({callback:e.callbackID});var r;if("function"==typeof e.form&&(r=e.form(e,e.query)),"post"===e.method&&!1!==r)return void n(e,function(n){i.post(n,e.data,r,t,e.callbackID,e.timeout)})}t(o("invalid_request","There was no mechanism for handling this request"))}},request_cors:function(e){return"withCredentials"in new XMLHttpRequest&&e()},domInstance:function(e,t){var n="HTML"+(e||"").replace(/^[a-z]/,function(e){return e.toUpperCase()})+"Element";return!!t&&(window[n]?t instanceof window[n]:window.Element?t instanceof window.Element&&(!e||t.tagName&&t.tagName.toLowerCase()===e):!(t instanceof Object||t instanceof Array||t instanceof String||t instanceof Number)&&t.tagName&&t.tagName.toLowerCase()===e)},clone:function(e){if(null===e||"object"!=typeof e||e instanceof Date||"nodeName"in e||this.isBinary(e)||"function"==typeof FormData&&e instanceof FormData)return e;if(Array.isArray(e))return e.map(this.clone.bind(this));var t={};for(var n in e)t[n]=this.clone(e[n]);return t},xhr:function(e,t,n,i,o){var a=new XMLHttpRequest,r=this.error,s=!1;"blob"===e&&(s=e,e="GET"),e=e.toUpperCase(),a.onload=function(t){var n=a.response;try{n=JSON.parse(a.responseText)}catch(e){401===a.status&&(n=r("access_denied",a.statusText))}var i=function(e){for(var t,n={},i=/([a-z\-]+):\s?(.*);?/gi;t=i.exec(e);)n[t[1]]=t[2];return n}(a.getAllResponseHeaders());i.statusCode=a.status,o(n||("GET"===e?r("empty_response","Could not get resource"):{}),i)},a.onerror=function(e){var t=a.responseText;try{t=JSON.parse(a.responseText)}catch(e){}o(t||r("access_denied","Could not get resource"))};var l;if("GET"===e||"DELETE"===e)i=null;else if(i&&"string"!=typeof i&&!(i instanceof FormData)&&!(i instanceof File)&&!(i instanceof Blob)){var u=new FormData;for(l in i)i.hasOwnProperty(l)&&(i[l]instanceof HTMLInputElement?"files"in i[l]&&i[l].files.length>0&&u.append(l,i[l].files[0]):i[l]instanceof Blob?u.append(l,i[l],i.name):u.append(l,i[l]));i=u}if(a.open(e,t,!0),s&&("responseType"in a?a.responseType=s:a.overrideMimeType("text/plain; charset=x-user-defined")),n)for(l in n)a.setRequestHeader(l,n[l]);return a.send(i),a},jsonp:function(e,t,n,i){var o,a=this.error,r=0,s=document.getElementsByTagName("head")[0],l=a("server_error","server_error"),u=function(){r++||window.setTimeout(function(){t(l),s.removeChild(c)},0)};n=this.globalEvent(function(e){return l=e,!0},n),e=e.replace(new RegExp("=\\?(&|$)"),"="+n+"$1");var c=this.append("script",{id:n,name:n,src:e,async:!0,onload:u,onerror:u,onreadystatechange:function(){/loaded|complete/i.test(this.readyState)&&u()}});window.navigator.userAgent.toLowerCase().indexOf("opera")>-1&&(o=this.append("script",{text:"document.getElementById('"+n+"').onerror();"}),c.async=!1),i&&window.setTimeout(function(){l=a("timeout","timeout"),u()},i),s.appendChild(c),o&&s.appendChild(o)},post:function(e,t,n,i,o,a){var r,s=this.error,l=document,u=null,c=[],f=0,d=null,p=0,h=function(e){p++||i(e)};this.globalEvent(h,o);var m;try{m=l.createElement('<iframe name="'+o+'">')}catch(e){m=l.createElement("iframe")}if(m.name=o,m.id=o,m.style.display="none",n&&n.callbackonload&&(m.onload=function(){h({response:"posted",message:"Content was posted"})}),a&&setTimeout(function(){h(s("timeout","The post operation timed out"))},a),l.body.appendChild(m),this.domInstance("form",t)){for(u=t.form,f=0;f<u.elements.length;f++)u.elements[f]!==t&&u.elements[f].setAttribute("disabled",!0);t=u}if(this.domInstance("form",t))for(u=t,f=0;f<u.elements.length;f++)u.elements[f].disabled||"file"!==u.elements[f].type||(u.encoding=u.enctype="multipart/form-data",u.elements[f].setAttribute("name","file"));else{for(d in t)t.hasOwnProperty(d)&&this.domInstance("input",t[d])&&"file"===t[d].type&&((u=t[d].form).encoding=u.enctype="multipart/form-data");u||(u=l.createElement("form"),l.body.appendChild(u),r=u);var g;for(d in t)if(t.hasOwnProperty(d)){var v=this.domInstance("input",t[d])||this.domInstance("textArea",t[d])||this.domInstance("select",t[d]);if(v&&t[d].form===u)v&&t[d].name!==d&&(t[d].setAttribute("name",d),t[d].name=d);else{var y=u.elements[d];if(g)for(y instanceof NodeList||(y=[y]),f=0;f<y.length;f++)y[f].parentNode.removeChild(y[f]);(g=l.createElement("input")).setAttribute("type","hidden"),g.setAttribute("name",d),v?g.value=t[d].value:this.domInstance(null,t[d])?g.value=t[d].innerHTML||t[d].innerText:g.value=t[d],u.appendChild(g)}}for(f=0;f<u.elements.length;f++)(g=u.elements[f]).name in t||!0===g.getAttribute("disabled")||(g.setAttribute("disabled",!0),c.push(g))}u.setAttribute("method","POST"),u.setAttribute("target",o),u.target=o,u.setAttribute("action",e),setTimeout(function(){u.submit(),setTimeout(function(){try{r&&r.parentNode.removeChild(r)}catch(e){try{console.error("HelloJS: could not remove iframe")}catch(e){}}for(var e=0;e<c.length;e++)c[e]&&(c[e].setAttribute("disabled",!1),c[e].disabled=!1)},0)},100)},hasBinary:function(e){for(var t in e)if(e.hasOwnProperty(t)&&this.isBinary(e[t]))return!0;return!1},isBinary:function(e){return e instanceof Object&&(this.domInstance("input",e)&&"file"===e.type||"FileList"in window&&e instanceof window.FileList||"File"in window&&e instanceof window.File||"Blob"in window&&e instanceof window.Blob)},toBlob:function(e){var t=/^data\:([^;,]+(\;charset=[^;,]+)?)(\;base64)?,/i,n=e.match(t);if(!n)return e;for(var i=atob(e.replace(t,"")),o=[],a=0;a<i.length;a++)o.push(i.charCodeAt(a));return new Blob([new Uint8Array(o)],{type:n[1]})}}),function(e){var t=e.api,n=e.utils;n.extend(n,{dataToJSON:function(e){var t=window,n=e.data;if(this.domInstance("form",n)?n=this.nodeListToJSON(n.elements):"NodeList"in t&&n instanceof NodeList?n=this.nodeListToJSON(n):this.domInstance("input",n)&&(n=this.nodeListToJSON([n])),("File"in t&&n instanceof t.File||"Blob"in t&&n instanceof t.Blob||"FileList"in t&&n instanceof t.FileList)&&(n={file:n}),!("FormData"in t&&n instanceof t.FormData))for(var i in n)if(n.hasOwnProperty(i))if("FileList"in t&&n[i]instanceof t.FileList)1===n[i].length&&(n[i]=n[i][0]);else{if(this.domInstance("input",n[i])&&"file"===n[i].type)continue;this.domInstance("input",n[i])||this.domInstance("select",n[i])||this.domInstance("textArea",n[i])?n[i]=n[i].value:this.domInstance(null,n[i])&&(n[i]=n[i].innerHTML||n[i].innerText)}return e.data=n,n},nodeListToJSON:function(e){for(var t={},n=0;n<e.length;n++){var i=e[n];!i.disabled&&i.name&&("file"===i.type?t[i.name]=i:t[i.name]=i.value||i.innerHTML)}return t}}),e.api=function(){var e=n.args({path:"s!",method:"s",data:"o",timeout:"i",callback:"f"},arguments);return e.data&&n.dataToJSON(e),t.call(this,e)}}(hello),hello.utils.responseHandler(window,window.opener||window.parent),"object"==typeof chrome&&"object"==typeof chrome.identity&&chrome.identity.launchWebAuthFlow&&function(){function e(t,n){var i={closed:!1};return chrome.identity.launchWebAuthFlow({url:t,interactive:n},function(t){if(void 0!==t){var n=hello.utils.url(t),o={location:{assign:function(t){e(t,!1)},search:n.search,hash:n.hash,href:n.href},close:function(){}};hello.utils.responseHandler(o,window)}else i.closed=!0}),i}hello.utils.popup=function(t){return e(t,!0)},hello.utils.iframe=function(t){e(t,!1)},hello.utils.request_cors=function(e){return e(),!0};var t={};chrome.storage.local.get("hello",function(e){t=e.hello||{}}),hello.utils.store=function(e,n){return 0===arguments.length?t:1===arguments.length?t[e]||null:n?(t[e]=n,chrome.storage.local.set({hello:t}),n):null===n?(delete t[e],chrome.storage.local.set({hello:t}),null):void 0}}(),function(){if(/^file:\/{3}[^\/]/.test(window.location.href)&&window.cordova){hello.utils.iframe=function(e,t){hello.utils.popup(e,t,{hidden:"yes"})};var e=hello.utils.popup;hello.utils.popup=function(t,n,i){var o=e.call(this,t,n,i);try{if(o&&o.addEventListener){var a=hello.utils.url(n),r=a.origin||a.protocol+"//"+a.hostname;o.addEventListener("loadstart",function(e){var t=e.url;if(0===t.indexOf(r)){var n=hello.utils.url(t),i={location:{assign:function(e){o.executeScript({code:'window.location.href = "'+e+';"'})},search:n.search,hash:n.hash,href:n.href},close:function(){if(o.close){o.close();try{o.closed=!0}catch(e){}}}};hello.utils.responseHandler(i,window)}})}}catch(e){}return o}}}(),function(e){function t(e){e&&"error"in e&&(e.error={code:"server_error",message:e.error.message||e.error})}function n(t,n,i){if(!("object"!=typeof t||"undefined"!=typeof Blob&&t instanceof Blob||"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer||"error"in t)){var o=("app_folder"!==t.root?t.root:"")+t.path.replace(/\&/g,"%26");o=o.replace(/^\//,""),t.thumb_exists&&(t.thumbnail=i.oauth_proxy+"?path="+encodeURIComponent("https://api-content.dropbox.com/1/thumbnails/auto/"+o+"?format=jpeg&size=m")+"&access_token="+i.options.access_token),t.type=t.is_dir?"folder":t.mime_type,t.name=t.path.replace(/.*\//g,""),t.is_dir?t.files=o.replace(/^\//,""):(t.downloadLink=e.settings.oauth_proxy+"?path="+encodeURIComponent("https://api-content.dropbox.com/1/files/auto/"+o)+"&access_token="+i.options.access_token,t.file="https://api-content.dropbox.com/1/files/auto/"+o),t.id||(t.id=t.path.replace(/^\//,""))}}function i(e){return function(t,n){delete t.query.limit,n(e)}}var o={version:"1.0",auth:"https://www.dropbox.com/1/oauth/authorize",request:"https://api.dropbox.com/1/oauth/request_token",token:"https://api.dropbox.com/1/oauth/access_token"},a={version:2,auth:"https://www.dropbox.com/1/oauth2/authorize",grant:"https://api.dropbox.com/1/oauth2/token"};e.init({dropbox:{name:"Dropbox",oauth:a,login:function(t){t.qs.scope="";var n=decodeURIComponent(t.qs.redirect_uri);0===n.indexOf("http:")&&0!==n.indexOf("http://localhost/")?e.services.dropbox.oauth=o:e.services.dropbox.oauth=a,t.options.popup.width=1e3,t.options.popup.height=1e3},base:"https://api.dropbox.com/1/",root:"sandbox",get:{me:"account/info","me/files":i("metadata/auto/@{parent|}"),"me/folder":i("metadata/auto/@{id}"),"me/folders":i("metadata/auto/"),default:function(e,t){e.path.match("https://api-content.dropbox.com/1/files/")&&(e.method="blob"),t(e.path)}},post:{"me/files":function(t,n){var i=t.data.parent,o=t.data.name;t.data={file:t.data.file},"string"==typeof t.data.file&&(t.data.file=e.utils.toBlob(t.data.file)),n("https://api-content.dropbox.com/1/files_put/auto/"+i+"/"+o)},"me/folders":function(t,n){var i=t.data.name;t.data={},n("fileops/create_folder?root=@{root|sandbox}&"+e.utils.param({path:i}))}},del:{"me/files":"fileops/delete?root=@{root|sandbox}&path=@{id}","me/folder":"fileops/delete?root=@{root|sandbox}&path=@{id}"},wrap:{me:function(e){if(t(e),!e.uid)return e;e.name=e.display_name;var n=e.name.split(" ");return e.first_name=n.shift(),e.last_name=n.join(" "),e.id=e.uid,delete e.uid,delete e.display_name,e},default:function(e,i,o){return t(e),e.is_dir&&e.contents&&(e.data=e.contents,delete e.contents,e.data.forEach(function(t){t.root=e.root,n(t,0,o)})),n(e,0,o),e.is_deleted&&(e.success=!0),e}},xhr:function(e){if(e.data&&e.data.file){var t=e.data.file;t&&(t.files?e.data=t.files[0]:e.data=t)}return"delete"===e.method&&(e.method="post"),!0},form:function(e,t){delete t.state,delete t.redirect_uri}}})}(hello),function(e){function t(e){return e.id&&(e.thumbnail=e.picture="https://graph.facebook.com/"+e.id+"/picture"),e}function n(e){return"data"in e&&e.data.forEach(t),e}function i(e,t,n){if("boolean"==typeof e&&(e={success:e}),e&&"data"in e){var i=n.query.access_token;if(!(e.data instanceof Array)){var a=e.data;delete e.data,e.data=[a]}e.data.forEach(function(e){e.picture&&(e.thumbnail=e.picture),e.pictures=(e.images||[]).sort(function(e,t){return e.width-t.width}),e.cover_photo&&e.cover_photo.id&&(e.thumbnail=o+e.cover_photo.id+"/picture?access_token="+i),"album"===e.type&&(e.files=e.photos=o+e.id+"/photos"),e.can_upload&&(e.upload_location=o+e.id+"/photos")})}return e}e.init({facebook:{name:"Facebook",oauth:{version:2,auth:"https://www.facebook.com/v2.9/dialog/oauth/",grant:"https://graph.facebook.com/oauth/access_token"},scope:{basic:"public_profile",email:"email",share:"user_posts",birthday:"user_birthday",events:"user_events",photos:"user_photos",videos:"user_videos",friends:"user_friends",files:"user_photos,user_videos",publish_files:"user_photos,user_videos,publish_actions",publish:"publish_actions",offline_access:""},refresh:!1,login:function(e){e.options.force&&(e.qs.auth_type="reauthenticate"),e.qs.display=e.options.display||"popup"},logout:function(t,n){var i=e.utils.globalEvent(t),o=encodeURIComponent(e.settings.redirect_uri+"?"+e.utils.param({callback:i,result:JSON.stringify({force:!0}),state:"{}"})),a=(n.authResponse||{}).access_token;if(e.utils.iframe("https://www.facebook.com/logout.php?next="+o+"&access_token="+a),!a)return!1},base:"https://graph.facebook.com/v2.9/",get:{me:"me?fields=email,first_name,last_name,name,timezone,verified","me/friends":"me/friends","me/following":"me/friends","me/followers":"me/friends","me/share":"me/feed","me/like":"me/likes","me/files":"me/albums","me/albums":"me/albums?fields=cover_photo,name","me/album":"@{id}/photos?fields=picture","me/photos":"me/photos","me/photo":"@{id}","friend/albums":"@{id}/albums","friend/photos":"@{id}/photos"},post:{"me/share":"me/feed","me/photo":"@{id}"},wrap:{me:t,"me/friends":n,"me/following":n,"me/followers":n,"me/albums":i,"me/photos":i,"me/files":i,default:i},xhr:function(t,n){return"get"!==t.method&&"post"!==t.method||(n.suppress_response_codes=!0),"post"===t.method&&t.data&&"string"==typeof t.data.file&&(t.data.file=e.utils.toBlob(t.data.file)),!0},jsonp:function(t,n){var i=t.method;"get"===i||e.utils.hasBinary(t.data)?"delete"===t.method&&(n.method="delete",t.method="post"):(t.data.method=i,t.method="get")},form:function(e){return{callbackonload:!0}}}});var o="https://graph.facebook.com/"}(hello),function(e){function t(t,n,i){var o=(i?"":"flickr:")+"?method="+t+"&api_key="+e.services.flickr.id+"&format=json";for(var a in n)n.hasOwnProperty(a)&&(o+="&"+a+"="+n[a]);return o}function n(n,i){return i||(i={}),function(o,a){!function(t){var n=e.getAuthResponse("flickr");t(n&&n.user_nsid?n.user_nsid:null)}(function(e){i.user_id=e,a(t(n,i,!0))})}}function i(e,t){var n="https://www.flickr.com/images/buddyicon.gif";return e.nsid&&e.iconserver&&e.iconfarm&&(n="https://farm"+e.iconfarm+".staticflickr.com/"+e.iconserver+"/buddyicons/"+e.nsid+(t?"_"+t:"")+".jpg"),n}function o(e,t,n,i,o){return o=o?"_"+o:"","https://farm"+t+".staticflickr.com/"+n+"/"+e+"_"+i+o+".jpg"}function a(e){e&&e.stat&&"ok"!=e.stat.toLowerCase()&&(e.error={code:"invalid_request",message:e.message})}function r(e){if(e.photoset||e.photos){u(e=s(e,"photoset"in e?"photoset":"photos")),e.data=e.photo,delete e.photo;for(var t=0;t<e.data.length;t++){var n=e.data[t];n.name=n.title,n.picture=o(n.id,n.farm,n.server,n.secret,""),n.pictures=function(e,t,n,i){return[{id:"t",max:100},{id:"m",max:240},{id:"n",max:320},{id:"",max:500},{id:"z",max:640},{id:"c",max:800},{id:"b",max:1024},{id:"h",max:1600},{id:"k",max:2048},{id:"o",max:2048}].map(function(a){return{source:o(e,t,n,i,a.id),width:a.max,height:a.max}})}(n.id,n.farm,n.server,n.secret),n.source=o(n.id,n.farm,n.server,n.secret,"b"),n.thumbnail=o(n.id,n.farm,n.server,n.secret,"m")}}return e}function s(e,t){return t in e?e=e[t]:"error"in e||(e.error={code:"invalid_request",message:e.message||"Failed to get data from Flickr"}),e}function l(e){if(a(e),e.contacts){u(e=s(e,"contacts")),e.data=e.contact,delete e.contact;for(var t=0;t<e.data.length;t++){var n=e.data[t];n.id=n.nsid,n.name=n.realname||n.username,n.thumbnail=i(n,"m")}}return e}function u(e){e.page&&e.pages&&e.page!==e.pages&&(e.paging={next:"?page="+ ++e.page})}e.init({flickr:{name:"Flickr",oauth:{version:"1.0a",auth:"https://www.flickr.com/services/oauth/authorize?perms=read",request:"https://www.flickr.com/services/oauth/request_token",token:"https://www.flickr.com/services/oauth/access_token"},base:"https://api.flickr.com/services/rest",get:{me:n("flickr.people.getInfo"),"me/friends":n("flickr.contacts.getList",{per_page:"@{limit|50}"}),"me/following":n("flickr.contacts.getList",{per_page:"@{limit|50}"}),"me/followers":n("flickr.contacts.getList",{per_page:"@{limit|50}"}),"me/albums":n("flickr.photosets.getList",{per_page:"@{limit|50}"}),"me/album":n("flickr.photosets.getPhotos",{photoset_id:"@{id}"}),"me/photos":n("flickr.people.getPhotos",{per_page:"@{limit|50}"})},wrap:{me:function(e){if(a(e),(e=s(e,"person")).id){if(e.realname){e.name=e.realname._content;var t=e.name.split(" ");e.first_name=t.shift(),e.last_name=t.join(" ")}e.thumbnail=i(e,"l"),e.picture=i(e,"l")}return e},"me/friends":l,"me/followers":l,"me/following":l,"me/albums":function(e){return a(e),e=s(e,"photosets"),u(e),e.photoset&&(e.data=e.photoset,e.data.forEach(function(e){e.name=e.title._content,e.photos="https://api.flickr.com/services/rest"+t("flickr.photosets.getPhotos",{photoset_id:e.id},!0)}),delete e.photoset),e},"me/photos":function(e){return a(e),r(e)},default:function(e){return a(e),r(e)}},xhr:!1,jsonp:function(e,t){"get"==e.method&&(delete t.callback,t.jsoncallback=e.callbackID)}}})}(hello),function(e){function t(e){!e.meta||400!==e.meta.code&&401!==e.meta.code||(e.error={code:"access_denied",message:e.meta.errorDetail})}function n(e){e&&e.id&&(e.thumbnail=e.photo.prefix+"100x100"+e.photo.suffix,e.name=e.firstName+" "+e.lastName,e.first_name=e.firstName,e.last_name=e.lastName,e.contact&&e.contact.email&&(e.email=e.contact.email))}function i(e,t){var n=t.access_token;return delete t.access_token,t.oauth_token=n,t.v=20121125,!0}hello.init({foursquare:{name:"Foursquare",oauth:{version:2,auth:"https://foursquare.com/oauth2/authenticate",grant:"https://foursquare.com/oauth2/access_token"},refresh:!0,base:"https://api.foursquare.com/v2/",get:{me:"users/self","me/friends":"users/self/friends","me/followers":"users/self/friends","me/following":"users/self/friends"},wrap:{me:function(e){return t(e),e&&e.response&&n(e=e.response.user),e},default:function(e){return t(e),e&&"response"in e&&"friends"in e.response&&"items"in e.response.friends&&(e.data=e.response.friends.items,e.data.forEach(n),delete e.response),e}},xhr:i,jsonp:i}})}(),function(e){function t(e,t){var n=t?t.statusCode:e&&"meta"in e&&"status"in e.meta&&e.meta.status;401!==n&&403!==n||(e.error={code:"access_denied",message:e.message||(e.data?e.data.message:"Could not get response")},delete e.message)}function n(e){e.id&&(e.thumbnail=e.picture=e.avatar_url,e.name=e.login)}hello.init({github:{name:"GitHub",oauth:{version:2,auth:"https://github.com/login/oauth/authorize",grant:"https://github.com/login/oauth/access_token",response_type:"code"},scope:{email:"user:email"},base:"https://api.github.com/",get:{me:"user","me/friends":"user/following?per_page=@{limit|100}","me/following":"user/following?per_page=@{limit|100}","me/followers":"user/followers?per_page=@{limit|100}","me/like":"user/starred?per_page=@{limit|100}"},wrap:{me:function(e,i){return t(e,i),n(e),e},default:function(e,i,o){return t(e,i),Array.isArray(e)&&(e={data:e}),e.data&&(!function(e,t,n){if(e.data&&e.data.length&&t&&t.Link){var i=t.Link.match(/<(.*?)>;\s*rel=\"next\"/);i&&(e.paging={next:i[1]})}}(e,i),e.data.forEach(n)),e}},xhr:function(e){return"get"!==e.method&&e.data&&(e.headers=e.headers||{},e.headers["Content-Type"]="application/json","object"==typeof e.data&&(e.data=JSON.stringify(e.data))),!0}}})}(),function(e){function t(e){return parseInt(e,10)}function n(e){return u(e),e.data=e.items,delete e.items,e}function i(e){if(!e.error)return e.name||(e.name=e.title||e.message),e.picture||(e.picture=e.thumbnailLink),e.thumbnail||(e.thumbnail=e.thumbnailLink),"application/vnd.google-apps.folder"===e.mimeType&&(e.type="folder",e.files="https://www.googleapis.com/drive/v2/files?q=%22"+e.id+"%22+in+parents"),e}function o(e){return{source:e.url,width:e.width,height:e.height}}function a(e){if(u(e),"feed"in e&&"entry"in e.feed)e.data=e.feed.entry.map(l),delete e.feed;else{if("entry"in e)return l(e.entry);"items"in e?(e.data=e.items.map(i),delete e.items):i(e)}return e}function r(e){e.name=e.displayName||e.name,e.picture=e.picture||(e.image?e.image.url:null),e.thumbnail=e.picture}function s(e,t,n){u(e);if("feed"in e&&"entry"in e.feed){for(var i=n.query.access_token,o=0;o<e.feed.entry.length;o++){var a=e.feed.entry[o];if(a.id=a.id.$t,a.name=a.title.$t,delete a.title,a.gd$email&&(a.email=a.gd$email&&a.gd$email.length>0?a.gd$email[0].address:null,a.emails=a.gd$email,delete a.gd$email),a.updated&&(a.updated=a.updated.$t),a.link){var r=a.link.length>0?a.link[0].href:null;r&&a.link[0].gd$etag&&(r+=(r.indexOf("?")>-1?"&":"?")+"access_token="+i,a.picture=r,a.thumbnail=r),delete a.link}a.category&&delete a.category}e.data=e.feed.entry,delete e.feed}return e}function l(e){var t,n=e.media$group,i=n.media$content.length?n.media$content[0]:{},a=n.media$content||[],r=n.media$thumbnail||[],s=a.concat(r).map(o).sort(function(e,t){return e.width-t.width}),l=0,u={id:e.id.$t,name:e.title.$t,description:e.summary.$t,updated_time:e.updated.$t,created_time:e.published.$t,picture:i?i.url:null,pictures:s,images:[],thumbnail:i?i.url:null,width:i.width,height:i.height};if("link"in e)for(l=0;l<e.link.length;l++){var c=e.link[l];if(c.rel.match(/\#feed$/)){u.upload_location=u.files=u.photos=c.href;break}}if("category"in e&&e.category.length)for(t=e.category,l=0;l<t.length;l++)t[l].scheme&&t[l].scheme.match(/\#kind$/)&&(u.type=t[l].term.replace(/^.*?\#/,""));return"media$thumbnail"in n&&n.media$thumbnail.length&&(t=n.media$thumbnail,u.thumbnail=t[0].url,u.images=t.map(o)),(t=n.media$content)&&t.length&&u.images.push(o(t[0])),u}function u(e){if("feed"in e&&e.feed.openSearch$itemsPerPage){var n=t(e.feed.openSearch$itemsPerPage.$t),i=t(e.feed.openSearch$startIndex.$t);i+n<t(e.feed.openSearch$totalResults.$t)&&(e.paging={next:"?start="+(i+n)})}else"nextPageToken"in e&&(e.paging={next:"?pageToken="+e.nextPageToken})}function c(e,t){var n={};e.data&&"undefined"!=typeof HTMLInputElement&&e.data instanceof HTMLInputElement&&(e.data={file:e.data}),!e.data.name&&Object(Object(e.data.file).files).length&&"post"===e.method&&(e.data.name=e.data.file.files[0].name),"post"===e.method?e.data={title:e.data.name,parents:[{id:e.data.parent||"root"}],file:e.data.file}:(n=e.data,e.data={},n.parent&&(e.data.parents=[{id:e.data.parent||"root"}]),n.file&&(e.data.file=n.file),n.name&&(e.data.title=n.name));var i;if("file"in e.data&&(i=e.data.file,delete e.data.file,"object"==typeof i&&"files"in i&&(i=i.files),!i||!i.length))t({error:{code:"request_invalid",message:"There were no files attached with this request to upload"}});else{var o=new function(){function e(e){var n=new FileReader;n.onload=function(n){t(btoa(n.target.result),e.type+a+"Content-Transfer-Encoding: base64")},n.readAsBinaryString(e)}function t(e,t){n.push(a+"Content-Type: "+t+a+a+e),o--,s()}var n=[],i=(1e10*Math.random()).toString(32),o=0,a="\r\n",r=a+"--"+i,s=function(){},l=/^data\:([^;,]+(\;charset=[^;,]+)?)(\;base64)?,/i;this.append=function(n,i){"string"!=typeof n&&"length"in Object(n)||(n=[n]);for(var r=0;r<n.length;r++){o++;var s=n[r];if("undefined"!=typeof File&&s instanceof File||"undefined"!=typeof Blob&&s instanceof Blob)e(s);else if("string"==typeof s&&s.match(l)){var u=s.match(l);t(s.replace(l,""),u[1]+a+"Content-Transfer-Encoding: base64")}else t(s,i)}},this.onready=function(e){(s=function(){0===o&&(n.unshift(""),n.push("--"),e(n.join(r),i),n=[])})()}};o.append(JSON.stringify(e.data),"application/json"),i&&o.append(i),o.onready(function(i,o){e.headers["content-type"]='multipart/related; boundary="'+o+'"',e.data=i,t("upload/drive/v2/files"+(n.id?"/"+n.id:"")+"?uploadType=multipart")})}}var f="https://www.google.com/m8/feeds/contacts/default/full?v=3.0&alt=json&max-results=@{limit|1000}&start-index=@{start|1}";e.init({google:{name:"Google Plus",oauth:{version:2,auth:"https://accounts.google.com/o/oauth2/auth",grant:"https://accounts.google.com/o/oauth2/token"},scope:{basic:"https://www.googleapis.com/auth/plus.me profile",email:"email",birthday:"",events:"",photos:"https://picasaweb.google.com/data/",videos:"http://gdata.youtube.com",friends:"https://www.google.com/m8/feeds, https://www.googleapis.com/auth/plus.login",files:"https://www.googleapis.com/auth/drive.readonly",publish:"",publish_files:"https://www.googleapis.com/auth/drive",share:"",create_event:"",offline_access:""},scope_delim:" ",login:function(e){"code"===e.qs.response_type&&(e.qs.access_type="offline"),e.options.force&&(e.qs.approval_prompt="force")},base:"https://www.googleapis.com/",get:{me:"plus/v1/people/me","me/friends":"plus/v1/people/me/people/visible?maxResults=@{limit|100}","me/following":f,"me/followers":f,"me/contacts":f,"me/share":"plus/v1/people/me/activities/public?maxResults=@{limit|100}","me/feed":"plus/v1/people/me/activities/public?maxResults=@{limit|100}","me/albums":"https://picasaweb.google.com/data/feed/api/user/default?alt=json&max-results=@{limit|100}&start-index=@{start|1}","me/album":function(e,t){var n=e.query.id;delete e.query.id,t(n.replace("/entry/","/feed/"))},"me/photos":"https://picasaweb.google.com/data/feed/api/user/default?alt=json&kind=photo&max-results=@{limit|100}&start-index=@{start|1}","me/file":"drive/v2/files/@{id}","me/files":"drive/v2/files?q=%22@{parent|root}%22+in+parents+and+trashed=false&maxResults=@{limit|100}","me/folders":"drive/v2/files?q=%22@{id|root}%22+in+parents+and+mimeType+=+%22application/vnd.google-apps.folder%22+and+trashed=false&maxResults=@{limit|100}","me/folder":"drive/v2/files?q=%22@{id|root}%22+in+parents+and+trashed=false&maxResults=@{limit|100}"},post:{"me/files":c,"me/folders":function(e,t){e.data={title:e.data.name,parents:[{id:e.data.parent||"root"}],mimeType:"application/vnd.google-apps.folder"},t("drive/v2/files")}},put:{"me/files":c},del:{"me/files":"drive/v2/files/@{id}","me/folder":"drive/v2/files/@{id}"},patch:{"me/file":"drive/v2/files/@{id}"},wrap:{me:function(e){return e.id&&(e.last_name=e.family_name||(e.name?e.name.familyName:null),e.first_name=e.given_name||(e.name?e.name.givenName:null),e.emails&&e.emails.length&&(e.email=e.emails[0].value),r(e)),e},"me/friends":function(e){return e.items&&(u(e),e.data=e.items,e.data.forEach(r),delete e.items),e},"me/contacts":s,"me/followers":s,"me/following":s,"me/share":n,"me/feed":n,"me/albums":a,"me/photos":function(e){e.data=e.feed.entry.map(l),delete e.feed},default:a},xhr:function(t){return"post"===t.method||"put"===t.method?function(e){if("object"==typeof e.data)try{e.data=JSON.stringify(e.data),e.headers["content-type"]="application/json"}catch(e){}}(t):"patch"===t.method&&(e.utils.extend(t.query,t.data),t.data=null),!0},form:!1}})}(hello),function(e){function t(e){return"string"==typeof e?{error:{code:"invalid_request",message:e}}:(e&&"meta"in e&&"error_type"in e.meta&&(e.error={code:e.meta.error_type,message:e.meta.error_message}),e)}function n(e){return o(e),e&&"data"in e&&e.data.forEach(i),e}function i(e){e.id&&(e.thumbnail=e.profile_picture,e.name=e.full_name||e.username)}function o(e){"pagination"in e&&(e.paging={next:e.pagination.next_url},delete e.pagination)}hello.init({instagram:{name:"Instagram",oauth:{version:2,auth:"https://instagram.com/oauth/authorize/",grant:"https://api.instagram.com/oauth/access_token"},refresh:!0,scope:{basic:"basic",photos:"",friends:"relationships",publish:"likes comments",email:"",share:"",publish_files:"",files:"",videos:"",offline_access:""},scope_delim:" ",base:"https://api.instagram.com/v1/",get:{me:"users/self","me/feed":"users/self/feed?count=@{limit|100}","me/photos":"users/self/media/recent?min_id=0&count=@{limit|100}","me/friends":"users/self/follows?count=@{limit|100}","me/following":"users/self/follows?count=@{limit|100}","me/followers":"users/self/followed-by?count=@{limit|100}","friend/photos":"users/@{id}/media/recent?min_id=0&count=@{limit|100}"},post:{"me/like":function(e,t){var n=e.data.id;e.data={},t("media/"+n+"/likes")}},del:{"me/like":"media/@{id}/likes"},wrap:{me:function(e){return t(e),"data"in e&&(e.id=e.data.id,e.thumbnail=e.data.profile_picture,e.name=e.data.full_name||e.data.username),e},"me/friends":n,"me/following":n,"me/followers":n,"me/photos":function(e){return t(e),o(e),"data"in e&&(e.data=e.data.filter(function(e){return"image"===e.type}),e.data.forEach(function(e){e.name=e.caption?e.caption.text:null,e.thumbnail=e.images.thumbnail.url,e.picture=e.images.standard_resolution.url,e.pictures=Object.keys(e.images).map(function(t){return function(e){return{source:e.url,width:e.width,height:e.height}}(e.images[t])}).sort(function(e,t){return e.width-t.width})})),e},default:function(e){return e=t(e),o(e),e}},xhr:function(e,t){var n=e.method,i="get"!==n;return i&&("post"!==n&&"put"!==n||!e.query.access_token||(e.data.access_token=e.query.access_token,delete e.query.access_token),e.proxy=i),i},form:!1}})}(),function(e){function t(e,t){var n,i;return e&&"Message"in e&&(i=e.Message,delete e.Message,"ErrorCode"in e?(n=e.ErrorCode,delete e.ErrorCode):n=function(e){switch(e.statusCode){case 400:return"invalid_request";case 403:return"stale_token";case 401:return"invalid_token";case 500:default:return"server_error"}}(t),e.error={code:n,message:i,details:e}),e}hello.init({joinme:{name:"join.me",oauth:{version:2,auth:"https://secure.join.me/api/public/v1/auth/oauth2",grant:"https://secure.join.me/api/public/v1/auth/oauth2"},refresh:!1,scope:{basic:"user_info",user:"user_info",scheduler:"scheduler",start:"start_meeting",email:"",friends:"",share:"",publish:"",photos:"",publish_files:"",files:"",videos:"",offline_access:""},scope_delim:" ",login:function(e){e.options.popup.width=400,e.options.popup.height=700},base:"https://api.join.me/v1/",get:{me:"user",meetings:"meetings","meetings/info":"meetings/@{id}"},post:{"meetings/start/adhoc":function(e,t){t("meetings/start")},"meetings/start/scheduled":function(e,t){var n=e.data.meetingId;e.data={},t("meetings/"+n+"/start")},"meetings/schedule":function(e,t){t("meetings")}},patch:{"meetings/update":function(e,t){t("meetings/"+e.data.meetingId)}},del:{"meetings/delete":"meetings/@{id}"},wrap:{me:function(e,n){return t(e,n),e.email?(e.name=e.fullName,e.first_name=e.name.split(" ")[0],e.last_name=e.name.split(" ")[1],e.id=e.email,e):e},default:function(e,n){return t(e,n),e}},xhr:function(e,t){var n=t.access_token;return delete t.access_token,e.headers.Authorization="Bearer "+n,"get"!==e.method&&e.data&&(e.headers["Content-Type"]="application/json","object"==typeof e.data&&(e.data=JSON.stringify(e.data))),"put"===e.method&&(e.method="patch"),!0}}})}(),function(e){function t(e){e&&"errorCode"in e&&(e.error={code:e.status,message:e.message})}function n(e){if(!e.error)return e.first_name=e.firstName,e.last_name=e.lastName,e.name=e.formattedName||e.first_name+" "+e.last_name,e.thumbnail=e.pictureUrl,e.email=e.emailAddress,e}function i(e){return t(e),o(e),e.values&&(e.data=e.values.map(n),delete e.values),e}function o(e){"_count"in e&&"_start"in e&&e._count+e._start<e._total&&(e.paging={next:"?start="+(e._start+e._count)+"&count="+e._count})}function a(e){e.access_token&&(e.oauth2_access_token=e.access_token,delete e.access_token)}function r(e,t){e.headers["x-li-format"]="json";var n=e.data.id;e.data=("delete"!==e.method).toString(),e.method="put",t("people/~/network/updates/key="+n+"/is-liked")}hello.init({linkedin:{oauth:{version:2,response_type:"code",auth:"https://www.linkedin.com/uas/oauth2/authorization",grant:"https://www.linkedin.com/uas/oauth2/accessToken"},refresh:!0,scope:{basic:"r_basicprofile",email:"r_emailaddress",files:"",friends:"",photos:"",publish:"w_share",publish_files:"w_share",share:"",videos:"",offline_access:""},scope_delim:" ",base:"https://api.linkedin.com/v1/",get:{me:"people/~:(picture-url,first-name,last-name,id,formatted-name,email-address)","me/share":"people/~/network/updates?count=@{limit|250}"},post:{"me/share":function(e,t){var n={visibility:{code:"anyone"}};e.data.id?n.attribution={share:{id:e.data.id}}:(n.comment=e.data.message,e.data.picture&&e.data.link&&(n.content={"submitted-url":e.data.link,"submitted-image-url":e.data.picture})),e.data=JSON.stringify(n),t("people/~/shares?format=json")},"me/like":r},del:{"me/like":r},wrap:{me:function(e){return t(e),n(e),e},"me/friends":i,"me/following":i,"me/followers":i,"me/share":function(e){return t(e),o(e),e.values&&(e.data=e.values.map(n),e.data.forEach(function(e){e.message=e.headline}),delete e.values),e},default:function(e,n){t(e),function(e,t){"{}"===JSON.stringify(e)&&200===t.statusCode&&(e.success=!0)}(e,n),o(e)}},jsonp:function(e,t){a(t),"get"===e.method&&(t.format="jsonp",t["error-callback"]=e.callbackID)},xhr:function(e,t){return"get"!==e.method&&(a(t),e.headers["Content-Type"]="application/json",e.headers["x-li-format"]="json",e.proxy=!0,!0)}}})}(),function(e){function t(e,t){var n=t.access_token;return delete t.access_token,t.oauth_token=n,t["_status_code_map[302]"]=200,!0}function n(e){return e.id&&(e.picture=e.avatar_url,e.thumbnail=e.avatar_url,e.name=e.username||e.full_name),e}hello.init({soundcloud:{name:"SoundCloud",oauth:{version:2,auth:"https://soundcloud.com/connect",grant:"https://soundcloud.com/oauth2/token"},base:"https://api.soundcloud.com/",get:{me:"me.json","me/friends":"me/followings.json","me/followers":"me/followers.json","me/following":"me/followings.json",default:function(e,t){t(e.path+".json")}},wrap:{me:function(e){return n(e),e},default:function(e){return Array.isArray(e)&&(e={data:e.map(n)}),function(e){"next_href"in e&&(e.paging={next:e.next_href})}(e),e}},xhr:t,jsonp:t}})}(),function(e){function t(e){return e.id&&(e.name=e.display_name,e.thumbnail=e.images.length?e.images[0].url:null,e.picture=e.thumbnail),e}function n(e){e&&"next"in e&&(e.paging={next:e.next},delete e.next)}hello.init({spotify:{name:"Spotify",oauth:{version:2,auth:"https://accounts.spotify.com/authorize",grant:"https://accounts.spotify.com/api/token"},scope_delim:" ",scope:{basic:"",photos:"",friends:"user-follow-read",publish:"user-library-read",email:"user-read-email",share:"",publish_files:"",files:"",videos:"",offline_access:""},base:"https://api.spotify.com",get:{me:"/v1/me","me/following":"/v1/me/following?type=artist","me/like":"/v1/me/tracks"},wrap:{me:t,"me/following":function(e){return n(e),e&&"artists"in e&&(e.data=e.artists.items.forEach(t)),e},"me/like":function(e){return n(e),e.data=e.items,e}},xhr:function(e,t){var n=t.access_token;return delete t.access_token,e.headers.Authorization="Bearer "+n,!0},jsonp:!1}})}(),function(e){function t(e){if(e.id){if(e.name){var t=e.name.split(" ");e.first_name=t.shift(),e.last_name=t.join(" ")}e.thumbnail=e.profile_image_url_https||e.profile_image_url}return e}function n(e){return i(e),o(e),e.users&&(e.data=e.users.map(t),delete e.users),e}function i(e){if(e.errors){var t=e.errors[0];e.error={code:"request_failed",message:t.message}}}function o(e){"next_cursor_str"in e&&(e.paging={next:"?cursor="+e.next_cursor_str})}var a="https://api.twitter.com/";e.init({twitter:{oauth:{version:"1.0a",auth:a+"oauth/authenticate",request:a+"oauth/request_token",token:a+"oauth/access_token"},login:function(e){var t="?force_login=true";this.oauth.auth=this.oauth.auth.replace(t,"")+(e.options.force?t:"")},base:a+"1.1/",get:{me:"account/verify_credentials.json","me/friends":"friends/list.json?count=@{limit|200}","me/following":"friends/list.json?count=@{limit|200}","me/followers":"followers/list.json?count=@{limit|200}","me/share":"statuses/user_timeline.json?count=@{limit|200}","me/like":"favorites/list.json?count=@{limit|200}"},post:{"me/share":function(t,n){var i=t.data;t.data=null;var o=[];i.message&&(o.push(i.message),delete i.message),i.link&&(o.push(i.link),delete i.link),i.picture&&(o.push(i.picture),delete i.picture),o.length&&(i.status=o.join(" ")),i.file?(i["media[]"]=i.file,delete i.file,t.data=i,n("statuses/update_with_media.json")):"id"in i?n("statuses/retweet/"+i.id+".json"):(e.utils.extend(t.query,i),n("statuses/update.json?include_entities=1"))},"me/like":function(e,t){var n=e.data.id;e.data=null,t("favorites/create.json?id="+n)}},del:{"me/like":function(){p.method="post";var e=p.data.id;p.data=null,callback("favorites/destroy.json?id="+e)}},wrap:{me:function(e){return i(e),t(e),e},"me/friends":n,"me/followers":n,"me/following":n,"me/share":function(e){return i(e),o(e),!e.error&&"length"in e?{data:e}:e},default:function(e){return e=function(e){return Array.isArray(e)?{data:e}:e}(e),o(e),e}},xhr:function(e){return"get"!==e.method}}})}(hello),function(e){hello.init({vk:{name:"Vk",oauth:{version:2,auth:"https://oauth.vk.com/authorize",grant:"https://oauth.vk.com/access_token"},scope:{email:"email",friends:"friends",photos:"photos",videos:"video",share:"share",offline_access:"offline"},refresh:!0,login:function(e){e.qs.display=window.navigator&&window.navigator.userAgent&&/ipad|phone|phone|android/.test(window.navigator.userAgent.toLowerCase())?"mobile":"popup"},base:"https://api.vk.com/method/",get:{me:function(e,t){e.query.fields="id,first_name,last_name,photo_max",t("users.get")}},wrap:{me:function(e,t,n){return function(e){if(e.error){var t=e.error;e.error={code:t.error_code,message:t.error_msg}}}(e),function(e,t){return null!==e&&"response"in e&&null!==e.response&&e.response.length&&((e=e.response[0]).id=e.uid,e.thumbnail=e.picture=e.photo_max,e.name=e.first_name+" "+e.last_name,t.authResponse&&null!==t.authResponse.email&&(e.email=t.authResponse.email)),e}(e,n)}},xhr:!1,jsonp:!0,form:!1}})}(),function(e){function t(e){return"data"in e&&e.data.forEach(function(e){e.picture&&(e.thumbnail=e.picture),e.images&&(e.pictures=e.images.map(n).sort(function(e,t){return e.width-t.width}))}),e}function n(e){return{width:e.width,height:e.height,source:e.source}}function i(e,t,n){if(e.id){var i=n.query.access_token;if(e.emails&&(e.email=e.emails.preferred),!1!==e.is_friend){var o=e.user_id||e.id;e.thumbnail=e.picture="https://apis.live.net/v5.0/"+o+"/picture?access_token="+i}}return e}function o(e,t,n){return"data"in e&&e.data.forEach(function(e){i(e,0,n)}),e}e.init({windows:{name:"Windows live",oauth:{version:2,auth:"https://login.live.com/oauth20_authorize.srf",grant:"https://login.live.com/oauth20_token.srf"},refresh:!0,logout:function(){return"http://login.live.com/oauth20_logout.srf?ts="+(new Date).getTime()},scope:{basic:"wl.signin,wl.basic",email:"wl.emails",birthday:"wl.birthday",events:"wl.calendars",photos:"wl.photos",videos:"wl.photos",friends:"wl.contacts_emails",files:"wl.skydrive",publish:"wl.share",publish_files:"wl.skydrive_update",share:"wl.share",create_event:"wl.calendars_update,wl.events_create",offline_access:"wl.offline_access"},base:"https://apis.live.net/v5.0/",get:{me:"me","me/friends":"me/friends","me/following":"me/contacts","me/followers":"me/friends","me/contacts":"me/contacts","me/albums":"me/albums","me/album":"@{id}/files","me/photo":"@{id}","me/files":"@{parent|me/skydrive}/files","me/folders":"@{id|me/skydrive}/files","me/folder":"@{id|me/skydrive}/files"},post:{"me/albums":"me/albums","me/album":"@{id}/files/","me/folders":"@{id|me/skydrive/}","me/files":"@{parent|me/skydrive}/files"},del:{"me/album":"@{id}","me/photo":"@{id}","me/folder":"@{id}","me/files":"@{id}"},wrap:{me:i,"me/friends":o,"me/contacts":o,"me/followers":o,"me/following":o,"me/albums":function(e){return"data"in e&&e.data.forEach(function(e){e.photos=e.files="https://apis.live.net/v5.0/"+e.id+"/photos"}),e},"me/photos":t,default:t},xhr:function(t){return"get"===t.method||"delete"===t.method||e.utils.hasBinary(t.data)||("string"==typeof t.data.file?t.data.file=e.utils.toBlob(t.data.file):(t.data=JSON.stringify(t.data),t.headers={"Content-Type":"application/json"})),!0},jsonp:function(t){"get"===t.method||e.utils.hasBinary(t.data)||(t.data.method=t.method,t.method="get")}}})}(hello),function(e){function t(e){e&&"meta"in e&&"error_type"in e.meta&&(e.error={code:e.meta.error_type,message:e.meta.error_message})}function n(e,n,a){t(e),o(e,n,a);return e.query&&e.query.results&&e.query.results.contact&&(e.data=e.query.results.contact,delete e.query,Array.isArray(e.data)||(e.data=[e.data]),e.data.forEach(i)),e}function i(e){e.id=null,!e.fields||e.fields instanceof Array||(e.fields=[e.fields]),(e.fields||[]).forEach(function(t){"email"===t.type&&(e.email=t.value),"name"===t.type&&(e.first_name=t.value.givenName,e.last_name=t.value.familyName,e.name=t.value.givenName+" "+t.value.familyName),"yahooid"===t.type&&(e.id=t.value)})}function o(e,t,n){return e.query&&e.query.count&&n.options&&(e.paging={next:"?start="+(e.query.count+(+n.options.start||1))}),e}function a(e){return"https://query.yahooapis.com/v1/yql?q="+(e+" limit @{limit|100} offset @{start|0}").replace(/\s/g,"%20")+"&format=json"}hello.init({yahoo:{oauth:{version:"1.0a",auth:"https://api.login.yahoo.com/oauth/v2/request_auth",request:"https://api.login.yahoo.com/oauth/v2/get_request_token",token:"https://api.login.yahoo.com/oauth/v2/get_token"},login:function(e){e.options.popup.width=560;try{delete e.qs.state.scope}catch(e){}},base:"https://social.yahooapis.com/v1/",get:{me:a("select * from social.profile(0) where guid=me"),"me/friends":a("select * from social.contacts(0) where guid=me"),"me/following":a("select * from social.contacts(0) where guid=me")},wrap:{me:function(e){if(t(e),e.query&&e.query.results&&e.query.results.profile){(e=e.query.results.profile).id=e.guid,e.last_name=e.familyName,e.first_name=e.givenName||e.nickname;var n=[];e.first_name&&n.push(e.first_name),e.last_name&&n.push(e.last_name),e.name=n.join(" "),e.email=e.emails&&e.emails[0]?e.emails[0].handle:null,e.thumbnail=e.image?e.image.imageUrl:null}return e},"me/friends":n,"me/following":n,default:o}}})}(),"function"=="function"&&__webpack_require__(1863)&&!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return hello}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)),"object"==typeof module&&module.exports&&(module.exports=hello);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25), __webpack_require__(22).setImmediate))

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};!function(){function e(o,t){if(!e.installed){if(e.installed=!0,!t)return void console.error("You have to install hello");o.hello=t,Object.defineProperties(o.prototype,{hello:{get:function(){return t}}})}}"object"==( false?"undefined":_typeof(exports))?module.exports=e: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return e}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):window.Vue&&window.hello&&Vue.use(e,window.hello)}();

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.vueMoment = {})));
}(this, (function (exports) { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}



function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var moment = createCommonjsModule(function (module, exports) {
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js

(function (global, factory) {
    (_typeof(exports)) === 'object' && 'object' !== 'undefined' ? module.exports = factory() :  false ? undefined(factory) : global.moment = factory();
})(commonjsGlobal, function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1 = /\d/; //       0 - 9
    var match2 = /\d\d/; //      00 - 99
    var match3 = /\d{3}/; //     000 - 999
    var match4 = /\d{4}/; //    0000 - 9999
    var match6 = /[+-]?\d{6}/; // -999999 - 999999
    var match1to2 = /\d\d?/; //       0 - 99
    var match3to4 = /\d\d\d\d?/; //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/; //       0 - 999
    var match1to4 = /\d{1,4}/; //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf
    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,

        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && 'object' !== 'undefined' && module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]];

    // iso time formats and regexes
    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    });

    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk = matches[matches.length - 1] || [];
        var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,

        // matching against regexp is expensive, do it on demand
        match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;val = period;period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;break;
            case 'month':
                output = monthDiff(this, that);break;
            case 'quarter':
                output = monthDiff(this, that) / 3;break;
            case 'second':
                output = (this - that) / 1e3;break; // 1000
            case 'minute':
                output = (this - that) / 6e4;break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds;
        var days = this._days;
        var months = this._months;
        var data = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asQuarters = makeAs('Q');
    var asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month
        M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds = round(duration.as('s'));
        var minutes = round(duration.as('m'));
        var hours = round(duration.as('h'));
        var days = round(duration.as('d'));
        var months = round(duration.as('M'));
        var years = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days = abs$1(this._days);
        var months = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM' // <input type="month" />
    };

    return hooks;
});
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var vueMoment = {
  install: function install(Vue, options) {
    var moment$$1 = options && options.moment ? options.moment : moment;

    Object.defineProperties(Vue.prototype, {
      $moment: {
        get: function get() {
          return moment$$1;
        }
      }
    });

    Vue.moment = moment$$1;

    Vue.filter('moment', function () {
      var arguments$1 = arguments;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments$1[_key];
      }

      args = Array.prototype.slice.call(args);
      var input = args.shift();
      var date = void 0;

      if (Array.isArray(input) && typeof input[0] === 'string') {
        // If input is array, assume we're being passed a format pattern to parse against.
        // Format pattern will accept an array of potential formats to parse against.
        // Date string should be at [0], format pattern(s) should be at [1]
        date = moment$$1(input[0], input[1], true);
      } else if (typeof input === 'number') {
        if (input.toString().length < 12) {
          // If input is an integer with fewer than 12 digits, assume Unix seconds...
          date = moment$$1.unix(input);
        } else {
          // ..otherwise, assume milliseconds.
          date = moment$$1(input);
        }
      } else {
        // Otherwise, throw the input at moment and see what happens...
        date = moment$$1(input);
      }

      if (!input || !date.isValid()) {
        // Log a warning if moment couldn't reconcile the input. Better than throwing an error?
        console.warn('Could not build a valid `moment` object from input.');
        return input;
      }

      function parse() {
        var arguments$1 = arguments;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments$1[_key2];
        }

        args = Array.prototype.slice.call(args);
        var method = args.shift();

        switch (method) {
          case 'add':
            {
              /*
              * Mutates the original moment by adding time.
              * http://momentjs.com/docs/#/manipulating/add/
              */

              var addends = args.shift().split(',').map(Function.prototype.call, String.prototype.trim);
              var obj = {};

              for (var n = 0; n < addends.length; n++) {
                var addend = addends[n].split(' ');
                obj[addend[1]] = addend[0];
              }
              date.add(obj);
              break;
            }

          case 'subtract':
            {
              /*
              * Mutates the original moment by subtracting time.
              * http://momentjs.com/docs/#/manipulating/subtract/
              */

              var subtrahends = args.shift().split(',').map(Function.prototype.call, String.prototype.trim);
              var _obj = {};

              for (var _n = 0; _n < subtrahends.length; _n++) {
                var subtrahend = subtrahends[_n].split(' ');
                _obj[subtrahend[1]] = subtrahend[0];
              }
              date.subtract(_obj);
              break;
            }

          case 'from':
            {
              /*
              * Display a moment in relative time, either from now or from a specified date.
              * http://momentjs.com/docs/#/displaying/fromnow/
              */

              var from = 'now';
              var removeSuffix = false;

              if (args[0] === 'now') { args.shift(); }
              // If valid, assume it is a date we want the output computed against.
              if (moment$$1(args[0]).isValid()) { from = moment$$1(args.shift()); }

              if (args[0] === true) {
                args.shift();
                removeSuffix = true;
              }

              if (from !== 'now') {
                date = date.from(from, removeSuffix);
              } else {
                date = date.fromNow(removeSuffix);
              }
              break;
            }

          case 'diff':
            {
              /*
              * Mutates the original moment by doing a difference with another date.
              * http://momentjs.com/docs/#/displaying/difference/
              */

              var referenceTime = moment$$1();
              var units = '';
              var float = false;

              if (moment$$1(args[0]).isValid()) {
                // If valid, assume it is a date we want the output computed against.
                referenceTime = moment$$1(args.shift());
              } else if (args[0] === null || args[0] === 'now') {
                // If null or 'now', remove argument and proceed with default referenceTime.
                args.shift();
              }

              if (args[0]) { units = args.shift(); }

              if (args[0] === true) { float = args.shift(); }

              date = date.diff(referenceTime, units, float);
              break;
            }

          case 'calendar':
            {
              /*
              * Formats a date with different strings depending on how close
              * to a certain date (today by default) the date is.
              * http://momentjs.com/docs/#/displaying/calendar-time/
              */

              var _referenceTime = moment$$1();
              var formats = {};

              if (moment$$1(args[0]).isValid()) {
                // If valid, assume it is a date we want the output computed against.
                _referenceTime = moment$$1(args.shift());
              } else if (args[0] === null || args[0] === 'now') {
                // If null or 'now', remove argument and proceed with default referenceTime.
                args.shift();
              }

              if (_typeof(args[0]) === 'object') { formats = args.shift(); }

              date = date.calendar(_referenceTime, formats);
              break;
            }

          case 'utc':
            {
              /*
              * Mutates the original moment by converting to UTC
              * https://momentjs.com/docs/#/manipulating/utc/
              */
              date.utc();
              break;
            }

          case 'timezone':
            {
              /*
              * Mutates the original moment by converting to a new timezone.
              * https://momentjs.com/timezone/docs/#/using-timezones/converting-to-zone/
              */
              date.tz(args.shift());
              break;
            }

          default:
            {
              /*
              * Formats a date by taking a string of tokens and replacing
              * them with their corresponding values.
              * http://momentjs.com/docs/#/displaying/format/
              */

              var format = method;
              date = date.format(format);
            }
        }

        if (args.length) { parse.apply(parse, args); }
      }

      parse.apply(parse, args);

      return date;
    });

    Vue.filter('duration', function () {
      var arguments$1 = arguments;

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments$1[_key3];
      }

      /*
      * Basic pass-through filter for leveraging moment.js's ability
      * to manipulate and display durations.
      * https://momentjs.com/docs/#/durations/
      */
      args = Array.prototype.slice.call(args);
      var input = args.shift();
      var method = args.shift();

      function createDuration(time) {
        if (!Array.isArray(time)) { time = [time]; }
        var result = moment$$1.duration.apply(moment$$1, _toConsumableArray(time));
        if (!result.isValid()) { console.warn('Could not build a valid `duration` object from input.'); }
        return result;
      }
      var duration = createDuration(input);

      if (method === 'add' || method === 'subtract') {
        // Generates a duration object and either adds or subtracts it
        // from our original duration.
        var durationChange = createDuration(args);
        duration[method](durationChange);
      } else if (duration && duration[method]) {
        var _duration;

        // This gives a full proxy to moment.duration functions.
        duration = (_duration = duration)[method].apply(_duration, _toConsumableArray(args));
      }

      return duration;
    });
  }
};

var vueMoment_1 = vueMoment.install;

exports['default'] = vueMoment;
exports.install = vueMoment_1;

Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js